(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 17549:
/***/ (function(module) {

(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;
var _$breadcrumbTypes_8 = ['navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual'];

// Array#reduce
var _$reduce_17 = function (arr, fn, accum) {
  var val = accum;

  for (var i = 0, len = arr.length; i < len; i++) {
    val = fn(val, arr[i], i, arr);
  }

  return val;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#filter


var _$filter_12 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return !fn(item, i, arr) ? accum : accum.concat(item);
  }, []);
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#includes


var _$includes_13 = function (arr, x) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

// Array#isArray
var _$isArray_14 = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/* eslint-disable-next-line no-prototype-builtins */
var _hasDontEnumBug = !{
  toString: null
}.propertyIsEnumerable('toString');

var _dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor']; // Object#keys

var _$keys_15 = function (obj) {
  // stripped down version of
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
  var result = [];
  var prop;

  for (prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
  }

  if (!_hasDontEnumBug) return result;

  for (var i = 0, len = _dontEnums.length; i < len; i++) {
    if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
  }

  return result;
};

var _$intRange_24 = function (min, max) {
  if (min === void 0) {
    min = 1;
  }

  if (max === void 0) {
    max = Infinity;
  }

  return function (value) {
    return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
  };
};

/* removed: var _$filter_12 = require('../es-utils/filter'); */;

/* removed: var _$isArray_14 = require('../es-utils/is-array'); */;

var _$listOfFunctions_25 = function (value) {
  return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function (f) {
    return typeof f === 'function';
  }).length === value.length;
};

var _$stringWithLength_26 = function (value) {
  return typeof value === 'string' && !!value.length;
};

var _$config_5 = {};
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$isArray_14 = require('./lib/es-utils/is-array'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$intRange_24 = require('./lib/validators/int-range'); */;

/* removed: var _$stringWithLength_26 = require('./lib/validators/string-with-length'); */;

/* removed: var _$listOfFunctions_25 = require('./lib/validators/list-of-functions'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var defaultErrorTypes = function () {
  return {
    unhandledExceptions: true,
    unhandledRejections: true
  };
};

_$config_5.schema = {
  apiKey: {
    defaultValue: function () {
      return null;
    },
    message: 'is required',
    validate: _$stringWithLength_26
  },
  appVersion: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  appType: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  autoDetectErrors: {
    defaultValue: function () {
      return true;
    },
    message: 'should be true|false',
    validate: function (value) {
      return value === true || value === false;
    }
  },
  enabledErrorTypes: {
    defaultValue: function () {
      return defaultErrorTypes();
    },
    message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
    allowPartialObject: true,
    validate: function (value) {
      // ensure we have an object
      if (typeof value !== 'object' || !value) return false;
      var providedKeys = _$keys_15(value);
      var defaultKeys = _$keys_15(defaultErrorTypes()); // ensure it only has a subset of the allowed keys

      if (_$filter_12(providedKeys, function (k) {
        return _$includes_13(defaultKeys, k);
      }).length < providedKeys.length) return false; // ensure all of the values are boolean

      if (_$filter_12(_$keys_15(value), function (k) {
        return typeof value[k] !== 'boolean';
      }).length > 0) return false;
      return true;
    }
  },
  onError: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onSession: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onBreadcrumb: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  endpoints: {
    defaultValue: function () {
      return {
        notify: 'https://notify.bugsnag.com',
        sessions: 'https://sessions.bugsnag.com'
      };
    },
    message: 'should be an object containing endpoint URLs { notify, sessions }',
    validate: function (val) {
      return (// first, ensure it's an object
        val && typeof val === 'object' && // notify and sessions must always be set
        _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
        _$filter_12(_$keys_15(val), function (k) {
          return !_$includes_13(['notify', 'sessions'], k);
        }).length === 0
      );
    }
  },
  autoTrackSessions: {
    defaultValue: function (val) {
      return true;
    },
    message: 'should be true|false',
    validate: function (val) {
      return val === true || val === false;
    }
  },
  enabledReleaseStages: {
    defaultValue: function () {
      return null;
    },
    message: 'should be an array of strings',
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$filter_12(value, function (f) {
        return typeof f === 'string';
      }).length === value.length;
    }
  },
  releaseStage: {
    defaultValue: function () {
      return 'production';
    },
    message: 'should be a string',
    validate: function (value) {
      return typeof value === 'string' && value.length;
    }
  },
  maxBreadcrumbs: {
    defaultValue: function () {
      return 25;
    },
    message: 'should be a number ≤100',
    validate: function (value) {
      return _$intRange_24(0, 100)(value);
    }
  },
  enabledBreadcrumbTypes: {
    defaultValue: function () {
      return _$breadcrumbTypes_8;
    },
    message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$reduce_17(value, function (accum, maybeType) {
        if (accum === false) return accum;
        return _$includes_13(_$breadcrumbTypes_8, maybeType);
      }, true);
    }
  },
  context: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || typeof value === 'string';
    }
  },
  user: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object with { id, email, name } properties',
    validate: function (value) {
      return value === null || value && _$reduce_17(_$keys_15(value), function (accum, key) {
        return accum && _$includes_13(['id', 'email', 'name'], key);
      }, true);
    }
  },
  metadata: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object',
    validate: function (value) {
      return typeof value === 'object' && value !== null;
    }
  },
  logger: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be null or an object with methods { debug, info, warn, error }',
    validate: function (value) {
      return !value || value && _$reduce_17(['debug', 'info', 'warn', 'error'], function (accum, method) {
        return accum && typeof value[method] === 'function';
      }, true);
    }
  },
  redactedKeys: {
    defaultValue: function () {
      return ['password'];
    },
    message: 'should be an array of strings|regexes',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (s) {
        return typeof s === 'string' || s && typeof s.test === 'function';
      }).length;
    }
  },
  plugins: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of plugin objects',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (p) {
        return p && typeof p === 'object' && typeof p.load === 'function';
      }).length;
    }
  },
  featureFlags: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of objects that have a "name" property',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (feature) {
        return feature && typeof feature === 'object' && typeof feature.name === 'string';
      }).length;
    }
  }
};

// extends helper from babel
// https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
var _$assign_11 = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#map


var _$map_16 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum.concat(fn(item, i, arr));
  }, []);
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var schema = _$config_5.schema;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var _$config_1 = {
  releaseStage: _$assign_11({}, schema.releaseStage, {
    defaultValue: function () {
      if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
      return 'production';
    }
  }),
  appType: _extends({}, schema.appType, {
    defaultValue: function () {
      return 'browser';
    }
  }),
  logger: _$assign_11({}, schema.logger, {
    defaultValue: function () {
      return (// set logger based on browser capability
        typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined
      );
    }
  })
};

var getPrefixedConsole = function () {
  var logger = {};
  var consoleLog = console.log;
  _$map_16(['debug', 'info', 'warn', 'error'], function (method) {
    var consoleMethod = console[method];
    logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
  });
  return logger;
};

var Breadcrumb = /*#__PURE__*/function () {
  function Breadcrumb(message, metadata, type, timestamp) {
    if (timestamp === void 0) {
      timestamp = new Date();
    }

    this.type = type;
    this.message = message;
    this.metadata = metadata;
    this.timestamp = timestamp;
  }

  var _proto = Breadcrumb.prototype;

  _proto.toJSON = function toJSON() {
    return {
      type: this.type,
      name: this.message,
      timestamp: this.timestamp,
      metaData: this.metadata
    };
  };

  return Breadcrumb;
}();

var _$Breadcrumb_3 = Breadcrumb;

var _$stackframe_34 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stackframe', [], factory);
  } else if (typeof _$stackframe_34 === 'object') {
    _$stackframe_34 = factory();
  } else {
    root.StackFrame = factory();
  }
})(this, function () {
  'use strict';

  function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }

  function _getter(p) {
    return function () {
      return this[p];
    };
  }

  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
  var numericProps = ['columnNumber', 'lineNumber'];
  var stringProps = ['fileName', 'functionName', 'source'];
  var arrayProps = ['args'];
  var props = booleanProps.concat(numericProps, stringProps, arrayProps);

  function StackFrame(obj) {
    if (obj instanceof Object) {
      for (var i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
          this['set' + _capitalize(props[i])](obj[props[i]]);
        }
      }
    }
  }

  StackFrame.prototype = {
    getArgs: function () {
      return this.args;
    },
    setArgs: function (v) {
      if (Object.prototype.toString.call(v) !== '[object Array]') {
        throw new TypeError('Args must be an Array');
      }

      this.args = v;
    },
    getEvalOrigin: function () {
      return this.evalOrigin;
    },
    setEvalOrigin: function (v) {
      if (v instanceof StackFrame) {
        this.evalOrigin = v;
      } else if (v instanceof Object) {
        this.evalOrigin = new StackFrame(v);
      } else {
        throw new TypeError('Eval Origin must be an Object or StackFrame');
      }
    },
    toString: function () {
      var functionName = this.getFunctionName() || '{anonymous}';
      var args = '(' + (this.getArgs() || []).join(',') + ')';
      var fileName = this.getFileName() ? '@' + this.getFileName() : '';
      var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
      var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
      return functionName + args + fileName + lineNumber + columnNumber;
    }
  };

  for (var i = 0; i < booleanProps.length; i++) {
    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);

    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
      return function (v) {
        this[p] = Boolean(v);
      };
    }(booleanProps[i]);
  }

  for (var j = 0; j < numericProps.length; j++) {
    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);

    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
      return function (v) {
        if (!_isNumber(v)) {
          throw new TypeError(p + ' must be a Number');
        }

        this[p] = Number(v);
      };
    }(numericProps[j]);
  }

  for (var k = 0; k < stringProps.length; k++) {
    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);

    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
      return function (v) {
        this[p] = String(v);
      };
    }(stringProps[k]);
  }

  return StackFrame;
});

var _$errorStackParser_31 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('error-stack-parser', ['stackframe'], factory);
  } else if (typeof _$errorStackParser_31 === 'object') {
    _$errorStackParser_31 = factory(_$stackframe_34);
  } else {
    root.ErrorStackParser = factory(root.StackFrame);
  }
})(this, function ErrorStackParser(StackFrame) {
  'use strict';

  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
  return {
    /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */
    parse: function ErrorStackParser$$parse(error) {
      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
        return this.parseOpera(error);
      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
        return this.parseV8OrIE(error);
      } else if (error.stack) {
        return this.parseFFOrSafari(error);
      } else {
        throw new Error('Cannot parse given Error object');
      }
    },
    // Separate line and column numbers from a string of the form: (URI:Line:Column)
    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
      // Fail-fast but return locations like "(native)"
      if (urlLike.indexOf(':') === -1) {
        return [urlLike];
      }

      var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
      var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
      return [parts[1], parts[2] || undefined, parts[3] || undefined];
    },
    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(CHROME_IE_STACK_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf('(eval ') > -1) {
          // Throw away eval information until we implement stacktrace.js/stackframe#8
          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
        }

        var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '('); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
        // case it has spaces in it, as the string is split on \s+ later on

        var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched

        sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
        var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token

        var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
        var functionName = tokens.join(' ') || undefined;
        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
        return new StackFrame({
          functionName: functionName,
          fileName: fileName,
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    },
    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
      }, this);
      return filtered.map(function (line) {
        // Throw away eval information until we implement stacktrace.js/stackframe#8
        if (line.indexOf(' > eval') > -1) {
          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
        }

        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
          // Safari eval frames only have function names and nothing else
          return new StackFrame({
            functionName: line
          });
        } else {
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
          var matches = line.match(functionNameRegex);
          var functionName = matches && matches[1] ? matches[1] : undefined;
          var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }
      }, this);
    },
    parseOpera: function ErrorStackParser$$parseOpera(e) {
      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
        return this.parseOpera9(e);
      } else if (!e.stack) {
        return this.parseOpera10(e);
      } else {
        return this.parseOpera11(e);
      }
    },
    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
      var lines = e.message.split('\n');
      var result = [];

      for (var i = 2, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
      var lines = e.stacktrace.split('\n');
      var result = [];

      for (var i = 0, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            functionName: match[3] || undefined,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    // Opera 10.65+ Error.stack very similar to FF/Safari
    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
      }, this);
      return filtered.map(function (line) {
        var tokens = line.split('@');
        var locationParts = this.extractLocation(tokens.pop());
        var functionCall = tokens.shift() || '';
        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
        var argsRaw;

        if (functionCall.match(/\(([^\)]*)\)/)) {
          argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
        }

        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
        return new StackFrame({
          functionName: functionName,
          args: args,
          fileName: locationParts[0],
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    }
  };
});

var _$errorStackParser_10 = _$errorStackParser_31;

var _$safeJsonStringify_30 = function (data, replacer, space, opts) {
  var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
  var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
  return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
};

var MAX_DEPTH = 20;
var MAX_EDGES = 25000;
var MIN_PRESERVED_DEPTH = 8;
var REPLACEMENT_NODE = '...';

function isError(o) {
  return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
}

function throwsMessage(err) {
  return '[Throws: ' + (err ? err.message : '?') + ']';
}

function find(haystack, needle) {
  for (var i = 0, len = haystack.length; i < len; i++) {
    if (haystack[i] === needle) return true;
  }

  return false;
} // returns true if the string `path` starts with any of the provided `paths`


function isDescendent(paths, path) {
  for (var i = 0, len = paths.length; i < len; i++) {
    if (path.indexOf(paths[i]) === 0) return true;
  }

  return false;
}

function shouldRedact(patterns, key) {
  for (var i = 0, len = patterns.length; i < len; i++) {
    if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
    if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
  }

  return false;
}

function __isArray_30(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function safelyGetProp(obj, prop) {
  try {
    return obj[prop];
  } catch (err) {
    return throwsMessage(err);
  }
}

function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
  var seen = []; // store references to objects we have seen before

  var edges = 0;

  function visit(obj, path) {
    function edgesExceeded() {
      return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
    }

    edges++;
    if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
    if (edgesExceeded()) return REPLACEMENT_NODE;
    if (obj === null || typeof obj !== 'object') return obj;
    if (find(seen, obj)) return '[Circular]';
    seen.push(obj);

    if (typeof obj.toJSON === 'function') {
      try {
        // we're not going to count this as an edge because it
        // replaces the value of the currently visited object
        edges--;
        var fResult = visit(obj.toJSON(), path);
        seen.pop();
        return fResult;
      } catch (err) {
        return throwsMessage(err);
      }
    }

    var er = isError(obj);

    if (er) {
      edges--;
      var eResult = visit({
        name: obj.name,
        message: obj.message
      }, path);
      seen.pop();
      return eResult;
    }

    if (__isArray_30(obj)) {
      var aResult = [];

      for (var i = 0, len = obj.length; i < len; i++) {
        if (edgesExceeded()) {
          aResult.push(REPLACEMENT_NODE);
          break;
        }

        aResult.push(visit(obj[i], path.concat('[]')));
      }

      seen.pop();
      return aResult;
    }

    var result = {};

    try {
      for (var prop in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;

        if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
          result[prop] = '[REDACTED]';
          continue;
        }

        if (edgesExceeded()) {
          result[prop] = REPLACEMENT_NODE;
          break;
        }

        result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
      }
    } catch (e) {}

    seen.pop();
    return result;
  }

  return visit(obj, []);
}

/* removed: var _$map_16 = require('./es-utils/map'); */;

/* removed: var _$filter_12 = require('./es-utils/filter'); */;

/* removed: var _$isArray_14 = require('./es-utils/is-array'); */;

/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;

function add(existingFeatures, existingFeatureKeys, name, variant) {
  if (typeof name !== 'string') {
    return;
  }

  if (variant === undefined) {
    variant = null;
  } else if (variant !== null && typeof variant !== 'string') {
    variant = _$safeJsonStringify_30(variant);
  }

  var existingIndex = existingFeatureKeys[name];

  if (typeof existingIndex === 'number') {
    existingFeatures[existingIndex] = {
      name: name,
      variant: variant
    };
    return;
  }

  existingFeatures.push({
    name: name,
    variant: variant
  });
  existingFeatureKeys[name] = existingFeatures.length - 1;
}

function merge(existingFeatures, newFeatures, existingFeatureKeys) {
  if (!_$isArray_14(newFeatures)) {
    return;
  }

  for (var i = 0; i < newFeatures.length; ++i) {
    var feature = newFeatures[i];

    if (feature === null || typeof feature !== 'object') {
      continue;
    } // 'add' will handle if 'name' doesn't exist & 'variant' is optional


    add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
  }

  return existingFeatures;
} // convert feature flags from a map of 'name -> variant' into the format required
// by the Bugsnag Event API:
//   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]


function toEventApi(featureFlags) {
  return _$map_16(_$filter_12(featureFlags, Boolean), function (_ref) {
    var name = _ref.name,
        variant = _ref.variant;
    var flag = {
      featureFlag: name
    }; // don't add a 'variant' property unless there's actually a value

    if (typeof variant === 'string') {
      flag.variant = variant;
    }

    return flag;
  });
}

function clear(features, featuresIndex, name) {
  var existingIndex = featuresIndex[name];

  if (typeof existingIndex === 'number') {
    features[existingIndex] = null;
    delete featuresIndex[name];
  }
}

var _$featureFlagDelegate_18 = {
  add: add,
  clear: clear,
  merge: merge,
  toEventApi: toEventApi
};

// Given `err` which may be an error, does it have a stack property which is a string?
var _$hasStack_19 = function (err) {
  return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
};

/**
 * Expose `isError`.
 */
var _$isError_32 = __isError_32;
/**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */

function __isError_32(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;

    case '[object Exception]':
      return true;

    case '[object DOMException]':
      return true;

    default:
      return value instanceof Error;
  }
}

var _$iserror_20 = _$isError_32;

/* removed: var _$assign_11 = require('./es-utils/assign'); */;

var __add_22 = function (state, section, keyOrObj, maybeVal) {
  var _updates;

  if (!section) return;
  var updates; // addMetadata("section", null) -> clears section

  if (keyOrObj === null) return __clear_22(state, section); // normalise the two supported input types into object form

  if (typeof keyOrObj === 'object') updates = keyOrObj;
  if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates); // exit if we don't have an updates object at this point

  if (!updates) return; // ensure a section with this name exists

  if (!state[section]) state[section] = {}; // merge the updates with the existing section

  state[section] = _$assign_11({}, state[section], updates);
};

var get = function (state, section, key) {
  if (typeof section !== 'string') return undefined;

  if (!key) {
    return state[section];
  }

  if (state[section]) {
    return state[section][key];
  }

  return undefined;
};

var __clear_22 = function (state, section, key) {
  if (typeof section !== 'string') return; // clear an entire section

  if (!key) {
    delete state[section];
    return;
  } // clear a single value from a section


  if (state[section]) {
    delete state[section][key];
  }
};

var _$metadataDelegate_22 = {
  add: __add_22,
  get: get,
  clear: __clear_22
};

var _$stackGenerator_33 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stack-generator', ['stackframe'], factory);
  } else if (typeof _$stackGenerator_33 === 'object') {
    _$stackGenerator_33 = factory(_$stackframe_34);
  } else {
    root.StackGenerator = factory(root.StackFrame);
  }
})(this, function (StackFrame) {
  return {
    backtrace: function StackGenerator$$backtrace(opts) {
      var stack = [];
      var maxStackSize = 10;

      if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
        maxStackSize = opts.maxStackSize;
      }

      var curr = arguments.callee;

      while (curr && stack.length < maxStackSize && curr['arguments']) {
        // Allow V8 optimizations
        var args = new Array(curr['arguments'].length);

        for (var i = 0; i < args.length; ++i) {
          args[i] = curr['arguments'][i];
        }

        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(new StackFrame({
            functionName: RegExp.$1 || undefined,
            args: args
          }));
        } else {
          stack.push(new StackFrame({
            args: args
          }));
        }

        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }

      return stack;
    }
  };
});

/* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */;

/* removed: var _$stackGenerator_33 = require('stack-generator'); */;

/* removed: var _$hasStack_19 = require('./lib/has-stack'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$featureFlagDelegate_18 = require('./lib/feature-flag-delegate'); */;

/* removed: var _$iserror_20 = require('./lib/iserror'); */;

var Event = /*#__PURE__*/function () {
  function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
    if (stacktrace === void 0) {
      stacktrace = [];
    }

    if (handledState === void 0) {
      handledState = defaultHandledState();
    }

    this.apiKey = undefined;
    this.context = undefined;
    this.groupingHash = undefined;
    this.originalError = originalError;
    this._handledState = handledState;
    this.severity = this._handledState.severity;
    this.unhandled = this._handledState.unhandled;
    this.app = {};
    this.device = {};
    this.request = {};
    this.breadcrumbs = [];
    this.threads = [];
    this._metadata = {};
    this._features = [];
    this._featuresIndex = {};
    this._user = {};
    this._session = undefined;
    this.errors = [createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)]; // Flags.
    // Note these are not initialised unless they are used
    // to save unnecessary bytes in the browser bundle

    /* this.attemptImmediateDelivery, default: true */
  }

  var _proto = Event.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }

    _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
  };

  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
  };

  _proto.getFeatureFlags = function getFeatureFlags() {
    return _$featureFlagDelegate_18.toEventApi(this._features);
  };

  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
  };

  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = [];
    this._featuresIndex = {};
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      payloadVersion: '4',
      exceptions: _$map_16(this.errors, function (er) {
        return _$assign_11({}, er, {
          message: er.errorMessage
        });
      }),
      severity: this.severity,
      unhandled: this._handledState.unhandled,
      severityReason: this._handledState.severityReason,
      app: this.app,
      device: this.device,
      request: this.request,
      breadcrumbs: this.breadcrumbs,
      context: this.context,
      groupingHash: this.groupingHash,
      metaData: this._metadata,
      user: this._user,
      session: this._session,
      featureFlags: this.getFeatureFlags()
    };
  };

  return Event;
}(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
// and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)


var formatStackframe = function (frame) {
  var f = {
    file: frame.fileName,
    method: normaliseFunctionName(frame.functionName),
    lineNumber: frame.lineNumber,
    columnNumber: frame.columnNumber,
    code: undefined,
    inProject: undefined
  }; // Some instances result in no file:
  // - calling notify() from chrome's terminal results in no file/method.
  // - non-error exception thrown from global code in FF
  // This adds one.

  if (f.lineNumber > -1 && !f.file && !f.method) {
    f.file = 'global code';
  }

  return f;
};

var normaliseFunctionName = function (name) {
  return /^global code$/i.test(name) ? 'global code' : name;
};

var defaultHandledState = function () {
  return {
    unhandled: false,
    severity: 'warning',
    severityReason: {
      type: 'handledException'
    }
  };
};

var ensureString = function (str) {
  return typeof str === 'string' ? str : '';
};

function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
  return {
    errorClass: ensureString(errorClass),
    errorMessage: ensureString(errorMessage),
    type: type,
    stacktrace: _$reduce_17(stacktrace, function (accum, frame) {
      var f = formatStackframe(frame); // don't include a stackframe if none of its properties are defined

      try {
        if (JSON.stringify(f) === '{}') return accum;
        return accum.concat(f);
      } catch (e) {
        return accum;
      }
    }, [])
  };
}

function getCauseStack(error) {
  if (error.cause) {
    return [error].concat(getCauseStack(error.cause));
  } else {
    return [error];
  }
} // Helpers


Event.getStacktrace = function (error, errorFramesToSkip, backtraceFramesToSkip) {
  if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack

  try {
    return _$filter_12(_$stackGenerator_33.backtrace(), function (frame) {
      return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
    }).slice(1 + backtraceFramesToSkip);
  } catch (e) {
    return [];
  }
};

Event.create = function (maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
  if (errorFramesToSkip === void 0) {
    errorFramesToSkip = 0;
  }

  var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger),
      error = _normaliseError[0],
      internalFrames = _normaliseError[1];

  var event;

  try {
    var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
    // tell the getStacktrace() function to skip the number of frames we know will
    // be from our own functions. This is added to the number of frames deep we
    // were told about
    internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
    // this is how many frames should be removed because they come from our library
    1 + errorFramesToSkip);
    event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
  } catch (e) {
    event = new Event(error.name, error.message, [], handledState, maybeError);
  }

  if (error.name === 'InvalidError') {
    event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
  }

  if (error.cause) {
    var _event$errors;

    var causes = getCauseStack(error).slice(1);
    var normalisedCauses = _$map_16(causes, function (cause) {
      // Only get stacktrace for error causes that are a valid JS Error and already have a stack
      var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];

      var _normaliseError2 = normaliseError(cause, true, 'error cause'),
          error = _normaliseError2[0];

      if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
      return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
    });

    (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
  }

  return event;
};

var makeSerialisable = function (err) {
  if (err === null) return 'null';
  if (err === undefined) return 'undefined';
  return err;
};

var normaliseError = function (maybeError, tolerateNonErrors, component, logger) {
  var error;
  var internalFrames = 0;

  var createAndLogInputError = function (reason) {
    var verb = component === 'error cause' ? 'was' : 'received';
    if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
    var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
    err.name = 'InvalidError';
    return err;
  }; // In some cases:
  //
  //  - the promise rejection handler (both in the browser and node)
  //  - the node uncaughtException handler
  //
  // We are really limited in what we can do to get a stacktrace. So we use the
  // tolerateNonErrors option to ensure that the resulting error communicates as
  // such.


  if (!tolerateNonErrors) {
    if (_$iserror_20(maybeError)) {
      error = maybeError;
    } else {
      error = createAndLogInputError(typeof maybeError);
      internalFrames += 2;
    }
  } else {
    switch (typeof maybeError) {
      case 'string':
      case 'number':
      case 'boolean':
        error = new Error(String(maybeError));
        internalFrames += 1;
        break;

      case 'function':
        error = createAndLogInputError('function');
        internalFrames += 2;
        break;

      case 'object':
        if (maybeError !== null && _$iserror_20(maybeError)) {
          error = maybeError;
        } else if (maybeError !== null && hasNecessaryFields(maybeError)) {
          error = new Error(maybeError.message || maybeError.errorMessage);
          error.name = maybeError.name || maybeError.errorClass;
          internalFrames += 1;
        } else {
          error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
          internalFrames += 2;
        }

        break;

      default:
        error = createAndLogInputError('nothing');
        internalFrames += 2;
    }
  }

  if (!_$hasStack_19(error)) {
    // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
    try {
      throw error;
    } catch (e) {
      if (_$hasStack_19(e)) {
        error = e; // if the error only got a stacktrace after we threw it here, we know it
        // will only have one extra internal frame from this function, regardless
        // of whether it went through createAndLogInputError() or not

        internalFrames = 1;
      }
    }
  }

  return [error, internalFrames];
}; // default value for stacktrace.type


Event.__type = 'browserjs';

var hasNecessaryFields = function (error) {
  return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
};

var _$Event_6 = Event;

// This is a heavily modified/simplified version of
//   https://github.com/othiym23/async-some
// with the logic flipped so that it is akin to the
// synchronous "every" method instead of "some".
// run the asynchronous test function (fn) over each item in the array (arr)
// in series until:
//   - fn(item, cb) => calls cb(null, false)
//   - or the end of the array is reached
// the callback (cb) will be passed (null, false) if any of the items in arr
// caused fn to call back with false, otherwise it will be passed (null, true)
var _$asyncEvery_7 = function (arr, fn, cb) {
  var index = 0;

  var next = function () {
    if (index >= arr.length) return cb(null, true);
    fn(arr[index], function (err, result) {
      if (err) return cb(err);
      if (result === false) return cb(null, false);
      index++;
      next();
    });
  };

  next();
};

/* removed: var _$asyncEvery_7 = require('./async-every'); */;

var _$callbackRunner_9 = function (callbacks, event, onCallbackError, cb) {
  // This function is how we support different kinds of callback:
  //  - synchronous - return value
  //  - node-style async with callback - cb(err, value)
  //  - promise/thenable - resolve(value)
  // It normalises each of these into the lowest common denominator – a node-style callback
  var runMaybeAsyncCallback = function (fn, cb) {
    if (typeof fn !== 'function') return cb(null);

    try {
      // if function appears sync…
      if (fn.length !== 2) {
        var ret = fn(event); // check if it returned a "thenable" (promise)

        if (ret && typeof ret.then === 'function') {
          return ret.then( // resolve
          function (val) {
            return setTimeout(function () {
              return cb(null, val);
            });
          }, // reject
          function (err) {
            setTimeout(function () {
              onCallbackError(err);
              return cb(null, true);
            });
          });
        }

        return cb(null, ret);
      } // if function is async…


      fn(event, function (err, result) {
        if (err) {
          onCallbackError(err);
          return cb(null);
        }

        cb(null, result);
      });
    } catch (e) {
      onCallbackError(e);
      cb(null);
    }
  };

  _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
};

var _$syncCallbackRunner_23 = function (callbacks, callbackArg, callbackType, logger) {
  var ignore = false;
  var cbs = callbacks.slice();

  while (!ignore) {
    if (!cbs.length) break;

    try {
      ignore = cbs.pop()(callbackArg) === false;
    } catch (e) {
      logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
      logger.error(e);
    }
  }

  return ignore;
};

var _$pad_29 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_29 = require('./pad.js'); */;

var env = typeof window === 'object' ? window : self;
var globalCount = 0;

for (var prop in env) {
  if (Object.hasOwnProperty.call(env, prop)) globalCount++;
}

var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);

var _$fingerprint_28 = function fingerprint() {
  return clientId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_29 = require('./lib/pad.js'); */;

var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

function randomBlock() {
  return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
}

function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal

  return c - 1;
}

function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(base),
      // Prevent same-machine collisions.
  counter = _$pad_29(safeCounter().toString(base), blockSize),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_28(),
      // Grab some more chars from Math.random()
  random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}

cuid.fingerprint = _$fingerprint_28;
var _$cuid_27 = cuid;

/* removed: var _$cuid_27 = require('@bugsnag/cuid'); */;

var Session = /*#__PURE__*/function () {
  function Session() {
    this.id = _$cuid_27();
    this.startedAt = new Date();
    this._handled = 0;
    this._unhandled = 0;
    this._user = {};
    this.app = {};
    this.device = {};
  }

  var _proto = Session.prototype;

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      id: this.id,
      startedAt: this.startedAt,
      events: {
        handled: this._handled,
        unhandled: this._unhandled
      }
    };
  };

  _proto._track = function _track(event) {
    this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
  };

  return Session;
}();

var _$Session_35 = Session;

/* removed: var _$config_5 = require('./config'); */;

/* removed: var _$Event_6 = require('./event'); */;

/* removed: var _$Breadcrumb_3 = require('./breadcrumb'); */;

/* removed: var _$Session_35 = require('./session'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$callbackRunner_9 = require('./lib/callback-runner'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$syncCallbackRunner_23 = require('./lib/sync-callback-runner'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var __add_4 = _$featureFlagDelegate_18.add,
    __clear_4 = _$featureFlagDelegate_18.clear,
    __merge_4 = _$featureFlagDelegate_18.merge;

var noop = function () {};

var Client = /*#__PURE__*/function () {
  function Client(configuration, schema, internalPlugins, notifier) {
    var _this = this;

    if (schema === void 0) {
      schema = _$config_5.schema;
    }

    if (internalPlugins === void 0) {
      internalPlugins = [];
    }

    // notifier id
    this._notifier = notifier; // intialise opts and config

    this._config = {};
    this._schema = schema; // i/o

    this._delivery = {
      sendSession: noop,
      sendEvent: noop
    };
    this._logger = {
      debug: noop,
      info: noop,
      warn: noop,
      error: noop
    }; // plugins

    this._plugins = {}; // state

    this._breadcrumbs = [];
    this._session = null;
    this._metadata = {};
    this._featuresIndex = {};
    this._features = [];
    this._context = undefined;
    this._user = {}; // callbacks:
    //  e: onError
    //  s: onSession
    //  sp: onSessionPayload
    //  b: onBreadcrumb
    // (note these names are minified by hand because object
    // properties are not safe to minify automatically)

    this._cbs = {
      e: [],
      s: [],
      sp: [],
      b: []
    }; // expose internal constructors

    this.Client = Client;
    this.Event = _$Event_6;
    this.Breadcrumb = _$Breadcrumb_3;
    this.Session = _$Session_35;
    this._config = this._configure(configuration, internalPlugins);
    _$map_16(internalPlugins.concat(this._config.plugins), function (pl) {
      if (pl) _this._loadPlugin(pl);
    }); // when notify() is called we need to know how many frames are from our own source
    // this inital value is 1 not 0 because we wrap notify() to ensure it is always
    // bound to have the client as its `this` value – see below.

    this._depth = 1;
    var self = this;
    var notify = this.notify;

    this.notify = function () {
      return notify.apply(self, arguments);
    };
  }

  var _proto = Client.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }

    __add_4(this._features, this._featuresIndex, name, variant);
  };

  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    __merge_4(this._features, featureFlags, this._featuresIndex);
  };

  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    __clear_4(this._features, this._featuresIndex, name);
  };

  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = [];
    this._featuresIndex = {};
  };

  _proto.getContext = function getContext() {
    return this._context;
  };

  _proto.setContext = function setContext(c) {
    this._context = c;
  };

  _proto._configure = function _configure(opts, internalPlugins) {
    var schema = _$reduce_17(internalPlugins, function (schema, plugin) {
      if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
      return schema;
    }, this._schema); // accumulate configuration and error messages

    var _reduce = _$reduce_17(_$keys_15(schema), function (accum, key) {
      var defaultValue = schema[key].defaultValue(opts[key]);

      if (opts[key] !== undefined) {
        var valid = schema[key].validate(opts[key]);

        if (!valid) {
          accum.errors[key] = schema[key].message;
          accum.config[key] = defaultValue;
        } else {
          if (schema[key].allowPartialObject) {
            accum.config[key] = _$assign_11(defaultValue, opts[key]);
          } else {
            accum.config[key] = opts[key];
          }
        }
      } else {
        accum.config[key] = defaultValue;
      }

      return accum;
    }, {
      errors: {},
      config: {}
    }),
        errors = _reduce.errors,
        config = _reduce.config;

    if (schema.apiKey) {
      // missing api key is the only fatal error
      if (!config.apiKey) throw new Error('No Bugsnag API Key set'); // warn about an apikey that is not of the expected format

      if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
    } // update and elevate some options


    this._metadata = _$assign_11({}, config.metadata);
    __merge_4(this._features, config.featureFlags, this._featuresIndex);
    this._user = _$assign_11({}, config.user);
    this._context = config.context;
    if (config.logger) this._logger = config.logger; // add callbacks

    if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
    if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
    if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession); // finally warn about any invalid config where we fell back to the default

    if (_$keys_15(errors).length) {
      this._logger.warn(generateConfigErrorMessage(errors, opts));
    }

    return config;
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto._loadPlugin = function _loadPlugin(plugin) {
    var result = plugin.load(this); // JS objects are not the safest way to store arbitrarily keyed values,
    // so bookend the key with some characters that prevent tampering with
    // stuff like __proto__ etc. (only store the result if the plugin had a
    // name)

    if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
    return this;
  };

  _proto.getPlugin = function getPlugin(name) {
    return this._plugins["~" + name + "~"];
  };

  _proto._setDelivery = function _setDelivery(d) {
    this._delivery = d(this);
  };

  _proto.startSession = function startSession() {
    var session = new _$Session_35();
    session.app.releaseStage = this._config.releaseStage;
    session.app.version = this._config.appVersion;
    session.app.type = this._config.appType;
    session._user = _$assign_11({}, this._user); // run onSession callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);

    if (ignore) {
      this._logger.debug('Session not started due to onSession callback');

      return this;
    }

    return this._sessionDelegate.startSession(this, session);
  };

  _proto.addOnError = function addOnError(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.e[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnError = function removeOnError(fn) {
    this._cbs.e = _$filter_12(this._cbs.e, function (f) {
      return f !== fn;
    });
  };

  _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
    this._cbs.sp.push(fn);
  };

  _proto.addOnSession = function addOnSession(fn) {
    this._cbs.s.push(fn);
  };

  _proto.removeOnSession = function removeOnSession(fn) {
    this._cbs.s = _$filter_12(this._cbs.s, function (f) {
      return f !== fn;
    });
  };

  _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.b[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
    this._cbs.b = _$filter_12(this._cbs.b, function (f) {
      return f !== fn;
    });
  };

  _proto.pauseSession = function pauseSession() {
    return this._sessionDelegate.pauseSession(this);
  };

  _proto.resumeSession = function resumeSession() {
    return this._sessionDelegate.resumeSession(this);
  };

  _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
    // coerce bad values so that the defaults get set
    message = typeof message === 'string' ? message : '';
    type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
    metadata = typeof metadata === 'object' && metadata !== null ? metadata : {}; // if no message, discard

    if (!message) return;
    var crumb = new _$Breadcrumb_3(message, metadata, type); // run onBreadcrumb callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);

    if (ignore) {
      this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');

      return;
    } // push the valid crumb onto the queue and maintain the length


    this._breadcrumbs.push(crumb);

    if (this._breadcrumbs.length > this._config.maxBreadcrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
    }
  };

  _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
    var types = this._config.enabledBreadcrumbTypes;
    return types === null || _$includes_13(types, type);
  };

  _proto.notify = function notify(maybeError, onError, postReportCallback) {
    if (postReportCallback === void 0) {
      postReportCallback = noop;
    }

    var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);

    this._notify(event, onError, postReportCallback);
  };

  _proto._notify = function _notify(event, onError, postReportCallback) {
    var _this2 = this;

    if (postReportCallback === void 0) {
      postReportCallback = noop;
    }

    event.app = _$assign_11({}, event.app, {
      releaseStage: this._config.releaseStage,
      version: this._config.appVersion,
      type: this._config.appType
    });
    event.context = event.context || this._context;
    event._metadata = _$assign_11({}, event._metadata, this._metadata);
    event._user = _$assign_11({}, event._user, this._user);
    event.breadcrumbs = this._breadcrumbs.slice();
    __merge_4(event._features, this._features, event._featuresIndex); // exit early if events should not be sent on the current releaseStage

    if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
      this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');

      return postReportCallback(null, event);
    }

    var originalSeverity = event.severity;

    var onCallbackError = function (err) {
      // errors in callbacks are tolerated but we want to log them out
      _this2._logger.error('Error occurred in onError callback, continuing anyway…');

      _this2._logger.error(err);
    };

    var callbacks = [].concat(this._cbs.e).concat(onError);
    _$callbackRunner_9(callbacks, event, onCallbackError, function (err, shouldSend) {
      if (err) onCallbackError(err);

      if (!shouldSend) {
        _this2._logger.debug('Event not sent due to onError callback');

        return postReportCallback(null, event);
      }

      if (_this2._isBreadcrumbTypeEnabled('error')) {
        // only leave a crumb for the error if actually got sent
        Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
          errorClass: event.errors[0].errorClass,
          errorMessage: event.errors[0].errorMessage,
          severity: event.severity
        }, 'error');
      }

      if (originalSeverity !== event.severity) {
        event._handledState.severityReason = {
          type: 'userCallbackSetSeverity'
        };
      }

      if (event.unhandled !== event._handledState.unhandled) {
        event._handledState.severityReason.unhandledOverridden = true;
        event._handledState.unhandled = event.unhandled;
      }

      if (_this2._session) {
        _this2._session._track(event);

        event._session = _this2._session;
      }

      _this2._delivery.sendEvent({
        apiKey: event.apiKey || _this2._config.apiKey,
        notifier: _this2._notifier,
        events: [event]
      }, function (err) {
        return postReportCallback(err, event);
      });
    });
  };

  return Client;
}();

var generateConfigErrorMessage = function (errors, rawInput) {
  var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function (key) {
    return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
  }).join('\n\n'));
  return er;
};

var stringify = function (val) {
  switch (typeof val) {
    case 'string':
    case 'number':
    case 'object':
      return JSON.stringify(val);

    default:
      return String(val);
  }
};

var _$Client_4 = Client;

var _$jsonPayload_21 = {};
/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;

var EVENT_REDACTION_PATHS = ['events.[].metaData', 'events.[].breadcrumbs.[].metaData', 'events.[].request'];

_$jsonPayload_21.event = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null, {
    redactedPaths: EVENT_REDACTION_PATHS,
    redactedKeys: redactedKeys
  });

  if (payload.length > 10e5) {
    event.events[0]._metadata = {
      notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
    };
    payload = _$safeJsonStringify_30(event, null, null, {
      redactedPaths: EVENT_REDACTION_PATHS,
      redactedKeys: redactedKeys
    });
    if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  }

  return payload;
};

_$jsonPayload_21.session = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null);
  if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  return payload;
};

var _$delivery_36 = {};
/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

_$delivery_36 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'notify', '4', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'sessions', '1', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    }
  };
};

var getApiUrl = function (config, endpoint, version, win) {
  // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
  // to an ISO string when you use JSON stringify. Simply parsing the result of
  // JSON.stringify is smaller than using a toISOstring() polyfill.
  var isoDate = JSON.parse(JSON.stringify(new Date()));
  var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
  return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
};

var matchPageProtocol = _$delivery_36._matchPageProtocol = function (endpoint, pageProtocol) {
  return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
};

/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

var _$delivery_37 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.notify;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '4');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.sessions;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '1');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    }
  };
};

var appStart = new Date();

var reset = function () {
  appStart = new Date();
};

var _$app_38 = {
  name: 'appDuration',
  load: function (client) {
    client.addOnError(function (event) {
      var now = new Date();
      event.app.duration = now - appStart;
    }, true);
    return {
      reset: reset
    };
  }
};

/*
 * Sets the default context to be the current URL
 */
var _$context_39 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.context !== undefined) return;
        event.context = win.location.pathname;
      }, true);
    }
  };
};

var _$pad_43 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_43 = require('./pad.js'); */;

var __env_42 = typeof window === 'object' ? window : self;
var __globalCount_42 = 0;

for (var __prop_42 in __env_42) {
  if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
}

var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);

var _$fingerprint_42 = function fingerprint() {
  return __clientId_42;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_43 = require('./lib/pad.js'); */;

var __c_41 = 0,
    __blockSize_41 = 4,
    __base_41 = 36,
    __discreteValues_41 = Math.pow(__base_41, __blockSize_41);

function __randomBlock_41() {
  return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
}

function __safeCounter_41() {
  __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
  __c_41++; // this is not subliminal

  return __c_41 - 1;
}

function __cuid_41() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(__base_41),
      // Prevent same-machine collisions.
  counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_42(),
      // Grab some more chars from Math.random()
  random = __randomBlock_41() + __randomBlock_41();
  return letter + timestamp + counter + print + random;
}

__cuid_41.fingerprint = _$fingerprint_42;
var _$cuid_41 = __cuid_41;

/* removed: var _$cuid_41 = require('@bugsnag/cuid'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';

var getDeviceId = function () {
  try {
    var storage = window.localStorage;
    var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY); // If we get an ID, make sure it looks like a valid cuid. The length can
    // fluctuate slightly, so some leeway is built in

    if (id && /^c[a-z0-9]{20,32}$/.test(id)) {
      return id;
    }

    id = _$cuid_41();
    storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
    return id;
  } catch (err) {// If localStorage is not available (e.g. because it's disabled) then give up
  }
};
/*
 * Automatically detects browser device details
 */


var _$device_40 = function (nav, screen) {
  if (nav === void 0) {
    nav = navigator;
  }

  if (screen === void 0) {
    screen = window.screen;
  }

  return {
    load: function (client) {
      var device = {
        locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
        userAgent: nav.userAgent
      };

      if (screen && screen.orientation && screen.orientation.type) {
        device.orientation = screen.orientation.type;
      } else {
        device.orientation = document.documentElement.clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';
      }

      if (client._config.generateAnonymousId) {
        device.id = getDeviceId();
      }

      client.addOnSession(function (session) {
        session.device = _$assign_11({}, session.device, device); // only set device id if collectUserIp is false

        if (!client._config.collectUserIp) setDefaultUserId(session);
      }); // add time just as the event is sent

      client.addOnError(function (event) {
        event.device = _$assign_11({}, event.device, device, {
          time: new Date()
        });
        if (!client._config.collectUserIp) setDefaultUserId(event);
      }, true);
    },
    configSchema: {
      generateAnonymousId: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

var setDefaultUserId = function (eventOrSession) {
  // device id is also used to populate the user id field, if it's not already set
  var user = eventOrSession.getUser();

  if (!user || !user.id) {
    eventOrSession.setUser(eventOrSession.device.id);
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Sets the event request: { url } to be the current href
 */


var _$request_44 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.request && event.request.url) return;
        event.request = _$assign_11({}, event.request, {
          url: win.location.href
        });
      }, true);
    }
  };
};

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;

var _$session_45 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled

    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');

      return sessionClient;
    }

    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });

    return sessionClient;
  },
  resumeSession: function (client) {
    // Do nothing if there's already an active session
    if (client._session) {
      return client;
    } // If we have a paused session then make it the active session


    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    } // Otherwise start a new session


    return client.startSession();
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Prevent collection of user IPs
 */


var _$clientIp_46 = {
  load: function (client) {
    if (client._config.collectUserIp) return;
    client.addOnError(function (event) {
      // If user.id is explicitly undefined, it will be missing from the payload. It needs
      // removing so that the following line replaces it
      if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
      event._user = _$assign_11({
        id: '[REDACTED]'
      }, event._user);
      event.request = _$assign_11({
        clientIp: '[REDACTED]'
      }, event.request);
    });
  },
  configSchema: {
    collectUserIp: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return value === true || value === false;
      }
    }
  }
};

var _$consoleBreadcrumbs_47 = {};
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;
/*
 * Leaves breadcrumbs when console log methods are called
 */


_$consoleBreadcrumbs_47.load = function (client) {
  var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
  if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
  _$map_16(CONSOLE_LOG_METHODS, function (method) {
    var original = console[method];

    console[method] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      client.leaveBreadcrumb('Console output', _$reduce_17(args, function (accum, arg, i) {
        // do the best/simplest stringification of each argument
        var stringified = '[Unknown value]'; // this may fail if the input is:
        // - an object whose [[Prototype]] is null (no toString)
        // - an object with a broken toString or @@toPrimitive implementation

        try {
          stringified = String(arg);
        } catch (e) {} // if it stringifies to [object Object] attempt to JSON stringify


        if (stringified === '[object Object]') {
          // catch stringify errors and fallback to [object Object]
          try {
            stringified = JSON.stringify(arg);
          } catch (e) {}
        }

        accum["[" + i + "]"] = stringified;
        return accum;
      }, {
        severity: method.indexOf('group') === 0 ? 'log' : method
      }), 'log');
      original.apply(console, args);
    };

    console[method]._restore = function () {
      console[method] = original;
    };
  });
};

if (false) {}

var CONSOLE_LOG_METHODS = _$filter_12(['log', 'debug', 'info', 'warn', 'error'], function (method) {
  return typeof console !== 'undefined' && typeof console[method] === 'function';
});

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;

var MAX_LINE_LENGTH = 200;
var MAX_SCRIPT_LENGTH = 500000;

var _$inlineScriptContent_48 = function (doc, win) {
  if (doc === void 0) {
    doc = document;
  }

  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.trackInlineScripts) return;
      var originalLocation = win.location.href;
      var html = ''; // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
      // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing

      var isOldIe = !!doc.attachEvent;
      var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';

      var getHtml = function () {
        return doc.documentElement.outerHTML;
      }; // get whatever HTML exists at this point in time


      html = getHtml();
      var prev = doc.onreadystatechange; // then update it when the DOM content has loaded

      doc.onreadystatechange = function () {
        // IE8 compatible alternative to document#DOMContentLoaded
        if (doc.readyState === 'interactive') {
          html = getHtml();
          DOMContentLoaded = true;
        }

        try {
          prev.apply(this, arguments);
        } catch (e) {}
      };

      var _lastScript = null;

      var updateLastScript = function (script) {
        _lastScript = script;
      };

      var getCurrentScript = function () {
        var script = doc.currentScript || _lastScript;

        if (!script && !DOMContentLoaded) {
          var scripts = doc.scripts || doc.getElementsByTagName('script');
          script = scripts[scripts.length - 1];
        }

        return script;
      };

      var addSurroundingCode = function (lineNumber) {
        // get whatever html has rendered at this point
        if (!DOMContentLoaded || !html) html = getHtml(); // simulate the raw html

        var htmlLines = ['<!-- DOC START -->'].concat(html.split('\n'));
        var zeroBasedLine = lineNumber - 1;
        var start = Math.max(zeroBasedLine - 3, 0);
        var end = Math.min(zeroBasedLine + 3, htmlLines.length);
        return _$reduce_17(htmlLines.slice(start, end), function (accum, line, i) {
          accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
          return accum;
        }, {});
      };

      client.addOnError(function (event) {
        // remove any of our own frames that may be part the stack this
        // happens before the inline script check as it happens for all errors
        event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function (f) {
          return !/__trace__$/.test(f.method);
        });
        var frame = event.errors[0].stacktrace[0]; // if frame.file exists and is not the original location of the page, this can't be an inline script

        if (frame && frame.file && frame.file.replace(/#.*$/, '') !== originalLocation.replace(/#.*$/, '')) return; // grab the last script known to have run

        var currentScript = getCurrentScript();

        if (currentScript) {
          var content = currentScript.innerHTML;
          event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH)); // only attempt to grab some surrounding code if we have a line number

          if (frame && frame.lineNumber) {
            frame.code = addSurroundingCode(frame.lineNumber);
          }
        }
      }, true); // Proxy all the timer functions whose callback is their 0th argument.
      // Keep a reference to the original setTimeout because we need it later

      var _map = _$map_16(['setTimeout', 'setInterval', 'setImmediate', 'requestAnimationFrame'], function (fn) {
        return __proxy(win, fn, function (original) {
          return __traceOriginalScript(original, function (args) {
            return {
              get: function () {
                return args[0];
              },
              replace: function (fn) {
                args[0] = fn;
              }
            };
          });
        });
      }),
          _setTimeout = _map[0]; // Proxy all the host objects whose prototypes have an addEventListener function


      _$map_16(['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'], function (o) {
        if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;

        __proxy(win[o].prototype, 'addEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor);
        });

        __proxy(win[o].prototype, 'removeEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
        });
      });

      function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
        if (alsoCallOriginal === void 0) {
          alsoCallOriginal = false;
        }

        return function () {
          // this is required for removeEventListener to remove anything added with
          // addEventListener before the functions started being wrapped by Bugsnag
          var args = [].slice.call(arguments);

          try {
            var cba = callbackAccessor(args);
            var cb = cba.get();
            if (alsoCallOriginal) fn.apply(this, args);
            if (typeof cb !== 'function') return fn.apply(this, args);

            if (cb.__trace__) {
              cba.replace(cb.__trace__);
            } else {
              var script = getCurrentScript(); // this function mustn't be annonymous due to a bug in the stack
              // generation logic, meaning it gets tripped up
              // see: https://github.com/stacktracejs/stack-generator/issues/6

              cb.__trace__ = function __trace__() {
                // set the script that called this function
                updateLastScript(script); // immediately unset the currentScript synchronously below, however
                // if this cb throws an error the line after will not get run so schedule
                // an almost-immediate aysnc update too

                _setTimeout(function () {
                  updateLastScript(null);
                }, 0);

                var ret = cb.apply(this, arguments);
                updateLastScript(null);
                return ret;
              };

              cb.__trace__.__trace__ = cb.__trace__;
              cba.replace(cb.__trace__);
            }
          } catch (e) {// swallow these errors on Selenium:
            // Permission denied to access property '__trace__'
            // WebDriverException: Message: Permission denied to access property "handleEvent"
          } // IE8 doesn't let you call .apply() on setTimeout/setInterval


          if (fn.apply) return fn.apply(this, args);

          switch (args.length) {
            case 1:
              return fn(args[0]);

            case 2:
              return fn(args[0], args[1]);

            default:
              return fn();
          }
        };
      }
    },
    configSchema: {
      trackInlineScripts: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

function __proxy(host, name, replacer) {
  var original = host[name];
  if (!original) return original;
  var replacement = replacer(original);
  host[name] = replacement;
  return original;
}

function eventTargetCallbackAccessor(args) {
  var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
  return {
    get: function () {
      return isEventHandlerObj ? args[1].handleEvent : args[1];
    },
    replace: function (fn) {
      if (isEventHandlerObj) {
        args[1].handleEvent = fn;
      } else {
        args[1] = fn;
      }
    }
  };
}

/*
 * Leaves breadcrumbs when the user interacts with the DOM
 */
var _$interactionBreadcrumbs_49 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('user')) return;
      win.addEventListener('click', function (event) {
        var targetText, targetSelector;

        try {
          targetText = getNodeText(event.target);
          targetSelector = getNodeSelector(event.target, win);
        } catch (e) {
          targetText = '[hidden]';
          targetSelector = '[hidden]';

          client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
        }

        client.leaveBreadcrumb('UI click', {
          targetText: targetText,
          targetSelector: targetSelector
        }, 'user');
      }, true);
    }
  };
}; // extract text content from a element


var getNodeText = function (el) {
  var text = el.textContent || el.innerText || '';
  if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
  text = text.replace(/^\s+|\s+$/g, ''); // trim whitespace

  return truncate(text, 140);
}; // Create a label from tagname, id and css class of the element


function getNodeSelector(el, win) {
  var parts = [el.tagName];
  if (el.id) parts.push('#' + el.id);
  if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.')); // Can't get much more advanced with the current browser

  if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');

  try {
    if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
  } catch (e) {
    // Sometimes the query selector can be invalid just return it as-is
    return parts.join('');
  } // try to get a more specific selector if this one matches more than one element


  if (el.parentNode.childNodes.length > 1) {
    var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
    parts.push(":nth-child(" + index + ")");
  }

  if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join(''); // try prepending the parent node selector

  if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
  return parts.join('');
}

function truncate(value, length) {
  var ommision = '(...)';
  if (value && value.length <= length) return value;
  return value.slice(0, length - ommision.length) + ommision;
}

var _$navigationBreadcrumbs_50 = {};
/*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/
_$navigationBreadcrumbs_50 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('navigation')) return; // returns a function that will drop a breadcrumb with a given name

      var drop = function (name) {
        return function () {
          return client.leaveBreadcrumb(name, {}, 'navigation');
        };
      }; // simple drops – just names, no meta


      win.addEventListener('pagehide', drop('Page hidden'), true);
      win.addEventListener('pageshow', drop('Page shown'), true);
      win.addEventListener('load', drop('Page loaded'), true);
      win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true); // some browsers like to emit popstate when the page loads, so only add the popstate listener after that

      win.addEventListener('load', function () {
        return win.addEventListener('popstate', drop('Navigated back'), true);
      }); // hashchange has some metadata that we care about

      win.addEventListener('hashchange', function (event) {
        var metadata = event.oldURL ? {
          from: relativeLocation(event.oldURL, win),
          to: relativeLocation(event.newURL, win),
          state: getCurrentState(win)
        } : {
          to: relativeLocation(win.location.href, win)
        };
        client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
      }, true); // the only way to know about replaceState/pushState is to wrap them… >_<

      if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
      if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
    }
  };

  if (false) {}

  return plugin;
};

if (false) {} // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
// just the path and hash parts, e.g. /pages/01.html?yes=no#section-2


var relativeLocation = function (url, win) {
  var a = win.document.createElement('A');
  a.href = url;
  return "" + a.pathname + a.search + a.hash;
};

var stateChangeToMetadata = function (win, state, title, url) {
  var currentPath = relativeLocation(win.location.href, win);
  return {
    title: title,
    state: state,
    prevState: getCurrentState(win),
    to: url || currentPath,
    from: currentPath
  };
};

var wrapHistoryFn = function (client, target, fn, win) {
  var orig = target[fn];

  target[fn] = function (state, title, url) {
    client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation'); // if throttle plugin is in use, reset the event sent count

    if (typeof client.resetEventCount === 'function') client.resetEventCount(); // if the client is operating in auto session-mode, a new route should trigger a new session

    if (client._config.autoTrackSessions) client.startSession(); // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
    // to '/undefined'. therefore we only pass the url if it's not undefined.

    orig.apply(target, [state, title].concat(url !== undefined ? url : []));
  };

  if (false) {}
};

var getCurrentState = function (win) {
  try {
    return win.history.state;
  } catch (e) {}
};

var BREADCRUMB_TYPE = 'request';

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
 * Leaves breadcrumbs when network requests occur
 */


var _$networkBreadcrumbs_51 = function (_ignoredUrls, win) {
  if (_ignoredUrls === void 0) {
    _ignoredUrls = [];
  }

  if (win === void 0) {
    win = window;
  }

  var restoreFunctions = [];
  var plugin = {
    load: function (client) {
      if (!client._isBreadcrumbTypeEnabled('request')) return;
      var ignoredUrls = [client._config.endpoints.notify, client._config.endpoints.sessions].concat(_ignoredUrls);
      monkeyPatchXMLHttpRequest();
      monkeyPatchFetch(); // XMLHttpRequest monkey patch

      function monkeyPatchXMLHttpRequest() {
        if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
        var nativeOpen = win.XMLHttpRequest.prototype.open; // override native open()

        win.XMLHttpRequest.prototype.open = function open(method, url) {
          var _this = this;

          var requestSetupKey = false;

          var error = function () {
            return handleXHRError(method, url);
          };

          var load = function () {
            return handleXHRLoad(method, url, _this.status);
          }; // if we have already setup listeners, it means open() was called twice, we need to remove
          // the listeners and recreate them


          if (requestSetupKey) {
            this.removeEventListener('load', load);
            this.removeEventListener('error', error);
          } // attach load event listener


          this.addEventListener('load', load); // attach error event listener

          this.addEventListener('error', error);
          requestSetupKey = true;
          nativeOpen.apply(this, arguments);
        };

        if (false) {}
      }

      function handleXHRLoad(method, url, status) {
        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');

          return;
        } // an XMLHttpRequest's URL can be an object as long as its 'toString'
        // returns a URL, e.g. a HTMLAnchorElement


        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        }

        var metadata = {
          status: status,
          request: method + " " + url
        };

        if (status >= 400) {
          // contacted server but got an error response
          client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
        }
      }

      function handleXHRError(method, url) {
        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');

          return;
        }

        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        } // failed to contact server


        client.leaveBreadcrumb('XMLHttpRequest error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      } // window.fetch monkey patch


      function monkeyPatchFetch() {
        // only patch it if it exists and if it is not a polyfill (patching a polyfilled
        // fetch() results in duplicate breadcrumbs for the same request because the
        // implementation uses XMLHttpRequest which is also patched)
        if (!('fetch' in win) || win.fetch.polyfill) return;
        var oldFetch = win.fetch;

        win.fetch = function fetch() {
          var _arguments = arguments;
          var urlOrRequest = arguments[0];
          var options = arguments[1];
          var method;
          var url = null;

          if (urlOrRequest && typeof urlOrRequest === 'object') {
            url = urlOrRequest.url;

            if (options && 'method' in options) {
              method = options.method;
            } else if (urlOrRequest && 'method' in urlOrRequest) {
              method = urlOrRequest.method;
            }
          } else {
            url = urlOrRequest;

            if (options && 'method' in options) {
              method = options.method;
            }
          }

          if (method === undefined) {
            method = 'GET';
          }

          return new Promise(function (resolve, reject) {
            // pass through to native fetch
            oldFetch.apply(void 0, _arguments).then(function (response) {
              handleFetchSuccess(response, method, url);
              resolve(response);
            })["catch"](function (error) {
              handleFetchError(method, url);
              reject(error);
            });
          });
        };

        if (false) {}
      }

      var handleFetchSuccess = function (response, method, url) {
        var metadata = {
          status: response.status,
          request: method + " " + url
        };

        if (response.status >= 400) {
          // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
          client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
        }
      };

      var handleFetchError = function (method, url) {
        client.leaveBreadcrumb('fetch() error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      };
    }
  };

  if (false) {}

  return plugin;
};

/* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */;
/*
 * Throttles and dedupes events
 */


var _$throttle_52 = {
  load: function (client) {
    // track sent events for each init of the plugin
    var n = 0; // add onError hook

    client.addOnError(function (event) {
      // have max events been sent already?
      if (n >= client._config.maxEvents) {
        client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");

        return false;
      }

      n++;
    });

    client.resetEventCount = function () {
      n = 0;
    };
  },
  configSchema: {
    maxEvents: {
      defaultValue: function () {
        return 10;
      },
      message: 'should be a positive integer ≤100',
      validate: function (val) {
        return _$intRange_24(1, 100)(val);
      }
    }
  }
};

var _$stripQueryString_53 = {};
/*
 * Remove query strings (and fragments) from stacktraces
 */
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

_$stripQueryString_53 = {
  load: function (client) {
    client.addOnError(function (event) {
      var allFrames = _$reduce_17(event.errors, function (accum, er) {
        return accum.concat(er.stacktrace);
      }, []);
      _$map_16(allFrames, function (frame) {
        frame.file = strip(frame.file);
      });
    });
  }
};

var strip = _$stripQueryString_53._strip = function (str) {
  return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
};

/*
 * Automatically notifies Bugsnag when window.onerror is called
 */
var _$onerror_54 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.autoDetectErrors) return;
      if (!client._config.enabledErrorTypes.unhandledExceptions) return;

      function onerror(messageOrEvent, url, lineNo, charNo, error) {
        // Ignore errors with no info due to CORS settings
        if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) {
          client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
        } else {
          // any error sent to window.onerror is unhandled and has severity=error
          var handledState = {
            severity: 'error',
            unhandled: true,
            severityReason: {
              type: 'unhandledException'
            }
          };
          var event; // window.onerror can be called in a number of ways. This big if-else is how we
          // figure out which arguments were supplied, and what kind of values it received.

          if (error) {
            // if the last parameter (error) was supplied, this is a modern browser's
            // way of saying "this value was thrown and not caught"
            event = client.Event.create(error, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          } else if ( // This complex case detects "error" events that are typically synthesised
          // by jquery's trigger method (although can be created in other ways). In
          // order to detect this:
          // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
          // - the second argument (url) must either not exist or be something other than a string (if it
          //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
          //    function)
          // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
          typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
            // The jQuery event may have a "type" property, if so use it as part of the error message
            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error'; // attempt to find a message from one of the conventional properties, but
            // default to empty string (the event will fill it with a placeholder)

            var message = messageOrEvent.message || messageOrEvent.detail || '';
            event = client.Event.create({
              name: name,
              message: message
            }, true, handledState, 'window onerror', 1); // provide the original thing onerror received – not our error-like object we passed to _notify

            event.originalError = messageOrEvent; // include the raw input as metadata – it might contain more info than we extracted

            event.addMetadata('window onerror', {
              event: messageOrEvent,
              extraParameters: url
            });
          } else {
            // Lastly, if there was no "error" parameter this event was probably from an old
            // browser that doesn't support that. Instead we need to generate a stacktrace.
            event = client.Event.create(messageOrEvent, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          }

          client._notify(event);
        }

        if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
      }

      var prevOnError = win.onerror;
      win.onerror = onerror;
    }
  };
}; // Sometimes the stacktrace has less information than was passed to window.onerror.
// This function will augment the first stackframe with any useful info that was
// received as arguments to the onerror callback.


var decorateStack = function (stack, url, lineNo, charNo) {
  if (!stack[0]) stack.push({});
  var culprit = stack[0];
  if (!culprit.file && typeof url === 'string') culprit.file = url;
  if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;

  if (!culprit.columnNumber) {
    if (isActualNumber(charNo)) {
      culprit.columnNumber = charNo;
    } else if (window.event && isActualNumber(window.event.errorCharacter)) {
      culprit.columnNumber = window.event.errorCharacter;
    }
  }
};

var isActualNumber = function (n) {
  return typeof n === 'number' && String.call(n) !== 'NaN';
};

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$iserror_20 = require('@bugsnag/core/lib/iserror'); */;

var _listener;
/*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */


var _$unhandledRejection_55 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;

      var listener = function (evt) {
        var error = evt.reason;
        var isBluebird = false; // accessing properties on evt.detail can throw errors (see #394)

        try {
          if (evt.detail && evt.detail.reason) {
            error = evt.detail.reason;
            isBluebird = true;
          }
        } catch (e) {}

        var event = client.Event.create(error, false, {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledPromiseRejection'
          }
        }, 'unhandledrejection handler', 1, client._logger);

        if (isBluebird) {
          _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
        }

        client._notify(event, function (event) {
          if (_$iserror_20(event.originalError) && !event.originalError.stack) {
            var _event$addMetadata;

            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
              name: event.originalError.name,
              message: event.originalError.message,
              code: event.originalError.code
            }, _event$addMetadata));
          }
        });
      };

      if ('addEventListener' in win) {
        win.addEventListener('unhandledrejection', listener);
      } else {
        win.onunhandledrejection = function (reason, promise) {
          listener({
            detail: {
              reason: reason,
              promise: promise
            }
          });
        };
      }

      _listener = listener;
    }
  };

  if (false) {}

  return plugin;
}; // The stack parser on bluebird stacks in FF get a suprious first frame:
//
// Error: derp
//   b@http://localhost:5000/bluebird.html:22:24
//   a@http://localhost:5000/bluebird.html:18:9
//   @http://localhost:5000/bluebird.html:14:9
//
// results in
//   […]
//     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
//     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
//     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
//     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
//
// so the following reduce/accumulator function removes such frames
//
// Bluebird pads method names with spaces so trim that too…
// https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571


var fixBluebirdStacktrace = function (error) {
  return function (frame) {
    if (frame.file === error.toString()) return;

    if (frame.method) {
      frame.method = frame.method.replace(/^\s+/, '');
    }
  };
};

var _$notifier_2 = {};
var name = 'Bugsnag JavaScript';
var version = '7.17.4';
var url = 'https://github.com/bugsnag/bugsnag-js';

/* removed: var _$Client_4 = require('@bugsnag/core/client'); */;

/* removed: var _$Event_6 = require('@bugsnag/core/event'); */;

/* removed: var _$Session_35 = require('@bugsnag/core/session'); */;

/* removed: var _$Breadcrumb_3 = require('@bugsnag/core/breadcrumb'); */;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$keys_15 = require('@bugsnag/core/lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */; // extend the base config schema with some browser-specific options


var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1);

/* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */;

/* removed: var _$unhandledRejection_55 = require('@bugsnag/plugin-window-unhandled-rejection'); */;

/* removed: var _$app_38 = require('@bugsnag/plugin-app-duration'); */;

/* removed: var _$device_40 = require('@bugsnag/plugin-browser-device'); */;

/* removed: var _$context_39 = require('@bugsnag/plugin-browser-context'); */;

/* removed: var _$request_44 = require('@bugsnag/plugin-browser-request'); */;

/* removed: var _$throttle_52 = require('@bugsnag/plugin-simple-throttle'); */;

/* removed: var _$consoleBreadcrumbs_47 = require('@bugsnag/plugin-console-breadcrumbs'); */;

/* removed: var _$networkBreadcrumbs_51 = require('@bugsnag/plugin-network-breadcrumbs'); */;

/* removed: var _$navigationBreadcrumbs_50 = require('@bugsnag/plugin-navigation-breadcrumbs'); */;

/* removed: var _$interactionBreadcrumbs_49 = require('@bugsnag/plugin-interaction-breadcrumbs'); */;

/* removed: var _$inlineScriptContent_48 = require('@bugsnag/plugin-inline-script-content'); */;

/* removed: var _$session_45 = require('@bugsnag/plugin-browser-session'); */;

/* removed: var _$clientIp_46 = require('@bugsnag/plugin-client-ip'); */;

/* removed: var _$stripQueryString_53 = require('@bugsnag/plugin-strip-query-string'); */; // delivery mechanisms


/* removed: var _$delivery_36 = require('@bugsnag/delivery-x-domain-request'); */;

/* removed: var _$delivery_37 = require('@bugsnag/delivery-xml-http-request'); */;

var Bugsnag = {
  _client: null,
  createClient: function (opts) {
    // handle very simple use case where user supplies just the api key as a string
    if (typeof opts === 'string') opts = {
      apiKey: opts
    };
    if (!opts) opts = {};
    var internalPlugins = [// add browser-specific plugins
    _$app_38, _$device_40(), _$context_39(), _$request_44(), _$throttle_52, _$session_45, _$clientIp_46, _$stripQueryString_53, _$onerror_54(), _$unhandledRejection_55(), _$navigationBreadcrumbs_50(), _$interactionBreadcrumbs_49(), _$networkBreadcrumbs_51(), _$consoleBreadcrumbs_47, // this one added last to avoid wrapping functionality before bugsnag uses it
    _$inlineScriptContent_48()]; // configure a client with user supplied options

    var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
      name: name,
      version: version,
      url: url
    }); // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)

    bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);

    bugsnag._logger.debug('Loaded!');

    bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
    return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
  },
  start: function (opts) {
    if (Bugsnag._client) {
      Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');

      return Bugsnag._client;
    }

    Bugsnag._client = Bugsnag.createClient(opts);
    return Bugsnag._client;
  },
  isStarted: function () {
    return Bugsnag._client != null;
  }
};
_$map_16(['resetEventCount'].concat(_$keys_15(_$Client_4.prototype)), function (m) {
  if (/^_/.test(m)) return;

  Bugsnag[m] = function () {
    if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
    Bugsnag._client._depth += 1;

    var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);

    Bugsnag._client._depth -= 1;
    return ret;
  };
});
_$notifier_2 = Bugsnag;
_$notifier_2.Client = _$Client_4;
_$notifier_2.Event = _$Event_6;
_$notifier_2.Session = _$Session_35;
_$notifier_2.Breadcrumb = _$Breadcrumb_3; // Export a "default" property for compatibility with ESM imports

_$notifier_2["default"] = Bugsnag;

return _$notifier_2;

});
//# sourceMappingURL=bugsnag.js.map


/***/ }),

/***/ 31832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17549)


/***/ }),

/***/ 84672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(6436);
(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;
var _$pad_5 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_5 = require('./pad.js'); */;

var os = __webpack_require__(28861),
    padding = 2,
    pid = _$pad_5(process.pid.toString(36), padding),
    hostname = os.hostname(),
    length = hostname.length,
    hostId = _$pad_5(hostname.split('').reduce(function (prev, char) {
  return +prev + char.charCodeAt(0);
}, +length + 36).toString(36), padding);

var _$fingerprint_4 = function fingerprint() {
  return pid + hostId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_4 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_5 = require('./lib/pad.js'); */;

var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

function randomBlock() {
  return _$pad_5((Math.random() * discreteValues << 0).toString(base), blockSize);
}

function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal

  return c - 1;
}

function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(base),
      // Prevent same-machine collisions.
  counter = _$pad_5(safeCounter().toString(base), blockSize),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_4(),
      // Grab some more chars from Math.random()
  random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}

cuid.fingerprint = _$fingerprint_4;
var _$cuid_3 = cuid;

/* removed: var _$cuid_3 = require('@bugsnag/cuid'); */;

var FLUSH_POLL_INTERVAL_MS = 50;
var inFlightRequests = new Map();

var noop = function () {};

var _$inFlight_6 = {
  trackInFlight: function (client) {
    var originalNotify = client._notify;

    client._notify = function (event, onError, callback) {
      if (callback === void 0) {
        callback = noop;
      }

      var id = _$cuid_3();
      inFlightRequests.set(id, true);

      var _callback = function () {
        inFlightRequests["delete"](id);
        callback.apply(null, arguments);
      };

      client._depth += 1;

      try {
        originalNotify.call(client, event, onError, _callback);
      } finally {
        client._depth -= 1;
      }
    };

    var patchDelivery = function (delivery) {
      var originalSendSession = delivery.sendSession;

      delivery.sendSession = function (session, callback) {
        if (callback === void 0) {
          callback = noop;
        }

        var id = _$cuid_3();
        inFlightRequests.set(id, true);

        var _callback = function () {
          inFlightRequests["delete"](id);
          callback.apply(null, arguments);
        };

        originalSendSession.call(delivery, session, _callback);
      };
    };

    var delivery = client._delivery;
    patchDelivery(delivery); // ensure we also monkey-patch any new delivery that might be set

    Object.defineProperty(client, '_delivery', {
      get: function () {
        return delivery;
      },
      set: function (newDeliviery) {
        patchDelivery(newDeliviery);
        delivery = newDeliviery;
      }
    });
  },
  flush: function (timeoutMs) {
    return new Promise(function (resolve, reject) {
      var resolveTimeout;
      var rejectTimeout = setTimeout(function () {
        if (resolveTimeout) clearTimeout(resolveTimeout);
        reject(new Error("flush timed out after " + timeoutMs + "ms"));
      }, timeoutMs);

      var resolveIfNoRequests = function () {
        if (inFlightRequests.size === 0) {
          clearTimeout(rejectTimeout);
          resolve();
          return;
        }

        resolveTimeout = setTimeout(resolveIfNoRequests, FLUSH_POLL_INTERVAL_MS);
      };

      resolveIfNoRequests();
    });
  }
};

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _$lambdaTimeoutApproaching_8 = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LambdaTimeoutApproaching, _Error);

  function LambdaTimeoutApproaching(remainingMs) {
    var _this;

    var message = "Lambda will timeout in " + remainingMs + "ms";
    _this = _Error.call(this, message) || this;
    _this.name = 'LambdaTimeoutApproaching';
    _this.stack = [];
    return _this;
  }

  return LambdaTimeoutApproaching;
}( /*#__PURE__*/_wrapNativeSuper(Error));

// Array#reduce
var _$reduce_2 = function (arr, fn, accum) {
  var val = accum;

  for (var i = 0, len = arr.length; i < len; i++) {
    val = fn(val, arr[i], i, arr);
  }

  return val;
};

/* removed: var _$reduce_2 = require('./reduce'); */; // Array#includes


var _$includes_1 = function (arr, x) {
  return _$reduce_2(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

/* removed: var _$includes_1 = require('@bugsnag/core/lib/es-utils/includes'); */;

var _$session_9 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled

    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_1(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');

      return sessionClient;
    }

    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });

    return sessionClient;
  },
  resumeSession: function (client) {
    // Do nothing if there's already an active session
    if (client._session) {
      return client;
    } // If we have a paused session then make it the active session


    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    } // Otherwise start a new session


    return client.startSession();
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

var _$src_7 = {};
/* removed: var _$inFlight_6 = require('@bugsnag/in-flight'); */;

/* removed: var _$session_9 = require('@bugsnag/plugin-browser-session'); */;

/* removed: var _$lambdaTimeoutApproaching_8 = require('./lambda-timeout-approaching'); */; // JS timers use a signed 32 bit integer for the millisecond parameter. SAM's
// "local invoke" has a bug that means it exceeds this amount, resulting in
// warnings. See https://github.com/aws/aws-sam-cli/issues/2519


var MAX_TIMER_VALUE = Math.pow(2, 31) - 1;
var BugsnagPluginAwsLambda = {
  name: 'awsLambda',
  load: function (client) {
    _$inFlight_6.trackInFlight(client);

    client._loadPlugin(_$session_9); // Reset the app duration between invocations, if the plugin is loaded


    var appDurationPlugin = client.getPlugin('appDuration');

    if (appDurationPlugin) {
      appDurationPlugin.reset();
    } // AWS add a default unhandledRejection listener that forcefully exits the
    // process. This breaks reporting of unhandled rejections, so we have to
    // remove all existing listeners and call them after we handle the rejection


    if (client._config.autoDetectErrors && client._config.enabledErrorTypes.unhandledRejections) {
      var listeners = process.listeners('unhandledRejection');
      process.removeAllListeners('unhandledRejection'); // This relies on our unhandled rejection plugin adding its listener first
      // using process.prependListener, so we can call it first instead of AWS'

      process.on('unhandledRejection', async function (reason, promise) {
        for (var listener of listeners) {
          await listener.call(process, reason, promise);
        }
      });
    }

    return {
      createHandler: function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
            _ref$flushTimeoutMs = _ref.flushTimeoutMs,
            flushTimeoutMs = _ref$flushTimeoutMs === void 0 ? 2000 : _ref$flushTimeoutMs,
            _ref$lambdaTimeoutNot = _ref.lambdaTimeoutNotifyMs,
            lambdaTimeoutNotifyMs = _ref$lambdaTimeoutNot === void 0 ? 1000 : _ref$lambdaTimeoutNot;

        return wrapHandler.bind(null, client, flushTimeoutMs, lambdaTimeoutNotifyMs);
      }
    };
  }
};

function wrapHandler(client, flushTimeoutMs, lambdaTimeoutNotifyMs, handler) {
  var _handler = handler;

  if (handler.length > 2) {
    // This is a handler expecting a 'callback' argument, so we convert
    // it to return a Promise so '_handler' always has the same API
    _handler = promisifyHandler(handler);
  }

  return async function (event, context) {
    var lambdaTimeout; // Guard against the "getRemainingTimeInMillis" being missing. This should
    // never happen but could when unit testing

    if (typeof context.getRemainingTimeInMillis === 'function' && lambdaTimeoutNotifyMs > 0) {
      var timeoutMs = context.getRemainingTimeInMillis() - lambdaTimeoutNotifyMs;

      if (timeoutMs <= MAX_TIMER_VALUE) {
        lambdaTimeout = setTimeout(function () {
          var handledState = {
            severity: 'warning',
            unhandled: true,
            severityReason: {
              type: 'log'
            }
          };
          var event = client.Event.create(new _$lambdaTimeoutApproaching_8(context.getRemainingTimeInMillis()), true, handledState, 'aws lambda plugin', 0);
          event.context = context.functionName || 'Lambda timeout approaching';

          client._notify(event);
        }, timeoutMs);
      }
    }

    client.addMetadata('AWS Lambda context', context);

    if (client._config.autoTrackSessions) {
      client.startSession();
    }

    try {
      return await _handler(event, context);
    } catch (err) {
      if (client._config.autoDetectErrors && client._config.enabledErrorTypes.unhandledExceptions) {
        var handledState = {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledException'
          }
        };

        var _event = client.Event.create(err, true, handledState, 'aws lambda plugin', 1);

        client._notify(_event);
      }

      throw err;
    } finally {
      if (lambdaTimeout) {
        clearTimeout(lambdaTimeout);
      }

      try {
        await _$inFlight_6.flush(flushTimeoutMs);
      } catch (err) {
        client._logger.error("Delivery may be unsuccessful: " + err.message);
      }
    }
  };
} // Convert a handler that uses callbacks to an async handler


function promisifyHandler(handler) {
  return function (event, context) {
    return new Promise(function (resolve, reject) {
      var result = handler(event, context, function (err, response) {
        if (err) {
          reject(err);
          return;
        }

        resolve(response);
      }); // Handle an edge case where the passed handler has the callback parameter
      // but actually returns a promise. In this case we need to resolve/reject
      // based on the returned promise instead of in the callback

      if (isPromise(result)) {
        result.then(resolve)["catch"](reject);
      }
    });
  };
}

function isPromise(value) {
  return (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function' && typeof value["catch"] === 'function';
}

_$src_7 = BugsnagPluginAwsLambda; // add a default export for ESM modules without interop

_$src_7["default"] = _$src_7;

return _$src_7;

});
//# sourceMappingURL=bugsnag-aws-lambda.js.map


/***/ }),

/***/ 14547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 45347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; },
/* harmony export */   "A": function() { return /* binding */ strategies; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 97304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, createLiteralElement, createNumberElement

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-skeleton-parser@1.3.6/node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-skeleton-parser@1.3.6/node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-skeleton-parser@1.3.6/node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6/* __assign */.pi)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6/* __assign */.pi)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}



/***/ }),

/***/ 32401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bc": function() { return /* binding */ IntlErrorCode; },
/* harmony export */   "Rw": function() { return /* binding */ IntlError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34254);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 56491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34254);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20289);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45347);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32401);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 91735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
/* unused harmony export default */
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "".concat(b);
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}


//# sourceMappingURL=equality.esm.js.map


/***/ }),

/***/ 65415:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 91620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(65415)
var ieee754 = __webpack_require__(30551)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 51626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 65936:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 89013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const validator = __webpack_require__(23303);
const XMLParser = __webpack_require__(87797);
const XMLBuilder = __webpack_require__(77996);

module.exports = {
  XMLParser: XMLParser,
  XMLValidator: validator,
  XMLBuilder: XMLBuilder
}

/***/ }),

/***/ 8209:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


const nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const nameChar = nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const nameRegexp = '[' + nameStartChar + '][' + nameChar + ']*'
const regexName = new RegExp('^' + nameRegexp + '$');

const getAllMatches = function(string, regex) {
  const matches = [];
  let match = regex.exec(string);
  while (match) {
    const allmatches = [];
    allmatches.startIndex = regex.lastIndex - match[0].length;
    const len = match.length;
    for (let index = 0; index < len; index++) {
      allmatches.push(match[index]);
    }
    matches.push(allmatches);
    match = regex.exec(string);
  }
  return matches;
};

const isName = function(string) {
  const match = regexName.exec(string);
  return !(match === null || typeof match === 'undefined');
};

exports.isExist = function(v) {
  return typeof v !== 'undefined';
};

exports.isEmptyObject = function(obj) {
  return Object.keys(obj).length === 0;
};

/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */
exports.merge = function(target, a, arrayMode) {
  if (a) {
    const keys = Object.keys(a); // will return an array of own properties
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      if (arrayMode === 'strict') {
        target[keys[i]] = [ a[keys[i]] ];
      } else {
        target[keys[i]] = a[keys[i]];
      }
    }
  }
};
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */

exports.getValue = function(v) {
  if (exports.isExist(v)) {
    return v;
  } else {
    return '';
  }
};

// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};

exports.isName = isName;
exports.getAllMatches = getAllMatches;
exports.nameRegexp = nameRegexp;


/***/ }),

/***/ 23303:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const util = __webpack_require__(8209);

const defaultOptions = {
  allowBooleanAttributes: false, //A tag can have attributes without any value
  unpairedTags: []
};

//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
exports.validate = function (xmlData, options) {
  options = Object.assign({}, defaultOptions, options);

  //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
  //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
  //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
  const tags = [];
  let tagFound = false;

  //indicates that the root tag has been closed (aka. depth 0 has been reached)
  let reachedRoot = false;

  if (xmlData[0] === '\ufeff') {
    // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
  }
  
  for (let i = 0; i < xmlData.length; i++) {

    if (xmlData[i] === '<' && xmlData[i+1] === '?') {
      i+=2;
      i = readPI(xmlData,i);
      if (i.err) return i;
    }else if (xmlData[i] === '<') {
      //starting of tag
      //read until you reach to '>' avoiding any '>' in attribute value
      let tagStartPos = i;
      i++;
      
      if (xmlData[i] === '!') {
        i = readCommentAndCDATA(xmlData, i);
        continue;
      } else {
        let closingTag = false;
        if (xmlData[i] === '/') {
          //closing tag
          closingTag = true;
          i++;
        }
        //read tagname
        let tagName = '';
        for (; i < xmlData.length &&
          xmlData[i] !== '>' &&
          xmlData[i] !== ' ' &&
          xmlData[i] !== '\t' &&
          xmlData[i] !== '\n' &&
          xmlData[i] !== '\r'; i++
        ) {
          tagName += xmlData[i];
        }
        tagName = tagName.trim();
        //console.log(tagName);

        if (tagName[tagName.length - 1] === '/') {
          //self closing tag without attributes
          tagName = tagName.substring(0, tagName.length - 1);
          //continue;
          i--;
        }
        if (!validateTagName(tagName)) {
          let msg;
          if (tagName.trim().length === 0) {
            msg = "Invalid space after '<'.";
          } else {
            msg = "Tag '"+tagName+"' is an invalid name.";
          }
          return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
        }

        const result = readAttributeStr(xmlData, i);
        if (result === false) {
          return getErrorObject('InvalidAttr', "Attributes for '"+tagName+"' have open quote.", getLineNumberForPosition(xmlData, i));
        }
        let attrStr = result.value;
        i = result.index;

        if (attrStr[attrStr.length - 1] === '/') {
          //self closing tag
          const attrStrStart = i - attrStr.length;
          attrStr = attrStr.substring(0, attrStr.length - 1);
          const isValid = validateAttributeString(attrStr, options);
          if (isValid === true) {
            tagFound = true;
            //continue; //text may presents after self closing tag
          } else {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
          }
        } else if (closingTag) {
          if (!result.tagClosed) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
          } else if (attrStr.trim().length > 0) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
          } else {
            const otg = tags.pop();
            if (tagName !== otg.tagName) {
              let openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
              return getErrorObject('InvalidTag',
                "Expected closing tag '"+otg.tagName+"' (opened in line "+openPos.line+", col "+openPos.col+") instead of closing tag '"+tagName+"'.",
                getLineNumberForPosition(xmlData, tagStartPos));
            }

            //when there are no more tags, we reached the root level.
            if (tags.length == 0) {
              reachedRoot = true;
            }
          }
        } else {
          const isValid = validateAttributeString(attrStr, options);
          if (isValid !== true) {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
          }

          //if the root level has been reached before ...
          if (reachedRoot === true) {
            return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
          } else if(options.unpairedTags.indexOf(tagName) !== -1){
            //don't push into stack
          } else {
            tags.push({tagName, tagStartPos});
          }
          tagFound = true;
        }

        //skip tag text value
        //It may include comments and CDATA value
        for (i++; i < xmlData.length; i++) {
          if (xmlData[i] === '<') {
            if (xmlData[i + 1] === '!') {
              //comment or CADATA
              i++;
              i = readCommentAndCDATA(xmlData, i);
              continue;
            } else if (xmlData[i+1] === '?') {
              i = readPI(xmlData, ++i);
              if (i.err) return i;
            } else{
              break;
            }
          } else if (xmlData[i] === '&') {
            const afterAmp = validateAmpersand(xmlData, i);
            if (afterAmp == -1)
              return getErrorObject('InvalidChar', "char '&' is not expected.", getLineNumberForPosition(xmlData, i));
            i = afterAmp;
          }else{
            if (reachedRoot === true && !isWhiteSpace(xmlData[i])) {
              return getErrorObject('InvalidXml', "Extra text at the end", getLineNumberForPosition(xmlData, i));
            }
          }
        } //end of reading tag text value
        if (xmlData[i] === '<') {
          i--;
        }
      }
    } else {
      if ( isWhiteSpace(xmlData[i])) {
        continue;
      }
      return getErrorObject('InvalidChar', "char '"+xmlData[i]+"' is not expected.", getLineNumberForPosition(xmlData, i));
    }
  }

  if (!tagFound) {
    return getErrorObject('InvalidXml', 'Start tag expected.', 1);
  }else if (tags.length == 1) {
      return getErrorObject('InvalidTag', "Unclosed tag '"+tags[0].tagName+"'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
  }else if (tags.length > 0) {
      return getErrorObject('InvalidXml', "Invalid '"+
          JSON.stringify(tags.map(t => t.tagName), null, 4).replace(/\r?\n/g, '')+
          "' found.", {line: 1, col: 1});
  }

  return true;
};

function isWhiteSpace(char){
  return char === ' ' || char === '\t' || char === '\n'  || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */
function readPI(xmlData, i) {
  const start = i;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] == '?' || xmlData[i] == ' ') {
      //tagname
      const tagname = xmlData.substr(start, i - start);
      if (i > 5 && tagname === 'xml') {
        return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
      } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
        //check if valid attribut string
        i++;
        break;
      } else {
        continue;
      }
    }
  }
  return i;
}

function readCommentAndCDATA(xmlData, i) {
  if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
    //comment
    for (i += 3; i < xmlData.length; i++) {
      if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  } else if (
    xmlData.length > i + 8 &&
    xmlData[i + 1] === 'D' &&
    xmlData[i + 2] === 'O' &&
    xmlData[i + 3] === 'C' &&
    xmlData[i + 4] === 'T' &&
    xmlData[i + 5] === 'Y' &&
    xmlData[i + 6] === 'P' &&
    xmlData[i + 7] === 'E'
  ) {
    let angleBracketsCount = 1;
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === '<') {
        angleBracketsCount++;
      } else if (xmlData[i] === '>') {
        angleBracketsCount--;
        if (angleBracketsCount === 0) {
          break;
        }
      }
    }
  } else if (
    xmlData.length > i + 9 &&
    xmlData[i + 1] === '[' &&
    xmlData[i + 2] === 'C' &&
    xmlData[i + 3] === 'D' &&
    xmlData[i + 4] === 'A' &&
    xmlData[i + 5] === 'T' &&
    xmlData[i + 6] === 'A' &&
    xmlData[i + 7] === '['
  ) {
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  }

  return i;
}

const doubleQuote = '"';
const singleQuote = "'";

/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */
function readAttributeStr(xmlData, i) {
  let attrStr = '';
  let startChar = '';
  let tagClosed = false;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
      if (startChar === '') {
        startChar = xmlData[i];
      } else if (startChar !== xmlData[i]) {
        //if vaue is enclosed with double quote then single quotes are allowed inside the value and vice versa
      } else {
        startChar = '';
      }
    } else if (xmlData[i] === '>') {
      if (startChar === '') {
        tagClosed = true;
        break;
      }
    }
    attrStr += xmlData[i];
  }
  if (startChar !== '') {
    return false;
  }

  return {
    value: attrStr,
    index: i,
    tagClosed: tagClosed
  };
}

/**
 * Select all the attributes whether valid or invalid.
 */
const validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');

//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""

function validateAttributeString(attrStr, options) {
  //console.log("start:"+attrStr+":end");

  //if(attrStr.trim().length === 0) return true; //empty string

  const matches = util.getAllMatches(attrStr, validAttrStrRegxp);
  const attrNames = {};

  for (let i = 0; i < matches.length; i++) {
    if (matches[i][1].length === 0) {
      //nospace before attribute name: a="sd"b="saf"
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' has no space in starting.", getPositionFromMatch(matches[i]))
    } else if (matches[i][3] !== undefined && matches[i][4] === undefined) {
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' is without value.", getPositionFromMatch(matches[i]));
    } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) {
      //independent attribute: ab
      return getErrorObject('InvalidAttr', "boolean attribute '"+matches[i][2]+"' is not allowed.", getPositionFromMatch(matches[i]));
    }
    /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */
    const attrName = matches[i][2];
    if (!validateAttrName(attrName)) {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is an invalid name.", getPositionFromMatch(matches[i]));
    }
    if (!attrNames.hasOwnProperty(attrName)) {
      //check for duplicate attribute.
      attrNames[attrName] = 1;
    } else {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is repeated.", getPositionFromMatch(matches[i]));
    }
  }

  return true;
}

function validateNumberAmpersand(xmlData, i) {
  let re = /\d/;
  if (xmlData[i] === 'x') {
    i++;
    re = /[\da-fA-F]/;
  }
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === ';')
      return i;
    if (!xmlData[i].match(re))
      break;
  }
  return -1;
}

function validateAmpersand(xmlData, i) {
  // https://www.w3.org/TR/xml/#dt-charref
  i++;
  if (xmlData[i] === ';')
    return -1;
  if (xmlData[i] === '#') {
    i++;
    return validateNumberAmpersand(xmlData, i);
  }
  let count = 0;
  for (; i < xmlData.length; i++, count++) {
    if (xmlData[i].match(/\w/) && count < 20)
      continue;
    if (xmlData[i] === ';')
      break;
    return -1;
  }
  return i;
}

function getErrorObject(code, message, lineNumber) {
  return {
    err: {
      code: code,
      msg: message,
      line: lineNumber.line || lineNumber,
      col: lineNumber.col,
    },
  };
}

function validateAttrName(attrName) {
  return util.isName(attrName);
}

// const startsWithXML = /^xml/i;

function validateTagName(tagname) {
  return util.isName(tagname) /* && !tagname.match(startsWithXML) */;
}

//this function returns the line number for the character at the given index
function getLineNumberForPosition(xmlData, index) {
  const lines = xmlData.substring(0, index).split(/\r?\n/);
  return {
    line: lines.length,

    // column number is last line's length + 1, because column numbering starts at 1:
    col: lines[lines.length - 1].length + 1
  };
}

//this function returns the position of the first character of match within attrStr
function getPositionFromMatch(match) {
  return match.startIndex + match[1].length;
}


/***/ }),

/***/ 77996:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

//parse Empty Node as self closing node
const buildFromOrderedJs = __webpack_require__(85947);

const defaultOptions = {
  attributeNamePrefix: '@_',
  attributesGroupName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  cdataPropName: false,
  format: false,
  indentBy: '  ',
  suppressEmptyNode: false,
  suppressUnpairedNode: true,
  suppressBooleanAttributes: true,
  tagValueProcessor: function(key, a) {
    return a;
  },
  attributeValueProcessor: function(attrName, a) {
    return a;
  },
  preserveOrder: false,
  commentPropName: false,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },//it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("\'", "g"), val: "&apos;" },
    { regex: new RegExp("\"", "g"), val: "&quot;" }
  ],
  processEntities: true,
  stopNodes: [],
  transformTagName: false,
};

function Builder(options) {
  this.options = Object.assign({}, defaultOptions, options);
  if (this.options.ignoreAttributes || this.options.attributesGroupName) {
    this.isAttribute = function(/*a*/) {
      return false;
    };
  } else {
    this.attrPrefixLen = this.options.attributeNamePrefix.length;
    this.isAttribute = isAttribute;
  }

  this.processTextOrObjNode = processTextOrObjNode

  if (this.options.format) {
    this.indentate = indentate;
    this.tagEndChar = '>\n';
    this.newLine = '\n';
  } else {
    this.indentate = function() {
      return '';
    };
    this.tagEndChar = '>';
    this.newLine = '';
  }

  if (this.options.suppressEmptyNode) {
    this.buildTextNode = buildEmptyTextNode;
    this.buildObjNode = buildEmptyObjNode;
  } else {
    this.buildTextNode = buildTextValNode;
    this.buildObjNode = buildObjectNode;
  }

  this.buildTextValNode = buildTextValNode;
  this.buildObjectNode = buildObjectNode;

  this.replaceEntitiesValue = replaceEntitiesValue;
  this.buildAttrPairStr = buildAttrPairStr;
}

Builder.prototype.build = function(jObj) {
  if(this.options.preserveOrder){
    return buildFromOrderedJs(jObj, this.options);
  }else {
    if(Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1){
      jObj = {
        [this.options.arrayNodeName] : jObj
      }
    }
    return this.j2x(jObj, 0).val;
  }
};

Builder.prototype.j2x = function(jObj, level) {
  let attrStr = '';
  let val = '';
  for (let key in jObj) {
    if (typeof jObj[key] === 'undefined') {
      // supress undefined node
    } else if (jObj[key] === null) {
      if(key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
      else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
      // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
    } else if (jObj[key] instanceof Date) {
      val += this.buildTextNode(jObj[key], key, '', level);
    } else if (typeof jObj[key] !== 'object') {
      //premitive type
      const attr = this.isAttribute(key);
      if (attr) {
        attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
      }else {
        //tag value
        if (key === this.options.textNodeName) {
          let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
          val += this.replaceEntitiesValue(newval);
        } else {
          val += this.buildTextNode(jObj[key], key, '', level);
        }
      }
    } else if (Array.isArray(jObj[key])) {
      //repeated nodes
      const arrLen = jObj[key].length;
      for (let j = 0; j < arrLen; j++) {
        const item = jObj[key][j];
        if (typeof item === 'undefined') {
          // supress undefined node
        } else if (item === null) {
          if(key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
          else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
          // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (typeof item === 'object') {
          val += this.processTextOrObjNode(item, key, level)
        } else {
          val += this.buildTextNode(item, key, '', level);
        }
      }
    } else {
      //nested node
      if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
        const Ks = Object.keys(jObj[key]);
        const L = Ks.length;
        for (let j = 0; j < L; j++) {
          attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        }
      } else {
        val += this.processTextOrObjNode(jObj[key], key, level)
      }
    }
  }
  return {attrStr: attrStr, val: val};
};

function buildAttrPairStr(attrName, val){
  val = this.options.attributeValueProcessor(attrName, '' + val);
  val = this.replaceEntitiesValue(val);
  if (this.options.suppressBooleanAttributes && val === "true") {
    return ' ' + attrName;
  } else return ' ' + attrName + '="' + val + '"';
}

function processTextOrObjNode (object, key, level) {
  const result = this.j2x(object, level + 1);
  if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) {
    return this.buildTextNode(object[this.options.textNodeName], key, result.attrStr, level);
  } else {
    return this.buildObjNode(result.val, key, result.attrStr, level);
  }
}

function buildObjectNode(val, key, attrStr, level) {
  let tagEndExp = '</' + key + this.tagEndChar;
  let piClosingChar = "";
  
  if(key[0] === "?") {
    piClosingChar = "?";
    tagEndExp = "";
  }

  if (attrStr && val.indexOf('<') === -1) {
    return ( this.indentate(level) + '<' +  key + attrStr + piClosingChar + '>' + val + tagEndExp );
  } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
    return this.indentate(level) + `<!--${val}-->` + this.newLine;
  }else {
    return (
      this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar +
      val +
      this.indentate(level) + tagEndExp    );
  }
}

function buildEmptyObjNode(val, key, attrStr, level) {
  if (val !== '') {
    return this.buildObjectNode(val, key, attrStr, level);
  } else {
    if(key[0] === "?") return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar;
    else return  this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
  }
}

function buildTextValNode(val, key, attrStr, level) {
  if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
    return this.indentate(level) + `<![CDATA[${val}]]>` +  this.newLine;
  }else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
    return this.indentate(level) + `<!--${val}-->` +  this.newLine;
  }else{
    let textValue = this.options.tagValueProcessor(key, val);
    textValue = this.replaceEntitiesValue(textValue);
  
    if( textValue === '' && this.options.unpairedTags.indexOf(key) !== -1){ //unpaired
      if(this.options.suppressUnpairedNode){
        return this.indentate(level) + '<' + key + this.tagEndChar;
      }else{
        return this.indentate(level) + '<' + key + "/" + this.tagEndChar;
      }
    } else{
      return (
        this.indentate(level) + '<' + key + attrStr + '>' +
         textValue +
        '</' + key + this.tagEndChar  );
    }

  }
}

function replaceEntitiesValue(textValue){
  if(textValue && textValue.length > 0 && this.options.processEntities){
    for (let i=0; i<this.options.entities.length; i++) {
      const entity = this.options.entities[i];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }
  return textValue;
}

function buildEmptyTextNode(val, key, attrStr, level) {
  if( val === '' && this.options.unpairedTags.indexOf(key) !== -1){ //unpaired
    if(this.options.suppressUnpairedNode){
      return this.indentate(level) + '<' + key + this.tagEndChar;
    }else{
      return this.indentate(level) + '<' + key + "/" + this.tagEndChar;
    }
  }else if (val !== '') { //empty
    return this.buildTextValNode(val, key, attrStr, level);
  } else {
    if(key[0] === "?") return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar; //PI tag
    else return  this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar; //normal
  }
}

function indentate(level) {
  return this.options.indentBy.repeat(level);
}

function isAttribute(name /*, options*/) {
  if (name.startsWith(this.options.attributeNamePrefix)) {
    return name.substr(this.attrPrefixLen);
  } else {
    return false;
  }
}

module.exports = Builder;


/***/ }),

/***/ 85947:
/***/ (function(module) {

const EOL = "\n";

/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */
function toXml(jArray, options){
    return arrToStr( jArray, options, "", 0);
}

function arrToStr(arr, options, jPath, level){
    let xmlStr = "";

    let indentation = "";
    if(options.format && options.indentBy.length > 0){//TODO: this logic can be avoided for each call
        indentation = EOL + "" + options.indentBy.repeat(level);
    }

    for (let i = 0; i < arr.length; i++) {
        const tagObj = arr[i];
        const tagName = propName(tagObj);
        let newJPath = "";
        if(jPath.length === 0) newJPath = tagName
        else newJPath = `${jPath}.${tagName}`;

        if(tagName === options.textNodeName){
            let tagText = tagObj[tagName];
            if(!isStopNode(newJPath, options)){
                tagText = options.tagValueProcessor( tagName, tagText);
                tagText = replaceEntitiesValue(tagText, options);
            }
            xmlStr += indentation + tagText;
            continue;
        }else if( tagName === options.cdataPropName){
            xmlStr += indentation + `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            continue;
        }else if( tagName === options.commentPropName){
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            continue;
        }else if( tagName[0] === "?"){
            const attStr = attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            continue;
        }
        const attStr = attr_to_str(tagObj[":@"], options);
        let tagStart =  indentation + `<${tagName}${attStr}`;
        let tagValue = arrToStr(tagObj[tagName], options, newJPath, level + 1);
        if(options.unpairedTags.indexOf(tagName) !== -1){
            if(options.suppressUnpairedNode)  xmlStr += tagStart + ">"; 
            else xmlStr += tagStart + "/>"; 
        }else if( (!tagValue || tagValue.length === 0) && options.suppressEmptyNode){ 
            xmlStr += tagStart + "/>"; 
        }else{ 
            //TODO: node with only text value should not parse the text value in next line
            xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>` ;
        }
    }
    
    return xmlStr;
}

function propName(obj){
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if(key !== ":@") return key;
    }
  }

function attr_to_str(attrMap, options){
    let attrStr = "";
    if(attrMap && !options.ignoreAttributes){
        for (let attr in attrMap){
            let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
            attrVal = replaceEntitiesValue(attrVal, options);
            if(attrVal === true && options.suppressBooleanAttributes){
                attrStr+= ` ${attr.substr(options.attributeNamePrefix.length)}`;
            }else{
                attrStr+= ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
            }
        }
    }
    return attrStr;
}

function isStopNode(jPath, options){
    jPath = jPath.substr(0,jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if(options.stopNodes[index] === jPath || options.stopNodes[index] === "*."+tagName) return true;
    }
    return false;
}

function replaceEntitiesValue(textValue, options){
    if(textValue && textValue.length > 0 && options.processEntities){
      for (let i=0; i< options.entities.length; i++) {
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
      }
    }
    return textValue;
  }
module.exports = toXml;

/***/ }),

/***/ 59989:
/***/ (function(module) {

//TODO: handle comments
function readDocType(xmlData, i){
    
    const entities = {};
    if( xmlData[i + 3] === 'O' &&
         xmlData[i + 4] === 'C' &&
         xmlData[i + 5] === 'T' &&
         xmlData[i + 6] === 'Y' &&
         xmlData[i + 7] === 'P' &&
         xmlData[i + 8] === 'E')
    {    
        i = i+9;
        let angleBracketsCount = 1;
        let hasBody = false, entity = false, comment = false;
        let exp = "";
        for(;i<xmlData.length;i++){
            if (xmlData[i] === '<') {
                if( hasBody && 
                     xmlData[i+1] === '!' &&
                     xmlData[i+2] === 'E' &&
                     xmlData[i+3] === 'N' &&
                     xmlData[i+4] === 'T' &&
                     xmlData[i+5] === 'I' &&
                     xmlData[i+6] === 'T' &&
                     xmlData[i+7] === 'Y'
                ){
                    i += 7;
                    entity = true;
                }else if( hasBody && 
                    xmlData[i+1] === '!' &&
                     xmlData[i+2] === 'E' &&
                     xmlData[i+3] === 'L' &&
                     xmlData[i+4] === 'E' &&
                     xmlData[i+5] === 'M' &&
                     xmlData[i+6] === 'E' &&
                     xmlData[i+7] === 'N' &&
                     xmlData[i+8] === 'T'
                ){
                    //Not supported
                    i += 8;
                }else if( hasBody && 
                    xmlData[i+1] === '!' &&
                    xmlData[i+2] === 'A' &&
                    xmlData[i+3] === 'T' &&
                    xmlData[i+4] === 'T' &&
                    xmlData[i+5] === 'L' &&
                    xmlData[i+6] === 'I' &&
                    xmlData[i+7] === 'S' &&
                    xmlData[i+8] === 'T'
                ){
                    //Not supported
                    i += 8;
                }else if( hasBody && 
                    xmlData[i+1] === '!' &&
                    xmlData[i+2] === 'N' &&
                    xmlData[i+3] === 'O' &&
                    xmlData[i+4] === 'T' &&
                    xmlData[i+5] === 'A' &&
                    xmlData[i+6] === 'T' &&
                    xmlData[i+7] === 'I' &&
                    xmlData[i+8] === 'O' &&
                    xmlData[i+9] === 'N'
                ){
                    //Not supported
                    i += 9;
                }else if( //comment
                    xmlData[i+1] === '!' &&
                    xmlData[i+2] === '-' &&
                    xmlData[i+3] === '-'
                ){
                    comment = true;
                }else{
                    throw new Error("Invalid DOCTYPE");
                }
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if(comment){
                    if( xmlData[i - 1] === "-" && xmlData[i - 2] === "-"){
                        comment = false;
                    }else{
                        throw new Error(`Invalid XML comment in DOCTYPE`);
                    }
                }else if(entity){
                    parseEntityExp(exp, entities);
                    entity = false;
                }
                angleBracketsCount--;
                if (angleBracketsCount === 0) {
                  break;
                }
            }else if( xmlData[i] === '['){
                hasBody = true;
            }else{
                exp += xmlData[i];
            }
        }
        if(angleBracketsCount !== 0){
            throw new Error(`Unclosed DOCTYPE`);
        }
    }else{
        throw new Error(`Invalid Tag instead of DOCTYPE`);
    }
    return {entities, i};
}

const entityRegex = RegExp("^\\s([a-zA-z0-0]+)[ \t](['\"])([^&]+)\\2");
function parseEntityExp(exp, entities){
    const match = entityRegex.exec(exp);
    if(match){
        entities[ match[1] ] = {
            regx : RegExp( `&${match[1]};`,"g"),
            val: match[3]
        };
    }
}
module.exports = readDocType;

/***/ }),

/***/ 45293:
/***/ (function(__unused_webpack_module, exports) {


const defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false, // remove NS from tag name or attribute name if true
    allowBooleanAttributes: false, //a tag can have attributes without any value
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true, //Trim string values of tag and attributes
    cdataPropName: false,
    numberParseOptions: {
      hex: true,
      leadingZeros: true
    },
    tagValueProcessor: function(tagName, val) {
      return val;
    },
    attributeValueProcessor: function(attrName, val) {
      return val;
    },
    stopNodes: [], //nested tags will not be parsed even for errors
    alwaysCreateTextNode: false,
    isArray: () => false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
};
   
const buildOptions = function(options) {
    return Object.assign({}, defaultOptions, options);
};

exports.buildOptions = buildOptions;
exports.defaultOptions = defaultOptions;

/***/ }),

/***/ 41685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

///@ts-check

const util = __webpack_require__(8209);
const xmlNode = __webpack_require__(2007);
const readDocType = __webpack_require__(59989);
const toNumber = __webpack_require__(51654);

const regx =
  '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
  .replace(/NAME/g, util.nameRegexp);

//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

class OrderedObjParser{
  constructor(options){
    this.options = options;
    this.currentNode = null;
    this.tagsNodeStack = [];
    this.docTypeEntities = {};
    this.lastEntities = {
      "amp" : { regex: /&(amp|#38|#x26);/g, val : "&"},
      "apos" : { regex: /&(apos|#39|#x27);/g, val : "'"},
      "gt" : { regex: /&(gt|#62|#x3E);/g, val : ">"},
      "lt" : { regex: /&(lt|#60|#x3C);/g, val : "<"},
      "quot" : { regex: /&(quot|#34|#x22);/g, val : "\""},
    };
    this.htmlEntities = {
      "space": { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      "cent" : { regex: /&(cent|#162);/g, val: "¢" },
      "pound" : { regex: /&(pound|#163);/g, val: "£" },
      "yen" : { regex: /&(yen|#165);/g, val: "¥" },
      "euro" : { regex: /&(euro|#8364);/g, val: "€" },
      "copyright" : { regex: /&(copy|#169);/g, val: "©" },
      "reg" : { regex: /&(reg|#174);/g, val: "®" },
      "inr" : { regex: /&(inr|#8377);/g, val: "₹" },
    };
    this.addExternalEntities = addExternalEntities;
    this.parseXml = parseXml;
    this.parseTextData = parseTextData;
    this.resolveNameSpace = resolveNameSpace;
    this.buildAttributesMap = buildAttributesMap;
    this.isItStopNode = isItStopNode;
    this.replaceEntitiesValue = replaceEntitiesValue;
    this.readStopNodeData = readStopNodeData;
    this.saveTextToParentTag = saveTextToParentTag;
  }

}

function addExternalEntities(externalEntities){
  const entKeys = Object.keys(externalEntities);
  for (let i = 0; i < entKeys.length; i++) {
    const ent = entKeys[i];
    this.lastEntities[ent] = {
       regex: new RegExp("&"+ent+";","g"),
       val : externalEntities[ent]
    }
  }
}

/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */
function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
  if (val !== undefined) {
    if (this.options.trimValues && !dontTrim) {
      val = val.trim();
    }
    if(val.length > 0){
      if(!escapeEntities) val = this.replaceEntitiesValue(val);
      
      const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
      if(newval === null || newval === undefined){
        //don't parse
        return val;
      }else if(typeof newval !== typeof val || newval !== val){
        //overwrite
        return newval;
      }else if(this.options.trimValues){
        return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
      }else{
        const trimmedVal = val.trim();
        if(trimmedVal === val){
          return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
        }else{
          return val;
        }
      }
    }
  }
}

function resolveNameSpace(tagname) {
  if (this.options.removeNSPrefix) {
    const tags = tagname.split(':');
    const prefix = tagname.charAt(0) === '/' ? '/' : '';
    if (tags[0] === 'xmlns') {
      return '';
    }
    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }
  return tagname;
}

//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');

function buildAttributesMap(attrStr, jPath) {
  if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
    // attrStr = attrStr.replace(/\r?\n/g, ' ');
    //attrStr = attrStr || attrStr.trim();

    const matches = util.getAllMatches(attrStr, attrsRegx);
    const len = matches.length; //don't make it inline
    const attrs = {};
    for (let i = 0; i < len; i++) {
      const attrName = this.resolveNameSpace(matches[i][1]);
      let oldVal = matches[i][4];
      const aName = this.options.attributeNamePrefix + attrName;
      if (attrName.length) {
        if (oldVal !== undefined) {
          if (this.options.trimValues) {
            oldVal = oldVal.trim();
          }
          oldVal = this.replaceEntitiesValue(oldVal);
          const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
          if(newVal === null || newVal === undefined){
            //don't parse
            attrs[aName] = oldVal;
          }else if(typeof newVal !== typeof oldVal || newVal !== oldVal){
            //overwrite
            attrs[aName] = newVal;
          }else{
            //parse
            attrs[aName] = parseValue(
              oldVal,
              this.options.parseAttributeValue,
              this.options.numberParseOptions
            );
          }
        } else if (this.options.allowBooleanAttributes) {
          attrs[aName] = true;
        }
      }
    }
    if (!Object.keys(attrs).length) {
      return;
    }
    if (this.options.attributesGroupName) {
      const attrCollection = {};
      attrCollection[this.options.attributesGroupName] = attrs;
      return attrCollection;
    }
    return attrs;
  }
}

const parseXml = function(xmlData) {
  xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
  const xmlObj = new xmlNode('!xml');
  let currentNode = xmlObj;
  let textData = "";
  let jPath = "";
  for(let i=0; i< xmlData.length; i++){//for each char in XML data
    const ch = xmlData[i];
    if(ch === '<'){
      // const nextIndex = i+1;
      // const _2ndChar = xmlData[nextIndex];
      if( xmlData[i+1] === '/') {//Closing Tag
        const closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.")
        let tagName = xmlData.substring(i+2,closeIndex).trim();

        if(this.options.removeNSPrefix){
          const colonIndex = tagName.indexOf(":");
          if(colonIndex !== -1){
            tagName = tagName.substr(colonIndex+1);
          }
        }

        if(this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }

        if(currentNode){
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
        }

        jPath = jPath.substr(0, jPath.lastIndexOf("."));
        
        currentNode = this.tagsNodeStack.pop();//avoid recurssion, set the parent tag scope
        textData = "";
        i = closeIndex;
      } else if( xmlData[i+1] === '?') {

        let tagData = readTagExp(xmlData,i, false, "?>");
        if(!tagData) throw new Error("Pi Tag is not closed.");

        textData = this.saveTextToParentTag(textData, currentNode, jPath);
        if( (this.options.ignoreDeclaration && tagData.tagName === "?xml") || this.options.ignorePiTags){

        }else{
  
          const childNode = new xmlNode(tagData.tagName);
          childNode.add(this.options.textNodeName, "");
          
          if(tagData.tagName !== tagData.tagExp && tagData.attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath);
          }
          currentNode.addChild(childNode);

        }


        i = tagData.closeIndex + 1;
      } else if(xmlData.substr(i + 1, 3) === '!--') {
        const endIndex = findClosingIndex(xmlData, "-->", i+4, "Comment is not closed.")
        if(this.options.commentPropName){
          const comment = xmlData.substring(i + 4, endIndex - 2);

          textData = this.saveTextToParentTag(textData, currentNode, jPath);

          currentNode.add(this.options.commentPropName, [ { [this.options.textNodeName] : comment } ]);
        }
        i = endIndex;
      } else if( xmlData.substr(i + 1, 2) === '!D') {
        const result = readDocType(xmlData, i);
        this.docTypeEntities = result.entities;
        i = result.i;
      }else if(xmlData.substr(i + 1, 2) === '![') {
        const closeIndex = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
        const tagExp = xmlData.substring(i + 9,closeIndex);

        textData = this.saveTextToParentTag(textData, currentNode, jPath);

        //cdata should be set even if it is 0 length string
        if(this.options.cdataPropName){
          // let val = this.parseTextData(tagExp, this.options.cdataPropName, jPath + "." + this.options.cdataPropName, true, false, true);
          // if(!val) val = "";
          currentNode.add(this.options.cdataPropName, [ { [this.options.textNodeName] : tagExp } ]);
        }else{
          let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
          if(val == undefined) val = "";
          currentNode.add(this.options.textNodeName, val);
        }
        
        i = closeIndex + 2;
      }else {//Opening tag
        let result = readTagExp(xmlData,i, this. options.removeNSPrefix);
        let tagName= result.tagName;
        let tagExp = result.tagExp;
        let attrExpPresent = result.attrExpPresent;
        let closeIndex = result.closeIndex;

        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }
        
        //save text as child node
        if (currentNode && textData) {
          if(currentNode.tagname !== '!xml'){
            //when nested tag is found
            textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
          }
        }

        if(tagName !== xmlObj.tagname){
          jPath += jPath ? "." + tagName : tagName;
        }

        //check if last tag was unpaired tag
        const lastTag = currentNode;
        if(lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1 ){
          currentNode = this.tagsNodeStack.pop();
        }

        if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) { //TODO: namespace
          let tagContent = "";
          //self-closing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            i = result.closeIndex;
          }
          //boolean tag
          else if(this.options.unpairedTags.indexOf(tagName) !== -1){
            i = result.closeIndex;
          }
          //normal tag
          else{
            //read until closing tag is found
            const result = this.readStopNodeData(xmlData, tagName, closeIndex + 1);
            if(!result) throw new Error(`Unexpected end of ${tagName}`);
            i = result.i;
            tagContent = result.tagContent;
          }

          const childNode = new xmlNode(tagName);
          if(tagName !== tagExp && attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
          }
          if(tagContent) {
            tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
          }
          
          jPath = jPath.substr(0, jPath.lastIndexOf("."));
          childNode.add(this.options.textNodeName, tagContent);
          
          currentNode.addChild(childNode);
        }else{
  //selfClosing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            if(tagName[tagName.length - 1] === "/"){ //remove trailing '/'
              tagName = tagName.substr(0, tagName.length - 1);
              tagExp = tagName;
            }else{
              tagExp = tagExp.substr(0, tagExp.length - 1);
            }
            
            if(this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }

            const childNode = new xmlNode(tagName);
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
            }
            jPath = jPath.substr(0, jPath.lastIndexOf("."));
            currentNode.addChild(childNode);
          }
    //opening tag
          else{
            const childNode = new xmlNode( tagName);
            this.tagsNodeStack.push(currentNode);
            
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
            }
            currentNode.addChild(childNode);
            currentNode = childNode;
          }
          textData = "";
          i = closeIndex;
        }
      }
    }else{
      textData += xmlData[i];
    }
  }
  return xmlObj.child;
}

const replaceEntitiesValue = function(val){
  if(this.options.processEntities){
    for(let entityName in this.docTypeEntities){
      const entity = this.docTypeEntities[entityName];
      val = val.replace( entity.regx, entity.val);
    }
    for(let entityName in this.lastEntities){
      const entity = this.lastEntities[entityName];
      val = val.replace( entity.regex, entity.val);
    }
    if(this.options.htmlEntities){
      for(let entityName in this.htmlEntities){
        const entity = this.htmlEntities[entityName];
        val = val.replace( entity.regex, entity.val);
      }
    }
  }
  return val;
}
function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
  if (textData) { //store previously collected data as textNode
    if(isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0
    
    textData = this.parseTextData(textData,
      currentNode.tagname,
      jPath,
      false,
      currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false,
      isLeafNode);

    if (textData !== undefined && textData !== "")
      currentNode.add(this.options.textNodeName, textData);
    textData = "";
  }
  return textData;
}

//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */
function isItStopNode(stopNodes, jPath, currentTagName){
  const allNodesExp = "*." + currentTagName;
  for (const stopNodePath in stopNodes) {
    const stopNodeExp = stopNodes[stopNodePath];
    if( allNodesExp === stopNodeExp || jPath === stopNodeExp  ) return true;
  }
  return false;
}

/**
 * Returns the tag Expression and where it is ending handling single-dobule quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */
function tagExpWithClosingIndex(xmlData, i, closingChar = ">"){
  let attrBoundary;
  let tagExp = "";
  for (let index = i; index < xmlData.length; index++) {
    let ch = xmlData[index];
    if (attrBoundary) {
        if (ch === attrBoundary) attrBoundary = "";//reset
    } else if (ch === '"' || ch === "'") {
        attrBoundary = ch;
    } else if (ch === closingChar[0]) {
      if(closingChar[1]){
        if(xmlData[index + 1] === closingChar[1]){
          return {
            data: tagExp,
            index: index
          }
        }
      }else{
        return {
          data: tagExp,
          index: index
        }
      }
    } else if (ch === '\t') {
      ch = " "
    }
    tagExp += ch;
  }
}

function findClosingIndex(xmlData, str, i, errMsg){
  const closingIndex = xmlData.indexOf(str, i);
  if(closingIndex === -1){
    throw new Error(errMsg)
  }else{
    return closingIndex + str.length - 1;
  }
}

function readTagExp(xmlData,i, removeNSPrefix, closingChar = ">"){
  const result = tagExpWithClosingIndex(xmlData, i+1, closingChar);
  if(!result) return;
  let tagExp = result.data;
  const closeIndex = result.index;
  const separatorIndex = tagExp.search(/\s/);
  let tagName = tagExp;
  let attrExpPresent = true;
  if(separatorIndex !== -1){//separate tag name and attributes expression
    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
    tagExp = tagExp.substr(separatorIndex + 1);
  }

  if(removeNSPrefix){
    const colonIndex = tagName.indexOf(":");
    if(colonIndex !== -1){
      tagName = tagName.substr(colonIndex+1);
      attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
    }
  }

  return {
    tagName: tagName,
    tagExp: tagExp,
    closeIndex: closeIndex,
    attrExpPresent: attrExpPresent,
  }
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */
function readStopNodeData(xmlData, tagName, i){
  const startIndex = i;
  // Starting at 1 since we already have an open tag
  let openTagCount = 1;

  for (; i < xmlData.length; i++) {
    if( xmlData[i] === "<"){ 
      if (xmlData[i+1] === "/") {//close tag
          const closeIndex = findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
          let closeTagName = xmlData.substring(i+2,closeIndex).trim();
          if(closeTagName === tagName){
            openTagCount--;
            if (openTagCount === 0) {
              return {
                tagContent: xmlData.substring(startIndex, i),
                i : closeIndex
              }
            }
          }
          i=closeIndex;
        } else if(xmlData[i+1] === '?') { 
          const closeIndex = findClosingIndex(xmlData, "?>", i+1, "StopNode is not closed.")
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 3) === '!--') { 
          const closeIndex = findClosingIndex(xmlData, "-->", i+3, "StopNode is not closed.")
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 2) === '![') { 
          const closeIndex = findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
          i=closeIndex;
        } else {
          const tagData = readTagExp(xmlData, i, '>')

          if (tagData) {
            const openTagName = tagData && tagData.tagName;
            if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length-1] !== "/") {
              openTagCount++;
            }
            i=tagData.closeIndex;
          }
        }
      }
  }//end for loop
}

function parseValue(val, shouldParse, options) {
  if (shouldParse && typeof val === 'string') {
    //console.log(options)
    const newval = val.trim();
    if(newval === 'true' ) return true;
    else if(newval === 'false' ) return false;
    else return toNumber(val, options);
  } else {
    if (util.isExist(val)) {
      return val;
    } else {
      return '';
    }
  }
}


module.exports = OrderedObjParser;


/***/ }),

/***/ 87797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { buildOptions} = __webpack_require__(45293);
const OrderedObjParser = __webpack_require__(41685);
const { prettify} = __webpack_require__(14362);
const validator = __webpack_require__(23303);

class XMLParser{
    
    constructor(options){
        this.externalEntities = {};
        this.options = buildOptions(options);
        
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */
    parse(xmlData,validationOption){
        if(typeof xmlData === "string"){
        }else if( xmlData.toString){
            xmlData = xmlData.toString();
        }else{
            throw new Error("XML data is accepted in String or Bytes[] form.")
        }
        if( validationOption){
            if(validationOption === true) validationOption = {}; //validate with default options
            
            const result = validator.validate(xmlData, validationOption);
            if (result !== true) {
              throw Error( `${result.err.msg}:${result.err.line}:${result.err.col}` )
            }
          }
        const orderedObjParser = new OrderedObjParser(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if(this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return prettify(orderedResult, this.options);
    }

    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */
    addEntity(key, value){
        if(value.indexOf("&") !== -1){
            throw new Error("Entity value can't have '&'")
        }else if(key.indexOf("&") !== -1 || key.indexOf(";") !== -1){
            throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'")
        }else{
            this.externalEntities[key] = value;
        }
    }
}

module.exports = XMLParser;

/***/ }),

/***/ 14362:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */
function prettify(node, options){
  return compress( node, options);
}

/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */
function compress(arr, options, jPath){
  let text;
  const compressedObj = {};
  for (let i = 0; i < arr.length; i++) {
    const tagObj = arr[i];
    const property = propName(tagObj);
    let newJpath = "";
    if(jPath === undefined) newJpath = property;
    else newJpath = jPath + "." + property;

    if(property === options.textNodeName){
      if(text === undefined) text = tagObj[property];
      else text += "" + tagObj[property];
    }else if(property === undefined){
      continue;
    }else if(tagObj[property]){
      
      let val = compress(tagObj[property], options, newJpath);
      const isLeaf = isLeafTag(val, options);

      if(tagObj[":@"]){
        assignAttributes( val, tagObj[":@"], newJpath, options);
      }else if(Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode){
        val = val[options.textNodeName];
      }else if(Object.keys(val).length === 0){
        if(options.alwaysCreateTextNode) val[options.textNodeName] = "";
        else val = "";
      }

      if(compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
        if(!Array.isArray(compressedObj[property])) {
            compressedObj[property] = [ compressedObj[property] ];
        }
        compressedObj[property].push(val);
      }else{
        //TODO: if a node is not an array, then check if it should be an array
        //also determine if it is a leaf node
        if (options.isArray(property, newJpath, isLeaf )) {
          compressedObj[property] = [val];
        }else{
          compressedObj[property] = val;
        }
      }
    }
    
  }
  // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
  if(typeof text === "string"){
    if(text.length > 0) compressedObj[options.textNodeName] = text;
  }else if(text !== undefined) compressedObj[options.textNodeName] = text;
  return compressedObj;
}

function propName(obj){
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if(key !== ":@") return key;
  }
}

function assignAttributes(obj, attrMap, jpath, options){
  if (attrMap) {
    const keys = Object.keys(attrMap);
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      const atrrName = keys[i];
      if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
        obj[atrrName] = [ attrMap[atrrName] ];
      } else {
        obj[atrrName] = attrMap[atrrName];
      }
    }
  }
}

function isLeafTag(obj, options){
  const propCount = Object.keys(obj).length;
  if( propCount === 0 || (propCount === 1 && obj[options.textNodeName]) ) return true;
  return false;
}
exports.prettify = prettify;


/***/ }),

/***/ 2007:
/***/ (function(module) {

"use strict";


class XmlNode{
  constructor(tagname) {
    this.tagname = tagname;
    this.child = []; //nested tags, text, cdata, comments in order
    this[":@"] = {}; //attributes map
  }
  add(key,val){
    // this.child.push( {name : key, val: val, isCdata: isCdata });
    this.child.push( {[key]: val });
  }
  addChild(node) {
    if(node[":@"] && Object.keys(node[":@"]).length > 0){
      this.child.push( { [node.tagname]: node.child, [":@"]: node[":@"] });
    }else{
      this.child.push( { [node.tagname]: node.child });
    }
  };
};


module.exports = XmlNode;

/***/ }),

/***/ 45512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; },
  "Ps": function() { return /* binding */ gql; }
});

// UNUSED EXPORTS: disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, resetCaches

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/error/GraphQLError.mjs




function toNormalizedArgs(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorArgs` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedArgs(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, undefined, source, [
    position,
  ]);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(53406);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
let DirectiveLocation;
/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(67719);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(55985);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(63089);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
let tokenKind_TokenKind;
/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(34402);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options) {
    const sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    var _this$_options;

    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (
      ((_this$_options = this._options) === null || _this$_options === void 0
        ? void 0
        : _this$_options.allowLegacyFragmentVariables) === true
    ) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;

    this._lexer.advance();

    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    var _this$_options2;

    if (
      ((_this$_options2 = this._options) === null || _this$_options2 === void 0
        ? void 0
        : _this$_options2.noLocation) !== true
    ) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.3.0/node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(56237);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 30551:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 20289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34254);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97304);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45347);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5208);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),

/***/ 19059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; },
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34254);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 5208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "FK": function() { return /* binding */ formatToParts; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97304);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19059);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 49420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setupReact;

var _reactDom = __webpack_require__(15286);

var getInstanceFromNode = void 0;
var secret = _reactDom.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
if (secret && secret.Events && secret.Events[0]) {
  getInstanceFromNode = secret.Events[0];
} else {
  console.warn('logrocket-react does not work with this version of React');
}

function setupReact() {
  var listener = function listener(event) {
    try {
      var fiberNode = getInstanceFromNode(event.target);
      var names = [];
      var currentElement = fiberNode;
      while (currentElement) {
        var name = typeof currentElement.elementType === 'function' && currentElement.elementType.displayName;
        if (name) {
          names.push(name);
        }
        currentElement = currentElement.return;
      }
      event.__lrName = names;
    } catch (err) {
      console.error('logrocket-react caught an error while hooking into React. Please make sure you are using the correct version of logrocket-react for your version of react-dom.');
    }
  };

  document.body.addEventListener('click', listener, { capture: true, passive: true });
}
module.exports = exports['default'];

/***/ }),

/***/ 65819:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else { var i, a; }
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_1413__) {

var arrayLikeToArray = __nested_webpack_require_1413__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/***/ (function(module) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \**********************************************************************/
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/***/ (function(module) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_6170__) {

var objectWithoutPropertiesLoose = __nested_webpack_require_6170__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_8204__) {

var arrayWithoutHoles = __nested_webpack_require_8204__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

var iterableToArray = __nested_webpack_require_8204__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");

var unsupportedIterableToArray = __nested_webpack_require_8204__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

var nonIterableSpread = __nested_webpack_require_8204__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_10452__) {

var arrayLikeToArray = __nested_webpack_require_10452__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./packages/@logrocket/console/src/index.js":
/*!**************************************************!*\
  !*** ./packages/@logrocket/console/src/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_11444__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_11444__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _registerConsole = _interopRequireDefault(__nested_webpack_require_11444__(/*! ./registerConsole */ "./packages/@logrocket/console/src/registerConsole.js"));
var _default = _registerConsole.default;
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/console/src/registerConsole.js":
/*!************************************************************!*\
  !*** ./packages/@logrocket/console/src/registerConsole.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_12290__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_12290__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerConsole;
var _typeof2 = _interopRequireDefault(__nested_webpack_require_12290__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _enhanceFunc = _interopRequireDefault(__nested_webpack_require_12290__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.js"));
var _exceptions = __nested_webpack_require_12290__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
// eslint-disable-line no-restricted-imports

function registerConsole(logger) {
  var unsubFunctions = [];
  var methods = ['log', 'warn', 'info', 'error', 'debug'];
  methods.forEach(function (method) {
    unsubFunctions.push((0, _enhanceFunc.default)(console, method, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      logger.addEvent('lr.core.LogEvent', function () {
        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var isEnabled = consoleOptions.isEnabled;
        if ((0, _typeof2.default)(isEnabled) === 'object' && isEnabled[method] === false || isEnabled === false) {
          return null;
        }
        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
          _exceptions.Capture.captureMessage(logger, args[0], args, {}, true);
        }
        return {
          logLevel: method.toUpperCase(),
          args: args
        };
      });
    }));
  });
  return function () {
    unsubFunctions.forEach(function (unsubFunction) {
      return unsubFunction();
    });
  };
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/Capture.js":
/*!*******************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/Capture.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_14515__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_14515__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.captureMessage = captureMessage;
exports.captureException = captureException;
var _typeof2 = _interopRequireDefault(__nested_webpack_require_14515__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _TraceKit = _interopRequireDefault(__nested_webpack_require_14515__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
var _stackTraceFromError = _interopRequireDefault(__nested_webpack_require_14515__(/*! ./stackTraceFromError */ "./packages/@logrocket/exceptions/src/stackTraceFromError.js"));
/* eslint-disable no-param-reassign */
// eslint-disable-line no-restricted-imports

function isScalar(value) {
  return /boolean|number|string/.test((0, _typeof2.default)(value));
}
function scrub(data, options) {
  if (options) {
    var optionalScalars = [
    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
    // and 'debug'. Defaults to 'error'.
    'level', 'logger'];
    for (var _i = 0, _optionalScalars = optionalScalars; _i < _optionalScalars.length; _i++) {
      var field = _optionalScalars[_i];
      var value = options[field];
      if (isScalar(value)) {
        data[field] = value.toString();
      }
    }
    var optionalMaps = ['tags', 'extra'];
    for (var _i2 = 0, _optionalMaps = optionalMaps; _i2 < _optionalMaps.length; _i2++) {
      var _field = _optionalMaps[_i2];
      var dirty = options[_field] || {};
      var scrubbed = {};
      for (var _i3 = 0, _Object$keys = Object.keys(dirty); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        var _value = dirty[key];
        if (isScalar(_value)) {
          scrubbed[key.toString()] = _value.toString();
        }
      }
      data[_field] = scrubbed;
    }
  }
}
function captureMessage(logger, message, messageArgs) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isConsole = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var data = {
    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
    message: message,
    messageArgs: messageArgs,
    browserHref: window.location ? window.location.href : ''
  };
  scrub(data, options);
  logger.addEvent('lr.core.Exception', function () {
    return data;
  });
}
function captureException(logger, exception) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);
  var data = {
    exceptionType: 'WINDOW',
    errorType: trace.name,
    message: trace.message,
    browserHref: window.location ? window.location.href : ''
  };
  scrub(data, options);
  var addEventOptions = {
    _stackTrace: (0, _stackTraceFromError.default)(trace)
  };
  logger.addEvent('lr.core.Exception', function () {
    return data;
  }, addEventOptions);
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/index.js":
/*!*****************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/index.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_18033__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_18033__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = __nested_webpack_require_18033__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "registerExceptions", ({
  enumerable: true,
  get: function get() {
    return _registerExceptions.default;
  }
}));
exports.Capture = void 0;
var _registerExceptions = _interopRequireDefault(__nested_webpack_require_18033__(/*! ./registerExceptions */ "./packages/@logrocket/exceptions/src/registerExceptions.js"));
var Capture = _interopRequireWildcard(__nested_webpack_require_18033__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
exports.Capture = Capture;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/raven/raven.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/raven/raven.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_20382__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_20382__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(__nested_webpack_require_20382__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(__nested_webpack_require_20382__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
var _TraceKit = _interopRequireDefault(__nested_webpack_require_20382__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
/* eslint-disable */

/*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

var objectPrototype = Object.prototype;
function isUndefined(what) {
  return what === void 0;
}
function isFunction(what) {
  return typeof what === 'function';
}
function each(obj, callback) {
  var i, j;
  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return objectPrototype.hasOwnProperty.call(object, key);
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);
  if (track) {
    track.push([obj, name, orig]);
  }
}
var _window = typeof window !== 'undefined' ? window : typeof __nested_webpack_require_20382__.g !== 'undefined' ? __nested_webpack_require_20382__.g : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var Handler = /*#__PURE__*/function () {
  function Handler(_ref) {
    var captureException = _ref.captureException;
    (0, _classCallCheck2.default)(this, Handler);
    this._errorHandler = this._errorHandler.bind(this);
    this._ignoreOnError = 0;
    this._wrappedBuiltIns = [];
    this.captureException = captureException;
    _TraceKit.default.report.subscribe(this._errorHandler);
    this._instrumentTryCatch();
  }
  (0, _createClass2.default)(Handler, [{
    key: "uninstall",
    value: function uninstall() {
      _TraceKit.default.report.unsubscribe(this._errorHandler);

      // restore any wrapped builtins
      var builtin;
      while (this._wrappedBuiltIns.length) {
        builtin = this._wrappedBuiltIns.shift();
        var obj = builtin[0],
          name = builtin[1],
          orig = builtin[2];
        obj[name] = orig;
      }
    }
  }, {
    key: "_errorHandler",
    value: function _errorHandler(report) {
      if (!this._ignoreOnError) {
        this.captureException(report);
      }
    }
  }, {
    key: "_ignoreNextOnError",
    value: function _ignoreNextOnError() {
      var _this = this;
      this._ignoreOnError += 1;
      setTimeout(function () {
        // onerror should trigger before setTimeout
        _this._ignoreOnError -= 1;
      });
    }

    /*
     * Wrap code within a context so Handler can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  }, {
    key: "context",
    value: function context(options, func, args) {
      if (isFunction(options)) {
        args = func || [];
        func = options;
        options = undefined;
      }
      return this.wrap(options, func).apply(this, args);
    }
  }, {
    key: "wrap",
    value:
    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    function wrap(options, func, _before) {
      var self = this;
      // 1 argument has been passed, and it's not a function
      // so just return it
      if (isUndefined(func) && !isFunction(options)) {
        return options;
      }

      // options is optional
      if (isFunction(options)) {
        func = options;
        options = undefined;
      }

      // At this point, we've passed along 2 arguments, and the second one
      // is not a function either, so we'll just return the second argument.
      if (!isFunction(func)) {
        return func;
      }

      // We don't wanna wrap it twice!
      try {
        if (func.__lr__) {
          return func;
        }

        // If this has already been wrapped in the past, return that
        if (func.__lr_wrapper__) {
          return func.__lr_wrapper__;
        }

        // If func is not extensible, return the function as-is to prevent TypeErrors
        // when trying to add new props & to assure immutable funcs aren't changed
        if (!Object.isExtensible(func)) {
          return func;
        }
      } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see lr-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return func;
      }
      function wrapped() {
        var args = [],
          i = arguments.length,
          deep = !options || options && options.deep !== false;
        if (_before && isFunction(_before)) {
          _before.apply(this, arguments);
        }

        // Recursively wrap all of a function's arguments that are
        // functions themselves.
        while (i--) {
          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
        }
        try {
          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
          // If you're seeing this frame in a stack trace, it means that LogRocket caught
          // an unhandled error thrown by your application code, reported it, then bubbled
          // it up. This is expected behavior and is not a bug with LogRocket.
          return func.apply(this, args);
        } catch (e) {
          self._ignoreNextOnError();
          self.captureException(_TraceKit.default.computeStackTrace(e), options);
          throw e;
        }
      }

      // copy over properties of the old function
      for (var property in func) {
        if (hasKey(func, property)) {
          wrapped[property] = func[property];
        }
      }
      wrapped.prototype = func.prototype;
      func.__lr_wrapper__ = wrapped;
      // Signal that this function has been wrapped already
      // for both debugging and to prevent it to being wrapped twice
      wrapped.__lr__ = true;
      wrapped.__inner__ = func;
      return wrapped;
    }
  }, {
    key: "_instrumentTryCatch",
    value:
    /**
     * Install any queued plugins
     */
    function _instrumentTryCatch() {
      var self = this;
      var wrappedBuiltIns = self._wrappedBuiltIns;
      function wrapTimeFn(orig) {
        return function (fn, t) {
          // preserve arity
          // Make a copy of the arguments to prevent deoptimization
          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; ++i) {
            args[i] = arguments[i];
          }
          var originalCallback = args[0];
          if (isFunction(originalCallback)) {
            args[0] = self.wrap(originalCallback);
          }

          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
          // also supports only two arguments and doesn't care what this is, so we
          // can just call the original function directly.
          if (orig.apply) {
            return orig.apply(this, args);
          } else {
            return orig(args[0], args[1]);
          }
        };
      }
      function wrapEventTarget(global) {
        var proto = _window[global] && _window[global].prototype;
        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
          fill(proto, 'addEventListener', function (orig) {
            return function (evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before;
              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
            };
          }, wrappedBuiltIns);
          fill(proto, 'removeEventListener', function (orig) {
            return function (evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          }, wrappedBuiltIns);
        }
      }
      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
      if (_window.requestAnimationFrame) {
        fill(_window, 'requestAnimationFrame', function (orig) {
          return function (cb) {
            return orig(self.wrap(cb));
          };
        }, wrappedBuiltIns);
      }

      // event targets borrowed from bugsnag-js:
      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      for (var i = 0; i < eventTargets.length; i++) {
        wrapEventTarget(eventTargets[i]);
      }
      var $ = _window.jQuery || _window.$;
      if ($ && $.fn && $.fn.ready) {
        fill($.fn, 'ready', function (orig) {
          return function (fn) {
            return orig.call(this, self.wrap(fn));
          };
        }, wrappedBuiltIns);
      }
    }
  }]);
  return Handler;
}();
exports["default"] = Handler;
;

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/registerExceptions.js":
/*!******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/registerExceptions.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_33669__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_33669__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = __nested_webpack_require_33669__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerCore;
var _raven = _interopRequireDefault(__nested_webpack_require_33669__(/*! ./raven/raven */ "./packages/@logrocket/exceptions/src/raven/raven.js"));
var Capture = _interopRequireWildcard(__nested_webpack_require_33669__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function registerCore(logger) {
  var raven = new _raven.default({
    captureException: function captureException(errorReport) {
      Capture.captureException(logger, null, null, errorReport);
    }
  });
  var rejectionHandler = function rejectionHandler(evt) {
    // http://2ality.com/2016/04/unhandled-rejections.html
    logger.addEvent('lr.core.Exception', function () {
      return {
        exceptionType: 'UNHANDLED_REJECTION',
        message: evt.reason || 'Unhandled Promise rejection'
      };
    });
  };
  window.addEventListener('unhandledrejection', rejectionHandler);
  return function () {
    window.removeEventListener('unhandledrejection', rejectionHandler);
    raven.uninstall();
  };
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/stackTraceFromError.js":
/*!*******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/stackTraceFromError.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = stackTraceFromError;
function stackTraceFromError(errorReport) {
  function makeNotNull(val) {
    return val === null ? undefined : val;
  }
  return errorReport.stack ? errorReport.stack.map(function (frame) {
    return {
      lineNumber: makeNotNull(frame.line),
      columnNumber: makeNotNull(frame.column),
      fileName: makeNotNull(frame.url),
      functionName: makeNotNull(frame.func)
    };
  }) : undefined;
}

/***/ }),

/***/ "./packages/@logrocket/network/src/fetchIntercept.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/network/src/fetchIntercept.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_37421__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_37421__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(__nested_webpack_require_37421__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _registerXHR = __nested_webpack_require_37421__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js");
var interceptors = [];
function makeInterceptor(fetch, fetchId) {
  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
    return [interceptor].concat(array);
  }, []);
  // if a browser supports fetch, it supports promise
  // eslint-disable-next-line compat/compat
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var promise = Promise.resolve(args);

  // Register request interceptors
  reversedInterceptors.forEach(function (_ref) {
    var request = _ref.request,
      requestError = _ref.requestError;
    if (request || requestError) {
      promise = promise.then(function (args) {
        return request.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      }, function (args) {
        return requestError.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      });
    }
  });
  promise = promise.then(function (args) {
    (0, _registerXHR.setActive)(false);
    var res;
    var err;
    try {
      res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args));
    } catch (_err) {
      err = _err;
    }
    (0, _registerXHR.setActive)(true);
    if (err) {
      throw err;
    }
    return res;
  });
  reversedInterceptors.forEach(function (_ref2) {
    var response = _ref2.response,
      responseError = _ref2.responseError;
    if (response || responseError) {
      promise = promise.then(function (res) {
        return response(fetchId, res);
      }, function (err) {
        return responseError && responseError(fetchId, err);
      });
    }
  });
  return promise;
}
function attach(env) {
  if (!env.fetch || !env.Promise) {
    // Make sure fetch is available in the given environment. If it's not, then
    // default to using XHR intercept.
    return;
  }
  var isPolyfill = env.fetch.polyfill;

  // eslint-disable-next-line no-param-reassign
  env.fetch = function (fetch) {
    var fetchId = 0;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return makeInterceptor.apply(void 0, [fetch, fetchId++].concat(args));
    };
  }(env.fetch);

  // Forward the polyfill properly from fetch (set by github/whatwg-fetch).
  if (isPolyfill) {
    // eslint-disable-next-line no-param-reassign
    env.fetch.polyfill = isPolyfill;
  }
}

// TODO: React Native
//   attach(global);

var didAttach = false;
var _default = {
  register: function register(interceptor) {
    if (!didAttach) {
      didAttach = true;
      attach(window);
    }
    interceptors.push(interceptor);
    return function () {
      var index = interceptors.indexOf(interceptor);
      if (index >= 0) {
        interceptors.splice(index, 1);
      }
    };
  },
  clear: function clear() {
    interceptors = [];
  }
};
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/network/src/index.js":
/*!**************************************************!*\
  !*** ./packages/@logrocket/network/src/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_41280__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_41280__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerNetwork;
var _defineProperty2 = _interopRequireDefault(__nested_webpack_require_41280__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(__nested_webpack_require_41280__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _registerFetch = _interopRequireDefault(__nested_webpack_require_41280__(/*! ./registerFetch */ "./packages/@logrocket/network/src/registerFetch.js"));
var _registerNetworkInformation = _interopRequireDefault(__nested_webpack_require_41280__(/*! ./registerNetworkInformation */ "./packages/@logrocket/network/src/registerNetworkInformation.js"));
var _registerXHR = _interopRequireDefault(__nested_webpack_require_41280__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js"));
var _mapValues = _interopRequireDefault(__nested_webpack_require_41280__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-line no-restricted-imports

function registerNetwork(logger) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isReactNative: false
  };
  var isReactNative = config.isReactNative,
    shouldAugmentNPS = config.shouldAugmentNPS,
    shouldParseXHRBlob = config.shouldParseXHRBlob;
  var ignoredNetwork = {};

  // truncate if > 4MB in size
  var truncate = function truncate(data) {
    var limit = 1024 * 1000 * 4;
    var str = data;
    if ((0, _typeof2.default)(data) === 'object' && data != null) {
      var proto = Object.getPrototypeOf(data);
      if (proto === Object.prototype || proto === null) {
        // plain object - jsonify for the size check
        str = JSON.stringify(data);
      }
    }
    if (str && str.length && str.length > limit && typeof str === 'string') {
      var beginning = str.substring(0, 1000);
      return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference/network");
    }
    return data;
  };
  var addRequest = function addRequest(reqId, request) {
    var method = request.method;
    logger.addEvent('lr.network.RequestEvent', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
        _ref$requestSanitizer = _ref.requestSanitizer,
        requestSanitizer = _ref$requestSanitizer === void 0 ? function (f) {
          return f;
        } : _ref$requestSanitizer;
      if (!isEnabled) {
        return null;
      }
      var sanitized = null;
      try {
        // only try catch user defined functions
        sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err);
      }
      if (sanitized) {
        var url = sanitized.url;
        if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
          // Writing and then reading from an a tag turns a relative
          // url into an absolute one.
          var a = document.createElement('a');
          a.href = sanitized.url;
          url = a.href;
        }
        return {
          reqId: reqId,
          // default
          url: url,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method,
          // default
          referrer: sanitized.referrer || undefined,
          // sanitized
          mode: sanitized.mode || undefined,
          // sanitized
          credentials: sanitized.credentials || undefined // sanitized
        };
      }

      ignoredNetwork[reqId] = true;
      return null;
    });
  };
  var addResponse = function addResponse(reqId, response) {
    var method = response.method,
      status = response.status;
    logger.addEvent('lr.network.ResponseEvent', function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$isEnabled = _ref2.isEnabled,
        isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled,
        _ref2$responseSanitiz = _ref2.responseSanitizer,
        responseSanitizer = _ref2$responseSanitiz === void 0 ? function (f) {
          return f;
        } : _ref2$responseSanitiz;
      if (!isEnabled) {
        return null;
      } else if (ignoredNetwork[reqId]) {
        delete ignoredNetwork[reqId];
        return null;
      }
      var sanitized = null;
      try {
        // only try catch user defined functions
        sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err);
        // fall through to redacted log
      }

      if (sanitized) {
        return {
          reqId: reqId,
          // default
          status: sanitized.status,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method // default
        };
      }

      return {
        reqId: reqId,
        // default
        status: status,
        // default
        headers: {},
        // redacted
        body: null,
        // redacted
        method: method // default
      };
    });
  };

  var isIgnored = function isIgnored(reqId) {
    return logger.isDisabled || ignoredNetwork[reqId] === true;
  };
  var unsubFetch = (0, _registerFetch.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored
  });
  var unsubXHR = (0, _registerXHR.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored,
    logger: logger,
    shouldAugmentNPS: shouldAugmentNPS,
    shouldParseXHRBlob: shouldParseXHRBlob
  });
  var unsubNetworkInformation = isReactNative ? function () {} : (0, _registerNetworkInformation.default)(logger);
  return function () {
    unsubNetworkInformation();
    unsubFetch();
    unsubXHR();
  };
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerFetch.js":
/*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerFetch.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_49151__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_49151__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerFetch;
var _defineProperty2 = _interopRequireDefault(__nested_webpack_require_49151__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _mapValues = _interopRequireDefault(__nested_webpack_require_49151__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
var _fetchIntercept = _interopRequireDefault(__nested_webpack_require_49151__(/*! ./fetchIntercept */ "./packages/@logrocket/network/src/fetchIntercept.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function makeObjectFromHeaders(headers) {
  // If using real fetch, we must stringify the Headers object.
  if (headers == null || typeof headers.forEach !== 'function') {
    return headers;
  }
  var result = {};
  headers.forEach(function (value, key) {
    if (result[key]) {
      result[key] = "".concat(result[key], ",").concat(value);
    } else {
      result[key] = "".concat(value);
    }
  });
  return result;
}

// XHR specification is unclear of what types to allow in value so using toString method for now
var stringifyHeaders = function stringifyHeaders(headers) {
  return (0, _mapValues.default)(makeObjectFromHeaders(headers), function (value) {
    return "".concat(value);
  });
};
function pluckFetchFields() {
  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    url: arg.url,
    headers: stringifyHeaders(arg.headers),
    method: arg.method && arg.method.toUpperCase(),
    referrer: arg.referrer || undefined,
    mode: arg.mode || undefined,
    credentials: arg.credentials || undefined
  };
}
function registerFetch(_ref) {
  var addRequest = _ref.addRequest,
    addResponse = _ref.addResponse,
    isIgnored = _ref.isIgnored;
  var LOGROCKET_FETCH_LABEL = 'fetch-';
  var fetchMethodMap = {};
  var unregister = _fetchIntercept.default.register({
    request: function request(fetchId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var p;
      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
        var clonedText;

        // Request.clone() and Request.text() may throw in Safari (e.g., when
        // request body contains FormData)
        try {
          clonedText = args[0].clone().text();
        } catch (err) {
          // if a browser supports fetch, it supports promise
          // eslint-disable-next-line compat/compat
          clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
        }
        p = clonedText.then(function (body) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: body
          });
        }, function (err) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: "LogRocket fetch error: ".concat(err.message)
          });
        });
      } else {
        // if a browser supports fetch, it supports promise
        // eslint-disable-next-line compat/compat
        p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
          url: "".concat(args[0]),
          body: (args[1] || {}).body
        }));
      }
      return p.then(function (req) {
        fetchMethodMap[fetchId] = req.method;
        addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
        return args;
      });
    },
    requestError: function requestError(fetchId, error) {
      // if a browser supports fetch, it supports promise
      // eslint-disable-next-line compat/compat
      return Promise.reject(error);
    },
    response: function response(fetchId, _response) {
      var responseClone;
      var responseTextPromise;
      if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) {
        // Don't even try to read ignored requests
        return _response;
      }
      try {
        // TODO: enhance function on original response and future clones for:
        // text(), json(), blob(), formdata(), arraybuffer()
        responseClone = _response.clone();
      } catch (err) {
        // safari has a bug where cloning can fail
        var responseHash = {
          url: _response.url,
          status: _response.status,
          headers: stringifyHeaders(_response.headers),
          body: "LogRocket fetch error: ".concat(err.message),
          method: fetchMethodMap[fetchId]
        };
        delete fetchMethodMap[fetchId];
        addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
        return _response;
      }
      try {
        if (window.TextDecoder) {
          // use a reader to manually read the response body rather than calling response.text()
          // response.text() was timing out for some responses, in some cases because Apollo sends
          //   an abort signal or because the stream wasn't getting terminated cleanly
          // using a reader allows us to capture what we can from response bodies before the
          //   response receives an abort signal
          var reader = responseClone.body.getReader();
          // response bodies always decode with UTF-8
          // https://developer.mozilla.org/en-US/docs/Web/API/Response/text
          var utf8Decoder = new window.TextDecoder('utf-8');
          var bodyContents = '';
          responseTextPromise = reader.read().then(function readResponseBody(_ref2) {
            var done = _ref2.done,
              value = _ref2.value;
            if (done) {
              return bodyContents;
            }
            var chunk = value ? utf8Decoder.decode(value, {
              stream: true
            }) : '';
            bodyContents += chunk;
            return reader.read().then(readResponseBody);
          });
        } else {
          // TextDecoder doesn't have support across all browsers that LR supports, so if there's
          //  no TextDecoder, fall back to the old approach
          responseTextPromise = responseClone.text();
        }
      } catch (error) {
        // eslint-disable-next-line compat/compat
        responseTextPromise = Promise.resolve("LogRocket error reading body: ".concat(error.message));
      }
      responseTextPromise.catch(function (error) {
        // don't drop request & log to console when the request is aborted,
        // as it may have already completed
        // https://github.com/LogRocket/logrocket/issues/34
        if (error.name === 'AbortError' && error instanceof DOMException) {
          return;
        }
        return "LogRocket error reading body: ".concat(error.message);
      }).then(function (data) {
        var responseHash = {
          url: _response.url,
          status: _response.status,
          headers: stringifyHeaders(_response.headers),
          body: data,
          method: fetchMethodMap[fetchId]
        };
        delete fetchMethodMap[fetchId];
        addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
      });
      return _response;
    },
    responseError: function responseError(fetchId, error) {
      var response = {
        url: undefined,
        status: 0,
        headers: {},
        body: "".concat(error)
      };
      addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
      // if a browser supports fetch, it supports promise
      // eslint-disable-next-line compat/compat
      return Promise.reject(error);
    }
  });
  return unregister;
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerNetworkInformation.js":
/*!***********************************************************************!*\
  !*** ./packages/@logrocket/network/src/registerNetworkInformation.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerNetworkInformation;
var EFFECTIVE_TYPE_VALS = {
  'slow-2g': 'SLOW2G',
  '2g': 'TWOG',
  '3g': 'THREEG',
  '4g': 'FOURG'
};
function registerNetworkInformation(logger) {
  var lastStatus = undefined;
  function sendNetworkInformation() {
    var newStatus = {
      online: window.navigator.onLine,
      effectiveType: 'UNKOWN'
    };
    if (!window.navigator.onLine) {
      newStatus.effectiveType = 'NONE';
    } else if (window.navigator.connection && window.navigator.connection.effectiveType) {
      newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || 'UNKNOWN';
    }
    if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) {
      return;
    }
    lastStatus = newStatus;
    logger.addEvent('lr.network.NetworkStatusEvent', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
      if (!isEnabled) {
        return null;
      }
      return newStatus;
    });
  }
  setTimeout(sendNetworkInformation);
  if (window.navigator.connection && typeof window.navigator.connection.addEventListener === 'function') {
    window.navigator.connection.addEventListener('change', sendNetworkInformation);
  }
  window.addEventListener('online', sendNetworkInformation);
  window.addEventListener('offline', sendNetworkInformation);
  return function () {
    window.removeEventListener('offline', sendNetworkInformation);
    window.removeEventListener('online', sendNetworkInformation);
    if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === 'function') {
      window.navigator.connection.removeEventListener('change', sendNetworkInformation);
    }
  };
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerXHR.js":
/*!********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerXHR.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_60441__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_60441__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setActive = setActive;
exports["default"] = registerXHR;
var _mapValues = _interopRequireDefault(__nested_webpack_require_60441__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
var _enhanceFunc = _interopRequireDefault(__nested_webpack_require_60441__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.js"));
var _startsWith = _interopRequireDefault(__nested_webpack_require_60441__(/*! @logrocket/utils/src/startsWith */ "./packages/@logrocket/utils/src/startsWith.js"));
var _nps = __nested_webpack_require_60441__(/*! @logrocket/utils/src/constants/nps */ "./packages/@logrocket/utils/src/constants/nps.js");
// eslint-disable-line no-restricted-imports
// eslint-disable-line no-restricted-imports
// eslint-disable-line no-restricted-imports

var isActive = true;
function setActive(shouldBeActive) {
  isActive = shouldBeActive;
}
var currentXHRId = 0;
function registerXHR(_ref) {
  var addRequest = _ref.addRequest,
    addResponse = _ref.addResponse,
    isIgnored = _ref.isIgnored,
    logger = _ref.logger,
    _ref$shouldAugmentNPS = _ref.shouldAugmentNPS,
    shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS,
    _ref$shouldParseXHRBl = _ref.shouldParseXHRBlob,
    shouldParseXHRBlob = _ref$shouldParseXHRBl === void 0 ? false : _ref$shouldParseXHRBl;
  var _XHR = XMLHttpRequest;
  var xhrMap = new WeakMap();
  var unsubscribedFromXhr = false;
  var LOGROCKET_XHR_LABEL = 'xhr-';
  window._lrXMLHttpRequest = XMLHttpRequest;

  // eslint-disable-next-line no-native-reassign
  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
    var xhrObject = new _XHR(mozAnon, mozSystem);
    if (!isActive) {
      return xhrObject;
    }
    xhrMap.set(xhrObject, {
      xhrId: ++currentXHRId,
      headers: {}
    });
    var openOriginal = xhrObject.open;
    function openShim() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      try {
        var url = args[1];
        if (window.URL && typeof window.URL === 'function' && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
          var logrocketSessionURL = new window.URL(logger.recordingURL);
          logrocketSessionURL.searchParams.set('nps', 'wootric');
          var urlObj = new window.URL(url);
          var responseText = urlObj.searchParams.get('response[text]');
          var feedback = responseText ? "".concat(responseText, "\n\n") : '';
          urlObj.searchParams.set('response[text]', "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
          args[1] = urlObj.href; // eslint-disable-line no-param-reassign
        }
      } catch (e) {/* do nothing */}
      return openOriginal.apply(this, args);
    }
    var sendOriginal = xhrObject.send;
    function sendShim() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      try {
        var currentXHR = xhrMap.get(xhrObject);
        if (window.URL && typeof window.URL === 'function' && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
          var recordingURL = new window.URL(logger.recordingURL);
          recordingURL.searchParams.set('nps', 'delighted');
          var logrocketSessionURL = encodeURIComponent(recordingURL.href);
          var data = args[0].split('&').map(function (dataString) {
            if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
              var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
              return "".concat(dataString).concat(isEmpty ? '' : '\n\n', "<").concat(logrocketSessionURL, "|View LogRocket session>");
            }
            return dataString;
          }).join('&');
          args[0] = data; // eslint-disable-line no-param-reassign
        }
      } catch (e) {/* do nothing */}
      return sendOriginal.apply(this, args);
    }
    if (shouldAugmentNPS) {
      xhrObject.open = openShim;
      xhrObject.send = sendShim;
    }

    // ..., 'open', (method, url, async, username, password) => {
    (0, _enhanceFunc.default)(xhrObject, 'open', function (method, url) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      currentXHR.method = method;
      currentXHR.url = url;
    });
    (0, _enhanceFunc.default)(xhrObject, 'send', function (data) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      if (!currentXHR) {
        return;
      }
      var request = {
        url: currentXHR.url,
        method: currentXHR.method && currentXHR.method.toUpperCase(),
        headers: (0, _mapValues.default)(currentXHR.headers || {}, function (headerValues) {
          return headerValues.join(', ');
        }),
        body: data
      };
      addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
    });
    (0, _enhanceFunc.default)(xhrObject, 'setRequestHeader', function (header, value) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      if (!currentXHR) {
        return;
      }
      currentXHR.headers = currentXHR.headers || {};
      currentXHR.headers[header] = currentXHR.headers[header] || [];
      currentXHR.headers[header].push(value);
    });
    var xhrListeners = {
      readystatechange: function readystatechange() {
        if (unsubscribedFromXhr) {
          return;
        }
        if (xhrObject.readyState === 4) {
          var currentXHR = xhrMap.get(xhrObject);
          if (!currentXHR) {
            return;
          }

          // Do not read ignored requests at all.
          if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) {
            return;
          }
          var headerString = xhrObject.getAllResponseHeaders() || '';
          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
            var next = previous;
            var headerParts = current.split(': ');
            if (headerParts.length > 0) {
              var key = headerParts.shift(); // first index of the array
              var value = headerParts.join(': '); // rest of the array repaired
              if (previous[key]) {
                next[key] += ", ".concat(value);
              } else {
                next[key] = value;
              }
            }
            return next;
          }, {});
          var body;

          // IE 11 sometimes throws when trying to access large responses
          try {
            switch (xhrObject.responseType) {
              case 'json':
                body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                break;
              case 'arraybuffer':
              case 'blob':
                {
                  body = xhrObject.response;
                  break;
                }
              case 'document':
                {
                  body = xhrObject.responseXML;
                  break;
                }
              case 'text':
              case '':
                {
                  body = xhrObject.responseText;
                  break;
                }
              default:
                {
                  body = '';
                }
            }
          } catch (err) {
            body = 'LogRocket: Error accessing response.';
          }
          var response = {
            url: currentXHR.url,
            status: xhrObject.status,
            headers: headers,
            body: body,
            method: (currentXHR.method || '').toUpperCase()
          };
          if (shouldParseXHRBlob && response.body instanceof Blob) {
            var blobReader = new FileReader();
            blobReader.readAsText(response.body);
            blobReader.onload = function () {
              try {
                response.body = JSON.parse(blobReader.result);
              } catch (_unused) {} // eslint-disable-line no-empty
              addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
            };
          } else {
            addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
          }
        }
      }
      // // Unused Event Listeners
      // loadstart: () => {},
      // progress: () => {},
      // abort: () => {},
      // error: () => {},
      // load: () => {},
      // timeout: () => {},
      // loadend: () => {},
    };

    Object.keys(xhrListeners).forEach(function (key) {
      xhrObject.addEventListener(key, xhrListeners[key]);
    });
    return xhrObject;
  };

  // this allows "instanceof XMLHttpRequest" to work
  XMLHttpRequest.prototype = _XHR.prototype;

  // Persist the static variables.
  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
    XMLHttpRequest[variable] = _XHR[variable];
  });
  return function () {
    unsubscribedFromXhr = true;
    // eslint-disable-next-line no-native-reassign
    XMLHttpRequest = _XHR;
  };
}

/***/ }),

/***/ "./packages/@logrocket/now/src/index.js":
/*!**********************************************!*\
  !*** ./packages/@logrocket/now/src/index.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/* eslint-disable compat/compat */
var dateNow = Date.now.bind(Date);
var loadTime = dateNow();
var _default = typeof performance !== 'undefined' && performance.now ? performance.now.bind(performance) : function () {
  return dateNow() - loadTime;
};
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/redux/src/createEnhancer.js":
/*!*********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createEnhancer.js ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_70996__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_70996__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createEnhancer;
var _defineProperty2 = _interopRequireDefault(__nested_webpack_require_70996__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _now = _interopRequireDefault(__nested_webpack_require_70996__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var storeIdCounter = 0;
function createEnhancer(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$stateSanitizer = _ref.stateSanitizer,
    stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$stateSanitizer,
    _ref$actionSanitizer = _ref.actionSanitizer,
    actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$actionSanitizer;
  // an enhancer is a function that returns a Store
  return function (createStore) {
    return function (reducer, initialState, enhancer) {
      var store = createStore(reducer, initialState, enhancer);
      var originalDispatch = store.dispatch;
      var storeId = storeIdCounter++;
      logger.addEvent('lr.redux.InitialState', function () {
        var sanitizedState;
        try {
          // only try catch user defined functions
          sanitizedState = stateSanitizer(store.getState());
        } catch (err) {
          console.error(err.toString());
        }
        return {
          state: sanitizedState,
          storeId: storeId
        };
      });
      var dispatch = function dispatch(action) {
        var start = (0, _now.default)();
        var err;
        var res;
        try {
          res = originalDispatch(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;
            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }
            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }
            return null;
          });
        }
        if (err) {
          throw err;
        }
        return res;
      };
      return _objectSpread(_objectSpread({}, store), {}, {
        dispatch: dispatch
      });
    };
  };
}

/***/ }),

/***/ "./packages/@logrocket/redux/src/createMiddleware.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createMiddleware.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_75152__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_75152__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createMiddleware;
var _now = _interopRequireDefault(__nested_webpack_require_75152__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
var storeIdCounter = 0;
function createMiddleware(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$stateSanitizer = _ref.stateSanitizer,
    stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$stateSanitizer,
    _ref$actionSanitizer = _ref.actionSanitizer,
    actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$actionSanitizer;
  return function (store) {
    var storeId = storeIdCounter++;
    logger.addEvent('lr.redux.InitialState', function () {
      var sanitizedState;
      try {
        // only try catch user defined functions
        sanitizedState = stateSanitizer(store.getState());
      } catch (err) {
        console.error(err.toString());
      }
      return {
        state: sanitizedState,
        storeId: storeId
      };
    });
    return function (next) {
      return function (action) {
        var start = (0, _now.default)();
        var err;
        var res;
        try {
          res = next(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;
            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }
            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }
            return null;
          });
        }
        if (err) {
          throw err;
        }
        return res;
      };
    };
  };
}

/***/ }),

/***/ "./packages/@logrocket/redux/src/index.js":
/*!************************************************!*\
  !*** ./packages/@logrocket/redux/src/index.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_77887__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_77887__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "createEnhancer", ({
  enumerable: true,
  get: function get() {
    return _createEnhancer.default;
  }
}));
Object.defineProperty(exports, "createMiddleware", ({
  enumerable: true,
  get: function get() {
    return _createMiddleware.default;
  }
}));
var _createEnhancer = _interopRequireDefault(__nested_webpack_require_77887__(/*! ./createEnhancer */ "./packages/@logrocket/redux/src/createEnhancer.js"));
var _createMiddleware = _interopRequireDefault(__nested_webpack_require_77887__(/*! ./createMiddleware */ "./packages/@logrocket/redux/src/createMiddleware.js"));

/***/ }),

/***/ "./packages/@logrocket/utils/src/TraceKit.js":
/*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/TraceKit.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_79027__) {

"use strict";
/* eslint-disable */



/*
 TraceKit - Cross brower stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window : typeof __nested_webpack_require_79027__.g !== 'undefined' ? __nested_webpack_require_79027__.g : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
function getLocationHref() {
  if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }
    if (exception) {
      throw exception;
    }
  }
  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
    var stack = null;
    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
      processLastException();
    } else if (ex) {
      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(ex);
      notifyHandlers(stack, true);
    } else {
      var location = {
        'url': url,
        'line': lineNo,
        'column': colNo
      };
      var name = undefined;
      var msg = message; // must be new var or will modify original `arguments`
      var groups;
      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          msg = groups[2];
        }
      }
      location.func = UNKNOWN_FUNCTION;
      stack = {
        'name': name,
        'message': msg,
        'url': getLocationHref(),
        'stack': [location]
      };
      notifyHandlers(stack, true);
    }
    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }
    return false;
  }
  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }
  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }
  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }
    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function () {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);
    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
}();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = function computeStackTraceWrapper() {
  /**
   * Escapes special characters, except for whitespace, in a string to be
   * used inside a regular expression as a string literal.
   * @param {string} text The string.
   * @return {string} The escaped string literal.
   */
  function escapeRegExp(text) {
    return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
  }

  /**
   * Escapes special characters in a string to be used inside a regular
   * expression as a string literal. Also ensures that HTML entities will
   * be matched the same as their literal friends.
   * @param {string} body The string.
   * @return {string} The escaped string.
   */
  function escapeCodeAsRegExpForMatchingInsideHTML(body) {
    return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
  }

  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;
    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
      gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
      winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
      lines = ex.stack.split('\n'),
      stack = [],
      parts,
      element,
      reference = /^(.*) is undefined$/.exec(ex.message);
    for (var i = 0, j = lines.length; i < j; ++i) {
      if (parts = chrome.exec(lines[i])) {
        var isNative = parts[2] && parts[2].indexOf('native') !== -1;
        element = {
          'url': !isNative ? parts[2] : null,
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': isNative ? [parts[2]] : [],
          'line': parts[3] ? +parts[3] : null,
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = winjs.exec(lines[i])) {
        element = {
          'url': parts[2],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': [],
          'line': +parts[3],
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = gecko.exec(lines[i])) {
        element = {
          'url': parts[3],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': parts[2] ? parts[2].split(',') : [],
          'line': parts[4] ? +parts[4] : null,
          'column': parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }
      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }
      stack.push(element);
    }
    if (!stack.length) {
      return null;
    }
    if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
      // FireFox uses this awesome columnNumber property for its top frame
      // Also note, Firefox's column number is 0-based and everything else expects 1-based,
      // so adding 1
      stack[0].column = ex.columnNumber + 1;
    }
    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      'url': url,
      'line': lineNo
    };
    if (initial.url && initial.line) {
      stackInfo.incomplete = false;
      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }
      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }
      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }
    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;
    for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }
      item = {
        'url': null,
        'func': UNKNOWN_FUNCTION,
        'line': null,
        'column': null
      };
      if (curr.name) {
        item.func = curr.name;
      } else if (parts = functionName.exec(curr.toString())) {
        item.func = parts[1];
      }
      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }
      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }
      stack.push(item);
    }
    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }
    var result = {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
    augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;
    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref()
    };
  }
  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
  return computeStackTrace;
}();
var _default = TraceKit;
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/utils/src/constants/nps.js":
/*!********************************************************!*\
  !*** ./packages/@logrocket/utils/src/constants/nps.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = void 0;
var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
exports.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
exports.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
var DELIGHTED_FEEDBACK_PREFIX = 'comment=';
exports.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;

/***/ }),

/***/ "./packages/@logrocket/utils/src/enhanceFunc.js":
/*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/enhanceFunc.js ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = enhanceFunc;
/* eslint no-param-reassign: ["error", { "props": false }] */

function enhanceFunc(obj, method, handler) {
  var original = obj[method];
  function shim() {
    var res;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (original) {
      res = original.apply(this, args);
    }
    handler.apply(this, args);
    return res;
  }
  obj[method] = shim;
  return function () {
    obj[method] = original;
  };
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/mapValues.js":
/*!****************************************************!*\
  !*** ./packages/@logrocket/utils/src/mapValues.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapValues;
function mapValues(obj, f) {
  if (obj == null) {
    return {};
  }
  var res = {};
  Object.keys(obj).forEach(function (key) {
    res[key] = f(obj[key]);
  });
  return res;
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/startsWith.js":
/*!*****************************************************!*\
  !*** ./packages/@logrocket/utils/src/startsWith.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startsWith;
function startsWith(value, search) {
  var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return value && search && value.substring(pos, pos + search.length) === search;
}

/***/ }),

/***/ "./packages/logrocket/src/LogRocket.js":
/*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_101681__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_101681__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.MAX_QUEUE_SIZE = void 0;
var _classCallCheck2 = _interopRequireDefault(__nested_webpack_require_101681__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(__nested_webpack_require_101681__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
var _defineProperty2 = _interopRequireDefault(__nested_webpack_require_101681__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(__nested_webpack_require_101681__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
var _network = _interopRequireDefault(__nested_webpack_require_101681__(/*! @logrocket/network */ "./packages/@logrocket/network/src/index.js"));
var _exceptions = __nested_webpack_require_101681__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
var _console = _interopRequireDefault(__nested_webpack_require_101681__(/*! @logrocket/console */ "./packages/@logrocket/console/src/index.js"));
var _redux = __nested_webpack_require_101681__(/*! @logrocket/redux */ "./packages/@logrocket/redux/src/index.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MAX_QUEUE_SIZE = 1000;
exports.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;
var considerIngestServerOption = function considerIngestServerOption() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    ingestServer = _ref.ingestServer,
    options = (0, _objectWithoutProperties2.default)(_ref, ["ingestServer"]);
  if (ingestServer) {
    return _objectSpread({
      serverURL: "".concat(ingestServer, "/i"),
      statsURL: "".concat(ingestServer, "/s")
    }, options);
  }
  return options;
};
var LogRocket = /*#__PURE__*/function () {
  function LogRocket() {
    var _this = this;
    (0, _classCallCheck2.default)(this, LogRocket);
    this._buffer = [];
    // TODO: tests for these exposed methods.
    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
      _this[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this.addEvent('lr.core.LogEvent', function () {
          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
            _exceptions.Capture.captureMessage(_this, args[0], args, {}, true);
          }
          return {
            logLevel: method.toUpperCase(),
            args: args
          };
        }, {
          shouldCaptureStackTrace: true
        });
      };
    });
    this._isInitialized = false;
    this._installed = [];

    // expose a callback to get the session URL from the global context
    window._lr_surl_cb = this.getSessionURL.bind(this);
  }
  (0, _createClass2.default)(LogRocket, [{
    key: "addEvent",
    value: function addEvent(type, getMessage) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var time = Date.now();
      this._run(function (logger) {
        logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
          timeOverride: time
        }));
      });
    }
  }, {
    key: "onLogger",
    value: function onLogger(logger) {
      this._logger = logger;
      while (this._buffer.length > 0) {
        var f = this._buffer.shift();
        f(this._logger);
      }
    }
  }, {
    key: "_run",
    value: function _run(f) {
      if (this._isDisabled) {
        return;
      }
      if (this._logger) {
        f(this._logger);
      } else {
        if (this._buffer.length >= MAX_QUEUE_SIZE) {
          this._isDisabled = true;
          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
          this.uninstall();
          return;
        }
        this._buffer.push(f.bind(this));
      }
    }
  }, {
    key: "init",
    value: function init(appID) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._isInitialized) {
        var _opts$shouldAugmentNP = opts.shouldAugmentNPS,
          shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP,
          _opts$shouldParseXHRB = opts.shouldParseXHRBlob,
          shouldParseXHRBlob = _opts$shouldParseXHRB === void 0 ? false : _opts$shouldParseXHRB,
          _opts$shouldDetectExc = opts.shouldDetectExceptions,
          shouldDetectExceptions = _opts$shouldDetectExc === void 0 ? true : _opts$shouldDetectExc;
        if (shouldDetectExceptions) {
          this._installed.push((0, _exceptions.registerExceptions)(this));
        }
        this._installed.push((0, _network.default)(this, {
          shouldAugmentNPS: !!shouldAugmentNPS,
          shouldParseXHRBlob: !!shouldParseXHRBlob
        }));
        this._installed.push((0, _console.default)(this));
        this._isInitialized = true;
        this._run(function (logger) {
          logger.init(appID, considerIngestServerOption(opts));
        });
      }
    }
  }, {
    key: "start",
    value: function start() {
      this._run(function (logger) {
        logger.start();
      });
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this._installed.forEach(function (f) {
        return f();
      });
      this._buffer = [];
      this._run(function (logger) {
        logger.uninstall();
      });
    }
  }, {
    key: "identify",
    value: function identify(id, opts) {
      this._run(function (logger) {
        logger.identify(id, opts);
      });
    }
  }, {
    key: "startNewSession",
    value: function startNewSession() {
      this._run(function (logger) {
        logger.startNewSession();
      });
    }
  }, {
    key: "track",
    value: function track(customEventName, eventProperties) {
      this._run(function (logger) {
        logger.track(customEventName, eventProperties);
      });
    }
  }, {
    key: "getSessionURL",
    value: function getSessionURL(cb) {
      if (typeof cb !== 'function') {
        throw new Error('LogRocket: must pass callback to getSessionURL()');
      }
      this._run(function (logger) {
        if (logger.getSessionURL) {
          logger.getSessionURL(cb);
        } else {
          cb(logger.recordingURL);
        }
      });
    }
  }, {
    key: "getVersion",
    value: function getVersion(cb) {
      this._run(function (logger) {
        cb(logger.version);
      });
    }
  }, {
    key: "captureMessage",
    value: function captureMessage(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _exceptions.Capture.captureMessage(this, message, [message], options);
    }
  }, {
    key: "captureException",
    value: function captureException(exception) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _exceptions.Capture.captureException(this, exception, options);
    }
  }, {
    key: "version",
    get: function get() {
      return this._logger && this._logger.version;
    }
  }, {
    key: "sessionURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingID",
    get: function get() {
      return this._logger && this._logger.recordingID;
    }
  }, {
    key: "threadID",
    get: function get() {
      return this._logger && this._logger.threadID;
    }
  }, {
    key: "tabID",
    get: function get() {
      return this._logger && this._logger.tabID;
    }
  }, {
    key: "reduxEnhancer",
    value: function reduxEnhancer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _redux.createEnhancer)(this, options);
    }
  }, {
    key: "reduxMiddleware",
    value: function reduxMiddleware() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _redux.createMiddleware)(this, options);
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return !!(this._isDisabled || this._logger && this._logger._isDisabled);
    }
  }]);
  return LogRocket;
}();
exports["default"] = LogRocket;

/***/ }),

/***/ "./packages/logrocket/src/makeLogRocket.js":
/*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_111588__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_111588__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = makeLogRocket;
var _LogRocket = _interopRequireDefault(__nested_webpack_require_111588__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));
var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';
var makeNoopPolyfill = function makeNoopPolyfill() {
  return {
    init: function init() {},
    uninstall: function uninstall() {},
    log: function log() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {},
    debug: function debug() {},
    addEvent: function addEvent() {},
    identify: function identify() {},
    start: function start() {},
    get threadID() {
      return null;
    },
    get recordingID() {
      return null;
    },
    get recordingURL() {
      return null;
    },
    reduxEnhancer: function reduxEnhancer() {
      return function (store) {
        return function () {
          return store.apply(void 0, arguments);
        };
      };
    },
    reduxMiddleware: function reduxMiddleware() {
      return function () {
        return function (next) {
          return function (action) {
            return next(action);
          };
        };
      };
    },
    track: function track() {},
    getSessionURL: function getSessionURL() {},
    getVersion: function getVersion() {},
    startNewSession: function startNewSession() {},
    onLogger: function onLogger() {},
    setClock: function setClock() {},
    captureMessage: function captureMessage() {},
    captureException: function captureException() {}
  };
};
function makeLogRocket() {
  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(REACT_NATIVE_NOTICE);
  }
  if (typeof window !== 'undefined') {
    if (window._disableLogRocket) {
      return makeNoopPolyfill();
    }
    if (window.MutationObserver && window.WeakMap) {
      // Save window globals that we rely on.
      window._lrMutationObserver = window.MutationObserver;
      var instance = new _LogRocket.default();
      getLogger(instance);
      return instance;
    }
  }
  return makeNoopPolyfill();
}

/***/ }),

/***/ "./packages/logrocket/src/setup.js":
/*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_114313__) {

"use strict";


var _interopRequireDefault = __nested_webpack_require_114313__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setup;
var _objectWithoutProperties2 = _interopRequireDefault(__nested_webpack_require_114313__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
var _makeLogRocket = _interopRequireDefault(__nested_webpack_require_114313__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));
var CDN_SERVER_MAP = {
  'cdn.logrocket.io': 'https://r.logrocket.io',
  'cdn.lr-ingest.io': 'https://r.lr-ingest.io',
  'cdn.lr-in.com': 'https://r.lr-in.com',
  'cdn.lr-in-prod.com': 'https://r.lr-in-prod.com',
  'cdn.lr-ingest.com': 'https://r.lr-ingest.com',
  'cdn-staging.logrocket.io': 'https://staging-i.logrocket.io',
  'cdn-staging.lr-ingest.io': 'https://staging-i.lr-ingest.io',
  'cdn-staging.lr-in.com': 'https://staging-i.lr-in.com',
  'cdn-staging.lr-in-prod.com': 'https://staging-i.lr-in-prod.com',
  'cdn-staging.lr-ingest.com': 'https://staging-i.lr-ingest.com'
};
function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    enterpriseServer = _ref.enterpriseServer,
    _ref$sdkVersion = _ref.sdkVersion,
    sdkVersion = _ref$sdkVersion === void 0 ? "4.0.0" : _ref$sdkVersion,
    opts = (0, _objectWithoutProperties2.default)(_ref, ["enterpriseServer", "sdkVersion"]);
  var scriptOrigin =   false ? 0 : 'https://cdn.logrocket.io';
  var scriptIngest;
  if (sdkVersion === 'script') {
    try {
      // eslint-disable-next-line compat/compat
      var scriptTag = document.currentScript;
      var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
      var scriptHostname = matches && matches[2];
      if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
        scriptOrigin = matches && matches[1];
        scriptIngest = CDN_SERVER_MAP[scriptHostname];
      }
    } catch (_) {
      /* no-op */
    }
  } else {
    // NPM
    scriptOrigin =   false ? 0 : 'https://cdn.lr-ingest.com';
    scriptIngest =   false ? 0 : 'https://r.lr-ingest.com';
  }
  var sdkServer = opts.sdkServer || enterpriseServer;
  var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
  var instance = (0, _makeLogRocket.default)(function () {
    var script = document.createElement('script');
    if (ingestServer) {
      if (typeof window.__SDKCONFIG__ === 'undefined') {
        window.__SDKCONFIG__ = {};
      }
      window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
      window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
    }
    if (sdkServer) {
      script.src = "".concat(sdkServer, "/logger.min.js");
    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
      script.src = window.__SDKCONFIG__.loggerURL;
    } else if (window._lrAsyncScript) {
      script.src = window._lrAsyncScript;
    } else {
      script.src = "".concat(scriptOrigin, "/logger-1.min.js");
    }
    script.async = true;
    document.head.appendChild(script);
    script.onload = function () {
      // Brave browser: Advertises its user-agent as Chrome ##.##... then
      // loads logger.min.js, but blocks the execution of the script
      // causing _LRlogger to be undefined.  Let's make sure its there first.
      if (typeof window._LRLogger === 'function') {
        instance.onLogger(new window._LRLogger({
          sdkVersion: sdkVersion
        }));
      } else {
        console.warn('LogRocket: script execution has been blocked by a product or service.');
        instance.uninstall();
      }
    };
    script.onerror = function () {
      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
      instance.uninstall();
    };
  });
  return instance;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_118520__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_118520__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__nested_webpack_require_118520__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
var exports = __webpack_exports__;
/*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/


var _interopRequireDefault = __nested_webpack_require_118520__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _setup = _interopRequireDefault(__nested_webpack_require_118520__(/*! ./setup */ "./packages/logrocket/src/setup.js"));
var instance = (0, _setup.default)();
var _default = instance;
exports["default"] = _default;
}();
__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});

/***/ }),

/***/ 6436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(70891);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 5174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(1629);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);

var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Layout)));


/***/ }),

/***/ 90625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51626);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93913);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var Spinner = function(param) {
    var _theme = param.theme, theme = _theme === void 0 ? "default" : _theme, _contextual = param.contextual, contextual = _contextual === void 0 ? false : _contextual, _relative = param.relative, relative = _relative === void 0 ? false : _relative, _className = param.className, className = _className === void 0 ? "" : _className;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().Spinner), className, (_obj = {}, _defineProperty(_obj, (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().SpinnerWhite), theme === "white"), _defineProperty(_obj, (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().SpinnerGrey), theme === "grey"), _defineProperty(_obj, (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().SpinnerWhiteCharcoal), theme === "white-charcoal"), _defineProperty(_obj, (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().SpinnerContextual), contextual), _defineProperty(_obj, (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().SpinnerRelative), relative), _obj)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disc),
                d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            })
        })
    });
};


/***/ }),

/***/ 90425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ CopyToClipboardButton; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/cart/partials/CopyToClipboardButton.module.scss
var CopyToClipboardButton_module = __webpack_require__(15018);
var CopyToClipboardButton_module_default = /*#__PURE__*/__webpack_require__.n(CopyToClipboardButton_module);
;// CONCATENATED MODULE: ./components/cart/partials/CopyToClipboardButton.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var CopyToClipboardButton = function(param) {
    var shareUrl = param.shareUrl, content = param.content, className = param.className;
    var clipboardButtonStateToTextMap = {
        default: "Copy To Clipboard",
        success: "Copied!",
        error: "Error!"
    };
    var ref = (0,react.useState)(true), clipboardSupported = ref[0], setClipboardSupported = ref[1];
    var ref1 = (0,react.useState)("default"), clipboardButtonState = ref1[0], setClipboardButtonState = ref1[1];
    var copyContentToClipboard = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setClipboardButtonState("default");
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.clipboard.writeText(shareUrl || content);
                    case 4:
                        setClipboardButtonState("success");
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                        setClipboardButtonState("error");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function copyContentToClipboard() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setClipboardSupported(window.navigator !== undefined && window.navigator.clipboard !== undefined);
    }, []);
    if (!clipboardSupported) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: [
            (CopyToClipboardButton_module_default()).CopyButton,
            className,
            clipboardButtonState === "success" ? (CopyToClipboardButton_module_default()).Clicked : ""
        ].join(" "),
        type: "button",
        size: "xl",
        variant: "ghost",
        callBack: copyContentToClipboard,
        children: "\uF012"
    });
};
/* harmony default export */ var partials_CopyToClipboardButton = ((/* unused pure expression or super */ null && (CopyToClipboardButton)));

;// CONCATENATED MODULE: ./components/cart/partials/index.ts



/***/ }),

/***/ 94765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddressDisplay */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _global_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80772);
/* harmony import */ var _global_Panel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12490);
/* harmony import */ var _CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41411);
/* harmony import */ var _CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var AddressDisplay = function(param) {
    var address = param.address, setStep = param.setStep, vatNumber = param.vatNumber, vatValidityResponse = param.vatValidityResponse;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_Panel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__header),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Billing Details"
                    }),
                    setStep && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: "secondary",
                        callBack: function() {
                            setStep(1);
                        },
                        children: "Edit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__body),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyRow),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyLabel),
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    address === null || address === void 0 ? void 0 : address.firstName,
                                    " ",
                                    address === null || address === void 0 ? void 0 : address.lastName
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyRow),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyLabel),
                                children: "Address"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("address", {
                                children: [
                                    address === null || address === void 0 ? void 0 : address.streetAddress1,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    address === null || address === void 0 ? void 0 : address.city.toLowerCase(),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    address === null || address === void 0 ? void 0 : address.postalCode,
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    address === null || address === void 0 ? void 0 : address.countryArea,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    address === null || address === void 0 ? void 0 : address.country.country
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyRow),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyLabel),
                                children: "Telephone"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: address === null || address === void 0 ? void 0 : address.phone
                            })
                        ]
                    }),
                    vatNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyRow),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_CheckoutForm_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AddressDisplay__bodyLabel),
                                children: "VAT Number"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    vatNumber,
                                    vatValidityResponse && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                children: vatValidityResponse
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressDisplay);


/***/ }),

/***/ 38680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CustomisedFontMetadata_CustomisedFontMetadata; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./lib/customiser/getIgnoredProperties.ts
var getIgnoredProperties = __webpack_require__(61702);
// EXTERNAL MODULE: ./components/checkout/CustomisedFontMetadata/CustomisedFontMetadata.module.scss
var CustomisedFontMetadata_module = __webpack_require__(85065);
var CustomisedFontMetadata_module_default = /*#__PURE__*/__webpack_require__.n(CustomisedFontMetadata_module);
;// CONCATENATED MODULE: ./components/checkout/CustomisedFontMetadata/CustomisedFontMetadata.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var CustomisedFontMetadata = function(param1) {
    var metadata = param1.metadata, variant = param1.variant, _className = param1.className, className = _className === void 0 ? "" : _className;
    var ref, ref1, ref2, ref3, ref4;
    var customisedFontMetadata = (ref = metadata.find(function(param) {
        var key = param.key;
        return key === "itemCustomiser";
    })) === null || ref === void 0 ? void 0 : ref.value;
    if (!customisedFontMetadata) {
        return;
    }
    var parsedMetadata = [];
    try {
        parsedMetadata = customisedFontMetadata && JSON.parse(customisedFontMetadata);
    } catch (error) {
        console.error("Error: Can't parse custom font metadata");
    }
    var fontFamily = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : (ref1 = parsedMetadata[0]) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "";
    var fontStyles = parsedMetadata.reduce(function(acc, item) {
        return _toConsumableArray(acc).concat([
            item.fontPathSrc
        ], _toConsumableArray(item.fontsAdditional));
    }, []);
    var stylisticSets = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : (ref2 = parsedMetadata[0]) === null || ref2 === void 0 ? void 0 : ref2.stylisticSets) || [];
    var variableAxes = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : (ref3 = parsedMetadata[0]) === null || ref3 === void 0 ? void 0 : ref3.variableAxes) || {};
    var base = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : (ref4 = parsedMetadata[0]) === null || ref4 === void 0 ? void 0 : ref4.fontBase) || "";
    var ignoredAxes = (0,getIgnoredProperties/* getIgnoredAxes */.DR)(variant);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (0,clsx_m/* default */.Z)((CustomisedFontMetadata_module_default()).CustomisedFontMetadata__list, className),
        children: [
            fontFamily && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__propertyName,
                        children: "Family"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__baseValue,
                        children: fontFamily
                    })
                ]
            }),
            base && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__propertyName,
                        children: "Base"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__baseValue,
                        children: base
                    })
                ]
            }),
            fontStyles && fontStyles.length >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__propertyName,
                        children: "Styles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__baseValue,
                        children: fontStyles.length
                    })
                ]
            }),
            !!Object.keys(variableAxes).length && Object.entries(variableAxes).map(function(param) {
                var _param = _slicedToArray(param, 2), fontAxesName = _param[0], fontAxesValue = _param[1];
                // Ignore axis
                if (ignoredAxes.includes(fontAxesName.toLowerCase())) {
                    return;
                }
                var value = String(fontAxesValue);
                var splitValue = value.split(":");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__propertyName,
                            children: fontAxesName
                        }),
                        splitValue.length > 1 ? "".concat(splitValue[0], " to ").concat(splitValue[1]) : fontAxesValue
                    ]
                }, fontAxesName);
            }),
            !!stylisticSets.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CustomisedFontMetadata_module_default()).CustomisedFontMetadata__propertyName,
                        children: "Alternatives"
                    }),
                    "".concat(stylisticSets.length, " set").concat(stylisticSets.length > 1 ? "s" : "")
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomisedFontMetadata_CustomisedFontMetadata = (CustomisedFontMetadata);

;// CONCATENATED MODULE: ./components/checkout/CustomisedFontMetadata/index.ts



/***/ }),

/***/ 80378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cms_Video; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@vimeo+player@2.17.1/node_modules/@vimeo/player/dist/player.es.js
/*! @vimeo/player v2.17.1 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */

/* global global */
var isNode = typeof __webpack_require__.g !== 'undefined' && {}.toString.call(__webpack_require__.g) === '[object global]';
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */

function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }

  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */

function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */

function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoEmbed(url) {
  var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
  return expr.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */

function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;

  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }

  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }

  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }

  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }

  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function (self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var hasDefine = Object.defineProperty && function () {
    try {
      // Avoid IE8's broken Object.defineProperty
      return Object.defineProperty({}, 'x', {
        value: 1
      }).x === 1;
    } catch (e) {}
  }();

  var defineProperty = function (object, name, value) {
    if (hasDefine) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });

    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }

    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();

  function isObject(x) {
    return Object(x) === x;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();

  if ( module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
    return setImmediate(fn);
  } : setTimeout; // dammit, IE8.

  try {
    Object.defineProperty({}, "x", {});

    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  } // Note: using a queue instead of array for efficiency


  scheduling_queue = function Queue() {
    var first, last, item;

    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }

    return {
      add: function add(fn, self) {
        item = new Item(fn, self);

        if (last) {
          last.next = item;
        } else {
          first = item;
        }

        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;

        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();

  function schedule(fn, self) {
    scheduling_queue.add(fn, self);

    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  } // promise duck typing


  function isThenable(o) {
    var _then,
        o_type = typeof o;

    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }

    return typeof _then == "function" ? _then : false;
  }

  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }

    this.chain.length = 0;
  } // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better


  function notifyIsolated(self, cb, chain) {
    var ret, _then;

    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }

        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }

  function resolve(msg) {
    var _then,
        self = this; // already triggered?


    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);

          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;

        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }

  function reject(msg) {
    var self = this; // already triggered?

    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    self.msg = msg;
    self.state = 2;

    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }

  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }

  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }

  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }

  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }

    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    } // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise


    this.__NPO__ = 1;
    var def = new MakeDef(this);

    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      }; // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.

      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);

      if (def.state !== 0) {
        schedule(notify, def);
      }

      return o.promise;
    };

    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };

    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }

  var PromisePrototype = builtInProp({}, "constructor", Promise,
  /*configurable=*/
  false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

  Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

  builtInProp(PromisePrototype, "__NPO__", 0,
  /*configurable=*/
  false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this; // spec mandated checks
    // note: best "isPromise" check that's practical for now

    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    if (arr.length === 0) {
      return Constructor.resolve([]);
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      var len = arr.length,
          msgs = Array(len),
          count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;

        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */
var callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */

function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }

  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */

function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */

function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!playerCallbacks[name]) {
    return true;
  } // If no callback is passed, remove all callbacks for the event


  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }

  var index = playerCallbacks[name].indexOf(callback);

  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }

  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */

function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);

  if (playerCallbacks.length < 1) {
    return false;
  }

  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */

function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/postmessage
 */
/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */

function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }

  return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */

function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }

  var message = {
    method: method
  };

  if (params !== undefined) {
    message.value = params;
  } // IE 8 and 9 do not support passing messages, so stringify them


  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }

  player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */

function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;

  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }

    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);

    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }

  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }

      callback.resolve(param);
    } catch (e) {// empty
    }
  });
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */

function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));

    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }

    return params;
  }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */

function createEmbed(_ref, element) {
  var html = _ref.html;

  if (!element) {
    throw new TypeError('An element must be provided');
  }

  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }

  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */

function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }

    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }

    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }

      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }

      try {
        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };

    xhr.send();
  });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };

  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }

      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }

  window.VimeoPlayerResizeEmbeds_ = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    } // 'spacechange' is fired only on embeds with cards


    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      } // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio


      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };

  window.addEventListener('message', onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initAppendVideoMetadata() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoSeoMetadataAppended) {
    return;
  }

  window.VimeoSeoMetadataAppended = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }

    var data = parseMessageData(event.data);

    if (!data || data.event !== 'ready') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i]; // Initiate appendVideoMetadata if iframe is a Vimeo embed

      var isValidMessageSource = iframe.contentWindow === event.source;

      if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
        var player = new Player(iframe);
        player.callMethod('appendVideoMetadata', window.location.href);
      }
    }
  };

  window.addEventListener('message', onMessage);
}

/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */
function initializeScreenfull() {
  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};

    for (; i < l; i++) {
      val = fnMap[i];

      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }

        return ret;
      }
    }

    return false;
  }();

  var eventNameMap = {
    fullscreenchange: fn.fullscreenchange,
    fullscreenerror: fn.fullscreenerror
  };
  var screenfull = {
    request: function request(element) {
      return new Promise(function (resolve, reject) {
        var onFullScreenEntered = function onFullScreenEntered() {
          screenfull.off('fullscreenchange', onFullScreenEntered);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenEntered);
        element = element || document.documentElement;
        var returnPromise = element[fn.requestFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenEntered).catch(reject);
        }
      });
    },
    exit: function exit() {
      return new Promise(function (resolve, reject) {
        if (!screenfull.isFullscreen) {
          resolve();
          return;
        }

        var onFullScreenExit = function onFullScreenExit() {
          screenfull.off('fullscreenchange', onFullScreenExit);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenExit);
        var returnPromise = document[fn.exitFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenExit).catch(reject);
        }
      });
    },
    on: function on(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.addEventListener(eventName, callback);
      }
    },
    off: function off(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.removeEventListener(eventName, callback);
      }
    }
  };
  Object.defineProperties(screenfull, {
    isFullscreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });
  return screenfull;
}

var playerMap = new WeakMap();
var readyMap = new WeakMap();
var screenfull = {};

var Player = /*#__PURE__*/function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Player);

    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }

      element = element[0];
    } // Find an element by ID


    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    } // Not an element!


    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    } // Already initialized an embed in this div, so grab the iframe


    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');

      if (iframe) {
        element = iframe;
      }
    } // iframe url is not a Vimeo url


    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    } // If there is already a player object in the map, return that


    if (playerMap.has(element)) {
      return playerMap.get(element);
    }

    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }

        if (_this.origin === '*') {
          _this.origin = event.origin;
        }

        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';

        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }

        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';

        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');

          resolve();
          return;
        }

        processData(_this, data);
      };

      _this._window.addEventListener('message', _this._onMessage);

      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
          // but store reference to the original element

          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    }); // Store a copy of this Player in the map

    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.

    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }

    if (screenfull.isEnabled) {
      var exitFullscreen = function exitFullscreen() {
        return screenfull.exit();
      };

      this.fullscreenchangeHandler = function () {
        if (screenfull.isFullscreen) {
          storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } else {
          removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } // eslint-disable-next-line


        _this.ready().then(function () {
          postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
        });
      };

      screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
    }

    return this;
  }
  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */


  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */

  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return

        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');

        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        } // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return


        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */

  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }

      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var callbacks = getCallbacks(this, "event:".concat(eventName));

      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }

      storeCallback(this, "event:".concat(eventName), callback);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */

    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */

    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */

  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */

  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */

  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */

    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */

    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */

  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }

      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */

    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */

  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */

    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */

  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */

    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */

  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */

  }, {
    key: "requestFullscreen",
    value: function requestFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.request(this.element);
      }

      return this.callMethod('requestFullscreen');
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */

  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.exit();
      }

      return this.callMethod('exitFullscreen');
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */

  }, {
    key: "getFullscreen",
    value: function getFullscreen() {
      if (screenfull.isEnabled) {
        return npo_src.resolve(screenfull.isFullscreen);
      }

      return this.get('fullscreen');
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "requestPictureInPicture",
    value: function requestPictureInPicture() {
      return this.callMethod('requestPictureInPicture');
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "exitPictureInPicture",
    value: function exitPictureInPicture() {
      return this.callMethod('exitPictureInPicture');
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "getPictureInPicture",
    value: function getPictureInPicture() {
      return this.get('pictureInPicture');
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */

    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */

  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);

        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);

          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }

        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          // If we've added an additional wrapper div, remove that from the DOM.
          // If not, just remove the iframe element.
          if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
            _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
          } else {
            _this5.element.parentNode.removeChild(_this5.element);
          }
        } // If the clip is private there is a case where the element stays the
        // div element. Destroy should reset the div and remove the iframe child.


        if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
          _this5.element.removeAttribute('data-vimeo-initialized');

          var iframe = _this5.element.querySelector('iframe');

          if (iframe && iframe.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
              iframe.parentNode.parentNode.removeChild(iframe.parentNode);
            } else {
              iframe.parentNode.removeChild(iframe);
            }
          }
        }

        _this5._window.removeEventListener('message', _this5._onMessage);

        if (screenfull.isEnabled) {
          screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
        }

        resolve();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */

  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */

  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */

    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */

  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */

    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */

    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */

  }, {
    key: "getCameraProps",
    value: function getCameraProps() {
      return this.get('cameraProps');
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */

    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */

  }, {
    key: "setCameraProps",
    value: function setCameraProps(camera) {
      return this.set('cameraProps', camera);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */

    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */

    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */

  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */

    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */

  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }
    /**
     * A promise to get the color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */

    /**
     * Get the color for this player.
     *
     * @return {GetColorPromise}
     */

  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }
    /**
     * A promise to set the color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */

    /**
     * Set the color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */

    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */

  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */

    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */

    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */

    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */

    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */

  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */

    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */

    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */

    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */

    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */

    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
     */

    /**
     * Get the playback rate of the player on a scale from `0.5` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
     */

    /**
     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */

    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */

  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */

    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */

  }, {
    key: "getQualities",
    value: function getQualities() {
      return this.get('qualities');
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */

    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */

  }, {
    key: "getQuality",
    value: function getQuality() {
      return this.get('quality');
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */

    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */

  }, {
    key: "setQuality",
    value: function setQuality(quality) {
      return this.set('quality', quality);
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */

    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */

  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */

    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */

  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */

    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */

  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */

    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */

  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */

    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */

  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */

    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */

  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */

    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */

  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */

    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */

  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */

    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */

    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */

    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }
  }]);

  return Player;
}(); // Setup embed only if this is not a node environment


if (!isNode) {
  screenfull = initializeScreenfull();
  initializeEmbeds();
  resizeEmbeds();
  initAppendVideoMetadata();
}

/* harmony default export */ var player_es = (Player);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@u-wave+react-vimeo@0.9.8_react@18.0.0/node_modules/@u-wave/react-vimeo/dist/react-vimeo.es.js




function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var eventNames = {
  play: 'onPlay',
  pause: 'onPause',
  ended: 'onEnd',
  timeupdate: 'onTimeUpdate',
  progress: 'onProgress',
  seeked: 'onSeeked',
  texttrackchange: 'onTextTrackChange',
  cuechange: 'onCueChange',
  cuepoint: 'onCuePoint',
  volumechange: 'onVolumeChange',
  playbackratechange: 'onPlaybackRateChange',
  error: 'onError',
  loaded: 'onLoaded'
};

var Vimeo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Vimeo, _React$Component);

  function Vimeo(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.refContainer = _this.refContainer.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Vimeo.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.createPlayer();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // eslint-disable-next-line react/destructuring-assignment
    var changes = Object.keys(this.props).filter(function (name) {
      return _this2.props[name] !== prevProps[name];
    });
    this.updateProps(changes);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.player.destroy();
  }
  /**
   * @private
   */
  ;

  _proto.getInitialOptions = function getInitialOptions() {
    /* eslint-disable react/destructuring-assignment */
    return {
      id: this.props.video,
      width: this.props.width,
      height: this.props.height,
      autopause: this.props.autopause,
      autoplay: this.props.autoplay,
      byline: this.props.showByline,
      color: this.props.color,
      controls: this.props.controls,
      loop: this.props.loop,
      portrait: this.props.showPortrait,
      title: this.props.showTitle,
      muted: this.props.muted,
      background: this.props.background,
      responsive: this.props.responsive,
      dnt: this.props.dnt,
      speed: this.props.speed,
      keyboard: this.props.keyboard,
      pip: this.props.pip,
      playsinline: this.props.playsInline,
      quality: this.props.quality,
      texttrack: this.props.textTrack,
      transparent: this.props.transparent
    };
    /* eslint-enable react/destructuring-assignment */
  }
  /**
   * @private
   */
  ;

  _proto.updateProps = function updateProps(propNames) {
    var _this3 = this;

    var player = this.player;
    propNames.forEach(function (name) {
      // eslint-disable-next-line react/destructuring-assignment
      var value = _this3.props[name];

      switch (name) {
        case 'autopause':
          player.setAutopause(value);
          break;

        case 'color':
          player.setColor(value);
          break;

        case 'loop':
          player.setLoop(value);
          break;

        case 'volume':
          player.setVolume(value);
          break;

        case 'paused':
          player.getPaused().then(function (paused) {
            if (value && !paused) {
              return player.pause();
            }

            if (!value && paused) {
              return player.play();
            }

            return null;
          });
          break;

        case 'width':
        case 'height':
          player.element[name] = value;
          break;

        case 'video':
          if (value) {
            var start = _this3.props.start;
            var loaded = player.loadVideo(value); // Set the start time only when loading a new video.
            // It seems like this has to be done after the video has loaded, else it just starts at
            // the beginning!

            if (typeof start === 'number') {
              loaded.then(function () {
                player.setCurrentTime(start);
              });
            }
          } else {
            player.unload();
          }

          break;

      }
    });
  }
  /**
   * @private
   */
  ;

  _proto.createPlayer = function createPlayer() {
    var _this4 = this;

    var _this$props = this.props,
        start = _this$props.start,
        volume = _this$props.volume;
    this.player = new player_es(this.container, this.getInitialOptions());
    Object.keys(eventNames).forEach(function (dmName) {
      var reactName = eventNames[dmName];

      _this4.player.on(dmName, function (event) {
        // eslint-disable-next-line react/destructuring-assignment
        var handler = _this4.props[reactName];

        if (handler) {
          handler(event);
        }
      });
    });
    var _this$props2 = this.props,
        onError = _this$props2.onError,
        onReady = _this$props2.onReady;
    this.player.ready().then(function () {
      if (onReady) {
        onReady(_this4.player);
      }
    }, function (err) {
      if (onError) {
        onError(err);
      } else {
        throw err;
      }
    });

    if (typeof start === 'number') {
      this.player.setCurrentTime(start);
    }

    if (typeof volume === 'number') {
      this.updateProps(['volume']);
    }
  }
  /**
   * @private
   */
  ;

  _proto.refContainer = function refContainer(container) {
    this.container = container;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        id = _this$props3.id,
        className = _this$props3.className,
        style = _this$props3.style;
    return /*#__PURE__*/react.createElement("div", {
      id: id,
      className: className,
      style: style,
      ref: this.refContainer
    });
  };

  return Vimeo;
}(react.Component);

if (false) {}

Vimeo.defaultProps = {
  autopause: true,
  autoplay: false,
  showByline: true,
  controls: true,
  loop: false,
  showPortrait: true,
  showTitle: true,
  muted: false,
  background: false,
  responsive: false,
  dnt: false,
  speed: false,
  keyboard: true,
  pip: false,
  playsInline: true,
  transparent: true
};



// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazyload@3.2.0_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(29155);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
// EXTERNAL MODULE: ./components/cms/Video/Video.module.scss
var Video_module = __webpack_require__(37881);
var Video_module_default = /*#__PURE__*/__webpack_require__.n(Video_module);
;// CONCATENATED MODULE: ./components/cms/Video/Video.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var Video = function(param) {
    var url = param.url, file = param.file, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _controls = param.controls, controls = _controls === void 0 ? false : _controls, _cover = param.cover, cover = _cover === void 0 ? false : _cover, _loop = param.loop, loop = _loop === void 0 ? false : _loop, hasBorder = param.hasBorder, borderColor = param.borderColor, borderRadius = param.borderRadius;
    var videoRef = (0,react.useRef)(null);
    var progressRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), playing = ref5[0], setPlaying = ref5[1];
    var ref1 = (0,react.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react.useState)(false), muted = ref2[0], setMuted = ref2[1];
    var inDev = "production" === "development";
    var host = "".concat(constants/* SITE_URL */._O, "cdn/");
    var filePath = "";
    if (url) {
        filePath = inDev ? url : url.replace("https://a.storyblok.com/", host);
    }
    var onPlay = function(control) {
        if (control === "play") {
            var ref, ref3;
            (ref3 = (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play()) === null || ref3 === void 0 ? void 0 : ref3.then(function() {
                return setPlaying(true);
            });
        } else if (control === "pause") {
            var ref4;
            (ref4 = videoRef.current) === null || ref4 === void 0 ? void 0 : ref4.pause();
            setPlaying(false);
        }
    };
    var onProgressChange = function(e) {
        var value = Number(e.currentTarget.value);
        setProgress(value);
        if (videoRef.current) {
            var ref;
            videoRef.current.currentTime = value * ((ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.duration) / 100;
        }
    };
    var onMute = function() {
        if (videoRef.current) {
            var isMuted = !videoRef.current.muted;
            videoRef.current.muted = isMuted;
            setMuted(isMuted);
        }
    };
    (0,react.useEffect)(function() {
        if (autoplay && !url) {
            onPlay("play");
            setMuted(autoplay);
        }
    }, [
        autoplay,
        url
    ]);
    if (!url && !file.filename) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Video_module_default()).placeholder,
        children: "Please add a Vimeo URL or Video File"
    });
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        once: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cover ? (Video_module_default()).containerCover : (Video_module_default()).container,
            children: url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
                video: filePath,
                autoplay: autoplay,
                muted: autoplay,
                loop: loop,
                controls: controls,
                responsive: true,
                className: (0,clsx_m/* default */.Z)((_obj = {}, _defineProperty(_obj, (Video_module_default()).hasBorder, hasBorder), _defineProperty(_obj, (Video_module_default())["border--white"], borderColor === "white"), _defineProperty(_obj, (Video_module_default())["border--normal-radius"], borderRadius === "normal"), _obj))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    controls && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Video_module_default()).controls,
                                "data-state": controls ? "visible" : "hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        "data-state": playing ? "pause" : "play",
                                        onClick: function() {
                                            return onPlay(playing ? "pause" : "play");
                                        },
                                        children: "Play/Pause"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Video_module_default()).progress,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            ref: progressRef,
                                            className: (Video_module_default()).seek,
                                            type: "range",
                                            min: "0",
                                            max: "100",
                                            step: "0.01",
                                            value: progress,
                                            autoComplete: "off",
                                            role: "slider",
                                            "aria-label": "Seek",
                                            onInput: onProgressChange,
                                            "aria-valuemin": 0,
                                            "aria-valuemax": 100,
                                            "aria-valuenow": progress
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Video_module_default()).soundControls,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    "data-state": muted ? "unmute" : "mute",
                                    onClick: onMute,
                                    children: "Mute/Unmute"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", _objectSpread({
                        ref: videoRef,
                        id: "".concat(file.id),
                        autoPlay: autoplay,
                        muted: autoplay ? autoplay : muted,
                        preload: "metadata",
                        loop: loop,
                        playsInline: true,
                        className: (0,clsx_m/* default */.Z)((_obj1 = {}, _defineProperty(_obj1, (Video_module_default()).hasBorder, hasBorder), _defineProperty(_obj1, (Video_module_default())["border--white"], borderColor === "white"), _defineProperty(_obj1, (Video_module_default())["border--normal-radius"], borderRadius === "normal"), _obj1))
                    }, controls && {
                        onTimeUpdate: function() {
                            // For mobile browsers, ensure that the progress element's max attribute is set
                            if (!progressRef.current.getAttribute("max")) progressRef.current.setAttribute("max", 100);
                            setProgress(Math.floor(videoRef.current.currentTime / videoRef.current.duration * 100));
                            if (videoRef.current.ended) {
                                if (loop) {
                                    onPlay("play");
                                } else {
                                    // Reset progress
                                    videoRef.current.currentTime = 0;
                                    progressRef.current.value = 0;
                                    setProgress(0);
                                    onPlay("pause");
                                }
                            }
                        }
                    }, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: file.filename,
                            type: "video/mp4"
                        })
                    }))
                ]
            })
        })
    });
};
/* harmony default export */ var Video_Video = (Video);

;// CONCATENATED MODULE: ./components/cms/Video/index.tsx

/* harmony default export */ var cms_Video = (Video_Video);


/***/ }),

/***/ 80772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Button; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Button/Button.module.scss
var Button_module = __webpack_require__(53896);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/global/Button/helpers.tsx

var generateClasses = function(param) {
    var variant = param.variant, size = param.size, muted = param.muted, align = param.align, fit_width_to_content = param.fit_width_to_content, className = param.className, textColor = param.textColor, isActive = param.isActive;
    var classes = [
        (Button_module_default()).buttonText,
        className
    ];
    classes.push((Button_module_default())["size-".concat(size)]);
    if (variant === "primary") classes.push((Button_module_default()).isPrimary);
    if (variant === "secondary") classes.push((Button_module_default()).isSecondary);
    if (variant === "secondary-filled") classes.push((Button_module_default())["isSecondary--filled"]);
    if (variant === "tertiary") classes.push((Button_module_default()).isTertiary);
    if (variant === "ghost") classes.push((Button_module_default()).isGhost);
    if (variant === "asLink") classes.push((Button_module_default()).asLink);
    if (variant === "asLinkActive") classes.push((Button_module_default()).asLinkActive);
    if (variant === "error") classes.push((Button_module_default()).isError);
    if (muted) classes.push((Button_module_default()).isMuted);
    if (align) classes.push((Button_module_default())["align-".concat(align)]);
    if (fit_width_to_content) classes.push((Button_module_default()).fitWidth);
    if (textColor) classes.push((Button_module_default()).forceWhite);
    if (isActive) classes.push((Button_module_default()).isActive);
    return classes.join(" ");
};
/* harmony default export */ var helpers = (generateClasses);

;// CONCATENATED MODULE: ./components/global/Button/Button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "s" : _size, align = _param.align, _block = _param.block, block = _block === void 0 ? false : _block, color = _param.color, children = _param.children, _href = _param.href, href = _href === void 0 ? "" : _href, _fit_width_to_content = _param.fit_width_to_content, fit_width_to_content = _fit_width_to_content === void 0 ? false : _fit_width_to_content, _muted = _param.muted, muted = _muted === void 0 ? false : _muted, type = _param.type, _className = _param.className, className = _className === void 0 ? "" : _className, _title = _param.title, title = _title === void 0 ? "" : _title, callBack = _param.callBack, disabled = _param.disabled, textColor = _param.textColor, isActive = _param.isActive, backgroundColor = _param.backgroundColor, id = _param.id, role = _param.role, tabIndex = _param.tabIndex, ariaLabel = _param.ariaLabel, target = _param.target, _dynamicSize = _param.dynamicSize, dynamicSize = _dynamicSize === void 0 ? true : _dynamicSize, otherProps = _objectWithoutProperties(_param, [
        "variant",
        "size",
        "align",
        "block",
        "color",
        "children",
        "href",
        "fit_width_to_content",
        "muted",
        "type",
        "className",
        "title",
        "callBack",
        "disabled",
        "textColor",
        "isActive",
        "backgroundColor",
        "id",
        "role",
        "tabIndex",
        "ariaLabel",
        "target",
        "dynamicSize"
    ]);
    var classes = helpers({
        variant: variant,
        size: size,
        muted: muted,
        align: align,
        fit_width_to_content: fit_width_to_content,
        className: className,
        textColor: textColor,
        isActive: isActive
    });
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            title: title,
            className: classes,
            style: {
                backgroundColor: backgroundColor
            },
            target: target,
            "aria-label": ariaLabel,
            // @ts-ignore
            onClick: callBack,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Button_module_default()).iconWrapper,
                children: children
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({
        ref: ref,
        id: id !== undefined ? id : null,
        role: role !== undefined ? role : null,
        tabIndex: tabIndex !== undefined ? tabIndex : null,
        title: title,
        type: type,
        className: [
            classes,
            className
        ].join(" "),
        // @ts-ignore
        disabled: disabled,
        onClick: callBack,
        style: {
            backgroundColor: backgroundColor
        },
        "aria-label": ariaLabel
    }, otherProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (Button_module_default()).iconWrapper,
            children: children
        })
    }));
});
Button.displayName = "Button";
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./components/global/Button/index.tsx

/* harmony default export */ var global_Button = (Button_Button);


/***/ }),

/***/ 79697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Card; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Modal/Modal.tsx
var Modal = __webpack_require__(47427);
// EXTERNAL MODULE: ./components/global/Card/Card.module.scss
var Card_module = __webpack_require__(3335);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./components/global/Card/Card.tsx






var parseCSSvars = function(vars) {
    if (!vars) return;
    var style = {};
    var lines = vars.replace(/(\r\n|\r|\n)/gm, "").replace(/(\s)/gm, " ") // Replace the spaces so they won't turn to &nbsp; when applied to the style
    .split(";");
    lines.forEach(function(line) {
        if (!line) return;
        var pair = line.split(":");
        if (pair.length === 2) style[pair[0]] = pair[1].trim();
    });
    return style;
};
var Card = function(param) {
    var children = param.children, tags = param.tags, variant = param.variant, layout = param.layout, growChild = param.growChild, link = param.link, cardHoverEffect = param.cardHoverEffect, fullHeight = param.fullHeight, cssVars = param.cssVars, modal = param.modal, _disableBackground = param.disableBackground, disableBackground = _disableBackground === void 0 ? false : _disableBackground, _imageAsBackground = param.imageAsBackground, imageAsBackground = _imageAsBackground === void 0 ? false : _imageAsBackground, _modalControlled = param.modalControlled, modalControlled = _modalControlled === void 0 ? false : _modalControlled, _modalControlledOpen = param.modalControlledOpen, modalControlledOpen = _modalControlledOpen === void 0 ? false : _modalControlledOpen, modalControlledSetOpen = param.modalControlledSetOpen, _grayscaleEffect = param.grayscaleEffect, grayscaleEffect = _grayscaleEffect === void 0 ? false : _grayscaleEffect;
    var openModal = function openModal() {
        modalControlled ? modalControlledSetOpen(true) : setShowModal(true);
    };
    var closeModal = function closeModal() {
        modalControlled ? modalControlledSetOpen(false) : setShowModal(false);
    };
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var _style = parseCSSvars(cssVars);
    var cardContent;
    // wrap card in link
    if (link) cardContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)((Card_module_default()).link, (Card_module_default()).content, layout && (Card_module_default())["layout-".concat(layout)], growChild && (Card_module_default())["grow-".concat(growChild)]),
            children: children
        })
    });
    // wrap in button for modal
    if (modal) cardContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                style: _style,
                className: (0,clsx_m/* default */.Z)((Card_module_default()).content, (Card_module_default()).buttonWrapper, layout && (Card_module_default())["layout-".concat(layout)], growChild && (Card_module_default())["grow-".concat(growChild)]),
                onClick: modal ? function() {
                    return openModal();
                } : null,
                children: children
            }),
            modal.contentOutsideModal
        ]
    });
    if (!cardContent) cardContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Card_module_default()).content, layout && (Card_module_default())["layout-".concat(layout)], growChild && (Card_module_default())["grow-".concat(growChild)]),
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (0,clsx_m/* default */.Z)((Card_module_default()).container, variant && (Card_module_default())["v-".concat(variant)], cardHoverEffect && (Card_module_default()).cardHoverEffect, fullHeight && (Card_module_default()).fullHeight, disableBackground && (Card_module_default()).disableBackground, imageAsBackground && (Card_module_default()).cardImageAsBackground, grayscaleEffect && (Card_module_default()).grayscaleEffect),
                style: _style,
                children: [
                    cardContent,
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Card_module_default()).tags,
                        children: tags
                    })
                ]
            }),
            modal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                cardModal: true,
                maxWidth: modal.maxWidth || "1140px",
                controlled: true,
                controlledOpen: modalControlled ? modalControlledOpen : showModal,
                controlledSetOpen: modalControlled ? modalControlledSetOpen : setShowModal,
                ModalTitle: modal.modalTitle,
                ModalButtonLabel: modal.modalButtonLabel,
                children: modal.modalContent
            })
        ]
    });
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ./components/global/Card/index.tsx

/* harmony default export */ var global_Card = (Card_Card);


/***/ }),

/***/ 24125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _components_global_InputErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5937);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32486);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36709);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var name = param.name, id = param.id, value = param.value, label = param.label, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, isRequired = param.isRequired, isChecked = param.isChecked, isDisabled = param.isDisabled, error = param.error, subLabel = param.subLabel, boxContent = param.boxContent, isPanel = param.isPanel, isBordered = param.isBordered, link = param.link, tag = param.tag, hideLabel = param.hideLabel, padding = param.padding, isSmall = param.isSmall, isLarge = param.isLarge, hideCheckbox = param.hideCheckbox, ariaLabel = param.ariaLabel, count = param.count, discount = param.discount, recommended = param.recommended;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Checkbox), _defineProperty({}, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["padding-".concat(padding)], padding)),
                onClick: function(ev) {
                    return ev.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        className: "visually-hidden",
                        type: "checkbox",
                        name: name,
                        id: id,
                        value: value,
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        required: isRequired,
                        checked: isChecked,
                        disabled: isDisabled,
                        ref: ref,
                        "aria-label": typeof label === "string" ? label : ariaLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel), (_obj = {}, _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--Panel"]), isPanel), _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--Border"]), isBordered), _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--Small"]), isSmall), _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--disabled"]), isDisabled), _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--hideCheckbox"]), hideCheckbox), _defineProperty(_obj, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["CheckboxLabel--discount"]), count), _obj)),
                        htmlFor: id,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__Content),
                            children: [
                                boxContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__BoxContent),
                                    children: boxContent
                                }),
                                !hideLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        tag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__Tag),
                                            children: tag
                                        }),
                                        label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: isLarge ? (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__LabelLarge) : (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__Label),
                                            children: label
                                        }),
                                        subLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxLabel__SubLabel),
                                            children: subLabel
                                        }),
                                        link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: link,
                                            className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Checkbox__SubLink),
                                            children: "Learn more"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    count && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().DiscountWrapper), _defineProperty({}, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["DiscountWrapper--recommended"]), recommended)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                id: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Label),
                                children: discount ? "".concat(count, " Styles \u2192 ").concat(discount, " OFF") : "".concat(count, " Styles")
                            }),
                            recommended && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                id: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Label),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Recommended"
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_InputErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                error: error
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 98188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Checkbox__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24125);



/***/ }),

/***/ 1500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PanelIcons": function() { return /* binding */ PanelIcons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(623);
/* harmony import */ var _CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var PanelIcons = function(param) {
    var iconName = param.iconName;
    var Icons = {
        broadcast: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlSpace: "preserve",
            viewBox: "0 0 400 400",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "M230.972 238.677c.33-.026.683-.363 1.014-.395l5.051-.434.197-.018c.822-.096 1.836-.416 2.795-.746.201-.08.305-.29.503-.371.198-.082.5-.035.701-.118 1.683-.758 3.288-1.741 4.781-2.844.312-.219.749-.218 1.052-.46.24-.202.315-.665.55-.865a29.82 29.82 0 0 0 3.462-3.654c.718-.754 1.264-1.681 1.911-2.53.132-.18.107-.411.237-.593.133-.179.388-.337.506-.528l1.455-2.469 1.238-2.593c.16-.357.62-.537.748-.914.113-.3-.041-.758.068-1.057l.928-2.457c.268-.821.48-1.646.715-2.442.303-1.024.652-2.044.883-3.135.055-.224-.053-.44 0-.667.052-.225.269-.46.32-.686.221-.956.461-1.913.664-2.874.176-.964.35-1.928.523-2.885.072-.395.436-.694.508-1.089.066-.319-.199-.732-.161-1.053.216-1.781.477-3.52.536-5.18.091-1.063.182-2.146.172-3.231.006-.226-.146-.409-.145-.636s.164-.5.166-.728c.025-.964-.081-1.914-.115-2.872-.046-.957-.219-1.885-.32-2.822-.058-.381.16-.766.088-1.146-.063-.308-.434-.591-.499-.892-.427-1.651-.955-3.229-1.683-4.543-.475-.861-.928-1.586-1.606-2.189a.369.369 0 0 0-.081-.054c-.094-.033-.317-.093-.454-.211-.179-.155-.29-.462-.47-.617l-4.535-3.946c-.311-.27-.385-.737-.691-1.005-.25-.217-.74-.233-.992-.447a141.754 141.754 0 0 1-4.029-3.547l-2.459-2.287c-.171-.162-.414-.177-.589-.337s-.276-.469-.451-.629c-1.46-1.372-2.978-2.703-4.401-4.099-.295-.287-.346-.762-.638-1.047-.237-.23-.722-.273-.962-.501l-3.871-3.726c-.779-.783-1.6-1.552-2.37-2.381-.161-.172-.403-.199-.567-.37-.166-.171-.25-.485-.416-.656l-4.181-4.331c-.286-.296-.318-.768-.603-1.061-.229-.24-.723-.295-.945-.541a9176.553 9176.553 0 0 1-3.641-3.957l-2.248-2.502c-.156-.176-.398-.215-.559-.39-.156-.179-.221-.501-.375-.681-1.304-1.527-2.615-3.066-3.911-4.585-.268-.313-.271-.786-.536-1.097-.216-.252-.699-.344-.918-.594a9440.612 9440.612 0 0 0-3.395-4.175l-2.085-2.643c-.14-.189-.376-.247-.519-.438-.143-.189-.189-.514-.332-.703l-3.625-4.818c-.25-.328-.207-.811-.445-1.143-.193-.271-.662-.4-.857-.668l-3.139-4.375-1.855-2.809c-.129-.197-.363-.27-.494-.468-.133-.197-.16-.521-.291-.719-1.129-1.662-2.193-3.382-3.27-5.063-.221-.348-.158-.818-.377-1.163-.178-.28-.643-.437-.824-.716l-1.579-2.561c.174 1.124.331 2.252.462 3.387.175 1.857.393 3.715.478 5.565l-.512.962c.138.175.305.336.42.527.321.518.36 1.094.053 1.634-.241.413-.045.962.021 1.437.019.108.005.222.015.334.015.328-.48.479-.322.775.156.293.383.554.574.848l.007 3.815-.087 3.796c-.145.217-.266.403-.401.578-.312.383-.397.767-.089 1.195.288.403.282.424-.005.8-.14.184-.278.361-.291.578-.05.769-.145 1.537-.062 2.304.034.298.423.514.321.85-.061.199-.273.349-.4.531a.658.658 0 0 0-.104.305c-.048.549-.075 1.101-.137 1.65-.066.469.113.85.343 1.241.213.353.198.599-.056.901-.115.139-.041.248-.136.395-.056.174-.326.859-.323 1.056-.008.335-.061.663-.1.993-.294 2.637-.598 5.273-.975 7.898-.256 1.972-.594 3.932-.886 5.899-.343 1.958-.662 3.922-1.036 5.874-.342 1.733-.647 3.476-1.018 5.18-.258.25-.496.479-.732.709.087.204.205.402.267.612.171.565.077 1.093-.341 1.515-.326.312-.26.903-.318 1.372-.01.109-.053.215-.07.324-.068.319-.587.345-.508.669.076.318.23.624.354.954-.389 1.743-.814 3.48-1.244 5.21l.004.018.011.04.004.043-.002.046-.006.047-.022.1-.027.104-.028.107-.02.108-.004.054.001.053.006.053.014.051-.064.051-.059.054-.05.052-.267 1.074.002.034.003.104-.005.105-.014.106-.025.108-.102.358-.058.177-.065.173-.008.014-.01.013-.027.025-.027.025-.012.014-.01.014-.072.121-.041.058-.043.056-.047.053-.051.049-.057.046-.062.04-.09.056-.029.023c.152.358.135.433-.133.665l.071.322.032.176c.004.053.009.1.014.144v.063l-.004.062-.008.061-.012.063c-.012.042-.023.088-.036.139l-.053.171-.054.174-.047.177-.095.354-.057.172-.069.166-.041.08-.046.077-.052.076-.058.072-.017.022-.02.033-.049.093-.127.28a27.48 27.48 0 0 1-.128.316c.049.131.078.263.003.397a.804.804 0 0 1-.232.233l-.094.278-.115.4-.041.177c-.01.056-.02.107-.027.153l-.008.066-.004.06.001.051.005.042-.15.555.002.001-.375 1.235c-.027.086.1.201.074.288a.168.168 0 0 1-.061.075c.125.365.064.598-.23.838-.14.113-.088.235-.207.36a9.58 9.58 0 0 1-.119.196c-.104.323-.197.651-.304.971-.024.074-.119.122-.214.17l-.133.412c.051.086.102.172.084.232l-.62 1.965c-.397 1.242-.858 2.689-1.347 4.214l-.012.046-.01.055-.017.127-.022.304c-.009.105-.017.211-.023.305l-.018.128-.01.055-.013.047-.032.092-.033.084a7.137 7.137 0 0 1-.072.148l-.076.131-.077.121-.077.122a6.69 6.69 0 0 0-.076.131l-.071.149-.034.085-.031.093-.246.776-.653 2.048-.536 1.498-.01.019-.013.017-.017.013-.019.01-.022.008-.024.005-.058.003-.062-.001-.026-.002-.12.352c-.684 1.865-1.349 3.738-2.055 5.595-.64 1.647-1.254 3.305-1.91 4.922l-.846.568c.05.217.131.433.154.65.068.586-.116 1.09-.602 1.431-.376.25-.418.844-.553 1.297-.029.105-.09.202-.127.307-.123.303-.639.236-.618.569.02.327.117.654.179 1.001-.975 2.331-2.029 4.645-3.059 6.932-.223.141-.402.268-.596.375-.434.232-.661.553-.541 1.066.111.482.098.499-.312.734-.2.116-.396.227-.491.421-.348.686-.717 1.364-.934 2.104-.084.287.195.635-.027.906-.133.16-.387.218-.574.337a.645.645 0 0 0-.211.242c-.256.489-.492.988-.758 1.472-.229.413-.209.834-.146 1.282.062.406-.046.628-.396.812-.16.084-.133.214-.276.313h-.001c-.117.139-.629.67-.701.853-.135.307-.312.589-.469.882-1.27 2.332-2.559 4.654-3.922 6.938-2.045 3.424-4.157 6.811-6.483 10.084-1.05 1.532-2.201 3.03-3.313 4.509l-.945.276c-.031.244-.037.502-.095.739-.151.642-.503 1.11-1.034 1.269-.403.107-.685.691-.976 1.115-.065.1-.153.176-.226.27-.223.268-.604-.047-.721.317-.117.358-.176.758-.275 1.165-.133.146-.271.287-.404.433l1.693-.765c.376-.166.834-.033 1.207-.197.305-.133.527-.566.829-.703 1.694-.739 3.331-1.492 4.924-2.153l3.116-1.271c.219-.088.336-.303.555-.395.221-.089.54-.057.762-.141l5.628-2.173c.383-.153.836.018 1.221-.122.313-.111.565-.527.878-.643l5.07-1.822 3.216-1.01c.226-.069.36-.273.587-.347s.545-.009.771-.081c1.91-.635 3.866-1.161 5.787-1.717.396-.112.83.08 1.225-.031.318-.092.602-.492.921-.588 1.774-.539 3.538-.939 5.206-1.382l3.275-.791c.229-.055.379-.25.609-.308.23-.057.543.025.775-.02l5.9-1.247c.404-.086.822.138 1.222.052.325-.068.636-.449.96-.522l5.292-.978 3.317-.566c.232-.038.395-.223.629-.265.232-.045.54.073.774.039l5.964-.848c.408-.059.811.191 1.215.134.328-.048.662-.406.99-.458 1.828-.294 3.626-.441 5.334-.665l3.342-.35c.234-.023.407-.197.643-.223.236-.026.535.1.771.073 1.992-.241 4.007-.365 5.993-.536.413-.027.8.248 1.208.215zM268.628 260.343l-3.158-.755-.068.092-.102.126-.107.118-.01.009-.014.007-.03.011-.032.01-.014.007-.014.008-.1.073-.052.032-.055.03-.058.025-.061.021-.063.016-.067.01a2.004 2.004 0 0 1-.098.012l-.083.021-.036.013-.034.016-.03.018-.027.02-.024.022-.021.024-.02.027-.016.029-.012.031-.01.035-.007.037-.005.039-.037.477-.02.16c-.01.046-.02.086-.027.125l-.017.053-.021.051-.023.048-.029.048-.07.102-.096.122-.097.125-.092.13-.183.258-.1.121-.053.058-.057.055-.059.052-.063.047-.067.043-.073.039-.021.012-.027.021-.07.059-.192.187-.24.252-.258.293-.251.305-.216.291-.086.131-.068.117-.025.053-.02.048-.013.042-.006.037-.292.405.002.001-1.971 2.638c-.141.185-.127.425-.264.612-.139.187-.432.316-.568.504l-3.506 4.742c-.24.325-.697.432-.935.754-.097.131-.138.316-.179.503l-.016.069-.008.035-.004.017-.002.005v.002l-.389.384-.002.001-.014.014-.17.172a1.409 1.409 0 0 1-.336.244c-.352.156-.707.368-1.523.376a3.592 3.592 0 0 1-.295-.019 2.644 2.644 0 0 1-.393-.101 2.613 2.613 0 0 1-.537-.245l-.288-.183-1.142-.724-.799-.504a.71.71 0 0 1-.48.553c-.195.08-.374.194-.568.287.079.955.062.953-.299 1.539l-4.223 6.902-.922.432c.121.58.064 1.109-.291 1.564-.129.174-.231.371-.352.55-.061.091-.129.173-.189.252l-.991.402c-.587.842-1.14 1.773-1.748 2.66-.265.388-.263.805-.225 1.246a.68.68 0 0 1-.508.727c-.435.126-.786.34-1.025.734a88.005 88.005 0 0 1-1.584 2.461c-.323.479-.563.983-.484 1.618.006.061-.104.183-.174.208-.696.211-1.137.617-1.283 1.294a2.444 2.444 0 0 0-.058.488c-.012.451-.188.605-.51.675-.224.037-.338.079-.469.271-1.037 1.527-1.957 3.124-3.301 4.352-1.334 1.23-2.961 2.087-4.67 2.614-1.715.522-3.495.771-5.297.991-.897.11-1.82.217-2.711.367-.848.145-1.472.311-2.091.55a6.702 6.702 0 0 0-.825-.249 7.864 7.864 0 0 0-.143.549c-.074.262-.225.358-.512.32a2.364 2.364 0 0 0-.504.007c.029.798.068.768-.213 1.153-.93 1.463-1.406 4.403-1.256 6.305-.16.239-.305.466-.449.711.209.132.439.222.578.349.158.114.201.284.277.438.045.124.123.235.178.354a.59.59 0 0 0 .084.175c-.051.24-.094.495-.135.84.51.572 1.221 1.075 2.037 1.536.346.211.756.123 1.136.009a.583.583 0 0 1 .715.335c.184.383.428.691.851.814.879.284 1.775.556 2.678.83.522.153 1.029.213 1.543-.076.049-.026.186.036.229.094.482.717 1.146.979 1.945.646.37-.16.557-.055.746.228.123.2.205.295.414.348.82.189 1.681.41 2.455.564l2.324.469 2.316.367c.771.103 1.547.164 2.316.248 3.064.235 6.285-.064 9.067-1.646l.942.141c.086-.22.154-.439.244-.643.141-.32.347-.498.68-.447.186.021.373-.001.567.004.292-.94.259-.965.741-1.374 1.834-1.671 3.439-3.573 4.965-5.449.333-.083.633-.171.938-.269-.053-.586.057-1.093.455-1.488.146-.151.268-.33.398-.493.067-.082.142-.155.208-.226l1.005-.309c.641-.792 1.254-1.677 1.919-2.512.29-.365.317-.782.311-1.225a.671.671 0 0 1 .554-.683c.439-.091.804-.277 1.068-.65a83.682 83.682 0 0 1 1.74-2.325c.342-.436.589-.888.516-1.479-.006-.055.105-.16.176-.18.854-.184 1.355-.694 1.355-1.561-.004-.405.168-.542.502-.61.234-.038.354-.079.484-.256 4.062-5.604 7.752-10.974 11.844-16.562l.975-.354c-.002-.23-.021-.456-.007-.678.042-.337.204-.587.565-.686.198-.062.385-.159.584-.233.004-.965.02-.961.426-1.514 1.602-2.181 3.164-4.388 4.823-6.479l.97-.338c-.062-.584.049-1.102.453-1.518.148-.158.271-.344.404-.514.068-.086.144-.162.211-.236l1.02-.316c.657-.791 1.287-1.675 1.969-2.51.297-.365.333-.784.336-1.231a.683.683 0 0 1 .568-.684c.44-.087.808-.269 1.08-.642.492-.674.996-1.308 1.506-1.937l-7.156-1.719c-4.326-1.04-8.668-2.08-13.002-3.118z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "M324.061 249.786c.14-.191.251-.406.374-.607l.195-.285.971-.576c.543-1.006 1.045-2.104 1.607-3.162.258-.455.168-.929.076-1.393a.82.82 0 0 1 .404-.899c.417-.236.74-.553.926-1.034.379-1.029.857-2.006 1.184-3.054.208-.591.322-1.164.086-1.758-.021-.057.057-.209.119-.256.777-.519 1.123-1.257.877-2.159-.114-.418.018-.623.33-.827.224-.13.317-.224.384-.46h-.001c2.223-7.454 3.34-14.801 2.836-22.318.197-.378.355-.681.514-.982-.15-.188-.311-.355-.441-.543-.174-.303-.25-.602-.068-.943.096-.193.154-.408.24-.617-.691-.722-.676-.715-.789-1.432-.572-2.772-1.367-5.527-2.687-7.979.044-.412.049-.756.052-1.109-.579-.154-1.021-.438-1.273-.992-.102-.203-.26-.374-.387-.56-.065-.093-.119-.191-.174-.281l-.057-1.167c-.344-.43-.707-.863-1.087-1.288-.412-.396-.796-.827-1.234-1.203-.366-.346-.819-.387-1.295-.374-.407.056-.736-.074-.849-.361-.157-.374-.428-.666-.897-.828-.994-.35-1.966-.717-2.937-1.093-.553-.218-1.104-.345-1.691-.124-.057.02-.195-.059-.234-.121-.418-.767-1.176-1.151-2.107-.945-.435.096-.641-.045-.832-.364-.124-.224-.21-.335-.444-.425l-21.925-8.064-.722-.888c-.246.055-.481.126-.724.161-.375.036-.701-.068-.934-.404-.135-.185-.306-.348-.455-.529-1.035.217-1.035.201-1.771-.077l-8.646-3.24-.718-.868c-.598.209-1.188.231-1.779-.061-.223-.106-.466-.18-.695-.268-.117-.045-.226-.1-.329-.146l-.72-.926c-1.086-.446-2.26-.842-3.402-1.302a1.581 1.581 0 0 0-.275-.077l.07.094c.3.396.504.846.76 1.268.461.866 1.035 1.698 1.35 2.626.361.91.746 1.822 1.081 2.751l.735 2.857-.325 1.069c.188.175.341.339.491.526.207.302.269.637.082.999-.099.206-.162.43-.253.644.676.789.663.806.761 1.574.129.761.143 1.517.156 2.271l.057 2.266c-.002.75.084 1.512.006 2.248l-.157 2.211-.626.9c.371.498.561 1.048.449 1.676-.039.236-.039.482-.059.72-.016.12-.049.232-.072.34-.24.275-.477.546-.757.869-.209 1.102-.35 2.275-.562 3.432-.09.504.074.921.282 1.351.156.344.092.725-.192.951-.376.307-.644.664-.744 1.154-.221 1.04-.463 2.07-.716 3.099-.147.588-.202 1.148.091 1.712.025.053-.036.209-.094.259-.711.565-.979 1.285-.721 2.154.129.405.004.611-.301.813-.215.131-.317.219-.39.447-.546 1.81-1.085 3.593-1.621 5.363l-1.977 5.187-.493 1.295c-.18.427-.396.84-.592 1.261l-1.213 2.521c-.425.834-.777 1.706-1.271 2.517l-1.487 2.451-.985.504c.01.248.035.491.025.733-.041.367-.178.675-.574.8-.215.078-.418.193-.633.283-.059 1.02-.079 1.022-.544 1.633l-1.374 1.814c-.457.604-1.021 1.131-1.525 1.697l-1.557 1.664c-.512.559-1.134 1.014-1.693 1.52l-1.096.203c-.113.611-.354 1.188-.94 1.506-.216.123-.415.28-.62.419-.104.07-.211.129-.311.187-.373.023-.734.045-1.165.055-.944.668-2.032 1.244-3.119 1.801-.477.235-.716.646-.987 1.033a.882.882 0 0 1-.962.36 2.291 2.291 0 0 0-.947-.056l13.695 3.185.827.79c.236-.084.461-.184.697-.249.369-.082.704-.019.977.286.156.166.347.307.518.469 1-.344 1.002-.328 1.766-.143 3.012.72 6.027 1.439 8.981 2.146l.819.772c.568-.281 1.15-.377 1.773-.16.234.078.484.12.723.18.121.03.236.07.346.105l.828.829c1.133.309 2.347.556 3.537.871.52.136.961.007 1.413-.164a.862.862 0 0 1 .978.267c.312.38.684.653 1.199.764 1.094.239 2.176.5 3.256.771.619.158 1.207.223 1.786-.063.055-.025.218.039.271.098.604.733 1.374 1.013 2.278.694.419-.148.641-.034.871.259.15.208.249.305.492.366l10.698 2.478c.214.063.435.082.658.056a5.49 5.49 0 0 0 .665-.057c.444-.041.881-.133 1.316-.227.867-.2 1.73-.447 2.555-.798.848-.294 1.629-.746 2.437-1.144.774-.459 1.544-.94 2.292-1.456l1.021-.044c.085-.244.148-.487.241-.712.156-.34.396-.536.769-.537.2-.016.4-.077.609-.11.27-1.045.271-1.027.8-1.523.538-.468.984-1.024 1.454-1.557.459-.54.947-1.057 1.381-1.613l1.238-1.711c.408-.571.834-1.112 1.189-1.753l.957-.503c-.101-.621-.03-1.182.352-1.686zM177.261 174.813l.234-.881.115-.431.057-.212.028-.105.015-.053.007-.026.003-.013.002-.007.002-.003c-.182-.211-.189-.221-.219-.254l.001-.002-.973-.285-.269-.072-.261-.056-.243-.04-.111-.012-.104-.006-.027-.002-.029-.005-.064-.018-.072-.026-.076-.035-.166-.084-.174-.098-.176-.091-.165-.079-.076-.031-.07-.023-.063-.014-.028-.003-.026-.001-.332.004-.383-.01-.355-.014-.142-.013-.104-.016-1.085-.233-.285-.073-.211-.063c-.066-.021-.133-.04-.211-.063l-.287-.073-.435-.083-.659-.107v-.003a37.201 37.201 0 0 0-4.396-.359 40.532 40.532 0 0 0-4.549.144c-.205.021-.367-.034-.547-.174-.153-.124-.336-.168-.508-.252-.145.149-.282.294-.428.446-.07.064-.158.106-.246.178-1.414.205-3.219.453-4.267.877-1.319.488-2.284 1.079-3.094 1.857-.78.786-1.468 1.811-1.599 3.309-.016.171-.082.289-.26.408-.16.102-.228.25-.327.383.157.152.315.293.476.43.074.067.121.144.195.224.201 1.188.734 2.579 1.459 3.571.758 1.088 1.731 2.078 2.711 2.952.998.882 2.086 1.728 3.58 2.745a.753.753 0 0 1 .319.48c.043.191.157.348.237.523l.619-.066c.098-.006.194.018.309.022 1.255.774 2.765 1.796 4.097 2.442.295.138.593.277.893.419l.915.405.461.199.467.189.932.372.931.351.923.328.904.311.445.146.219.072.109.036.054.019.027.009.013.005.008.002.003.001.323-.085.002.001.324-.905.082-.25c.025-.083.05-.164.072-.242l.057-.228.019-.104.013-.098.004-.026.007-.027.022-.061.03-.065.039-.069.095-.149.107-.155.105-.155c.033-.052.064-.102.094-.147l.037-.068.029-.063.02-.059.006-.027.002-.024.025-.315.044-.362.054-.334.027-.132a5.27 5.27 0 0 0 .027-.097l.209-.599c.062-.16.111-.288.15-.394l.111-.258c.034-.069.062-.13.092-.188l.092-.189.111-.258a23.207 23.207 0 0 0 .361-.993l.002.001c.498-1.441.682-2.304 1.162-3.868.027-.091.107-.141.275-.168.148-.021.235-.08.354-.121l-.319-.324c-.045-.051-.062-.1-.104-.16.163-.645.539-1.377.71-2.014h-.001l.983-3.688.478-1.822zM342.374 232.091l.076-.572-.076.572zM341.13 235.48v-.009c.002.002.008.006-.002.006-.005.001.004.002.002.003z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M245.029 267.061c.217.246.382.54.624.811.272.252.473.567.799.805.525.501 1.41 1.056 2.09 1.497.816.521 1.547.986 2.236 1.427.185.115.36.226.54.337l.64-.897 1.668-2.325a.918.918 0 0 1 .545-.374c.209-.052.387-.181.581-.271.009-.229-.001-.458.015-.686.009-.108.049-.214.072-.341 1.007-1.396 2.382-2.988 3.383-4.367l2.987-4.226c-.559.079-1.079-.048-1.505-.446-.35-.344-1.008-.316-1.533-.389-.121-.014-.24-.06-.363-.082-.357-.08-.393-.602-.754-.535-.355.066-.693.21-1.06.321l-8.257-1.971c-.209-.194-.391-.349-.557-.521-.188-.2-.387-.338-.607-.398a1.237 1.237 0 0 0-.021.055l-.111.29-.139.392-.191.596-.271.9-.004-.001a217.848 217.848 0 0 0-1.38 4.931c-.292 1.303-.511 2.653-.055 4.116.058.167.03.315-.072.514-.095.173-.056.336-.083.517l.547.195c.085.027.128.09.236.126zM250.874 272.562l-.021.031-.005.007-.003.004.375-.368c-.055.012-.059.024-.054.014.015-.013.036-.019.067-.041l.04-.025.001-.001.007-.005c.018-.012-.005.002-.005.004l-.003.002-.054.053c.055-.01.16-.019.357.002.129-.017.357.094.47.154l-.001-.001-.25-.155-.478-.299-.093.131-.35.493z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M251.233 272.208c-.031.022-.053.028-.067.041-.005.011-.001-.002.054-.014l.054-.053-.041.026z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "m251.281 272.177-.007.005-.001.001.003-.002c0-.002.023-.016.005-.004z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m254.99 239.913 1.81-1.939c.565-.68 1.075-1.41 1.611-2.104l.973-.344c.01-.224-.014-.452.02-.667.042-.291.14-.545.299-.754.147-.219.339-.406.607-.533.41-.188.561-.778.766-1.215.044-.102.118-.19.172-.29.168-.286.67-.149.701-.488.031-.332-.017-.673-.029-1.023.715-1.062 1.209-2.269 1.794-3.413.55-1.166 1.173-2.289 1.658-3.475.212-.155.382-.296.567-.417.417-.264.627-.613.478-1.134-.139-.488-.128-.503.268-.776.192-.134.384-.265.468-.472.305-.731.646-1.458.798-2.234.054-.305-.238-.609-.062-.921.105-.184.345-.28.511-.433a.673.673 0 0 0 .171-.282c.176-.543.333-1.093.521-1.632.165-.461.07-.887-.071-1.326-.134-.398-.068-.64.245-.896.143-.117.093-.241.217-.37.09-.162.503-.805.541-1.005.079-.335.204-.656.308-.983.63-2.664 1.288-5.329 1.846-8.002l.941-6.053c.12-2.024.329-4.051.388-6.064l-.07-2.676c-.033-.888.004-1.784-.156-2.641l.453-.905c-.15-.168-.328-.317-.457-.495-.349-.477-.435-.993-.184-1.548.227-.426-.111-.936-.275-1.375-.041-.102-.053-.213-.086-.319-.085-.311.365-.567.146-.823-.214-.249-.489-.444-.746-.671-.083-.299-.136-.61-.245-.897l-.341-.855-.675-1.713c-.229-.566-.575-1.064-.852-1.601-.303-.519-.548-1.078-.936-1.528-.009-.247-.03-.456-.029-.671.009-.478-.172-.836-.661-.947-.462-.1-.489-.086-.542-.539-.029-.219-.06-.438-.204-.591-.257-.27-.491-.566-.769-.814a6.208 6.208 0 0 0-.922-.622c-.258-.133-.629.067-.838-.182-.076-.08-.115-.196-.15-.318a1.83 1.83 0 0 0-.403.087c-.058.019-.212-.065-.258-.13-.51-.803-1.239-1.176-2.175-.971-.434.095-.641-.046-.832-.365-.123-.225-.21-.334-.445-.426l.156-.406c-.164-.048-.326-.1-.494-.128-.205-.043-.398.075-.602.034-.201-.05-.426-.235-.637-.251-1.759-.217-3.568-.042-5.294.474-.356.089-.763-.059-1.124.061-.232.074-.408.351-.605.53.367.312.731.618 1.098.923l4.121 3.473a.93.93 0 0 1 .334.578c.038.213.154.402.231.605.228.027.459.038.685.071.108.019.211.067.336.102.529.448.996.88 1.637 1.47 1.074.942 1.848 2.295 2.418 3.309 1.056 1.99 1.51 3.625 2.006 5.289.176.837.393 1.686.551 2.605.113.92.312 1.915.378 3.035.019.259-.037.461-.179.676-.127.183-.182.406-.273.609.14.19.294.374.428.572.062.096.1.21.162.332.037 1.82-.137 4.031-.295 5.798-.327 4.1-.641 6.43-1.404 10.748-.036.251-.156.421-.35.586-.172.138-.285.333-.43.501.082.216.181.427.256.646.035.105.039.222.066.351a60.39 60.39 0 0 1-.707 2.772c-.252.951-.616 1.895-.848 2.75-.307.984-.531 1.877-.819 2.701-.302.821-.585 1.596-.872 2.379-.512 1.591-1.311 3.124-2.241 5.159a1.029 1.029 0 0 1-.524.468c-.209.086-.379.242-.568.363.012.234.041.471.043.708 0 .114-.032.229-.047.364-.229.397-.479.811-.74 1.23-.283.409-.604.809-.91 1.216-.627.804-1.208 1.632-1.823 2.311-1.333 1.631-2.515 2.812-3.753 3.991-1.284 1.132-2.625 2.283-4.607 3.471a1.029 1.029 0 0 1-.692.157c-.224-.032-.441.036-.675.03-.121.204-.229.419-.36.621-.065.097-.157.177-.247.283-.418.219-.869.432-1.355.606-.48.183-.967.379-1.482.52-.998.319-2.053.565-3.113.718l.001.003-.3.024c-3.043.234-5.055.451-7.746.709a18.03 18.03 0 0 0 1.586 2.21c.227.302.244.733.505 1.014.213.226.665.265.898.45a14.899 14.899 0 0 0 3.896 2.591l.713.166c.249-.015.498-.014.746-.02.633-.063 1.271-.115 1.902-.228.631-.141 1.27-.224 1.893-.406l1.863-.553 1.807-.74c3.579-1.565 6.763-4.019 9.535-6.85zM139.392 255.11c.067-.354.227-.582.549-.615.18-.025.352-.095.536-.138.075-1.016.08-.998.479-1.502.766-1.001 1.498-2.024 2.24-3.031a8616.98 8616.98 0 0 1 2.229-3.232l.932-.403c-.105-.581-.037-1.104.33-1.546.135-.169.242-.362.361-.54.06-.091.129-.173.189-.251l.982-.409c.572-.855 1.105-1.801 1.696-2.703.261-.392.233-.818.179-1.258a.678.678 0 0 1 .475-.749c.428-.146.771-.376.992-.782l1.441-2.557c.279-.484.465-.973.312-1.551-.012-.055.083-.176.15-.205.828-.303 1.246-.894 1.112-1.765-.062-.403.09-.563.413-.681.226-.073.339-.132.444-.326 3.228-6.18 5.873-12.219 8.556-18.632l.863-.581c-.057-.225-.131-.441-.169-.66-.041-.34.057-.623.384-.809.178-.108.336-.25.512-.373-.229-.94-.215-.938.048-1.577.995-2.531 1.985-5.067 2.888-7.579l.82-.613c-.234-.542-.285-1.068-.027-1.588.074-.154.125-.322.182-.485l-.141-.062-.014-.009-.015-.011-.026-.029-.026-.029-.015-.014-.015-.012-.13-.083-.062-.046-.06-.048-.056-.052-.052-.056-.047-.061-.041-.066c-.021-.033-.039-.065-.057-.095l-.061-.079-.031-.034-.033-.029-.033-.027-.035-.023-.037-.02-.037-.017-.039-.014-.041-.01-.042-.006-.044-.003h-.046l-.048.004-.571.058-.194.011-.158-.002-.07-.007-.067-.011-.066-.016-.068-.02-.149-.055a40.68 40.68 0 0 0-.182-.077l-.186-.078-.189-.072-.379-.145-.183-.081-.089-.045-.086-.05-.084-.054-.08-.06-.076-.064-.074-.069-.022-.021-.034-.025c-.026-.019-.059-.04-.096-.065a65.913 65.913 0 0 1-.292-.173l-.825-.448c-.151-.076-.303-.152-.449-.227l-.419-.192-.184-.079-.161-.061c-.05-.016-.094-.028-.133-.039l-.055-.01-.047-.004a81.16 81.16 0 0 0-.575-.272l-.001.002a57.4 57.4 0 0 1-2.695-1.461c-.185-.11-.412-.065-.6-.175-.188-.111-.334-.373-.517-.49a44.49 44.49 0 0 1-4.542-3.173c-.301-.236-.363-.689-.648-.937-.232-.196-.702-.197-.933-.41a26.852 26.852 0 0 1-1.831-1.818c-.288-.303-.562-.644-.879-1.014-.284-.369-.576-.729-.83-1.106a14.434 14.434 0 0 1-1.648-3.118c-.094-.226-.297-.392-.375-.631-.081-.239-.005-.544-.054-.784-.494-2.02-.28-4.244.753-6.052.219-.371.685-.546.943-.864.188-.274.211-.716.436-.982 1.346-1.378 3.027-2.329 4.717-2.999.55-.203 1.105-.396 1.686-.552.556-.163 1.053-.269 1.586-.39.218-.044.363-.225.585-.268.222-.04.514.057.732.028a38.22 38.22 0 0 1 5.565-.437c.381-.004.711.312 1.084.314.302 0 .656-.291.961-.283 1.693.063 3.334.21 4.89.404l1.116.155 1.189.19.616.105.629.115 1.288.253.051.008.061.007.143.006.336-.002.336.005.144.01.062.007.052.01.201.057.172.064.151.068.143.072.295.141.172.067.2.061.874.225.1.028c.457-1.944.905-3.9 1.349-5.891l.75-.724c-.096-.211-.206-.411-.282-.621-.1-.327-.055-.623.234-.863.157-.138.287-.306.439-.456-.393-.887-.377-.888-.231-1.562.54-2.666 1.07-5.337 1.514-7.965l.698-.748c-.326-.491-.47-1-.307-1.557.057-.209.082-.43.115-.644.018-.108.047-.211.07-.308l.738-.77c.193-1.015.317-2.097.512-3.162.082-.465-.104-.847-.324-1.232a.684.684 0 0 1 .15-.876c.339-.3.566-.646.615-1.107l.357-2.918c.072-.556.057-1.078-.305-1.556-.032-.047.01-.194.061-.247.641-.598.825-1.301.365-2.057-.21-.35-.131-.555.122-.787.182-.153.265-.25.286-.471.631-6.94.822-13.519.617-20.415l.552-.878c-.144-.184-.298-.333-.421-.506-.175-.272-.197-.548.025-.842.115-.166.196-.353.304-.533-.609-.679-.595-.673-.63-1.313-.137-2.51-.417-5.004-.738-7.434.164-.378.293-.709.424-1.048-.457-.202-.747-.514-.771-1.069-.012-.207-.062-.398-.092-.596-.016-.1-.02-.203-.027-.298.146-.362.265-.718.424-1.158a53.018 53.018 0 0 0-.626-2.949c-.101-.438-.392-.591-.72-.696-.26-.092-.32-.411-.178-.817.183-.54.229-1.019.088-1.423-.289-.863-.564-1.735-.9-2.596-.183-.496-.408-.887-.912-.846-.047.002-.086-.149-.07-.242.217-1.124 0-1.855-.691-1.894-.34-.007-.386-.236-.32-.695.054-.319.062-.485-.037-.668-.771-1.433-1.75-2.71-2.801-3.891-1.123-1.109-2.318-2.165-3.75-2.839-2.785-1.526-6.172-1.605-9.293-.84l-.701-.57c-.186.247-.355.505-.535.724-.281.324-.553.402-.787.199-.137-.111-.298-.169-.449-.265-.707 1.075-.7 1.049-1.292 1.304-2.278 1.11-4.366 2.575-6.3 4.108l-.768-.154c-.195.743-.479 1.271-.891 1.558-.153.111-.299.271-.447.403-.074.067-.152.12-.223.173l-.824-.124c-.749.607-1.424 1.42-2.168 2.105-.324.302-.445.773-.531 1.285-.074.405-.297.621-.572.58-.365-.048-.697.045-.986.381l-1.803 2.114c-.346.396-.623.83-.602 1.484 0 .062-.103.151-.164.158-.752.028-1.252.511-1.296 1.413-.019.418-.183.523-.49.55-.213.009-.324.038-.448.202-.986 1.332-1.9 2.587-2.844 4.003-.971 1.39-1.854 2.829-2.766 4.245a209.443 209.443 0 0 0-5.158 8.809l-.923.477c.03.229.077.451.091.673 0 .34-.129.608-.477.754-.19.087-.365.209-.555.311.135.963.12.959-.202 1.568-1.279 2.392-2.481 4.829-3.653 7.219l-.871.53c.182.562.184 1.092-.121 1.584-.112.186-.191.393-.286.587-.048.099-.104.189-.155.276l-.929.533c-.457.927-.865 1.937-1.337 2.911-.205.426-.141.839-.036 1.268.075.345-.074.659-.383.804-.407.197-.718.47-.889.901a89.029 89.029 0 0 1-1.151 2.708c-.222.515-.347 1.023-.129 1.585.02.053-.061.185-.124.221-.78.4-1.137 1.031-.919 1.881.1.394-.035.568-.346.72-.217.097-.327.166-.408.37-2.557 6.503-4.619 12.773-6.711 19.413l-.805.657c.076.219.169.428.227.644.07.335-.001.626-.311.84-.168.124-.312.279-.477.417.312.917.297.917.092 1.577a307.73 307.73 0 0 0-2.221 7.806l-.764.683c.281.52.379 1.04.166 1.58-.076.204-.117.423-.176.631-.029.105-.069.205-.104.3l-.809.697c-.285.994-.508 2.062-.799 3.105-.125.455.011.852.19 1.257a.69.69 0 0 1-.233.859c-.365.267-.624.59-.716 1.045-.2.965-.423 1.918-.655 2.871-.134.545-.162 1.068.149 1.583.028.049-.028.192-.083.239-.697.53-.938 1.215-.574 2.014.168.37.066.565-.213.77-.199.134-.292.222-.34.438-1.381 6.848-2.307 13.378-3.12 20.272l-.671.794c.115.2.244.388.341.588.132.314.113.613-.151.88-.143.153-.256.333-.394.499.473.838.468.842.399 1.527a220.1 220.1 0 0 0-.633 8.057l-.6.822c.385.448.59.935.498 1.504-.031.214-.025.436-.037.65-.007.108-.024.214-.037.312l-.647.85c-.06 1.027-.044 2.113-.098 3.19-.026.47.202.823.477 1.175a.675.675 0 0 1-.03.883c-.295.342-.474.714-.459 1.175.02.979.039 1.951.06 2.925.007.562.097 1.069.522 1.445.038.037.018.18-.025.236-.553.656-.591 1.363-.037 1.948.258.27.211.47-.005.746-.157.187-.223.298-.212.507h-.001c.499 6.523 1.528 12.564 3.748 18.563l-.201 1.299c.179.031.361.036.522.083.24.096.378.32.297.805-.037.268-.037.523-.062.797.777.077.733.099 1.039.66 1.133 2.227 2.626 4.283 4.475 5.896.08.469.195.832.29 1.23.569-.313 1.023-.327 1.446.024.162.124.352.198.523.296.088.051.168.115.244.17.133.375.242.798.424 1.215.447.194.918.366 1.393.539.493.109.996.206 1.49.335.43.116.85-.239 1.262-.592.332-.287.643-.239.812.101.232.418.538.639.979.594l.697-.065c.23-.036.457-.092.685-.134.452-.098.911-.157 1.356-.271.504-.146.984-.398 1.407-1.098.04-.064.173-.072.221-.026.532.582 1.173.413 1.788-.552.287-.441.449-.469.667-.266.144.15.233.202.417.106 2.914-1.55 5.453-3.572 7.793-5.74 2.34-2.176 4.485-4.521 6.541-7.011l.879-.139c.027-.238.049-.469.073-.719z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M87.068 157.531c-.38-.116-.63-.512-1.013-.63-1.854-.57-3.73-1.149-5.595-1.724-.221-.067-.438-.3-.659-.368-.221-.067-.441.025-.66-.044l-3.118-.979-5.005-1.506c-.311-.09-.753.096-1.062.001-.38-.116-.63-.512-1.013-.629a7433.44 7433.44 0 0 1-5.595-1.725c-.221-.067-.438-.3-.659-.367s-.441.025-.66-.045l-3.118-.979-.549 1.789-.548 1.786c1.62.485 3.566 1.252 5.207 1.735.127-.02.239-.017.344-.045.219-.062.432-.146.648-.215.148.153.327.278.443.457a.91.91 0 0 0 .529.389c4.027 1.197 6.207 1.764 9.939 2.928 1.62.485 3.566 1.253 5.207 1.736.127-.02.239-.018.344-.045.219-.062.432-.146.648-.215.148.152.327.278.443.456a.911.911 0 0 0 .529.39c4.027 1.197 6.207 1.763 9.939 2.928l1.097-3.575-5.005-1.505c-.307-.091-.749.096-1.058.001zM76.752 123.092c.226.019.455.014.683.026.086.195.209.375.256.584a.902.902 0 0 0 .357.55c3.35 2.536 5.191 3.833 8.277 6.236 1.346 1.023 2.899 2.427 4.266 3.456.125.026.229.068.337.079.226.019.455.014.683.026.086.195.209.375.256.584a.902.902 0 0 0 .357.55c3.35 2.536 5.191 3.833 8.277 6.236l1.141-1.479 1.143-1.482-4.157-3.168c-.259-.194-.738-.176-.993-.373-.315-.242-.41-.7-.728-.945l-4.632-3.581c-.184-.142-.306-.436-.488-.576s-.422-.132-.602-.273l-2.576-2.014-4.157-3.168c-.259-.194-.738-.176-.993-.373-.315-.242-.41-.7-.728-.945l-4.632-3.581c-.184-.142-.306-.436-.488-.576s-.422-.132-.602-.273l-2.576-2.015-2.283 2.962c1.346 1.023 2.899 2.427 4.266 3.456.124.025.228.067.336.077zM82.771 181.534c-.111.062-.218.101-.307.163-.182.135-.352.288-.53.429-.193-.091-.405-.146-.577-.271a.901.901 0 0 0-.631-.178c-4.191.295-6.432.531-10.336.753-1.688.116-3.78.081-5.486.206-.111.062-.217.1-.306.162-.183.135-.352.289-.53.43-.193-.091-.405-.146-.577-.271a.9.9 0 0 0-.632-.178c-4.191.295-6.432.531-10.336.752l.23 3.732c1.67-.111 3.422-.229 5.215-.35.322-.025.672-.354.994-.374.396-.024.77.258 1.169.233l5.845-.354c.23-.014.516.127.746.112.23-.014.404-.179.633-.19 1.1-.06 2.191-.119 3.266-.179 1.67-.112 3.421-.229 5.215-.351.322-.024.672-.354.993-.374.397-.024.77.258 1.169.233 1.936-.117 3.898-.235 5.846-.354.229-.014.516.127.746.113.229-.015.404-.18.633-.19l3.265-.179-.229-3.733c-1.691.118-3.783.084-5.488.208z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m341.702 235.982-.014-.72.555-2.484.07-.312.018-.078.009-.039.006-.04.021-.158.008-.06.076-.572.168-1.249.292-2.15.147-1.074.018-.135.006-.135.014-.271.028-.54.112-2.158.057-1.079.025-.539-.016-.538-.059-2.149-.029-1.074-.004-.134-.014-.133-.027-.265-.055-.531-.217-2.122-.357-2.074-.283.056-.035.007-.018.004h-.002l-.552-.974-.001-.001h-.001l-.003-.001-.006-.002-.047-.018-.093-.035-.375-.137-.761-.261-.043-.016-.042-.019-.04-.021-.037-.024-.035-.026-.034-.029-.062-.064-.057-.074-.049-.082-.044-.091-.039-.097-.04-.095-.043-.082-.047-.071-.051-.06-.054-.049-.028-.021-.029-.018-.029-.016-.03-.012-.031-.01-.032-.008-.066-.008-.068.002-.072.011-.075.021-.077.029-.08.038-.082.046-.084.054-.053.032-.051.026-.049.019-.047.013-.044.007-.042.001-.042-.003-.04-.01-.038-.013-.038-.017-.035-.021-.006-.004c.002.023.003.045.006.067.03.38-.457.567-.285.905.167.332.409.631.619.97-.031 1.469-.064 2.941-.097 4.411-.106 1.461-.294 2.907-.44 4.352-.168.236-.298.44-.447.628-.324.415-.488.832-.249 1.351.222.485.212.51-.136.902-.169.193-.337.377-.385.62-.18.86-.395 1.718-.417 2.602-.017.34.361.647.176 1.005-.105.214-.349.35-.517.533a.857.857 0 0 0-.169.325l-.503 1.818c-.16.515-.06.972.087 1.45.138.434.073.709-.238 1.006-.142.136-.091.272-.214.42-.076.191-.531.896-.583 1.112-.099.367-.243.719-.366 1.077l-1.449 4.297-1.736 4.21c-.403 1.064-.939 2.077-1.449 3.102-.523 1.019-.998 2.06-1.563 3.059l-1.787 2.961-.452.743-.523.723-1.053 1.44-.575.784 3.634.855.068-.28.008-.035.005-.018.001-.001 1.541-.658.001-.002.003-.002.008-.006.053-.046.107-.091.107-.091.104-.098.209-.195.416-.395.104-.099.1-.105.198-.213.096-.093.1-.079.105-.067.11-.056.115-.045.12-.036.124-.027.128-.021.123-.025.114-.034.104-.042.096-.049.086-.056.078-.062.068-.069.061-.076.053-.081.044-.088.036-.093.027-.099.021-.104.013-.108.006-.113-.002-.118-.002-.074.004-.07.009-.066.015-.062.02-.059.023-.056.029-.052.032-.05.036-.047.04-.044.09-.084.101-.076.107-.072.037-.02.038-.016.083-.024.176-.034.123-.03.113-.038.105-.044.096-.052.045-.027.041-.031.074-.066.065-.074.056-.079.049-.085.038-.091.03-.097.021-.102.012-.105.004-.111-.004-.116-.014-.12-.008-.074-.001-.07.005-.065.01-.063.016-.059.02-.057.025-.055.029-.052.033-.05.036-.047.083-.091.186-.174.033-.023.035-.019.082-.03.085-.026.042-.015.04-.018.675-.365.535-.827.497-.865.503-.869.127-.218.115-.226.23-.453.464-.906.233-.455.059-.113.053-.117.104-.234.836-1.881.053-.117.049-.12.091-.241.183-.482.364-.965.183-.482.09-.24.046-.12.039-.123.306-.981.303-.977.15-.487.075-.242.019-.062.016-.062.028-.124.449-1.979.258-.32zm-.572-.502c.002-.001-.007-.003-.002-.003.01 0 .004-.004.002-.006v.009z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "m347.474 222.351-.003-.041-.007-.04-.02-.081-.023-.08-.03-.08-.037-.078-.042-.072-.048-.07-.103-.137-.104-.135-.049-.069-.044-.071-.007-.012-.005-.014-.004-.03.002-.034.007-.036.023-.074.03-.069.143-.272.153-.271-.428-.558.512-.868-.02-.692-.01-.348-.005-.087-.008-.087-.018-.175-.144-1.403-.146-1.406-.041-.353-.061-.352-.123-.703c-.033-.055-.066-.104-.097-.153l-.047-.071-.052-.065-.235-.239-.237-.234.123-.359.034-.124.021-.062.029-.059.035-.082.029-.081.02-.08.014-.08.005-.082-.003-.083-.012-.085-.019-.089c-.062-.271-.13-.574-.198-.884l-.027-.118-.035-.13-.072-.26a28.232 28.232 0 0 0-.099-.333 29.66 29.66 0 0 1-.068-.189l-.036-.085-.037-.075-.037-.066-.039-.054-.021-.022-.02-.019-.021-.015-.021-.012-.014-.004-.02-.002a2.947 2.947 0 0 1-.051.003l-.069.011a2.727 2.727 0 0 0-.085.018l-.047.011-.013.003h-.005l-.002-.002-.01-.009-.046-.033-.106-.063-.121-.059-.127-.053a39.055 39.055 0 0 0-.238-.086l-.02-.007-.021-.004-.046-.003h-.059l-.059.01-.062.017-.062.025-.064.032-.064.04a3.277 3.277 0 0 1-.094.052l-.045.02-.042.014-.04.008-.039.004-.037-.002-.035-.007-.033-.013-.032-.018-.03-.024-.029-.029-.029-.035-.026-.042-.025-.047-.024-.055-.039-.087-.043-.079-.047-.07-.051-.063-.053-.057-.057-.05-.061-.045-.061-.037-.087-.041-.045-.016-.046-.012-.047-.01-.049-.006-.049-.004h-.05l-.051.004-.052.008-.107.024-.111.04-.115.055-.082.04-.074.025-.033.008-.033.005-.029.002-.029-.002-.027-.004-.024-.006-.024-.009-.021-.012-.021-.013-.02-.016-.037-.037-.032-.043-.03-.05-.051-.11-.097-.243-.237.129-.115.056-.057.021-.055.015-.053.006-.025-.001-.025-.003-.023-.006-.023-.01-.022-.012-.022-.015-.021-.019-.021-.022-.019-.026-.019-.03-.033-.072-.029-.091-.022-.072-.027-.065-.032-.059-.035-.051-.041-.045-.045-.038-.051-.031-.055-.024-2.658-.987-.435-.158.3-.843-.129-.774-.198-.762-.402-1.527c-.232-1.031-.626-2.014-.993-3.004-.816-2.229-1.947-4.336-3.289-6.283a24.32 24.32 0 0 0-2.229-2.758c-.423-.414-.82-.854-1.277-1.229-.223-.194-.441-.394-.681-.568-.235-.177-.458-.382-.749-.463a506.736 506.736 0 0 0-8.791-3.389c-.348-.134-.687-.288-1.045-.397-.213-.058-.887-.531-1.057-.636v-.001c-.133-.136-.27-.098-.39-.252-.263-.338-.522-.427-.956-.328-.479.103-.938.16-1.426-.049l-1.73-.67a.81.81 0 0 1-.299-.199c-.16-.182-.262-.435-.458-.559-.331-.208-.67.097-.998.031-.848-.166-1.642-.521-2.442-.84-.227-.087-.375-.282-.529-.479-.314-.405-.333-.417-.848-.282-.55.145-.934-.072-1.245-.502-.143-.191-.306-.367-.487-.586l-7.95-2.978c-.377.065-.73.167-1.091.188-.367.021-.338-.501-.683-.625-.119-.037-.231-.098-.351-.127-.512-.136-1.168-.19-1.473-.574-.414-.499-.982-.692-1.625-.631-.238.021-.472.102-.708.148l-.687-.865c-1.833-.688-3.689-1.383-5.546-2.078l-12.524-4.703-4.413-1.66a19.618 19.618 0 0 0-3.319-1.971c-1.76-.823-4.125-1.648-6.178-1.72-.139.042-.269.08-.379.134-.229.121-.438.263-.652.391-.217-.1-.459-.18-.656-.301a1.138 1.138 0 0 0-.74-.154c-2.478.258-4.268.924-5.899 1.676-.384.182-.759.373-1.133.572-1.229-1.136-2.604-2.591-3.837-3.698-.123-.038-.226-.09-.334-.112-.227-.04-.458-.059-.687-.093-.07-.204-.181-.396-.21-.609a.932.932 0 0 0-.316-.585c-3.162-2.878-4.817-4.46-7.672-7.231-1.26-1.177-2.621-2.813-3.838-4.055-.121-.046-.219-.103-.325-.13-.223-.054-.452-.084-.677-.131-.059-.209-.158-.408-.176-.623a.923.923 0 0 0-.283-.604l-3.787-3.819a225.42 225.42 0 0 1-3.498-3.788c-1.156-1.272-2.498-2.917-3.618-4.243-.118-.053-.212-.116-.316-.149-.219-.066-.444-.11-.666-.171-.046-.212-.133-.416-.138-.632a.928.928 0 0 0-.245-.62l-3.551-4.035a227.587 227.587 0 0 1-3.253-3.993c-1.094-1.326-2.284-3.084-3.326-4.471-.114-.061-.205-.129-.307-.169-.214-.08-.438-.138-.655-.212-.032-.215-.106-.424-.098-.639a.92.92 0 0 0-.206-.633c-2.629-3.357-3.952-5.222-6.256-8.455-.967-1.42-2.01-3.271-2.991-4.702-.111-.066-.198-.142-.298-.188-.211-.093-.432-.165-.646-.253-.02-.215-.083-.426-.056-.642a.937.937 0 0 0-.156-.649l-2.947-4.494a196.372 196.372 0 0 1-2.711-4.387c-.908-1.461-1.826-3.391-2.729-4.878-.107-.073-.189-.152-.286-.205-.205-.104-.422-.19-.629-.29-.009-.215-.057-.434-.021-.646a.937.937 0 0 0-.129-.657 562.526 562.526 0 0 0-1.621-2.731 33.31 33.31 0 0 0-1.406-3.146c-.154-.304-.264-.645-.461-.914-.113-.153-.355-.953-.426-1.146v-.001c-.032-.207-.136-.225-.152-.444-.045-.479-.162-.704-.51-.762-.371-.077-.703-.19-.968-.605-.158-.237-.312-.476-.483-.699l-.341-.4-.42-.77c-.038-.198-.07-.401-.154-.548a.33.33 0 0 0-.26-.181c-.472-.79-1.017-1.521-1.628-2.084-.14-.053-.256-.118-.374-.147-.239-.064-.497-.07-.747-.092-.125-.211-.279-.43-.389-.64a1.245 1.245 0 0 0-.561-.562 8.228 8.228 0 0 0-2.157-.682c-2.14-.774-4.492-1-6.752-.739-.331.243-.629.509-.944.708-.321.203-.401-.275-.736-.213-.113.025-.227.025-.338.063-.475.186-1.045.53-1.399.378-.481-.206-1.011.004-1.515.503-.188.18-.354.406-.531.607l-.803-.269c-.807.41-1.639.785-2.436 1.23-.781.48-1.592.911-2.35 1.435-3.445 2.282-6.569 5.087-9.461 8.099-.955 1.016-1.916 2.023-2.811 3.1l-1.363 1.591-1.307 1.639c-.22.271-.455.526-.658.818-.117.17-.713.621-.853.749l-.001-.001c-.156.076-.159.221-.328.277-.371.125-.525.345-.551.789-.034.489-.096.933-.408 1.314-.366.447-.68.929-1.016 1.395a.677.677 0 0 1-.249.218c-.202.091-.462.112-.616.252-.26.239-.035.624-.159.897-.323.703-.797 1.318-1.229 1.957-.12.181-.331.264-.544.352-.439.18-.454.195-.41.688.049.526-.221.813-.684.988-.209.08-.398.186-.635.3l-1.99 3.232-1.918 3.289c.017.351.076.688.062 1.019-.014.336-.517.212-.67.502-.049.1-.119.19-.158.293-.183.438-.299 1.019-.703 1.226-.523.284-.771.763-.768 1.354.001.22.06.444.087.666-.29.155-.58.312-.896.479a158.573 158.573 0 0 0-2.416 4.705c-1.8 3.551-3.447 7.177-5.072 10.803-1.049 2.435-2.1 4.868-3.081 7.329-.128.306-.276.604-.38.922-.053.188-.513.767-.611.919l-.001-.001c-.13.114-.089.24-.237.341-.325.221-.406.453-.298.852.114.439.184.857-.008 1.289-.157.365-.298.738-.442 1.109l-.188.452a.66.66 0 0 1-.169.235c-.176.137-.424.219-.539.392-.189.293.125.611.074.906a1.055 1.055 0 0 1-.006.026c-.329.812-.654 1.629-1.002 2.497-.054.042-.104.085-.162.125-.385.273-.396.291-.24.759.01.031.008.056.015.086l-.399.991c-.017.013-.027.026-.045.038-.18.126-.344.271-.549.433a266.96 266.96 0 0 0-2.403 7.175l.009.029a165.848 165.848 0 0 0-1.205 3.729c-.053.113-.089.23-.109.354-.414 1.349-.788 2.626-1.211 4.069l-.129.441c-.139.476-.283.969-.439 1.496-.469 1.684-1.188 3.725-1.598 5.446.02.099.03.184.047.269-.128.482-.26.963-.384 1.446a.922.922 0 0 0-.155.348c-.164.73-.307 1.39-.441 2.023-.248.985-.503 1.97-.744 2.956-.598 2.581-1.209 5.158-1.741 7.754-.071.323-.165.643-.212.974-.02.194-.366.845-.441 1.011h-.002c-.111.135-.047.252-.176.377-.281.274-.32.518-.143.891.189.413.331.812.219 1.271-.125.536-.219 1.079-.333 1.618a.643.643 0 0 1-.138.291c-.148.165-.377.29-.463.48-.139.321.229.58.231.879.01.773-.175 1.524-.323 2.277-.039.213-.199.372-.36.538-.331.338-.339.357-.103.79.25.461.123.831-.225 1.175-.154.156-.289.328-.463.524l-.57 3.737-.502 3.765c.154.316.332.604.443.915.114.315-.396.393-.428.719-.007.111-.037.221-.034.33-.001.475.113 1.056-.181 1.4-.375.462-.418.998-.193 1.542.082.202.215.388.325.583l-.644.783c-.156 1.742-.343 3.502-.449 5.272-.316 3.971-.447 7.966-.486 11.955-.014 2.69.029 5.257.181 8.094.019.35.015.702.059 1.049.034.2-.124.979-.153 1.177-.069.178.02.27-.072.447-.203.391-.158.653.111.946.298.327.543.649.566 1.146.034.579.1 1.148.145 1.725a.835.835 0 0 1-.037.35c-.084.236-.254.479-.271.708-.026.387.386.432.478.713.249.727.27 1.548.404 2.339.037.222-.051.473-.137.731-.178.531-.176.56.174.803.375.257.379.68.188 1.245-.086.256-.131.507-.208.813.303 1.281.546 2.589.932 3.85l.537 1.905.634 1.865c.246.145.496.235.701.407.225.169-.091.688.041.995.048.101.079.222.133.313.221.408.562.799.531 1.361-.013.731.264 1.21.68 1.453.154.091.332.116.494.177.006.403.002.817.039 1.247.896 1.553 1.861 3.105 3.08 4.458 1.308 1.567 2.904 2.917 4.715 3.889.882.532 1.869.854 2.836 1.202l1.51.331c.501.121 1.021.109 1.531.17 2.746.188 5.484-.425 8.014-1.433.318-.123.637-.223.957-.373.184-.105.838-.223 1.007-.262v.001c.146.014.237-.121.38-.082.311.085.544-.035.837-.443.315-.47.618-.892 1.037-1.117.401-.231.811-.467 1.205-.723l.236-.11.3-.143c.172.014.34.117.516.049.174-.068.278-.269.38-.472a224.787 224.787 0 0 1 3.521-1.622c1.566-.73 3.573-1.477 5.154-2.216.084-.1.172-.173.233-.264.126-.191.232-.397.353-.594.217.015.438-.011.646.044a.932.932 0 0 0 .665-.062c3.886-1.805 5.943-2.807 9.611-4.342 1.587-.66 3.594-1.355 5.206-1.993.088-.095.18-.162.245-.249.135-.185.251-.384.382-.572.215.026.436.014.641.08a.932.932 0 0 0 .666-.025c3.949-1.606 6.091-2.395 9.833-3.708 1.63-.536 3.694-1.027 5.339-1.575.094-.089.189-.152.262-.235l.422-.55c.211.04.43.037.631.124a.93.93 0 0 0 .666.036c4.089-1.191 6.242-1.974 10.108-2.871 1.667-.409 3.745-.815 5.442-1.178.102-.078.202-.132.281-.207.162-.16.309-.338.467-.503.208.061.429.082.621.181a.926.926 0 0 0 .662.081l5.234-1.193c1.57-.313 3.109-.601 5.065-.939 1.694-.292 3.795-.564 5.517-.8.107-.072.212-.118.296-.188.173-.149.331-.317.499-.472.205.074.424.111.609.222a.926.926 0 0 0 .656.125c4.22-.639 6.465-1.103 10.426-1.484 1.709-.201 3.835-.274 5.561-.485.111-.068.218-.11.305-.178.059-.047.113-.099.17-.147l.008.006c.207.135.425.246.633.369-.002.235.059.467.035.692-.022.264.027.479.172.712 1.262 2.028 2.529 3.424 3.887 4.635 1.369 1.197 2.849 2.247 4.902 3.197.24.109.492.218.752.326.217.212.42.298.674.269 1.503.57 3.211 1.042 4.744 1.097.14-.051.269-.081.379-.137.115-.061.221-.129.328-.195.283.025.562.07.84.126l-.588 2.101-1.422 5.082c-.082.371.123.857.045 1.213-.049.222-.172.417-.289.619-.092.213-.184.434-.198.676-.027.587-.103 1.166.006 1.777.067.604.123 1.209.343 1.797l.283.883c.131.278.277.55.418.824.262.567.639 1.037 1.005 1.517.164.236.278.585.483.779.201.199.468.245.662.439.343.305.715.595 1.075.86-.509.256-.761.699-.779 1.265-.009.212.039.435.056.651l-.918.408-2.681 4.383-3.038 4.947-3.158 4.883-4.128 6.359-.196.284a5.626 5.626 0 0 0-.308.481c-.083.166-.591.569-.706.676-.136.061-.125.199-.273.238-.323.087-.436.273-.427.708.003.476-.028.929-.29 1.273-.295.413-.59.834-.934 1.211a.396.396 0 0 1-.242.149c-.197.03-.43-.032-.589.059-.261.16-.155.603-.329.83-.45.578-1.098.916-1.741 1.217-.183.084-.406.037-.632-.009-.47-.117-.483-.119-.664.296-.201.421-.581.481-1.064.285l-.688-.229c-1.105.243-2.238.378-3.373.501l-1.705.195c-.285.043-.564.072-.854.125-.28.045-.569.094-.93.174-.274.25-.507.538-.777.764-.27.221-.565-.194-.925-.07-.118.047-.246.071-.359.139-.502.254-1.002.714-1.52.744-.692.061-1.269.534-1.505 1.199-.088.246-.11.504-.155.744-.33.141-.683.297-1.055.494-.572.916-.949 1.848-1.266 2.891-.07.238-.107.427-.162.643l-.076.314-.038.157-.024.112-.008.044-.014.087-.232 1.394c-.066.533-.096 1.087-.142 1.629.003.564.005 1.132.058 1.709.146 1.161.442 2.386 1.098 3.478.646 1.067 1.514 2.01 2.459 2.649.932.697 1.91 1.164 2.875 1.606 2.582 1.088 5.141 1.737 7.672 2.396.318.082.627.192.955.244.193.023.823.386.985.465v.001c.13.113.247.056.366.188.261.293.5.342.874.18.421-.175.798-.294 1.278-.173.551.138 1.109.244 1.663.369a.704.704 0 0 1 .304.146c.176.153.317.387.519.477.341.154.579-.229.882-.229.783-.016 1.559.173 2.338.312.221.026.408.179.605.332.404.313.432.32.818.055.412-.29.801-.162 1.23.15.195.137.402.251.648.4 2.604.131 5.301-.099 7.763-1.068.215-.303.385-.615.605-.871.221-.267.554.156.85-.012.097-.064.204-.107.296-.178.4-.296.822-.747 1.268-.721.564-.022 1.016-.374 1.306-.939.106-.209.175-.441.245-.68.309-.03.618-.061.954-.092 1.382-1.187 2.628-2.556 3.846-3.939 2.796-3.201 5.045-6.248 7.405-9.388l4.699-6.233c.197-.26.418-.502.59-.781.094-.168.667-.605.801-.723.153-.074.145-.205.312-.262.367-.125.501-.323.494-.73-.002-.448.034-.864.324-1.225.334-.424.642-.867.966-1.299a.616.616 0 0 1 .244-.199c.202-.083.458-.095.612-.228.26-.224.041-.611.166-.876.321-.686.808-1.268 1.263-1.865.126-.171.338-.24.553-.314.44-.149.456-.162.431-.65-.029-.521.249-.788.712-.929.207-.065.403-.153.645-.246l4.347-5.979c.014-.346-.011-.683.04-1.001.052-.325.535-.14.719-.4.06-.091.138-.169.188-.264.229-.402.408-.953.828-1.099.547-.205.84-.637.91-1.213.027-.213-.001-.44.002-.66l.943-.326a6906.99 6906.99 0 0 1 3.039-4.162l7.091-9.182 3.511-4.49c.045.022.101.051.126.062.148.115.278.063.415.201.303.303.571.358.989.207.463-.161.904-.276 1.448-.121.629.172 1.264.312 1.895.47a.939.939 0 0 1 .347.164c.203.165.369.409.6.512.39.17.648-.183.99-.158.884.061 1.762.316 2.643.535.248.059.462.237.687.419.458.37.488.379.916.172.456-.227.893-.045 1.382.328.227.137.466.221.749.353 3.006-.241 5.91-1.386 8.521-2.887.221-.36.393-.723.621-1.036.231-.318.599.04.927-.17.113-.071.221-.147.318-.236.422-.385.857-.943 1.346-.998.322-.045.61-.171.859-.361.24-.199.422-.486.568-.809.107-.24.162-.504.243-.752l1.08-.234c.217-.186.421-.385.62-.59l.429-.27.463.658 3.87.905.13-.041.062-.021.059-.027.47-.285.183.231.065.072.03.04.027.045.036.063.038.056.039.05.043.042.047.035.051.029.054.021.06.017 1.141.3.17.037.078.012.071.006.065.001.059-.007.025-.006.023-.009.021-.011.018-.013.01-.01.01-.015a.394.394 0 0 0 .023-.046l.057-.146.016-.047.004-.012v-.003h.001l.001-.001h.002l.012-.002.048-.01c.031-.012.065-.022.101-.035l.105-.047.104-.056.186-.113.014-.01.014-.012.012-.013.006-.008.024-.02.093-.082.021-.021.018-.02.031-.04.056-.082.049-.087.042-.091.035-.096.051-.137.029-.062.031-.057.035-.053.038-.048.042-.044.045-.039.049-.035.053-.031.059-.027.061-.024.064-.021.07-.018.074-.013.081-.01.13-.015.126-.023.122-.032.118-.039.114-.046.107-.055.104-.061.101-.066.126-.097.117-.106.108-.116.099-.125.088-.135.07-.148.059-.157.045-.166.031-.119.039-.104.045-.09.052-.076.058-.064.062-.053.067-.045.07-.036.076-.03.078-.023.16-.04.338-.065.061-.35.036-.168.024-.08.029-.076.037-.071.045-.065.026-.03.028-.029.031-.026.034-.025.038-.023.039-.021.045-.019.047-.017c.032-.01.066-.02.104-.029l.119-.02.095-.016.091-.024.086-.031.084-.039.078-.046.076-.055.072-.062.068-.07.389-.434.193-.216.184-.225.732-.897.184-.225.091-.112.086-.116.341-.466.681-.935.106-.146.1-.15.196-.303.393-.605.392-.605.194-.304.179-.312.716-1.249.179-.312.089-.156.083-.159.322-.642.643-1.283.16-.321.143-.328.285-.656.568-1.314.139-.329.123-.335.247-.67.036-.086.045-.082.051-.078.057-.074.064-.067.07-.062.076-.056.082-.048.07-.04.063-.042.054-.045.047-.046.039-.049.033-.051.025-.053.018-.055.014-.057.006-.059.001-.06-.004-.062-.009-.063-.014-.065-.039-.135-.027-.09-.02-.09-.01-.09-.006-.092.002-.092.01-.092.018-.093.025-.093.601-2.002.149-.501.037-.126.03-.126.056-.254.218-1.015.015-.059.021-.057.025-.056.031-.054.07-.105.082-.1.173-.188.081-.089.072-.085-.107-.485.366-.605c.021-.039.036-.071.049-.097a.87.87 0 0 0 .036-.059l.017-.018.015-.013.016-.009.017-.006.039-.01.054-.017.074-.035a5.31 5.31 0 0 1 .103-.064 17.882 17.882 0 0 0-.104-.252l-.07-.195-.022-.082-.012-.074-.002-.067.002-.032.006-.031.008-.03.012-.03.03-.062.042-.062.054-.066.146-.152.2-.19-.139-.301-.13-.302-.02-.06-.015-.06-.012-.058-.006-.057-.001-.057.003-.057.008-.055.013-.055.017-.054.021-.054.027-.053.031-.053.035-.053.04-.053.089-.106.419-.474-.171-.299-.078-.15-.035-.076-.029-.078-.038-.121-.014-.061-.01-.059-.006-.059-.001-.059.002-.058.006-.057.012-.056.016-.055.021-.055.025-.054.03-.053.035-.052.041-.051.045-.051.105-.116.1-.121.197-.245-.173-.297-.077-.148-.031-.076-.023-.078-.045-.202-.016-.101-.011-.101-.006-.099-.001-.099.006-.099.01-.097.018-.096.023-.096.031-.094.037-.093.045-.092.054-.091.062-.09.068-.088.496-.559.057-.375.014-.097.008-.098.012-.199.049-.817.02-.333.004-.167-.004-.167-.008-.078-.016-.078-.023-.077-.03-.075-.038-.074-.045-.071-.052-.068-.06-.066-.065-.073-.051-.071-.02-.035-.017-.034-.012-.034-.008-.034-.004-.033v-.033l.002-.033.008-.033.011-.034.015-.033.018-.034.022-.034.278-.408.087-.142.06-.119.021-.055.018-.054.013-.055.009-.058.012-.129.005-.16.006-.163.013-.163.026-.328.003-.163-.012-.069zm-209.032 33.627c-2.056 2.49-4.201 4.835-6.541 7.011-2.34 2.168-4.879 4.19-7.793 5.74-.184.096-.273.044-.417-.106-.218-.203-.38-.176-.667.266-.615.965-1.256 1.134-1.788.552-.048-.046-.181-.038-.221.026-.423.699-.903.952-1.407 1.098-.445.114-.904.174-1.356.271-.228.042-.454.098-.685.134l-.697.065c-.44.045-.746-.176-.979-.594-.17-.34-.48-.388-.812-.101-.412.353-.832.708-1.262.592-.494-.129-.997-.226-1.49-.335a25.36 25.36 0 0 1-1.393-.539c-.182-.417-.291-.84-.424-1.215-.076-.055-.156-.119-.244-.17-.172-.098-.361-.172-.523-.296-.423-.352-.877-.338-1.446-.024-.095-.398-.21-.762-.29-1.23-1.849-1.613-3.342-3.67-4.475-5.896-.306-.562-.262-.583-1.039-.66.025-.273.025-.529.062-.797.081-.484-.057-.709-.297-.805-.161-.047-.344-.052-.522-.083l.201-1.299c-2.22-5.999-3.249-12.04-3.748-18.563h.001c-.011-.209.055-.32.212-.507.216-.276.263-.477.005-.746-.554-.585-.516-1.292.037-1.948.043-.057.063-.199.025-.236-.426-.376-.516-.883-.522-1.445-.021-.974-.04-1.946-.06-2.925-.015-.461.164-.833.459-1.175a.674.674 0 0 0 .03-.883c-.274-.352-.503-.705-.477-1.175.054-1.077.038-2.163.098-3.19l.647-.85c.013-.099.03-.204.037-.312.012-.215.006-.437.037-.65.092-.569-.113-1.056-.498-1.504.19-.262.38-.521.6-.822.168-2.65.362-5.357.633-8.057.068-.686.073-.689-.399-1.527.138-.166.251-.346.394-.499.265-.267.283-.565.151-.88-.097-.2-.226-.388-.341-.588l.671-.794c.813-6.895 1.739-13.425 3.12-20.272.048-.217.141-.305.34-.438.279-.204.381-.399.213-.77-.363-.799-.123-1.483.574-2.014.055-.047.111-.19.083-.239-.312-.515-.283-1.038-.149-1.583.232-.953.455-1.906.655-2.871.092-.455.351-.778.716-1.045a.69.69 0 0 0 .233-.859c-.18-.405-.315-.802-.19-1.257.291-1.044.514-2.111.799-3.105l.809-.697c.034-.095.074-.194.104-.3.059-.208.1-.427.176-.631.213-.54.115-1.061-.166-1.58l.764-.683a304.79 304.79 0 0 1 2.221-7.806c.205-.66.22-.66-.092-1.577.164-.138.309-.293.477-.417.31-.214.381-.505.311-.84-.058-.216-.15-.425-.227-.644l.805-.657c2.092-6.64 4.154-12.91 6.711-19.413.081-.204.191-.273.408-.37.311-.151.445-.326.346-.72-.218-.85.139-1.48.919-1.881.063-.036.144-.168.124-.221-.218-.562-.093-1.07.129-1.585.396-.896.783-1.795 1.151-2.708.171-.432.481-.704.889-.901.309-.145.458-.459.383-.804-.104-.429-.169-.842.036-1.268.472-.975.88-1.984 1.337-2.911l.929-.533c.051-.087.107-.178.155-.276.095-.194.174-.401.286-.587.305-.492.303-1.021.121-1.584l.871-.53c1.172-2.39 2.374-4.827 3.653-7.219.322-.609.337-.605.202-1.568.189-.102.364-.224.555-.311.348-.146.477-.414.477-.754-.014-.222-.061-.443-.091-.673l.923-.477a210.727 210.727 0 0 1 5.158-8.809c.911-1.416 1.795-2.855 2.766-4.245.943-1.416 1.857-2.671 2.844-4.003.124-.164.235-.193.448-.202.308-.026.472-.132.49-.55.044-.902.544-1.385 1.296-1.413.062-.007.164-.097.164-.158-.021-.654.256-1.089.602-1.484l1.803-2.114c.289-.336.621-.429.986-.381.275.041.498-.175.572-.58.086-.512.207-.983.531-1.285.744-.686 1.419-1.498 2.168-2.105l.824.124c.07-.053.148-.105.223-.173.148-.133.294-.292.447-.403.412-.286.695-.814.891-1.558l.768.154c1.934-1.533 4.021-2.998 6.3-4.108.592-.255.585-.229 1.292-1.304.151.096.312.153.449.265.234.203.506.125.787-.199.18-.219.35-.477.535-.724l.701.57c3.121-.766 6.508-.687 9.293.84 1.432.674 2.627 1.729 3.75 2.839 1.051 1.181 2.029 2.458 2.801 3.891.1.183.091.349.037.668-.065.459-.02.688.32.695.691.038.908.77.691 1.894-.016.093.023.244.07.242.504-.041.729.35.912.846.336.86.611 1.732.9 2.596.141.404.095.883-.088 1.423-.143.406-.082.726.178.817.328.105.619.259.72.696.244.999.447 1.981.626 2.949-.159.44-.278.796-.424 1.158.008.095.012.198.027.298.03.197.08.389.092.596.024.556.314.867.771 1.069-.131.339-.26.67-.424 1.048.321 2.43.602 4.924.738 7.434.035.641.021.635.63 1.313-.107.181-.188.367-.304.533-.223.294-.2.569-.025.842.123.173.277.322.421.506l-.552.878c.205 6.896.014 13.475-.617 20.415-.021.221-.104.317-.286.471-.253.232-.332.438-.122.787.46.756.275 1.459-.365 2.057-.051.053-.093.2-.061.247.361.478.377 1 .305 1.556l-.357 2.918c-.049.461-.276.808-.615 1.107a.682.682 0 0 0-.15.876c.221.386.406.768.324 1.232-.194 1.065-.318 2.147-.512 3.162l-.738.77c-.023.097-.053.199-.07.308-.033.214-.059.435-.115.644-.163.557-.02 1.065.307 1.557l-.698.748c-.443 2.628-.974 5.299-1.514 7.965-.146.675-.161.676.231 1.562-.152.15-.282.318-.439.456-.289.24-.334.536-.234.863.076.21.187.41.282.621l-.75.724a513.87 513.87 0 0 1-1.349 5.891 2.393 2.393 0 0 0-.1-.028l-.874-.225-.2-.061-.172-.067-.295-.141-.143-.072-.151-.068a9.713 9.713 0 0 0-.172-.064l-.201-.057-.052-.01-.062-.007-.144-.01-.336-.005-.336.002a23.238 23.238 0 0 1-.143-.006l-.061-.007-.051-.008-1.288-.253-.629-.115-.616-.105-1.189-.19-1.116-.155a56.553 56.553 0 0 0-4.89-.404c-.305-.008-.659.283-.961.283-.373-.003-.703-.318-1.084-.314a38.22 38.22 0 0 0-5.565.437c-.219.028-.511-.068-.732-.028-.222.043-.367.224-.585.268-.533.121-1.03.227-1.586.39a19.1 19.1 0 0 0-1.686.552c-1.689.67-3.371 1.621-4.717 2.999-.225.267-.248.708-.436.982-.259.318-.725.493-.943.864-1.033 1.808-1.247 4.032-.753 6.052.049.24-.027.545.054.784.078.239.281.405.375.631a14.434 14.434 0 0 0 1.648 3.118c.254.378.546.737.83 1.106.316.37.591.711.879 1.014a27.083 27.083 0 0 0 1.831 1.818c.23.213.7.214.933.41.285.247.348.7.648.937a44.49 44.49 0 0 0 4.542 3.173c.183.117.329.379.517.49.188.109.415.064.6.175a57.906 57.906 0 0 0 2.695 1.461l.001-.002.575.272.047.004.055.01c.039.011.083.023.133.039.049.018.104.038.161.061l.184.079.419.192.449.227.825.448.292.173.096.065.034.025.022.021.074.069.076.064.08.06.084.054.086.05.089.045.183.081.379.145.189.072.186.078.182.077.149.055.068.02.066.016.067.011.07.007.158.002.194-.011.571-.058.048-.004h.046l.044.003.042.006.041.01.039.014.037.017.037.02.035.023.033.027.033.029.031.034.061.079c.018.029.035.062.057.095l.041.066.047.061.052.056.056.052.06.048.062.046.13.083.015.012.015.014.026.029.026.029.015.011.014.009.141.062c-.057.163-.107.331-.182.485-.258.52-.207 1.046.027 1.588l-.82.613c-.902 2.512-1.893 5.048-2.888 7.579-.263.639-.277.637-.048 1.577-.176.123-.334.265-.512.373-.327.186-.425.469-.384.809.038.219.112.436.169.66l-.863.581c-2.683 6.413-5.328 12.452-8.556 18.632-.105.194-.219.253-.444.326-.323.117-.475.277-.413.681.134.871-.284 1.462-1.112 1.765-.067.029-.162.15-.15.205.152.578-.033 1.066-.312 1.551l-1.441 2.557c-.222.406-.564.637-.992.782a.68.68 0 0 0-.475.749c.055.439.082.866-.179 1.258-.591.902-1.124 1.848-1.696 2.703l-.982.409c-.061.078-.13.16-.189.251-.119.178-.227.371-.361.54-.367.442-.436.965-.33 1.546l-.932.403a4892.63 4892.63 0 0 1-2.229 3.232c-.742 1.007-1.475 2.03-2.24 3.031-.399.504-.404.486-.479 1.502-.185.043-.356.112-.536.138-.322.033-.481.262-.549.615-.023.25-.046.48-.07.729-.272.033-.544.075-.882.129zm37.36-75.657c-.171.637-.547 1.369-.71 2.014.041.061.059.109.104.16l.319.324c-.118.041-.205.1-.354.121-.168.027-.248.077-.275.168-.48 1.564-.664 2.427-1.162 3.868l-.002-.001-.211.599-.15.394-.111.258-.092.189-.092.188-.111.258-.15.394-.209.599a2.147 2.147 0 0 0-.027.097c-.008.039-.018.083-.027.132l-.054.334-.044.362-.025.315-.002.024-.006.027-.02.059-.029.063-.037.068-.094.147-.105.155-.107.155c-.033.053-.064.103-.095.149l-.039.069-.03.065-.022.061-.007.027-.004.026-.013.098-.019.104-.057.228c-.022.078-.047.159-.072.242l-.082.25-.324.905-.002-.001-.323.085-.003-.001-.008-.002-.013-.005-.027-.009-.054-.019-.109-.036-.219-.072-.445-.146c-.297-.102-.6-.205-.904-.311l-.923-.328a405.84 405.84 0 0 1-.931-.351l-.932-.372-.467-.189-.461-.199-.915-.405c-.3-.142-.598-.281-.893-.419-1.332-.646-2.842-1.668-4.097-2.442-.114-.005-.211-.028-.309-.022l-.619.066c-.08-.176-.194-.332-.237-.523-.056-.218-.147-.363-.319-.48-1.494-1.018-2.582-1.863-3.58-2.745-.979-.874-1.953-1.864-2.711-2.952-.725-.992-1.258-2.383-1.459-3.571-.074-.08-.121-.156-.195-.224-.16-.137-.318-.277-.476-.43.1-.133.167-.281.327-.383.178-.119.244-.237.26-.408.131-1.498.818-2.522 1.599-3.309.81-.778 1.774-1.369 3.094-1.857 1.048-.424 2.853-.672 4.267-.877.088-.071.176-.113.246-.178.146-.152.283-.297.428-.446.172.084.354.128.508.252.18.14.342.194.547.174a40.772 40.772 0 0 1 4.549-.144c1.365.035 2.706.123 4.396.359v.003l.659.107.435.083.287.073a28.886 28.886 0 0 1 .422.126l.285.073 1.085.233.104.016.142.013.355.014.383.01.332-.004.026.001.028.003.063.014.07.023.076.031.165.079.176.091.174.098.166.084.076.035.072.026.064.018.029.005.027.002.104.006.111.012.243.04.261.056.269.072.973.285-.001.002.219.254-.002.003-.002.007-.003.013-.007.026-.015.053-.028.105-.057.212-.115.431-.234.881-.477 1.819c-.329 1.231-.662 2.482-.983 3.691zm47.971 58.683c-.235.026-.534-.1-.771-.073-.235.025-.408.199-.643.223l-3.342.35c-1.708.224-3.506.371-5.334.665-.328.052-.662.41-.99.458-.404.058-.807-.192-1.215-.134l-5.964.848c-.234.034-.542-.084-.774-.039-.234.042-.396.227-.629.265l-3.317.566c-1.694.312-3.472.641-5.292.978-.324.073-.635.454-.96.522-.399.086-.817-.138-1.222-.052l-5.9 1.247c-.232.045-.545-.037-.775.02-.23.058-.38.253-.609.308l-3.275.791c-1.668.442-3.432.843-5.206 1.382-.319.096-.603.496-.921.588-.395.111-.828-.081-1.225.031-1.921.556-3.877 1.082-5.787 1.717-.227.072-.545.008-.771.081s-.361.277-.587.347l-3.216 1.01-5.07 1.822c-.312.115-.564.531-.878.643-.385.14-.838-.031-1.221.122l-5.628 2.173c-.222.084-.541.052-.762.141-.219.092-.336.307-.555.395l-3.116 1.271c-1.593.661-3.229 1.414-4.924 2.153-.302.137-.524.57-.829.703-.373.164-.831.031-1.207.197l-1.693.765c.133-.146.271-.287.404-.433.1-.407.158-.807.275-1.165.117-.364.498-.05.721-.317.072-.094.16-.17.226-.27.291-.424.572-1.008.976-1.115.531-.158.883-.627 1.034-1.269.058-.237.063-.495.095-.739l.945-.276c1.112-1.479 2.264-2.977 3.313-4.509 2.326-3.273 4.438-6.66 6.483-10.084 1.363-2.283 2.652-4.605 3.922-6.938.157-.293.334-.575.469-.882.072-.183.584-.714.701-.853h.001c.144-.1.116-.229.276-.313.35-.184.458-.405.396-.812-.063-.448-.083-.869.146-1.282.266-.483.502-.982.758-1.472a.638.638 0 0 1 .211-.242c.188-.119.441-.177.574-.337.223-.271-.057-.619.027-.906.217-.739.586-1.418.934-2.104.095-.194.291-.305.491-.421.409-.235.423-.252.312-.734-.12-.514.107-.834.541-1.066.193-.107.373-.234.596-.375 1.029-2.287 2.084-4.601 3.059-6.932-.062-.347-.159-.674-.179-1.001-.021-.333.495-.267.618-.569.037-.104.098-.201.127-.307.135-.453.177-1.047.553-1.297.485-.341.67-.845.602-1.431-.023-.218-.104-.434-.154-.65l.846-.568c.656-1.617 1.271-3.274 1.91-4.922.706-1.856 1.371-3.729 2.055-5.595l.12-.352.026.002.062.001.058-.003.024-.005.022-.008.019-.01.017-.013.013-.017.01-.019.536-1.498.653-2.048.246-.776.031-.093.034-.085.071-.149a6.69 6.69 0 0 1 .076-.131l.077-.122.077-.121.076-.131.072-.148.033-.084.032-.092.013-.047.01-.055.018-.128.023-.305.022-.304.017-.127.01-.055.012-.046 1.347-4.214.62-1.965c.018-.061-.033-.146-.084-.232l.133-.412c.095-.048.189-.096.214-.17.106-.319.2-.647.304-.971a9.58 9.58 0 0 0 .119-.196c.119-.125.067-.247.207-.36.295-.24.355-.473.23-.838.028-.023.053-.048.061-.075.025-.087-.102-.202-.074-.288l.375-1.235-.002-.001.15-.555-.005-.042-.001-.051.004-.06.008-.066.027-.153.041-.177.115-.4.094-.278a.791.791 0 0 0 .232-.233c.075-.135.046-.267-.003-.397l.128-.316.127-.28.049-.093.02-.033.017-.022.058-.072.052-.076.046-.077.041-.08.069-.166.057-.172.095-.354.047-.177.054-.174.053-.171c.013-.051.024-.097.036-.139l.012-.063.008-.061.004-.062v-.063a3.731 3.731 0 0 1-.014-.144l-.032-.176-.071-.322c.268-.232.285-.307.133-.665l.029-.023.09-.056.062-.04.057-.046.051-.049.047-.053.043-.056.041-.058.072-.121.01-.014.012-.014.027-.025.027-.025.01-.013.008-.014.065-.173.058-.177.102-.358.025-.108.014-.106.005-.105-.003-.104-.002-.034.267-1.074.05-.052.059-.054.064-.051-.014-.051-.006-.053-.001-.053.004-.054.02-.108.028-.107.027-.104.022-.1.006-.047.002-.046-.004-.043-.011-.04-.004-.018c.43-1.729.855-3.467 1.244-5.21-.123-.33-.277-.636-.354-.954-.079-.324.439-.35.508-.669.018-.109.061-.215.07-.324.059-.469-.008-1.06.318-1.372.418-.422.512-.949.341-1.515-.062-.21-.18-.408-.267-.612l.732-.709c.37-1.704.676-3.446 1.018-5.18.374-1.952.693-3.916 1.036-5.874.292-1.968.63-3.928.886-5.899.377-2.625.681-5.262.975-7.898.039-.33.092-.658.1-.993-.003-.196.268-.882.323-1.056.095-.146.021-.256.136-.395.254-.303.269-.549.056-.901-.229-.392-.409-.772-.343-1.241.062-.549.089-1.101.137-1.65a.658.658 0 0 1 .104-.305c.127-.183.34-.332.4-.531.102-.336-.287-.552-.321-.85-.082-.767.013-1.535.062-2.304.013-.217.151-.395.291-.578.287-.376.293-.396.005-.8-.309-.429-.223-.812.089-1.195.136-.175.257-.361.401-.578l.087-3.796-.007-3.815c-.191-.294-.418-.555-.574-.848-.158-.297.337-.447.322-.775-.01-.112.004-.226-.015-.334-.066-.475-.263-1.023-.021-1.437.308-.54.269-1.116-.053-1.634-.115-.191-.282-.353-.42-.527l.512-.962c-.085-1.851-.303-3.708-.478-5.565a88.348 88.348 0 0 0-.462-3.387l1.579 2.561c.182.279.646.436.824.716.219.345.156.815.377 1.163 1.076 1.682 2.141 3.401 3.27 5.063.131.197.158.521.291.719.131.198.365.271.494.468l1.855 2.809 3.139 4.375c.195.268.664.397.857.668.238.332.195.814.445 1.143l3.625 4.818c.143.189.189.514.332.703.143.19.379.248.519.438l2.085 2.643 3.395 4.175c.219.25.702.342.918.594.266.311.269.783.536 1.097 1.296 1.519 2.607 3.058 3.911 4.585.154.18.219.502.375.681.16.175.402.214.559.39l2.248 2.502 3.641 3.957c.223.246.717.301.945.541.284.293.316.765.603 1.061l4.181 4.331c.166.171.25.485.416.656.164.171.406.198.567.37.771.829 1.591 1.598 2.37 2.381l3.871 3.726c.24.228.725.271.962.501.292.285.343.76.638 1.047 1.424 1.396 2.941 2.727 4.401 4.099.175.16.276.469.451.629s.418.175.589.337l2.459 2.287a143.151 143.151 0 0 0 4.029 3.547c.252.214.742.23.992.447.307.268.381.735.691 1.005l4.535 3.946c.18.155.291.462.47.617.137.118.36.178.454.211a.336.336 0 0 1 .081.054c.679.604 1.132 1.328 1.606 2.189.728 1.313 1.256 2.892 1.683 4.543.065.301.436.584.499.892.072.381-.146.766-.088 1.146.102.938.274 1.865.32 2.822.034.958.141 1.908.115 2.872-.002.228-.164.501-.166.728s.15.41.145.636c.01 1.085-.081 2.168-.172 3.231-.06 1.66-.32 3.398-.536 5.18-.038.32.228.733.161 1.053-.072.395-.436.694-.508 1.089l-.523 2.885c-.203.961-.443 1.918-.664 2.874-.052.226-.269.461-.32.686-.053.227.055.443 0 .667-.23 1.091-.58 2.11-.883 3.135-.234.796-.447 1.621-.715 2.442l-.928 2.457c-.109.299.045.757-.068 1.057-.128.377-.588.557-.748.914l-1.238 2.593-1.455 2.469c-.118.191-.373.35-.506.528-.13.182-.105.413-.237.593-.647.85-1.193 1.776-1.911 2.53a29.82 29.82 0 0 1-3.462 3.654c-.234.2-.31.663-.55.865-.303.242-.739.241-1.052.46-1.493 1.103-3.099 2.086-4.781 2.844-.201.083-.503.036-.701.118-.198.081-.302.291-.503.371-.959.33-1.973.65-2.795.746l-.197.018-5.051.434c-.331.031-.684.368-1.014.395-.407.033-.795-.242-1.205-.209-1.989.165-4.003.289-5.996.53zm18.003 9.052c-.623.183-1.262.266-1.893.406-.631.112-1.27.164-1.902.228-.248.006-.497.005-.746.02l-.713-.166a14.932 14.932 0 0 1-3.896-2.591c-.233-.186-.686-.225-.898-.45-.261-.28-.278-.712-.505-1.014a18.138 18.138 0 0 1-1.586-2.21c2.691-.258 4.703-.475 7.746-.709l.3-.024-.001-.003a19.16 19.16 0 0 0 3.113-.718c.516-.141 1.002-.337 1.482-.52a10.9 10.9 0 0 0 1.355-.606c.09-.106.182-.187.247-.283.132-.202.239-.417.36-.621.233.006.451-.062.675-.03.257.026.466-.019.692-.157 1.982-1.188 3.323-2.339 4.607-3.471 1.238-1.18 2.42-2.36 3.753-3.991.615-.679 1.196-1.507 1.823-2.311.307-.407.627-.807.91-1.216.262-.42.512-.833.74-1.23.015-.135.047-.25.047-.364-.002-.237-.031-.474-.043-.708.189-.121.359-.277.568-.363.238-.104.397-.242.524-.468.931-2.035 1.729-3.568 2.241-5.159.287-.783.57-1.558.872-2.379.288-.824.513-1.717.819-2.701.231-.855.596-1.799.848-2.75a60.39 60.39 0 0 0 .707-2.772c-.027-.129-.031-.245-.066-.351-.075-.22-.174-.431-.256-.646.145-.168.258-.363.43-.501.193-.165.313-.335.35-.586.764-4.318 1.077-6.648 1.404-10.748.158-1.767.332-3.978.295-5.798-.062-.122-.1-.236-.162-.332-.134-.198-.288-.382-.428-.572.092-.203.146-.427.273-.609.142-.215.197-.417.179-.676-.066-1.12-.265-2.115-.378-3.035-.158-.92-.375-1.769-.551-2.605-.496-1.664-.95-3.299-2.006-5.289-.57-1.014-1.344-2.366-2.418-3.309-.641-.59-1.107-1.021-1.637-1.47-.125-.034-.228-.083-.336-.102-.226-.033-.457-.044-.685-.071-.077-.203-.193-.393-.231-.605a.93.93 0 0 0-.334-.578l-4.121-3.473c-.366-.305-.73-.611-1.098-.923.197-.18.373-.456.605-.53.361-.119.768.028 1.124-.061 1.726-.516 3.535-.69 5.294-.474.211.016.436.201.637.251.203.041.396-.077.602-.034.168.028.33.08.494.128l-.156.406c.235.092.322.201.445.426.191.319.398.46.832.365.936-.205 1.665.168 2.175.971.046.064.2.148.258.13.136-.048.27-.071.403-.087.035.122.074.238.15.318.209.249.58.049.838.182.327.175.631.391.922.622.277.248.512.545.769.814.145.153.175.372.204.591.053.453.08.439.542.539.489.111.67.47.661.947-.001.215.021.424.029.671.388.45.633 1.01.936 1.528.276.536.622 1.034.852 1.601l.675 1.713.341.855c.109.287.162.599.245.897.257.227.532.422.746.671.22.256-.23.513-.146.823.033.106.045.218.086.319.164.439.502.949.275 1.375-.251.555-.165 1.071.184 1.548.129.178.307.327.457.495l-.453.905c.16.856.123 1.753.156 2.641l.07 2.676c-.059 2.014-.268 4.04-.388 6.064l-.941 6.053c-.558 2.673-1.216 5.338-1.846 8.002-.104.327-.229.648-.308.983-.038.2-.451.843-.541 1.005-.124.129-.074.253-.217.37-.313.256-.379.497-.245.896.142.439.236.865.071 1.326-.188.539-.345 1.089-.521 1.632a.667.667 0 0 1-.171.282c-.166.152-.405.249-.511.433-.176.312.116.616.062.921-.151.776-.493 1.503-.798 2.234-.084.207-.275.338-.468.472-.396.273-.406.288-.268.776.149.521-.061.87-.478 1.134-.186.121-.355.262-.567.417-.485 1.186-1.108 2.309-1.658 3.475-.585 1.145-1.079 2.352-1.794 3.413.013.351.061.691.029 1.023-.031.339-.533.202-.701.488-.054.1-.128.188-.172.29-.205.437-.355 1.027-.766 1.215a1.48 1.48 0 0 0-.607.533 1.603 1.603 0 0 0-.299.754c-.033.215-.01.443-.02.667l-.973.344c-.536.694-1.046 1.425-1.611 2.104l-1.81 1.939c-2.772 2.831-5.956 5.285-9.544 6.85l-1.807.74-1.854.553zm2.469 18.68c.027-.181-.012-.344.083-.517.103-.198.13-.347.072-.514-.456-1.463-.237-2.813.055-4.116.413-1.534.825-3.037 1.38-4.931l.004.001.271-.9.191-.596.139-.392.111-.29.021-.055c.221.061.42.198.607.398.166.173.348.327.557.521l8.257 1.971c.366-.111.704-.255 1.06-.321.361-.066.396.455.754.535.123.022.242.068.363.082.525.072 1.184.045 1.533.389.426.398.946.525 1.505.446l-2.987 4.226c-1.001 1.379-2.376 2.971-3.383 4.367-.023.127-.063.232-.072.341-.016.228-.006.457-.015.686-.194.091-.372.22-.581.271a.918.918 0 0 0-.545.374l-1.668 2.325-.64.897.478.299.25.155.001.001c-.112-.061-.341-.171-.47-.154a1.286 1.286 0 0 0-.357-.002l-.375.368.003-.004.005-.007.021-.031.352-.494.093-.131c-.18-.111-.355-.222-.54-.337-.689-.44-1.42-.905-2.236-1.427-.68-.441-1.564-.996-2.09-1.497-.326-.237-.526-.553-.799-.805-.242-.271-.407-.564-.624-.811-.108-.035-.151-.099-.237-.129a32.071 32.071 0 0 1-.547-.192zm43.043.378c-.272.373-.64.555-1.08.642a.681.681 0 0 0-.568.684c-.003.447-.039.866-.336 1.231-.682.835-1.312 1.719-1.969 2.51-.379.118-.696.217-1.02.316-.067.074-.143.15-.211.236-.133.17-.256.355-.404.514-.404.416-.516.934-.453 1.518l-.97.338c-1.659 2.091-3.222 4.298-4.823 6.479-.406.553-.422.549-.426 1.514-.199.074-.386.172-.584.233-.361.099-.523.349-.565.686-.015.222.005.447.007.678l-.975.354c-4.092 5.588-7.781 10.958-11.844 16.562-.13.177-.25.218-.484.256-.334.068-.506.205-.502.61 0 .866-.502 1.377-1.355 1.561-.07.02-.182.125-.176.18.073.591-.174 1.043-.516 1.479a85.2 85.2 0 0 0-1.74 2.325c-.265.373-.629.56-1.068.65a.67.67 0 0 0-.554.683c.007.442-.021.859-.311 1.225-.665.835-1.278 1.72-1.919 2.512l-1.005.309c-.066.07-.141.144-.208.226-.131.163-.252.342-.398.493-.398.396-.508.902-.455 1.488a14.16 14.16 0 0 1-.938.269c-1.525 1.876-3.131 3.778-4.965 5.449-.482.409-.449.434-.741 1.374-.194-.005-.382.017-.567-.004-.333-.051-.539.127-.68.447-.09.203-.158.423-.244.643l-.942-.141c-2.782 1.582-6.003 1.882-9.067 1.646-.77-.084-1.545-.146-2.316-.248l-2.316-.367-2.324-.469c-.774-.154-1.635-.375-2.455-.564-.209-.053-.291-.147-.414-.348-.189-.282-.376-.388-.746-.228-.799.334-1.463.071-1.945-.646-.043-.058-.18-.12-.229-.094-.514.289-1.021.229-1.543.076-.902-.274-1.799-.546-2.678-.83-.423-.123-.667-.432-.851-.814a.583.583 0 0 0-.715-.335c-.38.114-.79.202-1.136-.009-.816-.461-1.527-.964-2.037-1.536.041-.345.084-.6.135-.84a.603.603 0 0 1-.084-.175c-.055-.119-.133-.23-.178-.354-.076-.153-.119-.323-.277-.438-.139-.127-.369-.217-.578-.349.145-.245.289-.472.449-.711-.15-1.901.326-4.842 1.256-6.305.281-.386.242-.355.213-1.153.166-.02.343-.022.504-.007.287.038.438-.059.512-.32.039-.178.086-.355.143-.549.252.052.525.144.825.249.619-.239 1.243-.405 2.091-.55.891-.15 1.813-.257 2.711-.367 1.802-.22 3.582-.469 5.297-.991 1.709-.527 3.336-1.384 4.67-2.614 1.344-1.228 2.264-2.824 3.301-4.352.131-.191.245-.233.469-.271.322-.069.498-.224.51-.675.004-.176.023-.339.058-.488.146-.677.587-1.083 1.283-1.294.069-.025.18-.147.174-.208-.079-.635.161-1.139.484-1.618a88.005 88.005 0 0 0 1.584-2.461c.239-.395.591-.608 1.025-.734a.68.68 0 0 0 .508-.727c-.038-.441-.04-.858.225-1.246.608-.887 1.161-1.818 1.748-2.66l.991-.402c.061-.079.129-.161.189-.252.12-.179.223-.376.352-.55.355-.455.412-.984.291-1.564l.922-.432 4.223-6.902c.361-.586.378-.584.299-1.539.194-.093.373-.207.568-.287a.707.707 0 0 0 .48-.553l.799.504 1.142.724.288.183c-.035-.013.279.166.537.245.129.044.27.08.393.101.098.01.195.017.295.019.816-.008 1.172-.22 1.523-.376.13-.063.229-.147.336-.244l.17-.172.014-.014.002-.001.389-.384v-.002l.002-.005.004-.017.008-.035.016-.069c.041-.187.082-.372.179-.503.237-.322.694-.429.935-.754l3.506-4.742c.137-.188.43-.317.568-.504.137-.188.123-.428.264-.612l1.971-2.638-.002-.001c.107-.147.188-.263.292-.405l.006-.037.013-.042.02-.048.025-.053.068-.117.086-.131.216-.291.251-.305.258-.293.24-.252.192-.187c.027-.022.052-.042.07-.059l.027-.021.021-.012.073-.039.067-.043.063-.047.059-.052.057-.055.053-.058.1-.121.183-.258.092-.13.097-.125.096-.122.07-.102.029-.048.023-.048.021-.051.017-.053.027-.125.02-.16.037-.477.005-.039.007-.037.01-.035.012-.031.016-.029.02-.027.021-.024.024-.022.027-.02.03-.018.034-.016.036-.013.083-.021.098-.012.067-.01.063-.016.061-.021.058-.025.055-.03.052-.032.1-.073.014-.008.014-.007.032-.01.03-.011.014-.007.01-.009.107-.118.102-.126.068-.092 3.158.755 13.01 3.116 7.156 1.719a43.54 43.54 0 0 0-1.514 1.939zm34.275-13.39-1.238 1.711c-.434.557-.922 1.073-1.381 1.613-.47.532-.916 1.089-1.454 1.557-.528.496-.53.479-.8 1.523-.209.033-.409.095-.609.11-.372.001-.612.197-.769.537-.093.225-.156.468-.241.712l-1.021.044c-.748.516-1.518.997-2.292 1.456-.808.397-1.589.85-2.437 1.144-.824.351-1.688.598-2.555.798-.436.094-.872.186-1.316.227a5.7 5.7 0 0 1-.665.057 1.623 1.623 0 0 1-.658-.056l-10.698-2.478c-.243-.062-.342-.158-.492-.366-.23-.293-.452-.407-.871-.259-.904.318-1.674.039-2.278-.694-.054-.059-.217-.123-.271-.098-.579.286-1.167.222-1.786.063-1.08-.271-2.162-.532-3.256-.771-.516-.11-.887-.384-1.199-.764a.864.864 0 0 0-.978-.267c-.452.171-.894.3-1.413.164-1.19-.315-2.404-.562-3.537-.871l-.828-.829c-.109-.035-.225-.075-.346-.105-.238-.06-.488-.102-.723-.18-.623-.217-1.205-.121-1.773.16l-.819-.772-8.981-2.146c-.764-.186-.766-.201-1.766.143-.171-.162-.361-.303-.518-.469-.272-.305-.607-.368-.977-.286-.236.065-.461.165-.697.249l-.827-.79-13.695-3.185c.315-.051.625-.027.947.056a.882.882 0 0 0 .962-.36c.271-.387.511-.798.987-1.033 1.087-.557 2.175-1.133 3.119-1.801.431-.01.792-.031 1.165-.055.1-.058.207-.116.311-.187.205-.139.404-.296.62-.419.587-.318.827-.895.94-1.506l1.096-.203c.56-.506 1.182-.961 1.693-1.52l1.557-1.664c.505-.566 1.068-1.094 1.525-1.697l1.374-1.814c.465-.61.485-.613.544-1.633.215-.09.418-.205.633-.283.396-.125.533-.433.574-.8.01-.242-.016-.485-.025-.733l.985-.504 1.487-2.451c.494-.811.847-1.683 1.271-2.517l1.213-2.521c.196-.421.412-.834.592-1.261l.493-1.295 1.977-5.187 1.621-5.363c.072-.229.175-.316.39-.447.305-.202.43-.408.301-.813-.259-.869.01-1.589.721-2.154.058-.05.119-.206.094-.259-.293-.563-.238-1.124-.091-1.712.253-1.028.495-2.059.716-3.099.101-.49.368-.848.744-1.154.284-.227.349-.607.192-.951-.208-.43-.372-.847-.282-1.351.212-1.156.353-2.33.562-3.432.28-.323.517-.594.757-.869.023-.107.057-.22.072-.34.02-.237.02-.483.059-.72.111-.628-.078-1.178-.449-1.676l.626-.9.157-2.211c.078-.736-.008-1.498-.006-2.248l-.057-2.266c-.014-.755-.027-1.511-.156-2.271-.098-.769-.085-.785-.761-1.574.091-.214.154-.438.253-.644.187-.362.125-.697-.082-.999a4.721 4.721 0 0 0-.491-.526c.101-.328.2-.657.325-1.069l-.735-2.857c-.335-.929-.72-1.841-1.081-2.751-.314-.928-.889-1.76-1.35-2.626-.256-.422-.46-.871-.76-1.268l-.07-.094c.091.02.182.039.275.077 1.143.46 2.316.855 3.402 1.302l.72.926c.104.047.212.102.329.146.229.088.473.161.695.268.591.292 1.182.27 1.779.061l.718.868 8.646 3.24c.735.278.735.294 1.771.077.149.182.32.345.455.529.232.336.559.44.934.404.242-.035.478-.106.724-.161l.722.888 21.925 8.064c.234.09.32.201.444.425.191.319.397.46.832.364.932-.206 1.689.179 2.107.945.039.062.178.141.234.121.588-.221 1.139-.094 1.691.124.971.376 1.942.743 2.937 1.093.47.162.74.454.897.828.112.287.441.417.849.361.476-.013.929.028 1.295.374.438.376.822.808 1.234 1.203.38.425.743.858 1.087 1.288l.057 1.167c.055.09.108.188.174.281.127.186.285.356.387.56.252.555.694.838 1.273.992-.003.354-.008.697-.052 1.109 1.319 2.451 2.114 5.206 2.687 7.979.113.717.098.71.789 1.432-.086.209-.145.424-.24.617-.182.342-.105.641.068.943.131.188.291.355.441.543l-.514.982c.504 7.518-.613 14.864-2.836 22.318h.001c-.066.236-.16.33-.384.46-.312.204-.444.409-.33.827.246.902-.1 1.641-.877 2.159-.062.047-.141.199-.119.256.236.594.122 1.167-.086 1.758-.326 1.048-.805 2.024-1.184 3.054-.186.481-.509.798-.926 1.034a.82.82 0 0 0-.404.899c.092.464.182.938-.076 1.393-.562 1.059-1.064 2.156-1.607 3.162-.36.215-.662.394-.971.576l-.195.285c-.123.201-.234.416-.374.607-.382.504-.452 1.064-.351 1.682l-.957.503c-.356.644-.781 1.185-1.19 1.757zm19.401-15.322-.016.062-.019.062-.075.242-.15.487-.303.977-.306.981-.039.123-.046.12-.09.24-.183.482-.364.965-.183.482-.091.241-.049.12-.053.117-.836 1.881-.104.234-.053.117-.059.113-.233.455-.464.906-.23.453-.115.226-.127.218-.503.869-.497.865-.535.827-.675.365-.04.018-.042.015-.085.026-.082.03-.035.019-.033.023-.186.174-.083.091-.036.047-.033.05-.029.052-.025.055-.02.057-.016.059-.01.063-.005.065.001.07.008.074.014.12.004.116-.004.111-.012.105-.021.102-.03.097-.038.091-.049.085-.056.079-.065.074-.074.066-.041.031-.045.027-.096.052-.105.044-.113.038-.123.03-.176.034-.083.024-.038.016-.037.02-.107.072-.101.076-.09.084-.04.044-.036.047-.032.05-.029.052-.023.056-.02.059-.015.062-.009.066-.004.07.002.074.002.118-.006.113-.013.108-.021.104-.027.099-.036.093-.044.088-.053.081-.061.076-.068.069-.078.062-.086.056-.096.049-.104.042-.114.034-.123.025-.128.021-.124.027-.12.036-.115.045-.11.056-.105.067-.1.079-.096.093-.198.213-.1.105-.104.099-.416.395-.209.195-.104.098-.107.091-.107.091-.053.046-.008.006-.003.002-.001.002-1.541.658-.001.001-.005.018-.008.035-.068.28-3.634-.855.575-.784 1.053-1.44.523-.723.452-.743 1.787-2.961c.565-.999 1.04-2.04 1.563-3.059.51-1.024 1.046-2.037 1.449-3.102l1.736-4.21 1.449-4.297c.123-.358.268-.71.366-1.077.052-.217.507-.921.583-1.112.123-.147.072-.284.214-.42.312-.297.376-.572.238-1.006-.146-.479-.247-.936-.087-1.45l.503-1.818a.857.857 0 0 1 .169-.325c.168-.184.411-.319.517-.533.186-.357-.192-.665-.176-1.005.022-.884.237-1.741.417-2.602.048-.243.216-.427.385-.62.348-.393.357-.417.136-.902-.239-.519-.075-.936.249-1.351.149-.188.279-.392.447-.628.146-1.444.334-2.891.44-4.352l.097-4.411c-.21-.339-.452-.638-.619-.97-.172-.338.315-.525.285-.905-.003-.022-.004-.044-.006-.067l.006.004.035.021.038.017.038.013.04.01.042.003.042-.001.044-.007.047-.013.049-.019.051-.026.053-.032.084-.054.082-.046.08-.038.077-.029.075-.021.072-.011.068-.002.066.008.032.008.031.01.03.012.029.016.029.018.028.021.054.049.051.06.047.071.043.082.04.095.039.097.044.091.049.082.057.074.062.064.034.029.035.026.037.024.04.021.042.019.043.016.761.261.375.137.093.035.047.018.006.002.003.001h.001l.001.001.552.974h.002l.018-.004.035-.007.283-.056.357 2.074.217 2.122.055.531.027.265.014.133.004.134.029 1.074.059 2.149.016.538-.025.539-.057 1.079-.112 2.158-.028.54-.014.271-.006.135-.018.135-.147 1.074-.292 2.15-.168 1.249-.076.572-.008.06-.021.158-.006.04-.009.039-.018.078-.07.312-.555 2.484.014.72-.261.317-.449 1.979-.025.127z"
                })
            ]
        }),
        desktop: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlSpace: "preserve",
            viewBox: "0 0 400 400",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "M297.42 290.933c-.206-.137-.467-.205-.702-.309-.236.128-.461.271-.7.393-.116.058-.252.088-.397.143-.453.003-.937-.006-1.424-.017l-.299.395c-.027.034-.09.026-.17.007-.192-.044-.189-.039-.119.105l.055.111c-.111-.007-.341-.121-.205.101.051.083.07.148.043.181-.124.16-.343.242-.467.402l-1.68-1.385-.029-.001 1.697 1.399-3.95 4.854-.024.009-.025.013-.057.037-.061.051-.062.062-.062.069-.062.074-.111.157-.025.039-.002.005-.002.002-.001.001.001.001.003.005.007.011.034.037.04.033.023.014.024.011.026.01.026.007.028.005.029.002.031-.001.032-.004.033-.007.034-.011.062-.016c.028-.006.062-.014.103-.021l.274-.05.277-.051.104-.021.065-.017.145.028.137.019.274.018.728.031.051.001.047-.003.046-.006.044-.008.082-.023.08-.028.158-.056.085-.02.045-.005.047-.003.935.016.937.037.937.037.938.016v3.502l-7.118.061-4.84.042-1.045.037-.682.005-.334-.013c-.107-.009-.211-.019-.311-.026l-.011-.004-.013-.009-.031-.032-.018-.022-.01-.014-.003-.003-.001-.002.002-.004.008-.013a7.81 7.81 0 0 1 .074-.124l.457-.776.709-.851.581-.655.583-.653.713-.848.195-.225.1-.102.1-.093.102-.085.102-.076.104-.067.104-.059.085-.046.074-.048.067-.05.06-.054.051-.059.043-.064.037-.071.03-.078.255-.656.107-.134 3.088-3.764.057-.063.064-.061.068-.059.072-.055.146-.098.141-.08.086-.047.076-.05.068-.052.061-.055.039-.047c-.378-.007-.761-.016-1.115-.016v.001l-3.414.12-.293.326-.076.094-.066.095-.028.048-.024.047-.019.047-.013.046-.004.012-.007.012-.009.011-.011.011-.027.021-.034.018-.083.034-.093.032-.01.003-.295.365-.029.109-.053.153a.695.695 0 0 0-.027.057l-.013.021-.013.017c-.076.088-.139.159-.189.219l-.136.138-.099.084-.082.057-.08.057a.639.639 0 0 1-.045.037 2394.7 2394.7 0 0 0-8.309 10.402 1.277 1.277 0 0 1-.648.457c-.232.072-.445.229-.67.344-.045.26-.071.521-.123.781-.026.124-.086.247-.132.393-1.308 1.65-3.049 3.548-4.349 5.176-3.039 3.735-4.703 5.953-7.925 10.002a1.284 1.284 0 0 1-.647.458c-.233.072-.446.229-.672.344-.044.261-.07.521-.121.781-.021.117-.1.263-.121.377-.301.382-.64.782-.99 1.189h31.89l27.663-32.317a65.213 65.213 0 0 0-.008-.45c-.238-.007-.575-.017-.911-.025l-.25-.001-.24.007-.22.019-.101.014-.092.019-.024.004-.027.003-.061-.002-.068-.01-.074-.015-.162-.044-.172-.053-.172-.053-.16-.043-.073-.014-.066-.008h-.058l-.026.003-.022.005-.291.074-.34.071-.316.054-.127.015-.096.004-.455-.01-3.143 3.749c-.152.178-.321.301-.523.342-.172.036-.26.101-.277.25l-.082.431-1.864 2.18c-.085.098-.243.155-.37.185-.172.039-.267.104-.277.255a.436.436 0 0 1-.182.338l-2.649-2.291 4.74-5.612c-3.692 0-6.407.065-10.864.082-.305 0-.537-.068-.779-.222zm4.422 6.884 1.35-.039.011.025.014.02.017.014.019.01.021.004h.021l.021-.004.021-.009.01-.006.001-.001h.002l.004.003.009.005.033.02.03.015.025.009.012.002h.009l.007-.002.006-.003.004-.006.002-.008v-.01l-.004-.013-.004-.021-.001-.03.001-.078v-.078l-.001-.031-.003-.021.041-.005.033-.011.028-.014.024-.019.053-.046.032-.026.04-.027.009-.007.005-.01.002-.011v-.013l-.006-.029-.011-.031-.02-.062-.002-.014-.001-.012.003-.012.005-.009.068-.074.074-.069.16-.128.161-.128.075-.068.068-.075 2.648 2.29-.957 1.202-.65.816-.023.033-.027.047-.068.114-.044.06-.05.056-.027.024-.029.021-.031.019-.032.015-.005-.001-.008-.004a.52.52 0 0 1-.029-.016l-.02-.012-.011-.007-.003-.002-.002-.001v.001l-.004.002-.031.022-.191.141-.129.002c-.039-.004-.076-.006-.109-.008l-.189-.031-.188-.033-.11-.01-.129-.002-.032-.002-.032-.006-.029-.013-.029-.018-.028-.023-.026-.03-.025-.037-.024-.043-.02-.037-.019-.027-.018-.02-.008-.007-.009-.005-.009-.002h-.008l-.008.003-.009.005-.009.007-.008.01-.018.026-.145.221-.037.002-.523.012-.525.001-.01-.001-.01-.003-.019-.011-.019-.016-.02-.021-.036-.052-.032-.058-.02-.035-.02-.027-.018-.021-.009-.006-.009-.005-.009-.002h-.009l-.008.003-.009.004-.009.008-.008.011-.018.028-.018.031-.018.025-.02.019-.018.013-.02.008-.008.001h-.01l-.008-.001-.009-.003-.016-.009v-3.502zm-2.056.039c.158.176.162.17.283.023l.091-.113c.12.092.225.341.378.096.057-.092.125-.148.2-.148.366-.006.733.109 1.1.104v3.504l-3.511.102a.347.347 0 0 1-.311-.172c-.072-.107-.127-.131-.191-.047l-.195.221c-.488.008-.984.022-1.479.015-.067 0-.143-.083-.197-.16-.073-.103-.13-.133-.192-.042-.063.092-.139.115-.193.084v-3.504l4.012-.089c.077-.002.139.052.205.126z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M258.751 323.998c-.195.228-.392.455-.595.688l-.056 1.46-.018.715-.004.767h.001l.132 7.104.914.023h.251l.241-.008.221-.019.101-.015.092-.019.024-.005.027-.002.061.002.068.008.074.016.164.043.172.053.173.052.161.042.073.014.066.008h.059l.025-.003.023-.006.292-.074.34-.073.317-.054.128-.016.095-.004c.242.004.44.007.604.011l.4.019.266.024.198.027.198.027.266.024.4.02.604.012v.003c5.052.019 7.961-.079 13.39-.116.313-.004.552.063.801.217.213.137.48.204.723.307.242-.129.473-.272.719-.396.119-.058.26-.088.408-.144 2.208-.02 4.901.144 7.087.132v-.001l2.896-.13.283-.244.072-.07.065-.074.027-.038.024-.039.019-.038.014-.04.004-.011.007-.009.008-.009.011-.008.026-.013.031-.011.078-.016.088-.011.086-.012.076-.017.031-.011.024-.013.009-.008.008-.009.006-.01.003-.011.032-.137.049-.148.027-.069.027-.06.026-.047.013-.018.012-.013.184-.164.13-.101.095-.059c.027-.014.053-.025.076-.036l.076-.037.096-.058c.035-.027.076-.06.13-.1.05-.045.11-.099.185-.164l.002.002c2.498-2.41 3.859-3.877 6.504-6.508a.74.74 0 0 1 .545-.229c.199-.004.379-.085.569-.127.029-.209.042-.423.077-.628.02-.099.066-.188.101-.299 1.073-1.074 2.513-2.252 3.581-3.309 2.498-2.411 3.859-3.877 6.505-6.509a.744.744 0 0 1 .546-.229c.199-.005.378-.085.568-.128.029-.208.043-.422.078-.628.018-.098.065-.187.1-.298 1.074-1.073 2.512-2.25 3.578-3.308l2.053-2.185.023-.386v-.105l-.008-.102-.008-.048-.012-.046-.014-.042-.019-.039-.005-.01-.002-.012v-.013l.002-.013.008-.029.016-.031.043-.068.053-.073.053-.073.041-.067.014-.03.008-.028.001-.013-.001-.012-.003-.012-.006-.01-.075-.123-.072-.143-.03-.07-.024-.063-.014-.054-.004-.022-.001-.018c.004-.103.007-.186.011-.255l.019-.169.024-.111.027-.084.027-.083.024-.112.02-.169.012-.256h.003c.02-1.555-.079-2.45-.116-4.122-.004-.096.063-.169.217-.246.137-.065.204-.148.307-.223l-.396-.222c-.057-.036-.088-.079-.144-.125-.019-.679.143-1.507.132-2.179h-.001l-.124-6.632-27.663 32.317h-31.89z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M295.567 301.321c.055.031.13.008.193-.084.062-.091.119-.061.192.042.055.077.13.16.197.16.495.008.991-.007 1.479-.015l.195-.221c.064-.084.119-.061.191.047a.346.346 0 0 0 .311.172l3.511-.102v-3.504c-.366.006-.733-.109-1.1-.104-.075 0-.144.057-.2.148-.153.245-.258-.004-.378-.096l-.091.113c-.121.146-.125.152-.283-.023-.066-.074-.128-.129-.207-.128l-4.012.089v3.506zM301.866 301.333l.008.001h.01l.008-.001.02-.008.018-.013.02-.019.018-.025.018-.031.018-.028.008-.011.009-.008.009-.004.008-.003h.009l.009.002.009.005.009.006.018.021.02.027.02.035.032.058.036.052.02.021.019.016.019.011.01.003.01.001.525-.001.523-.012.037-.002.145-.221.018-.026.008-.01.009-.007.009-.005.008-.003h.008l.009.002.009.005.008.007.018.02.019.027.02.037.024.043.025.037.026.03.028.023.029.018.029.013.032.006.032.002.129.002.11.01.188.033.189.031c.033.002.07.004.109.008l.129-.002.191-.141.031-.022.004-.002v-.001l.002.001.003.002.011.007.02.012.029.016.008.004.005.001.032-.015.031-.019.029-.021.027-.024.05-.056.044-.06c.024-.041.049-.08.068-.114.01-.017.02-.032.027-.047l.023-.033.65-.816.957-1.202-2.648-2.29-.068.075-.075.068-.161.128-.16.128-.074.069-.068.074-.005.009-.003.012.001.012.002.014.02.062.011.031.006.029v.013l-.002.011-.005.01-.009.007-.04.027-.032.026-.053.046-.024.019-.028.014-.033.011-.041.005.003.021.001.031v.078l-.001.078a.332.332 0 0 1 .001.03l.004.021.004.013v.01l-.002.008-.004.006-.006.003-.007.002h-.009l-.012-.002-.025-.009-.03-.015-.033-.02-.009-.005-.004-.003h-.002l-.001.001-.01.006-.021.009-.021.004h-.021l-.021-.004-.019-.01-.017-.014-.014-.02-.011-.025-1.35.039v3.504l.016.009.004.001zM264.606 216.837c-.008-.055-.016-.105-.021-.154-.012-.048-.021-.094-.031-.139l-.035-.132-.035-.132-.031-.139-.021-.155-.005-.085-.001-.093.01-.765c.009-.718.019-1.398.026-2.021l-.002-1.682-.003-.022-.007-.021-.011-.019-.015-.017-.018-.016-.022-.014-.053-.022-.063-.019-.072-.015c-.051-.007-.105-.015-.162-.021l-.344-.034-.078-.013-.07-.015-.062-.02-.027-.012-.023-.013-.039-.021-.043-.014-.047-.01-.051-.002-.107-.004-.114.001h-.117l-.115-.009-.057-.01-.055-.014-.051-.021-.049-.025-.137.093-.064.037-.062.031-.061.026-.059.021-.057.016-.055.012-.055.008-.053.004h-.051l-.051-.002-.098-.015-.094-.022-.184-.063-.184-.069-.094-.03-.096-.024-.1-.017-.105-.005-.348.001-.174.007-.173.016-.015.004-.014.006-.029.019-.029.02-.015.008-.016.006-.126.037-.062.022-.061.025-.06.031-.058.036-.055.042-.052.049-.072.07-.071.056-.035.021-.035.019-.034.014-.034.01-.035.007-.035.003-.035-.002-.035-.005-.036-.009-.036-.013-.037-.017-.036-.02a50.99 50.99 0 0 1-.438-.253l-.152-.078-.125-.053-.058-.019-.057-.013-.058-.009-.06-.006-.134-.004a7.346 7.346 0 0 1-.167.004l-.171.005-.172-.003-.342-.006-.169.007-.084.009-.083.013-.083.018-.081.022-.082.029-.08.035-.024.01-.034.011a8.744 8.744 0 0 1-.097.021l-.285.045-.373.043-.421.034-.426.021-.391.001a22.813 22.813 0 0 1-.17-.009l-.145-.016-.062-.01-.048-.011-.046-.014-.036-.018-.545-.006v.001c-1.762.011-3.933-.151-5.713-.132-.12.056-.233.086-.329.144-.197.123-.385.267-.58.396-.194-.103-.41-.17-.582-.307a.967.967 0 0 0-.646-.217c-4.378.037-6.724.135-10.798.116-1.764.012-3.938-.151-5.72-.132-.12.056-.232.086-.329.144-.197.123-.384.267-.579.396-.195-.103-.411-.17-.583-.307a.967.967 0 0 0-.646-.217c-4.378.037-6.724.135-10.798.116-1.764.012-3.938-.151-5.719-.132-.121.056-.233.086-.33.144-.197.123-.384.267-.579.396-.195-.103-.411-.17-.583-.307a.966.966 0 0 0-.645-.217c-4.378.037-6.725.135-10.797.116v-.003l-4.154-.049-.045-.003-.051-.007a3.099 3.099 0 0 0-.119-.024l-.276-.074-.277-.073-.119-.025-.052-.007-.045-.003-.092.002-.084.006a9.925 9.925 0 0 0-.154.021l-.139.03-.132.036-.132.035-.139.03-.155.021-.085.005-.093.001-.765-.01c-.718-.01-1.398-.019-2.021-.026l-1.682.003-.022.002-.021.007-.018.011-.018.015-.016.019-.014.021-.023.053-.018.063-.016.071-.021.163-.034.343-.013.078-.015.071-.02.062-.012.027-.013.024-.021.038-.014.043-.01.047-.006.05-.005.107.001.114v.117l-.009.116-.009.056-.016.055-.02.052-.025.049.093.136.037.064.031.062.026.06.021.06.016.057.012.056.008.054.004.053v.051l-.002.051-.014.097-.023.095-.063.185-.069.183-.03.094-.024.097-.016.1-.006.104.001.349.007.173.016.173.004.014.006.015.018.028.02.03.009.015.006.016.036.127.023.062.025.062.031.059.035.058.021.026-.013 1.027a.88.88 0 0 1-.034.061l-.078.15-.053.126-.019.058-.013.057-.009.058-.006.06-.004.135.004.166.004.171-.002.172-.006.342.007.169.009.084.013.083.018.083.022.082.029.081.029.067-.008.272c-.002.05.022.093.066.134l-.002.11-.002.044-.008.052-.025.118c-.021.085-.047.182-.073.277l-.073.277-.025.119-.007.052-.003.045.002.091.006.086.021.153.03.139.036.132.035.132.03.14.021.154.006.086v.092l-.01.765-.026 2.021.003 1.682.002.022.007.021.011.019.015.017.019.015.021.014.053.023.063.019.071.015.163.021.343.035.078.012.072.016.062.019.027.012.024.013.038.02.043.016.047.01.05.006.107.004.114-.002.117.001.116.009.056.01.054.014.053.02.049.026c.048-.033.094-.063.135-.093l.064-.037.062-.031.061-.026.059-.021.058-.017.056-.012.054-.008.052-.004.052-.001.05.004.098.014.096.022.184.063.183.068.094.031.097.024.1.017.104.005.349-.001.174-.006.172-.017.014-.003.015-.007.028-.019.03-.02.015-.008.016-.006.127-.037.062-.021.062-.027.059-.03.058-.036.055-.042.052-.049.072-.071.07-.055.035-.021.035-.018.035-.015.035-.011.034-.006.035-.003.035.002.036.005.035.009.036.013.036.016.037.021c.188.107.328.188.439.253l.15.078.126.053.058.018.057.014.057.01.061.006.135.002c.049 0 .104-.002.166-.004l.171-.004.171.003.343.007.169-.008.084-.009.083-.013.083-.018.082-.022.08-.029.081-.036.024-.01.035-.01c.025-.006.059-.014.096-.021l.285-.045.373-.043.42-.034.426-.021.392-.001.169.009.146.015.062.012.054.012.045.016.037.017.545.006v-.001c1.762-.012 3.933.151 5.713.132.12-.056.232-.086.329-.144.198-.123.384-.267.579-.396.195.103.412.17.583.307a.969.969 0 0 0 .646.217c4.379-.037 6.724-.135 10.799-.116 1.762-.012 3.937.151 5.719.132.12-.056.232-.086.328-.144.199-.123.385-.267.58-.396.195.103.412.17.582.307a.97.97 0 0 0 .646.217c4.378-.037 6.723-.135 10.799-.116 1.762-.012 3.936.151 5.719.132.119-.056.232-.086.328-.144.199-.123.385-.267.58-.396.195.103.411.17.582.307a.97.97 0 0 0 .646.217c4.377-.037 6.723-.135 10.796-.116v.003l4.154.049.044.003.052.007.118.024.277.074.277.073c.043.009.083.018.119.024l.052.008.045.003.091-.002.086-.005c.054-.008.104-.016.153-.021l.139-.031.132-.035.131-.035.141-.031.154-.021.086-.005.092-.001.765.01c.718.01 1.397.019 2.021.026l1.682-.003.022-.002.02-.007.02-.011.017-.015.015-.019.014-.021.023-.053.02-.063.014-.072.021-.162.035-.343.012-.079.016-.07.019-.062.012-.027.013-.024.02-.038.016-.043.01-.047.006-.05.004-.107-.002-.114.001-.117.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.061-.021-.059-.017-.057-.012-.056-.008-.054-.004-.053-.001-.051.004-.051.014-.098.022-.094.063-.184.068-.184.031-.094.024-.096.017-.101.005-.104-.001-.348-.006-.174-.017-.173-.003-.015-.007-.014-.019-.029-.02-.029-.008-.015-.006-.016-.037-.126-.021-.062-.027-.061-.03-.06-.036-.058-.02-.025.012-1.027.035-.061.078-.152.053-.125.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.029-.064.008-.275c.003-.05-.022-.093-.065-.135l.001-.109.003-.045.007-.051.024-.119.074-.276.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.092-.009-.092zm-4.056 1.674-.035.165-.055.317-.014.128-.005.095.011.604.019.4.024.266.016.115-.035 1.896-.914.023h-.251l-.241-.008-.221-.019-.101-.015-.092-.019-.024-.005-.027-.002-.061.002-.068.008-.074.016-.164.043-.172.053-.173.052-.161.042-.073.014-.066.008h-.059l-.025-.003-.023-.006-.292-.074-.34-.073-.317-.054-.128-.016-.095-.004c-.242.004-.44.007-.604.011l-.4.019-.266.024-.198.027-.198.027-.265.024-.401.02-.604.012-5.445.029c-.336.004-.721.312-1.057.312-.415 0-.784-.305-1.201-.305l-6.103-.007c-.24 0-.527-.158-.768-.158s-.434.153-.672.15l-3.406-.021-5.447.029c-.337.004-.721.312-1.058.312-.415 0-.784-.305-1.201-.305l-6.103-.007c-.24 0-.527-.158-.768-.158s-.434.153-.672.15l-3.406-.021-5.447.029c-.337.004-.721.312-1.058.312-.414 0-.784-.305-1.201-.305l-6.102-.007c-.24 0-.528-.158-.769-.158s-.433.153-.672.15l-3.406-.021v.002l-7.099-.132a116.19 116.19 0 0 1-.022-.914l-.001-.251.008-.241.019-.221.016-.101.018-.092.005-.024.003-.027-.002-.061-.01-.068-.015-.074a17.27 17.27 0 0 1-.043-.164l-.053-.172-.013-.041.02-1.014.033-.158.055-.317.016-.128.004-.095-.01-.604-.02-.4-.024-.266-.016-.116c.013-.649.024-1.287.035-1.896l.914-.023h.251l.24.008.222.019.101.015.092.019.024.005.027.002.061-.001.068-.01.075-.015.162-.043.174-.053.172-.052.161-.042.073-.014.066-.008h.059l.025.003.023.006.292.074.34.073.317.054.127.016.096.004.604-.01.4-.02.266-.024c.074-.01.136-.019.198-.026.062-.01.124-.018.198-.028l.266-.024.4-.02.604-.012 5.445-.029c.336-.004.721-.312 1.057-.312.414 0 .783.305 1.201.305l6.102.007c.24 0 .529.158.77.158s.432-.153.671-.15l3.407.021 5.447-.029c.336-.004.721-.312 1.057-.312.414 0 .783.305 1.201.305l6.102.007c.24 0 .529.158.77.158s.432-.153.671-.15l3.407.021 5.447-.029c.336-.004.721-.312 1.057-.312.414 0 .783.305 1.201.305l6.102.007c.24 0 .529.158.77.158s.432-.153.67-.15l3.407.021v-.002l7.099.132.023.914v.251l-.008.24a9.657 9.657 0 0 1-.02.222l-.014.101-.019.092-.005.024-.002.027.002.061.008.068.016.074.043.163.053.174.013.041-.019 1.007zM264.934 128.661c-.056-.118-.086-.229-.144-.323-.123-.194-.266-.378-.396-.569.103-.191.171-.404.307-.572a.934.934 0 0 0 .217-.634c-.004-.532-.003-1.026-.049-1.63-.017-.569-.115-1.103-.204-1.615-.08-.515-.25-.99-.371-1.464-.162-.46-.333-.907-.519-1.343-.8-1.716-1.887-3.263-3.659-4.788-1.549-1.278-3.802-2.554-5.867-2.864-.147.033-.281.044-.398.084-.243.088-.47.199-.697.297-.205-.117-.442-.195-.629-.342a1.177 1.177 0 0 0-.724-.248c-4.301.037-6.604.135-10.606.116-1.732.012-3.867-.151-5.618-.132-.118.056-.229.086-.323.144-.194.123-.377.267-.569.396-.191-.103-.403-.17-.571-.307a.942.942 0 0 0-.635-.217c-4.301.037-6.604.135-10.607.116-1.73.012-3.867-.151-5.617-.132-.118.056-.229.086-.322.144-.195.123-.379.267-.57.396-.191-.103-.404-.17-.572-.307a.94.94 0 0 0-.634-.217c-4.301.037-6.604.135-10.606.116-1.732.012-3.867-.151-5.618-.132-.118.056-.229.086-.323.144-.194.123-.377.267-.568.396-.192-.103-.404-.17-.572-.307a.942.942 0 0 0-.635-.217c-4.301.037-6.604.135-10.607.116-1.73.012-3.866-.151-5.617-.132-.117.056-.229.086-.322.144-.195.123-.378.267-.57.396-.191-.103-.404-.17-.572-.307a.938.938 0 0 0-.634-.217c-4.3.037-6.604.135-10.606.116-1.732.012-3.867-.151-5.618-.132-.118.056-.229.086-.323.144-.194.123-.377.267-.568.396-.192-.103-.404-.17-.572-.307a.942.942 0 0 0-.635-.217l-1.526.017c-.488.009-.909.003-1.461.044a9.672 9.672 0 0 0-1.493.168c-.482.065-.943.191-1.398.319-1.809.531-3.516 1.36-5.262 2.918-.762.665-1.52 1.513-2.189 2.434-.656.933-1.188 1.965-1.51 2.952.007.149-.014.279.018.404.059.256.144.499.215.74-.15.188-.291.405-.446.574-.187.198-.288.41-.328.7-.099.622-.083 1.243-.106 1.781l.02 1.383.043 2.506c.027 1.614.047 3.19.037 5.192.012 1.731-.15 3.867-.132 5.617.056.118.087.229.144.323.123.194.267.378.396.569-.103.191-.17.404-.307.572a.94.94 0 0 0-.217.634c.037 4.301.136 6.604.116 10.606.012 1.732-.15 3.867-.132 5.618.056.118.087.229.144.323.123.194.267.377.396.569-.103.191-.17.403-.307.572a.938.938 0 0 0-.217.634c.037 4.301.136 6.604.116 10.607.012 1.73-.15 3.866-.132 5.617.056.118.087.229.144.323.123.194.267.377.396.569-.103.191-.17.404-.307.572a.938.938 0 0 0-.217.634l.144 10.691c.02 1.013.215 2.136.486 3.246.338 1.087.755 2.176 1.344 3.031.119.089.214.183.319.245.226.123.478.202.708.3.049.235.143.471.157.712.035.269.136.479.337.691 1.748 1.846 3.553 2.749 5.326 3.363.896.303 1.818.481 2.799.6.484.044 1.012.059 1.515.076l1.429.002c1.73-.012 3.867.151 5.617.132.118-.056.229-.086.323-.144.194-.123.378-.267.569-.396.191.103.404.17.572.307a.94.94 0 0 0 .634.217c4.301-.037 6.604-.135 10.606-.116 1.732-.012 3.867.151 5.618.132.118-.056.229-.086.323-.144.194-.123.377-.267.568-.396.192.103.404.17.572.307a.942.942 0 0 0 .635.217c4.301-.037 6.604-.135 10.607-.116 1.73-.012 3.867.151 5.617.132.117-.056.229-.086.322-.144.195-.123.379-.267.57-.396.191.103.404.17.572.307a.938.938 0 0 0 .634.217c4.3-.037 6.604-.135 10.606-.116 1.732-.012 3.867.151 5.618.132.118-.056.229-.086.323-.144.194-.123.377-.267.568-.396.192.103.404.17.572.307a.942.942 0 0 0 .635.217c4.301-.037 6.604-.135 10.607-.116 1.73-.012 3.866.151 5.617.132.117-.056.229-.086.322-.144.195-.123.378-.267.57-.396.191.103.403.17.572.307a.938.938 0 0 0 .634.217c4.3-.037 6.604-.135 10.606-.116.458-.011.835.023 1.422 0a11.555 11.555 0 0 0 1.68-.112 11.084 11.084 0 0 0 3.19-.871c.104-.11.208-.194.283-.294.151-.209.277-.427.41-.637.235-.021.478-.088.715-.072.272.008.513-.035.743-.216 2.056-1.488 3.266-3.091 4.105-4.782.826-1.699 1.346-3.53 1.395-5.87-.012-1.731.151-3.867.132-5.618-.056-.117-.086-.229-.144-.322-.123-.195-.266-.378-.396-.569.103-.192.171-.404.307-.572a.936.936 0 0 0 .217-.634c-.036-4.301-.135-6.604-.116-10.607-.012-1.731.151-3.867.132-5.617-.056-.118-.086-.229-.144-.323-.123-.194-.266-.378-.396-.569.103-.191.171-.404.307-.572a.935.935 0 0 0 .217-.635c-.036-4.3-.135-6.604-.116-10.606-.012-1.731.151-3.867.132-5.617-.056-.118-.086-.229-.144-.323-.123-.194-.266-.378-.396-.569.103-.191.171-.404.307-.572a.933.933 0 0 0 .217-.634c-.036-4.301-.135-6.604-.116-10.607-.015-1.731.148-3.867.129-5.617zm-3.85 20.594-.021 3.347.029 5.351c.005.33.312.708.312 1.039 0 .406-.305.77-.305 1.18l-.007 5.993c0 .236-.158.52-.158.755 0 .236.153.425.15.66l-.021 3.346.029 5.351c.005.331.312.708.312 1.038 0 .407-.305.771-.305 1.18l-.007 5.994c0 .236-.158.52-.158.755 0 .236.153.425.15.659l-.021 3.347a9.24 9.24 0 0 1-1.042 4.271c-.121.241-.039.664-.184.913-.195.296-.641.349-.836.624-1.069 1.263-2.482 2.277-4.064 2.804-.184.073-.452-.001-.641.036-.187.047-.301.235-.492.282-.957.176-1.76.21-2.945.186l-5.351.029c-.33.004-.708.312-1.038.312-.407 0-.77-.305-1.18-.305l-5.994-.007c-.236 0-.52-.158-.755-.158s-.425.153-.659.15l-3.346-.021-5.352.029c-.33.004-.707.312-1.038.312-.407 0-.77-.305-1.18-.305l-5.993-.007c-.236 0-.52-.158-.756-.158s-.425.153-.659.15l-3.347-.021-5.35.029c-.331.004-.709.312-1.039.312-.406 0-.77-.305-1.18-.305l-5.994-.007c-.235 0-.519-.158-.755-.158-.235 0-.425.153-.659.15l-3.346-.021-5.352.029c-.33.004-.707.312-1.038.312-.407 0-.77-.305-1.18-.305l-5.993-.007c-.236 0-.52-.158-.756-.158s-.424.153-.659.15l-3.347-.021-5.35.029c-.331.004-.709.312-1.039.312-.406 0-.77-.305-1.18-.305l-5.994-.007c-.235 0-.519-.158-.754-.158-.236 0-.426.153-.66.15l-3.346-.021-1.301.01c-.434.001-.754-.03-1.143-.038-.736-.099-1.49-.223-2.207-.5-.258-.082-.676.09-.931-.047-.325-.145-.454-.556-.737-.741-1.432-.837-2.607-2.129-3.379-3.594-.084-.179-.044-.456-.129-.628-.085-.171-.266-.266-.335-.449a8.258 8.258 0 0 1-.522-2.711 14.697 14.697 0 0 1-.034-1.214l-.009-1.327-.01-2.723c-.005-.331-.312-.709-.312-1.039 0-.406.305-.77.305-1.18l.008-5.994c0-.235.158-.519.157-.755.001-.235-.153-.425-.15-.659l.021-3.346-.029-5.352c-.004-.33-.312-.707-.312-1.038 0-.407.305-.77.305-1.18l.007-5.993c.001-.236.159-.52.158-.756.001-.235-.153-.424-.15-.659l.021-3.347-.029-5.35c-.004-.331-.312-.708-.312-1.039 0-.406.305-.77.305-1.18l.007-5.993c.001-.236.159-.52.158-.755.001-.236-.153-.426-.15-.66l.021-3.346-.029-5.352c-.004-.33-.312-.707-.312-1.037 0-.408.305-.771.305-1.181l-.002-1.493c.028-.447.016-.844.085-1.262.089-.83.352-1.627.649-2.398.089-.177.334-.319.417-.491.077-.177.021-.384.13-.548a8.586 8.586 0 0 1 1.771-2.13 8.83 8.83 0 0 1 3.868-2.11c.26-.079.509-.453.798-.483.35-.062.688.202 1.027.198.382-.031.893-.03 1.396-.028l1.5.001 3 .008c.236 0 .52.158.756.158s.425-.153.659-.15l3.347.021 5.35-.029c.331-.004.709-.312 1.039-.312.406 0 .77.305 1.18.305l5.994.007c.235 0 .519.158.755.158.235 0 .425-.153.659-.15l3.346.021 5.352-.029c.33-.004.707-.312 1.038-.312.407 0 .77.305 1.18.305l5.993.007c.236 0 .52.158.756.158s.424-.153.659-.15l3.347.021 5.35-.029c.331-.004.709-.312 1.039-.312.406 0 .77.305 1.18.305l5.994.007c.235 0 .519.158.754.158.236 0 .426-.153.66-.15l3.346.021 5.352-.029c.33-.004.707-.312 1.037-.312.408 0 .771.305 1.181.305l5.993.007c.236 0 .52.158.756.158.235 0 .424-.153.658-.15l3.348.021 5.35-.029c.33-.004.709-.312 1.039-.312.406 0 .77.305 1.18.305l2.992-.001c.871.031 1.689.086 2.495.33.193.047.375.254.552.33.18.065.381-.025.564.043.861.371 1.664.858 2.373 1.438a9.348 9.348 0 0 1 2.651 3.519c.093.253.499.445.594.718.081.345-.119.711-.057 1.041.153.845.183 1.554.172 2.631l-.008 3.001c0 .236-.158.52-.158.755 0 .236.153.426.15.66l-.021 3.346.028 5.351c.006.331.312.708.312 1.038 0 .407-.305.771-.305 1.181l-.007 5.993c0 .236-.158.52-.158.756.003.232.156.421.153.655z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M242.704 161.032c-.008-.054-.016-.104-.021-.153-.012-.048-.021-.094-.031-.139l-.03-.114a.253.253 0 0 0 .007-.016l.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.008-.018c.001-.274-.007-.562-.022-.856l.01-.719-.002-1.682-.003-.022-.007-.021-.011-.019-.015-.017-.018-.015-.022-.014-.053-.023-.063-.019-.072-.015a11.524 11.524 0 0 0-.162-.021l-.344-.035-.078-.012-.07-.016-.062-.019-.027-.012-.023-.013-.039-.02-.043-.016-.047-.01-.05-.006-.107-.004-.114.002-.117-.001-.115-.009-.057-.01-.055-.014-.051-.02-.049-.026-.137.093-.064.037-.062.031-.061.026-.059.021-.057.017-.055.012-.011.001-.272-.003-.023-.003-.094-.022-.184-.063-.184-.068-.094-.031-.096-.024-.1-.017-.105-.005-.348.001-.174.006-.173.017-.015.003-.014.007-.029.019-.029.02-.015.008-.016.006-.126.037-.062.021-.061.027-.041.021-.041-.001-.057-.012-.277-.074-.277-.073c-.043-.009-.083-.018-.119-.024l-.052-.008-.045-.003-.091.002-.086.005c-.054.008-.104.016-.153.021l-.139.031-.114.03a.253.253 0 0 0-.016-.007l-.058-.018-.057-.014-.058-.01-.06-.006-.134-.002c-.051 0-.105.002-.167.004l-.171.004-.172-.003-.342-.007-.169.008-.084.009-.083.013-.083.018-.081.022-.082.029-.018.008c-.273-.001-.559.007-.853.022l-.723-.01-1.682.003-.022.002-.02.007-.02.011-.017.015-.015.019-.014.021-.023.053-.02.063-.014.072-.021.162-.035.343-.012.079-.016.07-.019.062-.012.027-.013.024-.02.038-.016.043-.01.047-.006.05-.004.107.002.114-.001.117-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.061.021.059.017.057.012.056.001.011-.002.271-.004.023-.022.094-.063.184-.068.184-.031.094-.024.096-.017.101-.005.104.001.348.006.174.017.173.003.015.007.014.019.029.02.029.008.015.006.016.037.126.021.062.027.061.021.041-.002.04-.012.058-.074.277-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.045.001.091.006.086c.008.054.016.104.021.153.012.048.021.094.031.139l.03.114a.253.253 0 0 0-.007.016l-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.008.018c-.001.273.007.558.022.851l-.01.725.001.547-.126-.013-.078-.013-.07-.015-.062-.02-.027-.012-.023-.013-.039-.021-.043-.014-.047-.01-.05-.007-.107-.004-.114.001h-.117l-.115-.009-.057-.01-.055-.014-.051-.021-.049-.025-.137.093-.064.037-.062.031-.061.026-.059.021-.057.016-.055.012-.011.002-.274-.004-.021-.003-.094-.022-.184-.063-.184-.069-.094-.03-.096-.024-.1-.017-.105-.005-.348.001-.174.007-.173.016-.015.004-.014.006-.029.019-.029.02-.015.008-.016.006-.126.037-.062.022-.061.025-.041.021-.041-.001-.057-.012a21.333 21.333 0 0 1-.277-.074l-.277-.073-.119-.025-.052-.007-.045-.003-.091.002-.086.006-.153.021-.139.03-.112.03-.018-.007-.058-.019-.057-.013-.058-.009-.06-.006-.134-.004a7.346 7.346 0 0 1-.167.004l-.171.005-.172-.003-.342-.006-.169.007-.084.009-.083.013-.083.018-.081.022-.082.029-.018.008c-.273-.002-.559.007-.853.021l-.723-.009-1.682.003-.022.002-.02.007-.02.011-.017.015-.015.019-.014.021-.023.053-.02.063-.014.071-.021.163-.035.343-.012.078-.016.071-.019.062-.012.027-.013.024-.02.038-.016.043-.01.047-.006.05-.004.107.002.114-.001.117-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.06.021.06.017.057.012.056.001.011-.002.271-.004.023-.022.095-.063.185-.068.183-.031.094-.024.097-.017.1-.005.104.001.349.006.173.017.173.003.014.007.015.019.028.02.03.008.015.006.016.037.127.021.062.027.062.021.041-.002.04-.012.058-.074.277-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.045.001.091.006.086c.008.054.016.104.021.153.012.048.021.094.031.139l.03.112-.007.017-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.008.018c-.001.272.007.558.022.851l-.01.726v.409h-.073l-.116-.009-.056-.01-.054-.014-.053-.021-.049-.025c-.048.033-.094.063-.135.093l-.064.037-.062.031-.061.026-.059.021-.058.016-.056.012-.054.008-.052.004h-.052l-.05-.002-.098-.015-.096-.022-.184-.063-.183-.069-.094-.03-.097-.024-.1-.017-.104-.005-.349.001-.174.007-.172.016-.014.004-.015.006-.028.019-.03.02-.015.008-.016.006-.127.037-.062.022-.062.025-.059.031-.058.036-.055.042-.052.049-.072.07-.07.056-.035.021-.035.019-.035.014-.035.01-.034.007-.035.003-.035-.002-.036-.005-.035-.009-.036-.013-.036-.017-.037-.02a40.873 40.873 0 0 1-.439-.253l-.15-.078-.126-.053-.058-.019-.057-.013-.057-.009-.061-.006-.135-.004a6.977 6.977 0 0 1-.166.004l-.171.005-.171-.003-.343-.006-.169.007-.084.009-.083.013-.083.018-.082.022-.08.029-.081.035-.024.01-.035.011-.096.021-.285.045-.373.043-.42.034-.426.021-.392.001-.169-.009-.146-.016-.062-.01-.054-.014-.045-.014-.037-.018-.545-.006v.001c-1.106.011-2.47-.151-3.588-.132-.075.056-.146.086-.207.144l-.363.396c-.123-.103-.259-.17-.366-.307-.126-.153-.247-.221-.405-.217-2.751.037-4.225.135-6.784.116v-.003l-4.154-.049-.044-.003-.052-.007a3.458 3.458 0 0 0-.118-.024 21.333 21.333 0 0 1-.277-.074l-.277-.073-.119-.025-.052-.007-.045-.003-.091.002-.086.006-.153.021-.139.03-.132.036-.131.035-.141.03-.154.021-.086.005-.092.001-.765-.01a759.57 759.57 0 0 0-2.021-.026l-.409.001.001-.074.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.061-.021-.059-.017-.057-.012-.056-.001-.011.002-.271.004-.023.022-.094.063-.184.068-.184.031-.094.024-.096.017-.101.005-.104-.001-.348-.006-.174-.017-.173-.003-.015-.007-.014-.019-.029-.02-.029-.008-.015-.006-.016-.037-.126-.021-.062-.027-.061-.021-.04.001-.046.012-.055.074-.276.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.092-.006-.084c-.008-.055-.016-.105-.021-.154-.012-.048-.021-.094-.031-.139l-.03-.113.007-.016.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.008-.018c.001-.275-.007-.562-.022-.857l.01-.719-.002-1.682-.003-.022-.007-.021-.011-.019-.015-.017-.018-.016-.022-.014-.053-.022-.063-.019-.072-.015c-.051-.007-.105-.015-.162-.021l-.344-.034-.078-.013-.07-.015-.062-.02-.027-.012-.023-.013-.039-.021-.043-.014-.047-.01-.05-.007-.107-.004-.114.001h-.117l-.115-.009-.057-.01-.055-.014-.051-.021-.049-.025-.137.093-.064.037-.062.031-.061.026-.059.021-.057.016-.055.012-.011.002-.274-.004-.021-.003-.094-.022-.184-.063-.184-.069-.094-.03-.096-.024-.1-.017-.105-.005-.348.001-.174.007-.173.016-.015.004-.014.006-.029.019-.029.02-.015.008-.016.006-.126.037-.062.022-.061.025-.041.021-.043-.001-.057-.012a21.333 21.333 0 0 1-.277-.074l-.277-.073-.119-.025-.052-.007-.045-.003-.091.002-.086.006-.153.021-.139.03-.111.03-.017-.007-.058-.019-.057-.013-.058-.009-.06-.006-.134-.004a7.346 7.346 0 0 1-.167.004l-.171.005-.172-.003-.342-.006-.169.007-.084.009-.083.013-.083.018-.081.022-.082.029-.018.008c-.274-.002-.56.007-.854.021l-.724-.009-.409.001v-.074l.009-.116.009-.056.016-.055.02-.052.025-.049-.093-.136-.037-.064-.031-.062-.026-.061-.021-.059-.016-.057-.012-.056-.002-.011.004-.279.002-.016.023-.094.063-.184.069-.184.03-.094.024-.096.016-.101.006-.104-.001-.348-.007-.174-.016-.173-.004-.015-.006-.014-.018-.029-.02-.029-.009-.015-.006-.016-.036-.126-.023-.062-.025-.061-.021-.041.001-.038.013-.06c.021-.085.047-.182.073-.277l.073-.277.025-.119.007-.052.003-.045-.002-.091-.006-.086a11.686 11.686 0 0 0-.021-.153l-.03-.139-.03-.112.007-.018.019-.058.013-.057.009-.058.006-.06.004-.135a6.977 6.977 0 0 1-.004-.166l-.004-.171.002-.172.006-.342-.007-.169-.009-.084-.013-.083-.018-.083-.022-.082-.029-.081-.008-.018c.002-.275-.007-.563-.021-.859.002-.242.006-.486.009-.716l-.003-1.682-.002-.022-.007-.021-.011-.019-.015-.017-.019-.015-.021-.014-.053-.023-.063-.019-.071-.015a11.735 11.735 0 0 0-.163-.021l-.343-.035-.078-.012-.072-.016-.062-.019-.027-.012-.024-.013-.038-.02-.043-.016-.047-.01-.05-.006-.107-.004-.114.002-.117-.001-.116-.009-.056-.01-.054-.014-.053-.02-.049-.026c-.048.033-.094.063-.135.093l-.064.037-.062.031-.061.026-.059.021-.058.017-.056.012-.011.001-.271-.003-.023-.003-.096-.022-.184-.063-.183-.068-.094-.031-.097-.024-.1-.017-.104-.005-.349.001-.174.006-.172.017-.014.003-.015.007-.028.019-.03.02-.015.008-.016.006-.127.037-.062.021-.062.027-.04.021-.042-.001-.057-.012-.276-.074-.277-.073c-.043-.009-.083-.018-.119-.024l-.052-.008-.045-.003-.092.002-.084.005c-.055.008-.105.016-.154.021l-.139.031-.113.03-.017-.007-.058-.018-.057-.014-.057-.01-.061-.006-.135-.002c-.049 0-.104.002-.166.004l-.171.004-.171-.003-.343-.006-.169.007-.084.009-.083.013-.083.018-.082.022-.08.029-.018.008c-.273-.001-.56.007-.854.022l-.723-.01-1.682.003-.022.002-.021.007-.018.011-.018.015-.016.019-.014.021-.023.053-.018.063-.016.072-.021.162-.034.343-.013.079-.015.07-.02.062-.012.027-.013.024-.021.038-.014.043-.01.047-.006.05-.005.107.001.114v.117l-.009.116-.009.056-.016.055-.02.052-.025.049.093.136.037.064.031.062.026.061.021.059.016.057.012.056.002.011-.004.279-.002.016-.023.094-.063.184-.069.184-.03.094-.024.096-.016.101-.006.104.001.348.007.174.016.173.004.015.006.014.018.029.02.029.009.015.006.016.036.126.023.062.025.061.021.041-.001.038-.013.06c-.021.085-.047.182-.073.277l-.073.277-.025.119-.007.052-.003.045.002.091.006.086.021.153.03.139.03.112-.007.018-.019.058-.013.057-.009.058-.006.06-.004.135.004.166.004.171-.002.172-.006.342.007.169.009.084.013.083.018.083.022.082.029.081.008.018a15.7 15.7 0 0 0 .021.855c-.002.244-.006.49-.009.72l.003 1.682.002.022.007.021.011.019.015.017.019.015.021.014.053.023.063.019.071.015.163.021.343.035.078.012.072.016.062.019.027.012.024.013.038.02.043.016.047.01.05.006.107.004.114-.002.117.001.116.009.056.01.054.014.053.02.049.026c.048-.033.094-.063.135-.093l.064-.037.062-.031.061-.026.059-.021.058-.017.056-.012.011-.001.271.003.023.003.096.022.184.063.183.068.094.031.097.024.1.017.104.005.349-.001.174-.006.172-.017.014-.003.015-.007.028-.019.03-.02.015-.008.016-.006.127-.037.062-.021.062-.027.04-.021.042.001.057.012.276.074.277.073c.043.009.083.018.119.024l.052.008.045.003.092-.002.084-.005c.055-.008.105-.016.154-.021l.139-.031.113-.03.017.007.058.018.057.014.057.01.061.006.135.002c.049 0 .104-.002.166-.004l.171-.004.171.003.343.007.169-.008.084-.009.083-.013.083-.018.082-.022.08-.029.018-.008c.273.001.56-.007.854-.022l.723.01.41-.001-.001.074-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.06.021.06.017.057.012.056.001.011-.002.271-.004.023-.022.095-.063.185-.068.183-.031.094-.024.097-.017.1-.005.104.001.349.006.173.017.173.003.014.007.015.019.028.02.03.008.015.006.016.037.127.021.062.027.062.021.041-.002.04-.012.058-.074.277-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.045.001.091.006.086c.008.054.016.104.021.153.012.048.021.094.031.139l.03.112-.007.017-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.008.018c-.001.272.007.558.022.851l-.01.726.002 1.682.003.022.007.021.011.019.015.017.018.015.022.014.053.023.063.019.072.015.162.021.344.035.078.012.07.016.062.019.027.012.023.013.039.02.043.016.047.01.05.006.107.004.114-.002.117.001.115.009.057.01.055.014.051.02.049.026.137-.093.064-.037.062-.031.061-.026.059-.021.057-.017.055-.012.011-.001.272.002.023.004.094.022.184.063.184.068.094.031.096.024.1.017.105.005.348-.001.174-.006.173-.017.015-.003.014-.007.029-.019.029-.02.015-.008.016-.006.126-.037.062-.021.061-.027.041-.021.043.001.057.012.277.074.277.073c.043.009.083.018.119.024l.052.008.045.003.091-.002.086-.005c.054-.008.104-.016.153-.021l.139-.031.112-.03.016.007.058.018.057.014.058.01.06.006.134.002c.051 0 .105-.002.168-.004l.17-.004.172.003.342.007.169-.008.084-.009.083-.013.083-.018.081-.022.082-.029.018-.008c.273.001.559-.007.854-.022l.724.01.409-.001-.001.074-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.06.021.06.017.057.012.056.001.011-.002.271-.004.023-.022.095-.063.185-.068.183-.031.094-.024.097-.017.1-.005.104.001.349.006.173.017.173.003.014.007.015.019.028.02.03.008.015.006.016.037.127.021.062.027.062.021.04-.002.041-.012.058-.074.276-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.045.001.092.006.084c.008.055.016.105.021.154.012.048.021.094.031.139l.03.113-.007.017-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.008.018c-.001.272.007.558.022.851l-.01.725.002 1.682.003.022.007.021.011.019.015.017.018.016.022.014.053.022.063.019.072.015c.051.007.105.015.162.021l.344.034.078.013.07.015.062.02.027.012.023.013.039.021.043.014.047.01.05.007.107.004.114-.001h.117l.115.009.057.01.055.014.051.021.049.025.137-.093.064-.037.062-.031.061-.026.059-.021.057-.016.055-.012.055-.008.053-.004h.051l.051.002.098.015.094.022.184.063.184.069.094.03.096.024.1.017.105.005.348-.001.174-.007.173-.016.015-.004.014-.006.029-.019.029-.02.015-.008.016-.006.126-.037.062-.022.061-.025.06-.031.058-.036.055-.042.052-.049.072-.07.071-.056.035-.021.035-.019.034-.014.034-.01.035-.007.035-.003.035.002.035.005.036.009.036.013.037.017.036.02.438.253.152.078.125.053.058.019.057.013.058.009.06.006.134.004.167-.004.171-.005.172.003.342.006.169-.007.084-.009.083-.013.083-.018.081-.022.082-.029.08-.035.024-.01.034-.011.097-.021.285-.045.373-.043.421-.034.426-.021.391-.001.17.009.145.016.062.01.054.014.046.014.036.018.545.006v-.001c1.106-.011 2.47.151 3.588.132.075-.056.146-.086.206-.144l.365-.396c.122.103.258.17.365.307.127.153.248.221.406.217 2.75-.037 4.225-.135 6.783-.116v.003l4.154.049.045.003.051.007.119.024.276.074.277.073.119.025.052.007.045.003.092-.002.084-.006.154-.021.139-.03.132-.036.132-.035.139-.03.155-.021.085-.005.093-.001.765.01c.718.01 1.398.019 2.021.026l1.682-.003.022-.002.021-.007.018-.011.018-.015.016-.019.014-.021.023-.053.018-.063.016-.071.021-.163.034-.343.013-.078.015-.071.02-.062.012-.027.013-.024.021-.038.014-.043.01-.047.006-.05.005-.107-.001-.114v-.117l.009-.116.009-.056.016-.055.02-.052.025-.049-.093-.136-.037-.064-.031-.062-.026-.06-.021-.06-.016-.057-.012-.056-.002-.011.004-.278.002-.016.023-.095.063-.185.069-.183.03-.094.024-.097.016-.1.006-.104-.001-.349-.007-.173-.016-.173-.004-.014-.006-.015-.018-.028-.02-.03-.009-.015-.006-.016-.036-.127-.023-.062-.025-.062-.021-.041.001-.038.013-.06c.021-.084.047-.18.073-.276l.073-.277.025-.119.007-.052.003-.045-.002-.092-.006-.084a9.925 9.925 0 0 0-.021-.154l-.03-.139-.03-.112.007-.018.019-.058.013-.057.009-.058.006-.06.004-.135a6.977 6.977 0 0 1-.004-.166l-.004-.171.002-.172.006-.342-.007-.169-.009-.084-.013-.083-.018-.083-.022-.082-.029-.081-.008-.019c.002-.275-.007-.562-.021-.858.002-.243.006-.487.009-.716l-.001-.41.074.001.115.009.057.01.055.014.051.02.049.026.137-.093.064-.037.062-.031.061-.026.059-.021.057-.017.055-.012.011-.001.272.003.023.003.094.022.184.063.184.068.094.031.096.024.1.017.105.005.348-.001.174-.006.173-.017.015-.003.014-.007.029-.019.029-.02.015-.008.016-.006.126-.037.062-.021.061-.027.041-.021.041.001.057.012.277.074.277.073c.043.009.083.018.119.024l.052.008.045.003.091-.002.086-.005c.054-.008.104-.016.153-.021l.139-.031.114-.03a.253.253 0 0 0 .016.007l.058.018.057.014.058.01.06.006.134.002c.051 0 .105-.002.167-.004l.171-.004.172.003.342.007.169-.008.084-.009.083-.013.083-.018.081-.022.082-.029.018-.008c.273.001.559-.007.852-.022l.724.01 1.682-.003.022-.002.02-.007.02-.011.017-.015.015-.019.014-.021.023-.053.02-.063.014-.072.021-.162.035-.343.012-.079.016-.07.019-.062.012-.027.013-.024.02-.038.016-.043.01-.047.006-.05.004-.107-.002-.114.001-.117.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.061-.021-.059-.017-.057-.012-.056-.001-.011.002-.271.004-.023.022-.094.063-.184.068-.184.031-.094.024-.096.017-.101.005-.104-.001-.348-.006-.174-.017-.173-.003-.015-.007-.014-.019-.029-.02-.029-.008-.015-.006-.016-.037-.126-.021-.062-.027-.061-.021-.04.001-.046.012-.055.074-.276.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.092-.006-.084c-.008-.055-.016-.105-.021-.154-.012-.048-.021-.094-.031-.139l-.03-.113.007-.016.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.008-.018c.001-.275-.007-.562-.022-.857l.01-.719-.001-.546.126.013.078.012.07.016.062.019.027.012.023.013.039.02.043.016.047.01.05.006.107.004.114-.002.117.001.115.009.057.01.055.014.051.02.049.026.137-.093.064-.037.062-.031.061-.026.059-.021.057-.017.055-.012.011-.001.272.003.023.003.094.022.184.063.184.068.094.031.096.024.1.017.105.005.348-.001.174-.006.173-.017.015-.003.014-.007.029-.019.029-.02.015-.008.016-.006.126-.037.062-.021.061-.027.041-.021.041.001.057.012.277.074.277.073c.043.009.083.018.119.024l.052.008.045.003.091-.002.086-.005c.054-.008.104-.016.153-.021l.139-.031.114-.03a.253.253 0 0 0 .016.007l.058.018.057.014.058.01.06.006.134.002c.051 0 .105-.002.167-.004l.171-.004.172.003.342.007.169-.008.084-.009.083-.013.083-.018.081-.022.082-.029.018-.008c.273.001.559-.007.852-.022l.724.01 1.682-.003.022-.002.02-.007.02-.011.017-.015.015-.019.014-.021.023-.053.02-.063.014-.072.021-.162.035-.343.012-.079.016-.07.019-.062.012-.027.013-.024.02-.038.016-.043.01-.047.006-.05.004-.107-.002-.114.001-.117.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.061-.021-.059-.017-.057-.012-.056-.001-.011.002-.271.004-.023.022-.094.063-.184.068-.184.031-.094.024-.096.017-.101.005-.104-.001-.348-.006-.174-.017-.173-.003-.015-.007-.014-.019-.029-.02-.029-.008-.015-.006-.016-.037-.126-.021-.062-.027-.061-.021-.04.001-.044.012-.055.074-.277.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.091-.003-.09zM186.007 144.321c.008.055.016.105.021.154.012.048.021.094.031.139l.035.132.035.132.031.139.021.155.005.085.001.093-.01.765c-.009.718-.019 1.398-.026 2.021l.002 1.682.003.022.007.021.011.019.015.017.018.016.022.014.053.022.063.019.072.015c.051.007.105.015.162.021l.344.034.078.013.07.015.062.02.027.012.023.013.039.021.043.014.047.01.05.007.107.004.114-.001h.117l.115.009.057.01.055.014.051.021.049.025.137-.093.064-.037.062-.031.061-.026.059-.021.057-.016.055-.012.011-.002.274.004.021.003.094.022.184.063.184.069.094.03.096.024.1.017.105.005.348-.001.174-.007.173-.016.015-.004.014-.006.029-.019.029-.02.015-.008.016-.006.126-.037.062-.022.061-.025.041-.021.041.001.057.012.277.074.277.073.119.025.052.007.045.003.091-.002.086-.006.153-.021.139-.03.112-.03a.134.134 0 0 1 .018.007l.058.019.057.013.058.009.06.006.134.004.167-.004.171-.005.172.003.342.006.169-.007.084-.009.083-.013.083-.018.081-.022.082-.029.018-.008c.273.002.559-.007.852-.021l.724.009 1.682-.003.022-.002.02-.007.02-.011.017-.015.015-.019.014-.021.023-.053.02-.063.014-.071.021-.163.035-.343.012-.078.016-.071.019-.062.012-.027.013-.024.02-.038.016-.043.01-.047.006-.05.004-.107-.002-.114.001-.117.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.06-.021-.06-.017-.057-.012-.056-.008-.054-.004-.053-.001-.051.004-.051.014-.097.022-.095.063-.185.068-.183.031-.094.024-.097.017-.1.005-.104-.001-.349-.006-.173-.017-.173-.003-.014-.007-.015-.019-.028-.02-.03-.008-.015-.006-.016-.037-.127-.021-.062-.027-.062-.03-.059-.036-.058-.042-.055-.049-.052-.071-.072-.055-.071-.021-.034-.018-.035-.015-.035-.011-.035-.006-.034-.002-.035v-.035l.006-.035.009-.036.013-.036.016-.036.021-.037c.107-.188.188-.327.253-.439l.078-.15.053-.126.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.036-.08-.01-.024-.01-.034-.021-.097-.045-.285c-.014-.112-.027-.238-.043-.373-.011-.135-.022-.277-.035-.42l-.02-.427-.002-.391.008-.17a4.33 4.33 0 0 0 .015-.136h.064v-.02c-.009-.15.079-.246.113-.413.003-.007-.041-.013-.108-.019l.001-.056.123-.011c.017-.061-.092-.131-.12-.194l.04-3.442.003-.045.007-.051.024-.119.074-.276.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.092-.006-.084c-.008-.055-.016-.105-.021-.154-.012-.048-.021-.094-.031-.139l-.035-.132-.035-.132-.031-.139-.021-.155-.005-.085-.001-.093.01-.765c.009-.718.019-1.398.026-2.021l-.002-1.682-.003-.022-.007-.021-.011-.019-.015-.017-.018-.016-.022-.014-.053-.022-.063-.019-.072-.015c-.051-.007-.105-.015-.162-.021l-.344-.034-.078-.013-.07-.015-.062-.02-.027-.012-.023-.013-.039-.021-.043-.014-.047-.01-.05-.007-.107-.004-.114.001h-.117l-.115-.009-.057-.01-.055-.014-.051-.021-.049-.025-.137.093-.064.037-.062.031-.061.026-.059.021-.057.016-.055.012-.011.002-.274-.004-.021-.003-.094-.022-.184-.063-.184-.069-.094-.03-.096-.024-.1-.017-.105-.005-.348.001-.174.007-.173.016-.015.004-.014.006-.029.019-.029.02-.015.008-.016.006-.126.037-.062.022-.061.025-.041.021-.041-.001-.057-.012a21.333 21.333 0 0 1-.277-.074l-.277-.073-.119-.025-.052-.007-.045-.003-.091.002-.086.006-.153.021-.139.03-.112.03-.018-.007-.058-.019-.057-.013-.058-.009-.06-.006-.134-.004a7.303 7.303 0 0 1-.168.004l-.17.005-.172-.003-.342-.006-.169.007-.084.009-.083.013-.083.018-.081.022-.082.029-.018.008c-.273-.002-.559.007-.853.021l-.723-.009-1.682.003-.022.002-.02.007-.02.011-.017.015-.015.019-.014.021-.023.053-.02.063-.014.071-.021.163-.035.343-.012.078-.016.071-.019.062-.012.027-.013.024-.02.038-.016.043-.01.047-.006.05-.004.107.002.114-.001.117-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.06.021.06.017.057.012.056.008.054.004.053.001.051-.004.051-.014.097-.022.095-.063.185-.068.183-.031.094-.024.097-.017.1-.005.104.001.349.006.173.017.173.003.014.007.015.019.028.02.03.008.015.006.016.037.127.021.062.027.062.03.059.036.058.042.055.049.052.071.072.055.071.021.034.018.035.015.035.011.035.006.034.002.035v.035l-.006.035-.009.036-.013.036-.016.036-.021.037c-.107.188-.188.327-.253.439l-.078.15-.053.126-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.036.08.01.024.01.034.021.097.045.285c.014.112.027.238.043.373.011.135.022.277.035.42l.02.427.002.391-.008.17a4.33 4.33 0 0 0-.015.136h-.064v.02c.009.15-.077.246-.113.413-.003.007.041.013.108.019l-.001.056-.123.011c-.016.061.092.131.12.193l-.04 3.443-.003.045-.007.051-.024.119-.074.276-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.046.001.092.006.083zM211.104 144.321c.008.055.016.105.021.154.012.048.021.094.031.139l.035.132.035.132.031.139.021.155.005.085.001.093-.011.765-.025 2.021.002 1.682.003.022.007.021.011.019.015.017.018.016.022.014.053.022.063.019.072.015c.051.007.105.015.162.021l.344.034.078.013.07.015.062.02.027.012.023.013.039.021.043.014.047.01.05.007.107.004.114-.001h.117l.115.009.057.01.055.014.051.021.049.025.137-.093.064-.037.062-.031.061-.026.059-.021.057-.016.055-.012.011-.002.274.004.021.003.094.022.184.063.184.069.094.03.096.024.1.017.105.005.348-.001.174-.007.173-.016.015-.004.014-.006.029-.019.029-.02.015-.008.016-.006.126-.037.062-.022.061-.025.041-.021.043.001.057.012.277.074.277.073.119.025.052.007.045.003.091-.002.086-.006.153-.021.139-.03.111-.03.017.007.058.019.057.013.058.009.06.006.134.004.167-.004.171-.005.172.003.342.006.169-.007.084-.009.083-.013.083-.018.081-.022.082-.029.018-.008c.273.002.559-.007.854-.021l.724.009 1.682-.003.022-.002.02-.007.02-.011.017-.015.015-.019.014-.021.023-.053.02-.063.014-.071.021-.163.035-.343.012-.078.016-.071.019-.062.012-.027.013-.024.02-.038.016-.043.01-.047.006-.05.004-.107-.002-.114.001-.117.009-.116.01-.056.014-.055.02-.052.026-.049-.093-.136-.037-.064-.031-.062-.026-.06-.021-.06-.017-.057-.012-.056-.008-.054-.004-.053-.001-.051.004-.051.014-.097.022-.095.063-.185.068-.183.031-.094.024-.097.017-.1.005-.104-.001-.349-.006-.173-.017-.173-.003-.014-.007-.015-.019-.028-.02-.03-.008-.015-.006-.016-.037-.127-.021-.062-.027-.062-.03-.059-.036-.058-.042-.055-.049-.052-.071-.072-.055-.071-.021-.034-.018-.035-.015-.035-.011-.035-.006-.034-.002-.035v-.035l.006-.035.009-.036.013-.036.016-.036.021-.037c.107-.188.188-.327.253-.439l.078-.15.053-.126.018-.058.014-.057.01-.058.006-.06.002-.135c0-.049-.002-.104-.004-.166l-.004-.171.004-.172.006-.342-.008-.169-.009-.084-.013-.083-.018-.083-.023-.082-.028-.081-.036-.08-.01-.024-.01-.034-.021-.097-.045-.285c-.014-.112-.027-.238-.043-.373-.011-.135-.022-.277-.035-.42l-.02-.427-.002-.391.008-.17a4.33 4.33 0 0 0 .015-.136h.064v-.02c-.009-.15.079-.246.113-.413.003-.007-.041-.013-.108-.019l.001-.056.123-.011c.017-.061-.092-.131-.12-.194l.04-3.442.003-.045.007-.051.024-.119.074-.276.073-.277c.009-.043.018-.083.024-.119l.008-.052.003-.045-.001-.092-.006-.084c-.008-.055-.016-.105-.021-.154-.012-.048-.021-.094-.031-.139l-.035-.132-.035-.132-.031-.139-.021-.155-.005-.085-.001-.093.01-.765c.009-.718.019-1.398.026-2.021l-.002-1.682-.003-.022-.007-.021-.011-.019-.015-.017-.018-.016-.022-.014-.053-.022-.063-.019-.072-.015c-.051-.007-.105-.015-.162-.021l-.344-.034-.078-.013-.07-.015-.062-.02-.027-.012-.023-.013-.039-.021-.043-.014-.047-.01-.05-.007-.107-.004-.114.001h-.117l-.115-.009-.057-.01-.055-.014-.051-.021-.049-.025-.137.093-.064.037-.062.031-.061.026-.059.021-.057.016-.055.012-.011.002-.274-.004-.021-.003-.094-.022-.184-.063-.184-.069-.094-.03-.096-.024-.1-.017-.105-.005-.348.001-.174.007-.173.016-.015.004-.014.006-.029.019-.029.02-.015.008-.016.006-.126.037-.062.022-.061.025-.041.021-.043-.001-.057-.012a21.333 21.333 0 0 1-.277-.074l-.277-.073-.119-.025-.052-.007-.045-.003-.091.002-.086.006-.153.021-.139.03-.111.03-.017-.007-.058-.019-.057-.013-.058-.009-.06-.006-.134-.004a7.346 7.346 0 0 1-.167.004l-.171.005-.172-.003-.342-.006-.169.007-.084.009-.083.013-.083.018-.081.022-.082.029-.018.008c-.274-.002-.56.007-.854.021l-.724-.009-1.682.003-.022.002-.02.007-.02.011-.017.015-.015.019-.014.021-.023.053-.02.063-.014.071-.021.163-.035.343-.012.078-.016.071-.019.062-.012.027-.013.024-.02.038-.016.043-.01.047-.006.05-.004.107.002.114-.001.117-.009.116-.01.056-.014.055-.02.052-.026.049.093.136.037.064.031.062.026.06.021.06.017.057.012.056.008.054.004.053.001.051-.004.051-.014.097-.022.095-.063.185-.068.183-.031.094-.024.097-.017.1-.005.104.001.349.006.173.017.173.003.014.007.015.019.028.02.03.008.015.006.016.037.127.021.062.027.062.03.059.036.058.042.055.049.052.071.072.055.071.021.034.018.035.015.035.011.035.006.034.002.035v.035l-.006.035-.009.036-.013.036-.016.036-.021.037c-.107.188-.188.327-.253.439l-.078.15-.053.126-.018.058-.014.057-.01.058-.006.06-.002.135c0 .049.002.104.004.166l.004.171-.004.172-.006.342.008.169.009.084.013.083.018.083.023.082.028.081.036.08.01.024.01.034.021.097.045.285c.014.112.027.238.043.373.011.135.022.277.035.42l.02.427.002.391-.008.17a4.33 4.33 0 0 0-.015.136h-.064v.02c.009.15-.077.246-.113.413-.003.007.041.013.108.019l-.001.056-.123.011c-.016.061.092.131.12.193l-.04 3.443-.003.045-.007.051-.024.119-.074.276-.073.277c-.009.043-.018.083-.024.119l-.008.052-.003.045.001.092.006.084zM160.419 218.274l-.01-.081-.018-.163-.035-.328c-.037-.243-.019-.39-.102-.714a20.122 20.122 0 0 0-.273-.955c-.096-.327-.209-.633-.36-.878-.28-.528-.56-1.064-.976-1.51-.199-.229-.379-.477-.602-.684l-.706-.586c-.333-.305-.947-.259-1.311-.46-.439-.271-.788-.681-1.321-.845-.625-.239-1.303-.22-1.959-.3l-.125-.01-.233.013-.048.005-.189.019-.38.038c-.278.041-.441.011-.854.133-.361.094-.724.2-1.079.316-.38.103-.616.29-.929.439-.611.284-1.115.724-1.624 1.153-.254.185-.582.402-.799.643-.197.255-.258.526-.414.794-.836 1.268-1.214 2.764-1.28 4.23h1.869l-1.86.188c.061.457.066.822.174 1.368.081.317.172.638.272.955.095.327.21.633.36.878.279.528.559 1.064.976 1.51.198.229.379.477.601.684l.707.586c.333.305.947.26 1.311.46.439.272.788.682 1.32.845.626.239 1.303.22 1.961.3l.123.01.234-.013.047-.005.189-.019.381-.039c.277-.04.441-.01.854-.132.361-.094.723-.2 1.078-.316.381-.104.617-.291.93-.439.611-.284 1.115-.724 1.624-1.154.254-.184.581-.401.798-.642.197-.255.259-.526.416-.794.834-1.267 1.213-2.764 1.279-4.23l-.014-.229-.003-.041zm-5.555 3.51c-.022.107-.088.147-.112.232-.057.166-.104.355-.177.543-.174-.009-.339-.004-.471-.124-.156-.116-.256-.153-.369-.096-.06.079-.41.09-.649.122l-.381.043-.144.016.029.004.015.002.008.001-.196.01.004-.001h.006l.092-.011.043-.005h-.002c-.322-.066-.652-.004-.936-.117-.282-.099-.584-.125-.822-.293l-.381-.188c-.127-.062-.221-.174-.334-.254l-.336-.254-.27-.324c-.086-.111-.203-.203-.272-.328l-.208-.383c-.195-.271-.182-.477-.301-.702-.066-.061-.08-.344-.104-.579-.021-.197-.04-.4-.06-.606.002-1.241.883-2.522 1.828-3.187.023-.107.088-.147.113-.232.057-.166.104-.355.176-.544.175.01.34.005.471.125.156.115.256.153.369.096.06-.079.412-.09.65-.122l.381-.043.143-.016-.028-.004-.015-.002-.008-.001.193-.01-.006.001-.094.011-.043.005h.002c.322.066.652.004.936.117.283.099.584.125.822.293l.381.188c.129.061.221.173.335.253l.336.254.269.324c.086.111.203.203.273.329l.209.383c.194.271.181.476.3.701.065.061.081.344.104.579l.036.366.019.187.005.055c-.001 1.241-.881 2.521-1.829 3.186zM212.763 302.509a.407.407 0 0 0-.156.335c-.001.147-.09.214-.256.257-.123.033-.276.093-.354.191l-1.693 2.183c-.02.151-.037.291-.053.423-.008.146-.09.212-.257.253-.196.046-.354.171-.493.349l-3.967 5.222 2.756 2.162c.418-.542.932-1.009 1.35-1.551a.57.57 0 0 0 .113-.387c-.016-.376.301-.376.511-.495l.017-.205c.023-.268.023-.276.346-.4a.712.712 0 0 0 .338-.225l4.555-5.949c.418-.543.932-1.009 1.35-1.551a.57.57 0 0 0 .114-.387c-.017-.376.301-.376.511-.495l.016-.204c.023-.269.024-.277.346-.401a.703.703 0 0 0 .338-.225l4.556-5.948c.418-.543.933-1.01 1.35-1.552a.57.57 0 0 0 .114-.386c-.016-.377.301-.377.51-.496l.018-.205c.023-.268.023-.276.345-.4a.715.715 0 0 0 .339-.225l4.555-5.948-2.146-1.685v-.021l2.156 1.692a14503.407 14503.407 0 0 1 7.238-9.056l.655-.774.412-.518.189-.262.164-.254.002-.004.002-.006.001-.016-.007-.043-.007-.028-.005-.016-.001-.004-.001-.002-.004-.001-.014-.002-.139-.022-.863-.141-1.073.007-.849.031-.848.032-1.074.012-.289.009-.137.012-.131.018-.125.023-.121.03-.113.037-.108.044-.087.035-.082.028-.078.02-.077.011-.075.002-.075-.007-.075-.017-.078-.026-.647-.221-.167-.002-4.719-.013-.083.004-.085.01-.086.017-.084.021-.164.052c-.051.02-.101.039-.146.058l-.089.035c-.03.01-.058.02-.084.027l-.081.02-.078.012-.076.002-.076-.008-.076-.018-.076-.028-.08-.031-.082-.024-.084-.02-.084-.013-.083-.007-.079-.002-.076.004-.07.01v3.503l6.066.04.021-.014.025-.012.062-.02.075-.015.084-.01.091-.004h.094l.188.013.043.006.006.001h.002l.002.001.002.006.004.012.01.05.001.051-.003.025-.006.026-.008.025-.01.024-.014.024-.016.024-.02.023-.022.021-.025.021-.028.02-.051.037-.078.066-.203.179-.205.18-.08.066-.053.039-.064.128-.066.116c-.051.073-.099.144-.15.221l-.412.573-.029.039-.029.035-.032.031-.032.027-.068.049-.07.043-.139.087-.065.053-.031.031-.03.034-.548.723-.53.736-.531.738-.49.646c-.025-.016-.05-.021-.078-.046-.086-.077-.208-.16-.314-.16l-2.365.015c-.111.079-.215.151-.312.221-.103.084-.189.061-.305-.047a.683.683 0 0 0-.496-.172l-4.802.087 1.044-1.349.011-.371c-.005-.129.065-.18.217-.201a.636.636 0 0 0 .429-.267l2.18-2.889 2.141-.04v-3.503c-.574.007-1.146-.11-1.72-.104a.436.436 0 0 0-.313.148c-.24.245-.404-.004-.591-.096l-.144.113c-.188.147-.194.152-.442-.024-.103-.074-.2-.128-.323-.127l-6.274.089c-.574.007-1.147-.11-1.72-.104a.44.44 0 0 0-.314.148c-.239.245-.402-.004-.59-.096l-.144.113c-.188.147-.194.152-.442-.024-.104-.074-.199-.128-.323-.127l-6.274.089c-.574.007-1.147-.11-1.721-.104a.437.437 0 0 0-.313.148c-.239.245-.403-.004-.591-.096l-.143.113c-.189.147-.195.152-.443-.024-.103-.074-.199-.128-.322-.127l-6.275.089c-.574.007-1.146-.11-1.72-.104a.437.437 0 0 0-.313.148c-.24.245-.403-.004-.591-.096l-.144.113a.534.534 0 0 1-.154.096l-.223-.175c-.017.021-.037.04-.055.062l-.011-.007c-.103-.074-.199-.128-.323-.127l-6.274.089c-.573.007-1.147-.11-1.72-.104a.44.44 0 0 0-.314.148c-.239.245-.402-.004-.59-.096l-.143.113c-.189.147-.195.152-.443-.024-.104-.074-.199-.128-.322-.127l-6.275.089c-.574.007-1.147-.11-1.721-.104a.434.434 0 0 0-.312.148c-.24.245-.404-.004-.592-.096l-.143.113c-.189.147-.195.152-.443-.024-.103-.074-.199-.128-.322-.127l-6.275.089c-.574.007-1.146-.11-1.72-.104a.437.437 0 0 0-.313.148c-.24.245-.403-.004-.591-.096l-.144.113c-.188.147-.194.152-.442-.024-.103-.074-.199-.128-.323-.127l-6.274.089c-.573.007-1.147-.11-1.72-.104a.44.44 0 0 0-.314.148c-.239.245-.402-.004-.59-.096l-.143.113c-.189.147-.195.152-.443-.024-.104-.074-.199-.128-.322-.127l-6.275.089c-.574.007-1.146-.11-1.721-.104a.435.435 0 0 0-.312.148c-.24.245-.404-.004-.592-.096l-.143.113c-.188.147-.195.152-.443-.024-.102-.074-.199-.128-.322-.127l-6.275.089c-.573.007-1.146-.11-1.72-.104a.437.437 0 0 0-.313.148c-.24.245-.403-.004-.59-.096l-.144.113c-.188.147-.194.152-.442-.024-.104-.074-.2-.128-.323-.127l-6.275.089c-.573.007-1.146-.11-1.72-.104a.437.437 0 0 0-.313.148c-.239.245-.403-.004-.591-.096l-.143.113c-.189.147-.195.152-.443-.024-.103-.074-.199-.128-.322-.127l-6.275.089c-.574.007-1.146-.11-1.721-.104a.435.435 0 0 0-.312.148c-.24.245-.404-.004-.591-.096l-.144.113c-.188.147-.194.152-.443-.024-.102-.074-.199-.128-.322-.127l-6.275.089c-.573.007-1.146-.11-1.719-.104a.44.44 0 0 0-.314.148c-.239.245-.403-.004-.59-.096l-.144.113c-.188.147-.194.152-.442-.024-.104-.074-.2-.128-.323-.127l-6.274.089v3.503c.084.032.203.009.302-.083.097-.091.187-.062.302.042.084.077.203.16.308.16l2.314-.015.306-.221c.101-.084.186-.06.299.046a.658.658 0 0 0 .485.173l2.067-.038-3.16 4.158c-.236.309-.518.584-.782.871l-2.029.037c-.086-.031-.208-.008-.309.084-.1.091-.191.061-.308-.042-.088-.077-.209-.16-.315-.16l-2.364.015a25.56 25.56 0 0 0-.312.221c-.104.084-.19.061-.307-.047a.678.678 0 0 0-.494-.172c-.477.009-.951.018-1.428.025l.465-.601.002-.071.439-.578a.724.724 0 0 0 .215-.189l2.385-3.159.256-.309-.01-.019.177-.233.017.016.062.05.064.051.023.021.016.017.033-.028.031-.019.031-.012.031-.007.072-.009.045-.008.05-.013.012-.002.011.002.01.006.011.009.019.023.019.028.036.056.01.011.01.008.01.006.012.002.107-.002.107-.012.214-.038.215-.038.108-.012.107-.003v-3.501l-1.633-.062-1.109-.041-.043-.005-.057-.01a4.392 4.392 0 0 0-.141-.022l-.078-.006-.078.001-.039.005-.037.008-.037.012-.035.016-.002.004-.003.008-.007.032-.004.022-.003.014-.001.003v.002h-.001l-.004.001-.038.013-.236.073-.086.107-.066.097-.099.177-.099.179-.064.098-.083.108-.021.029-.016.03-.01.033-.006.035-.018.056.003.018c-.075.082-.145.168-.221.248l-.068-.004-.026.029-.353.431-.347.44-.005.008-.004.01-.004.021v.026l.004.028.016.062.024.062.015.039.01.032.004.027-.001.012-.002.01-.001.002c-.008.007-.014.016-.022.021l-.003.001-.012.003-.014.001-.033-.004-.037-.004h-.031l-.027.004-.022.008-.018.011-.007.007-.006.007-.004.008-.004.009-.003.02.022.018-.004.002-.02-.016c-.008.011-.019.021-.027.031-.028.009-.059.016-.084.028l.001.067c-.138.168-.281.332-.429.492a.409.409 0 0 0-.151.115l-.358.472c-.102.114-.208.224-.301.345a.547.547 0 0 0-.076.148l-1.08 1.419a.572.572 0 0 0-.168.145l-2.227 2.906c-.217.228-.436.455-.626.704a.38.38 0 0 0-.07.205l-.389.507c-.015.006-.031.009-.045.016l.001.043-.383.499a.413.413 0 0 0-.196.133l-1.35 1.772c-.214.232-.429.465-.622.715a.53.53 0 0 0-.097.229l-.481.634c-.016.007-.031.012-.046.02l-.003.045-.467.611a.622.622 0 0 0-.23.174l-1.141 1.49c-.138.146-.277.29-.399.448a.354.354 0 0 0-.07.164l-.431.563-.003.001v.002l-.425.556a.396.396 0 0 0-.154.117l-2.361 3.101c-.313.348-.636.688-.92 1.058a.534.534 0 0 0-.104.287l-.331.434c-.034.045-.077.084-.113.127-.026.012-.054.021-.077.034l-.005.059c-.214.246-.433.489-.651.732-.014.015-.031.022-.044.039l-.055.071c-.058.066-.122.127-.175.196-.018.022-.023.052-.035.078l-.959 1.252c-.031.022-.062.041-.088.073l-3.554 4.666-.242.303c-.329.404-.723.756-1.04 1.169a.381.381 0 0 0-.07.22l-.396.495c-.013.005-.026.007-.038.013l.001.034-.417.521a.412.412 0 0 0-.162.12l-1.336 1.754-.309.386-2.929 3.665-.655.774-.412.518-.189.262-.164.253-.002.006-.002.006-.001.015.007.043.007.028.005.016v.004l.002.002.003.001.015.002c.041.007.088.015.139.022l.863.141 1.074-.006.849-.031.848-.033 1.074-.012.289-.008.043-.004c.067.002.135.013.201.012a.404.404 0 0 0 .229-.082l.04-.01.113-.037.108-.043c.03-.014.06-.025.087-.037l.057-.02c.1.043.191.129.289.176l.146-.113c.027-.021.045-.032.066-.047l.63.215.167.002 4.719.013.083-.004.085-.011.086-.016.085-.021.163-.052a.014.014 0 0 1 .006-.002l1.072-.016.035.006.083.008.08.001.044-.002c.517.017 1.031.096 1.548.091.021 0 .04-.011.06-.014.078.003.154.015.232.014a.44.44 0 0 0 .312-.148c.029-.03.056-.034.084-.051.078.046.155.107.235.146l.122-.096c.051.035.1.07.15.096l.143-.113.07-.051c.033.021.065.041.113.074.105.074.203.129.33.128l.236-.003c.006 0 .01.003.016.003l6.183-.087c.578-.004 1.157.107 1.734.102.006 0 .011-.004.017-.004.02 0 .041.004.062.004a.441.441 0 0 0 .313-.148.317.317 0 0 1 .154-.094c.134.011.252.129.378.189l.026-.021.031.021.144-.113c.079-.062.126-.092.172-.101.053.011.114.047.226.124.105.074.204.129.33.128l.035-.001.003.001 1.748-.024 4.546-.063c.566-.003 1.135.108 1.701.103.01 0 .018-.006.027-.006.036 0 .072.006.108.006.12 0 .229-.057.32-.148a.319.319 0 0 1 .141-.084c.106.037.204.129.308.18l.068-.055c.029.02.058.041.087.055l.146-.113c.048-.037.084-.064.116-.082.042.021.092.052.168.105.104.074.199.129.322.128l.164-.003.012.003 6.158-.085c.555.002 1.107.105 1.662.1.024 0 .046-.012.068-.017.094.005.188.018.28.017.12 0 .229-.057.321-.148.016-.016.028-.014.043-.025.063.042.127.09.191.121l.143-.113c.008-.007.013-.009.021-.015l.046.028.084.065c.003-.002.004-.007.008-.009.022.015.045.031.068.043l.146-.113.018-.013.054.036c.102.074.199.129.322.128l.363-.005c.01 0 .016.005.025.005l5.984-.083c.541.007 1.082.104 1.622.098.039 0 .075-.015.112-.026.15.011.301.028.451.026a.43.43 0 0 0 .26-.104.641.641 0 0 0 .08.052l.144-.113c.04-.031.069-.053.097-.07.12.027.229.129.344.184l.066-.052c.08.052.161.091.259.09l.563-.008c.014.001.025.008.039.008l5.812-.081c.526.012 1.055.102 1.581.096a.371.371 0 0 0 .154-.037c.207.018.416.039.623.037a.457.457 0 0 0 .32-.148c.094-.094.174-.104.25-.09.038.022.082.053.143.096.104.074.199.129.322.128l.764-.011c.019.002.033.011.053.011l5.638-.078c.515.015 1.027.099 1.542.093a.392.392 0 0 0 .178-.048c.271.025.541.051.812.048a.457.457 0 0 0 .32-.148c.032-.032.061-.037.09-.054.028.019.053.033.09.06.102.074.199.129.322.128l.963-.014c.023.004.043.014.066.014l5.465-.075c.5.018 1 .095 1.501.09a.374.374 0 0 0 .193-.06c.337.03.674.063 1.011.06a.45.45 0 0 0 .301-.134c.098.069.19.12.308.119l1.164-.017c.026.006.05.017.079.017l5.291-.073c.486.021.975.093 1.461.088a.386.386 0 0 0 .21-.071c.403.032.806.075 1.208.071.072 0 .14-.026.203-.064.06.029.121.051.191.05l1.364-.02c.031.007.06.02.094.02l5.116-.071c.474.024.947.091 1.422.086a.399.399 0 0 0 .225-.083c.469.026.938.088 1.406.083.041 0 .08-.015.119-.027.021.003.04.013.062.013l1.564-.022c.034.01.067.022.106.022l4.942-.068c.461.026.922.088 1.382.083a.401.401 0 0 0 .241-.095c.219.005.438.019.657.039l.005.003.004-.002c.312.028.625.058.938.055.024 0 .046-.012.068-.016l1.664-.023c.038.012.076.025.12.024l4.769-.066c.447.028.896.086 1.342.081a.415.415 0 0 0 .253-.103l.048-.001c.192-.002.385.019.577.034.009.005.018.013.026.017l.018-.014c.379.031.758.07 1.137.066.029 0 .055-.013.083-.02l1.636-.023a.369.369 0 0 0 .134.028l4.595-.063c.435.029.868.082 1.303.078a.401.401 0 0 0 .247-.1l.268-.004c.114-.001.228.014.342.02.017.011.032.023.048.031l.033-.025c.264.017.529.025.793.047.027.005.053.017.082.017l.17-.003c.096.005.193.019.289.018.034 0 .064-.014.097-.022l1.608-.022a.403.403 0 0 0 .148.03l4.632-.064.967.036 1.11.042.043.005.057.01c.041.007.089.015.14.022l.078.007.079-.002.038-.005.038-.008.036-.012.034-.015.003-.004.003-.009.008-.032.004-.022.002-.014v-.003l.001-.002h.001l.004-.002.038-.012.236-.073.086-.107c.023-.034.046-.066.065-.097l.1-.177.098-.179c.021-.03.042-.062.064-.098l.084-.109.02-.028.016-.03.011-.033.005-.035v-.038l-.006-.041-.012-.044-.02-.047-.016-.038-.01-.032-.004-.027v-.012l.002-.01.004-.008.006-.007.008-.006.009-.004.011-.003.014-.001.032.002.268.016.026-.029.353-.431.347-.44.006-.008.004-.01.004-.022v-.025l-.004-.029-.018-.062-.023-.063-.015-.037-.01-.033-.003-.027v-.012l.002-.01.004-.009.006-.007.008-.006.009-.004.012-.002.014-.001.033.003.036.005h.032l.027-.004.022-.007.018-.012.007-.006.006-.008.005-.008.003-.009.003-.019-2.756-2.163c-.348.419-.569.686-.918 1.104l.014.024.006.023.001.022-.002.009a.355.355 0 0 0-.164-.051l-2.364.015-.006.004c-.02-.005-.039-.019-.059-.019l-2.314.015a.589.589 0 0 1-.035.025l-.791.015a.811.811 0 0 0-.264-.038l-2.814.052c.057-.072.113-.147.17-.22l.011-.371c-.005-.129.065-.18.217-.201a.638.638 0 0 0 .429-.266l3.232-4.286c.076-.045.13-.15.117-.284-.013-.131.064-.182.215-.205.112-.018.249-.059.312-.139l1.385-1.788.011-.371c-.005-.13.065-.18.217-.202.179-.022.315-.119.429-.266l3.232-4.285c.076-.046.13-.151.117-.284-.013-.131.064-.182.215-.206.112-.018.249-.058.312-.138l1.385-1.788.011-.372c-.001-.038.018-.058.03-.084l2.29-.032c.579-.006 1.156.109 1.734.104a.448.448 0 0 0 .316-.148c.241-.245.407.004.595.096l.145-.113c.191-.146.197-.152.447.023.104.074.201.129.325.128l3.114-.044c-.035.035-.072.062-.104.104-1.325 1.737-2.649 3.48-3.967 5.216zm-7.461-19.965.011-.371c-.006-.129.064-.18.217-.201a.636.636 0 0 0 .429-.267l2.13-2.823.162-.001.306-.221c.102-.084.186-.06.299.046a.658.658 0 0 0 .485.173l5.492-.103c.085.032.203.009.302-.083.098-.091.188-.062.302.042.085.077.204.16.308.16l2.117-.014-2.982 3.916c-.312.408-.699.757-1.026 1.154a.688.688 0 0 0-.452-.146l-5.611.102c-.087-.031-.208-.008-.309.084-.1.091-.191.061-.309-.042-.087-.077-.209-.16-.314-.16l-2.365.015c-.112.079-.215.151-.312.221-.012.009-.021.004-.031.01.382-.5.769-.999 1.151-1.491zm-14.364 0 .011-.371c-.005-.129.065-.18.217-.201a.636.636 0 0 0 .429-.267l2.189-2.901c.477-.01.956-.019 1.432-.027.084.032.203.009.303-.083.098-.091.188-.062.301.042.086.077.204.16.309.16l2.314-.015.306-.221c.101-.084.187-.06.3.046a.65.65 0 0 0 .484.173l4.026-.075-3.042 3.994c-.292.381-.646.713-.958 1.077l-1.792.032c-.087-.031-.209-.008-.31.084-.099.091-.19.061-.308-.042-.088-.077-.209-.16-.314-.16l-2.365.015c-.112.079-.215.151-.312.221-.104.084-.189.061-.307-.047a.678.678 0 0 0-.494-.172l-3.443.062 1.024-1.324zm-1.116 4.822c.245-.245.412.004.604.096l.146-.113c.193-.146.199-.152.453.023.105.074.203.129.33.128l5.464-.075-2.22 2.913c-.342.445-.779.814-1.119 1.259a.421.421 0 0 0-.073.332c.048.336-.246.309-.431.396l.002.181c.002.235.002.243-.286.325-.12.033-.222.074-.295.169l-.462.606-1.559.028c-.084-.031-.205-.008-.305.084-.098.091-.188.061-.303-.042-.086-.077-.207-.16-.312-.16l-2.334.015-.309.221c-.101.084-.187.061-.302-.047a.666.666 0 0 0-.488-.172l-3.865.07.832-1.102c.076-.045.13-.15.117-.284-.013-.131.064-.181.215-.205.112-.019.249-.058.312-.139l1.385-1.788.011-.371c-.005-.13.065-.18.217-.202.179-.022.315-.12.429-.266l1.377-1.825.69-.01c.587-.006 1.172.109 1.758.104a.454.454 0 0 0 .321-.149zm-2.762 12.679c.002.235.002.244-.287.325-.119.033-.221.074-.294.17l-2.08 2.73-4.944.092c-.084-.031-.202-.008-.301.084-.098.091-.187.061-.301-.042-.084-.077-.203-.16-.307-.16l-2.306.015-.305.221c-.101.084-.185.061-.298-.047a.653.653 0 0 0-.483-.172l-.517.01c.812-1.078 1.627-2.156 2.436-3.229.076-.046.13-.151.117-.284-.013-.131.064-.182.215-.206.112-.018.249-.058.312-.138l1.385-1.788.011-.372c-.002-.044.019-.069.034-.098l1.338-.019c.579-.006 1.157.109 1.734.104a.444.444 0 0 0 .316-.148c.242-.245.407.004.596.096l.145-.113c.19-.146.196-.152.447.023.104.074.201.129.324.128l5.186-.073-.553.726c-.342.445-.779.813-1.12 1.258a.423.423 0 0 0-.072.333c.048.336-.247.308-.432.396l.004.178zm-14.363 0c.002.235.003.244-.286.325-.12.033-.221.074-.295.17l-2.146 2.816-.287.006c-.084-.031-.202-.008-.301.084-.098.091-.187.061-.301-.042-.084-.077-.203-.16-.307-.16l-2.307.015-.305.221c-.1.084-.185.061-.297-.047a.656.656 0 0 0-.484-.172l-4.99.093c.038-.033.079-.062.112-.105 1.025-1.362 2.052-2.724 3.071-4.08.074-.042.124-.144.108-.272-.016-.127.06-.174.206-.194.109-.015.243-.05.303-.126l1.054-1.362 5.349-.075c.579-.006 1.156.109 1.734.104a.444.444 0 0 0 .316-.148c.242-.245.407.004.596.096l.145-.113c.19-.146.196-.152.447.023.104.074.2.129.324.128l.664-.009-.504.661c-.341.445-.777.813-1.119 1.259a.428.428 0 0 0-.072.332c.049.336-.246.308-.432.396l.004.176zm-13.009-1.524c.056.326-.234.293-.413.373l.006.175c.008.229.008.236-.273.309-.117.029-.215.067-.285.157l-2.861 3.763a.804.804 0 0 0-.25-.036l-5.471.102c-.084-.031-.203-.008-.302.084-.097.091-.187.061-.3-.042-.085-.077-.203-.16-.307-.16l-2.307.015-.305.221c-.1.084-.186.061-.299-.047a.597.597 0 0 0-.279-.143.662.662 0 0 0 .209-.178l3.055-4.059c.074-.041.123-.143.107-.271-.016-.127.059-.174.205-.193.109-.014.242-.049.303-.125l1.02-1.318c.535.01 1.071.102 1.607.096a.448.448 0 0 0 .316-.148c.242-.245.406.004.596.096l.145-.113c.189-.146.196-.152.446.023.104.074.201.129.325.128l6.325-.089c-.306.363-.661.686-.95 1.062-.067.082-.084.194-.063.318zm-14.263-.123c.056.325-.234.291-.412.37l.007.175c.008.228.009.235-.272.307-.116.029-.214.066-.283.156l-2.993 3.936-1.104.021c-.084-.031-.202-.008-.301.084-.097.091-.187.061-.3-.042-.086-.077-.203-.16-.308-.16l-2.306.015-.305.221c-.101.084-.186.061-.299-.047a.652.652 0 0 0-.482-.172l-3.445.064.17-.22.049-.419c.007-.146.088-.209.254-.249.195-.044.352-.166.488-.342l3.727-4.907 3.613-.051c.578-.006 1.156.109 1.734.104a.448.448 0 0 0 .316-.148c.242-.245.406.004.596.096l.145-.113c.189-.146.195-.152.446.023.104.074.201.129.325.128l1.787-.025c-.266.29-.547.565-.785.877-.067.084-.084.196-.062.318zm-30.176 3.02c.002.235.003.244-.285.325-.121.033-.222.074-.295.17l-1.068 1.402-2.549.047c-.084-.031-.202-.008-.301.084-.098.091-.187.061-.301-.042-.084-.077-.203-.16-.307-.16l-2.306.015-.306.221c-.1.084-.185.061-.297-.047a.655.655 0 0 0-.483-.172l-3.623.067 2.134-2.829c.076-.046.13-.151.117-.284-.013-.131.064-.182.215-.206.112-.018.249-.058.312-.138l1.385-1.788.011-.372c-.005-.129.065-.18.217-.201a.636.636 0 0 0 .429-.267l.045-.06 3.258-.046c.578-.006 1.156.109 1.734.104a.451.451 0 0 0 .316-.148c.241-.245.406.004.596.096l.144-.113c.19-.146.196-.152.446.023.104.074.201.129.326.128l3.638-.051-1.581 2.076c-.342.445-.779.813-1.119 1.259a.416.416 0 0 0-.072.332c.048.336-.247.308-.432.396l.002.179zm-14.362-.916c.002.235.003.244-.286.325-.12.033-.221.074-.295.17l-1.721 2.258-.52.004-.305.221c-.1.084-.185.061-.298-.047a.653.653 0 0 0-.483-.172l-5.471.102c-.084-.031-.203-.008-.301.084-.098.091-.188.061-.301-.042-.085-.077-.203-.16-.307-.16l-1.554.01 2.995-3.981c.073-.041.122-.141.105-.269-.017-.126.058-.173.203-.191.109-.013.241-.048.301-.122l1.26-1.63c.068.044.135.095.204.128l.144-.113c.191-.146.197-.152.447.023.104.074.201.129.326.128l6.328-.089c.578-.006 1.156.109 1.734.104a.451.451 0 0 0 .316-.148c.028-.029.053-.031.078-.047l-.982 1.29c-.341.445-.777.813-1.119 1.259a.428.428 0 0 0-.072.332c.049.336-.246.308-.432.396l.006.177zm9.753-6.827.541-.717c.076-.045.13-.15.117-.284-.013-.131.064-.181.215-.205.112-.019.249-.058.312-.139l1.385-1.788.011-.371c-.005-.13.065-.18.217-.202.179-.022.315-.12.429-.266.57-.756 1.139-1.509 1.707-2.265l2.02-.027c.586-.006 1.172.109 1.758.104a.457.457 0 0 0 .32-.148c.244-.245.412.004.604.096l.146-.113c.192-.146.199-.152.452.023.105.074.204.129.33.128l4.844-.067-3.258 4.279c-.342.444-.779.813-1.12 1.258a.42.42 0 0 0-.072.332c.032.227-.093.285-.233.328l-.221.004c-.086-.031-.205-.008-.305.084-.099.091-.189.061-.305-.042-.086-.077-.205-.16-.311-.16l-2.334.015-.309.221c-.102.084-.188.061-.301-.047a.668.668 0 0 0-.49-.172l-5.537.102c-.086-.031-.205-.008-.305.084-.099.091-.189.061-.305-.042 0-.003-.001-.003-.002-.003zm8.986 7.74c.076-.046.129-.151.116-.284-.013-.131.065-.182.216-.206.111-.018.248-.058.312-.138l1.384-1.789.012-.371c-.006-.129.064-.18.217-.201a.631.631 0 0 0 .429-.267l.72-.955a.51.51 0 0 0 .162-.111c.241-.245.406.004.596.096l.144-.113c.19-.146.196-.152.446.023.104.074.201.129.326.128l6.328-.089c.578-.006 1.156.109 1.734.104.007 0 .013-.004.02-.005l-.012.149c-.021.266-.021.275-.34.396-.133.05-.246.105-.335.22l-4.022 5.254-.695.004-.305.221c-.101.084-.186.061-.299-.047a.652.652 0 0 0-.482-.172l-5.473.102c-.084-.031-.202-.008-.301.084-.097.091-.186.061-.3-.042-.085-.077-.204-.16-.308-.16l-1.678.011c.462-.615.927-1.231 1.388-1.842zm57.143-18.889.003-.359c-.009-.126.06-.174.208-.191a.582.582 0 0 0 .414-.248l2.201-2.922a.725.725 0 0 0 .321.073l5.492-.103c.085.032.203.009.302-.083.098-.091.188-.062.302.042.085.077.204.16.308.16l2.314-.015.307-.221c.1-.084.186-.06.299.046.006.006.015.007.021.013l-3.107 4.079c-.271.354-.594.667-.891 1.001l-.814.005a25.56 25.56 0 0 0-.312.221c-.104.084-.19.061-.307-.047a.682.682 0 0 0-.495-.172l-5.611.102c-.087-.031-.208-.008-.309.084-.1.091-.191.061-.308-.042-.088-.077-.209-.16-.315-.16l-1.005.007c.328-.426.658-.851.982-1.27zm.954 4.885c.587-.006 1.172.109 1.757.104a.453.453 0 0 0 .32-.148c.246-.245.413.004.604.096l.146-.113c.193-.146.199-.152.453.023.105.074.203.129.33.128l1.076-.015-2.174 2.853c-.341.445-.777.814-1.119 1.259a.429.429 0 0 0-.072.332c.049.336-.246.309-.432.396l.003.181c.002.235.003.243-.286.325-.12.033-.221.074-.295.169l-.402.529-.399.002-.309.221c-.102.084-.188.061-.302-.047a.666.666 0 0 0-.488-.172l-5.539.102c-.085-.031-.205-.008-.305.084-.098.091-.188.061-.304-.042-.086-.077-.206-.16-.311-.16l-1.622.011 1.152-1.531c.073-.042.123-.144.107-.272-.016-.128.06-.175.206-.194.11-.015.243-.051.303-.127l1.317-1.702.002-.359c-.009-.126.059-.173.208-.19a.584.584 0 0 0 .414-.248l1.071-1.422 4.89-.073zm-15.294-4.91.002-.359c-.01-.125.059-.172.207-.188a.582.582 0 0 0 .412-.246l2.198-2.921.544-.01c.085.032.203.009.303-.083.098-.091.188-.062.301.042.086.077.204.16.309.16l2.314-.015.307-.221c.1-.084.186-.06.299.046a.65.65 0 0 0 .484.173l4.916-.092-2.945 3.872c-.322.421-.74.768-1.063 1.188l-3.315.061c-.086-.031-.207-.008-.309.084-.1.091-.191.061-.308-.042-.087-.077-.208-.16-.315-.16l-2.364.015-.312.221c-.103.084-.19.061-.306-.047a.682.682 0 0 0-.495-.172l-1.897.034c.343-.449.691-.899 1.033-1.34zm-1.469 4.871c.104.074.203.129.329.128l6.411-.089c.188-.002.377.018.565.033l-1.815 2.388c-.324.424-.745.771-1.069 1.194a.397.397 0 0 0-.063.32c.056.327-.234.293-.414.373l.008.175c.007.229.008.237-.273.31-.117.029-.216.066-.285.157l-.93 1.223-2.719.05c-.085-.031-.205-.008-.305.084-.098.091-.188.061-.304-.042-.086-.077-.206-.16-.312-.16l-2.334.015-.309.221c-.101.084-.187.061-.301-.047a.667.667 0 0 0-.489-.172l-2.698.05 1.252-1.663c.074-.042.123-.143.107-.271-.016-.127.059-.174.205-.193.109-.014.242-.05.303-.125l1.309-1.693.002-.358c-.01-.125.059-.173.207-.189a.58.58 0 0 0 .412-.246l1.041-1.383c.314.029.63.059.945.056.12 0 .229-.057.32-.148.245-.245.412.004.604.096l.146-.113c.194-.151.2-.157.454.019zm-9.268-8.516 4.292-.08c.085.032.203.009.302-.083.098-.091.188-.062.302.042.085.077.204.16.308.16l2.314-.015.307-.221c.101-.084.186-.06.299.046a.655.655 0 0 0 .484.173l.299-.006-2.85 3.748c-.317.415-.727.757-1.046 1.168l-2.32.015c-.112.079-.215.151-.312.221-.103.084-.19.061-.306-.047a.683.683 0 0 0-.496-.172l-5.408.098 3.831-5.047zm-2.277 8.659a.457.457 0 0 0 .32-.148c.245-.245.412.004.604.096l.146-.113c.192-.146.199-.152.452.023.104.074.204.129.33.128l2.625-.036-1.743 2.292c-.322.422-.74.767-1.062 1.188-.067.085-.084.197-.062.319.056.326-.234.291-.412.371l.007.174c.008.229.009.236-.272.308-.116.028-.214.065-.283.156l-.949 1.249-1.555.01-.309.221c-.101.084-.187.061-.301-.047a.667.667 0 0 0-.489-.172l-5.538.102c-.086-.031-.205-.008-.305.084-.099.091-.189.061-.305-.042-.086-.077-.205-.159-.31-.16.035-.074.097-.128.216-.156.195-.044.352-.166.488-.342l3.908-5.146a.4.4 0 0 0 .154-.331c0-.039.022-.061.035-.09l2.852-.039c.586-.009 1.172.107 1.758.101zm-15.914-3.969c-.006-.129.064-.18.217-.201a.636.636 0 0 0 .428-.267l3.155-4.183 2.294-.015.307-.221c.1-.084.186-.06.299.046a.652.652 0 0 0 .484.173l5.492-.103c.084.032.203.009.302-.083.098-.091.188-.062.302.042.085.077.203.16.309.16l.256-.002c-.097.051-.211.081-.305.134l-.016.202c-.021.266-.021.275-.34.396-.133.05-.246.105-.335.22l-3.04 3.97c-.021-.001-.04-.009-.062-.009l-5.611.102c-.086-.031-.207-.008-.309.084-.1.091-.191.061-.309-.042-.086-.077-.208-.16-.314-.16l-2.365.015-.312.221c-.103.084-.189.061-.305-.047a.613.613 0 0 0-.23-.135l.008-.297zm4.135 3.865c.586-.006 1.172.109 1.758.104a.457.457 0 0 0 .32-.148c.244-.245.412.004.604.096l.146-.113.015-.011a.594.594 0 0 0-.06.28c.019.373-.297.371-.504.487l-.016.202c-.021.266-.021.275-.34.396-.133.05-.246.105-.335.22l-3.542 4.626c-1.553.028-3.105.058-4.65.085-.086-.031-.205-.008-.305.084-.099.091-.189.061-.305-.042-.086-.077-.205-.16-.311-.16l-2.334.015-.309.221c-.102.084-.188.061-.301-.047a.667.667 0 0 0-.489-.172l-1.007.019c.01-.095.073-.146.202-.166.112-.019.249-.059.312-.139l1.385-1.788.012-.371c-.006-.13.064-.18.217-.202.179-.022.315-.12.428-.266l2.521-3.342c.038.021.084.052.145.095.105.074.205.129.33.128l6.413-.091zm-18.508-4.41.011-.371c-.005-.129.065-.18.217-.201a.636.636 0 0 0 .429-.267l2.494-3.306 4.282-.08c.085.032.204.009.302-.083.098-.091.188-.062.302.042.085.077.204.16.309.16l2.314-.015.306-.221c.101-.084.186-.06.299.046a.656.656 0 0 0 .485.173l2.125-.04c-.001.188-.02.207-.286.283-.12.033-.221.074-.295.169l-3.497 4.593-1.31.023c-.086-.031-.208-.008-.309.084-.1.091-.191.061-.309-.042-.087-.077-.208-.16-.314-.16l-2.365.015c-.111.079-.215.151-.312.221-.103.084-.189.061-.306-.047a.679.679 0 0 0-.495-.172l-4.766.086.689-.89zm-14.107-.096-.001-.356c-.01-.124.058-.171.205-.187a.57.57 0 0 0 .409-.242l2.427-3.226 2.11-.014.307-.221c.1-.084.186-.06.299.046a.652.652 0 0 0 .484.173l5.492-.103c.084.032.203.009.303-.083.097-.091.187-.062.301.042.084.076.203.159.307.16l-3.32 4.359c-.198.259-.425.494-.65.731-.006-.005-.01-.004-.015-.009a.682.682 0 0 0-.495-.172l-5.611.102c-.087-.031-.208-.008-.309.084-.1.091-.191.061-.309-.042-.087-.077-.209-.16-.314-.16l-2.314.015.694-.897zm-7.442 9.312c.073-.041.122-.141.105-.269-.017-.126.058-.172.203-.191.109-.013.241-.047.301-.122l1.295-1.675-.001-.355c-.01-.125.058-.171.205-.187a.57.57 0 0 0 .409-.242l1.263-1.679 6.212-.086c.586-.006 1.172.109 1.757.104.12 0 .229-.057.32-.148.245-.245.413.004.604.096l.146-.113c.192-.146.198-.152.452.023.042.029.084.053.125.074l-2.551 3.349c-.341.445-.777.814-1.119 1.259a.429.429 0 0 0-.072.332c.049.336-.246.309-.432.396l.003.181c.002.235.003.243-.286.325-.12.033-.221.074-.295.169l-.068.09-4.795.088c-.086-.031-.205-.008-.305.084-.1.091-.189.061-.305-.042-.086-.077-.205-.16-.311-.16l-2.334.015-.309.221c-.102.084-.188.061-.302-.047a.667.667 0 0 0-.489-.172l-.423.008.997-1.326zm-12.844.436a.328.328 0 0 0 .139-.093l1.385-1.789.004-.129.38-.5a.677.677 0 0 0 .272-.21l1.023-1.355a.439.439 0 0 0 .152-.116l.755-.972c.146.01.292.027.438.025a.457.457 0 0 0 .321-.148c.245-.245.412.004.603.096l.146-.113c.193-.146.199-.152.453.023.105.074.203.129.33.128l5.688-.079-2.002 2.634c-.318.416-.733.757-1.053 1.173a.391.391 0 0 0-.06.317c.058.323-.231.288-.409.366l.009.172c.009.227.011.234-.269.305-.117.027-.214.064-.283.153l-.824 1.084-.466.009c-.085-.031-.204-.008-.305.084-.099.091-.188.061-.304-.042-.086-.077-.205-.16-.311-.16l-2.334.015-.309.221c-.102.084-.188.061-.302-.047a.667.667 0 0 0-.489-.172l-3.092.057c.241-.314.477-.624.714-.937zm-5.97 7.555a.375.375 0 0 0 .191-.107l1.385-1.788.012-.371.002-.005a.441.441 0 0 1 .154-.072c.123-.033.275-.094.354-.191l.716-.923v.388c.579-.006 1.157.109 1.734.104a.448.448 0 0 0 .316-.148c.241-.245.407.004.596.096l.144-.113c.191-.146.197-.152.447.023.104.074.201.129.325.128l4.093-.058c-.311.389-.697.719-1 1.114a.391.391 0 0 0-.06.317c.058.323-.231.287-.409.365l.009.173c.009.227.011.234-.269.304-.117.028-.214.064-.283.154l-2.825 3.717-2.659.049c-.085-.031-.203-.008-.302.084-.097.091-.187.061-.3-.042-.086-.077-.203-.16-.308-.16l-2.306.015-.305.221c-.101.084-.186.061-.299-.047a.652.652 0 0 0-.482-.172l-1.006.019 2.335-3.074zm16.201 7.654.003.181c.002.235.003.243-.286.325-.12.033-.221.074-.295.17l-3.343 4.388a.793.793 0 0 0-.292-.052h-.005a16.44 16.44 0 0 1-.224.004l-5.312.097c-.034-.005-.068-.011-.106 0a.317.317 0 0 0-.273.085c-.023.021-.046.016-.068.023-.036-.016-.07-.029-.11-.065-.086-.077-.205-.16-.309-.16l-.132.001-.002-.001-2.366.015c-.112.079-.215.151-.312.221-.008.006-.014.002-.021.007-.028-.017-.056-.023-.087-.054a.656.656 0 0 0-.484-.172l-.185.004c-.009 0-.016-.004-.024-.004l-5.61.102h-.005a.25.25 0 0 0-.151-.001l-.526-.003c-.078-.061-.167-.114-.251-.114l-2.364.015-.115.082-.667-.005a.757.757 0 0 0-.332-.075l-2.054.037-.001-.039.003-.023c.025-.009.041-.022.075-.027a.638.638 0 0 0 .429-.266l1.364-1.809.044-.027.065-.053.031-.031.03-.034.548-.722.53-.738.531-.737.486-.642c.097-.021.195-.057.246-.121l.525-.679c.039.001.077.007.115.007a.44.44 0 0 0 .312-.148c.238-.245.401.004.588.096l.143-.113c.188-.146.194-.152.441.023.103.074.199.129.322.128l6.252-.089c.571-.006 1.143.109 1.713.104a.44.44 0 0 0 .312-.148c.238-.245.402.004.588.096l.143-.113c.188-.146.195-.152.441.023.104.074.199.129.322.128l6.252-.089c.571-.006 1.143.109 1.713.104a.44.44 0 0 0 .312-.148c.239-.245.402.004.589.096l.143-.113c.188-.146.194-.152.44.023.104.074.199.129.322.128l.609-.009c-.055.063-.117.122-.168.188a.43.43 0 0 0-.072.333c.05.332-.245.303-.43.39zm14.795.522c.048.336-.246.308-.432.395l.003.181c.001.235.002.243-.286.325-.121.033-.221.074-.295.17l-2.666 3.499-1.025.019c-.01.002-.017-.002-.026.001l-.161.003c-.074-.027-.176-.004-.267.064-.013-.01-.024-.01-.038-.022-.087-.077-.209-.16-.314-.16l-.287.002-.006-.002-2.314.015-.302.219c-.024-.016-.047-.02-.074-.045a.682.682 0 0 0-.495-.172l-.194.004c-.009 0-.016-.004-.024-.004l-5.094.094.005-.176c-.005-.129.065-.18.217-.201a.638.638 0 0 0 .429-.266l3.232-4.286c.076-.045.13-.15.117-.284-.013-.131.064-.182.215-.205.112-.018.249-.059.312-.139l.412-.532.879-.013c.572-.006 1.143.109 1.713.104a.437.437 0 0 0 .312-.148c.239-.245.402.004.589.096l.143-.113c.188-.146.194-.152.441.023.103.074.198.129.321.128l6.084-.087c-.331.41-.73.766-1.051 1.183a.413.413 0 0 0-.073.33zm57.018-.798c.002.235.003.243-.286.325-.12.033-.221.074-.295.17l-3.64 4.777-2.065.014-.014.01-.908.017c-.055-.011-.107-.024-.168-.024l-4.803.089c-.076-.056-.16-.105-.24-.105-.447.003-.89.005-1.334.009-.009-.002-.018-.009-.026-.009l-2.313.015-.008.006-.939.017c-.047-.007-.092-.021-.144-.021l-5.012.093c-.077-.058-.163-.109-.245-.109l-1.125.007c-.007 0-.015-.007-.021-.007l-2.314.015-.005.004-.013-.002-.953.018c-.039-.006-.076-.018-.119-.018l-5.221.097c-.078-.06-.166-.113-.25-.113l-.916.006c-.006-.001-.012-.006-.018-.006l-2.314.015-.039.029c-.062-.014-.123-.028-.191-.027l-.764.014c-.032-.003-.061-.014-.096-.014l-5.429.101c-.079-.062-.169-.117-.255-.117l-.706.005c-.005-.001-.009-.005-.014-.005l-2.314.015-.108.079a.758.758 0 0 0-.336-.077l-.573.01c-.024-.001-.046-.01-.072-.01l-5.491.102a.25.25 0 0 0-.151-.001c-.079-.062-.169-.117-.255-.117l-.496.003c-.004 0-.007-.003-.01-.003l-2.314.015-.206.148a.688.688 0 0 0-.452-.146l-.044.001 2.956-3.92c.076-.045.129-.15.117-.284-.014-.131.064-.182.215-.205.111-.018.249-.059.312-.139.358-.463.716-.924 1.071-1.385l5.4-.076c.572-.006 1.143.109 1.715.104a.441.441 0 0 0 .312-.148c.238-.245.401.004.588.096l.143-.113c.188-.146.193-.152.441.023.102.074.198.129.321.128l6.252-.089c.571-.006 1.143.109 1.714.104a.441.441 0 0 0 .312-.148c.238-.245.401.004.588.096l.143-.113c.188-.146.194-.152.441.023.103.074.199.129.321.128l6.252-.089c.571-.006 1.144.109 1.714.104a.44.44 0 0 0 .312-.148c.238-.245.402.004.588.096l.143-.113c.188-.146.194-.152.441.023.103.074.199.129.322.128l6.252-.089c.571-.006 1.143.109 1.713.104a.44.44 0 0 0 .312-.148c.239-.245.402.004.588.096l.143-.113c.189-.146.195-.152.441.023.104.074.199.129.322.128l6.252-.089c.571-.006 1.143.109 1.713.104a.437.437 0 0 0 .312-.148c.239-.245.402.004.589.096l.143-.113c.188-.146.194-.152.441.023.103.074.198.129.321.128l3.779-.054c-.002.036-.008.071-.002.109.049.336-.246.308-.432.395l.004.17zm14.075.325c-.12.033-.221.074-.295.17l-3.682 4.832-2.245.042c-.073-.052-.153-.098-.229-.098l-1.753.011c-.011-.002-.023-.011-.034-.011l-2.314.015-.02.014-.879.016c-.062-.014-.123-.028-.191-.027l-2.105.039.16-.207.011-.371c-.005-.129.065-.18.217-.201a.638.638 0 0 0 .429-.266l3.232-4.286c.076-.045.13-.15.117-.284-.013-.131.064-.182.215-.205.112-.018.249-.059.312-.139l.17-.22c.114.03.218.128.328.183l.143-.113c.188-.146.193-.152.44.023.103.074.198.129.321.128l6.252-.089c.572-.006 1.143.109 1.714.104a.437.437 0 0 0 .312-.148.313.313 0 0 1 .133-.081.455.455 0 0 0-.044.271c.049.336-.246.308-.432.395l.004.181c.002.232.003.24-.287.322zm15.079-.9c.049.336-.246.308-.432.395l.003.181c.002.235.003.243-.286.325-.12.033-.221.074-.295.17l-3.643 4.782-1.363.009-.029.021-.82.015a.81.81 0 0 0-.24-.034l-4.178.077c-.072-.05-.15-.094-.225-.094l-1.963.013c-.012-.003-.025-.013-.038-.013l-.917.006.121-.156.012-.372c-.006-.129.064-.18.217-.201a.638.638 0 0 0 .428-.266l3.233-4.286c.076-.045.13-.15.116-.284-.012-.131.065-.181.215-.205.113-.018.25-.058.312-.139l.035-.045 3.029-.043c.572-.006 1.144.109 1.715.104a.441.441 0 0 0 .312-.148c.238-.245.401.004.588.096l.143-.113c.188-.146.193-.152.441.023.102.074.199.129.321.128l3.188-.046c0 .032-.005.065 0 .1zm7.109-9.132c-.341.445-.777.813-1.119 1.259a.428.428 0 0 0-.072.332c.049.336-.246.308-.432.396l.003.18c.002.235.003.244-.286.325-.12.033-.221.074-.295.17l-2.24 2.941c-.063.01-.128-.009-.203-.077-.086-.077-.204-.16-.308-.16l-2.306.015-.305.221c-.101.084-.186.061-.299-.047a.652.652 0 0 0-.482-.172l-5.473.102c-.084-.031-.201-.008-.301.084-.027.025-.053.021-.079.028l2.591-3.433c.076-.045.129-.151.115-.284-.012-.131.066-.182.216-.206.112-.018.249-.058.312-.138l1.385-1.788.012-.372c-.004-.093.045-.137.121-.167l.018.012c.104.074.201.129.325.128l6.327-.089c.58-.006 1.157.109 1.735.104a.444.444 0 0 0 .315-.148c.242-.245.407.004.596.096l.145-.113c.19-.146.197-.152.447.023.03.021.061.036.09.054l-.553.724zm5.918-7.541c-.341.445-.777.814-1.119 1.259a.429.429 0 0 0-.072.332c.049.336-.246.309-.432.396l.003.181c.002.235.003.243-.286.325-.12.033-.221.074-.295.169l-.514.676a.674.674 0 0 0-.439-.143l-5.539.102c-.084-.031-.204-.008-.305.084-.098.091-.188.061-.303-.042-.086-.077-.206-.16-.312-.16l-2.334.015-.308.221c-.092.076-.174.054-.273-.029l.922-1.221c.076-.045.129-.15.116-.284-.013-.131.065-.181.216-.205.111-.019.248-.058.312-.139l1.385-1.788.011-.371c-.006-.13.065-.18.217-.202.18-.022.316-.12.429-.266l1.319-1.749c.007 0 .012.003.018.003l6.412-.089c.586-.006 1.172.109 1.758.104a.457.457 0 0 0 .32-.148c.244-.245.412.004.604.096l.146-.113c.192-.146.199-.152.452.023.035.025.07.043.105.062l-2.214 2.901zm7.836 3.192-.309.221c-.102.084-.188.061-.303-.047a.665.665 0 0 0-.488-.172c-1.611.029-3.22.06-4.825.088l.845-1.119c.076-.045.13-.15.117-.284-.013-.131.064-.181.215-.205.112-.019.249-.058.312-.139l1.385-1.788.011-.371c-.005-.13.065-.18.217-.202.179-.022.315-.12.429-.266l1.362-1.807 2.046-.028c.586-.006 1.172.109 1.758.104a.457.457 0 0 0 .32-.148c.244-.245.412.004.604.096l.146-.113c.192-.146.199-.152.452.023.105.074.205.129.33.128l3.293-.046-.002.021c-.008.146-.09.211-.257.252-.196.046-.355.171-.493.349l-3.968 5.222a.413.413 0 0 0-.157.335c0 .02-.015.028-.018.045-.024.014-.051.02-.073.041-.099.091-.188.061-.304-.042-.086-.077-.206-.16-.311-.16-.783.003-1.565.007-2.334.012zM257.641 281.154c.955 0 1.823-.096 2.613-.276-2.428.254-3.757.276-2.613.276zM137.177 108.948l-.034.039c-.156.186-.122.151.034-.039z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M270.632 254.343c.133.073.218.074.281-.031.062-.094.132-.184.197-.298l.969-.392.947-.463c.082-.049.217-.033.322-.007.143.035.231.017.264-.107.033-.127.115-.202.199-.216 1.443-.907 2.785-2.138 4.152-3.4a.676.676 0 0 1 .482-.2c.156.001.237-.042.256-.175.025-.117.053-.24.081-.375l1.733-1.641c.079-.074.226-.098.343-.102.157-.006.245-.048.257-.184.011-.137.085-.238.172-.275 1.354-1.322 2.772-2.649 4.1-3.991.139-.137.294-.22.478-.222.156-.004.236-.047.253-.182l.078-.382 1.711-1.675c.077-.076.223-.101.338-.105.156-.007.242-.05.254-.186.01-.139.082-.241.167-.278l4.013-4.024c.139-.137.294-.221.479-.225.158-.005.238-.049.255-.182l.074-.379 1.711-1.675c.077-.075.223-.102.34-.107.157-.008.244-.052.254-.187.01-.137.081-.239.166-.277l4.002-4.035c.137-.14.291-.227.477-.234.158-.008.238-.053.252-.188l.068-.381 1.682-1.712c.076-.077.223-.105.34-.113.156-.011.242-.056.25-.192.007-.138.077-.241.162-.281l3.945-4.11c.137-.14.291-.228.477-.235.158-.008.238-.054.252-.187l.066-.381 1.684-1.712c.076-.077.222-.105.339-.114.157-.011.243-.057.251-.191.006-.138.076-.242.161-.281l1.971-2.053.983-1.031.86-.977a.685.685 0 0 1 .431-.236c.146-.019.215-.068.207-.196v-.365c.45-.56.807-1.192 1.199-1.801.046-.086.17-.143.275-.176.141-.045.208-.107.172-.231-.037-.126-.006-.234.061-.29.767-1.537 1.275-3.207 1.546-4.907a.71.71 0 0 1 .073-.218c.031-.861.062-1.713.057-2.483.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.572-.129-.192-.272-.376-.396-.57-.057-.095-.088-.205-.144-.324-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.316-.116-10.625a.935.935 0 0 1 .217-.635c.137-.168.204-.381.307-.573-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.323-.019-1.754.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.573-.129-.191-.272-.375-.396-.57-.057-.094-.088-.205-.144-.323-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.572-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.324-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.316-.116-10.625a.937.937 0 0 1 .217-.635c.137-.168.204-.381.307-.573-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.323-.019-1.754.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.573-.129-.191-.272-.375-.396-.57-.057-.094-.088-.205-.144-.323-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.572-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.324-.011-.863.022-1.86.083-2.86.062-.977.104-1.884.072-2.698-.051-1.854-.323-3.28-.807-4.457-.484-1.176-1.242-2.314-2.657-3.243-.155-.117-.263-.218-.322-.431-.052-.18-.177-.319-.273-.484-.204.045-.39.095-.587.153-.097.03-.195.032-.307.055-1.248-.549-3.232-.822-4.796-.884-4.009-.033-6.317.057-10.625.077a.938.938 0 0 1-.636-.219c-.168-.137-.381-.205-.572-.309-.192.129-.375.271-.57.394-.095.057-.205.088-.324.143-1.753.013-3.893-.158-5.627-.152-4.009-.033-6.316.057-10.625.077a.934.934 0 0 1-.635-.219c-.168-.137-.381-.205-.572-.309-.193.128-.376.271-.57.394-.096.057-.206.087-.324.143-1.754.013-3.893-.158-5.627-.152-4.01-.033-6.316.057-10.625.077a.932.932 0 0 1-.635-.219c-.169-.137-.381-.205-.574-.309-.191.128-.375.271-.569.394-.095.057-.206.087-.323.143-1.754.013-3.893-.158-5.627-.152-4.01-.033-6.317.057-10.625.077a.941.941 0 0 1-.636-.219c-.169-.138-.381-.205-.573-.309-.191.128-.375.271-.57.394-.094.057-.205.087-.323.143-1.753.013-3.893-.158-5.627-.152-4.01-.033-6.317.057-10.625.077a.939.939 0 0 1-.636-.22c-.168-.137-.381-.204-.572-.308-.192.128-.375.271-.57.394-.095.057-.205.087-.324.143-1.753.012-3.893-.158-5.627-.152-4.01-.034-6.316.056-10.625.077a.935.935 0 0 1-.635-.22c-.168-.137-.381-.205-.573-.308-.192.128-.375.271-.57.394-.095.057-.205.087-.323.143-1.754.012-3.893-.158-5.627-.152l-5.237.008c-1.647 0-3.324-.071-5.354-.037a.84.84 0 0 1-.598-.195c-.162-.131-.367-.193-.553-.286-.166.147-.325.29-.492.44-.081.064-.178.104-.278.168-1.561.146-3.379.507-4.769 1.223-1.609.781-2.789 1.676-3.947 2.656-1.176.965-2.269 2.084-3.786 3.642a.914.914 0 0 1-.599.294c-.213.021-.41.124-.617.187-.045.228-.073.46-.125.687-.026.107-.082.208-.127.331-1.221 1.253-2.84 2.65-4.053 3.885-2.835 2.822-4.389 4.523-7.395 7.595a.936.936 0 0 1-.602.297c-.216.023-.414.127-.623.191-.043.227-.068.456-.118.68-.026.107-.081.207-.125.33-1.228 1.242-2.82 2.682-4.021 3.932-2.803 2.867-4.336 4.594-7.305 7.714a.935.935 0 0 1-.598.306c-.215.025-.411.132-.619.198-.041.228-.064.46-.112.686-.024.107-.079.209-.122.332a59.282 59.282 0 0 1-2.006 1.983c-.313.302-.791.75-1.156 1.055-.386.33-.718.608-1.024.893-.56.503-1.013.975-1.423 1.443 5.539-4.383 11.021-3.881 15.575-3.86 32.049.148 87.046.369 98 .369 16.5 0 20.998 9.356 20.998 22.856v119c0 7.306-2.712 9.461-4.759 10.285a.423.423 0 0 1 .248.06z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m265.216 279.986 1.217-.32c.396-.147.812-.303 1.256-.467.211-.067.363-.094.584-.026.187.059.383.036.582.052l.252-.564c.035-.094.094-.172.144-.272.278-.219.636-.374.911-.635.297-.252.578-.448.967-.811.729-.65 1.455-1.297 2.078-1.905 2.914-2.778 4.514-4.456 7.605-7.482a.908.908 0 0 1 .611-.279c.217-.016.418-.112.629-.169.053-.225.088-.454.146-.678.029-.105.09-.204.137-.325 1.27-1.212 2.943-2.555 4.203-3.748 2.938-2.728 4.574-4.367 7.676-7.348a.929.929 0 0 1 .607-.278c.217-.016.416-.112.626-.17.051-.226.085-.456.142-.68.029-.105.09-.204.137-.326 1.258-1.217 2.92-2.566 4.168-3.764 2.92-2.737 4.557-4.371 7.497-7.454a.92.92 0 0 1 .597-.296c.215-.022.411-.126.618-.189.042-.226.067-.455.115-.679.024-.106.08-.206.122-.329 1.208-1.248 2.816-2.643 4.018-3.874.729-.697 1.246-1.354 1.797-1.962.418-.613.942-1.153 1.212-1.768.157-.302.333-.594.489-.908l.364-1.04.199-.545c.053-.197.088-.412.136-.625l.292-1.354c.053-.215.146-.378.315-.544.154-.138.246-.329.37-.498l-.325-.597c-.045-.096-.062-.205-.104-.322.047-.413.107-.848.176-1.293l.13-1.401c.087-.942.193-1.879.217-2.73.036-1.981.048-3.534.034-5.14l-.021-1.416c-.117.17-.232.342-.36.504-.346.484-.709.955-1.113 1.389-.395.452-.791.894-1.164 1.262-.09.091-.199.124-.326.147-.309.06-.309.067-.342.31l-.025.186c-.201.073-.498.019-.5.367a.468.468 0 0 1-.124.336c-.415.426-.919.767-1.335 1.193l-4.535 4.686c-.09.091-.198.124-.326.147-.307.058-.307.066-.342.31l-.024.185c-.202.073-.498.019-.501.368a.464.464 0 0 1-.124.336c-.415.426-.918.766-1.334 1.193-1.528 1.546-2.997 3.146-4.554 4.671-.092.09-.203.122-.332.144-.31.054-.311.062-.348.303l-.028.185c-.204.071-.501.012-.509.36a.459.459 0 0 1-.131.333c-.425.419-.936.751-1.36 1.171l-4.638 4.61c-.092.09-.201.12-.328.142-.309.051-.309.06-.35.303l-.028.186c-.203.07-.497.007-.508.359a.476.476 0 0 1-.133.335c-.425.419-.935.75-1.359 1.17-1.556 1.521-3.079 3.098-4.644 4.595-.093.087-.202.115-.33.133-.308.043-.309.052-.352.292l-.031.183c-.204.064-.498-.004-.513.344a.464.464 0 0 1-.136.329c-.428.41-.939.73-1.369 1.141-1.572 1.496-3.107 3.047-4.826 4.524-.102.088-.216.113-.348.128-.314.038-.318.044-.389.286l-.054.186c-.22.056-.513-.031-.571.324a.506.506 0 0 1-.184.331c-.527.375-1.104.667-1.667 1.004-2.017 1.278-4.401 2.184-6.727 2.511-.138.02-.253-.021-.376-.079-.241-.113-.293-.125-.405-.035v4.088c0 6.99-.255 16.16-7.101 18.364a41.558 41.558 0 0 0 1.891-.221c.736-.158 1.526-.22 2.287-.46z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "m50.434 323.631-.045.058c-.018 1.176-.141 2.358-.131 3.938h.001l.132 7.104.914.023h.251l.241-.008.221-.019.101-.015.092-.019.024-.005.027-.002.061.002.068.008.074.016.164.043.172.053.173.052.161.042.073.014.066.008h.059l.025-.003.023-.006.292-.074.34-.073.317-.054.128-.016.095-.004c.242.004.44.007.604.011l.4.019.266.024.198.027.198.027.266.024.4.02.604.012v.003c4.062.019 6.4-.079 10.764-.116a.962.962 0 0 1 .644.217c.17.137.387.204.58.307.195-.129.381-.272.578-.396.096-.058.209-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.767-.116a.962.962 0 0 1 .644.217c.17.137.387.204.58.307.195-.129.381-.272.578-.396.096-.058.209-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.944.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.958.958 0 0 1 .644.217c.171.137.386.204.581.307.194-.129.381-.272.578-.396.096-.058.207-.088.328-.144 1.774-.02 3.938.144 5.695.132v-.001l2.901-.13.282-.244.074-.072.064-.074.027-.037.023-.039.02-.039.014-.039.004-.011.006-.009.009-.009.011-.008.025-.013.033-.011.077-.017.087-.012.087-.012.076-.016.031-.011.024-.014.01-.008.008-.009.005-.01.003-.011.033-.137.048-.148.027-.069.027-.061.026-.047.013-.018.013-.013.183-.165.13-.101.095-.058.077-.037.076-.037.096-.059.13-.1.185-.165.002.001c2.705-2.619 4.188-4.205 7.055-7.062a.849.849 0 0 1 .578-.263c.209-.014.398-.105.6-.158.039-.218.062-.441.106-.657.024-.104.077-.198.117-.315 1.165-1.166 2.716-2.456 3.872-3.604 2.707-2.621 4.188-4.207 7.057-7.064a.849.849 0 0 1 .578-.263c.209-.014.398-.105.6-.158.039-.218.061-.441.105-.657.023-.104.077-.198.117-.315 1.165-1.166 2.716-2.456 3.873-3.604 2.706-2.622 4.188-4.208 7.056-7.065a.851.851 0 0 1 .579-.263c.208-.014.398-.105.599-.158.038-.218.062-.441.106-.657.023-.104.076-.197.117-.315 1.162-1.165 2.711-2.453 3.868-3.6l-.001-.001 2.021-2.16.027-.38.001-.104-.007-.1-.008-.047-.011-.045-.015-.042-.018-.039-.004-.01-.003-.012v-.012l.002-.013.009-.029.016-.03.044-.067.053-.071.053-.071.042-.066.015-.03.008-.028.001-.012v-.012l-.004-.012-.006-.009-.073-.122-.071-.143-.029-.068-.023-.063-.016-.054-.003-.021-.001-.018.014-.251.02-.166c.01-.044.019-.079.025-.11l.028-.082.028-.082.025-.109.021-.167.014-.252h.002c.045-2.969-.039-4.678-.047-7.868-.004-.184.065-.323.221-.469.137-.123.205-.28.31-.422-.128-.144-.271-.28-.392-.426-.057-.07-.087-.152-.143-.24-.008-1.299.169-2.881.168-4.166l-.069-7.039-.001-.123-.922-.023h-.253l-.243.008-.223.019-.102.015-.093.019-.024.005-.027.002-.062-.002-.069-.008-.074-.016a33.033 33.033 0 0 0-.165-.043l-.175-.053-.174-.052a21.683 21.683 0 0 0-.162-.042l-.074-.014-.066-.008h-.059l-.027.003-.023.006-.294.074-.343.073-.32.054-.129.016-.096.004c-.244-.004-.443-.007-.608-.011l-.404-.019-.269-.024-.199-.027-.199-.027-.268-.024-.404-.02-.609-.012v-.003c-4.039-.019-6.365.079-10.706.116a.95.95 0 0 1-.64-.217c-.17-.137-.385-.204-.578-.307-.193.129-.379.272-.575.396-.095.058-.206.088-.325.144-1.768.02-3.924-.144-5.672-.132-4.041-.019-6.367.079-10.709.116a.95.95 0 0 1-.64-.217c-.17-.137-.384-.204-.578-.307-.193.129-.378.272-.575.396-.095.058-.206.088-.325.144-1.768.02-3.923-.144-5.671-.132-4.041-.019-6.367.079-10.709.116a.952.952 0 0 1-.641-.217c-.17-.137-.384-.204-.578-.307-.193.129-.377.272-.574.396-.096.058-.207.088-.326.144-1.768.02-3.924-.144-5.671-.132-4.041-.019-6.366.079-10.708.116a.95.95 0 0 1-.641-.217c-.17-.137-.385-.204-.578-.307-.193.129-.378.272-.574.396-.096.058-.207.088-.326.144-1.768.02-3.924-.144-5.672-.132-4.041-.019-6.367.079-10.708.116a.952.952 0 0 1-.641-.217c-.169-.137-.384-.204-.577-.307-.193.129-.379.272-.575.396-.095.058-.207.088-.326.144-1.767.02-3.923-.144-5.671-.132-4.041-.019-6.367.079-10.709.116a.954.954 0 0 1-.641-.217c-.169-.137-.383-.204-.577-.307-.193.129-.378.272-.575.396-.095.058-.207.088-.326.144-1.767.02-3.923-.144-5.671-.132-4.041-.019-6.366.079-10.708.116a.952.952 0 0 1-.641-.217c-.17-.137-.385-.204-.578-.307-.193.129-.377.272-.574.396-.096.058-.207.088-.326.144-1.768.02-3.924-.144-5.672-.132-4.041-.019-6.366.079-10.708.116a.95.95 0 0 1-.64-.217c-.17-.137-.385-.204-.578-.307-.193.129-.379.272-.574.396-.096.058-.207.088-.326.144-1.766.02-3.919-.144-5.666-.132v.001l-3.459.13-.293.336-.075.096-.066.098-.028.048-.023.048-.018.048-.014.046-.004.013-.006.012-.01.012-.01.011-.027.021-.035.02-.082.036-.094.033-.093.033c-.028.014-.056.025-.081.036l-.033.02-.025.021-.01.012-.008.011-.006.012-.002.013a4.964 4.964 0 0 0-.029.158l-.045.175-.053.154a1.22 1.22 0 0 0-.026.059l-.013.022-.013.017-.189.225-.135.142-.099.086-.082.06-.08.059-.1.087-.136.141-.19.225-.002-.002c-2.346 2.958-3.611 4.729-6.088 7.944a.85.85 0 0 1-.54.337c-.205.041-.382.156-.574.236-.011.222-.004.445-.021.666-.01.105-.051.207-.075.328-1.005 1.312-2.377 2.797-3.376 4.09-2.348 2.959-3.612 4.73-6.089 7.945a.853.853 0 0 1-.54.337c-.205.04-.382.156-.574.235-.01.223-.004.446-.021.667-.011.105-.05.206-.075.328-1.005 1.312-2.377 2.797-3.377 4.089-2.347 2.96-3.611 4.73-6.088 7.945a.854.854 0 0 1-.541.338c-.205.04-.381.156-.574.235-.01.222-.004.446-.02.667-.01.105-.051.206-.076.328-1.004 1.312-2.377 2.797-3.376 4.089a204.485 204.485 0 0 0-2.995 3.877l-3.026 3.983c-.109.146-.251.217-.476.255-.196.029-.357.126-.543.196.021.182.066.357.091.525.009.08-.013.157-.013.248-.087.107-.178.223-.278.348zM137.143 108.987c-.155.186-.122.15.034-.039l-.034.039zM257.641 281.154c.955 0 1.823-.096 2.613-.276-2.428.254-3.757.276-2.613.276z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "M318.143 214.825c-.117.17-.232.342-.36.504-.346.484-.709.955-1.113 1.389-.395.452-.791.894-1.164 1.262-.09.091-.199.124-.326.147-.309.06-.309.067-.342.31l-.025.186c-.201.073-.498.019-.5.367a.468.468 0 0 1-.124.336c-.415.426-.919.767-1.335 1.193l-4.535 4.686c-.09.091-.198.124-.326.147-.307.058-.307.066-.342.31l-.024.185c-.202.073-.498.019-.501.368a.464.464 0 0 1-.124.336c-.415.426-.918.766-1.334 1.193-1.528 1.546-2.997 3.146-4.554 4.671-.092.09-.203.122-.332.144-.31.054-.311.062-.348.303l-.028.185c-.204.071-.501.012-.509.36a.459.459 0 0 1-.131.333c-.425.419-.936.751-1.36 1.171l-4.638 4.61c-.092.09-.201.12-.328.142-.309.051-.309.06-.35.303l-.028.186c-.203.07-.497.007-.508.359a.476.476 0 0 1-.133.335c-.425.419-.935.75-1.359 1.17-1.556 1.521-3.079 3.098-4.644 4.595-.093.087-.202.115-.33.133-.308.043-.309.052-.352.292l-.031.183c-.204.064-.498-.004-.513.344a.464.464 0 0 1-.136.329c-.428.41-.939.73-1.369 1.141-1.572 1.496-3.107 3.047-4.826 4.524-.102.088-.216.113-.348.128-.314.038-.318.044-.389.286l-.054.186c-.22.056-.513-.031-.571.324a.506.506 0 0 1-.184.331c-.527.375-1.104.667-1.667 1.004-2.017 1.278-4.401 2.184-6.727 2.511-.138.02-.253-.021-.376-.079-.241-.113-.293-.125-.405-.035-.026.021-.051.041-.087.073l-.145.133c-.219-.063-.422-.286-.66-.028a.492.492 0 0 1-.331.172c-.63.05-1.265-.018-1.88-.011-2.264.065-4.369.084-6.561.113-.128.001-.229-.053-.335-.127-.258-.177-.265-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.46.46 0 0 1-.325.148c-.595.007-1.19-.11-1.786-.104l-6.514.089c-.129.001-.229-.053-.336-.127-.257-.177-.264-.172-.459-.024l-.148.113c-.195-.092-.365-.341-.613-.096a.462.462 0 0 1-.326.148c-.594.007-1.189-.11-1.785-.104l-6.514.089c-.129.001-.229-.053-.336-.127-.258-.177-.264-.172-.459-.024l-.148.113c-.195-.092-.365-.341-.613-.096a.462.462 0 0 1-.326.148c-.595.007-1.189-.11-1.785-.104l-6.515.089c-.128.001-.228-.053-.335-.127-.258-.177-.264-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.46.46 0 0 1-.325.148c-.596.007-1.189-.11-1.785-.104l-6.515.089c-.128.001-.229-.053-.335-.127-.258-.177-.264-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.46.46 0 0 1-.325.148c-.596.007-1.19-.11-1.786-.104l-6.515.089a.56.56 0 0 1-.334-.127c-.258-.177-.265-.172-.461-.024l-.148.113c-.193-.092-.363-.341-.613-.096a.457.457 0 0 1-.324.148c-.596.007-1.19-.11-1.786-.104l-6.515.089c-.128.001-.229-.053-.335-.127-.257-.177-.264-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.458.458 0 0 1-.325.148c-.595.007-1.19-.11-1.786-.104l-6.514.089c-.128.001-.229-.053-.335-.127-.258-.177-.265-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.46.46 0 0 1-.326.148c-.594.007-1.189-.11-1.785-.104l-6.514.089c-.129.001-.229-.053-.336-.127-.257-.177-.264-.172-.459-.024l-.148.113c-.195-.092-.365-.341-.613-.096a.462.462 0 0 1-.326.148c-.595.007-1.189-.11-1.785-.104l-6.515.089c-.128.001-.228-.053-.335-.127-.258-.177-.264-.172-.459-.024l-.149.113c-.194-.092-.364-.341-.612-.096a.463.463 0 0 1-.326.148c-.595.007-1.189-.11-1.785-.104l-6.515.089c-.128.001-.229-.053-.335-.127-.258-.177-.264-.172-.46-.024l-.148.113c-.194-.092-.364-.341-.613-.096a.46.46 0 0 1-.325.148c-.596.007-1.189-.11-1.785-.104l-6.516.089c-.127.001-.228-.053-.334-.127-.258-.177-.264-.172-.461-.024l-.148.113c-.193-.092-.363-.341-.612-.096a.46.46 0 0 1-.325.148c-.069.001-.139-.01-.209-.013-.009.891-.016 1.764.003 2.553l.028 1.68.087 1.181c.014.754.192 1.447.348 2.148.04.271.118.537.206.804.145-.061.287-.115.422-.116 1.858-.011 3.672-.021 5.402-.029 1.11.007 2.24.015 3.378.021.237.003.428-.15.665-.15.238 0 .525.158.764.158l6.051.007c.414 0 .779.305 1.191.305.333 0 .714-.308 1.047-.312 1.859-.011 3.672-.021 5.402-.029 1.111.007 2.241.015 3.379.021.236.003.428-.15.665-.15.238 0 .524.158.763.158l6.051.007c.414 0 .78.305 1.191.305.334 0 .715-.308 1.049-.312 1.857-.011 3.671-.021 5.401-.029 1.11.007 2.241.015 3.378.021.236.003.428-.15.666-.15s.523.158.762.158l6.051.007c.414 0 .781.305 1.191.305.334 0 .715-.308 1.049-.312 1.857-.011 3.672-.021 5.402-.029 1.109.007 2.24.015 3.378.021.236.003.427-.15.665-.15s.524.158.763.158l6.051.007c.414 0 .78.305 1.191.305.333 0 .715-.308 1.048-.312 1.858-.011 3.672-.021 5.402-.029 1.111.007 2.24.015 3.379.021.236.003.427-.15.665-.15s.524.158.763.158l6.051.007c.414 0 .779.305 1.191.305.333 0 .715-.308 1.048-.312 1.858-.011 3.669-.021 5.399-.029l4.19-.049.045-.003.052-.007.119-.024.279-.074.279-.073c.044-.009.085-.018.121-.024l.053-.008.045-.003.092.002.086.005c.055.008.105.016.154.021l.141.031.133.035.133.035c.045.011.092.021.141.031l.156.021.086.005.094.001.771-.01c.723-.01 1.409-.019 2.038-.026l1.696.003.023.002.02.007.02.011.017.015.015.019.014.021.023.053.019.063.015.073.02.164.031.347.012.078.015.072.019.063.012.027.012.024.02.039.015.043.01.048.005.05.004.109-.002.115-.001.117.007.117.01.057.014.055.02.053.025.05-.094.136-.038.064-.032.062-.026.062-.021.059-.017.058-.012.056-.009.054-.005.054v.052l.002.051.014.098.021.096.062.187.067.185.029.095.024.098.015.101.005.105-.004.352-.008.176-.018.173-.003.015-.008.015-.018.028-.02.03-.009.015-.006.016-.038.127-.023.062-.025.062-.031.06-.037.058-.043.055-.049.052-.072.072-.055.071-.022.035-.019.035-.014.034-.012.035-.006.035-.003.035.001.036.004.036.01.035.012.037.016.037.02.037.25.445.076.153.052.127.018.058.013.058.009.058.005.061.002.136-.005.168-.006.172.001.173.004.346-.01.17-.009.085-.013.084-.02.083-.023.082-.029.082-.036.08-.011.025-.01.034-.022.098c-.013.076-.028.175-.048.287l-.045.376c-.014.136-.025.279-.039.423l-.024.43-.005.395.008.171c.004.053.01.103.014.146l.01.062.012.055.016.047.016.036.002.544h.002l-.043 2.482c-.004.115.061.217.105.322 1.234.047 2.504.111 3.56.066 1.15-.008 2.14-.067 3.075-.156a41.558 41.558 0 0 0 1.891-.221c.734-.152 1.524-.215 2.285-.454l1.217-.32c.396-.147.812-.303 1.256-.467.211-.067.363-.094.584-.026.187.059.383.036.582.052l.252-.564c.035-.094.094-.172.144-.272.278-.219.636-.374.911-.635.297-.252.578-.448.967-.811.729-.65 1.455-1.297 2.078-1.905 2.914-2.778 4.514-4.456 7.605-7.482a.908.908 0 0 1 .611-.279c.217-.016.418-.112.629-.169.053-.225.088-.454.146-.678.029-.105.09-.204.137-.325 1.27-1.212 2.943-2.555 4.203-3.748 2.938-2.728 4.574-4.367 7.676-7.348a.929.929 0 0 1 .607-.278c.217-.016.416-.112.626-.17.051-.226.085-.456.142-.68.029-.105.09-.204.137-.326 1.258-1.217 2.92-2.566 4.168-3.764 2.92-2.737 4.557-4.371 7.497-7.454a.92.92 0 0 1 .597-.296c.215-.022.411-.126.618-.189.042-.226.067-.455.115-.679.024-.106.08-.206.122-.329 1.208-1.248 2.816-2.643 4.018-3.874.729-.697 1.246-1.354 1.797-1.962.418-.613.942-1.153 1.212-1.768.157-.302.333-.594.489-.908l.364-1.04.199-.545c.053-.197.088-.412.136-.625l.292-1.354c.053-.215.146-.378.315-.544.154-.138.246-.329.37-.498l-.325-.597c-.045-.096-.062-.205-.104-.322.047-.413.107-.848.176-1.293l.13-1.401c.087-.942.193-1.879.217-2.73.036-1.981.048-3.534.034-5.14-.02-.465-.027-.936-.033-1.417zM297.42 290.933c-.206-.137-.467-.205-.702-.309-.236.128-.461.271-.7.393-.116.058-.252.088-.397.143-.453.003-.937-.006-1.424-.017l-.299.395c-.027.034-.09.026-.17.007-.192-.044-.189-.039-.119.105l.055.111c-.111-.007-.341-.121-.205.101.051.083.07.148.043.181-.124.16-.343.242-.467.402l-1.68-1.385-.029-.001 1.697 1.399-3.95 4.854-.024.009-.025.013-.057.037-.061.051-.062.062-.062.069-.062.074-.111.157-.025.039-.002.005-.002.002-.001.001.001.001.003.005.007.011.034.037.04.033.023.014.024.011.026.01.026.007.028.005.029.002.031-.001.032-.004.033-.007.034-.011.062-.016c.028-.006.062-.014.103-.021l.274-.05.277-.051.104-.021.065-.017.145.028.137.019.274.018.728.031.051.001.047-.003.046-.006.044-.008.082-.023.08-.028.158-.056.085-.02.045-.005.047-.003.935.016.937.037.937.037.938.016v3.502l-7.118.061-4.84.042-1.045.037-.682.005-.334-.013c-.107-.009-.211-.019-.311-.026l-.011-.004-.013-.009-.031-.032-.018-.022-.01-.014-.003-.003-.001-.002.002-.004.008-.013a7.81 7.81 0 0 1 .074-.124l.457-.776.709-.851.581-.655.583-.653.713-.848.195-.225.1-.102.1-.093.102-.085.102-.076.104-.067.104-.059.085-.046.074-.048.067-.05.06-.054.051-.059.043-.064.037-.071.03-.078.255-.656.107-.134 3.088-3.764.057-.063.064-.061.068-.059.072-.055.146-.098.141-.08.086-.047.076-.05.068-.052.061-.055.039-.047c-.378-.007-.761-.016-1.115-.016v.001l-3.414.12-.293.326-.076.094-.066.095-.028.048-.024.047-.019.047-.013.046-.004.012-.007.012-.009.011-.011.011-.027.021-.034.018-.083.034-.093.032-.01.003-.295.365-.029.109-.053.153a.695.695 0 0 0-.027.057l-.013.021-.013.017c-.076.088-.139.159-.189.219l-.136.138-.099.084-.082.057-.08.057a.639.639 0 0 1-.045.037 2394.7 2394.7 0 0 0-8.309 10.402 1.277 1.277 0 0 1-.648.457c-.232.072-.445.229-.67.344-.045.26-.071.521-.123.781-.026.124-.086.247-.132.393-1.308 1.65-3.049 3.548-4.349 5.176-3.039 3.735-4.703 5.953-7.925 10.002a1.284 1.284 0 0 1-.647.458c-.233.072-.446.229-.672.344-.044.261-.07.521-.121.781-.021.117-.1.263-.121.377-.301.382-.64.782-.99 1.189-.195.228-.392.455-.595.688l-.056 1.46-.018.715-.004.767h.001l.132 7.104.914.023h.251l.241-.008.221-.019.101-.015.092-.019.024-.005.027-.002.061.002.068.008.074.016.164.043.172.053.173.052.161.042.073.014.066.008h.059l.025-.003.023-.006.292-.074.34-.073.317-.054.128-.016.095-.004c.242.004.44.007.604.011l.4.019.266.024.198.027.198.027.266.024.4.02.604.012v.003c5.052.019 7.961-.079 13.39-.116.313-.004.552.063.801.217.213.137.48.204.723.307.242-.129.473-.272.719-.396.119-.058.26-.088.408-.144 2.208-.02 4.901.144 7.087.132v-.001l2.896-.13.283-.244.072-.07.065-.074.027-.038.024-.039.019-.038.014-.04.004-.011.007-.009.008-.009.011-.008.026-.013.031-.011.078-.016.088-.011.086-.012.076-.017.031-.011.024-.013.009-.008.008-.009.006-.01.003-.011.032-.137.049-.148.027-.069.027-.06.026-.047.013-.018.012-.013.184-.164.13-.101.095-.059c.027-.014.053-.025.076-.036l.076-.037.096-.058c.035-.027.076-.06.13-.1.05-.045.11-.099.185-.164l.002.002c2.498-2.41 3.859-3.877 6.504-6.508a.74.74 0 0 1 .545-.229c.199-.004.379-.085.569-.127.029-.209.042-.423.077-.628.02-.099.066-.188.101-.299 1.073-1.074 2.513-2.252 3.581-3.309 2.498-2.411 3.859-3.877 6.505-6.509a.744.744 0 0 1 .546-.229c.199-.005.378-.085.568-.128.029-.208.043-.422.078-.628.018-.098.065-.187.1-.298 1.074-1.073 2.512-2.25 3.578-3.308l2.053-2.185.023-.386v-.105l-.008-.102-.008-.048-.012-.046-.014-.042-.019-.039-.005-.01-.002-.012v-.013l.002-.013.008-.029.016-.031.043-.068.053-.073.053-.073.041-.067.014-.03.008-.028.001-.013-.001-.012-.003-.012-.006-.01-.075-.123-.072-.143-.03-.07-.024-.063-.014-.054-.004-.022-.001-.018c.004-.103.007-.186.011-.255l.019-.169.024-.111.027-.084.027-.083.024-.112.02-.169.012-.256h.003c.02-1.555-.079-2.45-.116-4.122-.004-.096.063-.169.217-.246.137-.065.204-.148.307-.223l-.396-.222c-.057-.036-.088-.079-.144-.125-.019-.679.143-1.507.132-2.179h-.001l-.124-6.632a65.213 65.213 0 0 0-.008-.45c-.238-.007-.575-.017-.911-.025l-.25-.001-.24.007-.22.019-.101.014-.092.019-.024.004-.027.003-.061-.002-.068-.01-.074-.015-.162-.044-.172-.053-.172-.053-.16-.043-.073-.014-.066-.008h-.058l-.026.003-.022.005-.291.074-.34.071-.316.054-.127.015-.096.004-.455-.01-3.143 3.749c-.152.178-.321.301-.523.342-.172.036-.26.101-.277.25l-.082.431-1.864 2.18c-.085.098-.243.155-.37.185-.172.039-.267.104-.277.255a.436.436 0 0 1-.182.338l-2.649-2.291 4.74-5.612c-3.692 0-6.407.065-10.864.082a1.283 1.283 0 0 1-.779-.213z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "M318.607 81.13c-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.324-.011-.863.022-1.86.083-2.86.062-.977.104-1.884.072-2.698-.051-1.854-.323-3.28-.807-4.457-.484-1.176-1.242-2.314-2.657-3.243-.155-.117-.263-.218-.322-.431-.052-.18-.177-.319-.273-.484-.204.045-.39.095-.587.153-.097.03-.195.032-.307.055-1.248-.549-3.232-.822-4.796-.884-4.009-.033-6.317.057-10.625.077a.938.938 0 0 1-.636-.219c-.168-.137-.381-.205-.572-.309-.192.129-.375.271-.57.394-.095.057-.205.088-.324.143-1.753.013-3.893-.158-5.627-.152-4.009-.033-6.316.057-10.625.077a.934.934 0 0 1-.635-.219c-.168-.137-.381-.205-.572-.309-.193.128-.376.271-.57.394-.096.057-.206.087-.324.143-1.754.013-3.893-.158-5.627-.152-4.01-.033-6.316.057-10.625.077a.932.932 0 0 1-.635-.219c-.169-.137-.381-.205-.574-.309-.191.128-.375.271-.569.394-.095.057-.206.087-.323.143-1.754.013-3.893-.158-5.627-.152-4.01-.033-6.317.057-10.625.077a.941.941 0 0 1-.636-.219c-.169-.138-.381-.205-.573-.309-.191.128-.375.271-.57.394-.094.057-.205.087-.323.143-1.753.013-3.893-.158-5.627-.152-4.01-.033-6.317.057-10.625.077a.939.939 0 0 1-.636-.22c-.168-.137-.381-.204-.572-.308-.192.128-.375.271-.57.394-.095.057-.205.087-.324.143-1.753.012-3.893-.158-5.627-.152-4.01-.034-6.316.056-10.625.077a.935.935 0 0 1-.635-.22c-.168-.137-.381-.205-.573-.308-.192.128-.375.271-.57.394-.095.057-.205.087-.323.143-1.754.012-3.893-.158-5.627-.152l-5.237.008c-1.647 0-3.324-.071-5.354-.037a.84.84 0 0 1-.598-.195c-.162-.131-.367-.193-.553-.286-.166.147-.325.29-.492.44-.081.064-.178.104-.278.168-1.561.146-3.379.507-4.769 1.223-1.609.781-2.789 1.676-3.947 2.656-1.176.965-2.269 2.084-3.786 3.642a.914.914 0 0 1-.599.294c-.213.021-.41.124-.617.187-.045.228-.073.46-.125.687-.026.107-.082.208-.127.331-1.221 1.253-2.84 2.65-4.053 3.885-2.835 2.822-4.389 4.523-7.395 7.595a.936.936 0 0 1-.602.297c-.216.023-.414.127-.623.191-.043.227-.068.456-.118.68-.026.107-.081.207-.125.33-1.228 1.242-2.82 2.682-4.021 3.932-2.803 2.867-4.336 4.594-7.305 7.714a.935.935 0 0 1-.598.306c-.215.025-.411.132-.619.198-.041.228-.064.46-.112.686-.024.107-.079.209-.122.332a59.282 59.282 0 0 1-2.006 1.983c-.313.302-.791.75-1.156 1.055-.386.33-.718.608-1.024.893-.56.503-1.013.975-1.423 1.443a13.13 13.13 0 0 0-1.533 2.127c-.718 1.236-1.279 2.622-1.785 4.535-.057.221-.176.367-.367.511-.165.122-.271.304-.409.459l.276.608c.037.098.047.204.078.322-.148.802-.299 1.709-.445 2.616-.098.92-.258 1.829-.248 2.669-.077 1.9-.031 3.521-.01 5.129l.078 5.424a.929.929 0 0 1-.216.636c-.136.168-.204.381-.307.573.13.191.272.375.396.57.058.094.088.205.144.323.02 1.753-.144 3.893-.132 5.627-.019 4.01.08 6.317.115 10.625a.926.926 0 0 1-.216.635c-.136.169-.204.382-.307.573.13.192.272.375.396.57.058.095.088.205.144.324.02 1.753-.144 3.893-.132 5.627-.019 4.009.08 6.316.116 10.625a.932.932 0 0 1-.217.635c-.136.168-.204.381-.307.573.13.192.272.375.396.57.058.095.088.205.144.323.02 1.754-.144 3.893-.132 5.627-.019 4.01.08 6.317.116 10.625a.935.935 0 0 1-.217.636c-.136.168-.204.381-.307.573.13.191.272.375.396.57.058.094.088.205.144.323.02 1.753-.144 3.893-.132 5.627-.019 4.01.08 6.317.116 10.625a.932.932 0 0 1-.217.635c-.136.169-.204.382-.307.573.13.192.272.375.396.57.058.095.088.205.144.324.02 1.753-.144 3.893-.132 5.627-.019 4.009.08 6.316.116 10.625a.932.932 0 0 1-.217.635c-.136.168-.204.381-.307.573.13.192.272.375.396.57.058.095.088.205.144.323.02 1.754-.144 3.893-.132 5.627-.019 4.01.08 6.317.116 10.625a.93.93 0 0 1-.217.635c-.136.169-.204.382-.307.574.13.191.272.375.396.57.058.094.088.205.144.323.008 1.808-.156 3.757.132 5.315.271 1.785.775 3.068 1.475 4.09.355.505.771.929 1.272 1.277.197.231.712.572 1.201.845a9.029 9.029 0 0 0 1.55.688c.25.078.394.169.494.293.081.105.246.175.37.241l.764-.136.09-.012c.015-.002.03-.005.046-.004l.012.001h.008l.458-.341.001.002.011.018.09.139c.02.125.046.252.069.376l4.249-.076c.196-.002.366.046.503.173.118.105.207.13.311.046l.318-.221 2.402-.015c.108 0 .231.083.32.16.118.104.211.133.312.042.104-.092.227-.115.314-.083l5.701-.103a.696.696 0 0 1 .503.173c.118.105.206.13.311.046l.317-.221 2.402-.015c.108 0 .232.083.32.16.119.104.212.133.312.042.104-.092.227-.115.314-.083l5.701-.103a.696.696 0 0 1 .503.173c.118.105.206.13.311.046l.317-.221 2.402-.015c.109 0 .232.083.32.16.119.104.212.133.312.042.104-.092.227-.115.314-.083l5.701-.103c.195-.002.367.046.504.173.117.105.205.13.311.046l.316-.221 2.403-.015c.108 0 .231.083.319.16.119.104.213.133.313.042.103-.092.226-.115.313-.083l5.701-.103c.196-.002.367.046.504.173.117.105.206.13.311.046l.317-.221 2.403-.015c.107 0 .23.083.319.16.118.104.212.133.313.042.102-.092.225-.115.312-.083l5.701-.103c.197-.002.367.046.504.173.117.105.206.13.311.046l.317-.221 2.403-.015c.107 0 .23.083.319.16.118.104.212.133.313.042.103-.092.226-.115.313-.083l5.701-.103c.196-.002.366.046.503.173.118.105.207.13.311.046l.318-.221 2.402-.015c.107 0 .231.083.32.16.118.104.211.133.312.042.103-.092.227-.115.313-.083l5.702-.103a.693.693 0 0 1 .502.173c.118.105.207.13.311.046l.318-.221 2.402-.015c.108 0 .231.083.32.16.118.104.211.133.312.042.104-.092.227-.115.314-.083l5.701-.103a.696.696 0 0 1 .503.173c.118.105.206.13.311.046l.317-.221 2.402-.015c.109 0 .232.083.32.16.119.104.212.133.312.042.104-.092.227-.115.314-.083l5.701-.103c.195-.002.367.046.504.173.117.105.205.13.31.046.101-.069.204-.142.317-.221l2.403-.015c.108 0 .231.083.319.16.119.104.213.133.313.042.103-.092.226-.115.313-.083l5.701-.103c.196-.002.367.046.504.173.117.105.205.13.311.046l.317-.221 2.402-.015c.108 0 .231.083.32.16.118.104.212.133.312.042.103-.092.226-.115.313-.083l5.701-.103c.196-.002.367.046.504.173.117.105.206.13.311.046l.317-.221 2.393-.02c.104-.002.222.078.309.154.114.101.206.128.302.036.097-.095.214-.12.299-.09 1.812-.068 3.59-.289 5.211-.745a.687.687 0 0 1 .227-.028.543.543 0 0 1 .25.07c.133.073.218.074.281-.031.062-.094.132-.184.197-.298l.969-.392.947-.463c.082-.049.217-.033.322-.007.143.035.231.017.264-.107.033-.127.115-.202.199-.216 1.443-.907 2.785-2.138 4.152-3.4a.676.676 0 0 1 .482-.2c.156.001.237-.042.256-.175.025-.117.053-.24.081-.375l1.733-1.641c.079-.074.226-.098.343-.102.157-.006.245-.048.257-.184.011-.137.085-.238.172-.275 1.354-1.322 2.772-2.649 4.1-3.991.139-.137.294-.22.478-.222.156-.004.236-.047.253-.182l.078-.382 1.711-1.675c.077-.076.223-.101.338-.105.156-.007.242-.05.254-.186.01-.139.082-.241.167-.278l4.013-4.024c.139-.137.294-.221.479-.225.158-.005.238-.049.255-.182l.074-.379 1.711-1.675c.077-.075.223-.102.34-.107.157-.008.244-.052.254-.187.01-.137.081-.239.166-.277l4.002-4.035c.137-.14.291-.227.477-.234.158-.008.238-.053.252-.188l.068-.381 1.682-1.712c.076-.077.223-.105.34-.113.156-.011.242-.056.25-.192.007-.138.077-.241.162-.281l3.945-4.11c.137-.14.291-.228.477-.235.158-.008.238-.054.252-.187l.066-.381 1.684-1.712c.076-.077.222-.105.339-.114.157-.011.243-.057.251-.191.006-.138.076-.242.161-.281l1.971-2.053.983-1.031.86-.977a.685.685 0 0 1 .431-.236c.146-.019.215-.068.207-.196v-.365c.45-.56.807-1.192 1.199-1.801.046-.086.17-.143.275-.176.141-.045.208-.107.172-.231-.037-.126-.006-.234.061-.29.767-1.537 1.275-3.207 1.546-4.907a.71.71 0 0 1 .073-.218c.031-.861.062-1.713.057-2.483.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.572-.129-.192-.272-.376-.396-.57-.057-.095-.088-.205-.144-.324-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.316-.116-10.625a.935.935 0 0 1 .217-.635c.137-.168.204-.381.307-.573-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.323-.019-1.754.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.573-.129-.191-.272-.375-.396-.57-.057-.094-.088-.205-.144-.323-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.572-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.324-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.316-.116-10.625a.937.937 0 0 1 .217-.635c.137-.168.204-.381.307-.573-.129-.192-.272-.375-.396-.57-.057-.095-.088-.205-.144-.323-.019-1.754.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.137-.168.204-.381.307-.573-.129-.191-.272-.375-.396-.57-.057-.094-.088-.205-.144-.323-.019-1.753.144-3.893.132-5.627.02-4.01-.079-6.317-.116-10.625a.94.94 0 0 1 .217-.636c.15-.162.217-.375.319-.566z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M353.417 228.207c-.3-1.785-.875-3.519-1.969-5.533-.267-.421-.502-.896-.814-1.34l-1.004-1.336c-.76-.822-1.541-1.668-2.407-2.209-.144-.034-.267-.083-.388-.099-.252-.028-.5-.027-.744-.041-.127-.204-.311-.361-.41-.572a1.146 1.146 0 0 0-.543-.528l-.808-.403-.798-.282c-.521-.173-1.01-.372-1.493-.49-.486-.103-.954-.2-1.411-.296a7.788 7.788 0 0 0-1.348-.205c-.889-.062-1.773-.206-2.693-.153-.924.013-1.904-.008-2.972.139l-1.464.138c-.504.053-1.008.156-1.521.231l-1.526.253c-.493.104-.962.246-1.409.373-.105.088-.211.149-.291.231-.164.175-.31.365-.466.544-.223-.043-.457-.047-.669-.128-.246-.09-.463-.103-.703-.004l-2.863 1.085c-.28.121-.541.242-.807.363l.015-1.862c-.004-.331-.312-.709-.312-1.04 0-.407.305-.771.305-1.182l.007-6.004c.001-.236.159-.52.158-.756.001-.236-.153-.426-.15-.66l.017-2.699c.005-.14.023-.277.024-.417a16.65 16.65 0 0 0-.024-1.22l-.024-4.377c-.004-.33-.312-.709-.312-1.039 0-.408.305-.771.305-1.183l.008-6.003c0-.236.158-.521.157-.757.001-.236-.153-.426-.15-.66l.021-3.353-.029-5.359c-.004-.331-.312-.709-.312-1.04 0-.407.305-.771.305-1.182l.007-6.004c.001-.236.159-.521.158-.757.001-.236-.153-.426-.15-.66l.021-3.352-.029-5.36c-.004-.331-.312-.709-.312-1.04 0-.407.305-.771.305-1.182l.007-6.004c.001-.236.159-.52.158-.756.001-.236-.153-.426-.15-.66l.021-3.353-.029-5.36c-.004-.33-.312-.709-.312-1.039 0-.408.305-.771.305-1.182l.007-6.004c.001-.236.159-.521.158-.757.001-.236-.153-.426-.15-.66l.021-3.353-.029-5.359c-.004-.331-.312-.709-.312-1.04 0-.407.305-.771.305-1.182l.007-6.004c.001-.236.159-.521.158-.757.001-.236-.153-.426-.15-.66l.021-3.352-.029-5.36c-.004-.331-.312-.709-.312-1.04 0-.407.305-.771.305-1.182l.007-6.004c.001-.236.159-.52.158-.756.001-.236-.153-.426-.15-.66l.021-3.353-.029-5.36c-.004-.33-.312-.709-.312-1.039 0-.408.305-.771.305-1.182l.007-6.004c.001-.236.158-.521.159-.756.002-.225-.148-.406-.143-.632.025-1.103.068-2.271.033-3.448-.09-1.838-.297-3.81-1.126-5.892-.174-.364-.644-.634-.81-.976-.197-.428-.223-.928-.49-1.348-1.367-1.955-3.572-3.334-5.82-3.953-.262-.081-.545-.354-.808-.385-.265-.048-.505.064-.763.017-1.256-.291-2.465-.27-3.669-.359l-5.36.01c-.33.003-.709.31-1.039.308-.408-.001-.771-.307-1.182-.309l-6.004-.029c-.236 0-.521-.16-.757-.16-.236-.001-.425.152-.66.148l-3.353-.034-5.359.01c-.33.003-.709.31-1.04.308-.407-.001-.771-.307-1.182-.309l-6.004-.029c-.236-.001-.521-.16-.757-.16-.236-.002-.425.151-.66.148l-3.352-.035-5.359.011c-.331.003-.709.31-1.041.308-.407-.001-.771-.307-1.182-.309l-6.004-.029c-.236-.001-.52-.16-.756-.161s-.426.152-.66.149l-3.352-.035-5.36.01c-.331.004-.709.311-1.04.309-.408-.001-.771-.308-1.182-.309l-6.004-.029c-.236-.001-.52-.16-.756-.161s-.426.152-.66.148l-3.353-.034-5.36.01c-.33.004-.709.31-1.039.309-.408-.002-.771-.308-1.182-.309l-6.004-.029c-.236-.001-.521-.16-.757-.161s-.425.152-.66.148l-3.353-.034-5.359.01c-.331.004-.709.31-1.04.309-.407-.002-.771-.308-1.182-.309l-6.004-.029c-.236-.001-.521-.16-.757-.161s-.425.152-.66.148l-3.352-.034c-1.703.005-3.549.021-5.32-.001-.326-.005-.707.292-1.034.283-.399-.01-.759-.328-1.169-.341-1.985-.058-4.123-.139-6.328.199-.258.045-.598-.076-.859-.016s-.435.259-.691.315c-.621.119-1.213.354-1.813.534-.575.238-1.165.453-1.708.727-1.717.841-3.307 1.976-4.801 3.217-.268.228-.377.715-.639.937-.311.285-.792.315-1.107.606-1.51 1.41-2.861 2.843-4.304 4.257-.167.168-.479.257-.646.425-.168.168-.193.412-.361.576l-2.386 2.366-3.769 3.828c-.23.238-.28.724-.514.959-.289.29-.762.333-1.053.625l-4.25 4.26c-.167.168-.48.259-.648.427-.164.17-.186.413-.352.58l-2.347 2.394-3.707 3.872c-.228.241-.27.728-.499.965-.284.293-.756.342-1.041.638l-4.182 4.31c-.164.17-.475.264-.639.434-.165.17-.186.412-.352.58-.396.404-.804.824-1.121 1.116l-1.24 1.097c-1.342 1.23-2.723 2.774-3.734 4.555-.178.325-.11.836-.284 1.149-.185.397-.626.629-.815 1.042-.858 2.006-1.384 4.114-1.74 6.198-.036.246-.234.52-.271.768-.035.249.089.466.052.711-.119 1.175-.252 2.347-.281 3.489-.051 1.809-.023 3.585-.021 5.431.005.331.312.709.312 1.04 0 .407-.305.771-.305 1.182l-.007 6.004c0 .236-.158.52-.158.756s.153.426.151.66c-.008 1.129-.016 2.25-.022 3.353l.029 5.359c.005.331.312.71.312 1.04 0 .408-.305.771-.305 1.182l-.007 6.004c0 .236-.158.521-.158.757s.153.426.15.66l-.021 3.353.029 5.359c.005.331.312.709.312 1.04 0 .407-.305.771-.305 1.182l-.007 6.004c0 .236-.158.521-.158.757s.153.425.15.66l-.021 3.352.029 5.36c.005.331.312.709.312 1.04 0 .407-.305.771-.305 1.182l-.007 6.004c0 .236-.158.52-.158.756s.153.426.15.66l-.021 3.353.029 5.359c.005.331.312.71.312 1.04 0 .408-.305.771-.305 1.182l-.007 6.004c0 .236-.158.521-.158.757s.153.425.15.66l-.021 3.353.029 5.359c.005.331.312.709.312 1.04 0 .407-.305.771-.305 1.182l-.007 6.004c0 .236-.158.521-.158.757s.153.425.15.66l-.021 3.352.029 5.359c.005.332.312.71.312 1.041 0 .407-.305.771-.305 1.182l-.007 6.004c0 .236-.158.52-.158.756-.001.236.161.449.161.694.006 1.196.096 2.402.277 3.601.311 1.847.873 3.871 2.172 5.75.233.339.771.507 1.044.795.335.358.472.895.904 1.214.132.104.252.182.371.257.116.074.257.17.329.203.172.101.354.185.535.266.369.153.756.264 1.15.331.394.065.795.089 1.193.07l.298-.021c.069-.025.062.04.059.09l-.001.15-.002.601c0 .188-.158.511-.158.698s.154.261.15.455l-.021 2.735.01 1.059c.008.376.059.948.09 1.42.051.493.038 1.002.148 1.494l.24 1.19-3.979-.005c-.238 0-.524-.158-.763-.158s-.429.153-.666.15l-3.378-.021-5.401.029c-.334.004-.715.312-1.049.312-.41 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.523-.158-.762-.158s-.43.153-.666.15l-3.379-.021-5.401.029c-.333.004-.714.312-1.048.312-.411 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.524-.158-.763-.158s-.429.153-.665.15l-3.379-.021v.002l-.262.006-.018.017-.022.016-.026.012-.03.012-.07.015a7.179 7.179 0 0 1-.083.009l-.092.002-.098-.003-.207-.021-.205-.034-.182-.043-.076-.022a.79.79 0 0 0-.062-.022c-.018-.008-.033-.016-.047-.021l-.017-.01-.012-.01-.039-.036-.04-.029-.039-.022-.041-.018-.04-.013-.04-.009-.083-.008-.166.007-.083.003-.084-.004c-.03-.002-.057-.004-.08-.004l-.066.002-.029.006-.027.01-.027.014-.028.018-.029.023-.032.029a3.748 3.748 0 0 1-.073.078c-.054.064-.122.146-.214.253l-.018.021-.018.016-.018.013-.018.009-.018.005-.017.002-.017-.003-.018-.006-.017-.011-.017-.015-.018-.018-.017-.021-.034-.055-.035-.071-.025-.049-.027-.042-.027-.036-.029-.03-.029-.027-.03-.021-.062-.037-.008-.006-.007-.008-.015-.02-.014-.019-.008-.007-.006-.003-.084-.017-.084-.006-.17-.001-.025.001-.025.004-.025.008-.023.009-.047.024-.045.031-.09.068-.045.033-.045.03-.045.022-.023.009-.024.005-.024.004-.025-.001-.025-.004-.025-.008-.027-.012-.027-.017-.029-.021-.029-.026-.03-.031-.031-.037-.065-.093-.024.026-.025.02-.026.014-.027.01-.027.006-.029.003-.057.001-.055-.002-.053.004-.024.006-.022.01-.021.016-.019.02-.012.013-.013.012-.031.019-.034.016-.038.012-.167.035-.079.021-.035.015-.016.009-.008.004-.002.002-.003-.002-.007-.004-.048-.023-.04-.014-.018-.002h-.014l-.012.004-.004.003-.004.004-.243.299c-.083.108-.171.224-.265.343-.18.244-.377.51-.586.79l-.221.299-.029.034-.029.03-.031.024-.031.021-.066.035-.067.028-.067.028-.066.034-.031.021-.031.025-.029.029-.029.033-.012.02-.01.023-.016.062c-.008.046-.018.099-.025.151-.01.053-.018.105-.025.151l-.016.061-.01.024-.012.019-1.209 1.618a5097.62 5097.62 0 0 1-3.094 3.99c-.189.248-.168.719-.359.964-.237.302-.688.384-.928.688l-3.498 4.445c-.137.175-.426.288-.563.463s-.126.41-.266.582l-1.967 2.471-3.095 3.99c-.188.248-.166.718-.359.964-.236.302-.688.383-.927.688l-3.497 4.445c-.139.175-.428.287-.564.463-.138.175-.127.41-.266.582l-1.967 2.471-3.094 3.99c-.189.248-.168.719-.36.963-.237.303-.688.384-.927.688a7967.445 7967.445 0 0 1-3.498 4.444c-.137.176-.427.288-.564.463-.137.176-.126.41-.266.583l-1.967 2.471-3.094 3.99c-.189.248-.167.718-.359.963-.237.303-.688.384-.928.688l-3.799 4.834-.003.171c0 .266-.158.543-.158.816s.153.522.15.787l-.021 3.496h.002l.006.539.017.036.016.046.012.054.012.062.016.145.008.17-.002.391-.02.427c-.013.143-.024.285-.035.42-.016.134-.029.261-.043.373l-.045.285c-.008.037-.016.069-.021.097l-.01.034-.01.024-.036.08-.028.081-.023.082-.018.083-.013.083-.009.084-.008.169.006.342.004.172-.004.171c-.002.062-.004.117-.004.166l.002.135.006.06.01.058.014.057.018.058.053.125.078.152.253.438.021.037.016.036.013.036.009.036.006.035v.035l-.002.035-.006.035-.011.034-.015.035-.018.034-.021.035-.055.071-.071.072-.049.052-.042.055-.036.058-.03.06-.027.061-.021.062-.037.126-.006.016-.008.015-.02.029-.019.029-.007.014-.003.015-.017.173-.006.174-.001.348.005.104.017.101.024.096.031.094.068.184.063.184.022.094.014.098.004.051-.001.051-.004.053-.008.054-.012.056-.017.057-.021.059-.026.061-.031.062-.037.064-.093.136.026.049.02.052.014.055.01.056.009.116.001.117-.002.114.004.107.006.05.01.047.016.043.02.038.013.024.012.027.019.062.016.07.012.079.035.343.021.162.014.072.02.063.023.053.014.021.015.019.017.015.02.011.02.007.022.002 1.682.003 2.021-.026.765-.01.092.001.086.005.154.021.141.031.131.035.132.035.139.031.153.021.086.005.091.002.045-.003.052-.008.119-.024.277-.073.277-.074.118-.024.052-.007.044-.003 4.154-.049 5.429-.029c.335-.004.719-.312 1.054-.312.413 0 .781.305 1.197.305l6.083.007c.24 0 .527.158.768.158.238 0 .431-.153.668-.15l3.396.021 5.432-.029c.335-.004.719-.312 1.054-.312.413 0 .781.305 1.197.305l6.083.007c.24 0 .527.158.768.158.238 0 .431-.153.668-.15l3.396.021 5.432-.029c.335-.004.719-.312 1.054-.312.413 0 .781.305 1.197.305l6.083.007c.24 0 .527.158.768.158.238 0 .43-.153.668-.15l3.396.021 5.432-.029c.335-.004.719-.312 1.053-.312.414 0 .782.305 1.198.305l6.083.007c.24 0 .527.158.767.158s.431-.153.669-.15l3.396.021 5.432-.029c.335-.004.718-.312 1.053-.312.414 0 .781.305 1.198.305l6.083.007c.24 0 .527.158.767.158s.431-.153.669-.15l3.396.021 5.432-.029c.334-.004.718-.312 1.053-.312.414 0 .781.305 1.197.305l6.084.007c.24 0 .527.158.767.158s.431-.153.669-.15l3.396.021 5.431-.029c.335-.004.719-.312 1.054-.312.414 0 .781.305 1.197.305l6.084.007c.24 0 .527.158.767.158s.431-.153.669-.15l3.396.021 5.431-.029c.335-.004.719-.312 1.054-.312.414 0 .781.305 1.197.305l6.084.007c.239 0 .527.158.766.158.24 0 .432-.153.67-.15l3.396.021v-.013l.22-.006.015-.017.019-.016.022-.012.025-.012.027-.008.031-.007.069-.009.077-.002.082.003.174.021.172.034.152.043.062.022.053.022.04.021.015.01.01.01.032.036.033.029.033.022.034.018.033.013.035.009.033.005.035.003.14-.007.069-.003.07.004c.025.002.047.004.067.004h.028l.027-.002.023-.006.023-.01.023-.014.023-.018.024-.023.026-.029.062-.078.179-.253.015-.021.016-.016.014-.013.016-.009.014-.005.015-.002.015.003.014.006.015.011.015.015.027.039.029.055.029.071.021.049.022.042.023.036.024.03.024.027.025.021.052.037.006.006.006.008.012.02.013.019.006.007.006.003.034.01.035.007.072.006.141.001.022-.001.021-.004.021-.008.02-.009.039-.024.039-.031.074-.068.037-.033.037-.03.039-.022.02-.009.021-.005.021-.004.021.001.021.004.022.008.022.012.022.017.024.021.024.026.053.068.055.093.02-.026.021-.02.021-.014.023-.01.023-.006.023-.003.049-.001.046.002.022-.001.021-.003.021-.006.019-.01.018-.016.016-.02.021-.024.025-.019.029-.016.031-.012.141-.035.066-.021.029-.015.013-.009.007-.004.001-.002.003.002.006.005.044.03.036.021.016.005.013.003.011-.001.004-.002.004-.003.236-.221.256-.258.57-.595.217-.226.027-.025.028-.021.029-.017.03-.013.062-.019.062-.012.063-.012.062-.018.031-.013.029-.017.028-.02.028-.025.01-.015.011-.021.018-.051.029-.132.029-.132.017-.052.01-.02.012-.015 1.178-1.221c1.146-1.134 2.348-2.322 3.578-3.541.22-.221.259-.689.48-.907.274-.268.731-.289 1.008-.559 1.337-1.306 2.692-2.628 4.038-3.94.159-.155.46-.229.618-.385.159-.154.179-.389.338-.541l2.268-2.188 3.58-3.543c.219-.221.258-.689.48-.907.273-.268.73-.289 1.007-.559 1.337-1.306 2.692-2.628 4.038-3.94.159-.155.46-.229.619-.385.158-.154.178-.389.338-.541.764-.736 1.521-1.469 2.268-2.188l3.58-3.543c.219-.221.258-.689.48-.907.273-.268.73-.289 1.006-.559l4.039-3.94c.158-.155.459-.229.618-.384s.179-.39.339-.542l2.267-2.188-.002-.002c.057-.058.103-.104.156-.16l-.001-.023.003-.023.007-.024.012-.026.032-.053.044-.056.055-.056.062-.057.141-.109.15-.097.141-.078.062-.029.054-.021a.938.938 0 0 0 .044-.013l.018-.003h.015l.049.003.043-.004.041-.007.037-.012.033-.015.031-.019.028-.021.026-.023.098-.104.049-.052.054-.047c.021-.017.037-.032.052-.046l.021-.021.018-.021.014-.021.01-.023.008-.025.004-.03.002-.034-.001-.039-.01-.101-.046-.309-.004-.024v-.022l.002-.02.004-.017.008-.014.01-.012.012-.008.015-.006.018-.003h.021l.022.003.025.005.06.019.071.03.05.02.045.015.043.009.039.005.036.001.034-.002.063-.011h.009l.01.001.022.006.021.005h.009l.006-.002.033-.018.029-.021.057-.045.104-.101.016-.017.012-.018.011-.02.009-.021.011-.045.007-.05.006-.103.004-.051.006-.047.013-.045.009-.02.01-.019.014-.017.016-.015.018-.013.021-.01.025-.008.027-.005.033-.002.035.001.086.013.105.026-.004-.033.002-.028.006-.026.01-.023.014-.021.016-.019.034-.035.034-.032.016-.017.014-.018.011-.019.007-.021.003-.022-.003-.026-.002-.016v-.016l.006-.032.01-.032.016-.031c.023-.039.052-.083.077-.124l.034-.062.011-.031.003-.016.002-.009v-.002h.004l.007-.001.053-.009.04-.012.016-.008.01-.007.008-.009.002-.004v-.006l.01-.328-.002-.37-.018-.841-.008-.317.001-.038.005-.035.01-.033.012-.031.031-.058.036-.055.036-.054.031-.058.012-.031.01-.032.006-.036.002-.038-.002-.019-.008-.021-.023-.05a6.235 6.235 0 0 1-.073-.115l-.073-.116-.023-.05-.008-.021-.002-.018-.033-1.729.005-3.968c-.003-.245-.308-.528-.306-.772.003-.303.31-.568.312-.873l.013-1.263c.13-.044.257-.1.401-.098 1.13.006 2.237.021 3.389-.009a47.42 47.42 0 0 0 5.562-.428c.348-.059.693-.424 1.035-.479.422-.059.859.174 1.296.055 2.079-.425 4.269-1.237 6.188-2.619.237-.141.574-.267.794-.446.215-.188.279-.451.486-.634l2.431-2.305c1.226-1.192 2.509-2.442 3.825-3.724.234-.231.293-.714.53-.943.293-.282.765-.312 1.06-.597a201.004 201.004 0 0 1 4.348-4.119c.172-.162.488-.24.66-.401.173-.161.205-.402.379-.561l2.463-2.272 3.895-3.68c.238-.229.305-.712.547-.938.297-.278.771-.304 1.07-.584l4.377-4.123c.172-.163.487-.243.659-.406.173-.163.204-.404.377-.564.827-.771 1.647-1.539 2.454-2.293l3.881-3.713c.236-.233.301-.709.537-.945.288-.291.758-.334 1.049-.628l4.263-4.302c.167-.169.483-.263.65-.433.168-.17.19-.411.359-.578l2.393-2.39c.61-.598 1.204-1.318 1.819-2.009.59-.788 1.264-1.532 1.752-2.499.186-.338.131-.854.301-1.179.162-.419.59-.684.755-1.123l.295-.794c.092-.266.131-.529.198-.794l.364-1.592c.211-1.058.289-2.089.438-3.133.027-.244.232-.528.238-.769.014-.243-.128-.449-.111-.688.059-.952.115-1.894.172-2.828l.178-.079c.293-.135.509-.566.807-.698.367-.162.809-.028 1.177-.187l2.733-1c.92-.306 1.859-.534 2.783-.805.219-.07.52.02.74-.017.22-.043.363-.228.584-.269l1.579-.304c.524-.073 1.046-.107 1.562-.162.401-.036.81-.116 1.218-.12l1.237-.015c.84-.056 1.661.089 2.505.156.305.009.689-.212.989-.142.369.083.622.452.982.53 1.711.491 3.337 1.258 4.691 2.351.151.141.222.432.366.568.146.139.371.14.52.281.666.709 1.264 1.483 1.715 2.332.74 1.292 1.326 2.8 1.549 4.45.045.291.443.585.441.896.021.38-.264.731-.242 1.102.024 1.807-.133 3.68-.66 5.476-.053.215-.261.43-.32.64-.07.208.019.42-.055.628-.182.497-.333 1.001-.53 1.487l-.643 1.431c-.31.746-.755 1.456-1.137 2.21-.429.731-.924 1.444-1.392 2.184-.189.251-.164.72-.359.973-.241.312-.693.398-.932.708-.595.738-1.27 1.425-1.902 2.144-.701.659-1.391 1.333-2.107 1.972-.177.145-.49.196-.666.339-.176.144-.218.377-.395.518-.824.708-1.728 1.308-2.604 1.91-.658.504-1.398.927-2.137 1.378l-2.329 1.411c-.291.181-.47.646-.762.821-.358.217-.837.148-1.201.367-.867.549-1.788 1.023-2.626 1.638l-2.545 1.787c-.199.142-.533.184-.733.325s-.269.378-.468.516c-.941.691-1.817 1.46-2.713 2.169-.671.586-1.407 1.126-2.066 1.782l-2.04 1.966c-.245.241-.311.729-.558.966-.312.281-.773.361-1.062.676l-2.088 2.313c-.71.764-1.31 1.626-1.969 2.432-.15.193-.459.331-.611.525-.151.194-.149.441-.302.633-.693.949-1.333 1.93-1.991 2.872-.518.73-.926 1.56-1.41 2.358-.232.404-.469.812-.707 1.224l-.647 1.281c-.152.312-.055.801-.209 1.107-.188.378-.646.581-.808.98a77.235 77.235 0 0 0-1.058 2.514c-.425-.061-.822-.283-1.263-.285l-7.359-.031c-.29-.001-.637-.16-.927-.161s-.522.152-.81.148l-4.109-.035-.002.002-.257.005-.018.018-.022.015-.025.013-.029.01-.07.016a5.191 5.191 0 0 1-.082.009l-.09.001-.098-.003c-.066-.007-.135-.015-.204-.021l-.201-.036-.179-.043-.075-.022a.592.592 0 0 0-.062-.022.435.435 0 0 0-.047-.021l-.016-.011-.012-.01-.039-.036-.039-.029-.039-.022-.039-.018-.04-.013-.04-.009-.082-.008-.164.005-.082.003-.082-.004-.08-.005-.064.004-.028.005-.028.009-.026.014-.028.018-.028.023-.032.029-.072.078-.211.252-.018.021-.018.017-.018.012-.018.009-.018.005-.017.002-.017-.003-.017-.007-.017-.01-.017-.015-.017-.018-.018-.021-.033-.056-.035-.07-.023-.05-.027-.042-.027-.036-.027-.03-.029-.027-.03-.021-.061-.037-.007-.006-.008-.008-.014-.021-.014-.018-.008-.007-.006-.004-.083-.016-.083-.007-.168-.001h-.025l-.024.004-.024.008-.023.009-.047.024-.045.03-.088.069-.043.033-.045.029-.045.022-.023.009-.023.006-.025.002h-.023l-.025-.004-.026-.008-.026-.012-.027-.017-.027-.021-.029-.026-.03-.031-.03-.037a2.914 2.914 0 0 1-.065-.093l-.023.025-.024.021-.026.014-.027.01-.027.006-.028.002h-.057l-.055-.001-.051.004-.024.006-.022.01-.021.015-.019.02-.012.014-.014.011-.029.02-.034.015-.038.013-.164.034-.078.021-.035.015-.016.009-.008.005-.002.001-.002-.002-.007-.003-.048-.025-.04-.014-.017-.003h-.014l-.012.003-.004.004-.004.004-.244.291-.266.335-.589.771-.223.293-.028.033-.029.029-.031.023-.032.021-.065.032-.067.027-.067.026-.066.033-.031.02-.031.023-.029.028-.029.034-.012.018-.01.024-.017.06-.026.15-.025.149-.018.06-.01.023-.011.019c-.44.573-.856 1.116-1.216 1.583l-4.02 5.025c-.246.312-.291.858-.541 1.168-.308.381-.818.529-1.129.913l-4.535 5.606c-.178.221-.516.387-.693.607-.179.221-.201.494-.381.712l-2.546 3.119.066.054c-1.45 1.757-3.179 3.838-4.087 4.974-.246.312-.293.858-.542 1.168-.308.381-.819.529-1.129.913l-4.678 5.783c-.213.264-.612.506-.831.777s-.246.55-.461.812l-.297.366-.021 4.288h.002l.006.539.017.036.016.046.012.054.012.062.016.145.008.17-.002.391-.02.427c-.013.143-.024.285-.035.42-.016.134-.029.261-.043.373l-.045.285c-.008.037-.016.069-.021.097l-.01.034-.01.024-.036.08-.028.081-.023.082-.018.083-.013.083-.009.084-.008.169.006.342.004.172-.004.171c-.002.062-.004.117-.004.166l.002.135.006.06.01.058.014.057.018.058.053.125.078.152.253.438.021.037.016.036.013.036.009.036.006.035v.035l-.002.035-.006.035-.011.034-.015.035-.018.034-.021.035-.055.071-.071.072-.049.052-.042.055-.036.058-.03.06-.027.061-.021.062-.037.126-.006.016-.008.015-.02.029-.019.029-.007.014-.003.015-.017.173-.006.174-.001.348.005.104.017.101.024.096.031.094.068.184.063.184.022.094.014.098.004.051-.001.051-.004.053-.008.054-.012.056-.017.057-.021.059-.026.061-.031.062-.037.064-.093.136.026.049.02.052.014.055.01.056.009.116.001.117-.002.114.004.107.006.05.01.047.016.043.02.038.013.024.012.027.019.062.016.07.012.079.035.343.021.162.014.072.02.063.023.053.014.021.015.019.017.015.02.011.02.007.022.002 1.682.003 2.021-.026.765-.01.092.001.086.005.154.021.141.031.131.035.132.035.139.031.153.021.086.005.091.002.045-.003.052-.008.119-.024.277-.073.277-.074.118-.024.052-.007.044-.003 4.154-.049 6.753-.029c.418-.004.895-.312 1.312-.312.515 0 .972.305 1.489.305l7.568.007c.297 0 .655.158.953.158s.536-.153.832-.15l4.226.021v.013l.22-.006.014-.017.02-.016.021-.012.025-.012.027-.008.031-.007.069-.009.077-.002.082.003.174.021.171.034.151.043.064.022.052.022c.016.008.028.016.04.021l.014.01.01.01.033.036.032.029.034.022.033.018.033.013.035.009.033.005.035.003.139-.007.07-.003.069.004c.025.002.048.004.067.004h.029l.025-.002.025-.006.023-.01.022-.014.023-.018.024-.023.027-.029.061-.078.18-.253.015-.021.015-.016.015-.013.015-.009.015-.005.015-.002.014.003.014.006.015.011.015.015.028.039.028.055.029.071.021.049.022.042.023.036.024.03.024.027.025.021.052.037.006.006.006.008.012.02.012.019.006.007.006.003.035.01.035.007.07.006.143.001.021-.001.021-.004.02-.008.021-.009.04-.024.037-.031.074-.068.037-.033.038-.03.038-.022.02-.009.021-.005.021-.004.021.001.021.004.021.008.022.012.022.017.024.021.024.026.053.068.055.093.02-.026.021-.02.021-.014.023-.01.023-.006.023-.003.048-.001.046.002.023-.001.021-.003.02-.006.02-.01.018-.016.016-.02.021-.024.025-.019.028-.016.033-.012c.043-.012.093-.023.139-.035l.066-.021.029-.015.014-.009.006-.004.002-.002.002.002.007.005.044.031.035.021.016.006.014.002.01-.001.004-.002.004-.003.236-.22.256-.257.57-.593.217-.225.027-.026.027-.02.03-.017.03-.013.062-.019.063-.012.062-.012.062-.018.029-.013.03-.016.028-.021.027-.024.012-.016.01-.02.018-.052c.01-.04.02-.086.029-.132l.029-.131.018-.052.01-.02.012-.015 1.176-1.215 3.301-3.263c.202-.204.222-.652.427-.853.253-.246.69-.248.945-.497l3.728-3.626c.146-.143.433-.201.579-.344s.156-.367.304-.508l2.094-2.011 3.302-3.263c.202-.203.222-.652.427-.852.253-.247.691-.249.945-.497l3.727-3.626c.146-.143.434-.201.58-.344s.156-.367.304-.508l2.093-2.012-.001-.001.159-.163-.002-.022.004-.024.008-.024.011-.026.033-.054.045-.056.056-.058.063-.057.144-.11.15-.1.143-.079a1.078 1.078 0 0 1 .161-.064l.018-.003h.015l.049.002.045-.003.041-.008.037-.012.033-.016.031-.019.029-.021.027-.023.1-.104.049-.053.055-.047.053-.046.021-.021.018-.021.014-.021.011-.023.008-.025.005-.03.002-.034-.001-.041-.009-.1-.045-.311-.002-.025-.001-.022.003-.02.004-.017.008-.015.01-.011.012-.009.016-.005.018-.004h.02l.023.003.025.005.061.019.07.03.051.02.045.014.043.009.039.005h.037l.034-.002.063-.011h.01l.01.001.022.006.021.004.009.001.006-.002.033-.019.031-.021.057-.047.105-.102.016-.017.012-.018.011-.021.009-.021.012-.047.007-.049.007-.104.004-.051.008-.049.012-.044.01-.021.011-.018.013-.018.016-.015.02-.013.021-.01.024-.008.028-.006.033-.002.036.001.086.012.106.026-.004-.033.002-.029.006-.026.011-.022.013-.021.016-.02.035-.035.035-.032.017-.017.014-.018.011-.02.008-.021.002-.023-.002-.025-.002-.017v-.016l.006-.032.011-.032.015-.031.08-.126.033-.063.012-.031.004-.016.002-.008v-.002l.004-.001.007-.001.053-.01.04-.013.015-.007.011-.008.007-.009.001-.005.001-.004.007-.334-.004-.375c-.008-.264-.018-.55-.025-.853l-.011-.322.001-.038.005-.037.009-.033.012-.031.031-.059.035-.056.035-.056.031-.059.012-.031.01-.033.006-.036.001-.038-.003-.02-.008-.021-.024-.051-.073-.117-.074-.116-.024-.05-.007-.021-.003-.019-.049-1.753-.029-2.078c-.004-.128-.312-.275-.312-.403 0-.158.305-.3.305-.459l.007-2.331c.001-.092.159-.201.158-.293.001-.092-.153-.165-.15-.257l.021-1.301h-.002l-.006-.537-.017-.036-.016-.045-.012-.055-.012-.062-.016-.145-.008-.169.002-.391.02-.424c.013-.143.024-.285.035-.419.016-.134.029-.261.043-.372l.045-.284c.008-.037.016-.069.021-.097l.01-.034.01-.024.036-.08.028-.08.023-.082.018-.082.013-.084.009-.083.008-.169-.006-.341-.004-.171.004-.17c.002-.062.004-.117.004-.166l-.002-.134-.006-.06-.01-.058-.014-.056-.018-.058-.053-.126a44.588 44.588 0 0 1-.078-.15l-.253-.438-.021-.037-.016-.036-.013-.036-.009-.035-.006-.035v-.035l.002-.035.006-.035.011-.034.015-.035.018-.034.021-.035.055-.07.071-.072.049-.052.042-.055.036-.058.03-.059.027-.061.021-.062.037-.126.006-.015.008-.016.02-.029.019-.029.007-.014.003-.014.017-.172.006-.174.001-.347-.005-.104-.017-.1-.024-.096-.031-.094-.068-.183-.063-.183-.022-.095-.014-.097-.004-.051.001-.051.004-.053.008-.053.012-.056.017-.057.021-.059.026-.061.031-.062.037-.064.093-.136-.026-.049-.02-.052-.014-.054-.01-.056-.009-.115-.001-.117.002-.114-.004-.106-.006-.051-.01-.046-.016-.043-.02-.038-.013-.024-.012-.026-.019-.062-.016-.071-.012-.078c-.012-.107-.023-.229-.035-.342a7.333 7.333 0 0 1-.021-.162l-.014-.071-.02-.063-.022-.053-.014-.021-.015-.019-.018-.015-.018-.011-.021-.007-.021-.003-1.677-.008-2.015.02-.762.008-.092-.001-.086-.006-.154-.021-.139-.031-.131-.035-.131-.037-.139-.031-.153-.021-.085-.006-.091-.002-.045.003-.052.007a3.099 3.099 0 0 1-.119.024l-.276.073c-.096.025-.191.051-.276.072-.043.009-.082.018-.118.024l-.051.007-.044.003-4.142.035-3.804.005c.418-.998.826-1.894 1.256-2.749l.519-1.06.6-1.052c.427-.706.813-1.493 1.382-2.291a64.173 64.173 0 0 1 1.592-2.229c.579-.749 1.218-1.456 1.729-2.142.027-.125.07-.229.082-.338.014-.235.025-.459.037-.69.196-.084.377-.206.582-.249.24-.052.422-.14.579-.324 1.409-1.561 2.414-2.834 3.581-3.91 1.129-1.111 2.199-2.234 3.762-3.44.653-.546 1.411-1.122 2.168-1.699.787-.54 1.6-1.048 2.295-1.558.062-.111.133-.2.176-.301l.234-.648c.213-.025.423-.092.635-.074a.897.897 0 0 0 .632-.182c1.75-1.19 3.171-1.997 4.511-2.861.702-.434 1.396-.863 2.135-1.318.756-.473 1.584-.922 2.438-1.551 1.51-1.022 3.391-2.299 4.754-3.575.055-.128.119-.231.152-.342.066-.232.107-.47.165-.702.218-.064.427-.17.651-.196.26-.034.453-.126.642-.312.761-.859 1.45-1.605 2.044-2.338.564-.76 1.101-1.449 1.596-2.156l1.401-2.223c.414-.811.922-1.629 1.366-2.613.364-.861.859-1.783 1.2-2.785.181-.496.39-.982.534-1.479.136-.501.262-.991.369-1.459-.023-.138-.025-.262-.058-.373-.064-.229-.173-.453-.272-.682.131-.187.23-.403.392-.564.183-.19.28-.389.314-.66.224-2.337.152-4.201-.202-5.985zm-216.274-119.22.034-.039c-.156.19-.19.225-.034.039zm-86.51 213.52c.186-.07.347-.167.543-.196.225-.038.366-.108.476-.255l3.026-3.983a207.739 207.739 0 0 1 2.995-3.877c.999-1.292 2.372-2.777 3.376-4.089.025-.122.066-.223.076-.328.016-.221.01-.445.02-.667.193-.079.369-.195.574-.235.236-.053.4-.15.541-.338 2.477-3.215 3.742-4.985 6.088-7.945 1-1.292 2.372-2.777 3.377-4.089.025-.122.064-.223.075-.328.017-.221.011-.444.021-.667.192-.079.369-.195.574-.235a.853.853 0 0 0 .54-.337c2.477-3.215 3.741-4.986 6.089-7.945.999-1.293 2.371-2.778 3.376-4.09.024-.121.065-.223.075-.328.017-.221.01-.444.021-.666.192-.08.369-.195.574-.236a.85.85 0 0 0 .54-.337c2.477-3.216 3.742-4.986 6.088-7.944l.002.002.19-.225.136-.141.1-.087.08-.059.082-.06.099-.086.135-.142.189-.225.013-.017.013-.022.026-.059c.016-.046.033-.099.053-.154l.045-.175.029-.158.002-.013.006-.012.008-.011.01-.012.025-.021.033-.02c.025-.011.053-.022.081-.036l.093-.033.094-.033.082-.036.035-.02.027-.021.01-.011.01-.012.006-.012.004-.013.014-.046.018-.048.023-.048.028-.048.066-.098.075-.096.293-.336 3.459-.13v-.001c1.747-.012 3.9.151 5.666.132.119-.056.23-.086.326-.144.195-.123.381-.267.574-.396.193.103.408.17.578.307.199.153.39.221.64.217 4.342-.037 6.667-.135 10.708-.116 1.748-.012 3.904.151 5.672.132.119-.056.23-.086.326-.144.197-.123.381-.267.574-.396.193.103.408.17.578.307a.956.956 0 0 0 .641.217c4.342-.037 6.667-.135 10.708-.116 1.748-.012 3.904.151 5.671.132.119-.056.231-.086.326-.144.197-.123.382-.267.575-.396.194.103.408.17.577.307.2.153.391.221.641.217 4.342-.037 6.668-.135 10.709-.116 1.748-.012 3.904.151 5.671.132.119-.056.231-.086.326-.144.196-.123.382-.267.575-.396.193.103.408.17.577.307.2.153.39.221.641.217 4.341-.037 6.667-.135 10.708-.116 1.748-.012 3.904.151 5.672.132.119-.056.23-.086.326-.144.196-.123.381-.267.574-.396.193.103.408.17.578.307.199.153.39.221.641.217 4.342-.037 6.667-.135 10.708-.116 1.747-.012 3.903.151 5.671.132.119-.056.23-.086.326-.144.197-.123.381-.267.574-.396.194.103.408.17.578.307a.956.956 0 0 0 .641.217c4.342-.037 6.668-.135 10.709-.116 1.748-.012 3.903.151 5.671.132.119-.056.23-.086.325-.144.197-.123.382-.267.575-.396.194.103.408.17.578.307.199.153.39.221.64.217 4.342-.037 6.668-.135 10.709-.116 1.748-.012 3.904.151 5.672.132.119-.056.23-.086.325-.144.196-.123.382-.267.575-.396.193.103.408.17.578.307.199.153.39.221.64.217 4.341-.037 6.667-.135 10.706-.116v.003l.609.012.404.02.268.024c.074.011.137.02.199.027l.199.027.269.024.404.019c.165.004.364.007.608.011l.096-.004.129-.016.32-.054.343-.073.294-.074.023-.006.027-.003h.059l.066.008.074.014.162.042.174.052.175.053.165.043.074.016.069.008.062.002.027-.002.024-.005.093-.019.102-.015.223-.019.243-.008h.253l.922.023.001.123.069 7.039c.001 1.285-.176 2.867-.168 4.166.056.088.086.17.143.24.121.146.264.282.392.426-.104.142-.173.299-.31.422-.155.146-.225.285-.221.469.008 3.19.092 4.899.047 7.868h-.002l-.014.252c-.01.067-.016.122-.021.167a2.368 2.368 0 0 0-.025.109l-.028.082-.028.082-.025.11-.02.166-.014.251.001.018.003.021.016.054.023.063.029.068.071.143c.028.045.054.088.073.122l.006.009.004.012v.012l-.001.012-.008.028-.015.03-.042.066-.053.071-.053.071-.044.067-.016.03-.009.029-.002.013v.012l.003.012.004.01.018.039.015.042.011.045.008.047.007.1-.001.104-.027.38-2.021 2.16.001.001c-1.157 1.146-2.706 2.435-3.868 3.6-.041.118-.094.212-.117.315-.045.216-.068.439-.106.657-.2.053-.391.145-.599.158a.851.851 0 0 0-.579.263c-2.868 2.857-4.35 4.443-7.056 7.065-1.157 1.147-2.708 2.438-3.873 3.604-.04.117-.094.212-.117.315-.045.216-.066.439-.105.657-.201.053-.391.145-.6.158a.849.849 0 0 0-.578.263c-2.869 2.857-4.35 4.443-7.057 7.064-1.156 1.148-2.707 2.438-3.872 3.604-.04.117-.093.212-.117.315-.045.216-.067.439-.106.657-.201.053-.391.145-.6.158a.849.849 0 0 0-.578.263c-2.867 2.857-4.35 4.443-7.055 7.062l-.002-.001-.185.165a8.069 8.069 0 0 0-.13.1l-.096.059-.076.037-.077.037-.095.058-.13.101-.183.165-.013.013-.013.018-.026.047-.027.061-.027.069-.048.148-.033.137-.003.011-.005.01-.008.009-.01.008-.024.014-.031.011-.076.016-.087.012-.087.012-.077.017-.033.011-.025.013-.011.008-.009.009-.006.009-.004.011-.014.039-.02.039-.023.039-.027.037-.064.074-.074.072-.282.244-2.901.13v.001c-1.757.012-3.921-.151-5.695-.132-.121.056-.232.086-.328.144-.197.123-.384.267-.578.396-.195-.103-.41-.17-.581-.307a.962.962 0 0 0-.644-.217c-4.365.037-6.703.135-10.766.116-1.758.012-3.925-.151-5.701-.132-.12.056-.232.086-.328.144-.197.123-.383.267-.578.396-.194-.103-.41-.17-.58-.307a.966.966 0 0 0-.645-.217c-4.365.037-6.703.135-10.766.116-1.758.012-3.925-.151-5.701-.132-.12.056-.232.086-.328.144-.197.123-.383.267-.578.396-.194-.103-.41-.17-.58-.307a.966.966 0 0 0-.645-.217c-4.365.037-6.703.135-10.766.116-1.758.012-3.925-.151-5.701-.132-.12.056-.232.086-.328.144-.197.123-.383.267-.578.396-.194-.103-.41-.17-.58-.307a.966.966 0 0 0-.645-.217c-4.365.037-6.703.135-10.766.116-1.757.012-3.925-.151-5.701-.132-.12.056-.232.086-.328.144-.197.123-.383.267-.578.396-.194-.103-.41-.17-.58-.307a.966.966 0 0 0-.645-.217c-4.364.037-6.703.135-10.766.116-1.757.012-3.924-.151-5.701-.132-.12.056-.232.086-.328.144-.197.123-.383.267-.578.396-.194-.103-.41-.17-.58-.307a.966.966 0 0 0-.645-.217c-4.364.037-6.703.135-10.766.116-1.757.012-3.924-.151-5.701-.132-.119.056-.232.086-.328.144-.197.123-.383.267-.578.396-.193-.103-.41-.17-.58-.307a.965.965 0 0 0-.644-.217c-4.365.037-6.704.135-10.767.116-1.757.012-3.924-.151-5.701-.132-.119.056-.232.086-.328.144-.197.123-.383.267-.578.396-.193-.103-.41-.17-.58-.307a.965.965 0 0 0-.644-.217c-4.364.037-6.703.135-10.764.116v-.003l-.604-.012-.4-.02-.266-.024a5.364 5.364 0 0 0-.198-.027 8.941 8.941 0 0 0-.198-.027 20.419 20.419 0 0 0-.266-.024l-.4-.019c-.163-.004-.361-.007-.604-.011l-.095.004-.128.016-.317.054-.34.073-.292.074-.023.006-.025.003h-.059l-.066-.008-.073-.014-.161-.042-.173-.052-.172-.053-.164-.043-.074-.016-.068-.008-.061-.002-.027.002-.024.005-.092.019-.101.015-.221.019-.241.008h-.251l-.914-.023-.132-7.104h-.001c-.01-1.58.113-2.763.131-3.938l.045-.058c.1-.125.191-.241.277-.351 0-.091.021-.168.013-.248-.023-.165-.068-.341-.09-.522zm207.008-41.353c-1.144 0 .186-.022 2.613-.276a11.68 11.68 0 0 1-2.613.276zm60.488-59.773c-.023.852-.13 1.788-.217 2.73l-.13 1.401c-.068.445-.129.88-.176 1.293.041.117.059.227.104.322.111.203.217.396.325.597-.124.169-.216.36-.37.498-.17.166-.263.329-.315.544l-.292 1.354c-.048.213-.083.428-.136.625l-.199.545-.364 1.04c-.156.314-.332.606-.489.908-.27.614-.794 1.154-1.212 1.768-.551.608-1.068 1.265-1.797 1.962-1.201 1.231-2.81 2.626-4.018 3.874-.042.123-.098.223-.122.329-.048.224-.073.453-.115.679-.207.063-.403.167-.618.189a.92.92 0 0 0-.597.296c-2.94 3.083-4.577 4.717-7.497 7.454-1.248 1.197-2.91 2.547-4.168 3.764-.047.122-.107.221-.137.326-.057.224-.091.454-.142.68-.21.058-.409.154-.626.17a.927.927 0 0 0-.607.278c-3.102 2.98-4.737 4.62-7.676 7.348-1.26 1.193-2.934 2.536-4.203 3.748-.047.121-.107.22-.137.325-.059.224-.094.453-.146.678-.211.057-.412.153-.629.169a.91.91 0 0 0-.611.279c-3.092 3.026-4.691 4.704-7.605 7.482-.623.608-1.35 1.255-2.078 1.905-.389.362-.67.559-.967.811-.275.261-.633.416-.911.635-.05.101-.108.179-.144.272l-.252.564c-.199-.016-.396.007-.582-.052-.221-.067-.373-.041-.584.026l-1.256.467-1.217.32c-.761.239-1.551.302-2.285.454-.618.087-1.243.16-1.891.221-.936.089-1.925.148-3.075.156-1.056.045-2.325-.02-3.56-.066-.045-.105-.109-.207-.105-.322l.043-2.482h-.002l-.002-.544-.016-.036-.016-.047-.012-.055-.01-.062-.014-.146a7.107 7.107 0 0 1-.008-.171l.005-.395c.008-.14.017-.284.024-.43.014-.144.025-.287.039-.423l.045-.376c.02-.112.035-.211.048-.287.009-.038.017-.071.022-.098l.01-.034.011-.025.036-.08.029-.082.023-.082.02-.083.013-.084.009-.085.01-.17-.004-.346-.001-.173.006-.172.005-.168-.002-.136-.005-.061-.009-.058-.013-.058-.018-.058-.052-.127a7.05 7.05 0 0 0-.076-.153l-.25-.445-.02-.037-.016-.037-.012-.037-.01-.035-.004-.036-.001-.036.003-.035.006-.035.012-.035.014-.034.019-.035.022-.035.055-.071.072-.072.049-.052.043-.055.037-.058.031-.06.025-.062.023-.062.038-.127.006-.016.009-.015.02-.03.018-.028.008-.015.003-.015.018-.173.008-.176.004-.352-.005-.105-.015-.101-.024-.098-.029-.095-.067-.185-.062-.187-.021-.096-.014-.098-.002-.051v-.052l.005-.054.009-.054.012-.056.017-.058.021-.059.026-.062.032-.062.038-.064.094-.136-.025-.05-.02-.053-.014-.055-.01-.057-.007-.117.001-.117.002-.115-.004-.109-.005-.05-.01-.048-.015-.043-.02-.039-.012-.024-.012-.027-.019-.063-.015-.072-.012-.078-.031-.347-.02-.164-.015-.073-.019-.063-.023-.053-.014-.021-.015-.019-.017-.015-.02-.011-.02-.007-.023-.002-1.696-.003-2.038.026-.771.01-.094-.001-.086-.005-.156-.021-.141-.031-.133-.035-.133-.035-.141-.031-.154-.021-.086-.005-.092-.002-.045.003-.053.008-.121.024-.279.073-.279.074a8.502 8.502 0 0 1-.119.024l-.052.007-.045.003-4.19.049-5.399.029c-.333.004-.715.312-1.048.312-.412 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.524-.158-.763-.158s-.429.153-.665.15l-3.379-.021-5.402.029c-.333.004-.715.312-1.048.312-.411 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.524-.158-.763-.158s-.429.153-.665.15l-3.378-.021-5.402.029c-.334.004-.715.312-1.049.312-.41 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.523-.158-.762-.158s-.43.153-.666.15l-3.378-.021-5.401.029c-.334.004-.715.312-1.049.312-.411 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.524-.158-.763-.158-.237 0-.429.153-.665.15l-3.379-.021-5.402.029c-.333.004-.714.312-1.047.312-.412 0-.777-.305-1.191-.305l-6.051-.007c-.238 0-.525-.158-.764-.158-.237 0-.428.153-.665.15l-3.378-.021-5.402.029c-.135.001-.277.056-.422.116a4.819 4.819 0 0 1-.206-.804c-.155-.701-.334-1.395-.348-2.148l-.087-1.181c-.01-.534-.019-1.092-.028-1.68a77.198 77.198 0 0 1-.003-2.553c.07.003.14.014.209.013a.463.463 0 0 0 .325-.148c.249-.245.419.004.612.096l.148-.113c.197-.147.203-.152.461.024.106.074.207.128.334.127l6.516-.089c.596-.007 1.189.11 1.785.104a.463.463 0 0 0 .325-.148c.249-.245.419.004.613.096l.148-.113c.196-.147.202-.152.46.024.106.074.207.128.335.127l6.515-.089c.596-.007 1.19.11 1.785.104a.468.468 0 0 0 .326-.148c.248-.245.418.004.612.096l.149-.113c.195-.147.201-.152.459.024.107.074.207.128.335.127l6.515-.089c.596-.007 1.19.11 1.785.104a.466.466 0 0 0 .326-.148c.248-.245.418.004.613.096l.148-.113c.195-.147.202-.152.459.024.107.074.207.128.336.127l6.514-.089c.596-.007 1.191.11 1.785.104a.464.464 0 0 0 .326-.148c.249-.245.419.004.613.096l.148-.113c.195-.147.202-.152.46.024.106.074.207.128.335.127l6.514-.089c.596-.007 1.191.11 1.786.104a.462.462 0 0 0 .325-.148c.249-.245.419.004.613.096l.148-.113c.196-.147.203-.152.46.024.106.074.207.128.335.127l6.515-.089c.596-.007 1.19.11 1.786.104a.461.461 0 0 0 .324-.148c.25-.245.42.004.613.096l.148-.113c.196-.147.203-.152.461.024a.56.56 0 0 0 .334.127l6.515-.089c.596-.007 1.19.11 1.786.104a.463.463 0 0 0 .325-.148c.249-.245.419.004.613.096l.148-.113c.196-.147.202-.152.46.024.106.074.207.128.335.127l6.515-.089c.596-.007 1.189.11 1.785.104a.463.463 0 0 0 .325-.148c.249-.245.419.004.613.096l.148-.113c.196-.147.202-.152.46.024.107.074.207.128.335.127l6.515-.089c.596-.007 1.19.11 1.785.104a.466.466 0 0 0 .326-.148c.248-.245.418.004.613.096l.148-.113c.195-.147.201-.152.459.024.107.074.207.128.336.127l6.514-.089c.596-.007 1.191.11 1.785.104a.466.466 0 0 0 .326-.148c.248-.245.418.004.613.096l.148-.113c.195-.147.202-.152.459.024.107.074.207.128.336.127l6.514-.089c.596-.007 1.191.11 1.786.104a.463.463 0 0 0 .325-.148c.249-.245.419.004.613.096l.148-.113c.195-.147.202-.152.46.024.106.074.207.128.335.127 2.191-.029 4.297-.048 6.561-.113.615-.007 1.25.061 1.88.011a.492.492 0 0 0 .331-.172c.238-.258.441-.035.66.028l.145-.133a1.54 1.54 0 0 1 .087-.073c.112-.09.164-.078.405.035.123.059.238.099.376.079 2.325-.327 4.71-1.232 6.727-2.511.563-.337 1.14-.629 1.667-1.004a.51.51 0 0 0 .184-.331c.059-.355.352-.269.571-.324l.054-.186c.07-.242.074-.248.389-.286.132-.015.246-.04.348-.128 1.719-1.478 3.254-3.028 4.826-4.524.43-.41.941-.73 1.369-1.141a.464.464 0 0 0 .136-.329c.015-.348.309-.279.513-.344l.031-.183c.043-.24.044-.249.352-.292.128-.018.237-.046.33-.133 1.564-1.497 3.088-3.074 4.644-4.595.425-.42.935-.751 1.359-1.17a.476.476 0 0 0 .133-.335c.011-.353.305-.289.508-.359l.028-.186c.041-.243.041-.252.35-.303.127-.021.236-.052.328-.142l4.638-4.61c.425-.42.936-.752 1.36-1.171a.459.459 0 0 0 .131-.333c.008-.349.305-.289.509-.36l.028-.185c.037-.24.038-.249.348-.303a.574.574 0 0 0 .332-.144c1.557-1.524 3.025-3.125 4.554-4.671.416-.428.919-.768 1.334-1.193a.464.464 0 0 0 .124-.336c.003-.35.299-.295.501-.368l.024-.185c.035-.243.035-.252.342-.31a.57.57 0 0 0 .326-.147l4.535-4.686c.416-.427.92-.768 1.335-1.193a.468.468 0 0 0 .124-.336c.002-.349.299-.294.5-.367l.025-.186c.033-.242.033-.25.342-.31a.573.573 0 0 0 .326-.147c.373-.368.77-.81 1.164-1.262.404-.434.768-.904 1.113-1.389.128-.162.243-.334.36-.504l.021 1.416a145.45 145.45 0 0 1-.022 5.141zm.071-128.418c.012 1.734-.15 3.874-.132 5.627.056.118.087.229.144.323.123.195.267.379.396.57-.103.192-.17.405-.307.573a.945.945 0 0 0-.217.636c.037 4.308.136 6.615.116 10.625.012 1.734-.15 3.873-.132 5.627.056.118.087.229.144.323.123.195.267.378.396.57-.103.192-.17.405-.307.573a.942.942 0 0 0-.217.635c.037 4.309.136 6.615.116 10.625.012 1.734-.15 3.874-.132 5.627.056.119.087.229.144.324.123.195.267.378.396.57-.103.191-.17.404-.307.572a.945.945 0 0 0-.217.636c.037 4.308.136 6.615.116 10.625.012 1.734-.15 3.874-.132 5.627.056.118.087.229.144.323.123.195.267.379.396.57-.103.192-.17.405-.307.573a.945.945 0 0 0-.217.636c.037 4.308.136 6.615.116 10.625.012 1.734-.15 3.873-.132 5.627.056.118.087.229.144.323.123.195.267.378.396.57-.103.192-.17.405-.307.573a.94.94 0 0 0-.217.635c.037 4.309.136 6.615.116 10.625.012 1.734-.15 3.874-.132 5.627.056.119.087.229.144.324.123.194.267.378.396.57-.103.191-.17.404-.307.572a.945.945 0 0 0-.217.636c.037 4.308.136 6.615.116 10.625a57.2 57.2 0 0 1-.057 2.483.676.676 0 0 0-.073.218c-.271 1.7-.779 3.37-1.546 4.907-.066.056-.098.164-.061.29.036.124-.031.187-.172.231-.105.033-.229.09-.275.176-.393.608-.749 1.241-1.199 1.801v.365c.008.128-.061.178-.207.196a.688.688 0 0 0-.431.236l-.86.977-.983 1.035-1.971 2.053c-.085.039-.155.144-.161.281-.008.135-.094.181-.251.191-.117.009-.263.037-.339.114l-1.684 1.712-.066.381c-.014.133-.094.179-.252.187-.186.008-.34.096-.477.235l-3.945 4.11c-.085.04-.155.144-.162.281-.008.137-.094.182-.25.192-.117.008-.264.036-.34.113l-1.682 1.712-.068.381c-.014.135-.094.18-.252.188-.186.008-.34.095-.477.234l-4.002 4.035c-.085.038-.156.141-.166.277-.01.135-.097.179-.254.187-.117.006-.263.032-.34.107l-1.711 1.675-.074.379c-.017.133-.097.177-.255.182-.186.004-.341.088-.479.225l-4.013 4.024c-.085.037-.157.14-.167.278-.012.136-.098.179-.254.186-.115.005-.261.029-.338.105l-1.711 1.675a30.83 30.83 0 0 1-.078.382c-.017.135-.097.178-.253.182-.184.002-.339.085-.478.222-1.327 1.342-2.746 2.669-4.1 3.991-.087.037-.161.139-.172.275-.012.136-.1.178-.257.184-.117.004-.264.027-.343.102l-1.733 1.641c-.028.135-.056.258-.081.375-.019.133-.1.176-.256.175a.672.672 0 0 0-.482.2c-1.367 1.263-2.709 2.493-4.152 3.4-.084.014-.166.089-.199.216-.032.124-.121.143-.264.107-.105-.026-.24-.042-.322.007l-.947.463-.969.392c-.065.114-.135.204-.197.298-.063.105-.148.104-.281.031a.543.543 0 0 0-.25-.07.693.693 0 0 0-.227.028c-1.621.456-3.398.677-5.211.745-.085-.03-.202-.005-.299.09-.096.092-.188.064-.302-.036-.087-.076-.205-.156-.309-.154l-2.393.02-.317.221c-.104.084-.193.06-.311-.046-.137-.127-.308-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.313.083-.101.091-.194.062-.312-.042-.089-.077-.212-.16-.32-.16l-2.402.015-.317.221c-.105.084-.193.06-.311-.046-.137-.127-.308-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.313.083-.101.091-.194.062-.313-.042-.088-.077-.211-.16-.319-.16l-2.403.015-.317.221c-.104.084-.192.06-.31-.046-.137-.127-.309-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.314.083-.101.091-.193.062-.312-.042-.088-.077-.211-.16-.32-.16l-2.402.015-.317.221c-.104.084-.192.06-.311-.046a.696.696 0 0 0-.503-.173l-5.701.103c-.088-.032-.211-.009-.314.083-.102.091-.194.062-.312-.042-.089-.077-.212-.16-.32-.16l-2.402.015-.318.221c-.104.084-.192.06-.311-.046a.693.693 0 0 0-.502-.173l-5.702.103c-.087-.032-.211-.009-.313.083-.102.091-.194.062-.312-.042-.089-.077-.213-.16-.32-.16l-2.402.015-.318.221c-.104.084-.192.06-.311-.046-.137-.127-.307-.175-.503-.173l-5.701.103c-.088-.032-.211-.009-.313.083-.102.091-.195.062-.313-.042-.089-.077-.212-.16-.319-.16l-2.403.015-.317.221c-.104.084-.193.06-.311-.046-.137-.127-.307-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.312.083-.102.091-.195.062-.313-.042-.089-.077-.212-.16-.319-.16l-2.403.015-.317.221c-.104.084-.193.06-.311-.046-.137-.127-.308-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.313.083-.101.091-.194.062-.313-.042-.088-.077-.211-.16-.319-.16l-2.403.015-.316.221c-.105.084-.193.06-.311-.046-.137-.127-.309-.175-.504-.173l-5.701.103c-.088-.032-.211-.009-.314.083-.101.091-.193.062-.312-.042-.088-.077-.211-.16-.32-.16l-2.402.015-.317.221c-.104.084-.192.06-.311-.046a.696.696 0 0 0-.503-.173l-5.701.103c-.088-.032-.211-.009-.314.083-.101.091-.193.062-.312-.042-.088-.077-.212-.16-.32-.16l-2.402.015-.317.221c-.104.084-.192.06-.311-.046a.696.696 0 0 0-.503-.173l-5.701.103c-.088-.032-.211-.009-.314.083-.102.091-.194.062-.312-.042-.089-.077-.212-.16-.32-.16l-2.402.015-.318.221c-.104.084-.192.06-.311-.046-.137-.127-.307-.175-.503-.173l-4.249.076c-.023-.124-.05-.251-.069-.376l-.09-.139-.011-.018-.001-.002-.458.341h-.008l-.012-.001c-.016-.001-.031.002-.046.004l-.09.012-.764.136c-.124-.066-.289-.136-.37-.241-.101-.124-.244-.215-.494-.293a9.107 9.107 0 0 1-1.55-.688c-.489-.272-1.004-.613-1.201-.845a5.111 5.111 0 0 1-1.272-1.277c-.699-1.021-1.204-2.305-1.475-4.09-.288-1.559-.124-3.508-.132-5.315-.056-.118-.086-.229-.144-.323-.123-.195-.266-.379-.396-.57.103-.192.171-.405.307-.574a.935.935 0 0 0 .217-.635c-.036-4.308-.135-6.615-.116-10.625-.012-1.734.151-3.873.132-5.627-.056-.118-.086-.229-.144-.323-.123-.195-.266-.378-.396-.57.103-.192.171-.405.307-.573a.937.937 0 0 0 .217-.635c-.036-4.309-.135-6.616-.116-10.625-.012-1.734.151-3.874.132-5.627-.056-.119-.086-.229-.144-.324-.123-.195-.266-.378-.396-.57.103-.191.171-.404.307-.573a.937.937 0 0 0 .217-.635c-.036-4.308-.135-6.615-.116-10.625-.012-1.734.151-3.874.132-5.627-.056-.118-.086-.229-.144-.323-.123-.195-.266-.379-.396-.57.103-.192.171-.405.307-.573a.94.94 0 0 0 .217-.636c-.036-4.308-.135-6.615-.116-10.625-.012-1.734.151-3.873.132-5.627-.056-.118-.086-.229-.144-.323-.123-.195-.266-.378-.396-.57.103-.192.171-.405.307-.573a.937.937 0 0 0 .217-.635c-.036-4.309-.135-6.616-.116-10.625-.012-1.734.151-3.874.132-5.627-.056-.119-.086-.229-.144-.324-.123-.195-.266-.378-.396-.57.103-.191.171-.404.307-.573a.931.931 0 0 0 .216-.635c-.035-4.308-.134-6.615-.115-10.625-.012-1.734.151-3.874.132-5.627-.056-.118-.086-.229-.144-.323-.123-.195-.266-.379-.396-.57.103-.192.171-.405.307-.573a.934.934 0 0 0 .216-.636l-.078-5.424c-.021-1.608-.067-3.229.01-5.129-.01-.84.15-1.749.248-2.669.146-.907.297-1.814.445-2.616-.031-.118-.041-.225-.078-.322l-.276-.608c.138-.155.244-.337.409-.459.191-.144.311-.29.367-.511.506-1.913 1.067-3.299 1.785-4.535.43-.745.923-1.43 1.533-2.127.41-.469.863-.94 1.423-1.443.307-.284.639-.562 1.024-.893a24.86 24.86 0 0 0 1.156-1.055 61.228 61.228 0 0 0 2.006-1.983c.043-.123.098-.225.122-.332.048-.226.071-.458.112-.686.208-.066.404-.173.619-.198a.935.935 0 0 0 .598-.306c2.969-3.12 4.502-4.847 7.305-7.714 1.2-1.25 2.793-2.689 4.021-3.932.044-.123.099-.223.125-.33.05-.224.075-.453.118-.68.209-.064.407-.168.623-.191a.936.936 0 0 0 .602-.297c3.006-3.071 4.56-4.772 7.395-7.595 1.213-1.234 2.832-2.632 4.053-3.885.045-.123.101-.224.127-.331.052-.227.08-.459.125-.687.207-.062.404-.165.617-.187a.914.914 0 0 0 .599-.294c1.518-1.558 2.61-2.677 3.786-3.642 1.158-.98 2.338-1.875 3.947-2.656 1.39-.716 3.208-1.076 4.769-1.223.101-.064.197-.104.278-.168.167-.15.326-.293.492-.44.186.093.391.155.553.286a.837.837 0 0 0 .598.195c2.03-.034 3.707.037 5.354.037l5.237-.008c1.734-.006 3.873.164 5.627.152.118-.056.229-.086.323-.143.195-.123.378-.266.57-.394.192.103.405.171.573.308a.94.94 0 0 0 .635.22c4.309-.021 6.615-.111 10.625-.077 1.734-.006 3.874.164 5.627.152.119-.056.229-.086.324-.143.195-.123.378-.266.57-.394.191.104.404.171.572.308a.944.944 0 0 0 .636.22c4.308-.021 6.615-.11 10.625-.077 1.734-.006 3.874.165 5.627.152.118-.056.229-.086.323-.143.195-.122.379-.266.57-.394.192.104.404.171.573.309a.946.946 0 0 0 .636.219c4.308-.021 6.615-.11 10.625-.077 1.734-.006 3.873.165 5.627.152.117-.056.229-.086.323-.143.194-.122.378-.266.569-.394.193.104.405.172.574.309a.937.937 0 0 0 .635.219c4.309-.021 6.615-.11 10.625-.077 1.734-.006 3.873.165 5.627.152.118-.056.229-.086.324-.143.194-.122.377-.266.57-.394.191.104.404.172.572.309a.939.939 0 0 0 .635.219c4.309-.021 6.616-.11 10.625-.077 1.734-.006 3.874.165 5.627.152.119-.055.229-.086.324-.143.195-.122.378-.265.57-.394.191.104.404.172.572.309a.943.943 0 0 0 .636.219c4.308-.021 6.616-.11 10.625-.077 1.563.062 3.548.335 4.796.884.111-.022.21-.024.307-.055.197-.059.383-.108.587-.153.097.165.222.305.273.484.06.213.167.313.322.431 1.415.929 2.173 2.067 2.657 3.243.483 1.177.756 2.604.807 4.457.031.814-.01 1.722-.072 2.698-.061 1-.094 1.997-.083 2.86.056.119.087.229.144.324.123.195.267.378.396.57-.103.191-.17.404-.307.572a.945.945 0 0 0-.217.636c.025 4.298.124 6.605.104 10.615zm-9.138 198.106-4.74 5.612 2.649 2.291a.436.436 0 0 0 .182-.338c.011-.151.105-.216.277-.255.127-.029.285-.087.37-.185l1.864-2.18.082-.431c.018-.149.105-.214.277-.25.202-.041.371-.164.523-.342l3.143-3.749.455.01.096-.004.127-.015.316-.054.34-.071.291-.074.022-.005.026-.003h.058l.066.008.073.014.16.043.172.053.172.053.162.044.074.015.068.01.061.002.027-.003.024-.004.092-.019.101-.014.22-.019.24-.007.25.001.911.025.008.45.124 6.632h.001c.011.672-.15 1.5-.132 2.179.056.046.087.089.144.125l.396.222c-.103.074-.17.157-.307.223-.153.077-.221.15-.217.246.037 1.672.136 2.567.116 4.122h-.003l-.012.256-.02.169c-.01.045-.019.081-.024.112-.01.03-.02.057-.027.083a1.694 1.694 0 0 0-.027.084l-.024.111-.019.169c-.004.069-.007.152-.011.255l.001.018.004.022.014.054.024.063.03.07.072.143.075.123.006.01.003.012.001.012-.001.013-.008.028-.014.03-.041.067-.053.073-.053.073-.043.068-.016.031-.008.029-.002.013v.013l.002.012.005.01.019.039.014.042.012.046.008.048.008.102v.105c-.009.142-.018.284-.023.386l-2.053 2.185c-1.066 1.058-2.504 2.234-3.578 3.308-.034.111-.082.2-.1.298-.035.206-.049.42-.078.628-.19.043-.369.123-.568.128a.742.742 0 0 0-.546.229c-2.646 2.632-4.007 4.098-6.505 6.509-1.068 1.057-2.508 2.234-3.581 3.309-.034.111-.081.2-.101.299-.035.205-.048.419-.077.628-.19.042-.37.123-.569.127a.746.746 0 0 0-.545.229c-2.645 2.631-4.006 4.098-6.504 6.508l-.002-.002-.185.164a4.28 4.28 0 0 0-.13.1l-.096.058-.076.037c-.023.011-.049.022-.076.036l-.095.059-.13.101-.184.164-.012.013-.013.018-.026.047-.027.06-.027.069-.049.148-.032.137-.003.011-.006.01-.008.009-.009.008-.024.013-.031.011-.076.017-.086.012-.088.011-.078.016-.031.011-.026.013-.011.008-.008.009-.007.009-.004.011-.014.04-.019.038-.024.039-.027.038-.065.074-.072.07-.283.244-2.896.13v.001c-2.186.012-4.879-.151-7.087-.132-.148.056-.289.086-.408.144-.246.123-.477.267-.719.396-.242-.103-.51-.17-.723-.307a1.393 1.393 0 0 0-.801-.217c-5.429.037-8.338.135-13.39.116v-.003l-.604-.012-.4-.02-.266-.024a5.364 5.364 0 0 0-.198-.027 8.941 8.941 0 0 0-.198-.027 20.419 20.419 0 0 0-.266-.024l-.4-.019c-.163-.004-.361-.007-.604-.011l-.095.004-.128.016-.317.054-.34.073-.292.074-.023.006-.025.003h-.059l-.066-.008-.073-.014-.161-.042-.173-.052-.172-.053-.164-.043-.074-.016-.068-.008-.061-.002-.027.002-.024.005-.092.019-.101.015-.221.019-.241.008h-.251l-.914-.023-.132-7.104h-.001l.004-.767.018-.715.056-1.46c.203-.232.399-.46.595-.688.351-.407.689-.808.99-1.189.021-.114.1-.26.121-.377.051-.26.077-.521.121-.781.226-.115.438-.271.672-.344.269-.089.463-.223.647-.458 3.222-4.049 4.886-6.267 7.925-10.002 1.3-1.628 3.041-3.525 4.349-5.176.046-.146.105-.269.132-.393.052-.26.078-.521.123-.781.225-.115.438-.271.67-.344.27-.088.465-.223.648-.457a2394.7 2394.7 0 0 1 8.309-10.402.639.639 0 0 0 .045-.037l.08-.057.082-.057.099-.084.136-.138.189-.219.013-.017.013-.021a13.9 13.9 0 0 1 .027-.057l.053-.153.029-.109.295-.365.01-.003.093-.032.083-.034.034-.018.027-.021.011-.011.009-.011.007-.012.004-.012.013-.046.019-.047.024-.047.028-.048.066-.095.076-.094.293-.326 3.414-.12v-.001c.354 0 .737.009 1.115.016l-.039.047-.061.055-.068.052-.076.05-.086.047-.141.08-.146.098-.072.055-.068.059-.064.061-.057.063c-1.035 1.262-2.066 2.52-3.088 3.764l-.107.134-.255.656-.03.078-.037.071-.043.064-.051.059-.06.054-.067.05-.074.048-.085.046-.104.059-.104.067-.102.076-.102.085-.1.093-.1.102-.195.225-.713.848-.583.653-.581.655-.709.851-.457.776a7.81 7.81 0 0 0-.074.124l-.008.013-.002.004.001.002.003.003.01.014.018.022.031.032.013.009.011.004c.1.008.203.018.311.026l.334.013.682-.005 1.045-.037 4.84-.042 7.118-.061v-3.502l-.938-.016-.937-.037-.937-.037-.935-.016-.047.003-.045.005-.085.02-.158.056-.08.028-.082.023-.044.008-.046.006-.047.003-.051-.001-.728-.031-.274-.018a8.908 8.908 0 0 1-.137-.019l-.145-.028-.065.017-.104.021c-.082.015-.18.032-.277.051l-.274.05-.103.021-.062.016-.034.011-.033.007-.032.004-.031.001-.029-.002-.028-.005-.026-.007-.026-.01-.024-.011-.023-.014-.04-.033-.034-.037-.007-.011-.003-.005-.001-.001.001-.001.002-.002.002-.005.025-.039.111-.157.062-.074.062-.069.062-.062.061-.051.057-.037.025-.013.024-.009 3.95-4.854-1.697-1.399.029.001 1.68 1.385c.124-.16.343-.242.467-.402.027-.032.008-.098-.043-.181-.136-.222.094-.107.205-.101l-.055-.111c-.07-.145-.073-.149.119-.105.08.02.143.027.17-.007l.299-.395c.487.011.971.02 1.424.017.146-.055.281-.085.397-.143.239-.122.464-.265.7-.393.235.104.496.172.702.309.242.154.474.223.778.219 4.458-.022 7.173-.088 10.865-.088z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m50.258 327.627.133 7.104.914.023h.251l.241-.008.221-.019.101-.015.092-.019.024-.005.027-.002.061.002.068.008.074.016.164.043.172.053.173.052.161.042.073.014.066.008h.059l.025-.003.023-.006.292-.074.34-.073.317-.054.128-.016.095-.004c.242.004.44.007.604.011l.4.019.266.024.198.027.198.027.266.024.4.02.604.012v.003c4.062.019 6.4-.079 10.764-.116a.962.962 0 0 1 .644.217c.17.137.387.204.58.307.195-.129.381-.272.578-.396.096-.058.209-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.767-.116a.962.962 0 0 1 .644.217c.17.137.387.204.58.307.195-.129.381-.272.578-.396.096-.058.209-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.777-.02 3.944.144 5.701.132 4.062.019 6.401-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.944.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.963.963 0 0 1 .645.217c.17.137.386.204.58.307.195-.129.381-.272.578-.396.096-.058.208-.088.328-.144 1.776-.02 3.943.144 5.701.132 4.062.019 6.4-.079 10.766-.116a.958.958 0 0 1 .644.217c.171.137.386.204.581.307.194-.129.381-.272.578-.396.096-.058.207-.088.328-.144 1.774-.02 3.938.144 5.695.132v-.001l2.901-.13.282-.244.074-.072.064-.074.027-.037.023-.039.02-.039.014-.039.004-.011.006-.009.009-.009.011-.008.025-.013.033-.011.077-.017.087-.012.087-.012.076-.016.031-.011.024-.014.01-.008.008-.009.005-.01.003-.011.033-.137.048-.148.027-.069.027-.061.026-.047.013-.018.013-.013.183-.165.13-.101.095-.058.077-.037.076-.037.096-.059.13-.1.185-.165.002.001c2.705-2.619 4.188-4.205 7.055-7.062a.849.849 0 0 1 .578-.263c.209-.014.398-.105.6-.158.039-.218.062-.441.106-.657.024-.104.077-.198.117-.315 1.165-1.166 2.716-2.456 3.872-3.604 2.707-2.621 4.188-4.207 7.057-7.064a.849.849 0 0 1 .578-.263c.209-.014.398-.105.6-.158.039-.218.061-.441.105-.657.023-.104.077-.198.117-.315 1.165-1.166 2.716-2.456 3.873-3.604 2.706-2.622 4.188-4.208 7.056-7.065a.851.851 0 0 1 .579-.263c.208-.014.398-.105.599-.158.038-.218.062-.441.106-.657.023-.104.076-.197.117-.315 1.162-1.165 2.711-2.453 3.868-3.6l-.001-.001 2.021-2.16.027-.38.001-.104-.007-.1-.008-.047-.011-.045-.015-.042-.018-.039-.004-.01-.003-.012v-.012l.002-.013.009-.029.016-.03.044-.067.053-.071.053-.071.042-.066.015-.03.008-.028.001-.012v-.012l-.004-.012-.006-.009-.073-.122-.071-.143-.029-.068-.023-.063-.016-.054-.003-.021-.001-.018.014-.251.02-.166c.01-.044.019-.079.025-.11l.028-.082.028-.082.025-.109.021-.167.014-.252h.002c.045-2.969-.039-4.678-.047-7.868-.004-.184.065-.323.221-.469.137-.123.205-.28.31-.422-.128-.144-.271-.28-.392-.426-.057-.07-.087-.152-.143-.24-.008-1.299.169-2.881.168-4.166l-.069-7.039-41.893 52.755H50.434l-.045.058c-.017 1.178-.14 2.361-.131 3.941z"
                })
            ]
        }),
        web: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlSpace: "preserve",
            viewBox: "0 0 400 400",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "m243.804 142.813-.006-.008-.001-.001-.001-.001.018.076.004-.016-.001-.017-.005-.017-.008-.016zM156.426 96.173l.031.006.032.002.033-.004.033-.008.031-.012.014-.007.002-.001h.002v-.001l-.23-.003.01.008.014.008.028.012zM238.528 137.763v.001l.008.006.002.001-.005-.004-.004-.003zM131.718 111.571l.012.031.015.025.008.01.009.008.008.004.01.002h.009l.009-.004.009-.006-.101-.125v.001l.002.005.002.011.008.038zM115.458 114.183l.039-.002.033-.004.025-.006.018-.007.005-.005.003-.004v-.002l-.001-.003-.003-.005-.007-.006-.01-.006-.016-.012-.02-.018a2.151 2.151 0 0 1-.046-.047l-.018-.018-.02.144h.006l.012.001zM217.634 144.784v.002a.492.492 0 0 0 .009-.033l-.003.005-.004.017-.002.009zM243.905 142.926l-.01.001-.012.003a.303.303 0 0 1-.02.003l-.029.002h-.01l.027.123.004-.004.006-.009.022-.031.018-.028.012-.023.003-.01.002-.009v-.007l-.003-.006-.005-.004-.005-.001zM161.268 78.729h.004v.613h-.004zM251.556 111.094v-.017l-.002-.041-.01-.038-.006-.017-.008-.016-.009-.014-.011-.012-.012-.011-.015-.008-.015-.006-.018-.003h-.014c.04.059.076.115.12.183zM250.415 110.524a2.707 2.707 0 0 0-.098-.075l-.023-.017-.024-.012-.024-.009-.025-.006-.053-.005h-.053l-.055-.001-.053-.004-.025-.005-.025-.007-.023-.011-.024-.013-.11-.078-.108-.083-.106-.086-.102-.092-.102-.093-.098-.098-.188-.201-.141-.161c-.048-.004-.102-.004-.124-.033-.006-.006.013-.032.04-.066l-.039-.049a.291.291 0 0 0-.023.016l.019-.022-.04-.05c-.033.022-.061.038-.066.031-.117-.154-.201-.333-.298-.498l-.06-.076-.178-.253-.16-.254-.146-.254-.133-.255-.12-.256-.11-.26-.099-.264-.089-.269-.031-.103-.045.037-.081.07-.179.166-.237.208-.028.026-.024.027-.021.028-.018.03-.028.062-.022.062-.047.126-.033.059-.021.029-.024.026-.255.252-.263.245-.533.482-.535.481-.264.246-.256.253-.018.001.008.007-2.266 2.345c-.102.137-.282.231-.318.401a5.394 5.394 0 0 1-.109.508 9.846 9.846 0 0 1-.213.688.583.583 0 0 1-.24.284c-.262.187-.26.188-.205.436l.041.188c-.169.153-.466.2-.367.545a.49.49 0 0 1-.035.378c-.312.569-.775 1.051-1.211 1.559l-.018-.015.012.023-.022.038-.028.038-.033.035-.04.032-.044.029-.049.025-.053.021-.055.014-.053.014-.023.01-.022.011-.021.013-.018.015-.018.017-.015.018-.026.042-.021.049-.018.056-.015.063-.026.105-.018.054-.023.053-.027.051-.03.049-.034.043-.037.037-.068.059a.564.564 0 0 1 .242.113c.233.177.239.172.418.024l.135-.113c.176.092.331.341.557.096a.406.406 0 0 1 .297-.148c.541-.007 1.081.11 1.623.104l.004.006v-.006l1.222-.04.009.025.014.02.015.015.017.01.019.004h.019l.02-.005.019-.008.009-.006.001-.001h.001l.004.003.009.006.031.022.028.018.024.011.011.004.009.001.007-.001.006-.002.004-.006.002-.007-.001-.009-.003-.013-.003-.021-.001-.029.003-.073.003-.073-.001-.029-.003-.021h.039l.033-.006.026-.011.024-.015.051-.037.031-.021.039-.021.008-.006.006-.008.002-.011v-.012l-.006-.028-.009-.03-.017-.062-.002-.014v-.012l.002-.01.005-.009.067-.062.072-.056.156-.103.155-.104.073-.057.066-.062.008.008-.004-.01 2.422-2.549c.049-.049.125-.049.219-.037.223.026.221.02.192-.158l-.023-.137c.139-.01.38.102.302-.167-.029-.101-.027-.183.02-.229.223-.231.531-.376.754-.607l.013-.003-.005-.005c.912-.934 1.521-1.554 2.401-2.455a.36.36 0 0 1-.083-.047zM217.69 144.567h-.016l-.037.004-.033.004-.025.005-.018.007-.006.005-.002.004v.005l.004.006.007.006.011.006.016.011.02.018.047.047v.001l.032-.129zM262.827 101.703l.014.032.018.025.008.01.01.007.01.005.012.002h.006l-.092-.135.002.006.002.01.01.038zM157.763 80.021h.004v.877h-.004zM268.749 101.931l.034.001.028-.002.012-.003.01-.005.008-.006.005-.007.003-.008v-.01l-.003-.012-.006-.014-.009-.022-.008-.035-.004-.022-.125.135.006.002.01.002.039.006zM263.07 102.031h.004v.002h-.004zM259.423 140.934l-.024.026-.009.012-.006.012-.004.012-.001.012.001.012.004.011.006.011.008.012.021.021.031.021.039.021.047.026.041.028.034.031.028.032.023.035.018.037.013.039.009.041.029.155.018.063.017.05.003.009.002.003.002.001v-.001l-.001-.004-.001-.003.002.002.002.008.011.033.007.02a.32.32 0 0 0 .197-.155.49.49 0 0 1 .303-.225c.615-.137 1.264-.072 1.813-.073l.021.041v-.041l7.123-.039.025.013.03.013.073.02.088.014.1.01.106.004h.11l.219-.013.052-.006.007-.001h.004l.001-.001.001-.007.001-.013-.001-.054-.003-.028-.007-.028-.008-.027-.012-.027-.014-.027-.018-.027-.02-.026-.021-.025-.025-.024-.029-.023-.031-.021-.035-.02-.062-.038c-.027-.02-.061-.042-.099-.068l-.256-.186a17.567 17.567 0 0 1-.258-.188l-.1-.069-.064-.04-.097-.137-.097-.123-.209-.233-.564-.607-.039-.042-.04-.036-.081-.062-.084-.05-.084-.045-.167-.088-.081-.055-.041-.032-.039-.036-.742-.764-.727-.779-.33-.354c-.07-.025-.146-.045-.192-.097-.01-.01.004-.042.026-.081l-.08-.086-.024.014.015-.024-.08-.086c-.037.02-.067.032-.078.021l-.434-.507a5.77 5.77 0 0 0-.077-.073l.005-.012-.122-.143-.353-.033-.002-.005-.003-.01-.013-.037-.014-.031-.016-.024-.008-.009-.008-.007-.009-.004-.009-.002-.008.002-.009.005-.009.009-.008.011-.016.019-.026.023-.071.059-.069.057-.026.024a.216.216 0 0 1-.016.019l-.043-.023-.039-.014-.037-.007-.038-.001-.087.002-.052-.001-.062-.005h-.007l-.007.001-.012.005-.012.007-.01.011-.018.027-.017.031-.032.062-.01.013-.01.01-.01.008-.012.004-.122.018-.12.014-.244.015-.121.009-.061.006-.06.008-.117.021-.058.014-.056.018-.003-.009-.002.009c-.92.308-1.6.82-2.035 1.459-.027.037-.092.036-.176.028-.201-.017-.201-.005-.113.135l.068.104c-.113.016-.369-.038-.193.161.064.073.1.135.08.177-.086.203-.273.387-.33.63l-.006-.002.006.007.005.021-.001.021-.007.02-.013.021-.018.019-.023.019-.029.017-.035.014-.033.015-.012.009-.01.008-.007.01-.005.01-.002.011v.011l.002.012.005.013.015.025.023.028.029.03.05.051.043.053.017.026.012.025.008.024v.023l-.037.325-.025.332-.01.338.008.34v.049a4.043 4.043 0 0 0-.197.196zM294.673 146.214l-.006-.016-.012-.017-.016-.029c-.006-.014-.014-.03-.021-.049l-.05-.13c-.019-.045-.036-.092-.05-.13a.556.556 0 0 1-.021-.05 1.161 1.161 0 0 1-.018-.03l.028-.068.019-.064.012-.063.006-.066.01-.149.021-.193.001-.023-.003-.022-.006-.021-.008-.021-.023-.039-.028-.038-.03-.037-.025-.037-.011-.02-.009-.021-.005-.021-.003-.022.004-.22.012-.221.037-.441.029-.351c-.027-.026-.084-.051-.08-.077 0-.005.037-.009.088-.013v-.001l.002-.034-.037-.004.037-.002.002-.036c-.044-.005-.078-.009-.077-.014.015-.098.05-.195.072-.293l-.022-.696.025-.009.02-.013.014-.014.01-.018.004-.018v-.018l-.004-.02-.01-.018-.005-.009-.001-.001v-.001l.003-.004.007-.009.022-.03.019-.028.012-.023.004-.01.001-.01-.001-.007-.002-.005-.004-.004-.008-.002h-.01l-.012.003-.02.003-.029.001-.072-.003-.072-.003h-.029l-.021.003.002-.039-.005-.031-.009-.027-.014-.023-.035-.05-.02-.031-.02-.039-.002-.005-.004-.004-.008-.004-.01-.003h-.012l-.028.005-.03.009-.062.017-.013.002h-.012l-.01-.002-.008-.006-.061-.065-.053-.072-.096-.153-.096-.155-.054-.072-.06-.066.002-.006-.004.004-2.861-2.85c-.055-.057-.059-.139-.052-.238.017-.237.011-.236-.18-.222l-.146.012c-.018-.15.09-.398-.194-.34-.106.022-.194.012-.247-.043-.26-.262-.432-.607-.691-.869l.003-.003h-.006l-.899-.879.012-.024.005-.023v-.021l-.006-.02-.01-.017-.013-.014-.02.001c-.016.045-.032.08-.053.079l-.575-.037-.015.026-.01.011-.008.008-.01.006-.009.002-.094-.002-.095-.012-.188-.038-.134-.027-1.046.015-.01-.014-.014-.012-.014-.011-.016-.009-.037-.015-.041-.01-.044-.004h-.046l-.046.005-.044.008-.043.013-.037.016-.033.02-.025.022-.009.012-.007.013-.006.014-.002.014.002.015.004.016.006.016.012.016.016.029c.006.014.014.03.021.049l.05.129.057.108.023.04.019.024-.025.057-.016.053-.009.053-.004.055c-.001.037-.003.077-.003.123l-.014.16-.001.021.003.018.006.018.01.016.024.03.03.027.061.053.013.014.011.014.008.015.006.016.025.16.015.162.008.164.003.082.014.073.053.298.014.074.008.038.004.019.006.017.061.131-.003.007.005-.002c.18.421.469.771.914 1.239.437.462 1.01 1.026 1.525 1.737.061.082.058.186.042.299-.038.271-.034.268.175.326l.16.045c.01.181-.156.416.148.484.114.025.204.084.247.174.237.438.24.93.405 1.37l-.002.006.004.001.016.044.012.044.021.085.039.165.074.312.137.588c.053.376.105.752.171 1.212l-.013.01-.01.012-.009.012.011-.007c.012-.006.026-.014.043-.021l.113-.05c.039-.019.08-.036.113-.051l.043-.021c.012-.006.021-.013.027-.017l.06.028.056.019.057.012.057.006.131.01.17.021.021.001.02-.003.019-.006.018-.008.035-.023.032-.028.032-.029.033-.026.018-.011.018-.009.018-.005.02-.003.189.004c.002 0 .003-.002.003-.002.003 0 .003.002.003.002l.19.012.104.01c.003-.001.006-.009.008-.009l.831.07 1.536-.021.01.013.014.013.014.01.016.01.037.014.041.01.044.004h.046l.046-.004.044-.009.043-.013.037-.016.033-.02.025-.021.009-.013.007-.013.006-.014.002-.014-.002-.015-.002-.021z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "m244.537 308.035-.063-.296-.027-.152-.021-.155-.013-.161-.002-.169.011-.562.012-.279.021-.277.004-.022.006-.022.02-.047.02-.047.01-.023.006-.025.041-.203.051-.197.032-.095.038-.092.043-.088.051-.083.072-.115c.02-.039.038-.077.057-.112l.022-.057.019-.056.016-.056.012-.056.006-.057.004-.056v-.057l-.004-.057-.008-.058-.012-.059-.032-.12a71.76 71.76 0 0 1-.239-.712 9.848 9.848 0 0 0-.073-.244c-.017-.075-.032-.142-.048-.204l-.027-.184-.012-.189.002-.217.009-.269.011-.552.004-.55.014-.272.025-.269.021-.133.024-.132.031-.13.036-.129.023-.095.023-.155.054-.458.054-.601.047-.677.033-.687.014-.629c-.002-.098-.004-.188-.004-.273a25.472 25.472 0 0 0-.012-.234l-.019-.188-.014-.072-.016-.059.011-.869h-.003l.073-2.672c.006-.188-.145-.341-.141-.529s.164-.411.168-.6l.098-4.785c.006-.327.313-.61.319-.937.006-.263-.294-.57-.294-.834l.052-4.272c.026-1.977.056-4.191.089-6.531-.289-.027-.579-.055-.869-.052l-.008-.007v.008l-.035.01-.036.004-.039-.002-.04-.007-.041-.013-.041-.02-.039-.024-.039-.031-.037-.028-.02-.011-.018-.007-.02-.006-.018-.002h-.019l-.019.002-.02.004-.02.008-.039.02-.041.027-.043.035-.07.058-.08.052-.041.021-.042.017-.042.01-.039.004-2.296-.013-.081-.002c-.113-.079-.215-.149-.314-.221l-.039-.026-.018-.01-.019-.007-.019-.005-.018-.002h-.019l-.019.002-.019.004-.019.007-.039.02-.039.028-.043.035-.052.044-.056.037-.059.03-.061.023-.064.018-.066.012-.068.008-.072.001-.281.002-.24.01a94.672 94.672 0 0 1-.826.063l-.24.008-.281-.001c-.176-.059-.319-.106-.42-.141l-.117-.04-.031-.015-.01-.006-.002-.003-.002-.003-.015-.071-.012-.074-.013-.158-.002-.161.007-.16.037-.493.042-2.281.061-3.356h.006l-.006-.008-.089-6.679c-.001-.131.054-.233.128-.343.176-.265.17-.271.023-.472l-.113-.152c.092-.199.341-.373.096-.628a.482.482 0 0 1-.148-.334c-.006-.61.109-1.22.104-1.831l-.089-6.678c-.001-.131.054-.234.128-.343.176-.265.17-.271.023-.472l-.113-.152c.092-.199.341-.373.096-.629a.481.481 0 0 1-.148-.333c-.006-.61.109-1.22.104-1.831l-.089-6.678c-.001-.131.054-.234.128-.344.176-.264.17-.27.023-.471l-.113-.152c.092-.199.341-.373.096-.629a.482.482 0 0 1-.148-.334c-.006-.609.109-1.219.104-1.83-.021-2.267-.029-4.386-.343-6.407-.017-.12.023-.222.083-.334.141-.271.139-.279-.045-.434l-.139-.116c.053-.193.266-.402-.021-.582a.408.408 0 0 1-.204-.266c-.155-.521-.159-1.096-.364-1.599-.65-1.884-1.766-3.456-3.199-4.817-.087-.08-.117-.182-.14-.304-.057-.292-.062-.298-.3-.308l-.181-.006c-.079-.188-.043-.484-.379-.449a.444.444 0 0 1-.339-.08c-.447-.352-.844-.794-1.334-1.147-1.751-1.279-3.85-2.637-5.396-4.809a.73.73 0 0 1-.127-.399c-.011-.361-.017-.359-.263-.488l-.189-.098c-.047-.248.09-.539-.256-.699a.62.62 0 0 1-.305-.293c-.295-.66-.42-1.375-.593-2.049l.007-.002-.009-.006a34.757 34.757 0 0 0-.094-.338l-.063-.315-.117-.591-.058-.291-.038-.298-.08-.652.012-.01.012-.012.009-.013.008-.015.011-.031.006-.035v-.009l-.006.002-.014.007-.014.011-.025.016-.043.021-.114.05c-.04.019-.081.036-.114.051l-.044.021a.503.503 0 0 0-.027.017l-.06-.028-.057-.019-.057-.012-.059-.006a3.262 3.262 0 0 0-.131-.01l-.171-.021-.021-.001-.02.003-.02.006-.018.008-.035.023-.033.028-.032.029-.033.026-.018.011-.018.009-.019.005-.02.003-.194-.004-.194-.012-.389-.037-.39-.037-.194-.012-.195-.004-.007-.003v.003l-6.378.089c-.125.001-.223-.054-.328-.128-.252-.176-.258-.17-.449-.023l-.146.113c-.19-.092-.356-.341-.601-.096a.45.45 0 0 1-.318.148c-.582.006-1.165-.109-1.748-.104-2.211-.023-4.594-.129-6.798-.797a.597.597 0 0 1-.309-.211c-.212-.239-.22-.228-.458-.161l-.183.055c-.167-.157-.251-.454-.579-.312a.504.504 0 0 1-.375.021 8.827 8.827 0 0 1-.871-.376c-.275-.157-.547-.321-.833-.454a22.219 22.219 0 0 1-5.772-3.738.618.618 0 0 1-.178-.333c-.08-.312-.086-.311-.342-.345l-.195-.025c-.094-.199-.026-.512-.381-.533a.496.496 0 0 1-.341-.152 18.354 18.354 0 0 1-1.161-1.496c-1.473-1.768-2.621-3.794-3.512-5.918-.049-.127-.035-.246-.004-.379.071-.317.064-.318-.145-.465l-.161-.109c.016-.226.192-.469-.131-.641a.446.446 0 0 1-.234-.289c-.166-.611-.21-1.252-.371-1.861-.435-2.251-.708-4.561-.468-6.859a.608.608 0 0 1 .15-.343c.195-.253.189-.257.059-.481l-.102-.17c.103-.195.403-.33.205-.625a.486.486 0 0 1-.078-.363c.117-.623.355-1.218.477-1.836.296-1.106.678-2.198 1.057-3.283l.74-1.562.441-.909c.104-.341.448-.549.678-.821a.655.655 0 0 1 .379-.199c.303-.054.304-.062.336-.301l.022-.184c.199-.07.493-.012.491-.357 0-.129.037-.246.121-.33.408-.416.902-.746 1.31-1.162l4.447-4.572c.088-.09.195-.121.321-.143.304-.053.305-.062.336-.301l.023-.183c.198-.07.492-.012.491-.357a.447.447 0 0 1 .12-.33c.408-.417.902-.746 1.311-1.163l4.446-4.572c.088-.089.196-.12.321-.142.304-.054.305-.062.336-.302l.023-.183c.199-.069.492-.011.491-.356a.447.447 0 0 1 .12-.33c.408-.417.902-.746 1.311-1.163l.004-.001-.003-.003.003-.017.004-.007.004-.007.006-.006.007-.004.017-.007.021-.003.025.002.029.006.033.011.031.009.013.002h.011l.01-.002.006-.004.006-.005.004-.007.003-.01.001-.01-.003-.025-.007-.031-.013-.038-.021-.062-.013-.06-.003-.026.002-.023.004-.02.004-.008.006-.007.338-.337.343-.326.025-.022.248.063.03.008.012.001h.01l.01-.002.007-.004.005-.005.004-.007.002-.009.002-.01-.003-.025-.009-.031-.013-.038-.016-.046-.009-.043-.005-.038.001-.035.006-.03.012-.028.016-.025.02-.022.081-.083.063-.077.098-.145.047-.07.052-.072c.021-.023.042-.049.065-.076l.083-.082.222-.023.036-.004h.005v-.002l.001-.003.002-.014.003-.022a.402.402 0 0 0 .006-.032l.003-.009.003-.004.029-.015.031-.012.031-.008.033-.005.066-.002.066.007.12.022.048.01.037.005.945.042 1.39.061v.004l.003-.004 6.311-.089c.125-.001.222.054.325.128.249.176.255.17.445.023l.144-.113c.188.092.354.341.594.096a.444.444 0 0 1 .316-.148c.576-.006 1.152.109 1.729.104l6.311-.089c.124-.001.222.054.325.128.323.176.326.17.59.023l.205-.113c.251.092.411.341.785.096a.867.867 0 0 1 .465-.148l.459.008c.479.434.926.902 1.407 1.298l3.958 3.192.455-.007c.078-.001.129.054.186.128.14.176.156.17.293.023l.1-.113c.092.092.287.341.523.096a.441.441 0 0 1 .314-.148c.577-.006 1.153.109 1.73.104l6.311-.089c.125-.001.222.054.324.128.25.176.256.17.446.023l.144-.113c.188.092.354.341.594.096a.444.444 0 0 1 .316-.148c.576-.006 1.152.109 1.729.104l6.312-.089c.124-.001.222.054.324.128.249.176.256.17.446.023l.143-.113c.189.092.354.341.595.096a.444.444 0 0 1 .315-.148c.576-.006 1.152.109 1.729.104v.008l.009-.01.033-.009.037-.004.039.001.039.008.041.013.041.019.039.025.039.031.037.028.019.011.019.008.018.004.019.003h.019l.019-.002.019-.005.02-.006.039-.021.041-.027.042-.035.071-.058.079-.052.041-.021.042-.016.041-.011.039-.004 2.283.013.08.002.313.221.037.026.019.01.019.007.019.005.018.003h.018l.019-.002.019-.005.019-.007.038-.02.04-.027.042-.037.052-.043.056-.037.058-.03.062-.023.062-.018.066-.013.068-.006.072-.002.279-.002.239-.01.412-.033.413-.031c.074-.002.154-.004.24-.008l.109.001.031-.025.1-.089.098-.096.099-.104.192-.228.187-.253.178-.275.169-.293.005-.004-.003-.002c.015-.064-.006-.146.008-.21 0-.003.05.018.118.048l.023.01-.001-.015-.095-.051.093.04-.001-.015a.969.969 0 0 1-.128-.073c.002-.019.115.017.117-.002l.004.002-.001-.01c.053-.119.104-.232.151-.342l.133-.329.116-.321.106-.318.099-.324.095-.338.092-.361.09-.393.016-.007.014-.01.014-.012.013-.014.022-.032.018-.038.015-.043.011-.045.004-.031-.012-.004-.016-.002-.017.001-.017.004-.018.007-.018.011-.031.016c-.016.006-.033.014-.055.021l-.143.05-.144.051-.055.021-.034.017-.074-.028-.072-.019-.07-.012-.072-.006a5.383 5.383 0 0 0-.164-.01l-.214-.021-.026-.001-.024.003-.023.006-.022.008-.043.023-.041.028-.041.029-.042.026-.022.011-.021.009-.023.005-.024.003-.243-.004-.243-.012-.486-.037-.487-.037-.244-.012-.243-.004-.006-.007-.003.007-1.311.019c-.463.003-.803.027-1.401.013-1.093-.038-2.277-.289-3.354-.931-.127-.073-.193-.187-.251-.313-.135-.315-.135-.308-.4-.337l-.203-.026c-.111-.225-.065-.521-.434-.571a.536.536 0 0 1-.357-.201c-.438-.565-.654-1.258-.85-1.919a5.728 5.728 0 0 1 .172-3.739c.134-.339.311-.658.51-.964-.084.021-.168.043-.253.041-.023 0-.046-.019-.067-.048l-.272-.005-.272-.006c-.021.027-.043.045-.068.044l-1.402-.053-.23.003-.01-.012-.195-.008-.012 2.104-.002.081c-.016.021-.027.039-.042.061l-.011.126-.037.441-.004.066v.034l.029.059.024.061.018.064.013.066.006.068.002.072.002.281.01.24.033.413.031.413c.002.074.004.154.008.24l-.002.281-.141.42-.041.117-.014.032-.006.009-.003.002-.003.002-.071.015-.075.012-.156.013-.162.002-.16-.007-.492-.037-1.141-.018-.57-.012-.666-.027-.129-.009-.131-.014-.262-.03-.131-.016-.133-.021-.266-.049-.267-.054-.27-.069-.134-.036-.135-.04-.271-.093-.134-.047-.068-.024-.066-.029-.268-.117-.134-.06-.132-.07-.262-.143-.064-.036-.063-.041-.126-.083-.127-.083-.123-.087-.24-.188-.119-.097-.112-.104.006-.023-.015.017a6.005 6.005 0 0 1-1.686-2.408c-.019-.053.018-.112.073-.179.132-.158.13-.155-.034-.191l-.127-.028c.062-.106.285-.236.023-.274-.099-.015-.164-.047-.177-.098-.064-.244.007-.508-.033-.746l.003-.002h-.004l-.072-.547-.025-.26-.02-.285-.051-.001-.029.001-.021.004.001-.039-.004-.031-.01-.025-.014-.023-.035-.048-.02-.03-.02-.037-.002-.005-.004-.003-.008-.005-.01-.002-.012.001-.027.005-.03.01-.06.019-.014.002-.012.001-.01-.002-.007-.005-.06-.063-.053-.069-.096-.148-.096-.148-.053-.07-.059-.063-.001-.003-.001.001c-.109-.084-.243-.142-.352-.226-.006-.005.027-.048.074-.104.041-.048.048-.06.059-.075l-.011-.002c-.015.011-.018.012-.05.039l-.088.074c.025-.033.071-.087.1-.123l-.019-.004c-.013.01-.017.012-.04.032-.069.061-.114.096-.119.091-.031-.022.025-.131-.006-.152l.01-.009-.023-.006a4726.113 4726.113 0 0 1-3.155-3.124l-.619-.648-.103-.103-.033-.028-.07-.014-.128-.017-.171-.014-.019-.015-.022-.014-.025-.012-.03-.012-.071-.018-.082-.012-.09-.008-.098-.001-.1.003-.099.008-.048.006-.007.001h-.003l-.002.001-.006.072v.022l.008.063.02.067.031.068.043.07.055.068.069.065.083.062.078.059.124.102.326.28.534.467.229.354.23.336.253.391.136.24.066.137.066.15.061.13.064.116.134.215.063.106.031.055.027.057.051.12.02.064.017.069.03.173.022.174.014.175.005.176-.002.176-.012.175-.019.176-.026.174-.033.172-.041.171-.049.169-.053.167-.061.165-.065.162-.147.318-.166.31-.184.3-.004.007c-.017.088-.023.179-.078.253-.011.016-.051.017-.104.012l-.014.021-.074.098a.25.25 0 0 1 .023.022l-.035-.006-.053.068.001.003.001.043-.002.044-.003.021c0 .004.005.011.003.014l-.006.006v.003l-.01.041-.017.038-.021.034-.183.231-.192.225-.2.218-.209.212-.217.206-.221.199-.456.382-.067.052-.209.022-.195.013-.048.003-.021.004-.02.006-.019.007-.017.01-.014.011-.014.013-.012.015-.012.017-.02.037-.015.046-.013.054-.016.066-.024.062-.031.06-.038.055-.045.053-.05.049-.056.046-.062.043-.413.275-.163.112-.124.092-.258.184-.156.1-.188.105-.348.038-.057.007h-.007l-.002.001-.003.002-.012.007-.021.012-.029.015-.01.003h-.004l-.002-.001-.049-.027-.049-.032-.094-.076-.09-.087-.082-.091a63.95 63.95 0 0 1-.24-.293l-1.205-1.264-1.773-1.859.001-.009-.005.005-2.521-2.392c-.049-.048-.048-.124-.036-.217.027-.222.021-.22-.156-.19l-.137.024c-.008-.138.104-.378-.163-.298-.101.029-.183.027-.228-.019-.229-.22-.371-.526-.6-.746v-.001l-.003-.002-.893-.835.011-.024.006-.023v-.021l-.006-.019-.01-.016-.014-.014-.017-.01-.02-.008-.011-.002h-.002v-.006l-.002-.011-.007-.038-.008-.031-.009-.025-.006-.01-.005-.008-.005-.004-.006-.002h-.006l-.007.004-.007.008-.006.01-.013.017-.021.021a14.3 14.3 0 0 0-.053.05l-.055.051-.02.021a.387.387 0 0 0-.014.017l-.027-.028-.027-.019-.026-.012-.027-.007-.062-.009-.037-.008-.043-.013-.01-.002-.01.002-.009.006-.009.009-.016.023-.016.028-.031.056-.008.011-.009.008-.009.006-.009.002-.091-.002-.092-.012-.184-.038-.182-.038-.092-.012-.092-.003-.004-.003v.003l-1.057.089c-.021.001-.037-.053-.055-.127-.041-.177-.043-.172-.074-.024l-.023.113c-.032-.092-.06-.341-.1-.096-.016.093-.033.148-.053.148-.098.007-.193-.11-.291-.104v-.002l-.003.002-1.222.04-.009-.025-.013-.02-.016-.015-.017-.01-.019-.004h-.019l-.019.005-.02.008-.008.006-.002.001v.001l-.001-.001-.004-.003-.009-.006-.031-.022-.028-.018-.024-.011-.01-.004-.01-.001-.006.001-.006.002-.004.005-.002.008v.009l.004.013.002.021.001.029-.003.072-.002.074v.029l.004.021h-.04l-.032.006-.027.01-.023.015a1.808 1.808 0 0 1-.051.037l-.031.021-.04.021-.008.006-.005.009-.002.01v.013l.005.027.009.031.018.062.002.013v.012l-.002.011-.006.008-.066.062-.072.056-.156.104-.156.102-.072.057-.067.062-.007-.002.004.004-1.51 1.635c-.031.031-.093.018-.171-.01-.187-.062-.185-.057-.128.095l.043.116c-.111-.019-.328-.154-.215.08.043.088.056.154.026.184-.14.147-.365.209-.505.357l-.005-.001.003.003-.703.759-.023-.013-.021-.006-.02-.001-.006.001.02.02.02.019.016.012-.029.021-.021.02-.013.02-.009.021-.015.049-.012.029-.018.033-.002.004v.004l.002.007.004.008.008.008.021.017.027.016.051.031.01.008.008.008.005.008.001.004v.004l-.012.074-.021.072-.027.072-.033.07-.062.14-.025.071-.016.072-.006-.001.005.004c-.505 2.731-2.407 5.174-4.991 6.288a.801.801 0 0 1-.445.041c-.369-.06-.365-.05-.562.16l-.15.16c-.27-.023-.521-.217-.785.076a.615.615 0 0 1-.391.209c-.766.104-1.529-.023-2.279-.121-2.758-.35-5.301-2.118-6.555-4.632-.078-.146-.077-.29-.066-.442.035-.369.032-.367-.193-.551l-.168-.143c.006-.27.188-.532-.121-.779a.617.617 0 0 1-.23-.377c-.146-.761-.064-1.531-.008-2.283.19-2.771 1.818-5.415 4.256-6.805.141-.085.283-.096.438-.092.369.01.37.015.538-.225l.134-.175c.269-.01.542.159.771-.165a.627.627 0 0 1 .364-.252c.73-.189 1.576-.146 2.232-.14l.008.017v-.017l2.951-.04.01.014.014.012.014.011.016.009.037.015.041.01.044.004h.046l.046-.005.044-.008.043-.013.037-.016.033-.02.025-.022.009-.012.007-.013.006-.014.002-.014-.002-.015-.004-.016-.006-.016-.012-.016-.016-.029c-.006-.014-.014-.03-.021-.049l-.05-.129a4.47 4.47 0 0 1-.05-.131.456.456 0 0 1-.021-.05 1.161 1.161 0 0 1-.018-.03l.028-.068.019-.064.01-.056h-.006l-.002-.007-.009-.03-.002-.019c-.019-.128-.096-.257-.091-.385 0-.027.051-.052.127-.074l-.018-.029-.028-.037-.03-.037-.025-.038-.011-.02-.009-.021-.005-.021-.003-.021v-.012l-.011-.036-.004-.035.013-1.999.002-.071.221-.274.026-.032.01-.017.007-.016.005-.016.003-.016v-.017l-.002-.016-.005-.017-.007-.016-.02-.034-.027-.034-.037-.037-.043-.046-.037-.048-.029-.051-.024-.054-.018-.056-.013-.058-.006-.061-.002-.062-.002-.246-.01-.209-.033-.403-.031-.413c-.002-.074-.004-.154-.008-.24l.002-.281.141-.42.041-.117.014-.032.006-.009.003-.002.003-.002.071-.015.075-.012.156-.013.162-.002.16.007.492.037.961.013.373-.002.371-.01.271-.013.268-.021.267-.025.264-.031.26-.039.256-.047.254-.053.25-.061.006.004-.001-.006c1.589-.46 2.806-1.391 3.902-2.749.065-.079.159-.106.272-.13.271-.054.271-.065.256-.284l-.014-.169c.172-.073.461-.042.391-.361-.025-.121-.014-.231.049-.317.303-.427.709-.804 1.041-1.264.604-.835 1.282-1.724 2.157-2.53a9.143 9.143 0 0 1 3.105-1.902.607.607 0 0 1 .395.004c.323.084.321.081.493-.114l.13-.151c.231.045.454.244.672-.039a.493.493 0 0 1 .323-.202c.371-.057.741-.052 1.106-.041l.015-.786c-.002-.011-.009-.019-.009-.029l.019-.943-.004-.002-.014-.005-.014-.002-.015.001-.015.004-.016.007-.017.011-.029.016c-.014.006-.03.014-.049.021l-.13.05c-.045.019-.092.036-.13.051l-.05.021-.03.017-.068-.028-.064-.019-.063-.012-.066-.006a4.448 4.448 0 0 0-.149-.01l-.193-.021-.023-.001-.022.003-.021.006-.021.008-.039.023-.038.028-.037.029-.037.026-.02.011-.021.009-.021.005-.023.003-.22-.004-.221-.012-.298-.023-.305-.041-.303-.055-.3-.066-.592-.157-.005-.024-.006.021c-2.06-.58-3.752-2.249-4.357-4.315-.631-2.099-.121-4.345 1.188-5.999.154-.194.325-.306.52-.4.473-.223.471-.218.668-.572l.162-.264c.371-.152.756-.099 1.083-.525.128-.16.313-.299.546-.38a5.215 5.215 0 0 1 1.791-.272c.521.019.871.053 1.316.047v.005l.003-.005 1.208-.039.009.025.013.02.015.014.017.01.019.004h.019l.019-.004.019-.009.009-.006.001-.001h.002l.004.003.008.007.031.021.027.018.025.012.01.004.009.001h.007l.006-.003.004-.005.002-.007-.001-.01-.003-.012-.003-.021-.001-.028.004-.073.002-.073v-.029l-.004-.021.04.001.032-.005.026-.011.024-.014.05-.036.032-.021.039-.021.004-.003.004-.003.005-.008.002-.011v-.012l-.005-.028-.009-.03-.017-.062-.002-.014v-.012l.002-.01.005-.008.066-.061.072-.056.155-.1.155-.1.073-.056.066-.061.004.004-.002-.006 3.073-3.145c.062-.061.147-.07.251-.067.247.004.246-.003.238-.2l-.009-.151c.157-.026.414.071.362-.222-.02-.11-.006-.203.053-.26.281-.286.649-.484.932-.771l.005.005-.003-.009.003-.017.003-.007.005-.007.006-.005.007-.005.017-.006.021-.003.025.002.029.007.033.011.031.01.012.002h.012l.008-.002.008-.003.006-.006.004-.007.002-.009.001-.01-.003-.025-.007-.031-.013-.038-.02-.062-.012-.06-.004-.026.002-.023.004-.02.004-.008.006-.006.337-.33.341-.319.025-.022.247.067.029.008.013.002h.01l.009-.002.007-.004.006-.005.004-.007.002-.009.001-.01-.003-.025-.008-.031-.013-.037-.016-.047-.009-.042-.004-.038v-.034l.007-.031.011-.027.016-.024.02-.022.081-.082.063-.075.098-.143.046-.069.052-.071c.021-.023.042-.047.064-.074l.084-.08.221-.02.035-.004h.005l.001-.002v-.003l.002-.014.004-.022a.314.314 0 0 1 .006-.032l.002-.009.002-.004.029-.015.031-.012.031-.008.033-.005.065-.002.065.007.118.022.048.01.035.005.935.042 1.373.061.003.002v-.002l6.067-.089c.12-.001.213.054.312.128.24.176.246.17.43.023l.138-.113c.181.092.339.341.571.096a.417.417 0 0 1 .303-.148c.555-.006 1.108.109 1.663.104l3.073-.038c1.217.006 2.551.24 3.765.9.142.077.223.194.296.325.176.318.169.322.457.344l.215.025c.137.229.119.542.506.582.15.013.281.08.385.192.508.556.799 1.233 1.105 1.854l-.01.012.012-.006.127.266.109.248.186.469.16.474.124.444.05-.025.098-.049a.398.398 0 0 1 .037-.021l.023-.018.051.029.049.019.047.012.049.007.112.011.145.021.019.002.016-.002.017-.006.015-.008.03-.023.028-.028.027-.029.028-.026.015-.011.016-.008.016-.006.017-.002.165.004.165.013.33.039.331.039.164.014.166.004v.021l.006-.021.994-.084c.02 0 .035.054.051.128.038.177.039.171.07.024l.022-.113c.029.092.054.342.093.096.016-.092.032-.148.051-.147.091-.006.182.11.271.105l.006.013v-.013l1.866-.03.007.014.008.012.009.011.01.009.023.015.026.01.021.004-.011-.077-.008-.036a.218.218 0 0 0-.008-.024l.043-.025.033-.028.027-.03.022-.033.048-.077.031-.046.039-.05.008-.013.004-.013v-.015l-.002-.015-.01-.031-.016-.033-.016-.034-.014-.032-.004-.015-.002-.016.002-.014.004-.013.066-.117.072-.113.166-.215.168-.21.081-.107.073-.112.012.001-.009-.005c.699-1.129 1.654-2.128 2.752-2.935-4.948-3.617-10.023-6.709-15.487-9.615l-.556-.923c-.239.034-.472.085-.704.101-.358.006-.648-.121-.823-.47-.104-.19-.243-.364-.361-.555-.997.134-.993.12-1.646-.21-1.272-.678-2.624-1.19-3.926-1.788-1.313-.575-2.609-1.174-3.938-1.653l-.645-.848c-.572.216-1.125.248-1.67-.031-.207-.102-.432-.17-.645-.254-.107-.043-.209-.096-.305-.141l-.66-.909c-1.031-.376-2.143-.696-3.227-1.083-.473-.168-.896-.067-1.332.076a.759.759 0 0 1-.885-.324c-.258-.406-.592-.673-1.07-.793a96.932 96.932 0 0 1-3.016-.818c-.57-.168-1.12-.241-1.666.037-.052.025-.201-.042-.25-.102-.546-.722-1.275-.967-2.124-.625-.394.16-.599.054-.813-.23-.141-.202-.234-.297-.463-.35-7.246-1.559-14.221-2.293-21.582-2.586a303.85 303.85 0 0 1-.902-.591c-.201.134-.389.28-.591.396-.32.16-.638.172-.946-.066-.176-.127-.377-.224-.566-.344-.84.553-.842.538-1.574.523a29.103 29.103 0 0 0-2.436.029l.065 6.753a.993.993 0 0 1-.128.468c-.176.36-.17.369-.023.644l.113.207c-.092.272-.341.51-.096.857.092.13.148.285.148.455.006.832-.109 1.664-.104 2.497l-.002.003h.004l.009.015.003.008.001.007v.009l-.001.008-.008.017-.013.017-.019.018-.025.016-.031.017-.027.015-.027.036v.003l.003.008.005.008.006.008.02.017.028.017.035.018.058.029.051.033.021.018.016.018.011.017.003.009.001.008-.001.478-.012.474-.002.033-.221.131-.026.016-.01.008-.007.007-.005.008-.003.008v.007l.002.008.005.008.007.008.02.016.027.018.037.017.043.022.037.022.029.024.024.025.018.026.013.027.006.028.002.03.002.116.01.1.033.171.017.083.015.088c.002.031.004.064.008.1a4.07 4.07 0 0 0-.002.117l-.141.174-.021.027-.004.003v.001l.001.001.002.003.009.011.014.019.018.027.004.008.002.004-.01.031-.015.03-.017.028-.021.027-.046.048-.051.043-.102.068-.041.026a.695.695 0 0 1-.029.023l-.697.639-1.026.939-.003.001.001.001-4.899 5.025a.63.63 0 0 1-.346.165c-.32.071-.321.08-.367.333l-.033.193c-.212.084-.518.037-.533.4a.519.519 0 0 1-.144.353c-.448.458-.984.828-1.434 1.286l-.001-.001v.005l-.003.016-.003.008-.004.006-.006.005-.007.005-.017.006-.02.002-.025-.002-.029-.006-.032-.012-.03-.01-.013-.002h-.011l-.008.001-.008.003-.005.006-.003.006-.003.009-.001.011.004.024.008.031.014.036.021.061.015.059.002.026v.023l-.004.019-.004.008-.004.006-.321.319-.325.31-.014.01-.012.012a14.86 14.86 0 0 0-.242-.068l-.029-.009-.012-.002-.011.001-.009.001-.006.003-.006.006-.004.006-.002.009v.01l.003.024.009.031.014.037.017.045.011.042.005.037-.001.034-.005.03-.01.026-.015.024-.019.021a5.134 5.134 0 0 0-.077.079l-.06.074-.097.143-.047.07-.052.072c-.021.023-.042.049-.065.076l-.083.082-.222.023-.036.004h-.005v.002l-.001.003-.001.014-.004.022a.402.402 0 0 0-.006.032l-.003.009-.003.004-.029.015-.031.012-.031.008-.033.005-.066.002-.066-.007-.12-.022-.048-.01-.037-.005-.871-.019-1.243-.019v-.003l-.003.003c-2.146.06-4.217.439-6.187.941-.112.038-.214.017-.33-.023-.278-.094-.286-.086-.413.111l-.096.15c-.199-.03-.438-.215-.573.087a.403.403 0 0 1-.233.232c-.482.236-1.023.355-1.516.59-1.75.933-3.127 2.357-4.839 3.95-.102.093-.218.124-.352.146-.325.052-.313.061-.392.311l-.059.192c-.232.069-.533-.009-.602.36a.564.564 0 0 1-.198.348c-.573.395-1.21.714-1.836 1.032-2.298 1.22-4.869 1.7-7.246 1.733a.65.65 0 0 1-.374-.11c-.31-.187-.319-.191-.57-.062l-.196.098c-.244-.112-.416-.378-.765-.166a.53.53 0 0 1-.443.058c-.387-.1-.764-.235-1.132-.376l-1.07-.592c-1.282-.764-2.339-1.979-2.879-3.398a6.626 6.626 0 0 1-.124-4.465.718.718 0 0 1 .271-.398c.318-.255.312-.253.305-.564l-.004-.24c.196-.211.541-.245.559-.662a.76.76 0 0 1 .174-.454c.244-.355.633-.564.963-.822.332-.269.716-.417 1.078-.61l.004.008.002-.012.545-.282.031-.016.033-.011.064-.021.127-.041.252-.079.514-.156.275-.08.145-.041.014-.004-.082-.001.006-.001.01-.004.037-.015.033-.019.025-.021.009-.012.007-.012.006-.013.002-.014-.002-.014-.004-.014-.006-.016-.012-.015a.36.36 0 0 0-.016-.027c-.006-.013-.014-.028-.021-.046l-.05-.122a3.62 3.62 0 0 1-.05-.123.544.544 0 0 1-.021-.047l-.018-.028.028-.064.019-.062.012-.06.006-.062c.008-.08.015-.172.025-.306v-.019l-.003-.019-.007-.017-.01-.017-.024-.03-.03-.029-.059-.059-.012-.015-.008-.016-.007-.017-.003-.018-.006-.174.004-.175.011-.176-.003-.175-.013-.352-.013-.175-.02-.175.002-.004-.003-.002c-.396-1.941-1.443-3.701-2.909-4.936-.09-.067-.125-.163-.154-.279-.074-.281-.087-.285-.311-.274a1.39 1.39 0 0 0-.174.018c-.092-.163-.094-.459-.41-.369a.454.454 0 0 1-.322-.017c-.237-.106-.452-.262-.684-.389-.237-.112-.473-.24-.725-.321l-.705-.176c-.237-.045-.48-.067-.72-.105-.237-.049-.487-.024-.729-.043l-.371-.013-.44.007-3.528.045a.584.584 0 0 1-.309-.099l-.322.168c-1.271.663-2.539 1.315-3.744 2.054l-1.064-.024c-.188.581-.508 1.033-1.066 1.286-.209.097-.402.23-.601.345-.101.058-.204.104-.3.15-.277-.008-.564-.023-.872-.034.003.008.01.016.013.023.062.145.131.211.265.176a.3.3 0 0 1 .315.084c1.676.935 3.188 2.214 4.332 3.79.124.157.182.33.144.52-.027.158-.003.246.124.291.115.045.227.104.355.162.414.695.785 1.438 1.044 2.222.038.104.003.25-.041.358-.056.145-.054.24.056.313.114.073.169.189.16.284l-.008.002.008.007.125.468.062.234.029.118.021.119.161.957.02.12.01.06.008.06.018.242.034.484.032.484.014.432.041 2.283.037.492.006.16-.001.162-.013.156-.012.075-.016.071-.001.003-.003.003-.008.006-.032.015a3.567 3.567 0 0 0-.117.04l-.42.141-.281.002c-.087-.004-.166-.006-.241-.008l-.412-.031-.412-.033-.241-.01-.281-.002-.071-.002-.069-.006-.066-.013-.063-.018-.062-.023-.059-.03-.056-.037-.053-.043-.041-.037-.041-.027-.038-.02-.019-.007-.019-.005-.019-.002h-.018l-.02.003-.018.005-.019.007-.019.01-.037.026c-.102.07-.201.141-.315.221l-.081.002-.736.004c-.003.001-.006.009-.008.009-.102.004-.203-.004-.305-.007l-1.246.007-.041-.004-.041-.011-.041-.016-.01-.005-.4.018-.036.005-.048.01a3.349 3.349 0 0 1-.119.022l-.066.007-.067-.002-.033-.005-.032-.008-.031-.012-.029-.015-.002-.004-.003-.009a.334.334 0 0 0-.006-.032l-.003-.022-.002-.014-.001-.003-.001-.002h-.004l-.035-.004-.223-.023-.084-.082a6.8 6.8 0 0 1-.064-.076l-.053-.072-.047-.07a7.597 7.597 0 0 0-.098-.145l-.062-.078-.082-.083-.02-.022-.016-.025-.011-.027-.007-.031v-.035l.004-.038.01-.042.016-.047.013-.037.009-.031.002-.025-.001-.011-.002-.009-.004-.006-.005-.006-.008-.004-.009-.002h-.011l-.012.001-.029.008-.248.063-.025-.021-.344-.328-.338-.336-.006-.007-.004-.008-.004-.02-.001-.023.003-.027.013-.06.02-.062.013-.038.008-.031.002-.025-.001-.01-.003-.009-.004-.007-.005-.006-.007-.004-.01-.002h-.01l-.014.002-.03.01-.034.01-.029.006-.025.002-.021-.003-.016-.007-.008-.004-.006-.006-.004-.007-.004-.007-.003-.017v-.006l-.003.003-2.32-2.178c-.078-.076-.112-.178-.076-.321.027-.121.01-.173-.09-.155l-.281.031c-.318-.309-.646-.615-.959-.938-.043-.042-.033-.149-.013-.239.026-.12.011-.178-.094-.153-.105.024-.171-.008-.183-.065l.001-.001-.003-.001-.066-.063-.073-.056-.156-.104-.155-.103-.073-.057-.067-.062-.004-.008-.003-.011v-.012l.002-.013.018-.062.009-.031.006-.027v-.013l-.003-.011-.005-.008-.008-.006-.039-.021-.032-.021-.05-.037-.025-.015-.026-.011-.032-.006h-.039l.002-.021.001-.03-.003-.073-.002-.073v-.029l.004-.021.002-.012.001-.01-.001-.008-.004-.004-.006-.003-.008-.001-.008.002-.011.003-.024.011-.028.018-.032.022-.008.006-.004.003h-.002v-.001l-.01-.006-.018-.009-.02-.004h-.02l-.018.004-.018.01-.015.014-.013.02-.01.025-1.223-.039-.004-.005v.007c-.19.018-.383.082-.574.102-.02.002-.037-.046-.051-.172-.012-.107-.021-.131-.031-.047-.012.075-.021.141-.032.221-.08.008-.161.022-.242.015-.011 0-.023-.083-.032-.16-.012-.103-.021-.133-.031-.042-.011.092-.023.115-.032.084v-1.014l-.008-.001v1.013l-2.651.048c-.127.254-.319.328-.615.32-.246-.018-.379-.005-.564.142-5.738 4.692-10.666 9.688-15.476 15.265l-1.034.327c-.023.239-.027.475-.066.703-.078.347-.271.598-.653.688-.212.057-.414.152-.629.223-.105.989-.104.994-.556 1.57l-.016.021.057.001.117.012.231.038.232.038.116.012.116.003v.008l.004-.008 2.993-.089c.059-.001.105.053.154.127.118.177.121.172.211.024l.068-.113c.09.092.168.341.281.096.043-.093.094-.148.15-.148.273-.007.547.11.82.104v.007l.004-.007 1.221-.04.01.025.012.02.016.015.017.01.019.004h.019l.019-.005.02-.008.008-.006.002-.001v-.001l.001.001.005.003.008.006.031.022.028.018.024.011.01.004.01.001.007-.001.005-.002.004-.005.002-.008v-.009l-.003-.013a.206.206 0 0 1-.003-.021l-.001-.029.003-.072.002-.074v-.029l-.004-.021h.041l.031-.006.027-.01.023-.015.051-.037.031-.021.04-.021.008-.006.005-.008.002-.011v-.013l-.005-.027-.009-.031-.018-.061-.002-.014v-.012l.002-.011.006-.008.066-.062.072-.056.156-.103.156-.103.072-.057.067-.062.004.004-.001-.006 1.545-1.668c.03-.032.094-.019.172.008.188.062.186.056.131-.097l-.043-.116c.111.017.33.15.219-.084-.043-.088-.055-.155-.025-.186.143-.15.371-.215.514-.366l.003.003-.001-.005.701-.756.023.013.021.006.02.002.016-.004.01-.006-.009-.009-.02-.019-.017-.012.031-.02.021-.021.013-.021.01-.021.014-.05.012-.028.016-.033.002-.004.001-.004-.002-.008-.005-.008-.008-.008-.021-.016-.027-.016-.053-.032-.01-.008-.008-.008-.004-.008-.002-.008.012-.074.02-.072.053-.144.055-.142.021-.071.012-.073h.003l-.002-.002c.404-2.12 1.617-4.09 3.386-5.361.1-.08.206-.104.342-.088.317.024.313.021.409-.199l.072-.17c.219-.015.471.133.58-.203a.475.475 0 0 1 .227-.285c.566-.193 1.168-.273 1.734-.418 2.104-.445 4.395-.077 6.242 1.087.107.07.162.173.207.293.108.288.111.283.358.276l.19-.005c.102.188.045.497.389.479a.446.446 0 0 1 .336.116c.463.389.697.965 1.057 1.428l-.006.004h.008l.076.102.037.049.018.024.015.026.112.201.208.378c.067.125.136.249.206.381l.109.204.029.054.006.014.006.015.011.028.016.043a.148.148 0 0 1 .021-.013c.029-.018.06-.035.084-.051l.031-.021.02-.017.043.028.041.019.041.012.042.007.095.009.058.008.066.013.015.002.015-.002.014-.006.013-.009.025-.023.023-.028.048-.056.013-.011.013-.008.014-.006.015-.002.14.002.026.002.006-.003.002.004.106.009.101.014c.002-.003.004-.012.006-.012l.33.039.031-.02.041-.021.042-.017.042-.01.039-.004 2.296.013.081.002c.113.079.215.149.314.221l.039.026.018.01.019.007.019.005.018.002h.019l.019-.002.019-.004.019-.007.039-.02.039-.028.043-.035.052-.044.056-.037.059-.03.061-.023.064-.018.066-.012.068-.008.072-.001.281-.002.24-.01a94.672 94.672 0 0 1 .826-.063l.24-.008.281.001c.176.059.319.106.42.141l.117.04.031.015.01.006.002.003.002.003.015.071.012.074.013.158.002.161-.007.16-.037.493-.042 2.281-.061 3.356h-.007l.007.008.089.847c.001.018-.054.03-.128.044-.176.034-.17.034-.023.06l.113.02c-.092.025-.341.048-.096.08.092.012.148.026.148.042.006.077-.109.155-.104.232l-.003.003h.005l.009.016.003.008.001.008v.008l-.001.008-.008.018-.013.018-.019.018-.025.017-.031.017-.029.016-.01.008-.008.008-.004.008-.003.008-.001.008.003.009.005.008.006.008.02.017.028.018.035.019.058.03.051.034.021.018.016.018.011.018.003.009.001.008-.001.491-.012.487-.002.034-.221.134-.026.016-.01.009-.007.008-.005.007-.003.008v.008l.002.008.005.008.007.009.02.017.027.017.037.018.043.022.037.023.029.025.024.025.018.027.013.028.006.03.002.029.002.121.01.102.033.179.017.086.015.093c.002.032.004.066.008.104a4.378 4.378 0 0 0-.002.122l-.141.182-.021.029-.004.003v.001l.001.001.002.003.007.011.014.02.018.027.004.009v.004l-.012.032-.016.03-.02.029-.021.027-.051.049-.055.043c-.038.024-.074.049-.106.068l-.044.027-.03.023-.734.643-1.072.945-.003-.002.001.005-1.991 1.982-1.936 2.035c-.076.079-.176.104-.293.116-.281.035-.281.043-.295.267l-.009.171c-.183.055-.463-.015-.438.311.01.122-.018.229-.091.305-.354.369-.798.654-1.153 1.025-1.324 1.365-2.508 2.675-3.965 4.136-.084.084-.187.11-.307.125-.289.038-.288.045-.316.279l-.028.175c-.202.051-.485-.036-.503.298a.414.414 0 0 1-.137.309c-.438.354-.902.652-1.376.968a17.778 17.778 0 0 1-5.577 2.854.556.556 0 0 1-.35-.044c-.285-.111-.286-.105-.437.083l-.114.145c-.205-.045-.41-.248-.598.046a.41.41 0 0 1-.282.188c-.567.081-1.149.052-1.71.116l-.004-.004v.004l-1.107.086-.01-.025-.012-.02-.015-.014-.016-.008-.006-.002.007.006.009.006.004.003.001.001-.092.005v-.001h.002l.008-.007.017-.009.017-.006h.018l.011.002-.023-.018-.028-.018-.023-.012-.019-.005h-.007l-.006.003-.003.004-.001.007v.009l.003.013.004.02.001.028V140.601l.001.028.003.021-.038-.002-.03.004-.025.01-.023.013a1.69 1.69 0 0 1-.048.034l-.03.019-.037.019-.004.003-.004.003-.004.008-.002.01v.012l.006.027.01.03.019.06.002.014v.011l-.002.01-.005.008-.062.058-.068.052-.147.093-.147.094-.069.051-.063.059h-.002v.002l-4.607 4.682a.57.57 0 0 1-.33.146c-.309.058-.31.065-.347.309l-.026.187c-.204.072-.501.016-.507.366a.473.473 0 0 1-.13.337c-.422.426-.93.765-1.353 1.192l-4.608 4.682c-.091.091-.2.124-.329.146-.309.057-.31.065-.347.309l-.027.186c-.203.073-.5.017-.506.367a.472.472 0 0 1-.129.337c-.422.426-.931.765-1.354 1.191l-4.607 4.683c-.092.091-.201.123-.33.146-.309.057-.31.065-.347.309l-.026.186c-.204.073-.501.017-.508.367a.464.464 0 0 1-.129.336c-.422.427-.93.766-1.353 1.192l-.006-.001.005.005-.004.017-.004.007-.004.007-.006.005-.006.005-.018.007-.021.002-.025-.001-.029-.007-.033-.011-.03-.01-.013-.002h-.011l-.009.002-.008.004-.005.005-.004.007-.003.009v.011l.002.025.008.031.012.037.02.062.014.06.002.027v.023l-.006.02-.004.008-.005.006-.337.332-.342.322-.025.021-.248-.065-.029-.008-.012-.001h-.011l-.009.002-.007.003-.005.006-.004.007-.003.008-.001.011.003.024.008.031.013.038.016.047.01.042.004.038-.001.034-.007.031-.01.027-.016.025-.02.021-.082.083-.062.076-.098.143-.047.07-.053.071-.064.075a33.97 33.97 0 0 0-.083.08c-.093.009-.169.017-.222.021l-.035.004h-.005v.002l-.001.003-.002.014-.004.022a.314.314 0 0 1-.006.032l-.002.008-.002.004-.029.016-.031.012-.031.008-.033.005-.066.001-.065-.006-.118-.022-.049-.01-.035-.005-.938-.041-1.379-.062v-.003l-.003.004-6.095.089c-.12.001-.214-.053-.312-.127-.06.068-.12.133-.185.197.371.945.356.945.196 1.659-.298 1.409-.653 2.807-.898 4.219l-.712 4.212c-.152.177-.291.337-.428.493l-.005.13-.037.492-.003.141c.164.377.234.771.133 1.196-.048.225-.059.46-.088.688-.014.114-.04.226-.061.329l-.025.029-.059 3.256h-.01l.01.008.089 6.308c-.001.134-.045.189-.116.284-.166.212-.16.223-.006.371l.117.109c-.092.162-.306.326-.035.487.102.059.17.133.184.225.088.438.1.897.277 1.301.632 1.458 1.932 2.497 3.526 2.953.094.025.151.099.212.192.146.229.16.222.341.107l.136-.088c.125.119.225.396.452.17.084-.083.173-.129.265-.117.234.017.43.047.695.083.289.027.576.056.865.052l6.308-.089c.124-.001.222.054.324.128.249.176.256.17.445.023l.144-.113c.188.092.354.341.594.096a.442.442 0 0 1 .315-.148c.576-.006 1.152.109 1.729.104l6.307-.089c.125-.001.222.054.324.128.25.176.256.17.445.023l.145-.113c.188.092.353.341.594.096a.441.441 0 0 1 .314-.148c.576-.006 1.152.109 1.729.104l6.312-.086c.135.004.239.062.351.141.266.188.27.183.48.045l.16-.106c.201.101.36.356.637.124.105-.086.227-.144.354-.127.627.076 1.235.268 1.856.354a21.878 21.878 0 0 1 6.48 2.196c.119.062.19.151.248.275.144.29.149.287.397.264l.189-.02c.128.183.148.484.497.406a.5.5 0 0 1 .37.048c.515.338.957.777 1.462 1.122 1.811 1.29 3.475 2.72 5.031 4.208a.554.554 0 0 1 .151.322c.056.306.063.306.304.338l.183.023c.071.201.013.495.36.496.13 0 .247.037.332.123.417.412.734.913 1.146 1.328l4.416 4.473c.086.087.114.192.133.317.047.3.056.3.291.329l.18.021c.065.195.006.483.348.475a.43.43 0 0 1 .324.109c.405.393.729.867 1.146 1.24a44.09 44.09 0 0 0 4.729 3.782c.095.07.143.16.182.276.098.276.107.276.34.254l.176-.02c.098.174.095.47.418.391a.401.401 0 0 1 .328.039c.468.271.879.64 1.353.91 1.747.932 3.592 1.628 5.479 2.145.112.027.185.103.259.198.182.229.19.227.398.129l.156-.076c.148.132.243.418.517.231a.424.424 0 0 1 .321-.093c.529.088 1.038.304 1.572.392l.006.008.001-.009.028-.007.031-.001.03.005.032.011.03.017.03.021.029.028.027.034.025.032.014.012.014.009.015.006.015.005.016.001h.015l.017-.003.016-.005.034-.017.036-.023.039-.031.064-.052.07-.044.036-.017.035-.013.034-.007h.033l.921.101.229.028.115.009.115.005.461.021.066.004.246.229.029.027.016.011.014.008.016.005.014.003h.016l.016-.001.015-.004.016-.007.032-.018.033-.027.035-.034.044-.043.046-.035.049-.028.05-.021.052-.016.055-.011.056-.005.058.001.229.007.194-.003.398-.03c.132-.011.263-.021.413-.031l.24-.008.281.001c.176.059.319.106.42.141l.117.04.031.015.01.006.002.003.002.003.015.071.012.074.013.158.002.161-.007.16-.037.493-.042 2.164-.061 3.12-.004.007h.004l.089 1.338c.001.025-.054.047-.128.068-.176.053-.17.055-.023.095l.113.03c-.092.04-.341.074-.096.126.092.019.148.042.148.066.006.122-.109.244-.104.366h-.003l.005.004.009.014.003.008.001.008v.008l-.001.008-.008.018-.013.017-.019.017-.025.017-.031.017-.029.016-.01.007-.008.008-.004.008-.003.008-.001.008.003.007.005.009.006.008.02.017.028.017.035.018.058.029.051.033.021.017.016.018.011.018.003.008.001.009-.001.477-.012.474-.002.033-.221.131-.026.016-.01.008-.007.008-.005.007-.003.008v.008l.002.007.005.008.007.008.02.016.027.018.037.018.043.021.037.022.029.024.024.025.018.026.013.027.006.028.002.03.002.116.01.1.033.171.017.083.015.088c.002.031.004.064.008.1a4.006 4.006 0 0 0-.002.117l-.141.173-.021.028-.004.003v.001l.001.001.002.003.009.011.014.019c.007.012.014.02.018.026l.004.009.002.004-.01.031-.015.03-.017.028-.021.026-.046.049-.051.042c-.037.025-.071.049-.102.068l-.041.027a.618.618 0 0 1-.028.022l-.697.64-1.026.939-.002-.003v.005l-2.876 3.004c-.058.058-.141.065-.241.061-.24-.008-.24-.002-.225.19l.014.147c-.152.023-.406-.076-.344.209.022.107.012.197-.043.252-.264.273-.614.459-.879.732h-.004l.002.002c-.294.316-.48.517-.775.832l-.023-.012-.022-.005-.021-.001-.018.005-.016.009-.012.013-.01.016-.006.019-.002.009.006-.097h-.006l-.01.001-.038.005-.032.006-.025.008-.018.009-.005.005-.003.006.002.005.003.006.007.006.01.007.017.012.021.019.047.051.049.051.02.02.018.013-.029.024-.021.023-.013.023-.008.024-.012.057-.01.033-.015.038-.001.005-.001.004.002.009.005.009.009.008.022.016.027.016.055.031.01.008.008.009.006.009.002.008-.008.084-.016.082-.045.165-.047.163-.016.083-.007.083h-.003l.002.003a28.504 28.504 0 0 1-1.404 6.615c-.044.124-.13.202-.237.28-.257.187-.253.193-.185.433l.053.183c-.154.155-.443.227-.307.554a.464.464 0 0 1 .006.36c-.236.561-.58 1.072-.82 1.627a56.609 56.609 0 0 1-3.094 5.788.576.576 0 0 1-.291.212c-.291.119-.289.127-.273.371l.014.186c-.184.113-.484.116-.416.46a.463.463 0 0 1-.056.354c-.324.5-.771.911-1.104 1.402-1.244 1.769-2.521 3.512-3.896 5.169-.08.098-.186.14-.311.173-.298.082-.297.09-.31.334l-.009.187c-.195.086-.494.05-.471.396.01.13-.02.249-.1.34-.383.447-.852.82-1.246 1.256a116.892 116.892 0 0 1-4.364 4.726c-.089.089-.197.121-.324.143-.304.054-.305.062-.339.302l-.023.185c-.2.07-.492.011-.498.355a.453.453 0 0 1-.127.329c-.42.41-.916.74-1.342 1.144-1.539 1.484-3.09 2.96-4.697 4.372-.095.083-.205.107-.334.119-.307.031-.308.039-.359.276l-.037.182c-.204.056-.493-.026-.521.318a.46.46 0 0 1-.15.32c-.443.384-.973.667-1.422 1.046l-.005.001.001.001c-.406.348-.666.568-1.073.916l-.024-.013-.023-.007h-.022l-.021.005-.02.01-.017.014-.016.018-.006.011.006-.001-.016.022v.001h-.001l.001-.001v-.002l.005-.01.005-.01-.01.001-.037.008-.033.009-.025.012-.009.006-.007.006-.006.006-.002.008.002.006.004.008.006.008.012.008.016.014.021.023.05.062.05.062.021.024a.175.175 0 0 1 .018.015l-.028.033-.019.031-.012.03-.006.031-.01.072-.008.044-.014.05-.001.011.003.012.006.01.008.01.023.02.028.018.056.036.011.009.009.01.005.011.003.011-.004.106-.012.106-.037.213-.037.213-.012.105-.004.107h-1.751v.004h1.751l.078 6.398c5.62 4.319 11.361 7.883 17.607 11.206.214.355.385.64.557.923.239-.033.471-.084.703-.1.359-.006.648.121.824.469.104.191.242.365.361.556.996-.135.992-.12 1.646.21 1.272.678 2.624 1.19 3.926 1.787 1.313.576 2.608 1.174 3.937 1.653l.645.848c.572-.216 1.125-.248 1.671.032.206.102.431.17.644.254.108.043.209.095.305.141l.661.909c1.03.376 2.143.696 3.226 1.083.473.168.896.067 1.332-.076a.758.758 0 0 1 .885.324c.258.406.593.672 1.07.792 1.015.256 2.016.532 3.016.819.571.167 1.12.241 1.666-.038.053-.024.201.042.25.102.547.722 1.276.968 2.125.626.393-.16.599-.055.813.229.14.202.233.297.462.35 7.246 1.56 14.221 2.293 21.583 2.585l.902.591c.201-.134.388-.28.591-.396.32-.16.637-.171.945.066.176.128.377.224.566.344.84-.553.842-.538 1.574-.523 1.441.059 2.881-.072 4.314-.099 1.433-.065 2.861-.059 4.267-.211l.948.481c.422-.443.906-.714 1.52-.7.229.001.462-.035.69-.053.115-.009.229-.006.335-.006l.989.531c1.097-.061 2.233-.296 3.378-.411.498-.056.837-.332 1.167-.651a.76.76 0 0 1 .938-.096c.405.24.828.376 1.312.28a95.142 95.142 0 0 1 3.069-.584c.588-.101 1.113-.275 1.485-.766.036-.045.199-.05.269-.018.811.444 1.578.361 2.191-.329.285-.317.516-.312.832-.15.213.121.338.166.568.112 6.434-1.535 12.39-3.572 18.397-6.076l.002-.078zm-43.468-187.464.031-.413.088-1.126.004-.048.008-.047.021-.089.026-.086.031-.08.036-.076.042-.07.049-.065.055-.06.045-.046.036-.046.028-.044.019-.044.013-.045.004-.023.002-.023-.004-.05-.014-.053-.052-.218-.048-.237.027-.104.026-.09.015-.045.018-.044.067-.175.139-.352.071-.174.086-.168.174-.334.089-.166.022-.042.025-.039.051-.079.207-.312.105-.156.054-.077.059-.073.238-.288.036-.038.042-.033.047-.031.05-.027.052-.023.052-.021.053-.016.053-.012.063-.015.056-.018.049-.021.042-.026.019-.015.016-.017.015-.019.013-.02.012-.021.008-.023.014-.054.013-.057.019-.054.023-.05.028-.046.031-.041.034-.036.018-.016.02-.013.039-.021h.014l-.006-.007c.024-.044.019-.122.041-.168.004-.004.037.029.123.123l.044.047h.004c-.005-.007-.001-.003-.013-.017l-.137-.172c.01-.02.016-.043.036-.05 0 0 .058.06.109.117.069.077.09.099.033.027-.058-.072-.069-.092-.048-.069l.135.16h.012l-.138-.164.202-.17.103-.084.051-.043.054-.037.432-.302.109-.075.054-.037.057-.033.228-.132.459-.256.477-.22.238-.107.246-.088.495-.173.505-.133.347-.085.351-.057.143-.021a3.339 3.339 0 0 1-.002-.102l-.042-2.283-.037-.492-.007-.16.002-.162.013-.156.012-.075.015-.071.002-.003.002-.003.01-.006.031-.015.117-.04.42-.141.281-.002c.086.004.166.006.24.008l.413.031.413.033.24.01.281.002h.016c.01-.004.019-.017.027-.017.368-.008.736.006 1.1.015l.058-.002 2.296-.013.039.004.042.011.042.016.033.017 1.586-.029.492-.037.16-.007.162.002.156.013.075.012.071.015.003.002.003.002.006.009.014.032.041.117.141.42.002.281c-.004.086-.006.166-.008.24l-.031.413-.033.413-.01.24-.002.281-.002.072-.006.068-.013.066-.018.064-.024.061-.029.059-.037.056-.043.052-.037.043-.027.04-.02.038-.007.019-.005.019-.002.019v.019l.003.018.005.019.007.019.01.019.026.038.221.314.002.081.003.574c.001.003.01.006.01.009.004.119-.003.236-.007.354l.007 1.358-.004.039-.011.042-.016.042-.021.041-.02.031c-.01.149-.02.299-.028.447l.002.007.028.068-.018.03-.021.05-.001.003-.001.008.004.017.001.039-.004.037-.009.032v.01h-.046l-.044.114-.021.049-.016.029-.012.017-.006.016-.004.015-.002.015.002.014.006.014.007.013.009.013.025.021.033.02.037.016.01.004.006.001.65.5.024.02.052.036.057.034.057.03.057.024.055.019.052.012.024.002.023.001.021-.003.02-.004.495.283.059.035.053.042.104.084.201.166c.131.11.257.219.382.326l.092.081.046.04.021.022.02.022.156.187.308.378.152.194.077.1.062.11.253.464.129.247.064.127.033.065.008.016.006.018.012.035-.016.006.021.005c.559 1.312.603 2.812.177 4.177a6.067 6.067 0 0 1-2.588 3.328c-.258.146-.514.228-.744.204-.195-.014-.329-.017-.443.116-.112.115-.244.225-.389.352-.287.104-.586.139-.889.17l-.453.046-.228.019-.161.002-1.275.002c-.115 0-.245-.083-.339-.16-.126-.104-.224-.133-.331-.042-.109.092-.239.115-.332.083l-.008-.012v.01l-3.355.062-2.283.041-.492.037-.16.006-.162-.001-.156-.013-.075-.012-.071-.016-.003-.001-.003-.003-.006-.008-.014-.032-.041-.117-.141-.42-.002-.281c.004-.087.006-.166.008-.241l.031-.412.033-.412.01-.241.002-.281.002-.071.006-.069.013-.066.018-.063.024-.062.029-.059.037-.056.043-.053.037-.042.027-.04h-.135c-.016-.018-.016-.038 0-.06l-.01-.205c-.057-.029-.108-.062-.108-.094-.006-.22.004-.437.011-.654l-.008-1.406-.022-.118-.007-.066.002-.067.005-.032.008-.033.012-.03.001-.001-.001-.127-.569.003-.039-.004-.042-.011-.042-.016-.041-.021-.038-.024-.886.016-2.283.042-.492.037-.16.007-.162-.002-.156-.013-.075-.012-.071-.015-.003-.002-.003-.002-.006-.009-.014-.032-.041-.117-.141-.42a23.588 23.588 0 0 0-.004-.523zM290.013 146.363l.003.011.014.037.017.033.017.021-.052-.107.001.005zM296.403 170.302l.387.066.354.047.359.034.402.024.01.025.016.021.018.016.021.011.021.006.025.002.023-.003.024-.007.011-.005.002-.001h.002l.059-.007.904-.896.059-.056.154-.027.004-.003.074-.06.084-.078.096.095.012-.002.02-.007.019-.008.017-.01.014-.011.014-.013.012-.015.01-.017.008-.018.014-.041.009-.048.005-.056.006-.068.004-.022c-1.346-.27-2.794-.842-3.957-1.859a.893.893 0 0 1-.262-.415c-.128-.378-.129-.376-.416-.476l-.217-.078c-.05-.129-.059-.275-.096-.393-.017-.09-.062-.152-.209-.144-.109.008-.195-.014-.244-.083-.244-.311-.422-.813-.863-.918l-.003-.005-.001.003-.059-.01-.059-.006-.057-.003-.056-.001-.214.004-.4.01-1.017.023-.009-.014-.012-.012-.012-.011-.015-.009-.032-.015-.006-.002.034.053c.01.013.019.023.025.033l.02.02-.022.053-.014.049-.004.047-.001.048.006.109.001.142.002.017.005.016.009.015.01.013.028.023.032.021.064.043.014.012.011.013.009.014.005.015.052.307.041.309.024.153.03.151.039.149.023.072.027.071-.003.008.004-.002a5.254 5.254 0 0 0 2.415 2.716c.064.034.09.11.109.206.057.225.066.227.235.145l.129-.066c.063.132.069.403.302.232.086-.062.17-.095.238-.069.338.116.664.329 1.039.404v.001h.005zM320.931 196.315c-.236-.348-.174-.572.062-.845.17-.182.244-.294.25-.529-.109-7.417-.941-14.382-2.299-21.619l.338-.862-.907-.853c-.04-.039-.032-.108-.013-.193.045-.204.039-.202-.125-.159l-.127.034c.005-.125.129-.354-.121-.257-.095.036-.168.041-.206.004-.188-.18-.29-.445-.479-.626l.925-.925-.002-.003-.926.926c-.338-.317-.553-.52-.893-.837l.012-.024.005-.022-.001-.021-.005-.019-.01-.016-.014-.014-.017-.011-.02-.007-.01-.002h-.002v-.001l-.001-.005-.001-.011-.008-.037-.008-.033-.009-.024-.005-.01-.006-.007-.006-.005-.005-.002-.007.001-.006.004-.006.007-.007.011-.013.016-.02.021-.055.05a2.243 2.243 0 0 1-.053.051l-.021.021-.012.017-.029-.028-.026-.019-.026-.012-.027-.006a.808.808 0 0 0-.062-.01l-.037-.008-.043-.014-.01-.001-.009.003-.009.006-.009.008-.017.023-.016.028-.03.056-.009.011-.008.009-.009.005-.009.003-.092-.004-.092-.012-.183-.037-.183-.037-.092-.012-.092-.004v-.003l-.004.003-7.199.089c-.141.001-.252-.054-.369-.128-.285-.176-.292-.17-.509-.023l-.164.113c-.215-.092-.402-.341-.678-.096a.539.539 0 0 1-.359.148c-.575.005-1.151-.072-1.728-.091l.113.118 2.332 2.42.002.01.004-.005c.095.07.215.114.311.185.006.004-.029.046-.078.103l-.045.056.016.003c.014-.011.011-.007.03-.024l.086-.074c-.022.028-.06.07-.089.105l.021.004c.01-.008.01-.006.023-.019a.478.478 0 0 1 .117-.093c.027.019-.033.123-.006.142l-.001.001.005.001.018.004.008.005.008.005.006.006.005.007.009.019.004.022-.001.026-.005.031-.01.034-.008.033-.001.013.001.011.002.01.004.008.006.006.008.005.01.003.011.002.026-.002.033-.006.039-.012.064-.018.062-.01.028-.002.025.003.02.006.01.005.006.006.373.374.363.378.023.028-.053.258-.007.031-.001.013.001.012.003.009.004.008.006.006.008.004.009.003.011.002.025-.002.033-.007.039-.012.049-.014.043-.008.041-.003.036.004.033.008.03.013.027.018.023.022.094.09.084.071.076.054.07.046.07.046.072.053c.023.021.049.042.076.065l.082.083.023.223.004.035v.005l.002.001h.004l.012.002.023.004a.286.286 0 0 1 .031.006l.01.002.004.002.015.03.012.03.008.033.005.032.002.067-.007.066a1.964 1.964 0 0 0-.022.119c-.004.018-.008.033-.01.048l-.005.036-.022.578-.018.349-.031.35-.053.514-.064.514-.078.513-.092.511-.005-.001.004.006c-.317 1.971-.985 3.945-2.077 5.678-.062.103-.158.152-.277.193-.281.1-.276.105-.262.339l.011.178c-.182.095-.471.069-.42.399.019.125.001.243-.072.33-.347.439-.809.769-1.192 1.16a18.828 18.828 0 0 1-4.773 3.495c-.103.052-.207.043-.326.019-.283-.058-.285-.054-.381.154l-.072.158c-.027-.002-.055-.01-.083-.015l-.032 1.737-.061 3.355-.009.008h.009l.089 1.451c.001.029-.054.051-.128.075-.176.058-.17.059-.023.103l.113.033c-.092.043-.341.081-.096.137.092.021.148.045.148.072.006.133-.109.265-.104.397h-.001l.003.004.009.014.003.008.001.008v.008l-.001.009-.008.016-.013.018-.019.017-.025.017-.031.017-.029.015-.01.008-.008.008-.004.008-.003.008-.001.008.003.008.005.008.006.008.02.016.028.018.035.018.058.029.051.033.021.018.016.017.011.018.003.008.001.009-.001.477-.012.475-.002.033-.221.131-.026.016-.01.008-.007.007-.005.008-.003.008v.007l.002.008.005.008.007.008.02.016.027.017.037.018.043.022.037.022.029.024.024.025.018.026.013.027.006.028.002.029.002.117.01.1.033.171.017.083.015.088c.002.031.004.064.008.1a4.07 4.07 0 0 0-.002.117l-.141.174-.021.027-.004.003v.001l.001.001.002.003.009.011.014.019.018.027.004.008.002.004-.01.031-.015.03-.017.028-.021.027-.046.048-.051.043-.102.068-.041.026a.695.695 0 0 1-.029.023l-.697.639-1.027.939-.002-.002v.004l-4.367 4.494c-.088.087-.193.117-.318.137-.301.051-.301.059-.33.296l-.021.182c-.196.067-.488.007-.484.35a.437.437 0 0 1-.116.326c-.4.409-.888.731-1.288 1.141-1.469 1.478-2.862 3.02-4.5 4.508-.096.085-.206.11-.334.125-.309.036-.309.044-.357.284l-.037.183c-.204.058-.491-.028-.516.315a.445.445 0 0 1-.145.317c-.442.383-.943.659-1.366 1.028-1.542 1.344-2.856 2.699-3.829 4.262a.555.555 0 0 1-.26.174c-.258.102-.258.113-.213.334l.037.168c-.16.098-.453.111-.342.412.043.113.047.22-.005.311-.196.474-.509.9-.712 1.38-.631 1.81-1.053 3.732-1.313 5.72-.019.116-.087.199-.176.285-.214.21-.21.218-.093.416l.098.152c-.109.167-.373.295-.154.556.083.098.129.206.116.319-.052.551-.226 1.09-.276 1.643a90.598 90.598 0 0 0-.164 6.135c-.002.121-.057.215-.133.315-.181.243-.176.249-.031.436l.11.141c-.095.183-.347.344-.106.59.091.092.145.2.143.319-.006.584-.133 1.165-.139 1.748a50.314 50.314 0 0 1-.088 3.197c-.066 1.068-.068 2.136-.213 3.206-.014.126-.08.22-.166.316-.205.233-.201.239-.078.448l.096.16c-.113.181-.381.314-.167.591.081.104.123.22.108.34-.051.588-.266 1.155-.373 1.739-.346 2.133-.779 4.279-1.492 6.377a.582.582 0 0 1-.234.279c-.255.188-.251.193-.181.432l.056.183c-.153.155-.443.225-.301.553a.503.503 0 0 1 .025.368c-.254.562-.627 1.067-.885 1.623-.422 1.035-1.092 1.972-1.66 2.951-.285.491-.689.912-1.033 1.371-.374.435-.682.928-1.126 1.304-.099.094-.216.129-.351.153-.322.059-.32.064-.372.313l-.038.19c-.215.074-.508.006-.541.37a.527.527 0 0 1-.159.348c-.296.244-.634.432-.968.624l.219.157.002-.002c.731.542 1.475 1.094 2.225 1.648.154.116.371.084.529.199s.254.381.412.496l4.002 2.926c.274.2.338.623.609.821.221.161.654.096.878.254l3.595 2.583 2.225 1.647c.154.117.371.085.529.199.158.115.254.381.412.496l2.876 2.103a141.482 141.482 0 0 0 7.206-7.777l1.035-.327c.023-.239.027-.475.066-.703.078-.347.271-.599.652-.688.212-.057.414-.152.629-.223.105-.99.104-.994.557-1.57l2.633-3.419c.867-1.142 1.646-2.339 2.467-3.487l.983-.43c-.081-.604.034-1.135.417-1.613.139-.182.25-.391.373-.583.062-.098.133-.187.196-.271l1.011-.457c.614-.909 1.193-1.91 1.83-2.868.278-.417.25-.869.202-1.328a.759.759 0 0 1 .49-.806c.436-.17.786-.428 1.017-.863l1.51-2.734c.275-.527.455-1.054.295-1.654-.014-.058.08-.19.146-.225.826-.372 1.254-1.016 1.121-1.914-.062-.416.092-.59.422-.733.232-.09.348-.158.455-.368 3.135-6.719 5.395-13.361 7.294-20.475l.802-.741c-.081-.225-.178-.438-.239-.659a.86.86 0 0 1 .288-.903c.16-.145.293-.32.449-.479-.371-.945-.356-.944-.196-1.658.298-1.41.653-2.807.898-4.22l.711-4.212.706-.813c-.32-.507-.508-1.043-.365-1.639.048-.225.059-.46.088-.687.014-.115.04-.226.061-.33l.718-.85c.153-1.087.283-2.235.397-3.379.045-.5-.157-.893-.403-1.285a.758.758 0 0 1 .095-.938c.32-.344.525-.728.545-1.22.033-1.046.157-2.079.16-3.12.02-.595-.046-1.147-.451-1.619-.037-.045-.01-.205.035-.266.589-.7.694-1.466.187-2.217z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "none",
                    d: "m131.971 111.847-.02-.024.009.013.011.011zM104.638 268.927c0-.132.053-.235.127-.346.176-.266.171-.271.023-.475l-.113-.152c.092-.201.34-.376.094-.633a.485.485 0 0 1-.148-.336c-.007-.613.108-1.227.102-1.842l-.1-6.719c-.001-.132.053-.235.127-.346.176-.266.17-.271.023-.474l-.113-.153c.092-.201.342-.383.083-.604a.428.428 0 0 1-.162-.297c-.017-.272.006-.549.016-.823-.011-.269-.02-.539-.058-.807-.044-.496-.221-.941-.318-1.414-.18-.438-.294-.905-.53-1.312-.388-.855-.952-1.616-1.587-2.344-.078-.085-.097-.188-.106-.31-.028-.293-.03-.301-.265-.324l-.18-.016c-.063-.188-.008-.479-.342-.462a.434.434 0 0 1-.32-.097c-.426-.359-.779-.813-1.251-1.158-1.687-1.271-3.63-2.4-5.518-3.744a.63.63 0 0 1-.215-.314c-.118-.305-.126-.303-.382-.309l-.197-.004c-.111-.199-.104-.511-.465-.481a.517.517 0 0 1-.369-.101c-.516-.391-.933-.914-1.428-1.336-1.781-1.585-3.423-3.431-4.677-5.523a.628.628 0 0 1-.084-.384c.021-.341.014-.342-.217-.465l-.177-.093c-.021-.237.115-.515-.231-.65a.536.536 0 0 1-.299-.259c-.265-.608-.438-1.257-.679-1.868-.883-2.238-1.441-4.562-1.773-6.887-.02-.138.02-.252.078-.375.137-.298.131-.303-.043-.495l-.134-.146c.062-.219.304-.424.036-.666a.507.507 0 0 1-.175-.335c-.049-.638-.006-1.284-.027-1.919h.001l-.002-.003-.01-.016-.004-.009-.002-.009v-.009l.002-.009.006-.02.014-.02.018-.02.025-.02.03-.02.028-.019.01-.009.008-.009.004-.009.002-.009v-.009l-.002-.008-.005-.009-.007-.009-.02-.018-.029-.018-.035-.019-.059-.031-.052-.035-.021-.019-.017-.019-.011-.019-.003-.01-.002-.009-.012-.536-.002-.532.002-.038c.078-.054.146-.102.217-.148l.025-.019.01-.009.008-.008.004-.009.002-.009v-.008l-.002-.009-.005-.009-.007-.009-.02-.017-.029-.019-.036-.02-.044-.024-.037-.025-.031-.026-.024-.028-.019-.029-.013-.031-.008-.031-.003-.034-.004-.131-.013-.111c-.013-.063-.022-.119-.034-.175l-.017-.083-.015-.088c-.002-.031-.004-.063-.008-.1a4.07 4.07 0 0 0 .002-.117l.141-.173.021-.028.004-.003v-.001l-.001-.001-.002-.003-.009-.011-.014-.019a.213.213 0 0 0-.018-.026l-.004-.009-.002-.004.01-.032.015-.029.017-.028.021-.027.046-.048.051-.043.102-.068.041-.027.029-.021.714-.656 1.06-.973.002.002v-.005l2.891-3.017c.058-.059.141-.065.242-.062.242.009.24.001.226-.191l-.013-.147c.152-.023.406.076.346-.211-.023-.107-.014-.197.042-.252.266-.274.618-.462.884-.736l.003-.001-.001-.001.836-.893.024.012.022.004h.021l.019-.006.017-.01.013-.014.011-.016.006-.02.003-.011v-.001l.001-.001.006-.001.01-.001.037-.007.033-.008.025-.01.009-.005.007-.005.006-.006.002-.006-.002-.006-.004-.006-.006-.007-.012-.007-.016-.012-.021-.021-.05-.054a1.89 1.89 0 0 1-.05-.054l-.021-.021-.018-.013.028-.028.019-.027.012-.025.006-.027.01-.062.008-.037.014-.043.001-.01-.003-.01-.006-.008-.008-.009-.023-.017-.028-.016-.056-.031-.011-.008-.009-.008-.005-.01-.003-.009.004-.091.012-.092.037-.183.037-.183.012-.092.004-.092h.365l-.001-.003h-.364c-.018-.128-.07-.255-.089-.383-.001-.008.054-.014.128-.02l.079-.007-.01-.017-.046-.004-.113-.009c.037-.005.098-.01.143-.014l-.01-.019c-.016-.001-.016-.003-.037-.004-.092-.005-.148-.012-.148-.019-.006-.035.109-.07.104-.105h.005l-.005-.008c-.016-1.119-.024-1.831-.039-2.951l.013-.01.013-.013.01-.015.01-.016.014-.037.01-.041.004-.044v-.046l-.004-.046-.01-.045-.012-.042-.016-.037-.02-.033-.021-.024-.013-.01-.013-.007-.014-.005-.014-.002-.015.001-.015.004-.016.007-.017.011-.029.016c-.014.006-.03.014-.049.021l-.13.05c-.045.019-.092.036-.13.051l-.05.021-.03.017-.068-.028-.064-.019-.063-.012-.066-.006a4.448 4.448 0 0 0-.149-.01l-.193-.021-.023-.001-.022.003-.021.006-.021.008-.039.023-.038.028-.037.029-.037.026-.02.011-.021.009-.021.005-.023.003-.22-.004-.221-.012-.441-.037-.442-.037-.221-.012-.221-.004-.008-.008v.008l-3.491.089c-.068.001-.122-.054-.18-.128-.138-.176-.142-.17-.246-.023l-.079.113c-.105-.092-.195-.341-.329-.096-.05.092-.109.148-.175.148-.318.006-.637-.109-.957-.104l-.003-.002v.004l-.015.009-.008.003-.008.001h-.009l-.008-.001-.017-.008-.017-.013-.018-.019-.016-.025-.014-.025-.079-.048-.001.001-.016.021-.018.027-.018.035-.029.058-.033.052-.018.021-.018.016-.017.011-.009.003-.008.001-.477-.001-.475-.012-.033-.002-.131-.221-.016-.026-.008-.01-.008-.007-.007-.005-.008-.003h-.007l-.008.002-.008.005-.008.007-.016.02-.018.027-.017.037-.022.043-.022.037-.024.03-.025.023-.026.018-.027.013-.028.006-.029.002-.117.002-.1.01-.171.033-.083.017-.088.015c-.031.002-.064.004-.1.008l-.117-.002-.174-.141-.027-.022-.003-.002-.001-.001-.002.001-.002.002-.011.008-.019.014-.027.019-.008.004-.004.002-.031-.011-.031-.014-.027-.017-.027-.021-.049-.046-.042-.052-.068-.101-.026-.041a.22.22 0 0 1-.023-.029l-.639-.697-.529-.578c.394 4.301 1.014 8.545 1.828 12.886l-.396 1.014c.172.167.352.317.504.491.221.277.295.585.125.939-.089.201-.143.42-.222.631.749.691.735.697.904 1.409l1.011 4.194 1.197 4.1-.279 1.038c.52.314.861.735 1.012 1.327.055.223.148.439.223.655.037.11.062.221.088.323l-.273 1.075c.326 1.048.746 2.125 1.096 3.221.172.471.529.735.922.982a.756.756 0 0 1 .324.885c-.139.447-.156.882.041 1.333.422.957.774 1.936 1.201 2.884.242.544.541 1.013 1.111 1.261.053.024.098.182.083.256-.224.877.015 1.613.798 2.068.364.211.405.439.312.787-.073.237-.096.372.007.584h-.001c3.303 6.638 7.097 12.542 11.476 18.463l.078 1.091c.226.077.452.136.663.226.312.16.534.389.542.777.013.215.066.43.093.651.968.302.958.312 1.413.886a57.25 57.25 0 0 0 1.711 2.11l-.046-3.275zM273.495 177.896l.183.037c.056.206-.022.496.323.523.131.01.245.057.324.147.389.442.688.966 1.078 1.408l4.308 4.818c.084.095.108.205.122.334.036.309.045.31.283.359l.182.036c.059.205-.018.496.329.521.042.003.079.017.118.027-.578-1.241-1.382-2.418-2.297-3.535-.07-.089-.086-.192-.09-.312-.012-.29-.02-.294-.246-.334l-.174-.027c-.045-.19.043-.476-.293-.479a.404.404 0 0 1-.307-.119c-.369-.393-.66-.866-1.055-1.248-.994-.973-2.064-1.893-3.161-2.807.057.085.083.18.095.289.032.309.041.31.278.362zM267.912 152.896l-.003-.011-.018-.037-.004-.007.026.06-.001-.005zM223.282 207.411l-.017-.033-.021-.024-.006-.006.062.116-.001-.005-.004-.011-.013-.037zM291.433 164.445l-.01.003-.037.014-.031.017-.025.019-.008.009-.007.011-.005.01v.011l.001.011.005.011.008.011.012.011.015.017.089-.153h-.001v.001l-.006-.003z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M295.249 196.415c.107-.026.131-.047.047-.069l-.221-.071c-.008-.177-.022-.355-.015-.535 0-.023.083-.052.16-.071a.273.273 0 0 0 .077-.03l-.043-.042c-.082-.022-.105-.049-.076-.067h.01l-.008-.008-.004-.221-.012-.222-.037-.441-.037-.441-.012-.221-.004-.22.003-.022.005-.021.009-.021.011-.02.025-.037.03-.037.028-.038.023-.039.008-.021.006-.021.003-.022-.001-.023a6.887 6.887 0 0 1-.021-.193l-.01-.149-.006-.066-.012-.063-.019-.064-.028-.068.018-.03.021-.05c.014-.038.031-.085.05-.13l.05-.13.021-.049.016-.029.012-.017.006-.016.004-.015.002-.015-.002-.014-.006-.014-.007-.013-.009-.013-.025-.021-.033-.02-.037-.016-.043-.013-.044-.009-.046-.004h-.046l-.044.004-.041.01-.037.014-.016.01-.014.01-.014.013-.01.013-2.951-.039v-.025l-.008.001v.026l-4.137.102a.427.427 0 0 1-.365-.172c-.086-.107-.15-.131-.226-.047l-.23.221c-.575.008-1.159.022-1.743.015-.061 0-.125-.052-.182-.11h-.03l-.068-.002a11.47 11.47 0 0 1-.134-.111c-.016.009-.03.003-.045.021-.075.092-.164.115-.229.084v-.259l-.004.002v.255l-1.495.06c-.095.007-.188.015-.296.022-.074.002-.154.004-.24.008l-.176-.001-.342.014-.039.005-.053.01c-.039.007-.083.015-.131.022l-.072.007-.072-.002-.036-.005-.035-.008-.034-.012-.031-.015-.003-.004-.003-.009a.379.379 0 0 1-.006-.032l-.004-.022-.002-.014-.001-.003-.001-.002-.004-.001-.037-.008-.23-.049-.086-.095-.065-.087-.1-.16-.099-.161-.065-.089-.083-.097-.021-.026-.016-.028-.011-.03-.006-.033-.001-.036.005-.04.012-.044.017-.047.015-.037.009-.032.003-.026v-.011l-.003-.009-.004-.008-.005-.006-.008-.005-.009-.003-.011-.002h-.014l-.031.005c-.082.013-.166.024-.26.038l-.025-.026-.352-.382-.346-.392-.006-.008-.004-.009-.004-.021v-.025l.003-.027.015-.062.021-.062.014-.037.009-.032.003-.026v-.012l-.003-.009-.001-.011-.005-.007-.008-.004-.01-.004-.011-.001-.013.001-.033.006-.035.008-.031.002-.025-.001-.022-.005-.017-.01-.007-.006-.006-.006-.005-.008-.003-.008-.004-.018-.002-.003-3.811-4.201c-.129-.146-.205-.306-.199-.491.004-.157-.035-.24-.168-.263l-.373-.094-1.578-1.796c-.07-.081-.088-.229-.088-.346.001-.156-.037-.246-.172-.263-.137-.017-.234-.094-.268-.181l-3.776-4.24a.693.693 0 0 1-.194-.494c.006-.158-.033-.241-.164-.266-.117-.031-.24-.063-.373-.1-.519-.598-1.047-1.202-1.559-1.825-.068-.083-.085-.229-.082-.348.004-.157-.033-.248-.168-.269-.137-.02-.233-.1-.265-.188l-1.852-2.197-.565-.712c-.187-.26-.398-.509-.549-.786-.191-.262-.255-.57-.402-.854l-.07-.959c-.014-.266.028-.504.152-.69.104-.15.127-.292.041-.388l-.222-.315-.028-2.387c0-.034.019-.069.032-.104-.013-.104-.026-.207-.037-.309l.231-.023.006-.01-.24.023-.014-.046-.01-.049-.002-.053.005-.055.011-.056.017-.056.022-.055.029-.054.027-.05.009-.024.007-.025.004-.023.002-.025v-.024l-.003-.024-.005-.025-.006-.023-.02-.039-.028-.041-.035-.043-.058-.07-.051-.08-.021-.041-.016-.042-.011-.042-.004-.039.013-2.296.002-.081.221-.314.015-.021-.01-.003-.044-.009-.047-.004h-.045l-.044.004-.04.01-.037.014-.016.01-.014.01-.014.013-.01.013-2.934-.039-.009-.008v.01l-5.522.102a.665.665 0 0 1-.488-.172c-.113-.107-.199-.131-.301-.047l-.308.221-2.327.015c-.105 0-.225-.083-.311-.16-.115-.103-.205-.133-.303-.042-.1.092-.219.115-.305.084l-5.522.102a.661.661 0 0 1-.487-.172c-.114-.107-.2-.131-.301-.047l-.309.221-2.327.015c-.104 0-.224-.083-.31-.16-.115-.103-.205-.133-.304-.042-.099.092-.219.115-.304.084l-4.93.082-1.33-1.083c-.199-.165-.348-.35-.403-.562-.06-.188-.081-.237-.222-.244a39.168 39.168 0 0 0-.377-.027l-1.797-1.479c-.081-.067-.12-.207-.137-.321-.025-.155-.074-.235-.174-.199-.107.029-.18 0-.203-.062l-.705-.561-1.422.045-2.066.036a.665.665 0 0 1-.488-.172c-.113-.107-.199-.131-.301-.047l-.308.221-2.327.015c-.105 0-.225-.083-.311-.16-.115-.103-.205-.133-.303-.042-.1.092-.219.115-.304.084l-5.523.102a.663.663 0 0 1-.487-.172c-.114-.107-.2-.131-.301-.047l-.309.221-2.327.015c-.104 0-.224-.083-.31-.16-.115-.103-.205-.133-.303-.042-.1.092-.22.115-.305.084l-.003-.004v.002l-.092.004-.091.012-.184.037-.184.037-.091.012-.091.004-.01-.003-.008-.005-.01-.009-.008-.011-.031-.056-.015-.028-.017-.023-.008-.008-.01-.006-.009-.003-.01.001-.043.014-.037.008a.735.735 0 0 0-.062.01l-.027.006-.027.012-.026.019-.028.028-.013-.017-.021-.021-.054-.051-.054-.05-.021-.021-.012-.016-.007-.011-.006-.007-.007-.004-.006-.001-.006.002-.006.005-.005.007-.006.01-.009.024-.008.033-.007.037-.001.011-.001.005v.001h-.002l-.011.002-.019.007-.018.011-.014.013-.01.017-.005.019-.001.021.006.023.011.024-.893.836-.001-.001v.005l-3.875 4.019c-.135.137-.286.222-.471.227-.156.006-.234.05-.247.183-.021.117-.041.24-.064.375l-1.653 1.674c-.074.075-.219.102-.334.108-.155.009-.24.053-.246.187-.006.137-.075.238-.158.276l-3.875 4.019c-.135.137-.287.222-.471.227-.156.007-.234.051-.248.183l-.063.376-1.653 1.674c-.074.074-.219.102-.334.107-.155.01-.24.053-.246.188-.006.136-.075.238-.158.275l-1.936 2.007-.453.475c-.101.11-.205.214-.301.327l-.459.986a.599.599 0 0 1-.355.33c-.145.051-.203.113-.168.232l.074.344c-.271.654-.449 1.354-.703 2.027-.032.091-.148.172-.248.226-.135.072-.191.145-.133.255.061.113.069.229.021.298-.143.84-.334 1.674-.428 2.52l-.105 2.558a.565.565 0 0 1-.148.455c-.1.109-.12.191-.031.282l.234.275c.03.354.025.714.084 1.067l.165 1.065c.015.095-.051.218-.114.312-.086.123-.103.214 0 .287a.302.302 0 0 1 .136.26c.247.815.397 1.661.754 2.441l.471 1.188.576 1.142a.608.608 0 0 1 .042.487c-.051.147-.031.229.094.268l.341.137c.388.594.728 1.23 1.183 1.792.059.077.058.215.043.325-.018.147.01.233.136.252.129.018.213.092.235.175 1.09 1.31 2.337 2.5 3.733 3.478a.6.6 0 0 1 .261.41c.023.15.074.219.197.206l.355-.014c.619.348 1.22.747 1.858 1.078.087.042.148.163.186.267.05.138.114.201.235.16.125-.043.234-.017.291.047.755.4 1.59.613 2.389.904.406.129.83.198 1.242.304.416.093.824.217 1.25.255a.584.584 0 0 1 .419.237c.089.121.165.157.271.088l.312-.175c.697.141 1.428.077 2.144.148.097.005.206.094.285.176.104.11.195.141.295.049.101-.092.222-.115.308-.084l5.582-.102a.674.674 0 0 1 .492.172c.115.107.201.131.304.047l.312-.221 2.352-.015c.106 0 .227.083.313.16.116.103.208.133.306.042.102-.092.223-.115.308-.084v.007l.007-.005 2.957-.061 2.084-.042.492-.037.16-.007.162.002.156.013.075.012.071.015.003.002.003.002.006.009.014.032.041.117.141.42.002.281c-.004.086-.006.166-.008.24l-.031.413c-.01.124-.021.249-.031.39a7.499 7.499 0 0 0-.004.164l.005.193-.001.049-.004.048-.012.046-.016.044-.022.043-.028.042-.036.039-.042.038-.035.031-.027.028-.019.028-.007.013-.004.014-.002.013.001.013.003.013.005.013.008.012.01.013.027.024.229.203.009.053.09.761.022.19.036.185.066.37.002.014v.014l-.006.028-.012.03-.016.03-.041.062-.047.059-.029.035-.023.033-.014.03-.005.014-.002.014v.013l.003.012.004.012.008.012.01.01.014.009.034.017.038.018.031.02.025.021.02.022.014.023.008.023.002.024-.002.023-.002.006.003-.001c.421 1.616 1.274 2.939 2.493 4.103.125.122.21.258.215.437.007.151.051.227.178.229l.37.025c.558.474 1.199.93 1.846 1.42.089.064.141.205.167.32.037.155.094.234.232.224.141-.011.258.047.312.126 1.593 1.139 3.338 2.446 4.728 4.185.138.182.22.371.21.571-.005.172.035.266.175.314.124.051.243.119.382.187.52.767.969 1.599 1.323 2.458.05.115.03.277-.001.398-.047.164-.043.273.082.35a.396.396 0 0 1 .197.307c.731 2.031 1.127 4.128 1.268 6.194.021.214-.018.401-.144.554-.103.132-.124.227-.038.336l.229.336c.038.879.04 1.678.035 2.508 0 .111-.083.238-.16.328-.103.122-.133.218-.042.321.092.105.115.231.084.321l.102 5.845c.002.2-.046.376-.172.516-.107.121-.131.212-.047.318l.221.325.015 2.464c0 .11-.083.237-.16.327-.103.122-.133.218-.042.321.092.105.115.231.084.321l.102 5.845c.002.201-.046.376-.172.517-.107.12-.131.211-.047.318l.221.325.015 2.463c0 .11-.083.237-.16.328-.103.121-.133.217-.042.32.092.105.115.231.084.321l.102 5.846c.002.2-.046.375-.172.516-.107.12-.131.211-.047.318l.221.325.015 2.463c0 .111-.083.237-.16.328-.103.122-.133.217-.042.321.092.104.115.231.084.321l-.006.008h.004l.004.221.012.222.037.441.037.441.012.221.004.221-.003.021-.005.021-.009.021-.011.02-.025.038-.03.037-.028.037-.023.039-.008.021-.006.021-.003.022.001.023.021.193.01.15.006.065.012.063.019.064.028.068-.018.03-.021.05a4.47 4.47 0 0 1-.05.131l-.05.129-.021.049-.016.029-.012.016-.006.016-.004.016-.002.015.002.014.006.014.007.013.009.012.025.022.033.02.037.016.043.013.044.008.046.005h.046l.044-.004.041-.01.037-.015.016-.009.014-.011.014-.012.01-.014 2.951.04v.006l.008-.007.858-.018-.038-.383c-.021-.217-.042-.435-.062-.627-.006-.098-.014-.189-.02-.271l-.005-.218a70.1 70.1 0 0 1 .015-.398l.027-.347c.026-.216.052-.411.077-.609l.076-.61c.01-.11.018-.226.027-.35.006-.124.01-.257.014-.4l.022-1.728.05-3.729-.176-1.428a5690.68 5690.68 0 0 0-.444-3.82l-.004-.051.001-.047.006-.044.01-.04.016-.036.018-.034.021-.03.024-.028.007-.006.002-.002v-.002l.002.001.008.004.031.017.066.038.141.085.312.201.655.435.292.179.127.068.109.05.082.036.088.046.188.117c.129.092.269.192.412.296l.217.158.219.148.219.129.107.055.105.045.195.257c.069.081.134.155.194.227l.192.198c.066.062.131.119.191.174l.189.153.189.135.188.12.188.108.755.388.191.102.192.109.194.121.196.137.643.47.317.239.31.245.023.022.023.023.043.055.042.055.048.053.213.199.198.205.092.105.085.105.076.108.066.109.092.154.1.14.105.127.114.113.124.102.134.09.146.079.157.069.96.387.326.141.262.127.23.128c.072.048.146.095.225.146l.557.406 1.266.918.309.233.297.242.28.255.133.132.127.137.098.096.165.147.5.42c.403.321.908.724 1.421 1.131l.165.125c.037.003.074.004.109.012.138.029.221.007.244-.12.023-.129.097-.21.176-.227l.996-.717c.328-.244.594-.564.895-.84.285-.294.603-.554.865-.869l.764-.971a.576.576 0 0 1 .416-.231c.15-.016.22-.062.21-.182-.001-.106-.014-.23-.024-.359.363-.592.732-1.191 1.102-1.791.041-.087.16-.146.263-.183.137-.048.199-.11.157-.233-.043-.125-.017-.234.046-.291.355-.768.726-1.527.962-2.363.266-.818.566-1.618.745-2.478a.604.604 0 0 1 .284-.4c.129-.077.174-.15.116-.265l-.14-.335c.198-.695.313-1.431.451-2.162.018-.099.119-.195.211-.262.121-.09.166-.17.094-.278-.074-.109-.076-.226-.029-.3.174-.857.231-1.748.32-2.63.086-.883.18-1.764.209-2.659a.626.626 0 0 1 .202-.459c.113-.104.144-.185.065-.288-.062-.099-.129-.2-.201-.312.037-.744.092-1.494.1-2.256.002-.102.087-.215.166-.297.105-.108.137-.195.049-.294-.091-.1-.111-.216-.078-.298l-.002-5.496c.001-.191.052-.357.181-.486.108-.111.132-.196.055-.302l-.202-.32.117-2.364c.007-.105.096-.221.178-.303.109-.108.145-.197.061-.303-.09-.108-.096-.232-.057-.316l.246-2.815c.133-.945.259-1.893.42-2.839.045-.195.131-.355.287-.464.131-.094.176-.175.117-.297l-.14-.364.276-1.193.387-1.193c.035-.107.152-.202.254-.263.137-.082.193-.162.141-.293-.053-.132-.037-.263.033-.336.701-1.851 1.667-3.696 2.957-5.272.135-.16.289-.268.478-.294.16-.024.237-.078.247-.219.01-.132.039-.254.064-.393.573-.603 1.158-1.2 1.771-1.724.082-.074.229-.096.346-.098.157-.004.246-.039.262-.172.016-.135.092-.231.178-.263 1.4-1.233 2.744-2.395 3.955-3.632a.64.64 0 0 1 .457-.199c.154-.006.232-.049.244-.18l.06-.371 1.624-1.645c.074-.074.217-.1.331-.104.153-.008.237-.05.243-.183.004-.136.071-.236.154-.272l3.806-3.95a.656.656 0 0 1 .464-.221c.156-.004.232-.047.244-.178l.061-.372 1.624-1.645c.073-.073.216-.099.331-.104.153-.008.238-.05.242-.183.005-.136.072-.235.154-.272h.006l-.002-.002.062-.066.056-.073.103-.156.104-.155.057-.073.062-.066.008-.005.01-.003h.012l.014.002.061.018.031.009.028.006h.012l.011-.003.008-.005.006-.008.021-.039.021-.032.037-.05.014-.024.011-.026.006-.033v-.039l.021.003.029.001.074-.003.074-.003.028.001a.206.206 0 0 1 .021.003l.012.003h.01l.008-.001.004-.004.003-.006.001-.007-.002-.009-.003-.011-.011-.024-.018-.028-.021-.031-.007-.009-.003-.004v-.001l.001-.001.005-.009.01-.019.004-.02v-.019l-.004-.019-.01-.017-.014-.016-.02-.013-.025-.01c.015-.463.023-.759.039-1.222l.004-.004h-.006l-.102-1.271c.008-.051.056-.089.182-.119zM190.461 72.87c-.423.443-.907.713-1.521.699-.229-.001-.461.035-.689.053-.115.009-.229.006-.336.007a441.92 441.92 0 0 0-.988-.532c-1.098.061-2.234.297-3.378.411-.499.056-.837.332-1.167.651a.761.761 0 0 1-.939.096c-.404-.24-.828-.376-1.311-.28a98.016 98.016 0 0 1-3.07.584c-.587.101-1.113.274-1.484.765-.037.046-.199.051-.27.019-.811-.444-1.577-.361-2.191.329-.284.316-.516.312-.832.149-.212-.12-.338-.164-.564-.112a109.28 109.28 0 0 0-6.461 1.759c-.021.029-.045.056-.048.104l-.054.387-1.627 1.822c-.073.082-.219.119-.336.135-.158.02-.244.07-.245.207-.002.14-.068.248-.151.293l-1.301-1.176-.002.003 1.299 1.174-.954 1.147-.649.779-.022.032-.026.045-.07.11-.043.057-.049.053-.027.022-.029.021-.03.018-.032.013-.005-.001-.009-.004-.027-.017-.02-.013-.012-.007-.002-.002-.002-.001v.001l-.004.002-.029.022-.188.141-.125.002c-.037-.004-.073-.006-.106-.008l-.183-.031-.184-.033-.107-.01-.125-.002-.031-.002-.031-.006-.029-.013-.027-.018-.027-.023-.026-.03-.024-.037-.023-.043-.02-.037-.018-.027-.017-.02-.009-.007-.008-.005-.008-.002h-.008l-.009.003-.008.005-.009.007-.008.01-.017.026-.14.221-.036.002-.509.012-.511.001-.009-.001-.01-.003-.018-.011-.019-.016-.019-.021-.035-.052-.031-.058-.02-.035-.018-.027-.018-.021-.009-.006-.009-.005-.008-.002h-.009l-.008.003-.009.004-.008.008-.008.011-.017.028-.018.031-.018.025-.019.019-.018.013-.018.008-.01.001h-.008l-.009-.001-.008-.003-.015-.009v-1.753h-.004v1.753l-5.029.102a.57.57 0 0 1-.443-.172c-.104-.107-.183-.131-.274-.047l-.28.221-1.779.012c-.041.076-.087.15-.13.224.11.019.221.038.331.054.139.019.273.15.364.25.122.138.226.195.374.141a.492.492 0 0 1 .408.022 12.73 12.73 0 0 1 3.277 1.562 12.01 12.01 0 0 1 2.643 2.508c.146.203.234.41.229.621-.005.183.045.279.178.351.125.066.248.148.39.234.536.862.916 1.822 1.218 2.8.033.133-.01.307-.059.434-.065.17-.068.287.05.391.118.104.181.252.169.365l-.004.006.004.004.14.904.034.227.019.228.03.456.028.457.01.215.005.197.018.791.042 2.188.037.492.007.16-.002.162-.013.156-.012.075-.015.071-.002.003-.002.003-.01.006-.031.015-.117.04-.42.141-.281.002c-.086-.004-.166-.006-.24-.008l-.413-.031c-.118-.01-.237-.02-.372-.029l-.105.002-.123.011-.031.001-.031-.004-.029-.009-.029-.015-.029-.021-.027-.027-.028-.035-.028-.041-.021-.035-.021-.025-.02-.019-.009-.006-.009-.004-.009-.001-.009.001-.008.003-.008.005-.008.008-.008.011-.014.027-.113.229-.035.005-.125.01-.062.005-.055.02-.221.074-.223.066-.227.055-.009.001-.009-.001-.021-.006-.044-.021-.045-.032-.047-.039-.029-.024-.025-.017-.021-.011-.009-.003h-.009l-.008.002-.006.004-.006.006-.004.008-.004.011-.002.013-.002.033v.035l-.003.03-.006.024-.009.02-.01.014-.006.005-.007.004-.007.002-.008.001-.016-.002-.004-.001.001.002c-.597.267-.993.748-1.265 1.28-.293.528-.369 1.181-.289 1.789.018.126-.031.244-.139.361-.078.098-.08.167.022.213l.271.139c.049.258.243.444.33.686.193.168.293.414.51.56.055.041.062.153.061.252-.002.132.033.2.136.171.098-.021.192-.016.229.039.292.14.57.306.926.356.172.031.322.11.509.114l.554.027c.33.056.832-.022 1.262-.044.439-.042.898-.036 1.322-.109a.584.584 0 0 1 .474.093c.122.087.208.097.287-.002l.243-.264a4.588 4.588 0 0 0 1.018-.266c.322-.122.678-.181.981-.337.083-.04.21-.01.312.027.135.049.223.04.263-.079.04-.121.124-.187.208-.189 1.444-.762 2.648-2.045 4.139-3.448.16-.142.334-.229.529-.231.166-.004.254-.049.285-.188l.119-.395c.314-.292.701-.558 1.055-.838a8.346 8.346 0 0 1 1.141-.77c.107-.065.271-.068.396-.055.168.019.272-.01.326-.148a.413.413 0 0 1 .266-.258 21.793 21.793 0 0 1 6.027-2.109c.213-.045.406-.043.573.061.144.09.241.103.34.006l.31-.258c.854-.096 1.726-.253 2.588-.284.115-.004.252.073.352.147.132.099.232.125.335.03.104-.096.235-.124.33-.095l.003.002v-.001l.089-.007.088-.015.176-.044.176-.044.089-.015.088-.006.01.002.008.006.008.008.009.01.032.055.016.028.016.022.009.008.009.006.009.002h.005l.004-.002.042-.014.036-.01.059-.011.027-.008.025-.013.025-.02.026-.029.013.017.02.021.054.049.053.049.021.02a.112.112 0 0 0 .012.017l.006.011.007.007.006.003.006.001.006-.002.005-.005.006-.008.004-.01.009-.025.007-.032.006-.038.002-.01v-.006l-.047.002.01-.002.018-.006.017-.01.013-.013.01-.016.004-.019v-.02l-.005-.022-.012-.024c.321-.301.526-.491.849-.792l.002-.001-.002-.002 4.271-4.415c.147-.15.311-.247.505-.262.165-.015.249-.064.269-.204l.086-.397c.602-.607 1.211-1.224 1.82-1.841.082-.082.234-.117.357-.13.162-.018.255-.067.268-.209.014-.144.09-.254.18-.298l.003.003.001-.005.062-.066.057-.073.102-.156.104-.155.057-.073.062-.066.008-.005.01-.002h.012l.014.001.061.018.031.009.028.006h.012l.011-.002.008-.006.006-.008.021-.039.021-.032.037-.05.014-.024.011-.026.006-.032v-.04l.021.003.03.001.073-.003.074-.003.028.001.021.003.012.003.01.001.008-.002.004-.004.003-.006.001-.007-.002-.009-.003-.011-.011-.024-.018-.028-.021-.031-.007-.009-.003-.004v-.001l.001-.001.005-.009.01-.019.004-.02v-.023l-.004-.019-.01-.017-.014-.016-.02-.013-.025-.009c.015-.464.023-.759.039-1.223l-.002-.003-.102-7.972c-.002-.274.046-.513.172-.704.107-.164.131-.288.047-.434-.068-.139-.142-.285-.221-.444l-.01-2.197c-.84.026-1.677.06-2.504.149-.352-.173-.651-.326-.953-.478zM138.882 99.509c-.416-1.562-1.328-2.95-2.436-4.094-.062-.072-.076-.161-.086-.266-.02-.256-.03-.258-.238-.248l-.156.01c-.048-.16.025-.454-.282-.373-.114.031-.214.027-.285-.026-.343-.271-.653-.597-1.039-.818-.786-.441-1.638-.73-2.511-.914a3.29 3.29 0 0 0-.232.507.759.759 0 0 1-.807.489c-.467-.036-.889.054-1.281.353-.487.369-.983.719-1.477 1.075l.377.001.475.012.033.002.131.221.016.026.008.01.007.007.008.005.007.003h.008l.008-.002.008-.005.008-.007.016-.02.017-.027.018-.037.022-.043.022-.037.024-.03.025-.023.025-.018.028-.013.028-.006.029-.002.117-.002.1-.01.171-.033.083-.017.088-.015c.031-.002.064-.004.1-.008l.117.002.174.141.027.022.004.002v.001l.002-.001.002-.002.012-.008.018-.014a.355.355 0 0 0 .027-.019l.008-.004.004-.002.032.011.03.014.028.017.026.021.049.046.042.052.069.101.026.041.022.029.639.698.939 1.027v.005l.004-.003 2.632 2.509c.052.05.053.127.042.222-.023.227-.017.226.164.198l.139-.021c.012.141-.097.384.175.31.103-.029.186-.025.233.023.239.23.392.547.631.777l-.004.004.006-.001.893.837-.011.024-.005.022v.004l.652.032.021-.038.008-.011.009-.009.009-.005.01-.003.091.004.091.012.184.037.099.02.479-.006.011.013.012.013.015.01.017.01.036.014.041.01.044.004h.046l.046-.004.045-.009.041-.013.039-.016.031-.02.025-.021.01-.013.008-.013.004-.014.002-.014v-.015l-.004-.015-.008-.016-.01-.017a.5.5 0 0 0-.018-.029l-.021-.049-.056-.112-.057-.109c-.009-.016-.018-.03-.023-.042a.249.249 0 0 0-.019-.024l.024-.059.017-.056.009-.055.004-.056.003-.127.013-.166v-.021l-.002-.019-.008-.018-.008-.018-.025-.031-.029-.028-.059-.058-.014-.016-.012-.016-.008-.017-.005-.019-.026-.182-.017-.185-.018-.372-.003-.094-.002-.047-.008-.047-.029-.184-.036-.183-.044-.182.005-.009-.005.011zM127.731 95.456l.007.003h.008l.008-.002.008-.005.008-.006.017-.021.017-.027.012-.021c-.032.022-.063.047-.097.069l.006.006.006.004zM210.039 123.821l.009.009.005.009.003.009-.004.091-.012.092-.023.113.008.004.014.004.014.002h.015l.015-.004.016-.008.017-.01.029-.017a.48.48 0 0 1 .049-.021l.13-.05c.045-.018.092-.035.13-.051l.05-.021.03-.017.068.028.064.019.063.012.066.007.149.009.193.021.023.002.022-.002.021-.006.021-.009.039-.023.038-.028.037-.029.037-.026.02-.011.021-.008.021-.006.023-.002.22.002.221.012.441.038.442.038.221.012.221.003v.012l.008-.012 1.723-.019.432-.006c.141-.002.309 0 .365-.021.163-.042.338-.017.492-.08a2.489 2.489 0 0 0 1.504-1.189c.033-.068.111-.095.213-.121.254-.063.219-.099.125-.262l-.082-.122c.124-.079.42-.146.174-.35-.086-.072-.137-.143-.127-.215.025-.35.057-.727-.064-1.081l.004-.007-.007.003-.028-.033-.01-.021-.006-.023-.001-.025.005-.029.01-.031.018-.034.014-.032.004-.016v-.026l-.004-.011-.006-.011-.007-.009-.009-.008-.012-.007-.029-.012-.035-.009-.042-.005-.068-.008-.063-.014-.027-.011-.023-.013-.023-.012-.01-.007-.009-.008-.109-.121-.101-.126-.048-.066-.006-.008-.003-.004-.004-.004-.018-.012-.032-.023-.126-.102-.12-.108-.029-.028-.015-.014-.008-.008-.009-.004-.072-.036-.141-.076-.138-.083-.037-.027-.1-.254-.014-.032-.009-.013-.009-.01-.01-.008-.01-.006-.011-.003-.011-.001h-.014l-.012.003-.028.012-.03.019-.034.027-.04.031-.039.025-.039.018-.038.01-.04.016-.041.011-.04.005-.04-.001-.294-.023-.031-.002-.046.002-.104.009-.199.018-.413.031c-.074.002-.154.004-.24.008l-.281-.002-.42-.141-.117-.04-.031-.015-.01-.006-.002-.003-.002-.003-.015-.071-.012-.075-.013-.156-.002-.162.007-.16.037-.492.042-2.283.012-.676c-.028-.091-.058-.182-.055-.273 0-.021.025-.04.061-.059l.004-.205-.012-.006.012-.005.004-.206c-.031-.02-.055-.038-.054-.061l.059-1.233-.009-.671.013-.01.013-.013.01-.015.01-.016.014-.037.01-.041.004-.044v-.046l-.004-.046-.008-.037-.094.001c-.033.039-.068.068-.109.067l-1.211-.034-.033.023-.02.011-.021.009-.021.005-.023.003-.22-.004-.137-.008-.001.008.002.015.004.015.006.016.012.017.016.029c.006.014.014.03.021.049l.05.13c.019.045.036.092.05.13a.556.556 0 0 1 .021.05l.018.03-.028.068-.019.064-.012.063-.006.066-.01.149-.021.193-.001.023.003.022.006.021.008.021.023.039.028.038.03.037.025.037.011.02.009.021.005.021.003.022-.004.22-.012.221-.037.441-.037.441-.012.222-.004.221v.008l.089 1.95c.001.038-.054.068-.128.101-.176.077-.17.079-.023.138l.113.044c-.092.059-.341.109-.096.184.092.028.148.062.148.098.006.178-.109.356-.104.535l.002.003.009.015.003.007.001.008v.008l-.001.009-.008.017-.013.017-.019.017-.025.017-.031.017-.029.015-.01.008-.008.008-.004.008-.003.008-.001.008.003.008.005.008.006.008.02.016.028.018.035.018.058.029.051.033.021.017.016.018.011.017.003.009.001.008-.001.477-.012.473-.002.034-.221.13-.026.016-.01.007-.007.008-.005.008-.003.008v.008l.002.007.005.008.007.008.02.016.027.017.037.018.043.021.037.023.029.023.024.025.018.027.013.027.006.028.002.029.002.116.01.1.033.171.017.082.015.089c.002.03.004.063.008.1a3.933 3.933 0 0 0-.002.116l-.141.173-.021.028-.004.003.001.002.002.003.009.011.014.019a.343.343 0 0 0 .018.026l.004.008.002.004-.01.032-.014.03-.018.028-.02.026-.047.049-.051.042-.1.068-.041.027-.029.022-.695.639-.35.32c-.002.047-.002.098-.029.119-.005.006-.03-.01-.063-.033l-.05.045.012.016-.016-.012-.05.046c.021.028.034.052.028.058-.114.096-.238.182-.359.27l-.289.311-.025-.012-.022-.005-.021.001-.003.001-.011.313a.058.058 0 0 0 .01.008l-.011.011-.003.07.002.137-.007.006-.003.099.049.027.009.001zM205.46 118.06c.064-.002.134-.002.196-.003.007-.014.014-.03.021-.04l.016.039.205-.002c.024-.043.049-.076.077-.075l.206.009.016-.009.021-.009.021-.005.023-.003.22.004.221.012.441.037.227.02.405-.006.01.013.014.013.006.004.208.009c-.005-.036-.018-.072-.017-.108 0-.034.039-.064.094-.094a19.546 19.546 0 0 1-.004-.238l-.037-.022.037-.019-.001-.025-.019-.043a1.161 1.161 0 0 1-.018-.03l.028-.068.006-.021-.001-.062c-.041-.027-.072-.056-.071-.089l.021-.59-.011-.016-.011-.02-.009-.021-.005-.021-.003-.022.004-.22.012-.221.037-.441v-.009l-.045-.002-.051.004-.049.01-.111.027-.065.021-.077.021-.017.006-.015.01-.013.012-.011.014-.018.033-.015.037-.028.073-.01.015-.01.014-.012.012-.015.008-.075.031-.072.038-.146.068-.152.063-.076.03-.072.038-.293.152-.035.02-.035.022-.064.049-.129.102-.098-.116-.001.008.095.112c-.014.032-.002.093-.014.126 0 0-.038-.038-.088-.093l-.01-.01v.01l.061.072-.062-.067-.001.01.088.106c-.002.01-.086-.072-.089-.062l-.004-.004-.001.007-.029.024-.025.027-.053.055-.1.104-.098.098-.047.049-.041.052-.158.2-.078.098-.064.104-.134.206-.034.052-.027.056-.055.113-.029.059c.047-.01.094-.027.141-.025.029-.003.056.037.08.093z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "m201.204 121.513.041.117.014.032.006.009.003.002.003.002.071.015.075.012.156.013.162.002.16-.007.492-.037 2.283-.042.886-.016.038.024.041.021.042.016.042.011.039.004.569-.003.001.127-.001.001-.012.03-.008.033-.005.032-.002.067.007.066c.009.043.017.083.022.118l.008 1.406c-.007.218-.017.435-.011.654 0 .031.052.064.108.094l.01.205c-.016.021-.016.042 0 .06h.135l-.027.04-.037.042-.043.053-.037.056-.029.059-.024.062-.018.063-.013.066-.006.069-.002.071-.002.281-.01.241-.033.412-.031.412c-.002.075-.004.154-.008.241l.002.281.141.42.041.117.014.032.006.008.003.003.003.001.071.016.075.012.156.013.162.001.16-.006.492-.037 2.283-.041 3.355-.062v-.01l.008.012c.093.032.223.009.332-.083.107-.091.205-.062.331.042.094.077.224.16.339.16l1.275-.002.161-.002.228-.019.453-.046c.303-.031.602-.065.889-.17.145-.127.276-.236.389-.352.114-.133.248-.13.443-.116.23.023.486-.058.744-.204a6.071 6.071 0 0 0 2.588-3.328c.426-1.364.382-2.864-.177-4.177l-.021-.005.016-.006-.012-.035-.006-.018-.008-.016-.033-.065-.064-.127-.129-.247-.253-.464-.062-.11-.077-.1-.152-.194-.308-.378-.156-.187-.02-.022-.021-.022-.046-.04-.092-.081c-.125-.107-.251-.216-.382-.326l-.201-.166-.104-.084-.053-.042-.059-.035-.495-.283-.02.004-.021.003-.023-.001-.024-.002-.052-.012-.055-.019-.057-.024-.057-.03-.057-.034-.052-.036-.024-.02-.65-.5-.006-.001-.01-.004-.037-.016-.033-.02-.025-.021-.009-.013-.007-.013-.006-.014-.002-.014.002-.015.004-.015.006-.016.012-.017.016-.029c.006-.014.014-.03.021-.049l.044-.114h.046v-.01l.009-.032.004-.037-.001-.039-.004-.017.001-.008.001-.003a.556.556 0 0 0 .021-.05l.018-.03-.028-.068-.002-.007.028-.447.02-.031.021-.041.016-.042.011-.042.004-.039-.007-1.358c.004-.118.011-.235.007-.354 0-.003-.009-.006-.01-.009l-.003-.574-.002-.081-.221-.314-.026-.038-.01-.019-.007-.019-.005-.019-.003-.018v-.019l.002-.019.005-.019.007-.019.02-.038.027-.04.037-.043.043-.052.037-.056.029-.059.024-.061.018-.064.013-.066.006-.068.002-.072.002-.281.01-.24.033-.413.031-.413c.002-.074.004-.154.008-.24l-.002-.281-.141-.42-.041-.117-.014-.032-.006-.009-.003-.002-.003-.002-.071-.015-.075-.012-.156-.013-.162-.002-.16.007-.492.037-1.586.029-.033-.017-.042-.016-.042-.011-.039-.004-2.296.013-.058.002c-.363-.009-.731-.022-1.1-.015-.009 0-.018.013-.027.017h-.016l-.281-.002-.24-.01-.413-.033-.413-.031c-.074-.002-.154-.004-.24-.008l-.281.002-.42.141-.117.04-.031.015-.01.006-.002.003-.002.003-.015.071-.012.075-.013.156-.002.162.007.16.037.492.042 2.283.002.102-.143.021-.351.057-.347.085-.505.133-.495.173-.246.088-.238.107-.477.22-.459.256-.228.132-.057.033-.054.037-.109.075-.432.302-.054.037-.051.043-.103.084-.202.17.138.164h-.012l-.135-.16c-.021-.022-.01-.003.048.069.057.071.036.05-.033-.027-.052-.058-.109-.117-.109-.117-.021.007-.026.03-.036.05l.137.172c.012.014.008.01.013.017h-.004l-.044-.047c-.086-.094-.119-.127-.123-.123-.022.046-.017.124-.041.168l.006.007h-.014l-.039.021-.02.013-.018.016-.034.036-.031.041-.028.046-.023.05-.019.054-.013.057-.014.054-.008.023-.012.021-.013.02-.015.019-.016.017-.019.015-.042.026-.049.021-.056.018-.063.015-.053.012-.053.016-.052.021-.052.023-.05.027-.047.031-.042.033-.036.038-.238.288-.059.073-.054.077-.105.156-.207.312-.051.079-.025.039-.022.042-.089.166-.174.334-.086.168-.071.174-.139.352-.067.175-.018.044-.015.045-.026.09-.027.104.048.237.052.218.014.053.004.05-.002.023-.004.023-.013.045-.019.044-.028.044-.036.046-.045.046-.055.06-.049.065-.042.07-.036.076-.031.08-.026.086-.021.089-.008.047-.004.048c-.038.492-.062.809-.088 1.126l-.031.413c-.002.074-.004.154-.008.24l.002.281c.069.179.118.321.151.422zm8.778 2.175.007-.006-.002-.137.003-.07.011-.011a.058.058 0 0 1-.01-.008l.011-.313.003-.001.021-.001.022.005.025.012.289-.311c.121-.088.245-.174.359-.27.006-.006-.008-.029-.028-.058l.05-.046.016.012-.012-.016.05-.045c.033.023.059.039.063.033.027-.021.027-.072.029-.119l.35-.32.695-.639.029-.022.041-.027a2.41 2.41 0 0 1 .1-.068l.051-.042.047-.049.02-.026.018-.028.014-.03.01-.032-.002-.004-.004-.008a1.732 1.732 0 0 0-.018-.026l-.014-.019-.009-.011-.002-.003-.001-.002.004-.003.021-.028.141-.173.002-.116c-.004-.036-.006-.069-.008-.1l-.015-.089-.017-.082-.033-.171-.01-.1-.002-.116-.002-.029-.006-.028-.013-.027-.018-.027-.024-.025-.029-.023-.037-.023-.043-.021-.037-.018-.027-.017-.02-.016-.007-.008-.005-.008-.002-.007v-.008l.003-.008.005-.008.007-.008.01-.007.026-.016.221-.13.002-.034.012-.473.001-.477-.001-.008-.003-.009-.011-.017-.016-.018-.021-.017-.051-.033-.058-.029-.035-.018-.028-.018-.02-.016-.006-.008-.005-.008-.003-.008.001-.008.003-.008.004-.008.008-.008.01-.008.029-.015.031-.017.025-.017.019-.017.013-.017.008-.017.001-.009v-.008l-.001-.008-.003-.007-.009-.015-.002-.003c-.006-.179.109-.357.104-.535 0-.036-.057-.069-.148-.098-.245-.074.004-.125.096-.184l-.113-.044c-.146-.059-.152-.061.023-.138.074-.032.129-.062.128-.101l-.089-1.95v-.008l.004-.221.012-.222.037-.441.037-.441.012-.221.004-.22-.003-.022-.005-.021-.009-.021-.011-.02-.025-.037-.03-.037-.028-.038-.023-.039-.008-.021-.006-.021-.003-.022.001-.023.021-.193.01-.149.006-.066.012-.063.019-.064.028-.068-.018-.03-.021-.05c-.014-.038-.031-.085-.05-.13l-.05-.13-.021-.049-.016-.029-.012-.017-.006-.016-.004-.015-.002-.015.001-.008.137.008.22.004.023-.003.021-.005.021-.009.02-.011.033-.023 1.211.034c.041.001.076-.028.109-.067l.094-.001.008.037.004.046v.046l-.004.044-.01.041-.014.037-.01.016-.01.015-.013.013-.013.01.009.671-.059 1.233c-.001.022.022.041.054.061l-.004.206-.012.005.012.006-.004.205c-.035.019-.061.037-.061.059a.82.82 0 0 0 .055.273l-.012.676-.042 2.283-.037.492-.007.16.002.162.013.156.012.075.015.071.002.003.002.003.01.006.031.015.117.04.42.141.281.002c.086-.004.166-.006.24-.008l.413-.031.199-.018.104-.009.046-.002.031.002.294.023.04.001.04-.005.041-.011.04-.016.038-.01.039-.018.039-.025.04-.031.034-.027.03-.019.028-.012.012-.003h.014l.011.001.011.003.01.006.01.008.009.01.009.013.014.032.1.254.037.027.138.083.141.076.072.036.009.004.008.008.015.014.029.028.12.108.126.102.032.023.018.012.004.004.003.004.006.008.048.066.101.126.109.121.009.008.01.007.023.012.023.013.027.011.063.014.068.008.042.005.035.009.029.012.012.007.009.008.007.009.006.011.004.011v.026l-.004.016-.014.032-.018.034-.01.031-.005.029.001.025.006.023.01.021.028.033.007-.003-.004.007c.121.354.09.731.064 1.081-.01.072.041.143.127.215.246.203-.05.271-.174.35l.082.122c.094.163.129.198-.125.262-.102.026-.18.053-.213.121a2.482 2.482 0 0 1-1.504 1.189c-.154.063-.329.038-.492.08-.057.021-.225.019-.365.021l-.432.006-1.723.019-.008.012v-.012l-.221-.003-.221-.012-.442-.038-.441-.038-.221-.012-.22-.002-.023.002-.021.006-.021.008-.02.011-.037.026-.037.029-.038.028-.039.023-.021.009-.021.006-.022.002-.023-.002-.193-.021-.149-.009-.066-.007-.063-.012-.064-.019-.068-.028-.03.017-.05.021c-.038.016-.085.033-.13.051l-.13.05-.049.021-.029.017-.017.01-.016.008-.015.004h-.015l-.014-.002-.014-.004-.008-.004.023-.113.012-.092.004-.091-.003-.009-.005-.009-.009-.009-.011-.008-.049-.027.005-.092zm-4.713-5.757.055-.113.027-.056.034-.052.134-.206.064-.104.078-.098.158-.2.041-.052.047-.049.098-.098.1-.104.053-.055.025-.027.029-.024.001-.007.004.004c.003-.011.087.071.089.062l-.088-.106.001-.01.062.067-.061-.072v-.01l.01.01c.05.055.088.093.088.093.012-.033 0-.094.014-.126l-.095-.112.001-.008.098.116.129-.102.064-.049.035-.022.035-.02.293-.152.072-.038.076-.03.152-.063.146-.068.072-.038.075-.031.015-.008.012-.012.01-.014.01-.015.028-.073.015-.037.018-.033.011-.014.013-.012.015-.01.017-.006.077-.021.065-.021c.041-.01.077-.02.111-.027l.049-.01.051-.004.045.002v.009l-.037.441-.012.221-.004.22.003.022.005.021.009.021.011.02.011.016-.021.59c-.001.033.03.062.071.089l.001.062-.006.021-.028.068.018.03.019.043.001.025-.037.019c.01.008.025.015.037.022l.004.238c-.055.029-.094.06-.094.094-.001.036.012.072.017.108l-.208-.009-.006-.004-.014-.013-.01-.013-.405.006-.227-.02-.441-.037-.221-.012-.22-.004-.023.003-.021.005-.021.009-.016.009-.206-.009c-.028-.001-.053.032-.077.075l-.205.002-.016-.039c-.007.01-.014.026-.021.04-.062.001-.132.001-.196.003-.024-.056-.051-.096-.08-.096-.047-.002-.094.016-.141.025l.029-.056z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m229.171 112.634.125.031.063.014.063.012.128.019.128.014.131.006h.13l.403-.007 1.597-.033.001-.038h2.045l.318-.006.492-.037.16-.007.162.002.156.013.075.012.071.015.003.002.003.002.004.005h.014c.006.011 0 .023.002.035v.001l.041.117.141.42.002.281c-.004.086-.006.166-.008.24l-.031.413-.033.413c-.004.065-.006.137-.009.211l-.001.132-.001.001-.001.178-.002.072-.006.068-.013.066-.018.064-.024.061-.013.025c.013.019.03.035.04.055l.01-.004.027-.015.054-.028.107-.056.054-.027.05-.031.2-.124.193-.141.193-.159.049-.043.048-.046.1-.095.05-.05.051-.054.104-.111.01.002-.008-.007c.318-.382.598-.828.825-1.322.116-.244.22-.5.312-.763l.129-.397.142-.511c.13-.343.255-.685.366-1.019.027-.131.107-.239.188-.35.133-.19.29-.332.486-.386l.094-.032c.115-.038.176-.097.193-.208.024-.131.064-.265.105-.417l1.567-1.59c.069-.068.206-.088.317-.09.147-.002.229-.041.229-.169 0-.131.062-.226.14-.259l.009.009.002-.017 3.818-3.906 3.471-3.531.374-.391-2.339.045a.621.621 0 0 1-.469-.172c-.109-.107-.192-.131-.289-.047l-.297.221-2.237.015c-.101 0-.216-.083-.298-.16-.111-.103-.197-.133-.291-.042-.096.092-.211.115-.293.084v-.004l-.003.002-.091.004-.09.012-.182.037-.18.037-.091.012-.09.004-.009-.003-.01-.005-.008-.009-.008-.011-.031-.056-.015-.028-.017-.023-.008-.008-.009-.006-.009-.003h-.006l-.004.001-.043.014-.037.008a.864.864 0 0 0-.061.01l-.027.006-.025.012-.027.019-.027.028-.013-.017-.021-.021a2.243 2.243 0 0 1-.053-.051l-.053-.05-.021-.021-.012-.016-.007-.011-.006-.007-.006-.004-.007-.001-.005.002-.006.005-.006.007-.004.01-.01.024-.008.033-.006.037-.002.011-.001.005-.001.001h-.002l-.01.002-.02.007-.016.01-.014.014-.01.016-.006.018v.021l.005.022.011.024-.889.818-.007-.002.005.005c-.887.921-1.779 1.845-2.672 2.77a.388.388 0 0 1-.363.115c-.131-.021-.189.004-.182.114l.002.307c-.376.381-.753.771-1.146 1.147-.052.051-.17.05-.267.037-.129-.018-.195.005-.18.118.015.113-.027.188-.093.207l-.006-.002.003.003-.937 1.007-.638.684-.021.029-.027.04-.068.099-.043.051-.047.045-.027.02-.028.017-.03.014-.031.009-.004-.001-.008-.005-.026-.018-.019-.014-.011-.009-.003-.002-.001-.001-.001.001-.003.002-.027.022c-.042.033-.1.082-.172.141l-.115.002c-.035-.004-.067-.006-.099-.008l-.087-.015-.081-.017-.17-.033-.098-.01-.115-.002-.029-.002-.028-.006-.027-.013-.026-.018-.025-.023-.023-.03-.022-.037-.021-.043-.017-.037-.018-.027-.016-.02-.008-.007-.007-.005-.008-.002h-.007l-.008.003-.008.005-.008.007-.007.01-.016.026-.129.221-.033.002-.468.012-.471.001-.009-.001-.009-.003-.017-.011-.017-.016-.018-.021-.032-.052-.029-.058-.018-.035-.017-.027-.016-.021-.008-.006-.008-.005-.008-.002h-.008l-.008.003-.008.004-.007.008-.008.011-.015.028-.017.031-.017.025-.017.019-.017.013-.016.008-.009.001h-.008l-.008-.001-.007-.003-.015-.009-.003-.004v.004l-1.008.008a2.646 2.646 0 0 0-.635.066 2.672 2.672 0 0 0-1.074.542 3.21 3.21 0 0 0-1.149 2.196c-.015.178-.06.288-.177.477-.102.072-.115.17-.018.252.088.076.172.155.271.229a2.853 2.853 0 0 0 1.174 1.602c.074.049.122.173.158.277.045.141.117.205.236.154.119-.05.225-.039.289.013l-.004.012.027-.008zM234.899 144.827l.013-.003.024-.008.021-.011.002-.002a1.1 1.1 0 0 1-.062.023h.002zM235.19 144.722l.03-.006.033-.013.036-.019.008-.005.004-.002-.119.044h.008zM215.927 131.823l-.014-.01-.013-.006-.013-.003h-.012l-.012.003-.01.006-.01.008-.01.01-.016.027-.014.033-.01.039-.002.01-.001.006.187-.097-.027-.012a.158.158 0 0 0-.023-.014z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M299.862 165.636c.068.133.143.178.254.12l.329-.148c.694.146 1.467.199 2.261.217.104.001.229.085.331.162.131.103.233.133.346.042a.386.386 0 0 1 .347-.084l6.301-.102c.217-.002.405.046.557.172.13.107.228.131.343.047l.351-.221 2.656-.015c.119 0 .256.083.354.16.131.103.234.133.346.042a.384.384 0 0 1 .346-.084l.004.004v-.002l1.391-.061.932-.041-.289-1.201-1.197-4.1.279-1.037c-.52-.314-.861-.735-1.012-1.328-.055-.223-.148-.438-.223-.655-.037-.11-.062-.221-.089-.323l.274-1.075c-.326-1.048-.746-2.125-1.097-3.221-.171-.471-.528-.734-.921-.981a.757.757 0 0 1-.324-.886c.139-.446.156-.882-.041-1.333-.422-.957-.774-1.935-1.202-2.883-.241-.545-.54-1.014-1.11-1.262-.053-.024-.098-.181-.084-.255.225-.878-.014-1.613-.798-2.069-.364-.21-.404-.439-.311-.787.073-.236.095-.372-.007-.584h.001c-3.304-6.638-7.099-12.542-11.477-18.463l-.078-1.09c-.226-.078-.452-.136-.663-.226-.312-.161-.533-.389-.541-.778-.014-.215-.066-.43-.094-.65-.967-.302-.957-.313-1.413-.886-1.753-2.289-3.716-4.405-5.573-6.53-.066-.392-.145-.711-.213-1.044-.613-.05-1.131-.255-1.509-.737-.144-.179-.319-.336-.478-.501-.08-.084-.149-.174-.217-.256l-.211-1.097a46.41 46.41 0 0 0-1.16-1.217l-1.25-1.185c-.357-.351-.787-.441-1.246-.497a.759.759 0 0 1-.666-.668c-.064-.467-.233-.871-.602-1.197-.764-.714-1.588-1.351-2.362-2.046-.446-.393-.914-.692-1.53-.675-.059 0-.165-.123-.184-.197-.178-.889-.681-1.484-1.611-1.523-.427-.023-.567-.207-.639-.554-.015-.087-.036-.147-.058-.21-.086.044-.179.074-.263.123-.135.067-.262.104-.423.049-.136-.044-.21-.022-.229.095l-.074.319a7.81 7.81 0 0 0-1.311 1.292c-.053.065-.178.09-.28.102-.138.016-.21.059-.181.179.031.121-.004.213-.07.254l-.006-.004.003.006-.088.151-.085.153-.081.154-.075.158-.139.319-.122.321-.071.218-.062.208-.138.602-.057.386-.023.124-.033.123-.041.117-.025.055-.029.051-.001.002-.003.002-.01.002-.033.004-.023.001-.014.001h-.008l-.006.003-.053.022-.331.139h-.222l-.189-.009c-.118-.013-.222-.022-.325-.033l-.313-.034a5.408 5.408 0 0 0-.152-.011 62.58 62.58 0 0 0-.178-.003l-.046-.002-.044-.007-.041-.013-.041-.018-.038-.023-.037-.031-.034-.037-.033-.043-.027-.037-.024-.027-.024-.02-.012-.007-.012-.005-.012-.002h-.012l-.012.002-.012.005-.012.007-.012.01-.023.026-.2.22-.052.002-.723.008-.729-.003-.013-.001-.013-.003-.026-.011-.026-.017-.025-.021-.051-.052-.045-.058-.026-.035-.026-.028-.024-.021-.012-.006-.013-.005-.012-.002h-.012l-.012.002-.012.005-.012.008-.012.01-.023.028-.024.031-.026.025-.025.019-.025.013-.025.007-.025.002-.023-.004-.021-.01v-.01l-.005.01c-.289.016-.579.078-.87.098-.029.001-.056-.047-.076-.174-.018-.105-.03-.13-.047-.046-.017.074-.031.141-.05.22-.12.008-.243.021-.366.014-.017 0-.035-.084-.049-.161-.017-.103-.031-.133-.047-.042-.016.092-.035.115-.049.083l-.006-.018v.016l-2.511.048-1.841.032-.477.034-.154.006-.156-.003-.152-.013-.072-.013-.068-.016-.002-.001-.004-.003-.006-.009-.014-.031-.041-.114-.152-.401-.01-.271.001-.232.02-.399.013-.193.004-.101.002-.025v-.008l.002.005.001.005.001-.003.001-.006.003-.035v-.046l-.002-.053-.008-.062-.001-.03.003-.03.008-.03.014-.03.021-.03.026-.029.032-.03.04-.03.031-.025.025-.021.017-.021.005-.01.004-.009v-.009l-.001-.009-.004-.008-.007-.008-.008-.007-.012-.007-.029-.013a11.296 11.296 0 0 1-.242-.102l-.01-.035-.062-.25-.072-.246-.166-.48-.002-.009-.001-.009.003-.021.009-.023.013-.024.035-.053.04-.051.024-.031.019-.027.011-.023.003-.011.001-.01-.002-.009-.003-.008-.006-.006-.008-.006-.011-.004-.012-.004-.033-.004-.035-.003-.029-.006-.025-.009-.02-.01-.014-.013-.005-.007-.004-.008-.003-.008v-.008l.002-.018.006-.003h-.008c-.601-1.194-1.539-1.825-2.802-2.02a.465.465 0 0 1-.323-.22c-.072-.113-.138-.145-.219-.068l-.244.213-2.178.007c-.102 0-.216-.083-.298-.16-.11-.103-.197-.133-.292-.042-.096.092-.21.115-.292.084l-.767.015-.295 1.14-.404 1.451-.343 1.214-.024.09-.023.108-.02.123-.018.138-.01.067-.014.064-.018.062-.023.061-.027.057-.034.055-.04.052-.046.05-.038.039-.029.039-.021.037-.007.019-.005.019-.003.018v.019l.002.019.005.018.007.019.01.019.027.037.228.295.007.076.025.26.038.254.05.247.062.237.074.228.085.217.096.206.106.195.012.027.009.032.003.035v.039l-.008.079-.016.08-.008.047-.002.02.072-.053c.016-.008.016-.006.004.007l.014.018a.842.842 0 0 1 .102-.063c.025.023.036.057.051.088l-.076.07.018.02c.051-.036.084-.057.087-.052.033.067.046.158.081.229l.047.045.092.081.094.077.201.146.217.133.115.062.117.059.246.109.261.096.184.059.189.055.194.048.197.044 1.536.265.938.128c.198.033.406.068.609.104l.295.064.271.075.005.003.004.003.011.011.021.036.013.025.006.015.002.004.001.002-.002.002-.009.012-.075.107-.47.669-.713.704-.582.538c-.176.159-.35.319-.549.501l-.217.203-.246.244-.063.061-.064.056-.066.049-.068.044-.07.036-.071.029-.074.022-.078.015-.062.011-.055.016-.047.02-.04.024-.018.015-.016.016-.015.018-.013.02-.011.021-.009.022-.015.052-.118.43-.069.072-1.99 2.008-.038.033-.043.028-.048.024-.051.021-.105.033-.103.021-.062.013-.056.016-.048.021-.041.025-.018.015-.017.017-.015.018-.012.02-.012.021-.008.023-.013.052-.012.057-.018.053-.022.049-.025.045-.03.04-.032.034-.035.029-.037.023-.006-.007-.001.014-2.104 2.248c-.073.076-.173.107-.314.07-.12-.03-.171-.014-.151.086l.035.277c-.297.308-.594.625-.906.927-.042.042-.147.03-.236.009-.117-.027-.174-.013-.148.09.025.104-.005.168-.061.179l-.008-.003.004.004-.939 1.026-.639.698-.023.029-.026.04-.069.101-.042.052-.048.046-.027.021-.027.017-.031.014-.031.01h-.004l-.008-.005-.027-.019-.019-.014-.011-.008-.002-.002-.002-.001-.001.001-.003.002-.027.022-.174.141-.117.001a2.713 2.713 0 0 1-.1-.008l-.088-.014-.083-.018-.171-.032-.1-.01-.117-.002-.029-.001-.028-.008-.027-.012-.026-.018-.025-.023-.024-.03-.022-.037-.021-.044-.018-.035-.018-.028-.016-.02-.008-.007-.008-.004-.008-.002h-.007l-.008.002-.007.005-.008.007-.008.01-.016.026-.131.221-.033.002-.475.012-.477.001-.008-.001-.009-.003-.017-.01-.018-.017-.018-.021-.033-.052-.029-.058-.018-.035-.017-.027-.017-.02-.008-.008-.008-.004-.008-.002h-.008l-.008.002-.008.006-.007.007-.008.011-.016.028-.017.031-.016.024-.018.02-.017.013-.017.007-.008.002h-.008l-.008-.001-.008-.003-.014-.01v-.008l-.004.008-5.184.103a.596.596 0 0 1-.457-.173c-.107-.105-.188-.13-.282-.046l-.289.221-2.185.015c-.098 0-.21-.083-.291-.16-.107-.104-.191-.133-.283-.042-.094.092-.207.115-.285.083-1.514.017-2.845.385-3.895 1.127a.441.441 0 0 1-.387.064c-.133-.036-.199-.01-.205.103l-.033.316c-.423.38-.823.844-1.238 1.359-.055.069-.183.101-.289.112-.143.016-.215.062-.195.186.021.125-.022.226-.094.268-.955 1.322-1.924 2.971-3.467 4.354-.156.142-.333.222-.525.215-.164-.003-.254.031-.293.167-.037.124-.094.243-.15.38a9.94 9.94 0 0 1-2.322 1.244c-.11.045-.266.008-.381-.033-.152-.056-.254-.052-.329.064-.077.12-.197.182-.296.178l-.002-.008-.004.008-.184.052-.18.06-.359.121-.18.061-.182.052-.182.045-.092.02-.092.016-.019.001-.019-.003-.019-.006-.018-.008-.036-.021-.035-.024-.035-.023-.035-.019-.019-.006-.019-.003h-.019l-.02.004-.157.044-.121.024-.055.013-.051.018-.051.024-.053.034a.201.201 0 0 1-.027-.015.537.537 0 0 1-.043-.017l-.113-.038a.014.014 0 0 0-.006-.002v.025l.004.038.01.036.014.031.01.015.01.013.013.011.013.009-.004.244c.047.018.085.035.085.053.008.199-.007.397-.015.594-.029.01-.054.02-.08.028l-.002.165c.05.025.082.054.08.086-.022.309-.045.618-.066.928l.023 1.33.042 2.281.037.493.007.16-.002.161-.013.158-.012.074-.015.071-.002.003-.002.003-.01.006-.031.015-.117.04-.42.141-.281.001a13.718 13.718 0 0 1-.24-.008l-.413-.031-.413-.032-.24-.01-.281-.002-.072-.001-.068-.008-.066-.012-.064-.018-.061-.023-.059-.03-.056-.037-.052-.044-.043-.035-.039-.028-.039-.02-.019-.007-.019-.004-.019-.002h-.019l-.018.002-.019.005-.019.007-.018.01-.039.026-.314.221-.081.002-2.296.013-.039-.004-.042-.01-.042-.017-.041-.021-.08-.052-.07-.058-.043-.035-.041-.027-.039-.02-.02-.008-.02-.004-.019-.002h-.019l-.018.002-.02.006-.018.007-.02.011-.037.028-.039.031-.039.024-.041.02-.041.013-.04.007-.039.002-.036-.004-.035-.01v-.017l-.008.017c-1.541-.021-2.859.631-3.822 1.684a.497.497 0 0 1-.379.173c-.137.005-.205.044-.182.161.02.107.021.207.045.323a5.22 5.22 0 0 0-.678 1.622c-.021.076-.117.148-.205.202-.119.07-.16.141-.078.229.081.09.093.182.059.246-.107 1.441.466 2.865 1.465 3.862.098.106.16.222.15.388-.002.138.035.205.151.191l.325-.025a5.356 5.356 0 0 0 1.583.769c.075.022.142.127.19.216.063.119.131.168.224.091.095-.078.187-.081.249-.044 1.432.186 2.889-.303 3.936-1.244a.49.49 0 0 1 .396-.129c.139.01.205-.026.199-.141a26.364 26.364 0 0 1-.008-.326c.369-.457.653-.985.856-1.539.023-.076.136-.135.226-.179.122-.058.176-.121.104-.218-.072-.1-.072-.192-.029-.251l.003-.001h-.001l.02-.166.006-.083.002-.083.004-.166-.007-.167-.006-.112-.009-.113-.015-.357-.005-.036c-.002-.015-.006-.03-.01-.048l-.022-.12-.007-.066.002-.067.005-.032.008-.032.012-.031.015-.029.004-.002.01-.003.031-.006.023-.004.012-.002h.004l.002-.001v-.004l.004-.036.023-.223.082-.083.076-.065.072-.052.07-.047c.046-.029.091-.061.142-.094l.066-.053.071-.068.02-.018.021-.012.025-.008.027-.004.032.002.036.007.039.013.045.018.064.025.023.004h.01l.008-.002.006-.002.004-.005.004-.007v-.008l-.002-.021-.01-.028-.077-.234.01-.01.009-.012.275-.291.285-.286.005-.004.007-.003.018-.003.021.001.025.004.057.018.059.022.064.023.023.005h.01l.008-.002.006-.003.006-.005.002-.006.001-.009-.001-.01-.002-.012-.012-.029-.012-.032-.008-.027-.004-.023.002-.02.004-.015.004-.006.006-.005.005-.004.007-.002.015-.002.004.004-.002-.006 1.305-1.448c.046-.048.121-.056.243.001.104.047.143.043.107-.043l-.078-.232c.186-.196.369-.401.57-.59.025-.026.113.003.189.036.102.044.146.043.105-.046-.04-.09-.027-.136.018-.135l.004.004-.001-.004.939-1.025.639-.697.022-.029.027-.041.068-.1.043-.052.048-.046.026-.021.029-.017.029-.014.031-.01h.005l.008.005.026.019.02.014.01.008.003.002.001.001.002-.001.002-.002.028-.022.174-.141.116-.001.1.008.088.014.083.018.171.032.1.01.116.002.03.001.027.008.028.012.026.018.025.023.023.03.023.037.021.044.018.035.017.028.017.02.008.007.007.004.008.002h.007l.008-.002.008-.005.008-.007.008-.01.016-.026c.041-.071.083-.142.131-.221l.033-.002.473-.012.477-.001.009.001.009.003.017.01.017.017.018.021.033.052.029.058.018.035.018.027.016.02.008.008.008.004.008.002h.008l.008-.002.008-.006.008-.007.008-.011.016-.028.016-.031.017-.024.017-.02.018-.013.016-.007.009-.002h.008l.008.001.007.003.015.01.003.002v-.002c.309-.019.617-.082.926-.103.031-.002.06.046.082.173.019.105.033.13.051.046l.051-.221c.129-.008.26-.022.391-.015.018 0 .037.083.051.16.002.011.004.011.006.02l.062-.037c.013-.031.024-.045.033-.023v.004l.004-.002 1.39-.062.944-.041.037-.005.048-.01c.035-.007.076-.015.12-.022l.065-.006.067.001.033.005.031.008.031.012.029.016.002.004.003.008a.19.19 0 0 0 .007.032l.003.022.002.014.001.003v.002l.004.001.036.004.222.022.084.082.064.075.053.072.047.071.098.144.062.078.082.083.02.022.016.024.011.028.007.031v.035l-.004.038-.01.042-.016.047-.013.037-.008.031-.003.025.001.01.003.009.003.007.006.006.007.003.009.002.011.001.012-.002.029-.008.248-.063.025.022.344.326.338.337.006.006.004.009.004.019.001.024-.003.026-.013.06-.021.062-.012.038-.008.031-.002.025.001.01.002.01.004.007.006.005.007.004.01.002h.01l.013-.002.031-.01.034-.01.029-.007.025-.001.021.003.017.007.008.004.005.006.005.007.003.007.003.017v.004l.003-.001 2.223 2.076c.075.072.105.171.067.312-.03.12-.014.17.085.149l.275-.036c.305.294.618.587.917.896.041.041.028.146.007.233-.028.118-.014.174.089.147.104-.025.166.004.177.06l-.005.005h.008l.123.117.127.111.266.213.266.212.128.111.122.117.01.014.008.015.005.018.003.018.002.039v.081l.004.038.006.018.008.016.01.014.014.012c.047.034.085.064.119.09l.088.074.041.031.042.025.048.022.058.017.005.029c.002.012.007.025.012.041.01.031.021.069.034.106.013.036.023.071.032.102l.181-.145.033-.03c-.036-.035-.066-.068-.061-.073.056-.063.13-.113.196-.171l.091.039.049-.05c-.043-.038-.066-.065-.056-.075.146-.129.326-.255.461-.407l.051-.074.086-.142.078-.146.067-.15.058-.155.023-.078.021-.08.03-.162.015-.165.002-.083-.004-.082-.008-.082-.012-.082-.017-.081-.021-.08-.025-.079-.029-.077-.068-.15-.082-.144-.094-.137-.104-.129-.218-.248-.45-.48-.497-.51-1.936-1.943-1.968-1.933-.879-.816-.559-.547-.263-.278a30.72 30.72 0 0 1-.233-.27l-.007-.012-.005-.016-.002-.048.001-.03.001-.018v-.005l.001-.002.005-.001.018-.002.163-.022 1.021-.141 1.27.007 1.003.031 1.003.032 1.27.012.342.009.162.012.154.018.149.023.142.03.135.037.128.044.103.035c.035.01.066.02.098.028l.093.02.091.011.089.002.089-.007.09-.017c.028-.008.059-.018.092-.026l.766-.221.209-.001.393.006.421.02.226.018.246.029.265.043.294.066.156.045.164.054.17.065.172.077.17.088.164.098.155.103.142.105.129.104.114.101.192.184.285.301.436.456.491.489.989.992.067.072.063.078.061.083.057.086.1.173c.029.057.057.111.082.164l.049.098.051.09.055.082.057.073.062.065.069.059.076.051c.026.014.054.027.084.044l.089.044.087.052.083.057.08.062.074.063.067.065.062.066.052.065.005.024.01-.01c.096.07.226.109.324.18.01.008-.017.049-.1.145-.028.032-.04.048-.049.06l.007.002c.007-.004.005 0 .022-.016l.17-.142c.041.029.087.055.117.096a.618.618 0 0 1-.091.117l.033.009c.019-.013.026-.016.016 0l-.003.003.004.001.973.886.705.646.035.027.047.033.116.085.06.051.056.058.024.03.021.033.018.034.015.036v.001l-.001.003-.004.008a.21.21 0 0 1-.018.028l-.014.019-.008.012-.002.002v.003l.002.004.018.036.113.223-.016.137c-.009.042-.017.08-.023.117l-.057.197-.031.095-.014.05-.004.013-.001.003-.001.002V142.548l-.001-.002h-.001v.001l-.007.01-.006.018-.003.021-.002.026-.001.007-.001.007-.008.012-.014.012-.018.012-.024.012-.03.01-.082.019a1.78 1.78 0 0 1-.064.015l-.02.008-.008.004-.004.004-.002.004v.004l.002.004.005.004.017.009.026.009.219.071v.009l.003.008.033.487v.005l-.002.004-.01.01-.035.021-.105.044c-.022.009-.043.018-.061.024l-.018.012-.007.004-.004.005-.002.005.001.004.003.004.004.003.003.001.018.006.029.004.058.011.021.006.014.007.004.004.004.004.002.004V143.554l-.002.004-.01.009h-.002l.003.002c.079.436.261.815.44 1.116.017.034-.008.079-.105.166-.08.072-.092.101-.009.075l.218-.063c.086.109.172.215.262.311.012.013-.035.085-.079.152a.238.238 0 0 0-.034.067l.062-.009c.062-.041.092-.047.083-.016l-.004.005.006-.001.043.041.051.034.102.065.112.051.056.025.029.011.031.01.12.041.03.01.031.009.064.017.256.08.013.007.011.009.01.013.008.015.029.068.018.033.02.028.012.012.014.009.014.006.016.002.072.005.062.008.054.008.052.003.047.001.048-.004.048-.011.053-.02a.317.317 0 0 0 .02.021l.031.028.091.059.062.04c.004-.123.003-.248.006-.37l.066-.041c.002-.109.004-.204.004-.306-.043-.043-.069-.089-.068-.142l.048-1.159-.005-.269-.042-2.283-.037-.492-.007-.16.002-.162.013-.156.012-.075.015-.071.002-.003.002-.003.01-.006.031-.015.117-.04.42-.141.281-.002c.086.004.166.006.24.008l.413.031.413.033.24.01.281.002.072.002.068.006.066.013.064.018.061.023.059.03.056.037.052.043.043.037.039.027.039.02.019.007.019.005.019.002h.019l.018-.003.019-.005.019-.007.008-.005v-.148c.018-.017.037-.016.059.001l.16-.003.049-.034c.024-.045.051-.082.076-.082.198-.005.395.004.592.01l1.805-.01.039.004.042.011.038.014v-.007l.011-.341.021-.325.03-.317.04-.319c.018-.107.035-.216.055-.328l.068-.347c.029-.119.061-.243.092-.373l.017-.004-.017-.004c.312-1.319 1.015-2.709 2.129-3.684a.424.424 0 0 1 .404-.108c.134.028.198.011.211-.102.016-.103.041-.203.068-.317a7.352 7.352 0 0 1 1.559-.833c.072-.027.184.02.268.07.113.067.183.074.22-.032.037-.11.112-.159.181-.147l.008.009-.002-.009.33-.103.33-.091.328-.081.328-.072.328-.063.326-.054.324-.045.324-.039.438-.04.436-.027.654-.023.037-.005.048-.01c.035-.007.076-.015.12-.022l.066-.007.066.002.033.005.031.008.031.012.029.015.003.004.003.009a.334.334 0 0 0 .006.032l.004.022.001.014.001.003v.002h.005l.036.004.222.023.083.082.065.076.052.072.047.07.046.071.056.076.074.088.094.097.022.025.019.027.014.031.009.034.004.037-.001.041-.008.045-.014.049-.011.039-.007.033v.027l.002.011.002.01.006.008.006.006.008.004h.002l.115-.115c.018-.006.023.002.019.021l.064.063c.054-.034.106-.063.117-.053.063.057.116.122.172.185l.261.25.389.388.006.007.006.01.006.021.003.025-.001.029-.006.039c.05.063.1.126.151.187l.038.037.008.005.007.007.005.007v.001l4.541 4.472 3.924 3.866.868.815.552.546.26.277.23.269.007.012.005.017c0 .012 0 .027.002.047l-.002.031-.002.017v.007l-.004.001-.018.002c-.048.007-.102.015-.163.022l-1.013.141-1.261-.006-.996-.031-.996-.033-1.261-.012-.339-.008-.161-.013-.154-.018-.146-.023-.142-.03-.134-.037-.127-.043-.102-.037a3.01 3.01 0 0 0-.097-.027l-.093-.02-.09-.012-.088-.002-.088.008-.09.017-.091.026-.761.221-.195.002-5.541.013-.098-.004-.1-.011-.101-.016-.101-.021-.191-.052-.173-.058-.104-.035a2.5 2.5 0 0 0-.099-.027l-.095-.021-.093-.011-.09-.002-.088.007-.09.019-.09.028-.094.031-.098.025-.098.019-.099.013-.097.008-.094.001-.09-.004-.082-.009v-.041l-.021.041c-1.226-.002-2.136.453-2.591 1.099-.047.067-.124.097-.266.084-.115-.008-.164.019-.109.102.046.074.084.145.139.221a2.214 2.214 0 0 0-.148.983c.002.045-.07.105-.143.157-.092.067-.116.122-.016.147.1.026.135.07.115.116.256.811.973 1.343 1.983 1.533.104.02.188.083.249.218.053.117.107.146.178.068l.205-.205 1.816-.003c.088 0 .187.083.258.16.096.103.17.133.252.042.082-.092.182-.115.252-.084l.004.009.005-.007 3.7-.061 2.516-.042.543-.037.176-.007.179.002.173.013.083.012.079.015.002.002.004.002.006.009.016.032.01.022.006.014.004.015.015.076.095.475-.028.309c-.013.095-.022.182-.034.264l-.074.449-.18 1.119-.015.085-.02.081-.024.077-.031.073-.035.068-.041.063-.049.059-.054.054-.044.043-.037.042-.027.041-.019.042-.007.021-.004.021-.002.021.001.022.003.022.006.023.018.05.07.197.068.215-.018.096-.153.671-.177.673-.205.674-.115.338-.126.336-.021.047-.029.044-.033.043-.039.04-.084.074-.088.061-.053.037-.045.036-.037.037-.029.04-.011.021-.009.021-.008.022-.004.023-.002.024v.025l.007.054.009.058.002.057-.004.055-.01.053-.016.05-.02.046-.023.041-.028.035-.013.006.008.004c-.018.078.006.178-.013.258-.003.008-.048-.007-.163-.059-.029-.014-.038-.016-.053-.022l.001.01.005.003.189.111c-.008.033-.01.07-.032.098-.002.004-.07-.027-.138-.058l.004.024c.021.014.028.021.01.014l-.008-.004.002.011-.5.947-.14.239-.153.236-.082.116-.086.115-.092.112-.096.11-.021.021-.022.018-.024.015-.025.013-.054.02-.056.016-.055.017-.053.021-.025.014-.023.017-.023.02-.021.023-.091.106-.083.089-.146.145-.066.063-.062.065-.059.072c-.019.025-.038.053-.06.081l-.046.013-.069.025a9.81 9.81 0 0 1-.364.127l-.07.019-.045.008-.025.003-.022.006-.021.008-.018.01-.017.012-.014.014-.013.016-.01.018-.01.018-.006.02-.01.041-.002.045V160.795l-.76.636v.002l-.001.002-.005.021-.01.045-.004.046v.046l.004.044.01.041.014.037.01.016.01.015.013.013.013.01-.023 1.476-.008.7-.004.342.004.129.002.066.002.033.004.033.002.006c.105 1.121 1.078 2.426 2.226 3.621.12.125.189.266.183.442-.003.149.037.224.163.231l.358.047c.515.496 1.07.986 1.627 1.489.076.067.107.205.119.317.017.151.062.231.194.226.133-.006.236.052.278.13l4.25 3.463c.146.125.241.271.259.454.018.155.066.23.198.234l.381.041c.59.511 1.189 1.037 1.766 1.599.078.074.109.219.119.337.014.156.059.242.193.248.139.006.244.075.283.161 1.354 1.326 2.701 2.744 3.828 4.406a.728.728 0 0 1 .142.539c-.024.162.005.25.132.302.117.05.23.113.36.178.431.728.831 1.503 1.144 2.327.046.108.011.268-.028.383-.054.156-.048.26.075.334a.367.367 0 0 1 .182.3l.001.007.118.34.13.339.065.17.057.173.05.175.042.177.001.019-.001.019-.006.018-.006.018-.02.036-.023.035-.023.036-.018.035-.005.019-.003.019.001.018.005.02.047.152.029.119.016.052.02.05.027.05.037.052-.014.027c-.006.011-.011.026-.018.043l-.036.113-.005.014h.014l.037-.004.035-.01.031-.014.014-.01.012-.01.011-.013.009-.013 2.495.039.007-.002 4.702-.102c.185-.002.24.046.329.172.069.104.125.138.174.04l.141-.249.364-.082.433-.108.875-.241c.078-.023.191.029.279.082.116.071.193.078.24-.031.045-.113.127-.164.199-.154a18.758 18.758 0 0 0 3.838-1.897.462.462 0 0 1 .408-.055c.131.04.202.025.219-.09.021-.099.045-.201.07-.314.476-.338.926-.714 1.365-1.096.059-.052.182-.05.279-.038.134.016.205-.01.196-.126-.009-.118.036-.198.104-.22.967-.982 1.709-2.137 2.263-3.362a.43.43 0 0 1 .304-.257c.133-.035.18-.086.129-.188a14.473 14.473 0 0 0-.12-.292c.195-.528.347-1.081.482-1.643.019-.074.119-.144.206-.191.117-.063.16-.126.086-.216-.076-.091-.082-.182-.041-.239l.005-.004h-.003l.014-.107.006-.109-.005-.219-.011-.221.002-.108.01-.107.004-.011.007-.01.021-.017.059-.031.029-.016.025-.017.01-.01.006-.01.004-.012v-.012l-.01-.053-.003-.045-.003-.074-.004-.033-.009-.032-.017-.033-.024-.036.019-.014.023-.023.055-.061.053-.062.023-.022a.18.18 0 0 0 .017-.014l.011-.008.008-.008.004-.007.002-.007-.002-.008-.004-.007-.008-.007-.009-.007-.024-.013-.032-.011-.037-.011-.011-.002-.004-.001-.03-.206-.003-.011-.008-.021-.012-.018-.016-.016-.018-.011-.02-.007-.021-.002-.023.004-.025.011-.929-.984-.001-.005-.003.003c-.085-.06-.202-.086-.289-.145-.009-.006.019-.046.103-.141.02-.022.023-.028.034-.041l-.013-.003-.168.143c-.035-.024-.076-.044-.102-.08a.611.611 0 0 1 .091-.113l-.028-.008c-.019.014-.026.017-.015.001l.005-.005-.01-.002-.158-.154-.165-.148-.339-.285-.34-.286-.164-.148-.158-.153-.014-.018-.012-.019-.008-.021-.006-.021-.009-.045-.005-.047-.007-.047-.011-.044-.01-.021-.01-.02-.015-.018-.019-.016c-.059-.047-.107-.088-.15-.123a5.291 5.291 0 0 1-.113-.099l-.051-.042-.054-.037-.059-.032-.068-.028c-.003-.008-.005-.02-.01-.033-.005-.015-.013-.031-.021-.051a4.971 4.971 0 0 0-.057-.128l-.056-.127-.02-.05-.009-.032-.004-.019-.006-.016-.008-.014-.01-.011-.012-.009-.013-.006-.015-.004-.016-.002-.014.001c.014.048.021.091.004.108-.199.211-.414.405-.621.602l-.062-.02-.186.203a.14.14 0 0 1-.041.104l-.341.309-.354.385-.021.029-.027.041a1.942 1.942 0 0 0-.068.101l-.043.051-.049.047-.026.02-.028.018-.029.014-.032.01h-.005l-.008-.005-.026-.019-.019-.014-.006-.004-.439.398-.305-.305-.047-.006a15.77 15.77 0 0 0-.158-.012l-.186-.004-.047-.003-.045-.007-.044-.013-.042-.02-.039-.025-.038-.032-.035-.038-.032-.045-.027-.037-.024-.029-.024-.021-.012-.007-.012-.005-.012-.003h-.012l-.013.001-.013.005-.012.007-.013.009-.026.025-.104.104-.115.104-.054-.001-.381-.023-.385-.033-.389-.046-.193-.026-.195-.035-.014-.003-.013-.005-.026-.016-.025-.021-.023-.025-.045-.06-.037-.064-.023-.04-.021-.032-.022-.023-.012-.01-.012-.007-.013-.005-.012-.002h-.013l-.013.002-.014.005-.015.008-.03.022-.032.025-.032.02-.031.013-.029.007-.029.002-.025-.004-.024-.01-.021-.014-.004-.005-.001.004c-1.615-.325-3.329-.975-4.715-2.198-.14-.127-.229-.274-.229-.457-.002-.154-.041-.227-.169-.242-.116-.018-.235-.047-.366-.078a8.346 8.346 0 0 1-1.272-1.901c-.046-.092-.021-.231.017-.339.049-.143.041-.229-.076-.28-.122-.051-.188-.148-.186-.235l.011-.004-.012-.005-.155-.415-.137-.42-.119-.422-.104-.424-.088-.426-.071-.427-.057-.429-.041-.429-.031-.587-.005-.297.004-.3.014-.309.031-.351.059-.495.021-.433.013-.14.02-.14.031-.135.02-.063.024-.06.001-.002.004-.002.009-.005.033-.008.023-.005.014-.002.013-.004.06-.022.366-.141.247-.001.21.008.361.031.361.032.211.01.246.002.062.001.061.008.059.012.056.018.054.023.051.03.049.037.046.044.036.035.035.028.034.02.017.007.016.004.016.002h.017l.017-.002.016-.005.016-.007.016-.01.033-.026.275-.221.072-.002.499-.006.251-.003.338.009 1.366.046.047.005.046.012.045.018.044.021.041.025.038.027.066.059.04.035.038.028.039.02.021.008.021.005.02.003h.021l.022-.002.022-.004.047-.013.051-.021.055-.023.026-.01.026-.006.053-.009.049-.003.048.004.044.01.039.015.018.009.017.012-.003.009.012-.007c.675.199 1.203.679 1.657 1.193.23.261.446.541.661.824l.311.396.209.239c.541.589 1.118.958 1.865 1.235.154.043.276.13.355.287zm-1.65-24.341-.015.086-.017.08-.033.166-.01.097-.002.113-.002.029-.006.027-.013.027-.018.025-.024.024-.029.023-.037.022-.043.021-.037.017-.027.017-.02.016-.007.007-.005.008-.002.007v.008l.003.007.005.008.007.007.01.008.026.016.221.127.002.032.012.46.001.334-.001.002.001.128-.001.008-.003.009-.011.017-.016.017-.008.007c.008.003.021.005.021.009-.018.092-.064.184-.089.275v.008l-.001.007-.003.008-.001.001c.018.938.034 1.878.051 2.816l.042 2.283.037.492.007.16-.002.162-.013.156-.012.075-.015.071-.002.003-.002.003-.01.006-.031.015-.117.04-.42.141-.281.002c-.086-.004-.166-.006-.24-.008l-.413-.031-.413-.033-.24-.01-.281-.002-.072-.002-.068-.006-.066-.013-.064-.018-.061-.023-.059-.03-.056-.037-.052-.043-.043-.037-.039-.027-.039-.02-.019-.007-.019-.005-.019-.002h-.019l-.018.003-.019.005-.019.007-.018.01-.039.026-.314.221-.081.002-1.745.01-.002.003c-.023.001-.047-.003-.07-.003l-.479.003-.039-.004-.042-.011-.032-.012c-.195-.018-.391-.042-.584-.064l-1.541.031-2.072.042-.492.037-.16.007-.162-.002-.156-.013-.075-.012-.071-.015-.003-.002-.003-.002-.006-.009-.014-.032-.041-.117-.141-.42-.002-.281c.004-.086.006-.166.008-.24l.031-.413.031-.388.004-.157a35.173 35.173 0 0 1-.006-.185v-.047l.006-.046.01-.044.016-.043.023-.041.028-.039.035-.038.042-.036.035-.03.027-.027.019-.026.007-.014.004-.012.002-.013-.001-.013-.003-.012-.006-.012-.007-.012-.011-.012-.027-.023-.227-.194-.004-.053-.002-.047-.004-.046-.012-.088-.025-.178-.049-.355-.045-.357-.072-.334-.002-.012v-.012l.006-.026.01-.027.016-.028.039-.059.047-.055.029-.033.021-.031.014-.027.005-.014.002-.012-.001-.012-.002-.012-.005-.01-.007-.01-.01-.01-.012-.008-.033-.016-.035-.015-.029-.018-.023-.019-.018-.021-.012-.022-.007-.021-.003-.021.002-.021.002-.002-.003-.003c-.294-.951-.765-1.578-1.52-2.383a.36.36 0 0 1-.089-.352c.028-.127.008-.185-.1-.177-.095.008-.195-.007-.309-.016-.373-.404-.816-.896-1.167-1.514-.049-.08-.036-.209-.001-.314.045-.141.039-.224-.079-.262-.12-.039-.188-.128-.189-.21l.013-.006-.016-.005-.118-.256-.015-.033-.012-.032-.022-.065-.043-.131-.167-.526-.041-.132-.02-.066-.014-.064-.049-.258-.094-.518-.044-.259-.019-.247-.034-.496-.029-.49-.009-.42-.042-2.281-.037-.493-.007-.16.002-.161.013-.158.012-.074.015-.071.002-.003.002-.003.01-.006.031-.015.117-.04.42-.141.281-.001.24.008.413.031.413.032.24.01.281.002.072.001.068.008.066.012.064.018.061.023.059.03.056.037.052.044.043.035.039.028.039.02.019.007.019.004.019.002h.019l.018-.002.019-.005.019-.007.018-.01.039-.026.314-.221.081-.002 1.276-.007c.002-.001.003-.006.004-.006.055-.002.109.004.164.005l.852-.005.039.004.042.01.042.017.041.021.005.003.052.005.969-.041.037-.005.05-.01c.036-.007.078-.015.123-.022l.067-.006.069.001.034.005.033.008.031.012.031.016.002.004.002.008a.379.379 0 0 1 .006.032l.004.022.002.014.001.003.001.002.004.001.036.005c.054.008.131.019.226.031l.084.086.065.079.053.075.046.073c.031.048.062.096.099.149.021.025.041.052.063.081l.082.087.02.023.016.026.012.028.006.032.001.035-.005.039-.01.042-.016.046-.014.038-.009.032-.003.025.001.01.003.009.003.007.006.006.007.004.009.002.011.001.012-.001.031-.007.252-.056.025.023.346.344.34.353.006.007.004.008.005.021.001.023-.004.027-.013.06-.021.062-.013.037-.009.032-.002.025.001.011.003.009.004.007.005.006.007.004.01.002.011.001.013-.001.031-.009.034-.01.03-.005.025-.001.021.004.018.007.006.006.006.006.005.006.003.008.004.018v.004l.002-.002 2.521 2.477a.348.348 0 0 1 .092.345c-.025.126-.006.183.101.171l.295-.011c.347.349.702.698 1.042 1.063.047.049.04.16.022.254-.023.124-.005.187.104.169s.18.021.194.082l-.006.005.007-.001.98.932.666.634.028.022.04.026c.027.021.061.044.096.068l.05.042.044.048.019.026.017.028.012.029.01.031-.002.005-.004.008c-.006.006-.012.015-.02.026l-.014.018-.008.011-.003.003-.001.001v.001l.004.003.021.027.141.169.002.113a.828.828 0 0 1-.002.102zM284.991 188.917l.008.01.012.008.027.016.033.012.039.01.011.001.005.001h.001a7.844 7.844 0 0 1-.106-.177l-.009.021-.014.026-.009.014-.006.014-.002.013v.012l.004.011.006.008z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "m298.077 140.916-.021-.027-.004-.003v-.001l.001-.001.003-.003.008-.011.014-.018a.131.131 0 0 1 .02-.026l.004-.008.002-.005-.01-.031-.012-.029-.017-.028-.019-.026-.044-.048-.05-.042-.096-.068-.04-.026a.618.618 0 0 0-.028-.022l-.666-.634-.98-.932-.007.001.006-.005c-.015-.062-.085-.1-.194-.082s-.128-.045-.104-.169c.018-.094.024-.205-.022-.254-.34-.365-.695-.715-1.042-1.063l-.295.011c-.106.012-.126-.045-.101-.171a.349.349 0 0 0-.092-.345c-.842-.826-1.684-1.653-2.521-2.477l-.002.002v-.004l-.004-.018-.003-.008-.005-.006-.006-.006-.006-.006-.018-.007-.021-.004-.025.001-.03.005-.034.01-.031.009-.013.001-.011-.001-.01-.002-.007-.004-.005-.006-.004-.007-.003-.009-.001-.011.002-.025.009-.032.013-.037.021-.062.013-.06.004-.027-.001-.023-.005-.021-.004-.008-.008-.007-.34-.353-.346-.344-.025-.023-.252.056-.031.007-.012.001-.011-.001-.009-.002-.007-.004-.006-.006-.003-.007-.003-.009-.001-.01.003-.025.009-.032.014-.038.016-.046.01-.042.005-.039-.001-.035-.006-.032-.012-.028-.016-.026-.02-.023-.082-.087a3.998 3.998 0 0 0-.063-.081l-.099-.149-.046-.073-.053-.075-.065-.079-.084-.086-.226-.031-.036-.005-.004-.001-.001-.002-.001-.003-.002-.014-.004-.022a.314.314 0 0 0-.006-.032l-.002-.008-.002-.004-.031-.016-.031-.012-.033-.008-.034-.005-.069-.001-.067.006-.123.022a2.205 2.205 0 0 1-.05.01l-.037.005-.969.041-.052-.005-.005-.003-.041-.021-.042-.017-.042-.01-.039-.004-.852.005c-.055-.001-.109-.007-.164-.005-.001 0-.002.005-.004.006l-1.276.007-.081.002c-.113.079-.215.149-.314.221l-.039.026-.018.01-.019.007-.019.005-.018.002h-.019l-.019-.002-.019-.004-.019-.007-.039-.02-.039-.028-.043-.035-.052-.044-.056-.037-.059-.03-.061-.023-.064-.018-.066-.012-.068-.008-.072-.001-.281-.002-.24-.01a94.672 94.672 0 0 0-.826-.063 13.718 13.718 0 0 0-.24-.008l-.281.001c-.176.059-.319.106-.42.141l-.117.04-.031.015-.01.006-.002.003-.002.003-.015.071-.012.074-.013.158-.002.161.007.16.037.493.042 2.281.009.42.029.49.034.496.019.247.044.259.094.518.049.258.014.064.02.066.041.132.167.526.043.131.022.065.012.032.015.033.118.256.016.005-.013.006c.002.082.069.171.189.21.118.038.124.121.079.262-.035.105-.048.234.001.314.351.617.794 1.109 1.167 1.514.113.009.214.023.309.016.107-.008.128.05.1.177a.36.36 0 0 0 .089.352c.755.805 1.226 1.432 1.52 2.383l.003.003-.002.002-.002.021.003.021.007.021.012.022.018.021.023.019.029.018.035.015.033.016.012.008.01.01.007.01.005.01.002.012.001.012-.002.012-.005.014-.014.027-.021.031-.029.033-.047.055-.039.059-.016.028-.01.027-.006.026v.012l.002.012.072.334.045.357.049.355.025.178.012.088.004.046.002.047.004.053.227.194.027.023.011.012.007.012.006.012.003.012.001.013-.002.013-.004.012-.007.014-.019.026-.027.027-.035.03-.042.036-.035.038-.028.039-.023.041-.016.043-.01.044-.006.046v.047l.006.185-.004.157-.031.388-.031.413c-.002.074-.004.154-.008.24l.002.281.141.42.041.117.014.032.006.009.003.002.003.002.071.015.075.012.156.013.162.002.16-.007.492-.037 2.072-.042 1.541-.031c.193.022.389.047.584.064l.032.012.042.011.039.004.479-.003c.023 0 .047.004.07.003l.002-.003 1.745-.01.081-.002c.113-.08.215-.15.314-.221l.039-.026.018-.01.019-.007.019-.005.018-.003h.019l.019.002.019.005.019.007.039.02.039.027.043.037.052.043.056.037.059.03.061.023.064.018.066.013.068.006.072.002.281.002.24.01.413.033.413.031c.074.002.154.004.24.008l.281-.002.42-.141.117-.04.031-.015.01-.006.002-.003.002-.003.015-.071.012-.075.013-.156.002-.162-.007-.16-.037-.492-.042-2.283c-.017-.938-.033-1.878-.051-2.816l.001-.001.003-.008.001-.007v-.008c.024-.092.071-.184.089-.275 0-.004-.014-.006-.021-.009l.008-.007.016-.017.011-.017.003-.009.001-.008v-.13l-.001-.334-.012-.46-.002-.032-.221-.127-.026-.016-.01-.008-.007-.007-.005-.008-.003-.007v-.008l.002-.007.005-.008.007-.007.02-.016.027-.017.037-.017.043-.021.037-.022.029-.023.024-.024.018-.025.013-.027.006-.027.002-.029.002-.113.01-.097.033-.166.017-.08.015-.086c.002-.03.004-.062.008-.097a3.844 3.844 0 0 1-.002-.113l-.145-.174zm-8.031 5.528-.017-.033-.014-.037-.003-.011-.002-.005.052.107-.016-.021zm4.631-.187-.006.014-.007.013-.009.013-.025.021-.033.02-.037.016-.043.013-.044.009-.046.004h-.046l-.044-.004-.041-.01-.037-.014-.016-.01-.014-.01-.014-.013-.01-.013-1.536.021-.831-.07c-.002 0-.005.008-.008.009l-.104-.01-.19-.012-.001-.002-.005.002-.189-.004-.02.003-.018.005-.018.009-.018.011-.033.026-.032.029-.032.028-.035.023-.018.008-.019.006-.02.003-.021-.001a5.157 5.157 0 0 0-.17-.021 3.412 3.412 0 0 1-.131-.01l-.057-.006-.057-.012-.056-.019-.06-.028-.027.017a.288.288 0 0 1-.043.021c-.033.015-.074.032-.113.051l-.113.05-.043.021-.011.007.009-.012.01-.012.013-.01-.171-1.212-.137-.588-.074-.312-.039-.165-.021-.085-.012-.044-.016-.044-.004-.001.002-.006c-.165-.44-.168-.932-.405-1.37-.043-.09-.133-.148-.247-.174-.305-.068-.139-.304-.148-.484l-.16-.045c-.209-.059-.213-.055-.175-.326.016-.113.019-.217-.042-.299-.516-.711-1.089-1.275-1.525-1.737-.445-.469-.734-.818-.914-1.239l-.005.002.003-.007-.061-.131-.006-.017-.004-.019-.008-.038-.014-.074-.053-.298-.014-.073-.003-.082-.008-.164-.015-.162-.025-.16-.006-.016-.008-.015-.011-.014-.013-.014-.061-.053-.03-.027-.024-.03-.01-.016-.006-.018-.003-.018.001-.021.014-.16c0-.046.002-.086.003-.123l.004-.055.009-.053.016-.053.025-.057-.019-.024-.023-.04-.057-.108-.05-.129-.021-.049-.016-.029-.012-.016-.006-.016-.004-.016-.002-.015.002-.014.006-.014.007-.013.009-.012.025-.022.033-.02.037-.016.043-.013.044-.008.046-.005h.046l.044.004.041.01.037.015.016.009.014.011.014.012.01.014 1.046-.015.134.027.188.038.095.012.094.002.009-.002.01-.006.008-.008.01-.011.015-.026.575.037c.021.001.037-.034.053-.079l.02-.001.013.014.01.017.006.02v.021l-.005.023-.012.024.899.879h.006l-.003.003c.26.262.432.607.691.869.053.055.141.065.247.043.284-.059.177.189.194.34l.146-.012c.19-.015.196-.016.18.222-.007.1-.003.182.052.238l2.861 2.85.004-.004-.002.006.06.066.054.072.096.155.096.153.053.072.061.065.008.006.01.002h.012l.013-.002.062-.017.03-.009.028-.005h.012l.01.003.008.004.004.004.002.005.02.039.02.031.035.05.014.023.009.027.005.031-.002.039.021-.003h.029l.072.003.072.003.029-.001.02-.003.012-.003h.01l.008.002.004.004.002.005.001.007-.001.01-.004.01-.012.023-.019.028-.022.03-.007.009-.003.004v.001l.001.001.005.009.01.018.004.02v.018l-.004.018-.01.018-.014.014-.02.013-.025.009.022.696c-.022.098-.058.195-.072.293-.001.005.033.009.077.014l-.002.036-.037.002.037.004-.002.034v.001c-.051.004-.088.008-.088.013-.004.026.053.051.08.077l-.029.351-.037.441-.012.221-.004.22.003.022.005.021.009.021.011.02.025.037.03.037.028.038.023.039.008.021.006.021.003.022-.001.023a6.887 6.887 0 0 0-.021.193l-.01.149-.006.066-.012.063-.019.064-.028.068.018.03.021.05c.014.038.031.085.05.13l.05.13.021.049.016.029.012.017.006.016.004.015.002.015-.004.02z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M157.707 225.124h.002v.006h-.002zM119.806 284.673l-.061-1.618-.042-1.108-.005-.043c-.002-.018-.006-.037-.01-.059l-.022-.143-.007-.079.002-.081.005-.039.008-.038.012-.038.015-.035.002-.001.002-.001.01-.004.031-.007.023-.004.012-.003h.006v-.002l.002-.004.013-.037.081-.238.109-.086.101-.066c.065-.035.124-.066.182-.099l.179-.094.088-.056.101-.076.026-.019.029-.014.031-.009.033-.004.036.002.04.007.043.013.045.02.037.017.032.011.026.005h.01l.01-.002.008-.004.007-.005.005-.007.004-.009.002-.012.001-.013-.003-.031-.023-.263.028-.024.816-.671.008-.005.009-.004.021-.004.025.001.027.004.061.017.062.024.037.015.033.009.025.004h.012l.01-.002.008-.004.007-.006.005-.007.004-.009.002-.012v-.014l-.005-.032-.006-.036-.001-.031.002-.026.007-.022.01-.017.006-.007.007-.006.008-.004.008-.004.019-.002.002.002.001-.005c1.395-1.162 2.74-2.401 4.092-3.63a.655.655 0 0 1 .475-.193c.156.004.235-.035.254-.165l.08-.367 1.686-1.571c.076-.071.219-.092.334-.094.153-.003.239-.043.248-.176.008-.135.078-.232.162-.267a121.549 121.549 0 0 0 3.816-3.916.657.657 0 0 1 .461-.226c.156-.008.234-.051.24-.183l.05-.373 1.556-1.692c.07-.076.211-.107.324-.119.152-.014.235-.061.232-.193-.002-.135.061-.237.141-.278 1.197-1.36 2.332-2.783 3.443-4.213a.65.65 0 0 1 .434-.269c.152-.021.225-.073.22-.203l.015-.373 1.365-1.828c.061-.082.199-.126.309-.15.148-.031.225-.086.205-.218-.018-.134.03-.243.104-.292 1.041-1.468 1.953-3.02 2.854-4.564.096-.156.215-.272.385-.322.146-.045.207-.105.182-.232l-.049-.369c.361-.65.702-1.32 1.029-1.992.045-.09.17-.157.275-.197.143-.055.209-.12.168-.244-.04-.125-.01-.238.055-.298.693-1.616 1.318-3.269 1.734-4.944a.62.62 0 0 1 .298-.396c.126-.078.166-.151.104-.264l-.153-.332.219-1.057c.064-.354.095-.709.153-1.063.013-.096.109-.194.197-.264.117-.094.158-.175.08-.274a.29.29 0 0 1-.052-.286l.003-.003h-.001l-.013-1.062-.015-.778-.005-.037-.01-.048-.022-.119-.007-.066.002-.067.005-.033.008-.031.012-.031.015-.029.004-.003.01-.002a.345.345 0 0 1 .031-.006l.023-.004.012-.002.004-.001h.002v-.005l.004-.035.023-.223.082-.083a6.8 6.8 0 0 1 .076-.064l.072-.053.07-.047.143-.096c.022-.019.047-.037.072-.059l.078-.076.021-.018.023-.014.026-.01.03-.005h.033l.037.005.041.012.046.016.037.015.029.009.025.003h.01l.008-.002.006-.004.006-.005.003-.007.001-.008v-.011l-.001-.012-.009-.028-.07-.242.012-.011.009-.013.304-.319.312-.314.006-.005.008-.004.019-.004h.022l.026.004.058.015.061.021.037.013.03.009.024.003h.01l.009-.003.007-.003.004-.005.004-.007.002-.009-.001-.01-.002-.013-.01-.03-.012-.033-.007-.028-.002-.024.002-.021.006-.016.004-.007.006-.005.006-.005.006-.002.017-.003.002.002v-.005l2.5-2.646a.36.36 0 0 1 .349-.104c.129.021.186-.001.173-.108l-.013-.299c.353-.363.705-.737 1.074-1.095.049-.049.162-.046.258-.031.126.02.189-.002.17-.111-.019-.111.021-.184.083-.201h.004l-.001-.001.062-.067.057-.073.103-.155.103-.156.057-.072.062-.067.008-.005.01-.002h.012l.014.002.061.017.031.01.028.005h.013l.01-.002.008-.005.006-.009.021-.039.021-.031.037-.051.014-.024.011-.026.006-.032v-.04a.26.26 0 0 0 .021.003l.03.001.073-.003.074-.003.029.001.02.003.012.003.01.001.008-.002.004-.004.004-.006v-.007l-.002-.009-.002-.01-.012-.025-.018-.027-.021-.032-.007-.008-.003-.005v-.001l.001-.001.005-.009.01-.019.004-.019v-.02l-.004-.019-.01-.017-.014-.015-.02-.013-.025-.01c.015-.464.023-.759.039-1.222l.004-.004h-.006c-.018-.389-.082-.779-.102-1.17-.002-.04.046-.075.172-.104.107-.023.131-.042.047-.063l-.221-.065c-.008-.162-.022-.328-.015-.493 0-.022.083-.047.16-.065.028-.007.036-.013.053-.019l-.047-.06c-.052-.018-.073-.036-.048-.051h.008l-.006-.007-.004-.206-.012-.205-.037-.41-.037-.411-.012-.205-.004-.204.003-.021.005-.02.009-.019.011-.019.025-.035.03-.034.028-.035.023-.036.008-.019.006-.021.003-.021-.001-.022a5.437 5.437 0 0 1-.021-.18l-.01-.139-.006-.062-.012-.06-.019-.06-.028-.063.018-.028.021-.046c.014-.036.031-.078.05-.121l.05-.121.021-.045.016-.027.012-.015.006-.015.004-.014.002-.014-.002-.014-.006-.012-.007-.012-.009-.012-.008-.006-.006-.002-.042-.006-.042-.002-.039.003-.038.008-.034.013-.015.009-.014.011-.013.011-.01.013a28.806 28.806 0 0 1-.365-.02l-.087-.005-.085-.009-.167-.021a532.782 532.782 0 0 0-1.97-.239l.001-.006-.009.006c-1.92-.306-3.869-.65-5.725-1.331-.191-.065-.344-.164-.431-.332-.073-.146-.147-.203-.277-.166l-.384.078-1.146-.468c-.376-.173-.744-.363-1.115-.551-.1-.051-.176-.182-.221-.291-.061-.146-.132-.215-.268-.181-.139.036-.26-.006-.321-.08a38.245 38.245 0 0 1-4.89-3.132c-.154-.123-.26-.269-.287-.454-.025-.157-.08-.231-.214-.231l-.389-.031c-.631-.494-1.233-1.028-1.838-1.563-.079-.073-.113-.219-.126-.335-.016-.157-.063-.241-.199-.243-.137-.002-.242-.068-.285-.151a99.16 99.16 0 0 1-4.055-3.892c-.134-.137-.215-.29-.216-.474-.003-.156-.044-.235-.175-.25l-.372-.071c-.532-.553-1.073-1.112-1.614-1.673-.071-.076-.094-.219-.097-.334-.005-.154-.045-.24-.178-.248-.135-.008-.233-.076-.269-.158a79.711 79.711 0 0 0-3.917-3.719.625.625 0 0 1-.233-.443c-.011-.153-.057-.228-.186-.229l-.365-.034c-.57-.455-1.135-.949-1.723-1.385-.078-.061-.117-.194-.136-.306-.024-.148-.075-.225-.203-.208-.13.017-.233-.033-.278-.107a22.692 22.692 0 0 0-4.474-2.443.577.577 0 0 1-.347-.328c-.058-.139-.123-.191-.238-.148l-.338.104c-.669-.188-1.332-.434-2.024-.563-.093-.021-.179-.125-.239-.218-.08-.124-.156-.172-.262-.102s-.215.069-.285.021c-1.664-.266-3.282-.218-5.191-.187a.666.666 0 0 1-.488-.172c-.113-.107-.199-.131-.301-.047l-.307.221-2.326.015c-.105 0-.225-.083-.311-.16-.115-.103-.205-.133-.303-.042-.1.092-.219.115-.304.084l-5.521.102a.663.663 0 0 1-.487-.172c-.114-.107-.2-.131-.301-.047l-.308.221-2.326.015c-.105 0-.225-.083-.311-.16-.114-.103-.205-.133-.303-.042-.1.092-.219.115-.303.084l-5.521.102a.66.66 0 0 1-.486-.172c-.114-.107-.2-.131-.301-.047l-.309.221-2.326.015c-.104 0-.224-.083-.31-.16-.114-.103-.205-.133-.303-.042-.1.092-.219.115-.304.084-.833.017-2.039.043-3.117-.184a9.717 9.717 0 0 1-3.149-1.186c-.202-.122-.356-.265-.411-.472-.052-.17-.119-.251-.27-.259a5.068 5.068 0 0 1-.44-.061 8.783 8.783 0 0 1-1.066-1.056.626.626 0 0 0-.054.242c.016 1.081.052 2.15.098 3.214l1.552 1.539c.111.11.179.295.215.44.048.194.122.312.29.351a.62.62 0 0 1 .381.262l-.004.003.006.001.066.062.073.056.155.103.156.104.073.057.066.062.005.008.002.01v.012l-.002.014-.017.061-.009.031-.006.028v.012l.002.011.006.008.008.006.039.021.031.021.051.038.024.014.026.011.033.006h.039l-.003.021-.001.03.003.073.003.073-.001.029-.003.021-.003.012-.001.01.002.008.004.004.006.003.011-.003.009-.002.011-.003.024-.011.028-.018.031-.021.009-.007.004-.003h.001l.001.001.009.006.019.009.02.004h.019l.019-.004.017-.01.015-.014.014-.02.01-.025 1.222.039v.001l.003-.003 3.056-.102c.104-.002.196.046.27.172.063.107.11.131.167.047l.17-.221c.425-.008.855-.022 1.287-.015.059 0 .125.083.172.16.063.103.113.133.168.042.055-.092.121-.115.168-.084v.012l.008-.01 3.355-.061 2.283-.042.492-.037.16-.007.162.002.156.013.075.012.071.015.003.002.003.002.006.009.014.032.041.117.141.42.002.281c-.004.086-.006.166-.008.24l-.031.413-.033.413-.01.24-.002.281-.002.072-.006.068-.013.066-.018.064-.024.061-.029.059-.037.056-.043.052-.037.043-.027.04-.02.038-.007.019-.005.019-.002.019v.019l.003.018.005.019.007.019.01.019.026.038.221.314.002.081.013 2.296-.004.039-.011.042-.016.042-.021.041-.051.08-.058.07-.035.043-.028.041-.02.039-.006.02-.005.02-.003.019.001.019.003.019.004.019.008.018.01.019.029.038.031.038.025.04.019.041.013.041.008.04.001.039-.004.037-.009.034-.004.008h.004c.018.111.082.224.102.335.002.012-.046.021-.172.03-.107.006-.131.012-.047.018l.221.019c.008.047.022.094.015.142a.753.753 0 0 1-.16.019c-.103.007-.133.013-.042.019.092.006.115.013.084.019h-.284l-.001.003h.283l.061 1.391.042.945.005.036c.002.015.006.03.01.048l.022.119.007.066-.002.067-.005.033-.008.032-.012.031-.015.029-.004.002-.01.002-.031.007-.023.003-.012.002-.004.001h-.002v.005l-.004.035-.023.223-.082.084a3.14 3.14 0 0 0-.076.064l-.072.053-.07.046-.145.098-.077.063-.083.081-.022.021-.025.015-.028.011-.031.007-.034.001-.038-.004-.043-.01-.046-.016-.038-.014-.031-.008-.025-.002h-.01l-.009.003-.007.004-.005.005-.004.008-.002.008-.001.011.002.013.008.029.063.248-.022.025-.326.343-.337.339-.007.005-.008.004-.02.005h-.029l-.027-.002-.059-.014-.062-.02-.037-.012-.031-.008-.025-.002h-.011l-.009.003-.007.004-.005.005-.001.002-.004.031.001.007.009.03.011.034.006.029.002.025-.003.021-.007.017-.005.007-.005.006-.007.004-.007.004-.018.003-.002-.002v.005l-2.513 2.657a.363.363 0 0 1-.351.105c-.128-.021-.186.002-.173.108l.012.3c-.354.365-.708.74-1.079 1.1-.049.049-.163.047-.258.032-.127-.02-.189.002-.172.112.019.111-.021.184-.083.201h-.004l.001.001-.064.069-.059.075-.107.161-.107.16-.059.074-.064.069-.008.005-.011.003h-.013l-.014-.001-.062-.018-.029-.009-.028-.005-.012.001-.012.002-.008.005-.006.009-.022.04-.022.033-.038.052-.015.024-.012.027-.006.033-.001.041-.021-.003-.03-.001-.074.004-.075.004h-.03a.22.22 0 0 0-.02-.002l-.013-.003-.01-.001-.007.002-.006.004-.002.006-.002.008.002.009.003.011.011.024.018.028.021.031.006.009.004.004.002.051v.001l-.002.001-.005.01-.008.02-.005.021.001.02.005.019.01.018.015.016.021.013.025.01-.009 1.279-.003.004h.004c.119 1.876.352 3.746.75 5.55a.678.678 0 0 1-.072.516c-.082.136-.088.227.014.308.094.076.171.166.28.252.226.729.386 1.495.657 2.212.034.097-.006.235-.051.341-.061.143-.059.238.059.299.119.062.18.165.177.256a20.059 20.059 0 0 0 2.649 4.677.66.66 0 0 1 .141.489c-.021.157.021.232.148.258l.365.092c.473.578 1.012 1.116 1.549 1.662.075.07.104.211.112.324.013.153.059.237.19.237.135 0 .236.063.277.145 1.363 1.216 2.938 2.246 4.551 3.321.167.111.284.248.329.432.04.155.102.227.239.217l.396.003c.683.455 1.394.914 2.092 1.434.094.068.152.213.184.331.042.158.105.238.246.231a.372.372 0 0 1 .322.144c1.64 1.231 3.345 2.693 4.545 4.665.123.2.189.4.161.6-.028.175-.009.279.121.353.117.07.23.155.362.245.224.424.395.871.551 1.326.18.45.294.913.396 1.379.03.125-.018.285-.069.401-.072.156-.068.266.031.364.107.101.15.239.133.345.19 1.068.23 2.212.264 3.197l.057 2.943c.002.202-.045.379-.172.52-.105.121-.13.213-.045.32.068.103.142.21.221.327l.019 2.479c0 .111-.083.238-.159.33-.104.122-.133.218-.042.322.093.106.116.233.084.323l.111 5.881c.001.202-.046.378-.172.52-.106.121-.13.212-.046.32l.221.327.019 2.478c.001.112-.082.239-.159.33-.104.123-.133.219-.042.323.093.106.116.233.084.323l.013.661.296.336c.066.392.144.711.212 1.044.614.049 1.133.255 1.51.737.145.179.32.335.478.501.08.084.149.174.218.256l.209 1.097c.369.406.764.81 1.162 1.217l1.249 1.185c.358.352.788.441 1.245.497a.758.758 0 0 1 .666.668c.065.467.234.87.603 1.197.763.714 1.588 1.351 2.362 2.046.371.326.762.576 1.234.646l-.011-2.005c0-.12.083-.257.16-.355.103-.132.133-.235.042-.348a.39.39 0 0 1-.084-.349h1.753v-.004h-1.753zM113.03 121.476l-.021.029-.027.041-.068.101-.043.051-.049.046-.025.021-.029.017-.029.014-.032.011-.004-.001-.008-.005-.026-.019-.02-.014-.01-.008-.004-.002-.001-.001-.001.001-.002.002-.028.022-.174.141-.116.001a2.548 2.548 0 0 1-.1-.008l-.088-.014-.083-.018-.171-.032-.1-.01-.116-.002-.03-.001-.027-.008-.028-.012-.026-.018-.025-.023-.023-.03-.023-.037-.021-.044-.018-.035-.017-.028-.017-.02-.007-.007-.008-.004-.008-.002h-.007l-.008.002-.008.005-.008.007-.008.01-.016.026a19.63 19.63 0 0 1-.13.221l-.034.002-.473.012-.477.001-.008-.001-.009-.003-.017-.01-.018-.017-.018-.021-.033-.052-.029-.058-.018-.035-.018-.027-.016-.02-.008-.008-.008-.004-.008-.002h-.008l-.008.002-.008.006-.008.007-.007.011-.016.028-.017.031-.016.024-.018.02-.017.013-.017.007-.008.002h-.008l-.008-.001-.008-.003-.014-.01-.004-.006v.006l-2.619.103c-.091.002-.169-.046-.232-.173-.054-.105-.094-.13-.143-.046l-.146.221c-.364.008-.734.022-1.104.015-.049 0-.105-.083-.146-.16-.055-.104-.098-.133-.145-.042-.047.092-.104.115-.144.083l-.004-.007v.005l-1.765.062-1.285.041-.326.037-.107.006-.107-.001-.053-.005-.051-.008-.031-.008c-.771 1.042-1.486 2.117-2.229 3.156l-.984.43c.082.604-.033 1.135-.416 1.613-.139.182-.25.391-.373.583-.062.098-.133.187-.196.271l-1.011.457c-.614.909-1.193 1.91-1.831 2.868-.278.418-.249.869-.202 1.328a.758.758 0 0 1-.489.806c-.437.17-.786.428-1.017.863-.506.914-1.008 1.824-1.51 2.734-.275.527-.456 1.054-.295 1.655.014.057-.08.189-.147.224-.825.372-1.253 1.016-1.12 1.914.062.416-.092.591-.422.733-.232.09-.348.158-.455.368-2.992 6.412-5.183 12.76-7.027 19.51l.834-.017a.627.627 0 0 1 .471.173c.109.105.192.13.29.046l.297-.221 2.248-.015c.101 0 .216.083.3.16.11.104.197.133.292.042.097-.092.212-.115.294-.083l.003.004v-.003l.091-.003.091-.012.182-.038.181-.038.092-.012.09-.002.01.002.008.006.009.008.008.011.03.056.016.028.017.023.009.009.008.006.01.002.01-.002.043-.013.037-.008.061-.009.027-.007.026-.012.026-.019.027-.028.014.017.02.021.054.051.054.05.02.021.012.017.008.01.006.008.006.004h.006l.006-.002.006-.004.006-.008.004-.01.01-.025.008-.031.006-.038.002-.011v-.006h.003l.011-.002.019-.007.017-.011.014-.013.01-.016.006-.019v-.021l-.005-.022-.011-.025.891-.824.001.001-.001-.005 4.016-4.114c.141-.14.296-.228.482-.234.16-.008.24-.054.256-.187l.072-.383 1.713-1.714c.076-.076.224-.104.342-.112.156-.011.244-.056.254-.192.008-.138.08-.242.166-.281l4.016-4.115c.139-.14.295-.228.482-.233.158-.009.238-.054.254-.188l.073-.383 1.712-1.713c.078-.077.225-.105.342-.113.158-.011.246-.056.254-.191.01-.139.081-.243.166-.282l4.016-4.115c.141-.14.296-.227.482-.233.16-.008.24-.054.256-.188l.072-.382 1.713-1.714c.076-.077.224-.105.342-.113.157-.011.244-.056.254-.191.008-.139.08-.243.166-.282h.004v-.001l.877-.955.609-.66.021-.028.027-.04.068-.1.043-.051.048-.046.026-.02.028-.017.03-.014.031-.01.004.001.008.005c.008.004.016.01.027.018l.019.014.011.009.002.002.002.001v-.001l.004-.002.027-.022.172-.141.116-.002c.036.004.068.006.099.008l.088.015.082.017.162.032.077.007.09-.003.022.001.022.006.021.012.021.017.02.022.02.029.018.036.018.043c.012.024.02.044.028.063l.013.019.006.007.006.004.006.002h.006l.006-.003.006-.005.012-.018.012-.027.096-.225h.013l.013-.003.363-.026.367-.016.006.001.008.003.014.01.014.016.015.02.029.051.026.057.031.062.015.02.007.007.006.004.006.002h.007l.005-.003.006-.005.006-.008.005-.011.01-.028.011-.032.011-.025.012-.02.012-.014.007-.005.006-.002.006-.002h.012l.006.003.013.009.001.004.002-.004c1.479-.188 2.916-.496 4.23-1.105a.505.505 0 0 1 .428.022c.125.054.197.043.232-.071l.121-.313c.535-.287 1.08-.566 1.592-.942.07-.048.195-.033.297-.009.136.033.215.016.229-.103.014-.121.08-.193.156-.207.605-.438 1.154-.985 1.732-1.475l1.621-1.688a.58.58 0 0 1 .435-.196c.149-.001.222-.04.224-.163.012-.109.022-.224.035-.349l1.465-1.513c.066-.068.201-.088.312-.09.147-.002.226-.04.222-.166-.003-.128.057-.222.133-.254l3.428-3.637a.559.559 0 0 1 .43-.191c.146.002.219-.036.223-.161.014-.112.027-.228.041-.355.484-.499.99-.99 1.502-1.476.068-.066.204-.081.313-.079.146.003.226-.032.228-.159 0-.129.062-.221.14-.251h.004l-.001-.001.066-.069.062-.074.112-.16.111-.159.061-.074.066-.068.009-.006.011-.002h.012l.014.002.062.018.031.01.028.006h.012l.011-.003.009-.005.006-.008.023-.041.023-.032.04-.052.016-.024.013-.027.007-.033.001-.041a.528.528 0 0 0 .021.003l.031.001.074-.002.075-.003.03.001.02.003.013.003.009.001.008-.002.006-.004.002-.006.002-.007-.002-.01-.002-.011-.011-.024-.017-.029-.021-.032-.006-.009-.003-.004v-.001l-.008.007.001-.001.005-.009.01-.019.004-.021v-.019l-.004-.02-.01-.018-.014-.016-.02-.013-.025-.01c.015-.477.023-.78.039-1.257h.001l-.003-.003c-.018-.246-.082-.494-.102-.741-.002-.025.046-.048.172-.065.107-.016.131-.027.047-.04l-.221-.042c-.008-.103-.022-.208-.015-.312 0-.014.083-.03.16-.041.103-.016.133-.028.042-.041-.092-.014-.115-.029-.084-.041l.01-.008h-.008l-.004-.221-.012-.222-.037-.441-.037-.441-.012-.221-.004-.221.003-.021.005-.021.009-.021.011-.02.025-.038.03-.037.028-.037.023-.039.008-.021.006-.021.003-.022-.001-.023a6.503 6.503 0 0 1-.021-.193l-.01-.15-.006-.065-.012-.063-.019-.064-.028-.068.018-.03.021-.05a4.47 4.47 0 0 1 .05-.131l.05-.129.021-.049.016-.029.012-.016.006-.016.004-.016.002-.015-.002-.014-.006-.014-.007-.013-.009-.012-.025-.022-.033-.02-.037-.016-.043-.013-.044-.008-.046-.005h-.046l-.044.004-.041.01-.037.015-.016.009-.014.011-.014.012-.01.014c-.721-.01-1.277-.018-1.878-.025-.009.056-.02.105-.028.105-.092.008-.184-.007-.273-.015a4.73 4.73 0 0 1-.016-.095l-.072.002c-.013.057-.025.092-.041.091-.16-.015-.319-.049-.479-.075l-1.154.033-1.552.041-.394.037-.127.006-.13-.001-.126-.013-.059-.012-.058-.016-.002-.001-.003-.003-.004-.008-.012-.032-.007-.022-.004-.014-.001-.003-.002-.003-.003-.006-.034-.047-.211-.296-.051-.219-.035-.188-.043-.328-.037-.297-.018-.083-.031-.096-.006-.024-.002-.025.004-.026.01-.026.016-.027.023-.029.028-.03.036-.031.029-.025.022-.022.015-.02.004-.009.002-.009v-.007l-.002-.007-.005-.006-.007-.004-.008-.005-.012-.004-.029-.005-.242-.037-.004-.014-.006-.013-.063-.193-.104-.177-.099-.18-.091-.185-.002-.007-.001-.008.002-.018.008-.021.012-.024.031-.052.038-.053.022-.033.018-.027.01-.023.003-.011.001-.009-.001-.007-.003-.007-.006-.005-.007-.003-.01-.002-.012-.001-.032.004-.036.006-.03.002-.025-.002-.02-.005-.016-.008-.006-.004-.004-.006-.003-.006-.002-.007-.001-.008.001-.008.001-.005-.003.003c-.63-.921-1.595-1.579-2.629-1.903-.109-.025-.188-.095-.233-.237-.039-.12-.088-.158-.167-.093l-.226.164c-.45-.033-.913-.121-1.369-.035-.062.007-.141-.068-.202-.141-.082-.096-.146-.12-.19-.025-.047.096-.113.124-.172.097-1.083.256-2.043.894-2.743 1.726-.069.088-.169.132-.321.117-.129-.012-.185.017-.156.113.025.091.026.167.066.271-.184.418-.461.795-.553 1.252-.018.059-.119.102-.209.131-.121.039-.168.087-.1.165.074.08.064.149.029.194l-.003.002h.001l.002.669-.004.224-.004.12.008.236.004.036.011.049.022.119.006.066-.001.066-.005.033-.008.032-.012.031-.016.03-.004.002-.008.002a.379.379 0 0 1-.032.006l-.022.004-.014.002h-.003l-.002.001v.001l-.001.004-.004.035-.023.223-.082.084-.076.064-.072.053-.07.046-.141.095-.066.052-.07.068-.02.017-.021.012-.025.008-.027.004-.033-.002-.035-.007-.039-.013-.045-.018-.064-.025-.023-.004h-.01l-.008.001-.006.003-.004.005-.004.006v.008l.002.021.01.028.078.233-.01.01-.013.014-.274.29-.283.284-.006.005-.007.003-.018.003-.021-.002-.024-.004-.057-.017-.059-.023-.064-.024-.023-.004h-.01l-.008.002-.007.003-.005.005-.002.006-.001.008.001.01.002.012.012.029.012.032.008.027.004.023-.002.02-.004.015-.004.006-.005.005-.005.004-.007.003-.015.002h-.006l.003.002-1.335 1.477c-.047.05-.123.058-.246.002-.104-.046-.143-.041-.109.044.025.077.051.149.078.234-.19.201-.379.409-.582.603-.027.026-.116-.002-.193-.035-.102-.043-.146-.041-.106.048.04.091.026.138-.019.136l-.007-.001.003.003-.938 1.024-.641.695z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "m157.603 225.079-.037-.015-.01-.003-.006-.002.074.031-.021-.011z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "m114.228 140.425-.017.006-.017.009-.008.007h-.002v.001l.092-.005-.001-.001-.004-.003-.009-.006-.007-.006-.011-.002h-.016zM123.278 283.111v-.001l-.001.001zM123.278 283.108v.002l.016-.022-.006.001-.005.01-.005.009z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M325.007 193.536c-.277-.393-.506-.778-.5-1.287.002-.593-.029-1.186-.041-1.778a.77.77 0 0 1 .07-.339c.107-.209.301-.396.342-.617.064-.372-.346-.553-.411-.865-.193-.807-.224-1.637-.272-2.461-.018-.232.097-.44.209-.656.232-.439.235-.463-.105-.852-.365-.414-.332-.834-.077-1.286.112-.204.201-.42.321-.673-.113-1.348-.348-2.691-.518-4.045-.203-1.349-.326-2.712-.61-4.046-.249-.28-.517-.521-.72-.806-.207-.29.258-.526.187-.871-.028-.117-.034-.239-.069-.352-.146-.488-.434-1.05-.261-1.496.213-.594.096-1.162-.296-1.648-.149-.18-.346-.324-.516-.487l.344-1.008c-.463-1.825-.835-3.698-1.383-5.524a127.65 127.65 0 0 0-4.053-12.197l-1.604-3.973c-.567-1.311-1.189-2.597-1.78-3.896-.147-.325-.274-.66-.446-.977-.109-.181-.24-.963-.291-1.153-.004-.184-.131-.243-.113-.431.039-.411-.092-.644-.476-.85-.42-.232-.793-.481-1.007-.942-.257-.535-.541-1.056-.809-1.586a.752.752 0 0 1-.084-.335c.006-.236.1-.489.04-.705-.104-.363-.544-.352-.756-.596-.537-.636-.911-1.378-1.314-2.1-.116-.202-.104-.439-.095-.683.02-.498.012-.521-.463-.723-.508-.215-.659-.607-.625-1.127a9.37 9.37 0 0 0-.005-.745 4546.73 4546.73 0 0 0-2.233-3.413l-1.127-1.709-1.201-1.656c-.344-.145-.688-.247-.991-.416-.31-.173.006-.589-.206-.87-.074-.094-.132-.201-.213-.287-.34-.38-.839-.763-.875-1.242-.061-.631-.452-1.062-1.02-1.326-.211-.099-.449-.145-.672-.22l-.121-1.062-1.774-2.216c-.606-.73-1.253-1.433-1.88-2.15l-2.125-2.412c-.726-.787-1.486-1.544-2.229-2.316l-2.242-2.303-2.344-2.197c-2.041-2.002-4.275-3.787-6.434-5.654a9.566 9.566 0 0 0-.842-.668c-.18-.111-.654-.738-.783-.886l.001-.001c-.082-.165-.222-.166-.284-.345-.141-.392-.355-.548-.787-.572-.476-.032-.916-.101-1.304-.43-.462-.372-.921-.748-1.41-1.085a.732.732 0 0 1-.228-.257c-.101-.21-.129-.475-.28-.638-.257-.274-.657-.062-.948-.198-.752-.351-1.402-.87-2.07-1.356-.189-.135-.279-.357-.375-.583-.195-.459-.203-.488-.727-.454-.559.037-.872-.24-1.073-.713-.093-.211-.209-.41-.335-.656l-3.458-2.162-3.567-2.007c-.371.014-.723.066-1.068.04-.351-.025-.244-.539-.555-.707-.105-.056-.207-.121-.318-.161-.479-.181-1.104-.294-1.35-.699-.336-.528-.863-.771-1.487-.767-.231 0-.464.058-.696.084l-.562-.918c-1.674-.861-3.453-1.56-5.188-2.35-3.936-1.697-7.975-3.156-12.059-4.447-1.346-.48-2.745-.788-4.115-1.189-1.381-.365-2.744-.794-4.146-1.073-.348-.08-.691-.183-1.047-.237-.21-.024-.908-.39-1.088-.47v-.001c-.146-.115-.271-.057-.406-.191-.295-.295-.557-.345-.955-.183-.441.174-.866.3-1.357.167-.58-.122-1.168-.209-1.75-.318a.722.722 0 0 1-.316-.136c-.183-.147-.322-.374-.529-.457-.351-.139-.617.226-.939.227-.828.004-1.639-.187-2.45-.343-.229-.045-.407-.191-.593-.346-.379-.316-.401-.323-.857-.068-.485.273-.889.157-1.274-.183-.176-.151-.367-.281-.588-.45-1.345-.139-2.69-.361-4.054-.43l-4.084-.271c-.328.172-.621.371-.943.497-.327.129-.455-.387-.807-.383-.121.004-.241-.015-.358-.002-.509.045-1.12.213-1.519-.046-.531-.33-1.112-.321-1.672-.047-.209.101-.394.254-.59.378l-.906-.584c-1.882-.046-3.787.098-5.691.141-4.279.18-8.556.594-12.791 1.219-1.42.163-2.824.425-4.227.696-1.402.272-2.812.503-4.205.811-.349.08-.702.14-1.047.245-.199.07-.988.048-1.183.055v-.001c-.181-.039-2.036.909-2.536 1.005-.585.108-1.154.276-1.724.441a.738.738 0 0 1-.343.018c-.229-.053-.452-.197-.675-.181-.375.028-.458.474-.747.615-.744.366-1.555.55-2.354.767-.224.063-1.193-.201-1.494.227-.319.458-.732.53-1.227.393-.224-.059-.452-.093-.724-.148-1.275.452-2.569.878-3.845 1.36l-3.794 1.538c-.22.298-.397.605-.634.859-.238.259-.575-.146-.898-.006-.105.056-.223.091-.323.154-.439.261-.917.68-1.388.618-.622-.065-1.141.194-1.527.686-.144.181-.242.399-.366.597l-1.069-.131c-1.713.783-3.371 1.731-5.068 2.598a42.083 42.083 0 0 0-2.809 1.563l-2.772 1.628c-1.85 1.082-3.604 2.32-5.408 3.471-1.198.777-2.327 1.656-3.493 2.48-1.16.832-2.318 1.666-3.418 2.578-.281.221-.576.424-.842.667-.15.147-.875.464-1.051.554v-.003c-.18.042-.213.176-.402.196-.416.045-.619.218-.741.629-.144.448-.309.861-.7 1.185-.459.376-.896.776-1.348 1.161a.745.745 0 0 1-.305.162c-.229.049-.496.016-.69.125-.328.185-.211.62-.412.87-.511.653-1.192 1.138-1.784 1.714-.169.16-.4.203-.638.252-.485.096-.505.108-.593.621-.092.547-.438.787-.946.874-.229.042-.451.108-.722.174l-1.455 1.422-1.396 1.492-2.788 2.995c-.062.371-.081.731-.176 1.068-.097.344-.569.13-.794.402-.072.095-.164.176-.229.274-.289.421-.545.999-1 1.144-.596.205-1.824 2.189-2.176 2.317-1.14 1.498-2.336 2.983-3.454 4.526-1.212 1.768-2.493 3.489-3.644 5.297l-1.711 2.723c-.574.904-1.146 1.809-1.656 2.752l-2.105 3.73c-.682 1.254-1.293 2.547-1.943 3.817-.162.318-.346.627-.485.958-.075.196-.602.789-.724.944-.146.115-.109.254-.27.356-.344.226-.444.473-.367.901.08.474.117.921-.109 1.376-.259.533-.488 1.08-.736 1.619a.755.755 0 0 1-.21.275c-.188.143-.444.227-.576.408-.218.308.065.645-.001.959-.162.817-.509 1.572-.821 2.338-.085.217-.278.354-.474.499-.402.296-.414.315-.277.813.148.53-.064.894-.49 1.19-.191.136-.365.292-.584.467l-1.277 3.874-.637 1.946c-.197.653-.365 1.315-.549 1.971.102.359.236.692.295 1.036.059.35-.463.362-.551.703-.025.117-.074.23-.09.347-.084.503-.07 1.132-.422 1.46-.465.438-.576 1.009-.416 1.621.056.226.168.441.25.661l-.752.759c-.395 1.842-.861 3.691-1.137 5.58-.342 2.115-.772 4.218-.976 6.354-.237 2.13-.553 4.251-.649 6.393l-.291 4.273-.076 4.282c-.009.357-.04.715-.022 1.074.019.209-.2.973-.242 1.164 0 0 .481 2.187.476 2.695-.002.593.029 1.186.041 1.778a.767.767 0 0 1-.07.339c-.107.21-.301.396-.342.617-.064.372.346.553.411.865.193.807.224 1.637.272 2.462.018.231-.097.44-.209.655-.232.439-.235.463.105.852.365.414.332.834.077 1.286-.112.205-.201.421-.321.673.113 1.348.348 2.692.518 4.045.203 1.349.326 2.712.61 4.047.249.279.517.521.72.805.207.29-.258.526-.187.871.028.117.034.239.069.352.146.488.434 1.05.261 1.496-.213.594-.096 1.162.296 1.648.149.18.346.324.516.487l-.344 1.008c.463 1.825.835 3.698 1.383 5.524a127.37 127.37 0 0 0 4.053 12.197l1.604 3.973c.567 1.311 1.188 2.598 1.779 3.896.148.326.275.661.447.977.109.182.241.966.291 1.154h-.001c.005.183.206 1.073.589 1.279.421.232.793.481 1.008.943.256.535.541 1.055.808 1.585.052.1.085.222.085.335-.006.236-.1.49-.041.706.105.362.544.352.756.596.538.636.912 1.378 1.314 2.099.117.202.104.439.096.683-.02.498-.012.521.463.723.508.216.658.608.625 1.127-.012.233-.004.47.004.746l2.233 3.413 1.127 1.708 1.201 1.657c.344.145.688.246.991.416.311.172-.006.588.205.87.076.093.133.201.214.287.34.38.839.763.874 1.242.062.631.453 1.062 1.021 1.326.211.099.448.145.671.219l.122 1.063 1.773 2.215c.606.731 1.254 1.434 1.879 2.151l2.125 2.412c.727.787 1.487 1.544 2.229 2.316l2.242 2.303 2.344 2.197c2.04 2.002 4.274 3.787 6.434 5.654.269.235.545.463.841.668.18.111.656.738.783.887.082.165.221.166.284.345.14.392.355.548.787.572.476.032.915.101 1.304.43.461.373.921.748 1.41 1.085a.71.71 0 0 1 .227.257c.102.21.129.475.281.638.256.274.656.062.947.198.752.352 1.402.87 2.07 1.357.189.135.279.356.375.582.196.459.204.488.728.454.558-.036.872.241 1.073.713.093.211.209.411.335.657l3.458 2.162 3.567 2.006c.37-.014.722-.066 1.067-.04.352.026.244.54.555.707.105.056.208.122.319.161.478.182 1.103.294 1.349.699.336.528.863.771 1.488.768.23 0 .464-.059.695-.085l.562.919c1.675.861 3.454 1.56 5.188 2.35 3.936 1.697 7.976 3.156 12.059 4.447 1.346.48 2.746.788 4.115 1.188 1.381.366 2.744.794 4.146 1.073.348.081.691.183 1.048.238.21.023.909.39 1.089.47l-.001.001c.146.114.271.056.405.19.295.296.557.345.955.183.441-.173.866-.299 1.357-.166.581.121 1.168.209 1.751.318a.73.73 0 0 1 .316.135c.183.147.322.375.529.458.351.138.617-.227.938-.228.828-.004 1.639.188 2.451.343.229.045.408.191.593.347.379.314.401.322.856.067.486-.273.889-.157 1.275.183.176.15.367.281.588.449 1.345.139 2.69.363 4.055.43l4.083.271c.327-.172.621-.372.942-.497.328-.128.455.386.809.382.119-.004.24.016.357.002.51-.044 1.121-.213 1.518.046.532.33 1.113.321 1.674.047.207-.101.393-.254.589-.378l.906.584c1.882.045 3.787-.098 5.691-.141a123.4 123.4 0 0 0 12.791-1.219c1.419-.164 2.823-.426 4.226-.697 1.402-.273 2.812-.503 4.206-.811.349-.081.702-.14 1.046-.246.199-.07.99-.047 1.184-.054.18.04.268-.067.447-.005.393.136.65.066.938-.255.323-.35.65-.649 1.15-.745.585-.107 1.153-.276 1.724-.441a.75.75 0 0 1 .343-.017c.228.053.452.196.675.181.375-.029.457-.475.746-.615.744-.367 1.556-.551 2.354-.767.225-.063.453.005.689.072.484.142.505.128.806-.299.319-.459.731-.53 1.227-.394.224.06.452.094.724.148 1.275-.451 2.568-.877 3.844-1.36l3.795-1.538c.01-.014.02-.027.029-.042l.707-.281c.98-.427 2.051-.89 3.178-1.382a1.55 1.55 0 0 0 .302-.131l.637-.277.022.207h.002l.125 1.02.025.066c.007.025.016.054.023.084l.049.217c.016.083.031.175.049.273l.045.32.086.739.073.81.059.799.04.711.019.544v.186l-.007.114-.018.155-.011.157-.004.315.017.319.029.32.082.646.074.648.066.569.041.22.056.213.08.23.111.278.349.801c.018.047.035.092.053.135.012.046.024.091.037.134l.012.066.01.066.005.066.001.066-.002.066-.006.068a7.469 7.469 0 0 0-.024.137l-.039.141-.054.145-.037.104-.03.109-.022.112-.018.116-.021.238-.008.244-.008.059-.013.058-.012.058-.003.027v.027l.021.328.032.329.076.659.028.197.038.188.046.18.051.173.109.339.104.34.043.176.036.184.024.191.012.203-.002.216-.021.231-.039.248-.062.268.037.089.031.096.025.101.021.105.035.218.025.222c.02.146.037.29.053.42l.018.094.02.087.023.079.029.07.035.095.033.116c.018.085.038.179.061.279l.109.646.057.305c.012.047.021.092.031.135l.016.062.008.028.002.007.001.001h.001v.001h.003l.009.002.033.008.034.003.034-.001.033-.005.034-.011.034-.015.033-.021.033-.026 2.41-2.112 2.876-2.561 1.088-.969c.093-.078.179-.15.259-.219l.235-.179.432-.291.431-.29.234-.178.257-.216.132-.129.154-.169.349-.403c.12-.141.241-.28.348-.403l.153-.168.131-.128 1.455-1.294c.068-.002.14.001.184-.037.043-.038.058-.116.074-.191l.301-.268 4.897-4.169.577.951.154.264.14.257.118.243.049.112.041.106.011.028.015.029.038.063.05.067.059.071.137.149.15.156.15.155.135.149.057.069.047.066.036.062.013.028.01.027.113.345.145.395.146.361.065.143.054.102.378.63.261.413.184.268.145.194c.045.062.09.123.145.194l.184.268.261.412.378.629 1.833 3.104c.115.19.509.256.62.449.139.236-.003.602.136.84l2.019 3.498c.08.138.039.382.119.52s.276.171.354.309l1.111 1.962.002-.001c.102.168.179.301.275.464l.033.022.035.032.039.04.039.049.087.117c.028.045.06.093.093.143l.195.339c.062.124.129.252.195.38l.181.381.149.344.104.27.03.094.008.035.004.026.01.087.016.085.021.083.025.08.031.078.035.077.078.149.177.293.089.147.082.149.08.146.07.114.034.05.037.045.04.042.044.04.108.083c.043.026.09.057.145.092l.438.253.036.021.032.023.028.025.026.026.022.028.018.029.016.031.012.033.01.035.005.037.002.04-.001.041-.013.089c-.008.031-.017.063-.024.098l-.018.07-.008.068-.003.067.003.066.008.066.012.064.032.128.003.017v.017l-.002.035-.002.035.002.016.004.014.073.157.081.153.174.302.058.088.063.078.07.071.073.065.151.124.146.127.068.07.061.078.027.041.025.045.023.048.02.05.018.055.016.057.011.062.008.065.004.07v.074l-.012.164.047.029.043.035.04.039.035.044.066.096.059.102.057.099.058.092.03.04.031.035.035.03.036.023.023.014.023.019.048.044.049.054.05.062.202.28.1.13.049.055.048.045.046.034.023.013.022.008.022.004h.021l.021-.004.021-.01 1.456-.842 1.735-1.036.656-.393.081-.046.077-.038.144-.06.136-.044.132-.035.132-.035.135-.043.145-.059.076-.038.08-.045.037-.024.041-.032.092-.081.202-.203.202-.202.091-.081.04-.032.037-.024.488-.291c.047.022.095.046.123.029s.036-.073.045-.13l1.401-.834.222-.086.094-.029.035-.009.025-.004.088-.009.084-.016.083-.021.08-.026.079-.03.076-.035.15-.078.293-.177.146-.089.149-.082.146-.08c.043-.025.08-.049.115-.07l.049-.035.045-.036.043-.04.041-.045a3.17 3.17 0 0 1 .082-.107c.026-.043.057-.09.092-.145l.252-.438.021-.036.023-.032.025-.029.026-.025.028-.022.029-.019.031-.015.034-.013.035-.009.037-.005.039-.002.042.001.088.013.098.024.07.017.068.009.068.003.066-.003.065-.009.065-.012.127-.031.017-.003h.017l.035.002.035.001.016-.002.014-.004.157-.072.153-.081.302-.175.088-.057.078-.064.071-.069.065-.073.124-.151.127-.147.07-.067.077-.061.042-.027.045-.025.047-.023.051-.021.054-.018.058-.015.061-.011.066-.008.069-.004h.074l.164.012.029-.047.034-.043.041-.04.043-.036.096-.065.102-.059.1-.057.091-.058.04-.03.035-.032.029-.034.023-.036.016-.023.018-.023.044-.048.054-.049.062-.05.28-.202.129-.1.055-.049.046-.048.034-.047.012-.022.008-.022.005-.021v-.021l-.005-.021-.009-.021-.841-1.456-1.036-1.735-.393-.656-.046-.08-.037-.076a8.106 8.106 0 0 0-.061-.145c-.016-.047-.029-.092-.043-.136l-.035-.132-.036-.132a7.627 7.627 0 0 1-.042-.136 3.546 3.546 0 0 1-.059-.144l-.039-.076-.044-.079-.024-.038-.033-.041-.08-.091-.203-.203-.203-.202a2.62 2.62 0 0 1-.08-.091l-.032-.04-.024-.037-2.125-3.569-1.834-3.104c-.115-.19-.509-.257-.621-.449-.137-.237.004-.602-.135-.841l-2.02-3.5c-.08-.137-.039-.382-.119-.52-.08-.137-.276-.17-.354-.309l-1.112-1.963-.002.001-4.217-7.538 1.045-.383.288-.099.279-.088.262-.069.12-.025.112-.02.029-.005.031-.009.07-.025.075-.035.081-.044.134-.081c.018.002.036.006.052 0 .038-.014.07-.055.102-.098l.068-.045.182-.117.111-.066c.155-.055.311-.108.467-.162l.234-.029a96.4 96.4 0 0 1 .415-.064l.382-.074.152-.036.111-.033.69-.249c.187-.071.333-.128.455-.176l.298-.127.219-.104c.016-.007.033-.017.049-.023l.014-.003.114-.018.157-.016.156-.023.312-.064.311-.084.309-.099.619-.219.623-.212.547-.187.208-.087c.063-.033.128-.065.196-.102l.211-.127.25-.169.715-.513.123-.08.123-.065.062-.026.063-.023.064-.02.065-.016.066-.012.068-.008.139-.007.146.009.154.021.111.014.113.006.115-.002.117-.008.24-.03.242-.044.059-.006h.061l.058-.001.028-.003.027-.006.318-.092.317-.102.633-.217.188-.07.176-.077.167-.083.16-.088.31-.179.314-.175.164-.08.172-.074.184-.065.197-.056c.068-.014.139-.027.213-.043.074-.01.15-.02.232-.029l.252-.015.277.003.08-.055.088-.051.094-.047.099-.045.208-.08.213-.073.401-.142.089-.036.082-.038.072-.041.064-.043.085-.055.106-.057.264-.119.611-.247.288-.121.126-.059.057-.028.027-.015.006-.004h.002v-.048l-.005-.034-.009-.033-.013-.032-.018-.03-.022-.03-.027-.027-.033-.027-2.609-1.904-3.152-2.266-1.192-.856-.272-.206-.228-.191-.382-.359-.381-.359a15.869 15.869 0 0 0-.227-.191 20.105 20.105 0 0 0-.27-.205c-.043-.029-.096-.062-.154-.102l-.201-.115-.473-.254-.474-.254-.198-.114a6.532 6.532 0 0 1-.154-.1l-6.473-4.657-2.85-2.048 1.441-1.406 1.396-1.492 2.788-2.995c.062-.371.082-.732.176-1.069.096-.343.57-.129.793-.401.074-.095.165-.176.229-.275.289-.42.545-.998 1-1.143.596-.205.958-.658 1.099-1.263.054-.224.053-.461.078-.692l.999-.362c1.14-1.498 2.337-2.983 3.454-4.526 1.213-1.768 2.493-3.489 3.645-5.297l1.711-2.723c.573-.904 1.146-1.809 1.656-2.751l2.105-3.731c.682-1.254 1.293-2.547 1.943-3.817.162-.318.346-.627.485-.958.075-.196.603-.79.723-.945l.001.001c.146-.115.109-.254.269-.356.345-.226.445-.473.368-.901-.08-.474-.117-.92.109-1.375.258-.534.488-1.081.736-1.62a.763.763 0 0 1 .209-.275c.189-.143.445-.227.577-.407.218-.309-.065-.646.001-.96.162-.817.509-1.572.821-2.338.085-.216.278-.354.474-.499.402-.295.414-.315.277-.813-.148-.53.064-.894.49-1.19.191-.136.365-.292.584-.467l1.277-3.874.637-1.945c.197-.653.365-1.315.549-1.972-.102-.359-.236-.692-.295-1.036-.059-.35.463-.362.551-.703.025-.117.074-.229.09-.347.084-.503.07-1.132.422-1.459.465-.439.576-1.01.416-1.621-.056-.227-.168-.441-.25-.662l.752-.759c.395-1.841.861-3.691 1.137-5.58.342-2.115.772-4.218.976-6.354.237-2.131.553-4.252.649-6.393l.291-4.274.076-4.282c.009-.357.04-.715.022-1.073-.019-.21.2-.974.242-1.165h.001c.075-.167-.013-.275.084-.438.229-.344.212-.609-.044-.962zm-29.647-23.64c-.068-.025-.152.007-.238.069-.232.171-.238-.101-.302-.232l-.129.066c-.169.082-.179.08-.235-.145-.02-.096-.045-.172-.109-.206a5.254 5.254 0 0 1-2.415-2.716l-.004.002.003-.008-.027-.071-.023-.072-.039-.149-.03-.151-.024-.153-.041-.309-.052-.307-.005-.015-.009-.014-.011-.013-.014-.012-.064-.043-.032-.021-.028-.023-.01-.013-.009-.015-.005-.016-.002-.017-.001-.142a2.543 2.543 0 0 1-.006-.109l.001-.048.004-.047.014-.049.022-.053-.02-.02-.025-.033-.034-.053.006.002.032.015.015.009.012.011.012.012.009.014c.386-.01.701-.017 1.017-.023l.4-.01.214-.004.056.001.057.003.059.006.059.01.001-.003.003.005c.441.104.619.607.863.918.049.069.135.091.244.083.146-.009.192.054.209.144.037.117.046.264.096.393l.217.078c.287.1.288.098.416.476a.893.893 0 0 0 .262.415c1.163 1.018 2.611 1.59 3.957 1.859l-.004.022-.006.068-.005.056-.009.048-.014.041-.008.018-.01.017-.012.015-.014.013-.014.011-.017.01-.019.008-.02.007-.012.002-.096-.095-.084.078-.074.06-.004.003-.154.027-.059.056-.904.896-.059.007h-.002l-.002.001-.011.005-.024.007-.023.003-.025-.002-.021-.006-.021-.011-.018-.016-.016-.021-.01-.025c-.145-.009-.277-.018-.402-.024l-.359-.034-.354-.047a48.66 48.66 0 0 0-.387-.066h-.004v-.001c-.376-.077-.702-.29-1.04-.407zm4.149-4.561c-.747-.277-1.324-.646-1.865-1.235l-.209-.239-.311-.396a14.61 14.61 0 0 0-.661-.824c-.454-.515-.982-.994-1.657-1.193l-.012.007.003-.009-.017-.012-.018-.009-.039-.015-.044-.01-.048-.004-.049.003-.053.009-.026.006-.026.01-.055.023-.051.021-.047.013-.022.004-.022.002h-.021l-.02-.003-.021-.005-.021-.008-.039-.02-.038-.028-.04-.035-.066-.059-.038-.027-.041-.025-.044-.021-.045-.018-.046-.012-.047-.005-1.366-.046-.338-.009-.251.003-.499.006-.072.002-.275.221-.033.026-.016.01-.016.007-.016.005-.017.002h-.017l-.016-.002-.016-.004-.017-.007-.034-.02-.035-.028-.036-.035-.046-.044-.049-.037-.051-.03-.054-.023-.056-.018-.059-.012-.061-.008-.062-.001-.246-.002-.211-.01-.361-.032c-.115-.011-.23-.021-.361-.031a10.366 10.366 0 0 0-.21-.008l-.247.001c-.154.059-.278.106-.366.141a.943.943 0 0 1-.06.022l-.013.004-.014.002-.023.005-.033.008-.009.005-.004.002-.001.002-.024.06-.02.063-.031.135-.02.14-.013.14-.021.433-.059.495-.031.351-.014.309-.004.3.005.297.031.587.041.429.057.429.071.427.088.426.104.424.119.422.137.42.155.415.012.005-.011.004c-.002.087.063.185.186.235.117.051.125.138.076.28-.038.107-.062.247-.017.339.329.685.767 1.33 1.272 1.901.131.031.25.061.366.078.128.016.167.088.169.242 0 .183.089.33.229.457 1.386 1.224 3.1 1.873 4.715 2.198l.001-.004.004.005.021.014.024.01.025.004.029-.002.029-.007.031-.013.032-.02.032-.025.03-.022.015-.008.014-.005.013-.002h.013l.012.002.013.005.012.007.012.01.022.023.021.032.023.04.037.064.045.06.023.025.025.021.026.016.013.005.014.003.195.035.193.026.389.046.385.033.381.023.054.001.115-.104.104-.104.026-.025.013-.009.012-.007.013-.005.013-.001h.012l.012.003.012.005.012.007.024.021.024.029.027.037.032.045.035.038.038.032.039.025.042.02.044.013.045.007.047.003.186.004.158.012.047.006.305.305.439-.398.006.004.019.014c.011.008.021.014.026.019l.008.005h.005l.032-.01.029-.014.028-.018.026-.02.049-.047.043-.051.068-.101.027-.041.021-.029.354-.385.341-.309a.14.14 0 0 0 .041-.104l.186-.203.062.02c.207-.196.422-.391.621-.602.018-.018.01-.061-.004-.108l.014-.001.016.002.015.004.013.006.012.009.01.011.008.014.006.016.004.019.009.032.02.05.056.127.057.128c.008.02.016.036.021.051l.01.033.068.028.059.032.054.037.051.042.113.099.15.123.019.016.015.018.01.02.01.021.011.044.007.047.005.047.009.045.006.021.008.021.012.019.014.018.158.153.164.148.34.286.339.285.165.148.158.154.01.002-.005.005c-.012.016-.004.013.015-.001l.028.008a.65.65 0 0 0-.091.113c.025.036.066.056.102.08l.168-.143.013.003-.034.041c-.084.095-.111.135-.103.141.087.059.204.085.289.145l.003-.003.001.005.929.984.025-.011.023-.004.021.002.02.007.018.011.016.016.012.018.008.021.003.011.03.206.004.001.011.002.037.011.032.011.024.013.009.007.008.007.004.007.002.008-.002.007-.004.007-.008.008-.011.008a.18.18 0 0 1-.017.014l-.023.022-.053.062-.055.061-.023.023-.019.014.024.036.017.033.009.032.004.033.003.074.003.045.01.053v.012l-.004.012-.006.01-.01.01-.025.017-.029.016-.059.031-.021.017-.007.01-.004.011-.01.107-.002.108.011.221.005.219-.006.109-.014.107h.003l-.005.004c-.041.058-.035.148.041.239.074.09.031.152-.086.216-.087.048-.188.117-.206.191a14.84 14.84 0 0 1-.482 1.643c.044.104.083.199.12.292.051.103.004.153-.129.188a.431.431 0 0 0-.304.257c-.554 1.226-1.296 2.38-2.263 3.362-.068.021-.113.102-.104.22.009.116-.062.142-.196.126-.098-.012-.221-.014-.279.038-.439.382-.89.758-1.365 1.096l-.07.314c-.017.115-.088.13-.219.09a.459.459 0 0 0-.408.055 18.707 18.707 0 0 1-3.838 1.897c-.072-.01-.154.041-.199.154-.047.109-.124.103-.24.031-.088-.053-.201-.105-.279-.082l-.875.241-.433.108-.364.082-.141.249c-.049.098-.104.063-.174-.04-.089-.126-.145-.174-.329-.172l-4.702.102-.007.002-2.495-.039-.009.013-.011.013-.012.01-.014.01-.031.014-.035.01-.037.004h-.014l.005-.014.036-.113.018-.043.014-.027-.037-.052-.027-.05-.02-.05-.016-.052-.029-.119-.047-.152-.005-.02-.001-.018.003-.019.005-.019.018-.035.023-.036.023-.035.02-.036.006-.018.006-.018.001-.019-.001-.019-.042-.177-.05-.175-.057-.173-.065-.17-.13-.339-.118-.34-.001-.007a.367.367 0 0 0-.182-.3c-.123-.074-.129-.178-.075-.334.039-.115.074-.274.028-.383a15.01 15.01 0 0 0-1.144-2.327c-.13-.064-.243-.128-.36-.178-.127-.052-.156-.14-.132-.302a.723.723 0 0 0-.142-.539c-1.127-1.662-2.474-3.08-3.828-4.406-.039-.086-.145-.155-.283-.161-.135-.006-.18-.092-.193-.248-.01-.118-.041-.263-.119-.337a40.086 40.086 0 0 0-1.766-1.599l-.381-.041c-.132-.004-.181-.079-.198-.234a.67.67 0 0 0-.259-.454l-4.25-3.463c-.042-.078-.146-.136-.278-.13-.132.006-.178-.074-.194-.226-.012-.112-.043-.25-.119-.317-.557-.503-1.112-.993-1.627-1.489l-.358-.047c-.126-.008-.166-.082-.163-.231a.578.578 0 0 0-.183-.442c-1.147-1.195-2.12-2.5-2.226-3.621l-.002-.006-.004-.033-.002-.033-.002-.066-.004-.129.004-.342.008-.7c.008-.458.016-.915.023-1.476l-.013-.01-.013-.013-.01-.015-.01-.016-.014-.037-.01-.041-.004-.044v-.046l.004-.046.01-.045.005-.021.001-.002v-.002l.76-.636v-.018l.002-.045.01-.041.006-.02.01-.018.01-.018.013-.016.014-.014.017-.012.018-.01.021-.008.022-.006.025-.003.045-.008.07-.019.182-.061.182-.066.069-.025.046-.013.06-.081.059-.072.062-.065.066-.063.146-.145.083-.089a12.1 12.1 0 0 1 .091-.106l.021-.023.023-.02.023-.017.025-.014.053-.021.055-.017.056-.016.054-.02.025-.013.024-.015.022-.018.021-.021.096-.11.092-.112.086-.115.082-.116.153-.236.14-.239.5-.947-.002-.011.008.004c.019.007.012 0-.01-.014l-.004-.024c.067.03.136.062.138.058.022-.027.024-.064.032-.098l-.189-.111-.005-.003-.001-.01.053.022c.115.052.16.066.163.059.019-.08-.005-.18.013-.258l-.008-.004.013-.006.028-.035.023-.041.02-.046.016-.05.01-.053.004-.055-.002-.057-.009-.058-.007-.054v-.025l.002-.024.004-.023.008-.022.009-.021.011-.021.029-.04.037-.037.045-.036.053-.037.088-.061.084-.074.039-.04.033-.043.029-.044.021-.047.126-.336.115-.338.205-.674.177-.673.153-.671.018-.096-.068-.215-.07-.197-.018-.05-.006-.023-.003-.022-.001-.022.002-.021.004-.021.007-.021.019-.042.027-.041.037-.042.044-.043.054-.054.049-.059.041-.063.035-.068.031-.073.024-.077.02-.081.015-.085.18-1.119.074-.449c.012-.082.021-.169.034-.264.009-.095.019-.197.028-.309l-.095-.475-.015-.076-.004-.015-.006-.014-.01-.022-.016-.032-.006-.009-.004-.002-.002-.002-.079-.015-.083-.012-.173-.013-.179-.002-.176.007-.543.037-2.516.042-3.7.061-.005.007-.004-.009c-.07-.031-.17-.008-.252.084-.082.091-.156.061-.252-.042-.071-.077-.17-.16-.258-.16l-1.816.003-.205.205c-.07.077-.125.049-.178-.068-.062-.135-.145-.198-.249-.218-1.011-.19-1.728-.723-1.983-1.533.02-.046-.016-.09-.115-.116-.101-.025-.076-.08.016-.147.072-.052.145-.112.143-.157a2.212 2.212 0 0 1 .148-.983c-.055-.076-.093-.146-.139-.221-.055-.083-.006-.109.109-.102.142.013.219-.017.266-.084.455-.646 1.365-1.101 2.591-1.099l.021-.041v.041l.082.009.09.004.094-.001.097-.008.099-.013.098-.019.098-.025.094-.031.09-.028.09-.019.088-.007.09.002.093.011.095.021.099.027.104.035.173.058.191.052.101.021.101.016.1.011.098.004 5.541-.013.195-.002.761-.221.091-.026.09-.017.088-.008.088.002.09.012.093.02.097.027.102.037.127.043.134.037.142.03.146.023.154.018.161.013.339.008 1.261.012.996.033.996.031 1.261.006 1.013-.141.163-.022.018-.002.004-.001v-.007l.002-.017.002-.031c-.002-.02-.002-.035-.002-.047l-.005-.017-.007-.012-.23-.269a21.128 21.128 0 0 0-.26-.277l-.552-.546-.868-.815-3.924-3.866-4.541-4.472v-.001l-.005-.007-.007-.007-.008-.005a1.309 1.309 0 0 0-.038-.037 4.565 4.565 0 0 1-.151-.187l.006-.039.001-.029-.003-.025-.006-.021-.006-.01-.006-.007-.389-.388-.261-.25c-.056-.062-.108-.128-.172-.185-.011-.011-.063.019-.117.053l-.064-.063c.005-.02-.001-.027-.019-.021l-.115.115h-.002l-.008-.004-.006-.006-.006-.008-.002-.01-.002-.011v-.027l.007-.033.011-.039.014-.049.008-.045.001-.041-.004-.037-.009-.034-.014-.031-.019-.027-.022-.025a3.922 3.922 0 0 1-.094-.097 3.513 3.513 0 0 1-.074-.088l-.056-.076-.046-.071-.047-.07-.052-.072c-.021-.023-.042-.049-.065-.076l-.083-.082-.222-.023-.036-.004h-.005v-.002l-.001-.003-.001-.014-.004-.022a.402.402 0 0 1-.006-.032l-.003-.009-.003-.004-.029-.015-.031-.012-.031-.008-.033-.005-.066-.002-.066.007-.12.022-.048.01-.037.005-.654.023-.436.027-.438.04-.324.039-.324.045-.326.054-.328.063-.328.072-.328.081-.33.091-.33.103.002.009-.008-.009c-.068-.012-.144.037-.181.147-.037.106-.106.1-.22.032-.084-.051-.195-.098-.268-.07a7.376 7.376 0 0 0-1.559.833c-.027.114-.053.215-.068.317-.013.112-.077.13-.211.102a.429.429 0 0 0-.404.108c-1.114.975-1.816 2.364-2.129 3.684l.017.004-.017.004c-.031.13-.062.254-.092.373-.023.119-.047.234-.068.347-.02.112-.037.221-.055.328l-.04.319-.03.317-.021.325-.011.341v.007l-.038-.014-.042-.011-.039-.004-1.805.01c-.197-.006-.394-.015-.592-.01-.025 0-.052.037-.076.082l-.049.034-.16.003c-.021-.017-.041-.018-.059-.001v.148l-.008.005-.019.007-.019.005-.018.003h-.019l-.019-.002-.019-.005-.019-.007-.039-.02-.039-.027-.043-.037-.052-.043-.056-.037-.059-.03-.061-.023-.064-.018-.066-.013-.068-.006-.072-.002-.281-.002-.24-.01-.413-.033-.413-.031c-.074-.002-.154-.004-.24-.008l-.281.002-.42.141-.117.04-.031.015-.01.006-.002.003-.002.003-.015.071-.012.075-.013.156-.002.162.007.16.037.492.042 2.283.005.269-.048 1.159c-.001.053.025.099.068.142 0 .102-.002.196-.004.306l-.066.041c-.003.122-.002.247-.006.37l-.062-.04-.091-.059-.031-.028-.02-.021-.053.02-.048.011-.048.004-.047-.001-.052-.003-.054-.008-.062-.008-.072-.005-.016-.002-.014-.006-.014-.009-.012-.012-.02-.028-.018-.033-.029-.068-.008-.015-.01-.013-.011-.009-.013-.007-.256-.08-.064-.017-.031-.009-.03-.01-.12-.041-.031-.01-.029-.011-.056-.025-.112-.051-.102-.065-.051-.034-.043-.041-.006.001.004-.005c.009-.031-.021-.025-.083.016l-.062.009a.226.226 0 0 1 .034-.067c.044-.067.091-.14.079-.152a4.565 4.565 0 0 1-.262-.311l-.218.063c-.083.025-.071-.003.009-.075.098-.087.122-.132.105-.166a3.369 3.369 0 0 1-.44-1.116l-.003-.002h.002l.01-.009.002-.004V143.531l-.002-.004-.004-.004-.004-.004-.014-.007-.021-.006-.058-.011-.029-.004-.018-.006-.003-.001-.004-.003-.003-.004-.001-.004.002-.005.004-.005.007-.004.018-.012.061-.024.105-.044.035-.021.01-.01.002-.004v-.005l-.033-.487-.003-.008v-.009l-.219-.071-.026-.009-.017-.009-.005-.004-.002-.004v-.004l.002-.004.004-.004.008-.004.02-.008.064-.015.082-.019.03-.01.024-.012.018-.012.014-.012.008-.012.001-.007.001-.007.002-.026.003-.021.006-.018.007-.01v-.001h.001l.001.002V142.547l.001-.002.001-.003.004-.013.014-.05.031-.095c.018-.063.035-.126.057-.197l.023-.117.016-.137-.113-.223-.018-.036-.002-.004v-.003l.002-.002.008-.012.014-.019.018-.028.004-.008.001-.003v-.001l-.015-.036-.018-.034-.021-.033-.024-.03-.056-.058-.06-.051-.116-.085-.047-.033-.035-.027-.705-.646-.973-.886-.004-.001.003-.003c.011-.016.003-.013-.016 0l-.033-.009a.618.618 0 0 0 .091-.117c-.03-.041-.076-.066-.117-.096l-.17.142c-.018.016-.016.012-.022.016l-.007-.002.049-.06c.083-.096.109-.137.1-.145-.099-.07-.229-.109-.324-.18l-.01.01-.005-.024-.052-.065-.062-.066-.067-.065-.074-.063-.08-.062-.083-.057-.087-.052-.089-.044c-.03-.017-.058-.03-.084-.044l-.076-.051-.069-.059-.062-.065-.057-.073-.055-.082-.051-.09-.049-.098c-.025-.053-.053-.107-.082-.164l-.1-.173-.057-.086-.061-.083-.063-.078-.067-.072-.989-.992-.491-.489-.436-.456-.285-.301-.192-.184-.114-.101-.129-.104-.142-.105-.155-.103-.164-.098-.17-.088-.172-.077-.17-.065-.164-.054-.156-.045-.294-.066-.265-.043-.246-.029-.226-.018-.421-.02-.393-.006-.209.001c-.276.079-.521.149-.766.221-.033.009-.063.019-.092.026l-.09.017-.089.007-.089-.002-.091-.011-.093-.02c-.031-.009-.062-.019-.098-.028l-.103-.035-.128-.044-.135-.037-.142-.03-.149-.023-.154-.018-.162-.012-.342-.009-1.27-.012-1.003-.032c-.32-.011-.64-.021-1.003-.031l-1.27-.007c-.43.059-.776.106-1.021.141a9.283 9.283 0 0 1-.163.022l-.018.002-.005.001-.001.002v.005l-.001.018-.001.03.002.048.005.016.007.012.233.27.263.278.559.547.879.816 1.968 1.933 1.936 1.943.497.51.45.48.218.248.104.129.094.137.082.144.068.15.029.077.025.079.021.08.017.081.012.082.008.082.004.082-.002.083-.015.165-.03.162-.021.08-.023.078-.058.155-.067.15-.078.146-.086.142-.051.074c-.135.152-.314.278-.461.407-.011.01.013.037.056.075l-.049.05-.091-.039c-.066.058-.141.107-.196.171-.006.005.024.038.061.073l-.033.03-.181.145a4.952 4.952 0 0 0-.032-.102c-.013-.037-.024-.075-.034-.106-.005-.016-.01-.029-.012-.041l-.005-.029-.058-.017-.048-.022-.042-.025-.041-.031-.088-.074c-.034-.025-.072-.056-.119-.09l-.014-.012-.01-.014-.008-.016-.006-.018-.004-.038v-.081l-.002-.039-.003-.018-.005-.018-.008-.015-.01-.014-.122-.117-.128-.111-.266-.212-.266-.213-.127-.111-.123-.117h-.008l.005-.005c-.011-.056-.073-.085-.177-.06-.103.026-.117-.029-.089-.147.021-.088.034-.192-.007-.233-.299-.309-.612-.602-.917-.896l-.275.036c-.099.021-.115-.029-.085-.149.038-.141.008-.239-.067-.312-.741-.693-1.483-1.387-2.223-2.076l-.003.001v-.004l-.003-.017-.003-.007-.005-.007-.005-.006-.008-.004-.017-.007-.021-.003-.025.001-.029.007-.034.01-.031.01-.013.002h-.01l-.01-.002-.007-.004-.006-.005-.004-.007-.002-.01-.001-.01.002-.025.008-.031.012-.038.021-.062.013-.06.003-.026-.001-.024-.004-.019-.004-.009-.006-.006-.338-.337-.344-.326-.017-.015c-.089.022-.168.044-.248.063l-.029.008-.012.002-.011-.001-.009-.002-.007-.003-.006-.006-.003-.007-.003-.009-.001-.01.003-.025.008-.031.013-.037.016-.047.01-.042.004-.038v-.035l-.007-.031-.011-.028-.016-.024-.02-.022a6.776 6.776 0 0 0-.082-.083l-.062-.078a11.283 11.283 0 0 0-.098-.144l-.047-.071-.053-.072-.064-.075-.084-.082a7.671 7.671 0 0 0-.222-.022l-.036-.004-.004-.001v-.002l-.001-.003-.002-.014-.002-.024a.212.212 0 0 1-.007-.032l-.003-.008-.002-.004-.029-.016-.031-.012-.031-.008-.033-.005-.067-.001-.065.006-.12.022-.048.01-.037.005-.944.041-1.39.062-.004.002v-.004c-.009-.021-.021-.008-.033.023l-.062.037c-.002-.009-.004-.009-.006-.02-.014-.077-.033-.16-.051-.16-.131-.008-.262.007-.391.015l-.051.221c-.018.084-.032.06-.051-.046-.022-.127-.051-.175-.082-.173-.309.021-.617.084-.926.103v.002l-.003-.002-.015-.01-.007-.003-.008-.001h-.008l-.009.002-.016.007-.018.013-.017.02-.017.024-.016.031-.016.028-.008.011-.008.007-.008.006-.008.002h-.008l-.008-.002-.008-.004-.008-.008-.016-.02-.018-.027-.018-.035-.029-.058-.033-.052-.018-.021-.017-.017-.017-.01-.009-.003-.009-.001-.477.001-.473.012-.033.002c-.048.079-.09.149-.131.221l-.016.026-.008.01-.008.007-.008.005-.008.002h-.007l-.008-.002-.007-.004-.008-.007-.017-.02-.017-.028-.018-.035-.021-.044-.023-.037-.023-.03-.025-.023-.026-.018-.028-.012-.027-.008-.03-.001-.116-.002-.1-.01-.171-.032-.083-.018-.088-.014a2.4 2.4 0 0 0-.1-.008l-.116.001-.174.141-.028.022-.002.002-.002.001-.001-.001-.003-.002-.01-.008-.02-.014-.026-.019-.008-.005h-.005l-.031.01-.029.014-.029.017-.026.021-.048.046-.043.052c-.025.035-.049.07-.068.1l-.027.041-.022.029-.639.697-.939 1.025.001.004-.004-.004c-.045-.001-.058.045-.018.135.04.089-.004.09-.105.046-.076-.033-.164-.062-.189-.036-.201.188-.385.394-.57.59l.078.232c.035.086-.004.09-.107.043-.122-.057-.197-.049-.243-.001l-1.305 1.448.002.006-.004-.004-.015.002-.007.002-.005.004-.006.005-.004.006-.004.015-.002.02.004.023.008.027.012.032.012.029.002.012.001.01-.001.009-.002.006-.006.005-.006.003-.008.002h-.01l-.023-.005-.064-.023-.059-.022-.057-.018-.025-.004-.021-.001-.018.003-.007.003-.005.004-.285.286-.275.291-.009.012-.01.01.077.234.01.028.002.021v.008l-.004.007-.004.005-.006.002-.008.002h-.01l-.023-.004-.064-.025-.045-.018-.039-.013-.036-.007-.032-.002-.027.004-.025.008-.021.012-.02.018-.071.068-.066.053-.142.094-.07.047-.072.052c-.023.021-.049.042-.076.065l-.082.083-.023.223-.004.036v.004l-.002.001h-.004l-.012.002-.023.004-.031.006-.01.003-.004.002-.015.029-.012.031-.008.032-.005.032-.002.067.007.066c.009.044.017.085.022.12.004.018.008.033.01.048l.005.036.015.357.009.113.006.112.007.167-.004.166-.002.083-.006.083-.02.166h.001l-.003.001c-.043.059-.043.151.029.251.072.097.019.16-.104.218-.09.044-.202.103-.226.179a5.414 5.414 0 0 1-.856 1.539l.008.326c.006.114-.061.15-.199.141a.487.487 0 0 0-.396.129c-1.047.941-2.504 1.43-3.936 1.244-.062-.037-.154-.034-.249.044-.093.077-.16.028-.224-.091-.049-.089-.115-.193-.19-.216a5.356 5.356 0 0 1-1.583-.769l-.325.025c-.116.014-.153-.054-.151-.191a.499.499 0 0 0-.15-.388c-.999-.997-1.572-2.421-1.465-3.862.034-.064.022-.156-.059-.246-.082-.089-.041-.159.078-.229.088-.054.185-.126.205-.202a5.196 5.196 0 0 1 .678-1.622c-.023-.116-.025-.216-.045-.323-.023-.117.045-.156.182-.161a.493.493 0 0 0 .379-.173c.963-1.053 2.281-1.705 3.822-1.684l.008-.017v.017l.035.01.036.004.039-.002.04-.007.041-.013.041-.02.039-.024.039-.031.037-.028.02-.011.018-.007.02-.006.018-.002h.019l.019.002.02.004.02.008.039.02.041.027.043.035.07.058.08.052.041.021.042.017.042.01.039.004 2.296-.013.081-.002c.113-.079.215-.149.314-.221l.039-.026.018-.01.019-.007.019-.005.018-.002h.019l.019.002.019.004.019.007.039.02.039.028.043.035.052.044.056.037.059.03.061.023.064.018.066.012.068.008.072.001.281.002.24.01a94.672 94.672 0 0 0 .826.063l.24.008.281-.001c.176-.059.319-.106.42-.141l.117-.04.031-.015.01-.006.002-.003.002-.003.015-.071.012-.074.013-.158.002-.161-.007-.16-.037-.493-.042-2.281-.023-1.33c.021-.31.044-.619.066-.928.002-.032-.03-.061-.08-.086l.002-.165c.026-.009.051-.019.08-.028.008-.196.022-.395.015-.594 0-.018-.038-.035-.085-.053l.004-.244-.013-.009-.013-.011-.01-.013-.01-.015-.014-.031-.01-.036-.004-.038v-.025l.006.002.113.038a.537.537 0 0 0 .043.017.53.53 0 0 0 .027.015l.053-.034.051-.024.051-.018.055-.013.121-.024c.045-.013.097-.026.157-.044l.02-.004h.019l.019.003.019.006.035.019.035.023.035.024.036.021.018.008.019.006.019.003.019-.001.092-.016.092-.02.182-.045.182-.052.18-.061.359-.121.18-.06.184-.052.004-.008.002.008c.099.004.219-.058.296-.178.075-.116.177-.12.329-.064.115.041.271.078.381.033a9.94 9.94 0 0 0 2.322-1.244c.057-.137.113-.256.15-.38.039-.136.129-.17.293-.167.192.007.369-.073.525-.215 1.543-1.383 2.512-3.031 3.467-4.354.071-.042.115-.143.094-.268-.02-.123.053-.17.195-.186.106-.012.234-.043.289-.112.415-.516.815-.979 1.238-1.359l.033-.316c.006-.112.072-.139.205-.103a.442.442 0 0 0 .387-.064c1.05-.742 2.381-1.11 3.895-1.127.078.032.191.009.285-.083.092-.091.176-.062.283.042.081.077.193.16.291.16l2.185-.015.289-.221c.095-.084.175-.06.282.046a.596.596 0 0 0 .457.173l5.184-.103.004-.008v.008l.014.01.008.003.008.001h.008l.008-.002.017-.007.017-.013.018-.02.016-.024.017-.031.016-.028.008-.011.007-.007.008-.006.008-.002h.008l.008.002.008.004.008.008.017.02.017.027.018.035.029.058.033.052.018.021.018.017.017.01.009.003.008.001.477-.001.475-.012.033-.002.131-.221.016-.026.008-.01.008-.007.007-.005.008-.002h.007l.008.002.008.004.008.007.016.02.018.028.018.035.021.044.022.037.024.03.025.023.026.018.027.012.028.008.029.001.117.002.1.01.171.032.083.018.088.014a2.4 2.4 0 0 0 .1.008l.117-.001.174-.141.027-.022.003-.002.001-.001.002.001.002.002.011.008.019.014a.355.355 0 0 1 .027.019l.008.005h.004l.031-.01.031-.014.027-.017.027-.021.048-.046.042-.052.069-.101.026-.04a.695.695 0 0 0 .023-.029l.639-.698.939-1.026-.004-.004.008.003c.056-.011.086-.074.061-.179-.025-.103.031-.117.148-.09.089.021.194.033.236-.009.312-.302.609-.619.906-.927l-.035-.277c-.02-.1.031-.116.151-.086.142.037.241.006.314-.07l2.104-2.248.001-.014.006.007.037-.023.035-.029.032-.034.03-.04.025-.045.022-.049.018-.053.012-.057.013-.052.008-.023.012-.021.012-.02.015-.018.017-.017.018-.015.041-.025.048-.021.056-.016.062-.013.103-.021.105-.033.051-.021.048-.024.043-.028.038-.033 1.99-2.008.069-.072.118-.43.015-.052.009-.022.011-.021.013-.02.015-.018.016-.016.018-.015.04-.024.047-.02.055-.016.062-.011.078-.015.074-.022.071-.029.07-.036.068-.044.066-.049.064-.056.063-.061.246-.244.217-.203c.199-.182.373-.342.549-.501l.582-.538.713-.704.47-.669.075-.107.009-.012.002-.002-.001-.002-.002-.004-.006-.015-.013-.025c-.009-.016-.017-.027-.021-.036l-.011-.011-.004-.003-.005-.003-.271-.075-.295-.064-.609-.104-.938-.128-1.536-.265-.197-.044-.194-.048-.189-.055-.184-.059-.261-.096-.246-.109-.117-.059-.115-.062-.217-.133-.201-.146-.094-.077-.092-.081-.047-.045c-.035-.07-.048-.161-.081-.229-.003-.005-.036.016-.087.052l-.018-.02.076-.07c-.015-.031-.025-.064-.051-.088a.842.842 0 0 0-.102.063l-.014-.018c.012-.013.012-.015-.004-.007l-.072.053.002-.02.008-.047.016-.08.008-.079v-.039l-.003-.035-.009-.032-.012-.027-.106-.195-.096-.206-.085-.217-.074-.228-.062-.237-.05-.247-.038-.254-.025-.26-.007-.076-.228-.295-.027-.037-.01-.019-.007-.019-.005-.018-.002-.019v-.019l.003-.018.005-.019.007-.019.021-.037.029-.039.038-.039.046-.05.04-.052.034-.055.027-.057.023-.061.018-.062.014-.064.01-.067.018-.138.02-.123.023-.108.024-.09.343-1.214.404-1.451.295-1.14.767-.015c.082.031.196.008.292-.084.095-.091.182-.061.292.042.082.077.196.16.298.16l2.178-.007.244-.213c.081-.076.146-.045.219.068a.468.468 0 0 0 .323.22c1.263.194 2.201.825 2.802 2.02h.008l-.006.003-.002.018v.008l.003.008.004.008.005.007.014.013.02.01.025.009.029.006.035.003.033.004.012.004.011.004.008.006.006.006.003.008.002.009-.001.01-.003.011-.011.023-.019.027-.024.031-.04.051-.035.053-.013.024-.009.023-.003.021.001.009.002.009.166.48.072.246.062.25.01.035.242.102.029.013.012.007.008.007.007.008.004.008.001.009v.009l-.004.009-.005.01-.017.021-.025.021-.031.025-.04.03-.032.03-.026.029-.021.03-.014.03-.008.03-.003.03.001.03.008.062.002.053v.046l-.003.035-.001.006-.001.003-.001-.005-.002-.005v.008l-.002.025-.004.101-.013.193-.02.399-.001.232.01.271.152.401.041.114.014.031.006.009.004.003.002.001.068.016.072.013.152.013.156.003.154-.006.477-.034 1.841-.032 2.511-.048v-.016l.006.018c.014.032.033.009.049-.083.016-.091.03-.061.047.042.014.077.032.161.049.161.123.008.246-.006.366-.014.019-.079.033-.146.05-.22.017-.084.029-.06.047.046.021.127.047.175.076.174.291-.02.581-.082.87-.098l.005-.01v.01l.021.01.023.004.025-.002.025-.007.025-.013.025-.019.026-.025.024-.031.023-.028.012-.01.012-.008.012-.005.012-.002h.012l.012.002.013.005.012.006.024.021.026.028.026.035.045.058.051.052.025.021.026.017.026.011.013.003.013.001.729.003.723-.008.052-.002.2-.22.023-.026.012-.01.012-.007.012-.005.012-.002h.012l.012.002.012.005.012.007.024.02.024.027.027.037.033.043.034.037.037.031.038.023.041.018.041.013.044.007.046.002.178.003.152.011.313.034.325.033.189.009h.222l.331-.139.053-.022.006-.003h.008l.014-.001.023-.001.033-.004.01-.002.003-.002.001-.002.029-.051.025-.055.041-.117.033-.123.023-.124c.023-.163.045-.311.057-.386l.138-.602.062-.208.071-.218.122-.321.139-.319.075-.158.081-.154.085-.153.088-.151-.003-.006.006.004c.066-.041.102-.133.07-.254-.029-.12.043-.163.181-.179.103-.012.228-.036.28-.102a7.772 7.772 0 0 1 1.311-1.292l.074-.319c.02-.117.094-.139.229-.095.161.055.288.019.423-.049.084-.049.177-.079.263-.123.021.062.043.123.058.21.071.347.212.53.639.554.931.039 1.434.635 1.611 1.523.019.074.125.197.184.197.616-.018 1.084.282 1.53.675.774.695 1.599 1.332 2.362 2.046.368.326.537.73.602 1.197a.759.759 0 0 0 .666.668c.459.056.889.146 1.246.497l1.25 1.185c.398.407.791.811 1.16 1.217l.211 1.097c.067.082.137.172.217.256.158.165.334.322.478.501.378.482.896.688 1.509.737.068.333.146.652.213 1.044 1.857 2.125 3.82 4.241 5.573 6.53.456.572.446.584 1.413.886.027.221.08.436.094.65.008.39.229.617.541.778.211.09.438.147.663.226l.078 1.09c4.378 5.921 8.173 11.825 11.477 18.463h-.001c.102.212.08.348.007.584-.094.348-.054.577.311.787.784.456 1.022 1.191.798 2.069-.014.074.031.23.084.255.57.248.869.717 1.11 1.262.428.948.78 1.926 1.202 2.883.197.451.18.887.041 1.333a.76.76 0 0 0 .324.886c.393.247.75.511.921.981.351 1.096.771 2.173 1.097 3.221l-.274 1.075c.027.103.052.213.089.323.074.217.168.433.223.655.15.593.492 1.014 1.012 1.328l-.279 1.037 1.197 4.1.289 1.201-.932.041-1.391.061v.002l-.004-.004a.385.385 0 0 0-.346.084c-.111.091-.215.061-.346-.042-.098-.077-.234-.16-.354-.16l-2.656.015-.351.221c-.115.084-.213.061-.343-.047-.151-.126-.34-.174-.557-.172l-6.301.102a.387.387 0 0 0-.347.084c-.112.091-.215.061-.346-.042-.103-.077-.227-.161-.331-.162-.794-.018-1.566-.07-2.261-.217l-.329.148c-.111.058-.186.013-.254-.12a.682.682 0 0 0-.364-.292zm-8.071-.892-.089.153-.015-.017-.012-.011-.008-.011-.005-.011-.001-.011v-.011l.005-.01.007-.011.008-.009.025-.019.031-.017.037-.014.01-.003.007.002zm3.741 33.354h.006l-.004.004c-.016.463-.024.759-.039 1.222l.025.01.02.013.014.016.01.017.004.019v.019l-.004.02-.01.019-.005.009-.001.001v.001l.003.004.007.009.021.031.018.028.011.024.003.011.002.009-.001.007-.003.006-.004.004-.008.001h-.01l-.012-.003a.206.206 0 0 0-.021-.003l-.028-.001-.074.003-.074.003-.029-.001a.104.104 0 0 0-.021-.003v.039l-.006.033-.011.026-.014.024-.037.05-.021.032-.021.039-.006.008-.008.005-.011.003h-.012l-.028-.006-.031-.009-.061-.018-.014-.002h-.012l-.01.003-.008.005-.062.066-.057.073-.104.155-.103.156-.056.073-.062.066.002.002h-.006c-.082.037-.149.137-.154.272-.004.133-.089.175-.242.183-.115.006-.258.031-.331.104l-1.624 1.645-.061.372c-.012.131-.088.174-.244.178a.656.656 0 0 0-.464.221l-3.806 3.95c-.083.036-.15.137-.154.272-.006.133-.09.175-.243.183-.114.005-.257.03-.331.104l-1.624 1.645-.06.371c-.012.131-.09.174-.244.18a.64.64 0 0 0-.457.199c-1.211 1.237-2.555 2.398-3.955 3.632-.086.031-.162.128-.178.263-.016.133-.104.168-.262.172-.117.002-.264.023-.346.098-.613.523-1.198 1.121-1.771 1.724-.025.139-.055.261-.064.393-.01.141-.087.194-.247.219-.188.026-.343.134-.478.294-1.29 1.576-2.256 3.422-2.957 5.272-.07.073-.086.204-.033.336.053.131-.004.211-.141.293-.102.061-.219.155-.254.263l-.387 1.193c-.093.399-.186.798-.276 1.193l.14.364c.059.122.014.203-.117.297-.156.108-.242.269-.287.464-.161.946-.287 1.894-.42 2.839l-.246 2.815c-.039.084-.033.208.057.316.084.105.049.194-.061.303-.082.082-.171.197-.178.303l-.117 2.364.202.32c.077.105.054.19-.055.302-.129.129-.18.295-.181.486l.002 5.496c-.033.082-.013.198.078.298.088.099.057.186-.049.294-.079.082-.164.195-.166.297-.008.762-.062 1.512-.1 2.256l.201.312c.078.104.048.185-.065.288a.626.626 0 0 0-.202.459c-.029.896-.123 1.776-.209 2.659-.089.882-.146 1.772-.32 2.63-.047.074-.045.19.029.3.072.108.027.188-.094.278-.092.066-.193.163-.211.262-.138.731-.253 1.467-.451 2.162l.14.335c.058.114.013.188-.116.265a.608.608 0 0 0-.284.4c-.179.859-.479 1.659-.745 2.478-.236.836-.606 1.596-.962 2.363-.062.057-.089.166-.046.291.042.123-.021.186-.157.233-.103.036-.222.096-.263.183l-1.102 1.791c.011.129.023.253.024.359.01.119-.06.166-.21.182a.582.582 0 0 0-.416.231l-.764.971c-.263.315-.58.575-.865.869-.301.275-.566.596-.895.84l-.996.717c-.079.017-.152.098-.176.227-.023.127-.106.149-.244.12-.035-.008-.072-.009-.109-.012l-.165-.125c-.513-.407-1.018-.81-1.421-1.131l-.5-.42-.165-.147-.098-.096-.127-.137-.133-.132-.28-.255-.297-.242-.309-.233-1.266-.918-.557-.406-.225-.146-.23-.128-.262-.127-.326-.141a426.71 426.71 0 0 1-.96-.387l-.157-.069-.146-.079-.134-.09-.124-.102-.114-.113-.105-.127-.1-.14a8.818 8.818 0 0 0-.092-.154l-.066-.109-.076-.108-.085-.105-.092-.105-.198-.205-.213-.199-.048-.053-.042-.055-.043-.055-.023-.023-.023-.022-.31-.245-.317-.239-.643-.47-.196-.137-.194-.121-.192-.109-.191-.102-.755-.388-.188-.108-.188-.12-.189-.135-.189-.153c-.061-.055-.125-.112-.191-.174a20.081 20.081 0 0 1-.192-.198 71.499 71.499 0 0 1-.194-.227l-.195-.257-.105-.045-.107-.055-.219-.129-.219-.148-.217-.158a86.28 86.28 0 0 0-.412-.296c-.065-.042-.128-.08-.188-.117l-.088-.046-.082-.036-.109-.05-.127-.068c-.089-.055-.188-.114-.292-.179l-.655-.435-.312-.201-.141-.085-.066-.038-.031-.017-.008-.004-.002-.001v.002l-.002.002-.007.006-.024.028-.021.03-.018.034-.016.036-.01.04-.006.044-.001.047.004.051.444 3.82.176 1.428-.05 3.729-.022 1.728c-.004.144-.008.276-.014.4l-.027.35c-.026.217-.051.413-.076.61-.025.198-.051.394-.077.609l-.027.347a73.8 73.8 0 0 0-.015.398l.005.218c.006.081.014.173.02.271.02.192.04.41.062.627l.038.383-.858.018-.008.007v-.006l-2.951-.04-.01.014-.014.012-.014.011-.016.009-.037.015-.041.01-.044.004h-.046l-.046-.005-.044-.008-.043-.013-.037-.016-.033-.02-.025-.022-.009-.012-.007-.013-.006-.014-.002-.014.002-.015.004-.016.006-.016.012-.016.016-.029c.006-.014.014-.03.021-.049l.05-.129a4.47 4.47 0 0 0 .05-.131.456.456 0 0 0 .021-.05l.018-.03-.028-.068-.019-.064-.012-.063-.006-.065-.01-.15-.021-.193-.001-.023.003-.022.006-.021.008-.021.023-.039.028-.037.03-.037.025-.038.011-.02.009-.021.005-.021.003-.021-.004-.221-.012-.221-.037-.441-.037-.441-.012-.222-.004-.221h-.004l.006-.008c.031-.09.008-.217-.084-.321-.091-.104-.061-.199.042-.321.077-.091.16-.217.16-.328l-.015-2.463c-.079-.116-.151-.224-.221-.325-.084-.107-.061-.198.047-.318.126-.141.174-.315.172-.516l-.102-5.846c.031-.09.008-.216-.084-.321-.091-.104-.061-.199.042-.32.077-.091.16-.218.16-.328l-.015-2.463c-.079-.117-.151-.224-.221-.325-.084-.107-.061-.198.047-.318.126-.141.174-.315.172-.517l-.102-5.845c.031-.09.008-.216-.084-.321-.091-.104-.061-.199.042-.321.077-.09.16-.217.16-.327l-.015-2.464-.221-.325c-.084-.106-.061-.197.047-.318.126-.14.174-.315.172-.516l-.102-5.845c.031-.09.008-.216-.084-.321-.091-.104-.061-.199.042-.321.077-.09.16-.217.16-.328a49.56 49.56 0 0 0-.035-2.508l-.229-.336c-.086-.109-.064-.204.038-.336.126-.152.165-.34.144-.554-.141-2.066-.536-4.163-1.268-6.194a.4.4 0 0 0-.197-.307c-.125-.076-.129-.186-.082-.35.031-.121.051-.283.001-.398a13.786 13.786 0 0 0-1.323-2.458c-.139-.067-.258-.136-.382-.187-.14-.049-.18-.143-.175-.314.01-.2-.072-.39-.21-.571-1.39-1.738-3.135-3.046-4.728-4.185-.055-.079-.172-.137-.312-.126-.139.011-.195-.068-.232-.224-.026-.115-.078-.256-.167-.32-.646-.49-1.288-.946-1.846-1.42-.133-.01-.255-.018-.37-.025-.127-.002-.171-.077-.178-.229-.005-.179-.09-.314-.215-.437-1.219-1.163-2.072-2.486-2.493-4.103l-.003.001.002-.006.002-.023-.002-.024-.008-.023-.014-.023-.02-.022-.025-.021-.031-.02-.038-.018-.034-.017-.014-.009-.01-.01-.008-.012-.004-.012-.003-.012v-.013l.002-.014.005-.014.014-.03.023-.033.029-.035.047-.059.041-.062.016-.03.012-.03.006-.028v-.014l-.002-.014-.066-.37-.036-.185-.022-.19-.09-.761-.009-.053c-.082-.073-.155-.139-.229-.203l-.027-.024-.01-.013-.008-.012-.005-.013-.003-.013-.001-.013.002-.013.004-.014.007-.013.019-.028.027-.028.035-.031.042-.038.036-.039.028-.042.022-.043.016-.044.012-.046.004-.048.001-.049-.005-.193.004-.164.031-.39.031-.413c.002-.074.004-.154.008-.24l-.002-.281-.141-.42-.041-.117-.014-.032-.006-.009-.003-.002-.003-.002-.071-.015-.075-.012-.156-.013-.162-.002-.16.007-.492.037-2.084.042-2.957.061-.007.005v-.007c-.085-.031-.206-.008-.308.084-.098.091-.189.061-.306-.042-.087-.077-.207-.16-.313-.16l-2.352.015-.312.221c-.103.084-.188.061-.304-.047a.674.674 0 0 0-.492-.172l-5.582.102c-.086-.031-.207-.008-.308.084-.1.092-.191.062-.295-.049-.079-.082-.188-.171-.285-.176-.716-.071-1.446-.008-2.144-.148l-.312.175c-.105.069-.182.033-.271-.088a.58.58 0 0 0-.419-.237c-.426-.038-.834-.162-1.25-.255-.412-.105-.836-.175-1.242-.304-.799-.291-1.634-.504-2.389-.904-.057-.063-.166-.09-.291-.047-.121.041-.186-.022-.235-.16-.037-.104-.099-.225-.186-.267-.639-.331-1.239-.73-1.858-1.078l-.355.014c-.123.013-.174-.056-.197-.206a.595.595 0 0 0-.261-.41c-1.396-.978-2.644-2.168-3.733-3.478-.022-.083-.106-.157-.235-.175-.126-.019-.153-.104-.136-.252.015-.11.016-.248-.043-.325-.455-.562-.795-1.198-1.183-1.792l-.341-.137c-.125-.038-.145-.12-.094-.268a.608.608 0 0 0-.042-.487l-.576-1.142-.471-1.188c-.356-.78-.507-1.626-.754-2.441a.302.302 0 0 0-.136-.26c-.103-.073-.086-.164 0-.287.063-.094.129-.217.114-.312l-.165-1.065c-.059-.354-.054-.714-.084-1.067l-.234-.275c-.089-.091-.068-.173.031-.282a.565.565 0 0 0 .148-.455l.105-2.558c.094-.846.285-1.68.428-2.52.048-.069.039-.185-.021-.298-.059-.11-.002-.183.133-.255.1-.054.216-.135.248-.226.254-.673.432-1.373.703-2.027l-.074-.344c-.035-.119.023-.182.168-.232a.596.596 0 0 0 .355-.33l.459-.986c.096-.113.2-.217.301-.327l.453-.475 1.936-2.007c.083-.037.152-.14.158-.275.006-.135.091-.178.246-.188.115-.006.26-.033.334-.107l1.653-1.674.063-.376c.014-.132.092-.176.248-.183.184-.005.336-.09.471-.227l3.875-4.019c.083-.038.152-.14.158-.276.006-.134.091-.178.246-.187.115-.007.26-.033.334-.108l1.653-1.674.064-.375c.013-.133.091-.177.247-.183.185-.005.336-.09.471-.227l3.875-4.019v-.005l.001.001.893-.836-.011-.024-.006-.023.001-.021.005-.019.01-.017.014-.013.018-.011.019-.007.011-.002h.002v-.001l.001-.005.001-.011.007-.037.008-.033.009-.024.006-.01.005-.007.006-.005.006-.002.006.001.007.004.006.007.007.011.012.016.021.021.054.05.054.051.021.021.013.017.028-.028.026-.019.027-.012.027-.006a.674.674 0 0 1 .062-.01l.037-.008.043-.014.01-.001.009.003.01.006.008.008.017.023.015.028.031.056.008.011.01.009.008.005.01.003.091-.004.091-.012.184-.037.184-.037.091-.012.092-.004v-.002l.003.004c.085.031.205.008.305-.084.098-.091.188-.061.303.042.086.077.205.16.31.16l2.327-.015.309-.221c.101-.084.187-.061.301.047a.663.663 0 0 0 .487.172l5.523-.102c.085.031.204.008.304-.084.098-.091.188-.061.303.042.086.077.205.16.311.16l2.327-.015.308-.221c.102-.084.188-.061.301.047a.665.665 0 0 0 .488.172l2.066-.036 1.422-.045.705.561c.023.062.096.091.203.062.1-.036.148.044.174.199.017.114.056.254.137.321l1.797 1.479.377.027c.141.007.162.057.222.244.056.212.204.396.403.562l1.33 1.083 4.93-.082c.085.031.205.008.304-.084.099-.091.188-.061.304.042.086.077.205.16.31.16l2.327-.015.309-.221c.101-.084.187-.061.301.047a.661.661 0 0 0 .487.172l5.522-.102c.086.031.205.008.305-.084.098-.091.188-.061.303.042.086.077.205.16.311.16l2.327-.015.308-.221c.102-.084.188-.061.301.047a.665.665 0 0 0 .488.172l5.522-.102v-.01l.009.008 2.934.039.01-.013.014-.013.014-.01.016-.01.037-.014.04-.01.044-.004h.045l.047.004.044.009.01.003-.015.021-.221.314-.002.081-.013 2.296.004.039.011.042.016.042.021.041.051.08.058.07.035.043.028.041.02.039.006.023.005.025.003.024v.024l-.002.025-.004.023-.007.025-.009.024-.027.05-.029.054-.022.055-.017.056-.011.056-.005.055.002.053.01.049.014.046.24-.023-.006.01-.231.023c.011.102.024.205.037.309-.014.035-.032.07-.032.104.01.8.02 1.599.028 2.387l.222.315c.086.096.062.237-.041.388-.124.187-.166.425-.152.69l.07.959c.147.283.211.592.402.854.15.277.362.526.549.786l.565.712 1.852 2.197c.031.088.128.168.265.188.135.021.172.111.168.269-.003.118.014.265.082.348.512.623 1.04 1.228 1.559 1.825l.373.1c.131.024.17.107.164.266-.008.187.066.347.194.494a8685.62 8685.62 0 0 1 3.776 4.24c.033.087.131.164.268.181.135.017.173.106.172.263 0 .117.018.265.088.346l1.578 1.796.373.094c.133.022.172.105.168.263a.692.692 0 0 0 .199.491l3.811 4.201.002.003.004.018.003.008.005.008.006.006.007.006.017.01.022.005.026.001.031-.002.035-.008.033-.006.013-.001.011.001.01.004.008.004.005.007.004.008.003.009v.012l-.003.026-.009.032-.014.037-.021.062-.015.062-.003.027v.025l.004.021.004.009.006.008.346.392.352.382.025.026c.094-.014.178-.025.26-.038l.031-.005h.014l.011.002.009.003.008.005.005.006.004.008.003.009v.011l-.003.026-.009.032-.015.037-.017.047-.012.044-.005.04.001.036.006.033.011.03.016.028.021.026.083.097.065.089c.035.059.066.109.099.161s.063.103.1.16l.065.087.086.095.23.049.037.008.004.001.001.002.001.003.002.014.004.022a.314.314 0 0 0 .006.032l.003.009.003.004.031.015.034.012.035.008.036.005.072.002.072-.007.131-.022.053-.01.039-.005.342-.014.176.001c.086-.004.166-.006.24-.008.107-.008.201-.016.296-.022l1.495-.06v-.255l.004-.002v.259c.064.031.153.008.229-.084.015-.019.029-.013.045-.021l.134.111.068.002h.03c.057.059.121.11.182.11.584.008 1.168-.007 1.743-.015l.23-.221c.075-.084.14-.061.226.047a.43.43 0 0 0 .365.172l4.137-.102v-.026l.008-.001v.025l2.951.039.01-.013.014-.013.014-.01.016-.01.037-.014.041-.01.044-.004h.046l.046.004.044.009.043.013.037.016.033.02.025.021.009.013.007.013.006.014.002.014-.002.015-.004.015-.006.016-.012.017-.016.029c-.006.014-.014.03-.021.049l-.05.13c-.019.045-.036.092-.05.13a.556.556 0 0 0-.021.05 1.161 1.161 0 0 0-.018.03l.028.068.019.064.012.063.006.066.01.149.021.193.001.023-.003.022-.006.021-.008.021-.023.039-.028.038-.03.037-.025.037-.011.02-.009.021-.005.021-.003.022.004.22.012.221.037.441.037.441.012.222.004.221.008.008h-.01c-.029.019-.006.045.076.067l.043.042a.222.222 0 0 1-.077.03c-.077.02-.16.048-.16.071-.008.18.007.358.015.535l.221.071c.084.022.061.043-.047.069-.126.03-.174.068-.172.111.02.435.055.86.088 1.282zm-71.878 9.667a3.984 3.984 0 0 0-.062-.116l.006.006.021.024.017.033.014.037.004.011v.005zm49.822-30.219c1.097.914 2.167 1.834 3.161 2.807.395.382.686.855 1.055 1.248.072.081.182.118.307.119.336.004.248.289.293.479l.174.027c.227.04.234.044.246.334.004.12.02.224.09.312.915 1.117 1.719 2.294 2.297 3.535-.039-.011-.076-.024-.118-.027-.347-.024-.271-.315-.329-.521l-.182-.036c-.238-.05-.247-.051-.283-.359-.014-.129-.038-.239-.122-.334l-4.308-4.818c-.391-.442-.689-.966-1.078-1.408a.457.457 0 0 0-.324-.147c-.346-.027-.268-.317-.323-.523l-.183-.037c-.237-.052-.246-.053-.277-.361a.636.636 0 0 0-.096-.29zm11.858 11.651v-.012l.002-.013.006-.014.009-.014.014-.026.009-.021.106.177h-.001l-.005-.001-.011-.001-.039-.01-.033-.012-.027-.016-.012-.008-.008-.01-.006-.011-.004-.008zm-17.093-36.054.004.007.018.037.003.011.002.005c-.013-.026-.019-.042-.027-.06zm-8.27-12.506.01-.338.025-.332.037-.325v-.023l-.008-.024-.012-.025-.017-.026-.043-.053-.05-.051-.029-.03-.023-.028-.015-.025-.005-.013-.002-.012v-.011l.002-.011.005-.01.007-.01.01-.008.012-.009.033-.015.035-.014.029-.017.023-.019.018-.019.013-.021.007-.02.001-.021-.005-.021-.006-.007.006.002c.057-.243.244-.427.33-.63.02-.042-.016-.104-.08-.177-.176-.199.08-.146.193-.161l-.068-.104c-.088-.14-.088-.151.113-.135.084.008.148.009.176-.028.436-.639 1.115-1.151 2.035-1.459l.002-.009.003.009.056-.018.058-.014.117-.021.06-.008.061-.006.121-.009.244-.015.12-.014.122-.018.012-.004.01-.008.01-.01.01-.013.032-.062.017-.031.018-.027.01-.011.012-.007.012-.005.007-.001h.007l.062.005.052.001.087-.002.038.001.037.007.039.014.043.023a.216.216 0 0 0 .016-.019l.026-.024.069-.057c.025-.021.051-.041.071-.059l.026-.023.016-.019.008-.011.009-.009.009-.005.008-.002.009.002.009.004.008.007.008.009.016.024.014.031.013.037.003.01.002.005.353.033.122.143-.005.012.077.073.434.507c.011.012.041-.001.078-.021l.08.086-.015.024.024-.014.08.086c-.022.039-.036.071-.026.081.046.052.122.071.192.097l.33.354.727.779.742.764.039.036.041.032.081.055.167.088.084.045.084.05.081.062.04.036.039.042.564.607.209.233.097.123.097.137.064.04c.027.02.062.043.1.069.075.056.166.121.258.188l.256.186.099.068.062.038.035.02.031.021.029.023.025.024.021.025.02.026.018.027.014.027.012.027.008.027.007.028.003.028.001.054-.001.013-.001.007-.001.001h-.004l-.007.001-.052.006-.219.013h-.11l-.106-.004-.1-.01-.088-.014-.073-.02-.03-.013-.025-.013-7.123.039v.041l-.021-.041c-.55.001-1.198-.063-1.813.073a.485.485 0 0 0-.303.225.316.316 0 0 1-.197.155l-.007-.02-.011-.033-.002-.008-.002-.002.001.003.001.004v.001l-.002-.001-.002-.003-.003-.009-.017-.05-.018-.063c-.01-.048-.02-.1-.029-.155l-.009-.041-.013-.039-.018-.037-.023-.035-.028-.032-.034-.031-.041-.028-.047-.026-.039-.021-.031-.021-.021-.021-.008-.012-.006-.011-.004-.011-.001-.012.001-.012.004-.012.006-.012.009-.012.024-.026.203-.209v-.049l-.014-.327zm-15.699 2.601v.007l-.002.009-.003.01-.012.023-.018.028-.022.031-.006.009-.004.004-.027-.123h.01l.029-.002a.303.303 0 0 0 .02-.003l.012-.003.01-.001.006.001.005.004.002.006zm-.102-.073-.004.016-.018-.076.001.001.001.001.006.008.008.018.005.017.001.015zm-5.279-5.093-.002-.001-.008-.006v-.001l.001.001.004.003.005.004zm-3.236 6.907-.004.002-.008.005-.036.019-.033.013-.03.006h-.008c.037-.015.068-.027.119-.045zm-.342.126-.002.002-.021.011-.024.008-.013.003h-.002a.919.919 0 0 1 .062-.024zm-17.35-.158-.02-.018-.016-.011-.011-.006-.007-.006-.004-.006v-.005l.002-.004.006-.005.018-.007.025-.005.033-.004.037-.004h.016l-.033.127v-.001c-.016-.014-.032-.031-.046-.045zm.033.107-.009.033v-.002l.002-.01.004-.017.003-.004zm-1.85-12.807.001-.006.002-.01.01-.039.014-.033.016-.027.01-.01.01-.008.01-.006.012-.003h.012l.013.003.013.006.014.01c.006.003.016.008.025.015l.027.012-.189.096zm13.085-19.328c-.119.051-.191-.014-.236-.154-.036-.104-.084-.229-.158-.277-.565-.376-1-.956-1.174-1.602-.1-.073-.184-.152-.271-.229-.098-.082-.084-.18.018-.252.117-.188.162-.299.177-.477a3.215 3.215 0 0 1 1.149-2.196 2.672 2.672 0 0 1 1.074-.542 2.59 2.59 0 0 1 .635-.066l1.008-.008v-.004l.003.004.015.009.007.003.008.001h.008l.009-.001.016-.008.017-.013.017-.019.017-.025.017-.031.015-.028.008-.011.007-.008.008-.004.008-.003h.008l.008.002.008.005.008.006.016.021.017.027.018.035.029.058.032.052.018.021.017.016.017.011.009.003.009.001.471-.001.468-.012.033-.002.129-.221.016-.026.007-.01.008-.007.008-.005.008-.003h.007l.008.002.007.005.008.007.016.02.018.027.017.037.021.043.022.037.023.03.025.023.026.018.027.013.028.006.029.002.115.002.098.01.17.033.081.017.087.015c.031.002.063.004.099.008l.115-.002.172-.141.027-.022.003-.002.001-.001.001.001.003.002.011.009.019.014.026.018.008.005.004.001.031-.009.03-.014.028-.017.027-.02.047-.045.043-.051c.025-.035.049-.069.068-.099l.027-.04.021-.029.638-.684.937-1.007-.003-.003.006.002c.065-.019.107-.094.093-.207-.016-.113.051-.136.18-.118.097.013.215.014.267-.037.393-.376.77-.767 1.146-1.147l-.002-.307c-.008-.11.051-.135.182-.114a.39.39 0 0 0 .363-.115c.893-.925 1.785-1.849 2.672-2.77l-.005-.005.007.002.889-.818-.011-.024-.005-.022v-.021l.006-.018.01-.016.014-.014.016-.01.02-.007.01-.002h.002l.001-.001.001-.005.002-.011.006-.037.008-.033.01-.024.004-.01.006-.007.006-.005.005-.002.007.001.006.004.006.007.007.011.012.016.021.021.053.05.053.051.021.021.013.017.027-.028.027-.019.025-.012.027-.006a.778.778 0 0 1 .061-.01l.037-.008.043-.014.004-.001h.006l.009.003.009.006.008.008.017.023.015.028.031.056.008.011.008.009.01.005.009.003.09-.004.091-.012.18-.037.182-.037.09-.012.091-.004.003-.002v.004c.082.031.197.008.293-.084.094-.091.18-.061.291.042.082.077.197.16.298.16l2.237-.015.297-.221c.097-.084.18-.061.289.047a.621.621 0 0 0 .469.172l2.339-.045-.374.391-3.471 3.531-3.818 3.906-.002.017-.009-.009c-.078.033-.14.128-.14.259 0 .128-.081.167-.229.169-.111.002-.248.021-.317.09l-1.567 1.59c-.041.152-.081.286-.105.417-.018.111-.078.17-.193.208l-.094.032c-.196.054-.354.195-.486.386-.08.11-.16.219-.188.35-.111.334-.236.676-.366 1.019l-.142.511-.129.397a7.473 7.473 0 0 1-.312.763 5.99 5.99 0 0 1-.825 1.322l.008.007-.01-.002-.104.111-.051.054-.05.05-.1.095-.048.046-.049.043-.193.159-.193.141-.2.124-.05.031-.054.027-.107.056-.054.028-.027.015-.01.004c-.01-.02-.027-.036-.04-.055l.013-.025.024-.061.018-.064.013-.066.006-.068.002-.072.001-.178.001-.001.001-.132c.003-.074.005-.146.009-.211l.033-.413.031-.413c.002-.074.004-.154.008-.24l-.002-.281-.141-.42-.041-.117v-.001c-.002-.012.004-.024-.002-.035h-.014l-.004-.005-.003-.002-.003-.002-.071-.015-.075-.012-.156-.013-.162-.002-.16.007-.492.037-.318.006h-2.045l-.001.038-1.597.033-.403.007h-.13l-.131-.006-.128-.014-.128-.019-.063-.012-.063-.014-.125-.031-.008.009.004-.012c-.083-.053-.189-.064-.308-.014zm19.218.417-.013.003c-.223.231-.531.376-.754.607-.047.047-.049.129-.02.229.078.269-.163.157-.302.167l.023.137c.028.178.03.185-.192.158-.094-.012-.17-.012-.219.037l-2.422 2.549.004.01-.008-.008-.066.062-.073.057-.155.104-.156.103-.072.056-.067.062-.005.009-.002.01v.012l.002.014.017.062.009.03.006.028v.012l-.002.011-.006.008-.008.006-.039.021-.031.021-.051.037-.024.015-.026.011-.033.006h-.039l.003.021.001.029-.003.073a8.644 8.644 0 0 1-.003.073l.001.029.003.021.003.013.001.009-.002.007-.004.006-.006.002-.007.001-.009-.001-.011-.004-.024-.011-.028-.018-.031-.022-.009-.006-.004-.003h-.001l-.001.001-.009.006-.019.008-.02.005h-.019l-.019-.004-.017-.01-.015-.015-.014-.02-.009-.025-1.222.04v.006l-.004-.006c-.542.007-1.082-.11-1.623-.104a.41.41 0 0 0-.297.148c-.226.245-.381-.004-.557-.096l-.135.113c-.179.147-.185.152-.418-.024a.541.541 0 0 0-.242-.113l.068-.059.037-.037.034-.043.03-.049.027-.051.023-.053.018-.054.026-.105.015-.063.018-.056.021-.049.026-.042.015-.018.018-.017.018-.015.021-.013.022-.011.023-.01.053-.014.055-.014.053-.021.049-.025.044-.029.04-.032.033-.035.028-.038.022-.038-.012-.023.018.015c.436-.508.898-.989 1.211-1.559a.49.49 0 0 0 .035-.378c-.099-.345.198-.392.367-.545l-.041-.188c-.055-.247-.057-.249.205-.436a.583.583 0 0 0 .24-.284c.082-.23.195-.605.213-.688.044-.167.081-.336.109-.508.036-.17.217-.265.318-.401l2.266-2.345-.008-.007.018-.001.256-.253.264-.246.535-.481.533-.482.263-.245.255-.252.024-.026.021-.029.033-.059.047-.126.022-.062.028-.062.018-.03.021-.028.024-.027.028-.026.237-.208.179-.166.081-.07.045-.037.031.103.089.269.099.264.11.26.12.256.133.255.146.254.16.254.178.253.06.076c.097.165.181.344.298.498.006.007.033-.009.066-.031l.04.05-.019.022.023-.016.039.049c-.027.034-.046.061-.04.066.022.029.076.029.124.033l.141.161.188.201.098.098.102.093.102.092.106.086.108.083.11.078.024.013.023.011.025.007.025.005.053.004.055.001h.053l.053.005.025.006.024.009.024.012.023.017.098.075.077.051c-.881.901-1.489 1.521-2.401 2.455l.011.001zm3.342-2.122h.014l.018.003.015.006.015.008.012.011.011.012.009.014.008.016.006.017.01.038.002.041V111.097l-.12-.184zm11.374-9.264.092.135h-.006l-.012-.002-.01-.005-.01-.007-.008-.01-.018-.025-.014-.032-.012-.038-.002-.01v-.006zm.258.38.002.003h-.001v-.001l-.001-.002zm5.624-.108.125-.135.004.022.008.035a.223.223 0 0 0 .009.022l.006.014.003.012v.01l-.003.008-.005.007-.008.006-.01.005-.012.003-.028.002-.034-.001-.039-.006-.01-.002-.006-.002zm-74.771-26.523.221.444c.084.146.061.27-.047.434-.126.191-.174.43-.172.704l.102 7.972.002.003c-.016.464-.024.759-.039 1.223l.025.009.02.013.014.016.01.017.004.019v.019l-.004.02-.01.019-.005.009-.001.001v.001l.003.004.007.009.021.031.018.028.011.024.003.011.002.009-.001.007-.003.006-.004.004-.008.002-.01-.001-.012-.003-.021-.003-.028-.001-.074.003-.073.003-.03-.001-.021-.003v.04l-.006.032-.011.026-.014.024-.037.05-.021.032-.021.039-.006.008-.008.006-.011.002h-.012l-.028-.006-.031-.009-.061-.018-.014-.001h-.012l-.01.002-.008.005-.062.066-.057.073-.104.155-.102.156-.057.073-.062.066-.001.005-.003-.003c-.09.044-.166.154-.18.298-.013.142-.105.191-.268.209-.123.013-.275.048-.357.13l-1.82 1.841-.086.397c-.02.14-.104.189-.269.204-.194.015-.357.111-.505.262l-4.271 4.415.002.002-.002.001-.849.792.012.024.005.022v.02l-.004.019-.01.016-.013.013-.017.01-.018.006-.01.002.047-.002v.006l-.002.01-.006.038-.007.032-.009.025-.004.01-.006.008-.005.005-.006.002-.006-.001-.006-.003-.007-.007-.006-.011a.112.112 0 0 1-.012-.017l-.021-.02-.053-.049-.054-.049-.02-.021-.013-.017-.026.029-.025.02-.025.013-.027.008-.059.011-.036.01-.042.014-.004.002h-.005L183.95 96l-.009-.006-.009-.008-.016-.022-.016-.028-.032-.055-.009-.01-.008-.008-.008-.006-.01-.002-.088.006-.089.015-.176.044-.176.044-.088.015-.089.007v.001l-.003-.002c-.095-.029-.226-.001-.33.095-.103.095-.203.068-.335-.03-.1-.074-.236-.151-.352-.147-.862.031-1.734.188-2.588.284l-.31.258c-.099.097-.196.084-.34-.006-.167-.104-.36-.105-.573-.061a21.814 21.814 0 0 0-6.027 2.109c-.101.023-.211.117-.266.258-.054.139-.158.167-.326.148-.125-.014-.289-.011-.396.055-.404.23-.79.483-1.141.77-.354.28-.74.546-1.055.838l-.119.395c-.031.139-.119.184-.285.188-.195.002-.369.09-.529.231-1.49 1.403-2.694 2.687-4.139 3.448-.084.003-.168.068-.208.189-.04.119-.128.128-.263.079-.102-.037-.229-.067-.312-.027-.304.156-.659.215-.981.337a4.614 4.614 0 0 1-1.018.266l-.243.264c-.079.099-.165.089-.287.002a.584.584 0 0 0-.474-.093c-.424.073-.883.067-1.322.109-.43.021-.932.1-1.262.044l-.554-.027c-.187-.004-.337-.083-.509-.114-.355-.051-.634-.217-.926-.356-.037-.055-.132-.061-.229-.039-.103.029-.138-.039-.136-.171.002-.099-.006-.211-.061-.252-.217-.146-.316-.392-.51-.56-.087-.241-.281-.428-.33-.686l-.271-.139c-.103-.046-.101-.115-.022-.213.107-.117.156-.235.139-.361-.08-.608-.004-1.261.289-1.789.271-.532.668-1.014 1.265-1.28l-.001-.002.004.001.016.002.008-.001.007-.002.007-.004.006-.005.01-.014.009-.02.006-.024.003-.03v-.035l.002-.033.002-.013.004-.011.004-.008.006-.006.006-.004.008-.002h.009l.009.003.021.011.025.017.029.024.047.039.045.032.044.021.021.006.009.001.009-.001.227-.055.223-.066.221-.074.055-.02.062-.005.125-.01.035-.005.113-.229.014-.027.008-.011.008-.008.008-.005.008-.003.009-.001.009.001.009.004.009.006.02.019.021.025.021.035.028.041.028.035.027.027.029.021.029.015.029.009.031.004.031-.001.123-.011.105-.002.372.029.413.031c.074.002.154.004.24.008l.281-.002.42-.141.117-.04.031-.015.01-.006.002-.003.002-.003.015-.071.012-.075.013-.156.002-.162-.007-.16-.037-.492-.042-2.188-.018-.791-.005-.197-.01-.215-.028-.457-.03-.456-.019-.228-.034-.227-.14-.904-.004-.004.004-.006c.012-.113-.051-.261-.169-.365-.118-.104-.115-.221-.05-.391.049-.127.092-.301.059-.434-.302-.978-.682-1.938-1.218-2.8-.142-.086-.265-.168-.39-.234-.133-.071-.183-.168-.178-.351.006-.211-.082-.418-.229-.621a12.033 12.033 0 0 0-2.643-2.508 12.78 12.78 0 0 0-3.277-1.562.489.489 0 0 0-.408-.022c-.148.055-.252-.003-.374-.141-.091-.1-.226-.231-.364-.25-.11-.016-.221-.035-.331-.054.043-.073.089-.147.13-.224l1.779-.012.28-.221c.092-.084.17-.061.274.047a.57.57 0 0 0 .443.172l5.029-.102v-2.63l.004-.001v2.631l.015.009.008.003.009.001h.008l.01-.001.018-.008.018-.013.019-.019.018-.025.018-.031.017-.028.008-.011.008-.008.009-.004.008-.003h.009l.008.002.009.005.009.006.018.021.018.027.02.035.031.058.035.052.019.021.019.016.018.011.01.003.009.001.511-.001.509-.012.036-.002.14-.221.017-.026.008-.01.009-.007.008-.005.009-.003h.008l.008.002.008.005.009.007.017.02.018.027.02.037.023.043.024.037.026.03.027.023.027.018.029.013.031.006.031.002.125.002.107.01.184.033.183.031c.033.002.069.004.106.008l.125-.002.188-.141.029-.022.004-.002v-.001l.002.001.002.002.012.007.02.013a.503.503 0 0 1 .027.017l.009.004.005.001.032-.013.03-.018.029-.021.027-.022.049-.053.043-.057.07-.11.026-.045.022-.032.649-.779.954-1.147-1.299-1.174-.455-.411.004-.001.453.409 1.301 1.176c.083-.045.149-.153.151-.293.001-.137.087-.188.245-.207.117-.016.263-.053.336-.135l1.627-1.822.054-.387c.003-.049.026-.075.048-.104a110.056 110.056 0 0 1 6.461-1.759c.227-.052.353-.008.564.112.316.162.548.167.832-.149.614-.69 1.381-.773 2.191-.329.07.032.232.027.27-.019.371-.49.897-.664 1.484-.765 1.024-.18 2.045-.37 3.07-.584.482-.096.906.04 1.311.28a.76.76 0 0 0 .939-.096c.33-.319.668-.596 1.167-.651 1.144-.114 2.28-.351 3.378-.411l.988.532c.106-.001.221.002.336-.007.229-.018.461-.054.689-.053.613.014 1.098-.256 1.521-.699l.948.48a32.45 32.45 0 0 1 2.504-.149c.009.738.012 1.475.015 2.199zm-37.549 20.748.23.003v.001h-.002l-.002.001-.014.007-.031.012-.033.008-.033.004-.032-.002-.031-.006-.028-.012-.014-.008-.01-.008zm-17.448 3.551.036.183.029.184.008.047.002.047.003.094.018.372.017.185.026.182.005.019.008.017.012.016.014.016.059.058.029.028.025.031.008.018.008.018.002.019v.021l-.013.166-.003.127-.004.056-.009.055-.017.056-.024.059.019.024.023.042.057.109.056.112.021.049.018.029.01.017.008.016.004.015v.015l-.002.014-.004.014-.008.013-.01.013-.025.021-.031.02-.039.016-.041.013-.045.009-.046.004h-.046l-.044-.004-.041-.01-.036-.014-.017-.01-.015-.01-.012-.013-.011-.013-.479.006-.099-.02-.184-.037-.091-.012-.091-.004-.01.003-.009.005-.009.009-.008.011-.021.038-.652-.032v-.004l.005-.022.011-.024-.893-.837-.006.001.004-.004c-.239-.23-.392-.547-.631-.777-.048-.049-.131-.053-.233-.023-.271.074-.163-.169-.175-.31l-.139.021c-.181.027-.188.028-.164-.198.011-.095.01-.172-.042-.222l-2.632-2.509-.004.003v-.005l-.939-1.027-.639-.698-.022-.029-.026-.041a2.444 2.444 0 0 1-.069-.101l-.042-.052-.049-.046-.026-.021-.028-.017-.03-.014-.032-.011-.004.002-.008.004-.027.019-.018.014-.012.008-.002.002-.002.001v-.001l-.004-.002-.027-.022-.174-.141-.117-.002c-.035.004-.068.006-.1.008l-.088.015-.083.017-.171.033-.1.01-.117.002-.029.002-.028.006-.028.013-.025.018-.025.023-.024.03-.022.037-.022.043-.018.037-.017.027-.016.02-.008.007-.008.005-.008.002h-.008l-.007-.003-.008-.005-.007-.007-.008-.01-.016-.026c-.043-.07-.084-.141-.131-.221l-.033-.002-.475-.012-.377-.001c.493-.356.989-.706 1.477-1.075.393-.299.814-.389 1.281-.353a.759.759 0 0 0 .807-.489c.066-.178.141-.348.232-.507.873.184 1.725.473 2.511.914.386.222.696.548 1.039.818.071.054.171.058.285.026.308-.081.234.213.282.373l.156-.01c.208-.01.219-.008.238.248.01.104.024.193.086.266 1.107 1.144 2.02 2.531 2.436 4.094l.005-.002-.005.009.044.173zm-11.112-4.32-.012.021-.017.027-.017.021-.008.006-.008.005-.008.002h-.008l-.007-.003-.008-.004-.006-.006c.036-.022.067-.047.099-.069zm-13.209 24.375.007.001c.045.002.059-.045.019-.136-.039-.089.005-.091.106-.048.077.033.166.062.193.035.203-.193.392-.401.582-.603-.027-.085-.053-.157-.078-.234-.033-.085.006-.09.109-.044.123.056.199.048.246-.002l1.335-1.477-.003-.002h.006l.015-.002.007-.003.005-.004.005-.005.004-.006.004-.015.002-.02-.004-.023-.008-.027-.012-.032-.012-.029-.002-.012-.001-.01.001-.008.002-.006.005-.005.007-.003.008-.002h.01l.023.004.064.024.059.023.057.017.024.004.021.002.018-.003.007-.003.006-.005.283-.284.274-.29.009-.012.01-.01-.078-.233-.01-.028-.002-.021v-.008l.004-.006.004-.005.006-.003.008-.001h.01l.023.004.064.025.045.018.039.013.035.007.033.002.027-.004.025-.008.021-.012.02-.017.07-.068.066-.052.141-.095.07-.046.072-.053.076-.064.082-.084.023-.223.004-.035.001-.004v-.001l.002-.001h.003l.014-.002.022-.004a.314.314 0 0 0 .032-.006l.008-.002.004-.002.016-.03.012-.031.008-.032.005-.033.001-.066-.006-.066-.022-.119-.011-.049a.303.303 0 0 0-.004-.036l-.008-.236.004-.12.004-.224-.002-.669h-.001l.003-.002c.035-.045.045-.114-.029-.194-.068-.078-.021-.126.1-.165.09-.029.191-.072.209-.131.092-.457.369-.834.553-1.252-.04-.104-.041-.181-.066-.271-.028-.097.027-.125.156-.113.152.015.252-.029.321-.117.7-.832 1.66-1.47 2.743-1.726.059.027.125-.001.172-.097.045-.095.108-.07.19.025.062.072.14.147.202.141.456-.086.919.002 1.369.035l.226-.164c.079-.065.128-.027.167.093.045.143.124.212.233.237 1.034.324 1.999.982 2.629 1.903l.003-.003-.001.005-.001.008.001.008.002.007.003.006.004.006.006.004.016.008.02.005.025.002.03-.002.036-.006.032-.004.012.001.01.002.007.003.006.005.003.007.001.007-.001.009-.003.011-.01.023-.018.027-.022.033-.038.053-.031.052-.012.024-.008.021-.002.018.001.008.002.007.091.185.099.18.104.177.063.193.006.013.004.014.242.037.029.005.012.004.008.005.007.004.005.006.002.007v.007l-.002.009-.004.009-.015.02-.022.022-.029.025-.036.031-.028.03-.023.029-.016.027-.01.026-.004.026.002.025.006.024.031.096.018.083.037.297.043.328.035.188.051.219.211.296.034.047.003.006.002.003.001.003.004.014.007.022.012.032.004.008.003.003.002.001.058.016.059.012.126.013.13.001.127-.006.394-.037 1.552-.041 1.154-.033c.159.026.318.061.479.075.016.001.028-.034.041-.091l.072-.002.016.095c.09.008.182.022.273.015.009 0 .02-.05.028-.105l1.878.025.01-.014.014-.012.014-.011.016-.009.037-.015.041-.01.044-.004h.046l.046.005.044.008.043.013.037.016.033.02.025.022.009.012.007.013.006.014.002.014-.002.015-.004.016-.006.016-.012.016-.016.029c-.006.014-.014.03-.021.049l-.05.129a4.47 4.47 0 0 0-.05.131.456.456 0 0 0-.021.05 1.161 1.161 0 0 0-.018.03l.028.068.019.064.012.063.006.065.01.15.021.193.001.023-.003.022-.006.021-.008.021-.023.039-.028.037-.03.037-.025.038-.011.02-.009.021-.005.021-.003.021.004.221.012.221.037.441.037.441.012.222.004.221h.008l-.01.008c-.031.012-.008.027.084.041.091.013.061.025-.042.041-.077.011-.16.027-.16.041-.008.104.007.21.015.312l.221.042c.084.013.061.024-.047.04-.126.018-.174.04-.172.065.02.247.084.495.102.741l.003.003h-.001c-.016.477-.024.78-.039 1.257l.025.01.02.013.014.016.01.018.004.02v.019l-.004.021-.01.019-.005.009-.001.002.008-.008v.001l.003.004.006.009.021.032.017.029.011.024.002.011.002.01-.002.007-.002.006-.006.004-.008.002-.009-.001-.013-.003-.02-.003-.03-.001a9.374 9.374 0 0 1-.075.003l-.074.002-.031-.001a.26.26 0 0 1-.021-.003l-.001.041-.007.033-.013.027-.016.024-.04.052-.023.032-.023.041-.006.008-.009.005-.011.003h-.012l-.028-.006-.031-.01-.062-.018-.014-.002h-.012l-.011.002-.009.006-.066.068-.061.074-.111.159-.112.16-.062.074-.066.069.001.001h-.004c-.077.03-.14.122-.14.251-.002.127-.081.162-.228.159-.109-.002-.245.013-.313.079-.512.485-1.018.977-1.502 1.476-.014.128-.027.243-.041.355-.004.125-.076.163-.223.161a.559.559 0 0 0-.43.191 8888.083 8888.083 0 0 0-3.428 3.637c-.076.032-.136.126-.133.254.004.126-.074.164-.222.166-.11.002-.245.021-.312.09l-1.465 1.513-.035.349c-.002.123-.074.162-.224.163a.582.582 0 0 0-.435.196l-1.621 1.688c-.578.489-1.127 1.037-1.732 1.475-.076.014-.143.086-.156.207-.014.118-.093.136-.229.103-.102-.024-.227-.039-.297.009-.512.376-1.057.655-1.592.942l-.121.313c-.035.114-.107.125-.232.071a.504.504 0 0 0-.428-.022c-1.314.609-2.752.918-4.23 1.105l-.002.004-.001-.004-.013-.009-.006-.003h-.012l-.006.002-.006.002-.007.005-.012.014-.012.02-.011.025-.011.032-.01.028-.005.011-.006.008-.006.005-.005.003h-.007l-.006-.002-.006-.004-.007-.007-.015-.02-.031-.062-.026-.057-.029-.051-.015-.02-.014-.016-.014-.01-.008-.003-.006-.001-.367.016-.363.026-.013.003h-.013l-.096.225-.012.027-.012.018-.006.005-.006.003h-.006l-.006-.002-.006-.004-.006-.007-.013-.019-.028-.063-.018-.043-.018-.036-.02-.029-.02-.022-.021-.017-.021-.012-.022-.006-.022-.001-.09.003-.077-.007-.162-.032-.082-.017-.088-.015c-.03-.002-.062-.004-.099-.008l-.116.002-.172.141-.027.022-.004.002v.001l-.002-.001-.002-.002-.011-.009-.019-.014-.027-.018-.008-.005-.004-.001-.031.01-.03.014-.028.017-.026.02-.048.046-.043.051c-.024.035-.049.07-.068.1l-.027.04-.021.028-.609.66-.877.955v.001h-.004c-.086.039-.158.144-.166.282-.01.136-.097.181-.254.191-.118.008-.266.036-.342.113l-1.713 1.714-.072.382c-.016.134-.096.18-.256.188-.187.007-.342.094-.482.233l-4.016 4.115c-.085.039-.156.144-.166.282-.008.136-.096.181-.254.191-.117.008-.264.036-.342.113l-1.712 1.713-.073.383c-.016.134-.096.179-.254.188-.188.006-.344.094-.482.233l-4.016 4.115c-.086.039-.158.144-.166.281-.01.137-.098.182-.254.192-.118.008-.266.036-.342.112l-1.713 1.714-.072.383c-.016.133-.096.179-.256.187-.187.007-.342.095-.482.234l-4.016 4.114.001.005-.001-.001-.891.824.011.025.005.022v.021l-.006.019-.01.016-.014.013-.017.011-.019.007-.011.002h-.003v.006l-.002.011-.006.038-.008.031-.01.025-.004.01-.006.008-.006.004-.006.002h-.006l-.006-.004-.006-.008-.008-.01a.091.091 0 0 0-.012-.017l-.02-.021-.054-.05-.054-.051-.02-.021-.014-.017-.027.028-.026.019-.026.012-.027.007-.061.009-.037.008-.043.013-.01.002-.01-.002-.008-.006-.009-.009-.017-.023-.016-.028-.03-.056-.008-.011-.009-.008-.008-.006-.01-.002-.09.002-.092.012-.181.038-.182.038-.091.012-.091.003v.003l-.003-.004c-.082-.032-.197-.009-.294.083-.095.091-.182.062-.292-.042-.084-.077-.199-.16-.3-.16l-2.248.015-.297.221c-.098.084-.181.06-.29-.046a.627.627 0 0 0-.471-.173l-.834.017c1.845-6.75 4.035-13.098 7.027-19.51.107-.21.223-.278.455-.368.33-.143.484-.317.422-.733-.133-.898.295-1.542 1.12-1.914.067-.034.161-.167.147-.224-.161-.602.02-1.128.295-1.655.502-.91 1.004-1.82 1.51-2.734.23-.436.58-.693 1.017-.863a.758.758 0 0 0 .489-.806c-.047-.459-.076-.91.202-1.328.638-.958 1.217-1.959 1.831-2.868l1.011-.457c.063-.084.134-.173.196-.271.123-.192.234-.401.373-.583.383-.479.498-1.009.416-1.613l.984-.43c.742-1.039 1.458-2.114 2.229-3.156l.031.008.051.008.053.005.107.001.107-.006.326-.037 1.285-.041 1.765-.062v-.005l.004.007c.04.032.097.009.144-.083.047-.091.09-.062.145.042.041.077.098.16.146.16.37.008.74-.007 1.104-.015l.146-.221c.049-.084.089-.06.143.046.063.127.142.175.232.173l2.619-.103v-.006l.004.006.014.01.008.003.008.001h.008l.008-.002.017-.007.017-.013.018-.02.016-.024.017-.031.016-.028.007-.011.008-.007.008-.006.008-.002h.008l.008.002.008.004.008.008.016.02.018.027.018.035.029.058.033.052.018.021.018.017.017.01.009.003.008.001.477-.001.473-.012.034-.002c.047-.079.089-.149.13-.221l.016-.026.008-.01.008-.007.008-.005.008-.002h.007l.008.002.008.004.007.007.017.02.017.028.018.035.021.044.023.037.023.03.025.023.026.018.028.012.027.008.03.001.116.002.1.01.171.032.083.018.088.014.1.008.116-.001.174-.141.028-.022.002-.002.001-.001.001.001.004.002.01.008.02.014.026.019.008.005.004.001.032-.011.029-.014.029-.017.025-.021.049-.046.043-.051.068-.101.027-.041.021-.029.64-.696.938-1.024.002-.004zm.837-5.568.02-.144.018.018.046.047.02.018.016.012.01.006.007.006.003.005.001.003v.002l-.003.004-.005.005-.018.007-.025.006-.033.004-.039.002-.01.001h-.008v-.002zm16.262-2.666.101.124-.009.006-.009.004h-.009l-.01-.002-.008-.004-.009-.008-.008-.01-.015-.025-.012-.031-.01-.038-.002-.011v-.005zm.247.304.021.025-.001-.001-.001-.001-.01-.011-.009-.012zm-28.975 158.29c-.455-.573-.445-.584-1.413-.886-.026-.222-.08-.437-.093-.651-.008-.389-.23-.617-.542-.777-.211-.09-.438-.148-.663-.226l-.078-1.091c-4.379-5.921-8.173-11.825-11.476-18.463h.001c-.103-.212-.08-.347-.007-.584.094-.348.053-.576-.312-.787-.783-.455-1.021-1.191-.798-2.068.015-.074-.03-.231-.083-.256-.57-.248-.869-.717-1.111-1.261-.427-.948-.779-1.927-1.201-2.884-.197-.451-.18-.886-.041-1.333a.758.758 0 0 0-.324-.885c-.393-.247-.75-.512-.922-.982-.35-1.096-.77-2.173-1.096-3.221.102-.399.188-.734.273-1.075-.026-.103-.051-.213-.088-.323-.074-.216-.168-.433-.223-.655-.15-.592-.492-1.013-1.012-1.327l.279-1.038-1.197-4.1-1.011-4.194c-.169-.712-.155-.718-.904-1.409.079-.211.133-.43.222-.631.17-.354.096-.662-.125-.939-.152-.174-.332-.324-.504-.491l.396-1.014c-.814-4.341-1.435-8.585-1.828-12.886l.529.578.639.697a.264.264 0 0 0 .023.029l.026.041.068.101.042.052.049.046.027.021.027.017.031.014.031.011.004-.002.008-.004.027-.019.019-.014.011-.008.002-.002.002-.001.001.001.003.002.027.022.174.141.117.002c.035-.004.068-.006.1-.008l.088-.015.083-.017.171-.033.1-.01.117-.002.029-.002.028-.006.027-.013.026-.018.025-.023.024-.03.022-.037.022-.043.017-.037.018-.027.016-.02.008-.007.008-.005.008-.002h.007l.008.003.007.005.008.007.008.01.016.026.131.221.033.002.475.012.477.001.008-.001.009-.003.017-.011.018-.016.018-.021.033-.052.029-.058.018-.035.018-.027.016-.021.001-.001.079.048.014.025.016.025.018.019.017.013.017.008.008.001h.008l.008-.001.008-.003.015-.009v-.004l.003.002c.32-.006.639.109.957.104.065 0 .125-.057.175-.148.134-.245.224.004.329.096l.079-.113c.104-.146.108-.152.246.023.058.074.111.129.18.128l3.491-.089v-.008l.008.008.221.004.221.012.442.037.441.037.221.012.22.004.023-.003.021-.005.021-.009.02-.011.037-.026.037-.029.038-.028.039-.023.021-.008.021-.006.022-.003.023.001.193.021.149.01.066.006.063.012.064.019.068.028.03-.017a.505.505 0 0 1 .05-.021c.038-.015.085-.032.13-.051l.13-.05.049-.021.029-.016.017-.011.016-.007.015-.004.015-.001.014.002.014.005.013.007.013.01.021.024.02.033.016.037.012.042.01.045.004.046v.046l-.004.044-.01.041-.014.037-.01.016-.01.015-.013.013-.013.01c.015 1.12.023 1.832.039 2.951l.005.008h-.005c.006.035-.109.07-.104.105 0 .007.057.014.148.019.021.001.021.003.037.004l.01.019c-.045.004-.105.009-.143.014l.113.009.046.004.01.017a8.598 8.598 0 0 1-.079.007c-.074.006-.129.012-.128.02.019.128.071.255.089.383h.364l.001.003h-.365l-.004.092-.012.092-.037.183-.037.183-.012.092-.004.091.003.009.005.01.009.008.011.008.056.031.028.016.023.017.008.009.006.008.003.01-.001.01-.014.043-.008.037-.01.062-.006.027-.012.025-.019.027-.028.028.018.013.021.021.05.054.05.054.021.021.016.012.012.007.006.007.004.006.002.006-.002.006-.006.006-.007.005-.009.005-.025.01-.033.008-.037.007-.01.001-.006.001-.001.001v.001l-.003.011-.006.02-.011.016-.013.014-.017.01-.019.006h-.021l-.022-.004-.024-.012-.836.893.001.001-.003.001c-.266.274-.618.462-.884.736-.056.055-.065.145-.042.252.061.287-.193.188-.346.211l.013.147c.015.192.017.2-.226.191-.102-.004-.185.003-.242.062l-2.891 3.017v.005l-.002-.002-1.06.973-.714.656-.029.021-.041.027a2.001 2.001 0 0 1-.102.068l-.051.043-.046.048-.021.027-.017.028-.015.029-.01.032.002.004.004.009.018.026.014.019.009.011.002.003.001.001v.001l-.004.003-.021.028-.141.173-.002.117c.004.036.006.068.008.1l.015.088.017.083c.012.056.021.111.034.175l.013.111.004.131.003.034.008.031.013.031.019.029.024.028.031.026.037.025.044.024.036.02.029.019.02.017.007.009.005.009.002.009v.008l-.002.009-.004.009-.008.008-.01.009-.025.019-.217.148-.002.038.002.532.012.536.002.009.003.01.011.019.017.019.021.019.052.035.059.031.035.019.029.018.02.018.007.009.005.009.002.008v.009l-.002.009-.004.009-.008.009-.01.009-.028.019-.03.02-.025.02-.018.02-.014.02-.006.02-.002.009v.009l.002.009.004.009.01.016.002.003h-.001c.021.635-.021 1.281.027 1.919a.507.507 0 0 0 .175.335c.268.242.025.447-.036.666l.134.146c.174.192.18.197.043.495a.623.623 0 0 0-.078.375c.332 2.324.891 4.648 1.773 6.887.24.611.414 1.26.679 1.868a.536.536 0 0 0 .299.259c.347.136.211.413.231.65l.177.093c.23.123.237.124.217.465a.628.628 0 0 0 .084.384c1.254 2.093 2.896 3.938 4.677 5.523.495.422.912.945 1.428 1.336a.524.524 0 0 0 .369.101c.361-.029.354.282.465.481l.197.004c.256.006.264.004.382.309a.625.625 0 0 0 .215.314c1.888 1.344 3.831 2.473 5.518 3.744.472.345.825.799 1.251 1.158.09.072.193.105.32.097.334-.018.278.274.342.462l.18.016c.234.023.236.031.265.324.01.122.028.225.106.31.635.728 1.199 1.488 1.587 2.344.236.407.351.875.53 1.312.098.473.274.918.318 1.414.038.268.047.538.058.807-.01.274-.032.551-.016.823a.428.428 0 0 0 .162.297c.259.221.009.402-.083.604l.113.153c.146.202.152.208-.023.474-.074.11-.128.214-.127.346l.1 6.719c.007.615-.108 1.229-.102 1.842 0 .126.057.24.148.336.246.257-.002.432-.094.633l.113.152c.147.203.152.209-.023.475a.602.602 0 0 0-.127.346l.049 3.296c-.585-.712-1.162-1.41-1.713-2.131zm123.175 44.061c-.23.054-.355.009-.568-.112-.316-.161-.547-.167-.832.15-.613.69-1.381.773-2.191.329-.069-.032-.232-.027-.269.018-.372.49-.897.665-1.485.766-1.023.18-2.045.369-3.069.584-.483.096-.906-.04-1.312-.28a.758.758 0 0 0-.938.096c-.33.319-.669.596-1.167.651-1.145.115-2.281.351-3.378.411l-.989-.531c-.105 0-.22-.003-.335.006-.229.018-.461.054-.69.053-.613-.014-1.098.257-1.52.7l-.948-.481c-1.405.152-2.834.146-4.267.211-1.434.026-2.873.157-4.314.099-.732-.015-.734-.029-1.574.523-.189-.12-.391-.216-.566-.344-.309-.237-.625-.227-.945-.066-.203.115-.39.262-.591.396-.277-.181-.556-.363-.902-.591-7.362-.292-14.337-1.025-21.583-2.585-.229-.053-.322-.147-.462-.35-.215-.284-.421-.39-.813-.229-.849.342-1.578.096-2.125-.626-.049-.06-.197-.126-.25-.102-.546.279-1.095.205-1.666.038-1-.287-2.001-.563-3.016-.819-.478-.12-.812-.386-1.07-.792a.756.756 0 0 0-.885-.324c-.436.144-.859.244-1.332.076-1.083-.387-2.195-.707-3.226-1.083l-.661-.909c-.096-.046-.196-.098-.305-.141-.213-.084-.438-.152-.644-.254-.546-.28-1.099-.248-1.671-.032l-.645-.848c-1.328-.479-2.623-1.077-3.937-1.653-1.302-.597-2.653-1.109-3.926-1.787-.653-.33-.649-.345-1.646-.21-.119-.19-.258-.364-.361-.556-.176-.348-.465-.475-.824-.469-.232.016-.464.066-.703.1-.172-.283-.343-.567-.557-.923-6.246-3.323-11.987-6.887-17.607-11.206l-.078-6.398H119.804a.39.39 0 0 0 .084.349c.091.112.061.216-.042.348-.077.099-.16.235-.16.355l.011 2.005c-.473-.07-.863-.32-1.234-.646-.774-.695-1.6-1.332-2.362-2.046-.368-.327-.537-.73-.603-1.197a.758.758 0 0 0-.666-.668c-.457-.056-.887-.146-1.245-.497l-1.249-1.185a46.528 46.528 0 0 1-1.162-1.217l-.209-1.097c-.068-.082-.138-.172-.218-.256-.157-.166-.333-.322-.478-.501-.377-.482-.896-.688-1.51-.737-.068-.333-.146-.652-.212-1.044l-.296-.336-.013-.661c.032-.09.009-.217-.084-.323-.091-.104-.062-.2.042-.323.077-.091.16-.218.159-.33l-.019-2.478c-.079-.118-.151-.226-.221-.327-.084-.108-.061-.199.046-.32.126-.142.173-.317.172-.52l-.111-5.881c.032-.09.009-.217-.084-.323-.091-.104-.062-.2.042-.322.076-.092.159-.219.159-.33l-.019-2.479-.221-.327c-.085-.107-.061-.199.045-.32.127-.141.174-.317.172-.52l-.057-2.943c-.033-.985-.073-2.129-.264-3.197a.403.403 0 0 0-.133-.345c-.1-.099-.104-.208-.031-.364.052-.116.1-.276.069-.401-.102-.466-.216-.929-.396-1.379a9.216 9.216 0 0 0-.551-1.326c-.132-.09-.245-.175-.362-.245-.13-.073-.149-.178-.121-.353.028-.199-.038-.399-.161-.6-1.2-1.972-2.905-3.434-4.545-4.665a.377.377 0 0 0-.322-.144c-.141.007-.204-.073-.246-.231-.031-.118-.09-.263-.184-.331-.698-.52-1.409-.979-2.092-1.434l-.396-.003c-.138.01-.199-.062-.239-.217-.045-.184-.162-.32-.329-.432-1.613-1.075-3.188-2.105-4.551-3.321-.041-.081-.143-.145-.277-.145-.132 0-.178-.084-.19-.237-.009-.113-.037-.254-.112-.324-.537-.546-1.076-1.084-1.549-1.662l-.365-.092c-.127-.025-.17-.101-.148-.258a.654.654 0 0 0-.141-.489 20.059 20.059 0 0 1-2.649-4.677c.003-.091-.058-.193-.177-.256-.117-.061-.119-.156-.059-.299.045-.105.085-.244.051-.341-.271-.717-.432-1.483-.657-2.212-.109-.086-.187-.176-.28-.252-.102-.081-.096-.172-.014-.308.098-.157.111-.329.072-.516-.398-1.804-.631-3.674-.75-5.55h-.004l.003-.004.009-1.279-.025-.01-.021-.013-.015-.016-.01-.018-.005-.019-.001-.02.005-.021.008-.02.005-.01.002-.001v-.001l-.002-.051-.004-.004-.006-.009-.021-.031-.018-.028-.011-.024-.003-.011-.002-.009.002-.008.002-.006.006-.004.007-.002.01.001.013.003a.22.22 0 0 1 .02.002h.03l.075-.004.074-.004.03.001a.206.206 0 0 1 .021.003l.001-.041.006-.033.012-.027.015-.024.038-.052.022-.033.022-.04.006-.009.008-.005.012-.002.012-.001.028.005.031.009.062.018.014.001h.013l.011-.003.008-.005.064-.069.059-.074.107-.16.107-.161.059-.075.064-.069-.001-.001h.004c.062-.018.102-.09.083-.201-.018-.11.045-.132.172-.112.095.015.209.017.258-.032.371-.359.725-.734 1.079-1.1l-.012-.3c-.013-.106.045-.13.173-.108a.368.368 0 0 0 .351-.105l2.513-2.657v-.005l.002.002.018-.003.007-.004.007-.004.005-.006.005-.007.007-.017.003-.021-.002-.025-.006-.029-.011-.034-.009-.03-.001-.007.004-.031.001-.002.005-.005.007-.004.009-.003h.011l.025.002.031.008.037.012.062.02.059.014.027.002h.023l.02-.005.008-.004.007-.005.337-.339.326-.343.022-.025-.063-.248-.008-.029-.002-.013.001-.011.002-.008.004-.008.005-.005.007-.004.009-.003h.01l.025.002.031.008.038.014.046.016.043.01.038.004.034-.001.031-.007.028-.011.025-.015.022-.021.083-.081.077-.063.145-.098.07-.046.072-.053c.023-.021.049-.042.076-.064l.082-.084.023-.223.004-.035v-.005h.002l.004-.001.012-.002.023-.003a.953.953 0 0 0 .031-.007l.01-.002.004-.002.015-.029.012-.031.008-.032.005-.033.002-.067-.007-.066a1.964 1.964 0 0 1-.022-.119c-.004-.018-.008-.033-.01-.048l-.005-.036-.042-.945-.061-1.391h-.282l.001-.003h.284c.031-.006.008-.013-.084-.019-.091-.006-.061-.012.042-.019a.753.753 0 0 0 .16-.019c.008-.048-.007-.095-.015-.142l-.221-.019c-.084-.006-.061-.012.047-.018.126-.009.174-.019.172-.03-.02-.111-.084-.224-.102-.335h-.004l.004-.008.009-.034.004-.037-.001-.039-.008-.04-.013-.041-.019-.041-.025-.04-.031-.038-.029-.038-.01-.019-.008-.018-.004-.019-.003-.019-.001-.019.003-.019.005-.02.006-.02.02-.039.028-.041.035-.043.058-.07.051-.08.021-.041.016-.042.011-.042.004-.039-.013-2.296-.002-.081-.221-.314-.026-.038-.01-.019-.007-.019-.005-.019-.003-.018v-.019l.002-.019.005-.019.007-.019.02-.038.027-.04.037-.043.043-.052.037-.056.029-.059.024-.061.018-.064.013-.066.006-.068.002-.072.002-.281.01-.24.033-.413.031-.413c.002-.074.004-.154.008-.24l-.002-.281-.141-.42-.041-.117-.014-.032-.006-.009-.003-.002-.003-.002-.071-.015-.075-.012-.156-.013-.162-.002-.16.007-.492.037-2.283.042-3.355.061-.008.01v-.012c-.047-.031-.113-.008-.168.084-.055.091-.104.061-.168-.042-.047-.077-.113-.16-.172-.16-.432-.008-.862.007-1.287.015l-.17.221c-.057.084-.104.061-.167-.047-.073-.126-.165-.174-.27-.172l-3.056.102-.003.003v-.001l-1.222-.039-.01.025-.014.02-.015.014-.017.01-.019.004h-.019l-.02-.004-.019-.009-.009-.006-.001-.001h-.001l-.004.003-.009.007-.031.021-.028.018-.024.011-.011.003-.004.005-.007-.001-.006-.003-.004-.004-.002-.008.001-.01.003-.012.003-.021.001-.029-.003-.073-.003-.073.001-.03.003-.021h-.039l-.033-.006-.026-.011-.024-.014-.051-.038-.031-.021-.039-.021-.008-.006-.006-.008-.002-.011v-.012l.006-.028.009-.031.017-.061.002-.014v-.012l-.002-.01-.005-.008-.066-.062-.073-.057-.156-.104-.155-.103-.073-.056-.066-.062-.006-.001.004-.003a.622.622 0 0 0-.381-.262c-.168-.039-.242-.156-.29-.351-.036-.146-.104-.33-.215-.44l-1.552-1.539a112.875 112.875 0 0 1-.098-3.214.605.605 0 0 1 .054-.242 8.93 8.93 0 0 0 1.066 1.056c.159.026.303.05.44.061.15.008.218.089.27.259.055.207.209.35.411.472.986.59 2.06.975 3.149 1.186 1.078.227 2.284.2 3.117.184.085.031.204.008.304-.084.098-.091.188-.061.303.042.086.077.205.16.31.16l2.326-.015.309-.221c.101-.084.187-.061.301.047a.66.66 0 0 0 .486.172l5.521-.102c.084.031.203.008.303-.084.098-.091.188-.061.303.042.086.077.205.16.311.16l2.326-.015.308-.221c.101-.084.187-.061.301.047a.663.663 0 0 0 .487.172l5.521-.102c.085.031.204.008.304-.084.098-.091.188-.061.303.042.086.077.205.16.311.16l2.326-.015.307-.221c.102-.084.188-.061.301.047a.666.666 0 0 0 .488.172c1.909-.031 3.527-.079 5.191.187.07.049.18.05.285-.021s.182-.022.262.102c.061.093.146.197.239.218.692.13 1.355.375 2.024.563l.338-.104c.115-.043.181.01.238.148a.574.574 0 0 0 .347.328c1.55.635 3.06 1.447 4.474 2.443.045.074.148.124.278.107.128-.017.179.06.203.208.019.111.058.245.136.306.588.436 1.152.93 1.723 1.385l.365.034c.129.002.175.076.186.229a.63.63 0 0 0 .233.443 79.711 79.711 0 0 1 3.917 3.719c.035.082.134.15.269.158.133.008.173.094.178.248.003.115.025.258.097.334.541.561 1.082 1.12 1.614 1.673l.372.071c.131.015.172.094.175.25.001.184.082.337.216.474a99.838 99.838 0 0 0 4.055 3.892c.043.083.148.149.285.151.136.002.184.086.199.243.013.116.047.262.126.335a39.833 39.833 0 0 0 1.838 1.563l.389.031c.134 0 .188.074.214.231.027.186.133.331.287.454a38.245 38.245 0 0 0 4.89 3.132c.062.074.183.116.321.08.136-.034.207.035.268.181.045.109.121.24.221.291.371.188.739.378 1.115.551.385.156.767.312 1.146.468l.384-.078c.13-.037.204.021.277.166.087.168.239.267.431.332 1.855.681 3.805 1.025 5.725 1.331l.009-.006-.001.006 1.336.16.634.079.167.021.085.009.087.005.365.02.01-.013.013-.011.014-.011.015-.009.034-.013.038-.008.039-.003.042.002.042.006.006.002.008.006.009.012.007.012.006.012.002.014-.002.014-.004.014-.006.015-.012.015a.36.36 0 0 1-.016.027l-.021.045-.05.121a2.927 2.927 0 0 0-.05.121.541.541 0 0 0-.021.046l-.018.028.028.063.019.06.012.06.006.062.01.139.021.18.001.022-.003.021-.006.021-.008.019-.023.036-.028.035-.03.034-.025.035-.011.019-.009.019-.005.02-.003.021.004.204.012.205.037.411.037.41.012.205.004.206.006.007h-.008c-.025.015-.004.033.048.051l.047.06c-.017.006-.024.012-.053.019-.077.019-.16.043-.16.065-.008.165.007.331.015.493.08.023.146.044.221.065.084.021.061.04-.047.063-.126.028-.174.063-.172.104.02.391.084.781.102 1.17h.006l-.004.004c-.016.463-.024.758-.039 1.222l.025.01.02.013.014.015.01.017.004.019v.02l-.004.019-.01.019-.005.009-.001.001v.001l.003.005.007.008.021.032.018.027.012.025.002.01.002.009v.007l-.004.006-.004.004-.008.002-.01-.001-.012-.003-.02-.003-.029-.001-.074.003-.073.003-.03-.001a.26.26 0 0 1-.021-.003v.04l-.006.032-.011.026-.014.024a1.808 1.808 0 0 0-.037.051l-.021.031-.021.039-.006.009-.008.005-.01.002h-.013l-.028-.005-.031-.01-.061-.017-.014-.002h-.012l-.01.002-.008.005-.062.067-.057.072-.103.156-.103.155-.057.073-.062.067.001.001h-.004c-.062.018-.102.09-.083.201.02.109-.044.131-.17.111-.096-.015-.209-.018-.258.031-.369.357-.722.731-1.074 1.095l.013.299c.013.107-.044.13-.173.108a.366.366 0 0 0-.349.104l-2.5 2.646v.005l-.002-.002-.017.003-.006.002-.006.005-.006.005-.004.007-.006.016-.002.021.002.024.007.028.012.033.01.03.002.013.001.01-.002.009-.004.007-.004.005-.007.003-.009.003h-.01l-.024-.003-.03-.009-.037-.013-.061-.021-.058-.015-.026-.004h-.022l-.019.004-.008.004-.006.005-.312.314-.304.319-.009.013-.012.011.07.242.009.028.001.012v.011l-.001.008-.003.007-.006.005-.006.004-.008.002h-.01l-.025-.003-.029-.009-.037-.015-.046-.016-.041-.012-.037-.005h-.033l-.03.005-.026.01-.023.014-.021.018-.078.076-.072.059-.143.096-.07.047-.072.053-.076.064-.082.083-.023.223-.004.035v.005h-.002l-.004.001-.012.002-.023.004a.286.286 0 0 0-.031.006l-.01.002-.004.003-.015.029-.012.031-.008.031-.005.033-.002.067.007.066c.009.043.017.084.022.119l.01.048.005.037.015.778.013 1.062h.001l-.003.003a.29.29 0 0 0 .052.286c.078.1.037.181-.08.274-.088.069-.185.168-.197.264-.059.354-.089.71-.153 1.063l-.219 1.057c.056.119.104.228.153.332.062.112.021.186-.104.264a.626.626 0 0 0-.298.396c-.416 1.676-1.041 3.328-1.734 4.944-.064.06-.095.173-.055.298.041.124-.025.189-.168.244-.105.04-.23.107-.275.197a41.582 41.582 0 0 1-1.029 1.992l.049.369c.025.127-.035.188-.182.232-.17.05-.289.166-.385.322-.9 1.545-1.812 3.097-2.854 4.564-.073.049-.121.158-.104.292.02.132-.057.187-.205.218-.109.024-.248.068-.309.15l-1.365 1.828-.015.373c.005.13-.067.182-.22.203-.181.023-.318.121-.434.269-1.111 1.43-2.246 2.853-3.443 4.213-.08.041-.143.144-.141.278.003.133-.08.18-.232.193-.113.012-.254.043-.324.119l-1.556 1.692-.05.373c-.006.132-.084.175-.24.183a.657.657 0 0 0-.461.226 122.62 122.62 0 0 1-3.816 3.916c-.084.034-.154.132-.162.267-.009.133-.095.173-.248.176-.115.002-.258.022-.334.094l-1.686 1.571-.08.367c-.019.13-.098.169-.254.165a.655.655 0 0 0-.475.193c-1.352 1.229-2.697 2.468-4.092 3.63l-.001.005-.002-.002-.019.002-.008.004-.008.004-.007.006-.006.007-.01.017-.007.022-.002.026.001.031.006.036.005.032v.014l-.002.012-.004.009-.005.007-.007.006-.008.004-.01.002h-.012l-.025-.004-.033-.009-.037-.015-.062-.024-.061-.017-.027-.004-.025-.001-.021.004-.009.004-.008.005-.816.671-.028.024.023.263.003.031-.001.013-.002.012-.004.009-.005.007-.007.005-.008.004-.01.002h-.01l-.026-.005-.032-.011-.037-.017-.045-.02-.043-.013-.04-.007-.036-.002-.033.004-.031.009-.029.014-.026.019-.101.076-.088.056-.179.094-.182.099c-.031.021-.063.043-.101.066l-.109.086-.081.238-.013.037-.002.004v.002h-.006l-.012.003-.023.004-.031.007-.01.004-.002.001-.002.001-.015.035-.012.038-.008.038-.005.039-.002.081.007.079c.009.052.017.101.022.143.004.021.008.041.01.059l.005.043.042 1.108.061 1.618h3.502l.004-.107.012-.105.037-.213.037-.213.012-.106.004-.106-.003-.011-.005-.011-.009-.01-.011-.009-.056-.036-.028-.018-.023-.02-.008-.01-.006-.01-.003-.012.001-.011.014-.05.008-.044.01-.072.006-.031.012-.03.019-.031.028-.033a.175.175 0 0 0-.018-.015l-.021-.024-.05-.062-.05-.062-.021-.023-.016-.014-.012-.008-.006-.008-.004-.008-.002-.006.002-.008.006-.006.007-.006.009-.006.025-.012.033-.009.037-.008.01-.001.006-.011.016-.018.017-.014.02-.01.021-.005h.022l.023.007.024.013c.407-.348.667-.568 1.073-.916l-.001-.001.005-.001c.449-.379.979-.662 1.422-1.046a.452.452 0 0 0 .15-.32c.028-.345.317-.263.521-.318l.037-.182c.052-.237.053-.245.359-.276.129-.012.239-.036.334-.119 1.607-1.412 3.158-2.888 4.697-4.372.426-.403.922-.733 1.342-1.144a.453.453 0 0 0 .127-.329c.006-.345.298-.285.498-.355l.023-.185c.034-.24.035-.248.339-.302a.554.554 0 0 0 .324-.143 115.564 115.564 0 0 0 4.364-4.726c.395-.436.863-.809 1.246-1.256a.452.452 0 0 0 .1-.34c-.023-.346.275-.31.471-.396l.009-.187c.013-.244.012-.252.31-.334.125-.033.23-.075.311-.173 1.375-1.657 2.652-3.4 3.896-5.169.334-.491.78-.902 1.104-1.402a.469.469 0 0 0 .056-.354c-.068-.344.232-.347.416-.46l-.014-.186c-.016-.244-.018-.252.273-.371.121-.049.221-.104.291-.212a56.609 56.609 0 0 0 3.094-5.788c.24-.555.584-1.066.82-1.627a.464.464 0 0 0-.006-.36c-.137-.327.152-.398.307-.554l-.053-.183c-.068-.239-.072-.246.185-.433.107-.078.193-.156.237-.28a28.504 28.504 0 0 0 1.404-6.615l-.002-.003h.003l.007-.083.016-.083.047-.163.045-.165.016-.082.008-.084-.002-.008-.006-.009-.008-.009-.01-.008-.055-.031-.027-.016-.022-.016-.009-.008-.005-.009-.002-.009.001-.004.001-.005.015-.038.01-.033.012-.057.008-.024.013-.023.021-.023.029-.024-.018-.013-.02-.02-.049-.051-.047-.051-.021-.019a.091.091 0 0 0-.017-.012l-.01-.007-.007-.006-.003-.006-.002-.005.003-.006.005-.005.018-.009.025-.008.032-.006.038-.005.01-.001h.006l-.006.097.002-.009.006-.019.01-.016.012-.013.016-.009.018-.005.021.001.022.005.023.012c.295-.315.481-.516.775-.832l-.002-.002h.004c.265-.273.615-.459.879-.732.055-.055.065-.145.043-.252-.062-.285.191-.186.344-.209l-.014-.147c-.016-.192-.016-.198.225-.19.101.005.184-.003.241-.061l2.876-3.004v-.005l.002.003 1.026-.939.697-.64.028-.022.041-.027.102-.068.051-.042.046-.049.021-.026.017-.028.015-.03.01-.031-.002-.004-.004-.009-.018-.026-.014-.019-.009-.011-.002-.003-.001-.001v-.001l.004-.003.021-.028.141-.173.002-.117c-.004-.035-.006-.068-.008-.1l-.015-.088-.017-.083-.033-.171-.01-.1-.002-.116-.002-.03-.006-.028-.013-.027-.018-.026-.024-.025-.029-.024-.037-.022-.043-.021-.037-.018-.027-.018-.02-.016-.007-.008-.005-.008-.002-.007v-.008l.003-.008.005-.007.007-.008.01-.008.026-.016.221-.131.002-.033.012-.474.001-.477-.001-.009-.003-.008-.011-.018-.016-.018-.021-.017-.051-.033-.058-.029-.035-.018-.028-.017-.02-.017-.006-.008-.005-.009-.003-.007.001-.008.003-.008.004-.008.008-.008.01-.007.029-.016.031-.017.025-.017.019-.017.013-.017.008-.018.001-.008v-.008l-.001-.008-.003-.008-.009-.014-.005-.004h.003c-.006-.122.109-.244.104-.366 0-.024-.057-.048-.148-.066-.245-.052.004-.086.096-.126l-.113-.03c-.146-.04-.152-.042.023-.095.074-.021.129-.043.128-.068l-.089-1.338h-.004l.004-.007.061-3.12.042-2.164.037-.493.007-.16-.002-.161-.013-.158-.012-.074-.015-.071-.002-.003-.002-.003-.01-.006-.031-.015-.117-.04-.42-.141-.281-.001-.24.008-.413.031-.398.03-.194.003-.229-.007-.058-.001-.056.005-.055.011-.052.016-.05.021-.049.028-.046.035-.044.043-.035.034-.033.027-.032.018-.016.007-.015.004-.016.001h-.016l-.014-.003-.016-.005-.014-.008-.016-.011-.029-.027-.246-.229-.066-.004-.461-.021-.115-.005-.115-.009-.229-.028-.921-.101h-.033l-.034.007-.035.013-.036.017-.07.044-.064.052-.039.031-.036.023-.034.017-.016.005-.017.003h-.015l-.016-.001-.015-.005-.015-.006-.014-.009-.014-.012-.025-.032-.027-.034-.029-.028-.03-.021-.03-.017-.032-.011-.03-.005-.031.001-.028.007-.001.009-.006-.008c-.534-.088-1.043-.304-1.572-.392a.418.418 0 0 0-.321.093c-.273.187-.368-.1-.517-.231l-.156.076c-.208.098-.217.101-.398-.129-.074-.096-.146-.171-.259-.198-1.887-.517-3.731-1.213-5.479-2.145-.474-.271-.885-.639-1.353-.91a.398.398 0 0 0-.328-.039c-.323.079-.32-.217-.418-.391l-.176.02c-.232.022-.242.022-.34-.254a.519.519 0 0 0-.182-.276 44.09 44.09 0 0 1-4.729-3.782c-.418-.373-.741-.848-1.146-1.24a.43.43 0 0 0-.324-.109c-.342.009-.282-.279-.348-.475l-.18-.021c-.235-.029-.244-.029-.291-.329-.019-.125-.047-.23-.133-.317l-4.416-4.473c-.412-.415-.729-.916-1.146-1.328a.452.452 0 0 0-.332-.123c-.348-.001-.289-.295-.36-.496l-.183-.023c-.24-.032-.248-.032-.304-.338a.56.56 0 0 0-.151-.322c-1.557-1.488-3.221-2.918-5.031-4.208-.505-.345-.947-.784-1.462-1.122a.504.504 0 0 0-.37-.048c-.349.078-.369-.224-.497-.406l-.189.02c-.248.023-.254.026-.397-.264a.539.539 0 0 0-.248-.275 21.84 21.84 0 0 0-6.48-2.196c-.621-.086-1.229-.277-1.856-.354-.128-.017-.249.041-.354.127-.276.232-.436-.023-.637-.124l-.16.106c-.211.138-.215.143-.48-.045-.111-.078-.216-.137-.351-.141l-6.312.086c-.577.006-1.153-.109-1.729-.104a.444.444 0 0 0-.314.148c-.241.245-.406-.004-.594-.096l-.145.113c-.189.146-.195.152-.445-.023-.103-.074-.199-.129-.324-.128l-6.307.089c-.577.006-1.153-.109-1.729-.104a.444.444 0 0 0-.315.148c-.24.245-.405-.004-.594-.096l-.144.113c-.189.146-.196.152-.445-.023-.103-.074-.2-.129-.324-.128l-6.308.089c-.289.004-.576-.024-.865-.052-.266-.036-.461-.066-.695-.083-.092-.012-.181.034-.265.117-.228.227-.327-.051-.452-.17l-.136.088c-.181.114-.195.122-.341-.107-.061-.094-.118-.167-.212-.192-1.595-.456-2.895-1.495-3.526-2.953-.178-.403-.189-.862-.277-1.301-.014-.092-.082-.166-.184-.225-.271-.161-.057-.325.035-.487l-.117-.109c-.154-.148-.16-.159.006-.371.071-.095.115-.15.116-.284l-.089-6.308-.01-.008h.01l.059-3.256.025-.029c.021-.104.047-.215.061-.329.029-.228.04-.463.088-.688.102-.426.031-.819-.133-1.196l.003-.141.037-.492.005-.13c.137-.156.275-.316.428-.493l.712-4.212c.245-1.412.601-2.81.898-4.219.16-.714.175-.714-.196-1.659.064-.064.125-.129.185-.197.099.074.192.128.312.127l6.095-.089.003-.004v.003l1.379.062.938.041.035.005.049.01.118.022.065.006.066-.001.033-.005.031-.008.031-.012.029-.016.002-.004.002-.008a.379.379 0 0 0 .006-.032l.004-.022.002-.014.001-.003v-.002h.005l.035-.004.222-.021.083-.08.064-.075.053-.071.047-.07.098-.143.062-.076.082-.083.02-.021.016-.025.01-.027.007-.031.001-.034-.004-.038-.01-.042-.016-.047-.013-.038-.008-.031-.003-.024.001-.011.003-.008.004-.007.005-.006.007-.003.009-.002h.011l.012.001.029.008.248.065.025-.021.342-.322.337-.332.005-.006.004-.008.006-.02v-.023l-.002-.027-.014-.06-.02-.062-.012-.037-.008-.031-.002-.025v-.011l.003-.009.004-.007.005-.005.008-.004.009-.002h.011l.013.002.03.01.033.011.029.007.025.001.021-.002.018-.007.006-.005.006-.005.004-.007.004-.007.004-.017-.005-.005.006.001c.423-.427.931-.766 1.353-1.192a.464.464 0 0 0 .129-.336c.007-.351.304-.294.508-.367l.026-.186c.037-.243.038-.252.347-.309.129-.023.238-.056.33-.146l4.607-4.683c.423-.427.932-.766 1.354-1.191a.472.472 0 0 0 .129-.337c.006-.351.303-.294.506-.367l.027-.186c.037-.243.038-.252.347-.309a.571.571 0 0 0 .329-.146l4.608-4.682c.423-.428.931-.767 1.353-1.192a.473.473 0 0 0 .13-.337c.006-.351.303-.294.507-.366l.026-.187c.037-.243.038-.251.347-.309a.577.577 0 0 0 .33-.146l4.607-4.682v-.002h.002l.063-.059.069-.051.147-.094.147-.093.068-.052.062-.058.005-.008.002-.01v-.011l-.002-.014-.019-.06-.01-.03-.006-.027v-.012l.002-.01.004-.008.004-.003.004-.003.037-.019.03-.019a1.69 1.69 0 0 0 .048-.034l.023-.013.025-.01.03-.004.038.002-.003-.021-.001-.028V140.437l-.001-.028-.004-.02-.003-.013v-.009l.001-.007.003-.004.006-.003h.007l.019.005.023.012.028.018.023.018.006.002.016.008.015.014.012.02.01.025 1.107-.086v-.004l.004.004c.561-.064 1.143-.035 1.71-.116a.416.416 0 0 0 .282-.188c.188-.294.393-.091.598-.046l.114-.145c.15-.188.151-.194.437-.083a.555.555 0 0 0 .35.044 17.778 17.778 0 0 0 5.577-2.854c.474-.315.938-.613 1.376-.968a.413.413 0 0 0 .137-.309c.018-.334.301-.247.503-.298l.028-.175c.028-.234.027-.241.316-.279.12-.015.223-.041.307-.125 1.457-1.461 2.641-2.771 3.965-4.136.355-.371.799-.656 1.153-1.025.073-.075.101-.183.091-.305-.024-.325.256-.256.438-.311l.009-.171c.014-.224.014-.231.295-.267.117-.013.217-.037.293-.116l1.936-2.035 1.991-1.982-.001-.005.003.002 1.072-.945.734-.643.03-.023.044-.027.106-.068.055-.043.051-.049.021-.027.02-.029.016-.03.012-.032v-.004l-.004-.009-.018-.027-.014-.02-.007-.011-.002-.003-.001-.001v-.001l.004-.003.021-.029.141-.182.002-.122c-.004-.038-.006-.072-.008-.104l-.015-.093-.017-.086-.033-.179-.01-.102-.002-.121-.002-.029-.006-.03-.013-.028-.018-.027-.024-.025-.029-.025-.037-.023-.043-.022-.037-.018-.027-.017-.02-.017-.007-.009-.005-.008-.002-.008v-.008l.003-.008.005-.007.007-.008.01-.009.026-.016.221-.134.002-.034.012-.487.001-.491-.001-.008-.003-.009-.011-.018-.016-.018-.021-.018-.051-.034-.058-.03-.035-.019-.028-.018-.02-.017-.006-.008-.005-.008-.003-.009.001-.008.003-.008.004-.008.008-.008.01-.008.029-.016.031-.017.025-.017.019-.018.013-.018.008-.018.001-.008v-.008l-.001-.008-.003-.008-.009-.016h-.005l.003-.003c-.006-.077.109-.155.104-.232 0-.016-.057-.03-.148-.042-.245-.032.004-.055.096-.08l-.113-.02c-.146-.025-.152-.025.023-.06.074-.014.129-.026.128-.044l-.089-.847-.007-.008h.007l.061-3.356.042-2.281.037-.493.007-.16-.002-.161-.013-.158-.012-.074-.015-.071-.002-.003-.002-.003-.01-.006-.031-.015-.117-.04-.42-.141-.281-.001-.24.008-.413.031-.413.032-.24.01-.281.002-.072.001-.068.008-.066.012-.064.018-.061.023-.059.03-.056.037-.052.044-.043.035-.039.028-.039.02-.019.007-.019.004-.019.002h-.019l-.018-.002-.019-.005-.019-.007-.018-.01-.039-.026-.314-.221-.081-.002-2.296-.013-.039.004-.042.01-.042.017-.041.021-.031.02-.33-.039c-.002 0-.004.009-.006.012l-.101-.014-.106-.009-.002-.004-.006.003-.026-.002-.14-.002-.015.002-.014.006-.013.008-.013.011-.048.056-.023.028-.025.023-.013.009-.014.006-.015.002-.015-.002-.066-.013-.058-.008-.095-.009-.042-.007-.041-.012-.041-.019-.043-.028-.02.017-.031.021c-.024.016-.055.033-.084.051a.148.148 0 0 0-.021.013l-.016-.043-.011-.028-.006-.015-.006-.014-.029-.054-.109-.204c-.07-.132-.139-.256-.206-.381l-.208-.378-.112-.201-.015-.026-.018-.024-.037-.049-.076-.102h-.008l.006-.004c-.359-.463-.594-1.039-1.057-1.428a.446.446 0 0 0-.336-.116c-.344.019-.287-.291-.389-.479l-.19.005c-.247.007-.25.012-.358-.276a.555.555 0 0 0-.207-.293c-1.848-1.164-4.139-1.532-6.242-1.087-.566.145-1.168.225-1.734.418a.481.481 0 0 0-.227.285c-.109.336-.361.188-.58.203l-.072.17c-.096.22-.092.224-.409.199a.427.427 0 0 0-.342.088c-1.769 1.271-2.981 3.241-3.386 5.361l.002.002h-.003l-.012.073-.021.071-.055.142-.053.144-.02.072-.012.074.002.008.004.008.008.008.01.008.053.032.027.016.021.016.008.008.005.008.002.008-.001.004-.002.004-.016.033-.012.028-.014.05-.01.021-.013.021-.021.021-.031.02.017.012.02.019.009.009-.01.006-.016.004-.02-.002-.021-.006-.023-.013-.701.756.001.005-.003-.003c-.143.151-.371.216-.514.366-.029.03-.018.098.025.186.111.234-.107.101-.219.084l.043.116c.055.152.058.158-.131.097-.078-.026-.142-.04-.172-.008l-1.545 1.668.001.006-.004-.004-.067.062-.072.057-.156.103-.156.103-.072.056-.066.062-.006.008-.002.011v.012l.002.014.018.061.009.031.005.027v.013l-.002.011-.005.008-.008.006-.04.021-.031.021-.051.037-.023.015-.027.01-.031.006h-.041l.004.021v.029l-.002.074-.003.072.001.029.003.021.003.013v.009l-.002.008-.004.005-.005.002-.007.001-.01-.001-.01-.004-.024-.011-.028-.018-.031-.022-.008-.006-.005-.003-.001-.001v.001l-.002.001-.008.006-.02.008-.019.005h-.019l-.019-.004-.017-.01-.016-.015-.012-.02-.01-.025-1.221.04-.004.007v-.007c-.273.007-.547-.11-.82-.104-.057 0-.107.056-.15.148-.113.245-.191-.004-.281-.096l-.068.113c-.09.147-.093.152-.211-.024-.049-.074-.096-.128-.154-.127l-2.993.089-.004.008v-.008l-.116-.003-.116-.012-.232-.038-.231-.038-.117-.012-.057-.001.016-.021c.452-.576.45-.581.556-1.57.215-.07.417-.166.629-.223.382-.09.575-.341.653-.688.039-.229.043-.464.066-.703.316-.101.637-.201 1.034-.327 4.81-5.577 9.737-10.572 15.476-15.265.186-.146.318-.159.564-.142.296.008.488-.066.615-.32l2.651-.048v-1.013l.008.001v1.014c.009.031.021.008.032-.084.01-.091.02-.061.031.042.009.077.021.16.032.16.081.008.162-.007.242-.015l.032-.221c.01-.084.02-.061.031.047.014.126.031.174.051.172.191-.02.384-.084.574-.102v.018l.004.005 1.223.039.01-.025.013-.02.015-.014.018-.01.018-.004h.02l.02.004.018.009.01.006v.001h.002l.004-.003.008-.006.032-.022.028-.018.024-.011.011-.003.008-.002.008.001.006.003.004.004.001.008-.001.01-.002.012-.004.021v.029l.002.073.003.073-.001.03-.002.021h.039l.032.006.026.011.025.015.05.037.032.021.039.021.008.006.005.008.003.011v.013l-.006.027-.009.031-.018.062-.002.013v.012l.003.011.004.008.067.062.073.057.155.103.156.104.073.056.066.063.003.001-.001.001c.012.058.077.09.183.065.104-.024.12.033.094.153-.021.09-.03.197.013.239.312.323.641.63.959.938l.281-.031c.1-.018.117.034.09.155-.036.144-.002.245.076.321l2.32 2.178.003-.003v.006l.003.017.004.007.004.007.006.006.008.004.016.007.021.003.025-.002.029-.006.034-.01.03-.01.014-.002h.01l.01.002.007.004.005.006.004.007.003.009.001.01-.002.025-.008.031-.013.038-.02.062-.013.06-.003.027.001.023.004.02.004.008.006.007.338.336.344.328.025.021.248-.063.029-.008.012-.001h.011l.009.002.008.004.005.006.004.006.002.009.001.011-.002.025-.009.031-.013.037-.016.047-.01.042-.004.038v.035l.007.031.011.027.016.025.02.022.082.083.062.078.098.145.047.07.053.072.064.076.084.082.223.023.035.004h.004l.001.002.001.003.002.014.003.022a.402.402 0 0 1 .006.032l.003.009.002.004.029.015.031.012.032.008.033.005.067.002.066-.007.119-.022.048-.01.036-.005.4-.018.01.005.041.016.041.011.041.004 1.246-.007c.102.003.203.011.305.007.002 0 .005-.008.008-.009l.736-.004.081-.002.315-.221.037-.026.019-.01.019-.007.018-.005.02-.003h.018l.019.002.019.005.019.007.038.02.041.027.041.037.053.043.056.037.059.03.062.023.063.018.066.013.069.006.071.002.281.002.241.01.412.033.412.031c.075.002.154.004.241.008l.281-.002.42-.141.117-.04.032-.015.008-.006.003-.003.001-.003.016-.071.012-.075.013-.156.001-.162-.006-.16-.037-.492-.041-2.283-.014-.432-.032-.484-.034-.484-.018-.242-.008-.06-.01-.06-.02-.12-.161-.957-.021-.119-.029-.118-.062-.234-.125-.468-.008-.007.008-.002c.009-.095-.046-.211-.16-.284-.109-.073-.111-.169-.056-.313.044-.108.079-.254.041-.358-.259-.783-.63-1.526-1.044-2.222-.129-.059-.24-.117-.355-.162-.127-.045-.151-.133-.124-.291.038-.189-.02-.362-.144-.52-1.145-1.576-2.656-2.855-4.332-3.79a.3.3 0 0 0-.315-.084c-.134.035-.203-.031-.265-.176-.003-.008-.01-.016-.013-.023.308.011.595.026.872.034.096-.047.199-.093.3-.15.198-.114.392-.248.601-.345.559-.253.879-.705 1.066-1.286l1.064.024c1.205-.738 2.473-1.391 3.744-2.054l.322-.168a.58.58 0 0 0 .309.099l3.528-.045.44-.007.371.013c.242.019.492-.006.729.043.239.038.482.061.72.105l.705.176c.252.081.487.209.725.321.231.127.446.282.684.389.1.042.204.053.322.017.316-.09.318.206.41.369a1.39 1.39 0 0 1 .174-.018c.224-.011.236-.007.311.274.029.116.064.212.154.279 1.466 1.234 2.514 2.994 2.909 4.936l.003.002-.002.004.02.175.013.175.013.352.003.175-.011.176-.004.175.006.174.003.018.007.017.008.016.012.015.059.059.03.029.024.03.01.017.007.017.003.019v.019l-.025.306-.006.062-.012.06-.019.062-.028.064.018.028.021.047c.014.036.031.079.05.123l.05.122.021.046.016.027.012.015.006.016.004.014.002.014-.002.014-.006.013-.007.012-.009.012-.025.021-.033.019-.037.015-.01.004-.006.001.082.001-.014.004-.145.041-.275.08-.514.156-.252.079-.127.041-.064.021-.033.011-.031.016-.545.282-.002.012-.004-.008c-.362.193-.746.342-1.078.61-.33.258-.719.467-.963.822a.767.767 0 0 0-.174.454c-.018.417-.362.451-.559.662l.004.24c.008.312.014.31-.305.564a.715.715 0 0 0-.271.398 6.626 6.626 0 0 0 .124 4.465c.54 1.42 1.597 2.635 2.879 3.398l1.07.592c.368.141.745.276 1.132.376a.53.53 0 0 0 .443-.058c.349-.212.521.054.765.166l.196-.098c.251-.13.261-.125.57.062a.65.65 0 0 0 .374.11c2.377-.033 4.948-.514 7.246-1.733.626-.318 1.263-.638 1.836-1.032a.564.564 0 0 0 .198-.348c.068-.369.369-.291.602-.36l.059-.192c.078-.25.066-.259.392-.311a.63.63 0 0 0 .352-.146c1.712-1.593 3.089-3.018 4.839-3.95.492-.234 1.033-.354 1.516-.59a.4.4 0 0 0 .233-.232c.136-.302.374-.117.573-.087l.096-.15c.127-.197.135-.205.413-.111.116.04.218.062.33.023 1.97-.502 4.04-.882 6.187-.941l.003-.003v.003l1.243.019.871.019.037.005.048.01c.035.007.076.015.12.022l.066.007.066-.002.033-.005.031-.008.031-.012.029-.015.003-.004.003-.009a.334.334 0 0 1 .006-.032l.004-.022.001-.014.001-.003v-.002h.005l.036-.004.222-.023.083-.082.065-.076.052-.072.047-.07.097-.143.06-.074.077-.079.019-.021.015-.024.01-.026.005-.03.001-.034-.005-.037-.011-.042-.017-.045-.014-.037-.009-.031-.003-.024v-.01l.002-.009.004-.006.006-.006.006-.003.009-.001.011-.001.012.002.029.009.242.068.012-.012.014-.01.325-.31.321-.319.004-.006.004-.008.004-.019v-.023l-.002-.026-.015-.059-.021-.061-.014-.036-.008-.031-.004-.024.001-.011.003-.009.003-.006.005-.006.008-.003.008-.001h.011l.013.002.03.01.032.012.029.006.025.002.02-.002.017-.006.007-.005.006-.005.004-.006.003-.008.003-.016v-.005l.001.001c.449-.458.985-.828 1.434-1.286a.519.519 0 0 0 .144-.353c.016-.363.321-.316.533-.4l.033-.193c.046-.253.047-.262.367-.333a.63.63 0 0 0 .346-.165l4.899-5.025-.001-.001.003-.001 1.026-.939.697-.639.029-.023.041-.026c.029-.021.064-.044.102-.068l.051-.043.046-.048.021-.027.017-.028.015-.03.01-.031-.002-.004-.004-.008-.018-.027-.014-.019-.009-.011-.002-.003-.001-.001v-.013l.004-.003.021-.027.141-.174.002-.117c-.004-.035-.006-.068-.008-.1l-.015-.088-.017-.083-.033-.171-.01-.1-.002-.116-.002-.03-.006-.028-.013-.027-.018-.026-.024-.025-.029-.024-.037-.022-.043-.022-.037-.017-.027-.018-.02-.016-.007-.008-.005-.008-.002-.008v-.007l.003-.008.005-.008.007-.007.01-.008.026-.016.221-.131.002-.033.012-.474.001-.478-.001-.008-.003-.009-.011-.017-.016-.018-.021-.018-.051-.033-.058-.029-.035-.018-.028-.017-.02-.017-.006-.008-.005-.008-.003-.008v-.003l.027-.036.027-.015.031-.017.025-.016.019-.018.013-.017.008-.017.001-.008v-.009l-.001-.007-.003-.008-.009-.015h-.004l.002-.003c-.006-.833.109-1.665.104-2.497a.79.79 0 0 0-.148-.455c-.245-.348.004-.585.096-.857l-.113-.207c-.146-.274-.152-.283.023-.644a.99.99 0 0 0 .128-.468l-.065-6.753a29.097 29.097 0 0 1 2.436-.029c.732.015.734.029 1.574-.523.189.12.391.217.566.344.309.238.626.227.946.066.202-.115.39-.262.591-.396l.902.591c7.361.293 14.336 1.027 21.582 2.586.229.053.322.147.463.35.215.284.42.391.813.23.849-.342 1.578-.097 2.124.625.049.06.198.127.25.102.546-.278 1.096-.205 1.666-.037 1 .287 2.002.562 3.016.818.479.12.812.387 1.07.793.191.3.535.433.885.324.436-.144.859-.244 1.332-.076 1.084.387 2.195.707 3.227 1.083l.66.909c.096.045.197.098.305.141.213.084.438.152.645.254.545.279 1.098.247 1.67.031l.645.848c1.328.479 2.624 1.078 3.938 1.653 1.302.598 2.653 1.11 3.926 1.788.652.33.648.344 1.646.21.118.19.258.364.361.555.175.349.465.476.823.47.232-.016.465-.066.704-.101.171.283.343.567.556.923 5.464 2.906 10.539 5.998 15.487 9.615-1.098.807-2.053 1.806-2.752 2.935l.009.005-.012-.001-.073.112-.081.107-.168.21-.166.215-.072.113-.066.117-.004.013-.002.014.002.016.004.015.014.032.016.034.016.033.01.031.002.015v.015l-.004.013-.008.013-.039.05-.031.046-.048.077-.022.033-.027.03-.033.028-.043.025.008.024.008.036.011.077-.021-.004-.026-.01-.023-.015-.01-.009-.009-.011-.008-.012-.007-.014-1.866.03v.013l-.006-.013c-.09.005-.181-.111-.271-.105-.019-.001-.035.056-.051.147-.039.246-.063-.004-.093-.096l-.022.113c-.031.146-.032.152-.07-.024-.016-.074-.031-.128-.051-.128l-.994.084-.006.021v-.021l-.166-.004-.164-.014-.331-.039-.33-.039-.165-.013-.165-.004-.017.002-.016.006-.016.008-.015.011-.028.026-.027.029-.028.028-.03.023-.015.008-.017.006-.016.002-.019-.002-.145-.021-.112-.011-.049-.007-.047-.012-.049-.019-.051-.029a.215.215 0 0 0-.023.018l-.037.021-.098.049-.05.025a71.548 71.548 0 0 0-.124-.444l-.16-.474-.186-.469-.109-.248-.127-.266-.012.006.01-.012c-.307-.621-.598-1.299-1.105-1.854a.58.58 0 0 0-.385-.192c-.387-.04-.369-.353-.506-.582l-.215-.025c-.288-.021-.281-.025-.457-.344-.073-.131-.154-.248-.296-.325-1.214-.66-2.548-.895-3.765-.9l-3.073.038c-.555.006-1.108-.109-1.663-.104a.422.422 0 0 0-.303.148c-.232.245-.391-.004-.571-.096l-.138.113c-.184.146-.189.152-.43-.023-.099-.074-.191-.129-.312-.128l-6.067.089v.002l-.003-.002-1.373-.061-.935-.042-.035-.005-.048-.01a2.903 2.903 0 0 0-.118-.022l-.065-.007-.065.002-.033.005-.031.008-.031.012-.029.015-.002.004-.002.009a.379.379 0 0 0-.006.032l-.004.022-.002.014v.003l-.001.002h-.005l-.035.004-.221.02-.084.08c-.022.027-.044.051-.064.074l-.052.071-.046.069-.098.143-.063.075-.081.082-.02.022-.016.024-.011.027-.007.031v.034l.004.038.009.042.016.047.013.037.008.031.003.025-.001.01-.002.009-.004.007-.006.005-.007.004-.009.002h-.01l-.013-.002-.029-.008-.247-.067-.025.022-.341.319-.337.33-.006.006-.004.008-.004.02-.002.023.004.026.012.06.02.062.013.038.007.031.003.025-.001.01-.002.009-.004.007-.006.006-.008.003-.008.002h-.012l-.012-.002-.031-.01-.033-.011-.029-.007-.025-.002-.021.003-.017.006-.007.005-.006.005-.005.007-.003.007-.003.017.003.009-.005-.005c-.282.286-.65.484-.932.771-.059.057-.072.149-.053.26.052.293-.205.195-.362.222l.009.151c.008.197.009.204-.238.2-.104-.003-.189.007-.251.067l-3.073 3.145.002.006-.004-.004-.066.061-.073.056-.155.1-.155.1-.072.056-.066.061-.005.008-.002.01v.012l.002.014.017.062.009.03.005.028v.012l-.002.011-.005.008-.003.011-.004.003-.039.021-.032.021-.05.036-.024.014-.026.011-.032.005-.04-.001.004.021v.029l-.002.073-.004.073.001.028.003.021.003.012.001.01-.002.007-.004.005-.006.003h-.007l-.009-.001-.01-.004-.025-.012-.027-.018-.031-.021-.008-.007-.004-.003h-.002l-.001.001-.009.006-.019.009-.019.004h-.019l-.019-.004-.017-.01-.015-.014-.013-.02-.009-.025-1.208.039-.003.005v-.005c-.445.006-.795-.028-1.316-.047a5.215 5.215 0 0 0-1.791.272c-.232.081-.418.22-.546.38-.327.427-.712.373-1.083.525l-.162.264c-.197.354-.195.35-.668.572a1.42 1.42 0 0 0-.52.4c-1.309 1.654-1.818 3.9-1.188 5.999.605 2.066 2.298 3.735 4.357 4.315l.006-.021.005.024.592.157.3.066.303.055.305.041.298.023.221.012.22.004.023-.003.021-.005.021-.009.02-.011.037-.026.037-.029.038-.028.039-.023.021-.008.021-.006.022-.003.023.001.193.021.149.01.066.006.063.012.064.019.068.028.03-.017a.505.505 0 0 1 .05-.021c.038-.015.085-.032.13-.051l.13-.05.049-.021.029-.016.017-.011.016-.007.015-.004.015-.001.014.002.014.005.004.002-.019.943c0 .011.007.019.009.029l-.015.786c-.365-.011-.735-.016-1.106.041a.497.497 0 0 0-.323.202c-.218.283-.44.084-.672.039l-.13.151c-.172.195-.17.198-.493.114a.607.607 0 0 0-.395-.004 9.158 9.158 0 0 0-3.105 1.902c-.875.807-1.554 1.695-2.157 2.53-.332.46-.738.837-1.041 1.264-.062.086-.074.196-.049.317.07.319-.219.288-.391.361l.014.169c.016.219.015.23-.256.284-.113.023-.207.051-.272.13-1.097 1.358-2.313 2.289-3.902 2.749l.001.006-.006-.004-.25.061-.254.053-.256.047-.26.039-.264.031-.267.025-.268.021-.271.013-.371.01-.373.002-.961-.013-.492-.037-.16-.007-.162.002-.156.013-.075.012-.071.015-.003.002-.003.002-.006.009-.014.032-.041.117-.141.42-.002.281c.004.086.006.166.008.24l.031.413.033.403.01.209.002.246.002.062.006.061.013.058.018.056.024.054.029.051.037.048.043.046.037.037.027.034.02.034.007.016.005.017.002.016v.017l-.003.016-.005.016-.007.016-.01.017-.026.032-.221.274-.002.071-.013 1.999.004.035.011.036v.012l.003.021.005.021.009.021.011.02.025.038.03.037.028.037.018.029c-.076.022-.127.047-.127.074-.005.128.072.257.091.385l.002.019.009.03.002.007h.006l-.01.056-.019.064-.028.068.018.03.021.05.05.131.05.129.021.049.016.029.012.016.006.016.004.016.002.015-.002.014-.006.014-.007.013-.009.012-.025.022-.033.02-.037.016-.043.013-.044.008-.046.005h-.046l-.044-.004-.041-.01-.037-.015-.016-.009-.014-.011-.014-.012-.01-.014-2.951.04v.017l-.008-.017c-.656-.006-1.502-.05-2.232.14a.627.627 0 0 0-.364.252c-.229.324-.502.155-.771.165l-.134.175c-.168.239-.169.234-.538.225-.154-.004-.297.007-.438.092-2.438 1.39-4.065 4.033-4.256 6.805-.057.752-.139 1.522.008 2.283a.617.617 0 0 0 .23.377c.31.247.127.51.121.779l.168.143c.226.184.229.182.193.551-.011.152-.012.297.066.442 1.254 2.514 3.797 4.282 6.555 4.632.75.098 1.514.225 2.279.121a.618.618 0 0 0 .391-.209c.264-.293.516-.1.785-.076l.15-.16c.197-.21.193-.22.562-.16.152.02.294.024.445-.041 2.584-1.114 4.486-3.557 4.991-6.288l-.005-.004.006.001.016-.072.025-.071.062-.14.033-.07.027-.072.021-.072.012-.074v-.004l-.001-.004-.005-.008-.008-.008-.01-.008-.051-.031-.027-.016-.021-.017-.008-.008-.004-.008-.002-.007v-.004l.002-.004.018-.033.012-.029.015-.049.009-.021.013-.02.021-.02.029-.021-.016-.012-.02-.019-.02-.02.006-.001.02.001.021.006.023.013.703-.759-.003-.003.005.001c.14-.148.365-.21.505-.357.029-.029.017-.096-.026-.184-.113-.234.104-.099.215-.08l-.043-.116c-.057-.151-.059-.157.128-.095.078.027.14.041.171.01l1.51-1.635-.004-.004.007.002.067-.062.072-.057.156-.102.156-.104.072-.056.066-.062.006-.008.002-.011v-.012l-.002-.013-.018-.062-.009-.031-.005-.027v-.013l.002-.01.005-.009.008-.006.04-.021.031-.021.051-.037.023-.015.027-.01.032-.006h.04l-.004-.021v-.029l.002-.074.003-.072-.001-.029-.002-.021-.004-.013v-.008l.002-.008.004-.005.006-.002.006-.001.01.001.01.004.024.011.028.018.031.022.009.006.004.003.001.001v-.001l.002-.001.008-.006.02-.008.019-.005h.019l.019.004.017.01.016.015.013.02.009.025 1.222-.04.003-.002v.002c.098-.007.193.11.291.104.02 0 .037-.056.053-.148.04-.245.067.004.1.096l.023-.113c.031-.147.033-.152.074.024.018.074.034.128.055.127l1.057-.089v-.003l.004.003.092.003.092.012.182.038.184.038.092.012.091.002.009-.002.009-.006.009-.008.008-.011.031-.056.016-.028.016-.023.009-.009.009-.006.01-.002.01.002.043.013.037.008.062.009.027.007.026.012.027.019.027.028a.387.387 0 0 1 .014-.017l.02-.021.055-.051a14.3 14.3 0 0 1 .053-.05l.021-.021.013-.017.006-.01.007-.008.007-.004h.006l.006.002.005.004.005.008.006.01.009.025.008.031.007.038.002.011v.006h.002l.011.002.02.008.017.01.014.014.01.016.006.019v.021l-.006.023-.011.024.893.835.003.002v.001c.229.22.371.526.6.746.045.046.127.048.228.019.267-.08.155.16.163.298l.137-.024c.178-.029.184-.031.156.19-.012.093-.013.169.036.217l2.521 2.392.005-.005-.001.009 1.773 1.859 1.205 1.264.24.293.082.091.09.087.094.076.049.032.049.027.002.001h.004l.01-.003.029-.015.021-.012.012-.007.003-.002.002-.001h.007l.057-.007.348-.038.188-.105.156-.1.258-.184.124-.092.163-.112.413-.275.062-.043.056-.046.05-.049.045-.053.038-.055.031-.06.024-.062.016-.066.013-.054.015-.046.02-.037.012-.017.012-.015.014-.013.014-.011.017-.01.019-.007.02-.006.021-.004.048-.003.195-.013.209-.022.067-.052.456-.382.221-.199.217-.206.209-.212.2-.218.192-.225.183-.231.021-.034.017-.038.01-.041v-.003l.006-.006c.002-.003-.003-.01-.003-.014l.003-.021.002-.044-.001-.043-.001-.003.053-.068.035.006a.24.24 0 0 0-.023-.022l.074-.098.014-.021c.053.005.093.004.104-.012.055-.074.062-.165.078-.253l.004-.007.184-.3.166-.31.147-.318.065-.162.061-.165.053-.167.049-.169.041-.171.033-.172.026-.174.019-.176.012-.175.002-.176-.005-.176-.014-.175-.022-.174-.03-.173-.017-.069-.02-.064-.051-.12-.027-.057-.031-.055-.063-.106-.134-.215-.064-.116-.061-.13-.066-.15-.066-.137-.136-.24-.253-.391-.23-.336-.229-.354-.534-.467-.326-.28c-.048-.038-.089-.073-.124-.102l-.078-.059-.083-.062a3.685 3.685 0 0 0-.069-.065l-.055-.068-.043-.07-.031-.068-.02-.067-.008-.063v-.022l.006-.072.002-.001h.003l.007-.001.048-.006.099-.008.1-.003.098.001.09.008.082.012.071.018.03.012.025.012.022.014.019.015.171.014.128.017.07.014.033.028.103.103.619.648.606.6 2.549 2.524.023.006-.01.009c.031.021-.025.13.006.152.005.005.05-.03.119-.091.023-.021.027-.022.04-.032l.019.004-.1.123.088-.074c.032-.027.035-.028.05-.039l.011.002c-.011.016-.018.027-.059.075-.047.057-.08.1-.074.104.108.084.242.142.352.226l.001-.001.001.003.059.063.053.07.096.148.096.148.053.069.06.063.007.005.01.002.012-.001.014-.002.06-.019.03-.01.027-.005.012-.001.01.002.008.005.004.003.002.005.02.037.02.03.035.048.014.023.01.025.004.031-.001.039.021-.004.029-.001.051.001.02.285c.009.09.018.175.025.26l.072.547h.004l-.003.002c.04.238-.031.502.033.746.013.051.078.083.177.098.262.038.039.168-.023.274l.127.028c.164.036.166.033.034.191-.056.066-.092.126-.073.179a5.995 5.995 0 0 0 1.686 2.408l.015-.017-.006.023.112.104.119.097.24.188.123.087.127.083.126.083.063.041.064.036.262.143.132.07.134.06.268.117.066.029.068.024.134.047.271.093.135.04.134.036.27.069.267.054.266.049.133.021.131.016.262.03.131.014.129.009.666.027.57.012 1.141.018.492.037.16.007.162-.002.156-.013.075-.012.071-.015.003-.002.003-.002.006-.009.014-.032.041-.117.141-.42.002-.281c-.004-.086-.006-.166-.008-.24l-.031-.413-.033-.413-.01-.24-.002-.281-.002-.072-.006-.068-.013-.066-.018-.064-.024-.061-.029-.059v-.034l.004-.066.037-.441.011-.126.042-.061.002-.081.012-2.104.195.008.01.012.23-.003 1.402.053c.025.001.047-.017.068-.044l.272.006.272.005c.021.029.044.048.067.048.085.002.169-.021.253-.041a5.453 5.453 0 0 0-.51.964 5.728 5.728 0 0 0-.172 3.739c.195.661.412 1.354.85 1.919.09.113.215.183.357.201.368.05.322.347.434.571l.203.026c.266.029.266.021.4.337.058.127.124.24.251.313 1.076.642 2.261.893 3.354.931.599.015.938-.01 1.401-.013l1.311-.019.003-.007.006.007.243.004.244.012.487.037.486.037.243.012.243.004.024-.003.023-.005.021-.009.022-.011.042-.026.041-.029.041-.028.043-.023.022-.008.023-.006.024-.003.026.001a7.563 7.563 0 0 0 .378.031l.072.006.07.012.072.019.074.028.034-.017a.646.646 0 0 1 .055-.021l.144-.051.143-.05c.021-.008.039-.016.055-.021l.031-.016.018-.011.018-.007.017-.004.017-.001.016.002.012.004-.004.031-.011.045-.015.043-.018.038-.022.032-.013.014-.014.012-.014.01-.016.007-.09.393-.092.361-.095.338-.099.324-.106.318-.116.321-.133.329-.151.342.001.01-.004-.002c-.002.019-.115-.017-.117.002a.969.969 0 0 0 .128.073l.001.015-.093-.04.095.051.001.015-.023-.01a.88.88 0 0 0-.118-.048c-.014.063.007.146-.008.21l.003.002-.005.004-.169.293-.178.275-.187.253-.192.228-.099.104-.098.096-.1.089-.031.025-.109-.001c-.086.004-.166.006-.24.008l-.413.031-.412.033-.239.01-.279.002-.072.002-.068.006-.066.013-.062.018-.062.023-.058.03-.056.037-.052.043-.042.037-.04.027-.038.02-.019.007-.019.005-.019.002h-.018l-.018-.003-.019-.005-.019-.007-.019-.01-.037-.026c-.101-.07-.2-.141-.313-.221l-.08-.002-2.283-.013-.039.004-.041.011-.042.016-.041.021-.079.052-.071.058-.042.035-.041.027-.039.021-.02.006-.019.005-.019.002h-.019l-.019-.003-.018-.004-.019-.008-.019-.011-.037-.028-.039-.031-.039-.025-.041-.019-.041-.013-.039-.008-.039-.001-.037.004-.033.009-.009.01v-.008c-.577.006-1.153-.109-1.729-.104a.446.446 0 0 0-.315.148c-.241.245-.405-.004-.595-.096l-.143.113c-.19.146-.197.152-.446-.023-.103-.074-.2-.129-.324-.128l-6.312.089c-.576.006-1.152-.109-1.729-.104a.446.446 0 0 0-.316.148c-.24.245-.405-.004-.594-.096l-.144.113c-.19.146-.196.152-.446-.023-.103-.074-.199-.129-.324-.128l-6.311.089c-.577.006-1.153-.109-1.73-.104a.444.444 0 0 0-.314.148c-.236.245-.432-.004-.523-.096l-.1.113c-.137.146-.153.152-.293-.023-.057-.074-.107-.129-.186-.128l-.455.007-3.958-3.192c-.481-.396-.928-.864-1.407-1.298l-.459-.008a.876.876 0 0 0-.465.148c-.374.245-.534-.004-.785-.096l-.205.113c-.264.146-.267.152-.59-.023-.104-.074-.201-.129-.325-.128l-6.311.089c-.577.006-1.153-.109-1.729-.104a.446.446 0 0 0-.316.148c-.24.245-.405-.004-.594-.096l-.144.113c-.19.146-.196.152-.445-.023-.104-.074-.2-.129-.325-.128l-6.311.089-.003.004v-.004l-1.39-.061-.945-.042-.037-.005-.048-.01a3.048 3.048 0 0 0-.12-.022l-.066-.007-.066.002-.033.005-.031.008-.031.012-.029.015-.003.004-.003.009a.334.334 0 0 1-.006.032l-.003.022-.002.014-.001.003v.002h-.005l-.036.004-.222.023-.083.082-.065.076-.052.072-.047.07-.098.145-.063.077-.081.083-.02.022-.016.025-.012.028-.006.03-.001.035.005.038.009.043.016.046.013.038.009.031.003.025-.002.01-.002.009-.004.007-.005.005-.007.004-.01.002h-.01l-.012-.001-.03-.008a14.607 14.607 0 0 0-.248-.063l-.025.022-.343.326-.338.337-.006.007-.004.008-.004.02-.002.023.003.026.013.06.021.062.013.038.007.031.003.025-.001.01-.003.01-.004.007-.006.005-.006.004-.01.002h-.011l-.013-.002-.031-.009-.033-.011-.029-.006-.025-.002-.021.003-.017.007-.007.004-.006.006-.004.007-.004.007-.003.017.003.003-.004.001c-.408.417-.902.746-1.311 1.163a.447.447 0 0 0-.12.33c.001.346-.292.287-.491.356l-.023.183c-.031.24-.032.248-.336.302-.125.021-.233.053-.321.142l-4.446 4.572c-.408.417-.902.746-1.311 1.163a.447.447 0 0 0-.12.33c.001.346-.293.287-.491.357l-.023.183c-.031.239-.032.248-.336.301-.126.021-.233.053-.321.143l-4.447 4.572c-.407.416-.901.746-1.31 1.162a.454.454 0 0 0-.121.33c.002.346-.292.287-.491.357l-.022.184c-.032.239-.033.247-.336.301a.655.655 0 0 0-.379.199c-.229.272-.574.48-.678.821l-.441.909-.74 1.562c-.379 1.085-.761 2.177-1.057 3.283-.121.618-.359 1.213-.477 1.836a.49.49 0 0 0 .078.363c.198.295-.103.43-.205.625l.102.17c.131.225.137.229-.059.481a.598.598 0 0 0-.15.343c-.24 2.299.033 4.608.468 6.859.161.609.205 1.25.371 1.861.034.125.11.225.234.289.323.172.146.415.131.641l.161.109c.209.146.216.147.145.465-.031.133-.045.252.004.379.891 2.124 2.039 4.15 3.512 5.918.364.514.744 1.021 1.161 1.496a.487.487 0 0 0 .341.152c.354.021.287.334.381.533l.195.025c.256.034.262.033.342.345.033.13.076.241.178.333a22.227 22.227 0 0 0 5.772 3.738c.286.133.558.297.833.454.285.136.572.271.871.376a.5.5 0 0 0 .375-.021c.328-.142.412.155.579.312l.183-.055c.238-.066.246-.078.458.161.088.1.177.178.309.211 2.204.668 4.587.773 6.798.797.583-.006 1.166.109 1.748.104a.452.452 0 0 0 .318-.148c.244-.245.41.004.601.096l.146-.113c.191-.146.197-.152.449.023.105.074.203.129.328.128l6.378-.089v-.003l.007.003.195.004.194.012.39.037.389.037.194.012.194.004.02-.003.019-.005.018-.009.018-.011.033-.026.032-.029.033-.028.035-.023.018-.008.02-.006.02-.003.021.001a4.6 4.6 0 0 0 .302.031l.059.006.057.012.057.019.06.028.027-.017c.013-.007.026-.014.044-.021.033-.015.074-.032.114-.051l.114-.05.043-.021.025-.016.014-.011.014-.007.006-.002v.009l-.006.035-.011.031-.008.015-.009.013-.012.012-.012.01.08.652.038.298.058.291.117.591.063.315.094.338.009.006-.007.002c.173.674.298 1.389.593 2.049a.616.616 0 0 0 .305.293c.346.16.209.451.256.699l.189.098c.246.129.252.127.263.488a.728.728 0 0 0 .127.399c1.546 2.172 3.645 3.529 5.396 4.809.49.354.887.796 1.334 1.147a.444.444 0 0 0 .339.08c.336-.035.3.262.379.449l.181.006c.238.01.243.016.3.308.022.122.053.224.14.304 1.434 1.361 2.549 2.934 3.199 4.817.205.503.209 1.078.364 1.599.022.111.097.2.204.266.287.18.074.389.021.582l.139.116c.184.154.186.163.045.434-.06.112-.1.214-.083.334.313 2.021.321 4.141.343 6.407.006.611-.109 1.221-.104 1.83 0 .125.057.238.148.334.245.256-.004.43-.096.629l.113.152c.146.201.152.207-.023.471-.074.109-.129.213-.128.344l.089 6.678c.006.611-.109 1.221-.104 1.831 0 .124.057.237.148.333.245.256-.004.43-.096.629l.113.152c.146.201.152.207-.023.472-.074.108-.129.212-.128.343l.089 6.678c.006.611-.109 1.221-.104 1.831 0 .125.057.238.148.334.245.255-.004.429-.096.628l.113.152c.146.201.152.207-.023.472-.074.109-.129.212-.128.343l.089 6.679.006.008h-.006l-.061 3.356-.042 2.281-.037.493-.007.16.002.161.013.158.012.074.015.071.002.003.002.003.01.006.031.015.117.04.42.141.281.001.24-.008.413-.031.413-.032.24-.01.281-.002.072-.001.068-.008.066-.012.064-.018.061-.023.059-.03.056-.037.052-.044.043-.035.039-.028.039-.02.019-.007.019-.004.019-.002h.019l.018.002.019.005.019.007.018.01.039.026.314.221.081.002 2.296.013.039-.004.042-.01.042-.017.041-.021.08-.052.07-.058.043-.035.041-.027.039-.02.02-.008.02-.004.019-.002h.019l.018.002.02.006.018.007.02.011.037.028.039.031.039.024.041.02.041.013.04.007.039.002.036-.004.035-.01v-.008l.008.007c.29-.003.58.024.869.052-.033 2.34-.062 4.555-.089 6.531l-.052 4.272c0 .264.3.571.294.834-.006.326-.313.609-.319.937-.032 1.585-.064 3.191-.098 4.785-.004.188-.164.411-.168.6s.146.342.141.529l-.073 2.672h.003l-.011.869.016.059.014.072.019.188.012.234c0 .086.002.176.004.273l-.014.629-.033.687c-.017.23-.032.46-.047.677l-.054.601-.054.458c-.01.06-.018.113-.023.155l-.023.095-.036.129-.031.13-.024.132-.021.133-.025.269-.014.272-.004.55-.011.552-.009.269-.002.217.012.189c.01.06.018.119.027.184.016.062.031.129.048.204.022.071.047.152.073.244l.239.712.032.12.012.059.008.058.004.057v.057l-.004.056-.006.057-.012.056-.016.056-.019.056-.022.057c-.019.035-.037.073-.057.112l-.072.115-.051.083-.043.088-.038.092-.032.095-.051.197-.041.203-.006.025-.01.023-.02.047-.02.047-.006.022-.004.022-.021.277-.012.279-.011.562.002.169.013.161.021.155.027.152.063.296.012.062c-6.028 2.505-11.984 4.542-18.418 6.077zM157.55 225.06l.006.002.01.003.037.015.021.012a1.377 1.377 0 0 0-.074-.032zm.154.066h.002l.002.001.002.001-.006-.002zm130.669 66.13.61.47.398.32.291.246c.092.077.184.154.291.246l.398.319.61.469.931.69.149.104.207.132.524.315.57.325.497.271.081.048.091.066c.03.025.063.053.099.081l.105.095.463.452.465.458.207.181c.033.025.064.049.094.07.03.019.059.036.084.053l.318.19.354.235.767.55 1.406 1.053-8.049 2.849c-.544.161-1.117.331-1.826.558-.055.017-.093.057-.123.115l-.494.164-.053.016-.061.014a.036.036 0 0 0-.01.002c-.027-.014-.053-.027-.084-.045-.076.023-.157.059-.235.088l-.159.018-.343.04a3.88 3.88 0 0 1-.146.023l-.062.014-.053.015-.2.076-.17.082c-.053.028-.102.057-.15.084l-.14.085-.14.085-.15.084-.172.081-.203.076-.883.292-2.335.773-1.935.666-.025.012-.021.014-.018.018-.014.021-.012.023-.01.026-.006.028-.003.03-.001.008v.004l.002.005.005.019.013.039.031.084c.025.057.053.117.08.182.061.125.123.258.18.378l.037.089.031.082.021.075.011.066.006.051.014.052.02.055.025.056.062.115.07.12.072.123.062.126.025.063.021.064.014.064.008.064.163.097.071.049.065.05.06.051.055.052.049.052.043.052.04.054.035.053.06.108.048.109.038.111.058.225.052.228.031.114.037.113.047.113.059.112.213.367.112.179.119.174.012.013.015.013.033.021.035.021.016.012.015.014.108.114.058.055.06.051.062.047.066.042.07.037.074.03.105.04.09.047.041.026.037.027.033.03.029.031.027.033.023.035.021.038.017.04.015.042.011.044.009.047.005.049.049.589.025.198.031.159.02.069.022.066.026.064.032.066.079.143.105.174.107.178.103.182.203.363.11.174.119.166.066.078.07.074.074.07.08.067.023.021.029.031.078.091.213.277.264.372.287.424.277.438.24.411.096.183.075.161.051.134.015.055.008.047.326.575h.001c.595 1.004 1.175 2.328 1.782 3.338.088.041.152.09.233.116l.534.134c-.023.163-.01.32-.07.486-.066.193-.061.337.026.479 1.485 2.489 2.349 3.784 3.686 6.126l-.003.002.293.527c.074.146.135.262.184.356l.111.242c.028.069.053.127.076.186l.076.185.111.242c.05.096.109.211.186.355l.293.527.051.08.078.104.205.247.234.258.211.215.016.017.016.021.029.051.027.061.024.07.044.16.042.176.042.176.044.163.024.071.026.064.028.053.016.022.018.019.062.07.063.08.127.182.127.204.126.218.438.802-3.34 2.021c-.064.027-.121.05-.178.072-.058.024-.115.049-.185.076l-.241.112-.357.185-.527.294-.08.052-.102.077c-.033.026-.073.062-.109.091-.322.213-.637.523-.953.695l-.006.003.005.008-.038.011-.175.042-.177.041-.162.044-.072.025-.063.026-.054.028-.021.016-.02.017-.07.062-.08.062-.182.128-.204.127-.218.126-.802.438-3.678-6.081c-.595-1.003-1.175-2.326-1.782-3.336-.088-.04-.152-.09-.233-.116l-.534-.133c.023-.164.01-.321.071-.487.066-.192.061-.337-.026-.479-1.484-2.489-2.35-3.782-3.685-6.124l.003-.002-2.494-4.397-.023-.048-.025-.058a8.028 8.028 0 0 1-.051-.138l-.105-.328-.105-.329c-.02-.05-.036-.097-.052-.138l-.025-.059-.024-.049a11.218 11.218 0 0 1-.114-.182l-.112-.151-.111-.131-.111-.12-.111-.121-.111-.132-.112-.152-.114-.185-.457-.81-1.211-2.142-1.029-1.77-.016-.022-.018-.018-.021-.015-.022-.01-.025-.007-.026-.004-.029-.001-.031.003-.008.001-.004.001-.004.002-.018.009-.036.02-.075.047-.163.115-.337.249-.079.054-.075.046-.07.035-.062.023-.049.016-.049.023-.049.03-.049.035-.102.084-.104.093-.107.094-.111.086-.059.038-.059.033-.061.026-.062.02-.063.179-.034.08-.036.073-.038.068-.04.063-.041.058-.043.054-.045.049-.045.045-.094.08-.1.067-.102.059-.209.101-.213.095-.105.052-.105.06-.102.067-.1.08-.317.28-.154.145-.147.15-.01.015-.01.016-.014.037-.015.038-.009.019-.01.017-.092.129-.041.067-.039.068-.034.07-.028.073-.022.075-.015.079-.02.111-.029.099-.01.025-.136-.154-.71.611-.096.027-.189.062-.15.062-.064.033-.061.035-.059.039-.059.044-.125.105-.148.137-.154.141-.158.135-.316.271-.15.142-.139.15-.064.079-.06.083-.056.087-.007.013-.087.069-.586.489-.871.751-.133.123-.173.172-.418.438-.439.482c-.037.043-.063.074-.1.114l-.002.002a.073.073 0 0 1-.009.008l.002.001-.26.299-.064.068-.084.072-.1.078c-.037.025-.074.053-.114.082l-.54.348-.544.352-.22.161-.088.075-.07.07-.253.267-.305.292-.698.624-1.324 1.132-1.704-13.42h-.001c-.177-1.418-.221-3.186-.407-4.617-.066-.09-.107-.177-.173-.248-.142-.146-.302-.278-.448-.421.083-.169.13-.351.249-.505.135-.18.184-.342.154-.545-.448-3.522-.768-5.4-1.133-8.686-.178-1.418-.221-3.188-.407-4.622-.067-.091-.108-.178-.174-.248-.141-.146-.301-.278-.447-.421.083-.169.13-.352.249-.505.134-.18.183-.343.154-.546-.449-3.521-.768-5.399-1.133-8.682l.004-.001-.236-2.281a213.942 213.942 0 0 1-.096-1.512l-.046-.606-.238-2.283a25.336 25.336 0 0 1-.029-.216l-.049-.288-.139-.714-.162-.765-.152-.654-.021-.109-.016-.133-.016-.319.005-.769.006-.774-.015-.327-.014-.139a42.878 42.878 0 0 0-.105-.549c-.023-.158-.05-.326-.077-.501l-.138-1.115-.221-2.079 13.198 9.453c1.164.834 2.493 2.003 3.674 2.84.111.013.204.041.3.041.203-.004.41-.031.614-.042.067.177.17.334.202.526.041.221.128.367.297.484 2.896 2.065 4.494 3.108 7.158 5.074 1.165.834 2.497 2.006 3.679 2.844.111.012.204.041.3.041.203-.005.41-.031.613-.043.068.177.171.335.203.526.041.221.128.367.296.484 2.897 2.065 4.495 3.108 7.157 5.073l-.001.002c.378.286.683.512.934.699zm32.341-92.464c.405.472.471 1.024.451 1.619-.003 1.041-.127 2.074-.16 3.12-.02.492-.225.876-.545 1.22a.758.758 0 0 0-.095.938c.246.393.448.785.403 1.285a85.013 85.013 0 0 1-.397 3.379l-.718.85c-.021.104-.047.215-.061.33-.029.227-.04.462-.088.687-.143.596.045 1.132.365 1.639l-.706.813-.711 4.212c-.245 1.413-.601 2.81-.898 4.22-.16.714-.175.713.196 1.658-.156.159-.289.335-.449.479a.861.861 0 0 0-.288.903c.062.221.158.435.239.659l-.802.741c-1.899 7.113-4.159 13.756-7.294 20.475-.107.21-.223.278-.455.368-.33.144-.484.317-.422.733.133.898-.295 1.542-1.121 1.914-.066.034-.16.167-.146.225.16.601-.02 1.127-.295 1.654l-1.51 2.734c-.23.436-.581.693-1.017.863a.759.759 0 0 0-.49.806c.048.459.076.911-.202 1.328-.637.958-1.216 1.959-1.83 2.868l-1.011.457c-.063.084-.134.173-.196.271-.123.192-.234.401-.373.583-.383.479-.498 1.009-.417 1.613l-.983.43c-.82 1.148-1.6 2.346-2.467 3.487l-2.633 3.419c-.453.576-.451.58-.557 1.57-.215.07-.417.166-.629.223-.382.089-.574.341-.652.688-.039.229-.043.464-.066.703l-1.035.327a140.76 140.76 0 0 1-7.206 7.777l-2.876-2.103c-.158-.115-.254-.381-.412-.496-.158-.114-.375-.082-.529-.199l-2.225-1.647-3.595-2.583c-.224-.158-.657-.093-.878-.254-.271-.198-.335-.621-.609-.821l-4.002-2.926c-.158-.115-.254-.381-.412-.496s-.375-.083-.529-.199l-2.225-1.648-.002.002-.219-.157c.334-.192.672-.38.968-.624a.527.527 0 0 0 .159-.348c.033-.364.326-.296.541-.37l.038-.19c.052-.249.05-.255.372-.313a.644.644 0 0 0 .351-.153c.444-.376.752-.869 1.126-1.304.344-.459.748-.88 1.033-1.371.568-.979 1.238-1.916 1.66-2.951.258-.556.631-1.062.885-1.623a.508.508 0 0 0-.025-.368c-.143-.328.147-.397.301-.553l-.056-.183c-.07-.238-.074-.244.181-.432a.582.582 0 0 0 .234-.279c.713-2.098 1.146-4.244 1.492-6.377.107-.584.322-1.151.373-1.739a.458.458 0 0 0-.108-.34c-.214-.276.054-.41.167-.591l-.096-.16c-.123-.209-.127-.215.078-.448.086-.097.152-.19.166-.316.145-1.07.146-2.138.213-3.206.069-1.069.087-2.135.088-3.197.006-.583.133-1.164.139-1.748a.44.44 0 0 0-.143-.319c-.24-.246.012-.407.106-.59l-.11-.141c-.145-.187-.149-.192.031-.436.076-.101.131-.194.133-.315-.01-2.058.036-4.102.164-6.135.051-.553.225-1.092.276-1.643a.419.419 0 0 0-.116-.319c-.219-.261.045-.389.154-.556l-.098-.152c-.117-.198-.121-.206.093-.416.089-.086.157-.169.176-.285.261-1.987.683-3.91 1.313-5.72.203-.479.516-.906.712-1.38.052-.091.048-.197.005-.311-.111-.301.182-.314.342-.412l-.037-.168c-.045-.221-.045-.232.213-.334a.566.566 0 0 0 .26-.174c.973-1.562 2.287-2.918 3.829-4.262.423-.369.924-.646 1.366-1.028a.445.445 0 0 0 .145-.317c.024-.344.312-.258.516-.315l.037-.183c.049-.24.049-.248.357-.284.128-.015.238-.04.334-.125 1.638-1.488 3.031-3.03 4.5-4.508.4-.409.888-.731 1.288-1.141a.437.437 0 0 0 .116-.326c-.004-.343.288-.282.484-.35l.021-.182c.029-.237.029-.245.33-.296.125-.02.23-.05.318-.137l4.367-4.494v-.004l.002.002 1.027-.939.697-.639.029-.023.041-.026c.029-.021.064-.044.102-.068l.051-.043.046-.048.021-.027.017-.028.015-.03.01-.031-.002-.004-.004-.008-.018-.027-.014-.019-.009-.011-.002-.003-.001-.001v-.001l.004-.003.021-.027.141-.174.002-.117c-.004-.035-.006-.068-.008-.1l-.015-.088-.017-.083-.033-.171-.01-.1-.002-.117-.002-.029-.006-.028-.013-.027-.018-.026-.024-.025-.029-.024-.037-.022-.043-.022-.037-.018-.027-.017-.02-.016-.007-.008-.005-.008-.002-.008v-.007l.003-.008.005-.008.007-.007.01-.008.026-.016.221-.131.002-.033.012-.475.001-.477-.001-.009-.003-.008-.011-.018-.016-.017-.021-.018-.051-.033-.058-.029-.035-.018-.028-.018-.02-.016-.006-.008-.005-.008-.003-.008.001-.008.003-.008.004-.008.008-.008.01-.008.029-.015.031-.017.025-.017.019-.017.013-.018.008-.016.001-.009v-.008l-.001-.008-.003-.008-.009-.014-.003-.004h.001c-.006-.133.109-.265.104-.397 0-.027-.057-.052-.148-.072-.245-.056.004-.094.096-.137l-.113-.033c-.146-.044-.152-.045.023-.103.074-.024.129-.046.128-.075l-.089-1.451h-.009l.009-.008.061-3.355.032-1.737c.028.005.056.013.083.015l.072-.158c.096-.208.098-.212.381-.154.119.024.224.033.326-.019a18.828 18.828 0 0 0 4.773-3.495c.384-.392.846-.721 1.192-1.16.073-.087.091-.205.072-.33-.051-.33.238-.305.42-.399l-.011-.178c-.015-.233-.02-.239.262-.339.119-.041.215-.091.277-.193 1.092-1.732 1.76-3.707 2.077-5.678l-.004-.006.005.001.092-.511.078-.513.064-.514.053-.514.031-.35.018-.349.022-.578.005-.036c.002-.015.006-.03.01-.048l.022-.119.007-.066-.002-.067-.005-.032-.008-.033-.012-.03-.015-.03-.004-.002-.01-.002a.345.345 0 0 0-.031-.006l-.023-.004-.012-.002h-.004l-.002-.001v-.005l-.004-.035a14.694 14.694 0 0 1-.023-.223 6.776 6.776 0 0 0-.082-.083l-.076-.065-.072-.053-.07-.046-.07-.046-.076-.054-.084-.071-.094-.09-.023-.022-.027-.018-.03-.013-.033-.008-.036-.004-.041.003-.043.008-.049.014-.039.012-.033.007-.025.002-.011-.002-.009-.003-.008-.004-.006-.006-.004-.008-.003-.009-.001-.012.001-.013.007-.031.053-.258-.023-.028-.363-.378-.373-.374-.006-.006-.01-.005-.02-.006-.025-.003-.028.002-.062.01-.064.018-.039.012-.033.006-.026.002-.011-.002-.01-.003-.008-.005-.006-.006-.004-.008-.002-.01-.001-.011.001-.013.008-.033.01-.034.005-.031.001-.026-.004-.022-.009-.019-.005-.007-.006-.006-.008-.005-.008-.005-.018-.004-.005-.001.001-.001c-.027-.019.033-.123.006-.142a.478.478 0 0 0-.117.093c-.014.013-.014.011-.023.019l-.021-.004.089-.105-.086.074c-.02.018-.017.014-.03.024l-.016-.003.045-.056c.049-.057.084-.099.078-.103-.096-.07-.216-.114-.311-.185l-.004.005-.002-.01-2.332-2.42-.113-.118c.576.019 1.152.096 1.728.091a.54.54 0 0 0 .359-.148c.275-.245.463.004.678.096l.164-.113c.217-.146.224-.152.509.023a.663.663 0 0 0 .369.128l7.199-.089.004-.003v.003l.092.004.092.012.183.037.183.037.092.012.092.004.009-.003.009-.005.008-.009.009-.011.03-.056.016-.028.017-.023.009-.008.009-.006.009-.003.01.001.043.014.037.008a.735.735 0 0 1 .062.01l.027.006.026.012.026.019.029.028.012-.017.021-.021.053-.051.055-.05.02-.021.013-.016.007-.011.006-.007.006-.004.007-.001.005.002.006.005.006.007.005.01.009.024.008.033.008.037.001.011.001.005v.001h.002l.01.002.02.007.017.011.014.014.01.016.005.019.001.021-.005.022-.012.024c.34.317.555.52.893.837l.003.002c.188.181.29.446.479.626.038.037.111.032.206-.004.25-.097.126.132.121.257l.127-.034c.164-.043.17-.045.125.159-.02.085-.027.154.013.193l.907.853-.338.862c1.357 7.237 2.189 14.202 2.299 21.619-.006.235-.08.348-.25.529-.236.272-.299.497-.062.845.508.751.402 1.517-.182 2.211-.05.067-.077.227-.04.272z"
                })
            ]
        }),
        app: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlSpace: "preserve",
            viewBox: "0 0 400 400",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().stroke),
                    d: "M377.939 119.343c-.25-.279-.446-.565-.41-1.062.046-.577-.026-1.141-.032-1.713a.96.96 0 0 1 .061-.358c.085-.249.242-.515.259-.747.023-.391-.368-.386-.454-.659-.1-.355-.242-.724-.32-1.11-.086-.386-.15-.785-.289-1.162-.07-.213-.021-.466.024-.727.088-.532.106-.567-.333-.751-.459-.196-.574-.593-.52-1.14.009-.238-.023-.467-.039-.748-1.418-2.241-3.686-3.924-6.176-4.816-.41.029-.825.152-1.209.179-.395.036-.215-.404-.547-.495-.115-.027-.218-.073-.336-.092-.506-.094-1.199.003-1.432-.288-.324-.349-.889-.478-1.592-.237-.259.078-.523.206-.781.309l-.568-.571c-1.834-.099-3.744-.037-5.621-.062l-12.607-.021-1.979.012-7.021-.012-.304.002c-.278-.057-.611-.146-.726-.171v-.001c-.154-.079-.256.005-.404-.097-.324-.222-.569-.212-.9.035a3.723 3.723 0 0 1-.389.247l-2.938.017c-.13-.102-.255-.214-.4-.247-.233-.052-.396.12-.569.253l-1.32.008c-.332-.001-.663-.023-.997.002-.194.022-.905-.18-1.081-.217v-.001c-.154-.079-.256.005-.404-.097-.324-.222-.569-.212-.9.035a3.56 3.56 0 0 1-.411.259c-.008-.005-.016-.008-.023-.014-.179-.128-.37-.234-.591-.374l-7.566.057c-.222.147-.43.301-.643.435-.066-.035-.133-.067-.2-.117-.179-.128-.37-.234-.591-.374l-7.566.057-.083.059-2.494.018-1.077.007a1.387 1.387 0 0 0-.967.007l-1.587.01a4.816 4.816 0 0 1-.091-.061l-5.278.037-11.925.077-.6.004c-.293-.056-.626-.134-.748-.156v-.001c-.18-.079-.273.006-.451-.095-.389-.219-.658-.208-.961.037a3.282 3.282 0 0 1-.335.231l-3.473.023c-.051-.016-.102-.043-.151-.046a.394.394 0 0 0-.207.048l-1.179.008c-.353 0-.708-.021-1.06.004-.203.023-.984-.174-1.184-.21v-.001c-.18-.079-.273.006-.451-.095-.389-.219-.658-.208-.961.037-.338.265-.67.477-1.168.483-.583.007-1.157.046-1.736.066a.871.871 0 0 1-.352-.062c-.236-.107-.475-.265-.703-.279-.387-.02-.44.394-.725.489a6.66 6.66 0 0 1-1.15.266l-1.179.266c-.22.054-.465-.018-.718-.085-.516-.13-.555-.16-.788.266-.25.444-.655.522-1.192.416-.242-.046-.486-.067-.78-.104a16.781 16.781 0 0 0-6.333 4.859c-.055.38-.074.743-.15 1.088-.062.361-.514.149-.701.441-.061.103-.139.19-.191.296-.242.445-.355 1.095-.756 1.279-.505.27-.722.813-.715 1.474.014.25.079.506.118.756-.253.165-.522.329-.786.522-.61 1.752-.914 3.622-1.305 5.467-.088.432-.178.863-.27 1.294l-2.097 10.753-1.528 7.805c-.066.326-.154.646-.195.979-.017.195-.354.851-.426 1.018h-.001c-.108.136-.046.252-.175.378-.282.275-.321.518-.145.89.189.412.33.812.217 1.271-.127.537-.222 1.08-.336 1.62a.642.642 0 0 1-.139.29c-.149.165-.378.287-.463.477-.143.32.219.582.215.882-.006.773-.205 1.522-.369 2.273-.043.212-.207.368-.371.529-.339.33-.348.349-.12.789.243.469.103.837-.261 1.167-.16.151-.303.317-.482.508-.479 2.459-.961 4.951-1.442 7.43.134.326.298.627.386.943.089.323-.428.363-.484.686-.016.109-.054.217-.061.326-.037.473.03 1.061-.289 1.38-.411.431-.496.958-.316 1.521.064.208.186.405.275.609l-.719.719-.489 2.517-3.788-.005c-.236 0-.52-.158-.757-.158-.236 0-.426.153-.661.15l-3.355-.021-5.365.029c-.331.004-.709.312-1.041.312-.408 0-.771-.305-1.184-.305l-6.01-.007c-.236 0-.52-.158-.757-.158-.236 0-.426.153-.661.15l-3.355-.021-5.365.029c-.331.004-.709.312-1.041.312-.408 0-.771-.305-1.183-.305l-6.011-.007c-.236 0-.52-.158-.757-.158-.236 0-.426.153-.661.15l-3.355-.021-5.365.029c-.331.004-.709.312-1.041.312-.408 0-.771-.305-1.183-.305l-6.011-.007c-.236 0-.52-.158-.757-.158-.236 0-.426.153-.661.15l-3.355-.021-5.365.029c-.331.004-.709.312-1.041.312-.408 0-.771-.305-1.183-.305l-3.001.001c-.48-.011-1.047.019-1.6.046-.374.031-.911.008-1.408.012-.236 0-.52-.158-.756-.158-.237 0-.427.154-.662.151l-3.355-.022-5.365.028c-.331.005-.709.312-1.041.312-.408 0-.771-.305-1.183-.305l-6.011-.008c-.236 0-.52-.158-.756-.158-.237 0-.427.153-.662.15-1.129-.008-2.252-.016-3.355-.022l-5.365.028c-.331.004-.709.312-1.041.312-.408 0-.771-.305-1.183-.305l-6.011-.008c-.236 0-.52-.159-.756-.159-.237 0-.427.154-.662.151l-3.355-.022-5.365.028c-.331.005-.709.312-1.041.312-.404-.002-.779-.301-1.175-.309-.935-.025-1.878-.042-2.794-.164a10.426 10.426 0 0 1-1.279-.188 8.042 8.042 0 0 1-1.18-.272c-.184-.05-.334-.256-.51-.304-.171-.065-.387.02-.561-.051-.848-.302-1.622-.772-2.298-1.321-1.044-.858-1.884-2.187-1.896-3.678-.015-.259-.368-.523-.317-.801.033-.345.409-.645.504-.954.08-.391.232-.76.38-1.131.139-.37.423-.796.628-1.191l1.348-2.415c.105-.19.377-.354.481-.542.104-.188.05-.405.157-.594.545-.95 1.086-1.896 1.619-2.823l2.627-4.672c.16-.29.08-.771.244-1.059.201-.354.646-.52.85-.877l2.99-5.206c.117-.205.396-.372.516-.576.117-.205.078-.445.199-.647l1.695-2.892c.85-1.491 1.74-3.055 2.654-4.656.161-.288.084-.773.25-1.056.205-.343.648-.49.854-.832 1-1.665 1.968-3.334 3.021-5.015.138-.202.432-.354.57-.558.139-.204.123-.455.262-.655l.99-1.444c.332-.477.662-.949.928-1.467.428-.792.863-1.604 1.309-2.43l.333-.623.275-.666.555-1.346c.131-.327-.004-.806.128-1.125.18-.387.561-.666.683-1.092l.434-1.543c.138-.518.315-1.023.369-1.568l.241-1.611c.079-.537.179-1.071.16-1.622.004-.257.166-.563.169-.824s-.148-.468-.144-.724c0-.309.018-.616.002-.924l-.107-.917-.221-1.817c-.248-.91-.48-1.851-.775-2.785-.39-.896-.7-1.855-1.182-2.734-.178-.315-.645-.528-.814-.838-.217-.376-.117-.897-.385-1.254a29.515 29.515 0 0 0-4.087-4.953c-.172-.185-.286-.503-.478-.667-.188-.167-.441-.186-.625-.353-.877-.815-1.822-1.526-2.747-2.229l-2.31-1.589c-.9-.59-1.877-1.097-2.912-1.47-.377-.137-.857.032-1.229-.046-.451-.13-.855-.476-1.346-.535-2.357-.229-4.805.628-6.551 2.258-.201.193-.543.305-.749.507-.204.203-.274.469-.438.698-.397.519-.877 1.098-1.203 1.563l-.961 1.375c-.974 1.43-1.993 2.93-3.038 4.466-.186.277-.152.772-.341 1.046-.232.338-.687.461-.921.803-1.138 1.648-2.29 3.32-3.434 4.979-.135.196-.428.342-.562.539-.137.195-.115.439-.248.635l-1.887 2.783-2.963 4.485c-.18.278-.135.765-.319 1.04-.228.34-.683.475-.912.816l-3.353 5.003c-.131.197-.422.347-.553.544-.133.197-.109.439-.242.634l-1.887 2.783-2.963 4.485c-.181.279-.131.76-.313 1.036-.226.34-.683.479-.911.821l-3.327 5.002c-.131.197-.421.348-.552.545s-.105.438-.238.633c-.631.937-1.258 1.867-1.873 2.783l-2.941 4.484c-.18.278-.13.761-.312 1.036-.227.341-.684.479-.91.82l-3.328 5.003c-.131.197-.42.348-.551.545-.131.196-.107.438-.239.632-.63.938-1.257 1.868-1.873 2.783l-2.94 4.485c-.18.278-.131.761-.314 1.037-.225.34-.682.477-.909.819l-3.327 5.002c-.131.197-.421.348-.552.545-.131.196-.106.438-.239.633l-1.873 2.783-2.94 4.485c-.179.277-.132.762-.314 1.037-.226.34-.682.477-.909.819l-3.328 5.002c-.13.197-.42.347-.551.544-.13.197-.105.439-.238.633l-1.873 2.783c-.941 1.437-1.93 2.942-2.941 4.485-.18.278-.131.763-.314 1.039-.226.34-.682.476-.908.817l-3.328 5.002c-.131.197-.42.347-.551.544s-.107.439-.239.634l-1.872 2.783-2.941 4.485c-.18.278-.133.764-.316 1.04-.225.34-.68.475-.907.816l-3.477 5.227c-.156.235-.495.459-.655.701-.152.245-.155.479-.277.725l-.046 3.9-.002 5.366c.003.331.308.712.306 1.043-.002.408-.309.771-.311 1.182l-.041 6.011c-.002.236-.161.52-.162.756-.002.236.151.427.146.662-.013 1.13-.025 2.252-.039 3.355l.003 5.365c.003.332.309.712.308 1.043-.002.408-.309.771-.311 1.182l-.035 6.011c-.001.236-.16.521-.162.757 0 .236.152.426.148.661l-.035 3.356.008 5.365c.003.332.31.711.309 1.043-.002.408-.309.771-.31 1.182-.009 1.991-.019 4.008-.026 6.011-.002.237-.16.521-.161.757s.152.427.149.662c-.012 1.13-.021 2.252-.031 3.355l.016 5.367c.004.331.311.71.311 1.041-.001.408-.307.771-.307 1.184l-.016 6.011c0 .237-.158.521-.158.758-.001.236.152.426.15.661l-.023 3.356.033 5.368c.004.331.312.709.312 1.041.002.408-.303.773-.302 1.185l.013 6.015c.001.236-.156.521-.154.759.001.237.156.426.154.661l.004 3.483c.057 2.054.012 4.276.218 6.382.032.384.419.555.495.875.09.4-.048.946.066 1.336-.059 1.307 1.486.978 2.543 1.161 1.139.101 2.299.188 3.461.252.273.015.562.183.842.195.279.013.533-.13.805-.118l1.951.054 1.734.027 5.378.016c.332-.001.71-.306 1.042-.304.408.004.775.312 1.188.315l6.023.058c.236.002.523.162.762.164.236.002.424-.15.66-.146l3.363.05 5.357-.072c.33-.008.704-.318 1.035-.32.407-.004.775.298 1.186.295l6.003-.041c.236-.002.521.154.758.152s.424-.157.659-.156l3.351-.005 5.358-.072c.33-.007.707-.318 1.039-.321.407-.003.771.299 1.182.296 1.988-.022 4.002-.035 6.006-.021.236 0 .521.158.758.158.236 0 .426-.153.66-.15l3.355.021 5.365-.029c.332-.004.71-.312 1.041-.312.408 0 .772.305 1.184.305l6.01.007c.236 0 .521.158.758.158.236 0 .426-.153.66-.15l3.355.021 5.365-.029c.332-.004.71-.312 1.041-.312.408 0 .772.305 1.184.305l6.01.007c.236 0 .521.158.758.158.236 0 .426-.153.66-.15l3.355.021 4.822-.026c1.382.302 2.833.498 4.574.532 1.801-.012 4.021.151 5.84.132.123-.056.238-.086.336-.144.203-.123.393-.267.592-.396.199.103.421.17.596.307a1 1 0 0 0 .659.217c4.471-.037 6.866-.135 11.027-.116 1.8-.012 4.021.151 5.84.132.122-.056.237-.086.336-.144.202-.123.393-.267.592-.396.199.103.42.17.595.307.205.153.402.221.66.217 4.471-.037 6.865-.135 11.026-.116.853.007 2.038-.006 3.131-.075l1.653-.204a29.552 29.552 0 0 0 1.541-.375c.117-.088.231-.149.32-.231.177-.183.325-.397.486-.591.236.022.485.004.715.064.266.064.499.056.763-.055 2.279-1.003 3.823-2.164 5.218-3.376 1.401-1.217 2.572-2.625 3.816-4.549 1.054-1.672 2.189-3.903 2.58-5.904-.021-.145-.02-.274-.049-.391-.062-.242-.188-.479-.277-.713.135-.195.237-.422.4-.592.187-.202.286-.41.323-.694.216-2.476-.03-4.382-.389-6.2-.442-1.803-1.032-3.529-2.122-5.555-.945-1.743-2.387-3.775-3.912-5.113-.139-.05-.253-.112-.371-.143a8.046 8.046 0 0 0-.74-.125c-.106-.209-.257-.406-.328-.63-.021-.063-.057-.11-.085-.166l1.009-.014c.9-.068 1.876-.038 2.938-.238.93-.108 1.944-.348 2.971-.581.998-.314 2.015-.625 2.853-1.081.091-.105.185-.185.251-.28.131-.205.246-.406.357-.623.223-.015.449-.072.673-.049.259.022.471-.027.698-.171 1.937-1.297 3.246-2.543 4.357-3.885 1.08-1.36 2.086-2.754 2.967-4.729.755-1.696 1.588-3.89 1.756-5.797-.036-.133-.048-.255-.092-.361-.111-.222-.243-.429-.361-.64.113-.195.191-.417.336-.591.164-.206.242-.41.25-.678-.047-2.332-.4-4.104-.906-5.771-.572-1.643-1.188-3.25-2.375-5.057-1.014-1.559-2.426-3.416-3.91-4.621-.133-.041-.252-.084-.367-.103-.244-.03-.488-.033-.729-.052-.1-.203-.242-.393-.308-.611-.081-.254-.207-.435-.442-.564a17.6 17.6 0 0 0-.767-.473c.069-.06.144-.117.196-.178.159-.182.28-.41.416-.616.23.004.469-.036.696.006.265.043.486.011.733-.114 2.107-1.167 3.51-2.396 4.776-3.662 1.224-1.315 2.295-2.715 3.373-4.662.914-1.689 1.819-3.926 2.127-5.868-.034-.14-.046-.267-.087-.379-.089-.232-.201-.45-.299-.673.137-.193.235-.417.373-.591.165-.205.244-.412.254-.688.103-2.397-.184-4.247-.664-5.976-.454-1.738-1.127-3.381-2.256-5.294-.98-1.644-2.379-3.617-3.912-4.855-.135-.046-.246-.105-.36-.132-.239-.051-.499-.05-.742-.076-.104-.206-.249-.399-.317-.62-.01-.029-.027-.049-.038-.075l3.683-.021c.331-.004.709-.312 1.041-.312.408 0 .771.305 1.183.305l6.011.007c.236 0 .52.158.757.158.236 0 .426-.153.661-.15l3.355.021 5.365-.029c.331-.004.709-.312 1.041-.312.408 0 .771.305 1.183.305l6.011.007c.072 0 .15.017.229.037l-.581 2.996c.133.326.297.627.385.944.09.323-.428.363-.484.685-.016.11-.053.218-.059.327-.039.472.029 1.061-.291 1.38-.41.43-.495.958-.315 1.521.065.209.187.406.275.61l-.72.718c-.332 1.713-.67 3.448-1.008 5.184l-2.283 11.707-1.527 7.806c-.067.325-.155.646-.196.979-.017.195-.354.85-.426 1.017h-.001c-.108.136-.045.252-.174.378-.283.275-.322.517-.146.89.188.412.33.812.217 1.271-.126.537-.222 1.081-.337 1.62a.64.64 0 0 1-.139.291c-.148.164-.377.287-.462.477-.142.319.219.582.216.882-.006.773-.206 1.522-.37 2.272-.044.213-.207.369-.372.53-.338.329-.346.348-.119.788.243.47.102.838-.26 1.168-.161.15-.303.316-.484.506l-1.441 7.43c.133.327.298.628.385.945.09.323-.427.363-.483.685-.015.11-.054.217-.06.327-.039.472.029 1.061-.29 1.379-.411.43-.495.959-.315 1.521.064.209.186.406.275.61l-.72.718-1.008 5.183-1.142 5.854-1.155 6.18-1.546 8.243c-.067.344-.156.694-.198 1.032-.012.193-.369.993-.424 1.19-.098.187-.025.264-.144.451-.259.414-.275.67-.072.922.203.282.408.574.385 1.071-.025.577-.041 1.142.031 1.713a.88.88 0 0 1-.043.356c-.086.247-.254.508-.275.74-.047.393.398.391.498.664.15.351.239.729.34 1.113l.352 1.148c.068.214.008.469-.012.718-.059.516-.05.542.375.738a.818.818 0 0 1 .443.448c.095.185.125.411.112.674-.009.236.007.473.015.758 1.389 2.261 3.494 4.082 5.837 5.327.396.008.784-.036 1.165-.044.382.001.198.45.519.578.111.04.209.1.323.131.502.109 1.175.12 1.399.444.314.405.89.474 1.578.337.255-.046.519-.172.776-.271l.566.572c1.842.077 3.742.029 5.619.047l12.613.013.943-.008 8.057.008.43-.004c.247.055.504.122.604.144v.001c.155.079.256-.006.406.096.326.221.57.211.9-.037.111-.082.225-.155.338-.223l3.021-.025c.119.094.236.19.369.221.219.048.374-.1.533-.229l1.352-.012c.332 0 .665.021.998-.005.194-.023.902.175 1.082.213v.001c.155.079.256-.006.406.096.326.221.57.211.9-.037a3.491 3.491 0 0 1 .437-.272c.181.128.372.233.594.372l7.567-.078c.213-.143.413-.29.617-.422.074.037.147.074.222.128.181.128.372.233.594.372l7.567-.078c.041-.027.079-.057.119-.085.822-.008 1.639-.017 2.463-.024l1.019-.01c.357.147.724.137 1.087-.01l1.484-.014.131.086 5.279-.053 11.928-.111.43-.004c.247.055.505.123.604.144v.001c.165.075.273-.014.434.084.354.211.621.193.963-.064.088-.062.174-.124.262-.184l5.262-.045c.332 0 .664.021.998-.005.195-.023.904.175 1.082.213v.001c.165.075.273-.014.434.084.354.211.621.193.963-.064.379-.269.742-.542 1.24-.56.582-.021 1.157-.122 1.734-.21a.725.725 0 0 1 .339.027c.218.076.431.26.653.252.375-.006.486-.446.777-.569.758-.295 1.545-.517 2.332-.736.223-.06.445-.019.683.03.484.096.514.09.784-.35.291-.458.684-.562 1.188-.5.229.029.463.033.745.049a21.284 21.284 0 0 0 6.469-5.168c.064-.37.08-.724.169-1.053.063-.351.548-.172.747-.467.064-.104.148-.193.203-.298.24-.455.463-1.027.854-1.261.538-.305.812-.836.828-1.452.006-.229-.038-.454-.083-.688l.874-.586.557-1.296c.162-.439.296-.889.444-1.334l.433-1.341.318-1.362.353-1.532.285-1.465.567-2.928 1.133-5.854 1.52-7.807c.066-.325.153-.647.194-.979.016-.195.351-.851.424-1.019h.001c.109-.137.046-.253.175-.379.282-.277.321-.52.144-.89-.189-.411-.332-.809-.219-1.269.126-.537.221-1.081.334-1.621a.65.65 0 0 1 .139-.291c.148-.165.377-.289.463-.479.141-.321-.221-.58-.218-.88.005-.772.204-1.521.366-2.272.044-.213.207-.369.372-.531.338-.332.347-.351.118-.789-.244-.467-.104-.835.259-1.168.161-.151.303-.318.483-.51l1.434-7.43c-.135-.325-.3-.625-.388-.941-.091-.321.427-.365.483-.687.016-.11.053-.218.059-.327.038-.472-.031-1.059.289-1.38.41-.433.494-.961.314-1.521-.066-.208-.188-.404-.277-.607l.719-.722 1.002-5.185 2.269-11.708 1.519-7.808c.066-.325.154-.646.194-.979.017-.196.355-.856.427-1.021h-.001c.107-.135.046-.251.174-.376.282-.276.321-.519.144-.89-.189-.411-.332-.81-.219-1.27.126-.537.221-1.081.334-1.62a.645.645 0 0 1 .139-.291c.148-.165.377-.289.463-.479.141-.32-.221-.581-.217-.88.004-.773.203-1.522.366-2.273.044-.212.206-.369.371-.531.338-.331.347-.35.118-.788-.244-.468-.104-.836.26-1.168.16-.151.302-.318.482-.509l1.434-7.431c-.135-.325-.299-.626-.388-.942-.09-.322.427-.364.483-.686.016-.111.054-.218.06-.327.038-.472-.031-1.06.288-1.38.41-.432.494-.96.314-1.521-.065-.209-.188-.405-.277-.608l.719-.722 1.002-5.184 2.269-11.709 1.519-7.807c.066-.325.154-.646.195-.979.016-.195.352-.852.424-1.018h.001c.108-.137.046-.252.174-.379.282-.275.321-.518.144-.89-.189-.411-.331-.811-.219-1.271.127-.537.221-1.08.335-1.62a.654.654 0 0 1 .138-.291c.149-.165.378-.288.463-.478.141-.32-.22-.582-.217-.881.004-.773.203-1.522.367-2.273.043-.212.206-.368.371-.53.338-.331.346-.349.118-.789-.244-.469-.104-.836.259-1.168.16-.151.302-.317.482-.508l1.434-7.431c-.135-.326-.299-.627-.387-.943-.09-.322.426-.363.482-.686.016-.11.054-.217.06-.326.038-.473-.03-1.061.288-1.381.41-.43.494-.959.314-1.521-.065-.208-.187-.405-.277-.609l.72-.719 1.001-5.184 1.137-5.885 1.164-6.211 1.547-8.25c.052-.342.125-.691.15-1.026.02-.191.307-.992.351-1.194h.001c.093-.189.019-.265.133-.457.235-.411.258-.668.03-.916zM227.005 311.562c-3.084-1.046-5.726-3.169-7.277-5.941a13.734 13.734 0 0 1-1.537-4.484 16.01 16.01 0 0 1 .131-4.821c.031-.207.137-.329.348-.543.297-.314.398-.522.193-.744-.439-.481-.203-1.2.525-1.943.059-.062.111-.207.078-.236-.364-.3-.35-.77-.238-1.289.189-.909.367-1.814.522-2.727.07-.43.323-.787.688-1.108.276-.24.356-.552.19-.812-.215-.321-.383-.656-.285-1.095.225-1.004.379-2.022.602-2.979l.762-.703c.027-.098.061-.202.083-.311.044-.215.071-.439.134-.65.176-.562.045-1.084-.271-1.588l.717-.746 1.571-8.082c.136-.688.151-.689-.252-1.581.15-.155.277-.327.433-.471.286-.249.328-.55.224-.88-.08-.21-.193-.41-.291-.621l.733-.752c1.301-6.941 2.53-13.512 3.835-20.473.045-.221.137-.311.334-.448.276-.21.375-.411.203-.784-.374-.806-.144-1.5.547-2.053.055-.049.109-.196.08-.245-.32-.515-.293-1.044-.175-1.6.202-.973.394-1.946.563-2.93.078-.464.326-.801.684-1.086a.704.704 0 0 0 .204-.881c-.198-.403-.354-.797-.251-1.265.238-1.071.408-2.162.645-3.184.287-.279.527-.515.771-.754.027-.098.061-.201.084-.311.043-.215.07-.439.133-.65.176-.562.045-1.083-.271-1.588l.717-.746 1.571-8.082c.136-.688.151-.689-.252-1.58.15-.156.277-.328.433-.471.286-.249.328-.551.224-.88-.08-.21-.193-.41-.291-.622l.734-.752 1.073-5.73.353.002 4.995-.027c-.334 1.523-.79 3.234-1.067 4.691.033.117.042.227.081.32.086.193.194.376.287.566-.142.184-.251.389-.421.548-.193.188-.299.37-.343.611-.808 4.192-1.16 6.438-1.965 10.337-.328 1.688-.911 3.768-1.235 5.474.033.114.042.223.082.314.086.189.195.368.289.554-.143.188-.252.395-.423.559-.194.192-.3.377-.345.618-.807 4.19-1.159 6.434-1.964 10.333-.327 1.687-.912 3.771-1.236 5.478.033.113.043.22.083.31.087.187.197.359.291.542-.143.19-.252.399-.424.567-.195.198-.302.385-.346.626-.807 4.189-1.158 6.429-1.963 10.329-.328 1.687-.914 3.777-1.238 5.481.034.112.044.218.084.306.088.182.199.351.293.529-.143.193-.253.404-.426.577-.195.202-.303.392-.346.632-.807 4.189-1.158 6.426-1.963 10.326-.328 1.686-.914 3.781-1.238 5.486.034.109.044.214.084.301.089.178.201.342.295.516-.143.197-.254.41-.427.588-.197.207-.304.398-.348.639l-1.942 10.503c-.124.997-.216 2.113-.094 3.227.125 1.104.525 2.2 1.188 2.979.135.066.243.142.36.184.234.095.504.124.767.164l.302.596c.088.222.231.382.481.52.569.233 1.107.457 1.655.556.533.15 1.063.203 1.574.252.536.078.941.05 1.361.045l1.234-.02c1.625-.023 3.21-.041 5.208-.03 1.735-.01 3.813.149 5.573.133.137-.054.259-.083.373-.139l.708-.382c.155.1.345.165.466.297.144.148.31.214.559.21 4.318-.031 6.652-.124 10.65-.102 1.734-.011 3.826.15 5.585.134.132-.055.251-.084.36-.14l.67-.386c.165.101.359.166.494.299.158.15.331.217.58.213 4.314-.031 6.639-.126 10.639-.104 1.733-.01 3.842.152 5.598.135.127-.055.243-.084.347-.141l.632-.389c.176.101.377.168.523.302a.828.828 0 0 0 .602.214c4.311-.031 6.626-.126 10.627-.104 1.732-.01 3.856.153 5.611.136.121-.055.234-.085.332-.142.203-.123.395-.266.594-.393.186.102.394.169.554.305.188.152.374.22.622.216 4.307-.032 6.613-.128 10.616-.105l1.459-.021c.559-.034 1.134-.037 1.712-.121 1.16-.111 2.311-.408 3.255-.863.101-.109.203-.194.274-.292.148-.196.242-.448.356-.667.241-.036.497-.102.726-.129a1.19 1.19 0 0 0 .716-.315c.937-.892 1.519-1.896 1.97-2.849.459-.956.742-1.906.996-2.795.457-1.703.705-3.251 1.12-5.185.333-1.686.917-3.731 1.246-5.438-.031-.125-.04-.238-.077-.342-.082-.212-.187-.418-.275-.629.139-.166.248-.359.415-.498a.93.93 0 0 0 .339-.575c.818-4.19 1.18-6.448 1.994-10.339.332-1.686.917-3.734 1.246-5.44-.031-.124-.039-.237-.077-.339-.083-.21-.188-.412-.276-.621.139-.168.248-.363.415-.504a.955.955 0 0 0 .34-.58c.819-4.189 1.18-6.446 1.994-10.336.332-1.686.917-3.738 1.247-5.444-.032-.123-.041-.235-.078-.335-.084-.208-.189-.407-.279-.613.141-.171.249-.367.418-.511a.967.967 0 0 0 .34-.585c.818-4.188 1.18-6.442 1.994-10.333.332-1.686.918-3.741 1.247-5.446-.032-.122-.04-.233-.079-.333-.083-.205-.189-.401-.279-.604.14-.174.249-.372.418-.518a.996.996 0 0 0 .342-.59c.818-4.188 1.178-6.44 1.992-10.331.332-1.685.92-3.744 1.248-5.449-.031-.121-.041-.231-.078-.329-.085-.203-.191-.396-.282-.596.14-.176.25-.375.419-.524.193-.176.298-.353.343-.594.818-4.188 1.178-6.438 1.992-10.328.333-1.686.92-3.748 1.249-5.453-.033-.119-.041-.229-.08-.326-.084-.199-.191-.39-.283-.587.141-.178.25-.379.42-.53.193-.18.299-.357.344-.599.818-4.187 1.178-6.435 1.992-10.326.332-1.685.92-3.751 1.249-5.455-.032-.118-.042-.228-.08-.323-.085-.197-.193-.385-.285-.579.142-.181.251-.382.422-.537.194-.183.3-.362.345-.603.817-4.187 1.176-6.432 1.991-10.324.332-1.684.921-3.754 1.249-5.457-.032-.117-.041-.227-.08-.321-.086-.194-.195-.379-.287-.57.142-.183.252-.386.424-.544.194-.186.3-.366.345-.607.817-4.185 1.177-6.429 1.991-10.32.332-1.685.921-3.758 1.25-5.461-.033-.116-.043-.225-.082-.317-.086-.192-.195-.374-.288-.562.142-.185.253-.39.425-.55.195-.189.301-.371.346-.612.818-4.185 1.176-6.426 1.99-10.318.332-1.685.922-3.761 1.251-5.464-.033-.114-.042-.223-.082-.314-.087-.189-.196-.367-.29-.554.143-.187.254-.393.426-.557.196-.191.303-.375.348-.616l.549-2.894c.182-1.037.298-1.987.325-2.917.036-.93-.036-1.842-.252-2.777-.22-.928-.591-1.918-1.364-2.787-.68-.737-1.611-1.352-2.63-1.772-.528-.144-1.044-.354-1.584-.429-.54-.066-1.062-.179-1.579-.183-.158.05-.298.076-.428.13a8.78 8.78 0 0 0-.775.391c-.189-.095-.416-.154-.582-.286-.194-.151-.41-.206-.709-.181l-2.141.16c-.528.022-1.058.068-1.496.061a14.083 14.083 0 0 1-2.527-.162c-1.604-.243-3.248-.252-5.18.004-1.005.164-2.146.369-3.195.837-1.051.449-2.021 1.129-2.633 1.972-.032.154-.078.283-.092.413-.014.275-.053.523-.004.81-.158.141-.299.327-.483.432-.23.122-.308.308-.358.591-.129.61-.151 1.199-.283 1.78-.035.188-.069.372-.104.552-.053.108-.093.192-.154.29-.251.371-.672.728-1.188 1.012-1.053.565-2.358.917-4.085.901-1.715.012-3.83-.151-5.563-.132-.117.056-.227.086-.32.144-.193.123-.375.267-.564.396-.189-.103-.4-.17-.566-.307a.925.925 0 0 0-.629-.217c-4.26.037-6.541.135-10.506.116-1.715.012-3.83-.151-5.564-.132-.117.056-.227.086-.319.144-.192.123-.374.267-.563.396-.19-.103-.4-.17-.567-.307a.926.926 0 0 0-.628-.217l-5.364.079c-.739.004-1.413-.007-2.118-.122-.697-.105-1.422-.279-2.086-.605-.586-.264-1.084-.707-1.324-1.139-.137-.213-.188-.427-.229-.634-.008-.107-.031-.223-.02-.255.004-.041-.02-.018-.012-.113l.037-.326-.051-.177-.005-.021-.003-.011v-.001l-.021.129v-.002l-.001-.003-.001-.007-.01-.055-.024-.104c-.088-.277-.203-.528-.305-.775.123-.238.166-.555.293-.809.158-.286.124-.652.018-1.058-.285-.903-.938-1.767-1.606-2.188-.667-.482-1.282-.685-1.837-.856-1.1-.297-1.996-.357-2.869-.419-1.719-.082-3.301-.038-5.274-.05-.857.006-1.815-.032-2.774-.068-.48-.018-.961-.033-1.43-.05a39.447 39.447 0 0 0-1.453-.011c-.123.057-.239.087-.336.145-.199.123-.383.267-.572.396-.209-.102-.438-.169-.63-.304-.233-.148-.414-.229-.724-.201-1.294.046-2.41.292-3.4.633a8.338 8.338 0 0 0-2.538 1.51c-1.436 1.279-2.322 3.012-2.927 5.307l-.703 2.945a59.067 59.067 0 0 0-.615 2.731c.031.126.041.239.078.343.082.213.188.418.276.63-.138.167-.246.36-.413.499a.93.93 0 0 0-.337.576c-.808 4.199-1.163 6.46-1.968 10.356-.328 1.689-.908 3.743-1.232 5.452.031.124.041.237.078.338.083.21.189.41.279.618-.14.17-.248.366-.415.508a.965.965 0 0 0-.339.584c-.808 4.197-1.162 6.455-1.967 10.352-.328 1.688-.908 3.748-1.232 5.457.031.121.041.233.078.333.084.205.191.401.281.604-.14.174-.248.372-.416.519a.993.993 0 0 0-.34.591c-.562 2.918-.906 4.904-1.334 7.15l-4.842.026a.81.81 0 0 0-.23.046l.334-1.716c.137-.688.151-.69-.252-1.581.15-.155.277-.327.433-.471.286-.249.328-.551.224-.879-.08-.211-.193-.41-.291-.622l.734-.753 3.834-20.472c.045-.221.137-.312.334-.448.276-.211.376-.412.203-.785-.374-.805-.144-1.498.547-2.053.055-.049.109-.195.08-.244-.32-.515-.293-1.043-.176-1.6.203-.973.395-1.945.564-2.93.077-.464.326-.801.684-1.087a.703.703 0 0 0 .204-.88c-.198-.402-.354-.797-.251-1.264.238-1.072.408-2.163.645-3.184l.771-.756c.027-.098.061-.201.084-.311.043-.215.07-.439.133-.65.17-.528.027-.995-.289-1.497l.696-.646c.1-.516.199-1.03.304-1.544l.565-2.935c.185-.979.382-1.962.694-2.912.195-.617.224-.594-.023-1.644.172-.083.326-.19.499-.256.321-.102.398-.374.396-.729-.019-.235-.069-.48-.104-.731.274-.1.528-.208.892-.307.836-1.392 1.891-2.637 3.135-3.634 1.228-1.011 2.61-1.831 4.099-2.372.372-.133.736-.299 1.117-.406l1.153-.297c.764-.236 1.563-.284 2.354-.418 1.59-.181 3.214-.191 4.848-.207.209.001.318.072.502.238.272.229.472.287.748.044.6-.526 1.314-.438 1.948.13.056.044.196.068.233.029.387-.416.889-.493 1.469-.487.994.006 1.986.001 2.985-.026.471-.017.849.16 1.196.454a.7.7 0 0 0 .903.026c.358-.274.716-.505 1.194-.496 1.099.021 2.203-.027 3.25.002l.887.607c.102.008.21.02.321.02.22.001.445-.018.665.002.584.062 1.072-.17 1.508-.578l.869.555 8.236-.059c.701-.002.707.012 1.504-.56.182.116.375.208.545.331.3.23.604.213.906.045.191-.119.367-.27.555-.408l.881.57 20.835-.29c.226.001.331.072.505.238.262.229.478.287.81.044.717-.525 1.442-.438 2.121.13.06.044.214.068.257.03.44-.416.965-.494 1.533-.488.994.006 1.986.002 2.984-.026.471-.016.85.161 1.201.455.261.224.615.24.903.026.353-.275.725-.506 1.161-.497 1.026.022 2.063-.027 3.041.002l.734.606c.092.008.188.02.29.021.2 0 .41-.019.606.001.521.062 1.012-.17 1.523-.578l.655.554c2.481-.003 5.029-.067 7.576-.034.648.023.632.038 1.739-.5.096.123.217.215.291.367.122.269.407.289.801.162.259-.093.525-.219.801-.33.123.219.253.395.388.704 1.593.348 3.134.891 4.492 1.752a9.96 9.96 0 0 1 3.192 3.479c.779 1.387 1.164 2.954 1.346 4.531a19.682 19.682 0 0 1-.059 4.829c-.025.208-.116.335-.316.557-.289.324-.389.534-.175.75.465.467.231 1.189-.503 1.951-.059.065-.111.21-.078.238.367.286.354.753.243 1.272-.188.91-.364 1.815-.519 2.727-.07.429-.323.793-.689 1.125-.277.248-.357.561-.189.813.217.312.387.639.29 1.078-.224 1.005-.377 2.021-.599 2.979l-.764.719c-.025.089-.057.184-.077.283-.042.202-.06.389-.124.607-.176.562-.043 1.083.272 1.587l-.716.747-1.561 8.084c-.137.688-.151.69.254 1.58-.15.156-.278.328-.434.473-.285.249-.326.551-.222.879.079.211.193.41.292.621l-.733.754-3.81 20.478c-.045.221-.137.312-.334.449-.275.212-.375.413-.201.785.375.804.145 1.498-.545 2.054-.055.049-.109.196-.08.245.322.513.295 1.042.178 1.598a86.573 86.573 0 0 0-.561 2.931c-.076.465-.324.802-.682 1.089a.701.701 0 0 0-.203.88c.199.402.355.796.252 1.264-.237 1.071-.406 2.163-.641 3.184l-.771.758c-.027.098-.061.201-.082.311-.044.215-.07.439-.133.651-.176.562-.043 1.082.272 1.585l-.716.749-1.562 8.084c-.136.688-.151.69.255 1.578-.15.156-.277.329-.434.473-.285.25-.326.552-.222.88.08.21.193.409.292.62l-.733.756-3.81 20.476c-.045.221-.137.312-.334.45-.275.212-.375.413-.201.785.375.803.146 1.497-.545 2.054-.055.05-.109.196-.08.245.322.513.295 1.041.178 1.597a88.684 88.684 0 0 0-.561 2.932c-.076.463-.324.802-.682 1.089a.703.703 0 0 0-.203.881c.199.401.355.794.252 1.262-.236 1.071-.405 2.163-.641 3.185l-.771.758c-.027.099-.061.202-.082.312-.044.215-.07.439-.133.65-.176.562-.043 1.082.272 1.585l-.716.749c-.514 2.659-1.037 5.373-1.562 8.084-.136.688-.151.69.255 1.577-.15.157-.277.33-.433.474-.286.251-.327.552-.223.88.08.21.193.408.292.619l-.733.757-3.81 20.476c-.045.221-.137.312-.334.45-.275.212-.375.414-.201.785.375.802.146 1.496-.545 2.054-.055.05-.109.197-.08.246.322.511.295 1.039.178 1.596a88.13 88.13 0 0 0-.561 2.931c-.076.464-.324.802-.682 1.09a.703.703 0 0 0-.203.881c.199.401.355.793.252 1.261-.236 1.072-.405 2.163-.64 3.185l-.772.76c-.027.099-.061.202-.082.312-.044.215-.07.439-.133.65-.176.562-.044 1.082.273 1.583l-.717.751c-.248 1.373-.547 2.568-.824 3.823-.381 1.205-.724 2.442-1.266 3.572-.272.578-.225.598-.087 1.487-.187.093-.354.205-.538.28-.336.126-.451.37-.441.696.016.213.073.438.084.648l-.938.334c-3.506 5.272-9.625 7.973-16.236 8.049-.225 0-.331-.071-.506-.236-.262-.229-.479-.286-.809-.041-.714.527-1.439.44-2.121-.125-.059-.044-.214-.067-.256-.029-.439.418-.963.496-1.531.492a87.383 87.383 0 0 0-2.983.035c-.47.018-.85-.158-1.202-.451a.701.701 0 0 0-.902-.023c-.355.275-.71.507-1.188.5-1.097-.02-2.2.033-3.247.007l-.896-.604c-.102-.008-.21-.02-.321-.02-.219 0-.444.02-.664 0-.585-.061-1.069.173-1.5.583l-.875-.552-8.232.082c-.701.004-.707-.011-1.497.563-.183-.116-.378-.206-.549-.329-.302-.23-.605-.211-.906-.043-.19.12-.363.271-.55.41l-.886-.568-20.823.35c-.227 0-.333-.071-.508-.236-.262-.229-.479-.286-.809-.041-.713.527-1.439.44-2.121-.125-.059-.044-.213-.067-.256-.029-.439.418-.963.496-1.531.492a87.324 87.324 0 0 0-2.982.035c-.471.018-.851-.158-1.202-.451a.702.702 0 0 0-.903-.023c-.365.275-.688.507-1.137.5-1.025-.02-2.064.033-3.041.007l-.729-.604c-.092-.008-.188-.02-.29-.02-.2 0-.41.02-.606 0-.521-.061-1.014.173-1.528.583l-.65-.552c-2.481.012-5.029.078-7.577.06-.646-.046-.634-.012-1.74.454-.093-.144-.211-.264-.283-.411-.117-.282-.407-.28-.793-.198-.256.07-.52.175-.791.264-.112-.25-.231-.48-.36-.791zm3.773-105.947c-.195.123-.379.267-.57.396-.193-.103-.406-.17-.574-.307a.945.945 0 0 0-.637-.217c-4.312.037-6.621.135-10.635.116-1.736.012-3.878-.151-5.633-.132-.119.056-.229.086-.324.144-.195.123-.379.267-.57.396-.193-.103-.406-.17-.574-.307a.945.945 0 0 0-.636-.217c-4.312.037-6.622.135-10.636.116-1.736.012-3.878-.151-5.633-.132-.119.056-.229.086-.324.144-.113.071-.222.151-.331.229-.259-.045-.521-.09-.789-.126-.008-.006-.017-.009-.024-.015a.945.945 0 0 0-.636-.217c-.691.006-1.318.014-1.922.021-.081-.002-.153-.01-.235-.012-1.743.012-3.893-.151-5.654-.132-.119.056-.23.086-.326.144-.045.028-.088.062-.133.092l-1.003.005-.013-.008a.95.95 0 0 0-.639-.217c-2.086.018-3.703.05-5.273.076a3.15 3.15 0 0 0-.049-.014l-.275-.073-.119-.025-.052-.007-.044-.003-.092.002-.084.006a9.55 9.55 0 0 0-.152.021l-.139.03-.13.036-.131.035-.052.012c-.745.01-1.515.017-2.334.02l-.85-.011-1.506.003c-1.622-.021-3.482-.142-5.051-.124-.119.056-.23.086-.326.144-.195.123-.379.267-.572.396-.193-.103-.406-.17-.576-.307a.95.95 0 0 0-.639-.217c-4.329.037-6.648.135-10.678.116-1.742.012-3.893-.151-5.654-.132-.119.056-.23.086-.325.144-.196.123-.38.267-.573.396-.193-.103-.406-.17-.576-.307a.95.95 0 0 0-.639-.217l-10.777.169c-1.908.093-4.312.402-6.125 1.183-.104.098-.209.169-.285.258-.16.182-.28.41-.417.616-.229-.004-.469.036-.696-.006a1.116 1.116 0 0 0-.732.115c-2.107 1.167-3.51 2.396-4.776 3.661-1.223 1.315-2.294 2.716-3.373 4.662-.914 1.689-1.82 3.926-2.128 5.868.035.14.047.267.087.379.089.232.201.451.298.673-.136.193-.234.417-.373.591a1.09 1.09 0 0 0-.252.688c-.104 2.397.182 4.247.664 5.976.453 1.738 1.127 3.381 2.255 5.295.98 1.643 2.38 3.615 3.913 4.854.134.046.245.105.359.132.238.051.499.049.742.076.104.206.25.399.318.62.084.255.216.437.44.598a19.174 19.174 0 0 0 2.718 1.491c-.008.01-.02.02-.026.029a7.364 7.364 0 0 0-.356.623c-.224.015-.45.072-.674.049a1.046 1.046 0 0 0-.697.171c-1.938 1.298-3.247 2.543-4.357 3.885-1.08 1.36-2.086 2.755-2.969 4.729-.754 1.696-1.586 3.89-1.756 5.797.037.134.049.255.092.361.111.222.244.429.362.641-.112.194-.191.416-.337.591a1.064 1.064 0 0 0-.249.678c.048 2.331.399 4.103.905 5.771.572 1.643 1.188 3.25 2.375 5.058.412.633.891 1.313 1.412 1.981v.062l.049.001c.751.954 1.587 1.876 2.45 2.576.132.042.251.084.366.103.245.03.489.034.729.052.101.204.242.394.309.612.08.253.207.435.442.564.563.368 1.105.675 1.634.942-1.912.928-3.285 1.973-4.535 3.058-1.4 1.218-2.572 2.625-3.816 4.549-1.054 1.672-2.189 3.903-2.581 5.903.021.145.02.275.049.392.062.241.188.478.276.712-.134.195-.236.422-.4.593-.186.201-.285.41-.323.693-.216 2.477.03 4.383.388 6.2.443 1.804 1.033 3.53 2.123 5.556.945 1.743 2.387 3.775 3.913 5.112.138.051.253.113.37.143.25.055.489.093.74.125.082.159.18.314.256.477-1.035-.039-2.079-.08-3.016-.069-.118.056-.229.086-.324.144-.195.123-.378.267-.57.396-.192-.103-.405-.17-.574-.307a.94.94 0 0 0-.635-.217c-4.312.037-6.623.135-10.637.116-1.736.012-3.877-.151-5.633-.132-.118.056-.229.086-.324.144-.195.123-.378.267-.57.396-.192-.103-.405-.17-.574-.307a.94.94 0 0 0-.635-.217c-4.312.037-6.623.135-10.637.116-1.736.012-3.877-.151-5.633-.132-.118.056-.229.086-.324.144-.194.123-.378.267-.57.396-.191-.103-.405-.17-.574-.307a.923.923 0 0 0-.636-.213c-4.318.071-6.63.188-10.649.201-1.738.026-3.883-.119-5.641-.086-.118.057-.229.088-.322.146-.195.125-.377.27-.567.4-.194-.102-.407-.167-.578-.302a.952.952 0 0 0-.64-.212c-4.317.072-6.629.188-10.646.202-1.732-.001-3.871-.184-5.622-.179-.117.055-.228.084-.321.141-.193.121-.375.264-.564.391-.193-.104-.406-.173-.576-.311a.954.954 0 0 0-.637-.223c-4.301.001-6.605.08-10.609.027a42.268 42.268 0 0 1-1.336-.029l-1.134-.061a36.053 36.053 0 0 0-2.188-.081c-.12.055-.223.085-.328.141l-.688.39c-.1-.104-.234-.172-.281-.309-.059-.154-.158-.223-.355-.22l-1.209.007-.564.004c-.111-.107-.074-.33-.104-.485a57.183 57.183 0 0 1-.108-1.946 102.826 102.826 0 0 1-.094-4.112c.004-.395.006-.812.009-1.241l.04-1.441c.031-.971.062-1.943.049-2.82-.056-.117-.087-.229-.145-.322-.124-.195-.268-.377-.398-.569.103-.192.169-.405.305-.574a.938.938 0 0 0 .215-.636c-.05-4.309-.149-6.618-.131-10.63-.013-1.735.151-3.876.135-5.631-.057-.118-.087-.229-.145-.323-.122-.195-.266-.379-.395-.571.104-.192.171-.405.307-.573a.941.941 0 0 0 .219-.636c-.031-4.312-.124-6.621-.095-10.634-.007-1.735.161-3.876.147-5.631-.055-.119-.086-.229-.143-.324-.122-.195-.265-.38-.393-.572.103-.191.17-.404.308-.572a.945.945 0 0 0 .219-.636c-.022-4.312-.111-6.622-.076-10.635-.005-1.735.167-3.876.155-5.632-.055-.118-.085-.229-.142-.324-.122-.195-.265-.379-.394-.572.104-.191.172-.404.309-.572a.939.939 0 0 0 .221-.635c-.018-4.312-.104-6.622-.064-10.635-.003-1.736.171-3.877.161-5.632-.056-.119-.085-.229-.142-.325-.122-.195-.265-.38-.393-.572.104-.191.172-.404.31-.572a.933.933 0 0 0 .22-.635c-.012-4.312-.098-6.622-.055-10.635l.008-.669.019-.553.058-1.132.016-.283c-.002-.096.004-.189.08-.261l.332-.461c.217-.305.422-.602.607-.889.003-.105.025-.194.019-.288-.026-.184-.021-.45-.029-.671.191-.104.365-.243.572-.309.237-.08.398-.2.532-.41 2.354-3.614 3.551-5.595 5.785-8.929.951-1.454 2.271-3.149 3.227-4.623.019-.129.055-.238.059-.35.006-.23-.013-.462-.014-.693.191-.104.365-.244.572-.31a.944.944 0 0 0 .533-.41c2.354-3.615 3.55-5.595 5.785-8.929.951-1.454 2.271-3.15 3.226-4.623.019-.13.055-.239.06-.35.005-.229-.014-.461-.016-.692.192-.104.367-.244.574-.31a.946.946 0 0 0 .532-.412c2.354-3.614 3.55-5.594 5.786-8.929.95-1.453 2.271-3.149 3.226-4.623.019-.129.054-.238.059-.349.005-.229-.015-.461-.016-.691.192-.104.366-.244.573-.311a.952.952 0 0 0 .534-.412c2.354-3.614 3.55-5.594 5.785-8.929.95-1.453 2.271-3.149 3.226-4.623.02-.129.055-.238.059-.349.006-.229-.014-.46-.016-.689.191-.105.367-.246.574-.312a.95.95 0 0 0 .533-.412c2.355-3.615 3.55-5.594 5.785-8.929.951-1.453 2.271-3.15 3.227-4.624.02-.129.055-.237.059-.348.004-.229-.016-.459-.018-.689.193-.104.367-.245.575-.312a.949.949 0 0 0 .534-.413c2.353-3.619 3.551-5.588 5.793-8.907.953-1.446 2.277-3.135 3.234-4.601.02-.129.055-.238.06-.348.005-.23-.013-.461-.014-.691.192-.104.366-.243.573-.309a.936.936 0 0 0 .534-.408c1.613-2.459 2.688-4.163 3.921-6.053 1.334.654 2.75 1.287 4.358 1.705.36.108.87-.134 1.23-.056.228.043.431.159.64.275.213.103.443.187.689.205 2.387.206 4.937-.454 6.917-1.795.222-.158.581-.222.807-.385.221-.166.319-.407.512-.583a24.594 24.594 0 0 0 2.647-2.567c1.222-1.384 2.343-2.881 3.466-4.402.198-.276.182-.771.383-1.042.243-.338.705-.459.95-.8l3.58-4.973c.141-.195.439-.341.58-.536.142-.196.127-.441.27-.634l1.016-1.396c.206.209.416.42.604.619.117.04.212.092.315.116l.667.113c.05.2.12.405.121.614.003.243.062.42.214.594 1.312 1.505 2.09 2.805 2.804 4.091.348.647.581 1.333.896 2.036.257.721.424 1.515.667 2.386.085.778.201 1.647.22 2.521-.07.881-.056 1.755-.129 2.546.039.112.055.216.098.308l.314.569c-.128.164-.223.351-.381.482a.797.797 0 0 0-.297.539c-.036.491-.191.939-.303 1.372l-.328 1.238c-.164.804-.504 1.505-.771 2.215-.305.698-.501 1.426-.907 2.129l-1.253 2.298c-.1.182-.201.368-.307.558-.127.18-.258.361-.391.547l-.82 1.121c-.555.773-1.109 1.457-1.568 2.257-.018.138-.053.254-.057.37-.004.244.017.489.021.732-.185.109-.353.258-.554.328a.937.937 0 0 0-.517.439c-2.295 3.856-3.323 5.883-5.353 9.355-.858 1.511-2.07 3.286-2.934 4.817-.011.131-.039.242-.037.353.009.23.041.461.057.691-.185.116-.35.267-.553.345a.949.949 0 0 0-.502.445c-2.105 3.77-3.164 5.826-5.169 9.308-.432.782-.924 1.528-1.466 2.464a72.527 72.527 0 0 0-1.52 2.666c-.01.133-.038.249-.033.358.014.228.055.447.079.667-.194.147-.368.326-.585.445a1.28 1.28 0 0 0-.536.543c-.262.536-.562.957-.748 1.509-.183.55-.382 1.063-.46 1.586l-.153.759-.054.748c-.062.49-.003.971.025 1.447.161 1.903 1.051 3.705 2.775 5.314 1.492 1.41 3.854 2.537 5.945 3.004.154-.025.293-.029.418-.063.259-.075.502-.175.745-.261.196.14.428.25.604.419.201.187.389.266.659.292 1.164.137 2.179.142 3.121.153.893-.012 1.716-.022 2.53-.034 1.618-.026 3.199-.046 5.206-.035 1.736-.012 3.877.15 5.633.132.118-.056.229-.086.324-.144.195-.123.379-.266.57-.395.192.102.405.17.574.306a.936.936 0 0 0 .636.217c4.312-.036 6.622-.134 10.636-.114 1.736-.011 3.877.152 5.633.133.118-.056.229-.086.324-.144.195-.123.379-.267.57-.396.192.104.405.17.574.307a.936.936 0 0 0 .636.217c4.312-.036 6.622-.134 10.636-.114 1.736-.011 3.877.151 5.633.133.109-.058.251-.083.366-.147.259-.135.423-.287.583-.425.181.094.376.151.529.278a.911.911 0 0 0 .625.212c4.312-.037 6.621-.135 10.635-.116 1.736-.012 3.878.151 5.633.132.119-.056.229-.086.324-.144.195-.123.379-.267.57-.396.193.103.406.17.574.307a.945.945 0 0 0 .637.217c4.312-.037 6.621-.135 10.635-.116 1.736-.012 3.878.151 5.633.132.119-.056.229-.086.324-.144.195-.123.379-.267.57-.396.193.103.406.17.574.307a.945.945 0 0 0 .636.217c4.312-.037 6.622-.135 10.636-.116 1.736-.012 3.878.151 5.633.132.119-.056.229-.086.324-.144.195-.123.379-.267.57-.396.193.103.406.17.574.307a.945.945 0 0 0 .636.217c4.312-.037 6.622-.135 10.636-.116 1.736-.012 3.878.151 5.633.132.119-.056.229-.086.324-.144.195-.123.379-.267.57-.396.193.103.406.17.574.307a.945.945 0 0 0 .636.217c4.312-.037 6.622-.135 10.636-.116 1.736-.012 3.878.151 5.633.132.119-.056.229-.086.324-.144.195-.123.379-.267.57-.396.193.103.406.17.574.307a.943.943 0 0 0 .636.217l2.917-.036c.456-.014.792.021 1.178.025.371.018.738.001 1.095.068 1.44.143 2.828.496 4.483 1.19 1.451.591 2.969 1.802 4.135 2.822.115.029.209.073.311.088l.658.062c.065.185.135.389.143.592.008.239.07.409.223.569 1.263 1.438 2.098 2.683 2.697 3.998.595 1.31 1.104 2.657 1.311 4.447.209 1.544.081 3.48-.232 5.003.039.114.055.219.098.313.1.197.182.385.268.586-.145.147-.258.319-.428.432-.192.134-.299.276-.348.492-1.217 3.616-2.433 5.468-5.127 7.833-1.201 1.007-2.955 1.824-4.395 2.397-.078.088-.16.15-.221.233l-.354.552c-.197-.034-.399-.031-.588-.132-.217-.104-.397-.128-.609-.068-.917.284-1.769.368-2.546.49-.793.048-1.488.122-2.336.118-1.617.026-3.199.046-5.205.037-1.736.012-3.878-.151-5.633-.132-.119.056-.229.086-.324.144-.195.123-.379.267-.57.396-.193-.103-.406-.17-.574-.307a.945.945 0 0 0-.637-.217c-4.312.037-6.621.135-10.635.116-1.736.012-3.878-.151-5.633-.132-.123.061-.233.092-.328.149zm-26.937 11.409c.816 1.309 1.486 2.808 1.861 4.428.075.285.48.551.51.857.057.373-.195.745-.139 1.108a16.807 16.807 0 0 1-.281 5.385c-.055.207-.271.415-.323.619-.052.203.054.41-.001.615-.176.477-.352.951-.525 1.423-.204.46-.439.902-.652 1.35a17.253 17.253 0 0 1-2.836 3.889c-.217.201-.262.656-.488.863-.275.26-.719.244-1.021.453-1.408 1.108-3.029 1.996-4.75 2.539-.197.082-.487.005-.693.049-.203.051-.328.242-.534.292-.489.146-.99.218-1.49.283l-.745.109-.748.028a15.38 15.38 0 0 1-.793.043 28.171 28.171 0 0 0-2.897-.226c-1.69.012-3.776-.151-5.487-.132-.115.056-.223.086-.314.144-.121.079-.238.166-.355.252h-.494a1.336 1.336 0 0 1-.266-.163.903.903 0 0 0-.619-.217c-4.201.037-6.451.135-10.36.116-1.691.012-3.776-.151-5.487-.132-.115.056-.223.086-.314.144-.123.079-.238.167-.355.253h-.494a1.34 1.34 0 0 1-.266-.164.903.903 0 0 0-.619-.217c-4.201.037-6.451.135-10.36.116-1.691.012-3.776-.151-5.487-.132-.115.056-.223.086-.314.144-.123.079-.239.167-.357.253h-.49a1.355 1.355 0 0 1-.268-.164.905.905 0 0 0-.619-.217l-5.289.079-2.395.032c-.688.053-1.418.049-2.198.132a16.786 16.786 0 0 1-3.093-.585c-.28-.094-.701.074-.99-.029-.354-.13-.553-.513-.878-.688a14.943 14.943 0 0 1-3.229-1.951c.131.001.271.006.398.005.11-.056.214-.087.302-.144.182-.123.352-.267.53-.396.181.103.381.17.539.307a.858.858 0 0 0 .598.217c4.035-.036 6.193-.134 9.947-.113l1.395-.001c.533.009 1.076-.049 1.627-.082 1.091-.119 2.176-.362 3.082-.753.096-.101.189-.185.254-.278.131-.201.232-.408.344-.607.233-.023.469-.091.708-.082a.952.952 0 0 0 .707-.247c1.888-1.547 2.579-3.419 2.946-5.164.1-.442.133-.895.198-1.346.022-.454.046-.913.071-1.386l.027-2.714c.004-.856.053-1.813.102-2.778.048-1.043-.011-2.199-.232-3.15-.082-.111-.141-.222-.218-.304-.159-.169-.356-.304-.538-.447.026-.236.029-.491.072-.722.051-.271.022-.5-.096-.752-1.118-2.171-2.799-3.256-4.442-3.945a13.804 13.804 0 0 0-2.644-.746 20.04 20.04 0 0 0-2.979-.299l-2.686-.095a52.72 52.72 0 0 0-2.633-.065c-.111.056-.214.087-.303.144-.182.123-.354.267-.532.396-.179-.103-.378-.17-.534-.307a.837.837 0 0 0-.594-.217c-1.805.015-3.229.043-4.594.066 1.209-.833 2.536-1.513 3.938-1.954.197-.083.487-.006.693-.049.203-.052.328-.243.534-.293.489-.145.99-.218 1.489-.283l.745-.109.748-.028c.734-.064 1.642-.062 2.542-.066l2.74-.011c.333-.004.713-.312 1.045-.312.41 0 .775.305 1.188.305l6.033.007c.237 0 .522.158.761.158.237 0 .428-.153.663-.15l3.368.021 5.387-.029c.332-.004.713-.312 1.045-.312.41 0 .775.305 1.188.305l6.034.007c.237 0 .522.158.761.158.236 0 .427-.153.663-.15l3.368.021 5.387-.029c.332-.004.713-.312 1.045-.312.41 0 .775.305 1.188.305l6.033.007c.238 0 .523.158.761.158s.428-.153.663-.15l3.369.021c1.548.022 3.167.218 4.764.688.279.094.701-.074.989.029.354.13.554.514.878.688a15.032 15.032 0 0 1 4.461 3.021c.162.141.238.426.371.588.142.156.368.178.51.337.355.366.656.773.949 1.184.311.395.574.821.819 1.253zm-.568 40.26c.108.352-.165.731-.107 1.083.173.854.181 1.735.224 2.612-.046.878-.071 1.759-.245 2.619-.034.204-.216.422-.261.62-.051.197.057.391.003.589-.226.96-.574 1.882-.974 2.754-.568 1.391-1.47 2.705-2.502 3.938-.19.215-.189.671-.389.893-.244.273-.715.249-.972.495-1.292 1.163-2.784 2.147-4.397 2.83-.186.092-.484.014-.674.088-.191.069-.293.271-.487.34-.456.191-.946.269-1.416.398-.469.141-.952.195-1.429.262-.736.16-1.51.147-2.291.209l-2.652.015c-.322.004-.691.312-1.014.312-.397 0-.752-.305-1.152-.305l-5.021-.006a23.723 23.723 0 0 0-3.128-.262c-1.8.012-4.021-.151-5.841-.132-.122.056-.236.086-.335.144-.124.076-.243.16-.364.243l-.551.003a1.398 1.398 0 0 1-.271-.157 1.004 1.004 0 0 0-.66-.217c-4.471.037-6.865.135-11.027.116-1.799.012-4.02-.151-5.84-.132-.123.056-.237.086-.336.144-.145.088-.284.188-.425.284a1.575 1.575 0 0 0-.233.081c-.182-.086-.373-.154-.528-.276a1.001 1.001 0 0 0-.659-.217c-4.471.037-6.865.135-11.027.116a50.837 50.837 0 0 0-2.485.043 14.515 14.515 0 0 1-2.188-.465c-.28-.062-.682.09-.965-.005-.34-.135-.54-.498-.859-.659-1.17-.491-2.27-1.166-3.281-1.949.026-.012.058-.022.081-.038.182-.123.352-.267.53-.396.181.104.381.17.539.307a.85.85 0 0 0 .598.217c4.035-.035 6.193-.133 9.948-.112l1.394-.001c.533.008 1.076-.049 1.627-.082 1.091-.119 2.176-.363 3.082-.753.096-.101.189-.186.254-.279.131-.201.232-.408.344-.607.233-.023.469-.091.708-.081a.955.955 0 0 0 .707-.248c1.888-1.547 2.579-3.419 2.946-5.164.1-.441.133-.895.198-1.346.022-.454.047-.913.071-1.386l.027-2.714c.004-.856.053-1.813.102-2.777.048-1.043-.011-2.2-.232-3.151-.082-.111-.141-.222-.218-.304-.159-.169-.356-.304-.538-.447.026-.236.029-.49.072-.722.051-.271.022-.5-.096-.752-1.118-2.171-2.799-3.255-4.442-3.945a13.732 13.732 0 0 0-2.644-.746 20.173 20.173 0 0 0-2.979-.3c-.83-.028-1.756-.062-2.686-.094a51.506 51.506 0 0 0-2.633-.064c-.11.055-.214.086-.303.143-.182.123-.354.267-.532.396-.179-.103-.378-.171-.534-.307a.842.842 0 0 0-.594-.218c-1.702.015-3.066.04-4.361.062a15.375 15.375 0 0 1 2.933-1.668c.187-.092.484-.014.674-.088.191-.07.294-.271.487-.34.457-.191.946-.27 1.416-.398.469-.142.953-.196 1.43-.263.734-.16 1.509-.147 2.289-.209l2.652-.015c.323-.004.691-.312 1.015-.312.397 0 .752.305 1.152.305l5.854.007c.23 0 .506.158.736.158s.416-.153.645-.15l3.269.021 5.226-.029c.323-.004.691-.312 1.015-.312.397 0 .752.305 1.152.305l5.854.007c.23 0 .506.158.736.158s.416-.153.645-.15l3.269.021 5.226-.029c.323-.004.691-.312 1.015-.312.397 0 .752.305 1.152.305l5.854.007c.23 0 .507.158.737.158s.415-.153.644-.15l3.269.021c1.499.032 3.077.188 4.624.654.281.061.683-.09.965.004.34.136.541.498.859.659 1.605.675 3.083 1.688 4.373 2.865.154.14.229.421.381.557.148.139.359.163.499.315a15.741 15.741 0 0 1 1.79 2.314c.852 1.237 1.48 2.697 1.959 4.232.071.278.452.524.527.812zm-14.857 31.474a16.937 16.937 0 0 1 1.749 4.645c.048.302.404.603.453.915.07.385-.193.755-.189 1.136a15.12 15.12 0 0 1-.577 5.534c-.049.216-.271.422-.355.623-.075.203.01.419-.068.623-.162.501-.399.969-.632 1.434-.208.478-.486.914-.76 1.347-.837 1.352-1.881 2.695-3.207 3.792-.213.223-.323.653-.572.849-.319.224-.746.212-1.078.397a15.105 15.105 0 0 1-5.116 2.174c-.214.057-.499-.025-.716-.005-.215.032-.363.21-.58.24l-.778.11-.783.033-.778.035-.856-.004-5.562.029c-.343.004-.735.312-1.079.312-.424 0-.801-.305-1.227-.305l-6.231-.007c-.245 0-.54-.158-.785-.158s-.441.153-.686.15l-3.479-.021-5.563.029c-.343.004-.735.312-1.078.312-.424 0-.801-.305-1.228-.305l-6.231-.007c-.244 0-.539-.158-.785-.158-.244 0-.441.153-.685.15l-3.479-.021c-1.599-.019-3.271-.236-4.912-.741-.288-.103-.725.065-1.021-.042-.373-.12-.56-.55-.899-.72a15.814 15.814 0 0 1-2.867-1.741c.172.002.353.008.519.006.11-.056.214-.086.302-.144.182-.123.352-.267.53-.396.181.104.381.17.539.307a.85.85 0 0 0 .598.217c4.035-.035 6.193-.133 9.948-.112l1.394-.001c.533.008 1.076-.049 1.627-.082 1.091-.119 2.176-.363 3.082-.753.096-.101.189-.186.254-.279.131-.201.232-.408.344-.607.233-.023.469-.091.708-.081a.961.961 0 0 0 .707-.248c1.888-1.547 2.579-3.419 2.946-5.164.1-.441.133-.895.198-1.346.022-.454.046-.913.071-1.386l.027-2.714c.004-.857.053-1.814.102-2.777.048-1.043-.01-2.2-.232-3.151-.082-.111-.141-.222-.218-.304-.159-.169-.356-.304-.538-.447.026-.236.029-.49.072-.722.051-.271.022-.5-.096-.752-1.118-2.171-2.799-3.255-4.442-3.945a13.732 13.732 0 0 0-2.644-.746 20.173 20.173 0 0 0-2.979-.3c-.83-.028-1.756-.062-2.686-.094a51.506 51.506 0 0 0-2.633-.064c-.11.055-.214.086-.303.143-.182.123-.354.267-.532.396-.179-.103-.378-.171-.534-.307a.842.842 0 0 0-.594-.218c-2.218.019-3.868.057-5.529.083.29-.13.628-.155.903-.309a15.124 15.124 0 0 1 5.115-2.176c.214-.056.499.025.716.005.215-.031.362-.209.58-.24l.777-.11.783-.032.777-.037.857.005 5.562-.029c.344-.004.736-.312 1.08-.312.423 0 .8.305 1.227.305l6.23.007c.246 0 .54.158.785.158.246 0 .441-.153.686-.15l3.479.021 5.562-.029c.344-.004.736-.312 1.08-.312.424 0 .801.305 1.227.305l6.231.007c.245 0 .54.158.784.158.246 0 .442-.153.686-.15l3.479.021c1.599.019 3.271.237 4.913.741.287.102.723-.065 1.021.043.371.119.559.549.898.719a16.042 16.042 0 0 1 4.557 3.193c.148.164.209.469.355.63s.38.188.525.353c.344.397.629.84.947 1.25.299.424.54.884.81 1.319zm-42.537-66.494-.05 2.899-.008 2.313c-.01.713-.039 1.359-.184 2.042-.042.239.192.646.103.894-.087.311-.484.403-.608.678-.625 1.362-1.938 2.331-3.374 2.72-.173.042-.438-.061-.604-.021-.164.046-.254.204-.428.233-.414.073-.834.093-1.248.117l-.621.01-.758-.006c-1.598.01-3.271.019-4.986.028-.309.004-.654.312-.962.312-.38 0-.724-.305-1.105-.305l-5.587-.01c-.22 0-.484-.158-.705-.158-.219 0-.395.153-.613.15l-1.789-.013c-.12-.188-.234-.379-.344-.572-.816-1.308-1.488-2.808-1.862-4.427-.075-.286-.479-.551-.51-.857-.056-.374.195-.746.138-1.109a16.807 16.807 0 0 1 .282-5.385c.054-.207.271-.415.323-.618.053-.204-.054-.411.001-.616l.526-1.423c.204-.46.439-.902.652-1.35a17.57 17.57 0 0 1 1.263-2.017l3.571-.018c.309-.004.662-.312.971-.312.381 0 .721.306 1.104.306l5.604.012c.221 0 .485.158.706.158s.397-.153.616-.15l1.574.011c.527.002 1.05.006 1.487.035.751.003 1.379.064 2.037.157.655.115 1.32.268 1.953.535.221.098.672-.078.89.069.279.161.312.553.541.751 1.201.902 1.829 2.406 1.953 3.882.027.176-.128.419-.113.589.013.172.164.289.164.466zm0 35.827-.05 2.899-.008 2.313c-.01.713-.039 1.359-.184 2.043-.042.238.192.646.103.893-.087.311-.484.404-.608.678-.625 1.362-1.938 2.331-3.374 2.72-.173.042-.438-.06-.604-.02-.164.046-.254.204-.428.233-.414.073-.834.093-1.248.117l-.621.01-.758-.006c-1.598.009-3.271.019-4.986.027-.309.005-.654.312-.962.312-.38-.001-.724-.306-1.105-.306l-5.587-.01c-.22 0-.484-.158-.705-.158-.219 0-.395.153-.613.15l-1.146-.009c-.078-.116-.168-.229-.243-.347-.853-1.238-1.481-2.698-1.958-4.232-.075-.276-.456-.523-.531-.812-.107-.351.165-.73.107-1.083-.172-.854-.182-1.735-.225-2.612.047-.878.072-1.759.246-2.618.035-.205.215-.422.26-.62.053-.197-.057-.391-.002-.59.225-.96.574-1.881.975-2.753.385-.94.928-1.843 1.555-2.712l3.215-.017c.309-.005.662-.312.971-.312.381 0 .721.305 1.104.306l5.604.011c.221.001.485.159.706.159s.397-.153.616-.15l1.574.011c.527.002 1.05.006 1.487.035a14.22 14.22 0 0 1 2.037.157c.655.115 1.32.267 1.953.535.221.098.672-.077.89.069.279.161.312.553.541.751 1.201.902 1.829 2.406 1.953 3.882.027.176-.128.419-.113.589.011.173.162.291.162.467zm-25.87 34.067c.049-.216.271-.422.355-.622.075-.203-.01-.419.068-.624.162-.501.4-.968.632-1.433.208-.478.487-.914.761-1.347.201-.325.416-.649.643-.97l3.924-.021c.309-.005.662-.312.971-.312.381 0 .721.305 1.104.306l5.604.011c.221.001.485.159.706.159s.397-.153.616-.15l1.574.011c.527.002 1.05.006 1.487.035a14.22 14.22 0 0 1 2.037.157c.655.115 1.32.267 1.953.535.221.098.672-.077.89.069.279.161.312.553.541.751 1.201.902 1.829 2.406 1.953 3.882.027.176-.128.419-.113.589.014.17.165.288.165.464l-.05 2.899-.008 2.313c-.01.713-.039 1.359-.184 2.043-.042.238.192.646.103.893-.087.311-.485.404-.608.678-.625 1.362-1.938 2.331-3.374 2.72-.173.042-.438-.06-.604-.02-.164.046-.254.204-.428.233-.414.073-.834.093-1.248.117l-.621.01-.758-.006c-1.598.009-3.271.019-4.986.027-.309.005-.654.312-.962.312-.38-.001-.724-.306-1.105-.306l-5.587-.01c-.22 0-.484-.158-.705-.158-.219 0-.395.153-.613.15l-1.998-.015c-.246-.375-.464-.768-.698-1.145a16.917 16.917 0 0 1-1.749-4.645c-.048-.302-.404-.602-.453-.915-.07-.384.193-.755.189-1.136a15.021 15.021 0 0 1 .576-5.529zm-13.864-201.2c.294-.415.533-.698.772-.986.234-.301.486-.583.768-.826.262-.261.522-.508.808-.702.045-.105.1-.187.132-.285.065-.204.11-.443.203-.633.188.025.372.011.545.084.202.083.349.067.537.016 1.602-.595 2.98-.328 4.159.105a9.53 9.53 0 0 1 1.729.882l.425.288.557.393 1.115.78c.17.124.348.271.521.407-.896 1.186-1.922 2.451-2.722 3.589-.024.129-.063.237-.073.348-.014.23-.004.464-.013.695-.196.099-.377.233-.587.293a.952.952 0 0 0-.551.396c-2.516 3.521-3.752 5.592-6.292 8.494-1.089 1.26-2.652 2.492-3.882 3.154-.058.096-.122.168-.164.258-.08.201-.166.375-.269.555-.192-.035-.382-.033-.554-.109a.926.926 0 0 0-.551-.057c-1.654.438-3.008.256-4.408-.074-1-.243-1.992-.643-3.098-1.171.933-1.379 2.13-2.939 3.045-4.281.021-.128.059-.237.064-.347.009-.23-.006-.463-.004-.693.193-.1.369-.235.575-.295a.92.92 0 0 0 .535-.396c2.397-3.549 3.618-5.498 5.893-8.773.244-.359.508-.731.785-1.109zm175.031 24.503c.242.01.487.018.726.033.287.027.671-.262.947-.21.365.044.582.411.879.479l.457.156c.094.066.264.106.297.167.177.098.137.154.209.254.021.133.078.354.017.695l-.09.715c-.036.17-.052.658-.034 1.075.033.375-.062.808.047 1.165.111.351.34.57.5.873.734 1.538 2.039 2.463 3.244 3.076.621.285 1.264.498 1.911.662 1.358.344 2.749.455 4.065.439.328-.004.701-.312 1.029-.312.402 0 .762.305 1.168.305l.62.001 5.317.006c.233 0 .514.158.748.158.232 0 .42-.153.652-.15l3.314.021 5.301-.029c.326-.004.701-.312 1.027-.312.403 0 .763.305 1.169.305l5.937.007c.234 0 .515.158.748.158.234 0 .421-.153.653-.15l3.314.021c1.902-.015 3.999-.327 6.009-1.418.363-.213.597-.718.914-.986.396-.311.967-.439 1.327-.92.227-.268.396-.608.576-.924l.186-.468.091-.233.033-.146c.115-.381.07-.785.127-1.176.059-.779.383-1.568.99-2.087.135-.13.441-.118.582-.229.139-.119.18-.298.342-.391.797-.399 1.673-.596 2.532-.693 1.133-.139 2.291-.156 3.425.031l1.074.15c.366.023.801-.253 1.154-.229.436.023.814.319 1.26.327.268.002.51-.017.767-.023l.706-.032 1.184-.081c.788-.049 1.58-.13 2.365-.062.188.011.326.185.507.194.179.03.415-.095.597-.058.859.171 1.717.533 2.282 1.204.926 1.027 1.067 2.562.903 3.982-.031.252.262.484.209.757-.058.336-.436.657-.5.97l-1.178 5.717c-.046.229-.264.502-.311.73-.047.229.073.413.023.639l-.684 3.24c-.33 1.66-.676 3.399-1.029 5.182-.061.32.178.69.111 1.011-.08.395-.462.741-.543 1.138l-1.193 5.804c-.047.229-.264.499-.311.728s.072.415.023.642l-.686 3.24-1.028 5.183c-.062.319.176.696.11 1.017-.08.395-.461.734-.542 1.131l-1.193 5.804c-.047.229-.263.496-.31.724-.047.229.072.419.022.646l-.685 3.239-1.029 5.183c-.061.32.175.704.109 1.023-.08.395-.459.729-.541 1.125l-1.193 5.804c-.047.229-.262.492-.309.721s.07.422.021.648l-.684 3.239c-.33 1.66-.676 3.4-1.029 5.184-.062.319.173.709.107 1.029-.08.395-.459.722-.539 1.119a4841.51 4841.51 0 0 0-1.193 5.803c-.047.229-.262.489-.309.718-.047.228.07.425.021.651l-.686 3.238-1.029 5.184c-.061.32.172.717.107 1.037-.081.395-.457.715-.539 1.112l-1.193 5.803c-.046.229-.26.485-.307.714s.069.429.02.655l-.684 3.237c-.33 1.661-.676 3.401-1.029 5.186-.061.32.17.723.105 1.043-.081.395-.456.709-.537 1.105l-1.193 5.803c-.047.229-.26.482-.307.711s.068.432.02.658l-.684 3.237-1.03 5.185c-.062.321.169.73.104 1.051-.081.394-.455.702-.536 1.099l-1.193 5.803c-.047.229-.259.479-.306.708s.068.434.019.661l-.685 3.236-1.029 5.187c-.061.32.168.736.103 1.056-.081.395-.453.696-.534 1.093l-.139.672c-.35 1.704-.702 3.422-1.055 5.131-.047.229-.258.476-.305.704s.066.438.018.665l-.684 3.236c-.33 1.661-.676 3.402-1.029 5.187-.062.32.166.742.101 1.062-.058.282-.263.515-.405.771a1.08 1.08 0 0 0-.127.316 4841.51 4841.51 0 0 0-1.193 5.803c-.047.229-.259.472-.305.7-.047.229.066.44.018.667l-.684 3.236c-.336 1.66-.639 3.451-1.09 4.996-.078.253.133.676.031.929-.072.193-.232.323-.381.458-.098.088-.19.178-.246.29-.318.714-.725 1.411-1.304 1.956-.571.551-1.287.937-2.04 1.168-.176.066-.449-.025-.627.008-.177.037-.273.227-.457.254-.875.146-1.738.169-2.806.178l-2.491.014-2.755.016c-.323.004-.704.312-1.028.312-.4 0-.745-.305-1.146-.305l-5.877-.007c-.23 0-.496-.158-.728-.158s-.429.153-.658.15l-3.278-.021-5.25.029c-.324.004-.734.312-1.06.312-.399 0-.714-.305-1.116-.305l-5.875-.007c-.231 0-.48-.158-.712-.158s-.444.153-.673.15l-3.277-.021-5.252.029c-.324.004-.766.312-1.091.312-.4 0-.684-.305-1.085-.305l-5.875-.007c-.232 0-.466-.158-.697-.158-.23 0-.459.153-.688.15l-3.274-.021-5.255.029c-.325.004-.798.312-1.123.312-.399 0-.652-.305-1.055-.305l-5.873-.007c-.232 0-.45-.158-.682-.158-.23 0-.475.153-.703.15l-3.271-.021-5.258.029c-.326.004-.829.312-1.154.312-.382-.003-.669-.295-.958-.317a7.175 7.175 0 0 1-2.32-.4c-.731-.293-1.392-.82-1.731-1.541-.064-.177-.002-.484-.043-.66-.039-.177-.256-.222-.275-.408-.123-.887-.025-1.779.143-2.631l.971-4.981c.06-.319-.188-.651-.123-.972.08-.394.468-.777.548-1.174l1.177-5.802c.046-.229.266-.518.312-.745.046-.229-.077-.396-.028-.624l.676-3.24c.324-1.658.664-3.396 1.014-5.176.059-.319-.186-.661-.121-.981.079-.394.465-.768.545-1.164.391-1.922.785-3.869 1.177-5.802.046-.228.265-.512.312-.74.045-.229-.076-.401-.027-.629l.675-3.239 1.013-5.177c.061-.319-.183-.671-.118-.991.079-.395.464-.758.544-1.155l1.176-5.8c.047-.229.264-.508.311-.736.045-.229-.075-.406-.027-.633.229-1.091.454-2.174.676-3.239l1.014-5.178c.061-.319-.182-.681-.117-1.001.08-.395.463-.748.542-1.146l1.177-5.8c.046-.229.263-.503.309-.73.046-.229-.074-.412-.025-.639l.675-3.238 1.014-5.179c.06-.319-.179-.69-.114-1.011.08-.395.459-.739.539-1.136.391-1.921.785-3.868 1.177-5.8.046-.229.262-.497.308-.726s-.072-.417-.023-.644l.547-2.625 4.791.006c.236 0 .52.158.756.158.237 0 .427-.153.662-.15l3.355.021 5.365-.029c.334-.007.696-.303 1.068-.329.439-.021.852.264 1.307.239a20.668 20.668 0 0 0 6.389-1.63c.234-.112.585-.104.822-.22.238-.115.356-.342.589-.455l1.597-.958 1.482-1.089a21.972 21.972 0 0 0 3.944-4.382c.188-.315.144-.833.329-1.138.237-.371.697-.573.885-.99.99-1.955 1.673-4.109 1.938-6.302.036-.258.252-.55.255-.814.014-.263-.129-.482-.113-.74l.051-.931c.004-.31-.021-.619-.031-.927-.03-.616-.037-1.231-.146-1.832-.227-1.886-.84-3.806-1.68-5.652-.164-.33-.619-.565-.775-.887-.211-.386-.164-.872-.398-1.264a20.625 20.625 0 0 0-4.354-4.944c-.207-.156-.362-.471-.573-.628-.211-.158-.469-.157-.674-.314-.516-.349-1.055-.66-1.579-.985-.537-.304-1.101-.553-1.645-.827-1.752-.722-3.675-1.295-5.702-1.511-.363-.062-.806.255-1.16.227-.434-.02-.845-.354-1.27-.359l-6.01-.007c-.236 0-.52-.158-.757-.158-.236 0-.426.153-.661.15l-.082-.001.313-1.604c.06-.32-.173-.722-.108-1.042.08-.394.454-.709.533-1.105.391-1.921.785-3.868 1.177-5.8.046-.229.259-.481.305-.71s-.069-.431-.021-.657c.228-1.09.452-2.172.675-3.236l1.014-5.182c.061-.32-.17-.731-.105-1.052.079-.394.451-.699.531-1.097l1.176-5.799c.047-.229.258-.477.304-.705s-.069-.436-.021-.662l.675-3.234 1.015-5.184c.061-.32-.169-.741-.104-1.062.079-.395.45-.689.53-1.087.389-1.92.783-3.867 1.176-5.799.046-.229.256-.471.303-.699.045-.229-.068-.441-.02-.668l.338-1.627c.113-.545.199-.939.309-1.364.3-1.298.826-2.709 1.965-3.653.211-.143.244-.617.498-.734.293-.176.727 0 1.026-.111a7.57 7.57 0 0 1 2.325-.375h1.074l1.657-.001c.211 0 .482.158.722.158.234 0 .421-.153.653-.15l3.314.021c1.455-.013 2.967-.04 4.424.022z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    className: (_CheckboxPanel_module_scss__WEBPACK_IMPORTED_MODULE_1___default().fill),
                    d: "M319.153 298.465c.102-.253-.109-.676-.031-.929.451-1.545.754-3.336 1.09-4.996l.684-3.236c.049-.227-.064-.438-.018-.667.046-.229.258-.472.305-.7.396-1.934.797-3.881 1.193-5.803.022-.112.07-.217.127-.316l-32.218-157.215a11.121 11.121 0 0 1-1.911-.662c-1.205-.613-2.51-1.538-3.244-3.076-.16-.303-.389-.522-.5-.873-.108-.357-.014-.79-.047-1.165-.018-.417-.002-.905.034-1.075l.09-.715c.062-.342.004-.562-.017-.695-.072-.1-.032-.156-.209-.254-.033-.061-.203-.101-.297-.167l-.457-.156c-.297-.067-.514-.435-.879-.479-.276-.052-.66.237-.947.21-.238-.016-.483-.023-.726-.033l37.597 183.461c.149-.136.309-.266.381-.459zM269.325 115.407a7.57 7.57 0 0 0-2.325.375c-.3.111-.733-.064-1.026.111-.254.117-.287.592-.498.734-1.139.944-1.665 2.355-1.965 3.653-.109.425-.195.819-.309 1.364l-.338 1.627c-.049.227.064.439.02.668-.047.229-.257.471-.303.699l-1.176 5.799c-.08.397-.451.692-.53 1.087-.064.32.165.741.104 1.062l-1.015 5.184-.675 3.234c-.049.227.066.434.021.662s-.257.477-.304.705l-1.176 5.799c-.08.397-.452.703-.531 1.097-.064.32.166.731.105 1.052l-1.014 5.182c-.223 1.064-.447 2.146-.675 3.236-.048.227.067.429.021.657s-.259.481-.305.71c-.392 1.932-.786 3.879-1.177 5.8-.079.396-.453.712-.533 1.105-.064.32.168.722.108 1.042-.106.542-.21 1.07-.313 1.604l.082.001c.235.003.425-.15.661-.15.237 0 .521.158.757.158l6.01.007c.425.006.836.34 1.27.359.354.028.797-.289 1.16-.227 2.027.216 3.95.789 5.702 1.511.544.274 1.107.523 1.645.827.524.325 1.063.637 1.579.985.205.157.463.156.674.314.211.157.366.472.573.628a20.625 20.625 0 0 1 4.354 4.944c.234.392.188.878.398 1.264.156.321.611.557.775.887.84 1.847 1.453 3.767 1.68 5.652.109.601.116 1.216.146 1.832.01.308.035.617.031.927l-.051.931c-.016.258.127.478.113.74-.003.265-.219.557-.255.814-.266 2.192-.948 4.347-1.938 6.302-.188.417-.647.619-.885.99-.186.305-.141.822-.329 1.138a22.003 22.003 0 0 1-3.944 4.382l-1.482 1.089-1.597.958c-.232.113-.351.34-.589.455-.237.115-.588.107-.822.22a20.66 20.66 0 0 1-6.389 1.63c-.455.024-.867-.26-1.307-.239-.372.026-.734.322-1.068.329-1.846.01-3.646.021-5.365.029-1.104-.007-2.227-.015-3.355-.021-.235-.003-.425.15-.662.15-.236 0-.52-.158-.756-.158l-4.791-.006-.547 2.625c-.049.227.069.415.023.644s-.262.497-.308.726c-.392 1.932-.786 3.879-1.177 5.8-.08.396-.459.741-.539 1.136-.064.32.174.691.114 1.011-.349 1.782-.688 3.521-1.014 5.179l-.675 3.238c-.049.227.071.41.025.639-.046.228-.263.502-.309.73l-1.177 5.8c-.079.397-.462.751-.542 1.146-.064.32.178.682.117 1.001l-1.014 5.178c-.222 1.065-.447 2.148-.676 3.239-.048.227.072.404.027.633-.047.229-.264.508-.311.736l-1.176 5.8c-.08.397-.465.761-.544 1.155-.064.32.179.672.118.991l-1.013 5.177-.675 3.239c-.049.228.072.4.027.629-.047.229-.266.513-.312.74-.392 1.933-.786 3.88-1.177 5.802-.08.396-.466.771-.545 1.164-.064.32.18.662.121.981-.35 1.78-.689 3.518-1.014 5.176l-.676 3.24c-.049.228.074.396.028.624-.046.228-.266.517-.312.745l-1.177 5.802c-.08.396-.468.78-.548 1.174-.064.32.183.652.123.972l-.971 4.981c-.168.852-.266 1.744-.143 2.631.02.187.236.231.275.408.041.176-.021.483.043.66.34.721 1 1.248 1.731 1.541.745.268 1.534.39 2.32.4.289.022.576.314.958.317.325 0 .828-.308 1.154-.312 1.809-.01 3.573-.021 5.258-.029 1.075.007 2.17.015 3.271.021.229.003.473-.15.703-.15.231 0 .449.158.682.158l5.873.007c.402 0 .655.305 1.055.305.325 0 .798-.308 1.123-.312 1.808-.01 3.572-.021 5.255-.029 1.077.007 2.172.015 3.274.021.229.003.457-.15.688-.15.231 0 .465.158.697.158l5.875.007c.401 0 .685.305 1.085.305.325 0 .767-.308 1.091-.312 1.807-.01 3.57-.021 5.252-.029 1.078.007 2.174.015 3.277.021.229.003.441-.15.673-.15s.48.158.712.158l5.875.007c.402 0 .717.305 1.116.305.325 0 .735-.308 1.06-.312 1.807-.01 3.568-.021 5.25-.029 1.078.007 2.174.015 3.278.021.229.003.427-.15.658-.15s.497.158.728.158l5.877.007c.401 0 .746.305 1.146.305.324 0 .705-.308 1.028-.312l2.755-.016-38.402-187.383-1.061.001zM326.001 264.39c.081-.396.453-.698.534-1.093.065-.319-.163-.735-.103-1.056l1.029-5.187.685-3.236c.05-.228-.065-.433-.019-.661s.259-.479.306-.708l1.193-5.803c.081-.396.455-.705.536-1.099.064-.32-.166-.729-.104-1.051l1.03-5.185.684-3.237c.049-.227-.066-.43-.02-.658s.26-.482.307-.711l1.193-5.803c.081-.396.456-.711.537-1.105.064-.32-.166-.723-.105-1.043l1.029-5.186.684-3.237c.05-.227-.066-.427-.02-.655s.261-.485.307-.714c.398-1.933.799-3.881 1.193-5.803.082-.397.458-.718.539-1.112.064-.32-.168-.717-.107-1.037l1.029-5.184.686-3.238c.049-.227-.068-.424-.021-.651.047-.229.262-.489.309-.718.396-1.934.797-3.881 1.193-5.803.08-.397.459-.725.539-1.119.065-.32-.169-.71-.107-1.029l1.029-5.184.684-3.239c.049-.227-.068-.42-.021-.648s.262-.492.309-.721c.398-1.934.799-3.882 1.193-5.804.082-.396.461-.73.541-1.125.065-.319-.17-.703-.109-1.023l1.029-5.183.685-3.239c.05-.227-.069-.417-.022-.646.047-.228.263-.495.31-.724l1.193-5.804c.081-.396.462-.736.542-1.131.065-.32-.172-.697-.11-1.017l1.028-5.183.686-3.24c.049-.227-.07-.413-.023-.642s.264-.499.311-.728l1.193-5.804c.081-.396.463-.743.543-1.138.066-.32-.172-.69-.111-1.011l1.029-5.182.684-3.24c.05-.227-.07-.41-.023-.639.047-.229.265-.502.311-.73l1.178-5.717c.064-.312.442-.634.5-.97.053-.272-.24-.505-.209-.757.164-1.42.022-2.955-.903-3.982-.565-.671-1.423-1.033-2.282-1.204-.182-.037-.418.088-.597.058-.181-.01-.318-.184-.507-.194-.785-.067-1.577.014-2.365.062l-1.184.081-.706.032c-.257.007-.499.025-.767.023-.445-.008-.824-.304-1.26-.327-.354-.024-.788.252-1.154.229l-1.074-.15c-1.134-.188-2.292-.17-3.425-.031-.859.098-1.735.294-2.532.693-.162.093-.203.271-.342.391-.141.111-.447.1-.582.229-.607.519-.932 1.308-.99 2.087-.057.391-.012.795-.127 1.176l-.033.146-.091.233-.186.468c-.181.315-.35.656-.576.924-.36.48-.931.609-1.327.92-.317.269-.551.773-.914.986-2.01 1.091-4.106 1.403-6.009 1.418-1.09-.007-2.198-.015-3.314-.021-.232-.003-.419.15-.653.15-.233 0-.514-.158-.748-.158l-5.937-.007c-.406 0-.766-.305-1.169-.305-.326 0-.701.308-1.027.312-1.824.01-3.604.021-5.301.029-1.09-.007-2.198-.015-3.314-.021-.232-.003-.42.15-.652.15-.234 0-.515-.158-.748-.158l-5.317-.006 28.694 140.026c.041-.219.087-.446.133-.668z"
                })
            ]
        })
    };
    return Icons[iconName];
};
/* harmony default export */ __webpack_exports__["default"] = (PanelIcons);


/***/ }),

/***/ 34316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85170);



var CustomFont = function(param) {
    var children = param.children, fontName = param.fontName, uuid = param.uuid;
    var createStyles = function createStyles() {
        return {
            __html: "\n      .custom-font-".concat(fontName.replace(/\s+/g, ""), " {\n        --custom-font: '").concat(fontName.replace(/\s+/g, ""), "';\n      }\n    ")
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    dangerouslySetInnerHTML: createStyles()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "custom-font-".concat(fontName.replace(/\s+/g, "")),
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomFont);


/***/ }),

/***/ 58677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-accessible-dropdown-menu-hook@3.2.0/node_modules/react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js
var use_dropdown_menu = __webpack_require__(32821);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/global/DropdownItem/DropdownItem.module.scss
var DropdownItem_module = __webpack_require__(49412);
var DropdownItem_module_default = /*#__PURE__*/__webpack_require__.n(DropdownItem_module);
;// CONCATENATED MODULE: ./components/global/DropdownItem/DropdownItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var DropdownItem = function(param) {
    var item = param.item, onSelect = param.onSelect, size = param.size, active = param.active, _scrollOnChange = param.scrollOnChange, scrollOnChange = _scrollOnChange === void 0 ? true : _scrollOnChange;
    var handleClick = function() {
        if (onSelect) onSelect(item);
    };
    var _obj;
    if ((item === null || item === void 0 ? void 0 : item.url) || (item === null || item === void 0 ? void 0 : item.path)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: item.url || item.path,
        scroll: scrollOnChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (0,clsx_m/* default */.Z)((DropdownItem_module_default()).DropdownItem, (_obj = {}, _defineProperty(_obj, (DropdownItem_module_default()).DropdownItemSmall, size === "small"), _defineProperty(_obj, (DropdownItem_module_default()).DropdownItemWide, size === "wide"), _defineProperty(_obj, (DropdownItem_module_default())["DropdownItem--active"], active), _obj)),
            children: [
                item.name,
                item.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: item.label
                })
            ]
        })
    });
    var _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx_m/* default */.Z)((DropdownItem_module_default()).DropdownItem, (_obj1 = {}, _defineProperty(_obj1, (DropdownItem_module_default()).DropdownItemSmall, size === "small"), _defineProperty(_obj1, (DropdownItem_module_default()).DropdownItemWide, size === "wide"), _defineProperty(_obj1, (DropdownItem_module_default())["DropdownItem--active"], active), _obj1)),
        type: "button",
        onClick: handleClick,
        children: [
            item.customContent ? item.customContent : item.name,
            item.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (DropdownItem_module_default()).DropdownItem__label,
                children: item.label
            })
        ]
    });
};
/* harmony default export */ var DropdownItem_DropdownItem = (DropdownItem);

;// CONCATENATED MODULE: ./components/global/DropdownItem/index.tsx


// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Icon/defaultIconSizes.tsx
var defaultIconSizes = __webpack_require__(57556);
// EXTERNAL MODULE: ./components/global/Dropdown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(14505);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
;// CONCATENATED MODULE: ./components/global/Dropdown/Dropdown.tsx
function Dropdown_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Dropdown_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Dropdown = function(param) {
    var items = param.items, defaultValue = param.defaultValue, onSelect = param.onSelect, size = param.size, transparency = param.transparency, color = param.color, align = param.align, id = param.id, _direction = param.direction, direction = _direction === void 0 ? "down" : _direction, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _inline = param.inline, inline = _inline === void 0 ? false : _inline, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _active = param.active, active = _active === void 0 ? false : _active, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? true : _showDropdown, _transparentMenu = param.transparentMenu, transparentMenu = _transparentMenu === void 0 ? false : _transparentMenu, _scrollOnChange = param.scrollOnChange, scrollOnChange = _scrollOnChange === void 0 ? true : _scrollOnChange;
    var createStyles = function createStyles() {
        return {
            __html: "\n      #".concat(id, " {\n        --dropdown-color: ").concat(color, ";\n      }\n    ")
        };
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,use_dropdown_menu/* default */.Z)(items === null || items === void 0 ? void 0 : items.length), buttonProps = ref.buttonProps, itemProps = ref.itemProps, isOpen = ref.isOpen, setIsOpen = ref.setIsOpen;
    var selectedValue = defaultValue ? defaultValue.name : "Choose...";
    var handleSelect = function(item) {
        setIsOpen(false);
        onSelect(item);
    };
    var onKeyDown = function(event) {
        var selectedIndex = items.findIndex(function(item) {
            return item.name === selectedValue;
        });
        if (event.key === "ArrowDown" && selectedIndex !== items.length - 1) {
            onSelect(items[selectedIndex + 1]);
        } else if (event.key === "ArrowUp" && selectedIndex !== 0) {
            onSelect(items[selectedIndex - 1]);
        } else if (event.key === "Tab") {
            setIsOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        var handleOpen = function() {
            setIsOpen(false);
        };
        router.events.on("routeChangeStart", handleOpen);
        return function() {
            router.events.off("routeChangeStart", handleOpen);
        };
    }, []);
    if (!(items === null || items === void 0 ? void 0 : items.length)) return null;
    var _obj;
    var selectedOption = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            color && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: createStyles()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", _objectSpread({
                type: "button",
                className: (0,clsx_m/* default */.Z)((Dropdown_module_default()).Button, (_obj = {}, Dropdown_defineProperty(_obj, (Dropdown_module_default()).ButtonSmall, size === "small"), Dropdown_defineProperty(_obj, (Dropdown_module_default()).ButtonWide, size === "wide"), Dropdown_defineProperty(_obj, (Dropdown_module_default()).ButtonFullWidth, fullWidth), Dropdown_defineProperty(_obj, (Dropdown_module_default()).DropdownIsActive, active), _obj))
            }, buttonProps, {
                disabled: disabled,
                onKeyDown: onKeyDown,
                children: [
                    (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.customContent) ? defaultValue.customContent : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Dropdown_module_default()).ButtonText,
                        children: selectedValue
                    }),
                    showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Dropdown_module_default()).ButtonIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, _objectSpread({
                            color: color || "var(--dropdown-color)",
                            iconName: "arrow-".concat(isOpen ? "up" : "down")
                        }, defaultIconSizes/* DEFAULT_ARROW_ICON_SIZES */.G))
                    })
                ]
            }))
        ]
    });
    var _obj1, _obj2, _obj3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: (0,clsx_m/* default */.Z)((Dropdown_module_default()).DropdownContainer, (_obj1 = {}, Dropdown_defineProperty(_obj1, (Dropdown_module_default()).DropdownContainerTransparent, transparency), Dropdown_defineProperty(_obj1, (Dropdown_module_default()).DropdownContainerInline, inline), Dropdown_defineProperty(_obj1, (Dropdown_module_default()).DropdownContainerWide, size === "wide"), _obj1)),
        children: [
            selectedOption,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Dropdown_module_default()).DropdownListWrapper, (_obj2 = {}, Dropdown_defineProperty(_obj2, (Dropdown_module_default()).DropdownListVisible, isOpen), Dropdown_defineProperty(_obj2, (Dropdown_module_default()).DropdownListWrapperSmall, size === "small"), Dropdown_defineProperty(_obj2, (Dropdown_module_default()).DropdownListWrapperWide, size === "wide"), Dropdown_defineProperty(_obj2, (Dropdown_module_default()).DropdownListWrapperUpwards, direction === "up"), Dropdown_defineProperty(_obj2, (Dropdown_module_default()).DropdownListWrapperFilled, !transparentMenu), _obj2)),
                role: "menu",
                children: [
                    selectedOption,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (0,clsx_m/* default */.Z)((Dropdown_module_default()).DropdownList, (_obj3 = {}, Dropdown_defineProperty(_obj3, (Dropdown_module_default()).DropdownListSmall, size === "small"), Dropdown_defineProperty(_obj3, (Dropdown_module_default()).DropdownListWide, size === "wide"), _obj3)),
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (0,clsx_m/* default */.Z)((Dropdown_module_default()).DropdownItem, Dropdown_defineProperty({}, (Dropdown_module_default())["DropdownItem__align-left"], align === "left")),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem_DropdownItem, _objectSpread({
                                    item: item,
                                    onSelect: handleSelect,
                                    size: size,
                                    active: selectedValue === item.name,
                                    scrollOnChange: scrollOnChange
                                }, itemProps))
                            }, item.name);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);

;// CONCATENATED MODULE: ./components/global/Dropdown/index.tsx



/***/ }),

/***/ 53409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);


var FontLoader = function(param) {
    var fontName = param.fontName, s3Path = param.s3Path, fullPath = param.fullPath;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fontLoaded = ref[0], setFontLoaded = ref[1];
    var fontNameNoSpaces = fontName.replace(/\s+/g, "");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!fontLoaded) {
            var font = new FontFace(fontNameNoSpaces, "url(".concat(fullPath ? "https://storage.prod.colophon-foundry.org/fonts/web" : "").concat(s3Path, ")"));
            document.fonts.add(font);
            font.load().then(function() {
                setFontLoaded(true);
            }).catch(function() {
                setFontLoaded(true);
            });
        }
    }, [
        fullPath,
        s3Path,
        fontNameNoSpaces
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (FontLoader);


/***/ }),

/***/ 232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* reexport */ Column; },
  "r": function() { return /* reexport */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Grid/Grid.module.scss
var Grid_module = __webpack_require__(88128);
var Grid_module_default = /*#__PURE__*/__webpack_require__.n(Grid_module);
;// CONCATENATED MODULE: ./components/global/Grid/Column.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Column = function(param) {
    var children = param.children, sm = param.sm, md = param.md, lg = param.lg, xl = param.xl, className = param.className, desktopOrder = param.desktopOrder, noColumnPadding = param.noColumnPadding;
    var nodeStyles = _objectSpread({}, noColumnPadding && {
        padding: "0"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Grid_module_default())["column-sm-".concat(sm)], (Grid_module_default())["column-md-".concat(md)], (Grid_module_default())["column-lg-".concat(lg)], (Grid_module_default())["column-xl-".concat(xl)], (Grid_module_default())["column-order-d-".concat(desktopOrder)], className),
        style: nodeStyles,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/global/Grid/Grid.tsx
function Grid_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Grid_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Grid_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Grid = function(_param) {
    var as = _param.as, theme = _param.theme, children = _param.children, fullWidth = _param.fullWidth, fullHeight = _param.fullHeight, rowSpacing = _param.rowSpacing, rowAlign = _param.rowAlign, className = _param.className, rowPadding = _param.rowPadding, columnSpacing = _param.columnSpacing, gutter = _param.gutter, reverseOnMobile = _param.reverseOnMobile, background = _param.background, rest = _objectWithoutProperties(_param, [
        "as",
        "theme",
        "children",
        "fullWidth",
        "fullHeight",
        "rowSpacing",
        "rowAlign",
        "className",
        "rowPadding",
        "columnSpacing",
        "gutter",
        "reverseOnMobile",
        "background"
    ]);
    var Component = as || "div";
    var rowStyles = Grid_objectSpread({
        rowGap: rowSpacing ? "".concat(rowSpacing, "px") : "0"
    }, rowAlign ? {
        alignItems: rowAlign
    } : "", {
        paddingTop: rowPadding ? rowPadding : "var(--row-padding)"
    }, columnSpacing ? {
        justifyContent: columnSpacing
    } : "", {
        paddingBottom: rowPadding ? rowPadding : "var(--row-padding)"
    });
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, Grid_objectSpread({
        className: (0,clsx_m/* default */.Z)((Grid_module_default()).grid, theme && "u-".concat(theme.toLowerCase()), (_obj = {}, Grid_defineProperty(_obj, (Grid_module_default()).gridFullWidth, fullWidth), Grid_defineProperty(_obj, (Grid_module_default()).gridFullHeight, fullHeight), Grid_defineProperty(_obj, (Grid_module_default()).background, background), Grid_defineProperty(_obj, className, className), _obj)),
        style: (Grid_objectSpread({}, gutter ? {
            "--custom-gutter": gutter
        } : ""), Grid_objectSpread({}, background && {
            "--grid-background": background
        }))
    }, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((Grid_module_default()).row, (_obj1 = {}, Grid_defineProperty(_obj1, (Grid_module_default())["reverse-mobile-vertical"], reverseOnMobile === "vertical"), Grid_defineProperty(_obj1, (Grid_module_default())["reverse-mobile-horizontal"], reverseOnMobile === "horizontal"), _obj1)),
            style: rowStyles,
            children: children
        })
    }));
};


;// CONCATENATED MODULE: ./components/global/Grid/index.tsx





/***/ }),

/***/ 57556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DEFAULT_ARROW_ICON_SIZES; }
/* harmony export */ });
var DEFAULT_ARROW_ICON_SIZES = {
    height: "18",
    width: "18"
};


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Icon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Icon/Icon.module.scss
var Icon_module = __webpack_require__(88625);
var Icon_module_default = /*#__PURE__*/__webpack_require__.n(Icon_module);
;// CONCATENATED MODULE: ./components/global/Icon/Icon.tsx




var Icon = function(param) {
    var iconName = param.iconName, width = param.width, height = param.height, label = param.label, color = param.color;
    var _style = {
        "--icon-color": color,
        width: width ? "".concat(width, "px") : "var(--icon-width, 24px)",
        height: height ? "".concat(height, "px") : "var(--icon-height, 24px)"
    };
    var component = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (Icon_module_default()).svg,
        viewBox: "0 0 ".concat(width || 24, " ").concat(height || 24),
        width: width || 24,
        height: height || 24,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
            href: "#icon-".concat(iconName)
        })
    });
    if (!label) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: _style,
        className: (Icon_module_default()).container,
        children: component
    });
    var labelStyle = {
        position: "relative"
    };
    var dim = Math.min(parseInt(width), parseInt(height));
    if (iconName === "number") {
        labelStyle.fontSize = "min( ".concat(dim * 2 / 3, "px, 16px)");
        labelStyle.lineHeight = "1.2";
        if (color) labelStyle.color = color;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Icon_module_default()).iconWithLabel),
        style: _style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: component
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Icon_module_default()).label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: labelStyle,
                    children: label
                })
            })
        ]
    });
};
/* harmony default export */ var Icon_Icon = (Icon);

;// CONCATENATED MODULE: ./components/global/Icon/index.tsx

/* harmony default export */ var global_Icon = (Icon_Icon);


/***/ }),

/***/ 5937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputErrorMessage_InputErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/InputErrorMessage/InputErrorMessage.module.scss
var InputErrorMessage_module = __webpack_require__(12957);
var InputErrorMessage_module_default = /*#__PURE__*/__webpack_require__.n(InputErrorMessage_module);
;// CONCATENATED MODULE: ./components/global/InputErrorMessage/InputErrorMessage.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var InputErrorMessage = function(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,clsx_m/* default */.Z)((InputErrorMessage_module_default()).InputErrorMessage, _defineProperty({}, (InputErrorMessage_module_default()).error, error)),
        "data-testid": "InputErrorMessage",
        children: error
    });
};
/* harmony default export */ var InputErrorMessage_InputErrorMessage = (InputErrorMessage);

;// CONCATENATED MODULE: ./components/global/InputErrorMessage/index.tsx



/***/ }),

/***/ 22621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputField_InputField; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/InputErrorMessage/index.tsx + 1 modules
var InputErrorMessage = __webpack_require__(5937);
// EXTERNAL MODULE: ./components/global/InputLabel/index.tsx + 1 modules
var InputLabel = __webpack_require__(78080);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/InputField/InputField.module.scss
var InputField_module = __webpack_require__(49679);
var InputField_module_default = /*#__PURE__*/__webpack_require__.n(InputField_module);
;// CONCATENATED MODULE: ./components/global/InputField/InputField.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var InputField = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var type = param.type, name = param.name, label = param.label, placeholder = param.placeholder, onChange = param.onChange, onFocus = param.onFocus, onKeyPress = param.onKeyPress, onBlur = param.onBlur, hasLabel = param.hasLabel, isRequired = param.isRequired, isDisabled = param.isDisabled, hasBorder = param.hasBorder, error = param.error, value = param.value, min = param.min, pattern = param.pattern, onWhite = param.onWhite, hasMobileKeyboard = param.hasMobileKeyboard, mobileKeyboardClickEvent = param.mobileKeyboardClickEvent, _disablePointerEvents = param.disablePointerEvents, disablePointerEvents = _disablePointerEvents === void 0 ? false : _disablePointerEvents, valuePrefix = param.valuePrefix, defaultValue = param.defaultValue, className = param.className;
    var ref1;
    var ref2 = (0,react.useState)(true), showPass = ref2[0], setShowPass = ref2[1];
    var toggleShow = function() {
        return setShowPass(function(show) {
            return !show;
        });
    };
    var inputRef = (0,react.useRef)(null);
    if ((inputRef === null || inputRef === void 0 ? void 0 : (ref1 = inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.type) && type === "password") {
        if (!showPass) {
            inputRef.current.type = "text";
        } else {
            inputRef.current.type = "password";
        }
    }
    var _obj;
    var input = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(valuePrefix && (InputField_module_default()).InputPrefixWrapper),
        children: [
            valuePrefix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputField_module_default()).InputPrefix,
                children: valuePrefix
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (0,clsx_m/* default */.Z)((InputField_module_default()).InputField, className, (_obj = {}, _defineProperty(_obj, (InputField_module_default()).InputFieldError, error), _defineProperty(_obj, (InputField_module_default()).InputFieldBorder, hasBorder && !error), _defineProperty(_obj, (InputField_module_default()).InputFieldIsDisabled, isDisabled), _defineProperty(_obj, (InputField_module_default()).InputFieldIsOnWhite, onWhite), _defineProperty(_obj, (InputField_module_default()).InputFieldPointerEventsDisabled, disablePointerEvents), _obj)),
                type: type,
                id: name,
                name: name,
                placeholder: placeholder,
                onChange: onChange,
                onFocus: onFocus,
                onKeyPress: onKeyPress,
                onBlur: onBlur,
                required: isRequired,
                disabled: isDisabled,
                ref: function(element) {
                    inputRef.current = element;
                    // This expression is not callable.
                    // Not all constituents of type 'ForwardedRef<HTMLInputElement>' are callable.
                    // Type 'MutableRefObject<HTMLInputElement>' has no call signatures.
                    // @ts-ignore
                    return ref ? ref(element) : null;
                },
                value: value,
                min: min,
                pattern: pattern,
                "data-cy": name,
                defaultValue: defaultValue
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InputField_module_default()).InputFieldContainer,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                name: name,
                label: label,
                isVisible: hasLabel,
                error: error
            }),
            hasMobileKeyboard && type === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputField_module_default()).InputMobileKeyboardWrapper,
                children: [
                    input,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        variant: "ghost",
                        callBack: function() {
                            return mobileKeyboardClickEvent("plus");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                iconName: "plus-circle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Plus"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        variant: "ghost",
                        callBack: function() {
                            return mobileKeyboardClickEvent("minus");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                iconName: "minus-circle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Minus"
                            })
                        ]
                    })
                ]
            }) : input,
            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((InputField_module_default()).InputIcon, _defineProperty({}, (InputField_module_default()).InputIcon__Error, error)),
                onClick: toggleShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    iconName: showPass ? "eye-shut" : "eye"
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputErrorMessage/* default */.Z, {
                error: error
            })
        ]
    });
});
InputField.displayName = "InputField";
/* harmony default export */ var InputField_InputField = (InputField);

;// CONCATENATED MODULE: ./components/global/InputField/index.tsx



/***/ }),

/***/ 78080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputLabel_InputLabel; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/InputLabel/InputLabel.module.scss
var InputLabel_module = __webpack_require__(26573);
var InputLabel_module_default = /*#__PURE__*/__webpack_require__.n(InputLabel_module);
;// CONCATENATED MODULE: ./components/global/InputLabel/InputLabel.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var InputLabel = function(param) {
    var name = param.name, label = param.label, isVisible = param.isVisible, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        className: (0,clsx_m/* default */.Z)((InputLabel_module_default()).InputLabel, _defineProperty({
            "visually-hidden": !isVisible
        }, (InputLabel_module_default()).error, error)),
        htmlFor: name,
        children: label
    });
};
/* harmony default export */ var InputLabel_InputLabel = (InputLabel);

;// CONCATENATED MODULE: ./components/global/InputLabel/index.tsx



/***/ }),

/***/ 47427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75968);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_global_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80772);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55689);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22093);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _partials__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27764);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








react_modal__WEBPACK_IMPORTED_MODULE_2___default().setAppElement("#root");
var customStyles = function(param) {
    var splitModal = param.splitModal, cardModal = param.cardModal, modalPadding = param.modalPadding, template = param.template;
    if (splitModal) return {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "24px",
            border: "none",
            padding: "0"
        }
    };
    if (cardModal) return {
        content: {}
    };
    return {
        content: _objectSpread({
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "24px",
            border: "none"
        }, !template && {
            padding: modalPadding || "var(--spacing-m, 24px)"
        }, {
            maxWidth: "90vw",
            maxHeight: "90vh"
        })
    };
};
var ModalComponent = function(param) {
    var ModalTitle = param.ModalTitle, ModalButtonLabel = param.ModalButtonLabel, splitModal = param.splitModal, controlled = param.controlled, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "500px" : _maxWidth, controlledOpen = param.controlledOpen, controlledSetOpen = param.controlledSetOpen, modalPadding = param.modalPadding, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "s" : _buttonSize, _buttonVariant = param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? "secondary" : _buttonVariant, _buttonPosition = param.buttonPosition, buttonPosition = _buttonPosition === void 0 ? "left" : _buttonPosition, _closeButtonColor = param.closeButtonColor, closeButtonColor = _closeButtonColor === void 0 ? "var(--color-primary)" : _closeButtonColor, children = param.children, cardModal = param.cardModal, template = param.template, asWrapper = param.asWrapper, _showWrapperVerticalScroll = param.showWrapperVerticalScroll, showWrapperVerticalScroll = _showWrapperVerticalScroll === void 0 ? false : _showWrapperVerticalScroll;
    var openModal = function openModal() {
        controlled ? controlledSetOpen(true) : setIsOpen(true);
    };
    var closeModal = function closeModal() {
        controlled ? controlledSetOpen(false) : setIsOpen(false);
    };
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), modalIsOpen = ref[0], setIsOpen = ref[1];
    var modalButton = splitModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        callBack: openModal,
        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalTriggerSplit),
        type: "button",
        children: ModalButtonLabel
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        callBack: openModal,
        variant: buttonVariant,
        size: buttonSize,
        align: buttonPosition,
        type: "button",
        children: ModalButtonLabel
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            !controlled && modalButton,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
                isOpen: controlled ? controlledOpen : modalIsOpen,
                onRequestClose: closeModal,
                style: customStyles({
                    splitModal: splitModal,
                    cardModal: cardModal,
                    modalPadding: modalPadding,
                    template: template
                }),
                contentLabel: ModalTitle,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(cardModal && (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cardModal), template && (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default())["modal-".concat(template)]),
                overlayClassName: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalOverlay),
                children: [
                    splitModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "button",
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalCloseSplit),
                                callBack: closeModal,
                                variant: "ghost",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    iconName: "close",
                                    color: closeButtonColor
                                })
                            }),
                            children
                        ]
                    }),
                    cardModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                        style: {
                            maxWidth: "88vw",
                            width: maxWidth
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "button",
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().close),
                                callBack: closeModal,
                                variant: "primary",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    iconName: "close",
                                    color: "var(--color-background)"
                                })
                            }),
                            children
                        ]
                    }),
                    !(splitModal || cardModal) && !template && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            !asWrapper && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalCloseContainer),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    callBack: closeModal,
                                    variant: "ghost",
                                    type: "button",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        iconName: "close",
                                        color: closeButtonColor
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContent), !showWrapperVerticalScroll && (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().noScrollbar)),
                                style: {
                                    maxWidth: "88vw",
                                    width: maxWidth
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: ModalTitle
                                    }),
                                    children
                                ]
                            })
                        ]
                    }),
                    template && template === "get-in-touch" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials__WEBPACK_IMPORTED_MODULE_5__/* .GetInTouchModalTemplate */ .kE, {
                        closeModal: closeModal,
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalComponent);


/***/ }),

/***/ 96332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ps": function() { return /* reexport */ partials/* BasicModalContent */.Ps; },
  "iq": function() { return /* reexport */ partials/* ModalMessageBody */.iq; },
  "e1": function() { return /* reexport */ partials/* ModalMessageBodyColumn */.e1; },
  "ZP": function() { return /* binding */ global_Modal; }
});

// UNUSED EXPORTS: CloseButton, GetInTouchModalTemplate, InfoModal, ModalIcons, ModalMessageBodyBlock, ModalMessageScrollCarousel, ModalMessageTwoColumnBody, Slide, TwoColumnModalContent

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var global_Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var global_Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Modal/Modal.tsx
var Modal_Modal = __webpack_require__(47427);
;// CONCATENATED MODULE: ./components/global/Modal/InfoModal.tsx






var InfoModal = function(param) {
    var title = param.title, children = param.children;
    var ref = useState(false), open = ref[0], setOpen = ref[1];
    var modalChildren = React.Children.map(children, function(child) {
        return /*#__PURE__*/ React.cloneElement(child, {
            className: styles.infoBlock
        });
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                className: styles.InfoModal__button,
                type: "button",
                variant: "ghost",
                callBack: function() {
                    return setOpen(true);
                },
                ariaLabel: "Open info modal",
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.InfoModal__buttonHitArea,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Modal, {
                controlled: true,
                controlledOpen: open,
                controlledSetOpen: setOpen,
                maxWidth: "100%",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.InfoModal__content,
                    children: [
                        /*#__PURE__*/ _jsx("h5", {
                            className: styles.InfoModal__contentTitle,
                            children: title
                        }),
                        modalChildren
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Modal_InfoModal = ((/* unused pure expression or super */ null && (InfoModal)));

// EXTERNAL MODULE: ./components/global/Modal/partials/index.ts + 9 modules
var partials = __webpack_require__(27764);
;// CONCATENATED MODULE: ./components/global/Modal/index.tsx


/* harmony default export */ var global_Modal = (Modal_Modal/* default */.Z);




/***/ }),

/***/ 62164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModalIcons": function() { return /* binding */ ModalIcons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);

var ModalIcons = function(param) {
    var iconName = param.iconName;
    var Icons = {
        addToCart: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "368",
            height: "326",
            viewBox: "0 0 368 326",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M367.56 179.129C367.654 178.926 367.789 178.746 367.92 178.541L367.885 175.232C367.871 174.13 367.89 173.027 367.737 171.933L367.399 168.646C367.332 168.101 367.308 167.548 367.207 167.009L366.889 165.39L366.461 163.167L366.289 162.198C366.113 161.985 365.917 161.833 365.701 161.716C365.674 161.295 365.633 160.875 365.574 160.458C365.428 160.266 365.256 160.102 365.114 159.918C364.974 159.73 365.287 159.598 365.238 159.377C365.219 159.304 365.216 159.227 365.191 159.154C365.103 158.84 364.874 158.494 364.966 158.216C365.075 157.846 364.978 157.48 364.667 157.195C364.554 157.089 364.411 157.007 364.286 156.913C364.337 156.704 364.39 156.495 364.446 156.268C364.235 155.704 363.948 155.166 363.699 154.613C363.403 154.083 363.12 153.541 362.798 153.024C361.349 150.692 359.505 148.6 357.575 146.824C356.263 145.639 354.887 144.534 353.456 143.517C353.282 143.382 353.105 143.251 352.915 143.139C352.8 143.078 352.487 142.704 352.403 142.618L352.404 142.617C352.348 142.515 352.261 142.524 352.217 142.413C352.119 142.169 351.983 142.077 351.707 142.099C351.404 142.12 351.124 142.115 350.867 141.937L349.946 141.355C349.886 141.321 349.83 141.268 349.795 141.208C349.725 141.08 349.697 140.91 349.598 140.817C349.428 140.66 349.186 140.833 348.999 140.768C348.52 140.601 348.094 140.322 347.648 140.083C347.523 140.015 347.457 139.882 347.386 139.747C347.241 139.469 347.23 139.46 346.909 139.522C346.569 139.59 346.366 139.432 346.217 139.149C346.15 139.02 346.068 138.902 345.978 138.754C344.494 138.022 342.957 137.354 341.412 136.74C341.183 136.787 340.971 136.857 340.756 136.877C340.539 136.895 340.572 136.557 340.369 136.484C340.3 136.463 340.234 136.425 340.164 136.411C339.861 136.336 339.474 136.32 339.301 136.076C339.065 135.764 338.731 135.644 338.346 135.719C338.203 135.744 338.063 135.807 337.922 135.85C337.792 135.676 337.661 135.502 337.52 135.314C336.437 134.936 335.321 134.616 334.209 134.28C331.701 133.559 329.156 132.972 326.6 132.483C324.893 132.157 323.178 131.879 321.457 131.663C321.241 131.634 321.027 131.589 320.809 131.577C320.682 131.575 320.237 131.379 320.125 131.339C320.031 131.276 319.958 131.324 319.869 131.247C319.674 131.077 319.512 131.065 319.279 131.206C319.019 131.357 318.767 131.476 318.463 131.43C318.106 131.383 317.746 131.345 317.387 131.316C317.32 131.31 317.246 131.287 317.189 131.248C317.071 131.162 316.974 131.021 316.844 130.98C316.625 130.912 316.482 131.171 316.287 131.194C315.784 131.257 315.284 131.172 314.783 131.143C314.64 131.135 314.525 131.042 314.405 130.951C314.16 130.761 314.146 130.757 313.883 130.949C313.603 131.156 313.353 131.099 313.102 130.893C312.989 130.802 312.866 130.724 312.723 130.624C311.078 130.583 309.411 130.578 307.754 130.622C307.564 130.759 307.395 130.911 307.207 131.017C307.014 131.124 306.911 130.794 306.697 130.807C306.625 130.814 306.551 130.806 306.48 130.818C306.171 130.867 305.809 130.998 305.554 130.843C305.215 130.652 304.863 130.688 304.536 130.9C304.415 130.977 304.311 131.089 304.198 131.181C304.01 131.072 303.823 130.96 303.618 130.841C302.476 130.946 301.318 131.036 300.167 131.198C297.574 131.518 294.993 131.979 292.448 132.596C290.755 133.029 289.065 133.483 287.415 134.07C287.206 134.138 286.993 134.192 286.79 134.278C286.674 134.338 286.188 134.376 286.069 134.393V134.392C285.954 134.377 285.911 134.454 285.795 134.426C285.54 134.363 285.388 134.426 285.243 134.655C285.077 134.903 284.909 135.129 284.616 135.238L283.606 135.656C283.542 135.681 283.465 135.696 283.395 135.687C283.247 135.665 283.094 135.594 282.959 135.623C282.73 135.674 282.732 135.972 282.572 136.088C282.159 136.393 281.678 136.57 281.228 136.81C281.1 136.876 280.951 136.857 280.798 136.839C280.486 136.803 280.47 136.808 280.341 137.109C280.202 137.426 279.962 137.518 279.638 137.485C279.492 137.471 279.347 137.475 279.171 137.47C277.735 138.313 276.286 139.322 274.956 140.465C274.889 140.692 274.852 140.913 274.769 141.111C274.683 141.31 274.381 141.146 274.22 141.303C274.168 141.359 274.104 141.405 274.057 141.463C273.85 141.711 273.663 142.056 273.35 142.124C272.95 142.235 272.707 142.526 272.62 142.901C272.587 143.041 272.593 143.188 272.579 143.331C272.35 143.392 272.142 143.475 271.901 143.558C271.143 144.491 270.451 145.499 269.881 146.574C269.881 146.576 269.879 146.579 269.878 146.582C269.537 146.637 269.104 146.868 268.998 147.101C268.896 147.323 268.817 147.555 268.701 147.769C268.529 148.079 268.582 148.387 268.635 148.7C268.653 148.778 268.653 148.856 268.662 148.944C268.536 149.231 268.398 149.526 268.283 149.825C268.223 149.99 268.131 150.1 267.998 150.198C267.721 150.401 267.594 150.502 267.501 150.626C267.263 149.706 266.918 148.776 266.393 147.839L266.36 147.786C266.279 147.669 266.28 147.587 266.309 147.432C266.34 147.21 266.294 147.077 266.041 146.996C265.475 146.819 265.332 146.428 265.304 145.834C265.301 145.785 265.242 145.691 265.203 145.684C264.779 145.612 264.506 145.372 264.25 145.069C263.814 144.523 263.291 144.124 262.799 143.659C262.567 143.443 262.445 143.194 262.371 142.901C262.322 142.676 262.131 142.517 261.887 142.512C261.582 142.511 261.302 142.492 261.047 142.294C260.44 141.875 259.776 141.542 259.18 141.17C259.043 140.943 258.928 140.754 258.811 140.561C258.75 140.53 258.684 140.495 258.618 140.459C258.479 140.397 258.335 140.346 258.202 140.271C257.852 140.072 257.489 140.066 257.108 140.247C256.969 140.08 256.832 139.914 256.672 139.723C254.912 139.116 253.004 138.926 251.123 138.899C250.646 138.923 250.635 138.914 250.1 139.322C249.977 139.251 249.846 139.197 249.729 139.121C249.522 138.979 249.311 138.999 249.114 139.126C248.99 139.227 248.881 139.346 248.763 139.458C248.572 139.372 248.379 139.286 248.14 139.179C247.335 139.284 246.561 139.491 245.798 139.718C245.611 138.259 245.28 136.823 244.832 135.431C244.754 135.203 244.687 134.97 244.592 134.749C244.526 134.625 244.491 134.072 244.447 133.948C244.447 133.821 244.367 133.78 244.383 133.649C244.414 133.362 244.333 133.197 244.092 133.061C243.819 132.911 243.613 132.737 243.449 132.438L242.871 131.399C242.834 131.334 242.807 131.252 242.803 131.172C242.789 131.011 242.824 130.832 242.766 130.692C242.664 130.455 242.375 130.512 242.227 130.363C241.858 129.966 241.528 129.521 241.176 129.094C241.076 128.975 241.053 128.812 241.025 128.645C240.971 128.298 240.952 128.291 240.614 128.243C240.253 128.196 240.091 127.972 240.012 127.623C239.973 127.468 239.924 127.312 239.864 127.132C238.488 125.92 236.893 124.929 235.194 124.226C234.942 124.262 234.71 124.325 234.477 124.335C234.245 124.344 234.272 124 234.041 123.939C233.963 123.92 233.889 123.885 233.81 123.873C233.47 123.808 233.045 123.808 232.835 123.569C232.545 123.28 232.148 123.225 231.734 123.335C231.582 123.376 231.437 123.454 231.29 123.512C231.127 123.349 230.954 123.216 230.766 123.064C230.131 123.011 229.496 122.916 228.853 122.942C228.211 122.936 227.567 122.937 226.927 123.021C225.018 123.193 223.145 123.652 221.35 124.322C221.11 123.571 220.844 122.828 220.547 122.099C219.785 120.271 218.861 118.474 217.735 116.874C217.608 116.665 217.469 116.462 217.307 116.275C217.209 116.169 217 115.67 216.942 115.549V115.548C216.915 115.424 216.825 115.399 216.811 115.268C216.786 114.979 216.651 114.848 216.366 114.766C216.05 114.674 215.766 114.569 215.548 114.299C215.299 113.977 214.993 113.705 214.708 113.416C214.653 113.361 214.604 113.289 214.58 113.217C214.532 113.063 214.536 112.881 214.45 112.752C214.304 112.532 214.017 112.641 213.823 112.529C213.321 112.246 212.927 111.829 212.466 111.491C212.335 111.397 212.274 111.248 212.206 111.094C212.069 110.78 212.056 110.766 211.706 110.77C211.339 110.769 211.12 110.589 210.962 110.274C210.89 110.131 210.802 109.997 210.702 109.831C209.057 108.89 207.263 108.149 205.395 107.743C205.154 107.805 204.926 107.936 204.696 107.99C204.46 108.052 204.415 107.708 204.171 107.672C204.088 107.663 204.007 107.638 203.925 107.634C203.571 107.598 203.142 107.698 202.876 107.511C202.519 107.277 202.106 107.251 201.714 107.43C201.568 107.503 201.44 107.611 201.304 107.7C201.099 107.584 200.893 107.467 200.669 107.34C199.354 107.382 198.032 107.6 196.739 107.916C196.36 108.009 195.987 108.113 195.618 108.227C195.467 107.665 195.307 107.106 195.118 106.557C194.496 104.809 193.679 103.133 192.661 101.571C192.53 101.378 192.41 101.175 192.264 100.989C192.171 100.887 192.005 100.386 191.937 100.28V100.279C191.911 100.161 191.822 100.139 191.808 100.014C191.779 99.7406 191.662 99.6036 191.389 99.5266C191.089 99.4386 190.829 99.3306 190.607 99.0856L189.817 98.2346C189.769 98.1796 189.72 98.1126 189.697 98.0436C189.649 97.8976 189.652 97.7216 189.566 97.6006C189.42 97.3996 189.144 97.5146 188.967 97.4046C188.523 97.1066 188.096 96.7766 187.679 96.4346C187.56 96.3426 187.506 96.1926 187.447 96.0386C187.318 95.7396 187.302 95.7286 186.963 95.7536C186.602 95.7826 186.401 95.6016 186.263 95.2826C186.201 95.1366 186.117 95.0086 186.022 94.8536C184.472 93.9546 182.749 93.3296 180.995 92.9396C180.763 93.0186 180.552 93.1216 180.333 93.1716C180.11 93.2236 180.071 92.8966 179.841 92.8646C179.763 92.8576 179.686 92.8366 179.609 92.8366C179.271 92.8286 178.867 92.8876 178.622 92.6956C178.289 92.4666 177.898 92.4606 177.525 92.6336C177.386 92.6966 177.263 92.7956 177.133 92.8756C176.945 92.7466 176.754 92.6436 176.542 92.5146C175.922 92.5406 175.297 92.5556 174.677 92.6596C174.055 92.7296 173.435 92.8276 172.825 92.9816C170.054 93.5916 167.468 94.7586 165.151 96.2396C164.385 96.7496 163.631 97.2606 162.902 97.8306C162.188 98.4156 161.432 98.9916 160.807 99.6026C160.643 99.7506 160.467 99.8906 160.315 100.054C160.229 100.154 159.786 100.376 159.68 100.438C159.569 100.472 159.559 100.561 159.442 100.582C159.184 100.629 159.071 100.75 159.026 101.024C158.973 101.326 158.901 101.601 158.666 101.814L157.872 102.589C157.822 102.638 157.755 102.681 157.686 102.698C157.541 102.735 157.37 102.718 157.25 102.792C157.199 102.823 157.168 102.866 157.148 102.913C156.653 101.713 156.303 100.476 156.226 99.1586C156.224 98.7936 156.361 98.4846 156.607 98.1816C156.724 98.0386 156.767 97.8806 156.707 97.7306C158.113 96.7506 159.463 95.6956 160.713 94.6336C160.926 94.5956 161.069 94.5486 161.217 94.5076C161.291 94.4876 161.379 94.4996 161.442 94.4626C161.647 94.3436 161.827 94.2106 161.838 93.9286C161.858 93.4746 162.076 93.2006 162.541 93.1486C162.619 93.1406 162.704 93.1386 162.772 93.1046C162.986 92.9946 163.166 92.8596 163.177 92.5856C163.191 92.1466 163.381 91.8556 163.861 91.7826C164.099 91.7476 164.31 91.6636 164.486 91.4776C164.884 90.9826 165.285 90.4866 165.67 90.0066C165.69 89.8246 165.705 89.6666 165.721 89.5096C165.77 89.0866 166.032 88.8036 166.368 88.5916C166.559 88.4676 166.799 88.4146 167.036 88.3226C167.789 87.4606 168.342 86.4616 168.974 85.5196C169.574 84.5566 170.247 83.6346 170.783 82.6376L172.349 79.6286L173.128 78.1246L173.774 76.5636L174.668 74.4246L175.068 73.4986C175.052 73.3316 175.021 73.1786 174.978 73.0316C174.957 72.9276 174.935 72.8226 174.915 72.7196C175.093 72.5996 175.271 72.4796 175.465 72.3486C175.688 71.7876 175.832 71.1966 176.018 70.6186C176.153 70.0266 176.306 69.4346 176.412 68.8346C176.895 66.1336 176.925 63.3436 176.68 60.7326C176.497 58.9736 176.214 57.2326 175.831 55.5186C175.792 55.3016 175.749 55.0866 175.681 54.8756C175.636 54.7526 175.656 54.2666 175.652 54.1456C175.679 54.0336 175.609 53.9816 175.651 53.8696C175.741 53.6226 175.703 53.4626 175.482 53.2956C175.244 53.1076 175.039 52.9166 174.966 52.6126L174.671 51.5636C174.65 51.4986 174.643 51.4206 174.657 51.3526C174.69 51.2096 174.784 51.0666 174.772 50.9296C174.75 50.6996 174.455 50.6646 174.359 50.4926C174.114 50.0476 173.985 49.5546 173.815 49.0806C173.766 48.9456 173.805 48.8026 173.844 48.6546C173.922 48.3516 173.92 48.3376 173.639 48.1706C173.341 47.9926 173.295 47.7386 173.375 47.4286C173.41 47.2876 173.43 47.1456 173.461 46.9756C172.847 45.4386 172.152 43.9136 171.414 42.4246C171.213 42.3066 171.008 42.2156 170.836 42.0866C170.662 41.9536 170.914 41.7256 170.811 41.5356C170.774 41.4736 170.75 41.4026 170.707 41.3446C170.532 41.0866 170.255 40.8156 170.289 40.5186C170.323 40.1276 170.155 39.8156 169.818 39.6136C169.695 39.5366 169.549 39.4896 169.417 39.4266C169.436 39.2106 169.455 38.9936 169.477 38.7596C168.924 37.7526 168.309 36.7686 167.708 35.7766C166.326 33.5616 164.828 31.4226 163.256 29.3486C162.205 27.9636 161.117 26.6106 159.983 25.2976C159.842 25.1316 159.713 24.9556 159.559 24.7996C159.465 24.7116 159.266 24.2706 159.209 24.1646H159.21C159.182 24.0556 159.096 24.0416 159.081 23.9246C159.05 23.6686 158.937 23.5516 158.67 23.5006C158.376 23.4386 158.109 23.3596 157.914 23.1196C157.68 22.8466 157.437 22.5776 157.191 22.3146C157.144 22.2656 157.105 22.1996 157.088 22.1306C157.058 21.9876 157.08 21.8186 157.011 21.7006C156.894 21.5036 156.614 21.6006 156.454 21.4876C156.038 21.1986 155.724 20.7996 155.37 20.4426C155.27 20.3426 155.245 20.1966 155.218 20.0466C155.163 19.7406 155.156 19.7296 154.831 19.6956C154.483 19.6626 154.337 19.4536 154.288 19.1316C154.265 18.9876 154.226 18.8486 154.186 18.6796C152.991 17.5476 151.754 16.4286 150.494 15.3526C150.262 15.3276 150.034 15.3276 149.823 15.2796C149.609 15.2306 149.753 14.9176 149.585 14.7836C149.526 14.7396 149.478 14.6836 149.417 14.6456C149.155 14.4756 148.799 14.3316 148.713 14.0456C148.589 13.6766 148.304 13.4676 147.919 13.4066C147.776 13.3836 147.624 13.3956 147.479 13.3886C147.414 13.1816 147.347 12.9736 147.277 12.7476C146.357 12.0616 145.435 11.3526 144.472 10.7026C142.33 9.20657 140.103 7.82157 137.799 6.57857C136.251 5.76657 134.693 4.97456 133.071 4.30656C132.872 4.21656 132.676 4.11556 132.467 4.04256C132.342 4.00856 131.955 3.71156 131.856 3.64556V3.64456C131.78 3.55856 131.697 3.58556 131.629 3.48656C131.483 3.26956 131.327 3.21557 131.065 3.28857C130.777 3.36157 130.501 3.41757 130.21 3.30357L129.181 2.93756C129.117 2.91556 129.049 2.87456 129.002 2.81956C128.907 2.70456 128.841 2.54957 128.722 2.48057C128.519 2.36657 128.32 2.58757 128.122 2.56757C127.612 2.51857 127.136 2.32957 126.642 2.20457C126.503 2.16957 126.406 2.05457 126.304 1.93957C126.095 1.70357 126.081 1.69656 125.783 1.83356C125.468 1.97756 125.227 1.88456 125.009 1.64356C124.909 1.53656 124.8 1.44156 124.672 1.32056C123.042 0.986564 121.289 0.765563 119.534 0.726562C119.333 0.848563 119.159 0.989566 118.964 1.08057C118.768 1.17157 118.652 0.847567 118.427 0.856567C118.352 0.862567 118.274 0.853562 118.2 0.866562C117.879 0.911562 117.511 1.04257 117.231 0.884567C116.858 0.698567 116.485 0.753564 116.169 0.974564C116.05 1.05556 115.956 1.16956 115.851 1.26556C115.641 1.15856 115.431 1.07957 115.197 0.980568C114.008 1.16657 112.82 1.45257 111.677 1.87057C110.96 2.13357 110.257 2.43757 109.577 2.78857C109.304 2.60057 108.88 2.47356 108.645 2.55756C108.408 2.64156 108.18 2.75056 107.94 2.81956C107.583 2.91356 107.405 3.16757 107.258 3.45357C107.223 3.52557 107.174 3.58756 107.126 3.65956C106.855 3.80356 106.57 3.94256 106.299 4.10056C106.154 4.19056 106.016 4.21557 105.854 4.20757C105.221 4.18257 105.197 4.16956 104.752 4.47756C104.293 4.78256 104.291 4.78356 104.008 5.32556C103.983 5.38056 103.918 5.43957 103.865 5.45457C103.076 5.59557 103.072 5.59556 102.786 5.78456C102.266 6.13456 101.795 6.53457 101.301 6.91357C98.1843 9.35357 95.3704 12.1126 92.8714 15.1186C91.5604 16.5736 90.4413 18.1756 89.2623 19.7296C88.6603 20.4976 88.1753 21.3466 87.6273 22.1526C87.1023 22.9736 86.5373 23.7706 86.0493 24.6126C85.4493 25.6766 84.8193 26.8006 84.2193 27.8656C84.1433 28.0016 84.0633 28.0426 83.9073 28.0946C83.6823 28.1796 83.5734 28.2916 83.6044 28.5686C83.6974 29.1766 83.4283 29.5956 82.8833 29.8496C82.8403 29.8726 82.7783 29.9626 82.7873 30.0006C82.9023 30.3996 82.7914 30.7466 82.6163 31.0986C82.3123 31.7146 82.0163 32.3316 81.7323 32.9596C81.5953 33.2536 81.3804 33.4446 81.1174 33.5946C80.9124 33.7026 80.8104 33.9276 80.8674 34.1676C80.9434 34.4686 80.9933 34.7556 80.8653 35.0606C80.5823 35.7636 80.2984 36.4696 80.0274 37.1406C79.8004 37.3006 79.6114 37.4346 79.4184 37.5716C79.3894 37.6346 79.3563 37.7036 79.3233 37.7736C79.2654 37.9146 79.2193 38.0646 79.1503 38.2016C78.9743 38.5686 79.0273 38.9456 79.1893 39.3176C79.0193 39.4636 78.8514 39.6066 78.6564 39.7736C78.3764 40.6696 78.0943 41.5766 77.8083 42.4866C77.7293 42.7476 77.6504 43.0096 77.5704 43.2716C77.3284 43.4626 77.1074 43.7406 77.0993 43.9466C77.0893 44.1836 77.1053 44.4226 77.0793 44.6576C77.0613 44.7936 77.0833 44.9126 77.1193 45.0266L77.0663 45.2546C76.9553 45.7276 76.9443 45.7316 77.1873 46.3546C77.0833 46.4586 76.9934 46.5756 76.8844 46.6706C76.6864 46.8366 76.6493 47.0456 76.7093 47.2746C76.7563 47.4206 76.8263 47.5586 76.8873 47.7046C76.7293 47.8626 76.5713 48.0206 76.3733 48.2176C76.0603 49.4026 75.9203 50.6036 75.7453 51.7886C75.5773 52.9746 75.4103 54.1516 75.2433 55.3306C75.1303 56.5136 75.0863 57.7046 75.0004 58.8986C74.9434 60.0946 74.8013 61.2926 74.8043 62.5146C74.8033 62.6696 74.7563 62.7426 74.6453 62.8596C74.4933 63.0366 74.4563 63.1856 74.6183 63.4196C74.9703 63.9206 74.9113 64.4156 74.5343 64.8856C74.5053 64.9266 74.4894 65.0336 74.5144 65.0636C74.7934 65.3686 74.8463 65.7286 74.8423 66.1216C74.8403 66.8076 74.8463 67.4906 74.8653 68.1786C74.8713 68.5026 74.7634 68.7686 74.5954 69.0196C74.4613 69.2066 74.4704 69.4526 74.6293 69.6436C74.8324 69.8776 75.0054 70.1136 75.0274 70.4426C75.0894 71.1966 75.1534 71.9546 75.2124 72.6726C75.0814 72.9146 74.9723 73.1176 74.8603 73.3246C74.8623 73.3946 74.8643 73.4706 74.8663 73.5476C74.8783 73.6986 74.9033 73.8526 74.9033 74.0056C74.8953 74.4136 75.0773 74.7326 75.3743 74.9966C75.2723 75.2016 75.1733 75.4056 75.0583 75.6426C75.3753 77.4876 75.7003 79.3706 76.0243 81.2516C76.1053 81.7296 76.0953 81.7356 76.5593 82.1996C76.5033 82.3396 76.4663 82.4826 76.4043 82.6156C76.2813 82.8526 76.3453 83.0536 76.5073 83.2326C76.6163 83.3436 76.7423 83.4386 76.8643 83.5446C76.7953 83.7496 76.7253 83.9566 76.6384 84.2156C77.2673 86.5696 77.7943 88.8866 78.5193 91.1406C79.2943 93.3746 80.0703 95.6126 80.8693 97.9146C80.9183 98.0606 80.8923 98.1476 80.8383 98.2966C80.7643 98.5166 80.7853 98.6676 81.0253 98.8206C81.5423 99.1496 81.6763 99.6286 81.5043 100.199C81.4923 100.248 81.5203 100.352 81.5543 100.37C81.9283 100.547 82.1153 100.859 82.2613 101.222C82.5203 101.854 82.7853 102.481 83.0673 103.106C83.2003 103.4 83.1923 103.686 83.1063 103.988C83.0383 104.214 83.1223 104.444 83.3293 104.569C83.5913 104.721 83.8253 104.883 83.9463 105.188C84.2063 105.899 84.5653 106.566 84.8813 107.21C84.8473 107.479 84.8193 107.703 84.7903 107.932C84.8173 107.996 84.8473 108.065 84.8783 108.135C84.9453 108.27 85.0264 108.403 85.0824 108.543C85.2263 108.921 85.5154 109.151 85.8934 109.295C85.8734 109.519 85.8543 109.739 85.8313 109.996C86.6903 111.647 87.5193 113.361 88.4423 115.017C88.6883 115.43 88.6823 115.44 89.2923 115.721C89.2883 115.866 89.3023 116.01 89.2903 116.153C89.2613 116.405 89.3783 116.579 89.5813 116.702C89.7163 116.775 89.8644 116.828 90.0094 116.893C90.0034 117.111 89.9964 117.331 89.9884 117.604C91.2574 119.669 92.4324 121.717 93.7504 123.672C95.1043 125.602 96.4564 127.53 97.8504 129.517H97.8493C97.9363 129.645 97.9384 129.733 97.9144 129.895C97.8904 130.131 97.9414 130.276 98.2034 130.37C98.7644 130.573 98.9943 131.016 98.9513 131.622C98.9493 131.673 98.9963 131.77 99.0333 131.78C99.4313 131.863 99.6993 132.11 99.9314 132.423C100.343 132.962 100.761 133.497 101.193 134.027C101.399 134.275 101.464 134.55 101.455 134.859C101.445 135.091 101.585 135.291 101.819 135.36C102.113 135.441 102.384 135.541 102.58 135.802C103.039 136.397 103.5 136.993 103.937 137.561C103.958 137.834 103.974 138.062 103.993 138.295C104.032 138.353 104.074 138.414 104.117 138.478C104.209 138.597 104.312 138.711 104.394 138.839C104.607 139.181 104.931 139.348 105.324 139.41C105.349 139.636 105.374 139.858 105.402 140.116C106.545 141.579 107.854 142.948 109.082 144.384C109.398 144.745 109.393 144.755 110.037 144.915C110.06 145.061 110.1 145.2 110.115 145.343C110.133 145.599 110.279 145.749 110.498 145.831C110.644 145.877 110.797 145.901 110.95 145.936C110.984 146.153 111.017 146.372 111.059 146.643C111.734 147.447 112.423 148.217 113.121 148.973C113.092 149.008 113.06 149.043 113.031 149.09C112.853 149.357 112.681 149.623 112.36 149.767L111.259 150.321C111.191 150.356 111.107 150.381 111.029 150.381C110.867 150.379 110.693 150.318 110.543 150.36C110.289 150.428 110.299 150.733 110.13 150.881C109.692 151.255 109.181 151.522 108.684 151.807C108.545 151.889 108.381 151.887 108.211 151.887C107.869 151.891 107.844 151.882 107.719 152.223C107.586 152.584 107.326 152.711 106.973 152.721C106.815 152.727 106.657 152.75 106.465 152.77L105.305 153.59L104.199 154.5L103.095 155.416L102.064 156.418C101.995 156.666 101.955 156.908 101.867 157.13C101.778 157.356 101.465 157.197 101.29 157.372C101.232 157.434 101.162 157.483 101.118 157.555C100.91 157.849 100.722 158.25 100.41 158.354C100.002 158.5 99.7424 158.821 99.6344 159.236C99.5934 159.39 99.5914 159.552 99.5694 159.709C99.3393 159.788 99.1323 159.892 98.8913 159.991C98.5063 160.533 98.1204 161.078 97.7334 161.624C97.3444 162.17 97.0493 162.78 96.7063 163.358C95.2343 166.004 94.1184 168.827 93.5264 171.794C93.2553 172.767 93.1873 173.78 93.0633 174.78C92.9013 175.78 92.9503 176.788 92.9383 177.792C92.9363 178.044 92.9183 178.296 92.9343 178.55C92.9363 178.696 92.8233 179.239 92.8253 179.374C92.7823 179.493 92.8463 179.565 92.7903 179.683C92.6673 179.939 92.6904 180.126 92.8804 180.361C93.0844 180.623 93.2553 180.879 93.2764 181.232C93.3093 181.644 93.3464 182.058 93.4024 182.466C93.4174 182.542 93.4173 182.63 93.3953 182.704C93.3473 182.854 93.2394 182.997 93.2384 183.151C93.2374 183.413 93.5303 183.503 93.6084 183.712C93.8134 184.251 93.8923 184.821 93.9943 185.386C94.0243 185.544 93.9683 185.698 93.9113 185.859C93.7903 186.187 93.8043 186.199 94.0773 186.427C94.3743 186.669 94.4083 186.956 94.3003 187.288C94.2533 187.438 94.2243 187.593 94.1774 187.776C94.4424 188.672 94.6734 189.588 94.9704 190.477L95.9133 193.123C96.1063 193.283 96.3093 193.416 96.4733 193.586C96.6403 193.76 96.3634 193.973 96.4494 194.199C96.4804 194.275 96.4973 194.357 96.5333 194.429C96.6873 194.743 96.9653 195.077 96.9123 195.396C96.8533 195.816 97.0163 196.177 97.3383 196.458C97.4553 196.562 97.6003 196.638 97.7303 196.729C97.6943 196.961 97.6573 197.196 97.6183 197.448C98.1023 198.639 98.6043 199.843 99.1673 201.01L101.004 204.985L102.957 208.891C103.806 210.639 104.725 212.346 105.632 214.059C105.744 214.276 105.843 214.497 105.972 214.705C106.05 214.824 106.172 215.346 106.21 215.473C106.215 215.598 106.3 215.639 106.29 215.766C106.269 216.047 106.358 216.204 106.614 216.34C106.896 216.494 107.147 216.662 107.296 216.975C107.47 217.338 107.669 217.69 107.86 218.043C107.896 218.109 107.922 218.191 107.922 218.268C107.923 218.426 107.863 218.596 107.908 218.741C107.982 218.983 108.285 218.973 108.422 219.145C108.774 219.584 109.017 220.096 109.278 220.592C109.353 220.731 109.343 220.891 109.334 221.055C109.314 221.389 109.319 221.405 109.636 221.553C109.975 221.711 110.072 221.981 110.041 222.326C110.029 222.482 110.033 222.64 110.029 222.826C110.91 224.433 111.828 226.045 112.75 227.64C112.969 227.761 113.191 227.857 113.383 227.994C113.578 228.135 113.34 228.389 113.461 228.594C113.505 228.662 113.535 228.739 113.584 228.803C113.785 229.084 114.094 229.381 114.084 229.703C114.08 230.127 114.285 230.459 114.637 230.693C114.766 230.781 114.918 230.836 115.058 230.91C115.051 231.142 115.043 231.379 115.036 231.633C115.666 232.742 116.315 233.856 116.972 234.967L121.38 242.471L124.353 247.453C124.476 247.662 124.585 247.879 124.724 248.08C124.814 248.203 124.937 248.676 124.978 248.795C124.984 248.91 125.069 248.943 125.06 249.061C125.04 249.321 125.128 249.456 125.39 249.577C125.593 249.673 125.784 249.78 125.937 249.946C125.994 250.001 126.046 250.075 126.091 250.157L126.666 251.143C126.702 251.205 126.727 251.28 126.725 251.346C126.718 251.485 126.646 251.623 126.685 251.75C126.758 251.961 127.035 252.018 127.14 252.197C127.328 252.687 127.328 253.232 127.341 253.761C127.343 253.911 127.259 254.054 127.174 254.199C127.001 254.494 126.997 254.504 127.209 254.74C127.43 254.996 127.382 255.275 127.185 255.562C127.107 255.689 127.027 255.824 126.931 255.98C126.908 257.615 126.824 259.533 126.728 261.339C126.845 261.558 126.98 261.757 127.065 261.976C127.152 262.201 126.814 262.283 126.804 262.519C126.803 262.599 126.786 262.681 126.792 262.759C126.809 263.103 126.901 263.519 126.716 263.78C126.478 264.13 126.466 264.518 126.63 264.905C126.691 265.05 126.786 265.18 126.862 265.317C126.725 265.506 126.589 265.698 126.44 265.905C126.348 267.171 126.255 268.452 126.163 269.733L125.444 278.385L124.918 284.153C124.894 284.393 124.855 284.633 124.847 284.876C124.849 285.021 124.661 285.524 124.624 285.647L124.626 285.649H124.624C124.614 285.682 124.606 285.708 124.599 285.729C124.592 285.75 124.584 285.766 124.579 285.778L124.569 285.794L124.561 285.806L124.551 285.814L124.539 285.82C124.525 285.828 124.508 285.836 124.48 285.851C124.466 285.859 124.452 285.871 124.433 285.884C124.415 285.902 124.395 285.921 124.37 285.945C124.403 286.013 124.432 286.074 124.457 286.127C124.48 286.182 124.501 286.229 124.519 286.272L124.54 286.333L124.554 286.388L124.56 286.439V286.49L124.552 286.539L124.536 286.588L124.513 286.641L124.482 286.698C124.457 286.735 124.429 286.778 124.396 286.829C124.362 286.876 124.322 286.931 124.278 286.993L124.39 287.212L124.498 287.435L124.53 287.523L124.549 287.611L124.554 287.654L124.556 287.699L124.555 287.742L124.55 287.785L124.543 287.828L124.532 287.871L124.502 287.959L124.46 288.047L124.404 288.135C124.315 288.262 124.223 288.393 124.132 288.526L124.251 288.745L124.307 288.854L124.353 288.969L124.38 289.061L124.398 289.151L124.404 289.241L124.4 289.329L124.394 289.374L124.384 289.417L124.37 289.46L124.354 289.503L124.334 289.546L124.311 289.587L124.286 289.628L124.256 289.669L124.122 289.862L123.995 290.059L124.114 290.28L124.168 290.391L124.19 290.448L124.207 290.509L124.239 290.663L124.26 290.817L124.267 290.971L124.265 291.047L124.259 291.121L124.248 291.197L124.234 291.271L124.214 291.345L124.191 291.417L124.162 291.489L124.129 291.561L124.088 291.631L124.043 291.701C123.945 291.836 123.848 291.969 123.721 292.14C123.681 292.517 123.635 292.937 123.59 293.355L123.565 293.609L123.555 293.738L123.551 293.865L123.553 293.926L123.559 293.987L123.571 294.046L123.589 294.105L123.611 294.162L123.637 294.219L123.669 294.272L123.705 294.325L123.746 294.384L123.777 294.441L123.798 294.494L123.804 294.521L123.808 294.546L123.81 294.573L123.808 294.598L123.804 294.623L123.798 294.648L123.778 294.699L123.749 294.752C123.663 294.881 123.598 294.979 123.546 295.057C123.523 295.096 123.501 295.131 123.482 295.162C123.466 295.195 123.451 295.224 123.437 295.25L123.408 295.332L123.388 295.418C123.384 295.447 123.38 295.48 123.374 295.516C123.372 295.553 123.368 295.594 123.364 295.639L123.337 295.889L123.306 296.139L123.296 296.264L123.297 296.389L123.302 296.451L123.31 296.512L123.324 296.574L123.341 296.636L123.362 296.695L123.386 296.752L123.442 296.861L123.498 296.97L123.547 297.085L123.55 297.095L123.551 297.105V297.128L123.547 297.153L123.539 297.18L123.516 297.237L123.49 297.286L123.37 297.483L123.243 297.676C123.317 297.826 123.389 297.973 123.472 298.139C123.341 298.328 123.207 298.524 123.05 298.75C122.904 300.15 122.755 301.586 122.607 303.006C122.619 303.053 122.63 303.096 122.64 303.137L122.657 303.198L122.678 303.255L122.889 303.698L122.741 303.934L122.696 304.016L122.671 304.057L122.642 304.092L122.601 304.143L122.564 304.192L122.533 304.245L122.507 304.298L122.485 304.353L122.467 304.412L122.455 304.474L122.447 304.538C122.396 304.942 122.334 305.444 122.279 305.88C122.267 305.989 122.257 306.095 122.246 306.194C122.239 306.294 122.232 306.385 122.226 306.467C122.225 306.51 122.224 306.549 122.222 306.584C122.224 306.621 122.224 306.654 122.224 306.686C122.228 306.715 122.23 306.745 122.232 306.768L122.239 306.801L122.248 306.83L122.254 306.844L122.264 306.858L122.278 306.87L122.296 306.882L122.339 306.907L122.394 306.928L122.425 306.94L122.443 306.944L122.463 306.946L122.548 306.956C122.608 306.962 122.672 306.966 122.738 306.972C122.874 306.976 123.021 306.98 123.164 306.984C123.307 306.982 123.445 306.982 123.562 306.982L123.626 306.978L123.688 306.97L123.748 306.954L123.805 306.934L123.86 306.911L123.915 306.88L123.966 306.845L124.017 306.806L124.093 306.751L124.13 306.728L124.169 306.71L124.206 306.694L124.243 306.682L124.282 306.676L124.32 306.672H124.359L124.399 306.674L124.438 306.682L124.48 306.694L124.522 306.71L124.565 306.73C124.592 306.748 124.623 306.763 124.655 306.783L124.727 306.828L124.801 306.867L124.875 306.9L124.951 306.927L125.026 306.95L125.103 306.968L125.179 306.982L125.257 306.992L125.361 306.996L125.463 306.992L125.567 306.98L125.669 306.959L125.769 306.928L125.869 306.887L125.967 306.836L126.063 306.775L126.131 306.73L126.197 306.697L126.259 306.674L126.319 306.66L126.376 306.654L126.431 306.656L126.484 306.664L126.535 306.678L126.585 306.698L126.634 306.721L126.729 306.78L126.92 306.909L127.11 306.772L127.207 306.71L127.256 306.685L127.307 306.664L127.358 306.648L127.411 306.638L127.465 306.636L127.521 306.642L127.578 306.658L127.638 306.685L127.7 306.722L127.764 306.773L127.815 306.812L127.868 306.847L127.923 306.874L127.979 306.897L128.037 306.917L128.098 306.929L128.16 306.937L128.226 306.941L130.191 306.935C130.08 308.337 130.09 309.742 130.244 311.121C130.482 313.025 130.973 314.881 131.738 316.609C131.838 316.826 131.926 317.052 132.039 317.255C132.1 317.372 132.232 317.933 132.295 318.052L132.294 318.054C132.315 318.191 132.391 318.208 132.4 318.353C132.423 318.671 132.522 318.822 132.748 318.892C132.99 318.978 133.22 319.072 133.418 319.347L134.117 320.288C134.166 320.343 134.213 320.417 134.239 320.495C134.291 320.661 134.302 320.864 134.386 320.997C134.531 321.22 134.756 321.077 134.915 321.194C135.315 321.514 135.755 321.85 136.153 322.223C136.182 322.246 136.2 322.285 136.223 322.317C136.196 322.301 136.174 322.288 136.145 322.272C134.213 322.29 132.242 322.307 130.272 322.327C129.772 322.329 129.768 322.319 129.204 322.702C129.073 322.626 128.934 322.565 128.811 322.483C128.596 322.329 128.379 322.342 128.165 322.454C128.03 322.534 127.907 322.636 127.772 322.727C127.579 322.612 127.383 322.495 127.141 322.348C122.103 322.428 117.334 322.502 112.282 322.582C112.122 322.582 112.046 322.533 111.921 322.424C111.734 322.272 111.579 322.233 111.344 322.397C110.835 322.749 110.318 322.69 109.831 322.313C109.788 322.284 109.679 322.268 109.647 322.293C109.335 322.572 108.961 322.625 108.555 322.621C107.846 322.619 107.138 322.625 106.426 322.644C106.09 322.656 105.82 322.539 105.569 322.343C105.381 322.195 105.13 322.185 104.924 322.327C104.67 322.511 104.418 322.665 104.076 322.661C103.293 322.661 102.506 322.663 101.759 322.665C101.522 322.515 101.322 322.39 101.12 322.263C101.048 322.259 100.971 322.253 100.891 322.249C100.735 322.249 100.575 322.263 100.418 322.249C100 322.21 99.6543 322.364 99.3483 322.638C99.1493 322.521 98.9523 322.406 98.7233 322.271C96.7913 322.289 94.8193 322.306 92.8483 322.326C92.3483 322.328 92.3444 322.318 91.7803 322.701C91.6504 322.625 91.5114 322.564 91.3894 322.482C91.1744 322.328 90.9573 322.341 90.7433 322.453C90.6063 322.533 90.4834 322.635 90.3504 322.726C90.1564 322.611 89.9613 322.494 89.7173 322.347C84.6803 322.427 79.9103 322.501 74.8603 322.581C74.6993 322.581 74.6233 322.532 74.4993 322.423C74.3113 322.271 74.1573 322.232 73.9213 322.396C73.4123 322.748 72.8943 322.689 72.4073 322.312C72.3663 322.283 72.2554 322.267 72.2254 322.292C71.9114 322.571 71.5373 322.624 71.1323 322.62C70.4233 322.618 69.7153 322.624 69.0033 322.643C68.6683 322.655 68.3973 322.538 68.1463 322.342C67.9594 322.194 67.7064 322.184 67.5014 322.326C67.2484 322.51 66.9943 322.664 66.6533 322.66C65.8703 322.66 65.0834 322.662 64.3363 322.664C64.0984 322.514 63.9003 322.389 63.6973 322.262C63.6253 322.258 63.5473 322.252 63.4683 322.248C63.3123 322.248 63.1503 322.262 62.9933 322.248C62.5753 322.209 62.2304 322.363 61.9234 322.637C61.7244 322.52 61.5274 322.405 61.2984 322.27C59.3664 322.288 57.3953 322.305 55.4253 322.325C54.9253 322.327 54.9213 322.317 54.3573 322.7C54.2263 322.624 54.0873 322.563 53.9643 322.481C53.7493 322.327 53.5323 322.34 53.3183 322.452C53.1833 322.532 53.0603 322.634 52.9253 322.725C52.7323 322.61 52.5364 322.493 52.2944 322.346C47.2554 322.426 42.4853 322.5 37.4333 322.58C33.9173 322.582 30.1193 322.586 26.6153 322.59C26.4333 322.492 26.2964 322.418 26.1604 322.346C26.0924 322.307 26.0353 322.237 25.9653 322.219C25.7363 322.158 25.5184 322.127 25.3194 322.319C24.9984 322.628 24.6474 322.667 24.2814 322.378C24.2214 322.327 24.1593 322.271 24.0893 322.245C23.8623 322.173 23.6443 322.141 23.4433 322.327C23.1233 322.628 22.7773 322.7 22.4003 322.413C22.2133 322.27 22.0113 322.181 21.7583 322.186C21.1283 322.194 20.4974 322.202 19.8904 322.209C19.7394 322.309 19.6094 322.397 19.4783 322.484C19.1234 322.714 18.7363 322.689 18.3613 322.562C18.1463 322.492 17.9593 322.339 17.7443 322.212C13.2283 322.257 8.71335 322.3 4.20435 322.345L1.88234 322.359L0.87134 322.351C0.49134 322.552 0.195344 322.792 0.0163443 323.154C0.0173443 323.3 0.0183421 323.459 0.0203421 323.609C0.0203421 323.681 0.0203399 323.754 0.0243399 323.826C0.0283399 323.908 0.036353 323.99 0.028353 324.07C0.007353 324.326 -0.0106497 324.652 0.14435 324.82C0.35535 325.174 1.49035 325.158 1.76035 324.986C1.89135 324.9 2.02435 324.953 2.15535 324.861L2.66335 324.681L3.15134 324.677C3.32734 324.79 3.46935 324.863 3.59035 324.958C3.89335 325.202 4.16035 325.101 4.43035 324.901C4.61635 324.764 4.80935 324.663 5.06935 324.665C5.85635 324.675 6.64334 324.653 7.42334 324.645C7.56834 324.733 7.70135 324.815 7.83435 324.897C8.24935 325.155 8.72434 325.161 9.13434 324.854C9.35934 324.686 9.53034 324.708 9.72034 324.87C9.84734 324.977 9.98235 325.042 10.1404 325.042L13.9233 325.001C14.0773 325.001 14.2123 324.925 14.3353 324.813C14.3943 324.764 14.4613 324.721 14.5313 324.686C14.9013 324.5 15.2823 324.483 15.6413 324.688C15.9113 324.84 16.1533 325.014 16.4963 324.999C17.2053 324.972 17.9143 324.978 18.6233 324.968C18.7833 324.968 18.9184 324.906 19.0434 324.79C19.2304 324.626 19.4024 324.606 19.6294 324.767C20.0514 325.068 20.5223 325.068 20.9263 324.759C21.2743 324.495 21.4753 324.724 21.7143 324.892C21.9513 324.722 22.1703 324.454 22.4903 324.757C22.6153 324.87 22.7544 324.925 22.9144 324.925L25.7504 324.915L32.8443 324.862C32.9983 324.862 33.1524 324.919 33.2684 325.034C33.4724 325.237 33.6533 325.182 33.8423 325.016C33.9663 324.907 34.1093 324.856 34.2703 324.856C35.1353 324.844 36.0023 324.833 36.8703 324.821C37.0714 324.817 37.2764 324.993 37.4364 325.071C37.5474 325.124 37.6204 325.067 37.7254 325.135C37.9584 325.281 38.1333 325.276 38.3683 325.11C38.6303 324.932 38.8894 324.786 39.2254 324.799L40.4073 324.801C40.4813 324.801 40.5634 324.819 40.6304 324.854C40.7674 324.928 40.8864 325.061 41.0304 325.092C41.2744 325.141 41.4053 324.871 41.6143 324.832C42.1563 324.732 42.7083 324.764 43.2573 324.77C43.4113 324.77 43.5444 324.856 43.6814 324.942C43.9604 325.12 43.9743 325.122 44.2493 324.915C44.5423 324.694 44.8194 324.737 45.1034 324.929C45.2324 325.015 45.3684 325.085 45.5274 325.177C47.3144 325.159 49.1254 325.142 50.9274 325.126C51.1354 324.995 51.3224 324.847 51.5314 324.747C51.7444 324.645 51.8463 324.977 52.0803 324.972C52.1593 324.968 52.2393 324.978 52.3163 324.968C52.6523 324.929 53.0533 324.806 53.3223 324.972C53.6813 325.183 54.0644 325.167 54.4314 324.976C54.5684 324.906 54.6883 324.8 54.8183 324.714C55.0133 324.835 55.2114 324.956 55.4234 325.087C56.6674 325.075 57.9293 325.064 59.1913 325.052L67.7013 324.978L73.3773 324.933C73.6133 324.933 73.8513 324.947 74.0883 324.929C74.2283 324.913 74.7343 325.046 74.8613 325.072C74.9703 325.125 75.0433 325.068 75.1503 325.136C75.3823 325.282 75.5574 325.277 75.7934 325.111C76.0544 324.933 76.3133 324.787 76.6503 324.8L77.8313 324.802C77.9053 324.802 77.9883 324.82 78.0543 324.855C78.1913 324.929 78.3094 325.062 78.4534 325.093C78.6974 325.142 78.8294 324.872 79.0394 324.833C79.5804 324.733 80.1334 324.765 80.6814 324.771C80.8363 324.771 80.9684 324.857 81.1044 324.943C81.3834 325.121 81.3983 325.123 81.6723 324.916C81.9663 324.695 82.2424 324.738 82.5264 324.93C82.6553 325.016 82.7923 325.086 82.9503 325.178C84.7383 325.16 86.5504 325.143 88.3504 325.127C88.5594 324.996 88.7463 324.848 88.9553 324.748C89.1683 324.646 89.2693 324.978 89.5023 324.973C89.5823 324.969 89.6623 324.979 89.7403 324.969C90.0743 324.93 90.4764 324.807 90.7464 324.973C91.1054 325.184 91.4864 325.168 91.8533 324.977C91.9903 324.907 92.1113 324.801 92.2403 324.715C92.4363 324.836 92.6334 324.957 92.8454 325.088C94.0914 325.076 95.3524 325.065 96.6134 325.053L105.125 324.979L110.799 324.934C111.037 324.934 111.274 324.948 111.512 324.93C111.651 324.914 112.158 325.047 112.283 325.073C112.394 325.126 112.467 325.069 112.572 325.137C112.805 325.283 112.98 325.278 113.215 325.112C113.477 324.934 113.736 324.788 114.072 324.801L115.254 324.803C115.328 324.803 115.41 324.821 115.477 324.856C115.614 324.93 115.733 325.063 115.877 325.094C116.121 325.143 116.252 324.873 116.461 324.834C117.003 324.734 117.555 324.766 118.104 324.772C118.258 324.772 118.391 324.858 118.528 324.944C118.807 325.122 118.821 325.124 119.096 324.917C119.389 324.696 119.666 324.739 119.95 324.931C120.079 325.017 120.215 325.087 120.374 325.179C122.161 325.161 123.972 325.144 125.774 325.128C125.982 324.997 126.169 324.849 126.378 324.749C126.591 324.647 126.693 324.979 126.927 324.974C127.006 324.97 127.086 324.98 127.163 324.97C127.499 324.931 127.9 324.808 128.169 324.974C128.528 325.185 128.911 325.169 129.278 324.978C129.415 324.908 129.535 324.802 129.665 324.716C129.86 324.837 130.058 324.958 130.27 325.089C131.514 325.077 132.776 325.066 134.038 325.054L140.948 324.993C141.655 325.163 142.372 325.29 143.093 325.348C143.308 325.239 143.497 325.108 143.703 325.03C143.913 324.942 144.015 325.26 144.249 325.255C144.327 325.249 144.409 325.259 144.485 325.247C144.821 325.196 145.212 325.085 145.491 325.222C145.864 325.386 146.252 325.322 146.591 325.083C146.648 325.044 146.695 324.993 146.745 324.946L147.403 324.94C147.464 324.961 147.52 324.981 147.585 325.004C147.675 324.984 147.763 324.957 147.853 324.936L148.224 324.934C148.46 324.934 148.698 324.948 148.935 324.93C149.075 324.914 149.581 325.047 149.708 325.073C149.817 325.126 149.89 325.069 149.997 325.137C150.229 325.283 150.404 325.278 150.64 325.112C150.901 324.934 151.16 324.788 151.497 324.801L152.678 324.803C152.752 324.803 152.835 324.821 152.901 324.856C153.038 324.93 153.156 325.063 153.3 325.094C153.544 325.143 153.676 324.873 153.886 324.834C154.427 324.734 154.98 324.766 155.528 324.772C155.683 324.772 155.815 324.858 155.951 324.944C156.23 325.122 156.245 325.124 156.519 324.917C156.813 324.696 157.089 324.739 157.373 324.931C157.502 325.017 157.639 325.087 157.797 325.179C159.585 325.161 161.397 325.144 163.197 325.128C163.406 324.997 163.593 324.849 163.802 324.749C164.015 324.647 164.116 324.979 164.349 324.974C164.429 324.97 164.509 324.98 164.587 324.97C164.921 324.931 165.323 324.808 165.593 324.974C165.952 325.185 166.333 325.169 166.7 324.978C166.837 324.908 166.958 324.802 167.087 324.716C167.283 324.837 167.48 324.958 167.692 325.089C168.938 325.077 170.199 325.066 171.46 325.054L179.972 324.98L185.646 324.935C185.884 324.935 186.121 324.949 186.359 324.931C186.498 324.915 187.005 325.048 187.13 325.074C187.241 325.127 187.314 325.07 187.419 325.138C187.652 325.284 187.827 325.279 188.062 325.113C188.324 324.935 188.583 324.789 188.919 324.802L189.644 324.804C189.974 324.902 190.308 324.982 190.646 325.056C190.671 325.068 190.697 325.089 190.724 325.095C190.749 325.099 190.769 325.089 190.792 325.089C191.364 325.206 191.942 325.302 192.522 325.349C192.737 325.24 192.926 325.109 193.133 325.031C193.342 324.943 193.444 325.261 193.678 325.256C193.758 325.25 193.838 325.26 193.914 325.248C194.25 325.197 194.641 325.086 194.92 325.223C195.236 325.362 195.561 325.328 195.859 325.174C197.439 325.158 199.031 325.143 200.619 325.129C200.827 324.998 201.014 324.85 201.223 324.75C201.436 324.648 201.538 324.98 201.772 324.975C201.851 324.971 201.931 324.981 202.008 324.971C202.344 324.932 202.745 324.809 203.014 324.975C203.373 325.186 203.756 325.17 204.123 324.979C204.26 324.909 204.38 324.803 204.51 324.717C204.705 324.838 204.903 324.959 205.115 325.09C206.359 325.078 207.621 325.067 208.883 325.055L217.393 324.981L223.069 324.936C223.305 324.936 223.543 324.95 223.78 324.932C223.92 324.916 224.426 325.049 224.553 325.075C224.662 325.128 224.735 325.071 224.842 325.139C225.074 325.285 225.249 325.28 225.485 325.114C225.746 324.936 226.005 324.79 226.342 324.803L227.523 324.805C227.597 324.805 227.68 324.823 227.746 324.858C227.883 324.932 228.001 325.065 228.145 325.096C228.389 325.145 228.521 324.875 228.731 324.836C229.272 324.736 229.825 324.768 230.373 324.774C230.528 324.774 230.66 324.86 230.796 324.946C231.075 325.124 231.09 325.126 231.364 324.919C231.658 324.698 231.934 324.741 232.218 324.933C232.347 325.019 232.484 325.089 232.642 325.181C234.43 325.163 236.242 325.146 238.042 325.13C238.251 324.999 238.438 324.851 238.647 324.751C238.86 324.649 238.961 324.981 239.194 324.976C239.274 324.972 239.354 324.982 239.432 324.972C239.766 324.933 240.168 324.81 240.438 324.976C240.797 325.187 241.178 325.171 241.545 324.98C241.682 324.91 241.803 324.804 241.932 324.718C242.128 324.839 242.325 324.96 242.537 325.091C243.783 325.079 245.044 325.068 246.305 325.056L254.817 324.982L260.491 324.937C260.729 324.937 260.966 324.951 261.204 324.933C261.343 324.917 261.853 325.052 261.977 325.076C262.227 325.127 262.068 325.125 262.273 325.299C262.754 324.977 262.754 324.977 263.249 325.285C263.376 325.195 263.499 325.101 263.633 325.019C263.845 324.894 264.052 324.902 264.288 325.039C264.415 325.115 264.544 325.191 264.675 325.269C264.804 325.177 264.923 325.072 265.063 325.003C265.281 324.894 265.501 324.88 265.718 325.026C265.84 325.106 265.974 325.171 266.103 325.245C266.234 325.153 266.353 325.042 266.498 324.985C266.869 324.84 267.25 324.805 267.617 325.02C267.75 325.104 267.881 325.186 268.054 325.293C268.406 325.293 268.797 325.293 269.189 325.293C269.346 325.293 269.506 325.297 269.663 325.279C269.811 325.263 269.954 325.193 270.069 325.074C270.204 324.935 270.321 324.908 270.458 324.984C270.971 325.273 270.973 325.283 271.315 325.271C271.624 325.253 271.944 325.326 272.237 325.185C272.378 325.117 272.493 325.003 272.632 324.931C272.677 324.908 272.765 324.937 272.824 324.966C272.956 325.027 273.081 325.099 273.21 325.169C273.339 325.079 273.468 324.991 273.612 324.892C273.8 324.999 273.993 325.111 274.219 325.244C275.525 325.232 276.864 325.219 278.19 325.207C278.27 325.17 278.346 325.15 278.412 325.109C278.542 325.021 278.669 324.937 278.799 324.849C278.931 324.913 279.073 324.96 279.189 325.052C279.324 325.152 279.453 325.2 279.621 325.195L291.731 325.093L292.521 325.085L294.104 325.245L296.171 325.054C296.587 325.052 296.816 324.966 297.146 325.204C297.333 325.337 297.847 325.282 298.062 325.12C298.367 324.893 298.212 325.134 298.988 325.009C299.254 324.97 299.406 324.749 299.406 324.542L299.402 323.827L299.398 323.163C299.394 322.843 298.785 322.272 298.447 322.27C298.211 322.266 297.974 322.29 297.738 322.27C297.395 322.237 297.144 322.411 296.887 322.584C296.825 322.633 296.754 322.664 296.68 322.707C296.372 322.709 296.056 322.703 295.742 322.717C295.572 322.731 295.437 322.69 295.299 322.608C294.759 322.284 294.757 322.292 294.213 322.301C293.658 322.307 293.66 322.307 293.124 322.608C293.072 322.641 292.984 322.655 292.932 322.637C292.187 322.326 292.189 322.325 291.843 322.326L289.951 322.34C281.91 322.406 273.871 322.475 265.832 322.541C264.572 322.555 263.242 322.566 261.98 322.58C261.82 322.58 261.744 322.531 261.619 322.422C261.432 322.27 261.277 322.231 261.042 322.395C260.533 322.747 260.016 322.688 259.529 322.311C259.486 322.282 259.377 322.266 259.345 322.291C259.033 322.57 258.659 322.623 258.253 322.619C257.544 322.617 256.836 322.623 256.124 322.642C255.788 322.654 255.518 322.537 255.267 322.341C255.079 322.193 254.828 322.183 254.622 322.325C254.368 322.509 254.116 322.663 253.774 322.659C252.991 322.659 252.204 322.661 251.457 322.663C251.22 322.513 251.02 322.388 250.818 322.261C250.746 322.257 250.669 322.251 250.589 322.247C250.433 322.247 250.273 322.261 250.116 322.247C249.698 322.208 249.352 322.362 249.046 322.636C248.847 322.519 248.65 322.404 248.421 322.269C246.489 322.287 244.517 322.304 242.546 322.324C242.046 322.326 242.042 322.316 241.478 322.699C241.348 322.623 241.209 322.562 241.087 322.48C240.872 322.326 240.655 322.339 240.441 322.451C240.304 322.531 240.181 322.633 240.048 322.724C239.854 322.609 239.659 322.492 239.416 322.345C234.378 322.425 229.608 322.499 224.558 322.579C224.397 322.579 224.321 322.53 224.197 322.421C224.009 322.269 223.855 322.23 223.619 322.394C223.11 322.746 222.592 322.687 222.105 322.31C222.064 322.281 221.953 322.265 221.923 322.29C221.609 322.569 221.235 322.622 220.83 322.618C220.121 322.616 219.413 322.622 218.701 322.641C218.366 322.653 218.095 322.536 217.844 322.34C217.657 322.192 217.404 322.182 217.199 322.324C216.946 322.508 216.692 322.662 216.351 322.658C215.568 322.658 214.781 322.66 214.034 322.662C213.796 322.512 213.598 322.387 213.395 322.26C213.323 322.256 213.246 322.25 213.166 322.246C213.01 322.246 212.848 322.26 212.691 322.246C212.273 322.207 211.928 322.361 211.621 322.635C211.422 322.518 211.225 322.403 210.996 322.268C209.064 322.286 207.093 322.303 205.123 322.323C204.623 322.325 204.619 322.315 204.055 322.698C203.924 322.622 203.785 322.561 203.662 322.479C203.447 322.325 203.23 322.338 203.016 322.45C202.881 322.53 202.758 322.632 202.623 322.723C202.588 322.702 202.551 322.68 202.515 322.659C204.297 321.526 205.889 320.097 207.248 318.489C208.504 317.059 209.512 315.44 210.381 313.749C210.485 313.534 210.604 313.325 210.693 313.101C210.738 312.972 211.078 312.576 211.156 312.472H211.157C211.246 312.392 211.22 312.302 211.32 312.23C211.542 312.07 211.598 311.906 211.533 311.621C211.464 311.307 211.42 311.017 211.554 310.707C211.712 310.344 211.789 309.959 211.911 309.586C211.932 309.516 211.972 309.441 212.024 309.385C212.136 309.274 212.299 309.192 212.37 309.057C212.485 308.83 212.27 308.649 212.27 308.436C212.283 307.977 212.387 307.532 212.489 307.082L212.663 307.184C212.787 307.094 212.909 307.004 213.048 306.905C213.228 307.014 213.412 307.126 213.628 307.257C214.876 307.245 216.158 307.234 217.425 307.222C217.464 307.204 217.501 307.189 217.536 307.173L217.588 307.152L217.637 307.125L218.007 306.865L218.23 306.984L218.306 307.021L218.344 307.041L218.379 307.066L218.427 307.101L218.476 307.132L218.524 307.157L218.574 307.177L218.625 307.193L218.678 307.203L218.735 307.209L218.794 307.211C219.154 307.213 219.605 307.217 219.993 307.221C220.093 307.221 220.187 307.219 220.276 307.217C220.364 307.213 220.446 307.209 220.52 307.205C220.557 307.201 220.59 307.199 220.624 307.195C220.655 307.189 220.686 307.185 220.712 307.181C220.739 307.175 220.763 307.169 220.784 307.163L220.813 307.153L220.838 307.141L220.849 307.133L220.86 307.121L220.87 307.107L220.879 307.087L220.896 307.042L220.91 306.983C220.917 306.942 220.924 306.893 220.932 306.842C220.937 306.789 220.941 306.731 220.947 306.672C220.951 306.551 220.955 306.42 220.959 306.293C220.958 306.166 220.957 306.043 220.957 305.939L220.953 305.88L220.945 305.825L220.931 305.774L220.911 305.725L220.886 305.678L220.857 305.631L220.822 305.586L220.782 305.543L220.728 305.477L220.706 305.446L220.687 305.413L220.672 305.382L220.661 305.349L220.653 305.316L220.649 305.283V305.25L220.653 305.217L220.661 305.182L220.673 305.147L220.689 305.11L220.71 305.073C220.727 305.05 220.743 305.024 220.762 304.997L220.807 304.935L220.847 304.871L220.881 304.809L220.908 304.745L220.931 304.679L220.949 304.613L220.963 304.549L220.973 304.481L220.979 304.393L220.975 304.305L220.963 304.217L220.942 304.129L220.913 304.043L220.872 303.957L220.821 303.873L220.76 303.791L220.717 303.73L220.684 303.673L220.661 303.62L220.647 303.569L220.641 303.52L220.643 303.473L220.652 303.426L220.667 303.383L220.687 303.34L220.71 303.299L220.768 303.217L220.898 303.053L220.763 302.889L220.701 302.805L220.676 302.764L220.655 302.719L220.639 302.676L220.629 302.631L220.628 302.584L220.635 302.537L220.651 302.486L220.678 302.435L220.715 302.382L220.766 302.327L220.805 302.284L220.84 302.239L220.869 302.192L220.892 302.143L220.911 302.094L220.924 302.041L220.933 301.988L220.936 301.931L220.942 299.286C220.962 297.081 220.981 294.878 221.001 292.677L221.005 292.622L221.014 292.569L221.029 292.516L221.049 292.465L221.074 292.416L221.103 292.369L221.139 292.324L221.179 292.283L221.216 292.248L221.246 292.215L221.27 292.18L221.29 292.147L221.306 292.114L221.315 292.081L221.32 292.048V292.015L221.316 291.982L221.306 291.949L221.294 291.916L221.278 291.883L221.237 291.817L221.182 291.751L221.145 291.706L221.115 291.659L221.089 291.612L221.069 291.561L221.053 291.51L221.043 291.457L221.037 291.404V291.347L221.088 288.927L221.09 288.892L221.096 288.857L221.106 288.822L221.118 288.787L221.151 288.721L221.192 288.653L221.28 288.526C221.307 288.485 221.333 288.446 221.356 288.411L221.358 288.409C221.415 288.327 221.36 288.268 221.43 288.188C221.584 288.014 221.581 287.877 221.423 287.69C221.252 287.479 221.113 287.272 221.135 287.01L221.177 286.096C221.18 286.037 221.201 285.975 221.239 285.926C221.321 285.824 221.459 285.738 221.496 285.629C221.557 285.441 221.292 285.326 221.265 285.162C221.19 284.738 221.245 284.312 221.277 283.889C221.285 283.77 221.377 283.672 221.468 283.571C221.657 283.366 221.66 283.356 221.466 283.132C221.259 282.89 221.314 282.679 221.519 282.472C221.61 282.378 221.686 282.277 221.787 282.161C221.833 280.776 221.969 279.388 222.066 277.999C221.951 277.827 221.816 277.669 221.731 277.499C221.644 277.325 221.982 277.276 221.992 277.097C221.992 277.036 222.01 276.976 222.004 276.915C221.988 276.653 221.894 276.331 222.077 276.14C222.306 275.884 222.336 275.595 222.178 275.292C222.121 275.179 222.028 275.075 221.955 274.966C222.094 274.829 222.233 274.693 222.385 274.546C222.492 273.593 222.602 272.626 222.711 271.661C222.852 270.579 223.044 269.507 223.207 268.427C223.357 267.345 223.575 266.279 223.81 265.218L224.26 263.087L224.826 260.989C224.875 260.815 224.939 260.645 224.972 260.464C224.987 260.357 225.221 260.019 225.27 259.935C225.37 259.767 225.334 259.882 225.543 259.785C225.338 259.338 225.328 259.33 225.748 259.072C225.695 258.953 225.638 258.836 225.593 258.713C225.528 258.522 225.588 258.373 225.778 258.248L226.094 258.043C226.039 257.922 225.969 257.801 225.941 257.678C225.891 257.485 225.936 257.321 226.128 257.213C226.235 257.152 226.329 257.076 226.431 257.01C226.378 256.885 226.303 256.762 226.287 256.637C226.245 256.321 226.309 256.032 226.602 255.844C226.711 255.776 226.825 255.713 226.977 255.631C227.081 255.385 227.196 255.111 227.313 254.836C227.359 254.727 227.409 254.615 227.439 254.498C227.469 254.389 227.446 254.262 227.371 254.137C227.282 253.989 227.292 253.893 227.403 253.826C227.821 253.58 227.83 253.584 227.921 253.338C227.997 253.115 228.157 252.92 228.116 252.658C228.095 252.531 228.026 252.402 228.001 252.275C227.992 252.234 228.046 252.183 228.094 252.156C228.195 252.09 228.302 252.035 228.409 251.976C228.372 251.851 228.335 251.724 228.294 251.583C228.456 251.501 228.622 251.417 228.817 251.317C229.258 250.426 229.672 249.493 230.149 248.6C230.146 248.53 230.158 248.469 230.147 248.407L230.065 248.024C230.171 247.967 230.266 247.895 230.389 247.862C230.529 247.821 230.619 247.76 230.678 247.645C231.662 245.782 232.807 243.999 233.925 242.202C235.125 240.452 236.285 238.675 237.571 236.97C237.76 236.712 237.74 236.718 238.083 236.658C238.275 236.623 238.368 236.463 238.339 236.232C238.3 235.906 238.672 235.568 238.933 235.013C238.992 234.892 239.32 234.988 239.579 235.068C239.725 235.115 239.779 235.181 239.857 235.324C239.978 235.521 240.109 235.603 240.377 235.517C240.953 235.333 241.406 235.538 241.734 236.038C241.763 236.079 241.859 236.126 241.895 236.11C242.267 235.938 242.624 235.997 242.994 236.118C243.641 236.327 244.289 236.528 244.945 236.718C245.256 236.804 245.468 236.995 245.641 237.255C245.769 237.452 245.997 237.536 246.226 237.458C246.51 237.356 246.785 237.282 247.095 237.388C247.802 237.644 248.542 237.8 249.234 237.99C249.415 238.191 249.566 238.359 249.72 238.531C249.786 238.552 249.857 238.576 249.929 238.599C250.075 238.636 250.228 238.661 250.37 238.712C250.749 238.851 251.11 238.784 251.467 238.593C251.622 238.755 251.776 238.913 251.954 239.099C253.757 239.544 255.597 239.999 257.434 240.453C257.901 240.57 257.909 240.56 258.522 240.297C258.627 240.397 258.746 240.481 258.844 240.582C259.014 240.771 259.221 240.799 259.448 240.728C259.593 240.675 259.73 240.599 259.876 240.533C260.034 240.683 260.194 240.832 260.394 241.019C262.78 241.447 265.097 241.882 267.428 242.242C269.773 242.506 272.12 242.769 274.534 243.039C274.686 243.059 274.755 243.115 274.862 243.242C275.024 243.416 275.169 243.472 275.41 243.34C275.931 243.063 276.418 243.162 276.852 243.557C276.891 243.59 276.996 243.612 277.027 243.588C277.352 243.328 277.715 243.299 278.104 243.326C278.785 243.369 279.465 243.406 280.149 243.428C280.472 243.436 280.725 243.569 280.956 243.78C281.128 243.938 281.37 243.964 281.575 243.833C281.829 243.665 282.079 243.526 282.405 243.552C283.157 243.595 283.913 243.64 284.63 243.683C284.853 243.855 285.042 243.962 285.235 244.091C285.305 244.093 285.38 244.097 285.456 244.101C285.607 244.101 285.763 244.087 285.913 244.097C286.317 244.134 286.653 243.976 286.95 243.701C287.141 243.816 287.331 243.931 287.551 244.064C289.415 244.027 291.32 243.988 293.22 243.949C293.701 243.908 293.707 243.918 294.228 243.492C294.359 243.558 294.495 243.607 294.617 243.68C294.834 243.817 295.043 243.787 295.242 243.659C295.367 243.569 295.478 243.458 295.6 243.356C295.794 243.456 295.99 243.557 296.234 243.684C298.657 243.448 301.021 243.297 303.349 242.805C304.515 242.598 305.683 242.391 306.859 242.182C307.445 242.073 308.039 241.991 308.627 241.86C309.211 241.712 309.797 241.565 310.389 241.415V241.417C310.539 241.38 310.621 241.409 310.764 241.489C310.973 241.596 311.127 241.598 311.313 241.385C311.713 240.928 312.209 240.869 312.757 241.125C312.804 241.145 312.912 241.135 312.934 241.102C313.162 240.762 313.498 240.627 313.879 240.54C314.543 240.368 315.217 240.247 315.863 240.009C316.168 239.898 316.45 239.929 316.737 240.04C316.951 240.126 317.189 240.06 317.336 239.86C317.516 239.61 317.701 239.385 318.017 239.288C318.736 239.052 319.457 238.813 320.143 238.589C320.412 238.659 320.635 238.718 320.864 238.778C320.932 238.758 321.005 238.739 321.079 238.719C321.224 238.672 321.368 238.612 321.517 238.576C321.913 238.48 322.187 238.252 322.363 237.875C322.582 237.91 322.8 237.943 323.051 237.984C324.773 237.238 326.53 236.478 328.286 235.718C328.733 235.532 328.731 235.511 329.052 234.921C329.198 234.931 329.343 234.923 329.485 234.942C329.737 234.983 329.919 234.874 330.052 234.676C330.133 234.543 330.194 234.397 330.266 234.254C330.486 234.27 330.706 234.287 330.98 234.307C332.055 233.723 333.115 233.147 334.168 232.575C335.189 231.948 336.165 231.257 337.159 230.602C338.138 229.924 339.161 229.311 340.11 228.577C341.048 227.831 341.993 227.079 342.952 226.315C343.075 226.219 343.164 226.211 343.329 226.223C343.567 226.231 343.712 226.168 343.79 225.901C343.952 225.319 344.401 225.083 344.993 225.047C345.042 225.041 345.132 224.979 345.137 224.94C345.179 224.522 345.409 224.237 345.7 223.971C346.206 223.504 346.706 223.033 347.198 222.549C347.427 222.32 347.701 222.227 348.015 222.201C348.251 222.183 348.44 222.021 348.487 221.783C348.538 221.484 348.609 221.209 348.854 220.988C349.411 220.47 349.868 219.851 350.374 219.334C350.64 219.264 350.861 219.205 351.087 219.145C351.138 219.096 351.191 219.041 351.245 218.987C351.349 218.874 351.443 218.749 351.556 218.643C351.859 218.368 351.968 218.014 351.96 217.614C352.179 217.546 352.394 217.479 352.646 217.401C353.296 216.717 353.851 215.942 354.412 215.165C354.976 214.394 355.545 213.618 356.113 212.843C356.402 212.452 356.414 212.452 356.425 211.796C356.56 211.734 356.7 211.671 356.829 211.612C357.065 211.518 357.166 211.331 357.183 211.091C357.185 210.935 357.163 210.777 357.154 210.616C357.351 210.518 357.548 210.421 357.794 210.298C358.422 209.243 359.041 208.202 359.656 207.167C360.258 206.126 360.706 205.011 361.233 203.94L361.996 202.319C362.261 201.782 362.506 201.235 362.695 200.663C363.111 199.534 363.53 198.399 363.955 197.247C364.105 196.847 364.258 196.444 364.411 196.036C364.529 195.618 364.65 195.198 364.769 194.774C365.01 193.928 365.253 193.073 365.498 192.219C366.053 190.528 366.309 188.766 366.615 187.09C366.743 186.932 366.84 186.813 366.935 186.695C366.986 186.636 367.064 186.593 367.095 186.529C367.195 186.32 367.265 186.113 367.111 185.892C366.863 185.537 366.886 185.197 367.238 184.888C367.3 184.837 367.365 184.784 367.394 184.718C367.486 184.509 367.537 184.298 367.371 184.079C367.1 183.731 367.059 183.391 367.379 183.058C367.537 182.892 367.645 182.704 367.66 182.456C367.709 181.843 367.758 181.227 367.805 180.636C367.717 180.482 367.642 180.349 367.567 180.216C367.341 179.855 367.399 179.484 367.56 179.129ZM270.421 152.608C270.472 152.283 270.523 151.962 270.585 151.651C270.773 151.48 270.941 151.344 271.118 151.211C271.138 151.154 271.163 151.095 271.18 151.03C271.213 150.905 271.235 150.774 271.282 150.652C271.401 150.325 271.354 150.021 271.169 149.694C271.345 149.575 271.517 149.457 271.718 149.32C272.306 147.831 273.163 146.418 274.203 145.155C274.461 144.827 274.472 144.842 274.487 144.257C274.626 144.224 274.754 144.177 274.889 144.153C275.133 144.12 275.243 143.979 275.284 143.778C275.305 143.647 275.304 143.509 275.317 143.37C275.522 143.337 275.729 143.306 275.987 143.265C278.993 140.445 282.783 138.301 286.925 136.736C287.057 136.687 287.136 136.709 287.277 136.775C287.482 136.863 287.619 136.845 287.763 136.629C288.075 136.158 288.536 136.068 289.056 136.295C289.099 136.311 289.197 136.295 289.214 136.263C289.391 135.907 289.698 135.774 290.044 135.674C290.648 135.501 291.251 135.328 291.858 135.153C292.144 135.07 292.407 135.125 292.668 135.261C292.862 135.365 293.08 135.32 293.224 135.139C293.402 134.913 293.588 134.716 293.886 134.657C294.57 134.521 295.247 134.34 295.907 134.246C296.14 134.357 296.336 134.449 296.536 134.543C296.599 134.536 296.668 134.531 296.738 134.52C296.873 134.495 297.011 134.458 297.15 134.445C297.521 134.428 297.798 134.231 298.029 133.921C298.22 134.011 298.411 134.101 298.631 134.203C300.322 133.941 302.063 133.745 303.807 133.6C304.252 133.571 304.254 133.58 304.735 133.169C304.855 133.239 304.982 133.293 305.094 133.368C305.293 133.51 305.485 133.486 305.67 133.363C305.787 133.275 305.894 133.174 306.01 133.077C306.186 133.187 306.364 133.3 306.586 133.439C311.061 133.236 315.33 133.331 319.818 133.814C319.961 133.834 320.023 133.89 320.119 134.014C320.265 134.189 320.395 134.244 320.625 134.112C321.121 133.826 321.576 133.947 321.949 134.379C321.982 134.412 322.078 134.441 322.107 134.42C322.425 134.187 322.763 134.191 323.121 134.254C323.746 134.354 324.371 134.453 325 134.553C325.296 134.598 325.512 134.76 325.695 134.994C325.83 135.172 326.048 135.224 326.255 135.119C326.512 134.984 326.767 134.871 327.064 134.941C327.748 135.091 328.434 135.244 329.086 135.387C329.257 135.583 329.398 135.747 329.545 135.915C329.606 135.935 329.672 135.956 329.738 135.977C329.873 136.01 330.015 136.034 330.146 136.081C330.497 136.21 330.833 136.136 331.168 135.938C331.31 136.096 331.448 136.254 331.61 136.437C333.266 136.883 334.956 137.358 336.611 137.924C337.032 138.068 337.03 138.077 337.635 137.882C337.719 137.992 337.815 138.089 337.888 138.207C338.014 138.418 338.198 138.475 338.415 138.437C338.556 138.406 338.693 138.35 338.838 138.306C338.958 138.476 339.078 138.646 339.228 138.859C343.403 140.443 347.276 142.216 351 144.677C351.117 144.757 351.146 144.835 351.174 144.988C351.223 145.207 351.313 145.314 351.577 145.298C352.152 145.259 352.48 145.598 352.598 146.149C352.611 146.194 352.678 146.264 352.715 146.26C353.103 146.201 353.403 146.355 353.674 146.586C354.152 146.986 354.654 147.357 355.125 147.768C355.352 147.956 355.451 148.202 355.482 148.491C355.503 148.71 355.663 148.858 355.884 148.882C356.167 148.902 356.433 148.946 356.642 149.159C357.133 149.636 357.616 150.134 358.039 150.614C358.065 150.864 358.077 151.073 358.086 151.284C358.12 151.333 358.155 151.388 358.196 151.437C358.279 151.538 358.374 151.631 358.446 151.739C358.635 152.03 358.942 152.153 359.317 152.212C359.318 152.412 359.319 152.61 359.319 152.839C360.27 154.126 361.122 155.54 361.747 157.057C361.897 157.448 361.886 157.445 362.436 157.798C362.401 157.919 362.368 158.047 362.314 158.164C362.209 158.371 362.27 158.539 362.434 158.69C362.547 158.784 362.678 158.866 362.805 158.96C362.736 159.138 362.642 159.319 362.532 159.538C363.512 163.633 362.52 167.92 359.899 171.278C359.813 171.383 359.731 171.407 359.573 171.426C359.344 171.461 359.233 171.535 359.245 171.783C359.267 172.32 358.893 172.607 358.327 172.662C358.28 172.668 358.206 172.724 358.209 172.76C358.245 173.129 358.044 173.377 357.794 173.612C357.366 174.032 356.894 174.401 356.445 174.803C356.237 174.998 355.967 175.035 355.68 175.008C355.462 174.983 355.289 175.096 355.239 175.313C355.177 175.583 355.099 175.842 354.846 175.995C354.274 176.352 353.719 176.77 353.137 177.073C352.884 177.048 352.672 177.026 352.456 177.003C352.4 177.03 352.338 177.058 352.279 177.093C352.164 177.163 352.044 177.236 351.918 177.288C351.577 177.419 351.385 177.694 351.27 178.063C351.063 178.038 350.858 178.012 350.621 177.983C349.114 178.729 347.522 179.405 345.898 180.003C345.481 180.148 345.477 180.134 345.123 180.653C344.989 180.616 344.854 180.596 344.726 180.553C344.499 180.465 344.323 180.535 344.175 180.703C344.085 180.816 344.009 180.939 343.921 181.062C343.724 180.998 343.525 180.933 343.276 180.853C339.024 182.136 334.838 182.951 330.356 183.367C330.213 183.379 330.141 183.338 330.024 183.236C329.846 183.097 329.708 183.064 329.508 183.24C329.08 183.617 328.61 183.588 328.16 183.236C328.121 183.209 328.023 183.199 327.998 183.226C327.732 183.525 327.4 183.58 327.039 183.589C326.406 183.612 325.775 183.636 325.14 183.659C324.84 183.671 324.597 183.554 324.373 183.358C324.207 183.21 323.982 183.2 323.799 183.344C323.574 183.526 323.346 183.686 323.041 183.674C322.341 183.656 321.638 183.639 320.971 183.623C320.765 183.463 320.594 183.328 320.418 183.191C320.355 183.183 320.285 183.175 320.216 183.168C320.076 183.16 319.934 183.166 319.795 183.145C319.426 183.084 319.111 183.223 318.818 183.481C318.65 183.354 318.482 183.225 318.287 183.079C316.572 182.964 314.82 182.819 313.079 182.602C312.637 182.543 312.637 182.534 312.083 182.844C311.979 182.752 311.864 182.676 311.768 182.578C311.6 182.4 311.407 182.39 311.202 182.469C311.07 182.53 310.946 182.61 310.813 182.682C310.661 182.539 310.508 182.395 310.317 182.217C305.881 181.543 301.706 180.66 297.417 179.283C297.28 179.236 297.231 179.17 297.163 179.029C297.056 178.83 296.938 178.75 296.686 178.834C296.145 179.016 295.718 178.818 295.449 178.305C295.425 178.264 295.339 178.215 295.303 178.229C294.948 178.391 294.615 178.323 294.28 178.19C293.692 177.961 293.104 177.733 292.513 177.502C292.233 177.397 292.055 177.197 291.928 176.932C291.833 176.733 291.637 176.627 291.412 176.684C291.135 176.76 290.865 176.807 290.59 176.678C289.957 176.387 289.317 176.106 288.729 175.793C288.607 175.566 288.506 175.377 288.403 175.184C288.347 175.151 288.29 175.114 288.227 175.082C288.104 175.018 287.974 174.961 287.858 174.885C287.552 174.676 287.212 174.67 286.84 174.781C286.741 174.595 286.643 174.412 286.529 174.197C285.049 173.363 283.537 172.5 282.122 171.508C281.758 171.262 281.76 171.258 281.139 171.268C281.092 171.137 281.03 171.014 280.993 170.885C280.932 170.649 280.774 170.545 280.555 170.522C280.411 170.514 280.263 170.53 280.111 170.532C280.05 170.335 279.99 170.136 279.915 169.887C278.187 168.539 276.576 167.08 275.199 165.528C273.836 163.989 272.629 162.276 271.738 160.335C271.683 160.214 271.701 160.14 271.765 160.011C271.857 159.82 271.853 159.691 271.621 159.552C271.126 159.251 271.011 158.812 271.296 158.341C271.317 158.3 271.308 158.21 271.275 158.191C270.929 157.994 270.757 157.703 270.709 157.363C270.586 156.775 270.472 156.188 270.406 155.587C270.361 155.305 270.459 155.072 270.67 154.863C270.823 154.707 270.832 154.502 270.678 154.326C270.484 154.111 270.307 153.887 270.345 153.598C270.37 153.268 270.395 152.936 270.421 152.608ZM245.187 142.738C245.888 142.512 246.601 142.305 247.311 142.094C247.458 141.941 247.589 141.774 247.749 141.649C247.913 141.521 248.038 141.827 248.228 141.789C248.292 141.773 248.359 141.772 248.42 141.751C248.689 141.668 249.013 141.492 249.242 141.616C249.55 141.802 249.854 141.774 250.159 141.569C250.272 141.495 250.374 141.385 250.485 141.296C250.643 141.406 250.801 141.517 250.973 141.636C251.994 141.657 253.041 141.681 254.059 141.906C256.356 142.328 258.56 143.314 260.419 144.726C261.07 145.158 261.6 145.742 262.185 146.258C262.452 146.534 262.686 146.827 262.94 147.11C263.193 147.384 263.444 147.674 263.68 148.039C263.799 148.211 263.905 148.393 264.039 148.557C264.111 148.637 264.228 148.982 264.285 149.138L264.273 149.146C264.261 149.245 264.332 149.261 264.306 149.362C264.249 149.581 264.304 149.674 264.531 149.753C264.791 149.831 264.969 150.002 265.049 150.251C265.149 150.543 265.246 150.843 265.303 151.165C265.317 151.224 265.315 151.294 265.292 151.353C265.242 151.478 265.133 151.597 265.129 151.715C265.129 151.91 265.397 151.979 265.462 152.145C265.619 152.579 265.67 153.039 265.682 153.506C265.692 153.637 265.614 153.755 265.536 153.875C265.376 154.121 265.374 154.129 265.598 154.352C265.827 154.59 265.784 154.833 265.596 155.077C265.513 155.188 265.444 155.305 265.354 155.438C265.364 156.948 265.292 158.497 265.104 160.029C265.215 160.223 265.342 160.403 265.411 160.594C265.483 160.791 265.141 160.83 265.116 161.03C265.11 161.098 265.09 161.165 265.091 161.232C265.082 161.522 265.158 161.887 264.946 162.084C264.678 162.352 264.634 162.672 264.762 163.02C264.809 163.149 264.893 163.274 264.955 163.401C264.799 163.54 264.642 163.678 264.472 163.829C264.246 164.868 263.989 165.919 263.655 166.929C263.484 167.519 263.267 168.025 263.073 168.572L262.686 169.429L262.589 169.644C262.599 169.617 262.549 169.705 262.533 169.73C262.494 169.814 262.434 169.886 262.375 169.959C262.078 170.328 261.514 170.707 260.987 170.904C260.443 171.119 259.867 171.244 259.288 171.318C257.736 171.507 256.166 171.396 254.616 171.195C254.422 171.168 254.222 171.129 254.031 171.109C253.92 171.105 253.478 170.937 253.371 170.9C253.36 170.894 253.353 170.894 253.344 170.89C255.651 168.702 256.739 167.255 258.658 164.919L256.679 163.401C255.861 164.381 255.065 165.467 254.13 166.467C253.964 166.649 253.923 166.992 253.753 167.172C253.544 167.395 253.212 167.451 253.005 167.672C252.517 168.229 251.95 168.709 251.41 169.217C250.869 169.725 250.323 170.229 249.733 170.672C249.596 170.781 249.368 170.83 249.232 170.938C249.096 171.047 249.051 171.215 248.915 171.323C248.276 171.86 247.561 172.274 246.902 172.745C245.852 173.436 244.719 174.12 243.503 174.696C243.288 174.801 243.132 175.126 242.904 175.216C242.627 175.329 242.301 175.243 242.026 175.359C240.832 175.863 239.577 176.238 238.315 176.509C237.913 176.54 237.51 176.556 237.106 176.542C234.752 176.522 232.399 175.929 230.28 174.892C228.866 174.199 227.542 173.312 226.378 172.247C226.239 172.108 226.122 171.954 225.96 171.827C225.856 171.755 225.747 171.358 225.724 171.253C225.742 171.144 225.62 171.142 225.662 171.023C225.752 170.767 225.652 170.666 225.285 170.64C224.887 170.607 224.551 170.529 224.4 170.292C224.212 170.024 224.027 169.749 223.861 169.466C223.828 169.413 223.818 169.343 223.841 169.275C223.898 169.129 224.046 168.963 224.042 168.836C224.028 168.627 223.562 168.697 223.423 168.563C223.048 168.225 222.952 167.762 222.792 167.334C222.755 167.209 222.86 167.057 222.966 166.906C223.181 166.594 223.183 166.586 222.789 166.467C222.382 166.334 222.414 166.078 222.678 165.764C222.798 165.621 222.878 165.481 223.025 165.313C222.882 164.206 222.98 163.051 223.343 161.987C223.753 162.366 224.166 162.751 224.558 163.069C224.628 163.079 224.685 163.1 224.747 163.102L225.144 163.092C225.176 163.207 225.233 163.313 225.242 163.44C225.255 163.585 225.302 163.682 225.403 163.762C227.137 165.186 228.101 165.908 229.693 167.258L229.692 167.26C230.225 167.719 230.846 168.254 231.501 168.819L231.519 168.837L231.539 168.858C231.553 168.876 231.566 168.895 231.582 168.915C231.609 168.958 231.641 169.007 231.672 169.056C231.703 169.105 231.734 169.154 231.762 169.197C231.778 169.217 231.791 169.236 231.805 169.254L231.825 169.275L231.843 169.293C231.872 169.316 231.9 169.336 231.924 169.355L232.001 169.4L232.075 169.437L232.148 169.466L232.221 169.497L232.295 169.532L232.372 169.579C232.396 169.599 232.424 169.618 232.453 169.641L232.785 169.928C233.097 170.198 233.392 170.453 233.664 170.688C233.934 170.913 234.178 171.118 234.391 171.293L234.401 171.301L234.413 171.305L234.427 171.307L234.44 171.305L234.455 171.301L234.471 171.295L234.502 171.275C234.523 171.265 234.549 171.254 234.575 171.242L234.654 171.193C234.707 171.156 234.764 171.119 234.816 171.086C234.843 171.07 234.869 171.057 234.892 171.045L234.926 171.031L234.958 171.025L234.983 171.021L235.008 171.013L235.031 171.001L235.054 170.985L235.103 170.948L235.152 170.905L235.202 170.864L235.256 170.825L235.283 170.809L235.312 170.797L235.343 170.787L235.375 170.783C235.382 170.748 235.388 170.717 235.394 170.685C235.403 170.656 235.412 170.628 235.419 170.601L235.45 170.533L235.487 170.474L235.528 170.427L235.573 170.39L235.622 170.359L235.673 170.334L235.78 170.297L235.889 170.26L235.943 170.24L235.996 170.215L236.046 170.186L236.095 170.147L236.245 170.012L236.317 169.942L236.385 169.868L236.39 169.86L236.393 169.852L236.398 169.832L236.403 169.811L236.409 169.791L236.448 169.725L236.481 169.653L236.493 169.614L236.503 169.575L236.509 169.532L236.51 169.487L236.511 169.423L236.517 169.368L236.531 169.321L236.54 169.301L236.551 169.281L236.563 169.265L236.577 169.249L236.594 169.235L236.612 169.225L236.631 169.215L236.652 169.207L236.701 169.197C236.828 169.179 236.926 169.166 237.002 169.156C237.039 169.148 237.072 169.142 237.102 169.136C237.131 169.128 237.157 169.12 237.18 169.115L237.213 169.101L237.242 169.085L237.3 169.048C237.319 169.032 237.338 169.017 237.36 168.997C237.382 168.977 237.405 168.956 237.43 168.931L237.503 168.865L237.578 168.801L237.73 168.672L237.8 168.602L237.862 168.528L237.89 168.487L237.916 168.444L237.937 168.399L237.957 168.35C237.961 168.342 237.967 168.33 237.975 168.317C237.983 168.304 237.995 168.288 238.006 168.268C238.034 168.233 238.07 168.188 238.11 168.135C238.153 168.086 238.202 168.03 238.254 167.971C238.307 167.914 238.363 167.852 238.421 167.791L238.597 167.617C238.657 167.562 238.714 167.512 238.766 167.465C238.793 167.444 238.819 167.424 238.844 167.404C238.869 167.386 238.893 167.371 238.913 167.355C238.935 167.343 238.956 167.332 238.975 167.322L239 167.312L239.023 167.306C239.107 167.234 239.175 167.175 239.263 167.099H239.262C240.111 166.337 241.234 165.484 242.089 164.708C242.121 164.63 242.161 164.565 242.183 164.497C242.217 164.347 242.249 164.204 242.285 164.056C242.426 164.021 242.56 163.962 242.705 163.954C242.873 163.942 242.996 163.893 243.117 163.782C244.162 162.825 244.965 162.089 245.75 161.37C246.52 160.548 247.291 159.763 248.094 158.565C248.783 157.542 249.596 156.15 249.85 154.799C249.834 154.701 249.832 154.615 249.811 154.537C249.763 154.378 249.674 154.22 249.608 154.066C249.692 153.93 249.754 153.773 249.857 153.648C249.982 153.502 250.014 153.35 250.012 153.153C249.989 151.43 249.444 150.158 248.713 149.119C247.968 148.076 247.047 147.247 245.745 146.496C244.615 145.859 243.107 145.298 241.814 145.164C241.723 145.189 241.64 145.199 241.568 145.228C241.418 145.289 241.277 145.38 241.134 145.459C241.001 145.384 240.851 145.332 240.732 145.235C240.591 145.125 240.451 145.073 240.269 145.086C240.201 145.088 240.142 145.097 240.076 145.099C240.094 145.023 240.112 144.945 240.164 144.892C240.485 144.566 240.885 144.324 241.303 144.13C241.418 144.069 241.559 144.088 241.701 144.107C241.992 144.144 242 144.143 242.105 143.863C242.217 143.562 242.448 143.487 242.738 143.543C242.869 143.566 242.998 143.574 243.15 143.594C243.827 143.311 244.505 143.025 245.187 142.738ZM266.649 191.094C266.917 191.272 267.157 191.457 267.281 191.785C267.581 192.533 267.86 193.295 268.198 193.984C268.186 194.115 268.175 194.236 268.163 194.351C267.841 194.429 267.522 194.583 267.429 194.712C267.345 194.831 267.213 194.819 267.13 194.944L266.747 195.262L266.325 195.41C266.137 195.353 265.994 195.326 265.863 195.269C265.532 195.117 265.339 195.312 265.152 195.554C265.022 195.722 264.876 195.857 264.643 195.906C263.936 196.049 263.237 196.22 262.541 196.379C262.395 196.32 262.262 196.266 262.129 196.211C261.922 196.123 261.715 196.102 261.521 196.149C261.323 196.178 261.135 196.268 260.971 196.438C260.789 196.624 260.628 196.618 260.438 196.475C260.309 196.377 260.182 196.325 260.04 196.338C258.903 196.438 257.774 196.658 256.624 196.594C256.483 196.592 256.362 196.666 256.251 196.776C256.196 196.825 256.136 196.866 256.07 196.899C255.731 197.079 255.376 197.092 255.053 196.881C254.811 196.725 254.598 196.549 254.285 196.559C253.639 196.61 252.998 196.469 252.354 196.416C252.208 196.398 252.08 196.445 251.955 196.547C251.766 196.688 251.605 196.688 251.418 196.504C251.071 196.16 250.652 196.109 250.235 196.369C249.878 196.59 249.728 196.348 249.541 196.148C249.301 196.269 249.054 196.49 248.819 196.128C248.728 195.993 248.614 195.911 248.47 195.88L245.925 195.335C244.859 195.13 243.829 194.741 242.779 194.456C241.736 194.142 240.679 193.868 239.666 193.45C239.532 193.399 239.419 193.294 239.359 193.147C239.253 192.887 239.079 192.879 238.857 192.973C238.711 193.034 238.57 193.034 238.431 192.981C237.679 192.704 236.924 192.428 236.169 192.151C235.993 192.092 235.888 191.852 235.782 191.717V191.715C235.71 191.625 235.627 191.651 235.563 191.547C235.424 191.322 235.275 191.262 235.01 191.324C234.719 191.388 234.442 191.422 234.161 191.281L233.162 190.826C233.1 190.797 233.037 190.75 232.996 190.693C232.911 190.572 232.867 190.406 232.758 190.324C232.572 190.185 232.348 190.381 232.154 190.334C231.655 190.215 231.196 189.986 230.741 189.756C230.612 189.69 230.54 189.557 230.466 189.42C230.312 189.143 230.302 189.135 229.984 189.203C229.642 189.279 229.431 189.121 229.283 188.83C229.215 188.699 229.133 188.578 229.044 188.428C227.568 187.668 226.033 186.979 224.578 186.141C224.346 186.161 224.123 186.203 223.904 186.196C223.681 186.186 223.759 185.848 223.568 185.749C223.501 185.716 223.441 185.671 223.373 185.644C223.082 185.525 222.695 185.449 222.559 185.181C222.371 184.831 222.054 184.671 221.661 184.671C221.515 184.669 221.364 184.706 221.216 184.72C221.118 184.527 221.019 184.331 220.911 184.12C219.886 183.577 218.891 182.944 217.874 182.354L214.458 180.327L211.087 178.22C209.597 177.267 208.08 176.359 206.612 175.37C206.426 175.247 206.251 175.11 206.057 175.001C205.94 174.94 205.619 174.567 205.536 174.48C205.479 174.378 205.391 174.388 205.347 174.277C205.247 174.033 205.109 173.947 204.835 173.963C204.532 173.975 204.25 173.961 203.995 173.775L203.079 173.156C203.02 173.117 202.966 173.06 202.934 172.998C202.87 172.863 202.852 172.691 202.757 172.592C202.596 172.424 202.342 172.578 202.156 172.5C201.68 172.301 201.267 171.988 200.846 171.695C200.727 171.613 200.673 171.47 200.617 171.326C200.503 171.031 200.494 171.021 200.166 171.045C199.814 171.072 199.625 170.889 199.518 170.578C199.467 170.439 199.401 170.308 199.332 170.148C197.948 169.209 196.546 168.255 195.151 167.308C194.916 167.302 194.687 167.324 194.469 167.294C194.247 167.263 194.359 166.937 194.177 166.817C194.113 166.778 194.057 166.727 193.991 166.694C193.712 166.546 193.335 166.426 193.225 166.143C193.073 165.776 192.773 165.582 192.381 165.539C192.246 165.523 192.104 165.539 191.965 165.541C192.27 165.225 192.569 164.9 192.852 164.559C192.899 164.305 192.942 164.073 192.989 163.823C193.048 163.577 193.374 163.696 193.522 163.489C193.571 163.417 193.631 163.354 193.674 163.28C193.863 162.966 194.028 162.557 194.309 162.389C194.694 162.168 194.907 161.793 194.948 161.356C194.968 161.196 194.923 161.022 194.911 160.858C195.113 160.718 195.316 160.579 195.536 160.427C195.735 160.053 195.882 159.654 196.023 159.25C196.047 159.26 196.067 159.271 196.094 159.281C196.407 159.386 196.672 159.511 196.891 159.778C197.157 160.08 197.422 160.385 197.711 160.665C197.766 160.717 197.815 160.787 197.84 160.859C197.889 161.009 197.887 161.191 197.977 161.316C198.127 161.531 198.408 161.42 198.6 161.523C199.088 161.804 199.508 162.175 199.973 162.487C200.102 162.577 200.165 162.725 200.235 162.878C200.384 163.177 200.402 163.187 200.752 163.153C201.127 163.11 201.334 163.301 201.509 163.596C201.587 163.729 201.683 163.854 201.79 164.01C203.47 164.817 205.298 165.336 207.134 165.576C207.364 165.478 207.572 165.359 207.79 165.289C208.013 165.207 208.083 165.543 208.321 165.555C208.402 165.555 208.483 165.573 208.561 165.567C208.907 165.551 209.313 165.465 209.582 165.62C209.942 165.829 210.34 165.811 210.705 165.618C210.842 165.55 210.957 165.427 211.082 165.335C211.285 165.44 211.491 165.546 211.714 165.661C212.975 165.563 214.227 165.323 215.458 165.03C216.562 164.749 217.685 164.411 218.718 164.024C218.977 163.922 219.24 163.836 219.503 163.753C219.366 164.769 219.422 165.806 219.631 166.81C220.09 169.035 221.295 171.054 222.819 172.794C222.911 172.909 222.915 172.985 222.897 173.12C222.881 173.319 222.946 173.444 223.241 173.52C223.864 173.696 224.171 174.024 224.174 174.536C224.177 174.579 224.239 174.657 224.281 174.661C224.737 174.702 225.055 174.876 225.341 175.112C225.856 175.508 226.388 175.887 226.964 176.208C227.236 176.358 227.354 176.562 227.395 176.812C227.427 176.992 227.628 177.109 227.91 177.099C228.264 177.081 228.586 177.091 228.867 177.224C229.51 177.531 230.203 177.777 230.84 178.003C230.928 178.196 231.014 178.343 231.104 178.489C231.166 178.51 231.231 178.534 231.298 178.557C231.438 178.598 231.589 178.629 231.719 178.678C232.06 178.828 232.487 178.752 232.948 178.59C233.047 178.725 233.145 178.858 233.26 179.01C233.641 179.076 234.028 179.123 234.414 179.162L234.394 179.394C235.779 179.456 237.199 179.337 238.476 179.097C238.542 179.087 238.611 179.085 238.677 179.076C239.128 178.99 239.132 179.004 239.831 178.525C239.908 178.58 240.002 178.619 240.071 178.681C240.186 178.79 240.385 178.724 240.628 178.558C240.634 178.554 240.641 178.548 240.647 178.544C240.662 178.54 240.675 178.542 240.689 178.536C240.912 178.462 241.111 178.39 241.318 178.317C241.373 178.35 241.42 178.379 241.483 178.419C243.685 177.681 245.735 176.608 247.656 175.31C247.963 175.093 248.265 174.855 248.568 174.621C249.019 174.32 249.496 174 249.982 173.676C251.666 174.041 253.38 174.328 255.14 174.453C257.384 174.605 259.742 174.525 262.07 173.721C262.07 173.721 262.674 173.549 263.248 173.229C263.287 173.209 263.324 173.192 263.362 173.172C263.421 175.41 263.599 177.645 263.916 179.856C264.072 181.147 264.443 182.475 264.69 183.751C264.723 183.913 264.693 184.001 264.611 184.151C264.502 184.374 264.497 184.542 264.705 184.743C265.139 185.179 265.274 185.686 265.042 186.272C265.026 186.321 265.044 186.436 265.077 186.458C265.437 186.694 265.598 187.048 265.715 187.448C265.928 188.147 266.121 188.85 266.377 189.536C266.516 189.854 266.507 190.153 266.419 190.462C266.352 190.697 266.438 190.947 266.649 191.094ZM225.169 158.594C225.458 158.48 225.75 158.365 226.065 158.24C226.788 157.527 227.518 156.804 228.249 156.082C229.494 154.768 230.739 153.453 232.004 152.146L233.062 151.013C233.541 150.518 234.041 150.042 234.541 149.568L234.6 149.644C235.384 149.031 236.3 148.509 237.308 148.158C237.481 148.079 237.638 147.84 237.828 147.781C238.06 147.709 238.314 147.857 238.547 147.818C239.674 147.593 240.863 147.566 241.997 147.777C242.131 147.804 242.268 147.941 242.398 147.968C242.531 147.991 242.66 147.918 242.788 147.962C243.416 148.124 243.996 148.392 244.541 148.679C245.381 149.136 246.156 149.789 246.691 150.581C246.791 150.718 247.053 150.801 247.148 150.958C247.257 151.155 247.123 151.423 247.21 151.614C247.552 152.606 247.542 153.673 247.24 154.735C247.196 154.86 247.042 154.975 247 155.098C246.956 155.219 247.021 155.356 246.974 155.48C246.708 156.065 246.4 156.637 246.027 157.172C245.48 158.027 244.736 158.84 243.937 159.648C243.777 159.794 243.736 160.104 243.574 160.247C243.377 160.423 243.058 160.434 242.859 160.61C241.89 161.467 240.908 162.336 239.933 163.197C239.818 163.299 239.609 163.343 239.494 163.445C239.38 163.549 239.357 163.705 239.242 163.804C238.689 164.288 238.14 164.769 237.601 165.24V165.242C236.558 166.129 235.443 167.076 234.478 167.896C234.371 167.812 234.217 167.691 234.066 167.57L233.955 167.478L233.852 167.386C233.822 167.353 233.79 167.322 233.763 167.294L233.725 167.249L233.693 167.206L233.673 167.183L233.645 167.162L233.611 167.142L233.572 167.121C233.515 167.1 233.449 167.072 233.383 167.047L233.285 167.01C233.254 166.996 233.224 166.985 233.196 166.971L233.158 166.951L233.125 166.931L233.1 166.91L233.09 166.898L233.082 166.886C233.055 166.845 233.021 166.794 232.986 166.74C232.947 166.689 232.906 166.633 232.867 166.578C232.825 166.525 232.785 166.476 232.75 166.433C232.732 166.413 232.715 166.394 232.701 166.378C232.685 166.362 232.672 166.351 232.66 166.341C232.553 166.253 232.464 166.183 232.39 166.124C232.315 166.067 232.255 166.022 232.205 165.985C232.153 165.95 232.112 165.923 232.077 165.899C232.041 165.878 232.011 165.858 231.979 165.84C231.948 165.82 231.917 165.803 231.879 165.779C231.844 165.756 231.803 165.728 231.752 165.695C231.701 165.658 231.643 165.613 231.566 165.556C231.494 165.497 231.404 165.427 231.296 165.339C230.607 164.771 229.884 164.173 229.144 163.562C229.01 163.453 228.728 163.484 228.595 163.373C228.433 163.236 228.417 162.959 228.253 162.822C227.46 162.156 226.657 161.48 225.86 160.809C225.764 160.731 225.719 160.555 225.626 160.475C225.531 160.397 225.39 160.412 225.298 160.331C225.005 160.082 224.718 159.838 224.431 159.592C224.49 159.543 224.562 159.496 224.66 159.455C225.184 159.23 225.377 159.016 225.314 158.807C225.294 158.735 225.214 158.668 225.169 158.594ZM219.913 127.852C220.04 127.589 220.188 127.35 220.468 127.223C221.099 126.914 221.762 126.663 222.393 126.44C222.63 126.52 222.821 126.571 223.021 126.655C223.083 126.643 223.15 126.633 223.217 126.614C223.349 126.577 223.482 126.526 223.616 126.503C223.975 126.446 224.237 126.202 224.471 125.858C224.657 125.946 224.84 126.032 225.055 126.133C226.709 125.773 228.463 125.648 230.186 125.86C230.628 125.893 230.618 125.921 231.215 125.622C231.309 125.724 231.413 125.81 231.496 125.915C231.638 126.112 231.828 126.126 232.049 126.063C232.19 126.016 232.328 125.946 232.475 125.887C232.598 126.054 232.723 126.222 232.877 126.432C237.147 127.721 240.467 130.974 242.197 135.118C242.256 135.247 242.23 135.335 242.166 135.49C242.078 135.717 242.086 135.858 242.306 135.985C242.782 136.258 242.894 136.738 242.621 137.29C242.601 137.337 242.609 137.436 242.641 137.452C242.975 137.624 243.112 137.934 243.194 138.288C243.286 138.915 243.426 139.534 243.507 140.166C243.524 140.299 243.506 140.422 243.475 140.542C243.332 140.604 243.19 140.667 243.047 140.726C242.507 140.956 241.965 141.176 241.463 141.48C240.436 142.042 239.412 142.601 238.47 143.301C237.991 143.638 237.494 143.953 237.026 144.31C236.571 144.683 236.112 145.058 235.651 145.435C235.533 145.529 235.44 145.542 235.264 145.543C235.008 145.554 234.862 145.624 234.813 145.869C234.698 146.382 234.336 146.695 233.673 146.784C233.619 146.795 233.529 146.858 233.529 146.892C233.539 147.132 233.447 147.327 233.306 147.508C233.227 147.566 233.151 147.612 233.07 147.674L233.111 147.726C233.091 147.745 233.074 147.764 233.053 147.784C232.564 148.239 232.081 148.698 231.613 149.165C231.39 149.382 231.099 149.51 230.743 149.598C230.473 149.661 230.29 149.832 230.295 150.032C230.309 150.281 230.299 150.511 230.068 150.739C229.88 150.931 229.691 151.125 229.51 151.308C229.183 151.65 228.872 151.982 228.548 152.297C228.224 152.415 227.952 152.513 227.675 152.612C227.624 152.661 227.571 152.714 227.515 152.767C227.416 152.875 227.329 152.991 227.216 153.096C226.905 153.376 226.862 153.657 226.984 153.924C226.724 154.037 226.466 154.149 226.167 154.278C224.949 155.648 223.766 156.942 222.572 158.232C222.267 158.56 222.252 158.567 222.337 158.924C222.176 159.012 222.011 159.104 221.858 159.188C221.56 159.334 221.448 159.479 221.443 159.614C221.446 159.695 221.497 159.783 221.526 159.873C221.299 160.022 221.071 160.171 220.787 160.356C220.633 160.594 220.489 160.84 220.358 161.092C220.104 161.135 219.85 161.177 219.612 161.258C219.339 161.184 219.112 161.122 218.88 161.059C218.806 161.078 218.728 161.096 218.648 161.116L218.179 161.269C218.045 161.303 217.925 161.352 217.818 161.415C217.57 161.557 217.449 161.74 217.316 161.984C217.108 161.931 216.902 161.88 216.662 161.822C214.994 162.355 213.252 162.75 211.502 162.91C211.057 162.941 211.06 162.949 210.564 163.348C210.445 163.272 210.318 163.211 210.208 163.129C210.014 162.977 209.824 162.99 209.631 163.104C209.508 163.182 209.395 163.292 209.271 163.374C209.104 163.245 208.937 163.116 208.729 162.956C206.504 162.847 204.393 162.286 202.477 161.326C200.584 160.334 198.875 158.924 197.643 157.092C197.565 156.976 197.568 156.895 197.602 156.746C197.635 156.533 197.614 156.399 197.373 156.305C197.069 156.192 196.903 155.987 196.837 155.74C197.091 153.466 196.735 151.163 195.95 149.047C195.987 148.907 196.033 148.771 196.091 148.643C196.763 149.223 197.491 149.946 198.157 150.492C198.229 150.505 198.29 150.527 198.352 150.532C198.491 150.531 198.623 150.531 198.76 150.531C198.796 150.65 198.856 150.76 198.867 150.888C198.884 151.035 198.933 151.136 199.039 151.221C200.85 152.714 201.853 153.475 203.516 154.891L203.514 154.893C204.016 155.328 204.599 155.833 205.213 156.367L205.231 156.385L205.249 156.406C205.261 156.422 205.274 156.44 205.288 156.46C205.313 156.501 205.343 156.547 205.371 156.594C205.399 156.641 205.429 156.688 205.454 156.729C205.468 156.749 205.481 156.766 205.493 156.783L205.511 156.805L205.529 156.822C205.556 156.843 205.582 156.862 205.605 156.88L205.677 156.923L205.748 156.956L205.817 156.983L205.887 157.01L205.957 157.043L206.03 157.086C206.054 157.106 206.079 157.125 206.106 157.146L206.418 157.418C206.711 157.672 206.988 157.914 207.244 158.135C207.482 158.335 207.699 158.518 207.887 158.675L207.897 158.682L207.908 158.684L207.92 158.685L207.933 158.683L207.947 158.678L207.959 158.668L207.991 158.648C208.011 158.641 208.034 158.633 208.059 158.626L208.134 158.593C208.186 158.568 208.24 158.541 208.289 158.518L208.326 158.502L208.361 158.49L208.394 158.484L208.425 158.483L208.448 158.484L208.47 158.48L208.492 158.472L208.515 158.462L208.562 158.435L208.609 158.402L208.658 158.371L208.709 158.344L208.736 158.333L208.763 158.326L208.792 158.322L208.821 158.324C208.83 158.291 208.838 158.262 208.844 158.232C208.856 158.203 208.865 158.175 208.875 158.15L208.91 158.083L208.949 158.028L208.992 157.985L209.039 157.951L209.088 157.926L209.138 157.905L209.242 157.877L209.349 157.851L209.403 157.835L209.455 157.815L209.506 157.789L209.555 157.756L209.709 157.635L209.783 157.571L209.854 157.503L209.859 157.495L209.863 157.487L209.869 157.467L209.875 157.446L209.883 157.428L209.926 157.364L209.961 157.295L209.977 157.258L209.989 157.218L209.997 157.177L210.001 157.132L210.005 157.068L210.016 157.013L210.032 156.968L210.043 156.948L210.054 156.93L210.067 156.914L210.082 156.9L210.099 156.888L210.117 156.878L210.136 156.87L210.157 156.865L210.204 156.859C210.329 156.852 210.423 156.848 210.497 156.844C210.534 156.84 210.565 156.836 210.595 156.833C210.623 156.827 210.648 156.822 210.671 156.818L210.704 156.807L210.733 156.794L210.792 156.761C210.812 156.747 210.831 156.734 210.853 156.716C210.875 156.698 210.899 156.679 210.925 156.656L211 156.594L211.077 156.535L211.231 156.42L211.303 156.358L211.369 156.288L211.398 156.25L211.425 156.21L211.448 156.166L211.469 156.119C211.474 156.112 211.48 156.1 211.488 156.088C211.497 156.075 211.509 156.06 211.522 156.042C211.551 156.01 211.588 155.968 211.63 155.92C211.674 155.874 211.725 155.822 211.777 155.768C211.833 155.715 211.89 155.66 211.949 155.604L212.13 155.445C212.192 155.397 212.25 155.351 212.303 155.309C212.33 155.289 212.357 155.271 212.381 155.254C212.406 155.239 212.43 155.225 212.451 155.212C212.474 155.201 212.495 155.192 212.513 155.184L212.539 155.175L212.562 155.172C212.648 155.107 212.716 155.054 212.806 154.985C213.716 154.305 214.773 153.435 215.626 152.688C215.659 152.61 215.699 152.547 215.72 152.479C215.754 152.331 215.786 152.186 215.821 152.04C215.959 152.009 216.092 151.952 216.234 151.947C216.398 151.938 216.52 151.891 216.638 151.783C217.669 150.835 218.466 150.177 219.221 149.384C219.986 148.597 220.673 147.747 221.443 146.57C222.089 145.545 222.806 144.125 222.982 142.798C222.966 142.706 222.954 142.62 222.92 142.545C222.851 142.389 222.767 142.244 222.692 142.1C222.77 141.965 222.829 141.811 222.925 141.688C223.024 141.542 223.063 141.395 223.053 141.206C222.959 139.554 222.434 138.337 221.782 137.33C221.114 136.322 220.3 135.466 219.12 134.632C218.099 133.917 216.731 133.179 215.495 132.886C215.405 132.898 215.323 132.902 215.247 132.925C215.093 132.976 214.946 133.044 214.798 133.101C214.679 133.009 214.542 132.931 214.437 132.824C214.314 132.705 214.183 132.644 214.005 132.625C213.553 132.577 213.134 132.563 212.732 132.566C213.218 132.144 213.701 131.722 214.195 131.302H214.196C214.317 131.208 214.404 131.202 214.566 131.216C214.801 131.228 214.941 131.168 215.017 130.904C215.183 130.334 215.611 130.073 216.205 130.095C216.254 130.098 216.346 130.057 216.352 130.022C216.417 129.646 216.67 129.416 216.976 129.214C217.503 128.846 218.045 128.517 218.596 128.195C218.853 128.036 219.118 128.02 219.395 128.089C219.603 128.137 219.808 128.063 219.913 127.852ZM197.073 146.935C197.093 146.936 197.128 146.922 197.151 146.919L197.077 147.008C197.073 146.981 197.079 146.963 197.073 146.935ZM220.224 139.78C220.566 140.753 220.607 141.821 220.365 142.862C220.347 142.987 220.202 143.106 220.159 143.224C220.121 143.344 220.187 143.472 220.146 143.594C219.943 144.174 219.65 144.732 219.324 145.265C218.8 146.09 218.166 146.933 217.378 147.703C217.25 147.848 217.23 148.157 217.065 148.293C216.873 148.463 216.561 148.467 216.368 148.637C215.429 149.463 214.477 150.299 213.532 151.128C213.421 151.227 213.219 151.265 213.107 151.363C212.996 151.461 212.973 151.617 212.862 151.713C212.331 152.186 211.797 152.644 211.245 153.048V153.049C210.201 153.832 209.083 154.669 208.116 155.393C208.014 155.313 207.871 155.2 207.727 155.086L207.623 154.998L207.527 154.91L207.443 154.823L207.408 154.781L207.378 154.739L207.369 154.728L207.359 154.717L207.334 154.696L207.301 154.676L207.264 154.658C207.209 154.637 207.147 154.613 207.084 154.59L206.99 154.556C206.961 154.543 206.931 154.532 206.906 154.522L206.869 154.502L206.838 154.483L206.815 154.462L206.805 154.451L206.798 154.44C206.774 154.401 206.742 154.352 206.709 154.3L206.6 154.145C206.561 154.094 206.524 154.047 206.493 154.006C206.475 153.986 206.46 153.969 206.446 153.953C206.43 153.939 206.419 153.928 206.409 153.918C206.305 153.836 206.223 153.769 206.154 153.713C206.083 153.66 206.026 153.617 205.98 153.582C205.931 153.551 205.893 153.525 205.86 153.502C205.825 153.482 205.796 153.465 205.766 153.447C205.736 153.429 205.707 153.412 205.672 153.392C205.639 153.37 205.6 153.344 205.551 153.312C205.504 153.277 205.447 153.235 205.377 153.182C205.309 153.126 205.225 153.06 205.123 152.978C204.403 152.38 203.649 151.753 202.877 151.111C202.736 150.998 202.447 151.021 202.309 150.906C202.139 150.761 202.12 150.479 201.948 150.336C201.12 149.636 200.282 148.928 199.45 148.224C199.35 148.141 199.301 147.961 199.202 147.877C199.104 147.795 198.959 147.807 198.862 147.723C198.479 147.395 198.102 147.073 197.726 146.75C198.332 146.056 198.944 145.348 199.572 144.734C200.198 144.091 200.823 143.441 201.512 142.795C201.855 142.467 201.864 142.473 201.991 141.825C202.134 141.796 202.27 141.75 202.411 141.73C202.665 141.702 202.805 141.551 202.876 141.329C202.917 141.183 202.937 141.03 202.968 140.877C203.183 140.838 203.4 140.799 203.669 140.75C205.204 139.32 206.718 137.926 208.241 136.544L208.301 136.615C208.995 136.022 209.864 135.57 210.833 135.324C211.007 135.285 211.165 135.03 211.351 134.997C211.581 134.968 211.807 135.141 212.028 135.112C213.121 135.023 214.261 135.163 215.331 135.498C215.461 135.529 215.573 135.691 215.695 135.736C215.818 135.781 215.953 135.722 216.076 135.769C216.65 136.031 217.217 136.308 217.703 136.675C218.484 137.207 219.211 137.898 219.719 138.731C219.803 138.88 220.08 138.959 220.17 139.119C220.257 139.328 220.14 139.586 220.224 139.78ZM193.699 111.947C193.827 111.881 193.962 111.822 194.098 111.776C194.469 111.667 194.7 111.403 194.866 111.038C195.082 111.083 195.288 111.104 195.531 111.173C197.173 110.576 198.937 110.198 200.721 110.111C201.178 110.097 201.172 110.107 201.705 109.71C201.822 109.797 201.947 109.867 202.054 109.959C202.241 110.127 202.436 110.129 202.642 110.031C202.774 109.96 202.897 109.867 203.032 109.783C203.199 109.906 203.36 110.057 203.555 110.241C208.11 110.892 212.051 113.336 214.971 117.072C215.061 117.192 215.067 117.279 215.047 117.437C215.029 117.668 215.083 117.803 215.348 117.884C215.92 118.055 216.127 118.532 216.054 119.099C216.05 119.147 216.091 119.24 216.127 119.249C216.529 119.34 216.735 119.624 216.916 119.952C217.244 120.518 217.541 121.1 217.828 121.694C217.968 121.971 217.976 122.235 217.869 122.512C217.79 122.718 217.861 122.93 218.068 123.061C218.33 123.221 218.566 123.399 218.677 123.694C218.847 124.216 219.029 124.736 219.187 125.25C219.013 125.334 218.837 125.415 218.667 125.503C216.971 126.393 215.298 127.45 213.868 128.586C213.686 128.726 213.497 128.855 213.325 129.009C213.227 129.103 212.759 129.298 212.645 129.353C212.53 129.38 212.51 129.469 212.389 129.483C212.123 129.513 211.995 129.629 211.924 129.902C211.842 130.203 211.74 130.476 211.483 130.675C211.18 130.911 210.896 131.163 210.608 131.407C210.553 131.452 210.482 131.491 210.411 131.506C210.263 131.533 210.089 131.505 209.964 131.572C209.753 131.686 209.831 131.974 209.702 132.134C209.37 132.548 208.942 132.864 208.542 133.206C208.429 133.304 208.276 133.321 208.121 133.342C207.803 133.384 207.79 133.39 207.725 133.72C207.657 134.073 207.427 134.214 207.094 134.247C206.946 134.263 206.8 134.296 206.623 134.326C205.34 135.472 204.037 136.632 202.766 137.815C202.704 138.047 202.67 138.278 202.588 138.487C202.504 138.7 202.208 138.521 202.045 138.676C201.992 138.731 201.928 138.776 201.88 138.833C201.666 139.079 201.463 139.429 201.16 139.482C200.764 139.566 200.505 139.832 200.379 140.216C200.33 140.358 200.318 140.515 200.287 140.662C200.066 140.704 199.844 140.747 199.603 140.793C198.734 141.607 197.861 142.532 196.99 143.421C196.499 143.924 196.082 144.441 195.623 144.95L195.287 145.333C195.113 145.551 195.039 145.672 194.912 145.847C194.808 145.982 194.721 146.125 194.635 146.271C194.625 146.274 194.615 146.277 194.608 146.281C193.735 144.837 192.67 143.513 191.409 142.39C191.212 142.221 191.023 142.04 190.813 141.884C190.696 141.788 190.322 141.356 190.221 141.251C190.153 141.136 190.055 141.135 189.997 141.01C189.875 140.732 189.694 140.632 189.381 140.635C189.031 140.64 188.731 140.599 188.4 140.425C188.01 140.226 187.629 140.019 187.21 139.874C187.132 139.844 187.052 139.795 186.993 139.735C186.985 139.727 186.979 139.715 186.972 139.708C186.974 139.706 186.974 139.704 186.975 139.702C186.984 139.688 186.995 139.673 187.007 139.654C187.034 139.618 187.069 139.573 187.111 139.521C187.153 139.471 187.201 139.415 187.252 139.356C187.306 139.297 187.361 139.237 187.418 139.176L187.594 139C187.653 138.945 187.709 138.895 187.762 138.848L187.838 138.786C187.863 138.768 187.887 138.752 187.908 138.738C187.929 138.724 187.951 138.714 187.969 138.704L187.994 138.693L188.017 138.688C188.101 138.615 188.167 138.556 188.255 138.48C189.016 137.786 190.034 137.017 190.8 136.312C190.827 136.238 190.862 136.179 190.878 136.114C190.903 135.972 190.927 135.835 190.952 135.694C191.083 135.668 191.208 135.617 191.343 135.617C191.501 135.613 191.614 135.57 191.724 135.471C192.662 134.6 193.382 133.932 194.087 133.279C194.782 132.497 195.525 131.776 196.214 130.635C196.84 129.686 197.491 128.379 197.739 127.209C197.723 127.123 197.721 127.047 197.7 126.979C197.659 126.836 197.585 126.7 197.509 126.559C197.589 126.446 197.648 126.311 197.749 126.21C197.864 126.09 197.923 125.966 197.937 125.798C198.062 124.336 197.826 123.207 197.531 122.157C197.395 121.627 197.128 121.145 196.918 120.613C196.676 120.095 196.316 119.599 195.967 119.019C195.571 118.589 195.201 118.036 194.721 117.585C194.225 117.155 193.76 116.662 193.219 116.399C193.129 116.389 193.055 116.37 192.98 116.37C192.825 116.374 192.672 116.395 192.522 116.408C192.446 116.284 192.344 116.175 192.287 116.036C192.222 115.87 192.114 115.794 191.958 115.733C190.608 115.17 189.495 114.977 188.427 114.899C188.388 114.899 188.348 114.897 188.308 114.895C188.554 114.694 188.804 114.494 189.066 114.302C189.317 114.105 189.595 114.047 189.898 114.069C190.127 114.089 190.318 113.95 190.4 113.729C190.5 113.452 190.62 113.196 190.898 113.03C191.212 112.833 191.527 112.635 191.839 112.44C192.158 112.262 192.48 112.096 192.796 111.942C193.06 111.975 193.28 112.002 193.505 112.03C193.566 112.006 193.632 111.977 193.699 111.947ZM186.579 136.64C185.623 137.461 184.618 138.326 183.712 139.104C183.679 139.083 183.644 139.065 183.608 139.043L183.559 139.011L183.536 138.996L183.524 138.99L183.522 138.988L183.52 138.986L183.44 138.988L183.434 138.984C183.413 138.974 183.396 138.966 183.377 138.959C183.375 138.953 183.373 138.947 183.371 138.942C183.359 138.912 183.348 138.882 183.338 138.856C183.324 138.83 183.312 138.806 183.301 138.785L183.285 138.752L183.277 138.737L183.267 138.725L183.257 138.716L183.247 138.708L183.235 138.705L183.221 138.704C183.077 138.712 182.92 138.72 182.756 138.727L182.744 138.717L182.706 138.672L182.674 138.629L182.653 138.607L182.626 138.586L182.592 138.565L182.553 138.545C182.495 138.524 182.43 138.497 182.364 138.471L182.265 138.436C182.234 138.422 182.203 138.41 182.176 138.398L182.137 138.378L182.106 138.357L182.079 138.336L182.069 138.325L182.061 138.314C182.034 138.273 182 138.222 181.963 138.168C181.925 138.116 181.883 138.06 181.844 138.006C181.801 137.954 181.762 137.904 181.727 137.862C181.708 137.841 181.692 137.823 181.676 137.807C181.66 137.792 181.647 137.78 181.637 137.77C181.528 137.684 181.438 137.614 181.366 137.555C181.29 137.498 181.229 137.454 181.18 137.418C181.127 137.383 181.087 137.356 181.051 137.333C181.015 137.311 180.984 137.293 180.952 137.274C180.92 137.255 180.89 137.238 180.853 137.215C180.817 137.192 180.776 137.165 180.724 137.13C180.675 137.094 180.615 137.05 180.538 136.994C180.464 136.935 180.376 136.865 180.267 136.778H180.266C179.47 136.129 178.636 135.448 177.781 134.749C177.627 134.626 177.321 134.64 177.168 134.513C176.98 134.358 176.941 134.062 176.752 133.906C175.836 133.146 174.906 132.376 173.984 131.611C173.875 131.521 173.81 131.332 173.701 131.242C173.592 131.151 173.439 131.158 173.332 131.067C173.082 130.856 172.835 130.65 172.586 130.441C172.752 130.246 172.777 130.13 172.856 129.611C173.001 129.569 173.139 129.51 173.282 129.478C173.54 129.427 173.678 129.261 173.741 129.031C173.774 128.879 173.784 128.72 173.805 128.562C174.022 128.5 174.24 128.439 174.51 128.364C178.026 124.863 181.354 121.55 184.877 118.04C184.99 117.932 185.078 117.914 185.243 117.908C185.482 117.89 185.617 117.812 185.671 117.537C185.672 117.531 185.676 117.527 185.676 117.521C186.069 117.472 186.465 117.423 186.87 117.373C187.342 117.322 187.814 117.393 188.298 117.391C188.472 117.381 188.694 117.209 188.865 117.253C189.078 117.298 189.226 117.535 189.433 117.576C190.449 117.767 191.378 118.25 192.241 118.793C192.334 118.873 192.381 119.05 192.47 119.125C192.561 119.201 192.699 119.184 192.79 119.262C193.267 119.596 193.573 120.094 193.958 120.499C194.181 120.873 194.446 121.236 194.656 121.639C194.805 122.069 195.063 122.47 195.147 122.934C195.187 123.096 195.43 123.238 195.471 123.409C195.516 123.62 195.383 123.831 195.379 124.041C195.394 124.547 195.496 125.056 195.399 125.565L195.325 126.331L195.12 127.076C195.088 127.194 194.95 127.304 194.92 127.419C194.892 127.534 194.966 127.663 194.905 127.772C194.625 128.289 194.473 128.859 194.097 129.314C193.649 130.102 192.998 130.793 192.299 131.524C192.155 131.656 192.129 131.955 191.985 132.086C191.805 132.247 191.506 132.242 191.326 132.404C190.45 133.187 189.563 133.981 188.683 134.769C188.579 134.862 188.383 134.896 188.28 134.99C188.176 135.083 188.161 135.233 188.057 135.324C187.557 135.765 187.061 136.205 186.573 136.636L186.579 136.64ZM184.19 154.319L184.194 154.364L184.202 154.403L184.214 154.434C184.23 154.469 184.245 154.509 184.263 154.551C184.278 154.594 184.292 154.641 184.308 154.689C184.331 154.788 184.358 154.893 184.384 155C184.427 155.216 184.47 155.431 184.501 155.583H184.499L184.419 155.633H184.417L184.413 155.635L184.405 155.637L184.387 155.642L184.355 155.651L184.29 155.671L184.157 155.71L183.887 155.788C183.705 155.843 183.523 155.896 183.336 155.951C182.965 156.06 182.584 156.173 182.201 156.285C181.42 156.472 180.625 156.661 179.857 156.844V156.845C178.712 157.133 177.252 157.245 176.079 157.464C176.006 157.514 175.934 157.546 175.877 157.595C175.762 157.706 175.65 157.812 175.535 157.921C175.394 157.876 175.245 157.857 175.117 157.786C174.969 157.707 174.836 157.684 174.67 157.716C171.76 158.069 170.162 158.523 167.627 158.411C166.516 158.362 165.212 158.007 164.215 157.649C164.135 157.659 164.065 157.654 163.996 157.669C163.85 157.709 163.711 157.747 163.565 157.787C163.478 157.684 163.385 157.573 163.332 157.448C163.269 157.302 163.189 157.211 163.055 157.147C161.918 156.548 161.194 155.885 160.627 155.151C160.072 154.41 159.658 153.573 159.481 152.431C159.301 151.436 159.574 150.192 159.922 149.237C159.912 149.16 159.916 149.092 159.901 149.026C159.861 148.882 159.822 148.745 159.782 148.602C159.889 148.522 159.997 148.428 160.124 148.377C160.27 148.316 160.36 148.238 160.425 148.106C161.039 146.981 161.744 146.227 162.483 145.561C163.224 144.89 164.054 144.325 165.209 143.777C166.111 143.308 167.316 142.996 168.359 142.736C169.478 142.619 170.602 142.507 171.731 142.436C172.207 142.403 172.255 142.395 172.709 142.05C172.769 142.045 172.826 142.039 172.885 142.035C172.993 142.082 173.104 142.127 173.203 142.182C173.433 142.321 173.652 142.294 173.863 142.167C173.972 142.093 174.072 142.005 174.177 141.92C174.224 141.915 174.273 141.911 174.32 141.907C174.502 141.999 174.685 142.091 174.912 142.204C177.09 142.028 179.216 141.854 181.338 141.683L181.346 141.716L181.405 141.95C181.444 142.107 181.485 142.267 181.525 142.429C181.607 142.753 181.692 143.083 181.776 143.417C181.943 144.085 182.113 144.767 182.277 145.423H182.278C182.405 145.954 182.45 146.633 182.585 147.168C182.63 147.196 182.657 147.226 182.7 147.246L182.998 147.362C182.944 147.436 182.916 147.512 182.839 147.584C182.753 147.667 182.722 147.735 182.743 147.812C183.067 149.13 183.294 149.824 183.561 151.058H183.559C183.59 151.212 183.618 151.338 183.639 151.443C183.657 151.548 183.672 151.631 183.684 151.701C183.693 151.769 183.7 151.824 183.705 151.873C183.709 151.921 183.713 151.961 183.717 152.002C183.721 152.043 183.723 152.084 183.728 152.133C183.735 152.18 183.741 152.235 183.75 152.305C183.762 152.373 183.777 152.457 183.795 152.562C183.817 152.666 183.844 152.791 183.876 152.946C183.881 152.963 183.887 152.983 183.893 153.007C183.901 153.03 183.911 153.056 183.921 153.085C183.945 153.143 183.973 153.209 184.002 153.278C184.034 153.346 184.067 153.417 184.099 153.483C184.133 153.548 184.164 153.608 184.19 153.657L184.197 153.672L184.203 153.689L184.212 153.726L184.216 153.769L184.218 153.817C184.216 153.851 184.216 153.888 184.214 153.925L184.204 154.042C184.2 154.122 184.195 154.2 184.19 154.27V154.319ZM148.987 131.419C148.841 131.401 148.694 131.389 148.548 131.361C148.321 131.313 148.188 131.173 148.128 130.922C148.097 130.785 148.066 130.647 148.032 130.506C147.884 130.488 147.731 130.487 147.589 130.444C147.368 130.382 147.211 130.248 147.172 130.004C147.151 129.865 147.11 129.731 147.079 129.594C146.931 129.572 146.774 129.572 146.64 129.514C146.298 129.369 146.025 129.139 145.945 128.747C145.92 128.601 145.894 128.457 145.861 128.268C145.64 128.031 145.396 127.767 145.151 127.503C145.054 127.396 144.957 127.285 144.845 127.191C144.741 127.101 144.601 127.052 144.442 127.053C144.254 127.056 144.16 126.992 144.132 126.849C144.027 126.309 144.043 126.295 143.825 126.066C143.63 125.863 143.492 125.593 143.21 125.48C143.075 125.427 142.919 125.419 142.78 125.37C142.735 125.353 142.706 125.273 142.692 125.213C142.659 125.081 142.637 124.949 142.62 124.813C142.477 124.776 142.337 124.741 142.175 124.7C142.154 124.497 142.13 124.29 142.103 124.045C141.344 123.125 140.615 122.148 139.937 121.159C139.867 121.119 139.812 121.072 139.746 121.046C139.607 120.995 139.472 120.944 139.334 120.895C139.322 120.759 139.289 120.626 139.309 120.49C139.327 120.335 139.301 120.214 139.222 120.084C137.895 117.982 136.823 115.748 136.175 113.41C135.514 111.074 135.39 108.632 135.676 106.215C135.738 105.852 135.894 105.573 136.177 105.334C136.27 105.257 136.305 105.156 136.301 105.045C136.33 105.031 136.36 105.022 136.389 105.005C136.519 104.919 136.635 104.813 136.76 104.714C136.963 104.817 137.172 104.943 137.428 105.043C142.5 104.488 147.171 102.981 151.703 100.688C152.447 100.334 153.187 99.9386 153.92 99.5156C153.928 99.6406 153.937 99.7656 153.957 99.8886C153.984 100.057 153.957 100.198 153.889 100.351C153.63 100.952 153.674 100.955 153.784 101.498C153.895 102.051 153.929 102.057 154.37 102.498C154.417 102.539 154.458 102.621 154.456 102.678C154.38 103.512 154.416 103.498 154.538 103.828C154.722 104.313 154.942 104.771 155.167 105.226C155.081 105.439 154.896 105.548 154.636 105.589C154.489 105.615 154.346 105.657 154.172 105.698C152.958 106.874 151.825 108.125 150.691 109.362C150.653 109.592 150.642 109.82 150.582 110.03C150.52 110.243 150.211 110.087 150.066 110.25C150.019 110.308 149.961 110.354 149.919 110.415C149.732 110.668 149.566 111.024 149.273 111.095C148.889 111.197 148.657 111.466 148.563 111.847C148.528 111.988 148.528 112.141 148.508 112.287C148.293 112.338 148.078 112.39 147.846 112.444C147.453 112.871 147.057 113.301 146.659 113.732C146.547 113.862 146.49 113.898 146.332 114.104L146.029 114.508C145.838 114.785 145.611 115.031 145.462 115.344C144.666 116.645 144.217 118.213 144.248 119.748C144.264 121.287 144.689 122.754 145.314 124.061C146.15 125.817 147.334 127.33 148.679 128.623C148.851 128.782 149.013 128.951 149.197 129.098C149.31 129.176 149.586 129.628 149.674 129.716C149.725 129.822 149.817 129.826 149.855 129.943C149.941 130.203 150.084 130.308 150.367 130.325C150.675 130.351 150.968 130.379 151.229 130.578C151.541 130.803 151.848 131.035 152.178 131.23C152.239 131.269 152.298 131.325 152.334 131.388C152.408 131.522 152.438 131.697 152.543 131.796C152.723 131.966 152.971 131.802 153.164 131.874C153.68 132.032 154.131 132.323 154.607 132.562C154.744 132.624 154.825 132.755 154.91 132.89C155.086 133.163 155.099 133.173 155.428 133.095C155.776 133.017 156.008 133.146 156.197 133.425C156.284 133.548 156.384 133.662 156.499 133.806C158.165 134.406 159.927 134.821 161.716 134.999C161.938 134.888 162.135 134.757 162.347 134.675C162.56 134.591 162.638 134.933 162.87 134.945C162.949 134.941 163.028 134.953 163.106 134.943C163.442 134.909 163.836 134.789 164.106 134.957C164.467 135.182 164.859 135.11 165.21 134.899C165.339 134.819 165.448 134.705 165.567 134.61C165.772 134.721 165.979 134.812 166.21 134.907C166.729 134.819 167.249 134.726 167.765 134.594C167.759 135.446 167.863 136.282 168.042 137.076C168.267 138.06 168.599 138.997 168.997 139.896C168.56 139.939 168.124 139.982 167.688 140.027L159.424 140.853C157.799 139.554 156.181 138.244 154.598 136.9C153.25 135.761 151.924 134.601 150.618 133.423C150.456 133.273 150.306 133.111 150.132 132.974C150.027 132.896 149.771 132.475 149.704 132.378C149.569 132.183 149.675 132.286 149.655 132.03C149.106 131.957 149.099 131.961 148.987 131.419ZM179.061 139.031C178.306 139.094 177.583 139.155 176.96 139.208C175.769 139.3 174.521 139.396 173.241 139.493C173.175 139.499 173.107 139.522 173.04 139.552C172.872 139.575 172.708 139.63 172.548 139.726C172.538 139.732 172.528 139.743 172.518 139.749C172.244 139.759 171.976 139.589 171.699 139.608C171.641 139.611 171.582 139.62 171.524 139.624C171.431 139.544 171.345 139.458 171.287 139.335C171.145 139.005 171.004 138.673 170.863 138.347C170.742 138.015 170.631 137.685 170.531 137.361C170.627 137.121 170.705 136.919 170.787 136.713C170.776 136.651 170.767 136.585 170.751 136.519C170.712 136.387 170.684 136.256 170.676 136.123C170.662 135.768 170.453 135.507 170.18 135.263C170.287 135.092 170.395 134.922 170.518 134.727C170.523 133.95 170.651 133.207 170.932 132.563C170.961 132.509 170.987 132.452 171.012 132.395C171.594 132.915 172.196 133.471 172.752 133.92C172.83 133.936 172.895 133.963 172.963 133.969C173.108 133.975 173.248 133.979 173.394 133.984C173.439 134.11 173.508 134.225 173.528 134.36C173.555 134.514 173.614 134.622 173.729 134.714C175.733 136.339 176.84 137.169 178.682 138.708V138.71C178.798 138.807 178.935 138.923 179.061 139.031ZM163.243 100.934C163.292 100.934 163.378 100.886 163.381 100.851C163.409 100.475 163.636 100.227 163.917 100.008C164.396 99.6096 164.903 99.2366 165.425 98.8666C165.665 98.6856 165.931 98.6446 166.22 98.6826C166.433 98.7056 166.632 98.6106 166.711 98.3966C166.806 98.1276 166.923 97.8796 167.188 97.7296C167.785 97.3656 168.41 97.0516 169.009 96.7706C169.265 96.8216 169.468 96.8426 169.683 96.9016C169.744 96.8826 169.808 96.8656 169.871 96.8406C169.997 96.7906 170.12 96.7286 170.251 96.6906C170.6 96.5966 170.818 96.3386 170.981 95.9836C171.182 96.0456 171.379 96.1066 171.61 96.1766C173.169 95.6456 174.844 95.3226 176.53 95.2846C176.96 95.2626 176.954 95.2676 177.466 94.9146C177.575 94.9986 177.691 95.0646 177.79 95.1536C177.964 95.3166 178.147 95.3136 178.345 95.2106C178.472 95.1326 178.591 95.0596 178.716 94.9806C178.866 95.1206 179.016 95.2606 179.202 95.4366C183.493 96.0016 187.276 98.3256 189.958 101.789C190.047 101.896 190.047 101.98 190.017 102.135C189.984 102.36 190.025 102.489 190.273 102.563C190.81 102.725 191.027 103.144 190.899 103.708C190.892 103.755 190.925 103.845 190.961 103.855C191.331 103.954 191.561 104.207 191.711 104.531C191.969 105.1 192.276 105.643 192.504 106.231C192.623 106.502 192.602 106.768 192.497 107.038C192.424 107.238 192.475 107.45 192.663 107.575C192.902 107.727 193.116 107.897 193.201 108.186C193.289 108.465 193.361 108.748 193.433 109.032C191.777 109.741 190.218 110.636 188.757 111.641C187.202 112.756 185.62 114.024 184.292 115.348C184.122 115.51 183.942 115.663 183.783 115.84C183.694 115.947 183.237 116.201 183.128 116.271C183.128 116.271 183.128 116.272 183.126 116.272C183.014 116.311 183.001 116.399 182.88 116.424C182.612 116.48 182.495 116.605 182.444 116.884C182.386 117.192 182.305 117.474 182.059 117.697L181.225 118.508C181.172 118.559 181.104 118.604 181.032 118.624C180.884 118.664 180.709 118.65 180.587 118.728C180.38 118.86 180.476 119.146 180.354 119.318C180.044 119.765 179.623 120.116 179.226 120.484C179.115 120.588 178.96 120.617 178.802 120.647C178.48 120.709 178.468 120.716 178.413 121.053C178.354 121.412 178.126 121.571 177.79 121.623C177.64 121.648 177.493 121.69 177.315 121.73C176.045 122.939 174.747 124.248 173.461 125.515C173.406 125.751 173.378 125.984 173.301 126.199C173.223 126.417 172.906 126.261 172.743 126.428C172.69 126.488 172.623 126.535 172.578 126.598C172.379 126.866 172.197 127.24 171.893 127.321C171.496 127.436 171.247 127.722 171.14 128.118C171.099 128.264 171.095 128.424 171.072 128.575C170.85 128.634 170.629 128.694 170.387 128.758L169.759 129.44L169.445 129.782C169.277 129.981 169.202 130.103 169.078 130.269C168.838 130.573 168.65 130.906 168.492 131.253C168.44 131.345 168.406 131.442 168.365 131.536C167.549 131.824 166.699 132.042 165.83 132.169C165.414 132.247 165.414 132.212 164.961 132.636C164.842 132.568 164.719 132.517 164.609 132.443C164.418 132.304 164.238 132.335 164.054 132.437C163.939 132.517 163.833 132.617 163.716 132.708C163.551 132.59 163.385 132.473 163.179 132.325C158.878 132.176 154.712 130.606 151.283 127.816C151.173 127.73 151.156 127.647 151.15 127.492C151.131 127.267 151.062 127.152 150.802 127.133C150.228 127.102 149.948 126.715 149.945 126.157C149.941 126.111 149.888 126.033 149.851 126.031C149.451 126.031 149.222 125.799 148.999 125.529C148.798 125.297 148.62 125.05 148.452 124.8C148.28 124.55 148.087 124.312 147.941 124.049C147.792 123.808 147.779 123.55 147.85 123.281C147.914 123.077 147.85 122.89 147.65 122.799C147.409 122.685 147.146 122.556 147.078 122.283C146.872 121.671 146.688 121.054 146.643 120.458C146.779 120.265 146.893 120.103 147.008 119.938C147.008 119.884 147.008 119.827 147.008 119.768C147.018 119.653 147.014 119.536 147.033 119.422C147.084 119.118 146.951 118.859 146.75 118.574C146.895 118.455 147.037 118.338 147.203 118.201C147.326 117.832 147.469 117.463 147.646 117.103C148.154 117.56 148.671 118.035 149.155 118.425C149.232 118.44 149.295 118.464 149.36 118.47C149.503 118.472 149.64 118.474 149.783 118.476C149.824 118.6 149.89 118.712 149.908 118.845C149.93 118.997 149.986 119.101 150.098 119.191C152.032 120.757 153.101 121.556 154.877 123.042L154.876 123.043C155.452 123.531 156.124 124.102 156.831 124.701C156.843 124.713 156.856 124.726 156.872 124.744C156.886 124.762 156.901 124.781 156.919 124.803C156.949 124.848 156.983 124.899 157.019 124.949C157.055 124.999 157.089 125.051 157.121 125.095C157.137 125.116 157.152 125.137 157.166 125.156C157.183 125.172 157.197 125.187 157.209 125.199C157.24 125.222 157.268 125.244 157.295 125.264L157.377 125.314L157.457 125.353L157.534 125.386L157.611 125.419L157.691 125.458L157.773 125.509C157.8 125.53 157.83 125.552 157.861 125.575L158.22 125.881C158.556 126.167 158.876 126.44 159.169 126.689C159.461 126.929 159.726 127.148 159.956 127.337L159.968 127.345L159.98 127.349L159.994 127.351L160.008 127.35L160.024 127.346L160.04 127.34L160.073 127.321C160.094 127.309 160.12 127.294 160.146 127.278L160.225 127.218C160.28 127.174 160.337 127.129 160.389 127.087C160.416 127.068 160.443 127.051 160.466 127.035L160.502 127.017L160.535 127.007L160.56 126.999L160.585 126.987L160.61 126.972L160.633 126.953L160.682 126.908L160.73 126.859L160.78 126.808L160.835 126.763L160.863 126.743L160.893 126.726L160.924 126.713L160.957 126.704C160.962 126.668 160.967 126.633 160.971 126.601C160.979 126.57 160.987 126.54 160.994 126.512L161.022 126.437L161.057 126.375L161.097 126.322L161.142 126.277L161.191 126.24L161.242 126.209L161.351 126.157L161.462 126.108L161.517 126.081L161.57 126.05L161.621 126.014L161.668 125.969L161.817 125.814L161.888 125.734L161.954 125.649L161.959 125.641L161.962 125.632L161.966 125.611L161.97 125.589L161.976 125.569L162.013 125.495L162.042 125.418L162.054 125.377L162.062 125.335L162.065 125.29L162.064 125.244L162.062 125.179L162.066 125.122L162.078 125.071L162.086 125.05L162.096 125.03L162.108 125.01L162.122 124.994L162.138 124.978L162.156 124.964L162.176 124.952L162.197 124.942L162.246 124.926C162.378 124.893 162.476 124.868 162.555 124.849C162.594 124.838 162.627 124.828 162.659 124.819C162.687 124.807 162.714 124.798 162.737 124.788L162.77 124.77L162.801 124.751L162.858 124.705C162.877 124.687 162.895 124.668 162.918 124.646C162.939 124.625 162.962 124.599 162.987 124.571L163.059 124.493L163.133 124.418L163.283 124.27L163.351 124.191L163.413 124.106L163.44 124.061L163.463 124.014L163.484 123.965L163.502 123.912C163.506 123.904 163.511 123.892 163.518 123.877C163.526 123.861 163.538 123.844 163.549 123.823C163.576 123.783 163.611 123.733 163.651 123.676C163.692 123.619 163.74 123.557 163.79 123.49C163.843 123.425 163.899 123.355 163.954 123.287C164.013 123.22 164.071 123.152 164.128 123.088C164.187 123.026 164.243 122.967 164.295 122.913L164.372 122.842C164.397 122.821 164.421 122.802 164.441 122.784C164.463 122.769 164.485 122.756 164.503 122.743L164.528 122.73L164.552 122.721C164.635 122.636 164.702 122.57 164.789 122.482H164.788C165.515 121.718 166.494 120.859 167.225 120.084C167.248 120.008 167.28 119.945 167.292 119.877C167.309 119.731 167.324 119.591 167.342 119.446C167.473 119.41 167.594 119.347 167.732 119.336C167.89 119.32 168.003 119.268 168.106 119.158C169.008 118.198 169.682 117.489 170.362 116.728C171.091 115.89 171.723 114.94 172.195 113.572C172.387 112.976 172.538 112.285 172.604 111.578C172.641 110.872 172.61 110.153 172.454 109.539C172.397 109.465 172.359 109.393 172.307 109.336C172.193 109.222 172.078 109.119 171.953 109.021C171.974 108.876 171.969 108.723 172.015 108.582C172.064 108.418 172.066 108.27 171.995 108.109C171.374 106.713 170.643 105.809 169.876 105.02C169.095 104.243 168.251 103.567 167.062 102.905C166.036 102.341 164.667 101.745 163.441 101.597C163.353 101.621 163.275 101.629 163.207 101.659C163.062 101.721 162.928 101.814 162.791 101.889C162.666 101.813 162.523 101.758 162.41 101.66C162.354 101.611 162.297 101.582 162.236 101.558C162.407 101.164 162.753 100.949 163.243 100.934ZM158.364 105.315C158.696 105.065 159.05 104.841 159.43 104.661C159.573 104.575 159.676 104.321 159.841 104.265C160.043 104.191 160.277 104.312 160.479 104.275C161.449 104.017 162.504 104.005 163.528 104.212C163.649 104.24 163.768 104.381 163.886 104.41C164.004 104.441 164.129 104.359 164.246 104.399C164.808 104.592 165.367 104.801 165.871 105.103C166.678 105.531 167.463 106.111 168.135 106.82C168.266 106.935 168.539 106.965 168.658 107.1C168.806 107.267 168.759 107.546 168.877 107.723C169.481 108.571 169.912 109.542 170.033 110.523C170.047 110.64 169.961 110.789 169.976 110.9C169.98 111.013 170.08 111.1 170.08 111.216C170.096 111.768 169.988 112.306 169.825 112.818C169.578 113.619 169.109 114.417 168.454 115.133C168.329 115.275 168.312 115.581 168.176 115.724C168.006 115.902 167.704 115.921 167.532 116.099C166.697 116.961 165.851 117.835 165.011 118.703C164.911 118.806 164.716 118.855 164.617 118.959C164.518 119.061 164.513 119.214 164.413 119.314C163.936 119.8 163.463 120.285 162.997 120.759L162.999 120.76C161.964 121.79 160.856 122.893 159.897 123.846C159.782 123.755 159.617 123.626 159.454 123.498L159.334 123.399L159.223 123.3C159.189 123.266 159.157 123.235 159.126 123.203L159.084 123.156L159.048 123.11L159.027 123.087L158.998 123.065L158.961 123.042L158.92 123.021C158.859 122.996 158.789 122.967 158.719 122.939L158.615 122.898C158.582 122.882 158.551 122.869 158.521 122.855L158.48 122.834L158.445 122.813L158.418 122.79L158.406 122.778L158.398 122.766C158.367 122.723 158.33 122.67 158.291 122.613C158.248 122.557 158.203 122.499 158.16 122.442C158.113 122.387 158.07 122.335 158.031 122.29C158.011 122.269 157.994 122.249 157.978 122.231C157.96 122.215 157.945 122.202 157.934 122.192C157.817 122.098 157.722 122.023 157.642 121.96C157.562 121.899 157.497 121.853 157.444 121.813C157.388 121.776 157.345 121.747 157.307 121.721C157.268 121.698 157.235 121.677 157.202 121.658C157.168 121.637 157.135 121.617 157.096 121.594C157.059 121.569 157.015 121.539 156.959 121.502C156.906 121.463 156.842 121.415 156.76 121.356C156.682 121.293 156.586 121.217 156.469 121.124H156.468C155.699 120.498 154.895 119.841 154.071 119.167C153.922 119.048 153.623 119.067 153.475 118.945C153.293 118.795 153.261 118.505 153.079 118.353C152.194 117.62 151.298 116.877 150.408 116.139C150.303 116.052 150.243 115.867 150.137 115.78C150.033 115.692 149.883 115.702 149.78 115.614C149.572 115.44 149.369 115.269 149.163 115.096L149.867 114.33C150.184 113.988 150.194 113.992 150.274 113.349C150.414 113.313 150.546 113.26 150.685 113.232C150.934 113.19 151.064 113.034 151.12 112.812C151.147 112.666 151.152 112.513 151.169 112.36C151.379 112.307 151.589 112.254 151.851 112.188C154.011 109.752 156.163 107.543 158.364 105.315ZM104.087 13.1166C104.283 13.0346 104.366 12.9356 104.287 12.6786C104.12 12.1226 104.329 11.7196 104.856 11.5606C104.897 11.5436 104.952 11.4706 104.94 11.4346C104.815 11.0576 104.882 10.7256 105.073 10.4406C105.375 9.92057 105.682 9.40856 106.036 8.91756C106.192 8.67856 106.421 8.57056 106.718 8.55656C106.936 8.54256 107.079 8.39657 107.082 8.16357C107.081 7.87257 107.101 7.58857 107.321 7.39857L108.04 6.71156C108.296 6.50456 108.55 6.29957 108.804 6.10957C109.058 6.10957 109.273 6.12156 109.493 6.13857C109.547 6.11157 109.605 6.08156 109.661 6.04656C109.768 5.97656 109.874 5.89356 109.989 5.83356C110.298 5.67156 110.466 5.41356 110.548 5.04656C110.757 5.07356 110.964 5.10357 111.205 5.13557C112.638 4.42157 114.222 3.94657 115.839 3.70357C116.251 3.63257 116.248 3.64956 116.651 3.22556C116.776 3.29356 116.903 3.34456 117.018 3.41656C117.223 3.55756 117.398 3.52357 117.563 3.40257C117.667 3.31856 117.758 3.21657 117.862 3.12157C118.036 3.23457 118.212 3.34956 118.429 3.49156C122.55 3.40756 126.801 4.34957 130.926 5.95757C131.057 6.00957 131.102 6.07857 131.161 6.22157C131.256 6.42557 131.368 6.50257 131.621 6.43957C132.168 6.29757 132.57 6.53957 132.805 7.05556C132.827 7.09656 132.909 7.15057 132.944 7.13757C133.315 6.99157 133.633 7.09856 133.956 7.25556C134.52 7.53056 135.085 7.80657 135.653 8.08257C135.921 8.21257 136.079 8.42857 136.182 8.70457C136.256 8.91257 136.45 9.02356 136.676 8.98656C136.959 8.93756 137.231 8.91456 137.49 9.07056C138.09 9.42556 138.715 9.74456 139.267 10.1176C139.367 10.3556 139.451 10.5556 139.537 10.7586C139.588 10.7956 139.642 10.8386 139.701 10.8756C139.82 10.9476 139.947 11.0126 140.058 11.0966C140.345 11.3326 140.683 11.3716 141.062 11.2946C141.145 11.4896 141.226 11.6826 141.321 11.9066C142.754 12.8446 144.178 13.8616 145.571 14.9226C145.92 15.1976 145.916 15.2076 146.548 15.2236C146.591 15.3566 146.65 15.4806 146.684 15.6126C146.737 15.8506 146.895 15.9616 147.116 15.9936C147.261 16.0076 147.407 16.0036 147.557 16.0086C147.616 16.2096 147.672 16.4116 147.745 16.6636C151.207 19.5076 154.315 22.4336 157.329 25.7966C157.421 25.9056 157.429 25.9896 157.417 26.1466C157.409 26.3736 157.468 26.5026 157.728 26.5586C158.289 26.6776 158.546 27.0726 158.535 27.6426C158.537 27.6896 158.588 27.7746 158.625 27.7796C159.018 27.8186 159.264 28.0486 159.488 28.3326C159.886 28.8266 160.285 29.3176 160.685 29.8126C160.874 30.0446 160.927 30.3096 160.906 30.6056C160.887 30.8286 161.013 31.0136 161.238 31.0746C161.52 31.1446 161.785 31.2306 161.959 31.4826C162.366 32.0516 162.775 32.6246 163.163 33.1686C163.158 33.4286 163.154 33.6456 163.15 33.8676C163.183 33.9226 163.217 33.9826 163.254 34.0436C163.33 34.1586 163.42 34.2716 163.488 34.3936C163.66 34.7246 163.961 34.8936 164.342 34.9716C164.34 35.1846 164.338 35.3956 164.336 35.6396C165.27 37.0796 166.207 38.5626 167.058 40.0906C167.276 40.4796 167.268 40.4856 167.848 40.7446C167.836 40.8836 167.842 41.0186 167.819 41.1546C167.77 41.3966 167.87 41.5606 168.055 41.6796C168.182 41.7496 168.321 41.8006 168.457 41.8656C168.434 42.0716 168.408 42.2786 168.377 42.5376C170.42 46.5086 172.111 50.4166 173.233 54.7386H173.232C173.266 54.8766 173.236 54.9536 173.154 55.0856C173.045 55.2806 173.039 55.4206 173.246 55.5846C173.701 55.9416 173.718 56.4126 173.435 56.9006C173.414 56.9416 173.417 57.0396 173.448 57.0606C173.775 57.2776 173.896 57.5916 173.942 57.9456C174.029 58.5626 174.154 59.1746 174.23 59.7946C174.273 60.0856 174.183 60.3356 174.013 60.5706C173.881 60.7476 173.901 60.9656 174.05 61.1306C174.246 61.3346 174.413 61.5456 174.428 61.8446C174.474 62.5266 174.498 63.2196 174.491 63.8616C174.344 64.0636 174.214 64.2276 174.079 64.3896C174.071 64.4496 174.061 64.5126 174.058 64.5776C174.053 64.7076 174.06 64.8406 174.042 64.9696C173.987 65.3116 174.134 65.6106 174.372 65.9036C174.239 66.0526 174.108 66.2006 173.954 66.3716C173.8 67.9646 173.487 69.5856 172.937 71.1306C172.798 71.4906 172.784 71.5176 172.918 72.0126C172.807 72.0776 172.7 72.1956 172.607 72.3416C172.401 72.4256 172.334 72.5866 172.353 72.8046C172.355 72.8216 172.361 72.8396 172.364 72.8566C172.299 73.0466 172.265 73.2216 172.283 73.3226C172.15 73.3816 172.023 73.4356 171.859 73.5006C169.847 77.1996 166.24 79.7236 162.045 80.4646C161.912 80.4856 161.836 80.4476 161.705 80.3556C161.512 80.2296 161.379 80.2096 161.223 80.4036C160.881 80.8156 160.411 80.7786 159.953 80.4416C159.914 80.4156 159.82 80.4076 159.799 80.4346C159.578 80.7346 159.264 80.7826 158.921 80.7896C158.32 80.8146 157.725 80.7736 157.121 80.7726C156.836 80.7796 156.611 80.6256 156.416 80.4126C156.27 80.2486 156.066 80.2176 155.883 80.3446C155.656 80.5046 155.426 80.6446 155.135 80.5886C154.471 80.4716 153.78 80.4106 153.145 80.2466C152.975 80.0576 152.832 79.8986 152.686 79.7386C152.625 79.7206 152.561 79.6996 152.495 79.6856C152.362 79.6616 152.224 79.6346 152.096 79.5886C151.755 79.4586 151.427 79.5346 151.095 79.7326C150.958 79.5746 150.824 79.4186 150.667 79.2386C149.046 78.7846 147.412 78.2216 145.805 77.5786C145.4 77.4066 145.404 77.3946 144.793 77.5436C144.718 77.4266 144.631 77.3216 144.565 77.2036C144.455 76.9866 144.276 76.9216 144.055 76.9456C143.912 76.9706 143.772 77.0106 143.625 77.0436C143.521 76.8636 143.416 76.6836 143.286 76.4576C139.266 74.5646 135.611 72.3696 132.002 69.6786C131.889 69.5926 131.863 69.5146 131.842 69.3616C131.805 69.1396 131.723 69.0226 131.457 69.0206C130.887 69.0126 130.558 68.6766 130.459 68.1146C130.447 68.0686 130.381 67.9956 130.344 67.9986C129.948 68.0436 129.664 67.8626 129.389 67.6276L127.93 66.4076C127.7 66.2166 127.597 65.9676 127.561 65.6726C127.538 65.4506 127.377 65.2936 127.145 65.2776C126.856 65.2606 126.579 65.2286 126.36 65.0146C125.852 64.5346 125.34 64.0496 124.856 63.5906C124.811 63.3346 124.772 63.1196 124.734 62.9026C124.692 62.8546 124.645 62.8016 124.599 62.7496C124.5 62.6496 124.391 62.5586 124.301 62.4506C124.068 62.1596 123.74 62.0506 123.352 62.0476C123.312 61.8386 123.272 61.6326 123.227 61.3926C122.03 60.1586 120.825 58.8786 119.674 57.5526C119.385 57.2146 119.391 57.2066 118.772 57.0666C118.756 56.9276 118.723 56.7956 118.715 56.6586C118.711 56.4146 118.573 56.2776 118.367 56.1986C118.229 56.1546 118.082 56.1326 117.935 56.0966C117.917 55.8886 117.9 55.6796 117.878 55.4176C115.032 51.9486 112.52 48.4986 110.253 44.6056C110.184 44.4796 110.192 44.3976 110.235 44.2466C110.288 44.0266 110.255 43.8896 110.01 43.7836C109.487 43.5546 109.301 43.1246 109.446 42.5616C109.454 42.5146 109.423 42.4206 109.389 42.4096C109.014 42.2906 108.815 42.0166 108.653 41.6946C108.37 41.1306 108.087 40.5676 107.801 40.0016C107.662 39.7356 107.664 39.4686 107.746 39.1866C107.81 38.9746 107.734 38.7656 107.529 38.6586C107.272 38.5276 107.041 38.3836 106.924 38.1026C106.649 37.4616 106.36 36.8246 106.131 36.1996C106.193 35.9496 106.244 35.7406 106.297 35.5276C106.277 35.4666 106.26 35.4006 106.235 35.3366C106.186 35.2056 106.128 35.0766 106.092 34.9426C106.004 34.5826 105.756 34.3496 105.404 34.1836C105.456 33.9796 105.506 33.7776 105.564 33.5426C105.022 31.9316 104.477 30.2776 104.088 28.5936C103.982 28.1676 103.987 28.1656 103.519 27.7576C103.572 27.6286 103.607 27.4956 103.665 27.3746C103.779 27.1586 103.729 26.9766 103.583 26.8126C103.48 26.7106 103.36 26.6216 103.245 26.5226C103.333 26.3346 103.421 26.1466 103.532 25.9106C103.149 23.7546 102.928 21.5916 102.942 19.5156C102.96 17.4606 103.208 15.3806 103.844 13.3416C103.89 13.2106 103.952 13.1686 104.087 13.1166ZM80.1944 45.2546C80.3314 45.0816 80.3153 44.8556 80.1593 44.6446C80.1313 44.6056 80.1063 44.5716 80.0853 44.5396C80.1113 44.4426 80.1324 44.3446 80.1604 44.2486L80.6873 42.5586C81.1003 41.2956 81.4453 40.0076 81.9133 38.7626L83.3764 35.0496C84.0444 33.4046 84.8803 31.8346 85.6243 30.2236L85.9234 29.6256C85.9764 29.5046 86.3313 29.1526 86.4113 29.0636C86.5713 28.8866 86.4953 29.0136 86.7433 28.9316C86.6863 28.3856 86.6884 28.3826 87.1864 28.1346C87.1664 27.9886 87.1434 27.8416 87.1344 27.6916C87.1254 27.4576 87.2294 27.2916 87.4574 27.1706C87.5824 27.1066 87.7094 27.0396 87.8374 26.9736C87.8184 26.8236 87.7834 26.6726 87.7894 26.5236C87.7974 26.2906 87.8893 26.1026 88.1153 26.0026C88.2413 25.9446 88.3593 25.8696 88.4803 25.8046C88.4613 25.6496 88.4313 25.4986 88.4593 25.3566C88.5293 24.9916 88.6994 24.6716 89.0704 24.5026C89.2104 24.4436 89.3464 24.3876 89.5264 24.3116C89.7094 24.0386 89.9114 23.7346 90.1134 23.4306C90.1954 23.3086 90.2803 23.1846 90.3473 23.0536C90.4093 22.9286 90.4264 22.7786 90.3884 22.6216C90.3434 22.4376 90.3823 22.3286 90.5173 22.2666C91.0233 22.0366 91.0213 22.0346 91.2023 21.7686C91.3633 21.5316 91.6014 21.3346 91.6564 21.0356C91.6804 20.8896 91.6543 20.7376 91.6763 20.5916C91.6823 20.5436 91.7563 20.4966 91.8133 20.4696C91.9383 20.4076 92.0664 20.3576 92.1954 20.3046C92.1984 20.1546 92.2003 20.0056 92.2023 19.8356C92.3953 19.7636 92.5933 19.6876 92.8253 19.5996C93.5323 18.6036 94.3454 17.6546 95.1514 16.7166C95.1724 16.6366 95.2043 16.5706 95.2133 16.4956C95.2273 16.3456 95.2403 16.1996 95.2563 16.0516C95.3853 16.0006 95.5063 15.9296 95.6453 15.9096C95.8033 15.8826 95.9163 15.8236 96.0163 15.7016C98.2253 13.2516 100.62 10.9036 103.225 8.91357C102.827 9.60357 102.467 10.3176 102.164 11.0546C102.08 11.2656 101.982 11.4706 101.914 11.6896C101.869 11.8166 101.586 12.2186 101.534 12.3306H101.533C101.453 12.4106 101.484 12.5006 101.39 12.5726C101.187 12.7306 101.14 12.8986 101.226 13.1756C101.31 13.4796 101.4 13.7706 101.312 14.0786C101.22 14.4406 101.129 14.8076 101.061 15.1756C101.049 15.2446 101.02 15.3196 100.976 15.3716C100.88 15.4806 100.734 15.5616 100.681 15.6926C100.593 15.9156 100.835 16.0996 100.84 16.3046C100.853 16.8346 100.792 17.3536 100.725 17.8716C100.712 18.0176 100.607 18.1326 100.519 18.2556C100.33 18.5056 100.326 18.5236 100.521 18.8036C100.73 19.1016 100.675 19.3576 100.472 19.6216C100.381 19.7416 100.304 19.8726 100.216 20.0226C100.215 21.7316 100.372 23.4186 100.593 25.0946C100.753 25.2706 100.925 25.4216 101.054 25.5986C101.185 25.7786 100.87 25.9216 100.91 26.1356C100.927 26.2076 100.927 26.2836 100.948 26.3526C101.03 26.6576 101.216 27.0006 101.106 27.2766C100.963 27.6426 101.049 27.9916 101.304 28.2876C101.398 28.3976 101.523 28.4846 101.63 28.5836C101.554 28.7866 101.477 28.9906 101.395 29.2126C101.663 30.3396 101.989 31.4646 102.331 32.5816C103.116 35.0916 104.084 37.5346 105.183 39.9056C105.913 41.4876 106.701 43.0426 107.543 44.5646C107.647 44.7546 107.74 44.9536 107.861 45.1356C107.936 45.2406 108.046 45.7146 108.08 45.8266L108.079 45.8276C108.083 45.9426 108.165 45.9736 108.153 46.0926C108.128 46.3546 108.22 46.4876 108.471 46.5926C108.748 46.7096 108.994 46.8406 109.141 47.1136L109.69 48.0476C109.726 48.1056 109.752 48.1786 109.754 48.2476C109.757 48.3936 109.701 48.5556 109.746 48.6846C109.824 48.9006 110.118 48.8606 110.253 49.0026C110.606 49.3666 110.838 49.8186 111.115 50.2366C111.193 50.3546 111.189 50.5026 111.187 50.6546C111.183 50.9656 111.187 50.9786 111.499 51.0726C111.833 51.1736 111.938 51.4066 111.925 51.7316C111.921 51.8776 111.931 52.0226 111.939 52.1956C112.893 53.5356 113.894 54.8696 114.921 56.1686C115.144 56.2386 115.366 56.2816 115.564 56.3696C115.765 56.4596 115.564 56.7386 115.702 56.9016C115.752 56.9556 115.789 57.0196 115.842 57.0686C116.063 57.2856 116.389 57.4966 116.414 57.7936C116.459 58.1836 116.701 58.4396 117.064 58.5746C117.199 58.6256 117.351 58.6416 117.494 58.6776C117.517 58.8936 117.541 59.1106 117.566 59.3446C118.312 60.2116 119.102 61.0606 119.888 61.9106C121.668 63.8126 123.55 65.6236 125.492 67.3586C126.789 68.5136 128.117 69.6376 129.493 70.7016C129.664 70.8376 129.824 70.9846 130.006 71.1076C130.113 71.1776 130.402 71.5696 130.482 71.6566C130.532 71.7576 130.618 71.7546 130.655 71.8656C130.737 72.1116 130.871 72.2046 131.143 72.2036C131.442 72.2046 131.719 72.2306 131.958 72.4276C132.238 72.6566 132.546 72.8486 132.838 73.0616C132.893 73.1016 132.945 73.1596 132.975 73.2226C133.034 73.3566 133.046 73.5286 133.137 73.6296C133.293 73.7996 133.547 73.6486 133.725 73.7286C134.188 73.9336 134.599 74.2296 135.014 74.5166C135.131 74.5946 135.186 74.7336 135.244 74.8746C135.361 75.1646 135.371 75.1756 135.695 75.1416C136.043 75.0966 136.236 75.2666 136.355 75.5666C136.412 75.7006 136.481 75.8276 136.557 75.9836C137.965 76.8486 139.446 77.6396 140.931 78.3996C141.16 78.3766 141.385 78.3136 141.601 78.3106C141.824 78.3056 141.761 78.6436 141.956 78.7336C142.024 78.7606 142.087 78.8036 142.155 78.8256C142.452 78.9266 142.835 78.9796 142.991 79.2346C143.207 79.5616 143.54 79.6916 143.929 79.6536C144.074 79.6396 144.217 79.5896 144.361 79.5576C144.479 79.7416 144.598 79.9266 144.727 80.1266C145.802 80.5556 146.901 80.9676 148.019 81.3296C150.539 82.1556 153.113 82.7436 155.82 83.0026C157.632 83.1816 159.463 83.1996 161.263 82.9726C161.492 82.9576 161.719 82.9386 161.941 82.8816C162.068 82.8456 162.58 82.8956 162.709 82.8996L162.71 82.9006C162.83 82.9346 162.883 82.8686 163.004 82.9166C163.268 83.0216 163.432 82.9626 163.604 82.7556C163.794 82.5266 163.985 82.3306 164.301 82.2676C164.668 82.1836 165.016 82.0406 165.375 81.9326C165.442 81.9106 165.523 81.9016 165.598 81.9136C165.752 81.9396 165.918 82.0306 166.059 81.9996C166.298 81.9526 166.297 81.6596 166.463 81.5486C166.9 81.2736 167.381 81.0686 167.842 80.8196C167.972 80.7516 168.129 80.7646 168.29 80.7766C168.623 80.8036 168.631 80.7806 168.74 80.4696C168.842 80.1586 169.058 80.0516 169.357 80.0396C169.317 80.1436 169.244 80.2236 169.11 80.2716C168.958 80.3266 168.841 80.4076 168.77 80.5416C168.256 81.6396 167.56 82.6226 166.915 83.6396C166.834 83.7626 166.826 83.9126 166.853 84.0726C166.863 84.1476 166.863 84.2256 166.855 84.3016C166.813 84.7006 166.625 85.0216 166.265 85.1916C165.997 85.3186 165.73 85.4126 165.561 85.6936C165.187 86.2576 164.732 86.7596 164.321 87.2966C164.224 87.4146 164.192 87.5536 164.207 87.7186C164.221 87.9596 164.13 88.1026 163.869 88.1676C163.383 88.2886 163.103 88.6316 163.091 89.1366C163.077 89.5676 162.788 89.5716 162.514 89.6286C162.481 89.9016 162.527 90.2326 162.087 90.2426C161.92 90.2486 161.787 90.3046 161.678 90.4126L159.77 92.3246C159.391 92.7436 158.942 93.0846 158.506 93.4386L157.198 94.5046C156.76 94.8576 156.332 95.2246 155.886 95.5656L154.469 96.4806C154.345 96.5586 154.191 96.5886 154.036 96.5506C153.765 96.4826 153.651 96.6196 153.586 96.8576C153.544 97.0136 153.456 97.1306 153.327 97.2126C152.979 97.4316 152.643 97.6766 152.282 97.8736L151.182 98.4406C151.012 98.5286 150.758 98.4566 150.587 98.4546C150.587 98.4546 150.587 98.4546 150.586 98.4546C150.47 98.4546 150.434 98.5346 150.315 98.5186C150.052 98.4826 149.91 98.5606 149.78 98.8076C149.635 99.0786 149.473 99.3216 149.18 99.4526C148.846 99.6226 148.5 99.7666 148.144 99.8846C148.078 99.9096 147.998 99.9216 147.925 99.9096C147.775 99.8846 147.621 99.7996 147.481 99.8176C147.247 99.8496 147.227 100.146 147.052 100.25C146.602 100.521 146.096 100.674 145.604 100.846C145.465 100.897 145.321 100.86 145.173 100.822C144.871 100.743 144.863 100.755 144.668 101.012C144.461 101.291 144.189 101.315 143.877 101.195C143.736 101.142 143.592 101.106 143.422 101.052C142.606 101.266 141.784 101.481 140.961 101.696L138.434 102.091C138.254 102.249 138.097 102.421 137.912 102.548C137.722 102.679 137.589 102.362 137.37 102.4C137.296 102.417 137.22 102.417 137.148 102.438C136.836 102.523 136.461 102.638 136.194 102.492C135.837 102.298 135.479 102.329 135.14 102.537C135.014 102.613 134.905 102.725 134.784 102.816C134.595 102.703 134.403 102.59 134.195 102.468C133.016 102.584 131.819 102.484 130.622 102.447C129.949 102.408 129.272 102.424 128.602 102.342L126.592 102.082C125.924 101.984 125.247 101.934 124.584 101.8L122.602 101.367C120.821 101.046 119.114 100.438 117.379 99.9226L116.731 99.7126C116.602 99.6776 116.2 99.3706 116.097 99.3016L116.098 99.3006C116.018 99.2126 115.934 99.2386 115.865 99.1386C115.712 98.9166 115.557 98.8616 115.288 98.9296C114.992 99.0016 114.706 99.0426 114.411 98.9096L113.362 98.4796C113.297 98.4526 113.23 98.4076 113.186 98.3526C113.095 98.2326 113.043 98.0736 112.93 97.9876C112.742 97.8386 112.518 98.0276 112.321 97.9716C111.815 97.8286 111.352 97.5636 110.885 97.3216C110.752 97.2556 110.677 97.1226 110.6 96.9876C110.441 96.7106 110.432 96.7026 110.1 96.7676C109.746 96.8386 109.526 96.6806 109.375 96.3896C109.307 96.2576 109.219 96.1456 109.135 95.9856C108.4 95.5536 107.659 95.1206 106.918 94.6846C106.176 94.2476 105.418 93.8306 104.727 93.3176C104.492 93.3106 104.262 93.3296 104.041 93.2956C103.816 93.2606 103.926 92.9316 103.74 92.8076C103.676 92.7676 103.619 92.7146 103.552 92.6806C103.267 92.5266 102.88 92.4026 102.768 92.1196C102.612 91.7516 102.307 91.5546 101.903 91.5046C101.756 91.4816 101.605 91.4876 101.456 91.4776C101.387 91.2626 101.316 91.0466 101.239 90.8126C100.316 90.0606 99.3833 89.2976 98.4473 88.5356L95.4893 85.7376C94.5563 84.7526 93.6583 83.7326 92.7403 82.7306C92.1213 82.0686 91.6143 81.3136 91.0453 80.6096C90.5023 79.8846 89.9044 79.1976 89.4064 78.4416C89.2834 78.2506 89.1724 78.0506 89.0354 77.8696C88.9494 77.7656 88.7973 77.2816 88.7523 77.1686C88.6663 76.9396 88.7464 77.0686 88.7854 76.8116C88.2674 76.5986 88.2654 76.5956 88.2713 76.0386C88.1293 75.9836 87.9883 75.9346 87.8473 75.8696C87.6303 75.7656 87.5293 75.5926 87.5253 75.3326C87.5253 75.1906 87.5233 75.0486 87.5233 74.9036C87.3773 74.8476 87.2403 74.7986 87.1153 74.7146C86.9223 74.5876 86.8103 74.4056 86.8403 74.1526C86.8563 74.0076 86.8513 73.8636 86.8584 73.7206C86.7194 73.6546 86.5683 73.6096 86.4543 73.5136C86.1603 73.2696 85.9554 72.9616 85.9794 72.5526C85.9944 72.4026 86.0074 72.2536 86.0264 72.0606C85.8684 71.7656 85.6923 71.4366 85.5163 71.1086L85.3033 70.7116C85.2333 70.5886 85.1153 70.4946 84.9653 70.4436C84.7873 70.3846 84.7173 70.2926 84.7363 70.1396C84.8043 69.5696 84.8133 69.5666 84.6723 69.2706C84.5403 69.0086 84.4853 68.7006 84.2453 68.4996C84.1303 68.4026 83.9814 68.3466 83.8624 68.2526C83.8214 68.2236 83.8173 68.1346 83.8213 68.0706C83.8273 67.9296 83.8464 67.7936 83.8624 67.6546C83.7303 67.5756 83.5983 67.4966 83.4503 67.4056C83.4813 67.2016 83.5114 66.9926 83.5484 66.7456C83.1404 65.5716 82.7223 64.3676 82.3083 63.1756C82.2473 63.1136 82.2053 63.0506 82.1463 63.0026L81.7793 62.7276C81.8043 62.5886 81.7953 62.4486 81.8613 62.3156C81.9273 62.1636 81.9453 62.0316 81.9033 61.8766C80.4063 56.8296 79.8083 51.5486 79.8213 46.2846C79.8333 45.8796 79.9464 45.5606 80.1944 45.2546ZM113.028 144.904C112.792 144.688 112.45 144.48 112.409 144.178C112.347 143.782 112.098 143.519 111.725 143.38C111.587 143.328 111.432 143.31 111.287 143.273C111.258 143.053 111.228 142.834 111.197 142.595C110.418 141.709 109.629 140.811 108.84 139.914C107.092 137.874 105.5 135.705 103.824 133.607L102.168 131.49C101.607 130.79 101.062 130.08 100.57 129.331C100.444 129.144 100.33 128.951 100.189 128.774C100.103 128.673 99.9433 128.201 99.8963 128.087C99.8803 127.97 99.7964 127.946 99.7944 127.824C99.7924 127.557 99.6944 127.425 99.4353 127.335C99.1493 127.231 98.8923 127.111 98.7223 126.839L98.0983 125.911C98.0583 125.853 98.0293 125.78 98.0233 125.708C98.0123 125.56 98.0603 125.392 98.0083 125.263C97.9203 125.044 97.6253 125.091 97.4823 124.948C97.1123 124.578 96.8433 124.129 96.5583 123.695C96.4763 123.574 96.4783 123.423 96.4773 123.269C96.4783 122.954 96.4724 122.941 96.1524 122.837C95.8104 122.728 95.6993 122.487 95.7113 122.161C95.7153 122.015 95.7014 121.87 95.6954 121.696C94.8244 120.253 93.9393 118.788 93.0603 117.333C92.8474 117.229 92.6303 117.15 92.4444 117.03C92.2543 116.907 92.4923 116.657 92.3754 116.47C92.3344 116.408 92.3053 116.336 92.2583 116.28C92.0653 116.025 91.7654 115.759 91.7803 115.458C91.7914 115.061 91.5953 114.759 91.2523 114.553C91.1253 114.476 90.9753 114.429 90.8383 114.365C90.8503 114.147 90.8614 113.927 90.8754 113.691C90.2774 112.677 89.7813 111.595 89.2233 110.543L87.3953 106.967L86.4783 105.178L85.6944 103.331L83.6044 98.3996C83.5184 98.1926 83.4473 97.9816 83.3443 97.7806C83.2783 97.6636 83.2193 97.1766 83.2153 97.0516C83.2333 96.9346 83.1584 96.8896 83.1904 96.7706C83.2604 96.5116 83.2044 96.3586 82.9794 96.2046C82.7344 96.0316 82.5204 95.8476 82.4324 95.5406L82.0874 94.4806C82.0654 94.4146 82.0574 94.3346 82.0704 94.2646C82.1014 94.1186 82.1923 93.9696 82.1783 93.8306C82.1543 93.5966 81.8593 93.5626 81.7603 93.3876C81.5053 92.9326 81.3714 92.4286 81.2164 91.9346C81.1714 91.7956 81.2144 91.6516 81.2554 91.5036C81.3424 91.2016 81.3413 91.1906 81.0623 91.0026C80.7633 90.8036 80.7224 90.5416 80.8244 90.2346C80.8674 90.0946 80.8943 89.9536 80.9373 89.7856C80.5173 88.1606 80.0913 86.5126 79.6673 84.8736C79.4933 84.7116 79.3083 84.5736 79.1633 84.4046C79.0173 84.2306 79.3174 84.0646 79.2594 83.8536C79.2383 83.7816 79.2303 83.7066 79.2023 83.6366C79.0893 83.3396 78.8783 82.9956 78.9803 82.7166C79.0943 82.3476 79.0333 81.9956 78.7883 81.6916C78.6983 81.5786 78.5773 81.4866 78.4733 81.3826C78.5623 81.1776 78.6523 80.9726 78.7493 80.7496C78.5503 79.5976 78.3493 78.4296 78.1463 77.2616L77.8074 75.2906L77.6273 73.3006L77.2684 69.3186C77.1554 68.4336 77.2063 67.5436 77.1833 66.6546L77.1613 63.9886C77.1613 63.7656 77.1753 63.5436 77.1573 63.3196C77.1413 63.1876 77.2743 62.7166 77.3003 62.5986C77.3533 62.4966 77.2963 62.4276 77.3643 62.3296C77.5053 62.1166 77.5103 61.9536 77.3663 61.7266C77.2084 61.4746 77.0823 61.2236 77.1203 60.9086L77.2133 59.8016C77.2183 59.7326 77.2414 59.6556 77.2814 59.5966C77.3664 59.4746 77.5093 59.3726 77.5503 59.2406C77.6173 59.0166 77.3593 58.8726 77.3353 58.6726C77.2773 58.1566 77.3494 57.6406 77.3974 57.1266C77.4094 56.9806 77.5044 56.8656 77.6004 56.7486C77.7964 56.5066 77.8003 56.4946 77.6163 56.2126C77.4193 55.9246 77.4923 55.6806 77.7043 55.4526L78.1893 58.4326L78.9243 61.3636C79.1643 62.3426 79.4013 63.3206 79.7613 64.2616L80.7464 67.1146C81.0583 68.0706 81.5333 68.9656 81.9203 69.8906C82.3473 70.7996 82.6883 71.7496 83.1883 72.6226L84.6293 75.2676C85.1934 76.3966 85.9964 77.4616 86.6684 78.5256C86.7543 78.6606 86.7563 78.7516 86.7303 78.9166C86.7053 79.1586 86.7573 79.3116 87.0213 79.4186C87.5893 79.6476 87.8044 80.1186 87.8064 80.7156C87.8083 80.7666 87.8634 80.8636 87.9024 80.8736C88.3184 80.9606 88.5864 81.2256 88.8284 81.5486C89.2544 82.1116 89.6863 82.6706 90.1333 83.2226C90.3483 83.4786 90.4103 83.7746 90.4263 84.0886C90.4363 84.3216 90.5983 84.5206 90.8443 84.5806C91.1533 84.6506 91.4373 84.7386 91.6583 84.9946C92.1793 85.5766 92.7034 86.1606 93.1994 86.7146C93.2484 86.9946 93.2894 87.2296 93.3324 87.4686C93.3754 87.5286 93.4283 87.5846 93.4843 87.6406C93.5973 87.7486 93.7223 87.8526 93.8263 87.9696C94.0993 88.2886 94.4594 88.4206 94.8714 88.4386C94.9333 88.6596 94.9943 88.8796 95.0643 89.1346C95.7813 89.7846 96.4464 90.5086 97.2254 91.1096C97.9884 91.7286 98.7553 92.3506 99.5213 92.9726C99.9113 93.2856 99.9043 93.3076 100.58 93.3486C100.639 93.4856 100.715 93.6136 100.766 93.7486C100.849 93.9956 101.035 94.1116 101.276 94.1446C101.434 94.1586 101.594 94.1486 101.757 94.1506C101.848 94.3576 101.938 94.5646 102.051 94.8226C106.199 97.6846 110.461 99.9226 115.215 101.628C115.363 101.688 115.416 101.761 115.494 101.911C115.615 102.122 115.744 102.223 116.021 102.149C116.626 101.973 117.095 102.181 117.443 102.687C117.474 102.727 117.576 102.776 117.613 102.76C117.998 102.591 118.369 102.653 118.755 102.778C119.434 102.979 120.096 103.235 120.803 103.348C121.133 103.41 121.367 103.584 121.569 103.83C121.717 104.016 121.965 104.083 122.198 103.988C122.487 103.866 122.766 103.771 123.097 103.851C123.857 104.043 124.629 104.185 125.371 104.281C125.585 104.462 125.764 104.613 125.945 104.767C126.016 104.781 126.093 104.796 126.172 104.812C126.328 104.833 126.49 104.843 126.646 104.876C127.058 104.974 127.424 104.868 127.759 104.638C127.946 104.783 128.129 104.925 128.342 105.089C129.311 105.186 130.301 105.185 131.289 105.234L132.775 105.29C132.98 105.293 133.183 105.283 133.388 105.271C133.402 105.311 133.418 105.349 133.435 105.391C133.382 105.689 133.322 105.996 133.313 106.308C133.308 106.478 133.255 106.605 133.16 106.734C132.791 107.24 132.769 107.246 132.769 107.796C132.758 108.355 132.758 108.358 133.044 108.895C133.075 108.947 133.087 109.034 133.073 109.087C132.798 109.837 132.796 109.845 132.815 110.191C132.837 110.83 132.96 111.457 133.038 112.089C133.731 116.114 135.585 119.747 137.798 122.937C140.027 126.139 142.633 128.981 145.336 131.676C146.202 132.503 147.099 133.394 147.986 134.191C148.097 134.295 148.118 134.379 148.128 134.541C148.153 134.773 148.235 134.901 148.51 134.935C149.103 135.006 149.417 135.385 149.509 135.969C149.519 136.017 149.586 136.098 149.624 136.098C150.032 136.09 150.329 136.287 150.612 136.545C151.11 136.994 151.61 137.44 152.133 137.86C152.381 138.058 152.496 138.314 152.549 138.617C152.584 138.846 152.758 139.011 152.998 139.029C153.299 139.047 153.58 139.086 153.82 139.3C154.386 139.773 154.956 140.249 155.496 140.7C155.557 140.908 155.609 141.088 155.66 141.265C154.853 141.363 154.047 141.462 153.24 141.553C152.999 141.58 152.756 141.592 152.516 141.637C152.376 141.668 151.847 141.592 151.715 141.582C151.597 141.541 151.53 141.605 151.414 141.551C151.161 141.431 150.983 141.457 150.763 141.648C150.517 141.855 150.271 142.029 149.926 142.053L148.726 142.184C148.65 142.192 148.564 142.185 148.494 142.157C148.346 142.098 148.211 141.979 148.06 141.966C147.806 141.945 147.703 142.228 147.494 142.289C146.956 142.449 146.39 142.479 145.834 142.536C145.676 142.555 145.531 142.485 145.383 142.417C145.08 142.274 145.065 142.272 144.811 142.512C144.539 142.767 144.252 142.758 143.943 142.601C143.803 142.533 143.656 142.478 143.485 142.406C141.673 142.636 139.837 142.871 138.01 143.105C137.815 143.259 137.641 143.428 137.442 143.552C137.237 143.679 137.094 143.361 136.86 143.395C136.78 143.41 136.696 143.408 136.62 143.428C136.284 143.506 135.891 143.677 135.599 143.544C135.209 143.377 134.824 143.439 134.474 143.674C134.343 143.76 134.234 143.879 134.113 143.98C133.9 143.884 133.685 143.787 133.455 143.681C132.191 143.851 130.882 144.036 129.594 144.249C126.691 144.735 123.817 145.429 120.988 146.257C120.052 146.566 119.11 146.851 118.182 147.179C117.452 147.461 116.718 147.734 115.991 148.019C115.319 147.288 114.657 146.542 114.005 145.794C113.777 145.731 113.552 145.694 113.347 145.609C113.14 145.523 113.326 145.231 113.177 145.067C113.126 145.017 113.085 144.951 113.028 144.904ZM151.341 307.888C151.345 307.882 151.348 307.88 151.351 307.874L151.33 307.923C151.333 307.912 151.337 307.9 151.341 307.888C151.263 308.042 151.181 308.105 151.025 308.183C150.793 308.318 150.679 308.464 150.718 308.699C150.814 309.26 150.396 309.726 149.815 309.816C149.766 309.828 149.689 309.902 149.687 309.937C149.683 310.339 149.451 310.652 149.137 310.9C148.59 311.334 147.991 311.685 147.363 311.929C147.07 312.06 146.783 311.982 146.537 311.845C146.351 311.706 146.154 311.749 145.99 311.884C145.787 312.081 145.549 312.228 145.244 312.183C145.071 312.158 144.906 312.103 144.734 312.074L144.489 311.988L144.367 311.945L144.305 311.925L144.277 311.917C144.287 311.921 144.298 311.927 144.307 311.931L144.326 311.941L144.327 311.943C144.288 311.923 144.272 311.916 144.265 311.912H144.264H144.263C144.267 311.912 144.265 311.912 144.265 311.912H144.268C144.085 311.818 143.872 311.721 143.734 311.633C143.619 311.537 143.505 311.483 143.384 311.369C143.325 311.103 143.275 310.92 143.265 310.699C143.23 310.65 143.193 310.599 143.15 310.551C143.058 310.463 142.985 310.344 142.914 310.235C142.753 309.924 142.485 309.741 142.123 309.575C142.148 309.362 142.215 309.141 142.277 308.909C142.008 308.079 141.966 307.134 142.078 306.202C142.208 305.247 142.465 304.384 142.974 303.432C143.21 303.049 143.177 303.073 143.204 302.387C143.339 302.321 143.474 302.248 143.617 302.211C143.874 302.147 143.985 301.975 144.057 301.756C144.092 301.606 144.108 301.447 144.139 301.283C144.359 301.248 144.579 301.215 144.854 301.172C145.791 300.451 146.884 299.971 147.932 299.977C148.192 299.979 148.454 299.985 148.702 300.049C148.827 300.076 148.956 300.09 149.073 300.141L149.378 300.245L149.857 300.481C149.939 300.545 150.023 300.604 150.112 300.659C150.297 300.804 150.515 300.975 150.683 301.177C151.41 301.954 151.839 303.087 151.943 304.282C152.044 305.472 151.822 306.719 151.341 307.888ZM184.665 322.308C184.622 322.279 184.513 322.263 184.481 322.288C184.169 322.567 183.795 322.62 183.389 322.616C182.68 322.614 181.972 322.62 181.26 322.639C180.924 322.651 180.654 322.534 180.403 322.338C180.215 322.19 179.964 322.18 179.758 322.322C179.504 322.506 179.252 322.66 178.91 322.656C178.127 322.656 177.34 322.658 176.593 322.66C176.356 322.51 176.156 322.385 175.954 322.258C175.882 322.254 175.805 322.248 175.725 322.244C175.569 322.244 175.409 322.258 175.252 322.244C174.834 322.205 174.488 322.359 174.182 322.633C173.983 322.516 173.786 322.401 173.557 322.266C171.625 322.284 169.653 322.301 167.682 322.321C167.182 322.323 167.178 322.313 166.614 322.696C166.484 322.62 166.345 322.559 166.223 322.477C166.008 322.323 165.791 322.336 165.577 322.448C165.44 322.528 165.317 322.63 165.184 322.721C164.99 322.606 164.795 322.489 164.552 322.342C160.717 322.403 157.037 322.461 153.27 322.52C154.969 321.411 156.493 320.032 157.8 318.487C159.057 317.057 160.065 315.438 160.932 313.747C161.037 313.532 161.157 313.323 161.245 313.099C161.291 312.97 161.631 312.574 161.709 312.47C161.799 312.388 161.772 312.3 161.873 312.228C162.094 312.068 162.15 311.904 162.086 311.619C162.016 311.305 161.973 311.015 162.107 310.705C162.265 310.342 162.341 309.957 162.464 309.584C162.485 309.514 162.525 309.439 162.577 309.383C162.688 309.272 162.852 309.188 162.923 309.055C163.038 308.828 162.823 308.647 162.823 308.434C162.835 307.961 162.945 307.502 163.05 307.041L167.392 306.992L171.787 306.945C171.971 306.945 172.153 306.961 172.338 306.943C172.445 306.927 172.838 307.06 172.936 307.084V307.086C173.022 307.139 173.077 307.082 173.16 307.148C173.341 307.296 173.475 307.289 173.657 307.125C173.86 306.945 174.06 306.801 174.321 306.813L175.235 306.817C175.294 306.817 175.356 306.833 175.408 306.868C175.514 306.944 175.606 307.077 175.718 307.106C175.907 307.157 176.009 306.885 176.171 306.848C176.59 306.748 177.017 306.778 177.442 306.786C177.561 306.786 177.664 306.872 177.769 306.958C177.985 307.134 177.997 307.138 178.209 306.931C178.436 306.708 178.65 306.751 178.869 306.945C178.969 307.029 179.074 307.099 179.197 307.193C179.33 307.191 179.466 307.189 179.599 307.187C179.508 308.503 179.517 309.822 179.661 311.117C179.899 313.021 180.39 314.877 181.153 316.605C181.253 316.82 181.342 317.046 181.454 317.251C181.516 317.368 181.647 317.925 181.71 318.048C181.731 318.185 181.806 318.204 181.816 318.349C181.838 318.667 181.938 318.818 182.165 318.888C182.405 318.974 182.636 319.068 182.835 319.343L183.532 320.284C183.583 320.339 183.629 320.413 183.655 320.491C183.708 320.657 183.719 320.858 183.803 320.993C183.946 321.216 184.172 321.071 184.331 321.19C184.73 321.508 185.171 321.846 185.568 322.219C185.672 322.301 185.728 322.444 185.797 322.578C185.415 322.695 185.03 322.592 184.665 322.308ZM193.746 311.937L193.755 311.941L193.757 311.943H193.758C193.761 311.945 193.755 311.941 193.746 311.937ZM200.77 307.89C200.774 307.884 200.778 307.882 200.78 307.876L200.759 307.923C200.763 307.912 200.767 307.902 200.77 307.89C200.692 308.042 200.612 308.105 200.455 308.183C200.222 308.318 200.11 308.464 200.147 308.699C200.243 309.26 199.825 309.726 199.245 309.818C199.196 309.828 199.12 309.902 199.116 309.937C199.112 310.339 198.882 310.652 198.567 310.9C198.02 311.334 197.422 311.685 196.794 311.929C196.499 312.06 196.212 311.982 195.967 311.845C195.782 311.706 195.585 311.749 195.421 311.884C195.218 312.081 194.978 312.228 194.674 312.183C194.501 312.158 194.335 312.103 194.163 312.074L193.919 311.988L193.796 311.945L193.734 311.925L193.704 311.915L193.698 311.913C193.71 311.919 193.723 311.925 193.735 311.931L193.745 311.937C193.714 311.921 193.647 311.89 193.692 311.912H193.696L193.698 311.914C193.514 311.818 193.3 311.721 193.163 311.633C193.047 311.537 192.934 311.483 192.811 311.367C192.754 311.103 192.703 310.918 192.693 310.699C192.657 310.65 192.621 310.597 192.577 310.551C192.485 310.461 192.413 310.344 192.343 310.235C192.181 309.924 191.913 309.741 191.55 309.575C191.575 309.362 191.643 309.141 191.704 308.909C191.436 308.079 191.394 307.134 191.506 306.202C191.636 305.247 191.892 304.382 192.402 303.432C192.639 303.049 192.605 303.073 192.631 302.385C192.767 302.321 192.901 302.248 193.045 302.209C193.301 302.147 193.412 301.975 193.486 301.756C193.521 301.606 193.537 301.447 193.568 301.283C193.787 301.248 194.007 301.215 194.283 301.172C195.219 300.449 196.312 299.971 197.361 299.977C197.621 299.979 197.882 299.985 198.13 300.049C198.254 300.076 198.384 300.09 198.502 300.141L198.806 300.245L199.285 300.481C199.368 300.545 199.452 300.604 199.54 300.659C199.724 300.804 199.943 300.975 200.112 301.175C200.839 301.954 201.267 303.087 201.372 304.282C201.475 305.472 201.253 306.72 200.77 307.89ZM236.056 234.318C236.029 234.347 236.013 234.38 235.994 234.414C235.883 234.596 235.89 234.818 235.907 235.043C235.916 235.111 235.908 235.176 235.908 235.248C235.765 235.441 235.609 235.637 235.474 235.842C235.404 235.957 235.308 236.018 235.177 236.055C234.661 236.201 234.666 236.207 234.417 236.557C234.161 236.909 234.157 236.905 234.16 237.428C234.163 237.481 234.136 237.545 234.097 237.569C233.509 237.87 233.507 237.868 233.353 238.092L232.509 239.322C230.714 241.937 229.091 244.687 227.575 247.494C226.142 250.348 224.802 253.262 223.796 256.295C223.495 257.25 223.099 258.234 222.862 259.207C222.827 259.33 222.764 259.375 222.632 259.437C222.446 259.537 222.376 259.644 222.482 259.871C222.709 260.359 222.543 260.734 222.074 261.008C222.037 261.033 221.998 261.113 222.015 261.143C222.216 261.455 222.187 261.754 222.095 262.063C221.929 262.6 221.843 263.155 221.731 263.706C221.685 263.968 221.524 264.151 221.291 264.302C221.113 264.415 221.059 264.609 221.164 264.798C221.3 265.034 221.407 265.261 221.344 265.525C221.194 266.125 221.094 266.74 220.989 267.318C220.81 267.476 220.661 267.609 220.509 267.744C220.494 267.799 220.476 267.857 220.466 267.92C220.445 268.043 220.437 268.17 220.404 268.289C220.308 268.609 220.416 268.906 220.644 269.189C220.502 269.326 220.361 269.46 220.199 269.617C219.926 271.125 219.812 272.676 219.62 274.217C219.574 274.61 219.564 274.612 219.889 275.096C219.8 275.188 219.727 275.289 219.633 275.377C219.457 275.527 219.451 275.699 219.549 275.879C219.619 275.994 219.711 276.102 219.795 276.215C219.665 276.356 219.535 276.496 219.373 276.67C219.045 280.621 218.947 284.361 218.85 288.311L218.846 288.313C218.795 289.961 218.743 291.676 218.691 293.389C218.662 295.1 218.632 296.811 218.604 298.453C218.504 298.623 218.43 298.752 218.356 298.877L218.322 298.924L218.284 298.967L218.249 299.012L218.235 299.035L218.226 299.058L218.205 299.138L218.189 299.216L218.179 299.294L218.18 299.37L218.185 299.409L218.193 299.446L218.205 299.483L218.22 299.52L218.239 299.555L218.263 299.592L218.291 299.627L218.324 299.662L218.379 299.721L218.426 299.778L218.468 299.837L218.502 299.896L218.531 299.957L218.552 300.016L218.566 300.077L218.574 300.139L218.576 300.2L218.569 300.262L218.555 300.323L218.534 300.385L218.506 300.447L218.47 300.509L218.427 300.573L218.376 300.635L218.3 300.723L218.267 300.768L218.253 300.791L218.243 300.814L218.217 300.894L218.197 300.972L218.185 301.05L218.182 301.089L218.184 301.126L218.188 301.165L218.194 301.202L218.206 301.239L218.22 301.276L218.24 301.311L218.262 301.348L218.29 301.383L218.321 301.42L218.375 301.477L218.423 301.534L218.465 301.593L218.501 301.65L218.53 301.711L218.554 301.77L218.571 301.831L218.582 301.892L218.585 301.953L218.582 302.015L218.571 302.077L218.553 302.139L218.527 302.203L218.493 302.267L218.452 302.331L218.403 302.397L218.35 302.463L218.304 302.529L218.264 302.599L218.231 302.673L218.204 302.747L218.186 302.827L218.174 302.909L218.172 302.995L218.184 303.747L218.185 304.122V304.216V304.261L218.184 304.267V304.271V304.273C218.198 304.232 218.198 304.234 218.205 304.212V304.214V304.226V304.249L218.206 304.442L213.212 304.485C213.317 302.71 213.181 300.909 212.857 299.157C212.685 298.987 212.503 298.848 212.363 298.677C212.22 298.503 212.513 298.3 212.457 298.073C212.435 297.997 212.428 297.915 212.4 297.843C212.285 297.529 212.031 297.2 212.107 296.88C212.18 296.46 212.076 296.081 211.742 295.833C211.625 295.737 211.482 295.675 211.354 295.597C211.383 295.361 211.413 295.126 211.445 294.87C211.205 294.29 210.841 293.768 210.543 293.214C210.199 292.685 209.819 292.175 209.436 291.673C207.608 289.505 205.146 287.804 202.367 287.153C200.534 286.682 198.6 286.587 196.729 286.901C196.493 286.917 196.266 286.977 196.03 287.038C195.893 287.083 195.415 287.054 195.292 287.054C195.292 287.054 195.292 287.054 195.291 287.054C195.29 287.054 195.29 287.054 195.29 287.054C195.188 287.025 195.11 287.095 195.013 287.05C194.802 286.964 194.628 287.029 194.392 287.269C194.128 287.535 193.88 287.765 193.562 287.857C193.189 287.966 192.838 288.162 192.476 288.308C192.408 288.337 192.331 288.353 192.269 288.343C192.138 288.322 192.019 288.232 191.88 288.259C191.65 288.31 191.568 288.665 191.388 288.802C190.935 289.179 190.427 289.374 189.98 289.695C189.853 289.783 189.722 289.771 189.585 289.763C189.307 289.743 189.288 289.751 189.117 290.113C188.93 290.492 188.708 290.619 188.421 290.617C188.291 290.619 188.158 290.638 187.997 290.652C187.261 291.213 186.616 291.898 185.946 292.55C185.341 293.269 184.678 293.941 184.158 294.73C184.119 295.003 184.11 295.265 184.057 295.507C184.004 295.751 183.702 295.605 183.563 295.806C183.516 295.872 183.471 295.941 183.436 296.015C183.285 296.339 183.171 296.767 182.895 296.906C182.541 297.103 182.316 297.451 182.323 297.9C182.321 298.062 182.356 298.228 182.373 298.388C182.179 298.511 181.981 298.636 181.769 298.771C181.471 299.351 181.246 299.966 181.016 300.582C180.767 301.191 180.578 301.82 180.412 302.455C180.226 303.113 180.077 303.779 179.949 304.447C177.632 304.494 175.326 304.541 172.943 304.59C172.818 304.59 172.759 304.543 172.663 304.432C172.518 304.28 172.398 304.243 172.217 304.405C171.822 304.757 171.421 304.7 171.045 304.323C171.012 304.294 170.926 304.278 170.903 304.303C170.66 304.58 170.371 304.633 170.057 304.631C169.508 304.629 168.96 304.633 168.41 304.654C168.15 304.666 167.939 304.549 167.746 304.353C167.601 304.205 167.405 304.193 167.246 304.337C167.051 304.521 166.855 304.675 166.591 304.669C165.985 304.657 165.375 304.692 164.797 304.675C164.612 304.525 164.459 304.4 164.303 304.271C164.246 304.267 164.187 304.259 164.125 304.259C164.015 304.259 163.902 304.267 163.791 304.259C163.871 302.556 163.738 300.835 163.429 299.157C163.257 298.987 163.075 298.846 162.934 298.677C162.791 298.501 163.086 298.3 163.028 298.073C163.007 297.997 162.999 297.915 162.971 297.843C162.857 297.529 162.602 297.2 162.678 296.88C162.752 296.46 162.649 296.081 162.314 295.833C162.196 295.737 162.053 295.675 161.926 295.597C161.955 295.361 161.985 295.126 162.016 294.87C161.778 294.29 161.413 293.768 161.114 293.214C160.771 292.685 160.391 292.175 160.009 291.673C158.18 289.505 155.718 287.804 152.939 287.153C151.106 286.682 149.171 286.587 147.301 286.903C147.064 286.917 146.839 286.977 146.602 287.038C146.464 287.083 145.986 287.054 145.863 287.054H145.861C145.759 287.025 145.683 287.095 145.586 287.05C145.373 286.964 145.2 287.029 144.963 287.269C144.7 287.535 144.451 287.765 144.133 287.857C143.76 287.966 143.41 288.162 143.048 288.308C142.981 288.337 142.904 288.355 142.84 288.345C142.711 288.322 142.59 288.232 142.453 288.259C142.221 288.31 142.139 288.665 141.959 288.802C141.506 289.179 140.998 289.374 140.553 289.697C140.424 289.783 140.295 289.771 140.158 289.763C139.879 289.745 139.861 289.751 139.689 290.113C139.502 290.492 139.279 290.619 138.994 290.619C138.863 290.619 138.73 290.639 138.568 290.652C137.832 291.213 137.189 291.898 136.518 292.55C135.914 293.269 135.25 293.941 134.73 294.73C134.691 295.003 134.682 295.265 134.629 295.507C134.577 295.753 134.275 295.607 134.136 295.806C134.089 295.874 134.042 295.941 134.009 296.017C133.857 296.341 133.743 296.767 133.468 296.906C133.114 297.103 132.888 297.451 132.896 297.9C132.892 298.064 132.929 298.228 132.945 298.388C132.75 298.513 132.554 298.636 132.341 298.771C132.042 299.351 131.817 299.966 131.587 300.582C131.339 301.191 131.149 301.82 130.983 302.455C130.79 303.141 130.629 303.836 130.501 304.533L130.493 304.535L130.423 304.558L130.354 304.572L130.284 304.58L130.213 304.582L130.142 304.576L130.071 304.562L129.999 304.542L129.925 304.513L129.853 304.478L129.779 304.435L129.705 304.386L129.604 304.308L129.551 304.277L129.524 304.263L129.496 304.253L129.404 304.228L129.312 304.208L129.222 304.196L129.134 304.194L129.089 304.198L129.046 304.206L129.003 304.218L128.96 304.232L128.919 304.252L128.876 304.275L128.835 304.302L128.794 304.335L128.729 304.388L128.664 304.437L128.598 304.478L128.53 304.515L128.462 304.544L128.394 304.569L128.326 304.587L128.256 304.597L128.184 304.601L128.114 304.597L128.041 304.587L127.968 304.569L127.894 304.544L127.82 304.511L127.744 304.47L127.668 304.421L127.592 304.368L127.512 304.323L127.431 304.282L127.346 304.249L127.258 304.224L127.167 304.206L127.071 304.194H126.97L126.099 304.21L125.666 304.212H125.558H125.505H125.497H125.494H125.493H125.492C125.497 304.226 125.497 304.226 125.501 304.232H125.499H125.487L125.464 304.228L125.273 304.207L126.723 290.045C126.851 288.69 126.988 287.262 127.117 285.904V285.902C127.135 285.738 127.189 285.666 127.312 285.55C127.484 285.376 127.537 285.222 127.4 284.966C127.103 284.411 127.212 283.892 127.638 283.435C127.671 283.394 127.699 283.285 127.677 283.251C127.431 282.903 127.418 282.519 127.462 282.106C127.534 281.383 127.602 280.663 127.653 279.936C127.674 279.594 127.817 279.329 128.036 279.092C128.202 278.916 128.239 278.66 128.116 278.438C127.958 278.163 127.829 277.891 127.868 277.543C127.941 276.744 128.014 275.943 128.085 275.182C128.257 274.953 128.401 274.764 128.547 274.569C128.558 274.497 128.569 274.417 128.581 274.337C128.595 274.177 128.598 274.013 128.625 273.855C128.704 273.433 128.581 273.066 128.337 272.728C128.472 272.537 128.606 272.345 128.761 272.124C128.907 270.151 129.058 268.136 129.208 266.122C129.245 265.612 129.257 265.608 128.917 265.003C129.003 264.874 129.074 264.737 129.165 264.618C129.334 264.409 129.338 264.186 129.241 263.96C129.173 263.815 129.081 263.681 128.999 263.538C129.128 263.349 129.259 263.157 129.421 262.919C129.491 261.759 129.545 260.612 129.591 259.47L129.645 257.757L129.675 255.945C129.663 254.736 129.671 253.529 129.534 252.328C129.444 251.734 129.336 251.121 128.966 250.621C128.659 250.094 128.351 249.566 128.04 249.033C127.765 248.574 127.476 248.094 127.185 247.609C127.097 247.457 127.097 247.363 127.123 247.191C127.149 246.933 127.097 246.769 126.837 246.65C126.272 246.379 126.054 245.892 126.128 245.275C126.132 245.222 126.089 245.117 126.051 245.103C125.65 244.968 125.411 244.665 125.204 244.308C124.839 243.681 124.47 243.06 124.085 242.445C123.901 242.156 123.862 241.857 123.901 241.539C123.934 241.299 123.812 241.07 123.583 240.963C123.294 240.832 123.032 240.686 122.862 240.381C122.462 239.69 122.059 238.994 121.678 238.334C121.688 238.049 121.695 237.811 121.702 237.566C121.668 237.502 121.633 237.431 121.597 237.359C121.518 237.22 121.424 237.084 121.356 236.939C121.178 236.55 120.868 236.322 120.475 236.187C120.475 235.953 120.475 235.72 120.475 235.451C119.485 233.748 118.446 232.023 117.456 230.275C117.204 229.832 117.211 229.824 116.596 229.509C116.598 229.355 116.581 229.202 116.592 229.054C116.617 228.786 116.498 228.601 116.293 228.464C116.156 228.384 116.006 228.323 115.859 228.249C115.863 228.02 115.868 227.79 115.874 227.503C114.591 225.276 113.328 223.118 112.106 220.937C110.88 218.759 109.617 216.597 108.429 214.316C108.354 214.171 108.361 214.082 108.4 213.918C108.448 213.678 108.41 213.522 108.154 213.385C107.603 213.086 107.411 212.59 107.518 211.981C107.525 211.928 107.486 211.821 107.45 211.805C107.055 211.651 106.834 211.336 106.645 210.969C106.312 210.328 105.98 209.69 105.645 209.047C105.485 208.746 105.468 208.445 105.531 208.131C105.582 207.895 105.478 207.658 105.258 207.535C104.981 207.387 104.729 207.223 104.581 206.908C104.229 206.193 103.877 205.476 103.541 204.795C103.57 204.514 103.596 204.279 103.621 204.039C103.592 203.971 103.56 203.898 103.529 203.824C103.457 203.683 103.384 203.537 103.328 203.388C103.191 202.986 102.906 202.734 102.53 202.564C102.554 202.332 102.578 202.101 102.605 201.834C101.791 200.057 100.917 198.256 100.191 196.41C100 195.943 100.007 195.937 99.4383 195.549C99.4603 195.399 99.4643 195.246 99.4943 195.102C99.5563 194.846 99.4633 194.647 99.2764 194.487C99.1504 194.389 99.0093 194.309 98.8733 194.217C98.9123 193.992 98.9363 193.772 98.9943 193.49C97.2143 188.761 95.7133 184.183 95.3263 179.232C95.3123 179.076 95.3513 178.998 95.4503 178.873C95.6033 178.685 95.6443 178.537 95.4843 178.312C95.1383 177.826 95.2024 177.306 95.5834 176.849C95.6134 176.81 95.6294 176.704 95.6044 176.673C95.3364 176.361 95.2563 175.985 95.3293 175.597C95.4173 174.913 95.4973 174.228 95.5603 173.536C95.5753 173.208 95.7704 172.974 96.0144 172.776C96.2024 172.63 96.2683 172.399 96.1743 172.174C96.0513 171.895 95.9593 171.617 96.0403 171.293C96.1933 170.545 96.4654 169.814 96.7084 169.121C96.9254 168.953 97.1053 168.812 97.2913 168.668C97.3163 168.604 97.3464 168.533 97.3754 168.463C97.4284 168.32 97.4534 168.162 97.5354 168.033C97.7394 167.681 97.7323 167.32 97.6073 166.935C97.7943 166.808 97.9783 166.683 98.1923 166.537C98.9513 164.836 99.9604 163.209 101.091 161.674C101.368 161.276 101.374 161.284 101.448 160.628C101.592 160.581 101.727 160.518 101.869 160.482C102.124 160.423 102.252 160.257 102.306 160.025C102.333 159.873 102.339 159.714 102.357 159.553C102.566 159.49 102.777 159.426 103.041 159.347C106.445 155.827 110.365 153.059 114.965 151.012C115.111 150.949 115.201 150.962 115.358 151.014C115.589 151.079 115.743 151.054 115.895 150.81C116.219 150.277 116.727 150.132 117.319 150.326C117.37 150.339 117.477 150.314 117.497 150.281C117.689 149.912 118.022 149.732 118.403 149.594C119.063 149.335 119.739 149.124 120.413 148.892C120.731 148.78 121.024 148.81 121.319 148.921C121.54 149.007 121.782 148.942 121.936 148.743C122.127 148.497 122.332 148.287 122.665 148.203C123.429 148.018 124.181 147.768 124.915 147.612C125.181 147.708 125.403 147.788 125.631 147.869C125.702 147.857 125.778 147.845 125.857 147.833C126.01 147.8 126.164 147.753 126.32 147.731C126.736 147.681 127.04 147.456 127.287 147.122C127.506 147.199 127.723 147.276 127.973 147.365C129.873 146.99 131.809 146.684 133.787 146.427C134.295 146.365 134.3 146.374 134.828 145.926C134.969 145.988 135.117 146.03 135.25 146.097C135.486 146.224 135.705 146.185 135.91 146.048C136.037 145.952 136.151 145.837 136.275 145.73C136.486 145.822 136.697 145.915 136.961 146.031C142.065 145.377 146.887 144.66 152.004 144.061V144.062C152.166 144.043 152.249 144.083 152.387 144.178C152.594 144.308 152.754 144.329 152.975 144.14C153.454 143.734 153.986 143.733 154.518 144.054C154.565 144.077 154.678 144.081 154.706 144.052C154.995 143.74 155.368 143.646 155.779 143.603C156.499 143.526 157.216 143.442 157.935 143.341C158.274 143.289 158.561 143.388 158.835 143.556C159.039 143.687 159.297 143.674 159.49 143.513C159.728 143.306 159.97 143.129 160.318 143.103C160.793 143.058 161.267 143.014 161.736 142.97C161.408 143.211 161.086 143.464 160.775 143.741C160.581 143.904 160.505 144.243 160.338 144.428C160.126 144.649 159.779 144.7 159.569 144.939C158.563 146.09 157.753 147.483 157.317 149.009C157.268 149.189 157.108 149.382 157.059 149.567C157.018 149.754 157.102 149.923 157.07 150.107C156.903 150.993 156.924 151.906 157.026 152.787C157.233 154.158 157.802 155.548 158.702 156.725C158.872 156.931 159.196 157.054 159.384 157.228C159.607 157.45 159.654 157.812 159.901 158.03C161.086 159.079 162.511 159.813 163.968 160.266C164.142 160.313 164.322 160.473 164.497 160.52C164.672 160.567 164.837 160.512 165.009 160.549C165.429 160.626 165.845 160.701 166.261 160.778C166.677 160.818 167.091 160.858 167.501 160.897C168.761 160.942 170.138 160.883 171.403 160.7C171.632 160.669 171.871 160.432 172.1 160.403C172.381 160.368 172.659 160.538 172.944 160.502C173.635 160.414 174.33 160.325 175.026 160.237L177.102 159.887C177.266 159.858 177.481 159.928 177.643 159.901C177.807 159.874 177.92 159.75 178.082 159.723C178.864 159.609 179.635 159.445 180.391 159.28V159.279C180.522 159.249 180.625 159.225 180.752 159.195L180.773 159.178L180.801 159.162C180.823 159.152 180.848 159.141 180.876 159.129C180.904 159.119 180.937 159.109 180.971 159.098C181.006 159.088 181.044 159.078 181.083 159.068C181.164 159.05 181.253 159.032 181.346 159.01C181.441 158.994 181.538 158.978 181.635 158.961C181.734 158.947 181.83 158.934 181.923 158.922C182.015 158.912 182.103 158.902 182.179 158.895C182.257 158.889 182.325 158.885 182.378 158.881C182.403 158.881 182.427 158.881 182.446 158.881C182.464 158.883 182.478 158.884 182.489 158.885L182.548 158.897L182.607 158.903L182.666 158.906L182.725 158.905L182.841 158.894L182.955 158.873L183.183 158.807L183.412 158.745C183.454 158.734 183.491 158.725 183.524 158.717C183.555 158.707 183.585 158.699 183.612 158.692L183.688 158.661L183.758 158.62C183.781 158.602 183.805 158.583 183.833 158.562C183.859 158.54 183.888 158.513 183.92 158.484C183.984 158.422 184.063 158.344 184.169 158.241L184.211 158.204L184.233 158.19L184.255 158.177L184.276 158.167L184.299 158.16L184.322 158.154L184.347 158.152H184.371L184.396 158.156L184.45 158.168L184.507 158.191L184.568 158.222L184.611 158.244L184.654 158.261L184.699 158.275L184.744 158.283L184.835 158.293H184.926L184.949 158.297L184.971 158.304L184.993 158.311L185.004 158.312L185.015 158.311L185.132 158.29L185.249 158.263L185.481 158.201L185.549 158.178L185.613 158.15L185.672 158.116L185.729 158.08L185.838 158.003L185.948 157.929L186.006 157.897L186.068 157.871L186.135 157.85L186.208 157.837L186.288 157.835C186.315 157.837 186.345 157.84 186.376 157.843C186.407 157.85 186.439 157.857 186.474 157.864L186.525 157.88L186.576 157.899L186.599 157.874L186.626 157.853L186.655 157.833L186.686 157.817L186.752 157.79L186.822 157.769L186.889 157.749L186.952 157.728L186.979 157.714L187.005 157.7L187.027 157.682L187.047 157.662L187.072 157.637L187.105 157.614C187.13 157.6 187.158 157.586 187.188 157.569C187.25 157.544 187.32 157.513 187.384 157.485C187.417 157.47 187.448 157.456 187.476 157.442L187.517 157.421L187.551 157.398L187.582 157.377L187.595 157.365L187.605 157.353L187.612 157.34L187.617 157.327L187.618 157.313L187.617 157.299C187.549 157.002 187.472 156.659 187.387 156.282C187.291 155.888 187.188 155.458 187.078 155.004L186.961 154.521C186.953 154.48 186.945 154.442 186.94 154.407C186.936 154.372 186.933 154.339 186.93 154.305V154.213L186.934 154.123C186.936 154.064 186.936 154.006 186.938 153.941C186.936 153.91 186.932 153.877 186.93 153.841C186.923 153.806 186.916 153.769 186.909 153.728C186.903 153.71 186.896 153.691 186.888 153.667C186.878 153.646 186.867 153.622 186.855 153.596C186.829 153.545 186.797 153.488 186.767 153.431C186.737 153.373 186.705 153.316 186.679 153.266C186.666 153.24 186.657 153.216 186.646 153.195C186.638 153.172 186.631 153.152 186.625 153.135C186.396 152.185 186.18 151.282 185.994 150.507C185.867 149.982 185.734 149.429 185.599 148.864C185.573 148.762 185.346 148.692 185.324 148.591C185.295 148.466 185.468 148.31 185.439 148.183C185.3 147.572 185.162 146.953 185.023 146.337C185.006 146.265 185.089 146.153 185.073 146.081C185.057 146.009 184.943 145.974 184.929 145.901C184.855 145.552 184.781 145.208 184.708 144.868H184.706C184.681 144.759 184.659 144.673 184.634 144.568L184.618 144.55L184.602 144.528C184.594 144.51 184.584 144.489 184.573 144.466C184.564 144.442 184.555 144.416 184.544 144.387C184.536 144.358 184.527 144.326 184.518 144.294C184.503 144.227 184.487 144.153 184.469 144.076C184.456 143.998 184.443 143.916 184.429 143.836C184.418 143.754 184.408 143.673 184.398 143.596C184.391 143.52 184.384 143.447 184.378 143.383C184.376 143.318 184.373 143.261 184.371 143.217C184.372 143.195 184.372 143.176 184.372 143.16C184.376 143.144 184.377 143.132 184.378 143.124L184.392 143.074L184.4 143.024L184.405 142.975L184.406 142.926L184.398 142.829L184.382 142.734L184.334 142.544L184.31 142.45L184.292 142.354C184.284 142.319 184.278 142.288 184.272 142.26C184.265 142.233 184.258 142.208 184.252 142.186L184.229 142.123L184.213 142.093L184.193 142.064C184.177 142.045 184.162 142.025 184.142 142.002C184.122 141.981 184.099 141.956 184.072 141.929C184.017 141.876 183.947 141.81 183.853 141.722L183.82 141.687L183.806 141.669L183.796 141.649L183.788 141.63L183.782 141.61L183.78 141.589V141.569L183.782 141.548L183.786 141.527L183.798 141.498H184.236C184.547 141.5 184.713 141.56 184.961 141.578C185.195 141.607 185.473 141.699 185.731 141.754C186.776 142.055 187.805 142.586 188.758 143.266C188.877 143.354 188.906 143.434 188.932 143.588C188.981 143.804 189.055 143.931 189.327 143.945C189.919 143.97 190.251 144.369 190.292 144.954C190.298 145.002 190.359 145.084 190.397 145.086C190.801 145.1 191.065 145.346 191.316 145.633C191.733 146.156 192.135 146.691 192.499 147.257C192.687 147.515 192.706 147.802 192.64 148.102C192.589 148.325 192.687 148.531 192.905 148.635C193.176 148.762 193.4 148.923 193.527 149.219C193.679 149.557 193.795 149.907 193.915 150.251C194.049 150.592 194.137 150.941 194.207 151.285C194.105 151.537 194.037 151.738 193.946 151.942C193.951 152.007 193.953 152.078 193.963 152.149C193.983 152.289 194.018 152.431 194.025 152.573C194.054 152.95 194.216 153.24 194.503 153.511C194.396 153.697 194.289 153.88 194.166 154.093C194.186 155.834 193.801 157.607 193.043 159.245C192.836 159.659 192.852 159.657 192.93 160.307C192.797 160.374 192.676 160.454 192.545 160.511C192.307 160.603 192.215 160.779 192.203 161.011C192.203 161.161 192.232 161.321 192.232 161.476C192.027 161.555 191.82 161.634 191.562 161.733C190.169 163.637 188.403 165.245 186.457 166.633C184.507 168.024 182.374 169.219 180.062 170.217L180.064 170.223L180.061 170.221C179.933 170.326 179.773 170.457 179.613 170.586L179.488 170.682L179.359 170.772L179.222 170.854L179.152 170.889L179.08 170.918C177.361 171.547 175.642 172.176 173.927 172.803C173.846 172.828 173.768 172.856 173.69 172.881L173.575 172.91L173.462 172.933L173.351 172.953L173.242 172.965L173.133 172.969H173.028C172.971 172.969 172.919 172.969 172.868 172.969C172.815 172.971 172.764 172.975 172.714 172.979C172.663 172.987 172.613 172.995 172.566 173.002L172.493 173.02L172.422 173.04L172.352 173.065L172.282 173.094L172.214 173.129L172.148 173.168L172.082 173.211L172.016 173.262L171.952 173.317L171.89 173.378L171.814 173.45L171.732 173.516L171.64 173.582L171.544 173.643L171.44 173.702L171.334 173.757L171.224 173.808L171.11 173.853L164.095 176.441L156.95 178.648L154.097 179.529L152.67 179.972L152.492 180.027L152.312 180.078L151.952 180.17L151.229 180.354L151.107 180.387L150.992 180.424L150.883 180.467L150.778 180.512L150.678 180.561L150.584 180.616L150.493 180.675L150.407 180.737C150.369 180.766 150.334 180.792 150.3 180.817C150.262 180.84 150.227 180.862 150.194 180.881C150.157 180.901 150.123 180.918 150.09 180.936L149.986 180.979L149.883 181.012L149.781 181.035L149.679 181.051L149.579 181.061L149.479 181.065L149.379 181.063L149.182 181.049C149.052 181.035 148.918 181.022 148.789 181.008C148.68 181.08 148.569 181.154 148.463 181.225L148.298 181.327L148.213 181.372L148.123 181.415L148.031 181.454L147.933 181.487L147.831 181.514L147.722 181.535C147.685 181.541 147.648 181.545 147.607 181.551C147.568 181.553 147.528 181.555 147.485 181.559C147.443 181.557 147.4 181.557 147.354 181.557C147.31 181.555 147.263 181.551 147.214 181.547L147.021 181.533L146.826 181.531L146.631 181.539L146.434 181.557L146.239 181.584L146.044 181.621L145.851 181.668L145.659 181.721L145.375 181.819L145.098 181.926L144.962 181.983L144.83 182.045L144.699 182.111L144.572 182.185C144.515 182.214 144.463 182.244 144.414 182.269C144.359 182.294 144.31 182.316 144.262 182.337C144.209 182.355 144.16 182.372 144.113 182.388L143.966 182.423L143.82 182.443C143.773 182.443 143.724 182.445 143.674 182.447C143.626 182.443 143.576 182.439 143.525 182.435C143.477 182.429 143.425 182.421 143.372 182.412L143.27 182.392L143.166 182.378L142.983 182.431L142.78 182.634C142.78 182.634 142.746 182.966 142.764 183.208C142.77 183.272 142.776 183.335 142.78 183.392L142.788 183.476L142.79 183.515V183.554C142.792 183.663 142.792 183.736 142.793 183.781C142.803 183.924 142.829 184.133 142.858 184.556C142.858 184.556 142.952 184.806 143.124 184.853C143.253 184.888 143.655 184.915 143.655 184.915C144.046 184.954 144.43 184.993 144.772 185.028L144.885 185.044L144.991 185.054L145.094 185.058L145.194 185.056L145.292 185.05L145.388 185.038L145.485 185.02L145.582 184.999L145.653 184.983L145.728 184.973L145.882 184.957L146.105 184.93L146.33 184.909L146.992 185.296L147.08 185.339L147.175 185.38C147.24 185.407 147.307 185.437 147.379 185.466L147.83 185.554L148.279 185.661L149.177 185.876L149.627 185.981L149.739 186.008L149.85 186.041L150.073 186.105L150.961 186.363L151.849 186.621L152.718 186.92L153.584 187.223L154.015 187.373L154.231 187.449L154.337 187.488L154.442 187.533C154.88 187.57 155.253 187.603 155.618 187.637C155.829 187.832 156.015 188.004 156.205 188.18L156.577 188.219L156.952 188.268C156.979 188.274 157.011 188.282 157.043 188.288L157.14 188.317C157.17 188.331 157.2 188.342 157.226 188.352L157.261 188.372L157.29 188.393L157.432 188.53L157.564 188.671L157.697 188.81L157.84 188.947L157.923 189.013L158.008 189.075L158.186 189.192L158.372 189.297L158.564 189.397C158.824 189.522 159.086 189.649 159.343 189.772C159.379 189.79 159.412 189.807 159.444 189.823C159.474 189.841 159.503 189.858 159.53 189.874C159.585 189.903 159.634 189.931 159.68 189.958C159.727 189.979 159.77 190.001 159.813 190.022C159.858 190.04 159.902 190.057 159.95 190.077C159.997 190.093 160.048 190.108 160.105 190.126C160.162 190.142 160.225 190.157 160.297 190.177C160.443 190.212 160.625 190.255 160.867 190.312C160.9 190.322 160.931 190.33 160.961 190.337L161.047 190.372L161.127 190.413L161.201 190.462L161.271 190.521L161.334 190.589L161.394 190.665C161.412 190.692 161.431 190.722 161.451 190.751L161.502 190.829L161.557 190.905L161.619 190.977L161.685 191.047L161.757 191.115L161.833 191.181L161.913 191.243L161.998 191.3L162.183 191.419L162.363 191.546L162.726 191.794C163.326 192.202 163.926 192.61 164.464 192.976C164.628 193.023 164.773 193.064 164.908 193.101L165.009 193.13L165.103 193.163L165.288 193.229L165.41 193.28L165.53 193.335L165.646 193.396L165.761 193.46L165.982 193.603L166.193 193.759L166.392 193.931L166.583 194.113L166.765 194.306L166.939 194.507L167.001 194.587L167.058 194.667L167.158 194.831L167.346 195.163L167.698 195.308L167.786 195.345L167.87 195.386L168.034 195.462C168.084 195.485 168.131 195.509 168.177 195.53L168.31 195.612L168.435 195.702L168.55 195.802L168.658 195.911L168.759 196.028L168.851 196.153L168.937 196.286L169.037 196.458L169.121 196.63L169.279 196.974C169.511 197.087 169.74 197.197 169.965 197.304C170.018 197.331 170.067 197.359 170.115 197.384C170.162 197.413 170.209 197.441 170.254 197.468L170.381 197.56L170.498 197.66L170.605 197.765L170.628 197.792L170.651 197.823L170.693 197.885L170.771 198.014L170.84 198.153L170.986 198.514L171.123 198.871C171.227 198.932 171.318 198.982 171.398 199.029C171.48 199.08 171.549 199.123 171.611 199.16C171.642 199.181 171.672 199.201 171.698 199.219L171.773 199.278L171.84 199.339L171.9 199.4L171.953 199.468L172.004 199.54L172.051 199.622C172.067 199.651 172.082 199.683 172.098 199.716C172.127 199.78 172.16 199.855 172.198 199.941C172.233 200.025 172.272 200.121 172.317 200.232C172.364 200.25 172.403 200.265 172.435 200.279C172.466 200.289 172.492 200.297 172.512 200.302C172.533 200.304 172.549 200.306 172.563 200.308C172.576 200.31 172.586 200.31 172.597 200.312L172.614 200.316L172.631 200.322L172.652 200.332L172.675 200.35C172.694 200.364 172.716 200.381 172.745 200.405C172.772 200.43 172.807 200.46 172.852 200.499L172.853 200.503C172.913 200.569 172.903 200.63 172.864 200.751C172.811 200.927 172.846 201.007 173.048 201.009C173.487 201.011 173.615 201.28 173.478 201.726C173.468 201.763 173.493 201.822 173.523 201.818C173.843 201.785 174.009 201.918 174.14 202.099C174.372 202.413 174.609 202.722 174.859 203.025C174.98 203.166 174.974 203.353 174.897 203.578C174.837 203.744 174.91 203.861 175.095 203.869C175.328 203.875 175.538 203.898 175.648 204.053C175.878 204.414 176.115 204.772 176.316 205.127C176.255 205.318 176.205 205.475 176.154 205.637C176.17 205.672 176.185 205.713 176.207 205.75C176.252 205.822 176.307 205.889 176.34 205.967C176.422 206.18 176.652 206.26 176.977 206.266C176.93 206.416 176.885 206.567 176.832 206.739L177.248 207.407L177.599 208.116L178.307 209.544C178.426 209.788 178.416 209.792 178.901 209.919C178.86 210.013 178.837 210.105 178.79 210.196C178.703 210.358 178.756 210.464 178.897 210.532C178.995 210.571 179.112 210.596 179.222 210.63C179.149 210.773 179.076 210.915 178.985 211.093C179.47 212.366 179.995 213.593 180.325 214.888C180.499 215.533 180.741 216.161 180.862 216.826C180.992 217.488 181.124 218.156 181.257 218.832C181.448 219.775 181.474 220.783 181.581 221.775C181.671 222.771 181.638 223.775 181.694 224.736C181.598 224.836 181.528 224.91 181.457 224.984C181.419 225.021 181.349 225.05 181.329 225.088C181.265 225.213 181.227 225.33 181.415 225.442C181.718 225.624 181.749 225.819 181.452 226.01C181.4 226.041 181.341 226.072 181.315 226.112C181.237 226.233 181.203 226.35 181.383 226.467C181.678 226.653 181.742 226.848 181.447 227.039C181.301 227.135 181.207 227.238 181.209 227.377C181.225 227.721 181.172 228.063 181.149 228.393C181.242 228.485 181.322 228.563 181.402 228.641C181.613 228.856 181.569 229.067 181.423 229.258C181.342 229.369 181.181 229.455 181.045 229.559C180.813 232.008 180.399 234.454 179.783 236.829C179.783 236.829 179.708 237.138 179.614 237.434C179.525 237.735 179.435 238.036 179.435 238.036L179.257 238.544C179.38 238.806 179.423 239.075 179.861 239.239C180 239.292 180.146 239.348 180.287 239.403C180.355 239.428 180.422 239.456 180.49 239.479C180.492 239.481 180.496 239.481 180.498 239.483C180.572 239.508 180.648 239.534 180.719 239.565C180.953 239.67 181.252 239.799 181.443 239.768C181.655 239.762 181.809 239.565 181.887 239.356C181.95 239.184 181.965 239.004 181.914 238.911C181.853 238.811 181.928 238.755 181.862 238.653L181.779 238.319L181.858 238.048C181.996 237.984 182.09 237.925 182.201 237.884C182.484 237.782 182.427 237.603 182.277 237.4C182.173 237.257 182.105 237.125 182.146 236.98C182.28 236.546 182.365 236.101 182.457 235.664C182.562 235.602 182.659 235.547 182.756 235.49C183.063 235.314 183.132 235.045 182.885 234.75C182.75 234.588 182.787 234.496 182.966 234.422C183.086 234.371 183.164 234.309 183.181 234.219C183.299 233.498 183.45 232.783 183.525 232.057C183.538 231.967 183.473 231.879 183.374 231.793C183.33 231.752 183.293 231.707 183.265 231.662C183.113 231.424 183.125 231.207 183.359 231.029C183.533 230.898 183.724 230.781 183.738 230.582L183.832 229.355C183.842 229.263 183.787 229.179 183.678 229.097C183.526 228.974 183.516 228.874 183.688 228.759C184.01 228.542 184.036 228.269 183.75 228.015C183.508 227.796 183.738 227.699 183.912 227.57C183.746 227.424 183.484 227.283 183.793 227.115C183.908 227.051 183.967 226.972 183.971 226.879L184.024 225.24C184.022 224.556 183.981 223.873 183.958 223.189L183.919 222.166L183.812 221.145C183.804 221.057 183.853 220.963 183.962 220.887C184.153 220.75 184.089 220.649 183.913 220.555C183.797 220.494 183.739 220.416 183.729 220.325C183.665 219.829 183.645 219.325 183.534 218.835C183.509 218.72 183.663 218.579 183.725 218.476C183.766 218.404 183.704 218.371 183.76 218.3C183.883 218.144 183.858 218.042 183.672 217.935C183.47 217.812 183.301 217.689 183.28 217.494C183.252 217.269 183.203 217.047 183.168 216.82C183.16 216.779 183.168 216.728 183.196 216.683C183.256 216.591 183.375 216.497 183.39 216.41C183.414 216.26 183.136 216.238 183.078 216.125C182.932 215.836 182.86 215.525 182.794 215.215C182.773 215.129 182.836 215.035 182.899 214.938C183.03 214.739 183.031 214.729 182.79 214.626C182.532 214.515 182.534 214.351 182.679 214.142C182.742 214.048 182.79 213.953 182.857 213.839C182.615 212.821 182.228 211.831 181.849 210.847C181.685 210.777 181.51 210.726 181.376 210.648C181.239 210.568 181.529 210.394 181.478 210.269C181.458 210.226 181.453 210.179 181.427 210.14C181.325 209.97 181.132 209.796 181.232 209.587C181.365 209.306 181.244 209.112 180.978 208.993C180.878 208.948 180.752 208.927 180.642 208.893C180.703 208.743 180.765 208.59 180.833 208.424C180.511 207.772 180.185 207.112 179.858 206.449C179.493 205.705 179.001 205.033 178.577 204.322C178.489 204.187 178.405 204.051 178.321 203.914C178.604 203.937 178.852 204.066 179.096 204.234C179.657 204.617 180.219 204.992 180.793 205.357C181.064 205.527 181.215 205.771 181.307 206.07C181.373 206.295 181.569 206.439 181.809 206.429C182.11 206.409 182.394 206.417 182.661 206.603C183.3 206.998 183.94 207.392 184.548 207.767C184.661 208.013 184.755 208.218 184.851 208.429C184.908 208.468 184.968 208.511 185.031 208.554C185.158 208.634 185.297 208.704 185.417 208.794C185.736 209.038 186.1 209.081 186.495 209.005C186.595 209.204 186.693 209.401 186.807 209.63C188.389 210.589 190.004 211.568 191.617 212.544C192.026 212.794 192.024 212.806 192.679 212.761C192.745 212.892 192.826 213.015 192.885 213.146C192.981 213.386 193.164 213.486 193.397 213.498C193.547 213.496 193.7 213.473 193.856 213.459C193.954 213.658 194.053 213.855 194.176 214.104C198.42 216.401 202.432 218.581 206.723 220.807C206.86 220.875 206.903 220.952 206.959 221.102C207.048 221.317 207.163 221.418 207.44 221.373C208.039 221.281 208.454 221.553 208.699 222.098C208.72 222.141 208.808 222.203 208.845 222.194C209.241 222.081 209.584 222.194 209.93 222.37C210.536 222.677 211.144 222.975 211.762 223.263C212.054 223.396 212.234 223.617 212.363 223.9C212.457 224.113 212.67 224.232 212.908 224.191C213.207 224.134 213.49 224.105 213.781 224.255C214.451 224.589 215.125 224.925 215.765 225.243C215.904 225.481 216.021 225.679 216.138 225.882C216.199 225.917 216.263 225.954 216.329 225.991L216.739 226.188C217.089 226.385 217.458 226.379 217.842 226.25C217.967 226.434 218.091 226.615 218.235 226.826C219.937 227.556 221.675 228.305 223.411 229.051C223.851 229.24 223.851 229.252 224.496 229.117C224.58 229.24 224.678 229.347 224.754 229.471C224.881 229.696 225.077 229.768 225.309 229.748C225.459 229.727 225.607 229.682 225.76 229.648C225.885 229.83 226.01 230.013 226.166 230.242C227.266 230.74 228.395 231.131 229.509 231.535C230.623 231.935 231.731 232.334 232.838 232.732C233.945 233.13 235.053 233.527 236.168 233.929C236.221 233.949 236.273 233.968 236.324 233.986C236.228 234.097 236.151 234.215 236.056 234.318ZM349.185 217.109C348.294 218.091 347.472 219.142 346.468 220.015L344.534 221.839C343.874 222.427 343.285 223.101 342.561 223.618C342.385 223.755 342.202 223.88 342.036 224.03C341.942 224.122 341.485 224.307 341.376 224.362L341.374 224.36C341.261 224.383 341.241 224.467 341.121 224.477C340.857 224.495 340.733 224.598 340.661 224.864C340.577 225.153 340.473 225.419 340.216 225.602L339.337 226.28C339.282 226.323 339.21 226.356 339.141 226.366C338.995 226.384 338.829 226.345 338.705 226.403C338.495 226.501 338.556 226.798 338.422 226.948C338.058 227.313 337.598 227.563 337.161 227.839C337.04 227.917 336.886 227.913 336.731 227.909C336.413 227.905 336.401 227.909 336.297 228.221C336.187 228.555 335.943 228.66 335.615 228.641C335.468 228.635 335.322 228.645 335.148 228.647C334.449 229.106 333.746 229.567 333.041 230.03L330.814 231.235C330.703 231.442 330.618 231.653 330.49 231.833C330.36 232.017 330.121 231.767 329.929 231.874C329.867 231.913 329.794 231.938 329.736 231.981C329.474 232.161 329.195 232.448 328.898 232.417C328.505 232.386 328.197 232.565 327.976 232.899C327.893 233.02 327.838 233.169 327.767 233.303C327.554 233.285 327.335 233.252 327.093 233.205C326.021 233.67 324.937 234.139 323.851 234.609C321.444 235.754 318.878 236.507 316.359 237.375C314.693 238.006 312.935 238.328 311.214 238.785C310.997 238.838 310.777 238.875 310.564 238.945C310.44 238.99 309.947 238.97 309.827 238.974C309.826 238.974 309.826 238.974 309.825 238.974C309.715 238.949 309.66 239.017 309.549 238.976C309.305 238.882 309.149 238.927 308.967 239.14C308.766 239.372 308.558 239.572 308.246 239.632C307.887 239.724 307.516 239.761 307.15 239.825C307.08 239.835 307 239.831 306.932 239.807C306.79 239.752 306.657 239.639 306.517 239.631C306.282 239.617 306.206 239.902 306.019 239.971C305.531 240.149 305.011 240.2 304.499 240.274C304.354 240.297 304.218 240.231 304.077 240.167C303.79 240.034 303.778 240.032 303.553 240.278C303.314 240.54 303.047 240.538 302.757 240.389C302.625 240.325 302.488 240.274 302.329 240.205C300.68 240.539 298.975 240.635 297.288 240.799C297.104 240.945 296.94 241.106 296.753 241.221C296.56 241.34 296.437 241.016 296.22 241.039C296.146 241.051 296.07 241.045 295.997 241.062C295.685 241.124 295.315 241.279 295.052 241.134C294.7 240.95 294.345 240.995 294.011 241.216C293.886 241.296 293.779 241.411 293.661 241.507C293.471 241.402 293.28 241.294 293.073 241.179C291.901 241.226 290.712 241.228 289.524 241.255L285.512 241.325C284.174 241.354 282.838 241.214 281.501 241.165L276.15 240.872C275.927 240.843 275.707 240.8 275.482 240.788C275.35 240.788 274.889 240.595 274.773 240.556V240.554C274.675 240.488 274.601 240.536 274.509 240.456C274.308 240.28 274.144 240.267 273.905 240.403C273.639 240.548 273.38 240.661 273.065 240.608L271.958 240.462C271.888 240.454 271.812 240.427 271.755 240.384C271.636 240.294 271.542 240.148 271.411 240.101C271.189 240.021 271.03 240.275 270.829 240.287C270.308 240.32 269.792 240.223 269.279 240.15C269.133 240.132 269.022 240.031 268.907 239.929C268.672 239.72 268.659 239.716 268.37 239.888C268.061 240.072 267.808 239.995 267.572 239.771C267.464 239.675 267.35 239.576 267.218 239.459C265.558 239.154 263.874 238.846 262.202 238.537C261.982 238.629 261.78 238.74 261.565 238.799C261.348 238.861 261.319 238.518 261.102 238.481C261.026 238.471 260.954 238.448 260.88 238.444C260.561 238.421 260.162 238.469 259.947 238.258C259.657 237.987 259.301 237.934 258.918 238.055C258.776 238.1 258.642 238.18 258.502 238.241C258.347 238.089 258.19 237.938 258.025 237.755C256.882 237.472 255.724 237.187 254.566 236.9L250.659 235.931L248.705 235.449L246.779 234.857L241.646 233.263C241.433 233.195 241.223 233.113 241.003 233.062C240.872 233.037 240.458 232.763 240.353 232.705V232.703C240.269 232.623 240.187 232.654 240.113 232.56C239.95 232.353 239.791 232.31 239.525 232.398C239.232 232.492 238.95 232.554 238.65 232.445L237.603 232.047C237.537 232.022 237.47 231.979 237.423 231.922C237.327 231.805 237.267 231.641 237.15 231.563C236.951 231.434 236.742 231.645 236.544 231.61C236.03 231.52 235.551 231.305 235.068 231.114C234.93 231.061 234.843 230.936 234.752 230.809C234.566 230.549 234.556 230.543 234.239 230.643C233.901 230.752 233.67 230.618 233.488 230.342C233.404 230.219 233.308 230.108 233.201 229.967C231.614 229.381 230.006 228.787 228.406 228.196C228.175 228.237 227.957 228.301 227.737 228.313C227.513 228.325 227.551 227.979 227.347 227.895C227.277 227.87 227.21 227.829 227.14 227.809C226.834 227.717 226.438 227.676 226.269 227.42C226.04 227.088 225.703 226.957 225.308 226.992C225.162 227.004 225.017 227.054 224.87 227.084C224.747 226.898 224.626 226.713 224.493 226.51C223.409 226.043 222.309 225.572 221.212 225.1C219.982 224.563 218.737 224.049 217.513 223.495L213.888 221.72L209.054 219.349C208.854 219.249 208.659 219.134 208.45 219.05C208.325 219.003 207.957 218.671 207.861 218.595C207.793 218.501 207.705 218.521 207.646 218.415C207.517 218.186 207.366 218.118 207.089 218.165C206.782 218.216 206.501 218.222 206.228 218.054L205.251 217.503C205.189 217.468 205.128 217.415 205.091 217.353C205.013 217.224 204.978 217.052 204.872 216.958C204.694 216.802 204.456 216.978 204.265 216.915C203.769 216.751 203.326 216.468 202.875 216.206C202.747 216.136 202.679 215.999 202.606 215.86C202.461 215.575 202.452 215.567 202.123 215.62C201.772 215.679 201.563 215.511 201.423 215.212C201.359 215.079 201.28 214.954 201.194 214.8C199.706 213.986 198.199 213.161 196.7 212.341C196.462 212.357 196.232 212.398 196.009 212.386C195.781 212.376 195.864 212.042 195.669 211.939C195.601 211.906 195.539 211.861 195.471 211.832C195.181 211.697 194.794 211.603 194.661 211.326C194.479 210.965 194.163 210.787 193.768 210.769C193.622 210.761 193.469 210.79 193.321 210.8C193.225 210.597 193.13 210.396 193.025 210.175C192.014 209.564 190.991 208.943 189.967 208.323C187.677 206.909 185.338 205.563 183.081 204.096L178.596 201.11C178.408 200.983 178.231 200.844 178.034 200.733C177.917 200.671 177.593 200.29 177.507 200.204L177.509 200.202C177.451 200.1 177.363 200.108 177.318 199.997C177.217 199.751 177.076 199.663 176.798 199.675C176.492 199.683 176.206 199.665 175.948 199.474L175.02 198.841C174.961 198.802 174.907 198.745 174.875 198.681C174.81 198.546 174.793 198.374 174.695 198.271C174.535 198.103 174.283 198.248 174.097 198.173C173.479 197.476 172.86 196.777 172.234 196.069C171.312 195.188 170.389 194.307 169.492 193.45L166.969 191.405L166.653 191.149L166.573 191.087L166.534 191.056L166.492 191.027L166.325 190.912L165.655 190.453L164.314 189.533L163.643 189.074L162.942 188.664L161.538 187.846L160.835 187.438L160.747 187.387L160.656 187.342L160.473 187.252L160.11 187.07L158.652 186.351L157.923 185.994L157.501 185.818C156.417 184.984 150.825 184.248 149.747 183.408L153.358 182.584L153.499 182.563L153.665 182.524L153.831 182.471L153.997 182.409C154.104 182.36 154.216 182.309 154.329 182.259L154.427 182.202L154.518 182.141L154.686 182.008L154.811 181.916L154.937 181.832L155.065 181.756L155.194 181.686L155.324 181.625L155.455 181.57L155.588 181.521L155.721 181.482L155.856 181.449L155.991 181.422L156.128 181.402L156.265 181.39L156.402 181.384H156.541L156.68 181.392L156.819 181.406L156.905 181.416L156.991 181.418L157.075 181.416L157.16 181.41L157.328 181.387L157.495 181.348L157.661 181.297L157.828 181.238C157.936 181.191 158.05 181.144 158.164 181.095L158.214 181.07L158.259 181.041L158.347 180.979L158.433 180.913L158.523 180.851C158.779 180.697 159.037 180.54 159.381 180.33C160.273 180.057 161.173 179.779 162.081 179.5C162.535 179.359 162.991 179.219 163.448 179.078L164.134 178.865L164.478 178.758L164.65 178.701L164.818 178.639C166.619 177.965 168.439 177.284 170.259 176.604C172.077 175.922 173.899 175.241 175.702 174.565C176.604 174.231 177.502 173.895 178.393 173.565C178.838 173.399 179.284 173.235 179.725 173.071L179.891 173.01L179.974 172.979L180.057 172.942L180.387 172.799L181.045 172.516L181.047 172.512C181.173 172.512 181.221 172.432 181.35 172.45C181.632 172.487 181.799 172.407 181.956 172.157C182.131 171.88 182.322 171.657 182.64 171.503L183.743 170.948C183.813 170.913 183.897 170.889 183.975 170.889C184.137 170.891 184.309 170.953 184.459 170.91C184.711 170.836 184.709 170.543 184.879 170.394C185.32 170.021 185.834 169.755 186.334 169.47C186.474 169.388 186.639 169.39 186.809 169.39C187.15 169.378 187.164 169.369 187.293 169.033C187.428 168.674 187.689 168.547 188.047 168.537C188.208 168.529 188.369 168.506 188.563 168.486C189.1 168.078 189.631 167.652 190.156 167.215C190.469 167.434 190.512 167.445 191.121 167.442C191.177 167.575 191.247 167.7 191.294 167.835C191.37 168.077 191.542 168.185 191.773 168.21C191.921 168.22 192.075 168.204 192.23 168.2C192.312 168.401 192.394 168.602 192.496 168.854C196.414 171.516 200.162 173.975 204.151 176.559C204.277 176.643 204.31 176.723 204.345 176.879C204.407 177.106 204.507 177.217 204.781 177.205C205.374 177.18 205.746 177.498 205.918 178.068C205.936 178.115 206.014 178.185 206.051 178.179C206.447 178.115 206.775 178.255 207.094 178.466C207.655 178.827 208.217 179.183 208.792 179.528C209.064 179.688 209.215 179.924 209.309 180.216C209.377 180.437 209.573 180.575 209.812 180.558C210.112 180.533 210.395 180.531 210.663 180.708C211.284 181.104 211.909 181.503 212.501 181.882C212.607 182.134 212.698 182.341 212.796 182.546C212.853 182.585 212.913 182.626 212.974 182.669C213.101 182.745 213.238 182.814 213.357 182.899C213.673 183.137 214.035 183.174 214.425 183.092C214.524 183.289 214.622 183.485 214.736 183.711C216.31 184.633 217.89 185.613 219.522 186.512C219.935 186.742 219.935 186.752 220.589 186.682C220.657 186.809 220.741 186.926 220.802 187.055C220.904 187.287 221.088 187.377 221.32 187.379C221.471 187.371 221.623 187.342 221.777 187.322C221.881 187.513 221.984 187.705 222.113 187.945C226.277 190.259 230.408 192.125 234.814 194.015C236.375 194.619 237.998 195.245 239.621 195.874C241.268 196.442 242.953 196.921 244.555 197.405C244.696 197.555 244.811 197.641 244.918 197.745C244.973 197.798 245.009 197.878 245.07 197.909C245.271 198.014 245.472 198.091 245.705 197.946C246.08 197.712 246.415 197.745 246.697 198.102C246.742 198.164 246.789 198.233 246.85 198.272C247.048 198.389 247.249 198.463 247.478 198.325C247.839 198.095 248.173 198.095 248.476 198.454C248.626 198.634 248.802 198.763 249.042 198.808C249.65 198.878 250.261 198.949 250.849 199.015C251.007 198.933 251.144 198.861 251.281 198.79C251.65 198.602 252.014 198.671 252.361 198.841C252.56 198.937 252.727 199.111 252.924 199.261C257.319 199.542 261.782 199.154 266.036 197.966L268.181 197.23L269.119 196.921C269.167 196.868 269.208 196.814 269.25 196.761C269.246 196.831 269.243 196.892 269.239 196.966C269.658 197.878 270.246 198.706 270.765 199.579C271.322 200.429 271.79 201.339 272.421 202.143C272.727 202.559 272.723 202.571 273.376 202.819C273.392 202.973 273.427 203.124 273.435 203.274C273.441 203.544 273.583 203.719 273.804 203.831C273.95 203.897 274.105 203.94 274.259 203.995C274.284 204.227 274.31 204.46 274.341 204.751C277.599 208.821 281.255 212.179 285.456 215.233C285.591 215.329 285.626 215.413 285.665 215.577C285.733 215.813 285.843 215.936 286.136 215.946C286.767 215.964 287.161 216.315 287.363 216.921C287.383 216.972 287.467 217.05 287.506 217.048C287.917 217.015 288.283 217.152 288.639 217.372C289.263 217.747 289.891 218.116 290.53 218.474C290.833 218.642 291.013 218.886 291.141 219.189C291.236 219.416 291.453 219.566 291.709 219.539C292.031 219.494 292.336 219.473 292.648 219.631C293.372 219.985 294.099 220.34 294.789 220.678C294.946 220.922 295.078 221.127 295.212 221.334C295.277 221.371 295.348 221.41 295.42 221.451C295.565 221.525 295.721 221.584 295.867 221.65C296.254 221.845 296.649 221.834 297.047 221.697C297.195 221.881 297.34 222.062 297.51 222.273C298.448 222.617 299.374 223.031 300.348 223.318C301.323 223.601 302.303 223.884 303.282 224.17C303.778 224.313 303.78 224.332 304.435 224.115C304.547 224.217 304.672 224.306 304.776 224.412C304.958 224.605 305.18 224.641 305.422 224.576C305.578 224.527 305.725 224.455 305.879 224.392C306.049 224.548 306.221 224.703 306.436 224.898C311.542 225.9 316.518 226.193 321.696 225.695C322.602 225.67 323.515 225.539 324.436 225.4C325.36 225.271 326.291 225.142 327.223 225.013C329.067 224.661 330.895 224.212 332.641 223.777C332.848 223.814 333.002 223.839 333.155 223.867C333.233 223.883 333.307 223.931 333.382 223.928C333.624 223.912 333.851 223.873 333.989 223.625C334.215 223.227 334.542 223.08 334.991 223.238C335.065 223.267 335.143 223.302 335.221 223.302C335.466 223.298 335.692 223.257 335.829 223.017C336.045 222.63 336.355 222.455 336.822 222.603C337.054 222.677 337.286 222.701 337.529 222.607C338.126 222.345 338.722 222.086 339.3 221.834C339.404 221.68 339.494 221.547 339.585 221.414C339.832 221.059 340.205 220.926 340.611 220.894C340.841 220.871 341.083 220.935 341.34 220.962C342.428 220.534 343.424 219.925 344.455 219.386C345.471 218.822 346.517 218.308 347.508 217.7L350.228 215.929L349.185 217.109ZM365.442 176.472C365.291 176.724 365.118 176.949 365.133 177.271C365.145 177.933 365.19 178.597 365.133 179.259C365.119 179.407 365.17 179.536 365.275 179.659C365.422 179.843 365.426 180.007 365.247 180.208C364.911 180.583 364.872 181.015 365.143 181.421C365.376 181.769 365.131 181.939 364.944 182.144C365.094 182.38 365.341 182.617 365.013 182.884C364.89 182.986 364.824 183.111 364.81 183.259C364.767 183.7 364.745 184.142 364.681 184.579L364.444 185.884L363.866 189.155L363.718 189.971L363.499 190.773L363.06 192.373C363.021 192.514 362.926 192.637 362.787 192.709C362.539 192.836 362.547 193.012 362.657 193.23C362.73 193.373 362.743 193.515 362.702 193.662C362.478 194.439 362.31 195.238 362.008 195.994C361.946 196.172 361.709 196.293 361.582 196.406C361.496 196.484 361.524 196.566 361.426 196.636C361.209 196.788 361.157 196.941 361.233 197.204C361.313 197.493 361.362 197.772 361.237 198.063L360.837 199.094C360.812 199.158 360.769 199.225 360.714 199.27C360.599 199.36 360.437 199.413 360.36 199.528C360.233 199.719 360.438 199.94 360.402 200.139C360.333 200.662 360.028 201.094 359.809 201.559C359.745 201.688 359.611 201.764 359.477 201.842C359.201 202 359.193 202.01 359.266 202.33C359.344 202.672 359.189 202.889 358.899 203.041C358.77 203.109 358.651 203.193 358.503 203.283C358.134 204.029 357.794 204.799 357.398 205.539L356.099 207.703C356.109 207.937 356.142 208.164 356.124 208.383C356.104 208.608 355.774 208.514 355.665 208.701C355.63 208.767 355.582 208.826 355.554 208.892C355.464 209.087 355.388 209.324 355.268 209.497C355.19 209.429 355.107 209.374 355.017 209.36C354.626 209.214 353.744 209.899 353.636 210.198C353.585 210.343 353.448 210.38 353.402 210.532L353.108 210.977L352.723 211.274C352.515 211.29 352.36 211.319 352.207 211.313C351.821 211.297 351.673 211.54 351.577 211.86C351.511 212.085 351.416 212.282 351.21 212.436C350.597 212.926 349.925 213.327 349.281 213.758C349.112 213.762 348.954 213.766 348.8 213.77C348.312 213.774 347.917 214.018 347.738 214.499C347.638 214.761 347.482 214.835 347.24 214.798C347.077 214.775 346.932 214.79 346.801 214.874C345.78 215.597 344.653 216.13 343.566 216.739C343.43 216.809 343.349 216.94 343.294 217.094C343.265 217.166 343.226 217.235 343.179 217.299C342.941 217.635 342.611 217.828 342.204 217.811C341.899 217.799 341.612 217.756 341.319 217.928C340.698 218.252 340.043 218.5 339.405 218.789C339.259 218.85 339.163 218.959 339.094 219.113C338.987 219.336 338.836 219.422 338.568 219.361C338.068 219.246 337.645 219.425 337.387 219.869C337.166 220.25 336.899 220.115 336.623 220.051C336.467 220.297 336.346 220.606 335.941 220.422C335.787 220.354 335.637 220.346 335.486 220.395L332.828 221.268C331.732 221.684 330.576 221.873 329.448 222.168C328.312 222.434 327.186 222.754 326.025 222.879C325.873 222.9 325.714 222.863 325.584 222.766C325.354 222.594 325.188 222.672 325.026 222.862C324.922 222.987 324.789 223.057 324.63 223.081C323.784 223.188 322.942 223.376 322.088 223.427C321.891 223.443 321.675 223.277 321.511 223.206C321.4 223.159 321.332 223.22 321.223 223.157C320.985 223.022 320.816 223.038 320.595 223.214C320.349 223.405 320.101 223.564 319.767 223.569L318.602 223.628C318.529 223.632 318.447 223.618 318.381 223.587C318.245 223.517 318.128 223.399 317.985 223.362C317.746 223.303 317.618 223.571 317.41 223.6C316.876 223.68 316.329 223.631 315.788 223.606C315.636 223.6 315.509 223.51 315.378 223.418C315.11 223.232 315.099 223.229 314.817 223.426C314.516 223.637 314.242 223.584 313.977 223.383C313.856 223.293 313.727 223.221 313.58 223.119C312.71 223.021 311.833 222.922 310.954 222.824C310.077 222.719 309.19 222.658 308.329 222.451C308.104 222.537 307.897 222.644 307.676 222.699C307.45 222.756 307.416 222.41 307.191 222.367C307.115 222.357 307.039 222.33 306.962 222.324C306.632 222.295 306.216 222.332 305.993 222.117C305.695 221.838 305.328 221.777 304.927 221.89C304.781 221.919 304.64 221.988 304.495 222.035C304.343 221.861 304.188 221.689 304.02 221.502C302.85 221.148 301.647 220.844 300.473 220.445C299.176 219.937 297.863 219.463 296.573 218.931L292.803 217.109L290.393 215.695L289.188 214.986L288.043 214.183C287.853 214.048 287.671 213.9 287.47 213.779C287.348 213.711 287.018 213.312 286.933 213.22H286.932C286.875 213.118 286.786 213.12 286.741 213.007C286.643 212.755 286.501 212.661 286.213 212.659C285.894 212.655 285.596 212.622 285.355 212.389L284.464 211.635C284.407 211.588 284.357 211.524 284.328 211.453C284.272 211.308 284.268 211.133 284.181 211.017C284.03 210.824 283.755 210.947 283.572 210.843C283.1 210.57 282.693 210.206 282.295 209.839C282.188 209.73 282.152 209.575 282.115 209.417C282.041 209.095 282.033 209.083 281.699 209.042C281.34 208.999 281.174 208.774 281.111 208.44C281.08 208.292 281.034 208.147 280.989 207.971C279.685 206.791 278.556 205.416 277.386 204.09C277.152 204.018 276.917 203.971 276.704 203.875C276.483 203.781 276.683 203.494 276.546 203.311C276.497 203.25 276.459 203.18 276.405 203.125C276.182 202.881 275.85 202.635 275.829 202.32C275.79 201.908 275.559 201.617 275.19 201.435C275.053 201.367 274.897 201.331 274.752 201.277C274.738 201.052 274.724 200.826 274.709 200.582C273.971 199.605 273.389 198.506 272.715 197.467C271.934 196.309 271.387 195.02 270.731 193.787C270.048 192.566 269.598 191.242 269.057 189.957L268.534 188.662L268.12 187.33L267.3 184.66C267.224 184.439 267.207 184.203 267.14 183.978C267.097 183.847 267.126 183.326 267.126 183.201C267.126 182.951 267.155 183.103 267.284 182.869C266.876 182.476 266.875 182.473 267.08 181.939C266.967 181.834 266.852 181.734 266.743 181.621C266.579 181.439 266.546 181.236 266.634 180.986C266.685 180.851 266.735 180.715 266.785 180.576C266.669 180.469 266.542 180.371 266.446 180.246C266.294 180.057 266.27 179.838 266.387 179.605C266.453 179.474 266.502 179.334 266.561 179.199C266.456 179.084 266.332 178.984 266.26 178.849C266.076 178.505 265.998 178.134 266.171 177.751C266.239 177.612 266.307 177.476 266.395 177.298C266.356 176.956 266.313 176.575 266.269 176.196C266.251 176.044 266.237 175.887 266.202 175.737C266.177 175.592 266.108 175.458 265.985 175.352C265.842 175.229 265.813 175.114 265.887 174.975C266.164 174.455 266.172 174.455 266.153 174.121C266.13 173.82 266.194 173.504 266.048 173.221C265.976 173.084 265.86 172.973 265.784 172.838C265.759 172.793 265.786 172.707 265.815 172.649C265.872 172.518 265.941 172.395 266.008 172.268C265.916 172.141 265.824 172.016 265.72 171.872C265.824 171.69 265.931 171.503 266.057 171.28C266.118 170.173 266.18 169.038 266.241 167.911C266.618 166.753 266.909 165.614 267.17 164.432C267.271 163.985 267.288 163.981 267.007 163.401C267.105 163.299 267.189 163.186 267.29 163.092C267.478 162.928 267.503 162.731 267.43 162.518C267.374 162.381 267.298 162.254 267.224 162.12C267.366 161.964 267.507 161.808 267.685 161.613C267.878 160.282 267.997 158.963 268.051 157.642C268.109 157.443 268.169 157.244 268.228 157.044C268.4 157.965 268.645 158.872 268.96 159.755C269.038 159.968 269.103 160.186 269.198 160.395C269.251 160.519 269.309 161.007 269.344 161.124C269.338 161.238 269.42 161.284 269.4 161.399C269.354 161.653 269.432 161.809 269.682 161.957C269.948 162.127 270.208 162.283 270.349 162.57C270.523 162.902 270.7 163.234 270.897 163.554C270.934 163.613 270.961 163.687 270.964 163.757C270.967 163.902 270.911 164.06 270.959 164.193C271.043 164.418 271.348 164.392 271.488 164.541C271.851 164.928 272.153 165.353 272.451 165.783C272.539 165.9 272.539 166.056 272.555 166.207C272.582 166.518 272.59 166.535 272.923 166.613C273.277 166.695 273.408 166.92 273.434 167.254C273.448 167.404 273.478 167.553 273.512 167.723C274.656 168.994 275.901 170.143 277.187 171.241C277.422 171.264 277.653 171.261 277.866 171.307C278.083 171.352 277.946 171.668 278.12 171.801C278.18 171.844 278.231 171.901 278.294 171.938C278.558 172.108 278.926 172.241 279.028 172.518C279.167 172.885 279.465 173.088 279.852 173.137C279.995 173.155 280.146 173.137 280.291 173.139C280.371 173.34 280.451 173.543 280.537 173.762C281.49 174.422 282.484 175.039 283.486 175.641C285.749 176.981 288.103 178.149 290.506 179.176C292.11 179.864 293.735 180.492 295.379 181.059C295.584 181.131 295.785 181.215 295.998 181.272C296.123 181.299 296.519 181.577 296.623 181.639C296.702 181.723 296.783 181.69 296.853 181.785C297.009 181.998 297.167 182.035 297.425 181.943C297.709 181.845 297.98 181.779 298.271 181.884L299.304 182.21C299.37 182.228 299.437 182.265 299.486 182.315C299.586 182.42 299.653 182.579 299.773 182.643C299.975 182.752 300.166 182.526 300.361 182.541C300.867 182.576 301.342 182.756 301.83 182.883C301.967 182.916 302.062 183.029 302.162 183.143C302.367 183.377 302.38 183.385 302.676 183.245C302.99 183.097 303.225 183.2 303.432 183.452C303.527 183.561 303.631 183.663 303.752 183.786C305.358 184.143 306.994 184.466 308.627 184.745C308.84 184.647 309.033 184.53 309.239 184.462C309.449 184.396 309.486 184.737 309.697 184.767C309.77 184.775 309.842 184.796 309.913 184.798C310.223 184.81 310.605 184.749 310.823 184.954C311.117 185.212 311.469 185.241 311.83 185.099C311.965 185.046 312.088 184.956 312.217 184.888C312.379 185.031 312.541 185.177 312.718 185.333C313.852 185.479 315.008 185.581 316.16 185.687C318.756 185.91 321.365 185.996 323.971 185.988C325.707 185.978 327.447 185.924 329.18 185.793C329.398 185.781 329.616 185.783 329.832 185.752C329.959 185.734 330.434 185.83 330.552 185.842C330.657 185.887 330.719 185.824 330.823 185.883C331.049 186.01 331.21 185.99 331.411 185.807C331.635 185.608 331.858 185.442 332.167 185.428C332.528 185.408 332.886 185.346 333.245 185.311C333.313 185.303 333.39 185.311 333.454 185.338C333.588 185.399 333.712 185.518 333.849 185.531C334.078 185.554 334.165 185.271 334.351 185.211C334.831 185.055 335.335 185 335.835 184.936C335.976 184.915 336.108 184.981 336.247 185.047C336.528 185.184 336.543 185.186 336.76 184.943C336.989 184.677 337.245 184.673 337.536 184.816C337.667 184.878 337.804 184.925 337.964 184.992C339.589 184.691 341.22 184.289 342.831 183.859C342.985 183.689 343.112 183.492 343.27 183.345C343.431 183.193 343.612 183.488 343.817 183.421C343.886 183.396 343.962 183.386 344.026 183.357C344.314 183.234 344.635 183.017 344.922 183.101C345.301 183.201 345.636 183.074 345.9 182.785C345.998 182.68 346.07 182.545 346.156 182.426C346.367 182.485 346.58 182.541 346.809 182.604C347.894 182.204 348.986 181.774 350.06 181.295C352.486 180.225 354.791 178.94 356.977 177.32C358.443 176.24 359.816 175.029 361.001 173.654C361.16 173.49 361.317 173.324 361.444 173.133C361.514 173.022 361.928 172.717 362.026 172.633H362.028C362.138 172.578 362.133 172.494 362.256 172.449C362.523 172.349 362.606 172.195 362.595 171.928C362.582 171.629 362.594 171.356 362.786 171.098C363.003 170.789 363.167 170.452 363.36 170.129C363.395 170.068 363.449 170.008 363.512 169.967C363.645 169.883 363.828 169.84 363.912 169.723C364.058 169.528 363.861 169.311 363.91 169.118C364.051 168.622 364.272 168.147 364.448 167.653C364.498 167.516 364.625 167.421 364.752 167.321C364.805 167.282 364.838 167.253 364.87 167.223L364.949 167.657L365.066 168.755C364.992 168.901 364.921 169.036 364.853 169.169C364.632 169.585 364.665 170.023 365.007 170.376C365.194 170.571 365.187 170.735 365.042 170.925C364.946 171.054 364.894 171.183 364.907 171.331L365.091 173.089C365.132 173.677 365.114 174.267 365.13 174.857C365.13 175.002 365.206 175.125 365.318 175.238C365.367 175.293 365.411 175.355 365.445 175.422C365.63 175.775 365.649 176.137 365.442 176.472Z",
                fill: "black"
            })
        })
    };
    return Icons[iconName];
};
/* harmony default export */ __webpack_exports__["default"] = (ModalIcons);


/***/ }),

/***/ 27764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ps": function() { return /* reexport */ BasicModalContent; },
  "kE": function() { return /* reexport */ GetInTouchModalTemplate; },
  "iq": function() { return /* reexport */ ModalMessageBody; },
  "e1": function() { return /* reexport */ ModalMessageBodyColumn_ModalMessageBodyColumn; }
});

// UNUSED EXPORTS: CloseButton, ModalIcons, ModalMessageBodyBlock, ModalMessageScrollCarousel, ModalMessageTwoColumnBody, Slide, TwoColumnModalContent

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var global_Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Modal/partials/CloseButton.module.scss
var CloseButton_module = __webpack_require__(30482);
var CloseButton_module_default = /*#__PURE__*/__webpack_require__.n(CloseButton_module);
;// CONCATENATED MODULE: ./components/global/Modal/partials/CloseButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var CloseButton_CloseButton = function(param) {
    var handleClose = param.handleClose, type = param.type;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,clsx_m/* default */.Z)((CloseButton_module_default()).CloseButton, (_obj = {}, _defineProperty(_obj, (CloseButton_module_default())["CloseButton--basic"], type === "basic"), _defineProperty(_obj, (CloseButton_module_default())["CloseButton--twoColumn"], type === "twoColumn"), _obj)),
        type: "button",
        onClick: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: (CloseButton_module_default()).CloseButton__buttonInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CloseButton_module_default()).CloseButton__closeIcon,
                    children: "\u274C"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    children: "Close"
                })
            ]
        })
    });
};
/* harmony default export */ var partials_CloseButton = ((/* unused pure expression or super */ null && (CloseButton_CloseButton)));

// EXTERNAL MODULE: ./components/global/Modal/partials/ModalContent.module.scss
var ModalContent_module = __webpack_require__(26862);
var ModalContent_module_default = /*#__PURE__*/__webpack_require__.n(ModalContent_module);
;// CONCATENATED MODULE: ./components/global/Modal/partials/BasicModalContent.tsx
function BasicModalContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var BasicModalContent = function(param) {
    var size = param.size, position = param.position, isError = param.isError, toastMessage = param.toastMessage, actions = param.actions, handleClose = param.handleClose, type = param.type, title = param.title, asModal = param.asModal;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((ModalContent_module_default()).ModalContent__inner, (ModalContent_module_default())["ModalContent__inner--basic"], (_obj = {}, BasicModalContent_defineProperty(_obj, (ModalContent_module_default())["ModalContent__inner--medium"], size === "medium"), BasicModalContent_defineProperty(_obj, (ModalContent_module_default())["ModalContent__inner--top"], position === "top"), _obj)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ModalContent_module_default()).ModalContent__header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((ModalContent_module_default()).ModalContent__message, (ModalContent_module_default())["ModalContent__message--basic"], BasicModalContent_defineProperty({}, (ModalContent_module_default())["ModalContent__message--medium"], size === "medium")),
                    children: [
                        isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                            iconName: "close-circle",
                            color: "var(--error)"
                        }),
                        toastMessage,
                        actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((ModalContent_module_default()).ModalContent__actions, (ModalContent_module_default())["ModalContent__actions--basic"]),
                            children: actions
                        })
                    ]
                }),
                !isError && !asModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton_CloseButton, {
                    type: type,
                    handleClose: handleClose
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/global/Toast/index.tsx + 16 modules
var Toast = __webpack_require__(81530);
// EXTERNAL MODULE: ./components/global/Modal/partials/GetInTouchModalTemplate.module.scss
var GetInTouchModalTemplate_module = __webpack_require__(44401);
var GetInTouchModalTemplate_module_default = /*#__PURE__*/__webpack_require__.n(GetInTouchModalTemplate_module);
;// CONCATENATED MODULE: ./components/global/Modal/partials/GetInTouchModalTemplate.tsx




var GetInTouchModalTemplate = function(param) {
    var closeModal = param.closeModal, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* TwoColumnToastContent */.i6, {
        position: "center",
        handleClose: closeModal,
        title: "Your Licensing",
        image: "get-in-touch.svg",
        type: "twoColumn",
        toastMessage: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GetInTouchModalTemplate_module_default()).ModalTemplate__header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                        iconName: "globe",
                        color: "var(--header-icon-color)"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GetInTouchModalTemplate_module_default()).ModalTemplate__body,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageBodyBlock */.js, {
                        className: (GetInTouchModalTemplate_module_default()).ModalTemplate__bodyBlock,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Get in Touch!"
                        }),
                        children: children
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partials_GetInTouchModalTemplate = ((/* unused pure expression or super */ null && (GetInTouchModalTemplate)));

// EXTERNAL MODULE: ./components/global/Modal/partials/ModalIcons.tsx
var ModalIcons = __webpack_require__(62164);
;// CONCATENATED MODULE: ./components/global/Modal/partials/ModalMessageBody.tsx
function ModalMessageBody_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ModalMessageBody = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((ModalContent_module_default()).ModalContent__MessageBody, className, ModalMessageBody_defineProperty({}, (ModalContent_module_default())["ModalContent__MessageBody--borderBottom"], borderBottom)),
        children: children
    });
};
/* harmony default export */ var partials_ModalMessageBody = ((/* unused pure expression or super */ null && (ModalMessageBody)));

;// CONCATENATED MODULE: ./components/global/Modal/partials/ModalMessageBodyBlock.tsx
function ModalMessageBodyBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ModalMessageBodyBlock = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom, title = param.title;
    return /*#__PURE__*/ _jsxs("article", {
        className: clsx(styles.MessageBodyBlok, className, ModalMessageBodyBlock_defineProperty({}, styles["Toast__MessageBody--borderBottom"], borderBottom)),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.MessageBodyBlok__Title,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.MessageBodyBlok__Body,
                children: children
            })
        ]
    });
};
/* harmony default export */ var partials_ModalMessageBodyBlock = ((/* unused pure expression or super */ null && (ModalMessageBodyBlock)));

;// CONCATENATED MODULE: ./components/global/Modal/partials/ModalMessageBodyColumn.tsx
function ModalMessageBodyColumn_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ModalMessageBodyColumn_ModalMessageBodyColumn = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom, withScroll = param.withScroll;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((ModalContent_module_default()).ModalContent__MessageBodyColumn, className, (_obj = {}, ModalMessageBodyColumn_defineProperty(_obj, (ModalContent_module_default())["ModalContent__MessageBody--borderBottom"], borderBottom), ModalMessageBodyColumn_defineProperty(_obj, (ModalContent_module_default())["ModalContent__MessageBodyColumn--withScroll"], withScroll), ModalMessageBodyColumn_defineProperty(_obj, "with-scrollbar", withScroll), _obj)),
        children: children
    });
};
/* harmony default export */ var partials_ModalMessageBodyColumn = ((/* unused pure expression or super */ null && (ModalMessageBodyColumn_ModalMessageBodyColumn)));

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/cms/Video/index.tsx + 3 modules
var cms_Video = __webpack_require__(80378);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 4 modules
var hooks = __webpack_require__(61499);
;// CONCATENATED MODULE: ./components/global/Modal/partials/ModalMessageScrollCarousel.tsx
function ModalMessageScrollCarousel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var ModalMessageScrollCarousel = function(param) {
    var slides = param.slides, className = param.className;
    var ref = useState(0), activeSlide = ref[0], setActiveSlide = ref[1];
    var _obj, _obj1;
    return /*#__PURE__*/ _jsxs(ModalMessageTwoColumnBody, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: clsx(styles.Toast__ScrollCarouselImageContainer, (_obj = {}, ModalMessageScrollCarousel_defineProperty(_obj, styles["Toast__ScrollCarouselImageContainer--image"], slides[0].img), ModalMessageScrollCarousel_defineProperty(_obj, styles["Toast__ScrollCarouselImageContainer--video"], slides[0].video), _obj)),
                children: slides.map(function(e, i) {
                    if (e.img) {
                        return /*#__PURE__*/ _jsx("img", {
                            className: clsx(styles.Toast__ScrollCarouselImage, ModalMessageScrollCarousel_defineProperty({}, styles["Toast__ScrollCarouselImage--active"], i === activeSlide)),
                            loading: "lazy",
                            src: e.img,
                            alt: e.title,
                            width: 480,
                            height: 480
                        }, i);
                    }
                    if (e.video) {
                        return /*#__PURE__*/ _jsx("div", {
                            className: clsx(styles.Toast__ScrollCarouselVideo, ModalMessageScrollCarousel_defineProperty({}, styles["Toast__ScrollCarouselVideo--active"], i === activeSlide)),
                            children: /*#__PURE__*/ _jsx(Video, {
                                controls: false,
                                loop: true,
                                autoplay: i === activeSlide,
                                file: e.video
                            })
                        }, i);
                    }
                    if (e.card) {
                        return /*#__PURE__*/ _jsx("div", {
                            className: clsx(styles.Toast__ScrollCarouselCard, ModalMessageScrollCarousel_defineProperty({}, styles["Toast__ScrollCarouselImage--active"], i === activeSlide)),
                            children: e.card
                        }, i);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ModalMessageBodyColumn, {
                withScroll: true,
                className: clsx(styles.Toast__ScrollCarouselBody, (_obj1 = {}, ModalMessageScrollCarousel_defineProperty(_obj1, styles["Toast__ScrollCarouselBody--image"], slides[0].img), ModalMessageScrollCarousel_defineProperty(_obj1, styles["Toast__ScrollCarouselBody--video"], slides[0].video), _obj1)),
                children: slides.map(function(e, i) {
                    return /*#__PURE__*/ _jsx(Slide, {
                        refId: i,
                        title: e.title,
                        body: e.body,
                        setActiveSlide: setActiveSlide,
                        activeSlide: activeSlide,
                        isLastElement: slides.length === i + 1
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var partials_ModalMessageScrollCarousel = ((/* unused pure expression or super */ null && (ModalMessageScrollCarousel)));
var Slide = function(param) {
    var title = param.title, body = param.body, refId = param.refId, setActiveSlide = param.setActiveSlide, isLastElement = param.isLastElement;
    var ref = useRef();
    var isVisible = useIsVisible({
        ref: ref,
        options: {
            threshold: 0.5
        }
    });
    useEffect(function() {
        if (isVisible) {
            setActiveSlide(refId);
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: styles.Toast__ScrollCarouselSlideWrapper,
        children: /*#__PURE__*/ _jsx(ModalMessageBodyColumn, {
            title: title,
            borderBottom: !isLastElement,
            children: body
        })
    });
};

;// CONCATENATED MODULE: ./components/global/Modal/partials/ModalMessageTwoColumnBody.tsx


var ModalMessageTwoColumnBody_ModalMessageTwoColumnBody = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _jsx("div", {
        className: [
            styles.Toast__MessageTwoColumnBody,
            className
        ].join(" "),
        children: children
    });
};
/* harmony default export */ var partials_ModalMessageTwoColumnBody = ((/* unused pure expression or super */ null && (ModalMessageTwoColumnBody_ModalMessageTwoColumnBody)));

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dynamic.js
var next_dynamic = __webpack_require__(17953);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/image.js
var next_image = __webpack_require__(96434);
;// CONCATENATED MODULE: ./components/global/Modal/partials/TwoColumnModalContent.tsx
function TwoColumnModalContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var TwoColumnModalContent = function(param) {
    var size = param.size, position = param.position, icon = param.icon, image = param.image, isError = param.isError, toastMessage = param.toastMessage, actions = param.actions, handleClose = param.handleClose, type = param.type, autoHeight = param.autoHeight;
    var ToastIcons = dynamic(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62164));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(62164)
                ];
            }
        }
    });
    var _obj, _obj1;
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx(styles.ModalContent__inner, (_obj = {}, TwoColumnModalContent_defineProperty(_obj, styles["ModalContent__inner--medium"], size === "medium"), TwoColumnModalContent_defineProperty(_obj, styles["ModalContent__inner--top"], position === "top"), TwoColumnModalContent_defineProperty(_obj, styles["ModalContent__inner--twoColumn"], type === "twoColumn"), TwoColumnModalContent_defineProperty(_obj, styles["ModalContent__inner--autoHeight"], autoHeight), _obj)),
        children: [
            icon ? /*#__PURE__*/ _jsx("div", {
                className: styles.ModalContent__Icon,
                children: /*#__PURE__*/ _jsx(ToastIcons, {
                    iconName: icon
                })
            }) : null,
            image ? /*#__PURE__*/ _jsx("div", {
                className: clsx(styles.ModalContent__Icon, TwoColumnModalContent_defineProperty({}, styles["ModalContent__Icon--twoColumn"], type === "twoColumn")),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: "/img/".concat(image),
                    alt: "",
                    width: "537",
                    height: "399",
                    loading: "eager",
                    priority: true
                })
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: clsx(styles.Toast__message, (_obj1 = {}, TwoColumnModalContent_defineProperty(_obj1, styles["Toast__message--medium"], size === "medium"), TwoColumnModalContent_defineProperty(_obj1, styles["Toast__message--twoColumn"], type === "twoColumn"), _obj1)),
                children: [
                    isError && /*#__PURE__*/ _jsx(Icon, {
                        iconName: "close-circle",
                        color: "var(--error)"
                    }),
                    toastMessage,
                    actions && /*#__PURE__*/ _jsx("div", {
                        className: clsx(styles.Toast__actions, styles["Toast__actions--twoColumn"]),
                        children: actions
                    })
                ]
            }),
            !isError && /*#__PURE__*/ _jsx(CloseButton, {
                handleClose: handleClose,
                type: "twoColumn"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/global/Modal/partials/index.ts












/***/ }),

/***/ 1776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12902);
/* harmony import */ var _translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33525);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80772);
/* harmony import */ var _Pagination_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18672);
/* harmony import */ var _Pagination_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Pagination_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Pagination = function(param) {
    var pageInfo = param.pageInfo, onLoadMore = param.onLoadMore, loadOnScroll = param.loadOnScroll;
    var t = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var paginationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(node) {
        if (node) {
            var observerOptions = {
                root: null,
                rootMargin: "20px",
                threshold: 1
            };
            var handleIntersection = function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        onLoadMore(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor);
                        observer.unobserve(entry.target);
                    }
                });
            };
            var paginationObserver = new IntersectionObserver(handleIntersection, observerOptions);
            paginationObserver.observe(node);
        }
    }, [
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor,
        onLoadMore
    ]);
    if (!pageInfo || !(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    var _hasNextPage = pageInfo.hasNextPage, hasNextPage = _hasNextPage === void 0 ? false : _hasNextPage;
    if (!hasNextPage) {
        return null;
    }
    return loadOnScroll ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: paginationRef
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: (_Pagination_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Pagination),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            type: "button",
            callBack: function() {
                onLoadMore(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor);
            },
            children: t.formatMessage(_translations__WEBPACK_IMPORTED_MODULE_2__/* .messages.loadMoreButton */ .s.loadMoreButton)
        })
    });
};


/***/ }),

/***/ 82184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24477);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var Panel = function(param) {
    var children = param.children, as = param.as, className = param.className;
    var Tag = as || "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().panel), _defineProperty({}, className, className)),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Panel);


/***/ }),

/***/ 74819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24477);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var PanelContent = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? "md" : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().panelContent), (_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant]),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PanelContent);


/***/ }),

/***/ 21252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24477);
/* harmony import */ var _Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var PanelHeader = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? "md" : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().panelHeader), (_Panel_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant]),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PanelHeader);


/***/ }),

/***/ 12490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Panel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82184);

/* harmony default export */ __webpack_exports__["Z"] = (_Panel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 84733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Radio_Radio; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/InputErrorMessage/index.tsx + 1 modules
var InputErrorMessage = __webpack_require__(5937);
// EXTERNAL MODULE: ./components/global/Radio/Radio.module.scss
var Radio_module = __webpack_require__(70971);
var Radio_module_default = /*#__PURE__*/__webpack_require__.n(Radio_module);
;// CONCATENATED MODULE: ./components/global/Radio/Radio.tsx




var Radio = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var name = param.name, value = param.value, id = param.id, label = param.label, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, isRequired = param.isRequired, isChecked = param.isChecked, isDisabled = param.isDisabled, error = param.error, subLabel = param.subLabel, isPanel = param.isPanel, tag = param.tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isPanel ? (Radio_module_default()).RadioPanel : (Radio_module_default()).Radio,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "".concat((Radio_module_default()).RadioInput, " visually-hidden"),
                type: "radio",
                name: name,
                id: id,
                value: value,
                onChange: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                required: isRequired,
                defaultChecked: isChecked,
                disabled: isDisabled,
                ref: ref,
                "data-cy": "radio-".concat(value)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Radio_module_default()).labelContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Radio_module_default()).mainLabel,
                                children: [
                                    label,
                                    " ",
                                    tag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Radio_module_default()).tag,
                                        children: tag
                                    })
                                ]
                            }),
                            subLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Radio_module_default()).subLabel,
                                children: subLabel
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputErrorMessage/* default */.Z, {
                error: error
            })
        ]
    });
});
Radio.displayName = "Radio";
/* harmony default export */ var Radio_Radio = (Radio);

;// CONCATENATED MODULE: ./components/global/Radio/index.tsx



/***/ }),

/***/ 72518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SelectField_SelectField; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/InputErrorMessage/index.tsx + 1 modules
var InputErrorMessage = __webpack_require__(5937);
// EXTERNAL MODULE: ./components/global/InputLabel/index.tsx + 1 modules
var InputLabel = __webpack_require__(78080);
// EXTERNAL MODULE: ./components/global/SelectField/SelectField.module.scss
var SelectField_module = __webpack_require__(12456);
var SelectField_module_default = /*#__PURE__*/__webpack_require__.n(SelectField_module);
;// CONCATENATED MODULE: ./components/global/SelectField/SelectField.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var SelectField = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var name = param.name, label = param.label, placeholder = param.placeholder, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, hasLabel = param.hasLabel, isRequired = param.isRequired, isDisabled = param.isDisabled, hasBorder = param.hasBorder, options = param.options, defaultLabel = param.defaultLabel, defaultValue = param.defaultValue, error = param.error;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                name: name,
                label: label,
                isVisible: hasLabel,
                error: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                    className: (0,clsx_m/* default */.Z)((SelectField_module_default()).SelectField, (_obj = {}, _defineProperty(_obj, (SelectField_module_default()).SelectFieldError, error), _defineProperty(_obj, (SelectField_module_default()).SelectFieldBorder, hasBorder && !error), _defineProperty(_obj, (SelectField_module_default()).SelectFieldIsDisabled, isDisabled), _obj)),
                    id: name,
                    name: name,
                    placeholder: placeholder,
                    defaultValue: defaultValue || (defaultLabel ? "" : null),
                    onChange: onChange,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    required: isRequired,
                    disabled: isDisabled,
                    ref: ref,
                    "data-cy": name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            defaultLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                disabled: true,
                                value: "",
                                children: defaultLabel
                            }),
                            options.map(function(option, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: option.value,
                                    selected: option.selected,
                                    children: option.text
                                }, i);
                            })
                        ]
                    })
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputErrorMessage/* default */.Z, {
                error: error
            })
        ]
    });
});
SelectField.displayName = "SelectField";
/* harmony default export */ var SelectField_SelectField = (SelectField);

;// CONCATENATED MODULE: ./components/global/SelectField/index.tsx



/***/ }),

/***/ 19521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VJ": function() { return /* reexport */ HeaderRow; },
  "iA": function() { return /* reexport */ Table; },
  "SC": function() { return /* reexport */ TableRow; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Table/Table.module.scss
var Table_module = __webpack_require__(75959);
var Table_module_default = /*#__PURE__*/__webpack_require__.n(Table_module);
;// CONCATENATED MODULE: ./components/global/Table/Table.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Table = function(param) {
    var header = param.header, children = param.children, _layout = param.layout, layout = _layout === void 0 ? "fixed" : _layout, variant = param.variant, cssVars = param.cssVars;
    var _style = _objectSpread({
        tableLayout: layout
    }, cssVars);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        style: _style,
        className: (0,clsx_m/* default */.Z)((Table_module_default()).table, variant && (Table_module_default())[variant]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: children
            })
        ]
    });
};
var HeaderRow = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
        className: (Table_module_default()).header,
        children: react.Children.map(children, function(child, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                children: child
            }, i);
        })
    });
};
var TableRow = function(param) {
    var children = param.children, labelColumn = param.labelColumn, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
        className: (0,clsx_m/* default */.Z)((Table_module_default()).row, className),
        children: children && react.Children.map(children, function(child, i) {
            return labelColumn && i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                children: child
            }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: child
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/global/Table/index.tsx




/***/ }),

/***/ 32486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Tag; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/Tag/Tag.module.scss
var Tag_module = __webpack_require__(88615);
var Tag_module_default = /*#__PURE__*/__webpack_require__.n(Tag_module);
;// CONCATENATED MODULE: ./components/global/Tag/Tag.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var Tag = function(param) {
    var label = param.label, variant = param.variant, eventHandler = param.eventHandler, className = param.className;
    var _obj;
    return eventHandler ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: function() {
            eventHandler(label);
        },
        type: "button",
        className: (0,clsx_m/* default */.Z)((Tag_module_default()).tag, (Tag_module_default()).tagAsButton, (_obj = {}, _defineProperty(_obj, (Tag_module_default()).error, variant === "error"), _defineProperty(_obj, className, !!className), _obj)),
        children: label
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)((Tag_module_default()).tag, _defineProperty({}, (Tag_module_default()).error, variant === "error")),
        children: label
    });
};
/* harmony default export */ var Tag_Tag = (Tag);

;// CONCATENATED MODULE: ./components/global/Tag/index.tsx

/* harmony default export */ var global_Tag = (Tag_Tag);


/***/ }),

/***/ 81530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cp": function() { return /* reexport */ BasicToastContent; },
  "vu": function() { return /* reexport */ ExpiredToast; },
  "bF": function() { return /* reexport */ SuccessToast; },
  "FN": function() { return /* reexport */ Toast_Toast; },
  "ww": function() { return /* reexport */ ToastMessageBody_ToastMessageBody; },
  "js": function() { return /* reexport */ ToastMessageBodyBlock; },
  "Ap": function() { return /* reexport */ ToastMessageBodyColumn; },
  "V8": function() { return /* reexport */ ToastMessageScrollCarousel_ToastMessageScrollCarousel; },
  "Hx": function() { return /* reexport */ ToastMessageTwoColumnBody; },
  "i6": function() { return /* reexport */ TwoColumnToastContent; },
  "ZP": function() { return /* binding */ global_Toast; }
});

// UNUSED EXPORTS: BasicExample, CloseButton, DefaultToastContent, GetInTouchToast, Slide, ToastIcons, exampleData

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.15.1_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(75968);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var global_Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Toast/Toast.module.scss
var Toast_module = __webpack_require__(21577);
var Toast_module_default = /*#__PURE__*/__webpack_require__.n(Toast_module);
// EXTERNAL MODULE: ./components/global/Toast/partials/CloseButton.module.scss
var CloseButton_module = __webpack_require__(45417);
var CloseButton_module_default = /*#__PURE__*/__webpack_require__.n(CloseButton_module);
;// CONCATENATED MODULE: ./components/global/Toast/partials/CloseButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var CloseButton = function(param) {
    var handleClose = param.handleClose, type = param.type;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,clsx_m/* default */.Z)((CloseButton_module_default()).CloseButton, (_obj = {}, _defineProperty(_obj, (CloseButton_module_default())["CloseButton--basic"], type === "basic"), _defineProperty(_obj, (CloseButton_module_default())["CloseButton--twoColumn"], type === "twoColumn"), _obj)),
        type: "button",
        onClick: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: (CloseButton_module_default()).CloseButton__buttonInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CloseButton_module_default()).CloseButton__closeIcon,
                    children: "\u274C"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    children: "Close"
                })
            ]
        })
    });
};
/* harmony default export */ var partials_CloseButton = ((/* unused pure expression or super */ null && (CloseButton)));

;// CONCATENATED MODULE: ./components/global/Toast/partials/BasicToastContent.tsx
function BasicToastContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var BasicToastContent = function(param) {
    var size = param.size, position = param.position, isError = param.isError, toastMessage = param.toastMessage, actions = param.actions, handleClose = param.handleClose, type = param.type, title = param.title, asModal = param.asModal;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__inner, (Toast_module_default())["Toast__inner--basic"], (_obj = {}, BasicToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--medium"], size === "medium"), BasicToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--top"], position === "top"), _obj)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Toast_module_default()).Toast__header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__message, (Toast_module_default())["Toast__message--basic"], BasicToastContent_defineProperty({}, (Toast_module_default())["Toast__message--medium"], size === "medium")),
                    children: [
                        isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                            iconName: "close-circle",
                            color: "var(--error)"
                        }),
                        toastMessage,
                        actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__actions, (Toast_module_default())["Toast__actions--basic"]),
                            children: actions
                        })
                    ]
                }),
                !isError && !asModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    type: type,
                    handleClose: handleClose
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dynamic.js
var dynamic = __webpack_require__(17953);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/image.js
var next_image = __webpack_require__(96434);
;// CONCATENATED MODULE: ./components/global/Toast/partials/DefaultToastContent.tsx
function DefaultToastContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var DefaultToastContent = function(param) {
    var size = param.size, position = param.position, icon = param.icon, image = param.image, isError = param.isError, toastMessage = param.toastMessage, actions = param.actions, handleClose = param.handleClose, type = param.type;
    var ToastIcons = (0,dynamic["default"])(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27867));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(27867)
                ];
            }
        }
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__inner, (_obj = {}, DefaultToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--medium"], size === "medium"), DefaultToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--top"], position === "top"), _obj)),
        children: [
            icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Toast_module_default()).Toast__icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastIcons, {
                    iconName: icon
                })
            }) : null,
            image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Toast_module_default()).Toast__icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/img/".concat(image),
                    alt: "",
                    width: "337",
                    height: "299",
                    loading: "eager",
                    priority: true
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__message, DefaultToastContent_defineProperty({}, (Toast_module_default())["Toast__message--medium"], size === "medium")),
                children: [
                    isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                        iconName: "close-circle",
                        color: "var(--error)"
                    }),
                    toastMessage,
                    actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Toast_module_default()).Toast__actions,
                        children: actions
                    })
                ]
            }),
            !isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                type: type,
                handleClose: handleClose
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/global/Toast/partials/ToastIcons.tsx
var ToastIcons = __webpack_require__(27867);
;// CONCATENATED MODULE: ./components/global/Toast/partials/ToastMessageBody.tsx
function ToastMessageBody_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ToastMessageBody_ToastMessageBody = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom, withScroll = param.withScroll;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__MessageBody, className, (_obj = {}, ToastMessageBody_defineProperty(_obj, (Toast_module_default())["Toast__MessageBody--borderBottom"], borderBottom), ToastMessageBody_defineProperty(_obj, "with-scrollbar", withScroll), _obj)),
        children: children
    });
};
/* harmony default export */ var partials_ToastMessageBody = ((/* unused pure expression or super */ null && (ToastMessageBody_ToastMessageBody)));

;// CONCATENATED MODULE: ./components/global/Toast/partials/ToastMessageBodyBlock.tsx
function ToastMessageBodyBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ToastMessageBodyBlock = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__MessageBodyBlok, className, ToastMessageBodyBlock_defineProperty({}, (Toast_module_default())["Toast__MessageBody--borderBottom"], borderBottom)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Toast_module_default()).Toast__MessageBodyBlokTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Toast_module_default()).Toast__MessageBodyBlokBody,
                children: children
            })
        ]
    });
};
/* harmony default export */ var partials_ToastMessageBodyBlock = ((/* unused pure expression or super */ null && (ToastMessageBodyBlock)));

;// CONCATENATED MODULE: ./components/global/Toast/partials/ToastMessageBodyColumn.tsx
function ToastMessageBodyColumn_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ToastMessageBodyColumn = function(param) {
    var children = param.children, className = param.className, borderBottom = param.borderBottom, withScroll = param.withScroll;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__MessageBodyColumn, className, (_obj = {}, ToastMessageBodyColumn_defineProperty(_obj, (Toast_module_default())["Toast__MessageBody--borderBottom"], borderBottom), ToastMessageBodyColumn_defineProperty(_obj, (Toast_module_default())["Toast__MessageBodyColumn--withScroll"], withScroll), ToastMessageBodyColumn_defineProperty(_obj, "with-scrollbar", withScroll), _obj)),
        children: children
    });
};
/* harmony default export */ var partials_ToastMessageBodyColumn = ((/* unused pure expression or super */ null && (ToastMessageBodyColumn)));

// EXTERNAL MODULE: ./components/cms/Video/index.tsx + 3 modules
var Video = __webpack_require__(80378);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 4 modules
var hooks = __webpack_require__(61499);
;// CONCATENATED MODULE: ./components/global/Toast/partials/ToastMessageScrollCarousel.tsx
function ToastMessageScrollCarousel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var ToastMessageScrollCarousel_ToastMessageScrollCarousel = function(param) {
    var slides = param.slides, className = param.className;
    var ref = (0,react.useState)(0), activeSlide = ref[0], setActiveSlide = ref[1];
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastMessageTwoColumnBody, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__ScrollCarouselImageContainer, (_obj = {}, ToastMessageScrollCarousel_defineProperty(_obj, (Toast_module_default())["Toast__ScrollCarouselImageContainer--image"], slides[0].img), ToastMessageScrollCarousel_defineProperty(_obj, (Toast_module_default())["Toast__ScrollCarouselImageContainer--video"], slides[0].video), _obj)),
                children: slides.map(function(e, i) {
                    if (e.img) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__ScrollCarouselImage, ToastMessageScrollCarousel_defineProperty({}, (Toast_module_default())["Toast__ScrollCarouselImage--active"], i === activeSlide)),
                            loading: "lazy",
                            src: e.img,
                            alt: e.title,
                            width: 480,
                            height: 480
                        }, i);
                    }
                    if (e.video) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__ScrollCarouselVideo, ToastMessageScrollCarousel_defineProperty({}, (Toast_module_default())["Toast__ScrollCarouselVideo--active"], i === activeSlide)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, {
                                controls: false,
                                loop: true,
                                autoplay: i === activeSlide,
                                file: e.video
                            })
                        }, i);
                    }
                    if (e.card) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__ScrollCarouselCard, ToastMessageScrollCarousel_defineProperty({}, (Toast_module_default())["Toast__ScrollCarouselImage--active"], i === activeSlide)),
                            children: e.card
                        }, i);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastMessageBodyColumn, {
                withScroll: true,
                className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__ScrollCarouselBody, (_obj1 = {}, ToastMessageScrollCarousel_defineProperty(_obj1, (Toast_module_default())["Toast__ScrollCarouselBody--image"], slides[0].img), ToastMessageScrollCarousel_defineProperty(_obj1, (Toast_module_default())["Toast__ScrollCarouselBody--video"], slides[0].video), _obj1)),
                children: slides.map(function(e, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                        refId: i,
                        title: e.title,
                        body: e.body,
                        setActiveSlide: setActiveSlide,
                        activeSlide: activeSlide,
                        isLastElement: slides.length === i + 1
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var partials_ToastMessageScrollCarousel = ((/* unused pure expression or super */ null && (ToastMessageScrollCarousel_ToastMessageScrollCarousel)));
var Slide = function(param) {
    var title = param.title, body = param.body, refId = param.refId, setActiveSlide = param.setActiveSlide, isLastElement = param.isLastElement;
    var ref = (0,react.useRef)();
    var isVisible = (0,hooks/* useIsVisible */.Or)({
        ref: ref,
        options: {
            threshold: 0.5
        }
    });
    (0,react.useEffect)(function() {
        if (isVisible) {
            setActiveSlide(refId);
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (Toast_module_default()).Toast__ScrollCarouselSlideWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastMessageBodyBlock, {
            title: title,
            borderBottom: !isLastElement,
            children: body
        })
    });
};

;// CONCATENATED MODULE: ./components/global/Toast/partials/ToastMessageTwoColumnBody.tsx
function ToastMessageTwoColumnBody_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var ToastMessageTwoColumnBody = function(param) {
    var children = param.children, className = param.className, withScroll = param.withScroll;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__MessageTwoColumnBody, className, ToastMessageTwoColumnBody_defineProperty({}, "with-scrollbar", withScroll)),
        children: children
    });
};
/* harmony default export */ var partials_ToastMessageTwoColumnBody = ((/* unused pure expression or super */ null && (ToastMessageTwoColumnBody)));

;// CONCATENATED MODULE: ./components/global/Toast/partials/TwoColumnToastContent.tsx
function TwoColumnToastContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var TwoColumnToastContent = function(param) {
    var size = param.size, position = param.position, icon = param.icon, image = param.image, isError = param.isError, toastMessage = param.toastMessage, actions = param.actions, handleClose = param.handleClose, type = param.type, autoHeight = param.autoHeight;
    var ToastIcons = (0,dynamic["default"])(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27867));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(27867)
                ];
            }
        }
    });
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__inner, (_obj = {}, TwoColumnToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--medium"], size === "medium"), TwoColumnToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--top"], position === "top"), TwoColumnToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--twoColumn"], type === "twoColumn"), TwoColumnToastContent_defineProperty(_obj, (Toast_module_default())["Toast__inner--autoHeight"], autoHeight), _obj)),
        children: [
            icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Toast_module_default()).Toast__icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastIcons, {
                    iconName: icon
                })
            }) : null,
            image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__icon, TwoColumnToastContent_defineProperty({}, (Toast_module_default())["Toast__icon--twoColumn"], type === "twoColumn")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/img/".concat(image),
                    alt: "",
                    width: "537",
                    height: "399",
                    loading: "eager",
                    priority: true
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__message, (_obj1 = {}, TwoColumnToastContent_defineProperty(_obj1, (Toast_module_default())["Toast__message--medium"], size === "medium"), TwoColumnToastContent_defineProperty(_obj1, (Toast_module_default())["Toast__message--twoColumn"], type === "twoColumn"), _obj1)),
                children: [
                    isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                        iconName: "close-circle",
                        color: "var(--error)"
                    }),
                    toastMessage,
                    actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)((Toast_module_default()).Toast__actions, (Toast_module_default())["Toast__actions--twoColumn"]),
                        children: actions
                    })
                ]
            }),
            !isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                handleClose: handleClose,
                type: "twoColumn"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/global/Toast/partials/index.ts











;// CONCATENATED MODULE: ./components/global/Toast/Toast.tsx
function Toast_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







lib_default().setAppElement("#root");
var Toast_Toast = function(param1) {
    var _message = param1.message, message = _message === void 0 ? "" : _message, _autoClose = param1.autoClose, autoClose = _autoClose === void 0 ? false : _autoClose, _autoCloseTime = param1.autoCloseTime, autoCloseTime = _autoCloseTime === void 0 ? 5000 : _autoCloseTime, _className = param1.className, className = _className === void 0 ? "" : _className, onClose = param1.onClose, _isError = param1.isError, isError = _isError === void 0 ? false : _isError, actions = param1.actions, _position = param1.position, position = _position === void 0 ? "top" : _position, _size = param1.size, size = _size === void 0 ? "regular" : _size, _asModal = param1.asModal, asModal = _asModal === void 0 ? false : _asModal, image = param1.image, icon = param1.icon, _type = param1.type, type = _type === void 0 ? "default" : _type, title = param1.title, _autoHeight = param1.autoHeight, autoHeight = _autoHeight === void 0 ? false : _autoHeight;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(message), toastMessage = ref[0], setToastMessage = ref[1];
    var handleClose = (0,react.useCallback)(function() {
        setToastMessage("");
        if (onClose) onClose();
        document.body.classList.remove("ReactModal__Body--open");
    }, [
        onClose
    ]);
    (0,react.useEffect)(function() {
        var handleRouteChange = function(_url, param) {
            var shallow = param.shallow;
            if (shallow) return;
            handleClose();
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!autoClose || !toastMessage) return;
        var autoCloseInterval = setInterval(function() {
            // close state
            handleClose();
            if (onClose) onClose();
        }, autoCloseTime);
        return function() {
            return clearInterval(autoCloseInterval);
        };
    }, [
        autoClose,
        autoCloseTime,
        handleClose,
        onClose,
        toastMessage
    ]);
    var ToastContentComponents = {
        default: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultToastContent, {
            size: size,
            position: position,
            icon: icon,
            image: image,
            isError: isError,
            toastMessage: toastMessage,
            actions: actions,
            handleClose: handleClose
        }),
        basic: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicToastContent, {
            size: size,
            position: position,
            icon: icon,
            image: image,
            isError: isError,
            toastMessage: toastMessage,
            actions: actions,
            handleClose: handleClose,
            type: type,
            title: title
        }),
        twoColumn: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumnToastContent, {
            size: size,
            position: position,
            icon: icon,
            image: image,
            isError: isError,
            toastMessage: toastMessage,
            actions: actions,
            handleClose: handleClose,
            type: type,
            autoHeight: autoHeight
        })
    };
    var getToastContent = function() {
        return ToastContentComponents[type];
    };
    var ToastComponent = function() {
        var _obj, _obj1;
        return asModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            isOpen: true,
            className: [
                (Toast_module_default()).Toast,
                className
            ].join(" "),
            overlayClassName: (0,clsx_m/* default */.Z)((Toast_module_default()).ToastWrapper, (_obj = {}, Toast_defineProperty(_obj, (Toast_module_default()).ToastWrapperCenter, position === "center"), Toast_defineProperty(_obj, (Toast_module_default()).ToastWrapperMedium, size === "medium"), Toast_defineProperty(_obj, (Toast_module_default()).ToastWrapperOverlay, true), _obj)),
            children: getToastContent()
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((Toast_module_default()).ToastWrapper, (_obj1 = {}, Toast_defineProperty(_obj1, (Toast_module_default()).ToastWrapperCenter, position === "center"), Toast_defineProperty(_obj1, (Toast_module_default()).ToastWrapperMedium, size === "medium"), _obj1)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "alert",
                className: [
                    (Toast_module_default()).Toast,
                    className
                ].join(" "),
                children: getToastContent()
            })
        });
    };
    return toastMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastComponent, {}) : null;
};
/* harmony default export */ var global_Toast_Toast = (/*#__PURE__*/(0,react.memo)(Toast_Toast));

;// CONCATENATED MODULE: ./components/global/Toast/variants/BasicExample.tsx




var BasicExample = function(param) {
    var successToastAction = param.successToastAction;
    var router = useRouter();
    var submit = function() {
        successToastAction();
        document.body.classList.remove("ReactModal__Body--open");
    };
    return /*#__PURE__*/ _jsx(Toast, {
        title: "Your Session Expired",
        message: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ToastMessageBody, {
                    borderBottom: true,
                    children: /*#__PURE__*/ _jsx("p", {
                        children: "Need to share the cart with your collaborator, colleague or client to checkout and license? Please copy and paste the link below."
                    })
                }),
                /*#__PURE__*/ _jsx(ToastMessageScrollCarousel, {
                    slides: exampleData
                })
            ]
        }),
        //////////////////////////
        // Single Column Example
        //////////////////////////
        // message={
        //   <>
        //     <ToastMessageBody borderBottom>
        //       <p>
        //         Need to share the cart with your collaborator, colleague or client to checkout and
        //         license? Please copy and paste the link below.
        //       </p>
        //     </ToastMessageBody>
        //     <ToastMessageBodyColumn withScroll>
        //       {exampleData.map((e, i) => (
        //         <ToastMessageBodyBlock key={i} title={e.title}>
        //           {e.body}
        //         </ToastMessageBodyBlock>
        //       ))}
        //     </ToastMessageBodyColumn>
        //   </>
        // }
        //////////////////////////
        // Dual Scroll Column Example
        //////////////////////////
        // message={
        //   <>
        //     <ToastMessageBody borderBottom>
        //       <p>
        //         Need to share the cart with your collaborator, colleague or client to checkout and
        //         license? Please copy and paste the link below.
        //       </p>
        //     </ToastMessageBody>
        //     <ToastMessageTwoColumnBody>
        //       <ToastMessageBodyColumn withScroll>
        //         {exampleData.map((e, i) => (
        //           <ToastMessageBodyBlock key={i} title={e.title}>
        //             {e.body}
        //           </ToastMessageBodyBlock>
        //         ))}
        //       </ToastMessageBodyColumn>
        //       <ToastMessageBodyColumn withScroll>
        //         {exampleData.map((e, i) => (
        //           <ToastMessageBodyBlock key={i} title={e.title}>
        //             {e.body}
        //           </ToastMessageBodyBlock>
        //         ))}
        //       </ToastMessageBodyColumn>
        //     </ToastMessageTwoColumnBody>
        //   </>
        // }
        //////////////////////////
        // Dual Column Example
        //////////////////////////
        // message={
        //   <>
        //     <ToastMessageBody borderBottom>
        //       <p>
        //         Need to share the cart with your collaborator, colleague or client to checkout and
        //         license? Please copy and paste the link below.
        //       </p>
        //     </ToastMessageBody>
        //     <ToastMessageTwoColumnBody>
        //       <div style={{ background: '#dcdcdc' }}>Col 1</div>
        //       <ToastMessageBodyColumn withScroll>
        //         {exampleData.map((e, i) => (
        //           <ToastMessageBodyBlock key={i} title={e.title}>
        //             {e.body}
        //           </ToastMessageBodyBlock>
        //         ))}
        //       </ToastMessageBodyColumn>
        //     </ToastMessageTwoColumnBody>
        //   </>
        // }
        // actions={
        //   <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
        //     <InputField onWhite label="shareUrl" type="text" name="shareUrl" value={'shareUrl'} />
        //     {true && (
        //       <Button
        //         className={styles.CodeBlock__button}
        //         type="button"
        //         variant="ghost"
        //         // callBack={}
        //       >
        //         
        //       </Button>
        //     )}
        //   </div>
        // }
        position: "center",
        onClose: submit,
        asModal: true,
        type: "basic"
    });
};
/* harmony default export */ var variants_BasicExample = ((/* unused pure expression or super */ null && (BasicExample)));
var exampleData = [
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "Professional"
        }),
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Professional (PRO) variants include the full CF-Standard character set, but may also contain support for Cyrillic and Greek scripts. Furthermore, extension stylistic sets and OpenType features will be included within PRO versions to give further flexibility and options for all type users. Every family has different stylistic sets and OpenType features within their Standard and Professional variants. Please check individual family pages to see the extent of features available."
        }),
        img: "/img/Image.jpg"
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "Standard \uF011"
        }),
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Standard (STD) variants contain the CF-Standard character map and no additional OpenType features. Most Standard variants will only contain basic ligatures. Please check individual family pages to see the extent of features available."
        }),
        img: "/img/Image.md.jpg"
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "Professional"
        }),
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Professional (PRO) variants include the full CF-Standard character set, but may also contain support for Cyrillic and Greek scripts. Furthermore, extension stylistic sets and OpenType features will be included within PRO versions to give further flexibility and options for all type users. Every family has different stylistic sets and OpenType features within their Standard and Professional variants. Please check individual family pages to see the extent of features available."
        }),
        img: "/img/Image.sm.jpg"
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "Standard \uF011"
        }),
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Standard (STD) variants contain the CF-Standard character map and no additional OpenType features. Most Standard variants will only contain basic ligatures. Please check individual family pages to see the extent of features available."
        }),
        img: "/img/Image.lg.jpg"
    }
];

// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Toast/variants/SuccessToast.module.scss
var SuccessToast_module = __webpack_require__(8278);
var SuccessToast_module_default = /*#__PURE__*/__webpack_require__.n(SuccessToast_module);
;// CONCATENATED MODULE: ./components/global/Toast/variants/ExpiredToast.tsx






var ExpiredToast = function(param) {
    var successToastAction = param.successToastAction;
    var router = (0,next_router.useRouter)();
    var submit = function() {
        successToastAction();
        document.body.classList.remove("ReactModal__Body--open");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast_Toast, {
        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SuccessToast_module_default()).SuccessToast__header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                        iconName: "info",
                        color: "var(--header-icon-color)"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SuccessToast_module_default()).SuccessToast__body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: [
                                (SuccessToast_module_default()).SuccessToast__title,
                                (SuccessToast_module_default()).desktop
                            ].join(" "),
                            children: "Your Session Expired"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: [
                                (SuccessToast_module_default()).SuccessToast__title,
                                (SuccessToast_module_default()).mobile
                            ].join(" "),
                            children: "Session Expired"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Unfortunately your session expired and you are required to re-login."
                        })
                    ]
                })
            ]
        }),
        actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    callBack: function() {
                        successToastAction();
                        router.push("/account/login");
                    },
                    title: "Log in",
                    size: "l",
                    children: "Log in"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    callBack: submit,
                    title: "Dismiss",
                    size: "l",
                    children: "Dismiss"
                })
            ]
        }),
        // size="medium"
        position: "center",
        onClose: submit,
        image: "expired-modal.svg",
        asModal: true,
        type: "twoColumn",
        className: (SuccessToast_module_default()).SuccessToast_ExpiredSessionImage
    });
};
/* harmony default export */ var variants_ExpiredToast = ((/* unused pure expression or super */ null && (ExpiredToast)));

;// CONCATENATED MODULE: ./components/global/Toast/variants/GetInTouchToast.tsx




var GetInTouchToast = function(param) {
    var successToastAction = param.successToastAction;
    debugger;
    return /*#__PURE__*/ _jsx(Toast, {
        message: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.SuccessToast__header,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        iconName: "globe",
                        color: "var(--header-icon-color)"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.SuccessToast__body,
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: styles.SuccessToast__title,
                            children: "Get in Touch!"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "Email",
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("a", {
                                    href: "mailto:abc@colophon-foundry.org",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "abc@colophon-foundry.org"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("br", {}),
                                "Address",
                                /*#__PURE__*/ _jsx("br", {}),
                                "141-143 Shoreditch High Street,",
                                /*#__PURE__*/ _jsx("br", {}),
                                "3rd Floor London,",
                                /*#__PURE__*/ _jsx("br", {}),
                                "England, E1 6JE"
                            ]
                        })
                    ]
                })
            ]
        }),
        position: "center",
        onClose: successToastAction,
        image: "get-in-touch.svg",
        asModal: true,
        type: "twoColumn"
    });
};
/* harmony default export */ var variants_GetInTouchToast = ((/* unused pure expression or super */ null && (GetInTouchToast)));

// EXTERNAL MODULE: ./components/providers/CheckoutProvider.tsx + 2 modules
var CheckoutProvider = __webpack_require__(34639);
// EXTERNAL MODULE: ./lib/datalayer/checkout.ts
var datalayer_checkout = __webpack_require__(74198);
;// CONCATENATED MODULE: ./components/global/Toast/variants/SuccessToast.tsx







var SuccessToast = function(param) {
    var successToastAction = param.successToastAction;
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast_Toast, {
        className: (SuccessToast_module_default()).SuccessToast__wrapper,
        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SuccessToast_module_default()).SuccessToast__header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Icon/* default */.Z, {
                        iconName: "cart",
                        color: "var(--header-icon-color)",
                        width: "30",
                        height: "30"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SuccessToast_module_default()).SuccessToast__body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (SuccessToast_module_default()).SuccessToast__title,
                            children: "Success!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "The items you selected have now been added to your cart. You aren\u2019t too far away from beginning to utilise the fonts! Please choose to continue shopping with us or checkout now."
                        })
                    ]
                })
            ]
        }),
        actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    // add 'view_cart' to the dataLayer
                    callBack: function() {
                        successToastAction(true);
                        datalayer_checkout/* default.viewCart */.Z.viewCart((checkout === null || checkout === void 0 ? void 0 : checkout.lines) || []);
                    },
                    title: "Checkout",
                    size: "l",
                    children: "Checkout"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    callBack: function() {
                        return successToastAction();
                    },
                    title: "Open Cart",
                    size: "l",
                    children: "Continue Shopping"
                })
            ]
        }),
        // size="medium"
        position: "center",
        onClose: successToastAction,
        image: "success.svg",
        asModal: true,
        type: "twoColumn",
        autoHeight: true
    });
};
/* harmony default export */ var variants_SuccessToast = ((/* unused pure expression or super */ null && (SuccessToast)));

;// CONCATENATED MODULE: ./components/global/Toast/variants/index.ts





;// CONCATENATED MODULE: ./components/global/Toast/index.tsx




/* harmony default export */ var global_Toast = (global_Toast_Toast);


/***/ }),

/***/ 27867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ToastIcons": function() { return /* binding */ ToastIcons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);

var ToastIcons = function(param) {
    var iconName = param.iconName;
    var Icons = {
        addToCart: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "368",
            height: "326",
            viewBox: "0 0 368 326",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M367.56 179.129C367.654 178.926 367.789 178.746 367.92 178.541L367.885 175.232C367.871 174.13 367.89 173.027 367.737 171.933L367.399 168.646C367.332 168.101 367.308 167.548 367.207 167.009L366.889 165.39L366.461 163.167L366.289 162.198C366.113 161.985 365.917 161.833 365.701 161.716C365.674 161.295 365.633 160.875 365.574 160.458C365.428 160.266 365.256 160.102 365.114 159.918C364.974 159.73 365.287 159.598 365.238 159.377C365.219 159.304 365.216 159.227 365.191 159.154C365.103 158.84 364.874 158.494 364.966 158.216C365.075 157.846 364.978 157.48 364.667 157.195C364.554 157.089 364.411 157.007 364.286 156.913C364.337 156.704 364.39 156.495 364.446 156.268C364.235 155.704 363.948 155.166 363.699 154.613C363.403 154.083 363.12 153.541 362.798 153.024C361.349 150.692 359.505 148.6 357.575 146.824C356.263 145.639 354.887 144.534 353.456 143.517C353.282 143.382 353.105 143.251 352.915 143.139C352.8 143.078 352.487 142.704 352.403 142.618L352.404 142.617C352.348 142.515 352.261 142.524 352.217 142.413C352.119 142.169 351.983 142.077 351.707 142.099C351.404 142.12 351.124 142.115 350.867 141.937L349.946 141.355C349.886 141.321 349.83 141.268 349.795 141.208C349.725 141.08 349.697 140.91 349.598 140.817C349.428 140.66 349.186 140.833 348.999 140.768C348.52 140.601 348.094 140.322 347.648 140.083C347.523 140.015 347.457 139.882 347.386 139.747C347.241 139.469 347.23 139.46 346.909 139.522C346.569 139.59 346.366 139.432 346.217 139.149C346.15 139.02 346.068 138.902 345.978 138.754C344.494 138.022 342.957 137.354 341.412 136.74C341.183 136.787 340.971 136.857 340.756 136.877C340.539 136.895 340.572 136.557 340.369 136.484C340.3 136.463 340.234 136.425 340.164 136.411C339.861 136.336 339.474 136.32 339.301 136.076C339.065 135.764 338.731 135.644 338.346 135.719C338.203 135.744 338.063 135.807 337.922 135.85C337.792 135.676 337.661 135.502 337.52 135.314C336.437 134.936 335.321 134.616 334.209 134.28C331.701 133.559 329.156 132.972 326.6 132.483C324.893 132.157 323.178 131.879 321.457 131.663C321.241 131.634 321.027 131.589 320.809 131.577C320.682 131.575 320.237 131.379 320.125 131.339C320.031 131.276 319.958 131.324 319.869 131.247C319.674 131.077 319.512 131.065 319.279 131.206C319.019 131.357 318.767 131.476 318.463 131.43C318.106 131.383 317.746 131.345 317.387 131.316C317.32 131.31 317.246 131.287 317.189 131.248C317.071 131.162 316.974 131.021 316.844 130.98C316.625 130.912 316.482 131.171 316.287 131.194C315.784 131.257 315.284 131.172 314.783 131.143C314.64 131.135 314.525 131.042 314.405 130.951C314.16 130.761 314.146 130.757 313.883 130.949C313.603 131.156 313.353 131.099 313.102 130.893C312.989 130.802 312.866 130.724 312.723 130.624C311.078 130.583 309.411 130.578 307.754 130.622C307.564 130.759 307.395 130.911 307.207 131.017C307.014 131.124 306.911 130.794 306.697 130.807C306.625 130.814 306.551 130.806 306.48 130.818C306.171 130.867 305.809 130.998 305.554 130.843C305.215 130.652 304.863 130.688 304.536 130.9C304.415 130.977 304.311 131.089 304.198 131.181C304.01 131.072 303.823 130.96 303.618 130.841C302.476 130.946 301.318 131.036 300.167 131.198C297.574 131.518 294.993 131.979 292.448 132.596C290.755 133.029 289.065 133.483 287.415 134.07C287.206 134.138 286.993 134.192 286.79 134.278C286.674 134.338 286.188 134.376 286.069 134.393V134.392C285.954 134.377 285.911 134.454 285.795 134.426C285.54 134.363 285.388 134.426 285.243 134.655C285.077 134.903 284.909 135.129 284.616 135.238L283.606 135.656C283.542 135.681 283.465 135.696 283.395 135.687C283.247 135.665 283.094 135.594 282.959 135.623C282.73 135.674 282.732 135.972 282.572 136.088C282.159 136.393 281.678 136.57 281.228 136.81C281.1 136.876 280.951 136.857 280.798 136.839C280.486 136.803 280.47 136.808 280.341 137.109C280.202 137.426 279.962 137.518 279.638 137.485C279.492 137.471 279.347 137.475 279.171 137.47C277.735 138.313 276.286 139.322 274.956 140.465C274.889 140.692 274.852 140.913 274.769 141.111C274.683 141.31 274.381 141.146 274.22 141.303C274.168 141.359 274.104 141.405 274.057 141.463C273.85 141.711 273.663 142.056 273.35 142.124C272.95 142.235 272.707 142.526 272.62 142.901C272.587 143.041 272.593 143.188 272.579 143.331C272.35 143.392 272.142 143.475 271.901 143.558C271.143 144.491 270.451 145.499 269.881 146.574C269.881 146.576 269.879 146.579 269.878 146.582C269.537 146.637 269.104 146.868 268.998 147.101C268.896 147.323 268.817 147.555 268.701 147.769C268.529 148.079 268.582 148.387 268.635 148.7C268.653 148.778 268.653 148.856 268.662 148.944C268.536 149.231 268.398 149.526 268.283 149.825C268.223 149.99 268.131 150.1 267.998 150.198C267.721 150.401 267.594 150.502 267.501 150.626C267.263 149.706 266.918 148.776 266.393 147.839L266.36 147.786C266.279 147.669 266.28 147.587 266.309 147.432C266.34 147.21 266.294 147.077 266.041 146.996C265.475 146.819 265.332 146.428 265.304 145.834C265.301 145.785 265.242 145.691 265.203 145.684C264.779 145.612 264.506 145.372 264.25 145.069C263.814 144.523 263.291 144.124 262.799 143.659C262.567 143.443 262.445 143.194 262.371 142.901C262.322 142.676 262.131 142.517 261.887 142.512C261.582 142.511 261.302 142.492 261.047 142.294C260.44 141.875 259.776 141.542 259.18 141.17C259.043 140.943 258.928 140.754 258.811 140.561C258.75 140.53 258.684 140.495 258.618 140.459C258.479 140.397 258.335 140.346 258.202 140.271C257.852 140.072 257.489 140.066 257.108 140.247C256.969 140.08 256.832 139.914 256.672 139.723C254.912 139.116 253.004 138.926 251.123 138.899C250.646 138.923 250.635 138.914 250.1 139.322C249.977 139.251 249.846 139.197 249.729 139.121C249.522 138.979 249.311 138.999 249.114 139.126C248.99 139.227 248.881 139.346 248.763 139.458C248.572 139.372 248.379 139.286 248.14 139.179C247.335 139.284 246.561 139.491 245.798 139.718C245.611 138.259 245.28 136.823 244.832 135.431C244.754 135.203 244.687 134.97 244.592 134.749C244.526 134.625 244.491 134.072 244.447 133.948C244.447 133.821 244.367 133.78 244.383 133.649C244.414 133.362 244.333 133.197 244.092 133.061C243.819 132.911 243.613 132.737 243.449 132.438L242.871 131.399C242.834 131.334 242.807 131.252 242.803 131.172C242.789 131.011 242.824 130.832 242.766 130.692C242.664 130.455 242.375 130.512 242.227 130.363C241.858 129.966 241.528 129.521 241.176 129.094C241.076 128.975 241.053 128.812 241.025 128.645C240.971 128.298 240.952 128.291 240.614 128.243C240.253 128.196 240.091 127.972 240.012 127.623C239.973 127.468 239.924 127.312 239.864 127.132C238.488 125.92 236.893 124.929 235.194 124.226C234.942 124.262 234.71 124.325 234.477 124.335C234.245 124.344 234.272 124 234.041 123.939C233.963 123.92 233.889 123.885 233.81 123.873C233.47 123.808 233.045 123.808 232.835 123.569C232.545 123.28 232.148 123.225 231.734 123.335C231.582 123.376 231.437 123.454 231.29 123.512C231.127 123.349 230.954 123.216 230.766 123.064C230.131 123.011 229.496 122.916 228.853 122.942C228.211 122.936 227.567 122.937 226.927 123.021C225.018 123.193 223.145 123.652 221.35 124.322C221.11 123.571 220.844 122.828 220.547 122.099C219.785 120.271 218.861 118.474 217.735 116.874C217.608 116.665 217.469 116.462 217.307 116.275C217.209 116.169 217 115.67 216.942 115.549V115.548C216.915 115.424 216.825 115.399 216.811 115.268C216.786 114.979 216.651 114.848 216.366 114.766C216.05 114.674 215.766 114.569 215.548 114.299C215.299 113.977 214.993 113.705 214.708 113.416C214.653 113.361 214.604 113.289 214.58 113.217C214.532 113.063 214.536 112.881 214.45 112.752C214.304 112.532 214.017 112.641 213.823 112.529C213.321 112.246 212.927 111.829 212.466 111.491C212.335 111.397 212.274 111.248 212.206 111.094C212.069 110.78 212.056 110.766 211.706 110.77C211.339 110.769 211.12 110.589 210.962 110.274C210.89 110.131 210.802 109.997 210.702 109.831C209.057 108.89 207.263 108.149 205.395 107.743C205.154 107.805 204.926 107.936 204.696 107.99C204.46 108.052 204.415 107.708 204.171 107.672C204.088 107.663 204.007 107.638 203.925 107.634C203.571 107.598 203.142 107.698 202.876 107.511C202.519 107.277 202.106 107.251 201.714 107.43C201.568 107.503 201.44 107.611 201.304 107.7C201.099 107.584 200.893 107.467 200.669 107.34C199.354 107.382 198.032 107.6 196.739 107.916C196.36 108.009 195.987 108.113 195.618 108.227C195.467 107.665 195.307 107.106 195.118 106.557C194.496 104.809 193.679 103.133 192.661 101.571C192.53 101.378 192.41 101.175 192.264 100.989C192.171 100.887 192.005 100.386 191.937 100.28V100.279C191.911 100.161 191.822 100.139 191.808 100.014C191.779 99.7406 191.662 99.6036 191.389 99.5266C191.089 99.4386 190.829 99.3306 190.607 99.0856L189.817 98.2346C189.769 98.1796 189.72 98.1126 189.697 98.0436C189.649 97.8976 189.652 97.7216 189.566 97.6006C189.42 97.3996 189.144 97.5146 188.967 97.4046C188.523 97.1066 188.096 96.7766 187.679 96.4346C187.56 96.3426 187.506 96.1926 187.447 96.0386C187.318 95.7396 187.302 95.7286 186.963 95.7536C186.602 95.7826 186.401 95.6016 186.263 95.2826C186.201 95.1366 186.117 95.0086 186.022 94.8536C184.472 93.9546 182.749 93.3296 180.995 92.9396C180.763 93.0186 180.552 93.1216 180.333 93.1716C180.11 93.2236 180.071 92.8966 179.841 92.8646C179.763 92.8576 179.686 92.8366 179.609 92.8366C179.271 92.8286 178.867 92.8876 178.622 92.6956C178.289 92.4666 177.898 92.4606 177.525 92.6336C177.386 92.6966 177.263 92.7956 177.133 92.8756C176.945 92.7466 176.754 92.6436 176.542 92.5146C175.922 92.5406 175.297 92.5556 174.677 92.6596C174.055 92.7296 173.435 92.8276 172.825 92.9816C170.054 93.5916 167.468 94.7586 165.151 96.2396C164.385 96.7496 163.631 97.2606 162.902 97.8306C162.188 98.4156 161.432 98.9916 160.807 99.6026C160.643 99.7506 160.467 99.8906 160.315 100.054C160.229 100.154 159.786 100.376 159.68 100.438C159.569 100.472 159.559 100.561 159.442 100.582C159.184 100.629 159.071 100.75 159.026 101.024C158.973 101.326 158.901 101.601 158.666 101.814L157.872 102.589C157.822 102.638 157.755 102.681 157.686 102.698C157.541 102.735 157.37 102.718 157.25 102.792C157.199 102.823 157.168 102.866 157.148 102.913C156.653 101.713 156.303 100.476 156.226 99.1586C156.224 98.7936 156.361 98.4846 156.607 98.1816C156.724 98.0386 156.767 97.8806 156.707 97.7306C158.113 96.7506 159.463 95.6956 160.713 94.6336C160.926 94.5956 161.069 94.5486 161.217 94.5076C161.291 94.4876 161.379 94.4996 161.442 94.4626C161.647 94.3436 161.827 94.2106 161.838 93.9286C161.858 93.4746 162.076 93.2006 162.541 93.1486C162.619 93.1406 162.704 93.1386 162.772 93.1046C162.986 92.9946 163.166 92.8596 163.177 92.5856C163.191 92.1466 163.381 91.8556 163.861 91.7826C164.099 91.7476 164.31 91.6636 164.486 91.4776C164.884 90.9826 165.285 90.4866 165.67 90.0066C165.69 89.8246 165.705 89.6666 165.721 89.5096C165.77 89.0866 166.032 88.8036 166.368 88.5916C166.559 88.4676 166.799 88.4146 167.036 88.3226C167.789 87.4606 168.342 86.4616 168.974 85.5196C169.574 84.5566 170.247 83.6346 170.783 82.6376L172.349 79.6286L173.128 78.1246L173.774 76.5636L174.668 74.4246L175.068 73.4986C175.052 73.3316 175.021 73.1786 174.978 73.0316C174.957 72.9276 174.935 72.8226 174.915 72.7196C175.093 72.5996 175.271 72.4796 175.465 72.3486C175.688 71.7876 175.832 71.1966 176.018 70.6186C176.153 70.0266 176.306 69.4346 176.412 68.8346C176.895 66.1336 176.925 63.3436 176.68 60.7326C176.497 58.9736 176.214 57.2326 175.831 55.5186C175.792 55.3016 175.749 55.0866 175.681 54.8756C175.636 54.7526 175.656 54.2666 175.652 54.1456C175.679 54.0336 175.609 53.9816 175.651 53.8696C175.741 53.6226 175.703 53.4626 175.482 53.2956C175.244 53.1076 175.039 52.9166 174.966 52.6126L174.671 51.5636C174.65 51.4986 174.643 51.4206 174.657 51.3526C174.69 51.2096 174.784 51.0666 174.772 50.9296C174.75 50.6996 174.455 50.6646 174.359 50.4926C174.114 50.0476 173.985 49.5546 173.815 49.0806C173.766 48.9456 173.805 48.8026 173.844 48.6546C173.922 48.3516 173.92 48.3376 173.639 48.1706C173.341 47.9926 173.295 47.7386 173.375 47.4286C173.41 47.2876 173.43 47.1456 173.461 46.9756C172.847 45.4386 172.152 43.9136 171.414 42.4246C171.213 42.3066 171.008 42.2156 170.836 42.0866C170.662 41.9536 170.914 41.7256 170.811 41.5356C170.774 41.4736 170.75 41.4026 170.707 41.3446C170.532 41.0866 170.255 40.8156 170.289 40.5186C170.323 40.1276 170.155 39.8156 169.818 39.6136C169.695 39.5366 169.549 39.4896 169.417 39.4266C169.436 39.2106 169.455 38.9936 169.477 38.7596C168.924 37.7526 168.309 36.7686 167.708 35.7766C166.326 33.5616 164.828 31.4226 163.256 29.3486C162.205 27.9636 161.117 26.6106 159.983 25.2976C159.842 25.1316 159.713 24.9556 159.559 24.7996C159.465 24.7116 159.266 24.2706 159.209 24.1646H159.21C159.182 24.0556 159.096 24.0416 159.081 23.9246C159.05 23.6686 158.937 23.5516 158.67 23.5006C158.376 23.4386 158.109 23.3596 157.914 23.1196C157.68 22.8466 157.437 22.5776 157.191 22.3146C157.144 22.2656 157.105 22.1996 157.088 22.1306C157.058 21.9876 157.08 21.8186 157.011 21.7006C156.894 21.5036 156.614 21.6006 156.454 21.4876C156.038 21.1986 155.724 20.7996 155.37 20.4426C155.27 20.3426 155.245 20.1966 155.218 20.0466C155.163 19.7406 155.156 19.7296 154.831 19.6956C154.483 19.6626 154.337 19.4536 154.288 19.1316C154.265 18.9876 154.226 18.8486 154.186 18.6796C152.991 17.5476 151.754 16.4286 150.494 15.3526C150.262 15.3276 150.034 15.3276 149.823 15.2796C149.609 15.2306 149.753 14.9176 149.585 14.7836C149.526 14.7396 149.478 14.6836 149.417 14.6456C149.155 14.4756 148.799 14.3316 148.713 14.0456C148.589 13.6766 148.304 13.4676 147.919 13.4066C147.776 13.3836 147.624 13.3956 147.479 13.3886C147.414 13.1816 147.347 12.9736 147.277 12.7476C146.357 12.0616 145.435 11.3526 144.472 10.7026C142.33 9.20657 140.103 7.82157 137.799 6.57857C136.251 5.76657 134.693 4.97456 133.071 4.30656C132.872 4.21656 132.676 4.11556 132.467 4.04256C132.342 4.00856 131.955 3.71156 131.856 3.64556V3.64456C131.78 3.55856 131.697 3.58556 131.629 3.48656C131.483 3.26956 131.327 3.21557 131.065 3.28857C130.777 3.36157 130.501 3.41757 130.21 3.30357L129.181 2.93756C129.117 2.91556 129.049 2.87456 129.002 2.81956C128.907 2.70456 128.841 2.54957 128.722 2.48057C128.519 2.36657 128.32 2.58757 128.122 2.56757C127.612 2.51857 127.136 2.32957 126.642 2.20457C126.503 2.16957 126.406 2.05457 126.304 1.93957C126.095 1.70357 126.081 1.69656 125.783 1.83356C125.468 1.97756 125.227 1.88456 125.009 1.64356C124.909 1.53656 124.8 1.44156 124.672 1.32056C123.042 0.986564 121.289 0.765563 119.534 0.726562C119.333 0.848563 119.159 0.989566 118.964 1.08057C118.768 1.17157 118.652 0.847567 118.427 0.856567C118.352 0.862567 118.274 0.853562 118.2 0.866562C117.879 0.911562 117.511 1.04257 117.231 0.884567C116.858 0.698567 116.485 0.753564 116.169 0.974564C116.05 1.05556 115.956 1.16956 115.851 1.26556C115.641 1.15856 115.431 1.07957 115.197 0.980568C114.008 1.16657 112.82 1.45257 111.677 1.87057C110.96 2.13357 110.257 2.43757 109.577 2.78857C109.304 2.60057 108.88 2.47356 108.645 2.55756C108.408 2.64156 108.18 2.75056 107.94 2.81956C107.583 2.91356 107.405 3.16757 107.258 3.45357C107.223 3.52557 107.174 3.58756 107.126 3.65956C106.855 3.80356 106.57 3.94256 106.299 4.10056C106.154 4.19056 106.016 4.21557 105.854 4.20757C105.221 4.18257 105.197 4.16956 104.752 4.47756C104.293 4.78256 104.291 4.78356 104.008 5.32556C103.983 5.38056 103.918 5.43957 103.865 5.45457C103.076 5.59557 103.072 5.59556 102.786 5.78456C102.266 6.13456 101.795 6.53457 101.301 6.91357C98.1843 9.35357 95.3704 12.1126 92.8714 15.1186C91.5604 16.5736 90.4413 18.1756 89.2623 19.7296C88.6603 20.4976 88.1753 21.3466 87.6273 22.1526C87.1023 22.9736 86.5373 23.7706 86.0493 24.6126C85.4493 25.6766 84.8193 26.8006 84.2193 27.8656C84.1433 28.0016 84.0633 28.0426 83.9073 28.0946C83.6823 28.1796 83.5734 28.2916 83.6044 28.5686C83.6974 29.1766 83.4283 29.5956 82.8833 29.8496C82.8403 29.8726 82.7783 29.9626 82.7873 30.0006C82.9023 30.3996 82.7914 30.7466 82.6163 31.0986C82.3123 31.7146 82.0163 32.3316 81.7323 32.9596C81.5953 33.2536 81.3804 33.4446 81.1174 33.5946C80.9124 33.7026 80.8104 33.9276 80.8674 34.1676C80.9434 34.4686 80.9933 34.7556 80.8653 35.0606C80.5823 35.7636 80.2984 36.4696 80.0274 37.1406C79.8004 37.3006 79.6114 37.4346 79.4184 37.5716C79.3894 37.6346 79.3563 37.7036 79.3233 37.7736C79.2654 37.9146 79.2193 38.0646 79.1503 38.2016C78.9743 38.5686 79.0273 38.9456 79.1893 39.3176C79.0193 39.4636 78.8514 39.6066 78.6564 39.7736C78.3764 40.6696 78.0943 41.5766 77.8083 42.4866C77.7293 42.7476 77.6504 43.0096 77.5704 43.2716C77.3284 43.4626 77.1074 43.7406 77.0993 43.9466C77.0893 44.1836 77.1053 44.4226 77.0793 44.6576C77.0613 44.7936 77.0833 44.9126 77.1193 45.0266L77.0663 45.2546C76.9553 45.7276 76.9443 45.7316 77.1873 46.3546C77.0833 46.4586 76.9934 46.5756 76.8844 46.6706C76.6864 46.8366 76.6493 47.0456 76.7093 47.2746C76.7563 47.4206 76.8263 47.5586 76.8873 47.7046C76.7293 47.8626 76.5713 48.0206 76.3733 48.2176C76.0603 49.4026 75.9203 50.6036 75.7453 51.7886C75.5773 52.9746 75.4103 54.1516 75.2433 55.3306C75.1303 56.5136 75.0863 57.7046 75.0004 58.8986C74.9434 60.0946 74.8013 61.2926 74.8043 62.5146C74.8033 62.6696 74.7563 62.7426 74.6453 62.8596C74.4933 63.0366 74.4563 63.1856 74.6183 63.4196C74.9703 63.9206 74.9113 64.4156 74.5343 64.8856C74.5053 64.9266 74.4894 65.0336 74.5144 65.0636C74.7934 65.3686 74.8463 65.7286 74.8423 66.1216C74.8403 66.8076 74.8463 67.4906 74.8653 68.1786C74.8713 68.5026 74.7634 68.7686 74.5954 69.0196C74.4613 69.2066 74.4704 69.4526 74.6293 69.6436C74.8324 69.8776 75.0054 70.1136 75.0274 70.4426C75.0894 71.1966 75.1534 71.9546 75.2124 72.6726C75.0814 72.9146 74.9723 73.1176 74.8603 73.3246C74.8623 73.3946 74.8643 73.4706 74.8663 73.5476C74.8783 73.6986 74.9033 73.8526 74.9033 74.0056C74.8953 74.4136 75.0773 74.7326 75.3743 74.9966C75.2723 75.2016 75.1733 75.4056 75.0583 75.6426C75.3753 77.4876 75.7003 79.3706 76.0243 81.2516C76.1053 81.7296 76.0953 81.7356 76.5593 82.1996C76.5033 82.3396 76.4663 82.4826 76.4043 82.6156C76.2813 82.8526 76.3453 83.0536 76.5073 83.2326C76.6163 83.3436 76.7423 83.4386 76.8643 83.5446C76.7953 83.7496 76.7253 83.9566 76.6384 84.2156C77.2673 86.5696 77.7943 88.8866 78.5193 91.1406C79.2943 93.3746 80.0703 95.6126 80.8693 97.9146C80.9183 98.0606 80.8923 98.1476 80.8383 98.2966C80.7643 98.5166 80.7853 98.6676 81.0253 98.8206C81.5423 99.1496 81.6763 99.6286 81.5043 100.199C81.4923 100.248 81.5203 100.352 81.5543 100.37C81.9283 100.547 82.1153 100.859 82.2613 101.222C82.5203 101.854 82.7853 102.481 83.0673 103.106C83.2003 103.4 83.1923 103.686 83.1063 103.988C83.0383 104.214 83.1223 104.444 83.3293 104.569C83.5913 104.721 83.8253 104.883 83.9463 105.188C84.2063 105.899 84.5653 106.566 84.8813 107.21C84.8473 107.479 84.8193 107.703 84.7903 107.932C84.8173 107.996 84.8473 108.065 84.8783 108.135C84.9453 108.27 85.0264 108.403 85.0824 108.543C85.2263 108.921 85.5154 109.151 85.8934 109.295C85.8734 109.519 85.8543 109.739 85.8313 109.996C86.6903 111.647 87.5193 113.361 88.4423 115.017C88.6883 115.43 88.6823 115.44 89.2923 115.721C89.2883 115.866 89.3023 116.01 89.2903 116.153C89.2613 116.405 89.3783 116.579 89.5813 116.702C89.7163 116.775 89.8644 116.828 90.0094 116.893C90.0034 117.111 89.9964 117.331 89.9884 117.604C91.2574 119.669 92.4324 121.717 93.7504 123.672C95.1043 125.602 96.4564 127.53 97.8504 129.517H97.8493C97.9363 129.645 97.9384 129.733 97.9144 129.895C97.8904 130.131 97.9414 130.276 98.2034 130.37C98.7644 130.573 98.9943 131.016 98.9513 131.622C98.9493 131.673 98.9963 131.77 99.0333 131.78C99.4313 131.863 99.6993 132.11 99.9314 132.423C100.343 132.962 100.761 133.497 101.193 134.027C101.399 134.275 101.464 134.55 101.455 134.859C101.445 135.091 101.585 135.291 101.819 135.36C102.113 135.441 102.384 135.541 102.58 135.802C103.039 136.397 103.5 136.993 103.937 137.561C103.958 137.834 103.974 138.062 103.993 138.295C104.032 138.353 104.074 138.414 104.117 138.478C104.209 138.597 104.312 138.711 104.394 138.839C104.607 139.181 104.931 139.348 105.324 139.41C105.349 139.636 105.374 139.858 105.402 140.116C106.545 141.579 107.854 142.948 109.082 144.384C109.398 144.745 109.393 144.755 110.037 144.915C110.06 145.061 110.1 145.2 110.115 145.343C110.133 145.599 110.279 145.749 110.498 145.831C110.644 145.877 110.797 145.901 110.95 145.936C110.984 146.153 111.017 146.372 111.059 146.643C111.734 147.447 112.423 148.217 113.121 148.973C113.092 149.008 113.06 149.043 113.031 149.09C112.853 149.357 112.681 149.623 112.36 149.767L111.259 150.321C111.191 150.356 111.107 150.381 111.029 150.381C110.867 150.379 110.693 150.318 110.543 150.36C110.289 150.428 110.299 150.733 110.13 150.881C109.692 151.255 109.181 151.522 108.684 151.807C108.545 151.889 108.381 151.887 108.211 151.887C107.869 151.891 107.844 151.882 107.719 152.223C107.586 152.584 107.326 152.711 106.973 152.721C106.815 152.727 106.657 152.75 106.465 152.77L105.305 153.59L104.199 154.5L103.095 155.416L102.064 156.418C101.995 156.666 101.955 156.908 101.867 157.13C101.778 157.356 101.465 157.197 101.29 157.372C101.232 157.434 101.162 157.483 101.118 157.555C100.91 157.849 100.722 158.25 100.41 158.354C100.002 158.5 99.7424 158.821 99.6344 159.236C99.5934 159.39 99.5914 159.552 99.5694 159.709C99.3393 159.788 99.1323 159.892 98.8913 159.991C98.5063 160.533 98.1204 161.078 97.7334 161.624C97.3444 162.17 97.0493 162.78 96.7063 163.358C95.2343 166.004 94.1184 168.827 93.5264 171.794C93.2553 172.767 93.1873 173.78 93.0633 174.78C92.9013 175.78 92.9503 176.788 92.9383 177.792C92.9363 178.044 92.9183 178.296 92.9343 178.55C92.9363 178.696 92.8233 179.239 92.8253 179.374C92.7823 179.493 92.8463 179.565 92.7903 179.683C92.6673 179.939 92.6904 180.126 92.8804 180.361C93.0844 180.623 93.2553 180.879 93.2764 181.232C93.3093 181.644 93.3464 182.058 93.4024 182.466C93.4174 182.542 93.4173 182.63 93.3953 182.704C93.3473 182.854 93.2394 182.997 93.2384 183.151C93.2374 183.413 93.5303 183.503 93.6084 183.712C93.8134 184.251 93.8923 184.821 93.9943 185.386C94.0243 185.544 93.9683 185.698 93.9113 185.859C93.7903 186.187 93.8043 186.199 94.0773 186.427C94.3743 186.669 94.4083 186.956 94.3003 187.288C94.2533 187.438 94.2243 187.593 94.1774 187.776C94.4424 188.672 94.6734 189.588 94.9704 190.477L95.9133 193.123C96.1063 193.283 96.3093 193.416 96.4733 193.586C96.6403 193.76 96.3634 193.973 96.4494 194.199C96.4804 194.275 96.4973 194.357 96.5333 194.429C96.6873 194.743 96.9653 195.077 96.9123 195.396C96.8533 195.816 97.0163 196.177 97.3383 196.458C97.4553 196.562 97.6003 196.638 97.7303 196.729C97.6943 196.961 97.6573 197.196 97.6183 197.448C98.1023 198.639 98.6043 199.843 99.1673 201.01L101.004 204.985L102.957 208.891C103.806 210.639 104.725 212.346 105.632 214.059C105.744 214.276 105.843 214.497 105.972 214.705C106.05 214.824 106.172 215.346 106.21 215.473C106.215 215.598 106.3 215.639 106.29 215.766C106.269 216.047 106.358 216.204 106.614 216.34C106.896 216.494 107.147 216.662 107.296 216.975C107.47 217.338 107.669 217.69 107.86 218.043C107.896 218.109 107.922 218.191 107.922 218.268C107.923 218.426 107.863 218.596 107.908 218.741C107.982 218.983 108.285 218.973 108.422 219.145C108.774 219.584 109.017 220.096 109.278 220.592C109.353 220.731 109.343 220.891 109.334 221.055C109.314 221.389 109.319 221.405 109.636 221.553C109.975 221.711 110.072 221.981 110.041 222.326C110.029 222.482 110.033 222.64 110.029 222.826C110.91 224.433 111.828 226.045 112.75 227.64C112.969 227.761 113.191 227.857 113.383 227.994C113.578 228.135 113.34 228.389 113.461 228.594C113.505 228.662 113.535 228.739 113.584 228.803C113.785 229.084 114.094 229.381 114.084 229.703C114.08 230.127 114.285 230.459 114.637 230.693C114.766 230.781 114.918 230.836 115.058 230.91C115.051 231.142 115.043 231.379 115.036 231.633C115.666 232.742 116.315 233.856 116.972 234.967L121.38 242.471L124.353 247.453C124.476 247.662 124.585 247.879 124.724 248.08C124.814 248.203 124.937 248.676 124.978 248.795C124.984 248.91 125.069 248.943 125.06 249.061C125.04 249.321 125.128 249.456 125.39 249.577C125.593 249.673 125.784 249.78 125.937 249.946C125.994 250.001 126.046 250.075 126.091 250.157L126.666 251.143C126.702 251.205 126.727 251.28 126.725 251.346C126.718 251.485 126.646 251.623 126.685 251.75C126.758 251.961 127.035 252.018 127.14 252.197C127.328 252.687 127.328 253.232 127.341 253.761C127.343 253.911 127.259 254.054 127.174 254.199C127.001 254.494 126.997 254.504 127.209 254.74C127.43 254.996 127.382 255.275 127.185 255.562C127.107 255.689 127.027 255.824 126.931 255.98C126.908 257.615 126.824 259.533 126.728 261.339C126.845 261.558 126.98 261.757 127.065 261.976C127.152 262.201 126.814 262.283 126.804 262.519C126.803 262.599 126.786 262.681 126.792 262.759C126.809 263.103 126.901 263.519 126.716 263.78C126.478 264.13 126.466 264.518 126.63 264.905C126.691 265.05 126.786 265.18 126.862 265.317C126.725 265.506 126.589 265.698 126.44 265.905C126.348 267.171 126.255 268.452 126.163 269.733L125.444 278.385L124.918 284.153C124.894 284.393 124.855 284.633 124.847 284.876C124.849 285.021 124.661 285.524 124.624 285.647L124.626 285.649H124.624C124.614 285.682 124.606 285.708 124.599 285.729C124.592 285.75 124.584 285.766 124.579 285.778L124.569 285.794L124.561 285.806L124.551 285.814L124.539 285.82C124.525 285.828 124.508 285.836 124.48 285.851C124.466 285.859 124.452 285.871 124.433 285.884C124.415 285.902 124.395 285.921 124.37 285.945C124.403 286.013 124.432 286.074 124.457 286.127C124.48 286.182 124.501 286.229 124.519 286.272L124.54 286.333L124.554 286.388L124.56 286.439V286.49L124.552 286.539L124.536 286.588L124.513 286.641L124.482 286.698C124.457 286.735 124.429 286.778 124.396 286.829C124.362 286.876 124.322 286.931 124.278 286.993L124.39 287.212L124.498 287.435L124.53 287.523L124.549 287.611L124.554 287.654L124.556 287.699L124.555 287.742L124.55 287.785L124.543 287.828L124.532 287.871L124.502 287.959L124.46 288.047L124.404 288.135C124.315 288.262 124.223 288.393 124.132 288.526L124.251 288.745L124.307 288.854L124.353 288.969L124.38 289.061L124.398 289.151L124.404 289.241L124.4 289.329L124.394 289.374L124.384 289.417L124.37 289.46L124.354 289.503L124.334 289.546L124.311 289.587L124.286 289.628L124.256 289.669L124.122 289.862L123.995 290.059L124.114 290.28L124.168 290.391L124.19 290.448L124.207 290.509L124.239 290.663L124.26 290.817L124.267 290.971L124.265 291.047L124.259 291.121L124.248 291.197L124.234 291.271L124.214 291.345L124.191 291.417L124.162 291.489L124.129 291.561L124.088 291.631L124.043 291.701C123.945 291.836 123.848 291.969 123.721 292.14C123.681 292.517 123.635 292.937 123.59 293.355L123.565 293.609L123.555 293.738L123.551 293.865L123.553 293.926L123.559 293.987L123.571 294.046L123.589 294.105L123.611 294.162L123.637 294.219L123.669 294.272L123.705 294.325L123.746 294.384L123.777 294.441L123.798 294.494L123.804 294.521L123.808 294.546L123.81 294.573L123.808 294.598L123.804 294.623L123.798 294.648L123.778 294.699L123.749 294.752C123.663 294.881 123.598 294.979 123.546 295.057C123.523 295.096 123.501 295.131 123.482 295.162C123.466 295.195 123.451 295.224 123.437 295.25L123.408 295.332L123.388 295.418C123.384 295.447 123.38 295.48 123.374 295.516C123.372 295.553 123.368 295.594 123.364 295.639L123.337 295.889L123.306 296.139L123.296 296.264L123.297 296.389L123.302 296.451L123.31 296.512L123.324 296.574L123.341 296.636L123.362 296.695L123.386 296.752L123.442 296.861L123.498 296.97L123.547 297.085L123.55 297.095L123.551 297.105V297.128L123.547 297.153L123.539 297.18L123.516 297.237L123.49 297.286L123.37 297.483L123.243 297.676C123.317 297.826 123.389 297.973 123.472 298.139C123.341 298.328 123.207 298.524 123.05 298.75C122.904 300.15 122.755 301.586 122.607 303.006C122.619 303.053 122.63 303.096 122.64 303.137L122.657 303.198L122.678 303.255L122.889 303.698L122.741 303.934L122.696 304.016L122.671 304.057L122.642 304.092L122.601 304.143L122.564 304.192L122.533 304.245L122.507 304.298L122.485 304.353L122.467 304.412L122.455 304.474L122.447 304.538C122.396 304.942 122.334 305.444 122.279 305.88C122.267 305.989 122.257 306.095 122.246 306.194C122.239 306.294 122.232 306.385 122.226 306.467C122.225 306.51 122.224 306.549 122.222 306.584C122.224 306.621 122.224 306.654 122.224 306.686C122.228 306.715 122.23 306.745 122.232 306.768L122.239 306.801L122.248 306.83L122.254 306.844L122.264 306.858L122.278 306.87L122.296 306.882L122.339 306.907L122.394 306.928L122.425 306.94L122.443 306.944L122.463 306.946L122.548 306.956C122.608 306.962 122.672 306.966 122.738 306.972C122.874 306.976 123.021 306.98 123.164 306.984C123.307 306.982 123.445 306.982 123.562 306.982L123.626 306.978L123.688 306.97L123.748 306.954L123.805 306.934L123.86 306.911L123.915 306.88L123.966 306.845L124.017 306.806L124.093 306.751L124.13 306.728L124.169 306.71L124.206 306.694L124.243 306.682L124.282 306.676L124.32 306.672H124.359L124.399 306.674L124.438 306.682L124.48 306.694L124.522 306.71L124.565 306.73C124.592 306.748 124.623 306.763 124.655 306.783L124.727 306.828L124.801 306.867L124.875 306.9L124.951 306.927L125.026 306.95L125.103 306.968L125.179 306.982L125.257 306.992L125.361 306.996L125.463 306.992L125.567 306.98L125.669 306.959L125.769 306.928L125.869 306.887L125.967 306.836L126.063 306.775L126.131 306.73L126.197 306.697L126.259 306.674L126.319 306.66L126.376 306.654L126.431 306.656L126.484 306.664L126.535 306.678L126.585 306.698L126.634 306.721L126.729 306.78L126.92 306.909L127.11 306.772L127.207 306.71L127.256 306.685L127.307 306.664L127.358 306.648L127.411 306.638L127.465 306.636L127.521 306.642L127.578 306.658L127.638 306.685L127.7 306.722L127.764 306.773L127.815 306.812L127.868 306.847L127.923 306.874L127.979 306.897L128.037 306.917L128.098 306.929L128.16 306.937L128.226 306.941L130.191 306.935C130.08 308.337 130.09 309.742 130.244 311.121C130.482 313.025 130.973 314.881 131.738 316.609C131.838 316.826 131.926 317.052 132.039 317.255C132.1 317.372 132.232 317.933 132.295 318.052L132.294 318.054C132.315 318.191 132.391 318.208 132.4 318.353C132.423 318.671 132.522 318.822 132.748 318.892C132.99 318.978 133.22 319.072 133.418 319.347L134.117 320.288C134.166 320.343 134.213 320.417 134.239 320.495C134.291 320.661 134.302 320.864 134.386 320.997C134.531 321.22 134.756 321.077 134.915 321.194C135.315 321.514 135.755 321.85 136.153 322.223C136.182 322.246 136.2 322.285 136.223 322.317C136.196 322.301 136.174 322.288 136.145 322.272C134.213 322.29 132.242 322.307 130.272 322.327C129.772 322.329 129.768 322.319 129.204 322.702C129.073 322.626 128.934 322.565 128.811 322.483C128.596 322.329 128.379 322.342 128.165 322.454C128.03 322.534 127.907 322.636 127.772 322.727C127.579 322.612 127.383 322.495 127.141 322.348C122.103 322.428 117.334 322.502 112.282 322.582C112.122 322.582 112.046 322.533 111.921 322.424C111.734 322.272 111.579 322.233 111.344 322.397C110.835 322.749 110.318 322.69 109.831 322.313C109.788 322.284 109.679 322.268 109.647 322.293C109.335 322.572 108.961 322.625 108.555 322.621C107.846 322.619 107.138 322.625 106.426 322.644C106.09 322.656 105.82 322.539 105.569 322.343C105.381 322.195 105.13 322.185 104.924 322.327C104.67 322.511 104.418 322.665 104.076 322.661C103.293 322.661 102.506 322.663 101.759 322.665C101.522 322.515 101.322 322.39 101.12 322.263C101.048 322.259 100.971 322.253 100.891 322.249C100.735 322.249 100.575 322.263 100.418 322.249C100 322.21 99.6543 322.364 99.3483 322.638C99.1493 322.521 98.9523 322.406 98.7233 322.271C96.7913 322.289 94.8193 322.306 92.8483 322.326C92.3483 322.328 92.3444 322.318 91.7803 322.701C91.6504 322.625 91.5114 322.564 91.3894 322.482C91.1744 322.328 90.9573 322.341 90.7433 322.453C90.6063 322.533 90.4834 322.635 90.3504 322.726C90.1564 322.611 89.9613 322.494 89.7173 322.347C84.6803 322.427 79.9103 322.501 74.8603 322.581C74.6993 322.581 74.6233 322.532 74.4993 322.423C74.3113 322.271 74.1573 322.232 73.9213 322.396C73.4123 322.748 72.8943 322.689 72.4073 322.312C72.3663 322.283 72.2554 322.267 72.2254 322.292C71.9114 322.571 71.5373 322.624 71.1323 322.62C70.4233 322.618 69.7153 322.624 69.0033 322.643C68.6683 322.655 68.3973 322.538 68.1463 322.342C67.9594 322.194 67.7064 322.184 67.5014 322.326C67.2484 322.51 66.9943 322.664 66.6533 322.66C65.8703 322.66 65.0834 322.662 64.3363 322.664C64.0984 322.514 63.9003 322.389 63.6973 322.262C63.6253 322.258 63.5473 322.252 63.4683 322.248C63.3123 322.248 63.1503 322.262 62.9933 322.248C62.5753 322.209 62.2304 322.363 61.9234 322.637C61.7244 322.52 61.5274 322.405 61.2984 322.27C59.3664 322.288 57.3953 322.305 55.4253 322.325C54.9253 322.327 54.9213 322.317 54.3573 322.7C54.2263 322.624 54.0873 322.563 53.9643 322.481C53.7493 322.327 53.5323 322.34 53.3183 322.452C53.1833 322.532 53.0603 322.634 52.9253 322.725C52.7323 322.61 52.5364 322.493 52.2944 322.346C47.2554 322.426 42.4853 322.5 37.4333 322.58C33.9173 322.582 30.1193 322.586 26.6153 322.59C26.4333 322.492 26.2964 322.418 26.1604 322.346C26.0924 322.307 26.0353 322.237 25.9653 322.219C25.7363 322.158 25.5184 322.127 25.3194 322.319C24.9984 322.628 24.6474 322.667 24.2814 322.378C24.2214 322.327 24.1593 322.271 24.0893 322.245C23.8623 322.173 23.6443 322.141 23.4433 322.327C23.1233 322.628 22.7773 322.7 22.4003 322.413C22.2133 322.27 22.0113 322.181 21.7583 322.186C21.1283 322.194 20.4974 322.202 19.8904 322.209C19.7394 322.309 19.6094 322.397 19.4783 322.484C19.1234 322.714 18.7363 322.689 18.3613 322.562C18.1463 322.492 17.9593 322.339 17.7443 322.212C13.2283 322.257 8.71335 322.3 4.20435 322.345L1.88234 322.359L0.87134 322.351C0.49134 322.552 0.195344 322.792 0.0163443 323.154C0.0173443 323.3 0.0183421 323.459 0.0203421 323.609C0.0203421 323.681 0.0203399 323.754 0.0243399 323.826C0.0283399 323.908 0.036353 323.99 0.028353 324.07C0.007353 324.326 -0.0106497 324.652 0.14435 324.82C0.35535 325.174 1.49035 325.158 1.76035 324.986C1.89135 324.9 2.02435 324.953 2.15535 324.861L2.66335 324.681L3.15134 324.677C3.32734 324.79 3.46935 324.863 3.59035 324.958C3.89335 325.202 4.16035 325.101 4.43035 324.901C4.61635 324.764 4.80935 324.663 5.06935 324.665C5.85635 324.675 6.64334 324.653 7.42334 324.645C7.56834 324.733 7.70135 324.815 7.83435 324.897C8.24935 325.155 8.72434 325.161 9.13434 324.854C9.35934 324.686 9.53034 324.708 9.72034 324.87C9.84734 324.977 9.98235 325.042 10.1404 325.042L13.9233 325.001C14.0773 325.001 14.2123 324.925 14.3353 324.813C14.3943 324.764 14.4613 324.721 14.5313 324.686C14.9013 324.5 15.2823 324.483 15.6413 324.688C15.9113 324.84 16.1533 325.014 16.4963 324.999C17.2053 324.972 17.9143 324.978 18.6233 324.968C18.7833 324.968 18.9184 324.906 19.0434 324.79C19.2304 324.626 19.4024 324.606 19.6294 324.767C20.0514 325.068 20.5223 325.068 20.9263 324.759C21.2743 324.495 21.4753 324.724 21.7143 324.892C21.9513 324.722 22.1703 324.454 22.4903 324.757C22.6153 324.87 22.7544 324.925 22.9144 324.925L25.7504 324.915L32.8443 324.862C32.9983 324.862 33.1524 324.919 33.2684 325.034C33.4724 325.237 33.6533 325.182 33.8423 325.016C33.9663 324.907 34.1093 324.856 34.2703 324.856C35.1353 324.844 36.0023 324.833 36.8703 324.821C37.0714 324.817 37.2764 324.993 37.4364 325.071C37.5474 325.124 37.6204 325.067 37.7254 325.135C37.9584 325.281 38.1333 325.276 38.3683 325.11C38.6303 324.932 38.8894 324.786 39.2254 324.799L40.4073 324.801C40.4813 324.801 40.5634 324.819 40.6304 324.854C40.7674 324.928 40.8864 325.061 41.0304 325.092C41.2744 325.141 41.4053 324.871 41.6143 324.832C42.1563 324.732 42.7083 324.764 43.2573 324.77C43.4113 324.77 43.5444 324.856 43.6814 324.942C43.9604 325.12 43.9743 325.122 44.2493 324.915C44.5423 324.694 44.8194 324.737 45.1034 324.929C45.2324 325.015 45.3684 325.085 45.5274 325.177C47.3144 325.159 49.1254 325.142 50.9274 325.126C51.1354 324.995 51.3224 324.847 51.5314 324.747C51.7444 324.645 51.8463 324.977 52.0803 324.972C52.1593 324.968 52.2393 324.978 52.3163 324.968C52.6523 324.929 53.0533 324.806 53.3223 324.972C53.6813 325.183 54.0644 325.167 54.4314 324.976C54.5684 324.906 54.6883 324.8 54.8183 324.714C55.0133 324.835 55.2114 324.956 55.4234 325.087C56.6674 325.075 57.9293 325.064 59.1913 325.052L67.7013 324.978L73.3773 324.933C73.6133 324.933 73.8513 324.947 74.0883 324.929C74.2283 324.913 74.7343 325.046 74.8613 325.072C74.9703 325.125 75.0433 325.068 75.1503 325.136C75.3823 325.282 75.5574 325.277 75.7934 325.111C76.0544 324.933 76.3133 324.787 76.6503 324.8L77.8313 324.802C77.9053 324.802 77.9883 324.82 78.0543 324.855C78.1913 324.929 78.3094 325.062 78.4534 325.093C78.6974 325.142 78.8294 324.872 79.0394 324.833C79.5804 324.733 80.1334 324.765 80.6814 324.771C80.8363 324.771 80.9684 324.857 81.1044 324.943C81.3834 325.121 81.3983 325.123 81.6723 324.916C81.9663 324.695 82.2424 324.738 82.5264 324.93C82.6553 325.016 82.7923 325.086 82.9503 325.178C84.7383 325.16 86.5504 325.143 88.3504 325.127C88.5594 324.996 88.7463 324.848 88.9553 324.748C89.1683 324.646 89.2693 324.978 89.5023 324.973C89.5823 324.969 89.6623 324.979 89.7403 324.969C90.0743 324.93 90.4764 324.807 90.7464 324.973C91.1054 325.184 91.4864 325.168 91.8533 324.977C91.9903 324.907 92.1113 324.801 92.2403 324.715C92.4363 324.836 92.6334 324.957 92.8454 325.088C94.0914 325.076 95.3524 325.065 96.6134 325.053L105.125 324.979L110.799 324.934C111.037 324.934 111.274 324.948 111.512 324.93C111.651 324.914 112.158 325.047 112.283 325.073C112.394 325.126 112.467 325.069 112.572 325.137C112.805 325.283 112.98 325.278 113.215 325.112C113.477 324.934 113.736 324.788 114.072 324.801L115.254 324.803C115.328 324.803 115.41 324.821 115.477 324.856C115.614 324.93 115.733 325.063 115.877 325.094C116.121 325.143 116.252 324.873 116.461 324.834C117.003 324.734 117.555 324.766 118.104 324.772C118.258 324.772 118.391 324.858 118.528 324.944C118.807 325.122 118.821 325.124 119.096 324.917C119.389 324.696 119.666 324.739 119.95 324.931C120.079 325.017 120.215 325.087 120.374 325.179C122.161 325.161 123.972 325.144 125.774 325.128C125.982 324.997 126.169 324.849 126.378 324.749C126.591 324.647 126.693 324.979 126.927 324.974C127.006 324.97 127.086 324.98 127.163 324.97C127.499 324.931 127.9 324.808 128.169 324.974C128.528 325.185 128.911 325.169 129.278 324.978C129.415 324.908 129.535 324.802 129.665 324.716C129.86 324.837 130.058 324.958 130.27 325.089C131.514 325.077 132.776 325.066 134.038 325.054L140.948 324.993C141.655 325.163 142.372 325.29 143.093 325.348C143.308 325.239 143.497 325.108 143.703 325.03C143.913 324.942 144.015 325.26 144.249 325.255C144.327 325.249 144.409 325.259 144.485 325.247C144.821 325.196 145.212 325.085 145.491 325.222C145.864 325.386 146.252 325.322 146.591 325.083C146.648 325.044 146.695 324.993 146.745 324.946L147.403 324.94C147.464 324.961 147.52 324.981 147.585 325.004C147.675 324.984 147.763 324.957 147.853 324.936L148.224 324.934C148.46 324.934 148.698 324.948 148.935 324.93C149.075 324.914 149.581 325.047 149.708 325.073C149.817 325.126 149.89 325.069 149.997 325.137C150.229 325.283 150.404 325.278 150.64 325.112C150.901 324.934 151.16 324.788 151.497 324.801L152.678 324.803C152.752 324.803 152.835 324.821 152.901 324.856C153.038 324.93 153.156 325.063 153.3 325.094C153.544 325.143 153.676 324.873 153.886 324.834C154.427 324.734 154.98 324.766 155.528 324.772C155.683 324.772 155.815 324.858 155.951 324.944C156.23 325.122 156.245 325.124 156.519 324.917C156.813 324.696 157.089 324.739 157.373 324.931C157.502 325.017 157.639 325.087 157.797 325.179C159.585 325.161 161.397 325.144 163.197 325.128C163.406 324.997 163.593 324.849 163.802 324.749C164.015 324.647 164.116 324.979 164.349 324.974C164.429 324.97 164.509 324.98 164.587 324.97C164.921 324.931 165.323 324.808 165.593 324.974C165.952 325.185 166.333 325.169 166.7 324.978C166.837 324.908 166.958 324.802 167.087 324.716C167.283 324.837 167.48 324.958 167.692 325.089C168.938 325.077 170.199 325.066 171.46 325.054L179.972 324.98L185.646 324.935C185.884 324.935 186.121 324.949 186.359 324.931C186.498 324.915 187.005 325.048 187.13 325.074C187.241 325.127 187.314 325.07 187.419 325.138C187.652 325.284 187.827 325.279 188.062 325.113C188.324 324.935 188.583 324.789 188.919 324.802L189.644 324.804C189.974 324.902 190.308 324.982 190.646 325.056C190.671 325.068 190.697 325.089 190.724 325.095C190.749 325.099 190.769 325.089 190.792 325.089C191.364 325.206 191.942 325.302 192.522 325.349C192.737 325.24 192.926 325.109 193.133 325.031C193.342 324.943 193.444 325.261 193.678 325.256C193.758 325.25 193.838 325.26 193.914 325.248C194.25 325.197 194.641 325.086 194.92 325.223C195.236 325.362 195.561 325.328 195.859 325.174C197.439 325.158 199.031 325.143 200.619 325.129C200.827 324.998 201.014 324.85 201.223 324.75C201.436 324.648 201.538 324.98 201.772 324.975C201.851 324.971 201.931 324.981 202.008 324.971C202.344 324.932 202.745 324.809 203.014 324.975C203.373 325.186 203.756 325.17 204.123 324.979C204.26 324.909 204.38 324.803 204.51 324.717C204.705 324.838 204.903 324.959 205.115 325.09C206.359 325.078 207.621 325.067 208.883 325.055L217.393 324.981L223.069 324.936C223.305 324.936 223.543 324.95 223.78 324.932C223.92 324.916 224.426 325.049 224.553 325.075C224.662 325.128 224.735 325.071 224.842 325.139C225.074 325.285 225.249 325.28 225.485 325.114C225.746 324.936 226.005 324.79 226.342 324.803L227.523 324.805C227.597 324.805 227.68 324.823 227.746 324.858C227.883 324.932 228.001 325.065 228.145 325.096C228.389 325.145 228.521 324.875 228.731 324.836C229.272 324.736 229.825 324.768 230.373 324.774C230.528 324.774 230.66 324.86 230.796 324.946C231.075 325.124 231.09 325.126 231.364 324.919C231.658 324.698 231.934 324.741 232.218 324.933C232.347 325.019 232.484 325.089 232.642 325.181C234.43 325.163 236.242 325.146 238.042 325.13C238.251 324.999 238.438 324.851 238.647 324.751C238.86 324.649 238.961 324.981 239.194 324.976C239.274 324.972 239.354 324.982 239.432 324.972C239.766 324.933 240.168 324.81 240.438 324.976C240.797 325.187 241.178 325.171 241.545 324.98C241.682 324.91 241.803 324.804 241.932 324.718C242.128 324.839 242.325 324.96 242.537 325.091C243.783 325.079 245.044 325.068 246.305 325.056L254.817 324.982L260.491 324.937C260.729 324.937 260.966 324.951 261.204 324.933C261.343 324.917 261.853 325.052 261.977 325.076C262.227 325.127 262.068 325.125 262.273 325.299C262.754 324.977 262.754 324.977 263.249 325.285C263.376 325.195 263.499 325.101 263.633 325.019C263.845 324.894 264.052 324.902 264.288 325.039C264.415 325.115 264.544 325.191 264.675 325.269C264.804 325.177 264.923 325.072 265.063 325.003C265.281 324.894 265.501 324.88 265.718 325.026C265.84 325.106 265.974 325.171 266.103 325.245C266.234 325.153 266.353 325.042 266.498 324.985C266.869 324.84 267.25 324.805 267.617 325.02C267.75 325.104 267.881 325.186 268.054 325.293C268.406 325.293 268.797 325.293 269.189 325.293C269.346 325.293 269.506 325.297 269.663 325.279C269.811 325.263 269.954 325.193 270.069 325.074C270.204 324.935 270.321 324.908 270.458 324.984C270.971 325.273 270.973 325.283 271.315 325.271C271.624 325.253 271.944 325.326 272.237 325.185C272.378 325.117 272.493 325.003 272.632 324.931C272.677 324.908 272.765 324.937 272.824 324.966C272.956 325.027 273.081 325.099 273.21 325.169C273.339 325.079 273.468 324.991 273.612 324.892C273.8 324.999 273.993 325.111 274.219 325.244C275.525 325.232 276.864 325.219 278.19 325.207C278.27 325.17 278.346 325.15 278.412 325.109C278.542 325.021 278.669 324.937 278.799 324.849C278.931 324.913 279.073 324.96 279.189 325.052C279.324 325.152 279.453 325.2 279.621 325.195L291.731 325.093L292.521 325.085L294.104 325.245L296.171 325.054C296.587 325.052 296.816 324.966 297.146 325.204C297.333 325.337 297.847 325.282 298.062 325.12C298.367 324.893 298.212 325.134 298.988 325.009C299.254 324.97 299.406 324.749 299.406 324.542L299.402 323.827L299.398 323.163C299.394 322.843 298.785 322.272 298.447 322.27C298.211 322.266 297.974 322.29 297.738 322.27C297.395 322.237 297.144 322.411 296.887 322.584C296.825 322.633 296.754 322.664 296.68 322.707C296.372 322.709 296.056 322.703 295.742 322.717C295.572 322.731 295.437 322.69 295.299 322.608C294.759 322.284 294.757 322.292 294.213 322.301C293.658 322.307 293.66 322.307 293.124 322.608C293.072 322.641 292.984 322.655 292.932 322.637C292.187 322.326 292.189 322.325 291.843 322.326L289.951 322.34C281.91 322.406 273.871 322.475 265.832 322.541C264.572 322.555 263.242 322.566 261.98 322.58C261.82 322.58 261.744 322.531 261.619 322.422C261.432 322.27 261.277 322.231 261.042 322.395C260.533 322.747 260.016 322.688 259.529 322.311C259.486 322.282 259.377 322.266 259.345 322.291C259.033 322.57 258.659 322.623 258.253 322.619C257.544 322.617 256.836 322.623 256.124 322.642C255.788 322.654 255.518 322.537 255.267 322.341C255.079 322.193 254.828 322.183 254.622 322.325C254.368 322.509 254.116 322.663 253.774 322.659C252.991 322.659 252.204 322.661 251.457 322.663C251.22 322.513 251.02 322.388 250.818 322.261C250.746 322.257 250.669 322.251 250.589 322.247C250.433 322.247 250.273 322.261 250.116 322.247C249.698 322.208 249.352 322.362 249.046 322.636C248.847 322.519 248.65 322.404 248.421 322.269C246.489 322.287 244.517 322.304 242.546 322.324C242.046 322.326 242.042 322.316 241.478 322.699C241.348 322.623 241.209 322.562 241.087 322.48C240.872 322.326 240.655 322.339 240.441 322.451C240.304 322.531 240.181 322.633 240.048 322.724C239.854 322.609 239.659 322.492 239.416 322.345C234.378 322.425 229.608 322.499 224.558 322.579C224.397 322.579 224.321 322.53 224.197 322.421C224.009 322.269 223.855 322.23 223.619 322.394C223.11 322.746 222.592 322.687 222.105 322.31C222.064 322.281 221.953 322.265 221.923 322.29C221.609 322.569 221.235 322.622 220.83 322.618C220.121 322.616 219.413 322.622 218.701 322.641C218.366 322.653 218.095 322.536 217.844 322.34C217.657 322.192 217.404 322.182 217.199 322.324C216.946 322.508 216.692 322.662 216.351 322.658C215.568 322.658 214.781 322.66 214.034 322.662C213.796 322.512 213.598 322.387 213.395 322.26C213.323 322.256 213.246 322.25 213.166 322.246C213.01 322.246 212.848 322.26 212.691 322.246C212.273 322.207 211.928 322.361 211.621 322.635C211.422 322.518 211.225 322.403 210.996 322.268C209.064 322.286 207.093 322.303 205.123 322.323C204.623 322.325 204.619 322.315 204.055 322.698C203.924 322.622 203.785 322.561 203.662 322.479C203.447 322.325 203.23 322.338 203.016 322.45C202.881 322.53 202.758 322.632 202.623 322.723C202.588 322.702 202.551 322.68 202.515 322.659C204.297 321.526 205.889 320.097 207.248 318.489C208.504 317.059 209.512 315.44 210.381 313.749C210.485 313.534 210.604 313.325 210.693 313.101C210.738 312.972 211.078 312.576 211.156 312.472H211.157C211.246 312.392 211.22 312.302 211.32 312.23C211.542 312.07 211.598 311.906 211.533 311.621C211.464 311.307 211.42 311.017 211.554 310.707C211.712 310.344 211.789 309.959 211.911 309.586C211.932 309.516 211.972 309.441 212.024 309.385C212.136 309.274 212.299 309.192 212.37 309.057C212.485 308.83 212.27 308.649 212.27 308.436C212.283 307.977 212.387 307.532 212.489 307.082L212.663 307.184C212.787 307.094 212.909 307.004 213.048 306.905C213.228 307.014 213.412 307.126 213.628 307.257C214.876 307.245 216.158 307.234 217.425 307.222C217.464 307.204 217.501 307.189 217.536 307.173L217.588 307.152L217.637 307.125L218.007 306.865L218.23 306.984L218.306 307.021L218.344 307.041L218.379 307.066L218.427 307.101L218.476 307.132L218.524 307.157L218.574 307.177L218.625 307.193L218.678 307.203L218.735 307.209L218.794 307.211C219.154 307.213 219.605 307.217 219.993 307.221C220.093 307.221 220.187 307.219 220.276 307.217C220.364 307.213 220.446 307.209 220.52 307.205C220.557 307.201 220.59 307.199 220.624 307.195C220.655 307.189 220.686 307.185 220.712 307.181C220.739 307.175 220.763 307.169 220.784 307.163L220.813 307.153L220.838 307.141L220.849 307.133L220.86 307.121L220.87 307.107L220.879 307.087L220.896 307.042L220.91 306.983C220.917 306.942 220.924 306.893 220.932 306.842C220.937 306.789 220.941 306.731 220.947 306.672C220.951 306.551 220.955 306.42 220.959 306.293C220.958 306.166 220.957 306.043 220.957 305.939L220.953 305.88L220.945 305.825L220.931 305.774L220.911 305.725L220.886 305.678L220.857 305.631L220.822 305.586L220.782 305.543L220.728 305.477L220.706 305.446L220.687 305.413L220.672 305.382L220.661 305.349L220.653 305.316L220.649 305.283V305.25L220.653 305.217L220.661 305.182L220.673 305.147L220.689 305.11L220.71 305.073C220.727 305.05 220.743 305.024 220.762 304.997L220.807 304.935L220.847 304.871L220.881 304.809L220.908 304.745L220.931 304.679L220.949 304.613L220.963 304.549L220.973 304.481L220.979 304.393L220.975 304.305L220.963 304.217L220.942 304.129L220.913 304.043L220.872 303.957L220.821 303.873L220.76 303.791L220.717 303.73L220.684 303.673L220.661 303.62L220.647 303.569L220.641 303.52L220.643 303.473L220.652 303.426L220.667 303.383L220.687 303.34L220.71 303.299L220.768 303.217L220.898 303.053L220.763 302.889L220.701 302.805L220.676 302.764L220.655 302.719L220.639 302.676L220.629 302.631L220.628 302.584L220.635 302.537L220.651 302.486L220.678 302.435L220.715 302.382L220.766 302.327L220.805 302.284L220.84 302.239L220.869 302.192L220.892 302.143L220.911 302.094L220.924 302.041L220.933 301.988L220.936 301.931L220.942 299.286C220.962 297.081 220.981 294.878 221.001 292.677L221.005 292.622L221.014 292.569L221.029 292.516L221.049 292.465L221.074 292.416L221.103 292.369L221.139 292.324L221.179 292.283L221.216 292.248L221.246 292.215L221.27 292.18L221.29 292.147L221.306 292.114L221.315 292.081L221.32 292.048V292.015L221.316 291.982L221.306 291.949L221.294 291.916L221.278 291.883L221.237 291.817L221.182 291.751L221.145 291.706L221.115 291.659L221.089 291.612L221.069 291.561L221.053 291.51L221.043 291.457L221.037 291.404V291.347L221.088 288.927L221.09 288.892L221.096 288.857L221.106 288.822L221.118 288.787L221.151 288.721L221.192 288.653L221.28 288.526C221.307 288.485 221.333 288.446 221.356 288.411L221.358 288.409C221.415 288.327 221.36 288.268 221.43 288.188C221.584 288.014 221.581 287.877 221.423 287.69C221.252 287.479 221.113 287.272 221.135 287.01L221.177 286.096C221.18 286.037 221.201 285.975 221.239 285.926C221.321 285.824 221.459 285.738 221.496 285.629C221.557 285.441 221.292 285.326 221.265 285.162C221.19 284.738 221.245 284.312 221.277 283.889C221.285 283.77 221.377 283.672 221.468 283.571C221.657 283.366 221.66 283.356 221.466 283.132C221.259 282.89 221.314 282.679 221.519 282.472C221.61 282.378 221.686 282.277 221.787 282.161C221.833 280.776 221.969 279.388 222.066 277.999C221.951 277.827 221.816 277.669 221.731 277.499C221.644 277.325 221.982 277.276 221.992 277.097C221.992 277.036 222.01 276.976 222.004 276.915C221.988 276.653 221.894 276.331 222.077 276.14C222.306 275.884 222.336 275.595 222.178 275.292C222.121 275.179 222.028 275.075 221.955 274.966C222.094 274.829 222.233 274.693 222.385 274.546C222.492 273.593 222.602 272.626 222.711 271.661C222.852 270.579 223.044 269.507 223.207 268.427C223.357 267.345 223.575 266.279 223.81 265.218L224.26 263.087L224.826 260.989C224.875 260.815 224.939 260.645 224.972 260.464C224.987 260.357 225.221 260.019 225.27 259.935C225.37 259.767 225.334 259.882 225.543 259.785C225.338 259.338 225.328 259.33 225.748 259.072C225.695 258.953 225.638 258.836 225.593 258.713C225.528 258.522 225.588 258.373 225.778 258.248L226.094 258.043C226.039 257.922 225.969 257.801 225.941 257.678C225.891 257.485 225.936 257.321 226.128 257.213C226.235 257.152 226.329 257.076 226.431 257.01C226.378 256.885 226.303 256.762 226.287 256.637C226.245 256.321 226.309 256.032 226.602 255.844C226.711 255.776 226.825 255.713 226.977 255.631C227.081 255.385 227.196 255.111 227.313 254.836C227.359 254.727 227.409 254.615 227.439 254.498C227.469 254.389 227.446 254.262 227.371 254.137C227.282 253.989 227.292 253.893 227.403 253.826C227.821 253.58 227.83 253.584 227.921 253.338C227.997 253.115 228.157 252.92 228.116 252.658C228.095 252.531 228.026 252.402 228.001 252.275C227.992 252.234 228.046 252.183 228.094 252.156C228.195 252.09 228.302 252.035 228.409 251.976C228.372 251.851 228.335 251.724 228.294 251.583C228.456 251.501 228.622 251.417 228.817 251.317C229.258 250.426 229.672 249.493 230.149 248.6C230.146 248.53 230.158 248.469 230.147 248.407L230.065 248.024C230.171 247.967 230.266 247.895 230.389 247.862C230.529 247.821 230.619 247.76 230.678 247.645C231.662 245.782 232.807 243.999 233.925 242.202C235.125 240.452 236.285 238.675 237.571 236.97C237.76 236.712 237.74 236.718 238.083 236.658C238.275 236.623 238.368 236.463 238.339 236.232C238.3 235.906 238.672 235.568 238.933 235.013C238.992 234.892 239.32 234.988 239.579 235.068C239.725 235.115 239.779 235.181 239.857 235.324C239.978 235.521 240.109 235.603 240.377 235.517C240.953 235.333 241.406 235.538 241.734 236.038C241.763 236.079 241.859 236.126 241.895 236.11C242.267 235.938 242.624 235.997 242.994 236.118C243.641 236.327 244.289 236.528 244.945 236.718C245.256 236.804 245.468 236.995 245.641 237.255C245.769 237.452 245.997 237.536 246.226 237.458C246.51 237.356 246.785 237.282 247.095 237.388C247.802 237.644 248.542 237.8 249.234 237.99C249.415 238.191 249.566 238.359 249.72 238.531C249.786 238.552 249.857 238.576 249.929 238.599C250.075 238.636 250.228 238.661 250.37 238.712C250.749 238.851 251.11 238.784 251.467 238.593C251.622 238.755 251.776 238.913 251.954 239.099C253.757 239.544 255.597 239.999 257.434 240.453C257.901 240.57 257.909 240.56 258.522 240.297C258.627 240.397 258.746 240.481 258.844 240.582C259.014 240.771 259.221 240.799 259.448 240.728C259.593 240.675 259.73 240.599 259.876 240.533C260.034 240.683 260.194 240.832 260.394 241.019C262.78 241.447 265.097 241.882 267.428 242.242C269.773 242.506 272.12 242.769 274.534 243.039C274.686 243.059 274.755 243.115 274.862 243.242C275.024 243.416 275.169 243.472 275.41 243.34C275.931 243.063 276.418 243.162 276.852 243.557C276.891 243.59 276.996 243.612 277.027 243.588C277.352 243.328 277.715 243.299 278.104 243.326C278.785 243.369 279.465 243.406 280.149 243.428C280.472 243.436 280.725 243.569 280.956 243.78C281.128 243.938 281.37 243.964 281.575 243.833C281.829 243.665 282.079 243.526 282.405 243.552C283.157 243.595 283.913 243.64 284.63 243.683C284.853 243.855 285.042 243.962 285.235 244.091C285.305 244.093 285.38 244.097 285.456 244.101C285.607 244.101 285.763 244.087 285.913 244.097C286.317 244.134 286.653 243.976 286.95 243.701C287.141 243.816 287.331 243.931 287.551 244.064C289.415 244.027 291.32 243.988 293.22 243.949C293.701 243.908 293.707 243.918 294.228 243.492C294.359 243.558 294.495 243.607 294.617 243.68C294.834 243.817 295.043 243.787 295.242 243.659C295.367 243.569 295.478 243.458 295.6 243.356C295.794 243.456 295.99 243.557 296.234 243.684C298.657 243.448 301.021 243.297 303.349 242.805C304.515 242.598 305.683 242.391 306.859 242.182C307.445 242.073 308.039 241.991 308.627 241.86C309.211 241.712 309.797 241.565 310.389 241.415V241.417C310.539 241.38 310.621 241.409 310.764 241.489C310.973 241.596 311.127 241.598 311.313 241.385C311.713 240.928 312.209 240.869 312.757 241.125C312.804 241.145 312.912 241.135 312.934 241.102C313.162 240.762 313.498 240.627 313.879 240.54C314.543 240.368 315.217 240.247 315.863 240.009C316.168 239.898 316.45 239.929 316.737 240.04C316.951 240.126 317.189 240.06 317.336 239.86C317.516 239.61 317.701 239.385 318.017 239.288C318.736 239.052 319.457 238.813 320.143 238.589C320.412 238.659 320.635 238.718 320.864 238.778C320.932 238.758 321.005 238.739 321.079 238.719C321.224 238.672 321.368 238.612 321.517 238.576C321.913 238.48 322.187 238.252 322.363 237.875C322.582 237.91 322.8 237.943 323.051 237.984C324.773 237.238 326.53 236.478 328.286 235.718C328.733 235.532 328.731 235.511 329.052 234.921C329.198 234.931 329.343 234.923 329.485 234.942C329.737 234.983 329.919 234.874 330.052 234.676C330.133 234.543 330.194 234.397 330.266 234.254C330.486 234.27 330.706 234.287 330.98 234.307C332.055 233.723 333.115 233.147 334.168 232.575C335.189 231.948 336.165 231.257 337.159 230.602C338.138 229.924 339.161 229.311 340.11 228.577C341.048 227.831 341.993 227.079 342.952 226.315C343.075 226.219 343.164 226.211 343.329 226.223C343.567 226.231 343.712 226.168 343.79 225.901C343.952 225.319 344.401 225.083 344.993 225.047C345.042 225.041 345.132 224.979 345.137 224.94C345.179 224.522 345.409 224.237 345.7 223.971C346.206 223.504 346.706 223.033 347.198 222.549C347.427 222.32 347.701 222.227 348.015 222.201C348.251 222.183 348.44 222.021 348.487 221.783C348.538 221.484 348.609 221.209 348.854 220.988C349.411 220.47 349.868 219.851 350.374 219.334C350.64 219.264 350.861 219.205 351.087 219.145C351.138 219.096 351.191 219.041 351.245 218.987C351.349 218.874 351.443 218.749 351.556 218.643C351.859 218.368 351.968 218.014 351.96 217.614C352.179 217.546 352.394 217.479 352.646 217.401C353.296 216.717 353.851 215.942 354.412 215.165C354.976 214.394 355.545 213.618 356.113 212.843C356.402 212.452 356.414 212.452 356.425 211.796C356.56 211.734 356.7 211.671 356.829 211.612C357.065 211.518 357.166 211.331 357.183 211.091C357.185 210.935 357.163 210.777 357.154 210.616C357.351 210.518 357.548 210.421 357.794 210.298C358.422 209.243 359.041 208.202 359.656 207.167C360.258 206.126 360.706 205.011 361.233 203.94L361.996 202.319C362.261 201.782 362.506 201.235 362.695 200.663C363.111 199.534 363.53 198.399 363.955 197.247C364.105 196.847 364.258 196.444 364.411 196.036C364.529 195.618 364.65 195.198 364.769 194.774C365.01 193.928 365.253 193.073 365.498 192.219C366.053 190.528 366.309 188.766 366.615 187.09C366.743 186.932 366.84 186.813 366.935 186.695C366.986 186.636 367.064 186.593 367.095 186.529C367.195 186.32 367.265 186.113 367.111 185.892C366.863 185.537 366.886 185.197 367.238 184.888C367.3 184.837 367.365 184.784 367.394 184.718C367.486 184.509 367.537 184.298 367.371 184.079C367.1 183.731 367.059 183.391 367.379 183.058C367.537 182.892 367.645 182.704 367.66 182.456C367.709 181.843 367.758 181.227 367.805 180.636C367.717 180.482 367.642 180.349 367.567 180.216C367.341 179.855 367.399 179.484 367.56 179.129ZM270.421 152.608C270.472 152.283 270.523 151.962 270.585 151.651C270.773 151.48 270.941 151.344 271.118 151.211C271.138 151.154 271.163 151.095 271.18 151.03C271.213 150.905 271.235 150.774 271.282 150.652C271.401 150.325 271.354 150.021 271.169 149.694C271.345 149.575 271.517 149.457 271.718 149.32C272.306 147.831 273.163 146.418 274.203 145.155C274.461 144.827 274.472 144.842 274.487 144.257C274.626 144.224 274.754 144.177 274.889 144.153C275.133 144.12 275.243 143.979 275.284 143.778C275.305 143.647 275.304 143.509 275.317 143.37C275.522 143.337 275.729 143.306 275.987 143.265C278.993 140.445 282.783 138.301 286.925 136.736C287.057 136.687 287.136 136.709 287.277 136.775C287.482 136.863 287.619 136.845 287.763 136.629C288.075 136.158 288.536 136.068 289.056 136.295C289.099 136.311 289.197 136.295 289.214 136.263C289.391 135.907 289.698 135.774 290.044 135.674C290.648 135.501 291.251 135.328 291.858 135.153C292.144 135.07 292.407 135.125 292.668 135.261C292.862 135.365 293.08 135.32 293.224 135.139C293.402 134.913 293.588 134.716 293.886 134.657C294.57 134.521 295.247 134.34 295.907 134.246C296.14 134.357 296.336 134.449 296.536 134.543C296.599 134.536 296.668 134.531 296.738 134.52C296.873 134.495 297.011 134.458 297.15 134.445C297.521 134.428 297.798 134.231 298.029 133.921C298.22 134.011 298.411 134.101 298.631 134.203C300.322 133.941 302.063 133.745 303.807 133.6C304.252 133.571 304.254 133.58 304.735 133.169C304.855 133.239 304.982 133.293 305.094 133.368C305.293 133.51 305.485 133.486 305.67 133.363C305.787 133.275 305.894 133.174 306.01 133.077C306.186 133.187 306.364 133.3 306.586 133.439C311.061 133.236 315.33 133.331 319.818 133.814C319.961 133.834 320.023 133.89 320.119 134.014C320.265 134.189 320.395 134.244 320.625 134.112C321.121 133.826 321.576 133.947 321.949 134.379C321.982 134.412 322.078 134.441 322.107 134.42C322.425 134.187 322.763 134.191 323.121 134.254C323.746 134.354 324.371 134.453 325 134.553C325.296 134.598 325.512 134.76 325.695 134.994C325.83 135.172 326.048 135.224 326.255 135.119C326.512 134.984 326.767 134.871 327.064 134.941C327.748 135.091 328.434 135.244 329.086 135.387C329.257 135.583 329.398 135.747 329.545 135.915C329.606 135.935 329.672 135.956 329.738 135.977C329.873 136.01 330.015 136.034 330.146 136.081C330.497 136.21 330.833 136.136 331.168 135.938C331.31 136.096 331.448 136.254 331.61 136.437C333.266 136.883 334.956 137.358 336.611 137.924C337.032 138.068 337.03 138.077 337.635 137.882C337.719 137.992 337.815 138.089 337.888 138.207C338.014 138.418 338.198 138.475 338.415 138.437C338.556 138.406 338.693 138.35 338.838 138.306C338.958 138.476 339.078 138.646 339.228 138.859C343.403 140.443 347.276 142.216 351 144.677C351.117 144.757 351.146 144.835 351.174 144.988C351.223 145.207 351.313 145.314 351.577 145.298C352.152 145.259 352.48 145.598 352.598 146.149C352.611 146.194 352.678 146.264 352.715 146.26C353.103 146.201 353.403 146.355 353.674 146.586C354.152 146.986 354.654 147.357 355.125 147.768C355.352 147.956 355.451 148.202 355.482 148.491C355.503 148.71 355.663 148.858 355.884 148.882C356.167 148.902 356.433 148.946 356.642 149.159C357.133 149.636 357.616 150.134 358.039 150.614C358.065 150.864 358.077 151.073 358.086 151.284C358.12 151.333 358.155 151.388 358.196 151.437C358.279 151.538 358.374 151.631 358.446 151.739C358.635 152.03 358.942 152.153 359.317 152.212C359.318 152.412 359.319 152.61 359.319 152.839C360.27 154.126 361.122 155.54 361.747 157.057C361.897 157.448 361.886 157.445 362.436 157.798C362.401 157.919 362.368 158.047 362.314 158.164C362.209 158.371 362.27 158.539 362.434 158.69C362.547 158.784 362.678 158.866 362.805 158.96C362.736 159.138 362.642 159.319 362.532 159.538C363.512 163.633 362.52 167.92 359.899 171.278C359.813 171.383 359.731 171.407 359.573 171.426C359.344 171.461 359.233 171.535 359.245 171.783C359.267 172.32 358.893 172.607 358.327 172.662C358.28 172.668 358.206 172.724 358.209 172.76C358.245 173.129 358.044 173.377 357.794 173.612C357.366 174.032 356.894 174.401 356.445 174.803C356.237 174.998 355.967 175.035 355.68 175.008C355.462 174.983 355.289 175.096 355.239 175.313C355.177 175.583 355.099 175.842 354.846 175.995C354.274 176.352 353.719 176.77 353.137 177.073C352.884 177.048 352.672 177.026 352.456 177.003C352.4 177.03 352.338 177.058 352.279 177.093C352.164 177.163 352.044 177.236 351.918 177.288C351.577 177.419 351.385 177.694 351.27 178.063C351.063 178.038 350.858 178.012 350.621 177.983C349.114 178.729 347.522 179.405 345.898 180.003C345.481 180.148 345.477 180.134 345.123 180.653C344.989 180.616 344.854 180.596 344.726 180.553C344.499 180.465 344.323 180.535 344.175 180.703C344.085 180.816 344.009 180.939 343.921 181.062C343.724 180.998 343.525 180.933 343.276 180.853C339.024 182.136 334.838 182.951 330.356 183.367C330.213 183.379 330.141 183.338 330.024 183.236C329.846 183.097 329.708 183.064 329.508 183.24C329.08 183.617 328.61 183.588 328.16 183.236C328.121 183.209 328.023 183.199 327.998 183.226C327.732 183.525 327.4 183.58 327.039 183.589C326.406 183.612 325.775 183.636 325.14 183.659C324.84 183.671 324.597 183.554 324.373 183.358C324.207 183.21 323.982 183.2 323.799 183.344C323.574 183.526 323.346 183.686 323.041 183.674C322.341 183.656 321.638 183.639 320.971 183.623C320.765 183.463 320.594 183.328 320.418 183.191C320.355 183.183 320.285 183.175 320.216 183.168C320.076 183.16 319.934 183.166 319.795 183.145C319.426 183.084 319.111 183.223 318.818 183.481C318.65 183.354 318.482 183.225 318.287 183.079C316.572 182.964 314.82 182.819 313.079 182.602C312.637 182.543 312.637 182.534 312.083 182.844C311.979 182.752 311.864 182.676 311.768 182.578C311.6 182.4 311.407 182.39 311.202 182.469C311.07 182.53 310.946 182.61 310.813 182.682C310.661 182.539 310.508 182.395 310.317 182.217C305.881 181.543 301.706 180.66 297.417 179.283C297.28 179.236 297.231 179.17 297.163 179.029C297.056 178.83 296.938 178.75 296.686 178.834C296.145 179.016 295.718 178.818 295.449 178.305C295.425 178.264 295.339 178.215 295.303 178.229C294.948 178.391 294.615 178.323 294.28 178.19C293.692 177.961 293.104 177.733 292.513 177.502C292.233 177.397 292.055 177.197 291.928 176.932C291.833 176.733 291.637 176.627 291.412 176.684C291.135 176.76 290.865 176.807 290.59 176.678C289.957 176.387 289.317 176.106 288.729 175.793C288.607 175.566 288.506 175.377 288.403 175.184C288.347 175.151 288.29 175.114 288.227 175.082C288.104 175.018 287.974 174.961 287.858 174.885C287.552 174.676 287.212 174.67 286.84 174.781C286.741 174.595 286.643 174.412 286.529 174.197C285.049 173.363 283.537 172.5 282.122 171.508C281.758 171.262 281.76 171.258 281.139 171.268C281.092 171.137 281.03 171.014 280.993 170.885C280.932 170.649 280.774 170.545 280.555 170.522C280.411 170.514 280.263 170.53 280.111 170.532C280.05 170.335 279.99 170.136 279.915 169.887C278.187 168.539 276.576 167.08 275.199 165.528C273.836 163.989 272.629 162.276 271.738 160.335C271.683 160.214 271.701 160.14 271.765 160.011C271.857 159.82 271.853 159.691 271.621 159.552C271.126 159.251 271.011 158.812 271.296 158.341C271.317 158.3 271.308 158.21 271.275 158.191C270.929 157.994 270.757 157.703 270.709 157.363C270.586 156.775 270.472 156.188 270.406 155.587C270.361 155.305 270.459 155.072 270.67 154.863C270.823 154.707 270.832 154.502 270.678 154.326C270.484 154.111 270.307 153.887 270.345 153.598C270.37 153.268 270.395 152.936 270.421 152.608ZM245.187 142.738C245.888 142.512 246.601 142.305 247.311 142.094C247.458 141.941 247.589 141.774 247.749 141.649C247.913 141.521 248.038 141.827 248.228 141.789C248.292 141.773 248.359 141.772 248.42 141.751C248.689 141.668 249.013 141.492 249.242 141.616C249.55 141.802 249.854 141.774 250.159 141.569C250.272 141.495 250.374 141.385 250.485 141.296C250.643 141.406 250.801 141.517 250.973 141.636C251.994 141.657 253.041 141.681 254.059 141.906C256.356 142.328 258.56 143.314 260.419 144.726C261.07 145.158 261.6 145.742 262.185 146.258C262.452 146.534 262.686 146.827 262.94 147.11C263.193 147.384 263.444 147.674 263.68 148.039C263.799 148.211 263.905 148.393 264.039 148.557C264.111 148.637 264.228 148.982 264.285 149.138L264.273 149.146C264.261 149.245 264.332 149.261 264.306 149.362C264.249 149.581 264.304 149.674 264.531 149.753C264.791 149.831 264.969 150.002 265.049 150.251C265.149 150.543 265.246 150.843 265.303 151.165C265.317 151.224 265.315 151.294 265.292 151.353C265.242 151.478 265.133 151.597 265.129 151.715C265.129 151.91 265.397 151.979 265.462 152.145C265.619 152.579 265.67 153.039 265.682 153.506C265.692 153.637 265.614 153.755 265.536 153.875C265.376 154.121 265.374 154.129 265.598 154.352C265.827 154.59 265.784 154.833 265.596 155.077C265.513 155.188 265.444 155.305 265.354 155.438C265.364 156.948 265.292 158.497 265.104 160.029C265.215 160.223 265.342 160.403 265.411 160.594C265.483 160.791 265.141 160.83 265.116 161.03C265.11 161.098 265.09 161.165 265.091 161.232C265.082 161.522 265.158 161.887 264.946 162.084C264.678 162.352 264.634 162.672 264.762 163.02C264.809 163.149 264.893 163.274 264.955 163.401C264.799 163.54 264.642 163.678 264.472 163.829C264.246 164.868 263.989 165.919 263.655 166.929C263.484 167.519 263.267 168.025 263.073 168.572L262.686 169.429L262.589 169.644C262.599 169.617 262.549 169.705 262.533 169.73C262.494 169.814 262.434 169.886 262.375 169.959C262.078 170.328 261.514 170.707 260.987 170.904C260.443 171.119 259.867 171.244 259.288 171.318C257.736 171.507 256.166 171.396 254.616 171.195C254.422 171.168 254.222 171.129 254.031 171.109C253.92 171.105 253.478 170.937 253.371 170.9C253.36 170.894 253.353 170.894 253.344 170.89C255.651 168.702 256.739 167.255 258.658 164.919L256.679 163.401C255.861 164.381 255.065 165.467 254.13 166.467C253.964 166.649 253.923 166.992 253.753 167.172C253.544 167.395 253.212 167.451 253.005 167.672C252.517 168.229 251.95 168.709 251.41 169.217C250.869 169.725 250.323 170.229 249.733 170.672C249.596 170.781 249.368 170.83 249.232 170.938C249.096 171.047 249.051 171.215 248.915 171.323C248.276 171.86 247.561 172.274 246.902 172.745C245.852 173.436 244.719 174.12 243.503 174.696C243.288 174.801 243.132 175.126 242.904 175.216C242.627 175.329 242.301 175.243 242.026 175.359C240.832 175.863 239.577 176.238 238.315 176.509C237.913 176.54 237.51 176.556 237.106 176.542C234.752 176.522 232.399 175.929 230.28 174.892C228.866 174.199 227.542 173.312 226.378 172.247C226.239 172.108 226.122 171.954 225.96 171.827C225.856 171.755 225.747 171.358 225.724 171.253C225.742 171.144 225.62 171.142 225.662 171.023C225.752 170.767 225.652 170.666 225.285 170.64C224.887 170.607 224.551 170.529 224.4 170.292C224.212 170.024 224.027 169.749 223.861 169.466C223.828 169.413 223.818 169.343 223.841 169.275C223.898 169.129 224.046 168.963 224.042 168.836C224.028 168.627 223.562 168.697 223.423 168.563C223.048 168.225 222.952 167.762 222.792 167.334C222.755 167.209 222.86 167.057 222.966 166.906C223.181 166.594 223.183 166.586 222.789 166.467C222.382 166.334 222.414 166.078 222.678 165.764C222.798 165.621 222.878 165.481 223.025 165.313C222.882 164.206 222.98 163.051 223.343 161.987C223.753 162.366 224.166 162.751 224.558 163.069C224.628 163.079 224.685 163.1 224.747 163.102L225.144 163.092C225.176 163.207 225.233 163.313 225.242 163.44C225.255 163.585 225.302 163.682 225.403 163.762C227.137 165.186 228.101 165.908 229.693 167.258L229.692 167.26C230.225 167.719 230.846 168.254 231.501 168.819L231.519 168.837L231.539 168.858C231.553 168.876 231.566 168.895 231.582 168.915C231.609 168.958 231.641 169.007 231.672 169.056C231.703 169.105 231.734 169.154 231.762 169.197C231.778 169.217 231.791 169.236 231.805 169.254L231.825 169.275L231.843 169.293C231.872 169.316 231.9 169.336 231.924 169.355L232.001 169.4L232.075 169.437L232.148 169.466L232.221 169.497L232.295 169.532L232.372 169.579C232.396 169.599 232.424 169.618 232.453 169.641L232.785 169.928C233.097 170.198 233.392 170.453 233.664 170.688C233.934 170.913 234.178 171.118 234.391 171.293L234.401 171.301L234.413 171.305L234.427 171.307L234.44 171.305L234.455 171.301L234.471 171.295L234.502 171.275C234.523 171.265 234.549 171.254 234.575 171.242L234.654 171.193C234.707 171.156 234.764 171.119 234.816 171.086C234.843 171.07 234.869 171.057 234.892 171.045L234.926 171.031L234.958 171.025L234.983 171.021L235.008 171.013L235.031 171.001L235.054 170.985L235.103 170.948L235.152 170.905L235.202 170.864L235.256 170.825L235.283 170.809L235.312 170.797L235.343 170.787L235.375 170.783C235.382 170.748 235.388 170.717 235.394 170.685C235.403 170.656 235.412 170.628 235.419 170.601L235.45 170.533L235.487 170.474L235.528 170.427L235.573 170.39L235.622 170.359L235.673 170.334L235.78 170.297L235.889 170.26L235.943 170.24L235.996 170.215L236.046 170.186L236.095 170.147L236.245 170.012L236.317 169.942L236.385 169.868L236.39 169.86L236.393 169.852L236.398 169.832L236.403 169.811L236.409 169.791L236.448 169.725L236.481 169.653L236.493 169.614L236.503 169.575L236.509 169.532L236.51 169.487L236.511 169.423L236.517 169.368L236.531 169.321L236.54 169.301L236.551 169.281L236.563 169.265L236.577 169.249L236.594 169.235L236.612 169.225L236.631 169.215L236.652 169.207L236.701 169.197C236.828 169.179 236.926 169.166 237.002 169.156C237.039 169.148 237.072 169.142 237.102 169.136C237.131 169.128 237.157 169.12 237.18 169.115L237.213 169.101L237.242 169.085L237.3 169.048C237.319 169.032 237.338 169.017 237.36 168.997C237.382 168.977 237.405 168.956 237.43 168.931L237.503 168.865L237.578 168.801L237.73 168.672L237.8 168.602L237.862 168.528L237.89 168.487L237.916 168.444L237.937 168.399L237.957 168.35C237.961 168.342 237.967 168.33 237.975 168.317C237.983 168.304 237.995 168.288 238.006 168.268C238.034 168.233 238.07 168.188 238.11 168.135C238.153 168.086 238.202 168.03 238.254 167.971C238.307 167.914 238.363 167.852 238.421 167.791L238.597 167.617C238.657 167.562 238.714 167.512 238.766 167.465C238.793 167.444 238.819 167.424 238.844 167.404C238.869 167.386 238.893 167.371 238.913 167.355C238.935 167.343 238.956 167.332 238.975 167.322L239 167.312L239.023 167.306C239.107 167.234 239.175 167.175 239.263 167.099H239.262C240.111 166.337 241.234 165.484 242.089 164.708C242.121 164.63 242.161 164.565 242.183 164.497C242.217 164.347 242.249 164.204 242.285 164.056C242.426 164.021 242.56 163.962 242.705 163.954C242.873 163.942 242.996 163.893 243.117 163.782C244.162 162.825 244.965 162.089 245.75 161.37C246.52 160.548 247.291 159.763 248.094 158.565C248.783 157.542 249.596 156.15 249.85 154.799C249.834 154.701 249.832 154.615 249.811 154.537C249.763 154.378 249.674 154.22 249.608 154.066C249.692 153.93 249.754 153.773 249.857 153.648C249.982 153.502 250.014 153.35 250.012 153.153C249.989 151.43 249.444 150.158 248.713 149.119C247.968 148.076 247.047 147.247 245.745 146.496C244.615 145.859 243.107 145.298 241.814 145.164C241.723 145.189 241.64 145.199 241.568 145.228C241.418 145.289 241.277 145.38 241.134 145.459C241.001 145.384 240.851 145.332 240.732 145.235C240.591 145.125 240.451 145.073 240.269 145.086C240.201 145.088 240.142 145.097 240.076 145.099C240.094 145.023 240.112 144.945 240.164 144.892C240.485 144.566 240.885 144.324 241.303 144.13C241.418 144.069 241.559 144.088 241.701 144.107C241.992 144.144 242 144.143 242.105 143.863C242.217 143.562 242.448 143.487 242.738 143.543C242.869 143.566 242.998 143.574 243.15 143.594C243.827 143.311 244.505 143.025 245.187 142.738ZM266.649 191.094C266.917 191.272 267.157 191.457 267.281 191.785C267.581 192.533 267.86 193.295 268.198 193.984C268.186 194.115 268.175 194.236 268.163 194.351C267.841 194.429 267.522 194.583 267.429 194.712C267.345 194.831 267.213 194.819 267.13 194.944L266.747 195.262L266.325 195.41C266.137 195.353 265.994 195.326 265.863 195.269C265.532 195.117 265.339 195.312 265.152 195.554C265.022 195.722 264.876 195.857 264.643 195.906C263.936 196.049 263.237 196.22 262.541 196.379C262.395 196.32 262.262 196.266 262.129 196.211C261.922 196.123 261.715 196.102 261.521 196.149C261.323 196.178 261.135 196.268 260.971 196.438C260.789 196.624 260.628 196.618 260.438 196.475C260.309 196.377 260.182 196.325 260.04 196.338C258.903 196.438 257.774 196.658 256.624 196.594C256.483 196.592 256.362 196.666 256.251 196.776C256.196 196.825 256.136 196.866 256.07 196.899C255.731 197.079 255.376 197.092 255.053 196.881C254.811 196.725 254.598 196.549 254.285 196.559C253.639 196.61 252.998 196.469 252.354 196.416C252.208 196.398 252.08 196.445 251.955 196.547C251.766 196.688 251.605 196.688 251.418 196.504C251.071 196.16 250.652 196.109 250.235 196.369C249.878 196.59 249.728 196.348 249.541 196.148C249.301 196.269 249.054 196.49 248.819 196.128C248.728 195.993 248.614 195.911 248.47 195.88L245.925 195.335C244.859 195.13 243.829 194.741 242.779 194.456C241.736 194.142 240.679 193.868 239.666 193.45C239.532 193.399 239.419 193.294 239.359 193.147C239.253 192.887 239.079 192.879 238.857 192.973C238.711 193.034 238.57 193.034 238.431 192.981C237.679 192.704 236.924 192.428 236.169 192.151C235.993 192.092 235.888 191.852 235.782 191.717V191.715C235.71 191.625 235.627 191.651 235.563 191.547C235.424 191.322 235.275 191.262 235.01 191.324C234.719 191.388 234.442 191.422 234.161 191.281L233.162 190.826C233.1 190.797 233.037 190.75 232.996 190.693C232.911 190.572 232.867 190.406 232.758 190.324C232.572 190.185 232.348 190.381 232.154 190.334C231.655 190.215 231.196 189.986 230.741 189.756C230.612 189.69 230.54 189.557 230.466 189.42C230.312 189.143 230.302 189.135 229.984 189.203C229.642 189.279 229.431 189.121 229.283 188.83C229.215 188.699 229.133 188.578 229.044 188.428C227.568 187.668 226.033 186.979 224.578 186.141C224.346 186.161 224.123 186.203 223.904 186.196C223.681 186.186 223.759 185.848 223.568 185.749C223.501 185.716 223.441 185.671 223.373 185.644C223.082 185.525 222.695 185.449 222.559 185.181C222.371 184.831 222.054 184.671 221.661 184.671C221.515 184.669 221.364 184.706 221.216 184.72C221.118 184.527 221.019 184.331 220.911 184.12C219.886 183.577 218.891 182.944 217.874 182.354L214.458 180.327L211.087 178.22C209.597 177.267 208.08 176.359 206.612 175.37C206.426 175.247 206.251 175.11 206.057 175.001C205.94 174.94 205.619 174.567 205.536 174.48C205.479 174.378 205.391 174.388 205.347 174.277C205.247 174.033 205.109 173.947 204.835 173.963C204.532 173.975 204.25 173.961 203.995 173.775L203.079 173.156C203.02 173.117 202.966 173.06 202.934 172.998C202.87 172.863 202.852 172.691 202.757 172.592C202.596 172.424 202.342 172.578 202.156 172.5C201.68 172.301 201.267 171.988 200.846 171.695C200.727 171.613 200.673 171.47 200.617 171.326C200.503 171.031 200.494 171.021 200.166 171.045C199.814 171.072 199.625 170.889 199.518 170.578C199.467 170.439 199.401 170.308 199.332 170.148C197.948 169.209 196.546 168.255 195.151 167.308C194.916 167.302 194.687 167.324 194.469 167.294C194.247 167.263 194.359 166.937 194.177 166.817C194.113 166.778 194.057 166.727 193.991 166.694C193.712 166.546 193.335 166.426 193.225 166.143C193.073 165.776 192.773 165.582 192.381 165.539C192.246 165.523 192.104 165.539 191.965 165.541C192.27 165.225 192.569 164.9 192.852 164.559C192.899 164.305 192.942 164.073 192.989 163.823C193.048 163.577 193.374 163.696 193.522 163.489C193.571 163.417 193.631 163.354 193.674 163.28C193.863 162.966 194.028 162.557 194.309 162.389C194.694 162.168 194.907 161.793 194.948 161.356C194.968 161.196 194.923 161.022 194.911 160.858C195.113 160.718 195.316 160.579 195.536 160.427C195.735 160.053 195.882 159.654 196.023 159.25C196.047 159.26 196.067 159.271 196.094 159.281C196.407 159.386 196.672 159.511 196.891 159.778C197.157 160.08 197.422 160.385 197.711 160.665C197.766 160.717 197.815 160.787 197.84 160.859C197.889 161.009 197.887 161.191 197.977 161.316C198.127 161.531 198.408 161.42 198.6 161.523C199.088 161.804 199.508 162.175 199.973 162.487C200.102 162.577 200.165 162.725 200.235 162.878C200.384 163.177 200.402 163.187 200.752 163.153C201.127 163.11 201.334 163.301 201.509 163.596C201.587 163.729 201.683 163.854 201.79 164.01C203.47 164.817 205.298 165.336 207.134 165.576C207.364 165.478 207.572 165.359 207.79 165.289C208.013 165.207 208.083 165.543 208.321 165.555C208.402 165.555 208.483 165.573 208.561 165.567C208.907 165.551 209.313 165.465 209.582 165.62C209.942 165.829 210.34 165.811 210.705 165.618C210.842 165.55 210.957 165.427 211.082 165.335C211.285 165.44 211.491 165.546 211.714 165.661C212.975 165.563 214.227 165.323 215.458 165.03C216.562 164.749 217.685 164.411 218.718 164.024C218.977 163.922 219.24 163.836 219.503 163.753C219.366 164.769 219.422 165.806 219.631 166.81C220.09 169.035 221.295 171.054 222.819 172.794C222.911 172.909 222.915 172.985 222.897 173.12C222.881 173.319 222.946 173.444 223.241 173.52C223.864 173.696 224.171 174.024 224.174 174.536C224.177 174.579 224.239 174.657 224.281 174.661C224.737 174.702 225.055 174.876 225.341 175.112C225.856 175.508 226.388 175.887 226.964 176.208C227.236 176.358 227.354 176.562 227.395 176.812C227.427 176.992 227.628 177.109 227.91 177.099C228.264 177.081 228.586 177.091 228.867 177.224C229.51 177.531 230.203 177.777 230.84 178.003C230.928 178.196 231.014 178.343 231.104 178.489C231.166 178.51 231.231 178.534 231.298 178.557C231.438 178.598 231.589 178.629 231.719 178.678C232.06 178.828 232.487 178.752 232.948 178.59C233.047 178.725 233.145 178.858 233.26 179.01C233.641 179.076 234.028 179.123 234.414 179.162L234.394 179.394C235.779 179.456 237.199 179.337 238.476 179.097C238.542 179.087 238.611 179.085 238.677 179.076C239.128 178.99 239.132 179.004 239.831 178.525C239.908 178.58 240.002 178.619 240.071 178.681C240.186 178.79 240.385 178.724 240.628 178.558C240.634 178.554 240.641 178.548 240.647 178.544C240.662 178.54 240.675 178.542 240.689 178.536C240.912 178.462 241.111 178.39 241.318 178.317C241.373 178.35 241.42 178.379 241.483 178.419C243.685 177.681 245.735 176.608 247.656 175.31C247.963 175.093 248.265 174.855 248.568 174.621C249.019 174.32 249.496 174 249.982 173.676C251.666 174.041 253.38 174.328 255.14 174.453C257.384 174.605 259.742 174.525 262.07 173.721C262.07 173.721 262.674 173.549 263.248 173.229C263.287 173.209 263.324 173.192 263.362 173.172C263.421 175.41 263.599 177.645 263.916 179.856C264.072 181.147 264.443 182.475 264.69 183.751C264.723 183.913 264.693 184.001 264.611 184.151C264.502 184.374 264.497 184.542 264.705 184.743C265.139 185.179 265.274 185.686 265.042 186.272C265.026 186.321 265.044 186.436 265.077 186.458C265.437 186.694 265.598 187.048 265.715 187.448C265.928 188.147 266.121 188.85 266.377 189.536C266.516 189.854 266.507 190.153 266.419 190.462C266.352 190.697 266.438 190.947 266.649 191.094ZM225.169 158.594C225.458 158.48 225.75 158.365 226.065 158.24C226.788 157.527 227.518 156.804 228.249 156.082C229.494 154.768 230.739 153.453 232.004 152.146L233.062 151.013C233.541 150.518 234.041 150.042 234.541 149.568L234.6 149.644C235.384 149.031 236.3 148.509 237.308 148.158C237.481 148.079 237.638 147.84 237.828 147.781C238.06 147.709 238.314 147.857 238.547 147.818C239.674 147.593 240.863 147.566 241.997 147.777C242.131 147.804 242.268 147.941 242.398 147.968C242.531 147.991 242.66 147.918 242.788 147.962C243.416 148.124 243.996 148.392 244.541 148.679C245.381 149.136 246.156 149.789 246.691 150.581C246.791 150.718 247.053 150.801 247.148 150.958C247.257 151.155 247.123 151.423 247.21 151.614C247.552 152.606 247.542 153.673 247.24 154.735C247.196 154.86 247.042 154.975 247 155.098C246.956 155.219 247.021 155.356 246.974 155.48C246.708 156.065 246.4 156.637 246.027 157.172C245.48 158.027 244.736 158.84 243.937 159.648C243.777 159.794 243.736 160.104 243.574 160.247C243.377 160.423 243.058 160.434 242.859 160.61C241.89 161.467 240.908 162.336 239.933 163.197C239.818 163.299 239.609 163.343 239.494 163.445C239.38 163.549 239.357 163.705 239.242 163.804C238.689 164.288 238.14 164.769 237.601 165.24V165.242C236.558 166.129 235.443 167.076 234.478 167.896C234.371 167.812 234.217 167.691 234.066 167.57L233.955 167.478L233.852 167.386C233.822 167.353 233.79 167.322 233.763 167.294L233.725 167.249L233.693 167.206L233.673 167.183L233.645 167.162L233.611 167.142L233.572 167.121C233.515 167.1 233.449 167.072 233.383 167.047L233.285 167.01C233.254 166.996 233.224 166.985 233.196 166.971L233.158 166.951L233.125 166.931L233.1 166.91L233.09 166.898L233.082 166.886C233.055 166.845 233.021 166.794 232.986 166.74C232.947 166.689 232.906 166.633 232.867 166.578C232.825 166.525 232.785 166.476 232.75 166.433C232.732 166.413 232.715 166.394 232.701 166.378C232.685 166.362 232.672 166.351 232.66 166.341C232.553 166.253 232.464 166.183 232.39 166.124C232.315 166.067 232.255 166.022 232.205 165.985C232.153 165.95 232.112 165.923 232.077 165.899C232.041 165.878 232.011 165.858 231.979 165.84C231.948 165.82 231.917 165.803 231.879 165.779C231.844 165.756 231.803 165.728 231.752 165.695C231.701 165.658 231.643 165.613 231.566 165.556C231.494 165.497 231.404 165.427 231.296 165.339C230.607 164.771 229.884 164.173 229.144 163.562C229.01 163.453 228.728 163.484 228.595 163.373C228.433 163.236 228.417 162.959 228.253 162.822C227.46 162.156 226.657 161.48 225.86 160.809C225.764 160.731 225.719 160.555 225.626 160.475C225.531 160.397 225.39 160.412 225.298 160.331C225.005 160.082 224.718 159.838 224.431 159.592C224.49 159.543 224.562 159.496 224.66 159.455C225.184 159.23 225.377 159.016 225.314 158.807C225.294 158.735 225.214 158.668 225.169 158.594ZM219.913 127.852C220.04 127.589 220.188 127.35 220.468 127.223C221.099 126.914 221.762 126.663 222.393 126.44C222.63 126.52 222.821 126.571 223.021 126.655C223.083 126.643 223.15 126.633 223.217 126.614C223.349 126.577 223.482 126.526 223.616 126.503C223.975 126.446 224.237 126.202 224.471 125.858C224.657 125.946 224.84 126.032 225.055 126.133C226.709 125.773 228.463 125.648 230.186 125.86C230.628 125.893 230.618 125.921 231.215 125.622C231.309 125.724 231.413 125.81 231.496 125.915C231.638 126.112 231.828 126.126 232.049 126.063C232.19 126.016 232.328 125.946 232.475 125.887C232.598 126.054 232.723 126.222 232.877 126.432C237.147 127.721 240.467 130.974 242.197 135.118C242.256 135.247 242.23 135.335 242.166 135.49C242.078 135.717 242.086 135.858 242.306 135.985C242.782 136.258 242.894 136.738 242.621 137.29C242.601 137.337 242.609 137.436 242.641 137.452C242.975 137.624 243.112 137.934 243.194 138.288C243.286 138.915 243.426 139.534 243.507 140.166C243.524 140.299 243.506 140.422 243.475 140.542C243.332 140.604 243.19 140.667 243.047 140.726C242.507 140.956 241.965 141.176 241.463 141.48C240.436 142.042 239.412 142.601 238.47 143.301C237.991 143.638 237.494 143.953 237.026 144.31C236.571 144.683 236.112 145.058 235.651 145.435C235.533 145.529 235.44 145.542 235.264 145.543C235.008 145.554 234.862 145.624 234.813 145.869C234.698 146.382 234.336 146.695 233.673 146.784C233.619 146.795 233.529 146.858 233.529 146.892C233.539 147.132 233.447 147.327 233.306 147.508C233.227 147.566 233.151 147.612 233.07 147.674L233.111 147.726C233.091 147.745 233.074 147.764 233.053 147.784C232.564 148.239 232.081 148.698 231.613 149.165C231.39 149.382 231.099 149.51 230.743 149.598C230.473 149.661 230.29 149.832 230.295 150.032C230.309 150.281 230.299 150.511 230.068 150.739C229.88 150.931 229.691 151.125 229.51 151.308C229.183 151.65 228.872 151.982 228.548 152.297C228.224 152.415 227.952 152.513 227.675 152.612C227.624 152.661 227.571 152.714 227.515 152.767C227.416 152.875 227.329 152.991 227.216 153.096C226.905 153.376 226.862 153.657 226.984 153.924C226.724 154.037 226.466 154.149 226.167 154.278C224.949 155.648 223.766 156.942 222.572 158.232C222.267 158.56 222.252 158.567 222.337 158.924C222.176 159.012 222.011 159.104 221.858 159.188C221.56 159.334 221.448 159.479 221.443 159.614C221.446 159.695 221.497 159.783 221.526 159.873C221.299 160.022 221.071 160.171 220.787 160.356C220.633 160.594 220.489 160.84 220.358 161.092C220.104 161.135 219.85 161.177 219.612 161.258C219.339 161.184 219.112 161.122 218.88 161.059C218.806 161.078 218.728 161.096 218.648 161.116L218.179 161.269C218.045 161.303 217.925 161.352 217.818 161.415C217.57 161.557 217.449 161.74 217.316 161.984C217.108 161.931 216.902 161.88 216.662 161.822C214.994 162.355 213.252 162.75 211.502 162.91C211.057 162.941 211.06 162.949 210.564 163.348C210.445 163.272 210.318 163.211 210.208 163.129C210.014 162.977 209.824 162.99 209.631 163.104C209.508 163.182 209.395 163.292 209.271 163.374C209.104 163.245 208.937 163.116 208.729 162.956C206.504 162.847 204.393 162.286 202.477 161.326C200.584 160.334 198.875 158.924 197.643 157.092C197.565 156.976 197.568 156.895 197.602 156.746C197.635 156.533 197.614 156.399 197.373 156.305C197.069 156.192 196.903 155.987 196.837 155.74C197.091 153.466 196.735 151.163 195.95 149.047C195.987 148.907 196.033 148.771 196.091 148.643C196.763 149.223 197.491 149.946 198.157 150.492C198.229 150.505 198.29 150.527 198.352 150.532C198.491 150.531 198.623 150.531 198.76 150.531C198.796 150.65 198.856 150.76 198.867 150.888C198.884 151.035 198.933 151.136 199.039 151.221C200.85 152.714 201.853 153.475 203.516 154.891L203.514 154.893C204.016 155.328 204.599 155.833 205.213 156.367L205.231 156.385L205.249 156.406C205.261 156.422 205.274 156.44 205.288 156.46C205.313 156.501 205.343 156.547 205.371 156.594C205.399 156.641 205.429 156.688 205.454 156.729C205.468 156.749 205.481 156.766 205.493 156.783L205.511 156.805L205.529 156.822C205.556 156.843 205.582 156.862 205.605 156.88L205.677 156.923L205.748 156.956L205.817 156.983L205.887 157.01L205.957 157.043L206.03 157.086C206.054 157.106 206.079 157.125 206.106 157.146L206.418 157.418C206.711 157.672 206.988 157.914 207.244 158.135C207.482 158.335 207.699 158.518 207.887 158.675L207.897 158.682L207.908 158.684L207.92 158.685L207.933 158.683L207.947 158.678L207.959 158.668L207.991 158.648C208.011 158.641 208.034 158.633 208.059 158.626L208.134 158.593C208.186 158.568 208.24 158.541 208.289 158.518L208.326 158.502L208.361 158.49L208.394 158.484L208.425 158.483L208.448 158.484L208.47 158.48L208.492 158.472L208.515 158.462L208.562 158.435L208.609 158.402L208.658 158.371L208.709 158.344L208.736 158.333L208.763 158.326L208.792 158.322L208.821 158.324C208.83 158.291 208.838 158.262 208.844 158.232C208.856 158.203 208.865 158.175 208.875 158.15L208.91 158.083L208.949 158.028L208.992 157.985L209.039 157.951L209.088 157.926L209.138 157.905L209.242 157.877L209.349 157.851L209.403 157.835L209.455 157.815L209.506 157.789L209.555 157.756L209.709 157.635L209.783 157.571L209.854 157.503L209.859 157.495L209.863 157.487L209.869 157.467L209.875 157.446L209.883 157.428L209.926 157.364L209.961 157.295L209.977 157.258L209.989 157.218L209.997 157.177L210.001 157.132L210.005 157.068L210.016 157.013L210.032 156.968L210.043 156.948L210.054 156.93L210.067 156.914L210.082 156.9L210.099 156.888L210.117 156.878L210.136 156.87L210.157 156.865L210.204 156.859C210.329 156.852 210.423 156.848 210.497 156.844C210.534 156.84 210.565 156.836 210.595 156.833C210.623 156.827 210.648 156.822 210.671 156.818L210.704 156.807L210.733 156.794L210.792 156.761C210.812 156.747 210.831 156.734 210.853 156.716C210.875 156.698 210.899 156.679 210.925 156.656L211 156.594L211.077 156.535L211.231 156.42L211.303 156.358L211.369 156.288L211.398 156.25L211.425 156.21L211.448 156.166L211.469 156.119C211.474 156.112 211.48 156.1 211.488 156.088C211.497 156.075 211.509 156.06 211.522 156.042C211.551 156.01 211.588 155.968 211.63 155.92C211.674 155.874 211.725 155.822 211.777 155.768C211.833 155.715 211.89 155.66 211.949 155.604L212.13 155.445C212.192 155.397 212.25 155.351 212.303 155.309C212.33 155.289 212.357 155.271 212.381 155.254C212.406 155.239 212.43 155.225 212.451 155.212C212.474 155.201 212.495 155.192 212.513 155.184L212.539 155.175L212.562 155.172C212.648 155.107 212.716 155.054 212.806 154.985C213.716 154.305 214.773 153.435 215.626 152.688C215.659 152.61 215.699 152.547 215.72 152.479C215.754 152.331 215.786 152.186 215.821 152.04C215.959 152.009 216.092 151.952 216.234 151.947C216.398 151.938 216.52 151.891 216.638 151.783C217.669 150.835 218.466 150.177 219.221 149.384C219.986 148.597 220.673 147.747 221.443 146.57C222.089 145.545 222.806 144.125 222.982 142.798C222.966 142.706 222.954 142.62 222.92 142.545C222.851 142.389 222.767 142.244 222.692 142.1C222.77 141.965 222.829 141.811 222.925 141.688C223.024 141.542 223.063 141.395 223.053 141.206C222.959 139.554 222.434 138.337 221.782 137.33C221.114 136.322 220.3 135.466 219.12 134.632C218.099 133.917 216.731 133.179 215.495 132.886C215.405 132.898 215.323 132.902 215.247 132.925C215.093 132.976 214.946 133.044 214.798 133.101C214.679 133.009 214.542 132.931 214.437 132.824C214.314 132.705 214.183 132.644 214.005 132.625C213.553 132.577 213.134 132.563 212.732 132.566C213.218 132.144 213.701 131.722 214.195 131.302H214.196C214.317 131.208 214.404 131.202 214.566 131.216C214.801 131.228 214.941 131.168 215.017 130.904C215.183 130.334 215.611 130.073 216.205 130.095C216.254 130.098 216.346 130.057 216.352 130.022C216.417 129.646 216.67 129.416 216.976 129.214C217.503 128.846 218.045 128.517 218.596 128.195C218.853 128.036 219.118 128.02 219.395 128.089C219.603 128.137 219.808 128.063 219.913 127.852ZM197.073 146.935C197.093 146.936 197.128 146.922 197.151 146.919L197.077 147.008C197.073 146.981 197.079 146.963 197.073 146.935ZM220.224 139.78C220.566 140.753 220.607 141.821 220.365 142.862C220.347 142.987 220.202 143.106 220.159 143.224C220.121 143.344 220.187 143.472 220.146 143.594C219.943 144.174 219.65 144.732 219.324 145.265C218.8 146.09 218.166 146.933 217.378 147.703C217.25 147.848 217.23 148.157 217.065 148.293C216.873 148.463 216.561 148.467 216.368 148.637C215.429 149.463 214.477 150.299 213.532 151.128C213.421 151.227 213.219 151.265 213.107 151.363C212.996 151.461 212.973 151.617 212.862 151.713C212.331 152.186 211.797 152.644 211.245 153.048V153.049C210.201 153.832 209.083 154.669 208.116 155.393C208.014 155.313 207.871 155.2 207.727 155.086L207.623 154.998L207.527 154.91L207.443 154.823L207.408 154.781L207.378 154.739L207.369 154.728L207.359 154.717L207.334 154.696L207.301 154.676L207.264 154.658C207.209 154.637 207.147 154.613 207.084 154.59L206.99 154.556C206.961 154.543 206.931 154.532 206.906 154.522L206.869 154.502L206.838 154.483L206.815 154.462L206.805 154.451L206.798 154.44C206.774 154.401 206.742 154.352 206.709 154.3L206.6 154.145C206.561 154.094 206.524 154.047 206.493 154.006C206.475 153.986 206.46 153.969 206.446 153.953C206.43 153.939 206.419 153.928 206.409 153.918C206.305 153.836 206.223 153.769 206.154 153.713C206.083 153.66 206.026 153.617 205.98 153.582C205.931 153.551 205.893 153.525 205.86 153.502C205.825 153.482 205.796 153.465 205.766 153.447C205.736 153.429 205.707 153.412 205.672 153.392C205.639 153.37 205.6 153.344 205.551 153.312C205.504 153.277 205.447 153.235 205.377 153.182C205.309 153.126 205.225 153.06 205.123 152.978C204.403 152.38 203.649 151.753 202.877 151.111C202.736 150.998 202.447 151.021 202.309 150.906C202.139 150.761 202.12 150.479 201.948 150.336C201.12 149.636 200.282 148.928 199.45 148.224C199.35 148.141 199.301 147.961 199.202 147.877C199.104 147.795 198.959 147.807 198.862 147.723C198.479 147.395 198.102 147.073 197.726 146.75C198.332 146.056 198.944 145.348 199.572 144.734C200.198 144.091 200.823 143.441 201.512 142.795C201.855 142.467 201.864 142.473 201.991 141.825C202.134 141.796 202.27 141.75 202.411 141.73C202.665 141.702 202.805 141.551 202.876 141.329C202.917 141.183 202.937 141.03 202.968 140.877C203.183 140.838 203.4 140.799 203.669 140.75C205.204 139.32 206.718 137.926 208.241 136.544L208.301 136.615C208.995 136.022 209.864 135.57 210.833 135.324C211.007 135.285 211.165 135.03 211.351 134.997C211.581 134.968 211.807 135.141 212.028 135.112C213.121 135.023 214.261 135.163 215.331 135.498C215.461 135.529 215.573 135.691 215.695 135.736C215.818 135.781 215.953 135.722 216.076 135.769C216.65 136.031 217.217 136.308 217.703 136.675C218.484 137.207 219.211 137.898 219.719 138.731C219.803 138.88 220.08 138.959 220.17 139.119C220.257 139.328 220.14 139.586 220.224 139.78ZM193.699 111.947C193.827 111.881 193.962 111.822 194.098 111.776C194.469 111.667 194.7 111.403 194.866 111.038C195.082 111.083 195.288 111.104 195.531 111.173C197.173 110.576 198.937 110.198 200.721 110.111C201.178 110.097 201.172 110.107 201.705 109.71C201.822 109.797 201.947 109.867 202.054 109.959C202.241 110.127 202.436 110.129 202.642 110.031C202.774 109.96 202.897 109.867 203.032 109.783C203.199 109.906 203.36 110.057 203.555 110.241C208.11 110.892 212.051 113.336 214.971 117.072C215.061 117.192 215.067 117.279 215.047 117.437C215.029 117.668 215.083 117.803 215.348 117.884C215.92 118.055 216.127 118.532 216.054 119.099C216.05 119.147 216.091 119.24 216.127 119.249C216.529 119.34 216.735 119.624 216.916 119.952C217.244 120.518 217.541 121.1 217.828 121.694C217.968 121.971 217.976 122.235 217.869 122.512C217.79 122.718 217.861 122.93 218.068 123.061C218.33 123.221 218.566 123.399 218.677 123.694C218.847 124.216 219.029 124.736 219.187 125.25C219.013 125.334 218.837 125.415 218.667 125.503C216.971 126.393 215.298 127.45 213.868 128.586C213.686 128.726 213.497 128.855 213.325 129.009C213.227 129.103 212.759 129.298 212.645 129.353C212.53 129.38 212.51 129.469 212.389 129.483C212.123 129.513 211.995 129.629 211.924 129.902C211.842 130.203 211.74 130.476 211.483 130.675C211.18 130.911 210.896 131.163 210.608 131.407C210.553 131.452 210.482 131.491 210.411 131.506C210.263 131.533 210.089 131.505 209.964 131.572C209.753 131.686 209.831 131.974 209.702 132.134C209.37 132.548 208.942 132.864 208.542 133.206C208.429 133.304 208.276 133.321 208.121 133.342C207.803 133.384 207.79 133.39 207.725 133.72C207.657 134.073 207.427 134.214 207.094 134.247C206.946 134.263 206.8 134.296 206.623 134.326C205.34 135.472 204.037 136.632 202.766 137.815C202.704 138.047 202.67 138.278 202.588 138.487C202.504 138.7 202.208 138.521 202.045 138.676C201.992 138.731 201.928 138.776 201.88 138.833C201.666 139.079 201.463 139.429 201.16 139.482C200.764 139.566 200.505 139.832 200.379 140.216C200.33 140.358 200.318 140.515 200.287 140.662C200.066 140.704 199.844 140.747 199.603 140.793C198.734 141.607 197.861 142.532 196.99 143.421C196.499 143.924 196.082 144.441 195.623 144.95L195.287 145.333C195.113 145.551 195.039 145.672 194.912 145.847C194.808 145.982 194.721 146.125 194.635 146.271C194.625 146.274 194.615 146.277 194.608 146.281C193.735 144.837 192.67 143.513 191.409 142.39C191.212 142.221 191.023 142.04 190.813 141.884C190.696 141.788 190.322 141.356 190.221 141.251C190.153 141.136 190.055 141.135 189.997 141.01C189.875 140.732 189.694 140.632 189.381 140.635C189.031 140.64 188.731 140.599 188.4 140.425C188.01 140.226 187.629 140.019 187.21 139.874C187.132 139.844 187.052 139.795 186.993 139.735C186.985 139.727 186.979 139.715 186.972 139.708C186.974 139.706 186.974 139.704 186.975 139.702C186.984 139.688 186.995 139.673 187.007 139.654C187.034 139.618 187.069 139.573 187.111 139.521C187.153 139.471 187.201 139.415 187.252 139.356C187.306 139.297 187.361 139.237 187.418 139.176L187.594 139C187.653 138.945 187.709 138.895 187.762 138.848L187.838 138.786C187.863 138.768 187.887 138.752 187.908 138.738C187.929 138.724 187.951 138.714 187.969 138.704L187.994 138.693L188.017 138.688C188.101 138.615 188.167 138.556 188.255 138.48C189.016 137.786 190.034 137.017 190.8 136.312C190.827 136.238 190.862 136.179 190.878 136.114C190.903 135.972 190.927 135.835 190.952 135.694C191.083 135.668 191.208 135.617 191.343 135.617C191.501 135.613 191.614 135.57 191.724 135.471C192.662 134.6 193.382 133.932 194.087 133.279C194.782 132.497 195.525 131.776 196.214 130.635C196.84 129.686 197.491 128.379 197.739 127.209C197.723 127.123 197.721 127.047 197.7 126.979C197.659 126.836 197.585 126.7 197.509 126.559C197.589 126.446 197.648 126.311 197.749 126.21C197.864 126.09 197.923 125.966 197.937 125.798C198.062 124.336 197.826 123.207 197.531 122.157C197.395 121.627 197.128 121.145 196.918 120.613C196.676 120.095 196.316 119.599 195.967 119.019C195.571 118.589 195.201 118.036 194.721 117.585C194.225 117.155 193.76 116.662 193.219 116.399C193.129 116.389 193.055 116.37 192.98 116.37C192.825 116.374 192.672 116.395 192.522 116.408C192.446 116.284 192.344 116.175 192.287 116.036C192.222 115.87 192.114 115.794 191.958 115.733C190.608 115.17 189.495 114.977 188.427 114.899C188.388 114.899 188.348 114.897 188.308 114.895C188.554 114.694 188.804 114.494 189.066 114.302C189.317 114.105 189.595 114.047 189.898 114.069C190.127 114.089 190.318 113.95 190.4 113.729C190.5 113.452 190.62 113.196 190.898 113.03C191.212 112.833 191.527 112.635 191.839 112.44C192.158 112.262 192.48 112.096 192.796 111.942C193.06 111.975 193.28 112.002 193.505 112.03C193.566 112.006 193.632 111.977 193.699 111.947ZM186.579 136.64C185.623 137.461 184.618 138.326 183.712 139.104C183.679 139.083 183.644 139.065 183.608 139.043L183.559 139.011L183.536 138.996L183.524 138.99L183.522 138.988L183.52 138.986L183.44 138.988L183.434 138.984C183.413 138.974 183.396 138.966 183.377 138.959C183.375 138.953 183.373 138.947 183.371 138.942C183.359 138.912 183.348 138.882 183.338 138.856C183.324 138.83 183.312 138.806 183.301 138.785L183.285 138.752L183.277 138.737L183.267 138.725L183.257 138.716L183.247 138.708L183.235 138.705L183.221 138.704C183.077 138.712 182.92 138.72 182.756 138.727L182.744 138.717L182.706 138.672L182.674 138.629L182.653 138.607L182.626 138.586L182.592 138.565L182.553 138.545C182.495 138.524 182.43 138.497 182.364 138.471L182.265 138.436C182.234 138.422 182.203 138.41 182.176 138.398L182.137 138.378L182.106 138.357L182.079 138.336L182.069 138.325L182.061 138.314C182.034 138.273 182 138.222 181.963 138.168C181.925 138.116 181.883 138.06 181.844 138.006C181.801 137.954 181.762 137.904 181.727 137.862C181.708 137.841 181.692 137.823 181.676 137.807C181.66 137.792 181.647 137.78 181.637 137.77C181.528 137.684 181.438 137.614 181.366 137.555C181.29 137.498 181.229 137.454 181.18 137.418C181.127 137.383 181.087 137.356 181.051 137.333C181.015 137.311 180.984 137.293 180.952 137.274C180.92 137.255 180.89 137.238 180.853 137.215C180.817 137.192 180.776 137.165 180.724 137.13C180.675 137.094 180.615 137.05 180.538 136.994C180.464 136.935 180.376 136.865 180.267 136.778H180.266C179.47 136.129 178.636 135.448 177.781 134.749C177.627 134.626 177.321 134.64 177.168 134.513C176.98 134.358 176.941 134.062 176.752 133.906C175.836 133.146 174.906 132.376 173.984 131.611C173.875 131.521 173.81 131.332 173.701 131.242C173.592 131.151 173.439 131.158 173.332 131.067C173.082 130.856 172.835 130.65 172.586 130.441C172.752 130.246 172.777 130.13 172.856 129.611C173.001 129.569 173.139 129.51 173.282 129.478C173.54 129.427 173.678 129.261 173.741 129.031C173.774 128.879 173.784 128.72 173.805 128.562C174.022 128.5 174.24 128.439 174.51 128.364C178.026 124.863 181.354 121.55 184.877 118.04C184.99 117.932 185.078 117.914 185.243 117.908C185.482 117.89 185.617 117.812 185.671 117.537C185.672 117.531 185.676 117.527 185.676 117.521C186.069 117.472 186.465 117.423 186.87 117.373C187.342 117.322 187.814 117.393 188.298 117.391C188.472 117.381 188.694 117.209 188.865 117.253C189.078 117.298 189.226 117.535 189.433 117.576C190.449 117.767 191.378 118.25 192.241 118.793C192.334 118.873 192.381 119.05 192.47 119.125C192.561 119.201 192.699 119.184 192.79 119.262C193.267 119.596 193.573 120.094 193.958 120.499C194.181 120.873 194.446 121.236 194.656 121.639C194.805 122.069 195.063 122.47 195.147 122.934C195.187 123.096 195.43 123.238 195.471 123.409C195.516 123.62 195.383 123.831 195.379 124.041C195.394 124.547 195.496 125.056 195.399 125.565L195.325 126.331L195.12 127.076C195.088 127.194 194.95 127.304 194.92 127.419C194.892 127.534 194.966 127.663 194.905 127.772C194.625 128.289 194.473 128.859 194.097 129.314C193.649 130.102 192.998 130.793 192.299 131.524C192.155 131.656 192.129 131.955 191.985 132.086C191.805 132.247 191.506 132.242 191.326 132.404C190.45 133.187 189.563 133.981 188.683 134.769C188.579 134.862 188.383 134.896 188.28 134.99C188.176 135.083 188.161 135.233 188.057 135.324C187.557 135.765 187.061 136.205 186.573 136.636L186.579 136.64ZM184.19 154.319L184.194 154.364L184.202 154.403L184.214 154.434C184.23 154.469 184.245 154.509 184.263 154.551C184.278 154.594 184.292 154.641 184.308 154.689C184.331 154.788 184.358 154.893 184.384 155C184.427 155.216 184.47 155.431 184.501 155.583H184.499L184.419 155.633H184.417L184.413 155.635L184.405 155.637L184.387 155.642L184.355 155.651L184.29 155.671L184.157 155.71L183.887 155.788C183.705 155.843 183.523 155.896 183.336 155.951C182.965 156.06 182.584 156.173 182.201 156.285C181.42 156.472 180.625 156.661 179.857 156.844V156.845C178.712 157.133 177.252 157.245 176.079 157.464C176.006 157.514 175.934 157.546 175.877 157.595C175.762 157.706 175.65 157.812 175.535 157.921C175.394 157.876 175.245 157.857 175.117 157.786C174.969 157.707 174.836 157.684 174.67 157.716C171.76 158.069 170.162 158.523 167.627 158.411C166.516 158.362 165.212 158.007 164.215 157.649C164.135 157.659 164.065 157.654 163.996 157.669C163.85 157.709 163.711 157.747 163.565 157.787C163.478 157.684 163.385 157.573 163.332 157.448C163.269 157.302 163.189 157.211 163.055 157.147C161.918 156.548 161.194 155.885 160.627 155.151C160.072 154.41 159.658 153.573 159.481 152.431C159.301 151.436 159.574 150.192 159.922 149.237C159.912 149.16 159.916 149.092 159.901 149.026C159.861 148.882 159.822 148.745 159.782 148.602C159.889 148.522 159.997 148.428 160.124 148.377C160.27 148.316 160.36 148.238 160.425 148.106C161.039 146.981 161.744 146.227 162.483 145.561C163.224 144.89 164.054 144.325 165.209 143.777C166.111 143.308 167.316 142.996 168.359 142.736C169.478 142.619 170.602 142.507 171.731 142.436C172.207 142.403 172.255 142.395 172.709 142.05C172.769 142.045 172.826 142.039 172.885 142.035C172.993 142.082 173.104 142.127 173.203 142.182C173.433 142.321 173.652 142.294 173.863 142.167C173.972 142.093 174.072 142.005 174.177 141.92C174.224 141.915 174.273 141.911 174.32 141.907C174.502 141.999 174.685 142.091 174.912 142.204C177.09 142.028 179.216 141.854 181.338 141.683L181.346 141.716L181.405 141.95C181.444 142.107 181.485 142.267 181.525 142.429C181.607 142.753 181.692 143.083 181.776 143.417C181.943 144.085 182.113 144.767 182.277 145.423H182.278C182.405 145.954 182.45 146.633 182.585 147.168C182.63 147.196 182.657 147.226 182.7 147.246L182.998 147.362C182.944 147.436 182.916 147.512 182.839 147.584C182.753 147.667 182.722 147.735 182.743 147.812C183.067 149.13 183.294 149.824 183.561 151.058H183.559C183.59 151.212 183.618 151.338 183.639 151.443C183.657 151.548 183.672 151.631 183.684 151.701C183.693 151.769 183.7 151.824 183.705 151.873C183.709 151.921 183.713 151.961 183.717 152.002C183.721 152.043 183.723 152.084 183.728 152.133C183.735 152.18 183.741 152.235 183.75 152.305C183.762 152.373 183.777 152.457 183.795 152.562C183.817 152.666 183.844 152.791 183.876 152.946C183.881 152.963 183.887 152.983 183.893 153.007C183.901 153.03 183.911 153.056 183.921 153.085C183.945 153.143 183.973 153.209 184.002 153.278C184.034 153.346 184.067 153.417 184.099 153.483C184.133 153.548 184.164 153.608 184.19 153.657L184.197 153.672L184.203 153.689L184.212 153.726L184.216 153.769L184.218 153.817C184.216 153.851 184.216 153.888 184.214 153.925L184.204 154.042C184.2 154.122 184.195 154.2 184.19 154.27V154.319ZM148.987 131.419C148.841 131.401 148.694 131.389 148.548 131.361C148.321 131.313 148.188 131.173 148.128 130.922C148.097 130.785 148.066 130.647 148.032 130.506C147.884 130.488 147.731 130.487 147.589 130.444C147.368 130.382 147.211 130.248 147.172 130.004C147.151 129.865 147.11 129.731 147.079 129.594C146.931 129.572 146.774 129.572 146.64 129.514C146.298 129.369 146.025 129.139 145.945 128.747C145.92 128.601 145.894 128.457 145.861 128.268C145.64 128.031 145.396 127.767 145.151 127.503C145.054 127.396 144.957 127.285 144.845 127.191C144.741 127.101 144.601 127.052 144.442 127.053C144.254 127.056 144.16 126.992 144.132 126.849C144.027 126.309 144.043 126.295 143.825 126.066C143.63 125.863 143.492 125.593 143.21 125.48C143.075 125.427 142.919 125.419 142.78 125.37C142.735 125.353 142.706 125.273 142.692 125.213C142.659 125.081 142.637 124.949 142.62 124.813C142.477 124.776 142.337 124.741 142.175 124.7C142.154 124.497 142.13 124.29 142.103 124.045C141.344 123.125 140.615 122.148 139.937 121.159C139.867 121.119 139.812 121.072 139.746 121.046C139.607 120.995 139.472 120.944 139.334 120.895C139.322 120.759 139.289 120.626 139.309 120.49C139.327 120.335 139.301 120.214 139.222 120.084C137.895 117.982 136.823 115.748 136.175 113.41C135.514 111.074 135.39 108.632 135.676 106.215C135.738 105.852 135.894 105.573 136.177 105.334C136.27 105.257 136.305 105.156 136.301 105.045C136.33 105.031 136.36 105.022 136.389 105.005C136.519 104.919 136.635 104.813 136.76 104.714C136.963 104.817 137.172 104.943 137.428 105.043C142.5 104.488 147.171 102.981 151.703 100.688C152.447 100.334 153.187 99.9386 153.92 99.5156C153.928 99.6406 153.937 99.7656 153.957 99.8886C153.984 100.057 153.957 100.198 153.889 100.351C153.63 100.952 153.674 100.955 153.784 101.498C153.895 102.051 153.929 102.057 154.37 102.498C154.417 102.539 154.458 102.621 154.456 102.678C154.38 103.512 154.416 103.498 154.538 103.828C154.722 104.313 154.942 104.771 155.167 105.226C155.081 105.439 154.896 105.548 154.636 105.589C154.489 105.615 154.346 105.657 154.172 105.698C152.958 106.874 151.825 108.125 150.691 109.362C150.653 109.592 150.642 109.82 150.582 110.03C150.52 110.243 150.211 110.087 150.066 110.25C150.019 110.308 149.961 110.354 149.919 110.415C149.732 110.668 149.566 111.024 149.273 111.095C148.889 111.197 148.657 111.466 148.563 111.847C148.528 111.988 148.528 112.141 148.508 112.287C148.293 112.338 148.078 112.39 147.846 112.444C147.453 112.871 147.057 113.301 146.659 113.732C146.547 113.862 146.49 113.898 146.332 114.104L146.029 114.508C145.838 114.785 145.611 115.031 145.462 115.344C144.666 116.645 144.217 118.213 144.248 119.748C144.264 121.287 144.689 122.754 145.314 124.061C146.15 125.817 147.334 127.33 148.679 128.623C148.851 128.782 149.013 128.951 149.197 129.098C149.31 129.176 149.586 129.628 149.674 129.716C149.725 129.822 149.817 129.826 149.855 129.943C149.941 130.203 150.084 130.308 150.367 130.325C150.675 130.351 150.968 130.379 151.229 130.578C151.541 130.803 151.848 131.035 152.178 131.23C152.239 131.269 152.298 131.325 152.334 131.388C152.408 131.522 152.438 131.697 152.543 131.796C152.723 131.966 152.971 131.802 153.164 131.874C153.68 132.032 154.131 132.323 154.607 132.562C154.744 132.624 154.825 132.755 154.91 132.89C155.086 133.163 155.099 133.173 155.428 133.095C155.776 133.017 156.008 133.146 156.197 133.425C156.284 133.548 156.384 133.662 156.499 133.806C158.165 134.406 159.927 134.821 161.716 134.999C161.938 134.888 162.135 134.757 162.347 134.675C162.56 134.591 162.638 134.933 162.87 134.945C162.949 134.941 163.028 134.953 163.106 134.943C163.442 134.909 163.836 134.789 164.106 134.957C164.467 135.182 164.859 135.11 165.21 134.899C165.339 134.819 165.448 134.705 165.567 134.61C165.772 134.721 165.979 134.812 166.21 134.907C166.729 134.819 167.249 134.726 167.765 134.594C167.759 135.446 167.863 136.282 168.042 137.076C168.267 138.06 168.599 138.997 168.997 139.896C168.56 139.939 168.124 139.982 167.688 140.027L159.424 140.853C157.799 139.554 156.181 138.244 154.598 136.9C153.25 135.761 151.924 134.601 150.618 133.423C150.456 133.273 150.306 133.111 150.132 132.974C150.027 132.896 149.771 132.475 149.704 132.378C149.569 132.183 149.675 132.286 149.655 132.03C149.106 131.957 149.099 131.961 148.987 131.419ZM179.061 139.031C178.306 139.094 177.583 139.155 176.96 139.208C175.769 139.3 174.521 139.396 173.241 139.493C173.175 139.499 173.107 139.522 173.04 139.552C172.872 139.575 172.708 139.63 172.548 139.726C172.538 139.732 172.528 139.743 172.518 139.749C172.244 139.759 171.976 139.589 171.699 139.608C171.641 139.611 171.582 139.62 171.524 139.624C171.431 139.544 171.345 139.458 171.287 139.335C171.145 139.005 171.004 138.673 170.863 138.347C170.742 138.015 170.631 137.685 170.531 137.361C170.627 137.121 170.705 136.919 170.787 136.713C170.776 136.651 170.767 136.585 170.751 136.519C170.712 136.387 170.684 136.256 170.676 136.123C170.662 135.768 170.453 135.507 170.18 135.263C170.287 135.092 170.395 134.922 170.518 134.727C170.523 133.95 170.651 133.207 170.932 132.563C170.961 132.509 170.987 132.452 171.012 132.395C171.594 132.915 172.196 133.471 172.752 133.92C172.83 133.936 172.895 133.963 172.963 133.969C173.108 133.975 173.248 133.979 173.394 133.984C173.439 134.11 173.508 134.225 173.528 134.36C173.555 134.514 173.614 134.622 173.729 134.714C175.733 136.339 176.84 137.169 178.682 138.708V138.71C178.798 138.807 178.935 138.923 179.061 139.031ZM163.243 100.934C163.292 100.934 163.378 100.886 163.381 100.851C163.409 100.475 163.636 100.227 163.917 100.008C164.396 99.6096 164.903 99.2366 165.425 98.8666C165.665 98.6856 165.931 98.6446 166.22 98.6826C166.433 98.7056 166.632 98.6106 166.711 98.3966C166.806 98.1276 166.923 97.8796 167.188 97.7296C167.785 97.3656 168.41 97.0516 169.009 96.7706C169.265 96.8216 169.468 96.8426 169.683 96.9016C169.744 96.8826 169.808 96.8656 169.871 96.8406C169.997 96.7906 170.12 96.7286 170.251 96.6906C170.6 96.5966 170.818 96.3386 170.981 95.9836C171.182 96.0456 171.379 96.1066 171.61 96.1766C173.169 95.6456 174.844 95.3226 176.53 95.2846C176.96 95.2626 176.954 95.2676 177.466 94.9146C177.575 94.9986 177.691 95.0646 177.79 95.1536C177.964 95.3166 178.147 95.3136 178.345 95.2106C178.472 95.1326 178.591 95.0596 178.716 94.9806C178.866 95.1206 179.016 95.2606 179.202 95.4366C183.493 96.0016 187.276 98.3256 189.958 101.789C190.047 101.896 190.047 101.98 190.017 102.135C189.984 102.36 190.025 102.489 190.273 102.563C190.81 102.725 191.027 103.144 190.899 103.708C190.892 103.755 190.925 103.845 190.961 103.855C191.331 103.954 191.561 104.207 191.711 104.531C191.969 105.1 192.276 105.643 192.504 106.231C192.623 106.502 192.602 106.768 192.497 107.038C192.424 107.238 192.475 107.45 192.663 107.575C192.902 107.727 193.116 107.897 193.201 108.186C193.289 108.465 193.361 108.748 193.433 109.032C191.777 109.741 190.218 110.636 188.757 111.641C187.202 112.756 185.62 114.024 184.292 115.348C184.122 115.51 183.942 115.663 183.783 115.84C183.694 115.947 183.237 116.201 183.128 116.271C183.128 116.271 183.128 116.272 183.126 116.272C183.014 116.311 183.001 116.399 182.88 116.424C182.612 116.48 182.495 116.605 182.444 116.884C182.386 117.192 182.305 117.474 182.059 117.697L181.225 118.508C181.172 118.559 181.104 118.604 181.032 118.624C180.884 118.664 180.709 118.65 180.587 118.728C180.38 118.86 180.476 119.146 180.354 119.318C180.044 119.765 179.623 120.116 179.226 120.484C179.115 120.588 178.96 120.617 178.802 120.647C178.48 120.709 178.468 120.716 178.413 121.053C178.354 121.412 178.126 121.571 177.79 121.623C177.64 121.648 177.493 121.69 177.315 121.73C176.045 122.939 174.747 124.248 173.461 125.515C173.406 125.751 173.378 125.984 173.301 126.199C173.223 126.417 172.906 126.261 172.743 126.428C172.69 126.488 172.623 126.535 172.578 126.598C172.379 126.866 172.197 127.24 171.893 127.321C171.496 127.436 171.247 127.722 171.14 128.118C171.099 128.264 171.095 128.424 171.072 128.575C170.85 128.634 170.629 128.694 170.387 128.758L169.759 129.44L169.445 129.782C169.277 129.981 169.202 130.103 169.078 130.269C168.838 130.573 168.65 130.906 168.492 131.253C168.44 131.345 168.406 131.442 168.365 131.536C167.549 131.824 166.699 132.042 165.83 132.169C165.414 132.247 165.414 132.212 164.961 132.636C164.842 132.568 164.719 132.517 164.609 132.443C164.418 132.304 164.238 132.335 164.054 132.437C163.939 132.517 163.833 132.617 163.716 132.708C163.551 132.59 163.385 132.473 163.179 132.325C158.878 132.176 154.712 130.606 151.283 127.816C151.173 127.73 151.156 127.647 151.15 127.492C151.131 127.267 151.062 127.152 150.802 127.133C150.228 127.102 149.948 126.715 149.945 126.157C149.941 126.111 149.888 126.033 149.851 126.031C149.451 126.031 149.222 125.799 148.999 125.529C148.798 125.297 148.62 125.05 148.452 124.8C148.28 124.55 148.087 124.312 147.941 124.049C147.792 123.808 147.779 123.55 147.85 123.281C147.914 123.077 147.85 122.89 147.65 122.799C147.409 122.685 147.146 122.556 147.078 122.283C146.872 121.671 146.688 121.054 146.643 120.458C146.779 120.265 146.893 120.103 147.008 119.938C147.008 119.884 147.008 119.827 147.008 119.768C147.018 119.653 147.014 119.536 147.033 119.422C147.084 119.118 146.951 118.859 146.75 118.574C146.895 118.455 147.037 118.338 147.203 118.201C147.326 117.832 147.469 117.463 147.646 117.103C148.154 117.56 148.671 118.035 149.155 118.425C149.232 118.44 149.295 118.464 149.36 118.47C149.503 118.472 149.64 118.474 149.783 118.476C149.824 118.6 149.89 118.712 149.908 118.845C149.93 118.997 149.986 119.101 150.098 119.191C152.032 120.757 153.101 121.556 154.877 123.042L154.876 123.043C155.452 123.531 156.124 124.102 156.831 124.701C156.843 124.713 156.856 124.726 156.872 124.744C156.886 124.762 156.901 124.781 156.919 124.803C156.949 124.848 156.983 124.899 157.019 124.949C157.055 124.999 157.089 125.051 157.121 125.095C157.137 125.116 157.152 125.137 157.166 125.156C157.183 125.172 157.197 125.187 157.209 125.199C157.24 125.222 157.268 125.244 157.295 125.264L157.377 125.314L157.457 125.353L157.534 125.386L157.611 125.419L157.691 125.458L157.773 125.509C157.8 125.53 157.83 125.552 157.861 125.575L158.22 125.881C158.556 126.167 158.876 126.44 159.169 126.689C159.461 126.929 159.726 127.148 159.956 127.337L159.968 127.345L159.98 127.349L159.994 127.351L160.008 127.35L160.024 127.346L160.04 127.34L160.073 127.321C160.094 127.309 160.12 127.294 160.146 127.278L160.225 127.218C160.28 127.174 160.337 127.129 160.389 127.087C160.416 127.068 160.443 127.051 160.466 127.035L160.502 127.017L160.535 127.007L160.56 126.999L160.585 126.987L160.61 126.972L160.633 126.953L160.682 126.908L160.73 126.859L160.78 126.808L160.835 126.763L160.863 126.743L160.893 126.726L160.924 126.713L160.957 126.704C160.962 126.668 160.967 126.633 160.971 126.601C160.979 126.57 160.987 126.54 160.994 126.512L161.022 126.437L161.057 126.375L161.097 126.322L161.142 126.277L161.191 126.24L161.242 126.209L161.351 126.157L161.462 126.108L161.517 126.081L161.57 126.05L161.621 126.014L161.668 125.969L161.817 125.814L161.888 125.734L161.954 125.649L161.959 125.641L161.962 125.632L161.966 125.611L161.97 125.589L161.976 125.569L162.013 125.495L162.042 125.418L162.054 125.377L162.062 125.335L162.065 125.29L162.064 125.244L162.062 125.179L162.066 125.122L162.078 125.071L162.086 125.05L162.096 125.03L162.108 125.01L162.122 124.994L162.138 124.978L162.156 124.964L162.176 124.952L162.197 124.942L162.246 124.926C162.378 124.893 162.476 124.868 162.555 124.849C162.594 124.838 162.627 124.828 162.659 124.819C162.687 124.807 162.714 124.798 162.737 124.788L162.77 124.77L162.801 124.751L162.858 124.705C162.877 124.687 162.895 124.668 162.918 124.646C162.939 124.625 162.962 124.599 162.987 124.571L163.059 124.493L163.133 124.418L163.283 124.27L163.351 124.191L163.413 124.106L163.44 124.061L163.463 124.014L163.484 123.965L163.502 123.912C163.506 123.904 163.511 123.892 163.518 123.877C163.526 123.861 163.538 123.844 163.549 123.823C163.576 123.783 163.611 123.733 163.651 123.676C163.692 123.619 163.74 123.557 163.79 123.49C163.843 123.425 163.899 123.355 163.954 123.287C164.013 123.22 164.071 123.152 164.128 123.088C164.187 123.026 164.243 122.967 164.295 122.913L164.372 122.842C164.397 122.821 164.421 122.802 164.441 122.784C164.463 122.769 164.485 122.756 164.503 122.743L164.528 122.73L164.552 122.721C164.635 122.636 164.702 122.57 164.789 122.482H164.788C165.515 121.718 166.494 120.859 167.225 120.084C167.248 120.008 167.28 119.945 167.292 119.877C167.309 119.731 167.324 119.591 167.342 119.446C167.473 119.41 167.594 119.347 167.732 119.336C167.89 119.32 168.003 119.268 168.106 119.158C169.008 118.198 169.682 117.489 170.362 116.728C171.091 115.89 171.723 114.94 172.195 113.572C172.387 112.976 172.538 112.285 172.604 111.578C172.641 110.872 172.61 110.153 172.454 109.539C172.397 109.465 172.359 109.393 172.307 109.336C172.193 109.222 172.078 109.119 171.953 109.021C171.974 108.876 171.969 108.723 172.015 108.582C172.064 108.418 172.066 108.27 171.995 108.109C171.374 106.713 170.643 105.809 169.876 105.02C169.095 104.243 168.251 103.567 167.062 102.905C166.036 102.341 164.667 101.745 163.441 101.597C163.353 101.621 163.275 101.629 163.207 101.659C163.062 101.721 162.928 101.814 162.791 101.889C162.666 101.813 162.523 101.758 162.41 101.66C162.354 101.611 162.297 101.582 162.236 101.558C162.407 101.164 162.753 100.949 163.243 100.934ZM158.364 105.315C158.696 105.065 159.05 104.841 159.43 104.661C159.573 104.575 159.676 104.321 159.841 104.265C160.043 104.191 160.277 104.312 160.479 104.275C161.449 104.017 162.504 104.005 163.528 104.212C163.649 104.24 163.768 104.381 163.886 104.41C164.004 104.441 164.129 104.359 164.246 104.399C164.808 104.592 165.367 104.801 165.871 105.103C166.678 105.531 167.463 106.111 168.135 106.82C168.266 106.935 168.539 106.965 168.658 107.1C168.806 107.267 168.759 107.546 168.877 107.723C169.481 108.571 169.912 109.542 170.033 110.523C170.047 110.64 169.961 110.789 169.976 110.9C169.98 111.013 170.08 111.1 170.08 111.216C170.096 111.768 169.988 112.306 169.825 112.818C169.578 113.619 169.109 114.417 168.454 115.133C168.329 115.275 168.312 115.581 168.176 115.724C168.006 115.902 167.704 115.921 167.532 116.099C166.697 116.961 165.851 117.835 165.011 118.703C164.911 118.806 164.716 118.855 164.617 118.959C164.518 119.061 164.513 119.214 164.413 119.314C163.936 119.8 163.463 120.285 162.997 120.759L162.999 120.76C161.964 121.79 160.856 122.893 159.897 123.846C159.782 123.755 159.617 123.626 159.454 123.498L159.334 123.399L159.223 123.3C159.189 123.266 159.157 123.235 159.126 123.203L159.084 123.156L159.048 123.11L159.027 123.087L158.998 123.065L158.961 123.042L158.92 123.021C158.859 122.996 158.789 122.967 158.719 122.939L158.615 122.898C158.582 122.882 158.551 122.869 158.521 122.855L158.48 122.834L158.445 122.813L158.418 122.79L158.406 122.778L158.398 122.766C158.367 122.723 158.33 122.67 158.291 122.613C158.248 122.557 158.203 122.499 158.16 122.442C158.113 122.387 158.07 122.335 158.031 122.29C158.011 122.269 157.994 122.249 157.978 122.231C157.96 122.215 157.945 122.202 157.934 122.192C157.817 122.098 157.722 122.023 157.642 121.96C157.562 121.899 157.497 121.853 157.444 121.813C157.388 121.776 157.345 121.747 157.307 121.721C157.268 121.698 157.235 121.677 157.202 121.658C157.168 121.637 157.135 121.617 157.096 121.594C157.059 121.569 157.015 121.539 156.959 121.502C156.906 121.463 156.842 121.415 156.76 121.356C156.682 121.293 156.586 121.217 156.469 121.124H156.468C155.699 120.498 154.895 119.841 154.071 119.167C153.922 119.048 153.623 119.067 153.475 118.945C153.293 118.795 153.261 118.505 153.079 118.353C152.194 117.62 151.298 116.877 150.408 116.139C150.303 116.052 150.243 115.867 150.137 115.78C150.033 115.692 149.883 115.702 149.78 115.614C149.572 115.44 149.369 115.269 149.163 115.096L149.867 114.33C150.184 113.988 150.194 113.992 150.274 113.349C150.414 113.313 150.546 113.26 150.685 113.232C150.934 113.19 151.064 113.034 151.12 112.812C151.147 112.666 151.152 112.513 151.169 112.36C151.379 112.307 151.589 112.254 151.851 112.188C154.011 109.752 156.163 107.543 158.364 105.315ZM104.087 13.1166C104.283 13.0346 104.366 12.9356 104.287 12.6786C104.12 12.1226 104.329 11.7196 104.856 11.5606C104.897 11.5436 104.952 11.4706 104.94 11.4346C104.815 11.0576 104.882 10.7256 105.073 10.4406C105.375 9.92057 105.682 9.40856 106.036 8.91756C106.192 8.67856 106.421 8.57056 106.718 8.55656C106.936 8.54256 107.079 8.39657 107.082 8.16357C107.081 7.87257 107.101 7.58857 107.321 7.39857L108.04 6.71156C108.296 6.50456 108.55 6.29957 108.804 6.10957C109.058 6.10957 109.273 6.12156 109.493 6.13857C109.547 6.11157 109.605 6.08156 109.661 6.04656C109.768 5.97656 109.874 5.89356 109.989 5.83356C110.298 5.67156 110.466 5.41356 110.548 5.04656C110.757 5.07356 110.964 5.10357 111.205 5.13557C112.638 4.42157 114.222 3.94657 115.839 3.70357C116.251 3.63257 116.248 3.64956 116.651 3.22556C116.776 3.29356 116.903 3.34456 117.018 3.41656C117.223 3.55756 117.398 3.52357 117.563 3.40257C117.667 3.31856 117.758 3.21657 117.862 3.12157C118.036 3.23457 118.212 3.34956 118.429 3.49156C122.55 3.40756 126.801 4.34957 130.926 5.95757C131.057 6.00957 131.102 6.07857 131.161 6.22157C131.256 6.42557 131.368 6.50257 131.621 6.43957C132.168 6.29757 132.57 6.53957 132.805 7.05556C132.827 7.09656 132.909 7.15057 132.944 7.13757C133.315 6.99157 133.633 7.09856 133.956 7.25556C134.52 7.53056 135.085 7.80657 135.653 8.08257C135.921 8.21257 136.079 8.42857 136.182 8.70457C136.256 8.91257 136.45 9.02356 136.676 8.98656C136.959 8.93756 137.231 8.91456 137.49 9.07056C138.09 9.42556 138.715 9.74456 139.267 10.1176C139.367 10.3556 139.451 10.5556 139.537 10.7586C139.588 10.7956 139.642 10.8386 139.701 10.8756C139.82 10.9476 139.947 11.0126 140.058 11.0966C140.345 11.3326 140.683 11.3716 141.062 11.2946C141.145 11.4896 141.226 11.6826 141.321 11.9066C142.754 12.8446 144.178 13.8616 145.571 14.9226C145.92 15.1976 145.916 15.2076 146.548 15.2236C146.591 15.3566 146.65 15.4806 146.684 15.6126C146.737 15.8506 146.895 15.9616 147.116 15.9936C147.261 16.0076 147.407 16.0036 147.557 16.0086C147.616 16.2096 147.672 16.4116 147.745 16.6636C151.207 19.5076 154.315 22.4336 157.329 25.7966C157.421 25.9056 157.429 25.9896 157.417 26.1466C157.409 26.3736 157.468 26.5026 157.728 26.5586C158.289 26.6776 158.546 27.0726 158.535 27.6426C158.537 27.6896 158.588 27.7746 158.625 27.7796C159.018 27.8186 159.264 28.0486 159.488 28.3326C159.886 28.8266 160.285 29.3176 160.685 29.8126C160.874 30.0446 160.927 30.3096 160.906 30.6056C160.887 30.8286 161.013 31.0136 161.238 31.0746C161.52 31.1446 161.785 31.2306 161.959 31.4826C162.366 32.0516 162.775 32.6246 163.163 33.1686C163.158 33.4286 163.154 33.6456 163.15 33.8676C163.183 33.9226 163.217 33.9826 163.254 34.0436C163.33 34.1586 163.42 34.2716 163.488 34.3936C163.66 34.7246 163.961 34.8936 164.342 34.9716C164.34 35.1846 164.338 35.3956 164.336 35.6396C165.27 37.0796 166.207 38.5626 167.058 40.0906C167.276 40.4796 167.268 40.4856 167.848 40.7446C167.836 40.8836 167.842 41.0186 167.819 41.1546C167.77 41.3966 167.87 41.5606 168.055 41.6796C168.182 41.7496 168.321 41.8006 168.457 41.8656C168.434 42.0716 168.408 42.2786 168.377 42.5376C170.42 46.5086 172.111 50.4166 173.233 54.7386H173.232C173.266 54.8766 173.236 54.9536 173.154 55.0856C173.045 55.2806 173.039 55.4206 173.246 55.5846C173.701 55.9416 173.718 56.4126 173.435 56.9006C173.414 56.9416 173.417 57.0396 173.448 57.0606C173.775 57.2776 173.896 57.5916 173.942 57.9456C174.029 58.5626 174.154 59.1746 174.23 59.7946C174.273 60.0856 174.183 60.3356 174.013 60.5706C173.881 60.7476 173.901 60.9656 174.05 61.1306C174.246 61.3346 174.413 61.5456 174.428 61.8446C174.474 62.5266 174.498 63.2196 174.491 63.8616C174.344 64.0636 174.214 64.2276 174.079 64.3896C174.071 64.4496 174.061 64.5126 174.058 64.5776C174.053 64.7076 174.06 64.8406 174.042 64.9696C173.987 65.3116 174.134 65.6106 174.372 65.9036C174.239 66.0526 174.108 66.2006 173.954 66.3716C173.8 67.9646 173.487 69.5856 172.937 71.1306C172.798 71.4906 172.784 71.5176 172.918 72.0126C172.807 72.0776 172.7 72.1956 172.607 72.3416C172.401 72.4256 172.334 72.5866 172.353 72.8046C172.355 72.8216 172.361 72.8396 172.364 72.8566C172.299 73.0466 172.265 73.2216 172.283 73.3226C172.15 73.3816 172.023 73.4356 171.859 73.5006C169.847 77.1996 166.24 79.7236 162.045 80.4646C161.912 80.4856 161.836 80.4476 161.705 80.3556C161.512 80.2296 161.379 80.2096 161.223 80.4036C160.881 80.8156 160.411 80.7786 159.953 80.4416C159.914 80.4156 159.82 80.4076 159.799 80.4346C159.578 80.7346 159.264 80.7826 158.921 80.7896C158.32 80.8146 157.725 80.7736 157.121 80.7726C156.836 80.7796 156.611 80.6256 156.416 80.4126C156.27 80.2486 156.066 80.2176 155.883 80.3446C155.656 80.5046 155.426 80.6446 155.135 80.5886C154.471 80.4716 153.78 80.4106 153.145 80.2466C152.975 80.0576 152.832 79.8986 152.686 79.7386C152.625 79.7206 152.561 79.6996 152.495 79.6856C152.362 79.6616 152.224 79.6346 152.096 79.5886C151.755 79.4586 151.427 79.5346 151.095 79.7326C150.958 79.5746 150.824 79.4186 150.667 79.2386C149.046 78.7846 147.412 78.2216 145.805 77.5786C145.4 77.4066 145.404 77.3946 144.793 77.5436C144.718 77.4266 144.631 77.3216 144.565 77.2036C144.455 76.9866 144.276 76.9216 144.055 76.9456C143.912 76.9706 143.772 77.0106 143.625 77.0436C143.521 76.8636 143.416 76.6836 143.286 76.4576C139.266 74.5646 135.611 72.3696 132.002 69.6786C131.889 69.5926 131.863 69.5146 131.842 69.3616C131.805 69.1396 131.723 69.0226 131.457 69.0206C130.887 69.0126 130.558 68.6766 130.459 68.1146C130.447 68.0686 130.381 67.9956 130.344 67.9986C129.948 68.0436 129.664 67.8626 129.389 67.6276L127.93 66.4076C127.7 66.2166 127.597 65.9676 127.561 65.6726C127.538 65.4506 127.377 65.2936 127.145 65.2776C126.856 65.2606 126.579 65.2286 126.36 65.0146C125.852 64.5346 125.34 64.0496 124.856 63.5906C124.811 63.3346 124.772 63.1196 124.734 62.9026C124.692 62.8546 124.645 62.8016 124.599 62.7496C124.5 62.6496 124.391 62.5586 124.301 62.4506C124.068 62.1596 123.74 62.0506 123.352 62.0476C123.312 61.8386 123.272 61.6326 123.227 61.3926C122.03 60.1586 120.825 58.8786 119.674 57.5526C119.385 57.2146 119.391 57.2066 118.772 57.0666C118.756 56.9276 118.723 56.7956 118.715 56.6586C118.711 56.4146 118.573 56.2776 118.367 56.1986C118.229 56.1546 118.082 56.1326 117.935 56.0966C117.917 55.8886 117.9 55.6796 117.878 55.4176C115.032 51.9486 112.52 48.4986 110.253 44.6056C110.184 44.4796 110.192 44.3976 110.235 44.2466C110.288 44.0266 110.255 43.8896 110.01 43.7836C109.487 43.5546 109.301 43.1246 109.446 42.5616C109.454 42.5146 109.423 42.4206 109.389 42.4096C109.014 42.2906 108.815 42.0166 108.653 41.6946C108.37 41.1306 108.087 40.5676 107.801 40.0016C107.662 39.7356 107.664 39.4686 107.746 39.1866C107.81 38.9746 107.734 38.7656 107.529 38.6586C107.272 38.5276 107.041 38.3836 106.924 38.1026C106.649 37.4616 106.36 36.8246 106.131 36.1996C106.193 35.9496 106.244 35.7406 106.297 35.5276C106.277 35.4666 106.26 35.4006 106.235 35.3366C106.186 35.2056 106.128 35.0766 106.092 34.9426C106.004 34.5826 105.756 34.3496 105.404 34.1836C105.456 33.9796 105.506 33.7776 105.564 33.5426C105.022 31.9316 104.477 30.2776 104.088 28.5936C103.982 28.1676 103.987 28.1656 103.519 27.7576C103.572 27.6286 103.607 27.4956 103.665 27.3746C103.779 27.1586 103.729 26.9766 103.583 26.8126C103.48 26.7106 103.36 26.6216 103.245 26.5226C103.333 26.3346 103.421 26.1466 103.532 25.9106C103.149 23.7546 102.928 21.5916 102.942 19.5156C102.96 17.4606 103.208 15.3806 103.844 13.3416C103.89 13.2106 103.952 13.1686 104.087 13.1166ZM80.1944 45.2546C80.3314 45.0816 80.3153 44.8556 80.1593 44.6446C80.1313 44.6056 80.1063 44.5716 80.0853 44.5396C80.1113 44.4426 80.1324 44.3446 80.1604 44.2486L80.6873 42.5586C81.1003 41.2956 81.4453 40.0076 81.9133 38.7626L83.3764 35.0496C84.0444 33.4046 84.8803 31.8346 85.6243 30.2236L85.9234 29.6256C85.9764 29.5046 86.3313 29.1526 86.4113 29.0636C86.5713 28.8866 86.4953 29.0136 86.7433 28.9316C86.6863 28.3856 86.6884 28.3826 87.1864 28.1346C87.1664 27.9886 87.1434 27.8416 87.1344 27.6916C87.1254 27.4576 87.2294 27.2916 87.4574 27.1706C87.5824 27.1066 87.7094 27.0396 87.8374 26.9736C87.8184 26.8236 87.7834 26.6726 87.7894 26.5236C87.7974 26.2906 87.8893 26.1026 88.1153 26.0026C88.2413 25.9446 88.3593 25.8696 88.4803 25.8046C88.4613 25.6496 88.4313 25.4986 88.4593 25.3566C88.5293 24.9916 88.6994 24.6716 89.0704 24.5026C89.2104 24.4436 89.3464 24.3876 89.5264 24.3116C89.7094 24.0386 89.9114 23.7346 90.1134 23.4306C90.1954 23.3086 90.2803 23.1846 90.3473 23.0536C90.4093 22.9286 90.4264 22.7786 90.3884 22.6216C90.3434 22.4376 90.3823 22.3286 90.5173 22.2666C91.0233 22.0366 91.0213 22.0346 91.2023 21.7686C91.3633 21.5316 91.6014 21.3346 91.6564 21.0356C91.6804 20.8896 91.6543 20.7376 91.6763 20.5916C91.6823 20.5436 91.7563 20.4966 91.8133 20.4696C91.9383 20.4076 92.0664 20.3576 92.1954 20.3046C92.1984 20.1546 92.2003 20.0056 92.2023 19.8356C92.3953 19.7636 92.5933 19.6876 92.8253 19.5996C93.5323 18.6036 94.3454 17.6546 95.1514 16.7166C95.1724 16.6366 95.2043 16.5706 95.2133 16.4956C95.2273 16.3456 95.2403 16.1996 95.2563 16.0516C95.3853 16.0006 95.5063 15.9296 95.6453 15.9096C95.8033 15.8826 95.9163 15.8236 96.0163 15.7016C98.2253 13.2516 100.62 10.9036 103.225 8.91357C102.827 9.60357 102.467 10.3176 102.164 11.0546C102.08 11.2656 101.982 11.4706 101.914 11.6896C101.869 11.8166 101.586 12.2186 101.534 12.3306H101.533C101.453 12.4106 101.484 12.5006 101.39 12.5726C101.187 12.7306 101.14 12.8986 101.226 13.1756C101.31 13.4796 101.4 13.7706 101.312 14.0786C101.22 14.4406 101.129 14.8076 101.061 15.1756C101.049 15.2446 101.02 15.3196 100.976 15.3716C100.88 15.4806 100.734 15.5616 100.681 15.6926C100.593 15.9156 100.835 16.0996 100.84 16.3046C100.853 16.8346 100.792 17.3536 100.725 17.8716C100.712 18.0176 100.607 18.1326 100.519 18.2556C100.33 18.5056 100.326 18.5236 100.521 18.8036C100.73 19.1016 100.675 19.3576 100.472 19.6216C100.381 19.7416 100.304 19.8726 100.216 20.0226C100.215 21.7316 100.372 23.4186 100.593 25.0946C100.753 25.2706 100.925 25.4216 101.054 25.5986C101.185 25.7786 100.87 25.9216 100.91 26.1356C100.927 26.2076 100.927 26.2836 100.948 26.3526C101.03 26.6576 101.216 27.0006 101.106 27.2766C100.963 27.6426 101.049 27.9916 101.304 28.2876C101.398 28.3976 101.523 28.4846 101.63 28.5836C101.554 28.7866 101.477 28.9906 101.395 29.2126C101.663 30.3396 101.989 31.4646 102.331 32.5816C103.116 35.0916 104.084 37.5346 105.183 39.9056C105.913 41.4876 106.701 43.0426 107.543 44.5646C107.647 44.7546 107.74 44.9536 107.861 45.1356C107.936 45.2406 108.046 45.7146 108.08 45.8266L108.079 45.8276C108.083 45.9426 108.165 45.9736 108.153 46.0926C108.128 46.3546 108.22 46.4876 108.471 46.5926C108.748 46.7096 108.994 46.8406 109.141 47.1136L109.69 48.0476C109.726 48.1056 109.752 48.1786 109.754 48.2476C109.757 48.3936 109.701 48.5556 109.746 48.6846C109.824 48.9006 110.118 48.8606 110.253 49.0026C110.606 49.3666 110.838 49.8186 111.115 50.2366C111.193 50.3546 111.189 50.5026 111.187 50.6546C111.183 50.9656 111.187 50.9786 111.499 51.0726C111.833 51.1736 111.938 51.4066 111.925 51.7316C111.921 51.8776 111.931 52.0226 111.939 52.1956C112.893 53.5356 113.894 54.8696 114.921 56.1686C115.144 56.2386 115.366 56.2816 115.564 56.3696C115.765 56.4596 115.564 56.7386 115.702 56.9016C115.752 56.9556 115.789 57.0196 115.842 57.0686C116.063 57.2856 116.389 57.4966 116.414 57.7936C116.459 58.1836 116.701 58.4396 117.064 58.5746C117.199 58.6256 117.351 58.6416 117.494 58.6776C117.517 58.8936 117.541 59.1106 117.566 59.3446C118.312 60.2116 119.102 61.0606 119.888 61.9106C121.668 63.8126 123.55 65.6236 125.492 67.3586C126.789 68.5136 128.117 69.6376 129.493 70.7016C129.664 70.8376 129.824 70.9846 130.006 71.1076C130.113 71.1776 130.402 71.5696 130.482 71.6566C130.532 71.7576 130.618 71.7546 130.655 71.8656C130.737 72.1116 130.871 72.2046 131.143 72.2036C131.442 72.2046 131.719 72.2306 131.958 72.4276C132.238 72.6566 132.546 72.8486 132.838 73.0616C132.893 73.1016 132.945 73.1596 132.975 73.2226C133.034 73.3566 133.046 73.5286 133.137 73.6296C133.293 73.7996 133.547 73.6486 133.725 73.7286C134.188 73.9336 134.599 74.2296 135.014 74.5166C135.131 74.5946 135.186 74.7336 135.244 74.8746C135.361 75.1646 135.371 75.1756 135.695 75.1416C136.043 75.0966 136.236 75.2666 136.355 75.5666C136.412 75.7006 136.481 75.8276 136.557 75.9836C137.965 76.8486 139.446 77.6396 140.931 78.3996C141.16 78.3766 141.385 78.3136 141.601 78.3106C141.824 78.3056 141.761 78.6436 141.956 78.7336C142.024 78.7606 142.087 78.8036 142.155 78.8256C142.452 78.9266 142.835 78.9796 142.991 79.2346C143.207 79.5616 143.54 79.6916 143.929 79.6536C144.074 79.6396 144.217 79.5896 144.361 79.5576C144.479 79.7416 144.598 79.9266 144.727 80.1266C145.802 80.5556 146.901 80.9676 148.019 81.3296C150.539 82.1556 153.113 82.7436 155.82 83.0026C157.632 83.1816 159.463 83.1996 161.263 82.9726C161.492 82.9576 161.719 82.9386 161.941 82.8816C162.068 82.8456 162.58 82.8956 162.709 82.8996L162.71 82.9006C162.83 82.9346 162.883 82.8686 163.004 82.9166C163.268 83.0216 163.432 82.9626 163.604 82.7556C163.794 82.5266 163.985 82.3306 164.301 82.2676C164.668 82.1836 165.016 82.0406 165.375 81.9326C165.442 81.9106 165.523 81.9016 165.598 81.9136C165.752 81.9396 165.918 82.0306 166.059 81.9996C166.298 81.9526 166.297 81.6596 166.463 81.5486C166.9 81.2736 167.381 81.0686 167.842 80.8196C167.972 80.7516 168.129 80.7646 168.29 80.7766C168.623 80.8036 168.631 80.7806 168.74 80.4696C168.842 80.1586 169.058 80.0516 169.357 80.0396C169.317 80.1436 169.244 80.2236 169.11 80.2716C168.958 80.3266 168.841 80.4076 168.77 80.5416C168.256 81.6396 167.56 82.6226 166.915 83.6396C166.834 83.7626 166.826 83.9126 166.853 84.0726C166.863 84.1476 166.863 84.2256 166.855 84.3016C166.813 84.7006 166.625 85.0216 166.265 85.1916C165.997 85.3186 165.73 85.4126 165.561 85.6936C165.187 86.2576 164.732 86.7596 164.321 87.2966C164.224 87.4146 164.192 87.5536 164.207 87.7186C164.221 87.9596 164.13 88.1026 163.869 88.1676C163.383 88.2886 163.103 88.6316 163.091 89.1366C163.077 89.5676 162.788 89.5716 162.514 89.6286C162.481 89.9016 162.527 90.2326 162.087 90.2426C161.92 90.2486 161.787 90.3046 161.678 90.4126L159.77 92.3246C159.391 92.7436 158.942 93.0846 158.506 93.4386L157.198 94.5046C156.76 94.8576 156.332 95.2246 155.886 95.5656L154.469 96.4806C154.345 96.5586 154.191 96.5886 154.036 96.5506C153.765 96.4826 153.651 96.6196 153.586 96.8576C153.544 97.0136 153.456 97.1306 153.327 97.2126C152.979 97.4316 152.643 97.6766 152.282 97.8736L151.182 98.4406C151.012 98.5286 150.758 98.4566 150.587 98.4546C150.587 98.4546 150.587 98.4546 150.586 98.4546C150.47 98.4546 150.434 98.5346 150.315 98.5186C150.052 98.4826 149.91 98.5606 149.78 98.8076C149.635 99.0786 149.473 99.3216 149.18 99.4526C148.846 99.6226 148.5 99.7666 148.144 99.8846C148.078 99.9096 147.998 99.9216 147.925 99.9096C147.775 99.8846 147.621 99.7996 147.481 99.8176C147.247 99.8496 147.227 100.146 147.052 100.25C146.602 100.521 146.096 100.674 145.604 100.846C145.465 100.897 145.321 100.86 145.173 100.822C144.871 100.743 144.863 100.755 144.668 101.012C144.461 101.291 144.189 101.315 143.877 101.195C143.736 101.142 143.592 101.106 143.422 101.052C142.606 101.266 141.784 101.481 140.961 101.696L138.434 102.091C138.254 102.249 138.097 102.421 137.912 102.548C137.722 102.679 137.589 102.362 137.37 102.4C137.296 102.417 137.22 102.417 137.148 102.438C136.836 102.523 136.461 102.638 136.194 102.492C135.837 102.298 135.479 102.329 135.14 102.537C135.014 102.613 134.905 102.725 134.784 102.816C134.595 102.703 134.403 102.59 134.195 102.468C133.016 102.584 131.819 102.484 130.622 102.447C129.949 102.408 129.272 102.424 128.602 102.342L126.592 102.082C125.924 101.984 125.247 101.934 124.584 101.8L122.602 101.367C120.821 101.046 119.114 100.438 117.379 99.9226L116.731 99.7126C116.602 99.6776 116.2 99.3706 116.097 99.3016L116.098 99.3006C116.018 99.2126 115.934 99.2386 115.865 99.1386C115.712 98.9166 115.557 98.8616 115.288 98.9296C114.992 99.0016 114.706 99.0426 114.411 98.9096L113.362 98.4796C113.297 98.4526 113.23 98.4076 113.186 98.3526C113.095 98.2326 113.043 98.0736 112.93 97.9876C112.742 97.8386 112.518 98.0276 112.321 97.9716C111.815 97.8286 111.352 97.5636 110.885 97.3216C110.752 97.2556 110.677 97.1226 110.6 96.9876C110.441 96.7106 110.432 96.7026 110.1 96.7676C109.746 96.8386 109.526 96.6806 109.375 96.3896C109.307 96.2576 109.219 96.1456 109.135 95.9856C108.4 95.5536 107.659 95.1206 106.918 94.6846C106.176 94.2476 105.418 93.8306 104.727 93.3176C104.492 93.3106 104.262 93.3296 104.041 93.2956C103.816 93.2606 103.926 92.9316 103.74 92.8076C103.676 92.7676 103.619 92.7146 103.552 92.6806C103.267 92.5266 102.88 92.4026 102.768 92.1196C102.612 91.7516 102.307 91.5546 101.903 91.5046C101.756 91.4816 101.605 91.4876 101.456 91.4776C101.387 91.2626 101.316 91.0466 101.239 90.8126C100.316 90.0606 99.3833 89.2976 98.4473 88.5356L95.4893 85.7376C94.5563 84.7526 93.6583 83.7326 92.7403 82.7306C92.1213 82.0686 91.6143 81.3136 91.0453 80.6096C90.5023 79.8846 89.9044 79.1976 89.4064 78.4416C89.2834 78.2506 89.1724 78.0506 89.0354 77.8696C88.9494 77.7656 88.7973 77.2816 88.7523 77.1686C88.6663 76.9396 88.7464 77.0686 88.7854 76.8116C88.2674 76.5986 88.2654 76.5956 88.2713 76.0386C88.1293 75.9836 87.9883 75.9346 87.8473 75.8696C87.6303 75.7656 87.5293 75.5926 87.5253 75.3326C87.5253 75.1906 87.5233 75.0486 87.5233 74.9036C87.3773 74.8476 87.2403 74.7986 87.1153 74.7146C86.9223 74.5876 86.8103 74.4056 86.8403 74.1526C86.8563 74.0076 86.8513 73.8636 86.8584 73.7206C86.7194 73.6546 86.5683 73.6096 86.4543 73.5136C86.1603 73.2696 85.9554 72.9616 85.9794 72.5526C85.9944 72.4026 86.0074 72.2536 86.0264 72.0606C85.8684 71.7656 85.6923 71.4366 85.5163 71.1086L85.3033 70.7116C85.2333 70.5886 85.1153 70.4946 84.9653 70.4436C84.7873 70.3846 84.7173 70.2926 84.7363 70.1396C84.8043 69.5696 84.8133 69.5666 84.6723 69.2706C84.5403 69.0086 84.4853 68.7006 84.2453 68.4996C84.1303 68.4026 83.9814 68.3466 83.8624 68.2526C83.8214 68.2236 83.8173 68.1346 83.8213 68.0706C83.8273 67.9296 83.8464 67.7936 83.8624 67.6546C83.7303 67.5756 83.5983 67.4966 83.4503 67.4056C83.4813 67.2016 83.5114 66.9926 83.5484 66.7456C83.1404 65.5716 82.7223 64.3676 82.3083 63.1756C82.2473 63.1136 82.2053 63.0506 82.1463 63.0026L81.7793 62.7276C81.8043 62.5886 81.7953 62.4486 81.8613 62.3156C81.9273 62.1636 81.9453 62.0316 81.9033 61.8766C80.4063 56.8296 79.8083 51.5486 79.8213 46.2846C79.8333 45.8796 79.9464 45.5606 80.1944 45.2546ZM113.028 144.904C112.792 144.688 112.45 144.48 112.409 144.178C112.347 143.782 112.098 143.519 111.725 143.38C111.587 143.328 111.432 143.31 111.287 143.273C111.258 143.053 111.228 142.834 111.197 142.595C110.418 141.709 109.629 140.811 108.84 139.914C107.092 137.874 105.5 135.705 103.824 133.607L102.168 131.49C101.607 130.79 101.062 130.08 100.57 129.331C100.444 129.144 100.33 128.951 100.189 128.774C100.103 128.673 99.9433 128.201 99.8963 128.087C99.8803 127.97 99.7964 127.946 99.7944 127.824C99.7924 127.557 99.6944 127.425 99.4353 127.335C99.1493 127.231 98.8923 127.111 98.7223 126.839L98.0983 125.911C98.0583 125.853 98.0293 125.78 98.0233 125.708C98.0123 125.56 98.0603 125.392 98.0083 125.263C97.9203 125.044 97.6253 125.091 97.4823 124.948C97.1123 124.578 96.8433 124.129 96.5583 123.695C96.4763 123.574 96.4783 123.423 96.4773 123.269C96.4783 122.954 96.4724 122.941 96.1524 122.837C95.8104 122.728 95.6993 122.487 95.7113 122.161C95.7153 122.015 95.7014 121.87 95.6954 121.696C94.8244 120.253 93.9393 118.788 93.0603 117.333C92.8474 117.229 92.6303 117.15 92.4444 117.03C92.2543 116.907 92.4923 116.657 92.3754 116.47C92.3344 116.408 92.3053 116.336 92.2583 116.28C92.0653 116.025 91.7654 115.759 91.7803 115.458C91.7914 115.061 91.5953 114.759 91.2523 114.553C91.1253 114.476 90.9753 114.429 90.8383 114.365C90.8503 114.147 90.8614 113.927 90.8754 113.691C90.2774 112.677 89.7813 111.595 89.2233 110.543L87.3953 106.967L86.4783 105.178L85.6944 103.331L83.6044 98.3996C83.5184 98.1926 83.4473 97.9816 83.3443 97.7806C83.2783 97.6636 83.2193 97.1766 83.2153 97.0516C83.2333 96.9346 83.1584 96.8896 83.1904 96.7706C83.2604 96.5116 83.2044 96.3586 82.9794 96.2046C82.7344 96.0316 82.5204 95.8476 82.4324 95.5406L82.0874 94.4806C82.0654 94.4146 82.0574 94.3346 82.0704 94.2646C82.1014 94.1186 82.1923 93.9696 82.1783 93.8306C82.1543 93.5966 81.8593 93.5626 81.7603 93.3876C81.5053 92.9326 81.3714 92.4286 81.2164 91.9346C81.1714 91.7956 81.2144 91.6516 81.2554 91.5036C81.3424 91.2016 81.3413 91.1906 81.0623 91.0026C80.7633 90.8036 80.7224 90.5416 80.8244 90.2346C80.8674 90.0946 80.8943 89.9536 80.9373 89.7856C80.5173 88.1606 80.0913 86.5126 79.6673 84.8736C79.4933 84.7116 79.3083 84.5736 79.1633 84.4046C79.0173 84.2306 79.3174 84.0646 79.2594 83.8536C79.2383 83.7816 79.2303 83.7066 79.2023 83.6366C79.0893 83.3396 78.8783 82.9956 78.9803 82.7166C79.0943 82.3476 79.0333 81.9956 78.7883 81.6916C78.6983 81.5786 78.5773 81.4866 78.4733 81.3826C78.5623 81.1776 78.6523 80.9726 78.7493 80.7496C78.5503 79.5976 78.3493 78.4296 78.1463 77.2616L77.8074 75.2906L77.6273 73.3006L77.2684 69.3186C77.1554 68.4336 77.2063 67.5436 77.1833 66.6546L77.1613 63.9886C77.1613 63.7656 77.1753 63.5436 77.1573 63.3196C77.1413 63.1876 77.2743 62.7166 77.3003 62.5986C77.3533 62.4966 77.2963 62.4276 77.3643 62.3296C77.5053 62.1166 77.5103 61.9536 77.3663 61.7266C77.2084 61.4746 77.0823 61.2236 77.1203 60.9086L77.2133 59.8016C77.2183 59.7326 77.2414 59.6556 77.2814 59.5966C77.3664 59.4746 77.5093 59.3726 77.5503 59.2406C77.6173 59.0166 77.3593 58.8726 77.3353 58.6726C77.2773 58.1566 77.3494 57.6406 77.3974 57.1266C77.4094 56.9806 77.5044 56.8656 77.6004 56.7486C77.7964 56.5066 77.8003 56.4946 77.6163 56.2126C77.4193 55.9246 77.4923 55.6806 77.7043 55.4526L78.1893 58.4326L78.9243 61.3636C79.1643 62.3426 79.4013 63.3206 79.7613 64.2616L80.7464 67.1146C81.0583 68.0706 81.5333 68.9656 81.9203 69.8906C82.3473 70.7996 82.6883 71.7496 83.1883 72.6226L84.6293 75.2676C85.1934 76.3966 85.9964 77.4616 86.6684 78.5256C86.7543 78.6606 86.7563 78.7516 86.7303 78.9166C86.7053 79.1586 86.7573 79.3116 87.0213 79.4186C87.5893 79.6476 87.8044 80.1186 87.8064 80.7156C87.8083 80.7666 87.8634 80.8636 87.9024 80.8736C88.3184 80.9606 88.5864 81.2256 88.8284 81.5486C89.2544 82.1116 89.6863 82.6706 90.1333 83.2226C90.3483 83.4786 90.4103 83.7746 90.4263 84.0886C90.4363 84.3216 90.5983 84.5206 90.8443 84.5806C91.1533 84.6506 91.4373 84.7386 91.6583 84.9946C92.1793 85.5766 92.7034 86.1606 93.1994 86.7146C93.2484 86.9946 93.2894 87.2296 93.3324 87.4686C93.3754 87.5286 93.4283 87.5846 93.4843 87.6406C93.5973 87.7486 93.7223 87.8526 93.8263 87.9696C94.0993 88.2886 94.4594 88.4206 94.8714 88.4386C94.9333 88.6596 94.9943 88.8796 95.0643 89.1346C95.7813 89.7846 96.4464 90.5086 97.2254 91.1096C97.9884 91.7286 98.7553 92.3506 99.5213 92.9726C99.9113 93.2856 99.9043 93.3076 100.58 93.3486C100.639 93.4856 100.715 93.6136 100.766 93.7486C100.849 93.9956 101.035 94.1116 101.276 94.1446C101.434 94.1586 101.594 94.1486 101.757 94.1506C101.848 94.3576 101.938 94.5646 102.051 94.8226C106.199 97.6846 110.461 99.9226 115.215 101.628C115.363 101.688 115.416 101.761 115.494 101.911C115.615 102.122 115.744 102.223 116.021 102.149C116.626 101.973 117.095 102.181 117.443 102.687C117.474 102.727 117.576 102.776 117.613 102.76C117.998 102.591 118.369 102.653 118.755 102.778C119.434 102.979 120.096 103.235 120.803 103.348C121.133 103.41 121.367 103.584 121.569 103.83C121.717 104.016 121.965 104.083 122.198 103.988C122.487 103.866 122.766 103.771 123.097 103.851C123.857 104.043 124.629 104.185 125.371 104.281C125.585 104.462 125.764 104.613 125.945 104.767C126.016 104.781 126.093 104.796 126.172 104.812C126.328 104.833 126.49 104.843 126.646 104.876C127.058 104.974 127.424 104.868 127.759 104.638C127.946 104.783 128.129 104.925 128.342 105.089C129.311 105.186 130.301 105.185 131.289 105.234L132.775 105.29C132.98 105.293 133.183 105.283 133.388 105.271C133.402 105.311 133.418 105.349 133.435 105.391C133.382 105.689 133.322 105.996 133.313 106.308C133.308 106.478 133.255 106.605 133.16 106.734C132.791 107.24 132.769 107.246 132.769 107.796C132.758 108.355 132.758 108.358 133.044 108.895C133.075 108.947 133.087 109.034 133.073 109.087C132.798 109.837 132.796 109.845 132.815 110.191C132.837 110.83 132.96 111.457 133.038 112.089C133.731 116.114 135.585 119.747 137.798 122.937C140.027 126.139 142.633 128.981 145.336 131.676C146.202 132.503 147.099 133.394 147.986 134.191C148.097 134.295 148.118 134.379 148.128 134.541C148.153 134.773 148.235 134.901 148.51 134.935C149.103 135.006 149.417 135.385 149.509 135.969C149.519 136.017 149.586 136.098 149.624 136.098C150.032 136.09 150.329 136.287 150.612 136.545C151.11 136.994 151.61 137.44 152.133 137.86C152.381 138.058 152.496 138.314 152.549 138.617C152.584 138.846 152.758 139.011 152.998 139.029C153.299 139.047 153.58 139.086 153.82 139.3C154.386 139.773 154.956 140.249 155.496 140.7C155.557 140.908 155.609 141.088 155.66 141.265C154.853 141.363 154.047 141.462 153.24 141.553C152.999 141.58 152.756 141.592 152.516 141.637C152.376 141.668 151.847 141.592 151.715 141.582C151.597 141.541 151.53 141.605 151.414 141.551C151.161 141.431 150.983 141.457 150.763 141.648C150.517 141.855 150.271 142.029 149.926 142.053L148.726 142.184C148.65 142.192 148.564 142.185 148.494 142.157C148.346 142.098 148.211 141.979 148.06 141.966C147.806 141.945 147.703 142.228 147.494 142.289C146.956 142.449 146.39 142.479 145.834 142.536C145.676 142.555 145.531 142.485 145.383 142.417C145.08 142.274 145.065 142.272 144.811 142.512C144.539 142.767 144.252 142.758 143.943 142.601C143.803 142.533 143.656 142.478 143.485 142.406C141.673 142.636 139.837 142.871 138.01 143.105C137.815 143.259 137.641 143.428 137.442 143.552C137.237 143.679 137.094 143.361 136.86 143.395C136.78 143.41 136.696 143.408 136.62 143.428C136.284 143.506 135.891 143.677 135.599 143.544C135.209 143.377 134.824 143.439 134.474 143.674C134.343 143.76 134.234 143.879 134.113 143.98C133.9 143.884 133.685 143.787 133.455 143.681C132.191 143.851 130.882 144.036 129.594 144.249C126.691 144.735 123.817 145.429 120.988 146.257C120.052 146.566 119.11 146.851 118.182 147.179C117.452 147.461 116.718 147.734 115.991 148.019C115.319 147.288 114.657 146.542 114.005 145.794C113.777 145.731 113.552 145.694 113.347 145.609C113.14 145.523 113.326 145.231 113.177 145.067C113.126 145.017 113.085 144.951 113.028 144.904ZM151.341 307.888C151.345 307.882 151.348 307.88 151.351 307.874L151.33 307.923C151.333 307.912 151.337 307.9 151.341 307.888C151.263 308.042 151.181 308.105 151.025 308.183C150.793 308.318 150.679 308.464 150.718 308.699C150.814 309.26 150.396 309.726 149.815 309.816C149.766 309.828 149.689 309.902 149.687 309.937C149.683 310.339 149.451 310.652 149.137 310.9C148.59 311.334 147.991 311.685 147.363 311.929C147.07 312.06 146.783 311.982 146.537 311.845C146.351 311.706 146.154 311.749 145.99 311.884C145.787 312.081 145.549 312.228 145.244 312.183C145.071 312.158 144.906 312.103 144.734 312.074L144.489 311.988L144.367 311.945L144.305 311.925L144.277 311.917C144.287 311.921 144.298 311.927 144.307 311.931L144.326 311.941L144.327 311.943C144.288 311.923 144.272 311.916 144.265 311.912H144.264H144.263C144.267 311.912 144.265 311.912 144.265 311.912H144.268C144.085 311.818 143.872 311.721 143.734 311.633C143.619 311.537 143.505 311.483 143.384 311.369C143.325 311.103 143.275 310.92 143.265 310.699C143.23 310.65 143.193 310.599 143.15 310.551C143.058 310.463 142.985 310.344 142.914 310.235C142.753 309.924 142.485 309.741 142.123 309.575C142.148 309.362 142.215 309.141 142.277 308.909C142.008 308.079 141.966 307.134 142.078 306.202C142.208 305.247 142.465 304.384 142.974 303.432C143.21 303.049 143.177 303.073 143.204 302.387C143.339 302.321 143.474 302.248 143.617 302.211C143.874 302.147 143.985 301.975 144.057 301.756C144.092 301.606 144.108 301.447 144.139 301.283C144.359 301.248 144.579 301.215 144.854 301.172C145.791 300.451 146.884 299.971 147.932 299.977C148.192 299.979 148.454 299.985 148.702 300.049C148.827 300.076 148.956 300.09 149.073 300.141L149.378 300.245L149.857 300.481C149.939 300.545 150.023 300.604 150.112 300.659C150.297 300.804 150.515 300.975 150.683 301.177C151.41 301.954 151.839 303.087 151.943 304.282C152.044 305.472 151.822 306.719 151.341 307.888ZM184.665 322.308C184.622 322.279 184.513 322.263 184.481 322.288C184.169 322.567 183.795 322.62 183.389 322.616C182.68 322.614 181.972 322.62 181.26 322.639C180.924 322.651 180.654 322.534 180.403 322.338C180.215 322.19 179.964 322.18 179.758 322.322C179.504 322.506 179.252 322.66 178.91 322.656C178.127 322.656 177.34 322.658 176.593 322.66C176.356 322.51 176.156 322.385 175.954 322.258C175.882 322.254 175.805 322.248 175.725 322.244C175.569 322.244 175.409 322.258 175.252 322.244C174.834 322.205 174.488 322.359 174.182 322.633C173.983 322.516 173.786 322.401 173.557 322.266C171.625 322.284 169.653 322.301 167.682 322.321C167.182 322.323 167.178 322.313 166.614 322.696C166.484 322.62 166.345 322.559 166.223 322.477C166.008 322.323 165.791 322.336 165.577 322.448C165.44 322.528 165.317 322.63 165.184 322.721C164.99 322.606 164.795 322.489 164.552 322.342C160.717 322.403 157.037 322.461 153.27 322.52C154.969 321.411 156.493 320.032 157.8 318.487C159.057 317.057 160.065 315.438 160.932 313.747C161.037 313.532 161.157 313.323 161.245 313.099C161.291 312.97 161.631 312.574 161.709 312.47C161.799 312.388 161.772 312.3 161.873 312.228C162.094 312.068 162.15 311.904 162.086 311.619C162.016 311.305 161.973 311.015 162.107 310.705C162.265 310.342 162.341 309.957 162.464 309.584C162.485 309.514 162.525 309.439 162.577 309.383C162.688 309.272 162.852 309.188 162.923 309.055C163.038 308.828 162.823 308.647 162.823 308.434C162.835 307.961 162.945 307.502 163.05 307.041L167.392 306.992L171.787 306.945C171.971 306.945 172.153 306.961 172.338 306.943C172.445 306.927 172.838 307.06 172.936 307.084V307.086C173.022 307.139 173.077 307.082 173.16 307.148C173.341 307.296 173.475 307.289 173.657 307.125C173.86 306.945 174.06 306.801 174.321 306.813L175.235 306.817C175.294 306.817 175.356 306.833 175.408 306.868C175.514 306.944 175.606 307.077 175.718 307.106C175.907 307.157 176.009 306.885 176.171 306.848C176.59 306.748 177.017 306.778 177.442 306.786C177.561 306.786 177.664 306.872 177.769 306.958C177.985 307.134 177.997 307.138 178.209 306.931C178.436 306.708 178.65 306.751 178.869 306.945C178.969 307.029 179.074 307.099 179.197 307.193C179.33 307.191 179.466 307.189 179.599 307.187C179.508 308.503 179.517 309.822 179.661 311.117C179.899 313.021 180.39 314.877 181.153 316.605C181.253 316.82 181.342 317.046 181.454 317.251C181.516 317.368 181.647 317.925 181.71 318.048C181.731 318.185 181.806 318.204 181.816 318.349C181.838 318.667 181.938 318.818 182.165 318.888C182.405 318.974 182.636 319.068 182.835 319.343L183.532 320.284C183.583 320.339 183.629 320.413 183.655 320.491C183.708 320.657 183.719 320.858 183.803 320.993C183.946 321.216 184.172 321.071 184.331 321.19C184.73 321.508 185.171 321.846 185.568 322.219C185.672 322.301 185.728 322.444 185.797 322.578C185.415 322.695 185.03 322.592 184.665 322.308ZM193.746 311.937L193.755 311.941L193.757 311.943H193.758C193.761 311.945 193.755 311.941 193.746 311.937ZM200.77 307.89C200.774 307.884 200.778 307.882 200.78 307.876L200.759 307.923C200.763 307.912 200.767 307.902 200.77 307.89C200.692 308.042 200.612 308.105 200.455 308.183C200.222 308.318 200.11 308.464 200.147 308.699C200.243 309.26 199.825 309.726 199.245 309.818C199.196 309.828 199.12 309.902 199.116 309.937C199.112 310.339 198.882 310.652 198.567 310.9C198.02 311.334 197.422 311.685 196.794 311.929C196.499 312.06 196.212 311.982 195.967 311.845C195.782 311.706 195.585 311.749 195.421 311.884C195.218 312.081 194.978 312.228 194.674 312.183C194.501 312.158 194.335 312.103 194.163 312.074L193.919 311.988L193.796 311.945L193.734 311.925L193.704 311.915L193.698 311.913C193.71 311.919 193.723 311.925 193.735 311.931L193.745 311.937C193.714 311.921 193.647 311.89 193.692 311.912H193.696L193.698 311.914C193.514 311.818 193.3 311.721 193.163 311.633C193.047 311.537 192.934 311.483 192.811 311.367C192.754 311.103 192.703 310.918 192.693 310.699C192.657 310.65 192.621 310.597 192.577 310.551C192.485 310.461 192.413 310.344 192.343 310.235C192.181 309.924 191.913 309.741 191.55 309.575C191.575 309.362 191.643 309.141 191.704 308.909C191.436 308.079 191.394 307.134 191.506 306.202C191.636 305.247 191.892 304.382 192.402 303.432C192.639 303.049 192.605 303.073 192.631 302.385C192.767 302.321 192.901 302.248 193.045 302.209C193.301 302.147 193.412 301.975 193.486 301.756C193.521 301.606 193.537 301.447 193.568 301.283C193.787 301.248 194.007 301.215 194.283 301.172C195.219 300.449 196.312 299.971 197.361 299.977C197.621 299.979 197.882 299.985 198.13 300.049C198.254 300.076 198.384 300.09 198.502 300.141L198.806 300.245L199.285 300.481C199.368 300.545 199.452 300.604 199.54 300.659C199.724 300.804 199.943 300.975 200.112 301.175C200.839 301.954 201.267 303.087 201.372 304.282C201.475 305.472 201.253 306.72 200.77 307.89ZM236.056 234.318C236.029 234.347 236.013 234.38 235.994 234.414C235.883 234.596 235.89 234.818 235.907 235.043C235.916 235.111 235.908 235.176 235.908 235.248C235.765 235.441 235.609 235.637 235.474 235.842C235.404 235.957 235.308 236.018 235.177 236.055C234.661 236.201 234.666 236.207 234.417 236.557C234.161 236.909 234.157 236.905 234.16 237.428C234.163 237.481 234.136 237.545 234.097 237.569C233.509 237.87 233.507 237.868 233.353 238.092L232.509 239.322C230.714 241.937 229.091 244.687 227.575 247.494C226.142 250.348 224.802 253.262 223.796 256.295C223.495 257.25 223.099 258.234 222.862 259.207C222.827 259.33 222.764 259.375 222.632 259.437C222.446 259.537 222.376 259.644 222.482 259.871C222.709 260.359 222.543 260.734 222.074 261.008C222.037 261.033 221.998 261.113 222.015 261.143C222.216 261.455 222.187 261.754 222.095 262.063C221.929 262.6 221.843 263.155 221.731 263.706C221.685 263.968 221.524 264.151 221.291 264.302C221.113 264.415 221.059 264.609 221.164 264.798C221.3 265.034 221.407 265.261 221.344 265.525C221.194 266.125 221.094 266.74 220.989 267.318C220.81 267.476 220.661 267.609 220.509 267.744C220.494 267.799 220.476 267.857 220.466 267.92C220.445 268.043 220.437 268.17 220.404 268.289C220.308 268.609 220.416 268.906 220.644 269.189C220.502 269.326 220.361 269.46 220.199 269.617C219.926 271.125 219.812 272.676 219.62 274.217C219.574 274.61 219.564 274.612 219.889 275.096C219.8 275.188 219.727 275.289 219.633 275.377C219.457 275.527 219.451 275.699 219.549 275.879C219.619 275.994 219.711 276.102 219.795 276.215C219.665 276.356 219.535 276.496 219.373 276.67C219.045 280.621 218.947 284.361 218.85 288.311L218.846 288.313C218.795 289.961 218.743 291.676 218.691 293.389C218.662 295.1 218.632 296.811 218.604 298.453C218.504 298.623 218.43 298.752 218.356 298.877L218.322 298.924L218.284 298.967L218.249 299.012L218.235 299.035L218.226 299.058L218.205 299.138L218.189 299.216L218.179 299.294L218.18 299.37L218.185 299.409L218.193 299.446L218.205 299.483L218.22 299.52L218.239 299.555L218.263 299.592L218.291 299.627L218.324 299.662L218.379 299.721L218.426 299.778L218.468 299.837L218.502 299.896L218.531 299.957L218.552 300.016L218.566 300.077L218.574 300.139L218.576 300.2L218.569 300.262L218.555 300.323L218.534 300.385L218.506 300.447L218.47 300.509L218.427 300.573L218.376 300.635L218.3 300.723L218.267 300.768L218.253 300.791L218.243 300.814L218.217 300.894L218.197 300.972L218.185 301.05L218.182 301.089L218.184 301.126L218.188 301.165L218.194 301.202L218.206 301.239L218.22 301.276L218.24 301.311L218.262 301.348L218.29 301.383L218.321 301.42L218.375 301.477L218.423 301.534L218.465 301.593L218.501 301.65L218.53 301.711L218.554 301.77L218.571 301.831L218.582 301.892L218.585 301.953L218.582 302.015L218.571 302.077L218.553 302.139L218.527 302.203L218.493 302.267L218.452 302.331L218.403 302.397L218.35 302.463L218.304 302.529L218.264 302.599L218.231 302.673L218.204 302.747L218.186 302.827L218.174 302.909L218.172 302.995L218.184 303.747L218.185 304.122V304.216V304.261L218.184 304.267V304.271V304.273C218.198 304.232 218.198 304.234 218.205 304.212V304.214V304.226V304.249L218.206 304.442L213.212 304.485C213.317 302.71 213.181 300.909 212.857 299.157C212.685 298.987 212.503 298.848 212.363 298.677C212.22 298.503 212.513 298.3 212.457 298.073C212.435 297.997 212.428 297.915 212.4 297.843C212.285 297.529 212.031 297.2 212.107 296.88C212.18 296.46 212.076 296.081 211.742 295.833C211.625 295.737 211.482 295.675 211.354 295.597C211.383 295.361 211.413 295.126 211.445 294.87C211.205 294.29 210.841 293.768 210.543 293.214C210.199 292.685 209.819 292.175 209.436 291.673C207.608 289.505 205.146 287.804 202.367 287.153C200.534 286.682 198.6 286.587 196.729 286.901C196.493 286.917 196.266 286.977 196.03 287.038C195.893 287.083 195.415 287.054 195.292 287.054C195.292 287.054 195.292 287.054 195.291 287.054C195.29 287.054 195.29 287.054 195.29 287.054C195.188 287.025 195.11 287.095 195.013 287.05C194.802 286.964 194.628 287.029 194.392 287.269C194.128 287.535 193.88 287.765 193.562 287.857C193.189 287.966 192.838 288.162 192.476 288.308C192.408 288.337 192.331 288.353 192.269 288.343C192.138 288.322 192.019 288.232 191.88 288.259C191.65 288.31 191.568 288.665 191.388 288.802C190.935 289.179 190.427 289.374 189.98 289.695C189.853 289.783 189.722 289.771 189.585 289.763C189.307 289.743 189.288 289.751 189.117 290.113C188.93 290.492 188.708 290.619 188.421 290.617C188.291 290.619 188.158 290.638 187.997 290.652C187.261 291.213 186.616 291.898 185.946 292.55C185.341 293.269 184.678 293.941 184.158 294.73C184.119 295.003 184.11 295.265 184.057 295.507C184.004 295.751 183.702 295.605 183.563 295.806C183.516 295.872 183.471 295.941 183.436 296.015C183.285 296.339 183.171 296.767 182.895 296.906C182.541 297.103 182.316 297.451 182.323 297.9C182.321 298.062 182.356 298.228 182.373 298.388C182.179 298.511 181.981 298.636 181.769 298.771C181.471 299.351 181.246 299.966 181.016 300.582C180.767 301.191 180.578 301.82 180.412 302.455C180.226 303.113 180.077 303.779 179.949 304.447C177.632 304.494 175.326 304.541 172.943 304.59C172.818 304.59 172.759 304.543 172.663 304.432C172.518 304.28 172.398 304.243 172.217 304.405C171.822 304.757 171.421 304.7 171.045 304.323C171.012 304.294 170.926 304.278 170.903 304.303C170.66 304.58 170.371 304.633 170.057 304.631C169.508 304.629 168.96 304.633 168.41 304.654C168.15 304.666 167.939 304.549 167.746 304.353C167.601 304.205 167.405 304.193 167.246 304.337C167.051 304.521 166.855 304.675 166.591 304.669C165.985 304.657 165.375 304.692 164.797 304.675C164.612 304.525 164.459 304.4 164.303 304.271C164.246 304.267 164.187 304.259 164.125 304.259C164.015 304.259 163.902 304.267 163.791 304.259C163.871 302.556 163.738 300.835 163.429 299.157C163.257 298.987 163.075 298.846 162.934 298.677C162.791 298.501 163.086 298.3 163.028 298.073C163.007 297.997 162.999 297.915 162.971 297.843C162.857 297.529 162.602 297.2 162.678 296.88C162.752 296.46 162.649 296.081 162.314 295.833C162.196 295.737 162.053 295.675 161.926 295.597C161.955 295.361 161.985 295.126 162.016 294.87C161.778 294.29 161.413 293.768 161.114 293.214C160.771 292.685 160.391 292.175 160.009 291.673C158.18 289.505 155.718 287.804 152.939 287.153C151.106 286.682 149.171 286.587 147.301 286.903C147.064 286.917 146.839 286.977 146.602 287.038C146.464 287.083 145.986 287.054 145.863 287.054H145.861C145.759 287.025 145.683 287.095 145.586 287.05C145.373 286.964 145.2 287.029 144.963 287.269C144.7 287.535 144.451 287.765 144.133 287.857C143.76 287.966 143.41 288.162 143.048 288.308C142.981 288.337 142.904 288.355 142.84 288.345C142.711 288.322 142.59 288.232 142.453 288.259C142.221 288.31 142.139 288.665 141.959 288.802C141.506 289.179 140.998 289.374 140.553 289.697C140.424 289.783 140.295 289.771 140.158 289.763C139.879 289.745 139.861 289.751 139.689 290.113C139.502 290.492 139.279 290.619 138.994 290.619C138.863 290.619 138.73 290.639 138.568 290.652C137.832 291.213 137.189 291.898 136.518 292.55C135.914 293.269 135.25 293.941 134.73 294.73C134.691 295.003 134.682 295.265 134.629 295.507C134.577 295.753 134.275 295.607 134.136 295.806C134.089 295.874 134.042 295.941 134.009 296.017C133.857 296.341 133.743 296.767 133.468 296.906C133.114 297.103 132.888 297.451 132.896 297.9C132.892 298.064 132.929 298.228 132.945 298.388C132.75 298.513 132.554 298.636 132.341 298.771C132.042 299.351 131.817 299.966 131.587 300.582C131.339 301.191 131.149 301.82 130.983 302.455C130.79 303.141 130.629 303.836 130.501 304.533L130.493 304.535L130.423 304.558L130.354 304.572L130.284 304.58L130.213 304.582L130.142 304.576L130.071 304.562L129.999 304.542L129.925 304.513L129.853 304.478L129.779 304.435L129.705 304.386L129.604 304.308L129.551 304.277L129.524 304.263L129.496 304.253L129.404 304.228L129.312 304.208L129.222 304.196L129.134 304.194L129.089 304.198L129.046 304.206L129.003 304.218L128.96 304.232L128.919 304.252L128.876 304.275L128.835 304.302L128.794 304.335L128.729 304.388L128.664 304.437L128.598 304.478L128.53 304.515L128.462 304.544L128.394 304.569L128.326 304.587L128.256 304.597L128.184 304.601L128.114 304.597L128.041 304.587L127.968 304.569L127.894 304.544L127.82 304.511L127.744 304.47L127.668 304.421L127.592 304.368L127.512 304.323L127.431 304.282L127.346 304.249L127.258 304.224L127.167 304.206L127.071 304.194H126.97L126.099 304.21L125.666 304.212H125.558H125.505H125.497H125.494H125.493H125.492C125.497 304.226 125.497 304.226 125.501 304.232H125.499H125.487L125.464 304.228L125.273 304.207L126.723 290.045C126.851 288.69 126.988 287.262 127.117 285.904V285.902C127.135 285.738 127.189 285.666 127.312 285.55C127.484 285.376 127.537 285.222 127.4 284.966C127.103 284.411 127.212 283.892 127.638 283.435C127.671 283.394 127.699 283.285 127.677 283.251C127.431 282.903 127.418 282.519 127.462 282.106C127.534 281.383 127.602 280.663 127.653 279.936C127.674 279.594 127.817 279.329 128.036 279.092C128.202 278.916 128.239 278.66 128.116 278.438C127.958 278.163 127.829 277.891 127.868 277.543C127.941 276.744 128.014 275.943 128.085 275.182C128.257 274.953 128.401 274.764 128.547 274.569C128.558 274.497 128.569 274.417 128.581 274.337C128.595 274.177 128.598 274.013 128.625 273.855C128.704 273.433 128.581 273.066 128.337 272.728C128.472 272.537 128.606 272.345 128.761 272.124C128.907 270.151 129.058 268.136 129.208 266.122C129.245 265.612 129.257 265.608 128.917 265.003C129.003 264.874 129.074 264.737 129.165 264.618C129.334 264.409 129.338 264.186 129.241 263.96C129.173 263.815 129.081 263.681 128.999 263.538C129.128 263.349 129.259 263.157 129.421 262.919C129.491 261.759 129.545 260.612 129.591 259.47L129.645 257.757L129.675 255.945C129.663 254.736 129.671 253.529 129.534 252.328C129.444 251.734 129.336 251.121 128.966 250.621C128.659 250.094 128.351 249.566 128.04 249.033C127.765 248.574 127.476 248.094 127.185 247.609C127.097 247.457 127.097 247.363 127.123 247.191C127.149 246.933 127.097 246.769 126.837 246.65C126.272 246.379 126.054 245.892 126.128 245.275C126.132 245.222 126.089 245.117 126.051 245.103C125.65 244.968 125.411 244.665 125.204 244.308C124.839 243.681 124.47 243.06 124.085 242.445C123.901 242.156 123.862 241.857 123.901 241.539C123.934 241.299 123.812 241.07 123.583 240.963C123.294 240.832 123.032 240.686 122.862 240.381C122.462 239.69 122.059 238.994 121.678 238.334C121.688 238.049 121.695 237.811 121.702 237.566C121.668 237.502 121.633 237.431 121.597 237.359C121.518 237.22 121.424 237.084 121.356 236.939C121.178 236.55 120.868 236.322 120.475 236.187C120.475 235.953 120.475 235.72 120.475 235.451C119.485 233.748 118.446 232.023 117.456 230.275C117.204 229.832 117.211 229.824 116.596 229.509C116.598 229.355 116.581 229.202 116.592 229.054C116.617 228.786 116.498 228.601 116.293 228.464C116.156 228.384 116.006 228.323 115.859 228.249C115.863 228.02 115.868 227.79 115.874 227.503C114.591 225.276 113.328 223.118 112.106 220.937C110.88 218.759 109.617 216.597 108.429 214.316C108.354 214.171 108.361 214.082 108.4 213.918C108.448 213.678 108.41 213.522 108.154 213.385C107.603 213.086 107.411 212.59 107.518 211.981C107.525 211.928 107.486 211.821 107.45 211.805C107.055 211.651 106.834 211.336 106.645 210.969C106.312 210.328 105.98 209.69 105.645 209.047C105.485 208.746 105.468 208.445 105.531 208.131C105.582 207.895 105.478 207.658 105.258 207.535C104.981 207.387 104.729 207.223 104.581 206.908C104.229 206.193 103.877 205.476 103.541 204.795C103.57 204.514 103.596 204.279 103.621 204.039C103.592 203.971 103.56 203.898 103.529 203.824C103.457 203.683 103.384 203.537 103.328 203.388C103.191 202.986 102.906 202.734 102.53 202.564C102.554 202.332 102.578 202.101 102.605 201.834C101.791 200.057 100.917 198.256 100.191 196.41C100 195.943 100.007 195.937 99.4383 195.549C99.4603 195.399 99.4643 195.246 99.4943 195.102C99.5563 194.846 99.4633 194.647 99.2764 194.487C99.1504 194.389 99.0093 194.309 98.8733 194.217C98.9123 193.992 98.9363 193.772 98.9943 193.49C97.2143 188.761 95.7133 184.183 95.3263 179.232C95.3123 179.076 95.3513 178.998 95.4503 178.873C95.6033 178.685 95.6443 178.537 95.4843 178.312C95.1383 177.826 95.2024 177.306 95.5834 176.849C95.6134 176.81 95.6294 176.704 95.6044 176.673C95.3364 176.361 95.2563 175.985 95.3293 175.597C95.4173 174.913 95.4973 174.228 95.5603 173.536C95.5753 173.208 95.7704 172.974 96.0144 172.776C96.2024 172.63 96.2683 172.399 96.1743 172.174C96.0513 171.895 95.9593 171.617 96.0403 171.293C96.1933 170.545 96.4654 169.814 96.7084 169.121C96.9254 168.953 97.1053 168.812 97.2913 168.668C97.3163 168.604 97.3464 168.533 97.3754 168.463C97.4284 168.32 97.4534 168.162 97.5354 168.033C97.7394 167.681 97.7323 167.32 97.6073 166.935C97.7943 166.808 97.9783 166.683 98.1923 166.537C98.9513 164.836 99.9604 163.209 101.091 161.674C101.368 161.276 101.374 161.284 101.448 160.628C101.592 160.581 101.727 160.518 101.869 160.482C102.124 160.423 102.252 160.257 102.306 160.025C102.333 159.873 102.339 159.714 102.357 159.553C102.566 159.49 102.777 159.426 103.041 159.347C106.445 155.827 110.365 153.059 114.965 151.012C115.111 150.949 115.201 150.962 115.358 151.014C115.589 151.079 115.743 151.054 115.895 150.81C116.219 150.277 116.727 150.132 117.319 150.326C117.37 150.339 117.477 150.314 117.497 150.281C117.689 149.912 118.022 149.732 118.403 149.594C119.063 149.335 119.739 149.124 120.413 148.892C120.731 148.78 121.024 148.81 121.319 148.921C121.54 149.007 121.782 148.942 121.936 148.743C122.127 148.497 122.332 148.287 122.665 148.203C123.429 148.018 124.181 147.768 124.915 147.612C125.181 147.708 125.403 147.788 125.631 147.869C125.702 147.857 125.778 147.845 125.857 147.833C126.01 147.8 126.164 147.753 126.32 147.731C126.736 147.681 127.04 147.456 127.287 147.122C127.506 147.199 127.723 147.276 127.973 147.365C129.873 146.99 131.809 146.684 133.787 146.427C134.295 146.365 134.3 146.374 134.828 145.926C134.969 145.988 135.117 146.03 135.25 146.097C135.486 146.224 135.705 146.185 135.91 146.048C136.037 145.952 136.151 145.837 136.275 145.73C136.486 145.822 136.697 145.915 136.961 146.031C142.065 145.377 146.887 144.66 152.004 144.061V144.062C152.166 144.043 152.249 144.083 152.387 144.178C152.594 144.308 152.754 144.329 152.975 144.14C153.454 143.734 153.986 143.733 154.518 144.054C154.565 144.077 154.678 144.081 154.706 144.052C154.995 143.74 155.368 143.646 155.779 143.603C156.499 143.526 157.216 143.442 157.935 143.341C158.274 143.289 158.561 143.388 158.835 143.556C159.039 143.687 159.297 143.674 159.49 143.513C159.728 143.306 159.97 143.129 160.318 143.103C160.793 143.058 161.267 143.014 161.736 142.97C161.408 143.211 161.086 143.464 160.775 143.741C160.581 143.904 160.505 144.243 160.338 144.428C160.126 144.649 159.779 144.7 159.569 144.939C158.563 146.09 157.753 147.483 157.317 149.009C157.268 149.189 157.108 149.382 157.059 149.567C157.018 149.754 157.102 149.923 157.07 150.107C156.903 150.993 156.924 151.906 157.026 152.787C157.233 154.158 157.802 155.548 158.702 156.725C158.872 156.931 159.196 157.054 159.384 157.228C159.607 157.45 159.654 157.812 159.901 158.03C161.086 159.079 162.511 159.813 163.968 160.266C164.142 160.313 164.322 160.473 164.497 160.52C164.672 160.567 164.837 160.512 165.009 160.549C165.429 160.626 165.845 160.701 166.261 160.778C166.677 160.818 167.091 160.858 167.501 160.897C168.761 160.942 170.138 160.883 171.403 160.7C171.632 160.669 171.871 160.432 172.1 160.403C172.381 160.368 172.659 160.538 172.944 160.502C173.635 160.414 174.33 160.325 175.026 160.237L177.102 159.887C177.266 159.858 177.481 159.928 177.643 159.901C177.807 159.874 177.92 159.75 178.082 159.723C178.864 159.609 179.635 159.445 180.391 159.28V159.279C180.522 159.249 180.625 159.225 180.752 159.195L180.773 159.178L180.801 159.162C180.823 159.152 180.848 159.141 180.876 159.129C180.904 159.119 180.937 159.109 180.971 159.098C181.006 159.088 181.044 159.078 181.083 159.068C181.164 159.05 181.253 159.032 181.346 159.01C181.441 158.994 181.538 158.978 181.635 158.961C181.734 158.947 181.83 158.934 181.923 158.922C182.015 158.912 182.103 158.902 182.179 158.895C182.257 158.889 182.325 158.885 182.378 158.881C182.403 158.881 182.427 158.881 182.446 158.881C182.464 158.883 182.478 158.884 182.489 158.885L182.548 158.897L182.607 158.903L182.666 158.906L182.725 158.905L182.841 158.894L182.955 158.873L183.183 158.807L183.412 158.745C183.454 158.734 183.491 158.725 183.524 158.717C183.555 158.707 183.585 158.699 183.612 158.692L183.688 158.661L183.758 158.62C183.781 158.602 183.805 158.583 183.833 158.562C183.859 158.54 183.888 158.513 183.92 158.484C183.984 158.422 184.063 158.344 184.169 158.241L184.211 158.204L184.233 158.19L184.255 158.177L184.276 158.167L184.299 158.16L184.322 158.154L184.347 158.152H184.371L184.396 158.156L184.45 158.168L184.507 158.191L184.568 158.222L184.611 158.244L184.654 158.261L184.699 158.275L184.744 158.283L184.835 158.293H184.926L184.949 158.297L184.971 158.304L184.993 158.311L185.004 158.312L185.015 158.311L185.132 158.29L185.249 158.263L185.481 158.201L185.549 158.178L185.613 158.15L185.672 158.116L185.729 158.08L185.838 158.003L185.948 157.929L186.006 157.897L186.068 157.871L186.135 157.85L186.208 157.837L186.288 157.835C186.315 157.837 186.345 157.84 186.376 157.843C186.407 157.85 186.439 157.857 186.474 157.864L186.525 157.88L186.576 157.899L186.599 157.874L186.626 157.853L186.655 157.833L186.686 157.817L186.752 157.79L186.822 157.769L186.889 157.749L186.952 157.728L186.979 157.714L187.005 157.7L187.027 157.682L187.047 157.662L187.072 157.637L187.105 157.614C187.13 157.6 187.158 157.586 187.188 157.569C187.25 157.544 187.32 157.513 187.384 157.485C187.417 157.47 187.448 157.456 187.476 157.442L187.517 157.421L187.551 157.398L187.582 157.377L187.595 157.365L187.605 157.353L187.612 157.34L187.617 157.327L187.618 157.313L187.617 157.299C187.549 157.002 187.472 156.659 187.387 156.282C187.291 155.888 187.188 155.458 187.078 155.004L186.961 154.521C186.953 154.48 186.945 154.442 186.94 154.407C186.936 154.372 186.933 154.339 186.93 154.305V154.213L186.934 154.123C186.936 154.064 186.936 154.006 186.938 153.941C186.936 153.91 186.932 153.877 186.93 153.841C186.923 153.806 186.916 153.769 186.909 153.728C186.903 153.71 186.896 153.691 186.888 153.667C186.878 153.646 186.867 153.622 186.855 153.596C186.829 153.545 186.797 153.488 186.767 153.431C186.737 153.373 186.705 153.316 186.679 153.266C186.666 153.24 186.657 153.216 186.646 153.195C186.638 153.172 186.631 153.152 186.625 153.135C186.396 152.185 186.18 151.282 185.994 150.507C185.867 149.982 185.734 149.429 185.599 148.864C185.573 148.762 185.346 148.692 185.324 148.591C185.295 148.466 185.468 148.31 185.439 148.183C185.3 147.572 185.162 146.953 185.023 146.337C185.006 146.265 185.089 146.153 185.073 146.081C185.057 146.009 184.943 145.974 184.929 145.901C184.855 145.552 184.781 145.208 184.708 144.868H184.706C184.681 144.759 184.659 144.673 184.634 144.568L184.618 144.55L184.602 144.528C184.594 144.51 184.584 144.489 184.573 144.466C184.564 144.442 184.555 144.416 184.544 144.387C184.536 144.358 184.527 144.326 184.518 144.294C184.503 144.227 184.487 144.153 184.469 144.076C184.456 143.998 184.443 143.916 184.429 143.836C184.418 143.754 184.408 143.673 184.398 143.596C184.391 143.52 184.384 143.447 184.378 143.383C184.376 143.318 184.373 143.261 184.371 143.217C184.372 143.195 184.372 143.176 184.372 143.16C184.376 143.144 184.377 143.132 184.378 143.124L184.392 143.074L184.4 143.024L184.405 142.975L184.406 142.926L184.398 142.829L184.382 142.734L184.334 142.544L184.31 142.45L184.292 142.354C184.284 142.319 184.278 142.288 184.272 142.26C184.265 142.233 184.258 142.208 184.252 142.186L184.229 142.123L184.213 142.093L184.193 142.064C184.177 142.045 184.162 142.025 184.142 142.002C184.122 141.981 184.099 141.956 184.072 141.929C184.017 141.876 183.947 141.81 183.853 141.722L183.82 141.687L183.806 141.669L183.796 141.649L183.788 141.63L183.782 141.61L183.78 141.589V141.569L183.782 141.548L183.786 141.527L183.798 141.498H184.236C184.547 141.5 184.713 141.56 184.961 141.578C185.195 141.607 185.473 141.699 185.731 141.754C186.776 142.055 187.805 142.586 188.758 143.266C188.877 143.354 188.906 143.434 188.932 143.588C188.981 143.804 189.055 143.931 189.327 143.945C189.919 143.97 190.251 144.369 190.292 144.954C190.298 145.002 190.359 145.084 190.397 145.086C190.801 145.1 191.065 145.346 191.316 145.633C191.733 146.156 192.135 146.691 192.499 147.257C192.687 147.515 192.706 147.802 192.64 148.102C192.589 148.325 192.687 148.531 192.905 148.635C193.176 148.762 193.4 148.923 193.527 149.219C193.679 149.557 193.795 149.907 193.915 150.251C194.049 150.592 194.137 150.941 194.207 151.285C194.105 151.537 194.037 151.738 193.946 151.942C193.951 152.007 193.953 152.078 193.963 152.149C193.983 152.289 194.018 152.431 194.025 152.573C194.054 152.95 194.216 153.24 194.503 153.511C194.396 153.697 194.289 153.88 194.166 154.093C194.186 155.834 193.801 157.607 193.043 159.245C192.836 159.659 192.852 159.657 192.93 160.307C192.797 160.374 192.676 160.454 192.545 160.511C192.307 160.603 192.215 160.779 192.203 161.011C192.203 161.161 192.232 161.321 192.232 161.476C192.027 161.555 191.82 161.634 191.562 161.733C190.169 163.637 188.403 165.245 186.457 166.633C184.507 168.024 182.374 169.219 180.062 170.217L180.064 170.223L180.061 170.221C179.933 170.326 179.773 170.457 179.613 170.586L179.488 170.682L179.359 170.772L179.222 170.854L179.152 170.889L179.08 170.918C177.361 171.547 175.642 172.176 173.927 172.803C173.846 172.828 173.768 172.856 173.69 172.881L173.575 172.91L173.462 172.933L173.351 172.953L173.242 172.965L173.133 172.969H173.028C172.971 172.969 172.919 172.969 172.868 172.969C172.815 172.971 172.764 172.975 172.714 172.979C172.663 172.987 172.613 172.995 172.566 173.002L172.493 173.02L172.422 173.04L172.352 173.065L172.282 173.094L172.214 173.129L172.148 173.168L172.082 173.211L172.016 173.262L171.952 173.317L171.89 173.378L171.814 173.45L171.732 173.516L171.64 173.582L171.544 173.643L171.44 173.702L171.334 173.757L171.224 173.808L171.11 173.853L164.095 176.441L156.95 178.648L154.097 179.529L152.67 179.972L152.492 180.027L152.312 180.078L151.952 180.17L151.229 180.354L151.107 180.387L150.992 180.424L150.883 180.467L150.778 180.512L150.678 180.561L150.584 180.616L150.493 180.675L150.407 180.737C150.369 180.766 150.334 180.792 150.3 180.817C150.262 180.84 150.227 180.862 150.194 180.881C150.157 180.901 150.123 180.918 150.09 180.936L149.986 180.979L149.883 181.012L149.781 181.035L149.679 181.051L149.579 181.061L149.479 181.065L149.379 181.063L149.182 181.049C149.052 181.035 148.918 181.022 148.789 181.008C148.68 181.08 148.569 181.154 148.463 181.225L148.298 181.327L148.213 181.372L148.123 181.415L148.031 181.454L147.933 181.487L147.831 181.514L147.722 181.535C147.685 181.541 147.648 181.545 147.607 181.551C147.568 181.553 147.528 181.555 147.485 181.559C147.443 181.557 147.4 181.557 147.354 181.557C147.31 181.555 147.263 181.551 147.214 181.547L147.021 181.533L146.826 181.531L146.631 181.539L146.434 181.557L146.239 181.584L146.044 181.621L145.851 181.668L145.659 181.721L145.375 181.819L145.098 181.926L144.962 181.983L144.83 182.045L144.699 182.111L144.572 182.185C144.515 182.214 144.463 182.244 144.414 182.269C144.359 182.294 144.31 182.316 144.262 182.337C144.209 182.355 144.16 182.372 144.113 182.388L143.966 182.423L143.82 182.443C143.773 182.443 143.724 182.445 143.674 182.447C143.626 182.443 143.576 182.439 143.525 182.435C143.477 182.429 143.425 182.421 143.372 182.412L143.27 182.392L143.166 182.378L142.983 182.431L142.78 182.634C142.78 182.634 142.746 182.966 142.764 183.208C142.77 183.272 142.776 183.335 142.78 183.392L142.788 183.476L142.79 183.515V183.554C142.792 183.663 142.792 183.736 142.793 183.781C142.803 183.924 142.829 184.133 142.858 184.556C142.858 184.556 142.952 184.806 143.124 184.853C143.253 184.888 143.655 184.915 143.655 184.915C144.046 184.954 144.43 184.993 144.772 185.028L144.885 185.044L144.991 185.054L145.094 185.058L145.194 185.056L145.292 185.05L145.388 185.038L145.485 185.02L145.582 184.999L145.653 184.983L145.728 184.973L145.882 184.957L146.105 184.93L146.33 184.909L146.992 185.296L147.08 185.339L147.175 185.38C147.24 185.407 147.307 185.437 147.379 185.466L147.83 185.554L148.279 185.661L149.177 185.876L149.627 185.981L149.739 186.008L149.85 186.041L150.073 186.105L150.961 186.363L151.849 186.621L152.718 186.92L153.584 187.223L154.015 187.373L154.231 187.449L154.337 187.488L154.442 187.533C154.88 187.57 155.253 187.603 155.618 187.637C155.829 187.832 156.015 188.004 156.205 188.18L156.577 188.219L156.952 188.268C156.979 188.274 157.011 188.282 157.043 188.288L157.14 188.317C157.17 188.331 157.2 188.342 157.226 188.352L157.261 188.372L157.29 188.393L157.432 188.53L157.564 188.671L157.697 188.81L157.84 188.947L157.923 189.013L158.008 189.075L158.186 189.192L158.372 189.297L158.564 189.397C158.824 189.522 159.086 189.649 159.343 189.772C159.379 189.79 159.412 189.807 159.444 189.823C159.474 189.841 159.503 189.858 159.53 189.874C159.585 189.903 159.634 189.931 159.68 189.958C159.727 189.979 159.77 190.001 159.813 190.022C159.858 190.04 159.902 190.057 159.95 190.077C159.997 190.093 160.048 190.108 160.105 190.126C160.162 190.142 160.225 190.157 160.297 190.177C160.443 190.212 160.625 190.255 160.867 190.312C160.9 190.322 160.931 190.33 160.961 190.337L161.047 190.372L161.127 190.413L161.201 190.462L161.271 190.521L161.334 190.589L161.394 190.665C161.412 190.692 161.431 190.722 161.451 190.751L161.502 190.829L161.557 190.905L161.619 190.977L161.685 191.047L161.757 191.115L161.833 191.181L161.913 191.243L161.998 191.3L162.183 191.419L162.363 191.546L162.726 191.794C163.326 192.202 163.926 192.61 164.464 192.976C164.628 193.023 164.773 193.064 164.908 193.101L165.009 193.13L165.103 193.163L165.288 193.229L165.41 193.28L165.53 193.335L165.646 193.396L165.761 193.46L165.982 193.603L166.193 193.759L166.392 193.931L166.583 194.113L166.765 194.306L166.939 194.507L167.001 194.587L167.058 194.667L167.158 194.831L167.346 195.163L167.698 195.308L167.786 195.345L167.87 195.386L168.034 195.462C168.084 195.485 168.131 195.509 168.177 195.53L168.31 195.612L168.435 195.702L168.55 195.802L168.658 195.911L168.759 196.028L168.851 196.153L168.937 196.286L169.037 196.458L169.121 196.63L169.279 196.974C169.511 197.087 169.74 197.197 169.965 197.304C170.018 197.331 170.067 197.359 170.115 197.384C170.162 197.413 170.209 197.441 170.254 197.468L170.381 197.56L170.498 197.66L170.605 197.765L170.628 197.792L170.651 197.823L170.693 197.885L170.771 198.014L170.84 198.153L170.986 198.514L171.123 198.871C171.227 198.932 171.318 198.982 171.398 199.029C171.48 199.08 171.549 199.123 171.611 199.16C171.642 199.181 171.672 199.201 171.698 199.219L171.773 199.278L171.84 199.339L171.9 199.4L171.953 199.468L172.004 199.54L172.051 199.622C172.067 199.651 172.082 199.683 172.098 199.716C172.127 199.78 172.16 199.855 172.198 199.941C172.233 200.025 172.272 200.121 172.317 200.232C172.364 200.25 172.403 200.265 172.435 200.279C172.466 200.289 172.492 200.297 172.512 200.302C172.533 200.304 172.549 200.306 172.563 200.308C172.576 200.31 172.586 200.31 172.597 200.312L172.614 200.316L172.631 200.322L172.652 200.332L172.675 200.35C172.694 200.364 172.716 200.381 172.745 200.405C172.772 200.43 172.807 200.46 172.852 200.499L172.853 200.503C172.913 200.569 172.903 200.63 172.864 200.751C172.811 200.927 172.846 201.007 173.048 201.009C173.487 201.011 173.615 201.28 173.478 201.726C173.468 201.763 173.493 201.822 173.523 201.818C173.843 201.785 174.009 201.918 174.14 202.099C174.372 202.413 174.609 202.722 174.859 203.025C174.98 203.166 174.974 203.353 174.897 203.578C174.837 203.744 174.91 203.861 175.095 203.869C175.328 203.875 175.538 203.898 175.648 204.053C175.878 204.414 176.115 204.772 176.316 205.127C176.255 205.318 176.205 205.475 176.154 205.637C176.17 205.672 176.185 205.713 176.207 205.75C176.252 205.822 176.307 205.889 176.34 205.967C176.422 206.18 176.652 206.26 176.977 206.266C176.93 206.416 176.885 206.567 176.832 206.739L177.248 207.407L177.599 208.116L178.307 209.544C178.426 209.788 178.416 209.792 178.901 209.919C178.86 210.013 178.837 210.105 178.79 210.196C178.703 210.358 178.756 210.464 178.897 210.532C178.995 210.571 179.112 210.596 179.222 210.63C179.149 210.773 179.076 210.915 178.985 211.093C179.47 212.366 179.995 213.593 180.325 214.888C180.499 215.533 180.741 216.161 180.862 216.826C180.992 217.488 181.124 218.156 181.257 218.832C181.448 219.775 181.474 220.783 181.581 221.775C181.671 222.771 181.638 223.775 181.694 224.736C181.598 224.836 181.528 224.91 181.457 224.984C181.419 225.021 181.349 225.05 181.329 225.088C181.265 225.213 181.227 225.33 181.415 225.442C181.718 225.624 181.749 225.819 181.452 226.01C181.4 226.041 181.341 226.072 181.315 226.112C181.237 226.233 181.203 226.35 181.383 226.467C181.678 226.653 181.742 226.848 181.447 227.039C181.301 227.135 181.207 227.238 181.209 227.377C181.225 227.721 181.172 228.063 181.149 228.393C181.242 228.485 181.322 228.563 181.402 228.641C181.613 228.856 181.569 229.067 181.423 229.258C181.342 229.369 181.181 229.455 181.045 229.559C180.813 232.008 180.399 234.454 179.783 236.829C179.783 236.829 179.708 237.138 179.614 237.434C179.525 237.735 179.435 238.036 179.435 238.036L179.257 238.544C179.38 238.806 179.423 239.075 179.861 239.239C180 239.292 180.146 239.348 180.287 239.403C180.355 239.428 180.422 239.456 180.49 239.479C180.492 239.481 180.496 239.481 180.498 239.483C180.572 239.508 180.648 239.534 180.719 239.565C180.953 239.67 181.252 239.799 181.443 239.768C181.655 239.762 181.809 239.565 181.887 239.356C181.95 239.184 181.965 239.004 181.914 238.911C181.853 238.811 181.928 238.755 181.862 238.653L181.779 238.319L181.858 238.048C181.996 237.984 182.09 237.925 182.201 237.884C182.484 237.782 182.427 237.603 182.277 237.4C182.173 237.257 182.105 237.125 182.146 236.98C182.28 236.546 182.365 236.101 182.457 235.664C182.562 235.602 182.659 235.547 182.756 235.49C183.063 235.314 183.132 235.045 182.885 234.75C182.75 234.588 182.787 234.496 182.966 234.422C183.086 234.371 183.164 234.309 183.181 234.219C183.299 233.498 183.45 232.783 183.525 232.057C183.538 231.967 183.473 231.879 183.374 231.793C183.33 231.752 183.293 231.707 183.265 231.662C183.113 231.424 183.125 231.207 183.359 231.029C183.533 230.898 183.724 230.781 183.738 230.582L183.832 229.355C183.842 229.263 183.787 229.179 183.678 229.097C183.526 228.974 183.516 228.874 183.688 228.759C184.01 228.542 184.036 228.269 183.75 228.015C183.508 227.796 183.738 227.699 183.912 227.57C183.746 227.424 183.484 227.283 183.793 227.115C183.908 227.051 183.967 226.972 183.971 226.879L184.024 225.24C184.022 224.556 183.981 223.873 183.958 223.189L183.919 222.166L183.812 221.145C183.804 221.057 183.853 220.963 183.962 220.887C184.153 220.75 184.089 220.649 183.913 220.555C183.797 220.494 183.739 220.416 183.729 220.325C183.665 219.829 183.645 219.325 183.534 218.835C183.509 218.72 183.663 218.579 183.725 218.476C183.766 218.404 183.704 218.371 183.76 218.3C183.883 218.144 183.858 218.042 183.672 217.935C183.47 217.812 183.301 217.689 183.28 217.494C183.252 217.269 183.203 217.047 183.168 216.82C183.16 216.779 183.168 216.728 183.196 216.683C183.256 216.591 183.375 216.497 183.39 216.41C183.414 216.26 183.136 216.238 183.078 216.125C182.932 215.836 182.86 215.525 182.794 215.215C182.773 215.129 182.836 215.035 182.899 214.938C183.03 214.739 183.031 214.729 182.79 214.626C182.532 214.515 182.534 214.351 182.679 214.142C182.742 214.048 182.79 213.953 182.857 213.839C182.615 212.821 182.228 211.831 181.849 210.847C181.685 210.777 181.51 210.726 181.376 210.648C181.239 210.568 181.529 210.394 181.478 210.269C181.458 210.226 181.453 210.179 181.427 210.14C181.325 209.97 181.132 209.796 181.232 209.587C181.365 209.306 181.244 209.112 180.978 208.993C180.878 208.948 180.752 208.927 180.642 208.893C180.703 208.743 180.765 208.59 180.833 208.424C180.511 207.772 180.185 207.112 179.858 206.449C179.493 205.705 179.001 205.033 178.577 204.322C178.489 204.187 178.405 204.051 178.321 203.914C178.604 203.937 178.852 204.066 179.096 204.234C179.657 204.617 180.219 204.992 180.793 205.357C181.064 205.527 181.215 205.771 181.307 206.07C181.373 206.295 181.569 206.439 181.809 206.429C182.11 206.409 182.394 206.417 182.661 206.603C183.3 206.998 183.94 207.392 184.548 207.767C184.661 208.013 184.755 208.218 184.851 208.429C184.908 208.468 184.968 208.511 185.031 208.554C185.158 208.634 185.297 208.704 185.417 208.794C185.736 209.038 186.1 209.081 186.495 209.005C186.595 209.204 186.693 209.401 186.807 209.63C188.389 210.589 190.004 211.568 191.617 212.544C192.026 212.794 192.024 212.806 192.679 212.761C192.745 212.892 192.826 213.015 192.885 213.146C192.981 213.386 193.164 213.486 193.397 213.498C193.547 213.496 193.7 213.473 193.856 213.459C193.954 213.658 194.053 213.855 194.176 214.104C198.42 216.401 202.432 218.581 206.723 220.807C206.86 220.875 206.903 220.952 206.959 221.102C207.048 221.317 207.163 221.418 207.44 221.373C208.039 221.281 208.454 221.553 208.699 222.098C208.72 222.141 208.808 222.203 208.845 222.194C209.241 222.081 209.584 222.194 209.93 222.37C210.536 222.677 211.144 222.975 211.762 223.263C212.054 223.396 212.234 223.617 212.363 223.9C212.457 224.113 212.67 224.232 212.908 224.191C213.207 224.134 213.49 224.105 213.781 224.255C214.451 224.589 215.125 224.925 215.765 225.243C215.904 225.481 216.021 225.679 216.138 225.882C216.199 225.917 216.263 225.954 216.329 225.991L216.739 226.188C217.089 226.385 217.458 226.379 217.842 226.25C217.967 226.434 218.091 226.615 218.235 226.826C219.937 227.556 221.675 228.305 223.411 229.051C223.851 229.24 223.851 229.252 224.496 229.117C224.58 229.24 224.678 229.347 224.754 229.471C224.881 229.696 225.077 229.768 225.309 229.748C225.459 229.727 225.607 229.682 225.76 229.648C225.885 229.83 226.01 230.013 226.166 230.242C227.266 230.74 228.395 231.131 229.509 231.535C230.623 231.935 231.731 232.334 232.838 232.732C233.945 233.13 235.053 233.527 236.168 233.929C236.221 233.949 236.273 233.968 236.324 233.986C236.228 234.097 236.151 234.215 236.056 234.318ZM349.185 217.109C348.294 218.091 347.472 219.142 346.468 220.015L344.534 221.839C343.874 222.427 343.285 223.101 342.561 223.618C342.385 223.755 342.202 223.88 342.036 224.03C341.942 224.122 341.485 224.307 341.376 224.362L341.374 224.36C341.261 224.383 341.241 224.467 341.121 224.477C340.857 224.495 340.733 224.598 340.661 224.864C340.577 225.153 340.473 225.419 340.216 225.602L339.337 226.28C339.282 226.323 339.21 226.356 339.141 226.366C338.995 226.384 338.829 226.345 338.705 226.403C338.495 226.501 338.556 226.798 338.422 226.948C338.058 227.313 337.598 227.563 337.161 227.839C337.04 227.917 336.886 227.913 336.731 227.909C336.413 227.905 336.401 227.909 336.297 228.221C336.187 228.555 335.943 228.66 335.615 228.641C335.468 228.635 335.322 228.645 335.148 228.647C334.449 229.106 333.746 229.567 333.041 230.03L330.814 231.235C330.703 231.442 330.618 231.653 330.49 231.833C330.36 232.017 330.121 231.767 329.929 231.874C329.867 231.913 329.794 231.938 329.736 231.981C329.474 232.161 329.195 232.448 328.898 232.417C328.505 232.386 328.197 232.565 327.976 232.899C327.893 233.02 327.838 233.169 327.767 233.303C327.554 233.285 327.335 233.252 327.093 233.205C326.021 233.67 324.937 234.139 323.851 234.609C321.444 235.754 318.878 236.507 316.359 237.375C314.693 238.006 312.935 238.328 311.214 238.785C310.997 238.838 310.777 238.875 310.564 238.945C310.44 238.99 309.947 238.97 309.827 238.974C309.826 238.974 309.826 238.974 309.825 238.974C309.715 238.949 309.66 239.017 309.549 238.976C309.305 238.882 309.149 238.927 308.967 239.14C308.766 239.372 308.558 239.572 308.246 239.632C307.887 239.724 307.516 239.761 307.15 239.825C307.08 239.835 307 239.831 306.932 239.807C306.79 239.752 306.657 239.639 306.517 239.631C306.282 239.617 306.206 239.902 306.019 239.971C305.531 240.149 305.011 240.2 304.499 240.274C304.354 240.297 304.218 240.231 304.077 240.167C303.79 240.034 303.778 240.032 303.553 240.278C303.314 240.54 303.047 240.538 302.757 240.389C302.625 240.325 302.488 240.274 302.329 240.205C300.68 240.539 298.975 240.635 297.288 240.799C297.104 240.945 296.94 241.106 296.753 241.221C296.56 241.34 296.437 241.016 296.22 241.039C296.146 241.051 296.07 241.045 295.997 241.062C295.685 241.124 295.315 241.279 295.052 241.134C294.7 240.95 294.345 240.995 294.011 241.216C293.886 241.296 293.779 241.411 293.661 241.507C293.471 241.402 293.28 241.294 293.073 241.179C291.901 241.226 290.712 241.228 289.524 241.255L285.512 241.325C284.174 241.354 282.838 241.214 281.501 241.165L276.15 240.872C275.927 240.843 275.707 240.8 275.482 240.788C275.35 240.788 274.889 240.595 274.773 240.556V240.554C274.675 240.488 274.601 240.536 274.509 240.456C274.308 240.28 274.144 240.267 273.905 240.403C273.639 240.548 273.38 240.661 273.065 240.608L271.958 240.462C271.888 240.454 271.812 240.427 271.755 240.384C271.636 240.294 271.542 240.148 271.411 240.101C271.189 240.021 271.03 240.275 270.829 240.287C270.308 240.32 269.792 240.223 269.279 240.15C269.133 240.132 269.022 240.031 268.907 239.929C268.672 239.72 268.659 239.716 268.37 239.888C268.061 240.072 267.808 239.995 267.572 239.771C267.464 239.675 267.35 239.576 267.218 239.459C265.558 239.154 263.874 238.846 262.202 238.537C261.982 238.629 261.78 238.74 261.565 238.799C261.348 238.861 261.319 238.518 261.102 238.481C261.026 238.471 260.954 238.448 260.88 238.444C260.561 238.421 260.162 238.469 259.947 238.258C259.657 237.987 259.301 237.934 258.918 238.055C258.776 238.1 258.642 238.18 258.502 238.241C258.347 238.089 258.19 237.938 258.025 237.755C256.882 237.472 255.724 237.187 254.566 236.9L250.659 235.931L248.705 235.449L246.779 234.857L241.646 233.263C241.433 233.195 241.223 233.113 241.003 233.062C240.872 233.037 240.458 232.763 240.353 232.705V232.703C240.269 232.623 240.187 232.654 240.113 232.56C239.95 232.353 239.791 232.31 239.525 232.398C239.232 232.492 238.95 232.554 238.65 232.445L237.603 232.047C237.537 232.022 237.47 231.979 237.423 231.922C237.327 231.805 237.267 231.641 237.15 231.563C236.951 231.434 236.742 231.645 236.544 231.61C236.03 231.52 235.551 231.305 235.068 231.114C234.93 231.061 234.843 230.936 234.752 230.809C234.566 230.549 234.556 230.543 234.239 230.643C233.901 230.752 233.67 230.618 233.488 230.342C233.404 230.219 233.308 230.108 233.201 229.967C231.614 229.381 230.006 228.787 228.406 228.196C228.175 228.237 227.957 228.301 227.737 228.313C227.513 228.325 227.551 227.979 227.347 227.895C227.277 227.87 227.21 227.829 227.14 227.809C226.834 227.717 226.438 227.676 226.269 227.42C226.04 227.088 225.703 226.957 225.308 226.992C225.162 227.004 225.017 227.054 224.87 227.084C224.747 226.898 224.626 226.713 224.493 226.51C223.409 226.043 222.309 225.572 221.212 225.1C219.982 224.563 218.737 224.049 217.513 223.495L213.888 221.72L209.054 219.349C208.854 219.249 208.659 219.134 208.45 219.05C208.325 219.003 207.957 218.671 207.861 218.595C207.793 218.501 207.705 218.521 207.646 218.415C207.517 218.186 207.366 218.118 207.089 218.165C206.782 218.216 206.501 218.222 206.228 218.054L205.251 217.503C205.189 217.468 205.128 217.415 205.091 217.353C205.013 217.224 204.978 217.052 204.872 216.958C204.694 216.802 204.456 216.978 204.265 216.915C203.769 216.751 203.326 216.468 202.875 216.206C202.747 216.136 202.679 215.999 202.606 215.86C202.461 215.575 202.452 215.567 202.123 215.62C201.772 215.679 201.563 215.511 201.423 215.212C201.359 215.079 201.28 214.954 201.194 214.8C199.706 213.986 198.199 213.161 196.7 212.341C196.462 212.357 196.232 212.398 196.009 212.386C195.781 212.376 195.864 212.042 195.669 211.939C195.601 211.906 195.539 211.861 195.471 211.832C195.181 211.697 194.794 211.603 194.661 211.326C194.479 210.965 194.163 210.787 193.768 210.769C193.622 210.761 193.469 210.79 193.321 210.8C193.225 210.597 193.13 210.396 193.025 210.175C192.014 209.564 190.991 208.943 189.967 208.323C187.677 206.909 185.338 205.563 183.081 204.096L178.596 201.11C178.408 200.983 178.231 200.844 178.034 200.733C177.917 200.671 177.593 200.29 177.507 200.204L177.509 200.202C177.451 200.1 177.363 200.108 177.318 199.997C177.217 199.751 177.076 199.663 176.798 199.675C176.492 199.683 176.206 199.665 175.948 199.474L175.02 198.841C174.961 198.802 174.907 198.745 174.875 198.681C174.81 198.546 174.793 198.374 174.695 198.271C174.535 198.103 174.283 198.248 174.097 198.173C173.479 197.476 172.86 196.777 172.234 196.069C171.312 195.188 170.389 194.307 169.492 193.45L166.969 191.405L166.653 191.149L166.573 191.087L166.534 191.056L166.492 191.027L166.325 190.912L165.655 190.453L164.314 189.533L163.643 189.074L162.942 188.664L161.538 187.846L160.835 187.438L160.747 187.387L160.656 187.342L160.473 187.252L160.11 187.07L158.652 186.351L157.923 185.994L157.501 185.818C156.417 184.984 150.825 184.248 149.747 183.408L153.358 182.584L153.499 182.563L153.665 182.524L153.831 182.471L153.997 182.409C154.104 182.36 154.216 182.309 154.329 182.259L154.427 182.202L154.518 182.141L154.686 182.008L154.811 181.916L154.937 181.832L155.065 181.756L155.194 181.686L155.324 181.625L155.455 181.57L155.588 181.521L155.721 181.482L155.856 181.449L155.991 181.422L156.128 181.402L156.265 181.39L156.402 181.384H156.541L156.68 181.392L156.819 181.406L156.905 181.416L156.991 181.418L157.075 181.416L157.16 181.41L157.328 181.387L157.495 181.348L157.661 181.297L157.828 181.238C157.936 181.191 158.05 181.144 158.164 181.095L158.214 181.07L158.259 181.041L158.347 180.979L158.433 180.913L158.523 180.851C158.779 180.697 159.037 180.54 159.381 180.33C160.273 180.057 161.173 179.779 162.081 179.5C162.535 179.359 162.991 179.219 163.448 179.078L164.134 178.865L164.478 178.758L164.65 178.701L164.818 178.639C166.619 177.965 168.439 177.284 170.259 176.604C172.077 175.922 173.899 175.241 175.702 174.565C176.604 174.231 177.502 173.895 178.393 173.565C178.838 173.399 179.284 173.235 179.725 173.071L179.891 173.01L179.974 172.979L180.057 172.942L180.387 172.799L181.045 172.516L181.047 172.512C181.173 172.512 181.221 172.432 181.35 172.45C181.632 172.487 181.799 172.407 181.956 172.157C182.131 171.88 182.322 171.657 182.64 171.503L183.743 170.948C183.813 170.913 183.897 170.889 183.975 170.889C184.137 170.891 184.309 170.953 184.459 170.91C184.711 170.836 184.709 170.543 184.879 170.394C185.32 170.021 185.834 169.755 186.334 169.47C186.474 169.388 186.639 169.39 186.809 169.39C187.15 169.378 187.164 169.369 187.293 169.033C187.428 168.674 187.689 168.547 188.047 168.537C188.208 168.529 188.369 168.506 188.563 168.486C189.1 168.078 189.631 167.652 190.156 167.215C190.469 167.434 190.512 167.445 191.121 167.442C191.177 167.575 191.247 167.7 191.294 167.835C191.37 168.077 191.542 168.185 191.773 168.21C191.921 168.22 192.075 168.204 192.23 168.2C192.312 168.401 192.394 168.602 192.496 168.854C196.414 171.516 200.162 173.975 204.151 176.559C204.277 176.643 204.31 176.723 204.345 176.879C204.407 177.106 204.507 177.217 204.781 177.205C205.374 177.18 205.746 177.498 205.918 178.068C205.936 178.115 206.014 178.185 206.051 178.179C206.447 178.115 206.775 178.255 207.094 178.466C207.655 178.827 208.217 179.183 208.792 179.528C209.064 179.688 209.215 179.924 209.309 180.216C209.377 180.437 209.573 180.575 209.812 180.558C210.112 180.533 210.395 180.531 210.663 180.708C211.284 181.104 211.909 181.503 212.501 181.882C212.607 182.134 212.698 182.341 212.796 182.546C212.853 182.585 212.913 182.626 212.974 182.669C213.101 182.745 213.238 182.814 213.357 182.899C213.673 183.137 214.035 183.174 214.425 183.092C214.524 183.289 214.622 183.485 214.736 183.711C216.31 184.633 217.89 185.613 219.522 186.512C219.935 186.742 219.935 186.752 220.589 186.682C220.657 186.809 220.741 186.926 220.802 187.055C220.904 187.287 221.088 187.377 221.32 187.379C221.471 187.371 221.623 187.342 221.777 187.322C221.881 187.513 221.984 187.705 222.113 187.945C226.277 190.259 230.408 192.125 234.814 194.015C236.375 194.619 237.998 195.245 239.621 195.874C241.268 196.442 242.953 196.921 244.555 197.405C244.696 197.555 244.811 197.641 244.918 197.745C244.973 197.798 245.009 197.878 245.07 197.909C245.271 198.014 245.472 198.091 245.705 197.946C246.08 197.712 246.415 197.745 246.697 198.102C246.742 198.164 246.789 198.233 246.85 198.272C247.048 198.389 247.249 198.463 247.478 198.325C247.839 198.095 248.173 198.095 248.476 198.454C248.626 198.634 248.802 198.763 249.042 198.808C249.65 198.878 250.261 198.949 250.849 199.015C251.007 198.933 251.144 198.861 251.281 198.79C251.65 198.602 252.014 198.671 252.361 198.841C252.56 198.937 252.727 199.111 252.924 199.261C257.319 199.542 261.782 199.154 266.036 197.966L268.181 197.23L269.119 196.921C269.167 196.868 269.208 196.814 269.25 196.761C269.246 196.831 269.243 196.892 269.239 196.966C269.658 197.878 270.246 198.706 270.765 199.579C271.322 200.429 271.79 201.339 272.421 202.143C272.727 202.559 272.723 202.571 273.376 202.819C273.392 202.973 273.427 203.124 273.435 203.274C273.441 203.544 273.583 203.719 273.804 203.831C273.95 203.897 274.105 203.94 274.259 203.995C274.284 204.227 274.31 204.46 274.341 204.751C277.599 208.821 281.255 212.179 285.456 215.233C285.591 215.329 285.626 215.413 285.665 215.577C285.733 215.813 285.843 215.936 286.136 215.946C286.767 215.964 287.161 216.315 287.363 216.921C287.383 216.972 287.467 217.05 287.506 217.048C287.917 217.015 288.283 217.152 288.639 217.372C289.263 217.747 289.891 218.116 290.53 218.474C290.833 218.642 291.013 218.886 291.141 219.189C291.236 219.416 291.453 219.566 291.709 219.539C292.031 219.494 292.336 219.473 292.648 219.631C293.372 219.985 294.099 220.34 294.789 220.678C294.946 220.922 295.078 221.127 295.212 221.334C295.277 221.371 295.348 221.41 295.42 221.451C295.565 221.525 295.721 221.584 295.867 221.65C296.254 221.845 296.649 221.834 297.047 221.697C297.195 221.881 297.34 222.062 297.51 222.273C298.448 222.617 299.374 223.031 300.348 223.318C301.323 223.601 302.303 223.884 303.282 224.17C303.778 224.313 303.78 224.332 304.435 224.115C304.547 224.217 304.672 224.306 304.776 224.412C304.958 224.605 305.18 224.641 305.422 224.576C305.578 224.527 305.725 224.455 305.879 224.392C306.049 224.548 306.221 224.703 306.436 224.898C311.542 225.9 316.518 226.193 321.696 225.695C322.602 225.67 323.515 225.539 324.436 225.4C325.36 225.271 326.291 225.142 327.223 225.013C329.067 224.661 330.895 224.212 332.641 223.777C332.848 223.814 333.002 223.839 333.155 223.867C333.233 223.883 333.307 223.931 333.382 223.928C333.624 223.912 333.851 223.873 333.989 223.625C334.215 223.227 334.542 223.08 334.991 223.238C335.065 223.267 335.143 223.302 335.221 223.302C335.466 223.298 335.692 223.257 335.829 223.017C336.045 222.63 336.355 222.455 336.822 222.603C337.054 222.677 337.286 222.701 337.529 222.607C338.126 222.345 338.722 222.086 339.3 221.834C339.404 221.68 339.494 221.547 339.585 221.414C339.832 221.059 340.205 220.926 340.611 220.894C340.841 220.871 341.083 220.935 341.34 220.962C342.428 220.534 343.424 219.925 344.455 219.386C345.471 218.822 346.517 218.308 347.508 217.7L350.228 215.929L349.185 217.109ZM365.442 176.472C365.291 176.724 365.118 176.949 365.133 177.271C365.145 177.933 365.19 178.597 365.133 179.259C365.119 179.407 365.17 179.536 365.275 179.659C365.422 179.843 365.426 180.007 365.247 180.208C364.911 180.583 364.872 181.015 365.143 181.421C365.376 181.769 365.131 181.939 364.944 182.144C365.094 182.38 365.341 182.617 365.013 182.884C364.89 182.986 364.824 183.111 364.81 183.259C364.767 183.7 364.745 184.142 364.681 184.579L364.444 185.884L363.866 189.155L363.718 189.971L363.499 190.773L363.06 192.373C363.021 192.514 362.926 192.637 362.787 192.709C362.539 192.836 362.547 193.012 362.657 193.23C362.73 193.373 362.743 193.515 362.702 193.662C362.478 194.439 362.31 195.238 362.008 195.994C361.946 196.172 361.709 196.293 361.582 196.406C361.496 196.484 361.524 196.566 361.426 196.636C361.209 196.788 361.157 196.941 361.233 197.204C361.313 197.493 361.362 197.772 361.237 198.063L360.837 199.094C360.812 199.158 360.769 199.225 360.714 199.27C360.599 199.36 360.437 199.413 360.36 199.528C360.233 199.719 360.438 199.94 360.402 200.139C360.333 200.662 360.028 201.094 359.809 201.559C359.745 201.688 359.611 201.764 359.477 201.842C359.201 202 359.193 202.01 359.266 202.33C359.344 202.672 359.189 202.889 358.899 203.041C358.77 203.109 358.651 203.193 358.503 203.283C358.134 204.029 357.794 204.799 357.398 205.539L356.099 207.703C356.109 207.937 356.142 208.164 356.124 208.383C356.104 208.608 355.774 208.514 355.665 208.701C355.63 208.767 355.582 208.826 355.554 208.892C355.464 209.087 355.388 209.324 355.268 209.497C355.19 209.429 355.107 209.374 355.017 209.36C354.626 209.214 353.744 209.899 353.636 210.198C353.585 210.343 353.448 210.38 353.402 210.532L353.108 210.977L352.723 211.274C352.515 211.29 352.36 211.319 352.207 211.313C351.821 211.297 351.673 211.54 351.577 211.86C351.511 212.085 351.416 212.282 351.21 212.436C350.597 212.926 349.925 213.327 349.281 213.758C349.112 213.762 348.954 213.766 348.8 213.77C348.312 213.774 347.917 214.018 347.738 214.499C347.638 214.761 347.482 214.835 347.24 214.798C347.077 214.775 346.932 214.79 346.801 214.874C345.78 215.597 344.653 216.13 343.566 216.739C343.43 216.809 343.349 216.94 343.294 217.094C343.265 217.166 343.226 217.235 343.179 217.299C342.941 217.635 342.611 217.828 342.204 217.811C341.899 217.799 341.612 217.756 341.319 217.928C340.698 218.252 340.043 218.5 339.405 218.789C339.259 218.85 339.163 218.959 339.094 219.113C338.987 219.336 338.836 219.422 338.568 219.361C338.068 219.246 337.645 219.425 337.387 219.869C337.166 220.25 336.899 220.115 336.623 220.051C336.467 220.297 336.346 220.606 335.941 220.422C335.787 220.354 335.637 220.346 335.486 220.395L332.828 221.268C331.732 221.684 330.576 221.873 329.448 222.168C328.312 222.434 327.186 222.754 326.025 222.879C325.873 222.9 325.714 222.863 325.584 222.766C325.354 222.594 325.188 222.672 325.026 222.862C324.922 222.987 324.789 223.057 324.63 223.081C323.784 223.188 322.942 223.376 322.088 223.427C321.891 223.443 321.675 223.277 321.511 223.206C321.4 223.159 321.332 223.22 321.223 223.157C320.985 223.022 320.816 223.038 320.595 223.214C320.349 223.405 320.101 223.564 319.767 223.569L318.602 223.628C318.529 223.632 318.447 223.618 318.381 223.587C318.245 223.517 318.128 223.399 317.985 223.362C317.746 223.303 317.618 223.571 317.41 223.6C316.876 223.68 316.329 223.631 315.788 223.606C315.636 223.6 315.509 223.51 315.378 223.418C315.11 223.232 315.099 223.229 314.817 223.426C314.516 223.637 314.242 223.584 313.977 223.383C313.856 223.293 313.727 223.221 313.58 223.119C312.71 223.021 311.833 222.922 310.954 222.824C310.077 222.719 309.19 222.658 308.329 222.451C308.104 222.537 307.897 222.644 307.676 222.699C307.45 222.756 307.416 222.41 307.191 222.367C307.115 222.357 307.039 222.33 306.962 222.324C306.632 222.295 306.216 222.332 305.993 222.117C305.695 221.838 305.328 221.777 304.927 221.89C304.781 221.919 304.64 221.988 304.495 222.035C304.343 221.861 304.188 221.689 304.02 221.502C302.85 221.148 301.647 220.844 300.473 220.445C299.176 219.937 297.863 219.463 296.573 218.931L292.803 217.109L290.393 215.695L289.188 214.986L288.043 214.183C287.853 214.048 287.671 213.9 287.47 213.779C287.348 213.711 287.018 213.312 286.933 213.22H286.932C286.875 213.118 286.786 213.12 286.741 213.007C286.643 212.755 286.501 212.661 286.213 212.659C285.894 212.655 285.596 212.622 285.355 212.389L284.464 211.635C284.407 211.588 284.357 211.524 284.328 211.453C284.272 211.308 284.268 211.133 284.181 211.017C284.03 210.824 283.755 210.947 283.572 210.843C283.1 210.57 282.693 210.206 282.295 209.839C282.188 209.73 282.152 209.575 282.115 209.417C282.041 209.095 282.033 209.083 281.699 209.042C281.34 208.999 281.174 208.774 281.111 208.44C281.08 208.292 281.034 208.147 280.989 207.971C279.685 206.791 278.556 205.416 277.386 204.09C277.152 204.018 276.917 203.971 276.704 203.875C276.483 203.781 276.683 203.494 276.546 203.311C276.497 203.25 276.459 203.18 276.405 203.125C276.182 202.881 275.85 202.635 275.829 202.32C275.79 201.908 275.559 201.617 275.19 201.435C275.053 201.367 274.897 201.331 274.752 201.277C274.738 201.052 274.724 200.826 274.709 200.582C273.971 199.605 273.389 198.506 272.715 197.467C271.934 196.309 271.387 195.02 270.731 193.787C270.048 192.566 269.598 191.242 269.057 189.957L268.534 188.662L268.12 187.33L267.3 184.66C267.224 184.439 267.207 184.203 267.14 183.978C267.097 183.847 267.126 183.326 267.126 183.201C267.126 182.951 267.155 183.103 267.284 182.869C266.876 182.476 266.875 182.473 267.08 181.939C266.967 181.834 266.852 181.734 266.743 181.621C266.579 181.439 266.546 181.236 266.634 180.986C266.685 180.851 266.735 180.715 266.785 180.576C266.669 180.469 266.542 180.371 266.446 180.246C266.294 180.057 266.27 179.838 266.387 179.605C266.453 179.474 266.502 179.334 266.561 179.199C266.456 179.084 266.332 178.984 266.26 178.849C266.076 178.505 265.998 178.134 266.171 177.751C266.239 177.612 266.307 177.476 266.395 177.298C266.356 176.956 266.313 176.575 266.269 176.196C266.251 176.044 266.237 175.887 266.202 175.737C266.177 175.592 266.108 175.458 265.985 175.352C265.842 175.229 265.813 175.114 265.887 174.975C266.164 174.455 266.172 174.455 266.153 174.121C266.13 173.82 266.194 173.504 266.048 173.221C265.976 173.084 265.86 172.973 265.784 172.838C265.759 172.793 265.786 172.707 265.815 172.649C265.872 172.518 265.941 172.395 266.008 172.268C265.916 172.141 265.824 172.016 265.72 171.872C265.824 171.69 265.931 171.503 266.057 171.28C266.118 170.173 266.18 169.038 266.241 167.911C266.618 166.753 266.909 165.614 267.17 164.432C267.271 163.985 267.288 163.981 267.007 163.401C267.105 163.299 267.189 163.186 267.29 163.092C267.478 162.928 267.503 162.731 267.43 162.518C267.374 162.381 267.298 162.254 267.224 162.12C267.366 161.964 267.507 161.808 267.685 161.613C267.878 160.282 267.997 158.963 268.051 157.642C268.109 157.443 268.169 157.244 268.228 157.044C268.4 157.965 268.645 158.872 268.96 159.755C269.038 159.968 269.103 160.186 269.198 160.395C269.251 160.519 269.309 161.007 269.344 161.124C269.338 161.238 269.42 161.284 269.4 161.399C269.354 161.653 269.432 161.809 269.682 161.957C269.948 162.127 270.208 162.283 270.349 162.57C270.523 162.902 270.7 163.234 270.897 163.554C270.934 163.613 270.961 163.687 270.964 163.757C270.967 163.902 270.911 164.06 270.959 164.193C271.043 164.418 271.348 164.392 271.488 164.541C271.851 164.928 272.153 165.353 272.451 165.783C272.539 165.9 272.539 166.056 272.555 166.207C272.582 166.518 272.59 166.535 272.923 166.613C273.277 166.695 273.408 166.92 273.434 167.254C273.448 167.404 273.478 167.553 273.512 167.723C274.656 168.994 275.901 170.143 277.187 171.241C277.422 171.264 277.653 171.261 277.866 171.307C278.083 171.352 277.946 171.668 278.12 171.801C278.18 171.844 278.231 171.901 278.294 171.938C278.558 172.108 278.926 172.241 279.028 172.518C279.167 172.885 279.465 173.088 279.852 173.137C279.995 173.155 280.146 173.137 280.291 173.139C280.371 173.34 280.451 173.543 280.537 173.762C281.49 174.422 282.484 175.039 283.486 175.641C285.749 176.981 288.103 178.149 290.506 179.176C292.11 179.864 293.735 180.492 295.379 181.059C295.584 181.131 295.785 181.215 295.998 181.272C296.123 181.299 296.519 181.577 296.623 181.639C296.702 181.723 296.783 181.69 296.853 181.785C297.009 181.998 297.167 182.035 297.425 181.943C297.709 181.845 297.98 181.779 298.271 181.884L299.304 182.21C299.37 182.228 299.437 182.265 299.486 182.315C299.586 182.42 299.653 182.579 299.773 182.643C299.975 182.752 300.166 182.526 300.361 182.541C300.867 182.576 301.342 182.756 301.83 182.883C301.967 182.916 302.062 183.029 302.162 183.143C302.367 183.377 302.38 183.385 302.676 183.245C302.99 183.097 303.225 183.2 303.432 183.452C303.527 183.561 303.631 183.663 303.752 183.786C305.358 184.143 306.994 184.466 308.627 184.745C308.84 184.647 309.033 184.53 309.239 184.462C309.449 184.396 309.486 184.737 309.697 184.767C309.77 184.775 309.842 184.796 309.913 184.798C310.223 184.81 310.605 184.749 310.823 184.954C311.117 185.212 311.469 185.241 311.83 185.099C311.965 185.046 312.088 184.956 312.217 184.888C312.379 185.031 312.541 185.177 312.718 185.333C313.852 185.479 315.008 185.581 316.16 185.687C318.756 185.91 321.365 185.996 323.971 185.988C325.707 185.978 327.447 185.924 329.18 185.793C329.398 185.781 329.616 185.783 329.832 185.752C329.959 185.734 330.434 185.83 330.552 185.842C330.657 185.887 330.719 185.824 330.823 185.883C331.049 186.01 331.21 185.99 331.411 185.807C331.635 185.608 331.858 185.442 332.167 185.428C332.528 185.408 332.886 185.346 333.245 185.311C333.313 185.303 333.39 185.311 333.454 185.338C333.588 185.399 333.712 185.518 333.849 185.531C334.078 185.554 334.165 185.271 334.351 185.211C334.831 185.055 335.335 185 335.835 184.936C335.976 184.915 336.108 184.981 336.247 185.047C336.528 185.184 336.543 185.186 336.76 184.943C336.989 184.677 337.245 184.673 337.536 184.816C337.667 184.878 337.804 184.925 337.964 184.992C339.589 184.691 341.22 184.289 342.831 183.859C342.985 183.689 343.112 183.492 343.27 183.345C343.431 183.193 343.612 183.488 343.817 183.421C343.886 183.396 343.962 183.386 344.026 183.357C344.314 183.234 344.635 183.017 344.922 183.101C345.301 183.201 345.636 183.074 345.9 182.785C345.998 182.68 346.07 182.545 346.156 182.426C346.367 182.485 346.58 182.541 346.809 182.604C347.894 182.204 348.986 181.774 350.06 181.295C352.486 180.225 354.791 178.94 356.977 177.32C358.443 176.24 359.816 175.029 361.001 173.654C361.16 173.49 361.317 173.324 361.444 173.133C361.514 173.022 361.928 172.717 362.026 172.633H362.028C362.138 172.578 362.133 172.494 362.256 172.449C362.523 172.349 362.606 172.195 362.595 171.928C362.582 171.629 362.594 171.356 362.786 171.098C363.003 170.789 363.167 170.452 363.36 170.129C363.395 170.068 363.449 170.008 363.512 169.967C363.645 169.883 363.828 169.84 363.912 169.723C364.058 169.528 363.861 169.311 363.91 169.118C364.051 168.622 364.272 168.147 364.448 167.653C364.498 167.516 364.625 167.421 364.752 167.321C364.805 167.282 364.838 167.253 364.87 167.223L364.949 167.657L365.066 168.755C364.992 168.901 364.921 169.036 364.853 169.169C364.632 169.585 364.665 170.023 365.007 170.376C365.194 170.571 365.187 170.735 365.042 170.925C364.946 171.054 364.894 171.183 364.907 171.331L365.091 173.089C365.132 173.677 365.114 174.267 365.13 174.857C365.13 175.002 365.206 175.125 365.318 175.238C365.367 175.293 365.411 175.355 365.445 175.422C365.63 175.775 365.649 176.137 365.442 176.472Z",
                fill: "black"
            })
        })
    };
    return Icons[iconName];
};
/* harmony default export */ __webpack_exports__["default"] = (ToastIcons);


/***/ }),

/***/ 94842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TV": function() { return /* reexport */ AddTypefaceToCart; },
  "VD": function() { return /* reexport */ CartSummary; },
  "Z1": function() { return /* reexport */ CheckoutLineItem; },
  "Ar": function() { return /* reexport */ Layout/* Layout */.A; },
  "m8": function() { return /* reexport */ OrdersTable; },
  "tl": function() { return /* reexport */ global_Pagination/* Pagination */.t; },
  "T9": function() { return /* reexport */ SavedAddressSelectionList; },
  "$j": function() { return /* reexport */ components_Spinner/* Spinner */.$; }
});

// UNUSED EXPORTS: AddressBookCard, ProductCollection, VariantSelector

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var global_Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Table/index.tsx + 1 modules
var Table = __webpack_require__(19521);
// EXTERNAL MODULE: ./components/providers/RegionsProvider.tsx + 10 modules
var RegionsProvider = __webpack_require__(60239);
// EXTERNAL MODULE: ./lib/checkout/migratedOrders.ts
var migratedOrders = __webpack_require__(42748);
// EXTERNAL MODULE: ./lib/hooks/mediaQuery.ts
var mediaQuery = __webpack_require__(99182);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./components/account/OrdersTable/OrdersTable.module.scss
var OrdersTable_module = __webpack_require__(92954);
var OrdersTable_module_default = /*#__PURE__*/__webpack_require__.n(OrdersTable_module);
;// CONCATENATED MODULE: ./components/account/OrdersTable/OrdersTable.tsx









var OrdersTable = function(param1) {
    var orders = param1.orders;
    var router = (0,next_router.useRouter)();
    var paths = (0,lib_paths/* usePaths */._)();
    var formatPrice = (0,RegionsProvider/* useRegions */.eH)().formatPrice;
    var screen = (0,mediaQuery/* useScreenSize */.e)();
    var migratedOrder = function(order) {
        return (0,migratedOrders/* isMigratedOrder */.RZ)(order);
    };
    var InvoiceRow = function(param) {
        var order = param.order;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
            className: (OrdersTable_module_default()).OrdersTable,
            children: [
                screen === "Mobile" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OrdersTable_module_default()).OrdersTableMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                            children: [
                                "Order #",
                                order === null || order === void 0 ? void 0 : order.number
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order.created.slice(0, 10)
                        }),
                        formatPrice(order.total.gross)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                    children: [
                        "Order #",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (OrdersTable_module_default()).digits,
                            children: order === null || order === void 0 ? void 0 : order.number
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (OrdersTable_module_default()).digits,
                    children: order.created.slice(0, 10)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                    variant: "secondary",
                    backgroundColor: "transparent",
                    callBack: function() {
                        return router.push(paths.account.orders._token(order.token).$url());
                    },
                    children: migratedOrder(order) ? "MIGRATED ORDER" : order.status
                }),
                screen !== "Mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (OrdersTable_module_default()).digits,
                    children: formatPrice(order.total.gross)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OrdersTable_module_default()).OrdersTableContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.iA, {
            cssVars: {
                "--set-table-row-padding": "24px"
            },
            children: orders.map(function(order, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceRow, {
                    order: order
                }, i);
            })
        })
    });
};
/* harmony default export */ var OrdersTable_OrdersTable = ((/* unused pure expression or super */ null && (OrdersTable)));

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.34.2_react@18.0.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(67128);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(12902);
// EXTERNAL MODULE: ./components/global/InputField/index.tsx + 1 modules
var InputField = __webpack_require__(22621);
// EXTERNAL MODULE: ./components/global/Panel/Panel.tsx
var Panel = __webpack_require__(82184);
// EXTERNAL MODULE: ./components/global/Panel/PanelContent.tsx
var PanelContent = __webpack_require__(74819);
// EXTERNAL MODULE: ./components/global/Toast/index.tsx + 16 modules
var Toast = __webpack_require__(81530);
// EXTERNAL MODULE: ./lib/datalayer/checkout.ts
var datalayer_checkout = __webpack_require__(74198);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
// EXTERNAL MODULE: ./components/global/Panel/PanelHeader.tsx
var PanelHeader = __webpack_require__(21252);
// EXTERNAL MODULE: ./components/translations.ts + 2 modules
var translations = __webpack_require__(33525);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
// EXTERNAL MODULE: ./components/global/Panel/index.ts
var global_Panel = __webpack_require__(12490);
// EXTERNAL MODULE: ./components/cart/CartDiscount.module.scss
var CartDiscount_module = __webpack_require__(93841);
var CartDiscount_module_default = /*#__PURE__*/__webpack_require__.n(CartDiscount_module);
;// CONCATENATED MODULE: ./components/cart/CartDiscount.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var CartDiscount = function(param) {
    var panelVariant = param.panelVariant, promoCode = param.promoCode, checkoutToken = param.checkoutToken, handleSubmitForm = param.handleSubmitForm, registerForm = param.registerForm, setErrorForm = param.setErrorForm, formErrors = param.formErrors;
    var ref4;
    var query = (0,RegionsProvider/* useRegions */.eH)().query;
    var ref1 = _slicedToArray((0,api/* useCheckoutAddPromoCodeMutation */.mT3)(), 1), checkoutAddPromoCodeMutation = ref1[0];
    var ref2 = _slicedToArray((0,api/* useCheckoutRemovePromoCodeMutation */.NMd)(), 1), checkoutRemovePromoCodeMutation = ref2[0];
    var onAddPromoCode = handleSubmitForm(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(formData) {
            var ref, ref3, promoMutationData, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return checkoutAddPromoCodeMutation({
                            variables: {
                                promoCode: formData.promoCode,
                                token: checkoutToken,
                                locale: query.locale
                            }
                        });
                    case 3:
                        ref3 = _ctx.sent;
                        promoMutationData = ref3.data;
                        errors = promoMutationData === null || promoMutationData === void 0 ? void 0 : (ref = promoMutationData.checkoutAddPromoCode) === null || ref === void 0 ? void 0 : ref.errors;
                        if (!!errors && errors.length > 0) {
                            setErrorForm("promoCode", {
                                message: errors[0].message || "Error"
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }());
    var onRemovePromoCode = handleSubmitForm(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(formData) {
            var ref, ref5, promoMutationData, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return checkoutRemovePromoCodeMutation({
                            variables: {
                                promoCode: formData.promoCode,
                                token: checkoutToken,
                                locale: query.locale
                            }
                        });
                    case 3:
                        ref5 = _ctx.sent;
                        promoMutationData = ref5.data;
                        errors = promoMutationData === null || promoMutationData === void 0 ? void 0 : (ref = promoMutationData.checkoutRemovePromoCode) === null || ref === void 0 ? void 0 : ref.errors;
                        if (!!errors && errors.length > 0) {
                            setErrorForm("promoCode", {
                                message: errors[0].message || "Error"
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CartDiscount_module_default()).CartDiscount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Panel/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelHeader/* default */.Z, {
                    variant: "xs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "u-h6",
                        children: "Discount Code / Gift Card"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelContent/* default */.Z, {
                    variant: panelVariant,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: onAddPromoCode,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (CartDiscount_module_default()).FormDescription,
                                    children: promoCode ? "Your discount code has been applied!" : "If you have a discount code, please apply the code here."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (CartDiscount_module_default()).DiscountField,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* default */.Z, _objectSpread({
                                            type: "text",
                                            name: "discount-code",
                                            label: "Discount Code",
                                            hasBorder: true,
                                            className: (CartDiscount_module_default()).Input,
                                            placeholder: "ILOVEFONTS",
                                            isDisabled: !!promoCode
                                        }, registerForm("promoCode", {
                                            required: true
                                        }))),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, _objectSpread({
                                            className: (CartDiscount_module_default()).button,
                                            size: "l",
                                            type: promoCode ? "button" : "submit"
                                        }, promoCode && {
                                            callBack: onRemovePromoCode
                                        }, {
                                            children: [
                                                promoCode ? "Remove" : "Apply",
                                                " Discount"
                                            ]
                                        }))
                                    ]
                                }),
                                !!formErrors.promoCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: (ref4 = formErrors.promoCode) === null || ref4 === void 0 ? void 0 : ref4.message
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/cart/CartSummary.module.scss
var CartSummary_module = __webpack_require__(63208);
var CartSummary_module_default = /*#__PURE__*/__webpack_require__.n(CartSummary_module);
// EXTERNAL MODULE: ./components/cart/partials/index.ts + 1 modules
var partials = __webpack_require__(90425);
;// CONCATENATED MODULE: ./components/cart/CartSummary.tsx



















var didInit = false;
var CartSummary = function(param) {
    var checkout = param.checkout, checkoutToken = param.checkoutToken, isCheckout = param.isCheckout, _panelVariant = param.panelVariant, panelVariant = _panelVariant === void 0 ? "md" : _panelVariant;
    var router = (0,next_router.useRouter)();
    var t = (0,components_useIntl/* default */.Z)();
    var paths = (0,lib_paths/* usePaths */._)();
    var subtotalPrice = checkout.subtotalPrice, shippingPrice = checkout.shippingPrice, shippingMethod = checkout.shippingMethod, totalPrice = checkout.totalPrice, discount = checkout.discount, voucherCode = checkout.voucherCode;
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            promoCode: voucherCode
        }
    }), registerForm = ref.register, handleSubmitForm = ref.handleSubmit, _formState = ref.formState, errorsForm = _formState.errors, setErrorForm = ref.setError;
    var formatPrice = (0,RegionsProvider/* useRegions */.eH)().formatPrice;
    var clipboardButtonStateToTextMap = {
        default: "Copy To Clipboard",
        success: "Copied!",
        error: "Error!"
    };
    var ref1 = (0,react.useState)(false), isShowingShareToast = ref1[0], setIsShowingShareToast = ref1[1];
    var shareUrl =  true ? "".concat(window.location.origin).concat(paths.sharecart._cartId(checkoutToken).$url().pathname.replace("[cartId]", "".concat(paths.sharecart._cartId(checkoutToken).$url().query.cartId))) : 0;
    var onlyFontsInTheCart = (0,util/* onlyFontsInCart */.bk)(checkout);
    var toggleShareToast = function() {
        setIsShowingShareToast(!isShowingShareToast);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (CartSummary_module_default()).cartSummary,
            isCheckout ? (CartSummary_module_default()).cartSummaryCheckout : "",
            panelVariant === "zero" ? (CartSummary_module_default()).noCartSummaryPadding : ""
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel/* default */.Z, {
                children: [
                    !isCheckout && /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelHeader/* default */.Z, {
                        variant: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "u-h6",
                            children: "Summary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelContent/* default */.Z, {
                        variant: panelVariant,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        className: (CartSummary_module_default()).cartTotals,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        children: t.formatMessage(translations/* messages.subtotal */.s.subtotal)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        children: formatPrice(subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.net)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (CartSummary_module_default()).cartTotals__Shipping,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        children: "".concat(t.formatMessage(translations/* messages.shipping */.s.shipping), " ").concat((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.name) ? "-  (".concat(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.name, ")") : "")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        children: onlyFontsInTheCart ? "N/A" : formatPrice(shippingPrice === null || shippingPrice === void 0 ? void 0 : shippingPrice.gross)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (CartSummary_module_default()).cartTotals__Tax,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        children: t.formatMessage(translations/* messages.tax */.s.tax)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        children: formatPrice(subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.tax)
                                                    })
                                                ]
                                            }),
                                            !!(discount === null || discount === void 0 ? void 0 : discount.amount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (CartSummary_module_default()).cartTotals__Discount,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                        children: [
                                                            "Discount Code ",
                                                            voucherCode && "[".concat(voucherCode, "]")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        children: formatPrice(discount)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (CartSummary_module_default()).cartTotals__grandTotal,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        children: t.formatMessage(translations/* messages.total */.s.total)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        children: formatPrice(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.gross)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            !isCheckout && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDiscount, {
                promoCode: voucherCode,
                formErrors: errorsForm,
                setErrorForm: setErrorForm,
                checkoutToken: checkoutToken,
                handleSubmitForm: handleSubmitForm,
                registerForm: registerForm,
                panelVariant: panelVariant
            }),
            router.pathname !== "/checkout" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CartSummary_module_default()).cartActions,
                children: [
                    isShowingShareToast && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* Toast */.FN, {
                        title: "Share your Cart",
                        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageBody */.ww, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Need to share the cart with your collaborator, colleague or client to checkout and license? Please copy and paste the link below."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toast/* ToastMessageBody */.ww, {
                                    className: (CartSummary_module_default()).CartSummary__CopyUrlRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* default */.Z, {
                                            onWhite: true,
                                            label: "shareUrl",
                                            type: "text",
                                            name: "shareUrl",
                                            value: shareUrl
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials/* CopyToClipboardButton */.m, {
                                            shareUrl: shareUrl
                                        })
                                    ]
                                })
                            ]
                        }),
                        position: "center",
                        onClose: function() {
                            toggleShareToast();
                        },
                        asModal: true,
                        type: "basic"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                        callBack: function() {
                            toggleShareToast();
                        },
                        className: (CartSummary_module_default()).modalTriggerSplit,
                        type: "button",
                        size: "l",
                        variant: "secondary",
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                        // add 'begin_checkout' to the dataLayer
                        callBack: function() {
                            return datalayer_checkout/* default.beginCheckout */.Z.beginCheckout((checkout === null || checkout === void 0 ? void 0 : checkout.lines) || []);
                        },
                        href: paths.checkout.$url(),
                        variant: "primary",
                        size: "l",
                        children: t.formatMessage(translations/* messages.checkoutButton */.s.checkoutButton)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/image.js
var next_image = __webpack_require__(96434);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/global/CustomFont/index.tsx
var CustomFont = __webpack_require__(34316);
// EXTERNAL MODULE: ./components/global/FontLoader/index.tsx
var FontLoader = __webpack_require__(53409);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/providers/CheckoutProvider.tsx + 2 modules
var CheckoutProvider = __webpack_require__(34639);
// EXTERNAL MODULE: ./lib/fonts/s3FontPath.ts
var s3FontPath = __webpack_require__(57189);
// EXTERNAL MODULE: ./lib/fonts/variantName.ts
var fonts_variantName = __webpack_require__(27562);
// EXTERNAL MODULE: ./lib/productHelpers.tsx
var productHelpers = __webpack_require__(11603);
// EXTERNAL MODULE: ./components/checkout/CustomisedFontMetadata/index.ts + 1 modules
var CustomisedFontMetadata = __webpack_require__(38680);
// EXTERNAL MODULE: ./components/checkout/CheckoutLineItem/CheckoutLineItem.module.scss
var CheckoutLineItem_module = __webpack_require__(23987);
var CheckoutLineItem_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutLineItem_module);
;// CONCATENATED MODULE: ./components/checkout/CheckoutLineItem/CheckoutLineItem.tsx
function CheckoutLineItem_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CheckoutLineItem_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CheckoutLineItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CheckoutLineItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CheckoutLineItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CheckoutLineItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CheckoutLineItem_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CheckoutLineItem_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CheckoutLineItem_slicedToArray(arr, i) {
    return CheckoutLineItem_arrayWithHoles(arr) || CheckoutLineItem_iterableToArrayLimit(arr, i) || CheckoutLineItem_unsupportedIterableToArray(arr, i) || CheckoutLineItem_nonIterableRest();
}
function CheckoutLineItem_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CheckoutLineItem_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CheckoutLineItem_arrayLikeToArray(o, minLen);
}























var CheckoutLineItem = function(param1) {
    var line1 = param1.line, disableChanges = param1.disableChanges, licencingButton = param1.licencingButton, _isCartOwner = param1.isCartOwner, isCartOwner = _isCartOwner === void 0 ? false : _isCartOwner, isCheckout = param1.isCheckout, isOrder = param1.isOrder;
    var ref23, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var paths = (0,lib_paths/* usePaths */._)();
    var t = (0,components_useIntl/* default */.Z)();
    var ref14 = (0,RegionsProvider/* useRegions */.eH)(), query = ref14.query, formatPrice = ref14.formatPrice;
    var ref15 = (0,CheckoutProvider/* useCheckout */.Mg)(), token = ref15.checkoutToken;
    var ref16 = CheckoutLineItem_slicedToArray((0,api/* useCheckoutLineUpdateMutation */.mLW)(), 2), checkoutLineUpdateMutation = ref16[0], ref17 = ref16[1], loadingLineUpdate = ref17.loading;
    var ref18 = CheckoutLineItem_slicedToArray((0,api/* useRemoveProductFromCheckoutMutation */.Sb_)(), 1), removeProductFromCheckout = ref18[0];
    var ref19 = (0,react.useState)(), quantity = ref19[0], setQuantity = ref19[1];
    var ref20 = (0,react.useState)(null), changed = ref20[0], setChanged = ref20[1];
    var ref21 = (0,react.useState)(null), errors1 = ref21[0], setErrors = ref21[1];
    (0,react.useEffect)(function() {
        if (!line1) return;
        setQuantity(line1.quantity);
    }, [
        line1
    ]);
    var changeLineState = function(event) {
        var ref, ref22;
        if (!(event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : (ref22 = ref.validity) === null || ref22 === void 0 ? void 0 : ref22.valid)) return;
        setQuantity(event.target.value);
    };
    var onQuantityUpdate = function() {
        var _ref = CheckoutLineItem_asyncToGenerator(runtime_default().mark(function _callee(event, value) {
            var ref, ref24, ref25, ref26, ref27, result, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (value) {
                            _ctx.next = 6;
                            break;
                        }
                        ;
                        changeLineState(event);
                        if (!(!(event === null || event === void 0 ? void 0 : (ref25 = event.target) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.validity) === null || ref26 === void 0 ? void 0 : ref26.valid) || (event === null || event === void 0 ? void 0 : (ref27 = event.target) === null || ref27 === void 0 ? void 0 : ref27.value) === "")) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return checkoutLineUpdateMutation({
                            variables: {
                                token: token,
                                lines: [
                                    {
                                        quantity: value ? value : parseFloat(event.target.value),
                                        variantId: (line1 === null || line1 === void 0 ? void 0 : line1.variant.id) || ""
                                    }
                                ],
                                locale: query.locale
                            }
                        });
                    case 8:
                        result = _ctx.sent;
                        errors = (ref = result.data) === null || ref === void 0 ? void 0 : (ref24 = ref.checkoutLinesUpdate) === null || ref24 === void 0 ? void 0 : ref24.errors;
                        if (errors && errors.length > 0) {
                            setErrors(errors);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onQuantityUpdate(event, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onMobileKeyboardClick = function(method) {
        if (method === "plus") {
            setQuantity(quantity + 1);
        } else if (method === "minus") {
            setQuantity(quantity > 1 ? quantity - 1 : 1);
        }
        setChanged(true);
    };
    (0,react.useEffect)(function() {
        if (changed) {
            var timer = setTimeout(function() {
                setChanged(false);
                onQuantityUpdate(undefined, quantity);
            }, 1500);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        quantity,
        changed
    ]);
    if (!line1) return null;
    var productHasImage = function(line) {
        var ref, ref28, ref29;
        return (ref = line.variant) === null || ref === void 0 ? void 0 : (ref28 = ref.product) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.thumbnail) === null || ref29 === void 0 ? void 0 : ref29.url;
    };
    var productIsFont = function(line) {
        return (0,productHelpers/* isFontItem */.H_)(line) || (0,productHelpers/* isCustomisedFont */.lp)(line);
    };
    var productIsFontFamily = function(line) {
        return productIsFont(line) && (0,productHelpers/* isFamilyVariant */.S5)(line.variant);
    };
    var productLineItemClass = isOrder || isCheckout ? (CheckoutLineItem_module_default()).lineItemProduct : (CheckoutLineItem_module_default()).lineItemProductCart;
    var getFontS3Path = function(line) {
        var ref;
        if (productIsFontFamily(line)) {
            var ref30;
            return (0,s3FontPath/* generateFamilyVariantS3Path */.z7)(line === null || line === void 0 ? void 0 : (ref30 = line.variant) === null || ref30 === void 0 ? void 0 : ref30.product.slug, line === null || line === void 0 ? void 0 : line.variant);
        }
        if ((0,productHelpers/* isCustomisedFont */.lp)(line)) {
            var itemCustomiserMetadata = line === null || line === void 0 ? void 0 : line.metadata.find(function(param) {
                var key = param.key;
                return key === "itemCustomiser";
            });
            var itemCustomiserMetadataValue = JSON.parse(itemCustomiserMetadata.value);
            var _itemCustomiserMetadataValue = CheckoutLineItem_slicedToArray(itemCustomiserMetadataValue, 1), itemCustomiser = _itemCustomiserMetadataValue[0];
            return (0,util/* updateFontsToWebfont */.cw)({
                font: itemCustomiser.fontPathSrc
            });
        }
        return (0,s3FontPath/* generateVariantS3Path */.MH)(line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : ref.product.slug, line === null || line === void 0 ? void 0 : line.variant.sku);
    };
    var getFontName = function(line) {
        if ((0,productHelpers/* isCustomisedFont */.lp)(line)) {
            var itemCustomiserMetadata = line === null || line === void 0 ? void 0 : line.metadata.find(function(param) {
                var key = param.key;
                return key === "itemCustomiser";
            });
            var itemCustomiserMetadataValue = JSON.parse(itemCustomiserMetadata.value);
            var _itemCustomiserMetadataValue = CheckoutLineItem_slicedToArray(itemCustomiserMetadataValue, 1), itemCustomiser = _itemCustomiserMetadataValue[0];
            return itemCustomiser.fontStyle;
        }
        return line === null || line === void 0 ? void 0 : line.variant.sku;
    };
    var fontVariantName = function(variant, variantName) {
        return (0,fonts_variantName/* variantNameWithVersionSuffix */.B)(variant, variantName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: !productIsFont(line1) ? productLineItemClass : (CheckoutLineItem_module_default()).lineItem,
        children: !productIsFont(line1) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CheckoutLineItem_module_default()).physicalItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CheckoutLineItem_module_default()).physicalItem__header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutLineItem_module_default()).lineItem__image,
                                    children: productHasImage(line1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: line1.variant.product.thumbnail.url || "",
                                        alt: ((ref23 = line1.variant) === null || ref23 === void 0 ? void 0 : (ref1 = ref23.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.alt) || "",
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (CheckoutLineItem_module_default()).physicalItem__name,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: paths.goods._slug(line1 === null || line1 === void 0 ? void 0 : (ref3 = line1.variant) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.product) === null || ref4 === void 0 ? void 0 : ref4.slug).$url(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: line1 === null || line1 === void 0 ? void 0 : (ref5 = line1.variant) === null || ref5 === void 0 ? void 0 : ref5.product.name
                                                })
                                            })
                                        }),
                                        (line1 === null || line1 === void 0 ? void 0 : (ref6 = line1.variant) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.product) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.productType) === null || ref8 === void 0 ? void 0 : ref8.hasVariants) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: (CheckoutLineItem_module_default()).physicalItem__variant,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (CheckoutLineItem_module_default()).physicalItem__type,
                                                    children: "Variant: "
                                                }),
                                                (0,fonts_variantName/* default */.Z)(line1 === null || line1 === void 0 ? void 0 : line1.variant)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CheckoutLineItem_module_default()).physicalItem__sub,
                                            children: disableChanges && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (CheckoutLineItem_module_default()).physicalItem__variant,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (CheckoutLineItem_module_default()).physicalItem__type,
                                                        children: "Quantity"
                                                    }),
                                                    " ",
                                                    line1 === null || line1 === void 0 ? void 0 : line1.quantity
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutLineItem_module_default()).lineItem__actions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: isOrder || isCheckout ? (CheckoutLineItem_module_default()).lineItem__price : (CheckoutLineItem_module_default()).lineItem__priceCart,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: formatPrice(line1 === null || line1 === void 0 ? void 0 : (ref9 = line1.totalPrice) === null || ref9 === void 0 ? void 0 : ref9.gross)
                                        })
                                    }),
                                    !disableChanges && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, {
                                            variant: "ghost",
                                            callBack: function() {
                                                removeProductFromCheckout({
                                                    variables: {
                                                        checkoutToken: token,
                                                        lineId: line1 === null || line1 === void 0 ? void 0 : line1.id,
                                                        locale: query.locale
                                                    }
                                                });
                                                // add 'remove_from_cart' to the dataLayer
                                                datalayer_checkout/* default.removeFromCart */.Z.removeFromCart(line1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    iconName: "close-circle"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: t.formatMessage(translations/* messages.removeButton */.s.removeButton)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !isCheckout && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CheckoutLineItem_module_default()).physicalItem__Bottom,
                    children: [
                        !disableChanges && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CheckoutLineItem_module_default()).physicalItemQuantity,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* default */.Z, {
                                className: (CheckoutLineItem_module_default()).quantityInput,
                                hasLabel: true,
                                name: "qty",
                                label: "Quantity",
                                type: "number",
                                value: "".concat(quantity),
                                onFocus: function() {
                                    setErrors(null);
                                },
                                onChange: function(ev) {
                                    return changeLineState(ev);
                                },
                                onBlur: function(ev) {
                                    return onQuantityUpdate(ev);
                                },
                                onKeyPress: function(ev) {
                                    if (ev.key === "Enter") {
                                        onQuantityUpdate(ev);
                                    }
                                },
                                min: 1,
                                isRequired: true,
                                isDisabled: loadingLineUpdate,
                                pattern: "[0-9]*",
                                disablePointerEvents: true,
                                hasMobileKeyboard: true,
                                mobileKeyboardClickEvent: onMobileKeyboardClick
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CheckoutLineItem_module_default()).physicalItemTotalPrice,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: formatPrice(line1 === null || line1 === void 0 ? void 0 : (ref10 = line1.totalPrice) === null || ref10 === void 0 ? void 0 : ref10.gross)
                            })
                        })
                    ]
                }),
                errors1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CheckoutLineItem_module_default()).errors,
                    children: errors1.map(function(err) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: err.message
                        }, err.field);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                    fullPath: true,
                    fontName: getFontName(line1),
                    s3Path: getFontS3Path(line1)
                }),
                productIsFont(line1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFont/* default */.Z, {
                    uuid: line1.id.replace(/=/g, ""),
                    fontName: getFontName(line1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutLineItem_module_default()).fontSample,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Aa"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CheckoutLineItem_module_default()).lineItem__info,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (CheckoutLineItem_module_default()).lineItem__name,
                            children: (0,productHelpers/* isFontItem */.H_)(line1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: paths.typefaces._slug(line1 === null || line1 === void 0 ? void 0 : (ref11 = line1.variant) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.product) === null || ref12 === void 0 ? void 0 : ref12.slug).$url(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: fontVariantName(line1 === null || line1 === void 0 ? void 0 : line1.variant, (0,fonts_variantName/* default */.Z)(line1 === null || line1 === void 0 ? void 0 : line1.variant))
                                })
                            })
                        }),
                        (0,productHelpers/* isCustomisedFont */.lp)(line1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomisedFontMetadata/* default */.Z, {
                            metadata: line1.metadata,
                            variant: line1.variant
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CheckoutLineItem_module_default()).lineItem__actions,
                    children: [
                        licencingButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CheckoutLineItem_module_default()).lineItem__licence,
                            children: licencingButton
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CheckoutLineItem_module_default()).lineItem__price,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: formatPrice(line1 === null || line1 === void 0 ? void 0 : (ref13 = line1.totalPrice) === null || ref13 === void 0 ? void 0 : ref13.gross)
                            })
                        }),
                        isCartOwner && !disableChanges && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, {
                                    variant: "ghost",
                                    callBack: function() {
                                        removeProductFromCheckout({
                                            variables: {
                                                checkoutToken: token,
                                                lineId: line1 === null || line1 === void 0 ? void 0 : line1.id,
                                                locale: query.locale
                                            }
                                        });
                                        // add 'remove_from_cart' to the dataLayer
                                        datalayer_checkout/* default.removeFromCart */.Z.removeFromCart(line1);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            iconName: "close-circle"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: t.formatMessage(translations/* messages.removeButton */.s.removeButton)
                                        })
                                    ]
                                }),
                                errors1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: errors1.map(function(err) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: err.message
                                        }, err.field);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                licencingButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CheckoutLineItem_module_default()).lineItem__licenceMobile,
                    children: licencingButton
                })
            ]
        })
    });
};
/* harmony default export */ var CheckoutLineItem_CheckoutLineItem = ((/* unused pure expression or super */ null && (CheckoutLineItem)));

// EXTERNAL MODULE: ./components/global/SelectField/index.tsx + 1 modules
var SelectField = __webpack_require__(72518);
// EXTERNAL MODULE: ./components/checkout/SavedAddressSelectionList.module.scss
var SavedAddressSelectionList_module = __webpack_require__(8340);
var SavedAddressSelectionList_module_default = /*#__PURE__*/__webpack_require__.n(SavedAddressSelectionList_module);
;// CONCATENATED MODULE: ./components/checkout/SavedAddressSelectionList.tsx
function SavedAddressSelectionList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SavedAddressSelectionList_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || SavedAddressSelectionList_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function SavedAddressSelectionList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SavedAddressSelectionList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SavedAddressSelectionList_arrayLikeToArray(o, minLen);
}



var SavedAddressSelectionList = function(param) {
    var savedAddresses = param.savedAddresses, setSavedAddress = param.setSavedAddress, selectedAddress = param.selectedAddress;
    if (savedAddresses.length === 0) return null;
    var onSelectSavedAddress = function(addressId) {
        if (!addressId) {
            return;
        }
        var address = savedAddresses.find(function(thisAddress) {
            return thisAddress.id === addressId;
        });
        setSavedAddress({
            firstName: address.firstName,
            lastName: address.lastName,
            companyName: address.companyName,
            streetAddress1: address.streetAddress1,
            streetAddress2: address.streetAddress2,
            city: address.city,
            cityArea: address.cityArea,
            postalCode: address.postalCode,
            country: address.country.code,
            countryArea: address.countryArea,
            phone: address.phone
        });
    };
    var addressIsSelected = function(address) {
        if (!selectedAddress) {
            return false;
        }
        var firstNameMatch = selectedAddress.firstName === address.firstName;
        var lastNameMatch = selectedAddress.lastName === address.lastName;
        var streetMatch = selectedAddress.streetAddress1 === address.streetAddress1;
        var postCodeMatch = selectedAddress.postalCode === address.postalCode;
        var countryMatch = selectedAddress.country.code === address.country.code;
        var cityMatch = selectedAddress.city === address.city;
        return firstNameMatch && lastNameMatch && streetMatch && postCodeMatch && countryMatch && cityMatch;
    };
    var activeAddress = savedAddresses.find(function(savedAddress) {
        return addressIsSelected(savedAddress);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SavedAddressSelectionList_module_default()).savedAddress,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Choose a saved address:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* default */.Z, {
                name: "savedAddress",
                label: "savedAddress",
                onChange: function(e) {
                    return onSelectSavedAddress(e.target.value);
                },
                defaultValue: activeAddress && activeAddress.id,
                options: _toConsumableArray(savedAddresses.map(function(address) {
                    return {
                        value: address.id,
                        text: "".concat(address === null || address === void 0 ? void 0 : address.firstName, " ").concat(address === null || address === void 0 ? void 0 : address.lastName, ", ").concat(address === null || address === void 0 ? void 0 : address.postalCode, " ").concat(address === null || address === void 0 ? void 0 : address.city, ", ").concat(address === null || address === void 0 ? void 0 : address.country.country)
                    };
                }))
            })
        ]
    });
};
/* harmony default export */ var checkout_SavedAddressSelectionList = ((/* unused pure expression or super */ null && (SavedAddressSelectionList)));

// EXTERNAL MODULE: ./components/checkout/AddressDisplay.tsx
var checkout_AddressDisplay = __webpack_require__(94765);
;// CONCATENATED MODULE: ./components/global/AddressBookCard.tsx
function AddressBookCard_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddressBookCard_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AddressBookCard_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AddressBookCard_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddressBookCard_slicedToArray(arr, i) {
    return AddressBookCard_arrayWithHoles(arr) || AddressBookCard_iterableToArrayLimit(arr, i) || AddressBookCard_unsupportedIterableToArray(arr, i) || AddressBookCard_nonIterableRest();
}
function AddressBookCard_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddressBookCard_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddressBookCard_arrayLikeToArray(o, minLen);
}






var AddressBookCard = function(param) {
    var address = param.address, onRefreshBook = param.onRefreshBook;
    var t = useIntl();
    var ref = AddressBookCard_slicedToArray(useSetAddressDefaultMutation(), 1), setAddressDefaultMutation = ref[0];
    var ref1 = AddressBookCard_slicedToArray(useAddressDeleteMutation(), 1), deleteAddressMutation = ref1[0];
    var cardHeader = "";
    if (address.isDefaultShippingAddress && address.isDefaultBillingAddress) {
        cardHeader = t.formatMessage(messages.defaultBillingAndShipping);
    } else if (address.isDefaultShippingAddress) {
        cardHeader = t.formatMessage(messages.defaultShipping);
    } else if (address.isDefaultBillingAddress) {
        cardHeader = t.formatMessage(messages.defaultBilling);
    }
    var onDeleteAddress = function(addressId) {
        deleteAddressMutation({
            variables: {
                id: addressId
            }
        });
        onRefreshBook();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "justify-between flex flex-col checkout-section-container md:mx-2 mb-2",
        children: [
            !!cardHeader && /*#__PURE__*/ _jsx("p", {
                className: "text-md font-semibold mb-1",
                children: cardHeader
            }),
            /*#__PURE__*/ _jsx(AddressDisplay, {
                address: address
            }),
            !address.isDefaultBillingAddress && /*#__PURE__*/ _jsx(Button, {
                callBack: function() {
                    return setAddressDefaultMutation({
                        variables: {
                            id: address.id,
                            type: "BILLING"
                        }
                    });
                },
                children: t.formatMessage(messages.setDefaultBilling)
            }),
            !address.isDefaultShippingAddress && /*#__PURE__*/ _jsx(Button, {
                callBack: function() {
                    return setAddressDefaultMutation({
                        variables: {
                            id: address.id,
                            type: "SHIPPING"
                        }
                    });
                },
                children: t.formatMessage(messages.setDefaultShipping)
            }),
            /*#__PURE__*/ _jsx(Button, {
                callBack: function() {
                    return onDeleteAddress(address.id);
                },
                children: t.formatMessage(messages.removeButton)
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/global/Pagination.tsx
var global_Pagination = __webpack_require__(1776);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(82201);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var global_Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./components/global/Card/index.tsx + 1 modules
var global_Card = __webpack_require__(79697);
// EXTERNAL MODULE: ./components/global/Tag/index.tsx + 1 modules
var global_Tag = __webpack_require__(32486);
;// CONCATENATED MODULE: ./components/product/ProductCard.tsx






var ProductCard_ProductCard = function(param) {
    var product = param.product, letterbox = param.letterbox;
    var ref1;
    var paths = usePaths();
    var media = product.media;
    var highResThumb = function(thumbnailUrl) {
        var ref;
        var productsInUrl = thumbnailUrl.includes("/products");
        if (!productsInUrl) {
            return media[0].url;
        }
        var thumbUrlArray = thumbnailUrl.split("/products/");
        var thumbFile = thumbUrlArray[1];
        var thumbName = thumbFile.split("_")[0];
        var matchingFullImage = media.find(function(image) {
            return image.url.includes(thumbName);
        }) || media[0];
        var letterBoxImage = media.find(function(image) {
            return image.url.includes("letterbox");
        });
        return letterbox && letterBoxImage ? letterBoxImage.url : (ref = media[0]) === null || ref === void 0 ? void 0 : ref.url;
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs(Card, {
                variant: "goods-card",
                link: paths.goods._slug(product.slug).$url(),
                cardHoverEffect: true,
                renderCardAsLink: true,
                tags: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Tag, {
                            label: product === null || product === void 0 ? void 0 : (ref1 = product.category) === null || ref1 === void 0 ? void 0 : ref1.name
                        }),
                        !(product === null || product === void 0 ? void 0 : product.isAvailable) && /*#__PURE__*/ _jsx(Tag, {
                            variant: "error",
                            label: "Sold Out"
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cardImage,
                        children: (product === null || product === void 0 ? void 0 : product.thumbnail) && /*#__PURE__*/ _jsx(Image, {
                            loading: letterbox ? "eager" : "lazy",
                            src: highResThumb(product === null || product === void 0 ? void 0 : product.media),
                            alt: product.name,
                            width: 719,
                            height: 480,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ _jsx("h4", {
                        className: styles.ProductCard__Title,
                        children: product.name
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var product_ProductCard = ((/* unused pure expression or super */ null && (ProductCard_ProductCard)));

// EXTERNAL MODULE: ./components/Spinner.tsx
var components_Spinner = __webpack_require__(90625);
;// CONCATENATED MODULE: ./components/product/ProductCollection.tsx
function ProductCollection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductCollection_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductCollection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductCollection_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductCollection_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductCollection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductCollection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductCollection_slicedToArray(arr, i) {
    return ProductCollection_arrayWithHoles(arr) || ProductCollection_iterableToArrayLimit(arr, i) || ProductCollection_unsupportedIterableToArray(arr, i) || ProductCollection_nonIterableRest();
}
function ProductCollection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductCollection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductCollection_arrayLikeToArray(o, minLen);
}












var productsPerPage = 10;
var ProductCollection = function(param) {
    var filter = param.filter, serverProductsData = param.serverProductsData, _allowMore = param.allowMore, allowMore = _allowMore === void 0 ? true : _allowMore;
    var t = useIntl();
    var query = useRegions().query;
    var ref5 = useState("All Categories"), category = ref5[0], setCategory = ref5[1];
    var ref1 = useState("All Languages"), language = ref1[0], setLanguage = ref1[1];
    var ref2 = useState(9), productsToShow = ref2[0], setProductsToShow = ref2[1];
    var ref3 = useState(), productData = ref3[0], setProductData = ref3[1];
    var searchState = useState("");
    var _searchState = ProductCollection_slicedToArray(searchState, 1), search = _searchState[0];
    var ref4 = ProductCollection_slicedToArray(useProductCollectionLazyQuery({
        fetchPolicy: "cache-and-network"
    }), 2), getProducts = ref4[0], loading = ref4[1].loading;
    var onLoadMore = function() {
        getProducts({
            variables: ProductCollection_objectSpread({
                filter: filter,
                first: productsToShow + productsPerPage
            }, query)
        }).then(function(data) {
            var ref;
            setProductData(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.products);
            setProductsToShow(productsToShow + productsPerPage);
        });
    };
    var productRenderData = productData || serverProductsData;
    var products = (productRenderData === null || productRenderData === void 0 ? void 0 : productRenderData.edges.map(function(edge) {
        return edge.node;
    })) || [];
    if (products.length === 0) {
        return /*#__PURE__*/ _jsx("p", {
            children: t.formatMessage(messages.noProducts)
        });
    }
    var filteredProducts = filterProducts(products, {
        search: search,
        category: category,
        language: language
    });
    var featuredProducts = filteredProducts.filter(function(product) {
        var featuredAttribute = product.attributes.length > 0 ? product.attributes.find(function(attribute) {
            return attribute.attribute.slug === "featured-goods";
        }) : null;
        if (!featuredAttribute) {
            return false;
        }
        var isFeatured = featuredAttribute.values.some(function(value) {
            return value.name === "Featured Goods: Yes";
        });
        return isFeatured;
    });
    var firstProduct = featuredProducts.length > 0 ? featuredProducts[0] : null;
    var lastProduct = featuredProducts.length > 1 ? featuredProducts[1] : null;
    var productsArray = filteredProducts.filter(function(item) {
        var firstProductId = firstProduct ? firstProduct.id : null;
        var lastProductId = lastProduct ? lastProduct.id : null;
        return item.id !== firstProductId && item.id !== lastProductId;
    });
    var isOdd = (productsArray === null || productsArray === void 0 ? void 0 : productsArray.length) % 2 !== 0;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.ProductCollection,
        children: [
            loading && /*#__PURE__*/ _jsx(Spinner, {}),
            /*#__PURE__*/ _jsx(Grid, {
                className: styles.ProductCollection__Grid,
                children: /*#__PURE__*/ _jsxs(Column, {
                    sm: 12,
                    md: 12,
                    lg: 12,
                    children: [
                        firstProduct && /*#__PURE__*/ _jsx("div", {
                            className: styles.ProductCollection__First,
                            children: /*#__PURE__*/ _jsx(ProductCard, {
                                product: firstProduct,
                                letterbox: true
                            }, firstProduct.id)
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            role: "list",
                            className: styles.ProductCollection__List,
                            children: productsArray === null || productsArray === void 0 ? void 0 : productsArray.map(function(product, i) {
                                /*#__PURE__*/ return _jsx("li", {
                                    className: [
                                        styles.ProductCollection__ListItem,
                                        isOdd && i === (productsArray === null || productsArray === void 0 ? void 0 : productsArray.length) - 1 ? styles.ProductCollection__ListOddItem : ""
                                    ].join(" "),
                                    children: /*#__PURE__*/ _jsx(ProductCard, {
                                        product: product
                                    }, product.id)
                                }, product.id);
                            })
                        }),
                        lastProduct && /*#__PURE__*/ _jsx("div", {
                            className: styles.ProductCollection__Last,
                            children: /*#__PURE__*/ _jsx(ProductCard, {
                                product: lastProduct,
                                letterbox: true
                            }, lastProduct.id)
                        }),
                        productsArray.length === 0 && /*#__PURE__*/ _jsx("div", {
                            className: styles.noresults,
                            children: /*#__PURE__*/ _jsx("h4", {
                                children: "No results"
                            })
                        }),
                        allowMore && /*#__PURE__*/ _jsx(Pagination, {
                            onLoadMore: onLoadMore,
                            pageInfo: products === null || products === void 0 ? void 0 : products.pageInfo
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var product_ProductCollection = ((/* unused pure expression or super */ null && (ProductCollection)));

// EXTERNAL MODULE: ./components/global/Dropdown/index.tsx + 3 modules
var global_Dropdown = __webpack_require__(58677);
;// CONCATENATED MODULE: ./components/product/VariantSelector.tsx
function VariantSelector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VariantSelector_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VariantSelector_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var VariantSelector = function(param) {
    var product = param.product, selectedVariantID = param.selectedVariantID;
    var paths = usePaths();
    var variants = product.variants;
    if (!variants || variants.length === 1) {
        return null;
    }
    var selectedVariant = variants.find(function(variant) {
        return variant.id === selectedVariantID;
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Dropdown, {
            defaultValue: {
                name: selectedVariant ? selectedVariant.name : variants[0].name
            },
            items: variants.map(function(variant) {
                if (!notNullable(variant)) {
                    return null;
                }
                return VariantSelector_objectSpread({
                    name: translate(variant, "name")
                }, variant.quantityAvailable === 0 && {
                    label: "Sold Out"
                }, {
                    path: paths.goods._slug(product.slug).$url({
                        query: {
                            variant: variant.id
                        }
                    })
                });
            }),
            inline: true,
            size: "small",
            fullWidth: true,
            scrollOnChange: false
        })
    });
};
/* harmony default export */ var product_VariantSelector = ((/* unused pure expression or super */ null && (VariantSelector)));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.15.1_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(75968);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/providers/TypefaceProvider.tsx
var TypefaceProvider = __webpack_require__(49717);
// EXTERNAL MODULE: ./lib/auth/index.ts + 1 modules
var auth = __webpack_require__(9714);
// EXTERNAL MODULE: ./lib/datalayer/addtocart.ts
var addtocart = __webpack_require__(35761);
// EXTERNAL MODULE: ./lib/fonts/fontVersion.ts
var fontVersion = __webpack_require__(16270);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 4 modules
var hooks = __webpack_require__(61499);
// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/ModalStyles.module.scss
var ModalStyles_module = __webpack_require__(80759);
var ModalStyles_module_default = /*#__PURE__*/__webpack_require__.n(ModalStyles_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/AddToCartInstruction.tsx





var AddToCartInstruction = function(param) {
    var variants = param.variants, cartFontsList = param.cartFontsList, watchFontVersion = param.watchFontVersion;
    var singleVersionFonts = cartFontsList.filter(function(variant) {
        return !variants.some(function(oppVariant) {
            return oppVariant.sku.replace(/-pro$/, "") === variant.sku.replace(/-pro$/, "");
        });
    });
    if (singleVersionFonts.length === 0) return;
    var variables = singleVersionFonts.map(function(font) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Tag/* default */.Z, {
            label: (0,fonts_variantName/* default */.Z)(font)
        }, font.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModalStyles_module_default()).instructions,
            children: [
                "The following fonts are not available as ",
                watchFontVersion,
                ": ",
                variables
            ]
        })
    });
};
/* harmony default export */ var AddTypeFaceToCart_AddToCartInstruction = (/*#__PURE__*/(0,react.memo)(AddToCartInstruction));

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/helpers.ts
function helpers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function helpers_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function helpers_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return helpers_arrayLikeToArray(arr);
}
function helpers_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function helpers_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function helpers_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function helpers_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function helpers_slicedToArray(arr, i) {
    return helpers_arrayWithHoles(arr) || helpers_iterableToArrayLimit(arr, i) || helpers_unsupportedIterableToArray(arr, i) || helpers_nonIterableRest();
}
function helpers_toConsumableArray(arr) {
    return helpers_arrayWithoutHoles(arr) || helpers_iterableToArray(arr) || helpers_unsupportedIterableToArray(arr) || helpers_nonIterableSpread();
}
function helpers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return helpers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return helpers_arrayLikeToArray(o, minLen);
}

var capitalizeFirstLetter = function(string) {
    var input = string.replace(/\W/g, "");
    return input.charAt(0).toUpperCase() + input.slice(1);
};
var getFontS3Sku = function(fontSku) {
    var isPro = fontSku.endsWith("-pro");
    var fontFileSku = isPro ? fontSku.replace("-pro", "") : fontSku;
    return fontFileSku;
};
/* Would like to use ProductVariant type, but requires privateMetaData */ var getFontGroups = function(variants) {
    var fontGroups = variants.reduce(function(acc, variant) {
        var ref;
        var fontStyleGroup = (ref = variant === null || variant === void 0 ? void 0 : variant.metadata.find(function(metadata) {
            return metadata.key === "group";
        })) === null || ref === void 0 ? void 0 : ref.value;
        if (!fontStyleGroup) return acc;
        var fontStyleGroupLowerCase = fontStyleGroup.toLowerCase();
        if (acc.includes(fontStyleGroupLowerCase)) return acc;
        return helpers_toConsumableArray(acc).concat([
            fontStyleGroupLowerCase
        ]);
    }, []);
    return fontGroups;
};
var nonFamilyGroupVariants = function(variants) {
    return variants.filter(function(variant) {
        return (0,productHelpers/* isNotFamilyVariant */.CY)(variant);
    });
};
var inStockVariants = function(variants) {
    return variants.filter(function(variant) {
        return variant.quantityAvailable > 0;
    });
};
var availableVariantsForSelection = function(variants, filterOutFamilies) {
    return filterOutFamilies ? inStockVariants(nonFamilyGroupVariants(variants)) : inStockVariants(variants);
};
var getFontVariantGroupMeta = function(variant) {
    var ref;
    return (ref = variant === null || variant === void 0 ? void 0 : variant.metadata.find(function(metadata) {
        return metadata.key === "group";
    })) === null || ref === void 0 ? void 0 : ref.value.toLowerCase();
};
var fontsByGroup = function(param) {
    var variants = param.variants, variantGroup = param.variantGroup, _groupVariantsByMeta = param.groupVariantsByMeta, groupVariantsByMeta = _groupVariantsByMeta === void 0 ? false : _groupVariantsByMeta;
    var fontVariantsGrouped = variants.filter(function(variant) {
        return variant.sku.includes(variantGroup);
    });
    var fontVariantsGroupedByMeta = groupVariantsByMeta ? variants.filter(function(variant) {
        return getFontVariantGroupMeta(variant) === variantGroup;
    }) : [];
    return fontVariantsGroupedByMeta.length ? fontVariantsGroupedByMeta : fontVariantsGrouped;
};
var variantExtractor = function(obj) {
    return Object.entries(obj.variants).map(function(param) {
        var _param = helpers_slicedToArray(param, 2), _key = _param[0], value = _param[1];
        return "licence".concat(capitalizeFirstLetter(value.name));
    });
};
var fontFamilyGroups = function(param) {
    var variants = param.variants, checkout = param.checkout;
    return inStockVariants(variants).filter(function(variant) {
        return variant.quantityAvailable > 0;
    }).filter(function(variant) {
        return (0,productHelpers/* isFamilyVariant */.S5)(variant);
    });
};

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/LicenceHolder.tsx
function LicenceHolder_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LicenceHolder_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LicenceHolder_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var LicenceHolder = function(param) {
    var content = param.content, register = param.register, errors = param.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ModalStyles_module_default()).licenceHolder,
        "data-cy": "licenceHolders",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).stepContent,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).licenceHolderField,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* default */.Z, LicenceHolder_objectSpread({
                    hasLabel: true,
                    type: "text",
                    name: "licenceHolderName"
                }, register("licenceHolderName", {
                    required: "This is required"
                }), {
                    label: "License Holder Name \u2055",
                    error: !!errors.licenceHolderName && errors.licenceHolderName.message
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).licenceHolderField,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* default */.Z, LicenceHolder_objectSpread({
                    hasLabel: true,
                    type: "email",
                    name: "licenceHolderEmail"
                }, register("licenceHolderEmail", LicenceHolder_objectSpread({
                    required: "This is required"
                }, util/* inputFieldValidation.emailFormat */.cU.emailFormat)), {
                    label: "License Holder Email \u2055",
                    error: !!errors.licenceHolderEmail && errors.licenceHolderEmail.message
                }))
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_LicenceHolder = (LicenceHolder);

// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dynamic.js
var dynamic = __webpack_require__(17953);
// EXTERNAL MODULE: ./components/global/InputErrorMessage/index.tsx + 1 modules
var InputErrorMessage = __webpack_require__(5937);
// EXTERNAL MODULE: ./components/global/CheckboxPanel/CheckboxPanel.module.scss
var CheckboxPanel_module = __webpack_require__(623);
var CheckboxPanel_module_default = /*#__PURE__*/__webpack_require__.n(CheckboxPanel_module);
;// CONCATENATED MODULE: ./components/global/CheckboxPanel/CheckboxPanel.tsx
function CheckboxPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var CheckboxPanel = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var name = param.name, id = param.id, value = param.value, label = param.label, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, isRequired = param.isRequired, isChecked = param.isChecked, isDisabled = param.isDisabled, error = param.error, image = param.image, padding = param.padding, icon = param.icon, _iconVariant = param.iconVariant, iconVariant = _iconVariant === void 0 ? "onWhite" : _iconVariant;
    var PanelIcons = (0,dynamic["default"])(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1500));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1500)
                ];
            }
        }
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((CheckboxPanel_module_default()).CheckboxPanel, (_obj = {}, CheckboxPanel_defineProperty(_obj, (CheckboxPanel_module_default())["padding-".concat(padding)], padding), CheckboxPanel_defineProperty(_obj, (CheckboxPanel_module_default())["iconVariant-".concat(iconVariant)], iconVariant), _obj)),
                onClick: function(ev) {
                    return ev.stopPropagation();
                },
                "data-cy": name,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "visually-hidden",
                        type: "checkbox",
                        name: name,
                        id: id,
                        value: value,
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        required: isRequired,
                        checked: isChecked,
                        disabled: isDisabled,
                        ref: ref,
                        "aria-label": label,
                        "data-cy": label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (CheckboxPanel_module_default()).CheckboxPanelLabel,
                        htmlFor: id,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CheckboxPanel_module_default()).CheckboxPanel__ImageWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckboxPanel_module_default()).CheckboxPanel__ImageLabel,
                                    children: label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (CheckboxPanel_module_default()).CheckboxPanel__Image,
                                    children: [
                                        icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelIcons, {
                                            iconName: icon
                                        }) : null,
                                        image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: image,
                                            alt: value,
                                            layout: "fill",
                                            loading: "eager",
                                            priority: true
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputErrorMessage/* default */.Z, {
                error: error
            })
        ]
    });
});
CheckboxPanel.displayName = "CheckboxPanel";
/* harmony default export */ var CheckboxPanel_CheckboxPanel = (CheckboxPanel);

// EXTERNAL MODULE: ./components/global/CheckboxPanel/PanelIcons.tsx
var PanelIcons = __webpack_require__(1500);
;// CONCATENATED MODULE: ./components/global/CheckboxPanel/index.tsx



// EXTERNAL MODULE: ./components/global/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(96332);
// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/InfoModal.module.scss
var InfoModal_module = __webpack_require__(23416);
var InfoModal_module_default = /*#__PURE__*/__webpack_require__.n(InfoModal_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/LicenceTypeModal.tsx






var LicenceTypeModal = function() {
    var ref = (0,react.useState)(false), isShowingModal = ref[0], setIsShowingModal = ref[1];
    var hideModal = function() {
        setIsShowingModal(false);
    };
    var showModal = function() {
        setIsShowingModal(true);
    };
    var handleClose = function() {
        hideModal();
        document.body.classList.remove("ReactModal__Body--open");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InfoModal_module_default()).infoModalContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                callBack: showModal,
                variant: "asLink",
                type: "button",
                children: "Learn about licensing from Colophon"
            }),
            isShowingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
                asWrapper: true,
                controlled: true,
                controlledOpen: isShowingModal,
                controlledSetOpen: handleClose,
                maxWidth: "100%",
                modalPadding: "0",
                ModalButtonLabel: "Learn about licensing from Colophon",
                buttonVariant: "asLink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* BasicToastContent */.Cp, {
                    position: "center",
                    handleClose: handleClose,
                    type: "basic",
                    title: "License Platforms",
                    toastMessage: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageBody */.ww, {
                                borderBottom: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Our licenses are available based on usage. You can upgrade at any time, and increase the tier level of the license. Need licensing beyond what's available here? Contact us at",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:abc@colophon-foundry.org",
                                            children: "abc@colophon-foundry.org"
                                        }),
                                        "."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageScrollCarousel */.V8, {
                                className: (InfoModal_module_default()).ScrollCarousel,
                                slides: getLicenseModalData()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_LicenceTypeModal = (LicenceTypeModal);
var getLicenseModalData = function() {
    return [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InfoModal_module_default()).LicenseModalHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: "Desktop License"
                })
            }),
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "A desktop license enables a font to be installed on a computer. This license is measured on the number of users who have the font installed. Create and print documents, as well as static images (.jpeg, .tiff, .png), even if the images are used on a website or within a mobile app.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "File Formats Delivered",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (InfoModal_module_default()).fileTypes,
                        children: ".OTF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                        size: "s",
                        className: (InfoModal_module_default()).LicenseModalButton,
                        variant: "primary",
                        href: "/docs/Colophon-Foundry-Desktop-EULA.pdf",
                        target: "_blank",
                        children: "Download Desktop EULA"
                    })
                ]
            }),
            img: "/icon/desktop.svg"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InfoModal_module_default()).LicenseModalHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: "Web License"
                })
            }),
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "A web license (or self-hosting web license) enables the font to be utilized in live text on a website, by uploading the typeface to a web server and referencing it via @font-face. This is an annual license, and is measured on the number of page views per month one website receives. Each license is for one website.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "File Formats Delivered",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (InfoModal_module_default()).fileTypes,
                        children: ".WOFF2 .WOFF .TTF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                        size: "s",
                        className: (InfoModal_module_default()).LicenseModalButton,
                        variant: "primary",
                        href: "/docs/Colophon-Foundry-Web-EULA.pdf",
                        target: "_blank",
                        children: "Download Web EULA"
                    })
                ]
            }),
            img: "/icon/web.svg"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InfoModal_module_default()).LicenseModalHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: "App License"
                })
            }),
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "An app license is for when you are developing an app for iOS, Android, or Windows Phone, and you will be embedding the font file in your mobile application's code. This is an annual license for apps with up to 25,000 registered users. Need licensing beyond what's available online? Contact us at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:abc@colophon-foundry.org",
                        children: "abc@colophon-foundry.org"
                    }),
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "File Formats Delivered",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (InfoModal_module_default()).fileTypes,
                        children: ".OTF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                        size: "s",
                        className: (InfoModal_module_default()).LicenseModalButton,
                        variant: "primary",
                        href: "/docs/Colophon-Foundry-App-EULA.pdf",
                        target: "_blank",
                        children: "Download App EULA"
                    })
                ]
            }),
            img: "/icon/app.svg"
        }
    ];
};

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/partials/LicenceVariantInput.tsx
function LicenceVariantInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LicenceVariantInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LicenceVariantInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var LicenceVariantInput = function(param) {
    var register = param.register, capitalizeFirstLetter = param.capitalizeFirstLetter, licenceVariant = param.licenceVariant, licence = param.licence, errors = param.errors;
    var ref = (0,react.useState)(false), maxUsageError = ref[0], setMaxUsageError = ref[1];
    var ref1 = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), state = ref1.state, setMaxUsageAmountError = ref1.setMaxUsageAmountError, updateMultiplier = ref1.updateMultiplier;
    var maxUsageValues = state.maxUsageValues, multipliers = state.multipliers;
    var valueOnChange = function(optionItems, value) {
        setMaxUsageAmountError(false);
        setMaxUsageError(false);
        var optionItem = optionItems.find(function(item) {
            return item.value === value;
        });
        if (!optionItem) {
            return false;
        }
        var maxUsageApplies = (0,util/* getMaxUsageApplies */.a9)(maxUsageValues, optionItem, multipliers);
        if (maxUsageApplies) {
            setMaxUsageAmountError(true);
        }
        if (maxUsageValues.includes(optionItem.text)) setMaxUsageError(true);
        return updateMultiplier(multipliers, value);
    };
    var options = licenceVariant.options;
    var optionItems1 = options.map(function(option) {
        return {
            value: '{"licenceName": "'.concat(licence.name, '","licenceVariant": "').concat(licenceVariant.name, '","licenceMultiplier": ').concat(option.multiply, ', "licenceMultiplierName": "').concat(option.name, '"}'),
            text: option.name,
            default: option.default
        };
    });
    var initial = optionItems1.find(function(item) {
        return item.default === true;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ModalStyles_module_default()).selectedLicenceItem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* default */.Z, LicenceVariantInput_objectSpread({
            name: licence.name,
            hasLabel: true,
            label: licenceVariant.text,
            options: optionItems1,
            defaultLabel: "Choose...",
            defaultValue: (initial === null || initial === void 0 ? void 0 : initial.value) || ""
        }, register("licence".concat(capitalizeFirstLetter(licenceVariant.name)), {
            required: true,
            onChange: function(e) {
                valueOnChange(optionItems1, e.target.value);
            }
        }), {
            error: maxUsageError
        }), licenceVariant.slug)
    }, licenceVariant.slug);
};
/* harmony default export */ var partials_LicenceVariantInput = ((/* unused pure expression or super */ null && (LicenceVariantInput)));

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/partials/LicenceVersionModal.tsx
function _throw(e) {
    throw e;
}







var LicenceVersionModal = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(false), isShowingModal = ref[0], setIsShowingModal = ref[1];
    var hideModal = function() {
        setIsShowingModal(false);
    };
    var showModal = function() {
        setIsShowingModal(true);
    };
    var handleClose = function() {
        hideModal();
        document.body.classList.remove("ReactModal__Body--open");
    };
    var LicenseModalData = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InfoModal_module_default()).LicenseModalHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        children: [
                            "Professional ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uF010"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Tag/* default */.Z, {
                            label: "Recommended"
                        })
                    })
                ]
            }),
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Professional (PRO) variants include the full CF-Standard character set, but may also contain support for Cyrillic and Greek scripts. Furthermore, extension stylistic sets and OpenType features will be included within PRO versions to give further flexibility and options for all type users. Every family has different stylistic sets and OpenType features within their Standard and Professional variants. Please check individual family pages to see the extent of features available."
            }),
            video: {
                id: 123123,
                filename: "/videos/PRO.mp4"
            }
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InfoModal_module_default()).LicenseModalHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: (InfoModal_module_default()).title,
                    children: "Standard"
                })
            }),
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Standard (STD) variants contain the CF-Standard character map and no additional OpenType features. Most Standard variants will only contain basic ligatures.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please check individual family pages to see the extent of features available."
                ]
            }),
            video: {
                id: 123321123,
                filename: "/videos/STD.mp4"
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InfoModal_module_default()).infoModalContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Only certain styles are available with the standard character sets."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                callBack: showModal,
                variant: "asLink",
                type: "button",
                children: "Learn more about Professional and Standard"
            }),
            isShowingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
                asWrapper: true,
                controlled: true,
                controlledOpen: isShowingModal,
                controlledSetOpen: handleClose,
                maxWidth: "100%",
                modalPadding: "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* BasicToastContent */.Cp, {
                    position: "center",
                    handleClose: handleClose,
                    type: "basic",
                    title: "Font Versions",
                    toastMessage: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageBody */.ww, {
                                borderBottom: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Colophon offers two core versions of each font family which is selected as part of the checkout and licensing process. Below we highlight differences between these types."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastMessageScrollCarousel */.V8, {
                                className: (InfoModal_module_default()).LicenseVersionModal__ScrollCarousel,
                                slides: LicenseModalData
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var partials_LicenceVersionModal = ((/* unused pure expression or super */ null && (LicenceVersionModal)));

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/partials/index.ts



;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/LicenceStep.tsx







var LicenceStep = function(param) {
    var licenceArray = param.licenceArray, register = param.register, content = param.content, isChecked = param.isChecked, capitalizeFirstLetter = param.capitalizeFirstLetter, updateSelectedLicences = param.updateSelectedLicences, errors = param.errors;
    var state = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)().state;
    var selectedLicences = state.selectedLicences, maxUsageError = state.maxUsageError;
    var ContactButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "https://www.monotype.com/colophon-speak-sales",
            children: "contact us"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-cy": "licencePlatforms",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).stepContent,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).licenceGroup,
                children: licenceArray.map(function(licence) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxPanel_CheckboxPanel, {
                            isChecked: isChecked.hasOwnProperty(licence.slug) ? isChecked[licence.slug].checked : false,
                            value: licence.slug,
                            id: licence.slug,
                            name: "licences",
                            label: licence.slug,
                            icon: licence.slug,
                            iconVariant: "onWhite",
                            onChange: function() {
                                updateSelectedLicences(licence);
                            }
                        })
                    }, licence.slug);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_LicenceTypeModal, {}),
            selectedLicences.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModalStyles_module_default()).selectedLicence,
                "data-cy": "licencePlatformsConfig",
                children: selectedLicences.map(function(licence) {
                    var variantArray = Object.values(licence.variants);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: variantArray.map(function(licenceVariant) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenceVariantInput, {
                                register: register,
                                capitalizeFirstLetter: capitalizeFirstLetter,
                                licenceVariant: licenceVariant,
                                licence: licence,
                                errors: errors
                            }, licence.name);
                        })
                    }, licence.name);
                })
            }),
            maxUsageError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (ModalStyles_module_default()).maxUsage,
                children: [
                    "\u2055 We offer additional licenses above the selected tier. The purchase process for these is on a case-by-case basis. Please ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactButton, {}),
                    " so we can discuss your requirements further."
                ]
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_LicenceStep = (LicenceStep);

// EXTERNAL MODULE: ./components/global/Radio/index.tsx + 1 modules
var Radio = __webpack_require__(84733);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/LicenceVersions.tsx
function LicenceVersions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LicenceVersions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LicenceVersions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var LicenceVersions = function(param) {
    var content = param.content, register = param.register;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: (ModalStyles_module_default()).stepContent,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ModalStyles_module_default()).stepContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, LicenceVersions_objectSpread({
                            name: "fontVersion",
                            value: "Pro",
                            tag: "Recommended",
                            id: "Pro",
                            label: "Professional (Pro)",
                            isPanel: true,
                            subLabel: "Professional ('PRO') fonts contain further stylistic sets, OpenType features and can also include further scripts, such as Cyrillic and Greek."
                        }, register("fontVersion")))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, LicenceVersions_objectSpread({
                            name: "fontVersion",
                            value: "Std",
                            id: "Std",
                            label: "Standard (Std)",
                            isPanel: true,
                            subLabel: "Standard ('STD') fonts contain our base CF-Standard character map that supports Eastern and Western European latin languages."
                        }, register("fontVersion")))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenceVersionModal, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_LicenceVersions = (LicenceVersions);

;// CONCATENATED MODULE: ./lib/fonts/fontLicences.ts
var fontLicences = {
    desktop: {
        slug: "desktop",
        name: "Desktop",
        variants: {
            desktop: {
                slug: "desktop",
                name: "Desktop",
                text: "How many people will use the typeface?",
                selected: {
                    name: "1 desktop user",
                    multiply: 1
                },
                options: [
                    {
                        name: "1 desktop user",
                        short: "1 people",
                        included_discount: "0%",
                        multiply: 1
                    },
                    {
                        name: "2 desktop users",
                        short: "2 people",
                        included_discount: "5%",
                        multiply: 1.25
                    },
                    {
                        name: "3 desktop users",
                        short: "3 people",
                        included_discount: "5%",
                        multiply: 1.5
                    },
                    {
                        name: "4 desktop users",
                        short: "4 people",
                        included_discount: "5%",
                        multiply: 1.75
                    },
                    {
                        name: "5 desktop users",
                        short: "5 people",
                        included_discount: "5%",
                        multiply: 2
                    },
                    {
                        name: "6 desktop users",
                        short: "6 people",
                        included_discount: "10%",
                        multiply: 2.25
                    },
                    {
                        name: "7 desktop users",
                        short: "7 people",
                        included_discount: "10%",
                        multiply: 2.5
                    },
                    {
                        name: "8 desktop users",
                        short: "8 people",
                        included_discount: "10%",
                        multiply: 2.65
                    },
                    {
                        name: "9 desktop users",
                        short: "9 people",
                        included_discount: "10%",
                        multiply: 2.8
                    },
                    {
                        name: "10 desktop users",
                        short: "10 people",
                        included_discount: "10%",
                        multiply: 3
                    },
                    {
                        name: "20 desktop users",
                        short: "20 people",
                        included_discount: "15%",
                        multiply: 3.197
                    },
                    {
                        name: "30 desktop users",
                        short: "30 people",
                        included_discount: "21%",
                        multiply: 4.615
                    },
                    {
                        name: "40 desktop users",
                        short: "40 people",
                        included_discount: "31%",
                        multiply: 5.696
                    },
                    {
                        name: "50 desktop users",
                        short: "50 people",
                        included_discount: "38%",
                        multiply: 6.55
                    },
                    {
                        name: "75 desktop users",
                        short: "75 people",
                        included_discount: "68%",
                        multiply: 8.1
                    },
                    {
                        name: "100 desktop users",
                        short: "100 people",
                        included_discount: "73%",
                        multiply: 11
                    },
                    {
                        name: "125 desktop users",
                        short: "125 people",
                        included_discount: "73%",
                        multiply: 11.792
                    },
                    {
                        name: "150 desktop users",
                        short: "150 people",
                        included_discount: "73%",
                        multiply: 12.971
                    },
                    {
                        name: "175 desktop users",
                        short: "175 people",
                        included_discount: "73%",
                        multiply: 14.268
                    },
                    {
                        name: "200 desktop users",
                        short: "200 people",
                        included_discount: "74%",
                        multiply: 15
                    },
                    {
                        name: "201+ desktop users",
                        short: "201+ people",
                        included_discount: "74%",
                        multiply: 0
                    }
                ]
            }
        }
    },
    web: {
        slug: "web",
        name: "Web",
        variants: {
            web: {
                slug: "web",
                name: "Web",
                text: "How many page views does your website have?",
                selected: {
                    name: "10,000 webpage views/month",
                    multiply: 1
                },
                options: [
                    {
                        name: "10,000 webpage views/month",
                        short: "10k views/month",
                        multiply: 1
                    },
                    {
                        name: "25,000 webpage views/month",
                        short: "25k views/month",
                        multiply: 2.5
                    },
                    {
                        name: "100,000 webpage views/month",
                        short: "100k views/month",
                        multiply: 5
                    },
                    {
                        name: "250,000 webpage views/month",
                        short: "250k views/month",
                        multiply: 10
                    },
                    {
                        name: "500,000 webpage views/month",
                        short: "500k views/month",
                        multiply: 15
                    },
                    {
                        name: "1,000,000 webpage views/month",
                        short: "1m views/month",
                        multiply: 20
                    },
                    {
                        name: "1,500,000 webpage views/month",
                        short: "1.5m views/month",
                        multiply: 25
                    },
                    {
                        name: "2,000,000 webpage views/month",
                        short: "2m views/month",
                        multiply: 30
                    },
                    {
                        name: "2,000,000+ webpage views/month",
                        short: "2m+ views/month",
                        multiply: 30
                    }
                ]
            }
        }
    },
    app: {
        slug: "app",
        name: "App",
        variants: {
            app: {
                slug: "app",
                name: "App",
                text: "How many titles do you wish to download?",
                selected: {
                    name: "1 title/year",
                    long: "1 title for one year",
                    multiply: 17
                },
                options: [
                    {
                        name: "1 title for one year",
                        long: "1 title for one year",
                        multiply: 17
                    },
                    {
                        name: "2 titles for one year",
                        long: "2 titles for one year",
                        multiply: 29
                    },
                    {
                        name: "3 titles for one year",
                        long: "3 titles for one year",
                        multiply: 43
                    },
                    {
                        name: "4+ titles for one year",
                        long: "4+ titles for one year",
                        multiply: 0
                    }
                ]
            }
        }
    }
};
var multiSkuDiscounts = function(variants) {
    var cartItemsCount = variants.length;
    var multiply;
    if (cartItemsCount >= 5 && cartItemsCount <= 10) {
        multiply = 0.75;
    }
    if (cartItemsCount > 10) {
        multiply = 0.5;
    }
    return multiply;
};
/* harmony default export */ var fonts_fontLicences = (fontLicences);

// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/StepNavigation.module.scss
var StepNavigation_module = __webpack_require__(80979);
var StepNavigation_module_default = /*#__PURE__*/__webpack_require__.n(StepNavigation_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/StepNavigation.tsx








var StepNavigation = function(param) {
    var steps = param.steps, onAddToCartSubmit = param.onAddToCartSubmit, isAddedToCart = param.isAddedToCart, watchFonts = param.watchFonts, isTouchDevice = param.isTouchDevice, control = param.control, stepActive = param.stepActive, setValue = param.setValue, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), summaryVisible = ref10[0], setSummaryVisible = ref10[1];
    var summaryRef = (0,react.useRef)();
    var ref11 = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), state = ref11.state, setStep = ref11.setStep;
    var maxUsageValues = state.maxUsageValues, step = state.step, selectedLicences = state.selectedLicences;
    var watchLicenceDesktop = (0,index_esm/* useWatch */.qo)({
        name: "licenceDesktop",
        control: control
    });
    var watchLicenceWeb = (0,index_esm/* useWatch */.qo)({
        name: "licenceWeb",
        control: control
    }) || '{"licenceName": '.concat((ref = fonts_fontLicences.web) === null || ref === void 0 ? void 0 : ref.name, ',"licenceVariant": ').concat((ref1 = fonts_fontLicences.web) === null || ref1 === void 0 ? void 0 : ref1.name, ',"licenceMultiplier": ').concat((ref5 = (ref2 = fonts_fontLicences.web) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.web) === null || ref4 === void 0 ? void 0 : ref4.options[1]) === null || ref5 === void 0 ? void 0 : ref5.multiply, ', "licenceMultiplierName":').concat((ref9 = (ref6 = fonts_fontLicences.web) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.variants) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.web) === null || ref8 === void 0 ? void 0 : ref8.options[1]) === null || ref9 === void 0 ? void 0 : ref9.name, "}");
    var watchLicenceApp = (0,index_esm/* useWatch */.qo)({
        name: "licenceApp",
        control: control
    });
    // const watchLicenceAppBroadcast = useWatch({ name: 'licenceBroadcast', control });
    // const watchLicenceAppElectronic = useWatch({ name: 'licenceElectronic', control });
    var watchLicenceHolderName = (0,index_esm/* useWatch */.qo)({
        name: "licenceHolderName",
        control: control
    });
    var watchLicenceHolderEmail = (0,index_esm/* useWatch */.qo)({
        name: "licenceHolderEmail",
        control: control
    });
    var nextDisabled = function() {
        if (stepActive("fontStyles")) {
            return watchFonts[0].length < 1;
        }
        if (stepActive("licencePlatform")) {
            var watchList = [
                watchLicenceDesktop,
                watchLicenceWeb,
                watchLicenceApp
            ];
            var formList = watchList.filter(function(licenceData) {
                if (licenceData) {
                    var licenceValue;
                    try {
                        var itemData = JSON.parse(licenceData);
                        licenceValue = itemData === null || itemData === void 0 ? void 0 : itemData.licenceMultiplierName;
                    } catch (e) {
                    // fail silently... shh
                    }
                    var maxUsageApplies = !maxUsageValues.includes(licenceValue);
                    return licenceData !== undefined && licenceData !== "" && maxUsageApplies;
                }
            });
            var selected = selectedLicences.reduce(function(p, n) {
                return p.concat(Object.keys(n.variants));
            }, []);
            // Checks if selected licence matches the length of selected values from the select options
            if (selected.length > 0 && formList.length > 0) {
                return selected.includes("web") ? !(selected.length === formList.length) : !(selected.length === formList.length - 1);
            }
            // Disable
            return true;
        }
    };
    var addToCartDisabled = function() {
        if (!watchLicenceHolderName || !watchLicenceHolderEmail) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepNavigation_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StepNavigation_module_default()).stepNavigation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StepNavigation_module_default()).back,
                        children: step > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, {
                            type: "button",
                            variant: "secondary",
                            size: "xl",
                            callBack: function() {
                                setStep(step - 1);
                            },
                            "data-cy": "back",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\u2190"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (StepNavigation_module_default()).backLabel,
                                    children: " Back"
                                })
                            ]
                        })
                    }),
                    isTouchDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StepNavigation_module_default()).summaryButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                            type: "button",
                            variant: "secondary",
                            size: "l",
                            align: "center",
                            callBack: function() {
                                setSummaryVisible(true);
                            },
                            children: "\xa0\xa0\xa0 Summary \xa0\xa0\xa0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StepNavigation_module_default()).next,
                        children: step < steps.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, {
                            type: "button",
                            variant: "primary",
                            size: "xl",
                            disabled: nextDisabled(),
                            callBack: function() {
                                if (stepActive("fontStyles") && watchFonts[0].length > 0) {
                                    return setStep(step + 1);
                                }
                                if (stepActive("licencePlatform") && watchFonts[0].length > 0) {
                                    if (watchLicenceDesktop || watchLicenceWeb || watchLicenceApp) {
                                        return setStep(step + 1);
                                    }
                                    return false;
                                }
                                return setStep(step + 1);
                            },
                            "data-cy": "next",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (StepNavigation_module_default()).nextLabel,
                                    children: "Continue "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\u2192"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Button/* default */.Z, {
                            disabled: addToCartDisabled() || isAddedToCart,
                            type: "button",
                            variant: "primary",
                            size: "xl",
                            className: (StepNavigation_module_default()).addtocart,
                            callBack: function() {
                                if (stepActive("licenceHolder") && watchFonts[0].length > 0) {
                                    if (watchLicenceDesktop || watchLicenceWeb || watchLicenceApp) {
                                        onAddToCartSubmit();
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (StepNavigation_module_default()).nextLabel,
                                    children: "Add to Cart"
                                }),
                                isTouchDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    iconName: "cart"
                                })
                            ]
                        })
                    })
                ]
            }),
            summaryVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: summaryRef,
                className: (StepNavigation_module_default()).navigationSummary,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StepNavigation_module_default()).navigationSummaryClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                            type: "button",
                            variant: "ghost",
                            callBack: function() {
                                summaryRef.current.classList.add((StepNavigation_module_default()).closeAnimation);
                                setTimeout(function() {
                                    return setSummaryVisible(false);
                                }, 200);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                iconName: "close"
                            })
                        })
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_StepNavigation = (StepNavigation);

// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/Summary.module.scss
var Summary_module = __webpack_require__(6458);
var Summary_module_default = /*#__PURE__*/__webpack_require__.n(Summary_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/Summary.tsx
function Summary_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Summary_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Summary_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var Summary = function(param1) {
    var product = param1.product, cartFontsList = param1.cartFontsList, fontPrice = param1.fontPrice, handleRemoveItem = param1.handleRemoveItem, formatTotal = param1.formatTotal, cartSubTotalAmount = param1.cartSubTotalAmount, allowEditing = param1.allowEditing, cartTotalAmount = param1.cartTotalAmount;
    var isFontFamilyGroup = function(cartFont) {
        return cartFont.familySkuNames && cartFont.familySkuNames.length > 0;
    };
    // Some skus will be from other products
    // For these, we just reformat the sku into a namer as best we can
    var formattedSku = function(param) {
        var sku = param.sku, productName = param.productName;
        return sku.replace(productName.toLowerCase(), "").replace(/-pro$/, "").replace(/-/g, " ").trim();
    };
    var ref1 = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), maxUsageError = ref1.state.maxUsageError;
    var cartFontsListArray = cartFontsList.map(function(cartFont) {
        if ((0,productHelpers/* isFamilyVariant */.S5)(cartFont) || (0,productHelpers/* isVariableFont */.bc)(cartFont)) {
            var familySkus = (0,productHelpers/* getFamilyMetaSkus */.nP)(cartFont);
            var familySkuProductName = familySkus.map(function(sku) {
                var ref;
                var skuVariant = product.variants.find(function(variant) {
                    return variant.sku.trim() === sku.trim();
                });
                var skuName = skuVariant ? (0,fonts_variantName/* default */.Z)(skuVariant) : formattedSku({
                    sku: sku,
                    productName: cartFont === null || cartFont === void 0 ? void 0 : (ref = cartFont.product) === null || ref === void 0 ? void 0 : ref.name
                });
                return skuName;
            });
            return Summary_objectSpread({}, cartFont, {
                familySkuNames: familySkuProductName
            });
        }
        return cartFont;
    });
    var skuDisplayFont = function(cartFont) {
        var isFamilyFont = (0,productHelpers/* isFamilyVariant */.S5)(cartFont);
        return isFamilyFont ? (0,productHelpers/* getFamilyMetaSkus */.nP)(cartFont)[0] : cartFont.sku;
    };
    var fontVariantName = function(variant, variantName) {
        return (0,fonts_variantName/* variantNameWithVersionSuffix */.B)(variant, variantName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Summary_module_default()).summary,
        "data-cy": "typeface-add-to-cart-summary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Summary_module_default()).summary__header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Summary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Summary_module_default()).summary__header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: (Summary_module_default()).summary__title,
                    children: product.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Summary_module_default()).summary__content,
                children: [
                    cartFontsListArray.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (Summary_module_default()).summary__list,
                        children: cartFontsListArray.map(function(cartFont) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (Summary_module_default())["summary__list-wrapper-item"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((Summary_module_default())["summary__list-item"], isFontFamilyGroup(cartFont) && (Summary_module_default())["summary__list-item__border"]),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFont/* default */.Z, {
                                                uuid: cartFont.id,
                                                fontName: getFontS3Sku(skuDisplayFont(cartFont)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Summary_module_default()).customFont,
                                                    children: "Aa"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: (Summary_module_default()).name,
                                                children: fontVariantName(cartFont, (0,fonts_variantName/* default */.Z)(cartFont))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Summary_module_default()).price,
                                                children: !maxUsageError ? fontPrice(cartFont) : "-"
                                            }),
                                            allowEditing && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                                                variant: "ghost",
                                                title: "Remove ".concat(cartFont.sku),
                                                callBack: function() {
                                                    return handleRemoveItem(cartFont);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    iconName: "close-circle"
                                                })
                                            })
                                        ]
                                    }),
                                    isFontFamilyGroup(cartFont) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)((Summary_module_default()).fontFamilyGroup, "with-scrollbar"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (Summary_module_default()).fontFamilyGroup__List,
                                            children: cartFont.familySkuNames.map(function(familySkuName) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (Summary_module_default()).fontFamilyGroup__ListItem,
                                                    children: familySkuName
                                                }, familySkuName);
                                            })
                                        })
                                    })
                                ]
                            }, cartFont.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: "1rem"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Summary_module_default()).total,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: (Summary_module_default()).totalValue + " u-h4",
                                children: !maxUsageError ? formatTotal(cartTotalAmount) : "-"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_Summary = (Summary);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-accessible-accordion@5.0.0_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(75101);
// EXTERNAL MODULE: ./components/global/Checkbox/index.tsx
var Checkbox = __webpack_require__(98188);
;// CONCATENATED MODULE: ./lib/fonts/getAllVariantsNonPurchaseable.ts

var getAllVariantsNonPurchaseable = function(variants) {
    var nonFamilyVariants = variants.filter(function(variant) {
        return (0,productHelpers/* isNotFamilyVariant */.CY)(variant);
    });
    var nonFamilyVariantsCount = nonFamilyVariants.length;
    var variantsNonPurchaseable = nonFamilyVariants.filter(function(variant) {
        var variantTypeAttribute = variant.attributes.find(function(attribute) {
            return attribute.attribute.slug === "variant-type";
        });
        var variantTypeAttributeValues = variantTypeAttribute.values;
        var isNoPurchase = variantTypeAttributeValues.some(function(value) {
            return value.name === "NoPurchase";
        });
        return isNoPurchase;
    });
    var variantsNonPurchaseableCount = variantsNonPurchaseable.length;
    return nonFamilyVariantsCount === variantsNonPurchaseableCount;
};

// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/FontGroup.module.scss
var FontGroup_module = __webpack_require__(8546);
var FontGroup_module_default = /*#__PURE__*/__webpack_require__.n(FontGroup_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/FontGroup.tsx
function FontGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FontGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FontGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var FontGroup = function(param) {
    var variantGroup = param.variantGroup, register = param.register, errors = param.errors, fonts = param.fonts, disable = param.disable;
    if (fonts.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "Alert",
            children: "Sorry, no fonts available. You may already have these fonts in your cart. If you wish to license the same fonts multiple times, please purchase separately."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: disable ? (FontGroup_module_default()).fontGroupDisabled : (FontGroup_module_default()).fontGroup,
            children: fonts.map(function(font) {
                var variantTypeAttribute = font.attributes.find(function(attribute) {
                    return attribute.attribute.slug === "variant-type";
                });
                var variantTypeAttributeValues = variantTypeAttribute.values;
                var nonPurchaseable = false;
                if (variantTypeAttributeValues.length > 0) {
                    var isNoPurchase = variantTypeAttributeValues.some(function(value) {
                        return value.name === "NoPurchase";
                    });
                    nonPurchaseable = isNoPurchase;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFont/* default */.Z, {
                        uuid: font.id,
                        fontName: getFontS3Sku(font.sku),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, FontGroup_objectSpread({
                            value: font.sku,
                            id: font.sku,
                            name: "fonts"
                        }, register("fonts", {
                            required: true
                        }), {
                            label: (0,fonts_variantName/* default */.Z)(font, variantGroup),
                            error: errors.fonts && "This field is Required",
                            isPanel: true,
                            boxContent: "Aa",
                            tooltip: (0,fonts_variantName/* default */.Z)(font, variantGroup),
                            isDisabled: disable || nonPurchaseable,
                            hideCheckbox: nonPurchaseable
                        }))
                    })
                }, font.id);
            })
        })
    });
};
/* harmony default export */ var AddTypeFaceToCart_FontGroup = (FontGroup);

// EXTERNAL MODULE: ./components/typeface/AddTypeFaceToCart/VariantGroupings.module.scss
var VariantGroupings_module = __webpack_require__(71080);
var VariantGroupings_module_default = /*#__PURE__*/__webpack_require__.n(VariantGroupings_module);
;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/VariantGroupings.tsx
function VariantGroupings_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VariantGroupings_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VariantGroupings_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var VariantGroupingLabels = function(group) {
    var Labels = {
        rd: "Round",
        st: "Straight"
    };
    return Labels[group] || group.replace("-", "");
};
var VariantGroupings = function(param1) {
    var product = param1.product, variantGroupings = param1.variantGroupings, variants1 = param1.variants, register = param1.register, content = param1.content, errors = param1.errors, fontsByGroup = param1.fontsByGroup, watchFonts = param1.watchFonts, groupVariantsByMeta = param1.groupVariantsByMeta, fontFamilyGroups = param1.fontFamilyGroups;
    var ref4, ref1;
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    var Arrow = function(param) {
        var expanded = param.expanded;
        var screen = (0,mediaQuery/* useScreenSize */.e)();
        var iconSize = screen === "Mobile" ? "24" : "32";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (VariantGroupings_module_default()).arrow,
            children: expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                iconName: "arrow-up",
                color: "currentColor",
                width: iconSize,
                height: iconSize
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                iconName: "arrow-down",
                color: "currentColor",
                width: iconSize,
                height: iconSize
            })
        });
    };
    var expanded1 = variantGroupings.length < 2 ? [
        variantGroupings[0]
    ] : [];
    var fonts = function(variants, variantGroup) {
        return fontsByGroup({
            checkout: checkout,
            variants: variants,
            variantGroup: variantGroup,
            groupVariantsByMeta: groupVariantsByMeta
        });
    };
    var fontFamilyGroupsArray = fontFamilyGroups;
    var familySelected = watchFonts[0].length > 0 ? watchFonts[0].some(function(font) {
        return (0,productHelpers/* isFamilyVariant */.S5)({
            sku: font
        });
    }) : false;
    var allowMultipleFamilyBundles = ((ref1 = (ref4 = product.metadata) === null || ref4 === void 0 ? void 0 : ref4.find(function(param) {
        var key = param.key;
        return key === "allowMultipleFamilyBundles";
    })) === null || ref1 === void 0 ? void 0 : ref1.value) === "true" || false;
    var hasSelectedOtherThanFamily = !!watchFonts[0].filter(function(sku) {
        return !sku.includes("-family") && !sku.includes("-subfamily");
    }).length;
    var disableFamily = function(familySku) {
        if (watchFonts[0].length < 1 || familySelected) {
            return false;
        }
        return allowMultipleFamilyBundles ? hasSelectedOtherThanFamily : familySku !== watchFonts[0][0];
    };
    var onlyGroupFamillies = getAllVariantsNonPurchaseable(variants1);
    var variableFontVariants = variants1.filter(function(variant) {
        return (0,productHelpers/* isVariableFont */.bc)(variant);
    });
    var staticFontVariants = variants1.filter(function(variant) {
        return !(0,productHelpers/* isVariableFont */.bc)(variant);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-cy": "typeface-add-to-cart-variants",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VariantGroupings_module_default()).stepContent + " u-h5",
                children: content
            }),
            variableFontVariants.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VariantGroupings_module_default()).variableFontSection,
                "data-cy": "typeface-add-to-cart-variants-variable",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (VariantGroupings_module_default()).variableFontSection__heading,
                        children: "Select a variable font:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Variable font purchases will include the relevant static font files within your download"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_FontGroup, {
                            variantGroup: null,
                            register: register,
                            errors: errors,
                            fonts: variableFontVariants,
                            disable: false
                        })
                    })
                ]
            }),
            fontFamilyGroupsArray.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VariantGroupings_module_default()).fontFamilyGroup,
                "data-cy": "typeface-add-to-cart-variants-family",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Select a complete family:"
                    }),
                    fontFamilyGroupsArray.map(function(fontFamilyGroup, index) {
                        var ref, ref2, ref3;
                        var isDisabled = disableFamily(fontFamilyGroup === null || fontFamilyGroup === void 0 ? void 0 : fontFamilyGroup.sku);
                        var count = ((ref = fontFamilyGroup.metadata.find(function(m) {
                            return m.key === "familySkus";
                        })) === null || ref === void 0 ? void 0 : ref.value.split(",").length.toString()) || 0;
                        var discount = ((ref2 = fontFamilyGroup.metadata.find(function(m) {
                            return m.key === "discount";
                        })) === null || ref2 === void 0 ? void 0 : ref2.value) || null;
                        var recommended = ((ref3 = fontFamilyGroup.metadata.find(function(m) {
                            return m.key === "recommended";
                        })) === null || ref3 === void 0 ? void 0 : ref3.value) || false;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isDisabled ? (VariantGroupings_module_default()).fontFamilyGroupDisabled : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, VariantGroupings_objectSpread({
                                value: fontFamilyGroup.sku,
                                id: fontFamilyGroup.sku,
                                name: "fonts"
                            }, register("fonts", {
                                required: true
                            }), {
                                label: (0,fonts_variantName/* default */.Z)(fontFamilyGroup),
                                error: errors.fonts && "This field is Required",
                                isPanel: true,
                                isLarge: true,
                                isDisabled: isDisabled,
                                count: count,
                                discount: discount,
                                recommended: recommended
                            }))
                        }, fontFamilyGroup.sku);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: onlyGroupFamillies ? "These fonts can only be purchased as part of a family. Browse the families:" : "Or select individual styles:"
                    })
                ]
            }),
            variantGroupings.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                allowZeroExpanded: true,
                allowMultipleExpanded: true,
                preExpanded: expanded1,
                children: variantGroupings.map(function(variantGroup) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                        uuid: variantGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (VariantGroupings_module_default()).heading,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (VariantGroupings_module_default()).title,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: VariantGroupingLabels(variantGroup)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "".concat(fonts(staticFontVariants, variantGroup).length, " styles")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemState */.CB, {
                                                children: function(state) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                                                        expanded: state.expanded
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemState */.CB, {
                                    children: function(state) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: state.expanded ? (VariantGroupings_module_default()).expanded : (VariantGroupings_module_default()).hidden,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_FontGroup, {
                                                variantGroup: variantGroup,
                                                register: register,
                                                errors: errors,
                                                fonts: fonts(staticFontVariants, variantGroup),
                                                disable: familySelected
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    }, variantGroup);
                })
            }) : variantGroupings.map(function(variantGroup) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cy": "typeface-add-to-cart-variants-static",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_FontGroup, {
                        variantGroup: variantGroup,
                        register: register,
                        errors: errors,
                        fonts: fonts(staticFontVariants, variantGroup),
                        disable: familySelected
                    })
                }, variantGroup);
            })
        ]
    });
};
/* harmony default export */ var AddTypeFaceToCart_VariantGroupings = (VariantGroupings);

;// CONCATENATED MODULE: ./components/typeface/AddTypeFaceToCart/AddTypefaceToCart.tsx
function AddTypefaceToCart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddTypefaceToCart_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AddTypefaceToCart_arrayLikeToArray(arr);
}
function AddTypefaceToCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddTypefaceToCart_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddTypefaceToCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddTypefaceToCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddTypefaceToCart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddTypefaceToCart_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AddTypefaceToCart_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddTypefaceToCart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddTypefaceToCart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddTypefaceToCart_toConsumableArray(arr) {
    return AddTypefaceToCart_arrayWithoutHoles(arr) || AddTypefaceToCart_iterableToArray(arr) || AddTypefaceToCart_unsupportedIterableToArray(arr) || AddTypefaceToCart_nonIterableSpread();
}
function AddTypefaceToCart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddTypefaceToCart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddTypefaceToCart_arrayLikeToArray(o, minLen);
}


/* eslint-disable react-hooks/exhaustive-deps */ 





























lib_default().setAppElement("#root");
var AddTypefaceToCart = function(param1) {
    var product1 = param1.product, productLicences = param1.productLicences, setClosed = param1.setClosed, isOpen = param1.isOpen;
    var router = (0,next_router.useRouter)();
    var screen = (0,mediaQuery/* useScreenSize */.e)();
    var signOut = (0,auth/* useSaleorAuthContext */.ex)().signOut;
    var isTouchDevice = screen === "Mobile" || screen === "Tablet";
    var ref4 = (0,CheckoutProvider/* useCheckout */.Mg)(), checkoutToken = ref4.checkoutToken, checkout = ref4.checkout, setCheckoutToken = ref4.setCheckoutToken, refetch = ref4.refetch, resetCheckoutToken = ref4.resetCheckoutToken;
    var user = (0,hooks/* useUser */.aF)().user;
    var ref1 = (0,RegionsProvider/* useRegions */.eH)(), currentChannel = ref1.currentChannel, formatPrice = ref1.formatPrice;
    var variants = product1.variants;
    var licenceArray = Object.values(productLicences);
    var singleVersionFont = !variants.some(function(variant) {
        return variant.sku.endsWith("-pro");
    });
    var ref2 = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), state = ref2.state, setStep = ref2.setStep, setSelectedLicences = ref2.setSelectedLicences, setMultipliers = ref2.setMultipliers, setMultiplierValue = ref2.setMultiplierValue, setCartFontsList = ref2.setCartFontsList, setCartSubTotalAmount = ref2.setCartSubTotalAmount, setCartTotalAmount = ref2.setCartTotalAmount, setAddToCartResponse = ref2.setAddToCartResponse, setAddToCartError = ref2.setAddToCartError, setAddToCartResult = ref2.setAddToCartResult, removeLicenceMultiplier = ref2.removeLicenceMultiplier, resetState = ref2.resetState, setIsOpen = ref2.setIsOpen, setIsChecked = ref2.setIsChecked, setIsAddedToCart = ref2.setIsAddedToCart, setIsLoading = ref2.setIsLoading, setMaxUsageAmountError = ref2.setMaxUsageAmountError;
    var step1 = state.step, selectedLicences = state.selectedLicences, multipliers = state.multipliers, multiplierValue = state.multiplierValue, cartFontsList = state.cartFontsList, cartSubTotalAmount = state.cartSubTotalAmount, cartTotalAmount = state.cartTotalAmount, addtoCartError = state.addtoCartError, isChecked = state.isChecked, isAddedToCart = state.isAddedToCart, loading = state.loading, maxUsageValues = state.maxUsageValues;
    var steps = [
        {
            label: "Font Styles",
            content: function(productName) {
                return "Which ".concat(productName, " styles do you need to purchase?");
            },
            id: "fontStyles"
        },
        {
            label: "Font Version",
            content: function() {
                return "Which version do you require?";
            },
            id: "fontVersion"
        },
        {
            label: "License Platforms",
            content: function() {
                return "Which platforms do you need a license for?";
            },
            id: "licencePlatform"
        },
        {
            label: "License Holder",
            content: function() {
                return "License holder details?";
            },
            id: "licenceHolder"
        }
    ];
    var requiredLicenceFields = licenceArray.map(function(licence) {
        return [
            variantExtractor(licence).map(function(key) {
                return key;
            })
        ];
    }).flat(2) // flat the array then map it back for Object.fromEntries
    .map(function(value) {
        return [
            value
        ];
    });
    var obj = Object.fromEntries(requiredLicenceFields);
    var initialValues = AddTypefaceToCart_objectSpread({
        fonts: [],
        fontVersion: "Pro"
    }, obj);
    var ref3 = (0,index_esm/* useForm */.cI)({
        defaultValues: initialValues
    }), control = ref3.control, register = ref3.register, setValue = ref3.setValue, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors, reset = ref3.reset;
    var watchFonts = (0,index_esm/* useWatch */.qo)({
        name: [
            "fonts"
        ],
        control: control
    });
    var watchFontVersion = (0,index_esm/* useWatch */.qo)({
        name: "fontVersion",
        control: control
    });
    var resetForm = function() {
        setSelectedLicences([]);
        setStep(0);
        setMultipliers([]);
        setMultiplierValue(0);
        setIsChecked({});
        reset(initialValues);
    };
    /**
   * @deprecated
   */ var haveVariantGroupings = product1.metadata.some(function(metadata) {
        return metadata.key === "variant-groups";
    });
    var variantDataGroups = getFontGroups(variants);
    var haveVariantDataGroups = variantDataGroups.length > 0;
    /**
   * @deprecated
   */ var variantGroupings1 = haveVariantGroupings ? product1.metadata.find(function(metadata) {
        return metadata.key === "variant-groups";
    }).value.split(",") : [];
    // Filter out pro - for display purposes as user chooses pro/std in step 4
    var variantsNotPro = variants.filter(function(variant) {
        return !(0,fontVersion/* fontIsPro */.j)(variant);
    });
    var variantsPro = variants.filter(function(variant) {
        return (0,fontVersion/* fontIsPro */.j)(variant);
    }).length > 0 ? variants.filter(function(variant) {
        return (0,fontVersion/* fontIsPro */.j)(variant);
    }) : variants.filter(function(variant) {
        return !(0,fontVersion/* fontIsPro */.j)(variant);
    });
    var variantsToFilter = watchFontVersion === "Pro" ? variantsPro : variantsNotPro;
    var opposingFamiliesVariantsToFilter = watchFontVersion === "Pro" ? variantsNotPro : variantsPro;
    var availableProFonts1 = availableVariantsForSelection(variantsPro, false);
    var variantsForSelection = availableVariantsForSelection(variantsToFilter, true);
    var variantsAndFamiliesForSelection = availableVariantsForSelection(variantsToFilter, false);
    var opposingFamiliesVariantsForSelection = availableVariantsForSelection(opposingFamiliesVariantsToFilter, false);
    var singleVersionFonts = cartFontsList.filter(function(variant) {
        return !opposingFamiliesVariantsForSelection.some(function(oppVariant) {
            return oppVariant.sku.replace(/-pro$/, "") === variant.sku.replace(/-pro$/, "");
        });
    });
    var versionSelectionDisabled = singleVersionFonts.length === cartFontsList.length;
    // Remove the Licence Version step if either the font is single version entirely
    // OR the variants selected are single-version
    if (singleVersionFont || versionSelectionDisabled) {
        steps.splice(1, 1);
    }
    var stepIndex = function(stepId) {
        return steps.findIndex(function(step) {
            return step.id === stepId;
        });
    };
    var stepActive = function(stepId) {
        return stepIndex(stepId) === step1;
    };
    (0,react.useEffect)(function() {
        var newValue;
        if (multipliers.length > 1) {
            newValue = multipliers.reduce(function(prevMultiplier, multiplier) {
                return prevMultiplier + multiplier.licenceMultiplier;
            }, 0);
        } else if (multipliers.length === 1) {
            newValue = multipliers[0].licenceMultiplier;
        }
        if (newValue < 1) {
            newValue = 1;
        }
        setMultiplierValue(newValue);
    }, [
        multipliers
    ]);
    (0,react.useEffect)(function() {
        var isPro = watchFontVersion === "Pro";
        // Manipulate whether we're returning pro/std fonts
        var cartFontsArray1 = variants.filter(function(variant1) {
            return watchFonts[0].some(function(font) {
                var exists = variants.some(function(variant) {
                    return variant.sku === font;
                });
                if (!exists) {
                    return font.replace(/-pro$/, "") === variant1.sku.replace(/-pro$/, "");
                }
                return isPro ? font === variant1.sku : font.replace(/-pro$/, "") === variant1.sku;
            });
        });
        setCartFontsList(cartFontsArray1);
        var totalAmount = cartFontsArray1.reduce(function(n, cartFontsArray) {
            return n + cartFontsArray.pricing.price.net.amount;
        }, 0);
        // pricing > price > net > amount
        setCartSubTotalAmount(totalAmount);
        setCartTotalAmount(totalAmount);
    }, [
        watchFontVersion,
        variants,
        watchFonts
    ]);
    (0,react.useEffect)(function() {
        if (watchFontVersion !== "Pro") {
            var watchFontsRevised = watchFonts[0].map(function(item) {
                return item.replace(/-pro$/, "");
            });
            setValue("fonts", watchFontsRevised);
        } else {
            var watchFontsRevised1 = watchFonts[0].map(function(item) {
                return item.concat("-pro");
            });
            setValue("fonts", watchFontsRevised1);
        }
    }, [
        watchFontVersion
    ]);
    // Close the modal on browser back button and prevent from moving to another page
    var onRouteChangeStart = (0,react.useCallback)(function() {
        if (!isOpen) {
            return true;
        }
        setClosed();
        router.events.emit("routeChangeError"); // This will signal next.js to cancel the route change
        router.replace(router.asPath); // Preserve the url
        throw "Route change aborted";
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", onRouteChangeStart);
        return function() {
            router.events.off("routeChangeStart", onRouteChangeStart);
        };
    }, [
        onRouteChangeStart
    ]);
    // Reset form values on route change
    (0,react.useEffect)(function() {
        resetForm();
    }, [
        router.asPath
    ]);
    var fontPrice = function(product) {
        var price = AddTypefaceToCart_objectSpread({}, product.pricing.price.net, {
            amount: product.pricing.price.net.amount * (multiplierValue || 1)
        });
        return formatPrice(price);
    };
    /**
   * Raw price of font
   * @param product
   * @returns price
   */ var fontPriceRaw = function(product) {
        var price = {
            amount: product.pricing.price.net.amount * (multiplierValue || 1)
        };
        return price.amount;
    };
    /**
   * Format Total Price
   * @param value
   * @returns price
   */ var formatTotal = function(value) {
        var price = AddTypefaceToCart_objectSpread({}, product1.pricing.priceRange.start.net, {
            amount: value * (multiplierValue || 1)
        });
        return formatPrice(price);
    };
    var updateMultipliersDefault = function(licence) {
        var initialVal = Object.values(licence.variants).map(//@ts-ignore
        function(el) {
            return el.options.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.default) === true;
            });
        });
        if (initialVal.filter(Boolean).length > 0) {
            initialVal.map(function(val) {
                setMultipliers(AddTypefaceToCart_toConsumableArray(multipliers).concat([
                    {
                        licenceMultiplier: val.multiply,
                        licenceMultiplierName: val.name,
                        licenceName: licence.name,
                        licenceVariant: licence.name
                    }
                ]));
            });
        }
    };
    /**
   * Update the licence data
   * @param licence
   */ var updateSelectedLicences = function(licence) {
        // Needs to be written better
        var licenceInState = selectedLicences.some(function(variant) {
            return variant.slug === licence.slug;
        });
        if (!licenceInState) {
            updateMultipliersDefault(licence);
            setSelectedLicences(AddTypefaceToCart_toConsumableArray(selectedLicences).concat([
                licence
            ]));
            setIsChecked(AddTypefaceToCart_objectSpread({}, isChecked, AddTypefaceToCart_defineProperty({}, licence.slug, {
                checked: true,
                name: licence.slug
            })));
        } else {
            var updatedLicences = selectedLicences.filter(function(variant) {
                return variant.slug !== licence.slug;
            });
            var maxUsageApplies = (0,util/* getMaxUsageApplies */.a9)(maxUsageValues, null, multipliers, updatedLicences);
            removeLicenceMultiplier(multipliers, licence);
            setSelectedLicences(updatedLicences);
            setMaxUsageAmountError(maxUsageApplies);
            setIsChecked(AddTypefaceToCart_objectSpread({}, isChecked, AddTypefaceToCart_defineProperty({}, licence.slug, {
                checked: false,
                name: licence.slug
            })));
            handleRemoveLicenceInForm(licence);
        }
    };
    var onErrorAlertCallback = function() {
        var _ref = AddTypefaceToCart_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        resetForm();
                        _ctx.next = 3;
                        return signOut();
                    case 3:
                        _ctx.next = 5;
                        return resetCheckoutToken();
                    case 5:
                        setIsOpen(false);
                        resetState();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onErrorAlertCallback() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Handle Add to Cart
   */ var onAddToCartSubmit = handleSubmit(function() {
        var _ref = AddTypefaceToCart_asyncToGenerator(runtime_default().mark(function _callee(formData) {
            var handleFail, ref, filteredVariants, requiredVariants, licences, filteredLicences, addTypefaceToCartBody, response, responseJson, token, lineItems;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsAddedToCart(false);
                        setIsLoading(true);
                        handleFail = function() {
                            var _$err = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                            if (_$err) setAddToCartResponse(_$err);
                            setIsAddedToCart(false);
                            setIsLoading(false);
                            setAddToCartError(true);
                            setAddToCartResult("error");
                        };
                        _ctx.prev = 3;
                        ;
                        filteredVariants = variants.filter(function(variant) {
                            return cartFontsList.some(function(font) {
                                return font.sku === variant.sku;
                            });
                        });
                        requiredVariants = filteredVariants.map(function(filteredVariant) {
                            return {
                                id: filteredVariant.id,
                                sku: filteredVariant.sku,
                                basePrice: filteredVariant.pricing.price.net.amount,
                                calculatedPriceWithSign: fontPrice(filteredVariant),
                                calculatedPrice: fontPriceRaw(filteredVariant)
                            };
                        });
                        licences = [
                            formData.licenceDesktop && JSON.parse(formData.licenceDesktop),
                            formData.licenceWeb && JSON.parse(formData.licenceWeb),
                            formData.licenceApp && JSON.parse(formData.licenceApp)
                        ];
                        filteredLicences = licences.filter(function(licence) {
                            return licence;
                        });
                        if (!(filteredLicences.length < 1 || !formData.licenceHolderName)) {
                            _ctx.next = 12;
                            break;
                        }
                        handleFail();
                        return _ctx.abrupt("return");
                    case 12:
                        addTypefaceToCartBody = JSON.stringify(AddTypefaceToCart_objectSpread({}, formData, {
                            variants: requiredVariants,
                            licences: filteredLicences,
                            email: (user === null || user === void 0 ? void 0 : user.email) || "anonymous@example.com",
                            userId: (user === null || user === void 0 ? void 0 : user.id) || null,
                            licenceeData: {
                                licenceHolderName: formData.licenceHolderName,
                                licenceHolderEmail: formData.licenceHolderEmail,
                                licenceHolderCompany: formData.licenceHolderCompany || ""
                            },
                            channel: currentChannel.slug,
                            oldCheckout: checkout || {},
                            checkoutToken: checkoutToken,
                            s3Family: (0,productHelpers/* getFontMetaS3Family */.Zm)(product1)
                        }));
                        _ctx.next = 15;
                        return fetch("/api/saleor-app/add-to-cart", {
                            headers: {
                                "Content-Type": "application/json"
                            },
                            method: "POST",
                            body: addTypefaceToCartBody
                        });
                    case 15:
                        response = _ctx.sent;
                        _ctx.next = 18;
                        return response.json();
                    case 18:
                        responseJson = _ctx.sent;
                        token = responseJson === null || responseJson === void 0 ? void 0 : (ref = responseJson.checkout) === null || ref === void 0 ? void 0 : ref.token;
                        if (token) {
                            setCheckoutToken(token);
                            setAddToCartResponse(responseJson);
                            setIsAddedToCart(true);
                            setAddToCartResult("success");
                            refetch();
                            resetForm();
                            setClosed();
                            setIsLoading(false);
                            lineItems = filteredVariants.map(function(lineItem) {
                                return {
                                    item_id: lineItem.sku,
                                    item_name: lineItem.name,
                                    price: fontPriceRaw(lineItem),
                                    quantity: 1
                                };
                            });
                            (0,addtocart/* default */.Z)({
                                lines: lineItems
                            });
                        } else {
                            handleFail();
                        }
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](3);
                        handleFail(_ctx.t0);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    23
                ]
            ]);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }());
    // Remove font items in the cart.
    var handleRemoveItem = function(cartFont) {
        var remainingFonts = cartFontsList.filter(function(item) {
            return item.sku !== cartFont.sku;
        }).map(function(item) {
            return item.sku;
        });
        setValue("fonts", remainingFonts);
    };
    var handleRemoveLicenceInForm = function(licence) {
        var variantArray = Object.values(licence.variants);
        variantArray.map(function(licenceVariant) {
            setValue("licence".concat(capitalizeFirstLetter(licenceVariant.name)), undefined);
        });
    };
    if (variants.length < 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "No Variants!"
        });
    }
    var FontFamilyRender = function(param) {
        var variantGroupings = param.variantGroupings, availableProFonts = param.availableProFonts;
        var availableProFontsNotVariable = availableProFonts.filter(function(variant) {
            return !variant.sku.includes("variable");
        });
        var availableProFontsVariable = availableProFonts.filter(function(variant) {
            return variant.sku.includes("variable");
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: variantGroupings.map(function(variantGroup, i) {
                // Load all the web fonts
                // Use pro versions
                var fonts = fontsByGroup({
                    variants: availableProFontsNotVariable,
                    variantGroup: variantGroup,
                    groupVariantsByMeta: true
                }).filter(function(variant) {
                    return (0,productHelpers/* isNotFamilyVariant */.CY)(variant);
                });
                var _$fontFamilyGroups = availableProFontsNotVariable.filter(function(variant) {
                    return (0,productHelpers/* isFamilyVariant */.S5)(variant);
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            fonts.map(function(font) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                                    fontName: getFontS3Sku(font.sku),
                                    fullPath: true,
                                    s3Path: (0,s3FontPath/* generateVariantS3Path */.MH)(product1.slug, font.sku)
                                }, font.name);
                            }),
                            availableProFontsVariable.map(function(variableFont) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                                    fontName: getFontS3Sku(variableFont.sku),
                                    fullPath: true,
                                    s3Path: (0,s3FontPath/* generateVariantS3Path */.MH)(product1.slug, variableFont.sku)
                                }, variableFont.name);
                            }),
                            _$fontFamilyGroups.map(function(fontFamilyGroup) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                                    fontName: fontFamilyGroup.sku,
                                    fullPath: true,
                                    s3Path: (0,s3FontPath/* generateFamilyVariantS3Path */.z7)(product1.slug, fontFamilyGroup)
                                }, fontFamilyGroup.sku);
                            })
                        ]
                    })
                }, i);
            })
        });
    };
    var ErrorModalContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModalStyles_module_default()).errorModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Sorry, an error occured. Please close, and try again."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                    type: "button",
                    callBack: onErrorAlertCallback,
                    children: "Close"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FontFamilyRender, {
                variantGroupings: haveVariantDataGroups ? variantDataGroups : variantGroupings1,
                availableProFonts: availableProFonts1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                isOpen: isOpen,
                closeTimeoutMS: 500,
                shouldReturnFocusAfterClose: true,
                className: (ModalStyles_module_default()).addToCartModal__Content,
                bodyOpenClassName: (ModalStyles_module_default()).addToCartModalBody,
                overlayClassName: (ModalStyles_module_default()).addToCartModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModalStyles_module_default()).addToCartModal__ContentContainer,
                        "data-cy": "typeface-add-to-cart-modal",
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Spinner/* Spinner */.$, {}),
                            addtoCartError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* default */.ZP, {
                                isError: true,
                                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModalContent, {}),
                                size: "regular",
                                position: "top"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModalStyles_module_default()).closeModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Button/* default */.Z, {
                                    variant: "ghost",
                                    callBack: function() {
                                        return setClosed();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        iconName: "close"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModalStyles_module_default()).progressBar,
                                "data-cy": "typeface-add-to-cart-progress",
                                children: steps.map(function(stepper, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ModalStyles_module_default()).progressBarItems,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: step1 === index ? (ModalStyles_module_default()).stepperCircleActive : step1 > index ? (ModalStyles_module_default()).stepperCircleDone : (ModalStyles_module_default()).stepperCircle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: index + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ModalStyles_module_default()).stepperLabel + " u-h6",
                                                    children: stepper.label
                                                })
                                            ]
                                        })
                                    }, stepper.label);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModalStyles_module_default()).progressBarMobile,
                                children: steps.map(function(stepper, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: step1 === index ? (ModalStyles_module_default()).stepperLabelMobile : (ModalStyles_module_default()).hidden,
                                        children: stepper.label
                                    }, stepper.label);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_Grid/* Grid */.r, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Grid/* Column */.s, {
                                        sm: 0,
                                        md: 0,
                                        lg: 0,
                                        xl: 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Grid/* Column */.s, {
                                        sm: 12,
                                        md: 12,
                                        lg: 6,
                                        xl: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: (ModalStyles_module_default()).addTypefaceForm,
                                            children: [
                                                stepActive("fontStyles") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_VariantGroupings, {
                                                    product: product1,
                                                    content: steps[stepIndex("fontStyles")].content(product1.name),
                                                    variantGroupings: haveVariantDataGroups ? variantDataGroups : variantGroupings1,
                                                    variants: variantsForSelection,
                                                    groupVariantsByMeta: haveVariantDataGroups,
                                                    register: register,
                                                    errors: errors,
                                                    fontsByGroup: fontsByGroup,
                                                    fontFamilyGroups: fontFamilyGroups({
                                                        variants: variantsToFilter,
                                                        checkout: checkout
                                                    }),
                                                    watchFonts: watchFonts
                                                }),
                                                stepActive("fontVersion") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_LicenceVersions, {
                                                            content: steps[stepIndex("fontVersion")].content(null),
                                                            register: register
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_AddToCartInstruction, {
                                                            variants: variantsAndFamiliesForSelection,
                                                            cartFontsList: cartFontsList,
                                                            watchFontVersion: watchFontVersion
                                                        })
                                                    ]
                                                }),
                                                stepActive("licencePlatform") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_LicenceStep, {
                                                    register: register,
                                                    content: steps[stepIndex("licencePlatform")].content(null),
                                                    isChecked: isChecked,
                                                    licenceArray: licenceArray,
                                                    capitalizeFirstLetter: capitalizeFirstLetter,
                                                    updateSelectedLicences: updateSelectedLicences,
                                                    errors: errors
                                                }),
                                                stepActive("licenceHolder") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_LicenceHolder, {
                                                    content: steps[stepIndex("licenceHolder")].content(null),
                                                    register: register,
                                                    errors: errors
                                                })
                                            ]
                                        })
                                    }),
                                    !isTouchDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Grid/* Column */.s, {
                                        sm: 0,
                                        md: 12,
                                        lg: 6,
                                        xl: 5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_Summary, {
                                            product: product1,
                                            cartFontsList: cartFontsList,
                                            fontPrice: fontPrice,
                                            handleRemoveItem: handleRemoveItem,
                                            formatTotal: formatTotal,
                                            cartSubTotalAmount: cartSubTotalAmount,
                                            cartTotalAmount: cartTotalAmount,
                                            allowEditing: stepActive("fontStyles")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModalStyles_module_default()).bottomSpacer
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_StepNavigation, {
                        steps: steps,
                        onAddToCartSubmit: onAddToCartSubmit,
                        isAddedToCart: isAddedToCart,
                        watchFonts: watchFonts,
                        control: control,
                        isTouchDevice: isTouchDevice,
                        stepActive: stepActive,
                        setValue: setValue,
                        children: isTouchDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypeFaceToCart_Summary, {
                            product: product1,
                            cartFontsList: cartFontsList,
                            fontPrice: fontPrice,
                            handleRemoveItem: handleRemoveItem,
                            formatTotal: formatTotal,
                            cartSubTotalAmount: cartSubTotalAmount,
                            cartTotalAmount: cartTotalAmount,
                            allowEditing: stepActive("fontStyles")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/index.ts













/***/ }),

/***/ 5303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iJ": function() { return /* binding */ useAddressValidationRules; },
/* harmony export */   "FS": function() { return /* binding */ AddressValidationProvider; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95841);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67062);
/* harmony import */ var _CheckoutProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34639);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ref = _slicedToArray((0,_lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2);
var useAddressValidationRules = ref[0], Provider = ref[1];
var AddressValidationProvider = function(param) {
    var children = param.children;
    var ref6, ref1, ref2;
    var checkout = (0,_CheckoutProvider__WEBPACK_IMPORTED_MODULE_4__/* .useCheckout */ .Mg)().checkout;
    var existingCountry = checkout === null || checkout === void 0 ? void 0 : (ref6 = checkout.billingAddress) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.country) === null || ref1 === void 0 ? void 0 : ref1.code;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedCountry = ref3[0], setSelectedCountry = ref3[1];
    var activeCountry = selectedCountry || existingCountry;
    var existingCountryArea = checkout === null || checkout === void 0 ? void 0 : (ref2 = checkout.billingAddress) === null || ref2 === void 0 ? void 0 : ref2.countryArea;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedCountryArea = ref4[0], setSelectedCountryArea = ref4[1];
    var activeCountryArea = selectedCountryArea || existingCountryArea;
    var ref5 = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_3__/* .useAddressValidationRulesQuery */ .EKp)({
        variables: {
            countryCode: activeCountry || "GB",
            countryArea: activeCountryArea
        }
    }), addressValidationData = ref5.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: {
            addressValidationData: addressValidationData,
            setSelectedCountry: setSelectedCountry,
            setSelectedCountryArea: setSelectedCountryArea
        },
        children: children
    });
};


/***/ }),

/***/ 34639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oo": function() { return /* binding */ CheckoutProvider; },
  "Mg": function() { return /* binding */ useCheckout; }
});

// UNUSED EXPORTS: Provider

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./lib/checkout/getEUCountry.ts
var getEUCountry = __webpack_require__(67414);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
;// CONCATENATED MODULE: ./lib/hooks/useLocalStorage.ts
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

function useLocalStorage(key, initialValue) {
    var sync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).sync;
    var ref = (0,react.useState)(function() {
        var result;
        try {
            var item = window.localStorage.getItem(key);
            result = item ? JSON.parse(item) : initialValue;
        } catch (e) {
            result = initialValue;
        }
        return result;
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(valueOrCb) {
        setStoredValue(valueOrCb);
        var valueToStore = _instanceof(valueOrCb, Function) ? valueOrCb(storedValue) : valueOrCb;
        try {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (e) {
            console.warn("Could not save ".concat(key, " to localStorage"));
        }
    };
    var onStorage = (0,react.useCallback)(function(event) {
        if (event.key !== key) return;
        try {
            var item = event.newValue;
            if (item) {
                setStoredValue(JSON.parse(item));
            }
        } catch (e) {
            console.warn("Could not update value for ".concat(key));
        }
    }, [
        key
    ]);
    (0,react.useEffect)(function() {
        if (sync) {
            window.addEventListener("storage", onStorage);
            return function() {
                window.removeEventListener("storage", onStorage);
            };
        }
    }, [
        onStorage,
        sync
    ]);
    return [
        storedValue,
        setValue
    ];
}

// EXTERNAL MODULE: ./lib/regions.ts
var regions = __webpack_require__(85567);
// EXTERNAL MODULE: ./lib/useSafeContext.ts
var useSafeContext = __webpack_require__(95841);
// EXTERNAL MODULE: ./node_modules/.pnpm/fast-xml-parser@4.0.9/node_modules/fast-xml-parser/src/fxp.js
var fxp = __webpack_require__(89013);
// EXTERNAL MODULE: ./lib/vat/helpers.ts
var helpers = __webpack_require__(53728);
;// CONCATENATED MODULE: ./lib/vat/service.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var viesVatChecker = function() {
    var _ref1 = _asyncToGenerator(runtime_default().mark(function _callee1(param1) {
        var countryCode1, vatNumber1, regex, validate, result, validateVATResult, parser, JSONObject, fault, valid;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    countryCode1 = param1.countryCode, vatNumber1 = param1.vatNumber;
                    regex = new RegExp("^(ATU[0-9]{8}|BE0[0-9]{9}|BG[0-9]{9,10}|CY[0-9]{8}L|CZ[0-9]{8,10}|DE[0-9]{9}|DK[0-9]{8}|EE[0-9]{9}|(EL|GR)[0-9]{9}|ES[0-9A-Z][0-9]{7}[0-9A-Z]|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|GB([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|HU[0-9]{8}|HR[0-9]{11}|IE[0-9]S[0-9]{5}L|IT[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|LV[0-9]{11}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SE[0-9]{12}|SI[0-9]{8}|SK[0-9]{10})$");
                    validate = function() {
                        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
                            var countryCode, vatNumber, headers, soapRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        countryCode = param.countryCode, vatNumber = param.vatNumber;
                                        headers = new Headers();
                                        headers.append("Content-Type", "text/xml");
                                        soapRequest = '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"\n    xmlns:tns1="urn:ec.europa.eu:taxud:vies:services:checkVat:types"\n    xmlns:impl="urn:ec.europa.eu:taxud:vies:services:checkVat">\n    <soap:Header>\n    </soap:Header>\n    <soap:Body>\n      <tns1:checkVat xmlns:tns1="urn:ec.europa.eu:taxud:vies:services:checkVat:types"\n       xmlns="urn:ec.europa.eu:taxud:vies:services:checkVat:types">\n       <tns1:countryCode>'.concat((0,helpers/* getCountryVatCode */.n)(countryCode), "</tns1:countryCode>\n       <tns1:vatNumber>").concat(vatNumber, "</tns1:vatNumber>\n      </tns1:checkVat>\n    </soap:Body>\n  </soap:Envelope>");
                                        return _ctx.abrupt("return", fetch("http://ec.europa.eu/taxation_customs/vies/services/checkVatService", {
                                            method: "POST",
                                            headers: headers,
                                            mode: "cors",
                                            body: soapRequest
                                        }).then(function(response) {
                                            return response.text();
                                        }).catch(function(error) {
                                            console.log(error);
                                            return false;
                                        }));
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function validate(_) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    result = regex.test("".concat(countryCode1).concat(vatNumber1));
                    if (result) {
                        _ctx1.next = 6;
                        break;
                    }
                    return _ctx1.abrupt("return", {
                        errors: [
                            {
                                message: "VAT Number is an invalid format"
                            }
                        ],
                        success: false
                    });
                case 6:
                    _ctx1.next = 8;
                    return validate({
                        countryCode: countryCode1,
                        vatNumber: vatNumber1
                    });
                case 8:
                    validateVATResult = _ctx1.sent;
                    if (validateVATResult) {
                        _ctx1.next = 11;
                        break;
                    }
                    return _ctx1.abrupt("return", {
                        errors: [
                            {
                                message: "Your VAT number could not be checked. Please try again in a moment."
                            }
                        ],
                        success: false
                    });
                case 11:
                    parser = new fxp.XMLParser();
                    JSONObject = parser.parse("".concat(validateVATResult));
                    fault = JSONObject["env:Envelope"]["env:Body"]["env:Fault"];
                    if (!fault) {
                        _ctx1.next = 16;
                        break;
                    }
                    return _ctx1.abrupt("return", {
                        errors: [
                            {
                                message: "Your VAT number could not be checked. Please try again in a moment."
                            }
                        ],
                        success: false
                    });
                case 16:
                    valid = JSONObject["env:Envelope"]["env:Body"]["ns2:checkVatResponse"]["ns2:valid"];
                    return _ctx1.abrupt("return", {
                        errors: valid ? [] : [
                            {
                                message: "VAT Number is invalid"
                            }
                        ],
                        success: valid
                    });
                case 18:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function viesVatChecker(_) {
        return _ref1.apply(this, arguments);
    };
}();
var getVatValidity = function(param) {
    var countryCode = param.countryCode, vatNumber = param.vatNumber, checkoutToken = param.checkoutToken, checkoutId = param.checkoutId, email = param.email, channel = param.channel, userId = param.userId;
    var origin;
    if (true) {
        origin = window.location.origin;
    }
    return fetch("".concat(origin, "/api/saleor-app/vat-check"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            vatCountry: countryCode,
            inputVatNumber: vatNumber,
            checkoutToken: checkoutToken,
            checkoutId: checkoutId,
            email: email,
            channel: channel,
            userId: userId
        })
    }).then(function(response) {
        return response.json();
    }).catch(function(error) {
        console.log(error);
        return false;
    });
};
var resetVatNumber = function(param) {
    var checkoutToken = param.checkoutToken, checkoutId = param.checkoutId, email = param.email, channel = param.channel, userId = param.userId;
    var origin;
    if (true) {
        origin = window.location.origin;
    }
    return fetch("".concat(origin, "/api/saleor-app/vat-reset"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            checkoutToken: checkoutToken,
            checkoutId: checkoutId,
            email: email,
            channel: channel,
            userId: userId
        })
    }).then(function(response) {
        return response.json();
    }).catch(function(error) {
        console.log(error);
        return false;
    });
};
var toggleVatRemoval = function(param) {
    var countryCode = param.countryCode, vatNumber = param.vatNumber, checkoutToken = param.checkoutToken, checkoutId = param.checkoutId, email = param.email, channel = param.channel, userId = param.userId;
    var origin;
    if (true) {
        origin = window.location.origin;
    }
    return fetch("".concat(origin, "/api/saleor-app/vat-removal"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            vatCountry: countryCode,
            inputVatNumber: vatNumber,
            checkoutToken: checkoutToken,
            checkoutId: checkoutId,
            email: email,
            channel: channel,
            userId: userId
        })
    }).then(function(response) {
        return response.json();
    }).catch(function(error) {
        console.log(error);
    });
};

// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
;// CONCATENATED MODULE: ./components/providers/CheckoutProvider.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function CheckoutProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CheckoutProvider_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CheckoutProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CheckoutProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var ref = _slicedToArray((0,useSafeContext/* default */.Z)(), 2);
var useCheckout = ref[0], Provider = ref[1];
var checkVat = function() {
    var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(checkout, vatCountry, vatNumber, channel, userId) {
        var vatResult;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getVatValidity({
                        countryCode: vatCountry,
                        vatNumber: vatNumber,
                        checkoutToken: checkout.token,
                        email: checkout.email,
                        checkoutId: checkout.id,
                        channel: channel,
                        userId: userId
                    });
                case 2:
                    vatResult = _ctx.sent;
                    return _ctx.abrupt("return", vatResult);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkVat(checkout, vatCountry, vatNumber, channel, userId) {
        return _ref.apply(this, arguments);
    };
}();
var resetVat = function() {
    var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(checkout, channel, userId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return resetVatNumber({
                        checkoutToken: checkout.token,
                        email: checkout.email,
                        checkoutId: checkout.id,
                        channel: channel,
                        userId: userId
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function resetVat(checkout, channel, userId) {
        return _ref.apply(this, arguments);
    };
}();
var CheckoutProvider = function(param1) {
    var children = param1.children;
    var ref9;
    var router = (0,next_router.useRouter)();
    var locale = ((ref9 = router.query.locale) === null || ref9 === void 0 ? void 0 : ref9.toString()) || regions/* DEFAULT_LOCALE */.ZW;
    var ref1 = _slicedToArray(useLocalStorage(constants/* CHECKOUT_TOKEN */.ES, "", {
        sync: true
    }), 2), checkoutToken = ref1[0], setCheckoutToken = ref1[1];
    var ref2 = (0,react.useState)("sameAsBillingAddress"), shippingAddress = ref2[0], setShippingAddress = ref2[1];
    var ref3 = (0,react.useState)(true), addNewBillingAddress = ref3[0], setAddNewBillingAddress = ref3[1];
    var ref4 = (0,react.useState)(true), addNewShippingAddress = ref4[0], setAddNewShippingAddress = ref4[1];
    var ref5 = (0,react.useState)([]), checkoutFormErrors = ref5[0], setCheckoutFormErrors = ref5[1];
    var ref6 = (0,react.useState)({}), vatValidityResponse = ref6[0], setVatValidityResponse = ref6[1];
    var ref7 = (0,react.useState)(false), vatChecking = ref7[0], setVatChecking = ref7[1];
    var updateCheckoutFormErrors = function(type) {
        var errors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if (type === "clear") {
            return setCheckoutFormErrors([]);
        }
        if (type === "add") {
            return setCheckoutFormErrors(_toConsumableArray(checkoutFormErrors).concat(_toConsumableArray(errors)));
        }
        if (type === "remove") {
            var errorArray = checkoutFormErrors.filter(function(arrError) {
                return !errors.includes(arrError);
            });
            return setCheckoutFormErrors(errorArray);
        }
    };
    var ref8 = (0,api/* useCheckoutByTokenQuery */.KEu)({
        variables: {
            checkoutToken: checkoutToken,
            locale: (0,regions/* localeToEnum */.BN)(locale)
        },
        skip: !checkoutToken || "object" === "undefined",
        fetchPolicy: "network-only"
    }), data = ref8.data, loading = ref8.loading, checkoutError = ref8.error, networkStatus = ref8.networkStatus, refetch = ref8.refetch, fetchMore = ref8.fetchMore;
    var resetCheckoutToken = function() {
        return setCheckoutToken("");
    };
    // Every time the country/vat number fields change
    // If the country is EU, we check the number
    // Otherwise reset/do nothing
    var checkVatNumber = function() {
        var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var number, country, currentChannel, userId, euCountry, ref11, ref10, success, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        number = param.number, country = param.country, currentChannel = param.currentChannel, userId = param.userId;
                        setVatChecking(true);
                        setVatValidityResponse({});
                        euCountry = (0,getEUCountry/* getEUCountry */.J)(country);
                        if (!(euCountry.length > 0 && number && country !== "GB")) {
                            _ctx.next = 14;
                            break;
                        }
                        ;
                        _ctx.next = 8;
                        return checkVat(data === null || data === void 0 ? void 0 : data.checkout, country, number, currentChannel, userId);
                    case 8:
                        ref10 = _ctx.sent;
                        success = ref10.success;
                        errors = ref10.errors;
                        setVatValidityResponse({
                            vatValid: success,
                            message: success ? "Your VAT number is valid." : (ref11 = errors[0]) === null || ref11 === void 0 ? void 0 : ref11.message
                        });
                        _ctx.next = 15;
                        break;
                    case 14:
                        {
                            resetVat(data === null || data === void 0 ? void 0 : data.checkout, currentChannel, userId);
                            setVatValidityResponse({});
                        }
                    case 15:
                        setVatChecking(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkVatNumber(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // Ping VAT Number to Saleor to remove VAT or, if no number, add it back
    var toggleVatOrNotVat = function() {
        var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(vat, checkout, currentChannel) {
            var ref14, ref12, ref13, userId, vatRemovalResponse, success;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        userId = checkout === null || checkout === void 0 ? void 0 : (ref14 = checkout.user) === null || ref14 === void 0 ? void 0 : ref14.id;
                        _ctx.next = 4;
                        return toggleVatRemoval({
                            checkoutToken: checkout.token,
                            email: checkout.email,
                            checkoutId: checkout.id,
                            channel: currentChannel.slug,
                            countryCode: vat === null || vat === void 0 ? void 0 : vat.country,
                            vatNumber: vat === null || vat === void 0 ? void 0 : vat.number,
                            userId: userId
                        });
                    case 4:
                        vatRemovalResponse = _ctx.sent;
                        success = vatRemovalResponse === null || vatRemovalResponse === void 0 ? void 0 : (ref12 = vatRemovalResponse.taxableObject) === null || ref12 === void 0 ? void 0 : ref12.taxExemption;
                        setVatValidityResponse({
                            vatValid: success,
                            message: success ? "Your VAT number is valid." : (ref13 = vatRemovalResponse === null || vatRemovalResponse === void 0 ? void 0 : vatRemovalResponse.errors[0]) === null || ref13 === void 0 ? void 0 : ref13.message
                        });
                        _ctx.next = 9;
                        return fetchMore({
                            variables: {
                                checkoutToken: checkout.token,
                                locale: (0,regions/* localeToEnum */.BN)(locale)
                            }
                        });
                    case 9:
                        return _ctx.abrupt("return", true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function toggleVatOrNotVat(vat, checkout, currentChannel) {
            return _ref.apply(this, arguments);
        };
    }();
    // Reset and remove VAT, reinstate tax
    var resetAndRemoveVAT = function() {
        var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var currentChannel, ref16, ref15, userId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentChannel = param.currentChannel;
                        ;
                        userId = data === null || data === void 0 ? void 0 : (ref16 = data.checkout) === null || ref16 === void 0 ? void 0 : (ref15 = ref16.user) === null || ref15 === void 0 ? void 0 : ref15.id;
                        _ctx.next = 5;
                        return resetVat(data === null || data === void 0 ? void 0 : data.checkout, currentChannel, userId);
                    case 5:
                        _ctx.next = 7;
                        return fetchMore({
                            variables: {
                                checkoutToken: data.checkout.token,
                                locale: (0,regions/* localeToEnum */.BN)(locale)
                            }
                        });
                    case 7:
                        return _ctx.abrupt("return", true);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resetAndRemoveVAT(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCheckoutById = function() {
        var _ref = CheckoutProvider_asyncToGenerator(runtime_default().mark(function _callee(token) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!token) {
                            _ctx.next = 4;
                            break;
                        }
                        setCheckoutToken(token);
                        _ctx.next = 4;
                        return fetchMore({
                            variables: {
                                checkoutToken: token,
                                locale: (0,regions/* localeToEnum */.BN)(locale)
                            }
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCheckoutById(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var providerValues = {
        checkoutToken: checkoutToken,
        setCheckoutToken: setCheckoutToken,
        resetCheckoutToken: resetCheckoutToken,
        loadCheckoutById: loadCheckoutById,
        checkout: data === null || data === void 0 ? void 0 : data.checkout,
        loading: loading,
        checkoutError: checkoutError,
        checkoutFormErrors: checkoutFormErrors,
        updateCheckoutFormErrors: updateCheckoutFormErrors,
        refetch: refetch,
        shippingAddress: shippingAddress,
        setShippingAddress: setShippingAddress,
        setAddNewBillingAddress: setAddNewBillingAddress,
        setAddNewShippingAddress: setAddNewShippingAddress,
        addNewBillingAddress: addNewBillingAddress,
        addNewShippingAddress: addNewShippingAddress,
        checkVatNumber: checkVatNumber,
        vatChecking: vatChecking,
        setVatValidityResponse: setVatValidityResponse,
        resetAndRemoveVAT: resetAndRemoveVAT,
        toggleVatOrNotVat: toggleVatOrNotVat,
        vatValidityResponse: vatValidityResponse,
        networkStatus: networkStatus,
        fetchMore: fetchMore
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};


/***/ }),

/***/ 13657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ useHeaderTheme; },
/* harmony export */   "AD": function() { return /* binding */ HeaderThemeProvider; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6474);
/* harmony import */ var _components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_global_Header_HeaderPanel_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87820);
/* harmony import */ var _components_global_Header_HeaderPanel_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_global_Header_HeaderPanel_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95841);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var ref = _slicedToArray((0,_lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2);
var useHeaderTheme = ref[0], Provider = ref[1];
var HeaderThemeProvider = function(param) {
    var children = param.children;
    var initialHeaderClasses = function() {
        return (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4___default().header));
    };
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), menuOpen = ref4[0], setMenuOpen = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), headerFixed = ref1[0], setHeaderFixed = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), headerTheme = ref2[0], setHeaderTheme = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialHeaderClasses()), headerClasses = ref3[0], setHeaderClasses = ref3[1];
    var headerFixedScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var isFixed = window.scrollY > 2;
        setHeaderFixed(isFixed);
    }, [
        setHeaderFixed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", headerFixedScroll);
        return function() {
            return window.removeEventListener("scroll", headerFixedScroll);
        };
    }, [
        headerFixedScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.classList.remove("mobile-overflow-hidden");
        if (menuOpen) {
            document.body.classList.add("mobile-overflow-hidden");
        }
    }, [
        menuOpen
    ]);
    // header classes from state
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var classes = (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4___default().header), "th-".concat(headerTheme), headerFixed ? (_components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headerFixed) : "", menuOpen ? (_components_global_Header_Header_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headerMenuOpen) : "");
        setHeaderClasses(classes);
    }, [
        menuOpen,
        headerFixed,
        headerTheme
    ]);
    // check window scroll on first page load
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fix = window.scrollY > 2;
        setHeaderFixed(fix);
    }, []);
    // listener
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!menuOpen) return;
        var loopThroughParents = function(el, check) {
            check(el);
            if (el.parentElement) loopThroughParents(el.parentElement, check);
        };
        var clickListen = function(ev) {
            if (!menuOpen) return;
            var headerClick = false;
            loopThroughParents(ev.target, function(el) {
                var cls = el.getAttribute("class");
                if (cls === null || cls === void 0 ? void 0 : cls.includes((_components_global_Header_HeaderPanel_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerPanel))) headerClick = true;
                if ([
                    "Open Menu",
                    "Close Menu"
                ].includes(el.title)) headerClick = true; // so that menu icon click does not immediately close
            });
            if (!headerClick) setMenuOpen(false);
        };
        window.addEventListener("click", clickListen);
        window.addEventListener("touchstart", clickListen);
        return function() {
            window.removeEventListener("click", clickListen);
            window.removeEventListener("touchstart", clickListen);
        };
    }, [
        setMenuOpen,
        menuOpen
    ]);
    var providerValues = {
        headerState: {
            theme: headerTheme,
            fixed: headerFixed,
            menuOpen: menuOpen
        },
        headerFixedScroll: headerFixedScroll,
        setHeaderTheme: setHeaderTheme,
        setMenuOpen: setMenuOpen,
        headerClasses: headerClasses
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};


/***/ }),

/***/ 60239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ providers_RegionsProvider; },
  "eH": function() { return /* binding */ useRegions; }
});

// UNUSED EXPORTS: Provider, RegionsProvider, importMessages, useContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(42623);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(1998);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(41444);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+ecma402-abstract@1.11.4/node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(14547);
// EXTERNAL MODULE: ./node_modules/.pnpm/intl-messageformat@9.13.0/node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(20289);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(32401);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+icu-messageformat-parser@2.1.0/node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 9 modules
var lib = __webpack_require__(97304);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_es6/* __assign */.pi)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(56491);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/.pnpm/intl-messageformat@9.13.0/node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(19059);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@formatjs+intl@2.2.1_typescript@4.6.3/node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: formatMessage.bind(null, resolvedConfig, formatters), $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/intl-messageformat@9.13.0/node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(5208);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6/* __rest */._T)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, coreIntl), { formatMessage: provider_formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements,
        }, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

// EXTERNAL MODULE: ./components/providers/CheckoutProvider.tsx + 2 modules
var CheckoutProvider = __webpack_require__(34639);
// EXTERNAL MODULE: ./lib/regions.ts
var regions = __webpack_require__(85567);
// EXTERNAL MODULE: ./lib/useSafeContext.ts
var useSafeContext = __webpack_require__(95841);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
;// CONCATENATED MODULE: ./locale/en-US.json
var en_US_namespaceObject = JSON.parse('{"app.checkout.addressField":"Address","app.checkout.billingAddressCardHeader":"Billing Address","app.checkout.billingMethodCardHeader":"Billing Method","app.checkout.cardNumberField":"Card number","app.checkout.checkoutButton":"Checkout →","app.checkout.cityField":"City","app.checkout.cvcField":"CVC","app.checkout.discount":"Discount","app.checkout.discountCode":"Discount code","app.checkout.emailAddressCardHeader":"Purchasing our typefaces requires a Colophon Foundry account.","app.checkout.expDateField":"Expiration date","app.checkout.firstNameField":"First name","app.checkout.lastNameField":"Last name","app.checkout.orderSummary":"Order summary","app.checkout.pageHeader":"Your Cart","app.checkout.paymentButton":"Pay {total}","app.checkout.paymentCardHeader":"Payment","app.checkout.paymentInstruction":"Choose payment method","app.checkout.phoneField":"Phone","app.checkout.postalCodeField":"Postal code","app.checkout.sameAsBillingButton":"Use the same address as billing","app.checkout.shipping":"Shipping","app.checkout.shippingAddressCardHeader":"Shipping Address","app.checkout.shippingMethodCardHeader":"Shipping Method","app.checkout.subtotal":"Subtotal","app.checkout.tax":"Tax","app.checkout.total":"Total","app.checkout.vatNumberCardHeader":"Enter VAT details","app.home.greeting":"More →","app.login.createAccount":"Create Account","app.login.emailField":"Email","app.login.greeting":"Welcome back","app.login.header":"Login to your account","app.login.passwordField":"Password","app.login.remindPassword":"Forgot your password?","app.navigation.accountPreferences":"Account preferences","app.navigation.addressBook":"Address book","app.navigation.login":"Log in →","app.navigation.logout":"Log out","app.navigation.orders":"Orders","app.preferences.addressbook.defaultBilling":"Default billing address","app.preferences.addressbook.defaultBillingShipping":"Default billing and shipping address","app.preferences.addressbook.defaultShipping":"Default shipping address","app.preferences.addressbook.noData":"No addresses information for this user","app.preferences.addressbook.setDefaultBilling":"Set as billing default","app.preferences.addressbook.setDefaultShipping":"Set as shipping default","app.preferences.changeEmail.header":"Change email","app.preferences.changePassword.header":"Repeat new password","app.preferences.changePassword.newPasswordFieldLabel":"New password","app.preferences.changePassword.oldPasswordFieldLabel":"Old password","app.product.addToCart":"Add to Cart","app.product.adding":"Adding...","app.product.attributes":"Attributes","app.product.soldOut":"Sold out!","app.product.variantNotChosen":"Please choose a variant","app.region.channelField":"Channel","app.region.languageField":"Language","app.region.modalHeader":"Choose your region","app.register.backToLogin":"Back","app.register.emailField":"Email","app.register.header":"Create a new account","app.register.passwordField":"Password","app.register.registerButton":"Create account","app.search.searchFieldPlaceholder":"What are you looking for?","app.search.searchHeader":"Search","app.ui.activateButton":"Activate","app.ui.browseProducts":"Browse products","app.ui.changeButton":"Change account","app.ui.loadMoreButton":"Load more","app.ui.noProductsInfo":"Make sure to write complete words (e.g. Grotesque) or check for any typos","app.ui.productCounter":"{currentItemsCount} out of {totalItemsCount}","app.ui.removeButton":"Remove","app.ui.saveButton":"Save","app.ui.saveEmailChanges":"Save email","app.ui.savePasswordChanges":"Save password"}');
var locale_en_US_namespaceObject = /*#__PURE__*/__webpack_require__.t(en_US_namespaceObject, 2);
;// CONCATENATED MODULE: ./components/providers/RegionsProvider.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var ref = _slicedToArray((0,useSafeContext/* default */.Z)(), 2);
var useContext = ref[0], Provider = ref[1];
function importMessages(locale) {
    switch(locale){
        case "en-US":
            return locale_en_US_namespaceObject;
        // case 'pl-PL':
        //   return pl;
        default:
            return locale_en_US_namespaceObject;
    }
}
var RegionsProvider = function(param1) {
    var children = param1.children;
    var ref2;
    var router = (0,next_router.useRouter)();
    var resetCheckoutToken = (0,CheckoutProvider/* useCheckout */.Mg)().resetCheckoutToken;
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    var ref1 = (0,react.useState)(router.query.channel), currentChannelSlug = ref1[0], setCurrentChannelSlug = ref1[1];
    var setCurrentChannel = function(channel) {
        resetCheckoutToken();
        setCurrentChannelSlug(channel);
        apolloClient.clearStore();
    };
    var locale = ((ref2 = router.query.locale) === null || ref2 === void 0 ? void 0 : ref2.toString()) || regions/* DEFAULT_LOCALE */.ZW;
    var currentChannel = regions/* CHANNELS.find */.pD.find(function(param) {
        var slug = param.slug;
        return slug === currentChannelSlug;
    }) || regions/* DEFAULT_CHANNEL */.vE;
    var formatPrice = function(price) {
        return (0,util/* formatAsMoney */.AW)((price === null || price === void 0 ? void 0 : price.amount) || 0, (price === null || price === void 0 ? void 0 : price.currency) || currentChannel.currencyCode, locale);
    };
    var providerValues = {
        channels: regions/* CHANNELS */.pD,
        defaultChannel: regions/* DEFAULT_CHANNEL */.vE,
        currentChannel: currentChannel,
        setCurrentChannel: setCurrentChannel,
        currentLocale: locale,
        query: {
            channel: currentChannel.slug,
            locale: (0,regions/* localeToEnum */.BN)(locale)
        },
        formatPrice: formatPrice
    };
    var msgs = importMessages(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: providerValues,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(provider, {
            messages: msgs,
            locale: locale,
            defaultLocale: regions/* DEFAULT_LOCALE */.ZW,
            children: children
        })
    });
};
var useRegions = useContext;
/* harmony default export */ var providers_RegionsProvider = (RegionsProvider);


/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aV": function() { return /* binding */ useSiteTicker; },
/* harmony export */   "Jh": function() { return /* binding */ SiteTickerProvider; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95841);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var ref = _slicedToArray((0,_lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2);
var useSiteTicker = ref[0], Provider = ref[1];
var SiteTickerProvider = function(param) {
    var children = param.children;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("false"), showTicker = ref1[0], setShowTicker = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var saved =  true ? localStorage.getItem("site-ticker") : 0;
        setShowTicker(saved || "true");
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var tickerHeight = showTicker === "false" ? "0px" : "40px";
        document.documentElement.style.setProperty("--ticker-height", tickerHeight);
    }, [
        showTicker
    ]);
    var hideTicker = function() {
        localStorage.setItem("site-ticker", "false");
        setShowTicker("false");
    };
    var providerValue = {
        showTicker: showTicker,
        setShowTicker: setShowTicker,
        hideTicker: hideTicker
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: providerValue,
        children: children
    });
};


/***/ }),

/***/ 49717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ useTypefaceAddToCart; },
/* harmony export */   "Vi": function() { return /* binding */ TypefaceProvider; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95841);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var ref = _slicedToArray((0,_lib_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2);
var useTypefaceAddToCart = ref[0], Provider = ref[1];
var TypefaceProvider = function(param) {
    var children = param.children;
    var reducer = function reducer(state, action) {
        switch(action.type){
            case "setStep":
                return _objectSpread({}, state, {
                    step: action.payload
                });
            case "setSelectedLicences":
                return _objectSpread({}, state, {
                    selectedLicences: action.payload
                });
            case "setMultipliers":
                return _objectSpread({}, state, {
                    multipliers: action.payload
                });
            case "setMultiplierValue":
                return _objectSpread({}, state, {
                    multiplierValue: action.payload
                });
            case "setCartFontsList":
                return _objectSpread({}, state, {
                    cartFontsList: action.payload
                });
            case "setCartSubTotalAmount":
                return _objectSpread({}, state, {
                    cartSubTotalAmount: action.payload
                });
            case "setCartTotalAmount":
                return _objectSpread({}, state, {
                    cartTotalAmount: action.payload
                });
            case "setAddToCartResponse":
                return _objectSpread({}, state, {
                    addToCartResponse: action.payload
                });
            case "setAddToCartError":
                return _objectSpread({}, state, {
                    addtoCartError: action.payload
                });
            case "setMaxUsageAmountError":
                return _objectSpread({}, state, {
                    maxUsageError: action.payload
                });
            case "setAddToCartResult":
                return _objectSpread({}, state, {
                    addToCartResult: action.payload
                });
            case "setIsChecked":
                return _objectSpread({}, state, {
                    isChecked: action.payload
                });
            case "setIsAddedToCart":
                return _objectSpread({}, state, {
                    isAddedToCart: action.payload
                });
            case "setIsOpen":
                return _objectSpread({}, state, {
                    isOpen: action.payload
                });
            case "setIsLoading":
                return _objectSpread({}, state, {
                    loading: action.payload
                });
            case "resetState":
                return initialState;
            default:
                throw new Error();
        }
    };
    var MAX_USAGE_VALUES = [
        "201+ desktop users",
        "2,000,000+ webpage views/month",
        "10m+ downloads",
        "4+ titles for one year"
    ];
    var initialState = {
        maxUsageValues: MAX_USAGE_VALUES,
        isChecked: {},
        step: 0,
        selectedLicences: [],
        isAddedToCart: false,
        multipliers: [],
        multiplierValue: 0,
        cartFontsList: [],
        cartSubTotalAmount: 0,
        cartTotalAmount: 0,
        addToCartResponse: {},
        addtoCartError: false,
        maxUsageError: false,
        loading: false,
        addToCartResult: "",
        isOpen: false
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialState), state1 = ref1[0], dispatch = ref1[1];
    var setStep = function(value) {
        return dispatch({
            type: "setStep",
            payload: value
        });
    };
    var setSelectedLicences = function(value) {
        return dispatch({
            type: "setSelectedLicences",
            payload: value
        });
    };
    var setMultipliers = function(value) {
        return dispatch({
            type: "setMultipliers",
            payload: value
        });
    };
    var setMultiplierValue = function(value) {
        return dispatch({
            type: "setMultiplierValue",
            payload: value
        });
    };
    var setCartFontsList = function(value) {
        return dispatch({
            type: "setCartFontsList",
            payload: value
        });
    };
    var setCartSubTotalAmount = function(value) {
        return dispatch({
            type: "setCartSubTotalAmount",
            payload: value
        });
    };
    var setCartTotalAmount = function(value) {
        return dispatch({
            type: "setCartTotalAmount",
            payload: value
        });
    };
    var setAddToCartResponse = function(value) {
        return dispatch({
            type: "setAddToCartResponse",
            payload: value
        });
    };
    var setAddToCartError = function(value) {
        return dispatch({
            type: "setAddToCartError",
            payload: value
        });
    };
    var setMaxUsageAmountError = function(value) {
        return dispatch({
            type: "setMaxUsageAmountError",
            payload: value
        });
    };
    var setAddToCartResult = function(value) {
        return dispatch({
            type: "setAddToCartResult",
            payload: value
        });
    };
    var setIsChecked = function(value) {
        return dispatch({
            type: "setIsChecked",
            payload: value
        });
    };
    var setIsAddedToCart = function(value) {
        return dispatch({
            type: "setIsAddedToCart",
            payload: value
        });
    };
    var setIsOpen = function(value) {
        return dispatch({
            type: "setIsOpen",
            payload: value
        });
    };
    var resetState = function() {
        return dispatch({
            type: "resetState"
        });
    };
    var setIsLoading = function(value) {
        return dispatch({
            type: "setIsLoading",
            payload: value
        });
    };
    var updateMultiplier = function(multipliers, licences) {
        var licenceData = JSON.parse(licences);
        var licenceVariant = licenceData.licenceVariant;
        var multiplierInState = multipliers.some(function(multiplier) {
            return multiplier.licenceVariant === licenceVariant;
        });
        var newMultipliers;
        if (multiplierInState) {
            newMultipliers = _toConsumableArray(multipliers.filter(function(multiplier) {
                return multiplier.licenceVariant !== licenceVariant;
            })).concat([
                licenceData
            ]);
        } else {
            newMultipliers = _toConsumableArray(multipliers).concat([
                licenceData
            ]);
        }
        setMultipliers(newMultipliers);
    };
    var removeLicenceMultiplier = function(multipliers, licence) {
        var newMultipliers = multipliers.filter(function(multiplier) {
            return multiplier.licenceName !== licence.name;
        });
        setMultipliers(newMultipliers);
    };
    var providerValues = {
        state: state1,
        setStep: setStep,
        setSelectedLicences: setSelectedLicences,
        setMultipliers: setMultipliers,
        setMultiplierValue: setMultiplierValue,
        setCartFontsList: setCartFontsList,
        setCartSubTotalAmount: setCartSubTotalAmount,
        setCartTotalAmount: setCartTotalAmount,
        setAddToCartResponse: setAddToCartResponse,
        setAddToCartError: setAddToCartError,
        setMaxUsageAmountError: setMaxUsageAmountError,
        setAddToCartResult: setAddToCartResult,
        updateMultiplier: updateMultiplier,
        setIsChecked: setIsChecked,
        setIsAddedToCart: setIsAddedToCart,
        removeLicenceMultiplier: removeLicenceMultiplier,
        setIsOpen: setIsOpen,
        setIsLoading: setIsLoading,
        resetState: resetState
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};


/***/ }),

/***/ 33525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ messages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(12902);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,components_useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = useIntl();
    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-intl@5.25.1_bavw3gp4gwiouc7hx2b35bsypi/node_modules/react-intl/lib/index.js










function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
// @ts-ignore issue w/ TS Intl types
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');


;// CONCATENATED MODULE: ./components/translations.ts

var messages = defineMessages({
    more: {
        id: "app.home.greeting",
        description: "Link to proceed to the product collection view.",
        defaultMessage: "More \u2192"
    },
    loginWelcomeMessage: {
        id: "app.login.greeting",
        description: "Welcome message on home screen",
        defaultMessage: "Welcome back"
    },
    loginHeader: {
        id: "app.login.header",
        description: "Login form header",
        defaultMessage: "Login to your account"
    },
    loginEmailFieldLabel: {
        id: "app.login.emailField",
        description: "Email field label",
        defaultMessage: "Email"
    },
    loginPasswordFieldLabel: {
        id: "app.login.passwordField",
        description: "Password field label",
        defaultMessage: "Password"
    },
    loginRemindPasswordButtonLabel: {
        id: "app.login.remindPassword",
        description: "Button for reminding the password to the users",
        defaultMessage: "Forgot Your Password?"
    },
    createAccount: {
        id: "app.login.createAccount",
        description: "Link to create account view",
        defaultMessage: "Create Account"
    },
    registerHeader: {
        id: "app.register.header",
        description: "Register form header",
        defaultMessage: "Create a new account"
    },
    registerEmailFieldLabel: {
        id: "app.register.emailField",
        description: "Email field label",
        defaultMessage: "Email"
    },
    registerPasswordFieldLabel: {
        id: "app.register.passwordField",
        description: "Password field label",
        defaultMessage: "Password"
    },
    registerButton: {
        id: "app.register.registerButton",
        description: "Register account button label",
        defaultMessage: "Create Account"
    },
    backToLogin: {
        id: "app.register.backToLogin",
        description: "Link to go to the login page",
        defaultMessage: "Back"
    },
    logIn: {
        id: "app.navigation.login",
        description: "Link to login view",
        defaultMessage: "Login"
    },
    menuAccountPreferences: {
        id: "app.navigation.accountPreferences",
        description: "Link to account preferences view",
        defaultMessage: "Account preferences"
    },
    menuAccountAddressBook: {
        id: "app.navigation.addressBook",
        description: "Link to address book view",
        defaultMessage: "Address book"
    },
    menuAccountOrders: {
        id: "app.navigation.orders",
        description: "Link to orders view",
        defaultMessage: "Orders"
    },
    logOut: {
        id: "app.navigation.logout",
        description: "Log out link",
        defaultMessage: "Log out"
    },
    regionModalHeader: {
        id: "app.region.modalHeader",
        description: "Header of the region selection modal.",
        defaultMessage: "Choose your region"
    },
    channelFieldLabel: {
        id: "app.region.channelField",
        description: "Label of channel selection field.",
        defaultMessage: "Channel"
    },
    languageFieldLabel: {
        id: "app.region.languageField",
        description: "Label of language selection field.",
        defaultMessage: "Language"
    },
    addToCart: {
        id: "app.product.addToCart",
        description: "Add to cart button label.",
        defaultMessage: "Add to Cart"
    },
    variantNotChosen: {
        id: "app.product.variantNotChosen",
        description: "Warning message when variant is not chosen.",
        defaultMessage: "Please chose the variant"
    },
    soldOut: {
        id: "app.product.soldOut",
        description: "Warning message when variant is sold out.",
        defaultMessage: "Sold out!"
    },
    attributes: {
        id: "app.product.attributes",
        description: "Attributes table header.",
        defaultMessage: "Attributes"
    },
    adding: {
        id: "app.product.adding",
        description: "Message displayed during adding product to the cart.",
        defaultMessage: "Adding..."
    },
    checkoutButton: {
        id: "app.checkout.checkoutButton",
        description: "Go to checkout button label.",
        defaultMessage: "Checkout \u2192"
    },
    cartPageHeader: {
        id: "app.checkout.pageHeader",
        description: "Header of the cart page.",
        defaultMessage: "Your Cart"
    },
    discountCodeFieldLabel: {
        id: "app.checkout.discountCode",
        description: "Name of the discount code field.",
        defaultMessage: "Discount code"
    },
    discount: {
        id: "app.checkout.discount",
        description: "Discount code table header at the checkout summary.",
        defaultMessage: "Discount"
    },
    subtotal: {
        id: "app.checkout.subtotal",
        description: "Subtotal table header at the checkout summary.",
        defaultMessage: "Subtotal"
    },
    total: {
        id: "app.checkout.total",
        description: "Total table header at the checkout summary.",
        defaultMessage: "Total"
    },
    shipping: {
        id: "app.checkout.shipping",
        description: "Shipping table header at the checkout summary.",
        defaultMessage: "Shipping"
    },
    tax: {
        id: "app.checkout.tax",
        description: "Tax table header at the checkout summary.",
        defaultMessage: "Tax"
    },
    emailAddressCardHeader: {
        id: "app.checkout.emailAddressCardHeader",
        description: "Header of the email section.",
        defaultMessage: "Purchasing our typefaces requires a Colophon Foundry account."
    },
    vatNumberCardHeader: {
        id: "app.checkout.vatNumberCardHeader",
        description: "Header of the vat section.",
        defaultMessage: "Enter VAT details"
    },
    billingMethodCardHeader: {
        id: "app.checkout.billingMethodCardHeader",
        description: "Header of the billing method section.",
        defaultMessage: "Billing Method"
    },
    billingAddressCardHeader: {
        id: "app.checkout.billingAddressCardHeader",
        description: "Header of the billing address section.",
        defaultMessage: "Billing Address"
    },
    shippingAddressCardHeader: {
        id: "app.checkout.shippingAddressCardHeader",
        description: "Header of the shipping address section.",
        defaultMessage: "Shipping Address"
    },
    shippingMethodCardHeader: {
        id: "app.checkout.shippingMethodCardHeader",
        description: "Header of the shipping method section.",
        defaultMessage: "Shipping Method"
    },
    paymentCardHeader: {
        id: "app.checkout.paymentCardHeader",
        description: "Header of the payment section.",
        defaultMessage: "Payment"
    },
    paymentInstruction: {
        id: "app.checkout.paymentInstruction",
        description: "User instructions at payment section.",
        defaultMessage: "Choose payment method"
    },
    phoneField: {
        id: "app.checkout.phoneField",
        description: "Phone number field label.",
        defaultMessage: "Phone"
    },
    firstNameField: {
        id: "app.checkout.firstNameField",
        description: "First name field label.",
        defaultMessage: "First name"
    },
    lastNameField: {
        id: "app.checkout.lastNameField",
        description: "Last name field label.",
        defaultMessage: "Last name"
    },
    addressField: {
        id: "app.checkout.addressField",
        description: "Address field label.",
        defaultMessage: "Address"
    },
    cityField: {
        id: "app.checkout.cityField",
        description: "City field label.",
        defaultMessage: "City"
    },
    postalCodeField: {
        id: "app.checkout.postalCodeField",
        description: "Postal code field label.",
        defaultMessage: "Postal code"
    },
    cardNumberField: {
        id: "app.checkout.cardNumberField",
        description: "Card number field label.",
        defaultMessage: "Card number"
    },
    expDateField: {
        id: "app.checkout.expDateField",
        description: "Expiration date field label.",
        defaultMessage: "Expiration date"
    },
    cvcField: {
        id: "app.checkout.cvcField",
        description: "CVC code field label.",
        defaultMessage: "CVC"
    },
    paymentButton: {
        id: "app.checkout.paymentButton",
        description: "Payment button label.",
        defaultMessage: "Pay {total}"
    },
    sameAsBillingButton: {
        id: "app.checkout.sameAsBillingButton",
        description: "Use same address as billing button label.",
        defaultMessage: "Use the same address as billing"
    },
    orderSummary: {
        id: "app.checkout.orderSummary",
        description: "Header of the order summary section.",
        defaultMessage: "Order summary"
    },
    browseProducts: {
        id: "app.ui.browseProducts",
        description: "Label for the link to the product browsing.",
        defaultMessage: "Browse products"
    },
    loadMoreButton: {
        id: "app.ui.loadMoreButton",
        description: "Display more products button label.",
        defaultMessage: "Load more"
    },
    noProducts: {
        id: "app.ui.noProductsInfo",
        description: "Displayed when list has no products.",
        defaultMessage: "Make sure to write complete words (e.g. Grotesque) or check for any typos"
    },
    noProductsFiltered: {
        id: "app.ui.noProductsFilteredInfo",
        description: "Displayed when list has no products.",
        defaultMessage: "Please try changing your filters."
    },
    removeButton: {
        id: "app.ui.removeButton",
        description: "Remove item button label.",
        defaultMessage: "Remove"
    },
    activateButton: {
        id: "app.ui.activateButton",
        description: "Activate button label.",
        defaultMessage: "Activate"
    },
    changeButton: {
        id: "app.ui.changeButton",
        description: "Change button label.",
        defaultMessage: "Change account"
    },
    saveButton: {
        id: "app.ui.saveButton",
        description: "Save button label.",
        defaultMessage: "Save"
    },
    saveEmailChanges: {
        id: "app.ui.saveEmailChanges",
        description: "Save email label.",
        defaultMessage: "Save email"
    },
    deleteAccount: {
        id: "app.ui.deleteAccount",
        description: "Delete account label.",
        defaultMessage: "Delete Account"
    },
    savePasswordChanges: {
        id: "app.ui.savePasswordChanges",
        description: "Save password label.",
        defaultMessage: "Save password"
    },
    paginationProductCounter: {
        id: "app.ui.productCounter",
        description: "Message with number of displayed products.",
        defaultMessage: "{currentItemsCount} out of {totalItemsCount}"
    },
    searchHeader: {
        id: "app.search.searchHeader",
        description: "Header of the search page.",
        defaultMessage: "Search"
    },
    searchFieldPlaceholder: {
        id: "app.search.searchFieldPlaceholder",
        description: "Placeholder displayed in the search field.",
        defaultMessage: "What are you looking for?"
    },
    changeEmailHeader: {
        id: "app.preferences.changeEmail.header",
        description: "Header for email change section",
        defaultMessage: "Change email"
    },
    changePasswordHeader: {
        id: "app.preferences.changePassword.header",
        description: "Header for password change section",
        defaultMessage: "Change password"
    },
    oldPasswordFieldLabel: {
        id: "app.preferences.changePassword.oldPasswordFieldLabel",
        description: "Old password field label",
        defaultMessage: "Old password"
    },
    newPasswordFieldLabel: {
        id: "app.preferences.changePassword.newPasswordFieldLabel",
        description: "New password field label",
        defaultMessage: "New password"
    },
    newPasswordRepeatedFieldLabel: {
        id: "app.preferences.changePassword.header",
        description: "Repeated new password field label",
        defaultMessage: "Repeat new password"
    },
    noAddressDataMessage: {
        id: "app.preferences.addressbook.noData",
        description: "Message displayed when user has no address saved",
        defaultMessage: "No addresses information for this user"
    },
    defaultBillingAndShipping: {
        id: "app.preferences.addressbook.defaultBillingShipping",
        description: "Message displayed when address is both billing and shipping default",
        defaultMessage: "Default billing and shipping address"
    },
    defaultBilling: {
        id: "app.preferences.addressbook.defaultBilling",
        description: "Message displayed when address is billing default",
        defaultMessage: "Default billing address"
    },
    defaultShipping: {
        id: "app.preferences.addressbook.defaultShipping",
        description: "Message displayed when address is shipping default",
        defaultMessage: "Default shipping address"
    },
    setDefaultShipping: {
        id: "app.preferences.addressbook.setDefaultShipping",
        description: "Set shipping default button label",
        defaultMessage: "Set as shipping default"
    },
    setDefaultBilling: {
        id: "app.preferences.addressbook.setDefaultBilling",
        description: "Set billing default button label",
        defaultMessage: "Set as billing default"
    }
});


/***/ }),

/***/ 84817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ SaleorAuthClient; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/ts-invariant@0.10.3/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(35985);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.3.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(45512);
;// CONCATENATED MODULE: ./lib/auth/mutations.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AccountErrorFragment on AccountError {\n    code\n    field\n    message\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  mutation refreshToken($refreshToken: String!) {\n    tokenRefresh(refreshToken: $refreshToken) {\n      token\n      errors {\n        ...AccountErrorFragment\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  mutation checkoutCustomerDetach($checkoutId: ID!) {\n    checkoutCustomerDetach(id: $checkoutId) {\n      errors {\n        message\n        field\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  mutation checkoutCustomerAttach($checkoutId: ID!) {\n    checkoutCustomerAttach(id: $checkoutId) {\n      errors {\n        message\n        field\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  mutation tokenCreate($email: String!, $password: String!) {\n    tokenCreate(email: $email, password: $password) {\n      token\n      refreshToken\n      errors {\n        message\n        field\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  mutation passwordReset($email: String!, $password: String!, $token: String!) {\n    setPassword(email: $email, password: $password, token: $token) {\n      token\n      refreshToken\n      errors {\n        message\n        field\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var accountErrorFragment = (0,lib/* default */.ZP)(_templateObject());
var TOKEN_REFRESH = (0,lib/* default */.ZP)(_templateObject1(), accountErrorFragment);
var CHECKOUT_CUSTOMER_DETACH = (0,lib/* default */.ZP)(_templateObject2());
var CHECKOUT_CUSTOMER_ATTACH = (0,lib/* default */.ZP)(_templateObject3());
var TOKEN_CREATE = (0,lib/* default */.ZP)(_templateObject4());
var PASSWORD_RESET = (0,lib/* default */.ZP)(_templateObject5());

// EXTERNAL MODULE: ./lib/auth/SaleorAuthStorageHandler.ts
var SaleorAuthStorageHandler = __webpack_require__(37998);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/printer.mjs + 1 modules
var printer = __webpack_require__(15810);
;// CONCATENATED MODULE: ./lib/auth/utils.ts
/* provided dependency */ var Buffer = __webpack_require__(91620)["Buffer"];

var MILLI_MULTIPLYER = 1000;
var TOKEN_GRACE_PERIOD = 2000;
// returns timestamp
var getTokenExpiry = function(token) {
    var tokenParts = token.split(".");
    var decodedTokenData = Buffer.from(tokenParts[1] || "", "base64").toString();
    var parsedTokenData = JSON.parse(decodedTokenData);
    var expiryStamp = parsedTokenData.exp * MILLI_MULTIPLYER || 0;
    return expiryStamp;
};
var isExpiredToken = function(token) {
    // we'll assume a generous time of 2 seconds for api to
    // process our request
    return getTokenExpiry(token) - TOKEN_GRACE_PERIOD <= Date.now();
};
// query here is document node but because of graphql-tag using
// a different version of graphql and pnpm overrides not working
// https://github.com/pnpm/pnpm/issues/4097
// we're gonna do this instead
var getRequestData = function(query, variables) {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            query: (0,printer/* print */.S)(query),
            variables: variables
        })
    };
};

;// CONCATENATED MODULE: ./lib/auth/SaleorAuthClient.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var SaleorAuthClient = function SaleorAuthClient(param) {
    "use strict";
    var saleorApiUrl = param.saleorApiUrl, storage = param.storage, onAuthRefresh = param.onAuthRefresh;
    var _this = this;
    _classCallCheck(this, SaleorAuthClient);
    this.accessToken = null;
    this.tokenRefreshPromise = null;
    this.hasValidAccessToken = function() {
        return !!_this.accessToken && !isExpiredToken(_this.accessToken);
    };
    this.runAuthorizedRequest = function(input, init) {
        // technically we run this only when token is there
        // but just to make typescript happy
        if (!_this.hasValidAccessToken()) {
            return fetch(input, init);
        }
        var headers = (init === null || init === void 0 ? void 0 : init.headers) || {};
        return fetch(input, _objectSpread({}, init, {
            headers: _objectSpread({}, headers, {
                Authorization: "Bearer ".concat(_this.accessToken)
            })
        }));
    };
    var _this1 = this;
    this.handleRequestWithTokenRefresh = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(input, init) {
            var _obj, ref, refreshToken, _obj1, ref1, response, res, tmp, graphqlErrors, _data, _tokenRefresh, errors, token, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        refreshToken = _this1.storageHandler.getRefreshToken();
                        (0,invariant/* default */.ZP)(refreshToken, "Missing refresh token in token refresh handler");
                        if (!_this1.hasValidAccessToken()) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _this1.fetchWithAuth(input, init));
                    case 5:
                        (ref = (_obj = _this1).onAuthRefresh) === null || ref === void 0 ? void 0 : ref.call(_obj, true);
                        if (!_this1.tokenRefreshPromise) {
                            _ctx.next = 25;
                            break;
                        }
                        ;
                        _ctx.next = 10;
                        return _this1.tokenRefreshPromise;
                    case 10:
                        response = _ctx.sent;
                        _ctx.next = 13;
                        return response.json();
                    case 13:
                        res = _ctx.sent;
                        tmp = res.errors, graphqlErrors = tmp === void 0 ? [] : tmp, _data = res.data, _tokenRefresh = _data.tokenRefresh, errors = _tokenRefresh.errors, token = _tokenRefresh.token;
                        (ref1 = (_obj1 = _this1).onAuthRefresh) === null || ref1 === void 0 ? void 0 : ref1.call(_obj1, false);
                        if (!(errors.length || graphqlErrors.length || !token)) {
                            _ctx.next = 21;
                            break;
                        }
                        ;
                        _this1.tokenRefreshPromise = null;
                        (ref2 = _this1.storageHandler) === null || ref2 === void 0 ? void 0 : ref2.clearAuthStorageExpiry();
                        return _ctx.abrupt("return", fetch(input, init));
                    case 21:
                        _this1.storageHandler.setAuthState("signedIn");
                        _this1.accessToken = token;
                        _this1.tokenRefreshPromise = null;
                        return _ctx.abrupt("return", _this1.runAuthorizedRequest(input, init));
                    case 25:
                        // this is the first failed request, initialize refresh
                        _this1.tokenRefreshPromise = fetch(_this1.saleorApiUrl, getRequestData(TOKEN_REFRESH, {
                            refreshToken: refreshToken
                        }));
                        return _ctx.abrupt("return", _this1.fetchWithAuth(input, init));
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(input, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this2 = this;
    this.checkoutCustomerAttach = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(checkout) {
            var response, readResponse, _data, tmp, ref, _errors, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!((checkout === null || checkout === void 0 ? void 0 : checkout.id) && !(checkout === null || checkout === void 0 ? void 0 : checkout.user))) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 3;
                        return _this2.runAuthorizedRequest(_this2.saleorApiUrl, getRequestData(CHECKOUT_CUSTOMER_ATTACH, {
                            checkoutId: checkout === null || checkout === void 0 ? void 0 : checkout.id
                        }));
                    case 3:
                        response = _ctx.sent;
                        _ctx.next = 6;
                        return response.json();
                    case 6:
                        readResponse = _ctx.sent;
                        _data = readResponse.data, tmp = _data.checkoutCustomerAttach, ref = tmp === void 0 ? {} : tmp, _errors = ref.errors, errors = _errors === void 0 ? [] : _errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                        // @todo - how do we want to handle an error on attach?
                        // to confirm with Saleor. Probably just fail silently.
                        }
                    case 9:
                        return _ctx.abrupt("return");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(checkout) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this3 = this;
    this.fetchWithAuth = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(input, init) {
            var ref, refreshToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        refreshToken = (ref = _this3.storageHandler) === null || ref === void 0 ? void 0 : ref.getRefreshToken();
                        if (!_this3.hasValidAccessToken()) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", _this3.runAuthorizedRequest(input, init));
                    case 4:
                        if (!refreshToken) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", _this3.handleRequestWithTokenRefresh(input, init));
                    case 6:
                        return _ctx.abrupt("return", fetch(input, init));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(input, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this4 = this;
    this.resetPassword = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(variables) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(_this4.saleorApiUrl, getRequestData(PASSWORD_RESET, variables));
                    case 2:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", _this4.handleSignIn(response));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this5 = this;
    this.signIn = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(variables) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(_this5.saleorApiUrl, getRequestData(TOKEN_CREATE, variables));
                    case 2:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", _this5.handleSignIn(response, variables === null || variables === void 0 ? void 0 : variables.checkout));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this6 = this;
    this.handleSignIn = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(response, checkout) {
            var readResponse, responseData, errors, token, refreshToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return response.json();
                    case 2:
                        readResponse = _ctx.sent;
                        responseData = "tokenCreate" in readResponse.data ? readResponse.data.tokenCreate : readResponse.data.setPassword;
                        if (responseData) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", readResponse);
                    case 6:
                        errors = responseData.errors, token = responseData.token, refreshToken = responseData.refreshToken;
                        if (!(!token || errors.length)) {
                            _ctx.next = 10;
                            break;
                        }
                        _this6.storageHandler.setAuthState("signedOut");
                        return _ctx.abrupt("return", readResponse);
                    case 10:
                        if (token) {
                            _this6.accessToken = token;
                        }
                        if (refreshToken) {
                            _this6.storageHandler.setRefreshToken(refreshToken);
                        }
                        _this6.storageHandler.setAuthState("signedIn");
                        if (!(checkout === null || checkout === void 0 ? void 0 : checkout.id)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 16;
                        return _this6.checkoutCustomerAttach(checkout);
                    case 16:
                        return _ctx.abrupt("return", readResponse);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response, checkout) {
            return _ref.apply(this, arguments);
        };
    }();
    this.signOut = function() {
        _this.accessToken = null;
        _this.storageHandler.clearAuthStorage();
    };
    var _this7 = this;
    this.checkoutSignOut = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(variables) {
            var response, readResponse, _data, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this7.runAuthorizedRequest(_this7.saleorApiUrl, getRequestData(CHECKOUT_CUSTOMER_DETACH, variables));
                    case 2:
                        response = _ctx.sent;
                        _ctx.next = 5;
                        return response.json();
                    case 5:
                        readResponse = _ctx.sent;
                        _data = readResponse.data, errors = _data.checkoutCustomerDetach.errors;
                        if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                            _this7.signOut();
                        }
                        return _ctx.abrupt("return", readResponse);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    this.storageHandler = new SaleorAuthStorageHandler/* SaleorAuthStorageHandler */.Us(storage);
    this.onAuthRefresh = onAuthRefresh;
    this.saleorApiUrl = saleorApiUrl;
    this.cleanup = this.storageHandler.cleanup;
};


/***/ }),

/***/ 36739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useSaleorAuthContext; },
/* harmony export */   "s": function() { return /* binding */ SaleorAuthProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35985);
/* harmony import */ var _useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95841);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var ref = _slicedToArray((0,_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2), useSaleorAuthContext = ref[0], Provider = ref[1];

var SaleorAuthProvider = function(param) {
    var children = param.children, saleorAuthClient = param.saleorAuthClient, isAuthenticating = param.isAuthenticating;
    (0,ts_invariant__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(saleorAuthClient, "Missing Saleor Auth Client - are you sure you created it using useSaleorAuthClient?");
    var signIn = saleorAuthClient.signIn, signOut = saleorAuthClient.signOut, checkoutSignOut = saleorAuthClient.checkoutSignOut, resetPassword = saleorAuthClient.resetPassword;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: {
            isAuthenticating: isAuthenticating,
            signIn: signIn,
            signOut: signOut,
            checkoutSignOut: checkoutSignOut,
            resetPassword: resetPassword
        },
        children: children
    });
};


/***/ }),

/***/ 37998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_Y": function() { return /* binding */ STORAGE_AUTH_EVENT_KEY; },
/* harmony export */   "Us": function() { return /* binding */ SaleorAuthStorageHandler; }
/* harmony export */ });
/* unused harmony export STORAGE_AUTH_STATE_KEY */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52375);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/* auth state when user signs in / out */ var STORAGE_AUTH_EVENT_KEY = "saleor_storage_auth_change";
var STORAGE_AUTH_STATE_KEY = "saleor_auth_module_auth_state";
var REFRESH_TOKEN_KEY = "saleor_auth_module_refresh_token";
var SaleorAuthStorageHandler = function SaleorAuthStorageHandler(storage) {
    "use strict";
    var _this = this;
    _classCallCheck(this, SaleorAuthStorageHandler);
    this.handleStorageChange = function(event) {
        var oldValue = event.oldValue, newValue = event.newValue, type = event.type, key = event.key;
        if (oldValue === newValue || type !== "storage" || key !== STORAGE_AUTH_STATE_KEY) {
            return;
        }
        _this.sendAuthStateEvent(newValue);
    };
    this.cleanup = function() {
         true && window.removeEventListener("storage", _this.handleStorageChange);
    };
    /* auth state */ this.sendAuthStateEvent = function(authState) {
        var event = new CustomEvent(STORAGE_AUTH_EVENT_KEY, {
            detail: {
                authState: authState
            }
        });
         true && window.dispatchEvent(event);
    };
    this.getAuthState = function() {
        return _this.storage.getItem(STORAGE_AUTH_STATE_KEY) || "signedOut";
    };
    this.setAuthState = function(authState) {
        _this.storage.setItem(STORAGE_AUTH_STATE_KEY, authState);
        _this.sendAuthStateEvent(authState);
    };
    /* refresh token */ this.getRefreshToken = function() {
        return _this.storage.getItem(REFRESH_TOKEN_KEY) || null;
    };
    this.setRefreshToken = function(token) {
        _this.storage.setItem(REFRESH_TOKEN_KEY, token);
    };
    /* performed on logout */ this.clearAuthStorage = function() {
        _this.setAuthState("signedOut");
        _this.storage.removeItem(REFRESH_TOKEN_KEY);
        _this.storage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CHECKOUT_TOKEN */ .ES);
    };
    /* performed on expiry */ this.clearAuthStorageExpiry = function() {
        _this.setAuthState("expired");
        _this.storage.removeItem(REFRESH_TOKEN_KEY);
        _this.storage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CHECKOUT_TOKEN */ .ES);
    };
    this.storage = storage;
     true && window.addEventListener("storage", this.handleStorageChange);
};


/***/ }),

/***/ 9714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SQ": function() { return /* reexport */ useAuthChange; },
  "ex": function() { return /* reexport */ SaleorAuthProvider/* useSaleorAuthContext */.e; }
});

// UNUSED EXPORTS: SaleorAuthClient, SaleorAuthProvider, serverApolloClient, useApolloClient

// EXTERNAL MODULE: ./lib/auth/SaleorAuthClient.ts + 2 modules
var SaleorAuthClient = __webpack_require__(84817);
// EXTERNAL MODULE: ./lib/auth/SaleorAuthProvider.tsx
var SaleorAuthProvider = __webpack_require__(36739);
// EXTERNAL MODULE: ./lib/auth/useApolloClient.ts + 54 modules
var useApolloClient = __webpack_require__(65630);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./lib/auth/SaleorAuthStorageHandler.ts
var SaleorAuthStorageHandler = __webpack_require__(37998);
;// CONCATENATED MODULE: ./lib/auth/useAuthChange.ts


// used to handle client cache invalidation on login / logout and when
// token refreshin fails
var useAuthChange = function(param) {
    var onSignedOut = param.onSignedOut, onSignedIn = param.onSignedIn, onExpiry = param.onExpiry;
    var handleAuthChange = function(event) {
        var isCustomAuthEvent = (event === null || event === void 0 ? void 0 : event.type) === SaleorAuthStorageHandler/* STORAGE_AUTH_EVENT_KEY */._Y;
        if (!isCustomAuthEvent) {
            return;
        }
        var authState = event.detail.authState;
        if (authState === "signedIn") {
            onSignedIn();
        } else if (authState === "signedOut") {
            onSignedOut();
        } else if (authState === "expired") {
            onExpiry();
        }
    };
    (0,react.useEffect)(function() {
        // for current window
        window.addEventListener(SaleorAuthStorageHandler/* STORAGE_AUTH_EVENT_KEY */._Y, handleAuthChange);
        return function() {
            window.removeEventListener(SaleorAuthStorageHandler/* STORAGE_AUTH_EVENT_KEY */._Y, handleAuthChange);
        };
    }, []);
};

;// CONCATENATED MODULE: ./lib/auth/index.ts






/***/ }),

/***/ 65630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useApolloClient; }
});

// UNUSED EXPORTS: serverApolloClient

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(93663);
;// CONCATENATED MODULE: ./node_modules/.pnpm/zen-observable-ts@1.2.5/node_modules/zen-observable-ts/module.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}



;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/graphql/fragments.js


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new globals/* InvariantError */.ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new globals/* InvariantError */.ej(41);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,globals/* invariant */.kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,globals/* invariant */.kG)(fragments.length === 1, 42);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: (0,tslib_es6/* __spreadArray */.ev)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragment = fragmentMap && fragmentMap[selection.name.value];
            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value, ".")) : (0,globals/* invariant */.kG)(fragment, 43);
            return fragment;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/graphql/storeUtils.js



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return ((0,objects/* isNonNullObject */.s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new globals/* InvariantError */.ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new globals/* InvariantError */.ej(52);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,objects/* isNonNullObject */.s)(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (storeUtils_isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function storeUtils_isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/graphql/getFromAST.js


function checkDocument(doc) {
    __DEV__ ? (0,globals/* invariant */.kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,globals/* invariant */.kG)(doc && doc.kind === 'Document', 44);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new globals/* InvariantError */.ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new globals/* InvariantError */.ej(45);
        }
        return definition;
    });
    __DEV__ ? (0,globals/* invariant */.kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,globals/* invariant */.kG)(operations.length <= 1, 46);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,globals/* invariant */.kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,globals/* invariant */.kG)(queryDef && queryDef.operation === 'query', 47);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,globals/* invariant */.kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,globals/* invariant */.kG)(doc.kind === 'Document', 48);
    __DEV__ ? (0,globals/* invariant */.kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,globals/* invariant */.kG)(doc.definitions.length <= 1, 49);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,globals/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,globals/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 50);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new globals/* InvariantError */.ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new globals/* InvariantError */.ej(51);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new globals/* InvariantError */.ej("illegal argument: ".concat(key)) : new globals/* InvariantError */.ej(24);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : Observable.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return Observable.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || Observable.of()
                    : rightLink.request(operation) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || Observable.of()
                    : rightLink.request(operation, forward) || Observable.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && globals/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || Observable.of();
                }) || Observable.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new globals/* InvariantError */.ej('request is not implemented') : new globals/* InvariantError */.ej(19);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/core/execute.js

var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/version.js
var version = '3.6.2';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(31082);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/serializeFetchParameter.js

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new globals/* InvariantError */.ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new globals/* InvariantError */.ej(21);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/selectURI.js
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js

var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function parseAndCheckHttpResponse(operations) {
    return function (response) { return response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            throw parseError;
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
        }
        if (!Array.isArray(result) &&
            !parseAndCheckHttpResponse_hasOwnProperty.call(result, 'data') &&
            !parseAndCheckHttpResponse_hasOwnProperty.call(result, 'errors')) {
            throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName, "'."));
        }
        return result;
    }); };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/checkFetcher.js

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new globals/* InvariantError */.ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new globals/* InvariantError */.ej(20);
    }
};
//# sourceMappingURL=checkFetcher.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/printer.mjs + 1 modules
var language_printer = __webpack_require__(15810);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, __spreadArray([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), headersToLowerCase(config.headers)) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, language_printer/* print */.S);
    return {
        options: options,
        body: body,
    };
}
;
function headersToLowerCase(headers) {
    if (headers) {
        var normalized_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalized_1[name.toLowerCase()] = headers[name];
        });
        return normalized_1;
    }
    return headers;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/createSignalIfSupported.js
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/rewriteURIForGET.js

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/utils/fromError.js

function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/createHttpLink.js














var backupFetch = (0,globals/* maybe */.wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,visitor/* visit */.Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib_es6/* __assign */.pi)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            var currentFetch = preferredFetch || (0,globals/* maybe */.wY)(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/link/http/HttpLink.js



var HttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));

//# sourceMappingURL=HttpLink.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@wry+equality@0.5.3/node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(91735);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@wry+trie@0.3.2/node_modules/@wry/trie/lib/trie.esm.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(42457);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(66314);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/graphql/directives.js


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,globals/* invariant */.kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,globals/* invariant */.kG)(evaledValue !== void 0, 37);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    (0,visitor/* visit */.Vn)(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, root) {
    return getDirectiveNames(root).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,globals/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,globals/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, 38);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,globals/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,globals/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', 39);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,globals/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,globals/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 40);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/mergeDeep.js


var mergeDeep_hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = objects/* isNonNullObject */.s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,objects/* isNonNullObject */.s)(source) && (0,objects/* isNonNullObject */.s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (mergeDeep_hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib_es6/* __spreadArray */.ev)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,objects/* isNonNullObject */.s)(value)) {
            if (this.pastCopies.has(value)) {
                if (!Object.isFrozen(value))
                    return value;
                this.pastCopies.delete(value);
            }
            if (Array.isArray(value)) {
                value = value.slice(0);
            }
            else {
                value = (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
            }
            this.pastCopies.add(value);
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/helpers.js

var hasOwn = Object.prototype.hasOwnProperty;
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                id !== void 0 ? { id: id } :
                    _id !== void 0 ? { _id: _id } :
                        void 0;
        }
        if (id === void 0)
            id = _id;
        if (id !== void 0) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,compact/* compact */.o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,objects/* isNonNullObject */.s)(result)) {
        return isArray(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if (storeUtils_isField(field) && shouldInclude(field, variables)) {
                    var key = resultKeyNameFromField(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,objects/* isNonNullObject */.s)(value) &&
        !isReference(value) &&
        !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger;
}
var isArray = function (a) { return Array.isArray(a); };
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/object-canon.js





function shallowCopy(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        return isArray(value)
            ? value.slice(0)
            : (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        this.pool = new Trie(canUse/* canUseWeakMap */.mr);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,objects/* isNonNullObject */.s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/errorHandling.js
function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}
//# sourceMappingURL=errorHandling.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/filterInPlace.js
function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}
//# sourceMappingURL=filterInPlace.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/graphql/transform.js







var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !!v.name && !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !!fs.name && !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,visitor/* visit */.Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (storeUtils_isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (storeUtils_isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && globals/* invariant.warn */.kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((storeUtils_isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,visitor/* visit */.Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = (0,visitor/* visit */.Vn)(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return storeUtils_isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/makeUniqueId.js
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/observables/iteration.js
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/observables/subclassing.js


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUse/* canUseSymbol */.aS && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.addCount = 0;
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                if (_this.sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new Observable(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
            ++this.addCount;
        }
    };
    Concast.prototype.removeObserver = function (observer, quietly) {
        if (this.observers.delete(observer) &&
            --this.addCount < 1 &&
            !quietly) {
            this.handlers.error(new Error("Observable cancelled prematurely"));
        }
    };
    Concast.prototype.cleanup = function (callback) {
        var _this = this;
        var called = false;
        var once = function () {
            if (!called) {
                called = true;
                _this.observers.delete(observer);
                callback();
            }
        };
        var observer = {
            next: once,
            error: once,
            complete: once,
        };
        var count = this.addCount;
        this.addObserver(observer);
        this.addCount = count;
    };
    return Concast;
}(Observable));

fixObservableSubclass(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(15771);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(85234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(50804);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep_toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (cloneDeep_toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(18158);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/ObservableQuery.js





var ObservableQuery_assign = Object.assign, ObservableQuery_hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        _this.options = (0,tslib_es6/* __assign */.pi)({ initialFetchPolicy: options.fetchPolicy || "cache-first" }, options);
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = getOperationDefinition(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            core_networkStatus/* NetworkStatus.ready */.I.ready;
        var result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, lastResult), { loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,equality_esm/* equal */.D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        return !this.last || !(0,equality_esm/* equal */.D)(this.last.result, newResult);
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,equality_esm/* equal */.D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            var queryDef = getQueryDefinition(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && globals/* invariant.warn */.kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !(0,equality_esm/* equal */.D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.refetch */.I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && globals/* invariant.error */.kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,equality_esm/* equal */.D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, core_networkStatus/* NetworkStatus.setVariables */.I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,globals/* invariant */.kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,globals/* invariant */.kG)(pollInterval, 10);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,core_networkStatus/* isNetworkRequestInFlight */.O)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: "network-only",
                    }, core_networkStatus/* NetworkStatus.poll */.I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : cloneDeep(newResult), variables: variables });
        if (!(0,arrays/* isNonEmptyArray */.O)(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch ||
            newNetworkStatus === core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore ||
            newNetworkStatus === core_networkStatus/* NetworkStatus.poll */.I.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,mergeOptions/* mergeOptions */.J)(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !(0,equality_esm/* equal */.D)(newOptions.variables, oldVariables) &&
                (!newOptions.fetchPolicy || newOptions.fetchPolicy === oldFetchPolicy)) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
                }
            }
        }
        var variables = options.variables && (0,tslib_es6/* __assign */.pi)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer, true);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            iterateObserversSafely(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: core_networkStatus/* NetworkStatus.error */.I.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(Observable));

fixObservableSubclass(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && globals/* invariant.error */.kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && globals/* invariant.debug */.kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
//# sourceMappingURL=ObservableQuery.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@wry+context@0.6.1/node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (context_esm_isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function context_esm_isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/optimism@0.16.1/node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var bundle_esm_a;
var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (bundle_esm_a = Array.from, bundle_esm_a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : bundle_esm_a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true,
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                bundle_esm_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new Trie(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/reactiveVars.js


var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: dep(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return removeClientSetsFromDocument(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (storeUtils_isField(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,globals/* invariant */.kG)(fragment, 9);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                argumentsObjectFromField(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/QueryInfo.js





;
var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,equality_esm/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,equality_esm/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.lastDiff = void 0;
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0,equality_esm/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !(0,equality_esm/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    reobserveCacheFirst(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !(0,equality_esm/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,equality_esm/* equal */.D)(variables, lastWrite.variables) &&
            (0,equality_esm/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, options, cacheWriteBehavior) {
        var _this = this;
        this.graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors) ? result.errors : [];
        this.reset();
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: _this.document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/QueryManager.js











var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('QueryManager stopped while query was in flight') : new globals/* InvariantError */.ej(11));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        __DEV__ ? (0,globals/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,globals/* invariant */.kG)(mutation, 12);
                        __DEV__ ? (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 13);
                        mutationId = this.generateMutationId();
                        mutation = this.transform(mutation).document;
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_h.sent());
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new errors/* ApolloError */.c({
                                            graphQLErrors: result.errors,
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6/* __assign */.pi)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        resolve(storeResult);
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof errors/* ApolloError */.c ? err : new errors/* ApolloError */.c({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && getOperationName(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: diff.result });
                            }
                        }
                        update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables,
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var forLink = removeConnectionDirectiveFromDocument(this.cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = forLink && this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
                asQuery: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,globals/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,globals/* invariant */.kG)(options.query, 14);
        __DEV__ ? (0,globals/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,globals/* invariant */.kG)(options.query.kind === 'Document', 15);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.returnPartialData, 16);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.pollInterval, 17);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new globals/* InvariantError */.ej(18));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = makeUniqueId("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = canonicalStringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.cleanup(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                Observable.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        return asyncMap(this.getObservableFromLink(queryInfo.document, options.context, options.variables), function (result) {
            var hasErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    }));
                }
                queryInfo.markResult(result, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = result.errors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,errors/* isApolloError */.M)(networkError)
                ? networkError
                : new errors/* ApolloError */.c({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            return _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
        };
        this.fetchCancelFns.set(queryId, function (reason) {
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast = new Concast(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.cleanup(function () {
            _this.fetchCancelFns.delete(queryId);
            if (queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
        });
        return concast;
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !(0,equality_esm/* equal */.D)(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) { return Observable.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                if (shouldNotify) {
                    return [
                        resultsFromCache(readCache()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "no-cache":
                if (shouldNotify) {
                    return [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink.empty();
        }
        if (!cache) {
            throw __DEV__ ? new globals/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new globals/* InvariantError */.ej(7);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 8);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function (options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && globals/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/core/cache.js



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = wrap(getFragmentQueryDocument);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/core/types/common.js
var MissingFieldError = (function () {
    function MissingFieldError(message, path, query, variables) {
        this.message = message;
        this.path = path;
        this.query = query;
        this.variables = variables;
    }
    return MissingFieldError;
}());

//# sourceMappingURL=common.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(91437);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(isReference(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return isReference(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return makeReference(objOrIdOrRef);
            }
            if (isReference(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = makeReference(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,globals/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || makeReference(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if (isReference(obj)) {
                    found_1[obj.__ref] = true;
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? dep() : null;
        this.keyMaker = new Trie(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new Trie(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_esm/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,equality_esm/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/readFromStore.js








;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new ObjectCanon;
        this.executeSelectionSet = wrap(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = wrap(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(getQueryDefinition(query))), variables);
        var rootRef = makeReference(rootId);
        var merger = new DeepMerger;
        var execResult = this.executeSelectionSet({
            selectionSet: getMainDefinition(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: {
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: canonicalStringify(variables),
                canonizeResults: canonizeResults,
                fragmentMap: createFragmentMap(getFragmentDefinitions(query)),
                merge: function (a, b) {
                    return merger.merge(a, b);
                },
            },
        });
        var missing;
        if (execResult.missing) {
            missing = [new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var result = {};
        var missing;
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            result = { __typename: typename };
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = context.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!shouldInclude(selection, variables))
                return;
            if (storeUtils_isField(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = resultKeyNameFromField(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = context.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if (isArray(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    result = context.merge(result, (_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = getFragmentFromSelection(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = context.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if (isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                __DEV__ ? (0,globals/* invariant */.kG)(!isReference(value), "Missing selection set for object of type ".concat(getTypenameFromStoreObject(store, value), " returned for query field ").concat(field.name.value)) : (0,globals/* invariant */.kG)(!isReference(value), 5);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                hasOwn.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,globals/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,globals/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && argumentsObjectFromField(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && hasOwn.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new DeepMerger;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if (isArray(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!isArray(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return isArray(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if (isArray(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/policies.js







getStoreKeyName.setStringify(canonicalStringify);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? argumentsObjectFromField(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if (isArray(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,globals/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,globals/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && globals/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if (isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === fieldNameFromStoreName(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: isReference,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, context), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && globals/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if (isArray(existing) || isArray(incoming)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Cannot automatically merge arrays") : new globals/* InvariantError */.ej(4);
        }
        if ((0,objects/* isNonNullObject */.s)(existing) &&
            (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) &&
                storeValueIsStoreObject(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) &&
                isReference(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/writeToStore.js








;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader) {
        this.cache = cache;
        this.reader = reader;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = getOperationDefinition(query);
        var merger = makeProcessedFieldsMerger();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(operationDefinition)), variables);
        var context = {
            store: store,
            written: Object.create(null),
            merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: canonicalStringify(variables),
            fragmentMap: createFragmentMap(getFragmentDefinitions(query)),
            overwrite: !!overwrite,
            incomingById: new Map,
            clientOnly: false,
            deferred: false,
            flavors: new Map,
        };
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!isReference(ref)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new globals/* InvariantError */.ej(6);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if (isReference(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = resultKeyNameFromField(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    (isReference(incomingValue) ||
                        storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && globals/* invariant.error */.kG.error("Missing field '".concat(resultKeyNameFromField(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = makeReference(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? cloneDeep(value) : value;
        }
        if (isArray(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = getTypenameFromResult(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new Trie(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!shouldInclude(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = argumentsObjectFromField(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if (storeUtils_isField(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = getFragmentFromSelection(selection, context.fragmentMap);
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !isReference(incoming)) {
            var e_1 = (!isArray(incoming) &&
                (isReference(existing) || storeValueIsStoreObject(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return isArray(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = (isArray(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if (isReference(existing))
        return;
    if ((0,equality_esm/* equal */.D)(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!isArray(existing) &&
        !isArray(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && globals/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
        }));
        this.maybeBroadcastWatch = wrap(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, rootId = c.rootId, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, canonicalStringify({ optimistic: optimistic, rootId: rootId, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        canonicalStringify.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            forgetCache(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !(0,equality_esm/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/policies/pagination.js



function concatPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming) {
            return existing ? __spreadArray(__spreadArray([], existing, true), incoming, true) : incoming;
        },
    };
}
function offsetLimitPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (args) {
                var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                for (var i = 0; i < incoming.length; ++i) {
                    merged[offset + i] = incoming[i];
                }
            }
            else {
                merged.push.apply(merged, incoming);
            }
            return merged;
        },
    };
}
function relayStylePagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        read: function (existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing)
                return existing;
            var edges = [];
            var firstEdgeCursor = "";
            var lastEdgeCursor = "";
            existing.edges.forEach(function (edge) {
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        firstEdgeCursor = firstEdgeCursor || edge.cursor || "";
                        lastEdgeCursor = edge.cursor || lastEdgeCursor;
                    }
                }
            });
            var _b = existing.pageInfo || {}, startCursor = _b.startCursor, endCursor = _b.endCursor;
            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getExtras(existing)), { edges: edges, pageInfo: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing.pageInfo), { startCursor: startCursor || firstEdgeCursor, endCursor: endCursor || lastEdgeCursor }) });
        },
        merge: function (existing, incoming, _a) {
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            if (!existing) {
                existing = makeEmptyData();
            }
            if (!incoming) {
                return existing;
            }
            var incomingEdges = incoming.edges ? incoming.edges.map(function (edge) {
                if (isReference(edge = (0,tslib_es6/* __assign */.pi)({}, edge))) {
                    edge.cursor = readField("cursor", edge);
                }
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                if (firstEdge && startCursor) {
                    firstEdge.cursor = startCursor;
                }
                if (lastEdge && endCursor) {
                    lastEdge.cursor = endCursor;
                }
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) {
                    incoming = mergeDeep(incoming, {
                        pageInfo: {
                            startCursor: firstCursor,
                        },
                    });
                }
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) {
                    incoming = mergeDeep(incoming, {
                        pageInfo: {
                            endCursor: lastCursor,
                        },
                    });
                }
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.after; });
                if (index >= 0) {
                    prefix = prefix.slice(0, index + 1);
                }
            }
            else if (args && args.before) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.before; });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            }
            else if (incoming.edges) {
                prefix = [];
            }
            var edges = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], prefix, true), incomingEdges, true), suffix, true);
            var pageInfo = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0,tslib_es6/* __rest */._T)(_b, ["hasPreviousPage", "hasNextPage", "startCursor", "endCursor"]);
                Object.assign(pageInfo, extras);
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage)
                        pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor)
                        pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage)
                        pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor)
                        pageInfo.endCursor = endCursor;
                }
            }
            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getExtras(existing)), getExtras(incoming)), { edges: edges, pageInfo: pageInfo });
        },
    };
}
var getExtras = function (obj) { return (0,tslib_es6/* __rest */._T)(obj, notExtras); };
var notExtras = ["edges", "pageInfo"];
function makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: "",
        },
    };
}
//# sourceMappingURL=pagination.js.map
;// CONCATENATED MODULE: ./lib/auth/typePolicies.ts

var typePolicies = {
    User: {
        fields: {
            orders: relayStylePagination()
        }
    }
};
/* harmony default export */ var auth_typePolicies = ((/* unused pure expression or super */ null && (typePolicies)));

;// CONCATENATED MODULE: ./lib/auth/useApolloClient.ts




// for static geenration of pages, we don't need auth there
var serverApolloClient = new ApolloClient({
    link: createHttpLink({
        uri: constants/* API_URI */.G9
    }),
    cache: new InMemoryCache({
        typePolicies: typePolicies
    }),
    ssrMode: true
});
var useApolloClient = function(fetchWithAuth) {
    var httpLink = createHttpLink({
        uri: constants/* API_URI */.G9,
        fetch: fetchWithAuth
    });
    var apolloClient = (0,react.useMemo)(function() {
        return new ApolloClient({
            link: httpLink,
            cache: new InMemoryCache({
                typePolicies: typePolicies
            })
        });
    }, []);
    return {
        apolloClient: apolloClient,
        resetClient: function() {
            return apolloClient.resetStore();
        }
    };
};


/***/ }),

/***/ 14353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AWSClient; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6666);
/* harmony import */ var _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var AWSRequest = /*#__PURE__*/ function() {
    "use strict";
    function AWSRequest() {
        _classCallCheck(this, AWSRequest);
        this.endpoints = {
            fontData: {
                fondue: function(param) {
                    var params = param.params, pathAppend = param.pathAppend;
                    return {
                        method: "GET",
                        resource: "typefaces/".concat(pathAppend),
                        params: params
                    };
                }
            },
            fontDownload: {
                post: function(param) {
                    var body = param.body;
                    return {
                        method: "POST",
                        resource: "fonts/download",
                        body: body
                    };
                }
            },
            fontGlyphsData: {
                get: function(param) {
                    var params = param.params, pathAppend = param.pathAppend;
                    return {
                        method: "GET",
                        resource: "typefaces/".concat(pathAppend),
                        params: params
                    };
                }
            }
        };
    }
    var _proto = AWSRequest.prototype;
    _proto.request = function request(endpoint) {
        var apiUrl = "https://api.prod.colophon-foundry.org";
        var reqUrl = "".concat(apiUrl, "/").concat(endpoint.resource);
        if (endpoint.params) {
            var qs = Object.keys(endpoint.params).map(function(key) {
                return "".concat(key, "=").concat(endpoint.params[key]);
            }).join("&");
            reqUrl = "".concat(apiUrl, "/").concat(endpoint.resource, "?").concat(qs);
        }
        return fetch(reqUrl, {
            method: endpoint === null || endpoint === void 0 ? void 0 : endpoint.method,
            body: (endpoint === null || endpoint === void 0 ? void 0 : endpoint.body) ? endpoint.body : null
        }).then(function() {
            var _ref = _asyncToGenerator(_opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(response) {
                var data;
                return _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return response.json();
                        case 2:
                            data = _ctx.sent;
                            return _ctx.abrupt("return", data);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(error) {
            return error;
        });
    };
    _proto.fontData = function fontData(method, options) {
        var existingEndpoint = this.endpoints.fontData[method];
        if (existingEndpoint) {
            var endpoint = existingEndpoint(options);
            return this.request(endpoint);
        }
    };
    _proto.fontGlyphsData = function fontGlyphsData(method, options) {
        var existingEndpoint = this.endpoints.fontGlyphsData[method];
        if (existingEndpoint) {
            var endpoint = existingEndpoint(options);
            return this.request(endpoint);
        }
    };
    _proto.fontDownload = function fontDownload(method, options) {
        var existingEndpoint = this.endpoints.fontDownload[method];
        if (existingEndpoint) {
            var endpoint = existingEndpoint(options);
            return this.request(endpoint);
        }
    };
    return AWSRequest;
}();
var AWSClient = new AWSRequest();


/***/ }),

/***/ 67414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getEUCountry; }
/* harmony export */ });
/* unused harmony export euCountries */
var euCountries = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "GB"
];
var getEUCountry = function(code) {
    var countryCode = code || "GB";
    return euCountries.filter(function(country) {
        return country === countryCode;
    });
};


/***/ }),

/***/ 42748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RZ": function() { return /* binding */ isMigratedOrder; },
/* harmony export */   "$C": function() { return /* binding */ getMigratedOrderLinesData; },
/* harmony export */   "$N": function() { return /* binding */ getMigratedOrderTotals; },
/* harmony export */   "L8": function() { return /* binding */ getMigratedOrderLines; }
/* harmony export */ });
/* unused harmony exports getMigratedOrderLineTransactionId, getMigratedOrderLineBraintreeId */
var isMigratedOrder = function(order) {
    var ref;
    return ((ref = order.metadata.find(function(item) {
        return item.key === "migrated_order";
    })) === null || ref === void 0 ? void 0 : ref.value) === "true";
};
var getMigratedOrderLinesData = function(order) {
    var ref;
    return (ref = order.metadata.find(function(item) {
        return item.key === "migratedOrderLines";
    })) === null || ref === void 0 ? void 0 : ref.value;
};
var getMigratedOrderLineTransactionId = function(order) {
    var ref;
    return (ref = order.metadata.find(function(item) {
        return item.key === "transactionId";
    })) === null || ref === void 0 ? void 0 : ref.value;
};
var getMigratedOrderLineBraintreeId = function(order) {
    var ref;
    return (ref = order.metadata.find(function(item) {
        return item.key === "braintree_id";
    })) === null || ref === void 0 ? void 0 : ref.value;
};
var getMigratedOrderTotals = function(order) {
    var ref, ref1;
    var migratedOrderSubtotal = (ref = order.metadata.find(function(item) {
        return item.key === "subtotal";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var migratedOrderTotal = (ref1 = order.metadata.find(function(item) {
        return item.key === "total";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    return {
        subtotal: {
            amount: migratedOrderSubtotal,
            currency: "GBP"
        },
        total: {
            amount: migratedOrderTotal,
            currency: "GBP"
        }
    };
};
var getMigratedOrderLines = function(migratedOrderLinesData) {
    var migratedOrderLinesDataArray = [];
    try {
        migratedOrderLinesDataArray = JSON.parse(migratedOrderLinesData);
    } catch (e) {
        return [];
    }
    return migratedOrderLinesDataArray;
};


/***/ }),

/***/ 52375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "px": function() { return /* binding */ SITE_NAME; },
/* harmony export */   "ES": function() { return /* binding */ CHECKOUT_TOKEN; },
/* harmony export */   "G9": function() { return /* binding */ API_URI; },
/* harmony export */   "We": function() { return /* binding */ STORYBLOK_IMAGE_QUALITY; },
/* harmony export */   "js": function() { return /* binding */ SOCIAL_FACEBOOK_ID; },
/* harmony export */   "ag": function() { return /* binding */ SOCIAL_INSTAGRAM_ID; },
/* harmony export */   "R1": function() { return /* binding */ SOCIAL_TWITTER_ID; },
/* harmony export */   "V3": function() { return /* binding */ SOCIAL_PINTEREST_ID; },
/* harmony export */   "l9": function() { return /* binding */ SCREEN_SIZE_MOBILE_MAX; },
/* harmony export */   "xU": function() { return /* binding */ SCREEN_SIZE_TABLET_MIN; },
/* harmony export */   "$r": function() { return /* binding */ SCREEN_SIZE_TABLET_MAX; },
/* harmony export */   "QG": function() { return /* binding */ SCREEN_SIZE_DESKTOP_MIN; },
/* harmony export */   "m0": function() { return /* binding */ SCREEN_SIZE_DESKTOP_MAX; },
/* harmony export */   "X": function() { return /* binding */ SCREEN_SIZE_LARGEDESKTOP_MIN; },
/* harmony export */   "$N": function() { return /* binding */ GTM_TRACKING_ID; },
/* harmony export */   "AC": function() { return /* binding */ GA_4_TRACKING_ID; },
/* harmony export */   "BA": function() { return /* binding */ LOGROCKET_ID; },
/* harmony export */   "tt": function() { return /* binding */ CUSTOMISER_PRODUCT_VARIANT_ID_DEFAULT; }
/* harmony export */ });
/* unused harmony exports TRAILING_SLASH, STORYBOOK_PREVIEW_KEY, ENVIRONMENT, VERSION, SOCIAL_LINKEDIN_ID, SOCIAL_YOUTUBE_ID, IMAGE_SIZES, SCREEN_SIZE_LARGEDESKTOP_MAX, SCREEN_SIZE_SUPERLARGEDESKTOP_MIN, COOKIE_BOT_ID, PRODUCTS_GOODS_CATEGORY, DEFAULT_TYPEFACE_PRODUCTS_CATEGORY, TRANSACTIONAL_TEST_MODE */
/* provided dependency */ var process = __webpack_require__(6436);
// Env vars that can be overridden
var SITE_URL = process.env.SITE_URL || "https://www.colophon-foundry.org/";
var SITE_NAME = process.env.SITE_NAME || "Colophon Foundry";
var TRAILING_SLASH = true;
var CHECKOUT_TOKEN = "checkoutToken";
var API_URI = "https://colophon-prod.eu.saleor.cloud/graphql/" || 0;
var STORYBLOK_IMAGE_QUALITY = 75;
var STORYBOOK_PREVIEW_KEY = (/* unused pure expression or super */ null && ("WygMRPInxMCOSMUw1Vt4TAtt"));
var ENVIRONMENT = "production" || 0;
var VERSION = ENVIRONMENT === "development" ? "draft" : "published";
// Constants that aren't expected to differ between environments
var SOCIAL_FACEBOOK_ID = "null";
var SOCIAL_INSTAGRAM_ID = "https://www.instagram.com/colophonfoundry/";
var SOCIAL_TWITTER_ID = "https://twitter.com/colophonfoundry";
var SOCIAL_PINTEREST_ID = "https://www.pinterest.co.uk/colophonfoundry";
var SOCIAL_LINKEDIN_ID = null;
var SOCIAL_YOUTUBE_ID = null;
var IMAGE_SIZES = (/* unused pure expression or super */ null && ([]));
// Ensure these match: styles/_sass-variables.scss
var SCREEN_SIZE_MOBILE_MAX = "767px";
var SCREEN_SIZE_TABLET_MIN = "768px";
var SCREEN_SIZE_TABLET_MAX = "1023px";
var SCREEN_SIZE_DESKTOP_MIN = "1024px";
var SCREEN_SIZE_DESKTOP_MAX = "1239px";
var SCREEN_SIZE_LARGEDESKTOP_MIN = "1240px";
var SCREEN_SIZE_LARGEDESKTOP_MAX = "1599px";
var SCREEN_SIZE_SUPERLARGEDESKTOP_MIN = "1600px";
// Add Google Analytics 4 and/or GTM scripts by configuring the below
var GTM_TRACKING_ID = "GTM-WTNF89D" || 0;
var GA_4_TRACKING_ID = process.env.NEXT_PUBLIC_GA_4_TRACKING_ID || null;
var LOGROCKET_ID = process.env.NEXT_PUBLIC_LOGROCKET_ID || null;
var COOKIE_BOT_ID = (/* unused pure expression or super */ null && ("7baa71e9-e33f-4ec2-bde7-79c606d83278"));
// Saleor item constants
var PRODUCTS_GOODS_CATEGORY = "Q2F0ZWdvcnk6NjE=";
var DEFAULT_TYPEFACE_PRODUCTS_CATEGORY = (/* unused pure expression or super */ null && ("Q2F0ZWdvcnk6MjQ="));
var CUSTOMISER_PRODUCT_VARIANT_ID_DEFAULT = "UHJvZHVjdFZhcmlhbnQ6Mjc4MQ==";
var TRANSACTIONAL_TEST_MODE = process.env.NEXT_PUBLIC_TRANSACTIONAL_TEST_MODE || false;


/***/ }),

/***/ 61702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DR": function() { return /* binding */ getIgnoredAxes; },
/* harmony export */   "gi": function() { return /* binding */ getIgnoredOpentype; },
/* harmony export */   "ns": function() { return /* binding */ getFilteredAxes; }
/* harmony export */ });
/* harmony import */ var _productHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11603);

var ignoredPropertiesMap = {
    ignoredAxes: "ignored-axes",
    ignoredOpentype: "ignored-opentype",
    ignoredOpentypeCustomiser: "ignored-opentype-customiser"
};
var getIgnoredAxes = function(variant) {
    var ignoredAxes = (0,_productHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getMetaDataValueByKey */ .jN)({
        item: variant
    })(ignoredPropertiesMap.ignoredAxes);
    var ignoredAxesArray = ignoredAxes && ignoredAxes.split(",") || [];
    return ignoredAxesArray;
};
var getIgnoredOpentype = function(variant) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _isCustomiser = ref.isCustomiser, isCustomiser = _isCustomiser === void 0 ? false : _isCustomiser;
    var ignoredPropertiesKey = isCustomiser ? "ignoredOpentypeCustomiser" : "ignoredOpentype";
    var ignoredOpentypeString = (0,_productHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getMetaDataValueByKey */ .jN)({
        item: variant
    })(ignoredPropertiesMap[ignoredPropertiesKey]);
    var ignoredOpentype = ignoredOpentypeString ? ignoredOpentypeString.split(",") : "";
    var ignoredOpentypeArray = Array.isArray(ignoredOpentype) ? ignoredOpentype : [
        ignoredOpentype
    ];
    var ignoredOpentypeArrayFormatted = ignoredOpentypeArray.map(function(item) {
        return item.toLowerCase().trim();
    });
    return ignoredOpentypeArrayFormatted;
};
var getFilteredAxes = function(fontAxes, ignoredAxes) {
    return fontAxes.filter(function(axis) {
        return !ignoredAxes.includes(axis.id.toLowerCase());
    });
};


/***/ }),

/***/ 35761:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pushAddToCartDataLayer = function(param) {
    var lines = param.lines;
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            items: lines
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (pushAddToCartDataLayer);


/***/ }),

/***/ 74198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var beginCheckout = function(lines) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            items: lines.map(function(line) {
                return {
                    item_id: line === null || line === void 0 ? void 0 : line.id,
                    item_name: line.metadata.length > 0 ? line.variant.sku : line.variant.product.name,
                    item_type: line.metadata.length === 0 ? "goods" : "typefaces",
                    price: "".concat(line === null || line === void 0 ? void 0 : line.totalPrice.gross.amount),
                    quantity: "".concat(line.quantity)
                };
            })
        }
    });
};
var addShippingInfo = function(shipping_tier) {
    var currency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "\xa3";
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_shipping_info",
        ecommerce: {
            shipping_tier: "".concat(shipping_tier.name, " - ").concat(currency).concat(shipping_tier.price.amount)
        }
    });
};
var viewItemList = function(lines, item_type) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
            items: lines.map(function(line) {
                var ref, ref1;
                var itemCategory = line.metadata.length === 0 ? "goods" : "typefaces";
                return _objectSpread({
                    item_id: line === null || line === void 0 ? void 0 : line.id,
                    item_name: line.metadata.length > 0 ? line.name : line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.name,
                    item_category: itemCategory
                }, itemCategory === "typefaces" && {
                    item_subcategory: line.category.name
                });
            })
        }
    });
};
var selectItem = function(item) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "select_item",
        ecommerce: {
            item: {
                item_id: item === null || item === void 0 ? void 0 : item.id,
                item_name: item.metadata.length > 0 ? item.name : item.variant.product.name
            }
        }
    });
};
var viewItem = function(item) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_item",
        ecommerce: {
            item: {
                item_id: item === null || item === void 0 ? void 0 : item.id,
                item_name: item.name
            }
        }
    });
};
var removeFromCart = function(item) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
            item_id: item === null || item === void 0 ? void 0 : item.id,
            item_name: item.metadata.length > 0 ? item.variant.sku : item.variant.product.name,
            item_type: item.metadata.length === 0 ? "goods" : "typefaces",
            price: "".concat(item === null || item === void 0 ? void 0 : item.totalPrice.gross.amount),
            quantity: "".concat(item.quantity)
        }
    });
};
var viewCart = function(lines) {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_cart",
        ecommerce: {
            items: lines.map(function(line) {
                return {
                    item_id: line === null || line === void 0 ? void 0 : line.id,
                    item_name: line.metadata.length > 0 ? line.variant.sku : line.variant.product.name,
                    item_type: line.metadata.length === 0 ? "goods" : "typefaces",
                    price: "".concat(line === null || line === void 0 ? void 0 : line.totalPrice.gross.amount),
                    quantity: "".concat(line.quantity)
                };
            })
        }
    });
};
var checkoutDataLayer = {
    beginCheckout: beginCheckout,
    addShippingInfo: addShippingInfo,
    viewItemList: viewItemList,
    selectItem: selectItem,
    viewItem: viewItem,
    removeFromCart: removeFromCart,
    viewCart: viewCart
};
/* harmony default export */ __webpack_exports__["Z"] = (checkoutDataLayer);


/***/ }),

/***/ 16270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ fontVersion; },
/* harmony export */   "j": function() { return /* binding */ fontIsPro; }
/* harmony export */ });
var fontVersion = function(variant) {
    var skuIsPro = variant.sku.endsWith("pro");
    return skuIsPro ? "pro" : "std";
};
var fontIsPro = function(variant) {
    return fontVersion(variant) === "pro";
};


/***/ }),

/***/ 57189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MH": function() { return /* binding */ generateVariantS3Path; },
/* harmony export */   "z7": function() { return /* binding */ generateFamilyVariantS3Path; },
/* harmony export */   "q0": function() { return /* binding */ generateS3PathFromVariants; }
/* harmony export */ });
/* unused harmony exports fontFamilyGroupDisplayFont, fontDisplayAttribute, getFontVersion */
/* harmony import */ var _productHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11603);

var fontFamilyGroupDisplayFont = function(group) {
    var familySkus = group.metadata.find(function(meta) {
        return meta.key === "familySkus";
    });
    if (familySkus) {
        var skusArray = familySkus.value.split(",");
        return skusArray.length > 0 ? skusArray[0] : null;
    }
    return false;
};
var fontDisplayAttribute = function(attributes) {
    var ref;
    var attributeData = attributes === null || attributes === void 0 ? void 0 : attributes.find(function(attribute) {
        return attribute.attribute.slug === "display-font";
    });
    return (attributeData === null || attributeData === void 0 ? void 0 : (ref = attributeData.values) === null || ref === void 0 ? void 0 : ref.length) > 0 ? attributeData.values[0].name.toLowerCase() : null;
};
var getFontVersion = function(variants) {
    var firstVariant = variants[0];
    var firstVariantSku = firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku;
    var skuIsPro = firstVariantSku.endsWith("pro");
    return skuIsPro ? "pro" : "std";
};
var generateVariantS3Path = function(productSlug, sku) {
    if (!productSlug || !sku) return;
    var fontVersion = sku.endsWith("pro") ? "pro" : "std";
    var normalizedSku = sku === null || sku === void 0 ? void 0 : sku.replace(/-std$/, "");
    var result = normalizedSku ? "/".concat(productSlug.replaceAll(/\s+/g, "-").toLowerCase(), "/").concat(fontVersion, "/").concat(normalizedSku, ".woff2") : "";
    return result;
};
var generateFamilyVariantS3Path = function(productSlug, fontFamilyVariant) {
    var familyDisplayFont = fontFamilyGroupDisplayFont(fontFamilyVariant);
    return generateVariantS3Path(productSlug, familyDisplayFont);
};
var generateS3PathFromVariants = function(productSlug, variants, attributes) {
    if (!variants || variants.length === 0) {
        return "";
    }
    var nonFamilyGroupVariants = variants.filter(function(variant) {
        return (0,_productHelpers__WEBPACK_IMPORTED_MODULE_0__/* .isNotFamilyVariant */ .CY)(variant);
    });
    if (!nonFamilyGroupVariants || nonFamilyGroupVariants.length === 0) {
        return "";
    }
    // By default the sku we use is the first variant
    var ref = nonFamilyGroupVariants[0], _sku = ref.sku, sku = _sku === void 0 ? "" : _sku;
    // If the display font has been set, instead we use that
    // Allows control over the font used
    if (fontDisplayAttribute(attributes)) {
        sku = fontDisplayAttribute(attributes);
    }
    return generateVariantS3Path(productSlug, sku);
};


/***/ }),

/***/ 27562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ variantNameWithVersionSuffix; }
/* harmony export */ });
/* harmony import */ var _fontVersion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16270);

function titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for(var i = 0; i < splitStr.length; i++){
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
}
var variantNameFormatted = function(variant) {
    var variantGroup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", lowerCase = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var metadata = variant.metadata;
    var tmp = variant.name, variantName = tmp === void 0 ? "" : tmp;
    var formattedVariantName = lowerCase ? variantName.toLowerCase() : variantName;
    var metadataName = metadata && metadata.some(function(meta) {
        return meta.key === "name";
    }) ? metadata.find(function(meta) {
        return meta.key === "name";
    }).value : null;
    var name = metadataName || formattedVariantName;
    return titleCase(name);
};
var variantNameWithVersionSuffix = function(variant, variantName) {
    var variantIsPro = (0,_fontVersion__WEBPACK_IMPORTED_MODULE_0__/* .fontVersion */ .V)(variant) === "pro";
    return variantIsPro ? "".concat(variantName, " (Pro)") : "".concat(variantName, " (Std)");
};
/* harmony default export */ __webpack_exports__["Z"] = (variantNameFormatted);


/***/ }),

/***/ 61499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nr": function() { return /* reexport */ useDebounce; },
  "Or": function() { return /* reexport */ useIsVisible; },
  "X8": function() { return /* reexport */ useSbImage; },
  "aF": function() { return /* reexport */ useUser/* useUser */.a; }
});

// UNUSED EXPORTS: useWindowDimensions

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./lib/hooks/useDebounce.ts

function useDebounce(value, delay) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            return setDebouncedValue(value);
        }, delay || 500);
        return function() {
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ var hooks_useDebounce = ((/* unused pure expression or super */ null && (useDebounce)));

;// CONCATENATED MODULE: ./lib/hooks/useIsVisible.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function useIsVisible(param1) {
    var ref = param1.ref, options = param1.options;
    var ref1 = (0,react.useState)(false), isIntersecting = ref1[0], setIntersecting = ref1[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            return setIntersecting(entry.isIntersecting);
        }, options);
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        ref
    ]);
    return isIntersecting;
}

// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
;// CONCATENATED MODULE: ./lib/hooks/useSbImage.ts

var useSbImage = function() {
    var isSVG = function(image) {
        return image.endsWith(".svg");
    };
    var getSbImage = function(image, size) {
        var quality = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
        var host = "".concat(constants/* SITE_URL */._O, "cdn/");
        return isSVG(image) ? image.replace("https://a.storyblok.com/", host) : image.replace("https://a.storyblok.com/", host) + "/m/".concat(size, "x0/filters:quality(").concat(quality, ")");
    };
    return {
        getSbImage: getSbImage,
        isSVG: isSVG
    };
};
/* harmony default export */ var hooks_useSbImage = ((/* unused pure expression or super */ null && (useSbImage)));

// EXTERNAL MODULE: ./lib/hooks/useUser.ts
var useUser = __webpack_require__(56804);
;// CONCATENATED MODULE: ./lib/hooks/useWindowDimensions.ts

function useWindowDimensions() {
    var getWindowDimensions = function getWindowDimensions() {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height
        };
    };
    var handleResize = function handleResize() {
        setWindowDimensions(getWindowDimensions());
    };
    var hasWindow = "object" !== "undefined";
    var ref = useState(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    useEffect(function() {
        if (hasWindow) {
            window.addEventListener("resize", handleResize);
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, [
        hasWindow
    ]);
    return windowDimensions;
}
/* harmony default export */ var hooks_useWindowDimensions = ((/* unused pure expression or super */ null && (useWindowDimensions)));

;// CONCATENATED MODULE: ./lib/hooks/index.ts







/***/ }),

/***/ 99182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useScreenSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52375);


var didInit = false;
/* eslint-disable react-hooks/rules-of-hooks */ var useMediaQuery = function(media) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), targetReached = ref[0], setTargetReached = ref[1];
    var updateTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.matches) {
            setTargetReached(true);
        } else {
            setTargetReached(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!didInit) {
            didInit = true;
        }
        var matchMedia = window.matchMedia(media);
        if (matchMedia === null || matchMedia === void 0 ? void 0 : matchMedia.addEventListener) {
            matchMedia.addEventListener("change", function(e) {
                return updateTarget(e);
            });
        } else {
            matchMedia.addListener(updateTarget);
        }
        // Check on mount (callback is not called until a change occurs)
        if (matchMedia && matchMedia.matches) {
            setTargetReached(true);
        }
        return function() {
            didInit = false;
            if (matchMedia === null || matchMedia === void 0 ? void 0 : matchMedia.addEventListener) {
                return matchMedia.removeEventListener("change", function(e) {
                    return updateTarget(e);
                });
            } else {
                return matchMedia.removeListener(updateTarget);
            }
        };
    }, []);
    return targetReached;
};
var useScreenSize = function() {
    var screenSizes = [
        {
            name: "Mobile",
            matching: useMediaQuery("(max-width: ".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_MOBILE_MAX */ .l9, ")"))
        },
        {
            name: "Tablet",
            matching: useMediaQuery("(min-width: ".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_TABLET_MIN */ .xU, ") and (max-width: ").concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_TABLET_MAX */ .$r, ")"))
        },
        {
            name: "Desktop",
            matching: useMediaQuery("(min-width: ".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_DESKTOP_MIN */ .QG, ") and (max-width: ").concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_DESKTOP_MAX */ .m0, ")"))
        },
        {
            name: "LargeDesktop",
            matching: useMediaQuery("(min-width: ".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE_LARGEDESKTOP_MIN */ .X, ")"))
        }
    ];
    var matchingScreen = screenSizes.find(function(size) {
        return size.matching;
    });
    return matchingScreen ? matchingScreen.name : "";
};
/* eslint-enable react-hooks/rules-of-hooks */ /* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useMediaQuery)));


/***/ }),

/***/ 56804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67062);

var useUser = function() {
    var ref = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_0__/* .useUserQuery */ .bTj)(), data = ref.data, loading = ref.loading, fetchUserData = ref.refetch, fetchMore = ref.fetchMore;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var authenticated = !!(user === null || user === void 0 ? void 0 : user.id);
    return {
        user: user,
        loading: loading,
        authenticated: authenticated,
        fetchUserData: fetchUserData,
        fetchMore: fetchMore
    };
};


/***/ }),

/***/ 51595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uniq; }
/* harmony export */ });
function uniq(a) {
    var seen = {};
    return a.filter(function(item) {
        return seen.hasOwnProperty(item) ? false : seen[item] = true;
    });
};


/***/ }),

/***/ 47475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ usePaths; }
});

;// CONCATENATED MODULE: ./lib/$path.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var pagesPath = {
    $404: {
        $url: function(url) {
            return {
                pathname: "/404",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    _slug: function(slug) {
        return {
            $url: function(url) {
                return {
                    pathname: "/[slug]",
                    query: {
                        slug: slug
                    },
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        };
    },
    account: {
        confirm: {
            $url: function(url) {
                return {
                    pathname: "/account/confirm",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        confirm_account_delete: {
            $url: function(url) {
                return {
                    pathname: "/account/confirm-account-delete",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        confirm_email_change: {
            $url: function(url) {
                return {
                    pathname: "/account/confirm-email-change",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        forgot_password: {
            $url: function(url) {
                return {
                    pathname: "/account/forgot-password",
                    query: url === null || url === void 0 ? void 0 : url.query,
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        login: {
            $url: function(url) {
                return {
                    pathname: "/account/login",
                    query: url === null || url === void 0 ? void 0 : url.query,
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        new_password: {
            $url: function(url) {
                return {
                    pathname: "/account/new-password",
                    query: url === null || url === void 0 ? void 0 : url.query,
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        orders: {
            _token: function(token) {
                return {
                    $url: function(url) {
                        return {
                            pathname: "/account/orders/[token]",
                            query: {
                                token: token
                            },
                            hash: url === null || url === void 0 ? void 0 : url.hash
                        };
                    }
                };
            }
        },
        register: {
            $url: function(url) {
                return {
                    pathname: "/account/register",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        $url: function(url) {
            return {
                pathname: "/account",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    articles_guides: {
        _slug: function(slug) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/articles-guides/[slug]",
                        query: {
                            slug: slug
                        },
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                }
            };
        },
        $url: function(url) {
            return {
                pathname: "/articles-guides",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    cart: {
        $url: function(url) {
            return {
                pathname: "/cart",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    checkout: {
        $url: function(url) {
            return {
                pathname: "/checkout",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    custom_projects: {
        _slug: function(slug) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/custom-projects/[slug]",
                        query: {
                            slug: slug
                        },
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                }
            };
        },
        $url: function(url) {
            return {
                pathname: "/custom-projects",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    goods: {
        _slug: function(slug) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/goods/[slug]",
                        query: _objectSpread({
                            slug: slug
                        }, url === null || url === void 0 ? void 0 : url.query),
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                }
            };
        },
        $url: function(url) {
            return {
                pathname: "/goods",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    in_use: {
        $url: function(url) {
            return {
                pathname: "/in-use",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    in_use_folder: {
        $url: function(url) {
            return {
                pathname: "/in-use-folder",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    sharecart: {
        _cartId: function(cartId) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/sharecart/[cartId]",
                        query: _objectSpread({
                            cartId: cartId
                        }, url === null || url === void 0 ? void 0 : url.query),
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                }
            };
        }
    },
    test: {
        icons: {
            $url: function(url) {
                return {
                    pathname: "/test/icons",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        }
    },
    tools: {
        _slug: function(slug) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/tools/[slug]",
                        query: {
                            slug: slug
                        },
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                }
            };
        },
        cf_creator: {
            $url: function(url) {
                return {
                    pathname: "/tools/cf-creator",
                    query: url === null || url === void 0 ? void 0 : url.query,
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        colophon_standard: {
            $url: function(url) {
                return {
                    pathname: "/tools/colophon-standard",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        },
        proofer: {
            $url: function(url) {
                return {
                    pathname: "/tools/proofer",
                    hash: url === null || url === void 0 ? void 0 : url.hash
                };
            }
        }
    },
    typefaces: {
        _slug: function(slug) {
            return {
                $url: function(url) {
                    return {
                        pathname: "/typefaces/[slug]",
                        query: _objectSpread({
                            slug: slug
                        }, url === null || url === void 0 ? void 0 : url.query),
                        hash: url === null || url === void 0 ? void 0 : url.hash
                    };
                },
                glyphs: {
                    _fontStyle: function(fontStyle) {
                        return {
                            $url: function(url) {
                                return {
                                    pathname: "/typefaces/[slug]/glyphs/[[...fontStyle]]",
                                    query: _objectSpread({
                                        slug: slug,
                                        fontStyle: fontStyle
                                    }, url === null || url === void 0 ? void 0 : url.query),
                                    hash: url === null || url === void 0 ? void 0 : url.hash
                                };
                            }
                        };
                    }
                },
                in_use: {
                    $url: function(url) {
                        return {
                            pathname: "/typefaces/[slug]/in-use",
                            query: {
                                slug: slug
                            },
                            hash: url === null || url === void 0 ? void 0 : url.hash
                        };
                    }
                },
                info: {
                    $url: function(url) {
                        return {
                            pathname: "/typefaces/[slug]/info",
                            query: {
                                slug: slug
                            },
                            hash: url === null || url === void 0 ? void 0 : url.hash
                        };
                    }
                },
                opentype: {
                    _fontStyle: function(fontStyle) {
                        return {
                            $url: function(url) {
                                return {
                                    pathname: "/typefaces/[slug]/opentype/[[...fontStyle]]",
                                    query: {
                                        slug: slug,
                                        fontStyle: fontStyle
                                    },
                                    hash: url === null || url === void 0 ? void 0 : url.hash
                                };
                            }
                        };
                    }
                },
                proofer: {
                    _fontStyle: function(fontStyle) {
                        return {
                            $url: function(url) {
                                return {
                                    pathname: "/typefaces/[slug]/proofer/[[...fontStyle]]",
                                    query: {
                                        slug: slug,
                                        fontStyle: fontStyle
                                    },
                                    hash: url === null || url === void 0 ? void 0 : url.hash
                                };
                            }
                        };
                    }
                },
                variable: {
                    _fontStyle: function(fontStyle) {
                        return {
                            $url: function(url) {
                                return {
                                    pathname: "/typefaces/[slug]/variable/[[...fontStyle]]",
                                    query: {
                                        slug: slug,
                                        fontStyle: fontStyle
                                    },
                                    hash: url === null || url === void 0 ? void 0 : url.hash
                                };
                            }
                        };
                    }
                }
            };
        },
        $url: function(url) {
            return {
                pathname: "/typefaces",
                hash: url === null || url === void 0 ? void 0 : url.hash
            };
        }
    },
    $url: function(url) {
        return {
            pathname: "/",
            hash: url === null || url === void 0 ? void 0 : url.hash
        };
    }
};

;// CONCATENATED MODULE: ./lib/paths.ts

var usePaths = function() {
    // Kept in case need a quick revert
    // const { currentChannel, currentLocale: locale } = useRegions();
    return pagesPath;
};


/***/ }),

/***/ 11603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tM": function() { return /* binding */ getProductFontSizeAdjust; },
/* harmony export */   "Ow": function() { return /* binding */ getFontDisplayName; },
/* harmony export */   "S5": function() { return /* binding */ isFamilyVariant; },
/* harmony export */   "CY": function() { return /* binding */ isNotFamilyVariant; },
/* harmony export */   "bc": function() { return /* binding */ isVariableFont; },
/* harmony export */   "nP": function() { return /* binding */ getFamilyMetaSkus; },
/* harmony export */   "H_": function() { return /* binding */ isFontItem; },
/* harmony export */   "ad": function() { return /* binding */ isFontGroupItem; },
/* harmony export */   "lp": function() { return /* binding */ isCustomisedFont; },
/* harmony export */   "tb": function() { return /* binding */ isPhysicalItem; },
/* harmony export */   "sQ": function() { return /* binding */ hasCustomisedFont; },
/* harmony export */   "uN": function() { return /* binding */ getCustomFontName; },
/* harmony export */   "jN": function() { return /* binding */ getMetaDataValueByKey; },
/* harmony export */   "xw": function() { return /* binding */ getFontStyleBySku; },
/* harmony export */   "Zm": function() { return /* binding */ getFontMetaS3Family; }
/* harmony export */ });
/* unused harmony exports searchMatch, getProductCategory, getProductLanguage, filterProducts, getProductCategories, filterProductsByCategoryAndSearch, isIgnoredCustomiser */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52375);
/* harmony import */ var _fonts_variantName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27562);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70108);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var searchMatch = function(text, searchString) {
    if (!text || !searchString) return false;
    var preparedText = normalize(text);
    var preparedSearch = normalize(searchString.trim());
    var pattern = preparedSearch.split(" ").map(function(term) {
        return "(?=.*".concat(term, ")");
    }).join("") + ".*";
    return preparedText.search(new RegExp(pattern, "i")) !== -1;
};
var getAttribute = function(prod, name) {
    return prod.attributes.find(function(attr) {
        return attr.attribute.name === name;
    });
};
var getProductCategory = function(prod) {
    var attr = getAttribute(prod, "FontCategory");
    if (!attr || attr.values.length === 0) return;
    return attr.values[0].name;
};
var getProductLanguage = function(prod) {
    var attr = getAttribute(prod, "FontLanguages");
    var langs = attr.values.map(function(val) {
        return val.name;
    });
    return langs;
};
var filterProducts = function(products, param) {
    var search = param.search, category = param.category, language = param.language;
    var filtered = _toConsumableArray(products);
    // Filter by Category
    filtered = filtered.filter(function(prod) {
        if (category === "All Categories") return true;
        var cat = getProductCategory(prod);
        return cat ? cat === category : false;
    });
    // Filter by Language
    filtered = filtered.filter(function(prod) {
        if (language === "All Languages") return true;
        var lang = getProductLanguage(prod);
        return lang.includes(language);
    });
    // Filter Search
    filtered = filtered.filter(function(prod) {
        if (!search) return true;
        return searchMatch(prod.name, search);
    });
    return filtered;
};
var getProductCategories = function(products) {
    var categories = [
        "All Categories"
    ];
    products.forEach(function(prod) {
        var cat = getProductCategory(prod);
        if (cat && !categories.includes(cat)) categories.push(cat);
    });
    categories = categories.map(function(li) {
        return {
            name: li
        };
    });
    return categories;
};
var filterProductsByCategoryAndSearch = function(list, category, search) {
    // filter by category
    var filtered = list.filter(function(prod) {
        if (category === "All Categories") return true;
        var cat = getProductCategory(prod);
        return cat === category;
    });
    // filter search
    filtered = filtered.filter(function(prod) {
        if (!search) return true;
        return searchMatch(prod.name, search);
    });
    return filtered;
};
var getProductFontSizeAdjust = function(param) {
    var metadata = param.metadata;
    var fsa = metadata.find(function(meta) {
        return meta.key === "font-size-adjust";
    });
    if (fsa) return fsa.value;
};
var getFontDisplayName = function(param) {
    var name = param.name, metadata = param.metadata;
    var displayName = metadata.find(function(meta) {
        return meta.key === "displayName";
    });
    if (displayName) return displayName.value;
    return name;
};
var isFamilyVariant = function(variant) {
    return variant.sku.includes("-family") || variant.sku.includes("-family-pro") || variant.sku.includes("-subfamily") || variant.sku.includes("-subfamily-pro");
};
var isNotFamilyVariant = function(variant) {
    return !variant.sku.includes("-family") && !variant.sku.includes("-family-pro") && !variant.sku.includes("-subfamily") && !variant.sku.includes("-subfamily-pro");
};
var isIgnoredCustomiser = function(variant) {
    var ref;
    var ignoreCustomiserMetadata = (ref = variant.metadata.find(function(param) {
        var key = param.key;
        return key === "ignored-customiser";
    })) === null || ref === void 0 ? void 0 : ref.value;
    return ignoreCustomiserMetadata === "true";
};
var isVariableFont = function(variant) {
    return variant.sku.includes("-variable-");
};
var getFamilyMetaSkus = function(product) {
    var familySkusMeta = product.metadata.find(function(metadataItem) {
        return metadataItem.key === "familySkus";
    });
    var familySkus = familySkusMeta ? familySkusMeta.value.split(",") : [];
    return familySkus;
};
var isFontItem = function(lineItem) {
    var ref, ref1, ref2;
    return (lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productType) === null || ref2 === void 0 ? void 0 : ref2.slug) === "font-family";
};
var isFontGroupItem = function(lineItem) {
    return isFontItem(lineItem) && isFamilyVariant(lineItem.variant);
};
var isCustomisedFont = function(lineItem) {
    var ref;
    return (lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.id) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMISER_PRODUCT_VARIANT_ID_DEFAULT */ .tt;
};
var isPhysicalItem = function(lineItem) {
    return !isFontItem(lineItem) && !isCustomisedFont(lineItem);
};
var hasCustomisedFont = function(lineItems) {
    return !!lineItems.filter(function(lineItem) {
        return isCustomisedFont(lineItem);
    }).length;
};
var getCustomFontName = function(lineItem) {
    var ref;
    var fontName = (ref = lineItem.metadata.find(function(param) {
        var key = param.key;
        return key === "itemCustomName";
    })) === null || ref === void 0 ? void 0 : ref.value;
    return fontName || (0,_fonts_variantName__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(lineItem.variant);
};
var getMetaDataValueByKey = function(param1) {
    var item = param1.item;
    return function() {
        var metaDataKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var ref;
        return (ref = item.metadata.find(function(param) {
            var key = param.key;
            return key === metaDataKey;
        })) === null || ref === void 0 ? void 0 : ref.value;
    };
};
var getFontStyleBySku = function(fontStyles, sku) {
    return fontStyles.find(function(option) {
        return option.sku === sku;
    });
};
var getFontMetaS3Family = function(product) {
    var s3FamilyMeta = product.metadata.find(function(metadataItem) {
        return metadataItem.key === "s3Family";
    });
    return s3FamilyMeta ? s3FamilyMeta.value.split(",").map(function(item) {
        return item.trim();
    }) : [];
};


/***/ }),

/***/ 85567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZW": function() { return /* binding */ DEFAULT_LOCALE; },
/* harmony export */   "vE": function() { return /* binding */ DEFAULT_CHANNEL; },
/* harmony export */   "pD": function() { return /* binding */ CHANNELS; },
/* harmony export */   "BN": function() { return /* binding */ localeToEnum; }
/* harmony export */ });
/* unused harmony exports LOCALES, CHANNEL_SLUG_KEY, regionCombinations, contextToRegionQuery, languageCodeToLocale */
var LOCALES = [
    {
        slug: "en-GB",
        code: "EN_GB",
        name: "British English"
    }
];
var DEFAULT_LOCALE = "en-GB";
var CHANNEL_SLUG_KEY = "channelSlug";
var DEFAULT_CHANNEL = {
    slug: "uk-store",
    name: "British Pound Sterling",
    currencyCode: "GBP"
};
var CHANNELS = [
    DEFAULT_CHANNEL,
    {
        slug: "default-channel",
        name: "United States Dollar",
        currencyCode: "USD"
    }
];
var regionCombinations = function() {
    var combinations = [];
    CHANNELS.forEach(function(channel) {
        LOCALES.forEach(function(locale) {
            combinations.push({
                channelSlug: channel.slug,
                localeSlug: locale.slug
            });
        });
    });
    return combinations;
};
var localeToEnum = function(localeSlug) {
    var ref, ref1;
    var chosenLocale = (ref = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === localeSlug;
    })) === null || ref === void 0 ? void 0 : ref.code;
    if (chosenLocale) {
        return chosenLocale;
    }
    return ((ref1 = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === DEFAULT_LOCALE;
    })) === null || ref1 === void 0 ? void 0 : ref1.code) || "EN_US";
};
var contextToRegionQuery = function(context) {
    var ref, ref2, ref3, ref4;
    return {
        channel: ((ref = context.params) === null || ref === void 0 ? void 0 : (ref2 = ref.channel) === null || ref2 === void 0 ? void 0 : ref2.toString()) || DEFAULT_CHANNEL.slug,
        locale: localeToEnum(((ref3 = context.params) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.locale) === null || ref4 === void 0 ? void 0 : ref4.toString()) || DEFAULT_LOCALE)
    };
};
var languageCodeToLocale = function(locale) {
    // Converts locale from EN_US to en-US
    var splitted = locale.split("_");
    splitted[0] = splitted[0].toLowerCase();
    return splitted.join("-");
};


/***/ }),

/***/ 95841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);

function createSafeContext() {
    var useContext = function useContext() {
        var value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
        if (value === undefined) {
            throw new Error("useContext must be inside a Provider with a value");
        }
        return value;
    };
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
    return [
        useContext,
        context.Provider
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (createSafeContext);


/***/ }),

/***/ 70108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UO": function() { return /* binding */ addZeroes; },
  "Sx": function() { return /* binding */ characterToHex; },
  "Vx": function() { return /* binding */ convertSnakeToCamelCase; },
  "od": function() { return /* binding */ entitify; },
  "Ep": function() { return /* binding */ formErrorParser; },
  "AW": function() { return /* binding */ formatAsMoney; },
  "s$": function() { return /* binding */ formatAwsS3FontData; },
  "Mw": function() { return /* binding */ generateAwsFontDataPromise; },
  "a9": function() { return /* binding */ getMaxUsageApplies; },
  "Bx": function() { return /* binding */ getVersionScripts; },
  "cU": function() { return /* binding */ inputFieldValidation; },
  "jU": function() { return /* binding */ isBrowser; },
  "kE": function() { return /* binding */ isNumeric; },
  "Fv": function() { return /* binding */ normalize; },
  "Yj": function() { return /* binding */ notNullable; },
  "bk": function() { return /* binding */ onlyFontsInCart; },
  "NM": function() { return /* binding */ round; },
  "cw": function() { return /* binding */ updateFontsToWebfont; }
});

// UNUSED EXPORTS: capitalizeFirstLetter, fontDisplayAttribute, getFontVersion, isVariantInCart, pluralize, slugify

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
;// CONCATENATED MODULE: ./components/customiser/helpers/index.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var getStepActiveIndexFromQuery = function(queryStep) {
    var step = Array.isArray(queryStep) ? queryStep[0] : queryStep;
    var stepAsNumber = parseInt(step, 10);
    if (!stepAsNumber) return 0;
    return stepAsNumber;
};
var getFormDefaultValues = function(form, formState, customFormStateKey) {
    var formFields = Object.values(form);
    var formDefaultValues = formFields.reduce(function(acc, formField) {
        return _objectSpread({}, acc, _defineProperty({}, formField.name, formState ? formState[formField.name] : formField.defaultValue));
    }, {});
    // Some values of the form state are grouped by a custom key and nested
    // and need to be accessed via that key
    return customFormStateKey ? formDefaultValues[customFormStateKey] : formDefaultValues;
};
var getFontStylesFeaturesGroups = function(fontStyles) {
    var fontStylesFeaturesGroups = fontStyles.reduce(function(acc, fontStyleCart) {
        if (!fontStyleCart.fondue.featuresGroups) return acc;
        return _toConsumableArray(acc).concat(_toConsumableArray(fontStyleCart.fondue.featuresGroups));
    }, []);
    return fontStylesFeaturesGroups;
};
// ensure only unique features across all font styles returned
var getFontStylesFeaturesGroupsWithUniqueFeaturesOnly = function(featureGroups) {
    var fontStylesFeaturesGroupsWithUniqueFeaturesOnly = featureGroups.reduce(function(acc, featureGroup) {
        if (!featureGroup.features) return acc;
        var featureGroupNameAsSlug = featureGroup.name.toLowerCase().replace(" ", "-");
        var features = acc[featureGroupNameAsSlug] ? _toConsumableArray(acc[featureGroupNameAsSlug].features).concat(_toConsumableArray(featureGroup.features)) : _toConsumableArray(featureGroup.features);
        var uniqueFeatures = Array.from(new Set(features.map(function(feature) {
            return feature.tag;
        }))).map(function(tag) {
            return features.find(function(feature) {
                return feature.tag === tag;
            });
        });
        return _objectSpread({}, acc, _defineProperty({}, featureGroupNameAsSlug, {
            name: featureGroup.name,
            features: Array.from(uniqueFeatures)
        }));
    }, {});
    return fontStylesFeaturesGroupsWithUniqueFeaturesOnly;
};
// Get groupings if they're provided
// Ref: AddTypefaceToCart.tsx and variantGroupings
// We have to treat this differently as font bases don't match what is being shown in the cart
// following conversation with MG.
var getFontBases = function(fontStyles) {
    var fontBases = fontStyles.reduce(function(acc, fontStyle) {
        var ref;
        var fontStyleBase = (ref = fontStyle === null || fontStyle === void 0 ? void 0 : fontStyle.metadata.find(function(metadata) {
            return metadata.key === "base";
        })) === null || ref === void 0 ? void 0 : ref.value;
        if (!fontStyleBase) return acc;
        var fontStyleBaseLowerCase = fontStyleBase.toLowerCase();
        if (acc.includes(fontStyleBaseLowerCase)) return acc;
        return _toConsumableArray(acc).concat([
            fontStyleBaseLowerCase
        ]);
    }, []);
    return fontBases;
};
var getFontStylesVariableAxes = function(fontStyles) {
    var fontStylesVariableAxes = fontStyles.reduce(function(acc, fontStyle) {
        var fontStyleIsVariable = fontStyle.fondue.isVariable;
        var fontStyleVariableAxes = fontStyleIsVariable ? fontStyle.fondue.variable.axes : [];
        return _toConsumableArray(acc).concat(_toConsumableArray(fontStyleVariableAxes));
    }, []);
    var uniqueFontStylesVariableAxes = Array.from(new Map(fontStylesVariableAxes.map(function(fontAxes) {
        return [
            fontAxes.id,
            fontAxes
        ];
    })).values());
    return uniqueFontStylesVariableAxes;
};
// Format fontStyles data to be grouped by base style
var getFontStylesByBase = function(fontStyles, fontBases) {
    var fontStylesVariableAxes = getFontStylesVariableAxes(fontStyles);
    var fontStylesByBases = fontBases.reduce(function(acc, fontBase) {
        var fontBaseSlug = fontBase.toLowerCase().replace(" ", "-").trim();
        var fontStylesByBase = fontStyles.filter(function(fontStyle) {
            var ref;
            var fontStyleBase = (ref = fontStyle === null || fontStyle === void 0 ? void 0 : fontStyle.metadata.find(function(metadata) {
                return metadata.key === "base";
            })) === null || ref === void 0 ? void 0 : ref.value;
            if (!fontStyleBase) return false;
            return fontBase.toLowerCase() === fontStyleBase.toLowerCase();
        });
        return _objectSpread({}, acc, _defineProperty({}, fontBaseSlug, {
            name: fontBase,
            slug: fontBaseSlug,
            styles: fontStylesByBase,
            axes: fontStylesVariableAxes
        }));
    }, {});
    return fontStylesByBases;
};
var getFontStylesByTypeByVersion = function(fontStyles) {
    return fontStyles.reduce(function(acc, fontStyle) {
        // Type
        var fontStyleType = fontStyle.fondue.isVariable ? "variable" : "static";
        // Version
        var fontStyleVersion = fontStyle.sku.match(/-pro$/) ? "pro" : "std";
        // Accumulator by version
        var fontStyleByVersion = _defineProperty({}, fontStyleVersion, acc[fontStyleType] && acc[fontStyleType][fontStyleVersion] ? _toConsumableArray(acc[fontStyleType][fontStyleVersion]).concat([
            fontStyle
        ]) : [
            fontStyle
        ]);
        // Accumulator by type, by version
        var fontStyleByTypeByVersion = _defineProperty({}, fontStyleType, acc[fontStyleType] ? _objectSpread({}, acc[fontStyleType], fontStyleByVersion) : _objectSpread({}, fontStyleByVersion));
        return _objectSpread({}, acc, fontStyleByTypeByVersion);
    }, {});
};
// Try to return the "best" layout features
// ref: https://github.com/Wakamai-Fondue/wakamai-fondue-site/blob/master/src/components/report/FeatureControls.js#L22
var getFeatureChars = function(font) {
    if (!font.featureChars) return {};
    if ("DFLT" in font.featureChars && "dflt" in font.featureChars["DFLT"]) {
        return font.featureChars["DFLT"]["dflt"];
    } else if ("latn" in font.featureChars && "dflt" in font.featureChars["latn"]) {
        return font.featureChars["latn"]["dflt"];
    } else if (Object.keys(font.featureChars).length > 0) {
        // If all else fails, return first
        var first = Object.keys(font.featureChars)[0];
        return Object.values(font.featureChars[first])[0];
    } else {
        return {};
    }
};
var getFeatureGroupFeaturesByFeatureChars = function(featureChars) {
    return function(features) {
        var featureGroupFeatures = features.reduce(function(acc, feature) {
            if (!featureChars[feature.tag]) return acc;
            if (!featureChars[feature.tag]["lookups"].length) return acc;
            var chars = featureChars[feature.tag]["lookups"].map(function(lookup) {
                return {
                    type: lookup.type,
                    typeName: lookup.typeName,
                    chars: lookup.input
                };
            });
            return _toConsumableArray(acc).concat([
                _objectSpread({}, feature, {
                    chars: chars
                })
            ]);
        }, []);
        return featureGroupFeatures;
    };
};
var filterFontStylesByBaseAndVersionAndType = function(fontStyles, fontBase, fontVersion) {
    var fontStylesByVersionAndType = fontStyles.reduce(function(acc, fontStyle) {
        var isVariable = fontStyle.fondue.isVariable;
        var baseMetadata = fontStyle === null || fontStyle === void 0 ? void 0 : fontStyle.metadata.find(function(param) {
            var key = param.key;
            return key === "base";
        });
        var version = fontStyle.sku.match(/-pro$/) ? "pro" : "std";
        var base = baseMetadata === null || baseMetadata === void 0 ? void 0 : baseMetadata.value.toLowerCase();
        if (isVariable || base !== fontBase || version !== fontVersion) return acc;
        return _toConsumableArray(acc).concat([
            {
                fondue: {
                    summary: {
                        "Font subfamily": fontStyle.fondue.summary["Font subfamily"]
                    },
                    meta: {
                        path: fontStyle.fondue.meta.path
                    }
                }
            }
        ]);
    }, []);
    return fontStylesByVersionAndType;
};
var getFontAxesMidValue = function(fontAxes) {
    return Math.round(fontAxes.min + (fontAxes.max - fontAxes.min) / 2);
};

// EXTERNAL MODULE: ./lib/regions.ts
var regions = __webpack_require__(85567);
// EXTERNAL MODULE: ./lib/aws/client.ts
var client = __webpack_require__(14353);
// EXTERNAL MODULE: ./lib/customiser/getIgnoredProperties.ts
var getIgnoredProperties = __webpack_require__(61702);
// EXTERNAL MODULE: ./lib/fonts/variantName.ts
var variantName = __webpack_require__(27562);
// EXTERNAL MODULE: ./lib/isUniq.ts
var isUniq = __webpack_require__(51595);
;// CONCATENATED MODULE: ./lib/util.tsx
function util_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function util_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return util_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function util_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function util_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function util_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function util_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            util_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function util_toConsumableArray(arr) {
    return util_arrayWithoutHoles(arr) || util_iterableToArray(arr) || util_unsupportedIterableToArray(arr) || util_nonIterableSpread();
}
function util_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return util_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return util_arrayLikeToArray(o, minLen);
}








var formatAsMoney = function() {
    var amount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, currency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : regions/* DEFAULT_LOCALE */.ZW;
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(amount);
};
// Returns true for non nullable values
function notNullable(value) {
    return value !== null && value !== undefined;
}
var pluralize = function(count, noun) {
    var suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    return "".concat(count, " ").concat(noun).concat(count !== 1 ? suffix : "");
};
var isBrowser = "object" !== "undefined";
var inputFieldValidation = {
    emailFormat: {
        pattern: {
            value: /\S+@\S+\.\S+/,
            message: "\u24D8 Entered value does not match email format"
        }
    }
};
// can get a list of conditional errors
// only the first existing error
// (ignores false and null)
var formErrorParser = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$err = _step.value;
            if (_$err) return _$err;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var fontDisplayAttribute = function(attributes) {
    var ref;
    var attributeData = attributes === null || attributes === void 0 ? void 0 : attributes.find(function(attribute) {
        return attribute.attribute.slug === "display-font";
    });
    return (attributeData === null || attributeData === void 0 ? void 0 : (ref = attributeData.values) === null || ref === void 0 ? void 0 : ref.length) > 0 ? attributeData.values[0].name.toLowerCase() : null;
};
var getFontVersion = function(variants) {
    var firstVariant = variants[0];
    var firstVariantSku = firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku;
    var skuIsPro = firstVariantSku.endsWith("pro");
    return skuIsPro ? "pro" : "std";
};
var entitify = function(code) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: "&#x".concat(code, ";")
        }
    });
};
var convertSnakeToCamelCase = function(str) {
    return str.replace(/-([a-z])/g, function(x, up) {
        return up.toUpperCase();
    });
};
var characterToHex = function(str) {
    if (!str) return;
    var hex, result = "";
    for(var i = 0; i < str.length; i++){
        hex = str.charCodeAt(i).toString(16);
        result += ("000" + hex).slice(-4);
    }
    return result;
};
var capitalizeFirstLetter = function(string) {
    var input = string.replace(/\W/g, "");
    return input.charAt(0).toUpperCase() + input.slice(1);
};
var updateFontsToWebfont = function(param) {
    var font = param.font, _extension = param.extension, extension = _extension === void 0 ? ".woff2" : _extension;
    return "/".concat(font).replace(".ttf", extension).replace(".otf", extension);
};
var onlyFontsInCart = function(checkout) {
    return checkout.lines.every(function(line) {
        var ref, ref1, ref2;
        var isTypeface = (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productType) === null || ref2 === void 0 ? void 0 : ref2.slug) === "font-family";
        return isTypeface;
    });
};
// TEMP: Due to Saleor bug, multiples of the same variant cannot be purchased in the same cart
var isVariantInCart = function(checkout) {
    return function(variantSku) {
        return false;
        if (!checkout || !(checkout === null || checkout === void 0 ? void 0 : checkout.lines) || (checkout === null || checkout === void 0 ? void 0 : checkout.lines.length) === 0) return false;
        return checkout.lines.some(function(line) {
            var ref, ref3, ref4, ref5;
            var isTypeface = (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref3 = ref.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.productType) === null || ref4 === void 0 ? void 0 : ref4.slug) === "font-family";
            return isTypeface ? (line === null || line === void 0 ? void 0 : (ref5 = line.variant) === null || ref5 === void 0 ? void 0 : ref5.sku.replace(/-pro$/, "")) === variantSku.replace(/-pro$/, "") : false;
        });
    };
};
// Format the font data so we can separate the pro/std versions
var formatAwsS3FontData = function(awsS3FontData) {
    var awsS3fontDataFormatted = awsS3FontData.reduce(function(acc, variantFontStyle) {
        var variantFontStyleSkuWithoutVersion = variantFontStyle.sku.replace(/-pro$/, "");
        var skuIsPro = variantFontStyle.sku.endsWith("pro");
        acc[variantFontStyleSkuWithoutVersion] = {
            name: (0,variantName/* default */.Z)(variantFontStyle),
            versions: acc[variantFontStyleSkuWithoutVersion] ? util_toConsumableArray(acc[variantFontStyleSkuWithoutVersion].versions).concat([
                util_objectSpread({}, variantFontStyle, {
                    version: skuIsPro ? "pro" : "std"
                })
            ]) : [
                util_objectSpread({}, variantFontStyle, {
                    version: skuIsPro ? "pro" : "std"
                })
            ]
        };
        return acc;
    }, {});
    return awsS3fontDataFormatted;
};
var generateAwsFontDataPromise = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(fontStyle) {
        var hasFeatureGroups, fontStyleFamilyName, skuIsPro, fontStyleSkuWithoutVersion, awsPath, params, awsS3FontData, features, ignoredFeatures, featuresWithoutIgnoredFeatures, featureChars, getFeatureGroupFeatures, featuresStylisticSets, featuresCharacterVariants, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    hasFeatureGroups = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    if (fontStyle) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 3:
                    fontStyleFamilyName = fontStyle.product.slug;
                    skuIsPro = fontStyle.sku.endsWith("pro");
                    fontStyleSkuWithoutVersion = fontStyle.sku.replace(/-pro$/, "");
                    awsPath = "".concat(fontStyleFamilyName, "/").concat(fontStyleSkuWithoutVersion);
                    params = {
                        properties: "slug,isVariable,variable,features,featureChars,categorisedCharacters,summary",
                        version: skuIsPro ? "pro" : "std"
                    };
                    _ctx.next = 10;
                    return client/* AWSClient.fontData */.k.fontData("fondue", {
                        params: params,
                        pathAppend: awsPath
                    });
                case 10:
                    awsS3FontData = _ctx.sent;
                    features = awsS3FontData.features;
                    ignoredFeatures = (0,getIgnoredProperties/* getIgnoredOpentype */.gi)(fontStyle, {
                        isCustomiser: true
                    });
                    featuresWithoutIgnoredFeatures = features.filter(function(feature) {
                        return !ignoredFeatures.includes(feature.tag);
                    });
                    featureChars = getFeatureChars(awsS3FontData);
                    getFeatureGroupFeatures = getFeatureGroupFeaturesByFeatureChars(featureChars);
                    featuresStylisticSets = featuresWithoutIgnoredFeatures ? featuresWithoutIgnoredFeatures.filter(function(feature) {
                        var ref;
                        return feature === null || feature === void 0 ? void 0 : (ref = feature.name) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes("stylistic set");
                    }) : [];
                    featuresCharacterVariants = featuresWithoutIgnoredFeatures ? featuresWithoutIgnoredFeatures.filter(function(feature) {
                        var ref;
                        return feature === null || feature === void 0 ? void 0 : (ref = feature.name) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes("character variants");
                    }) : [];
                    return _ctx.abrupt("return", util_objectSpread({}, fontStyle, {
                        fondue: util_objectSpread({}, awsS3FontData, {
                            isVariable: awsS3FontData.isVariable || null,
                            variable: awsS3FontData.variable || null
                        }, hasFeatureGroups && {
                            featuresGroups: [
                                {
                                    name: "Stylistic Sets",
                                    features: getFeatureGroupFeatures(featuresStylisticSets)
                                },
                                {
                                    name: "Character Variants",
                                    features: getFeatureGroupFeatures(featuresCharacterVariants)
                                }
                            ]
                        })
                    }));
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function generateAwsFontDataPromise(fontStyle) {
        return _ref.apply(this, arguments);
    };
}();
var slugify = function(str) {
    return str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
};
var getVersionScripts = function(selectedVersion) {
    var ref, ref6, ref7;
    return selectedVersion ? (0,isUniq/* default */.Z)((ref7 = selectedVersion === null || selectedVersion === void 0 ? void 0 : (ref = selectedVersion.fondue) === null || ref === void 0 ? void 0 : (ref6 = ref.categorisedCharacters) === null || ref6 === void 0 ? void 0 : ref6.map(function(character) {
        return character.script;
    })) === null || ref7 === void 0 ? void 0 : ref7.filter(function(script) {
        return script !== null;
    })) : [];
};
function isNumeric(value) {
    return /^-?\d+$/.test(value);
}
// Function to remove accents from letter https://stackoverflow.com/a/37511463
function normalize(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
var getMaxUsageApplies = function(maxUsageValues, optionItem, multipliers, updatedLicences) {
    var isValid = false;
    // validating when updateSelectedLicences
    if (!optionItem && updatedLicences) {
        var includedLicences = updatedLicences.map(function(l) {
            return l.name;
        });
        var includedMultipliers = multipliers.filter(function(m) {
            return(// Validate if any of the selected multipliers
            // are exceeding the limit
            includedLicences.includes(m.licenceName) && maxUsageValues.includes(m.licenceMultiplierName));
        });
        if (includedMultipliers.length > 0) isValid = true;
        return isValid;
    }
    var item = JSON.parse(optionItem.value);
    if (maxUsageValues.includes(optionItem.text)) return true;
    if (multipliers) {
        for(var i = 0; i < multipliers.length; i++){
            var multiplier = multipliers[i];
            // check if is multiplier max usage
            // and if its an update to an existing license
            if (maxUsageValues.includes(multiplier.licenceMultiplierName) && multiplier.licenceVariant !== item.licenceVariant) {
                isValid = true;
                break;
            }
        }
    }
    return isValid;
};
var addZeroes = function(num) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return num.toFixed(precision);
};
function round(value) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var multiplier = Math.pow(10, precision);
    return Math.round(value * multiplier) / multiplier;
}


/***/ }),

/***/ 53728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getCountryVatCode; }
/* harmony export */ });
var getCountryVatCode = function(code) {
    var countryToVatCodeMap = {
        GR: "EL"
    };
    return countryToVatCodeMap[code] || code;
};


/***/ }),

/***/ 20474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(85170));
var _head = _interopRequireDefault(__webpack_require__(76095));
var _imageConfig = __webpack_require__(86393);
var _useIntersection = __webpack_require__(31442);
var _imageConfigContext = __webpack_require__(67293);
var _utils = __webpack_require__(25994);
var _normalizeTrailingSlash = __webpack_require__(87052);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "200px" : _lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _loader = _param.loader, loader = _loader === void 0 ? defaultImageLoader : _loader, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutProperties(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "loader",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _objectSpread({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread into image:
        delete rest["layout"];
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary,
        disabled: !isLazy
    }), 2), setIntersection = ref1[0], isIntersected = ref1[1];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    if (false) {}
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layout === "raw" ? {
        aspectRatio: "".concat(widthInt, " / ").concat(heightInt)
    } : layoutStyle);
    var blurStyle = placeholder === "blur" ? {
        filter: "blur(20px)",
        backgroundSize: objectFit || "cover",
        backgroundImage: 'url("'.concat(blurDataURL, '")'),
        backgroundPosition: objectPosition || "0% 0%"
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var imgRef = (0, _react).useRef(null);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        setIntersection(imgRef.current);
    }, [
        setIntersection
    ]);
    (0, _react).useEffect(function() {
        handleLoading(imgRef, srcString, layout, placeholder, onLoadingCompleteRef);
    }, [
        srcString,
        layout,
        placeholder,
        isVisible
    ]);
    var imgElementArgs = _objectSpread({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        imgRef: imgRef,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, layout === "raw" ? /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)) : /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref;
var experimentalLayoutRaw = (ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false}) === null || ref === void 0 ? void 0 : ref.experimentalLayoutRaw;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    "raw",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive" || layout === "raw")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref2 = getWidths(config, width, layout, sizes), widths = ref2.widths, kind = ref2.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref2;
    var loaderKey = ((ref2 = loaderProps.config) === null || ref2 === void 0 ? void 0 : ref2.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(imgRef, src, layout, placeholder, onLoadingCompleteRef) {
    var handleLoad = function() {
        var img = imgRef.current;
        if (!img) {
            return;
        }
        if (img.src !== emptyDataURL) {
            var p = "decode" in img ? img.decode() : Promise.resolve();
            p.catch(function() {}).then(function() {
                if (!imgRef.current) {
                    return;
                }
                loadedImageURLs.add(src);
                if (placeholder === "blur") {
                    img.style.filter = "";
                    img.style.backgroundSize = "";
                    img.style.backgroundImage = "";
                    img.style.backgroundPosition = "";
                }
                if (onLoadingCompleteRef.current) {
                    var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
                    // Pass back read-only primitive values but not the
                    // underlying DOM element because it could be misused.
                    onLoadingCompleteRef.current({
                        naturalWidth: naturalWidth,
                        naturalHeight: naturalHeight
                    });
                }
                if (false) { var parent, ref3; }
            });
        }
    };
    if (imgRef.current) {
        if (imgRef.current.complete) {
            // If the real image fails to load, this will still remove the placeholder.
            // This is the desired behavior for now, and will be revisited when error
            // handling is worked on for the image component itself.
            handleLoad();
        } else {
            imgRef.current.onload = handleLoad;
        }
    }
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, imgRef = _param.imgRef, placeholder = _param.placeholder, loading = _param.loading, sizes = _param.sizes, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, rest = _objectWithoutProperties(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "imgRef",
        "placeholder",
        "loading",
        "sizes",
        "srcString",
        "config",
        "unoptimized",
        "loader"
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, layout === "raw" && !sizes ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        ref: imgRef,
        style: _objectSpread({}, imgStyle, blurStyle)
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    }), layout === "raw" && !sizes ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading || "lazy"
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 87647:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(85170));
var _router = __webpack_require__(43411);
var _router1 = __webpack_require__(78318);
var _useIntersection = __webpack_require__(31442);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === "object" && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === "function") {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return /*#__PURE__*/ _react.default.cloneElement(child, childProps);
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 31442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(85170);
var _requestIdleCallback = __webpack_require__(83039);
var hasIntersectionObserver = typeof IntersectionObserver !== "undefined";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 66165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = dynamic;
__webpack_unused_export__ = noSSR;
var _react = _interopRequireDefault(__webpack_require__(85170));
var _loadable = _interopRequireDefault(__webpack_require__(86688));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === "boolean") {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 29262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(85170));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 86688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(85170));
var _useSubscription = __webpack_require__(66902);
var _loadableContext = __webpack_require__(29262);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined" && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 1629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(87142);
// EXTERNAL MODULE: ./styles/globals.scss
var styles_globals = __webpack_require__(45892);
// EXTERNAL MODULE: ./styles/colours.css
var colours = __webpack_require__(79260);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var utilities_globals = __webpack_require__(93663);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(41660);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,utilities_globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,utilities_globals/* invariant */.kG)(context.client, 26);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/logrocket@4.0.0/node_modules/logrocket/dist/build.umd.js
var build_umd = __webpack_require__(65819);
var build_umd_default = /*#__PURE__*/__webpack_require__.n(build_umd);
// EXTERNAL MODULE: ./node_modules/.pnpm/logrocket-react@5.0.1_vw3iafyr25wt2pplc27c4fxnu4/node_modules/logrocket-react/dist/index.js
var dist = __webpack_require__(49420);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/head.js
var head = __webpack_require__(23087);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/script.js
var script = __webpack_require__(31021);
// EXTERNAL MODULE: ./components/index.ts + 27 modules
var components = __webpack_require__(94842);
// EXTERNAL MODULE: ./components/global/Toast/index.tsx + 16 modules
var Toast = __webpack_require__(81530);
// EXTERNAL MODULE: ./components/providers/AddressValidationProvider.tsx
var AddressValidationProvider = __webpack_require__(5303);
// EXTERNAL MODULE: ./components/providers/CheckoutProvider.tsx + 2 modules
var CheckoutProvider = __webpack_require__(34639);
// EXTERNAL MODULE: ./components/providers/HeaderThemeProvider.tsx
var HeaderThemeProvider = __webpack_require__(13657);
// EXTERNAL MODULE: ./components/providers/RegionsProvider.tsx + 10 modules
var RegionsProvider = __webpack_require__(60239);
// EXTERNAL MODULE: ./components/providers/SiteTickerProvider.tsx
var SiteTickerProvider = __webpack_require__(79771);
// EXTERNAL MODULE: ./components/providers/TypefaceProvider.tsx
var TypefaceProvider = __webpack_require__(49717);
// EXTERNAL MODULE: ./lib/auth/index.ts + 1 modules
var auth = __webpack_require__(9714);
// EXTERNAL MODULE: ./lib/auth/SaleorAuthProvider.tsx
var SaleorAuthProvider = __webpack_require__(36739);
// EXTERNAL MODULE: ./lib/auth/useApolloClient.ts + 54 modules
var useApolloClient = __webpack_require__(65630);
// EXTERNAL MODULE: ./lib/auth/SaleorAuthClient.ts + 2 modules
var SaleorAuthClient = __webpack_require__(84817);
;// CONCATENATED MODULE: ./lib/auth/useSaleorAuthClient.ts


/**
 * This hook should be used only once per application.
 * @see Use {@link useSaleorAuthContext} for accessing the auth state.
 */ var useSaleorAuthClient = function(param) {
    var saleorApiUrl = param.saleorApiUrl, storage = param.storage, onAuthRefresh = param.onAuthRefresh;
    var ref = (0,react.useState)(false), isAuthenticating = ref[0], setIsAuthenticating = ref[1];
    var saleorAuthClient = (0,react.useMemo)(function() {
        return new SaleorAuthClient/* SaleorAuthClient */.x({
            storage: storage,
            saleorApiUrl: saleorApiUrl,
            onAuthRefresh: function(value) {
                setIsAuthenticating(value);
                onAuthRefresh === null || onAuthRefresh === void 0 ? void 0 : onAuthRefresh(value);
            }
        });
    }, [
        storage,
        saleorApiUrl,
        onAuthRefresh
    ]);
    (0,react.useEffect)(function() {
        return function() {
            saleorAuthClient.cleanup();
        };
    }, []);
    return {
        saleorAuthClient: saleorAuthClient,
        isAuthenticating: isAuthenticating
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@bugsnag+js@7.18.0/node_modules/@bugsnag/js/browser/notifier.js
var notifier = __webpack_require__(31832);
var notifier_default = /*#__PURE__*/__webpack_require__.n(notifier);
;// CONCATENATED MODULE: ./lib/bugsnag.js
/* provided dependency */ var process = __webpack_require__(6436);

function start() {
    // next.js executes top-level code at build time. See https://github.com/vercel/next.js/discussions/16840 for further example
    // So use NEXT_PHASE to avoid Bugsnag.start being executed during the build phase
    // See https://nextjs.org/docs/api-reference/next.config.js/introduction and https://github.com/vercel/next.js/blob/canary/packages/next/shared/lib/constants.ts#L1-L5 for
    // more details on NEXT_PHASE
    if (process.env.NEXT_PHASE !== "phase-production-build") {
        if (process.env.NEXT_IS_SERVER === true) {
            notifier_default().start({
                apiKey: "d198995c7b8b9d15d0d499979c5dbcbd",
                appVersion: process.env.NEXT_BUILD_ID,
                // @bugsnag/plugin-aws-lambda must only be imported on the server
                plugins: [
                    __webpack_require__(84672)
                ]
            });
        } else {
            // If preferred two separate Bugsnag projects e.g. a javascript and a node project could be used rather than a single one
            notifier_default().start({
                apiKey: "d198995c7b8b9d15d0d499979c5dbcbd",
                appVersion: process.env.NEXT_BUILD_ID,
                plugins: []
            });
        }
    }
}
function getServerlessHandler() {
    return Bugsnag.getPlugin("awsLambda").createHandler();
}

// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
;// CONCATENATED MODULE: ./pages/_app.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


























start();
if ( true && constants/* LOGROCKET_ID */.BA) {
    build_umd_default().init(constants/* LOGROCKET_ID */.BA);
    dist_default()((build_umd_default()));
}
var MyApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps, err = param.err;
    var _getLayout;
    var getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
        return page;
    };
    var uri = "https://colophon-prod.eu.saleor.cloud/graphql/";
    var awsUri = "https://api.prod.colophon-foundry.org";
    var hostname = new URL(uri).hostname;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), showLoader = ref[0], setShowLoader = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), sessionExpired = ref2[0], setSessionExpired = ref2[1];
    var useSaleorAuthClientProps = useSaleorAuthClient({
        saleorApiUrl: "https://colophon-prod.eu.saleor.cloud/graphql/",
        storage:  true ? window.localStorage : 0
    });
    var saleorAuthClient = useSaleorAuthClientProps.saleorAuthClient;
    var ref3 = (0,useApolloClient/* useApolloClient */.x)(saleorAuthClient.fetchWithAuth), apolloClient = ref3.apolloClient, resetClient = ref3.resetClient;
    var handleExpiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return resetClient();
                    case 2:
                        setSessionExpired(true);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleExpiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleExpiryToastClose = function() {
        // document.body.classList.remove('ReactModal__Body--open');
        setSessionExpired(false);
        router.push({
            pathname: "/"
        });
    };
    (0,auth/* useAuthChange */.SQ)({
        onSignedOut: function() {
            return resetClient();
        },
        onExpiry: function() {
            return handleExpiry();
        },
        onSignedIn: function() {
            return resetClient();
        }
    });
    (0,react.useEffect)(function() {
        var handleStart = function(url) {
            if (error) {
                setError(false);
                return;
            }
            setShowLoader(true);
        };
        var handleStop = function(url) {
            setShowLoader(false);
        };
        var handleError = function() {
            setShowLoader(false);
            setError(true);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleStop);
        router.events.on("routeChangeError", handleError);
        return function() {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleStop);
            router.events.off("routeChangeError", handleError);
        };
    }, [
        setShowLoader,
        router,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#da532c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#000000"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "//".concat(hostname),
                        crossOrigin: "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: awsUri,
                        crossOrigin: "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "dns-prefetch",
                        href: "//".concat(hostname)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "dns-prefetch",
                        href: awsUri
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: "/fonts/CFBasis-Regular.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: "/fonts/CFBasisMonoPro-Regular.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: ""
                    })
                ]
            }),
            constants/* GA_4_TRACKING_ID */.AC && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(constants/* GA_4_TRACKING_ID */.AC)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                        id: "GA4",
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', ".concat(constants/* GA_4_TRACKING_ID */.AC, ", { 'anonymize_ip': true });\n              ")
                        }
                    })
                ]
            }),
            constants/* GTM_TRACKING_ID */.$N && /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                id: "GTM",
                strategy: "afterInteractive",
                onLoad: function() {
                    build_umd_default().getSessionURL(function(sessionURL) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "add_to_cart",
                            eventCategory: "LogRocket",
                            eventAction: sessionURL
                        });
                    });
                },
                dangerouslySetInnerHTML: {
                    __html: "\n                (function(w,d,s,l,i){w[l]=w[l] || [];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer','".concat(constants/* GTM_TRACKING_ID */.$N, "');\n                  ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleorAuthProvider/* SaleorAuthProvider */.s, _objectSpread({}, useSaleorAuthClientProps, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
                    client: apolloClient,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteTickerProvider/* SiteTickerProvider */.Jh, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderThemeProvider/* HeaderThemeProvider */.AD, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutProvider/* CheckoutProvider */.oo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressValidationProvider/* AddressValidationProvider */.FS, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionsProvider/* default */.ZP, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TypefaceProvider/* TypefaceProvider */.Vi, {
                                            children: [
                                                showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Spinner */.$j, {
                                                    theme: "white"
                                                }),
                                                sessionExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ExpiredToast */.vu, {
                                                    successToastAction: handleExpiryToastClose
                                                }),
                                                getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, pageProps, {
                                                    err: err
                                                })))
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 67062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MI8": function() { return /* binding */ ProductByIdDocument; },
  "TeI": function() { return /* binding */ ProductCollectionDocument; },
  "NU$": function() { return /* binding */ useAccountDeleteMutation; },
  "WeI": function() { return /* binding */ useAccountRegisterMutation; },
  "EKp": function() { return /* binding */ useAddressValidationRulesQuery; },
  "$0i": function() { return /* binding */ useCheckoutAddProductLineMutation; },
  "mT3": function() { return /* binding */ useCheckoutAddPromoCodeMutation; },
  "nci": function() { return /* binding */ useCheckoutBillingAddressUpdateMutation; },
  "KEu": function() { return /* binding */ useCheckoutByTokenQuery; },
  "ODL": function() { return /* binding */ useCheckoutCompleteMutation; },
  "Oux": function() { return /* binding */ useCheckoutEmailUpdateMutation; },
  "mLW": function() { return /* binding */ useCheckoutLineUpdateMutation; },
  "HBn": function() { return /* binding */ useCheckoutPaymentCreateMutation; },
  "NMd": function() { return /* binding */ useCheckoutRemovePromoCodeMutation; },
  "Ehv": function() { return /* binding */ useCheckoutShippingAddressUpdateMutation; },
  "QQP": function() { return /* binding */ useCheckoutShippingMethodUpdateMutation; },
  "pCg": function() { return /* binding */ useConfirmAccountMutation; },
  "p2M": function() { return /* binding */ useConfirmEmailChangeMutation; },
  "F9n": function() { return /* binding */ useCreateCheckoutMutation; },
  "Mcz": function() { return /* binding */ useCurrentUserAddressesQuery; },
  "pXK": function() { return /* binding */ useCustomiserCollectionLazyQuery; },
  "bRA": function() { return /* binding */ useOrderDetailsByTokenQuery; },
  "Oa5": function() { return /* binding */ usePasswordChangeMutation; },
  "fW$": function() { return /* binding */ useProductBySlugQuery; },
  "a3X": function() { return /* binding */ useProductCollectionQuery; },
  "Sb_": function() { return /* binding */ useRemoveProductFromCheckoutMutation; },
  "X6T": function() { return /* binding */ useRequestAccountDeleteMutation; },
  "gns": function() { return /* binding */ useRequestEmailChangeMutation; },
  "PwH": function() { return /* binding */ useRequestPasswordResetMutation; },
  "Ttb": function() { return /* binding */ useSetPasswordMutation; },
  "oHg": function() { return /* binding */ useTypefaceCollectionLazyQuery; },
  "bTj": function() { return /* binding */ useUserQuery; }
});

// UNUSED EXPORTS: AccountDeleteDocument, AccountRegisterDocument, AddressDeleteDocument, AddressDetailsFragmentDoc, AddressSetDefaultDocument, AddressValidationRulesDocument, AttributeDataDocument, AttributeDetailsFragmentDoc, AvailableShippingMethodsDocument, CategoryBasicFragmentDoc, CategoryBySlugDocument, CategoryDetailsFragmentDoc, CategoryPathsDocument, CheckoutAddProductLineDocument, CheckoutAddPromoCodeDocument, CheckoutBillingAddressUpdateDocument, CheckoutByTokenDocument, CheckoutCompleteDocument, CheckoutCustomerAttachDocument, CheckoutCustomerDetachDocument, CheckoutDetailsFragmentDoc, CheckoutEmailUpdateDocument, CheckoutLineDetailsFragmentDoc, CheckoutLineUpdateDocument, CheckoutPaymentCreateDocument, CheckoutRemovePromoCodeDocument, CheckoutShippingAddressUpdateDocument, CheckoutShippingMethodUpdateDocument, CollectionBasicFragmentDoc, CollectionBySlugDocument, CollectionDetailsFragmentDoc, CollectionPathsDocument, ConfirmAccountDocument, ConfirmEmailChangeDocument, CreateCheckoutDocument, CurrentUserAddressesDocument, CurrentUserDetailsDocument, CustomiserAttributeFragmentDoc, CustomiserCollectionDocument, CustomiserProductByIdDocument, CustomiserProductCardFragmentDoc, CustomiserProductDetailsFragmentDoc, DeliveryMethodFragmentDoc, ErrorDetailsFragmentDoc, FontDataProductBySlugDocument, FontProductDetailsFragmentDoc, FontProductVariantDetailsFragmentDoc, HomepageBlockFragmentDoc, HomepageBlocksQueryDocument, ImageFragmentDoc, MainMenuDocument, MenuItemFragmentDoc, OrderDetailsByTokenDocument, OrderDetailsFragmentDoc, OrderDetailsQueryDocument, OrdersDocument, PageDocument, PageInfoFragmentDoc, PagePathsDocument, PasswordChangeDocument, PriceFragmentDoc, ProductBySlugDocument, ProductCardFragmentDoc, ProductCardFragmentLightFragmentDoc, ProductDetailsFragmentDoc, ProductDropdownFragmentDoc, ProductFontsDropdownDocument, ProductMediaFragmentDoc, ProductPathsDocument, ProductVariantByIdDocument, ProductVariantDetailsFragmentDoc, RemoveProductFromCheckoutDocument, RequestAccountDeleteDocument, RequestEmailChangeDocument, RequestPasswordResetDocument, SelectedAttributeDetailsFragmentDoc, SetAddressDefaultDocument, SetPasswordDocument, TrialsProductsDocument, TypefaceCardFragmentDoc, TypefaceCollectionDocument, TypefaceProductPageQueryDocument, UpdateMetaDataDocument, UserDocument, useAddressDeleteMutation, useAddressSetDefaultMutation, useAddressValidationRulesLazyQuery, useAttributeDataLazyQuery, useAttributeDataQuery, useAvailableShippingMethodsLazyQuery, useAvailableShippingMethodsQuery, useCategoryBySlugLazyQuery, useCategoryBySlugQuery, useCategoryPathsLazyQuery, useCategoryPathsQuery, useCheckoutByTokenLazyQuery, useCheckoutCustomerAttachMutation, useCheckoutCustomerDetachMutation, useCollectionBySlugLazyQuery, useCollectionBySlugQuery, useCollectionPathsLazyQuery, useCollectionPathsQuery, useCurrentUserAddressesLazyQuery, useCurrentUserDetailsLazyQuery, useCurrentUserDetailsQuery, useCustomiserCollectionQuery, useCustomiserProductByIdLazyQuery, useCustomiserProductByIdQuery, useFontDataProductBySlugLazyQuery, useFontDataProductBySlugQuery, useHomepageBlocksQuery, useHomepageBlocksQueryLazyQuery, useMainMenuLazyQuery, useMainMenuQuery, useOrderDetailsByTokenLazyQuery, useOrderDetailsQuery, useOrderDetailsQueryLazyQuery, useOrdersLazyQuery, useOrdersQuery, usePageLazyQuery, usePagePathsLazyQuery, usePagePathsQuery, usePageQuery, useProductByIdLazyQuery, useProductByIdQuery, useProductBySlugLazyQuery, useProductCollectionLazyQuery, useProductFontsDropdownLazyQuery, useProductFontsDropdownQuery, useProductPathsLazyQuery, useProductPathsQuery, useProductVariantByIdLazyQuery, useProductVariantByIdQuery, useSetAddressDefaultMutation, useTrialsProductsLazyQuery, useTrialsProductsQuery, useTypefaceCollectionQuery, useTypefaceProductPageQuery, useTypefaceProductPageQueryLazyQuery, useUpdateMetaDataMutation, useUserLazyQuery

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.3.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(45512);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(34254);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(18158);
// EXTERNAL MODULE: ./node_modules/.pnpm/@wry+equality@0.5.3/node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(91735);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(93663);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/parser/index.js

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,globals/* invariant */.kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,globals/* invariant */.kG)(!!document && !!document.kind, 30);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 31);
    __DEV__ ? (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, 32);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,globals/* invariant */.kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(definitions.length === 1, 33);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,globals/* invariant */.kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,globals/* invariant */.kG)(operation.type === type, 34);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(85234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(42623);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useMutation.js







function useMutation(mutation, options) {
    var client = (0,useApolloClient/* useApolloClient */.x)(options === null || options === void 0 ? void 0 : options.client);
    verifyDocumentType(mutation, DocumentType.Mutation);
    var _a = (0,react.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,mergeOptions/* mergeOptions */.J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new client_errors/* ApolloError */.c({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,equality_esm/* equal */.D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_a = baseOptions.onCompleted) === null || _a === void 0 ? void 0 : _a.call(baseOptions, response.data);
            (_b = executeOptions.onCompleted) === null || _b === void 0 ? void 0 : _b.call(executeOptions, response.data);
            return response;
        }).catch(function (error) {
            var _a, _b;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,equality_esm/* equal */.D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (baseOptions.onError || clientOptions.onError) {
                (_a = baseOptions.onError) === null || _a === void 0 ? void 0 : _a.call(baseOptions, error);
                (_b = executeOptions.onError) === null || _b === void 0 ? void 0 : _b.call(executeOptions, error);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react.useCallback)(function () {
        setResult({ called: false, loading: false, client: client });
    }, []);
    (0,react.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib_es6/* __assign */.pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/use-sync-external-store@1.2.0_react@18.0.0/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(43893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(41660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(50804);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(91437);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(42457);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(15771);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useQuery.js











var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query) {
        this.client = client;
        this.query = query;
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.I.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.I.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        verifyDocumentType(query, DocumentType.Query);
    }
    InternalState.prototype.forceUpdate = function () {
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0,shim.useSyncExternalStore)((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,equality_esm/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,equality_esm/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.I.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return subscription.unsubscribe(); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0,equality_esm/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.observable.reobserve(watchQueryOptions);
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, displayName = _a.displayName, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6/* __rest */._T)(_a, ["skip", "ssr", "onCompleted", "onError", "displayName", "defaultOptions"]);
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (defaultOptions)
            toMerge.push(defaultOptions);
        var latestOptions = this.observable && this.observable.options;
        if (latestOptions && toMerge.length) {
            var defaults_1 = toMerge.reduce(mergeOptions/* mergeOptions */.J, Object.create(null));
            toMerge.length = 1;
            toMerge[0] = defaults_1;
            Object.keys(defaults_1).forEach(function (defaultOptionName) {
                var currentOptionValue = latestOptions[defaultOptionName];
                if (useQuery_hasOwnProperty.call(latestOptions, defaultOptionName) &&
                    !(0,equality_esm/* equal */.D)(defaults_1[defaultOptionName], currentOptionValue)) {
                    defaults_1[defaultOptionName] = defaultOptionName === "variables"
                        ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaults_1.variables), currentOptionValue) : currentOptionValue;
                }
            });
        }
        toMerge.push(otherOptions);
        var merged = toMerge.reduce(mergeOptions/* mergeOptions */.J, Object.create(null));
        var watchQueryOptions = Object.assign(merged, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (skip) {
            var _b = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? watchQueryOptions.fetchPolicy : _b;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        return watchQueryOptions;
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery((0,tslib_es6/* __assign */.pi)({}, this.watchQueryOptions));
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        if (this.renderPromises) {
            this.renderPromises.registerSSRObservable(obsQuery);
            var ssrAllowed = !(this.queryHookOptions.ssr === false ||
                this.queryHookOptions.skip);
            if (ssrAllowed && obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        if (!result.loading) {
            if (result.error) {
                this.onError(result.error);
            }
            else if (result.data) {
                this.onCompleted(result.data);
            }
        }
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6/* __rest */._T)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: true, previousData: this.previousData }));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            queryResult.error = new client_errors/* ApolloError */.c({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.I.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useLazyQuery.js






var EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore',
];
function useLazyQuery(query, options) {
    var internalState = useInternalState((0,useApolloClient/* useApolloClient */.x)(options && options.client), query);
    var execOptionsRef = (0,react.useRef)();
    var defaultOptions = internalState.client.defaultOptions.watchQuery;
    var initialFetchPolicy = (options && options.fetchPolicy) ||
        (execOptionsRef.current && execOptionsRef.current.fetchPolicy) ||
        (defaultOptions && defaultOptions.fetchPolicy) ||
        "cache-first";
    var useQueryResult = internalState.useQuery((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), execOptionsRef.current), { skip: !execOptionsRef.current }));
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    var eagerMethods = (0,react.useMemo)(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = (0,react.useCallback)(function (executeOptions) {
        var promise = result.reobserve(execOptionsRef.current = executeOptions ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
            fetchPolicy: initialFetchPolicy,
        }).then(function (apolloQueryResult) {
            apolloQueryResult = apolloQueryResult || internalState["getCurrentResult"]();
            if (apolloQueryResult.error ||
                (0,arrays/* isNonEmptyArray */.O)(apolloQueryResult.errors)) {
                var _a = result.observable.options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a;
                if (errorPolicy === "none") {
                    throw apolloQueryResult.error || new client_errors/* ApolloError */.c({
                        graphQLErrors: apolloQueryResult.errors,
                    });
                }
            }
            return internalState.toQueryResult(apolloQueryResult);
        }).then(function (queryResult) { return Object.assign(queryResult, eagerMethods); });
        internalState.forceUpdate();
        promise.catch(function () { });
        return promise;
    }, []);
    return [execute, result];
}
//# sourceMappingURL=useLazyQuery.js.map
;// CONCATENATED MODULE: ./saleor/api.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    fragment PageInfoFragment on PageInfo {\n  hasNextPage\n  startCursor\n  endCursor\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    fragment AttributeDetailsFragment on AttributeCountableEdge {\n  node {\n    name\n    id\n    slug\n    choices(first: 100) {\n      pageInfo {\n        ...PageInfoFragment\n      }\n      edges {\n        cursor\n        node {\n          id\n          name\n          value\n          slug\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CategoryBasicFragment on Category {\n  id\n  name\n  slug\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ImageFragment on Image {\n  url\n  alt\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CategoryDetailsFragment on Category {\n  id\n  ...CategoryBasicFragment\n  seoTitle\n  seoDescription\n  description\n  translation(languageCode: $locale) {\n    id\n    description\n  }\n  backgroundImage {\n    ...ImageFragment\n  }\n  children(first: 40) {\n    pageInfo {\n      ...PageInfoFragment\n    }\n    edges {\n      cursor\n      node {\n        id\n        name\n      }\n    }\n  }\n  ancestors(first: 5) {\n    edges {\n      node {\n        ...CategoryBasicFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    fragment AddressDetailsFragment on Address {\n  id\n  phone\n  firstName\n  lastName\n  streetAddress1\n  streetAddress2\n  city\n  companyName\n  postalCode\n  countryArea\n  isDefaultBillingAddress\n  isDefaultShippingAddress\n  country {\n    code\n    country\n  }\n  metadata {\n    key\n    value\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    fragment PriceFragment on Money {\n  currency\n  amount\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    fragment DeliveryMethodFragment on ShippingMethod {\n  id\n  name\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  price {\n    ...PriceFragment\n  }\n  minimumDeliveryDays\n  maximumDeliveryDays\n}\n    ",
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CheckoutLineDetailsFragment on CheckoutLine {\n  id\n  totalPrice {\n    gross {\n      ...PriceFragment\n    }\n  }\n  metadata {\n    key\n    value\n  }\n  variant {\n    id\n    sku\n    metadata {\n      key\n      value\n    }\n    product {\n      metadata {\n        key\n        value\n      }\n      productType {\n        hasVariants\n        isDigital\n        slug\n      }\n      id\n      name\n      translation(languageCode: $locale) {\n        id\n        name\n      }\n      slug\n      thumbnail {\n        ...ImageFragment\n      }\n    }\n    pricing {\n      price {\n        gross {\n          ...PriceFragment\n        }\n      }\n    }\n    name\n    translation(languageCode: $locale) {\n      id\n      name\n    }\n  }\n  quantity\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CheckoutDetailsFragment on Checkout {\n  id\n  token\n  email\n  user {\n    id\n    metadata {\n      key\n      value\n    }\n  }\n  metadata {\n    key\n    value\n  }\n  billingAddress {\n    ...AddressDetailsFragment\n  }\n  shippingAddress {\n    ...AddressDetailsFragment\n  }\n  shippingMethod {\n    ...DeliveryMethodFragment\n  }\n  isShippingRequired\n  availableShippingMethods {\n    ...DeliveryMethodFragment\n  }\n  availablePaymentGateways {\n    id\n    name\n    config {\n      field\n      value\n    }\n  }\n  lines {\n    ...CheckoutLineDetailsFragment\n  }\n  discount {\n    ...PriceFragment\n  }\n  discountName\n  voucherCode\n  subtotalPrice {\n    net {\n      ...PriceFragment\n    }\n    tax {\n      ...PriceFragment\n    }\n  }\n  shippingPrice {\n    gross {\n      ...PriceFragment\n    }\n  }\n  totalPrice {\n    gross {\n      ...PriceFragment\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CollectionBasicFragment on Collection {\n  id\n  name\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  slug\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CollectionDetailsFragment on Collection {\n  id\n  ...CollectionBasicFragment\n  seoTitle\n  seoDescription\n  description\n  translation(languageCode: $locale) {\n    id\n    description\n  }\n  backgroundImage {\n    ...ImageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductMediaFragment on ProductMedia {\n  url(size: 2048)\n  alt\n  type\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    fragment FontProductVariantDetailsFragment on ProductVariant {\n  id\n  name\n  sku\n  metadata {\n    key\n    value\n  }\n  product {\n    name\n    slug\n    productType {\n      isDigital\n      slug\n    }\n  }\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  quantityAvailable\n  media {\n    ...ProductMediaFragment\n  }\n  pricing {\n    price {\n      gross {\n        ...PriceFragment\n      }\n      net {\n        ...PriceFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CustomiserProductDetailsFragment on Product {\n  id\n  name\n  slug\n  metadata {\n    key\n    value\n  }\n  variants {\n    ...FontProductVariantDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CustomiserAttributeFragment on SelectedAttribute {\n  attribute {\n    slug\n  }\n  values {\n    name\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    fragment CustomiserProductCardFragment on Product {\n  id\n  slug\n  name\n  variants {\n    id\n    name\n    sku\n    metadata {\n      key\n      value\n    }\n  }\n  metadata {\n    key\n    value\n  }\n  attributes {\n    ...CustomiserAttributeFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ErrorDetailsFragment on CheckoutError {\n  field\n  message\n  code\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    fragment FontProductDetailsFragment on Product {\n  id\n  name\n  slug\n  description\n  seoDescription\n  seoTitle\n  productType {\n    isDigital\n    slug\n  }\n  variants {\n    ...FontProductVariantDetailsFragment\n  }\n  metadata {\n    key\n    value\n  }\n}\n    ",
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    fragment HomepageBlockFragment on MenuItem {\n  id\n  name\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  category {\n    id\n    slug\n  }\n  collection {\n    id\n    slug\n  }\n  page {\n    id\n    slug\n  }\n  page {\n    id\n    content\n    title\n    translation(languageCode: $locale) {\n      content\n      title\n    }\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    fragment MenuItemFragment on MenuItem {\n  id\n  name\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  category {\n    id\n    slug\n  }\n  collection {\n    id\n    slug\n  }\n  page {\n    id\n    slug\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    fragment OrderDetailsFragment on Order {\n  id\n  token\n  created\n  number\n  status\n  metadata {\n    key\n    value\n  }\n  lines {\n    id\n    metadata {\n      key\n      value\n    }\n    productSku\n    productName\n    variantName\n    quantity\n    variant {\n      sku\n      id\n      product {\n        productType {\n          isDigital\n          slug\n        }\n        id\n        name\n        slug\n        thumbnail {\n          ...ImageFragment\n        }\n      }\n      pricing {\n        price {\n          gross {\n            ...PriceFragment\n          }\n        }\n      }\n      name\n      metadata {\n        key\n        value\n      }\n    }\n    thumbnail {\n      url\n      alt\n    }\n    unitPrice {\n      gross {\n        ...PriceFragment\n      }\n    }\n    totalPrice {\n      gross {\n        ...PriceFragment\n      }\n    }\n  }\n  total {\n    currency\n    gross {\n      ...PriceFragment\n    }\n    net {\n      ...PriceFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    fragment SelectedAttributeDetailsFragment on SelectedAttribute {\n  attribute {\n    id\n    slug\n    name\n    translation(languageCode: $locale) {\n      id\n      name\n    }\n    type\n    unit\n  }\n  values {\n    id\n    name\n    translation(languageCode: $locale) {\n      id\n      name\n      richText\n    }\n    value\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductVariantDetailsFragment on ProductVariant {\n  id\n  name\n  sku\n  metadata {\n    key\n    value\n  }\n  product {\n    name\n    slug\n    productType {\n      isDigital\n      slug\n    }\n  }\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  quantityAvailable\n  attributes {\n    ...SelectedAttributeDetailsFragment\n  }\n  media {\n    ...ProductMediaFragment\n  }\n  pricing {\n    price {\n      gross {\n        ...PriceFragment\n      }\n      net {\n        ...PriceFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductCardFragment on Product {\n  id\n  slug\n  name\n  isAvailable\n  productType {\n    isDigital\n    slug\n  }\n  variants {\n    ...ProductVariantDetailsFragment\n  }\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  media {\n    type\n    url(size: 1080)\n    alt\n  }\n  thumbnail(size: 100) {\n    ...ImageFragment\n  }\n  category {\n    id\n    name\n    translation(languageCode: $locale) {\n      id\n      name\n    }\n  }\n  attributes {\n    ...SelectedAttributeDetailsFragment\n  }\n  pricing {\n    onSale\n    priceRange {\n      start {\n        net {\n          ...PriceFragment\n        }\n        gross {\n          ...PriceFragment\n        }\n      }\n      stop {\n        net {\n          ...PriceFragment\n        }\n        gross {\n          ...PriceFragment\n        }\n      }\n    }\n  }\n  metadata {\n    key\n    value\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductCardFragmentLight on Product {\n  id\n  slug\n  name\n  isAvailable\n  variants {\n    id\n    name\n    sku\n    metadata {\n      key\n      value\n    }\n    product {\n      name\n      slug\n      productType {\n        isDigital\n        slug\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductDetailsFragment on Product {\n  id\n  name\n  slug\n  description\n  seoDescription\n  seoTitle\n  isAvailableForPurchase\n  productType {\n    isDigital\n    slug\n  }\n  translation(languageCode: $locale) {\n    id\n    description\n    name\n  }\n  attributes {\n    ...SelectedAttributeDetailsFragment\n  }\n  category {\n    ...CategoryBasicFragment\n  }\n  variants {\n    ...ProductVariantDetailsFragment\n  }\n  pricing {\n    priceRange {\n      start {\n        net {\n          ...PriceFragment\n        }\n        gross {\n          ...PriceFragment\n        }\n        net {\n          ...PriceFragment\n        }\n      }\n    }\n  }\n  media {\n    ...ProductMediaFragment\n  }\n  thumbnail {\n    ...ImageFragment\n  }\n  category {\n    name\n  }\n  metadata {\n    key\n    value\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProductDropdownFragment on Product {\n  id\n  slug\n  name\n  metadata {\n    key\n    value\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n    fragment TypefaceCardFragment on Product {\n  id\n  slug\n  name\n  isAvailable\n  productType {\n    isDigital\n    slug\n  }\n  variants {\n    id\n    name\n    sku\n    metadata {\n      key\n      value\n    }\n  }\n  translation(languageCode: $locale) {\n    id\n    name\n  }\n  thumbnail {\n    ...ImageFragment\n  }\n  images {\n    url\n    id\n    alt\n  }\n  category {\n    id\n    name\n    translation(languageCode: $locale) {\n      id\n      name\n    }\n  }\n  attributes {\n    ...SelectedAttributeDetailsFragment\n  }\n  pricing {\n    onSale\n    priceRange {\n      start {\n        net {\n          ...PriceFragment\n        }\n        gross {\n          ...PriceFragment\n        }\n      }\n      stop {\n        net {\n          ...PriceFragment\n        }\n        gross {\n          ...PriceFragment\n        }\n      }\n    }\n  }\n  metadata {\n    key\n    value\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    mutation AccountDelete($token: String!) {\n  accountDelete(token: $token) {\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n    mutation AccountRegister($input: AccountRegisterInput!) {\n  accountRegister(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n    mutation AddressDelete($id: ID!) {\n  accountAddressDelete(id: $id) {\n    user {\n      addresses {\n        ...AddressDetailsFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n    mutation AddressSetDefault($addressID: ID!, $userID: ID!, $addressType: AddressTypeEnum!) {\n  addressSetDefault(addressId: $addressID, type: $addressType, userId: $userID) {\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutAddProductLine($checkoutToken: UUID!, $variantId: ID!, $locale: LanguageCodeEnum!) {\n  checkoutLinesAdd(\n    token: $checkoutToken\n    lines: [{quantity: 1, variantId: $variantId}]\n  ) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutAddPromoCode($token: UUID!, $promoCode: String!, $locale: LanguageCodeEnum!) {\n  checkoutAddPromoCode(token: $token, promoCode: $promoCode) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      message\n      field\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutBillingAddressUpdate($token: UUID!, $address: AddressInput!, $locale: LanguageCodeEnum!) {\n  checkoutBillingAddressUpdate(billingAddress: $address, token: $token) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n    mutation checkoutComplete($checkoutToken: UUID!, $paymentData: JSONString) {\n  checkoutComplete(token: $checkoutToken, paymentData: $paymentData) {\n    order {\n      id\n      status\n      token\n      shippingPrice {\n        gross {\n          ...PriceFragment\n        }\n      }\n      total {\n        currency\n        gross {\n          ...PriceFragment\n        }\n        net {\n          ...PriceFragment\n        }\n      }\n      lines {\n        productName\n        variantName\n        quantity\n        totalPrice {\n          gross {\n            ...PriceFragment\n          }\n        }\n      }\n      billingAddress {\n        id\n        ...AddressDetailsFragment\n      }\n      shippingAddress {\n        id\n        ...AddressDetailsFragment\n      }\n    }\n    confirmationNeeded\n    confirmationData\n    errors {\n      field\n      message\n      variants\n      addressType\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCheckout($email: String!, $lines: [CheckoutLineInput!]!, $channel: String!) {\n  checkoutCreate(input: {channel: $channel, email: $email, lines: $lines}) {\n    checkout {\n      id\n      token\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n    mutation checkoutPaymentCreate($checkoutToken: UUID!, $paymentInput: PaymentInput!) {\n  checkoutPaymentCreate(token: $checkoutToken, input: $paymentInput) {\n    payment {\n      id\n      total {\n        ...PriceFragment\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n    mutation checkoutCustomerAttach($customerId: ID, $token: UUID) {\n  checkoutCustomerAttach(customerId: $customerId, token: $token) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      lines {\n        id\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n    mutation checkoutCustomerDetach($token: UUID, $checkoutId: ID) {\n  checkoutCustomerDetach(token: $token, checkoutId: $checkoutId) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      lines {\n        id\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutEmailUpdate($token: UUID!, $email: String!, $locale: LanguageCodeEnum!) {\n  checkoutEmailUpdate(email: $email, token: $token) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutLineUpdate($token: UUID, $lines: [CheckoutLineUpdateInput!]!, $locale: LanguageCodeEnum!) {\n  checkoutLinesUpdate(token: $token, lines: $lines) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      ...ErrorDetailsFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RemoveProductFromCheckout($checkoutToken: UUID!, $lineId: ID!, $locale: LanguageCodeEnum!) {\n  checkoutLineDelete(token: $checkoutToken, lineId: $lineId) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutRemovePromoCode($token: UUID!, $promoCode: String!, $locale: LanguageCodeEnum!) {\n  checkoutRemovePromoCode(token: $token, promoCode: $promoCode) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      message\n      field\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutShippingAddressUpdate($token: UUID!, $address: AddressInput!, $locale: LanguageCodeEnum!) {\n  checkoutShippingAddressUpdate(shippingAddress: $address, token: $token) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CheckoutShippingMethodUpdate($token: UUID!, $shippingMethodId: ID!, $locale: LanguageCodeEnum!) {\n  checkoutShippingMethodUpdate(shippingMethodId: $shippingMethodId, token: $token) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n    mutation confirmAccount($email: String!, $token: String!) {\n  confirmAccount(email: $email, token: $token) {\n    user {\n      email\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n    mutation confirmEmailChange($channel: String!, $token: String!) {\n  confirmEmailChange(channel: $channel, token: $token) {\n    errors {\n      field\n      message\n    }\n    user {\n      email\n    }\n  }\n}\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SetAddressDefault($id: ID!, $type: AddressTypeEnum!) {\n  accountSetDefaultAddress(id: $id, type: $type) {\n    user {\n      addresses {\n        ...AddressDetailsFragment\n      }\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n    mutation PasswordChange($newPassword: String!, $oldPassword: String!) {\n  passwordChange(newPassword: $newPassword, oldPassword: $oldPassword) {\n    user {\n      email\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RequestAccountDelete($redirectUrl: String!, $channel: String!) {\n  accountRequestDeletion(channel: $channel, redirectUrl: $redirectUrl) {\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        '\n    mutation RequestEmailChange($newEmail: String!, $password: String!, $redirectUrl: String!) {\n  requestEmailChange(\n    channel: "uk-store"\n    newEmail: $newEmail\n    password: $password\n    redirectUrl: $redirectUrl\n  ) {\n    user {\n      email\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    '
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n    mutation requestPasswordReset($channel: String!, $email: String!, $redirectUrl: String!) {\n  requestPasswordReset(\n    channel: $channel\n    email: $email\n    redirectUrl: $redirectUrl\n  ) {\n    errors {\n      field\n      message\n      code\n      addressType\n      __typename\n    }\n  }\n}\n    "
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SetPassword($email: String!, $password: String!, $token: String!) {\n  setPassword(email: $email, password: $password, token: $token) {\n    user {\n      email\n      firstName\n    }\n    csrfToken\n    refreshToken\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n    mutation updateMetaData($id: ID!, $input: [MetadataInput!]!) {\n  updateMetadata(id: $id, input: $input) {\n    item {\n      metadata {\n        key\n        value\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n    query AddressValidationRules($countryCode: CountryCode!, $countryArea: String, $city: String, $cityArea: String) {\n  addressValidationRules(\n    countryCode: $countryCode\n    countryArea: $countryArea\n    city: $city\n    cityArea: $cityArea\n  ) {\n    countryName\n    allowedFields\n    requiredFields\n    countryAreaType\n    countryAreaChoices {\n      raw\n      verbose\n    }\n    cityAreaChoices {\n      raw\n      verbose\n    }\n    cityType\n    cityChoices {\n      raw\n      verbose\n    }\n  }\n}\n    "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n    query AttributeData($ids: [ID!]) {\n  attributes(first: 10, filter: {ids: $ids}) {\n    edges {\n      cursor\n      ...AttributeDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n    query AvailableShippingMethods($channel: String!, $locale: LanguageCodeEnum!) {\n  shop {\n    availableShippingMethods(channel: $channel) {\n      id\n      name\n      translation(languageCode: $locale) {\n        id\n        name\n      }\n      price {\n        ...PriceFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n    query CategoryBySlug($slug: String!, $locale: LanguageCodeEnum!) {\n  category(slug: $slug) {\n    ...CategoryDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n    query CategoryPaths($after: String) {\n  categories(first: 100, after: $after) {\n    pageInfo {\n      ...PageInfoFragment\n    }\n    edges {\n      node {\n        slug\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n    query CheckoutByToken($checkoutToken: UUID!, $locale: LanguageCodeEnum!) {\n  checkout(token: $checkoutToken) {\n    ...CheckoutDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n    query CollectionBySlug($slug: String!, $channel: String!, $locale: LanguageCodeEnum!) {\n  collection(slug: $slug, channel: $channel) {\n    id\n    ...CollectionDetailsFragment\n    backgroundImage {\n      ...ImageFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n    query CollectionPaths($after: String, $channel: String!) {\n  collections(first: 20, channel: $channel, after: $after) {\n    pageInfo {\n      ...PageInfoFragment\n    }\n    edges {\n      node {\n        slug\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n    query CurrentUserDetails($before: String, $after: String) {\n  me {\n    id\n    lastLogin\n    dateJoined\n    email\n    firstName\n    lastName\n    checkoutTokens\n    avatar {\n      ...ImageFragment\n    }\n    orders(first: 10, before: $before, after: $after) {\n      edges {\n        cursor\n        node {\n          ...OrderDetailsFragment\n        }\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      totalCount\n    }\n    metadata {\n      key\n      value\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n    query CustomiserCollection($before: String, $after: String, $filter: ProductFilterInput, $channel: String!, $first: Int = 100) {\n  products(\n    first: $first\n    channel: $channel\n    after: $after\n    before: $before\n    filter: $filter\n  ) {\n    totalCount\n    edges {\n      cursor\n      node {\n        ...CustomiserProductCardFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n    query CustomiserProductById($id: ID, $channel: String!, $locale: LanguageCodeEnum!) {\n  product(id: $id, channel: $channel) {\n    ...CustomiserProductDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n    query FontDataProductBySlug($slug: String!, $channel: String!, $locale: LanguageCodeEnum!) {\n  product(slug: $slug, channel: $channel) {\n    ...FontProductDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n    query HomepageBlocksQuery($slug: String!, $channel: String!, $locale: LanguageCodeEnum!) {\n  menu(channel: $channel, slug: $slug) {\n    id\n    name\n    slug\n    items {\n      ...HomepageBlockFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        '\n    query MainMenu($locale: LanguageCodeEnum!, $channel: String!) {\n  menu(slug: "navbar", channel: $channel) {\n    id\n    items {\n      children {\n        ...MenuItemFragment\n      }\n      ...MenuItemFragment\n    }\n  }\n}\n    ',
        ""
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n    query OrderDetailsQuery($token: UUID!) {\n  orderByToken(token: $token) {\n    id\n    number\n    shippingPrice {\n      gross {\n        ...PriceFragment\n      }\n    }\n    created\n    lines {\n      id\n      thumbnail {\n        ...ImageFragment\n      }\n      totalPrice {\n        gross {\n          ...PriceFragment\n        }\n      }\n      productName\n      variantName\n      quantity\n    }\n    total {\n      gross {\n        ...PriceFragment\n      }\n    }\n    statusDisplay\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n    query OrderDetailsByToken($locale: LanguageCodeEnum!, $token: UUID!) {\n  orderByToken(token: $token) {\n    id\n    metadata {\n      key\n      value\n    }\n    status\n    number\n    created\n    shippingAddress {\n      ...AddressDetailsFragment\n    }\n    billingAddress {\n      ...AddressDetailsFragment\n    }\n    paymentStatus\n    payments {\n      paymentMethodType\n    }\n    invoices {\n      id\n      number\n      externalUrl\n      url\n      status\n    }\n    subtotal {\n      net {\n        ...PriceFragment\n      }\n      tax {\n        ...PriceFragment\n      }\n    }\n    total {\n      gross {\n        ...PriceFragment\n      }\n    }\n    lines {\n      id\n      productSku\n      productName\n      variantName\n      quantity\n      metadata {\n        key\n        value\n      }\n      variant {\n        sku\n        id\n        product {\n          productType {\n            isDigital\n            slug\n          }\n          id\n          name\n          translation(languageCode: $locale) {\n            id\n            name\n          }\n          slug\n          thumbnail {\n            ...ImageFragment\n          }\n        }\n        pricing {\n          price {\n            gross {\n              ...PriceFragment\n            }\n          }\n        }\n        name\n        metadata {\n          key\n          value\n        }\n        translation(languageCode: $locale) {\n          id\n          name\n        }\n      }\n      thumbnail {\n        url\n        alt\n      }\n      unitPrice {\n        gross {\n          ...PriceFragment\n        }\n      }\n      totalPrice {\n        gross {\n          ...PriceFragment\n        }\n      }\n    }\n    shippingPrice {\n      gross {\n        ...PriceFragment\n      }\n    }\n    discount {\n      ...PriceFragment\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n    query Orders($before: String, $after: String) {\n  me {\n    orders(first: 10, before: $before, after: $after) {\n      edges {\n        cursor\n        node {\n          ...OrderDetailsFragment\n        }\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      totalCount\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n    query Page($slug: String!, $locale: LanguageCodeEnum!) {\n  page(slug: $slug) {\n    id\n    title\n    translation(languageCode: $locale) {\n      id\n      title\n      content\n    }\n    seoTitle\n    seoDescription\n    slug\n    created\n    content\n  }\n}\n    "
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "\n    query PagePaths($after: String) {\n  pages(first: 100, after: $after) {\n    pageInfo {\n      ...PageInfoFragment\n    }\n    edges {\n      node {\n        slug\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductById($id: ID, $channel: String!, $locale: LanguageCodeEnum!) {\n  product(id: $id, channel: $channel) {\n    ...ProductDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductBySlug($slug: String!, $channel: String!, $locale: LanguageCodeEnum!) {\n  product(slug: $slug, channel: $channel) {\n    ...ProductDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductCollection($before: String, $after: String, $filter: ProductFilterInput, $channel: String!, $locale: LanguageCodeEnum!, $first: Int = 100) {\n  products(\n    first: $first\n    channel: $channel\n    after: $after\n    before: $before\n    filter: $filter\n  ) {\n    totalCount\n    edges {\n      cursor\n      node {\n        ...ProductCardFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductFontsDropdown($before: String, $after: String, $channel: String!, $filter: ProductFilterInput) {\n  products(\n    first: 100\n    channel: $channel\n    after: $after\n    before: $before\n    filter: $filter\n  ) {\n    edges {\n      cursor\n      node {\n        ...ProductDropdownFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductPaths($after: String, $channel: String!) {\n  products(first: 100, channel: $channel, after: $after) {\n    pageInfo {\n      ...PageInfoFragment\n    }\n    edges {\n      node {\n        slug\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n    query ProductVariantById($id: ID, $channel: String!, $locale: LanguageCodeEnum!) {\n  productVariant(id: $id, channel: $channel) {\n    ...ProductVariantDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n    query TrialsProducts($before: String, $after: String, $filter: ProductFilterInput, $channel: String!, $first: Int = 100) {\n  products(\n    first: $first\n    channel: $channel\n    after: $after\n    before: $before\n    filter: $filter\n  ) {\n    totalCount\n    edges {\n      cursor\n      node {\n        ...ProductCardFragmentLight\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n    query TypefaceCollection($before: String, $after: String, $filter: ProductFilterInput, $channel: String!, $locale: LanguageCodeEnum!, $first: Int = 100, $sort: ProductOrder) {\n  products(\n    first: $first\n    channel: $channel\n    after: $after\n    before: $before\n    filter: $filter\n    sortBy: $sort\n  ) {\n    totalCount\n    edges {\n      cursor\n      node {\n        ...TypefaceCardFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n    query TypefaceProductPageQuery($slug: String!, $channel: String!) {\n  product(slug: $slug, channel: $channel) {\n    id\n    name\n    slug\n    description\n    seoDescription\n    seoTitle\n    isAvailableForPurchase\n    productType {\n      isDigital\n      slug\n    }\n    pricing {\n      priceRange {\n        start {\n          net {\n            ...PriceFragment\n          }\n          gross {\n            ...PriceFragment\n          }\n          net {\n            ...PriceFragment\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n    query user($before: String, $after: String) {\n  user: me {\n    id\n    email\n    firstName\n    checkoutTokens\n    metadata {\n      key\n      value\n    }\n    orders(first: 10, before: $before, after: $after) {\n      edges {\n        cursor\n        node {\n          ...OrderDetailsFragment\n        }\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      totalCount\n    }\n    addresses {\n      ...AddressDetailsFragment\n    }\n    defaultBillingAddress {\n      ...AddressDetailsFragment\n    }\n    defaultShippingAddress {\n      ...AddressDetailsFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "\n    query CurrentUserAddresses {\n  me {\n    addresses {\n      ...AddressDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var PageInfoFragmentDoc = (0,lib/* gql */.Ps)(_templateObject());
var AttributeDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject1(), PageInfoFragmentDoc);
var CategoryBasicFragmentDoc = (0,lib/* gql */.Ps)(_templateObject2());
var ImageFragmentDoc = (0,lib/* gql */.Ps)(_templateObject3());
var CategoryDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject4(), CategoryBasicFragmentDoc, ImageFragmentDoc, PageInfoFragmentDoc);
var AddressDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject5());
var PriceFragmentDoc = (0,lib/* gql */.Ps)(_templateObject6());
var DeliveryMethodFragmentDoc = (0,lib/* gql */.Ps)(_templateObject7(), PriceFragmentDoc);
var CheckoutLineDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject8(), PriceFragmentDoc, ImageFragmentDoc);
var CheckoutDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject9(), AddressDetailsFragmentDoc, DeliveryMethodFragmentDoc, CheckoutLineDetailsFragmentDoc, PriceFragmentDoc);
var CollectionBasicFragmentDoc = (0,lib/* gql */.Ps)(_templateObject10());
var CollectionDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject11(), CollectionBasicFragmentDoc, ImageFragmentDoc);
var ProductMediaFragmentDoc = (0,lib/* gql */.Ps)(_templateObject12());
var FontProductVariantDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject13(), ProductMediaFragmentDoc, PriceFragmentDoc);
var CustomiserProductDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject14(), FontProductVariantDetailsFragmentDoc);
var CustomiserAttributeFragmentDoc = (0,lib/* gql */.Ps)(_templateObject15());
var CustomiserProductCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject16(), CustomiserAttributeFragmentDoc);
var ErrorDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject17());
var FontProductDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject18(), FontProductVariantDetailsFragmentDoc);
var HomepageBlockFragmentDoc = (0,lib/* gql */.Ps)(_templateObject19());
var MenuItemFragmentDoc = (0,lib/* gql */.Ps)(_templateObject20());
var OrderDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject21(), ImageFragmentDoc, PriceFragmentDoc);
var SelectedAttributeDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject22());
var ProductVariantDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject23(), SelectedAttributeDetailsFragmentDoc, ProductMediaFragmentDoc, PriceFragmentDoc);
var ProductCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject24(), ProductVariantDetailsFragmentDoc, ImageFragmentDoc, SelectedAttributeDetailsFragmentDoc, PriceFragmentDoc);
var ProductCardFragmentLightFragmentDoc = (0,lib/* gql */.Ps)(_templateObject25());
var ProductDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject26(), SelectedAttributeDetailsFragmentDoc, CategoryBasicFragmentDoc, ProductVariantDetailsFragmentDoc, PriceFragmentDoc, ProductMediaFragmentDoc, ImageFragmentDoc);
var ProductDropdownFragmentDoc = (0,lib/* gql */.Ps)(_templateObject27());
var TypefaceCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject28(), ImageFragmentDoc, SelectedAttributeDetailsFragmentDoc, PriceFragmentDoc);
var AccountDeleteDocument = (0,lib/* gql */.Ps)(_templateObject29());
/**
 * __useAccountDeleteMutation__
 *
 * To run a mutation, you first call `useAccountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeleteMutation, { data, loading, error }] = useAccountDeleteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useAccountDeleteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(AccountDeleteDocument, options);
}
var AccountRegisterDocument = (0,lib/* gql */.Ps)(_templateObject30());
/**
 * __useAccountRegisterMutation__
 *
 * To run a mutation, you first call `useAccountRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRegisterMutation, { data, loading, error }] = useAccountRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useAccountRegisterMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(AccountRegisterDocument, options);
}
var AddressDeleteDocument = (0,lib/* gql */.Ps)(_templateObject31(), AddressDetailsFragmentDoc);
/**
 * __useAddressDeleteMutation__
 *
 * To run a mutation, you first call `useAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressDeleteMutation, { data, loading, error }] = useAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useAddressDeleteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(AddressDeleteDocument, options);
}
var AddressSetDefaultDocument = (0,lib/* gql */.Ps)(_templateObject32());
/**
 * __useAddressSetDefaultMutation__
 *
 * To run a mutation, you first call `useAddressSetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressSetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressSetDefaultMutation, { data, loading, error }] = useAddressSetDefaultMutation({
 *   variables: {
 *      addressID: // value for 'addressID'
 *      userID: // value for 'userID'
 *      addressType: // value for 'addressType'
 *   },
 * });
 */ function useAddressSetDefaultMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(AddressSetDefaultDocument, options);
}
var CheckoutAddProductLineDocument = (0,lib/* gql */.Ps)(_templateObject33(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutAddProductLineMutation__
 *
 * To run a mutation, you first call `useCheckoutAddProductLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAddProductLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAddProductLineMutation, { data, loading, error }] = useCheckoutAddProductLineMutation({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      variantId: // value for 'variantId'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutAddProductLineMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutAddProductLineDocument, options);
}
var CheckoutAddPromoCodeDocument = (0,lib/* gql */.Ps)(_templateObject34(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutAddPromoCodeMutation__
 *
 * To run a mutation, you first call `useCheckoutAddPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAddPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAddPromoCodeMutation, { data, loading, error }] = useCheckoutAddPromoCodeMutation({
 *   variables: {
 *      token: // value for 'token'
 *      promoCode: // value for 'promoCode'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutAddPromoCodeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutAddPromoCodeDocument, options);
}
var CheckoutBillingAddressUpdateDocument = (0,lib/* gql */.Ps)(_templateObject35(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutBillingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutBillingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBillingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutBillingAddressUpdateMutation, { data, loading, error }] = useCheckoutBillingAddressUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      address: // value for 'address'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutBillingAddressUpdateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutBillingAddressUpdateDocument, options);
}
var CheckoutCompleteDocument = (0,lib/* gql */.Ps)(_templateObject36(), PriceFragmentDoc, AddressDetailsFragmentDoc);
/**
 * __useCheckoutCompleteMutation__
 *
 * To run a mutation, you first call `useCheckoutCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCompleteMutation, { data, loading, error }] = useCheckoutCompleteMutation({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      paymentData: // value for 'paymentData'
 *   },
 * });
 */ function useCheckoutCompleteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutCompleteDocument, options);
}
var CreateCheckoutDocument = (0,lib/* gql */.Ps)(_templateObject37());
/**
 * __useCreateCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutMutation, { data, loading, error }] = useCreateCheckoutMutation({
 *   variables: {
 *      email: // value for 'email'
 *      lines: // value for 'lines'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useCreateCheckoutMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CreateCheckoutDocument, options);
}
var CheckoutPaymentCreateDocument = (0,lib/* gql */.Ps)(_templateObject38(), PriceFragmentDoc);
/**
 * __useCheckoutPaymentCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutPaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutPaymentCreateMutation, { data, loading, error }] = useCheckoutPaymentCreateMutation({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      paymentInput: // value for 'paymentInput'
 *   },
 * });
 */ function useCheckoutPaymentCreateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutPaymentCreateDocument, options);
}
var CheckoutCustomerAttachDocument = (0,lib/* gql */.Ps)(_templateObject39());
/**
 * __useCheckoutCustomerAttachMutation__
 *
 * To run a mutation, you first call `useCheckoutCustomerAttachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCustomerAttachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCustomerAttachMutation, { data, loading, error }] = useCheckoutCustomerAttachMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      token: // value for 'token'
 *   },
 * });
 */ function useCheckoutCustomerAttachMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(CheckoutCustomerAttachDocument, options);
}
var CheckoutCustomerDetachDocument = (0,lib/* gql */.Ps)(_templateObject40());
/**
 * __useCheckoutCustomerDetachMutation__
 *
 * To run a mutation, you first call `useCheckoutCustomerDetachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCustomerDetachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCustomerDetachMutation, { data, loading, error }] = useCheckoutCustomerDetachMutation({
 *   variables: {
 *      token: // value for 'token'
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */ function useCheckoutCustomerDetachMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(CheckoutCustomerDetachDocument, options);
}
var CheckoutEmailUpdateDocument = (0,lib/* gql */.Ps)(_templateObject41(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutEmailUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutEmailUpdateMutation, { data, loading, error }] = useCheckoutEmailUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutEmailUpdateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutEmailUpdateDocument, options);
}
var CheckoutLineUpdateDocument = (0,lib/* gql */.Ps)(_templateObject42(), CheckoutDetailsFragmentDoc, ErrorDetailsFragmentDoc);
/**
 * __useCheckoutLineUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutLineUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLineUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLineUpdateMutation, { data, loading, error }] = useCheckoutLineUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      lines: // value for 'lines'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutLineUpdateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutLineUpdateDocument, options);
}
var RemoveProductFromCheckoutDocument = (0,lib/* gql */.Ps)(_templateObject43(), CheckoutDetailsFragmentDoc);
/**
 * __useRemoveProductFromCheckoutMutation__
 *
 * To run a mutation, you first call `useRemoveProductFromCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductFromCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductFromCheckoutMutation, { data, loading, error }] = useRemoveProductFromCheckoutMutation({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      lineId: // value for 'lineId'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useRemoveProductFromCheckoutMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(RemoveProductFromCheckoutDocument, options);
}
var CheckoutRemovePromoCodeDocument = (0,lib/* gql */.Ps)(_templateObject44(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutRemovePromoCodeMutation__
 *
 * To run a mutation, you first call `useCheckoutRemovePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutRemovePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutRemovePromoCodeMutation, { data, loading, error }] = useCheckoutRemovePromoCodeMutation({
 *   variables: {
 *      token: // value for 'token'
 *      promoCode: // value for 'promoCode'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutRemovePromoCodeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutRemovePromoCodeDocument, options);
}
var CheckoutShippingAddressUpdateDocument = (0,lib/* gql */.Ps)(_templateObject45(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutShippingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingAddressUpdateMutation, { data, loading, error }] = useCheckoutShippingAddressUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      address: // value for 'address'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutShippingAddressUpdateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutShippingAddressUpdateDocument, options);
}
var CheckoutShippingMethodUpdateDocument = (0,lib/* gql */.Ps)(_templateObject46(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutShippingMethodUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingMethodUpdateMutation, { data, loading, error }] = useCheckoutShippingMethodUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      shippingMethodId: // value for 'shippingMethodId'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutShippingMethodUpdateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(CheckoutShippingMethodUpdateDocument, options);
}
var ConfirmAccountDocument = (0,lib/* gql */.Ps)(_templateObject47());
/**
 * __useConfirmAccountMutation__
 *
 * To run a mutation, you first call `useConfirmAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAccountMutation, { data, loading, error }] = useConfirmAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */ function useConfirmAccountMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(ConfirmAccountDocument, options);
}
var ConfirmEmailChangeDocument = (0,lib/* gql */.Ps)(_templateObject48());
/**
 * __useConfirmEmailChangeMutation__
 *
 * To run a mutation, you first call `useConfirmEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailChangeMutation, { data, loading, error }] = useConfirmEmailChangeMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      token: // value for 'token'
 *   },
 * });
 */ function useConfirmEmailChangeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(ConfirmEmailChangeDocument, options);
}
var SetAddressDefaultDocument = (0,lib/* gql */.Ps)(_templateObject49(), AddressDetailsFragmentDoc);
/**
 * __useSetAddressDefaultMutation__
 *
 * To run a mutation, you first call `useSetAddressDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddressDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddressDefaultMutation, { data, loading, error }] = useSetAddressDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */ function useSetAddressDefaultMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(SetAddressDefaultDocument, options);
}
var PasswordChangeDocument = (0,lib/* gql */.Ps)(_templateObject50());
/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */ function usePasswordChangeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(PasswordChangeDocument, options);
}
var RequestAccountDeleteDocument = (0,lib/* gql */.Ps)(_templateObject51());
/**
 * __useRequestAccountDeleteMutation__
 *
 * To run a mutation, you first call `useRequestAccountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountDeleteMutation, { data, loading, error }] = useRequestAccountDeleteMutation({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useRequestAccountDeleteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(RequestAccountDeleteDocument, options);
}
var RequestEmailChangeDocument = (0,lib/* gql */.Ps)(_templateObject52());
/**
 * __useRequestEmailChangeMutation__
 *
 * To run a mutation, you first call `useRequestEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailChangeMutation, { data, loading, error }] = useRequestEmailChangeMutation({
 *   variables: {
 *      newEmail: // value for 'newEmail'
 *      password: // value for 'password'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */ function useRequestEmailChangeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(RequestEmailChangeDocument, options);
}
var RequestPasswordResetDocument = (0,lib/* gql */.Ps)(_templateObject53());
/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */ function useRequestPasswordResetMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(RequestPasswordResetDocument, options);
}
var SetPasswordDocument = (0,lib/* gql */.Ps)(_templateObject54());
/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */ function useSetPasswordMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useMutation(SetPasswordDocument, options);
}
var UpdateMetaDataDocument = (0,lib/* gql */.Ps)(_templateObject55());
/**
 * __useUpdateMetaDataMutation__
 *
 * To run a mutation, you first call `useUpdateMetaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaDataMutation, { data, loading, error }] = useUpdateMetaDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */ function useUpdateMetaDataMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdateMetaDataDocument, options);
}
var AddressValidationRulesDocument = (0,lib/* gql */.Ps)(_templateObject56());
/**
 * __useAddressValidationRulesQuery__
 *
 * To run a query within a React component, call `useAddressValidationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressValidationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressValidationRulesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      countryArea: // value for 'countryArea'
 *      city: // value for 'city'
 *      cityArea: // value for 'cityArea'
 *   },
 * });
 */ function useAddressValidationRulesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(AddressValidationRulesDocument, options);
}
function useAddressValidationRulesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(AddressValidationRulesDocument, options);
}
var AttributeDataDocument = (0,lib/* gql */.Ps)(_templateObject57(), AttributeDetailsFragmentDoc);
/**
 * __useAttributeDataQuery__
 *
 * To run a query within a React component, call `useAttributeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeDataQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */ function useAttributeDataQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(AttributeDataDocument, options);
}
function useAttributeDataLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(AttributeDataDocument, options);
}
var AvailableShippingMethodsDocument = (0,lib/* gql */.Ps)(_templateObject58(), PriceFragmentDoc);
/**
 * __useAvailableShippingMethodsQuery__
 *
 * To run a query within a React component, call `useAvailableShippingMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableShippingMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableShippingMethodsQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useAvailableShippingMethodsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(AvailableShippingMethodsDocument, options);
}
function useAvailableShippingMethodsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(AvailableShippingMethodsDocument, options);
}
var CategoryBySlugDocument = (0,lib/* gql */.Ps)(_templateObject59(), CategoryDetailsFragmentDoc);
/**
 * __useCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCategoryBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CategoryBySlugDocument, options);
}
function useCategoryBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CategoryBySlugDocument, options);
}
var CategoryPathsDocument = (0,lib/* gql */.Ps)(_templateObject60(), PageInfoFragmentDoc);
/**
 * __useCategoryPathsQuery__
 *
 * To run a query within a React component, call `useCategoryPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */ function useCategoryPathsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CategoryPathsDocument, options);
}
function useCategoryPathsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CategoryPathsDocument, options);
}
var CheckoutByTokenDocument = (0,lib/* gql */.Ps)(_templateObject61(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutByTokenQuery__
 *
 * To run a query within a React component, call `useCheckoutByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutByTokenQuery({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCheckoutByTokenQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(CheckoutByTokenDocument, options);
}
function useCheckoutByTokenLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckoutByTokenDocument, options);
}
var CollectionBySlugDocument = (0,lib/* gql */.Ps)(_templateObject62(), CollectionDetailsFragmentDoc, ImageFragmentDoc);
/**
 * __useCollectionBySlugQuery__
 *
 * To run a query within a React component, call `useCollectionBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCollectionBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CollectionBySlugDocument, options);
}
function useCollectionBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CollectionBySlugDocument, options);
}
var CollectionPathsDocument = (0,lib/* gql */.Ps)(_templateObject63(), PageInfoFragmentDoc);
/**
 * __useCollectionPathsQuery__
 *
 * To run a query within a React component, call `useCollectionPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionPathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useCollectionPathsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CollectionPathsDocument, options);
}
function useCollectionPathsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CollectionPathsDocument, options);
}
var CurrentUserDetailsDocument = (0,lib/* gql */.Ps)(_templateObject64(), ImageFragmentDoc, OrderDetailsFragmentDoc);
/**
 * __useCurrentUserDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDetailsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */ function useCurrentUserDetailsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CurrentUserDetailsDocument, options);
}
function useCurrentUserDetailsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CurrentUserDetailsDocument, options);
}
var CustomiserCollectionDocument = (0,lib/* gql */.Ps)(_templateObject65(), CustomiserProductCardFragmentDoc);
/**
 * __useCustomiserCollectionQuery__
 *
 * To run a query within a React component, call `useCustomiserCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomiserCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomiserCollectionQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      first: // value for 'first'
 *   },
 * });
 */ function useCustomiserCollectionQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CustomiserCollectionDocument, options);
}
function useCustomiserCollectionLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useLazyQuery(CustomiserCollectionDocument, options);
}
var CustomiserProductByIdDocument = (0,lib/* gql */.Ps)(_templateObject66(), CustomiserProductDetailsFragmentDoc);
/**
 * __useCustomiserProductByIdQuery__
 *
 * To run a query within a React component, call `useCustomiserProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomiserProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomiserProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useCustomiserProductByIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CustomiserProductByIdDocument, options);
}
function useCustomiserProductByIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CustomiserProductByIdDocument, options);
}
var FontDataProductBySlugDocument = (0,lib/* gql */.Ps)(_templateObject67(), FontProductDetailsFragmentDoc);
/**
 * __useFontDataProductBySlugQuery__
 *
 * To run a query within a React component, call `useFontDataProductBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFontDataProductBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFontDataProductBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useFontDataProductBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FontDataProductBySlugDocument, options);
}
function useFontDataProductBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FontDataProductBySlugDocument, options);
}
var HomepageBlocksQueryDocument = (0,lib/* gql */.Ps)(_templateObject68(), HomepageBlockFragmentDoc);
/**
 * __useHomepageBlocksQuery__
 *
 * To run a query within a React component, call `useHomepageBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageBlocksQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useHomepageBlocksQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(HomepageBlocksQueryDocument, options);
}
function useHomepageBlocksQueryLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(HomepageBlocksQueryDocument, options);
}
var MainMenuDocument = (0,lib/* gql */.Ps)(_templateObject69(), MenuItemFragmentDoc);
/**
 * __useMainMenuQuery__
 *
 * To run a query within a React component, call `useMainMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainMenuQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useMainMenuQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(MainMenuDocument, options);
}
function useMainMenuLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(MainMenuDocument, options);
}
var OrderDetailsQueryDocument = (0,lib/* gql */.Ps)(_templateObject70(), PriceFragmentDoc, ImageFragmentDoc);
/**
 * __useOrderDetailsQuery__
 *
 * To run a query within a React component, call `useOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useOrderDetailsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(OrderDetailsQueryDocument, options);
}
function useOrderDetailsQueryLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(OrderDetailsQueryDocument, options);
}
var OrderDetailsByTokenDocument = (0,lib/* gql */.Ps)(_templateObject71(), AddressDetailsFragmentDoc, PriceFragmentDoc, ImageFragmentDoc);
/**
 * __useOrderDetailsByTokenQuery__
 *
 * To run a query within a React component, call `useOrderDetailsByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsByTokenQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      token: // value for 'token'
 *   },
 * });
 */ function useOrderDetailsByTokenQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(OrderDetailsByTokenDocument, options);
}
function useOrderDetailsByTokenLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(OrderDetailsByTokenDocument, options);
}
var OrdersDocument = (0,lib/* gql */.Ps)(_templateObject72(), OrderDetailsFragmentDoc);
/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */ function useOrdersQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(OrdersDocument, options);
}
function useOrdersLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(OrdersDocument, options);
}
var PageDocument = (0,lib/* gql */.Ps)(_templateObject73());
/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function usePageQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(PageDocument, options);
}
function usePageLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(PageDocument, options);
}
var PagePathsDocument = (0,lib/* gql */.Ps)(_templateObject74(), PageInfoFragmentDoc);
/**
 * __usePagePathsQuery__
 *
 * To run a query within a React component, call `usePagePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagePathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */ function usePagePathsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(PagePathsDocument, options);
}
function usePagePathsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(PagePathsDocument, options);
}
var ProductByIdDocument = (0,lib/* gql */.Ps)(_templateObject75(), ProductDetailsFragmentDoc);
/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useProductByIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductByIdDocument, options);
}
function useProductByIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductByIdDocument, options);
}
var ProductBySlugDocument = (0,lib/* gql */.Ps)(_templateObject76(), ProductDetailsFragmentDoc);
/**
 * __useProductBySlugQuery__
 *
 * To run a query within a React component, call `useProductBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useProductBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(ProductBySlugDocument, options);
}
function useProductBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductBySlugDocument, options);
}
var ProductCollectionDocument = (0,lib/* gql */.Ps)(_templateObject77(), ProductCardFragmentDoc);
/**
 * __useProductCollectionQuery__
 *
 * To run a query within a React component, call `useProductCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCollectionQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *      first: // value for 'first'
 *   },
 * });
 */ function useProductCollectionQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(ProductCollectionDocument, options);
}
function useProductCollectionLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductCollectionDocument, options);
}
var ProductFontsDropdownDocument = (0,lib/* gql */.Ps)(_templateObject78(), ProductDropdownFragmentDoc);
/**
 * __useProductFontsDropdownQuery__
 *
 * To run a query within a React component, call `useProductFontsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFontsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFontsDropdownQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      channel: // value for 'channel'
 *      filter: // value for 'filter'
 *   },
 * });
 */ function useProductFontsDropdownQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductFontsDropdownDocument, options);
}
function useProductFontsDropdownLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductFontsDropdownDocument, options);
}
var ProductPathsDocument = (0,lib/* gql */.Ps)(_templateObject79(), PageInfoFragmentDoc);
/**
 * __useProductPathsQuery__
 *
 * To run a query within a React component, call `useProductPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useProductPathsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductPathsDocument, options);
}
function useProductPathsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductPathsDocument, options);
}
var ProductVariantByIdDocument = (0,lib/* gql */.Ps)(_templateObject80(), ProductVariantDetailsFragmentDoc);
/**
 * __useProductVariantByIdQuery__
 *
 * To run a query within a React component, call `useProductVariantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *   },
 * });
 */ function useProductVariantByIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductVariantByIdDocument, options);
}
function useProductVariantByIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductVariantByIdDocument, options);
}
var TrialsProductsDocument = (0,lib/* gql */.Ps)(_templateObject81(), ProductCardFragmentLightFragmentDoc);
/**
 * __useTrialsProductsQuery__
 *
 * To run a query within a React component, call `useTrialsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialsProductsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      first: // value for 'first'
 *   },
 * });
 */ function useTrialsProductsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(TrialsProductsDocument, options);
}
function useTrialsProductsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(TrialsProductsDocument, options);
}
var TypefaceCollectionDocument = (0,lib/* gql */.Ps)(_templateObject82(), TypefaceCardFragmentDoc);
/**
 * __useTypefaceCollectionQuery__
 *
 * To run a query within a React component, call `useTypefaceCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTypefaceCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTypefaceCollectionQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      locale: // value for 'locale'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *   },
 * });
 */ function useTypefaceCollectionQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(TypefaceCollectionDocument, options);
}
function useTypefaceCollectionLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useLazyQuery(TypefaceCollectionDocument, options);
}
var TypefaceProductPageQueryDocument = (0,lib/* gql */.Ps)(_templateObject83(), PriceFragmentDoc);
/**
 * __useTypefaceProductPageQuery__
 *
 * To run a query within a React component, call `useTypefaceProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTypefaceProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTypefaceProductPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channel: // value for 'channel'
 *   },
 * });
 */ function useTypefaceProductPageQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(TypefaceProductPageQueryDocument, options);
}
function useTypefaceProductPageQueryLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(TypefaceProductPageQueryDocument, options);
}
var UserDocument = (0,lib/* gql */.Ps)(_templateObject84(), OrderDetailsFragmentDoc, AddressDetailsFragmentDoc);
/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */ function useUserQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(UserDocument, options);
}
function useUserLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(UserDocument, options);
}
var CurrentUserAddressesDocument = (0,lib/* gql */.Ps)(_templateObject85(), AddressDetailsFragmentDoc);
/**
 * __useCurrentUserAddressesQuery__
 *
 * To run a query within a React component, call `useCurrentUserAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAddressesQuery({
 *   variables: {
 *   },
 * });
 */ function useCurrentUserAddressesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return useQuery(CurrentUserAddressesDocument, options);
}
function useCurrentUserAddressesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CurrentUserAddressesDocument, options);
}


/***/ }),

/***/ 93913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__Wk_vu","SpinnerWhite":"Spinner_SpinnerWhite__6xPyd","SpinnerGrey":"Spinner_SpinnerGrey__lDrbX","SpinnerWhiteCharcoal":"Spinner_SpinnerWhiteCharcoal__7jnZa","SpinnerContextual":"Spinner_SpinnerContextual__3EMiH","SpinnerRelative":"Spinner_SpinnerRelative__dT_By","disc":"Spinner_disc__Wn6Gv","rotate":"Spinner_rotate__1oawe"};

/***/ }),

/***/ 92954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OrdersTableContainer":"OrdersTable_OrdersTableContainer__vPvgy","OrdersTable":"OrdersTable_OrdersTable__yQnC9","OrdersTableItem":"OrdersTable_OrdersTableItem__Yq1me","OrdersTableItem__ButtonMobile":"OrdersTable_OrdersTableItem__ButtonMobile__NZ3Yv","InvoiceRowTitle":"OrdersTable_InvoiceRowTitle__sfmBh","InvoiceRowDate":"OrdersTable_InvoiceRowDate__M8TMP","digits":"OrdersTable_digits__D_9kI"};

/***/ }),

/***/ 93841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartDiscount":"CartDiscount_CartDiscount__ZOi_e","FormDescription":"CartDiscount_FormDescription__9oa3a","DiscountField":"CartDiscount_DiscountField__pAuLB","Input":"CartDiscount_Input__sseZu"};

/***/ }),

/***/ 63208:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cartSummary":"CartSummary_cartSummary__vtQHd","noCartSummaryPadding":"CartSummary_noCartSummaryPadding__aWxAA","cartSummaryCheckout":"CartSummary_cartSummaryCheckout__zNKSe","cartTotals":"CartSummary_cartTotals__2eYoz","cartTotals__grandTotal":"CartSummary_cartTotals__grandTotal__se0Ol","cartTotals__Shipping":"CartSummary_cartTotals__Shipping__NGifx","cartTotals__Tax":"CartSummary_cartTotals__Tax__wEoRp","cartTotals__Discount":"CartSummary_cartTotals__Discount__U3S_T","cartActions":"CartSummary_cartActions__CudyW","shareModal":"CartSummary_shareModal__NlbFn","CartSummary__CopyUrlRow":"CartSummary_CartSummary__CopyUrlRow__5kSrO"};

/***/ }),

/***/ 15018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CopyButton":"CopyToClipboardButton_CopyButton__bAuJT","Clicked":"CopyToClipboardButton_Clicked__hPDOK","change-color":"CopyToClipboardButton_change-color__kaLsa"};

/***/ }),

/***/ 41411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkoutFormMain":"CheckoutForm_checkoutFormMain__5aV3A","checkoutStep":"CheckoutForm_checkoutStep__TXQGl","continue":"CheckoutForm_continue__gcg5r","checkoutLayout":"CheckoutForm_checkoutLayout__RfsQ1","checkoutSteps":"CheckoutForm_checkoutSteps__7meBb","stepper":"CheckoutForm_stepper__17BdM","stepperCircle":"CheckoutForm_stepperCircle__16D7F","stepperCircleActive":"CheckoutForm_stepperCircleActive__yiSpO","stepperCircleDone":"CheckoutForm_stepperCircleDone__dFe4V","checkoutGrid":"CheckoutForm_checkoutGrid__5Yp6C","confirmTitle":"CheckoutForm_confirmTitle__6cW5x","confirmSubTitle":"CheckoutForm_confirmSubTitle__sxSg0","checkoutCartLayout":"CheckoutForm_checkoutCartLayout__vtLq1","checkoutLoginEmail":"CheckoutForm_checkoutLoginEmail__hKsjd","checkoutAlreadyLoggedinButtonGroup":"CheckoutForm_checkoutAlreadyLoggedinButtonGroup__jFmfF","checkoutLoginButtonGroup":"CheckoutForm_checkoutLoginButtonGroup__L8H6F","checkoutLoginForgotPassword":"CheckoutForm_checkoutLoginForgotPassword__RpV50","checkoutRegisterFields":"CheckoutForm_checkoutRegisterFields__MKoe_","checkoutForgotPasswordFields":"CheckoutForm_checkoutForgotPasswordFields__Xrrwb","checkoutRegisterButtonGroup":"CheckoutForm_checkoutRegisterButtonGroup__uv0Ck","checkoutVAT":"CheckoutForm_checkoutVAT__oFT8s","stepNavigation":"CheckoutForm_stepNavigation__PQGz5","vatStep":"CheckoutForm_vatStep__H1eOL","stepNavigationBack":"CheckoutForm_stepNavigationBack__Vaq3V","stepNavigationBackLabel":"CheckoutForm_stepNavigationBackLabel__LAw88","stepNavigationContinueLabel":"CheckoutForm_stepNavigationContinueLabel__8OAYW","stepNavigationContinue":"CheckoutForm_stepNavigationContinue__Pd4Hm","AddressDisplay":"CheckoutForm_AddressDisplay__mSCQM","AddressDisplay__header":"CheckoutForm_AddressDisplay__header__anyc9","AddressDisplay__body":"CheckoutForm_AddressDisplay__body__yjNJw","AddressDisplay__bodyRow":"CheckoutForm_AddressDisplay__bodyRow__8S_JA","AddressDisplay__bodyLabel":"CheckoutForm_AddressDisplay__bodyLabel__OHZM2"};

/***/ }),

/***/ 23987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineItem":"CheckoutLineItem_lineItem__1ghF3","lineItem__name":"CheckoutLineItem_lineItem__name__z9bc3","lineItem__image":"CheckoutLineItem_lineItem__image__ukE7M","lineItem__info":"CheckoutLineItem_lineItem__info__l7_6h","lineItem__actions":"CheckoutLineItem_lineItem__actions__k9PnC","lineItem__licence":"CheckoutLineItem_lineItem__licence__ngVz_","lineItem__price":"CheckoutLineItem_lineItem__price__Pt5m9","lineItem__priceCart":"CheckoutLineItem_lineItem__priceCart__Bnc0P","lineItem__licenceMobile":"CheckoutLineItem_lineItem__licenceMobile__Rrsco","lineItemProduct":"CheckoutLineItem_lineItemProduct__CBx69","lineItemProductCart":"CheckoutLineItem_lineItemProductCart__vCMbw","lineItemProduct__name":"CheckoutLineItem_lineItemProduct__name__zGNC_","lineItemProductCart__name":"CheckoutLineItem_lineItemProductCart__name__59VtW","lineItemProduct__image":"CheckoutLineItem_lineItemProduct__image__XXJql","lineItemProductCart__image":"CheckoutLineItem_lineItemProductCart__image__t_CHk","lineItemProduct__info":"CheckoutLineItem_lineItemProduct__info__9Ojpg","lineItemProductCart__info":"CheckoutLineItem_lineItemProductCart__info__hR_5a","lineItemProduct__actions":"CheckoutLineItem_lineItemProduct__actions__ikHTs","lineItemProductCart__actions":"CheckoutLineItem_lineItemProductCart__actions__fz_32","lineItemProduct__licence":"CheckoutLineItem_lineItemProduct__licence__71arA","lineItemProductCart__licence":"CheckoutLineItem_lineItemProductCart__licence__ylUZ_","lineItemProduct__licenceMobile":"CheckoutLineItem_lineItemProduct__licenceMobile__YBS25","lineItemProductCart__licenceMobile":"CheckoutLineItem_lineItemProductCart__licenceMobile__14UzA","fontSample":"CheckoutLineItem_fontSample__lDjfl","physicalItem":"CheckoutLineItem_physicalItem__Vu5A8","physicalItem__header":"CheckoutLineItem_physicalItem__header__cdzeP","physicalItem__Bottom":"CheckoutLineItem_physicalItem__Bottom__lJk1d","physicalItem__name":"CheckoutLineItem_physicalItem__name___yLPs","physicalItem__sub":"CheckoutLineItem_physicalItem__sub__2_FW0","physicalItem__variant":"CheckoutLineItem_physicalItem__variant__azla9","physicalItemTotalPrice":"CheckoutLineItem_physicalItemTotalPrice___CkKv","physicalItem__type":"CheckoutLineItem_physicalItem__type__nUfwS","physicalItemQuantity":"CheckoutLineItem_physicalItemQuantity__83a6a","errors":"CheckoutLineItem_errors__4fReR","quantityInput":"CheckoutLineItem_quantityInput__tGu8Z"};

/***/ }),

/***/ 85065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CustomisedFontMetadata__list":"CustomisedFontMetadata_CustomisedFontMetadata__list__Cyvn3","CustomisedFontMetadata__item":"CustomisedFontMetadata_CustomisedFontMetadata__item__1cBh4","CustomisedFontMetadata__propertyName":"CustomisedFontMetadata_CustomisedFontMetadata__propertyName__MT_bZ","CustomisedFontMetadata__baseValue":"CustomisedFontMetadata_CustomisedFontMetadata__baseValue__9rAte"};

/***/ }),

/***/ 8340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"savedAddress":"SavedAddressSelectionList_savedAddress__ss4h2"};

/***/ }),

/***/ 37881:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Video_placeholder__fO_mY","container":"Video_container__bBLJk","containerCover":"Video_containerCover__wbtqY","hasBorder":"Video_hasBorder__2WjDN","border--white":"Video_border--white__r1DZ5","border--normal-radius":"Video_border--normal-radius__S2J4M","controls":"Video_controls__BatGz","progress":"Video_progress__We4Gt","soundControls":"Video_soundControls__1uZ7S","seek":"Video_seek__Od4bc"};

/***/ }),

/***/ 53896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__XAWhu","iconWrapper":"Button_iconWrapper__eMUO3","isPrimary":"Button_isPrimary__FSuHf","isSecondary":"Button_isSecondary__OYUz1","isSecondary--filled":"Button_isSecondary--filled__J_QNY","isError":"Button_isError__qpOhn","isTertiary":"Button_isTertiary__OWoV4","isGhost":"Button_isGhost__hw6Kx","isBlank":"Button_isBlank__tBxhS","isMuted":"Button_isMuted__t_QIs","fitWidth":"Button_fitWidth__Yz92_","align-left":"Button_align-left__Z2Df1","align-center":"Button_align-center__JLCa7","align-right":"Button_align-right__mj_CM","align-float-right":"Button_align-float-right__FuR6i","size-s":"Button_size-s__fWCDf","size-l":"Button_size-l__i_iV4","size-xl":"Button_size-xl__b0iS9","asLink":"Button_asLink__aAx1W","asLinkActive":"Button_asLinkActive__7G1mi","isActive":"Button_isActive__7Wiw5","forceWhite":"Button_forceWhite__Vgkik"};

/***/ }),

/***/ 3335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__yny_Q","fullHeight":"Card_fullHeight__XhYjw","content":"Card_content__NJbmz","cardImageAsBackground":"Card_cardImageAsBackground__eRFr6","tags":"Card_tags__CVVzB","v-plain":"Card_v-plain__nKsyb","v-custom-projects-recent":"Card_v-custom-projects-recent__cuFmp","v-custom-projects-tall":"Card_v-custom-projects-tall__N_HE_","v-storyblok-card-grid":"Card_v-storyblok-card-grid__pJOmV","v-home-about":"Card_v-home-about__hNSR9","v-home-tools":"Card_v-home-tools__BAbNI","v-home-articles":"Card_v-home-articles__yDMqs","v-articles-card":"Card_v-articles-card__tRJGW","v-home-typeface":"Card_v-home-typeface__QDAFZ","v-tools-cards":"Card_v-tools-cards__X2S0p","v-goods-card":"Card_v-goods-card__4arON","v-opentype":"Card_v-opentype__HAt3q","v-in-use":"Card_v-in-use__l6dQI","v-in-use-modal":"Card_v-in-use-modal__gXtDK","v-related-goods":"Card_v-related-goods__22dw1","link":"Card_link__T_Oa1","buttonWrapper":"Card_buttonWrapper__ABImB","layout-flex":"Card_layout-flex__E0rTw","layout-flex-center":"Card_layout-flex-center__7HYVI","cardHoverEffect":"Card_cardHoverEffect__2Txz6","clickEventButton":"Card_clickEventButton__cZAUU","disableBackground":"Card_disableBackground__jGvBF","grayscaleEffect":"Card_grayscaleEffect__nDfRz"};

/***/ }),

/***/ 36709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__hzTA7","CheckboxLabel":"Checkbox_CheckboxLabel__tUHS9","CheckboxLabel--Panel":"Checkbox_CheckboxLabel--Panel__mFeKm","checkboxImage":"Checkbox_checkboxImage__8Vo_0","checkboxImageLabel":"Checkbox_checkboxImageLabel__VYmYL","CheckboxLabel__Content":"Checkbox_CheckboxLabel__Content__9BMWz","CheckboxLabel__LabelLarge":"Checkbox_CheckboxLabel__LabelLarge__PoKUW","CheckboxLabel__BoxContent":"Checkbox_CheckboxLabel__BoxContent__EjgM2","CheckboxLabel--Small":"Checkbox_CheckboxLabel--Small__pzEfp","CheckboxLabel--disabled":"Checkbox_CheckboxLabel--disabled__Iq_r5","CheckboxLabel--Border":"Checkbox_CheckboxLabel--Border__6rLWA","CheckboxLabel--hideCheckbox":"Checkbox_CheckboxLabel--hideCheckbox__LQ6iG","CheckboxLabel--discount":"Checkbox_CheckboxLabel--discount__3Olry","CheckboxLabel__SubLabel":"Checkbox_CheckboxLabel__SubLabel__f1uib","padding-s":"Checkbox_padding-s__CDkY_","DiscountWrapper":"Checkbox_DiscountWrapper__ca_Nz","DiscountWrapper--recommended":"Checkbox_DiscountWrapper--recommended__SqYrs","Label":"Checkbox_Label__S9zup"};

/***/ }),

/***/ 623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CheckboxPanel":"CheckboxPanel_CheckboxPanel__DpZwj","CheckboxPanelLabel":"CheckboxPanel_CheckboxPanelLabel__8A5Q4","CheckboxPanel__ImageLabel":"CheckboxPanel_CheckboxPanel__ImageLabel__iV5Gl","CheckboxPanelLabel__Content":"CheckboxPanel_CheckboxPanelLabel__Content__jVmph","CheckboxPanel__ImageWrapper":"CheckboxPanel_CheckboxPanel__ImageWrapper__h97H_","CheckboxPanel__Image":"CheckboxPanel_CheckboxPanel__Image__4ayo0","iconVariant-onWhite":"CheckboxPanel_iconVariant-onWhite__ocM_4","stroke":"CheckboxPanel_stroke__lZhvE","fill":"CheckboxPanel_fill__1tNUR","iconVariant-onDark":"CheckboxPanel_iconVariant-onDark___eCTv"};

/***/ }),

/***/ 14505:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DropdownContainer":"Dropdown_DropdownContainer__b8zr4","DropdownContainerWide":"Dropdown_DropdownContainerWide__s2mFG","DropdownContainerTransparent":"Dropdown_DropdownContainerTransparent__qMaED","DropdownContainerInline":"Dropdown_DropdownContainerInline__fsl1k","Button":"Dropdown_Button__R9yaY","ButtonSmall":"Dropdown_ButtonSmall__rgIgS","ButtonWide":"Dropdown_ButtonWide__AaB74","DropdownIsActive":"Dropdown_DropdownIsActive__w2vct","ButtonText":"Dropdown_ButtonText__DyMfb","ButtonIcon":"Dropdown_ButtonIcon__6m7xF","ButtonFullWidth":"Dropdown_ButtonFullWidth__ACBK5","DropdownListWrapper":"Dropdown_DropdownListWrapper__Tt3p1","DropdownItem":"Dropdown_DropdownItem__70gje","DropdownListWrapperFilled":"Dropdown_DropdownListWrapperFilled__nY1ZW","DropdownListWrapperSmall":"Dropdown_DropdownListWrapperSmall__zs2N5","DropdownListWrapperWide":"Dropdown_DropdownListWrapperWide__68u8Z","DropdownListWrapperUpwards":"Dropdown_DropdownListWrapperUpwards__nqWZC","DropdownList":"Dropdown_DropdownList__k9gb4","DropdownListSmall":"Dropdown_DropdownListSmall__XjNOj","DropdownListWide":"Dropdown_DropdownListWide__8_SZk","DropdownListVisible":"Dropdown_DropdownListVisible__eJ579","TypefacesDropdown":"Dropdown_TypefacesDropdown__av8C7","DropdownItem__align-left":"Dropdown_DropdownItem__align-left__kAGAv"};

/***/ }),

/***/ 49412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DropdownItem":"DropdownItem_DropdownItem__SUP2J","DropdownItem__label":"DropdownItem_DropdownItem__label__WtclS","DropdownItem--active":"DropdownItem_DropdownItem--active__07Kf3","DropdownItemSmall":"DropdownItem_DropdownItemSmall__HQyFx","DropdownItemWide":"DropdownItem_DropdownItemWide__AK4F2"};

/***/ }),

/***/ 88128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__T5b0G","row":"Grid_row__Ed3_Q","gridFullWidth":"Grid_gridFullWidth__bCMNe","gridFullHeight":"Grid_gridFullHeight__dEy36","column-sm-1":"Grid_column-sm-1__edETE","column-sm-2":"Grid_column-sm-2__ie_yr","column-sm-3":"Grid_column-sm-3__48GG2","column-sm-4":"Grid_column-sm-4__rhV11","column-sm-5":"Grid_column-sm-5__kGrsv","column-sm-6":"Grid_column-sm-6__alzsJ","column-sm-7":"Grid_column-sm-7__2AHSP","column-sm-8":"Grid_column-sm-8__31uQ7","column-sm-9":"Grid_column-sm-9__PGW9m","column-sm-10":"Grid_column-sm-10__MsFIJ","column-sm-11":"Grid_column-sm-11__RlBJh","column-sm-12":"Grid_column-sm-12___CINt","column-sm-0":"Grid_column-sm-0__p4lry","column-md-1":"Grid_column-md-1__r4yU3","column-md-2":"Grid_column-md-2__op8zB","column-md-3":"Grid_column-md-3__TgBfm","column-md-4":"Grid_column-md-4__zwkgS","column-md-5":"Grid_column-md-5___DEYA","column-md-6":"Grid_column-md-6__r3ZZ2","column-md-7":"Grid_column-md-7__J6Md5","column-md-8":"Grid_column-md-8__Hr93X","column-md-9":"Grid_column-md-9__YwonR","column-md-10":"Grid_column-md-10__vKbEO","column-md-11":"Grid_column-md-11__dhhw3","column-md-12":"Grid_column-md-12__GQKzC","column-order-d-1":"Grid_column-order-d-1___veoY","column-order-d-2":"Grid_column-order-d-2__vHI1I","column-order-d-3":"Grid_column-order-d-3__o7bMP","column-order-d-4":"Grid_column-order-d-4__luqwB","column-order-d-5":"Grid_column-order-d-5__ZRn8y","column-order-d-6":"Grid_column-order-d-6__j4ZgQ","column-order-d-7":"Grid_column-order-d-7__zzFvV","column-order-d-8":"Grid_column-order-d-8__gV49d","column-order-d-9":"Grid_column-order-d-9__TUT5A","column-order-d-10":"Grid_column-order-d-10__ITiJ5","column-order-d-11":"Grid_column-order-d-11__ZFYTq","column-order-d-12":"Grid_column-order-d-12__pZcP9","column-md-0":"Grid_column-md-0__jjarj","column-lg-1":"Grid_column-lg-1__Yn6SH","column-lg-2":"Grid_column-lg-2__xH9uQ","column-lg-3":"Grid_column-lg-3__NX6pF","column-lg-4":"Grid_column-lg-4__Ua1Yd","column-lg-5":"Grid_column-lg-5__dkmZu","column-lg-6":"Grid_column-lg-6__8SIAz","column-lg-7":"Grid_column-lg-7__5KKW6","column-lg-8":"Grid_column-lg-8__RNn9V","column-lg-9":"Grid_column-lg-9__GTGmw","column-lg-10":"Grid_column-lg-10__p_aGX","column-lg-11":"Grid_column-lg-11__hSxf3","column-lg-12":"Grid_column-lg-12__kwDPu","column-lg-0":"Grid_column-lg-0__mY2bK","column-xl-1":"Grid_column-xl-1__dffLX","column-xl-2":"Grid_column-xl-2__q9aIW","column-xl-3":"Grid_column-xl-3__C1dEi","column-xl-4":"Grid_column-xl-4__UfsUo","column-xl-5":"Grid_column-xl-5__mpr3T","column-xl-6":"Grid_column-xl-6__gCROs","column-xl-7":"Grid_column-xl-7__XP6V5","column-xl-8":"Grid_column-xl-8__44f7Q","column-xl-9":"Grid_column-xl-9__oHraX","column-xl-10":"Grid_column-xl-10__tDXoB","column-xl-11":"Grid_column-xl-11__HbMox","column-xl-12":"Grid_column-xl-12__ldVS2","column-xl-0":"Grid_column-xl-0__zlDQg","reverse-mobile-vertical":"Grid_reverse-mobile-vertical__X2Ugp","reverse-mobile-horizontal":"Grid_reverse-mobile-horizontal__wqA7h"};

/***/ }),

/***/ 6474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__Yc5wm","header__content":"Header_header__content__4RB6t","breadcrumbArrow":"Header_breadcrumbArrow__15XLN","breadcrumbMobile":"Header_breadcrumbMobile__Jtlp1","breadcrumbDesktop":"Header_breadcrumbDesktop___i1HQ","logoNav":"Header_logoNav__OnhfP","logoNav_menuIsOpen":"Header_logoNav_menuIsOpen__CpiOo","logoLabel":"Header_logoLabel__ZLb3L","logoArrow":"Header_logoArrow__yiNbf","logo":"Header_logo__x2t32","navtopIcons":"Header_navtopIcons__lKqsd","topIcon":"Header_topIcon__AYbm1","headerBorder":"Header_headerBorder__zDNCJ","showFixedNav":"Header_showFixedNav__Gb1bf","basketCount":"Header_basketCount__Bvkpr","wrapper":"Header_wrapper__RdNhR","headerFixed":"Header_headerFixed__nPxsb","headerMenuOpen":"Header_headerMenuOpen___AOMv","accountName":"Header_accountName__rPfCZ"};

/***/ }),

/***/ 87820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerPanel":"HeaderPanel_headerPanel__A3U06","headerPanel__inner":"HeaderPanel_headerPanel__inner__lxFn6"};

/***/ }),

/***/ 88625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__wZSDZ","svg":"Icon_svg__NQKae","iconWithLabel":"Icon_iconWithLabel__bk4yN","label":"Icon_label__2dZsH"};

/***/ }),

/***/ 12957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"InputErrorMessage":"InputErrorMessage_InputErrorMessage__UTZXB","error":"InputErrorMessage_error__AEpK3"};

/***/ }),

/***/ 49679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"InputFieldContainer":"InputField_InputFieldContainer__LNEfg","InputPrefixWrapper":"InputField_InputPrefixWrapper__les8T","InputPrefix":"InputField_InputPrefix__eUkBl","InputField":"InputField_InputField__ZD0mb","InputIcon":"InputField_InputIcon__XyZKi","InputFieldError":"InputField_InputFieldError__4wXJ_","InputFieldBorder":"InputField_InputFieldBorder__sqRet","InputFieldIsDisabled":"InputField_InputFieldIsDisabled__F75OU","InputFieldIsOnWhite":"InputField_InputFieldIsOnWhite__AM2IJ","InputMobileKeyboardWrapper":"InputField_InputMobileKeyboardWrapper__3ADVh","InputMobileKeyboardButton":"InputField_InputMobileKeyboardButton__AjvwE","InputMobileKeyboardButtonInner":"InputField_InputMobileKeyboardButtonInner__4xLcA","InputMobileKeyboardButtonPlus":"InputField_InputMobileKeyboardButtonPlus__ET2_R","InputMobileKeyboardButtonMinus":"InputField_InputMobileKeyboardButtonMinus__RuKTL","InputFieldPointerEventsDisabled":"InputField_InputFieldPointerEventsDisabled__Uhqak"};

/***/ }),

/***/ 26573:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"InputLabel_InputLabel__9e3Og","error":"InputLabel_error__9X_RI"};

/***/ }),

/***/ 22093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Modal_modalOverlay__pAWxT","modalContent":"Modal_modalContent__T8d0x","noScrollbar":"Modal_noScrollbar__yHE28","modalCloseContainer":"Modal_modalCloseContainer__7Vc2S","modalCloseSplit":"Modal_modalCloseSplit__yTU5c","modalTriggerSplit":"Modal_modalTriggerSplit__toELc","cardModal":"Modal_cardModal__Tgi2E","content":"Modal_content__IE84r","close":"Modal_close__WGfOp","modal-get-in-touch":"Modal_modal-get-in-touch__x1ZDf"};

/***/ }),

/***/ 30482:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton_CloseButton__SNyK6","CloseButton--basic":"CloseButton_CloseButton--basic__n8wB_","CloseButton--twoColumn":"CloseButton_CloseButton--twoColumn__8xtKe","CloseButton__closeIcon":"CloseButton_CloseButton__closeIcon__wW8Bu","CloseButton__buttonInner":"CloseButton_CloseButton__buttonInner__bD8gA"};

/***/ }),

/***/ 44401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ModalTemplate__header":"GetInTouchModalTemplate_ModalTemplate__header__S54y6","ModalTemplate__body":"GetInTouchModalTemplate_ModalTemplate__body__gbx6N","ModalTemplate__title":"GetInTouchModalTemplate_ModalTemplate__title__pmRAy","ModalTemplate__bodyBlock":"GetInTouchModalTemplate_ModalTemplate__bodyBlock__exHvx"};

/***/ }),

/***/ 26862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ModalContent__inner":"ModalContent_ModalContent__inner__NvT7Y","ModalContent__inner--top":"ModalContent_ModalContent__inner--top__rmexU","ModalContent__inner--medium":"ModalContent_ModalContent__inner--medium__nVIap","ModalContent__inner--basic":"ModalContent_ModalContent__inner--basic__ezh3N","ModalContent__inner--twoColumn":"ModalContent_ModalContent__inner--twoColumn__TvPls","ModalContent__inner--autoHeight":"ModalContent_ModalContent__inner--autoHeight__m1Sp9","ModalContent__header":"ModalContent_ModalContent__header__2n__e","ModalContent__actions":"ModalContent_ModalContent__actions__QQrWL","ModalContent__actions--basic":"ModalContent_ModalContent__actions--basic__fwKT8","ModalContent__actions--twoColumn":"ModalContent_ModalContent__actions--twoColumn__9orja","ModalContent__MessageBody":"ModalContent_ModalContent__MessageBody__M5jFK","ModalContent__MessageBody--borderBottom":"ModalContent_ModalContent__MessageBody--borderBottom__ZkHUP","ModalContent__MessageBodyColumn":"ModalContent_ModalContent__MessageBodyColumn__oYJmI","ModalContent__MessageBodyColumn--withScroll":"ModalContent_ModalContent__MessageBodyColumn--withScroll__NOT0a","ModalContent__message":"ModalContent_ModalContent__message__m0da4","ModalContent__message--medium":"ModalContent_ModalContent__message--medium__dMl8a","ModalContent__message--basic":"ModalContent_ModalContent__message--basic__Mgh1h","ModalContent__message--twoColumn":"ModalContent_ModalContent__message--twoColumn__zeh4P","MessageBodyBlok":"ModalContent_MessageBodyBlok__Ash8v","MessageBodyBlok__Title":"ModalContent_MessageBodyBlok__Title__c94hw","MessageBodyBlok__Body":"ModalContent_MessageBodyBlok__Body__0uXNQ","ModalContent__Icon":"ModalContent_ModalContent__Icon__UsZpS","ModalContent__Icon--twoColumn":"ModalContent_ModalContent__Icon--twoColumn__CKfkA","ModalContent__Message":"ModalContent_ModalContent__Message__2adAJ","ModalContent__Message--medium":"ModalContent_ModalContent__Message--medium__FDghq","ModalContent__Message--basic":"ModalContent_ModalContent__Message--basic__jse2s","ModalContent__Message--twoColumn":"ModalContent_ModalContent__Message--twoColumn__GPCoX"};

/***/ }),

/***/ 18672:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__dHcc3"};

/***/ }),

/***/ 24477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__pbtm7","panelContent":"Panel_panelContent__z_bez","panelHeader":"Panel_panelHeader__x27a5","panelHeaderSticky":"Panel_panelHeaderSticky__foHUP","xs":"Panel_xs__PsP5L","checkout":"Panel_checkout__YGMAS","lg":"Panel_lg__k_oxb","zero":"Panel_zero__Xxnj4"};

/***/ }),

/***/ 70971:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RadioPanel":"Radio_RadioPanel__8BLFl","RadioInput":"Radio_RadioInput__03ylM","subLabel":"Radio_subLabel__HTTFp","mainLabel":"Radio_mainLabel__A__R5","tag":"Radio_tag__X3g7D","labelContainer":"Radio_labelContainer__fewp9"};

/***/ }),

/***/ 12456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SelectField":"SelectField_SelectField__nwpHF","SelectFieldError":"SelectField_SelectFieldError__X8KB2","SelectFieldBorder":"SelectField_SelectFieldBorder__zmVpC","SelectFieldIsDisabled":"SelectField_SelectFieldIsDisabled__sXHF7"};

/***/ }),

/***/ 75959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__zaDPC","header":"Table_header__oETEd","row":"Table_row__v43B_"};

/***/ }),

/***/ 88615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__g8xxG","tagAsButton":"Tag_tagAsButton__MHqIO","error":"Tag_error__0kfOp"};

/***/ }),

/***/ 21577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastWrapper":"Toast_ToastWrapper__A_KjX","ToastWrapperOverlay":"Toast_ToastWrapperOverlay__O2Z96","ToastWrapperCenter":"Toast_ToastWrapperCenter__ONMXS","Toast":"Toast_Toast__N7fu0","Toast__inner":"Toast_Toast__inner__UMYv2","Toast__inner--top":"Toast_Toast__inner--top__7C5i6","Toast__inner--medium":"Toast_Toast__inner--medium__BC5Ex","Toast__inner--basic":"Toast_Toast__inner--basic__PlswR","Toast__inner--twoColumn":"Toast_Toast__inner--twoColumn__xI5KE","Toast__inner--autoHeight":"Toast_Toast__inner--autoHeight__ziWaE","Toast__header":"Toast_Toast__header__xsfnK","Toast__actions":"Toast_Toast__actions__EZOl1","Toast__actions--basic":"Toast_Toast__actions--basic___XeQa","Toast__actions--twoColumn":"Toast_Toast__actions--twoColumn__px7k3","Toast__message":"Toast_Toast__message__iFFy2","Toast__message--medium":"Toast_Toast__message--medium__wQ7KX","Toast__message--basic":"Toast_Toast__message--basic__IYZVT","Toast__message--twoColumn":"Toast_Toast__message--twoColumn__ws_s6","Toast__MessageBody":"Toast_Toast__MessageBody__9wCWS","Toast__MessageBody--borderBottom":"Toast_Toast__MessageBody--borderBottom__ipJ73","Toast__icon":"Toast_Toast__icon__aKfnH","Toast__icon--twoColumn":"Toast_Toast__icon--twoColumn__BN8f2","Toast__MessageTwoColumnBody":"Toast_Toast__MessageTwoColumnBody__zRnrf","Toast__buttonInner":"Toast_Toast__buttonInner__ywZnu","Toast__closeIcon":"Toast_Toast__closeIcon__MYnl7","Toast__MessageBodyColumn":"Toast_Toast__MessageBodyColumn__kRpDL","Toast__MessageBodyColumn--withScroll":"Toast_Toast__MessageBodyColumn--withScroll__OD0ZL","Toast__MessageBodyBlok":"Toast_Toast__MessageBodyBlok__c2W_j","Toast__MessageBodyBlokTitle":"Toast_Toast__MessageBodyBlokTitle__WPGMq","Toast__MessageBodyBlokBody":"Toast_Toast__MessageBodyBlokBody__48_cq","Toast__ScrollCarouselImageContainer":"Toast_Toast__ScrollCarouselImageContainer__zSet8","Toast__ScrollCarouselImageContainer--image":"Toast_Toast__ScrollCarouselImageContainer--image__VzaMg","Toast__ScrollCarouselImageContainer--video":"Toast_Toast__ScrollCarouselImageContainer--video__ONWRZ","Toast__ScrollCarouselImage":"Toast_Toast__ScrollCarouselImage__DAtMb","Toast__ScrollCarouselImage--active":"Toast_Toast__ScrollCarouselImage--active__LOuRi","Toast__ScrollCarouselVideo":"Toast_Toast__ScrollCarouselVideo__2i5mK","Toast__ScrollCarouselVideo--active":"Toast_Toast__ScrollCarouselVideo--active__onp7t","Toast__ScrollCarouselCard":"Toast_Toast__ScrollCarouselCard__0VyMN","Toast__ScrollCarouselSlideWrapper":"Toast_Toast__ScrollCarouselSlideWrapper__HpdQG","Toast__ScrollCarouselBody":"Toast_Toast__ScrollCarouselBody__eIXE6","Toast__ScrollCarouselBody--image":"Toast_Toast__ScrollCarouselBody--image__QMQV3","Toast__ScrollCarouselBody--video":"Toast_Toast__ScrollCarouselBody--video__LIrqd"};

/***/ }),

/***/ 45417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton_CloseButton__fuEmV","CloseButton--basic":"CloseButton_CloseButton--basic__QDggQ","CloseButton--twoColumn":"CloseButton_CloseButton--twoColumn__Nfdr4","CloseButton__closeIcon":"CloseButton_CloseButton__closeIcon__BmLXX","CloseButton__buttonInner":"CloseButton_CloseButton__buttonInner__I8oAB"};

/***/ }),

/***/ 8278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toastMessage":"SuccessToast_toastMessage__00EPv","SuccessToast__wrapper":"SuccessToast_SuccessToast__wrapper__m14JO","SuccessToast__header":"SuccessToast_SuccessToast__header__gEXM9","SuccessToast__body":"SuccessToast_SuccessToast__body__WDR6M","SuccessToast__title":"SuccessToast_SuccessToast__title__kz6fc","mobile":"SuccessToast_mobile__Bjxe9","desktop":"SuccessToast_desktop__32UmU","SuccessToast_ExpiredSessionImage":"SuccessToast_SuccessToast_ExpiredSessionImage__bpsVM"};

/***/ }),

/***/ 8546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fontGroup":"FontGroup_fontGroup__tLv4M","fontGroupDisabled":"FontGroup_fontGroupDisabled__TKJES","fontGroupDisabledDisabled":"FontGroup_fontGroupDisabledDisabled__AqDz_"};

/***/ }),

/***/ 23416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoModalContainer":"InfoModal_infoModalContainer__7uqsc","infoModalArticle":"InfoModal_infoModalArticle__WHbe3","inlineButton":"InfoModal_inlineButton__agoHP","paragraph":"InfoModal_paragraph__c0EW6","introParagraph":"InfoModal_introParagraph__Z_JcQ","content":"InfoModal_content__EcIF3","scrollableContent":"InfoModal_scrollableContent__2dgFw","downloadSection":"InfoModal_downloadSection__zXI2M","downloadSection__fileExtensions":"InfoModal_downloadSection__fileExtensions__fV227","downloadSection__downloadButton":"InfoModal_downloadSection__downloadButton__CFVmO","learnMore":"InfoModal_learnMore__b_EtQ","infoModalContent":"InfoModal_infoModalContent___JtID","proHeader":"InfoModal_proHeader__wZO_p","LicenseModalHeader":"InfoModal_LicenseModalHeader__eDVyY","fileTypes":"InfoModal_fileTypes__Hg7mM","LicenseModalButton":"InfoModal_LicenseModalButton__62SmO","ScrollCarousel":"InfoModal_ScrollCarousel__yCZCe","LicenseVersionModal__ScrollCarousel":"InfoModal_LicenseVersionModal__ScrollCarousel__OPz4H"};

/***/ }),

/***/ 80759:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addToCartModal":"ModalStyles_addToCartModal__blXBJ","slide-up":"ModalStyles_slide-up__Fdy8E","addToCartModal__Content":"ModalStyles_addToCartModal__Content__b3iPx","addToCartModal__ContentContainer":"ModalStyles_addToCartModal__ContentContainer__KIxkC","addToCartModalBody":"ModalStyles_addToCartModalBody__yu5hH","addTypefaceForm":"ModalStyles_addTypefaceForm___pbB7","progressBar":"ModalStyles_progressBar__yKA6l","progressBarMobile":"ModalStyles_progressBarMobile__MsAK0","progressBarItems":"ModalStyles_progressBarItems__mbYBQ","stepperCircle":"ModalStyles_stepperCircle__qypjF","stepperCircleActive":"ModalStyles_stepperCircleActive__o00W6","stepperCircleDone":"ModalStyles_stepperCircleDone__ECLzJ","stepperLabel":"ModalStyles_stepperLabel__Tcfaq","stepperLabelMobile":"ModalStyles_stepperLabelMobile__bODAr","modalContent":"ModalStyles_modalContent__RYFMY","modalContent__Right":"ModalStyles_modalContent__Right__BgSRk","modalContent__Left":"ModalStyles_modalContent__Left__MIk1T","closeModal":"ModalStyles_closeModal__EGZY5","hidden":"ModalStyles_hidden__TBufd","variantGroupLabel":"ModalStyles_variantGroupLabel__a_SoX","licenceGroup":"ModalStyles_licenceGroup__VALRP","stepContainer":"ModalStyles_stepContainer__sSjQb","stepContent":"ModalStyles_stepContent__lY0pj","subLabelLicence":"ModalStyles_subLabelLicence__QhI8y","selectedLicence":"ModalStyles_selectedLicence__XLbWn","selectedLicenceItem":"ModalStyles_selectedLicenceItem__9kqpY","licenceHolder":"ModalStyles_licenceHolder__P59P2","licenceHolderField":"ModalStyles_licenceHolderField__wmRXT","licenceHolderWeb":"ModalStyles_licenceHolderWeb__59TkW","bottomSpacer":"ModalStyles_bottomSpacer__rTYgr","errorModal":"ModalStyles_errorModal__m1f0y","maxUsage":"ModalStyles_maxUsage__IhOwQ","slide-down":"ModalStyles_slide-down__zIue0"};

/***/ }),

/***/ 80979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"StepNavigation_container__dCTi4","stepNavigation":"StepNavigation_stepNavigation__mHXQ_","summaryButton":"StepNavigation_summaryButton__iija2","back":"StepNavigation_back__XGMe4","next":"StepNavigation_next__aDT79","backLabel":"StepNavigation_backLabel__8XzDx","nextLabel":"StepNavigation_nextLabel___be6X","navigationSummary":"StepNavigation_navigationSummary__JvUas","openAnimation":"StepNavigation_openAnimation__ddQDE","navigationSummaryClose":"StepNavigation_navigationSummaryClose__kbjFY","closeAnimation":"StepNavigation_closeAnimation__4AYBu"};

/***/ }),

/***/ 6458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__R7VyK","summary__header":"Summary_summary__header__7CT5I","summary__content":"Summary_summary__content__O8pjr","share":"Summary_share__9FCIP","summary__title":"Summary_summary__title__M9oTl","summary__list":"Summary_summary__list__47oTo","summary__list-wrapper-item":"Summary_summary__list-wrapper-item__mkiIm","summary__list-item":"Summary_summary__list-item__DjCWH","summary__list-item__border":"Summary_summary__list-item__border__0k9Mh","customFont":"Summary_customFont__wzpu5","name":"Summary_name__HkzJN","price":"Summary_price__glYha","subTotal":"Summary_subTotal__gZsUB","subTotalValue":"Summary_subTotalValue__sfx1W","emptyGrow":"Summary_emptyGrow__YMX7H","total":"Summary_total__88fjG","totalValue":"Summary_totalValue__ZXllb","fontFamilyGroup":"Summary_fontFamilyGroup__unmaK","fontFamilyGroup__List":"Summary_fontFamilyGroup__List__KIpsQ","fontFamilyGroup__ListItem":"Summary_fontFamilyGroup__ListItem__vWiyP"};

/***/ }),

/***/ 71080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fontFamilyGroup":"VariantGroupings_fontFamilyGroup__06Hbk","fontFamilyGroupDisabled":"VariantGroupings_fontFamilyGroupDisabled__vjNw7","heading":"VariantGroupings_heading__UTae5","title":"VariantGroupings_title___snwA","expanded":"VariantGroupings_expanded__EsD9H","hidden":"VariantGroupings_hidden__vlfc0","expand":"VariantGroupings_expand__ru8h3","variableFontSection":"VariantGroupings_variableFontSection__taGcS","variableFontSection__heading":"VariantGroupings_variableFontSection__heading__metGl"};

/***/ }),

/***/ 79260:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 87142:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 45892:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28861:
/***/ (function(module) {

var __dirname = "/";
(function(){if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.endianness=function(){return"LE"};e.hostname=function(){if(typeof location!=="undefined"){return location.hostname}else return""};e.loadavg=function(){return[]};e.uptime=function(){return 0};e.freemem=function(){return Number.MAX_VALUE};e.totalmem=function(){return Number.MAX_VALUE};e.cpus=function(){return[]};e.type=function(){return"Browser"};e.release=function(){if(typeof navigator!=="undefined"){return navigator.appVersion}return""};e.networkInterfaces=e.getNetworkInterfaces=function(){return{}};e.arch=function(){return"javascript"};e.platform=function(){return"browser"};e.tmpdir=e.tmpDir=function(){return"/tmp"};e.EOL="\n";e.homedir=function(){return"/"}}();module.exports=n})();

/***/ }),

/***/ 70891:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 66902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(()=>{"use strict";var e={800:e=>{
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var r=Object.getOwnPropertySymbols;var t=Object.prototype.hasOwnProperty;var u=Object.prototype.propertyIsEnumerable;function toObject(e){if(e===null||e===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(e)}function shouldUseNative(){try{if(!Object.assign){return false}var e=new String("abc");e[5]="de";if(Object.getOwnPropertyNames(e)[0]==="5"){return false}var r={};for(var t=0;t<10;t++){r["_"+String.fromCharCode(t)]=t}var u=Object.getOwnPropertyNames(r).map((function(e){return r[e]}));if(u.join("")!=="0123456789"){return false}var n={};"abcdefghijklmnopqrst".split("").forEach((function(e){n[e]=e}));if(Object.keys(Object.assign({},n)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(e){return false}}e.exports=shouldUseNative()?Object.assign:function(e,n){var a;var i=toObject(e);var s;for(var c=1;c<arguments.length;c++){a=Object(arguments[c]);for(var o in a){if(t.call(a,o)){i[o]=a[o]}}if(r){s=r(a);for(var f=0;f<s.length;f++){if(u.call(a,s[f])){i[s[f]]=a[s[f]]}}}}return i}},569:(e,r,t)=>{
/** @license React vundefined
 * use-subscription.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if(false){}},403:(e,r,t)=>{
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u=t(800),n=t(522);r.useSubscription=function(e){var r=e.getCurrentValue,t=e.subscribe,a=n.useState((function(){return{getCurrentValue:r,subscribe:t,value:r()}}));e=a[0];var i=a[1];a=e.value;if(e.getCurrentValue!==r||e.subscribe!==t)a=r(),i({getCurrentValue:r,subscribe:t,value:a});n.useDebugValue(a);n.useEffect((function(){function b(){if(!e){var n=r();i((function(e){return e.getCurrentValue!==r||e.subscribe!==t||e.value===n?e:u({},e,{value:n})}))}}var e=!1,n=t(b);b();return function(){e=!0;n()}}),[r,t]);return a}},138:(e,r,t)=>{if(true){e.exports=t(403)}else{}},522:e=>{e.exports=__webpack_require__(85170)}};var r={};function __nccwpck_require__(t){var u=r[t];if(u!==undefined){return u.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(138);module.exports=t})();

/***/ }),

/***/ 17953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(66165)


/***/ }),

/***/ 23087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(76095)


/***/ }),

/***/ 96434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20474)


/***/ }),

/***/ 40559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(87647)


/***/ }),

/***/ 86317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(78318)


/***/ }),

/***/ 31021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28226)


/***/ }),

/***/ 74049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(36257);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 40507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(74049)();
}


/***/ }),

/***/ 36257:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 75101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UQ": function() { return /* binding */ Accordion; },
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "on": function() { return /* binding */ AccordionItemButtonWrapper; },
/* harmony export */   "Ol": function() { return /* binding */ AccordionItemHeadingWrapper; },
/* harmony export */   "Mt": function() { return /* binding */ AccordionItemPanel; },
/* harmony export */   "CB": function() { return /* binding */ AccordionItemState; }
/* harmony export */ });
/* unused harmony export resetNextUuid */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var AccordionStore = /*#__PURE__*/_createClass(function AccordionStore(_ref) {
  var _this = this;

  var _ref$expanded = _ref.expanded,
      _expanded = _ref$expanded === void 0 ? [] : _ref$expanded,
      _ref$allowMultipleExp = _ref.allowMultipleExpanded,
      allowMultipleExpanded = _ref$allowMultipleExp === void 0 ? false : _ref$allowMultipleExp,
      _ref$allowZeroExpande = _ref.allowZeroExpanded,
      allowZeroExpanded = _ref$allowZeroExpande === void 0 ? false : _ref$allowZeroExpande;

  _classCallCheck(this, AccordionStore);

  _defineProperty(this, "expanded", void 0);

  _defineProperty(this, "allowMultipleExpanded", void 0);

  _defineProperty(this, "allowZeroExpanded", void 0);

  _defineProperty(this, "toggleExpanded", function (uuid) {
    if (_this.isItemDisabled(uuid)) {
      return _this;
    }

    var isExpanded = _this.isItemExpanded(uuid);

    if (!isExpanded) {
      return _this.augment({
        expanded: _this.allowMultipleExpanded ? [].concat(_toConsumableArray(_this.expanded), [uuid]) : [uuid]
      });
    } else {
      return _this.augment({
        expanded: _this.expanded.filter(function (expandedUuid) {
          return expandedUuid !== uuid;
        })
      });
    }
  });

  _defineProperty(this, "isItemDisabled", function (uuid) {
    var isExpanded = _this.isItemExpanded(uuid);

    var isOnlyOneExpanded = _this.expanded.length === 1;
    return Boolean(isExpanded && !_this.allowZeroExpanded && isOnlyOneExpanded);
  });

  _defineProperty(this, "isItemExpanded", function (uuid) {
    return _this.expanded.indexOf(uuid) !== -1;
  });

  _defineProperty(this, "getPanelAttributes", function (uuid, dangerouslySetExpanded) {
    var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);
    return {
      role: _this.allowMultipleExpanded ? undefined : 'region',
      'aria-hidden': _this.allowMultipleExpanded ? !expanded : undefined,
      'aria-labelledby': _this.getButtonId(uuid),
      id: _this.getPanelId(uuid),
      hidden: expanded ? undefined : true
    };
  });

  _defineProperty(this, "getHeadingAttributes", function () {
    return {
      role: 'heading'
    };
  });

  _defineProperty(this, "getButtonAttributes", function (uuid, dangerouslySetExpanded) {
    var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);

    var disabled = _this.isItemDisabled(uuid);

    return {
      id: _this.getButtonId(uuid),
      'aria-disabled': disabled,
      'aria-expanded': expanded,
      'aria-controls': _this.getPanelId(uuid),
      role: 'button',
      tabIndex: 0
    };
  });

  _defineProperty(this, "getPanelId", function (id) {
    return "accordion__panel-".concat(id);
  });

  _defineProperty(this, "getButtonId", function (id) {
    return "accordion__heading-".concat(id);
  });

  _defineProperty(this, "augment", function (args) {
    return new AccordionStore(_objectSpread2({
      expanded: _this.expanded,
      allowMultipleExpanded: _this.allowMultipleExpanded,
      allowZeroExpanded: _this.allowZeroExpanded
    }, args));
  });

  this.expanded = _expanded;
  this.allowMultipleExpanded = allowMultipleExpanded;
  this.allowZeroExpanded = allowZeroExpanded;
});

var Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var Provider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Provider, _React$PureComponent);

  var _super = _createSuper(Provider);

  function Provider() {
    var _this;

    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", new AccordionStore({
      expanded: _this.props.preExpanded,
      allowMultipleExpanded: _this.props.allowMultipleExpanded,
      allowZeroExpanded: _this.props.allowZeroExpanded
    }));

    _defineProperty(_assertThisInitialized(_this), "toggleExpanded", function (key) {
      _this.setState(function (state) {
        return state.toggleExpanded(key);
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state.expanded);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isItemDisabled", function (key) {
      return _this.state.isItemDisabled(key);
    });

    _defineProperty(_assertThisInitialized(_this), "isItemExpanded", function (key) {
      return _this.state.isItemExpanded(key);
    });

    _defineProperty(_assertThisInitialized(_this), "getPanelAttributes", function (key, dangerouslySetExpanded) {
      return _this.state.getPanelAttributes(key, dangerouslySetExpanded);
    });

    _defineProperty(_assertThisInitialized(_this), "getHeadingAttributes", function () {
      // uuid: UUID
      return _this.state.getHeadingAttributes();
    });

    _defineProperty(_assertThisInitialized(_this), "getButtonAttributes", function (key, dangerouslySetExpanded) {
      return _this.state.getButtonAttributes(key, dangerouslySetExpanded);
    });

    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          allowZeroExpanded = _this$state.allowZeroExpanded,
          allowMultipleExpanded = _this$state.allowMultipleExpanded;
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Provider, {
        value: {
          allowMultipleExpanded: allowMultipleExpanded,
          allowZeroExpanded: allowZeroExpanded,
          toggleExpanded: this.toggleExpanded,
          isItemDisabled: this.isItemDisabled,
          isItemExpanded: this.isItemExpanded,
          getPanelAttributes: this.getPanelAttributes,
          getHeadingAttributes: this.getHeadingAttributes,
          getButtonAttributes: this.getButtonAttributes
        }
      }, this.props.children || null);
    }
  }]);

  return Provider;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

_defineProperty(Provider, "defaultProps", {
  allowMultipleExpanded: false,
  allowZeroExpanded: false
});

var Consumer = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(Consumer, _React$PureComponent2);

  var _super2 = _createSuper(Consumer);

  function Consumer() {
    var _this2;

    _classCallCheck(this, Consumer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "renderChildren", function (container) {
      return container ? _this2.props.children(container) : null;
    });

    return _this2;
  }

  _createClass(Consumer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Consumer, null, this.renderChildren);
    }
  }]);

  return Consumer;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

var _excluded = ["className", "allowMultipleExpanded", "allowZeroExpanded", "onChange", "preExpanded"];

var Accordion = function Accordion(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'accordion' : _ref$className,
      allowMultipleExpanded = _ref.allowMultipleExpanded,
      allowZeroExpanded = _ref.allowZeroExpanded,
      onChange = _ref.onChange,
      preExpanded = _ref.preExpanded,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Provider, {
    preExpanded: preExpanded,
    allowMultipleExpanded: allowMultipleExpanded,
    allowZeroExpanded: allowZeroExpanded,
    onChange: onChange
  }, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
    "data-accordion-component": "Accordion",
    className: className
  }, rest)));
};

var DisplayName;

(function (DisplayName) {
  DisplayName["Accordion"] = "Accordion";
  DisplayName["AccordionItem"] = "AccordionItem";
  DisplayName["AccordionItemButton"] = "AccordionItemButton";
  DisplayName["AccordionItemHeading"] = "AccordionItemHeading";
  DisplayName["AccordionItemPanel"] = "AccordionItemPanel";
})(DisplayName || (DisplayName = {}));

var DisplayName$1 = DisplayName;

// @ts-ignore
var DEFAULT = 0;
var counter = 0;
function useGlobalCounterId() {
  var current = counter;
  counter = counter + 1;
  return "raa-".concat(current);
}
function resetGlobalCounterId() {
  counter = DEFAULT;
}
var useNextId = react__WEBPACK_IMPORTED_MODULE_0__.useId || useGlobalCounterId; // HTML5 ids allow all unicode characters, except for ASCII whitespaces
// https://infra.spec.whatwg.org/#ascii-whitespace
// eslint-disable-next-line no-control-regex

var idRegex = /[\u0009\u000a\u000c\u000d\u0020]/g;
function assertValidHtmlId(htmlId) {
  if (htmlId === '' || idRegex.test(htmlId)) {
    console.error("uuid must be a valid HTML5 id but was given \"".concat(htmlId, "\", ASCII whitespaces are forbidden"));
    return false;
  }

  return true;
}

var Context$1 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

var Provider$1 = function Provider(_ref) {
  var children = _ref.children,
      uuid = _ref.uuid,
      accordionContext = _ref.accordionContext,
      dangerouslySetExpanded = _ref.dangerouslySetExpanded;

  var toggleExpanded = function toggleExpanded() {
    accordionContext.toggleExpanded(uuid);
  };

  var renderChildren = function renderChildren(accordionContext) {
    var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : accordionContext.isItemExpanded(uuid);
    var disabled = accordionContext.isItemDisabled(uuid);
    var panelAttributes = accordionContext.getPanelAttributes(uuid, dangerouslySetExpanded);
    var headingAttributes = accordionContext.getHeadingAttributes(uuid);
    var buttonAttributes = accordionContext.getButtonAttributes(uuid, dangerouslySetExpanded);
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context$1.Provider, {
      value: {
        uuid: uuid,
        expanded: expanded,
        disabled: disabled,
        toggleExpanded: toggleExpanded,
        panelAttributes: panelAttributes,
        headingAttributes: headingAttributes,
        buttonAttributes: buttonAttributes
      }
    }, children);
  };

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer, null, renderChildren);
};

var ProviderWrapper = function ProviderWrapper(props) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer, null, function (accordionContext) {
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Provider$1, _extends({}, props, {
      accordionContext: accordionContext
    }));
  });
};
var Consumer$1 = function Consumer(_ref2) {
  var children = _ref2.children;

  var renderChildren = function renderChildren(container) {
    return container ? children(container) : null;
  };

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context$1.Consumer, null, renderChildren);
};

var _excluded$1 = ["uuid", "dangerouslySetExpanded", "className", "activeClassName"];

var AccordionItem = function AccordionItem(_ref) {
  var customUuid = _ref.uuid,
      dangerouslySetExpanded = _ref.dangerouslySetExpanded,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'accordion__item' : _ref$className,
      activeClassName = _ref.activeClassName,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(useNextId()),
      _useState2 = _slicedToArray(_useState, 1),
      instanceUuid = _useState2[0];

  var uuid = customUuid !== null && customUuid !== void 0 ? customUuid : instanceUuid;

  var renderChildren = function renderChildren(itemContext) {
    var expanded = itemContext.expanded;
    var cx = expanded && activeClassName ? activeClassName : className;
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
      "data-accordion-component": "AccordionItem",
      className: cx
    }, rest));
  };

  assertValidHtmlId(uuid.toString());

  if (rest.id) {
    assertValidHtmlId(rest.id);
  }

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ProviderWrapper, {
    uuid: uuid,
    dangerouslySetExpanded: dangerouslySetExpanded
  }, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer$1, null, renderChildren));
};

AccordionItem.displayName = DisplayName$1.AccordionItem;

function getClosestAccordion(el) {
  return el && (el.matches('[data-accordion-component="Accordion"]') ? el : getClosestAccordion(el.parentElement));
}
function getSiblingButtons(item) {
  var parentAccordion = getClosestAccordion(item);
  return parentAccordion && Array.from(parentAccordion.querySelectorAll('[data-accordion-component="AccordionItemButton"]'));
}
function focusFirstSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var first = siblings[0];

  if (first) {
    first.focus();
  }
}
function focusLastSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var last = siblings[siblings.length - 1];

  if (last) {
    last.focus();
  }
}
function focusNextSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var currentIndex = siblings.indexOf(item);

  if (currentIndex !== -1) {
    var next = siblings[currentIndex + 1];

    if (next) {
      next.focus();
    }
  }
}
function focusPreviousSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var currentIndex = siblings.indexOf(item);

  if (currentIndex !== -1) {
    var previous = siblings[currentIndex - 1];

    if (previous) {
      previous.focus();
    }
  }
}

var keycodes = {
  END: 'End',
  ENTER: 'Enter',
  HOME: 'Home',
  SPACE: ' ',
  SPACE_DEPRECATED: 'Spacebar',
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight'
};

var _excluded$2 = ["toggleExpanded", "className"];

var AccordionItemButton = function AccordionItemButton(_ref) {
  var toggleExpanded = _ref.toggleExpanded,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'accordion__button' : _ref$className,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var handleKeyPress = function handleKeyPress(evt) {
    var keyCode = evt.key;

    if (keyCode === keycodes.ENTER || keyCode === keycodes.SPACE || keyCode === keycodes.SPACE_DEPRECATED) {
      evt.preventDefault();
      toggleExpanded();
    }
    /* The following block is ignored from test coverage because at time
     * time of writing Jest/react-testing-library can not assert 'focus'
     * functionality.
     */
    // istanbul ignore next


    if (evt.target instanceof HTMLElement) {
      switch (keyCode) {
        case keycodes.HOME:
          {
            evt.preventDefault();
            focusFirstSiblingOf(evt.target);
            break;
          }

        case keycodes.END:
          {
            evt.preventDefault();
            focusLastSiblingOf(evt.target);
            break;
          }

        case keycodes.LEFT:
        case keycodes.UP:
          {
            evt.preventDefault();
            focusPreviousSiblingOf(evt.target);
            break;
          }

        case keycodes.RIGHT:
        case keycodes.DOWN:
          {
            evt.preventDefault();
            focusNextSiblingOf(evt.target);
            break;
          }
      }
    }
  };

  if (rest.id) {
    assertValidHtmlId(rest.id);
  }

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
    className: className
  }, rest, {
    role: "button",
    tabIndex: 0,
    onClick: toggleExpanded,
    onKeyDown: handleKeyPress,
    "data-accordion-component": "AccordionItemButton"
  }));
};

var AccordionItemButtonWrapper = function AccordionItemButtonWrapper(props) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer$1, null, function (itemContext) {
    var toggleExpanded = itemContext.toggleExpanded,
        buttonAttributes = itemContext.buttonAttributes;
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(AccordionItemButton, _extends({
      toggleExpanded: toggleExpanded
    }, props, buttonAttributes));
  });
};

var defaultProps = {
  className: 'accordion__heading',
  'aria-level': 3
};
var SPEC_ERROR = "AccordionItemButton may contain only one child element, which must be an instance of AccordionItemButton.\n\nFrom the WAI-ARIA spec (https://www.w3.org/TR/wai-aria-practices-1.1/#accordion):\n\n\u201CThe button element is the only element inside the heading element. That is, if there are other visually persistent elements, they are not included inside the heading element.\u201D\n\n";
var AccordionItemHeading = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AccordionItemHeading, _React$PureComponent);

  var _super = _createSuper(AccordionItemHeading);

  function AccordionItemHeading() {
    var _this;

    _classCallCheck(this, AccordionItemHeading);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
      _this.ref = ref;
    });

    return _this;
  }

  _createClass(AccordionItemHeading, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      AccordionItemHeading.VALIDATE(this.ref);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      AccordionItemHeading.VALIDATE(this.ref);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
        "data-accordion-component": "AccordionItemHeading"
      }, this.props, {
        ref: this.setRef
      }));
    }
  }], [{
    key: "VALIDATE",
    value: function VALIDATE(ref) {
      if (ref === undefined) {
        throw new Error('ref is undefined');
      }

      if (!(ref.childElementCount === 1 && ref.firstElementChild && ref.firstElementChild.getAttribute('data-accordion-component') === 'AccordionItemButton')) {
        throw new Error(SPEC_ERROR);
      }
    }
  }]);

  return AccordionItemHeading;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

_defineProperty(AccordionItemHeading, "defaultProps", defaultProps);

var AccordionItemHeadingWrapper = function AccordionItemHeadingWrapper(props) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer$1, null, function (itemContext) {
    var headingAttributes = itemContext.headingAttributes;

    if (props.id) {
      assertValidHtmlId(props.id);
    }

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(AccordionItemHeading, _extends({}, props, headingAttributes));
  });
};

AccordionItemHeadingWrapper.displayName = DisplayName$1.AccordionItemHeading;

var _excluded$3 = ["className", "region", "id"];

var AccordionItemPanel = function AccordionItemPanel(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'accordion__panel' : _ref$className,
      region = _ref.region,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, _excluded$3);

  var renderChildren = function renderChildren(_ref2) {
    var panelAttributes = _ref2.panelAttributes;

    if (id) {
      assertValidHtmlId(id);
    }

    var attrs = _objectSpread2(_objectSpread2({}, panelAttributes), {}, {
      'aria-labelledby': region ? panelAttributes['aria-labelledby'] : undefined
    });

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
      "data-accordion-component": "AccordionItemPanel",
      className: className
    }, rest, attrs, {
      role: region ? 'region' : undefined
    }));
  };

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer$1, null, renderChildren);
};

var AccordionItemState = function AccordionItemState(_ref) {
  var children = _ref.children;

  var renderChildren = function renderChildren(itemContext) {
    var expanded = itemContext.expanded,
        disabled = itemContext.disabled;
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children({
      expanded: expanded,
      disabled: disabled
    }));
  };

  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Consumer$1, null, renderChildren);
};




/***/ }),

/***/ 32821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
const react_1 = __webpack_require__(85170);
function useDropdownMenu(itemCount, options) {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const currentFocusIndex = react_1.useRef(null);
    const firstRun = react_1.useRef(true);
    const clickedOpen = react_1.useRef(false);
    const buttonRef = react_1.useRef(null);
    const itemRefs = react_1.useMemo(() => Array.from({ length: itemCount }, () => react_1.createRef()), [itemCount]);
    const isKeyboardEvent = (e) => e.key !== undefined;
    const moveFocus = (itemIndex) => {
        var _a;
        currentFocusIndex.current = itemIndex;
        (_a = itemRefs[itemIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    react_1.useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        if (isOpen && !(options === null || options === void 0 ? void 0 : options.disableFocusFirstItemOnClick)) {
            moveFocus(0);
        }
        else if (!isOpen) {
            clickedOpen.current = false;
        }
    }, [isOpen]);
    react_1.useEffect(() => {
        if (!isOpen) {
            return;
        }
        const removalTracker = {
            removed: false,
        };
        const handleEveryClick = (event) => {
            setTimeout(() => {
                if (!(event.target instanceof Element)) {
                    return;
                }
                if (event.target.closest('[role="menu"]') instanceof Element) {
                    return;
                }
                setIsOpen(false);
            }, 10);
        };
        setTimeout(() => {
            if (removalTracker.removed) {
                return;
            }
            document.addEventListener('click', handleEveryClick);
        }, 1);
        return () => {
            removalTracker.removed = true;
            document.removeEventListener('click', handleEveryClick);
        };
    }, [isOpen]);
    react_1.useEffect(() => {
        const disableArrowScroll = (event) => {
            if (isOpen && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
                event.preventDefault();
            }
        };
        document.addEventListener('keydown', disableArrowScroll);
        return () => document.removeEventListener('keydown', disableArrowScroll);
    }, [isOpen]);
    const buttonListener = (e) => {
        if (isKeyboardEvent(e)) {
            const { key } = e;
            if (!['Enter', ' ', 'Tab', 'ArrowDown', 'Escape'].includes(key)) {
                return;
            }
            if ((key === 'Tab' || key === 'ArrowDown') && clickedOpen.current && isOpen) {
                e.preventDefault();
                moveFocus(0);
            }
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                setIsOpen(true);
            }
            if (key === 'Escape') {
                e.preventDefault();
                setIsOpen(false);
            }
        }
        else {
            if (options === null || options === void 0 ? void 0 : options.disableFocusFirstItemOnClick) {
                clickedOpen.current = !isOpen;
            }
            setIsOpen(!isOpen);
        }
    };
    const itemListener = (e) => {
        var _a;
        const { key } = e;
        if (['Tab', 'Shift', 'Enter', 'Escape', 'ArrowUp', 'ArrowDown', ' '].includes(key)) {
            let newFocusIndex = currentFocusIndex.current;
            if (key === 'Escape') {
                setIsOpen(false);
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            else if (key === 'Tab') {
                setIsOpen(false);
                return;
            }
            else if (key === 'Enter' || key === ' ') {
                if (!e.currentTarget.href) {
                    e.currentTarget.click();
                }
                setIsOpen(false);
                return;
            }
            if (newFocusIndex !== null) {
                if (key === 'ArrowUp') {
                    newFocusIndex -= 1;
                }
                else if (key === 'ArrowDown') {
                    newFocusIndex += 1;
                }
                if (newFocusIndex > itemRefs.length - 1) {
                    newFocusIndex = 0;
                }
                else if (newFocusIndex < 0) {
                    newFocusIndex = itemRefs.length - 1;
                }
            }
            if (newFocusIndex !== null) {
                moveFocus(newFocusIndex);
            }
            return;
        }
        if (/[a-zA-Z0-9./<>?;:"'`!@#$%^&*()\\[\]{}_+=|\\-~,]/.test(key)) {
            const index = itemRefs.findIndex((ref) => {
                var _a, _b, _c, _d, _e, _f;
                return ((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.innerText) === null || _b === void 0 ? void 0 : _b.toLowerCase().startsWith(key.toLowerCase())) ||
                    ((_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.toLowerCase().startsWith(key.toLowerCase())) ||
                    ((_f = (_e = ref.current) === null || _e === void 0 ? void 0 : _e.getAttribute('aria-label')) === null || _f === void 0 ? void 0 : _f.toLowerCase().startsWith(key.toLowerCase()));
            });
            if (index !== -1) {
                moveFocus(index);
            }
        }
    };
    const buttonProps = {
        onKeyDown: buttonListener,
        onClick: buttonListener,
        tabIndex: 0,
        ref: buttonRef,
        role: 'button',
        'aria-haspopup': true,
        'aria-expanded': isOpen,
    };
    const itemProps = Array.from({ length: itemCount }, (_ignore, index) => ({
        onKeyDown: itemListener,
        tabIndex: -1,
        role: 'menuitem',
        ref: itemRefs[index],
    }));
    return { buttonProps, itemProps, isOpen, setIsOpen, moveFocus };
}
exports.Z = useDropdownMenu;


/***/ }),

/***/ 1998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zt": function() { return /* binding */ Provider; },
/* harmony export */   "_y": function() { return /* binding */ Context; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72535);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 12902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1998);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41444);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ }),

/***/ 41444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14547);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56491);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 60198:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 56237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(60198);
} else {}


/***/ }),

/***/ 29155:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(85170);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(40507);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(9353);

var _scrollParent = __webpack_require__(94754);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(35571);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(27460);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(element) {
      if (element) {
        this.ref = element;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          height = _props2.height,
          children = _props2.children,
          placeholder = _props2.placeholder,
          className = _props2.className,
          classNamePrefix = _props2.classNamePrefix,
          style = _props2.style;


      return _react2.default.createElement(
        'div',
        { className: classNamePrefix + '-wrapper ' + className, ref: this.setRef, style: style },
        this.visible ? children : placeholder ? placeholder : _react2.default.createElement('div', {
          style: { height: height },
          className: classNamePrefix + '-placeholder'
        })
      );
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  className: _propTypes2.default.string,
  classNamePrefix: _propTypes2.default.string,
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

LazyLoad.defaultProps = {
  className: '',
  classNamePrefix: 'lazyload',
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

__webpack_unused_export__ = decorator;
exports.ZP = LazyLoad;
__webpack_unused_export__ = lazyLoadHandler;
__webpack_unused_export__ = forceVisible;

/***/ }),

/***/ 35571:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 9353:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 94754:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/**
 * @fileOverview Find scroll parent
 */

exports["default"] = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 27460:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 63534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 95772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(85170);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15286);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(40507);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(31634);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(85421);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(68102);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(63534);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 31634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(85170);

var _propTypes = __webpack_require__(40507);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(95877);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(27344);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(85421);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(8066);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(68102);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(86337);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(72672);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 85421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(91190);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(68102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 72672:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(86337);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 8066:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 95877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(98286);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 86337:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 68102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(65936);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 27344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(98286);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 98286:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object|iframe/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
    // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 75968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(95772);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 51654:
/***/ (function(module) {

const hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;


//polyfill
if (!Number.parseInt && window.parseInt) {
    Number.parseInt = window.parseInt;
}
if (!Number.parseFloat && window.parseFloat) {
    Number.parseFloat = window.parseFloat;
}

  
const consider = {
    hex :  true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
    //skipLike: /regex/
};

function toNumber(str, options = {}){
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }

    options = Object.assign({}, consider, options );
    if(!str || typeof str !== "string" ) return str;
    
    let trimmedStr  = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;

    if(options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && hexRegex.test(trimmedStr)) {
        return Number.parseInt(trimmedStr, 16);
    // } else if (options.parseOct && octRegex.test(str)) {
    //     return Number.parseInt(val, 8);
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    }else{
        //separate negative sign, leading zeros, and rest number
        const match = numRegex.exec(trimmedStr);
        if(match){
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            
            const eNotation = match[4] || match[6];
            if(!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if(!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else{//no leading zeros or leading zeros are allowed
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if(numStr.search(/[eE]/) !== -1){ //given number is long and parsed to eNotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(eNotation){ //given number has enotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(trimmedStr.indexOf(".") !== -1){ //floating number
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));

                    
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if(numStr === "0" && (numTrimmedByZeros === "") ) return num; //0.0
                    else if(numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if( sign && numStr === "-"+numTrimmedByZeros) return num;
                    else return str;
                }
                
                if(leadingZeros){
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if(numTrimmedByZeros === numStr) return num;
                    else if(sign+numTrimmedByZeros === numStr) return num;
                    else return str;
                }

                if(trimmedStr === numStr) return num;
                else if(trimmedStr === sign+numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);

                // }
                return str;
            }
            // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
            
        }else{ //non-numeric string
            return str;
        }
    }
}

/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */
function trimZeros(numStr){
    if(numStr && numStr.indexOf(".") !== -1){//float
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if(numStr === ".")  numStr = "0";
        else if(numStr[0] === ".")  numStr = "0"+numStr;
        else if(numStr[numStr.length-1] === ".")  numStr = numStr.substr(0,numStr.length-1);
        return numStr;
    }
    return numStr;
}
module.exports = toNumber


/***/ }),

/***/ 34254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "pi": function() { return /* binding */ __assign; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 17196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(85170);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 43893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(17196);
} else {}


/***/ }),

/***/ 91190:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 50804:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 85234:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isApolloError; },
/* harmony export */   "c": function() { return /* binding */ ApolloError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34254);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93663);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15771);



function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.graphQLErrors) || (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 41660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42457);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 42623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93663);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41660);



function useApolloClient(override) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 29);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 15771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; }
/* harmony export */ });
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 42457:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; }
/* harmony export */ });
var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 66314:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 91437:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93663);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 18158:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34254);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66314);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaults.variables), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 93663:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ej": function() { return /* reexport */ invariant/* InvariantError */.ej; },
  "kG": function() { return /* reexport */ invariant/* invariant */.kG; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: DEV, checkDEV, global

// EXTERNAL MODULE: ./node_modules/.pnpm/ts-invariant@0.10.3/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(35985);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ts-invariant@0.10.3/node_modules/ts-invariant/process/index.js
/* provided dependency */ var process = __webpack_require__(6436);
function process_maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  process_maybe(function() { return globalThis }) ||
  process_maybe(function() { return window }) ||
  process_maybe(function() { return self }) ||
  process_maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  process_maybe(function() { return process_maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !process_maybe(function() { return "production" }) &&
      !process_maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(34402);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 36);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30753:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 85369:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 53406:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

let OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));


/***/ }),

/***/ 55985:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; },
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63089);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 63089:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 67719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
let Kind;
/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/***/ }),

/***/ 15810:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ print; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(55985);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(31082);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}


/***/ }),

/***/ 34402:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; },
  "T": function() { return /* binding */ isSource; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(30753);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(85369);
;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 5 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
   true
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : 0;

;// CONCATENATED MODULE: ./node_modules/.pnpm/graphql@16.3.0/node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}


/***/ }),

/***/ 31082:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30753);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85369);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53406);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67719);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 67128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "qo": function() { return /* binding */ useWatch; }
/* harmony export */ });
/* unused harmony exports Controller, FormProvider, appendErrors, get, set, useController, useFieldArray, useFormContext, useFormState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
                    _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const tearDown = (subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => tearDown(subscription);
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    const _mounted = React.useRef(true);
    _name.current = name;
    const callback = React.useCallback((value) => _mounted.current &&
        shouldSubscribeByName(_name.current, value.name, exact) &&
        shouldRenderFormState(value, _localProxyFormState.current) &&
        updateFormState({
            ...control._formState,
            ...value,
        }), [control, exact]);
    useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        return () => {
            _mounted.current = false;
        };
    }, []);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isFunction = (value) => typeof value === 'function';

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue(isUndefined(_name.current) ||
                (isObject(fieldValues) && !objectHasFunction(fieldValues))
                ? { ...fieldValues }
                : Array.isArray(fieldValues)
                    ? [...fieldValues]
                    : isUndefined(fieldValues)
                        ? defaultValue
                        : fieldValues);
        }
    }, [control, exact, defaultValue]);
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback,
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._removeUnmounted();
    });
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    React.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: React.useCallback((event) => {
                _registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            }, [name]),
            onBlur: React.useCallback(() => {
                _registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            }, [name, control]),
            ref: React.useCallback((elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            }, [name, control._fields]),
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        for (const key in data) {
            if (isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) && isEmptyArray(objectRef)))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    const callback = React.useCallback(({ values, name: fieldArrayName, }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                const validationModeBeforeSubmit = getValidationModes(control._options.mode);
                if ((!validationModeBeforeSubmit.isOnSubmit ||
                    control._formState.isSubmitted) &&
                    field &&
                    field._f) {
                    validateField(field, get(control._formValues, name), control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => key.startsWith(control._names.focus));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === '' || isNullOrUndefined(value)
            ? NaN
            : +value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? undefined
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
            name,
        };
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty =
                isFieldDirty ||
                    isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty =
                isFieldDirty ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isBlurEvent);
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => _options.resolver
        ? await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
        : {};
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = {
            ...(_stateFlags.mount
                ? _formValues
                : isUndefined(defaultValue)
                    ? _defaultValues
                    : isString(names)
                        ? { [names]: defaultValue }
                        : defaultValue),
        };
        return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? +1 : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (info) => name(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(!!Array.isArray(get(_defaultValues, name))
                                            ? [{}]
                                            : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuiltInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _options.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            try {
                                if (isHTMLElement(fieldReference)) {
                                    fieldReference.closest('form').reset();
                                    break;
                                }
                            }
                            catch (_a) { }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._options = props;
    }
    else {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
            control._formState = {
                ...control._formState,
                ...value,
            };
            updateFormState({ ...control._formState });
        }
    }, [control]);
    useSubscribe({
        subject: control._subjects.state,
        callback,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 35985:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony export setVerbosity */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34254);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* harmony default export */ __webpack_exports__["ZP"] = (invariant);
//# sourceMappingURL=invariant.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(5174), __webpack_exec__(78318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);